angular.module("app.locale.en-ca", [
'tmh.dynamicLocale'
])

.run(['tmhDynamicLocaleCache', function (tmhDynamicLocaleCache) {
    var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
    function getDecimals(n) {
        n = n + '';
        var i = n.indexOf('.');
        return (i == -1) ? 0 : n.length - i - 1;
    }

    function getVF(n, opt_precision) {
        var v = opt_precision;

        if (undefined === v) {
            v = Math.min(getDecimals(n), 3);
        }

        var base = Math.pow(10, v);
        var f = ((n * base) | 0) % base;
        return { v: v, f: f };
    }
    tmhDynamicLocaleCache.put('en-ca', {
        "DATETIME_FORMATS": {
            "AMPMS": [
              "AM",
              "PM"
            ],
            "DAY": [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday"
            ],
            "MONTH": [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December"
            ],
            "SHORTDAY": [
              "Sun",
              "Mon",
              "Tue",
              "Wed",
              "Thu",
              "Fri",
              "Sat"
            ],
            "SHORTMONTH": [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec"
            ],
            "fullDate": "EEEE, MMMM d, y",
            "longDate": "MMMM d, y",
            "medium": "MMM d, y h:mm:ss a",
            "mediumDate": "MMM d, y",
            "mediumTime": "h:mm:ss a",
            "short": "y-MM-dd h:mm a",
            "shortDate": "y-MM-dd",
            "shortTime": "h:mm a"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "$",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
              {
                  "gSize": 3,
                  "lgSize": 3,
                  "maxFrac": 3,
                  "minFrac": 0,
                  "minInt": 1,
                  "negPre": "-",
                  "negSuf": "",
                  "posPre": "",
                  "posSuf": ""
              },
              {
                  "gSize": 3,
                  "lgSize": 3,
                  "maxFrac": 2,
                  "minFrac": 2,
                  "minInt": 1,
                  "negPre": "\u00a4-",
                  "negSuf": "",
                  "posPre": "\u00a4",
                  "posSuf": ""
              }
            ]
        },
        "FROALA": {
            "translation": {
                // Place holder
                "Type something": "Type something",

                // Basic formatting
                "Bold": "Bold",
                "Italic": "Italic",
                "Underline": "Underline",
                "Strikethrough": "Strikethrough",

                // Main buttons
                "Insert": "Insert",
                "Delete": "Delete",
                "Cancel": "Cancel",
                "OK": "OK",
                "Back": "Back",
                "Remove": "Remove",
                "More": "More",
                "Update": "Update",
                "Style": "Style",

                // Font
                "Font Family": "Font Family",
                "Font Size": "Font Size",

                // Colors
                "Colors": "Colours",
                "Background": "Background",
                "Text": "Text",
                "HEX Color": "HEX Colour",

                // Paragraphs
                "Paragraph Format": "Paragraph Format",
                "Normal": "Normal",
                "Code": "Code",
                "Heading 1": "Heading 1",
                "Heading 2": "Heading 2",
                "Heading 3": "Heading 3",
                "Heading 4": "Heading 4",

                // Style
                "Paragraph Style": "Paragraph Style",
                "Inline Style": "Inline Style",

                // Alignment
                "Align": "Align",
                "Align Left": "Align Left",
                "Align Center": "Align Centre",
                "Align Right": "Alight Right",
                "Align Justify": "Align Justify",
                "None": "None",

                // Lists
                "Ordered List": "Ordered List",
                "Unordered List": "Unordered List",

                // Indent
                "Decrease Indent": "Decrease Indent",
                "Increase Indent": "Increase Indent",

                // Links
                "Insert Link": "Insert Link",
                "Open in new tab": "Open in new tab",
                "Open Link": "Open Link",
                "Edit Link": "Edit Link",
                "Unlink": "Unlink",
                "Choose Link": "Choose Link",

                // Images
                "Insert Image": "Insert Image",
                "Upload Image": "Upload Image",
                "By URL": "By URL",
                "Browse": "Browse",
                "Drop image": "Drop image",
                "or click": "or click",
                "Manage Images": "Manage Images",
                "Loading": "Loading",
                "Deleting": "Deleting",
                "Tags": "Tags",
                "Are you sure? Image will be deleted.": "Are you sure? Image will be deleted.",
                "Replace": "Replace",
                "Uploading": "Uploading",
                "Loading image": "Loading image",
                "Display": "Display",
                "Inline": "Inline",
                "Break Text": "Break Text",
                "Alternative Text": "Alternative Text",
                "Change Size": "Change Size",
                "Width": "Width",
                "Height": "Height",
                "Something went wrong. Please try again.": "Something went wrong. Please try again.",
                "Image Caption": "Image Caption",
                "Advanced Edit": "Advanced Edit",

                // Video
                "Insert Video": "Insert Video",
                "Embedded Code": "Embedded Code",
                "Paste in a video URL": "Paste in a video URL",
                "Drop video": "Drop video",
                "Your browser does not support HTML5 video.": "Your browser does not support HTML5 video.",
                "Upload Video": "Upload Video",

                // Tables
                "Insert Table": "Insert Table",
                "Table Header": "Table Header",
                "Remove Table": "Remove Table",
                "Table Style": "Table Style",
                "Horizontal Align": "Horizontal Align",
                "Row": "Row",
                "Insert row above": "Insert row above",
                "Insert row below": "Insert row below",
                "Delete row": "Delete row",
                "Column": "Column",
                "Insert column before": "Insert column before",
                "Insert column after": "Insert column after",
                "Delete column": "Delete column",
                "Cell": "Cell",
                "Merge cells": "Merge cells",
                "Horizontal split": "Horizontal split",
                "Vertical split": "Vertical split",
                "Cell Background": "Cell Background",
                "Vertical Align": "Vertical Align",
                "Top": "Top",
                "Middle": "Middle",
                "Bottom": "Bottom",
                "Align Top": "Align Top",
                "Align Middle": "Align Middle",
                "Align Bottom": "Align Bottom",
                "Cell Style": "Cell Style",

                // Files
                "Upload File": "Upload File",
                "Drop file": "Drop file",

                // Emoticons
                "Emoticons": "Emoticons",

                // Line breaker
                "Break": "Break",

                // Math
                "Subscript": "Subscript",
                "Superscript": "Superscript",

                // Full screen
                "Fullscreen": "Fullscreen",

                // Horizontal line
                "Insert Horizontal Line": "Insert Horizontal Line",

                // Clear formatting
                "Clear Formatting": "Cell Formatting",

                // Undo, redo
                "Undo": "Undo",
                "Redo": "Redo",

                // Select all
                "Select All": "Select All",

                // Code view
                "Code View": "Code View",

                // Quote
                "Quote": "Quote",
                "Increase": "Increase",
                "Decrease": "Decrease",

                // Quick Insert
                "Quick Insert": "Quick Insert",

                // Spcial Characters
                "Special Characters": "Special Characters",
                "Latin": "Latin",
                "Greek": "Greek",
                "Cyrillic": "Cyrillic",
                "Punctuation": "Punctuation",
                "Currency": "Currency",
                "Arrows": "Arrows",
                "Math": "Math",
                "Misc": "Misc",

                // Print.
                "Print": "Print",

                // Spell Checker.
                "Spell Checker": "Spell Checker",

                // Help
                "Help": "Help",
                "Shortcuts": "Shortcuts",
                "Inline Editor": "Inline Editor",
                "Show the editor": "Show the editor",
                "Common actions": "Common actions",
                "Copy": "Copy",
                "Cut": "Cut",
                "Paste": "Paste",
                "Basic Formatting": "Basic Formatting",
                "Increase quote level": "Increase quote level",
                "Decrease quote level": "Decrease quote level",
                "Image / Video": "Image / Video",
                "Resize larger": "Resize larger",
                "Resize smaller": "Resize smaller",
                "Table": "Table",
                "Select table cell": "Select table cell",
                "Extend selection one cell": "Extend selection one cell",
                "Extend selection one row": "Extend selection one row",
                "Navigation": "Navigation",
                "Focus popup / toolbar": "Focus popup / toolbar",
                "Return focus to previous position": "Return focus to previous position",

                // Embed.ly
                "Embed URL": "Embed URL",
                "Paste in a URL to embed": "Paste in a URL to embed",

                // Word Paste.
                "The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?": "The pasted content is coming from a formated document. Do you want to keep the format or clean it up?",
                "Keep": "Keep",
                "Clean": "Clean",
                "Word Paste Detected": "Paste Detected"
            }
        },
        "id": "en-ca",
        "pluralCat": function (n, opt_precision) { var i = n | 0; var vf = getVF(n, opt_precision); if (i == 1 && vf.v == 0) { return PLURAL_CATEGORY.ONE; } return PLURAL_CATEGORY.OTHER; }

    });
}])
;
angular.module("app.locale.en-gb", [
'tmh.dynamicLocale'
])

.run(['tmhDynamicLocaleCache', function (tmhDynamicLocaleCache) {
    var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
    function getDecimals(n) {
        n = n + '';
        var i = n.indexOf('.');
        return (i == -1) ? 0 : n.length - i - 1;
    }

    function getVF(n, opt_precision) {
        var v = opt_precision;

        if (undefined === v) {
            v = Math.min(getDecimals(n), 3);
        }

        var base = Math.pow(10, v);
        var f = ((n * base) | 0) % base;
        return { v: v, f: f };
    }

    tmhDynamicLocaleCache.put('en-gb', {
        "DATETIME_FORMATS": {
            "AMPMS": [
              "a.m.",
              "p.m."
            ],
            "DAY": [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday"
            ],
            "ERANAMES": [
              "Before Christ",
              "Anno Domini"
            ],
            "ERAS": [
              "BC",
              "AD"
            ],
            "FIRSTDAYOFWEEK": 0,
            "MONTH": [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December"
            ],
            "SHORTDAY": [
              "Sun",
              "Mon",
              "Tue",
              "Wed",
              "Thu",
              "Fri",
              "Sat"
            ],
            "SHORTMONTH": [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec"
            ],
            "STANDALONEMONTH": [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December"
            ],
            "WEEKENDRANGE": [
              5,
              6
            ],
            "fullDate": "EEEE, d MMMM y",
            "longDate": "d MMMM y",
            "medium": "d MMM y HH:mm:ss",
            "mediumDate": "d MMM y",
            "mediumTime": "HH:mm:ss",
            "short": "dd/MM/y HH:mm",
            "shortDate": "dd/MM/y",
            "shortTime": "HH:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "\u00a3",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
              {
                  "gSize": 3,
                  "lgSize": 3,
                  "maxFrac": 3,
                  "minFrac": 0,
                  "minInt": 1,
                  "negPre": "-",
                  "negSuf": "",
                  "posPre": "",
                  "posSuf": ""
              },
              {
                  "gSize": 3,
                  "lgSize": 3,
                  "maxFrac": 2,
                  "minFrac": 2,
                  "minInt": 1,
                  "negPre": "-\u00a4",
                  "negSuf": "",
                  "posPre": "\u00a4",
                  "posSuf": ""
              }
            ]
        },
        "FROALA":{
            "translation":{
                // Place holder
                "Type something": "Type something",

                // Basic formatting
                "Bold": "Bold",
                "Italic": "Italic",
                "Underline": "Underline",
                "Strikethrough": "Strikethrough",

                // Main buttons
                "Insert": "Insert",
                "Delete": "Delete",
                "Cancel": "Cancel",
                "OK": "OK",
                "Back": "Back",
                "Remove": "Remove",
                "More": "More",
                "Update": "Update",
                "Style": "Style",

                // Font
                "Font Family": "Font Family",
                "Font Size": "Font Size",

                // Colors
                "Colors": "Colours",
                "Background": "Background",
                "Text": "Text",
                "HEX Color": "HEX Colour",

                // Paragraphs
                "Paragraph Format": "Paragraph Format",
                "Normal": "Normal",
                "Code": "Code",
                "Heading 1": "Heading 1",
                "Heading 2": "Heading 2",
                "Heading 3": "Heading 3",
                "Heading 4": "Heading 4",

                // Style
                "Paragraph Style": "Paragraph Style",
                "Inline Style": "Inline Style",

                // Alignment
                "Align": "Align",
                "Align Left": "Align Left",
                "Align Center": "Align Centre",
                "Align Right": "Alight Right",
                "Align Justify": "Align Justify",
                "None": "None",

                // Lists
                "Ordered List": "Ordered List",
                "Unordered List": "Unordered List",

                // Indent
                "Decrease Indent": "Decrease Indent",
                "Increase Indent": "Increase Indent",

                // Links
                "Insert Link": "Insert Link",
                "Open in new tab": "Open in new tab",
                "Open Link": "Open Link",
                "Edit Link": "Edit Link",
                "Unlink": "Unlink",
                "Choose Link": "Choose Link",

                // Images
                "Insert Image": "Insert Image",
                "Upload Image": "Upload Image",
                "By URL": "By URL",
                "Browse": "Browse",
                "Drop image": "Drop image",
                "or click": "or click",
                "Manage Images": "Manage Images",
                "Loading": "Loading",
                "Deleting": "Deleting",
                "Tags": "Tags",
                "Are you sure? Image will be deleted.": "Are you sure? Image will be deleted.",
                "Replace": "Replace",
                "Uploading": "Uploading",
                "Loading image": "Loading image",
                "Display": "Display",
                "Inline": "Inline",
                "Break Text": "Break Text",
                "Alternative Text": "Alternative Text",
                "Change Size": "Change Size",
                "Width": "Width",
                "Height": "Height",
                "Something went wrong. Please try again.": "Something went wrong. Please try again.",
                "Image Caption": "Image Caption",
                "Advanced Edit": "Advanced Edit",

                // Video
                "Insert Video": "Insert Video",
                "Embedded Code": "Embedded Code",
                "Paste in a video URL": "Paste in a video URL",
                "Drop video": "Drop video",
                "Your browser does not support HTML5 video.": "Your browser does not support HTML5 video.",
                "Upload Video": "Upload Video",

                // Tables
                "Insert Table": "Insert Table",
                "Table Header": "Table Header",
                "Remove Table": "Remove Table",
                "Table Style": "Table Style",
                "Horizontal Align": "Horizontal Align",
                "Row": "Row",
                "Insert row above": "Insert row above",
                "Insert row below": "Insert row below",
                "Delete row": "Delete row",
                "Column": "Column",
                "Insert column before": "Insert column before",
                "Insert column after": "Insert column after",
                "Delete column": "Delete column",
                "Cell": "Cell",
                "Merge cells": "Merge cells",
                "Horizontal split": "Horizontal split",
                "Vertical split": "Vertical split",
                "Cell Background": "Cell Background",
                "Vertical Align": "Vertical Align",
                "Top": "Top",
                "Middle": "Middle",
                "Bottom": "Bottom",
                "Align Top": "Align Top",
                "Align Middle": "Align Middle",
                "Align Bottom": "Align Bottom",
                "Cell Style": "Cell Style",

                // Files
                "Upload File": "Upload File",
                "Drop file": "Drop file",

                // Emoticons
                "Emoticons": "Emoticons",

                // Line breaker
                "Break": "Break",

                // Math
                "Subscript": "Subscript",
                "Superscript": "Superscript",

                // Full screen
                "Fullscreen": "Fullscreen",

                // Horizontal line
                "Insert Horizontal Line": "Insert Horizontal Line",

                // Clear formatting
                "Clear Formatting": "Cell Formatting",

                // Undo, redo
                "Undo": "Undo",
                "Redo": "Redo",

                // Select all
                "Select All": "Select All",

                // Code view
                "Code View": "Code View",

                // Quote
                "Quote": "Quote",
                "Increase": "Increase",
                "Decrease": "Decrease",

                // Quick Insert
                "Quick Insert": "Quick Insert",

                // Spcial Characters
                "Special Characters": "Special Characters",
                "Latin": "Latin",
                "Greek": "Greek",
                "Cyrillic": "Cyrillic",
                "Punctuation": "Punctuation",
                "Currency": "Currency",
                "Arrows": "Arrows",
                "Math": "Math",
                "Misc": "Misc",

                // Print.
                "Print": "Print",

                // Spell Checker.
                "Spell Checker": "Spell Checker",

                // Help
                "Help": "Help",
                "Shortcuts": "Shortcuts",
                "Inline Editor": "Inline Editor",
                "Show the editor": "Show the editor",
                "Common actions": "Common actions",
                "Copy": "Copy",
                "Cut": "Cut",
                "Paste": "Paste",
                "Basic Formatting": "Basic Formatting",
                "Increase quote level": "Increase quote level",
                "Decrease quote level": "Decrease quote level",
                "Image / Video": "Image / Video",
                "Resize larger": "Resize larger",
                "Resize smaller": "Resize smaller",
                "Table": "Table",
                "Select table cell": "Select table cell",
                "Extend selection one cell": "Extend selection one cell",
                "Extend selection one row": "Extend selection one row",
                "Navigation": "Navigation",
                "Focus popup / toolbar": "Focus popup / toolbar",
                "Return focus to previous position": "Return focus to previous position",

                // Embed.ly
                "Embed URL": "Embed URL",
                "Paste in a URL to embed": "Paste in a URL to embed",

                // Word Paste.
                "The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?": "The pasted content is coming from a formatted document. Do you want to keep the format or clean it up?",
                "Keep": "Keep",
                "Clean": "Clean",
                "Word Paste Detected": "Paste Detected"
              }
         },
        "id": "en-gb",
        "localeID": "en_GB",
        "pluralCat": function (n, opt_precision) { var i = n | 0; var vf = getVF(n, opt_precision); if (i == 1 && vf.v == 0) { return PLURAL_CATEGORY.ONE; } return PLURAL_CATEGORY.OTHER; }
    });
}])
;
angular.module("app.locale.en-ie", [
'tmh.dynamicLocale'
])

.run(['tmhDynamicLocaleCache', function (tmhDynamicLocaleCache) {
    var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
    function getDecimals(n) {
        n = n + '';
        var i = n.indexOf('.');
        return (i == -1) ? 0 : n.length - i - 1;
    }

    function getVF(n, opt_precision) {
        var v = opt_precision;

        if (undefined === v) {
            v = Math.min(getDecimals(n), 3);
        }

        var base = Math.pow(10, v);
        var f = ((n * base) | 0) % base;
        return { v: v, f: f };
    }
    tmhDynamicLocaleCache.put('en-ie', {
        "DATETIME_FORMATS": {
            "AMPMS": [
              "a.m.",
              "p.m."
            ],
            "DAY": [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday"
            ],
            "MONTH": [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December"
            ],
            "SHORTDAY": [
              "Sun",
              "Mon",
              "Tue",
              "Wed",
              "Thu",
              "Fri",
              "Sat"
            ],
            "SHORTMONTH": [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec"
            ],
            "fullDate": "EEEE d MMMM y",
            "longDate": "d MMMM y",
            "medium": "d MMM y HH:mm:ss",
            "mediumDate": "d MMM y",
            "mediumTime": "HH:mm:ss",
            "short": "dd/MM/y HH:mm",
            "shortDate": "dd/MM/y",
            "shortTime": "HH:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "\u20ac",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
              {
                  "gSize": 3,
                  "lgSize": 3,
                  "maxFrac": 3,
                  "minFrac": 0,
                  "minInt": 1,
                  "negPre": "-",
                  "negSuf": "",
                  "posPre": "",
                  "posSuf": ""
              },
              {
                  "gSize": 3,
                  "lgSize": 3,
                  "maxFrac": 2,
                  "minFrac": 2,
                  "minInt": 1,
                  "negPre": "\u00a4-",
                  "negSuf": "",
                  "posPre": "\u00a4",
                  "posSuf": ""
              }
            ]
        },
        "FROALA": {
            "translation": {
                // Place holder
                "Type something": "Type something",

                // Basic formatting
                "Bold": "Bold",
                "Italic": "Italic",
                "Underline": "Underline",
                "Strikethrough": "Strikethrough",

                // Main buttons
                "Insert": "Insert",
                "Delete": "Delete",
                "Cancel": "Cancel",
                "OK": "OK",
                "Back": "Back",
                "Remove": "Remove",
                "More": "More",
                "Update": "Update",
                "Style": "Style",

                // Font
                "Font Family": "Font Family",
                "Font Size": "Font Size",

                // Colors
                "Colors": "Colours",
                "Background": "Background",
                "Text": "Text",
                "HEX Color": "HEX Colour",

                // Paragraphs
                "Paragraph Format": "Paragraph Format",
                "Normal": "Normal",
                "Code": "Code",
                "Heading 1": "Heading 1",
                "Heading 2": "Heading 2",
                "Heading 3": "Heading 3",
                "Heading 4": "Heading 4",

                // Style
                "Paragraph Style": "Paragraph Style",
                "Inline Style": "Inline Style",

                // Alignment
                "Align": "Align",
                "Align Left": "Align Left",
                "Align Center": "Align Centre",
                "Align Right": "Alight Right",
                "Align Justify": "Align Justify",
                "None": "None",

                // Lists
                "Ordered List": "Ordered List",
                "Unordered List": "Unordered List",

                // Indent
                "Decrease Indent": "Decrease Indent",
                "Increase Indent": "Increase Indent",

                // Links
                "Insert Link": "Insert Link",
                "Open in new tab": "Open in new tab",
                "Open Link": "Open Link",
                "Edit Link": "Edit Link",
                "Unlink": "Unlink",
                "Choose Link": "Choose Link",

                // Images
                "Insert Image": "Insert Image",
                "Upload Image": "Upload Image",
                "By URL": "By URL",
                "Browse": "Browse",
                "Drop image": "Drop image",
                "or click": "or click",
                "Manage Images": "Manage Images",
                "Loading": "Loading",
                "Deleting": "Deleting",
                "Tags": "Tags",
                "Are you sure? Image will be deleted.": "Are you sure? Image will be deleted.",
                "Replace": "Replace",
                "Uploading": "Uploading",
                "Loading image": "Loading image",
                "Display": "Display",
                "Inline": "Inline",
                "Break Text": "Break Text",
                "Alternative Text": "Alternative Text",
                "Change Size": "Change Size",
                "Width": "Width",
                "Height": "Height",
                "Something went wrong. Please try again.": "Something went wrong. Please try again.",
                "Image Caption": "Image Caption",
                "Advanced Edit": "Advanced Edit",

                // Video
                "Insert Video": "Insert Video",
                "Embedded Code": "Embedded Code",
                "Paste in a video URL": "Paste in a video URL",
                "Drop video": "Drop video",
                "Your browser does not support HTML5 video.": "Your browser does not support HTML5 video.",
                "Upload Video": "Upload Video",

                // Tables
                "Insert Table": "Insert Table",
                "Table Header": "Table Header",
                "Remove Table": "Remove Table",
                "Table Style": "Table Style",
                "Horizontal Align": "Horizontal Align",
                "Row": "Row",
                "Insert row above": "Insert row above",
                "Insert row below": "Insert row below",
                "Delete row": "Delete row",
                "Column": "Column",
                "Insert column before": "Insert column before",
                "Insert column after": "Insert column after",
                "Delete column": "Delete column",
                "Cell": "Cell",
                "Merge cells": "Merge cells",
                "Horizontal split": "Horizontal split",
                "Vertical split": "Vertical split",
                "Cell Background": "Cell Background",
                "Vertical Align": "Vertical Align",
                "Top": "Top",
                "Middle": "Middle",
                "Bottom": "Bottom",
                "Align Top": "Align Top",
                "Align Middle": "Align Middle",
                "Align Bottom": "Align Bottom",
                "Cell Style": "Cell Style",

                // Files
                "Upload File": "Upload File",
                "Drop file": "Drop file",

                // Emoticons
                "Emoticons": "Emoticons",

                // Line breaker
                "Break": "Break",

                // Math
                "Subscript": "Subscript",
                "Superscript": "Superscript",

                // Full screen
                "Fullscreen": "Fullscreen",

                // Horizontal line
                "Insert Horizontal Line": "Insert Horizontal Line",

                // Clear formatting
                "Clear Formatting": "Cell Formatting",

                // Undo, redo
                "Undo": "Undo",
                "Redo": "Redo",

                // Select all
                "Select All": "Select All",

                // Code view
                "Code View": "Code View",

                // Quote
                "Quote": "Quote",
                "Increase": "Increase",
                "Decrease": "Decrease",

                // Quick Insert
                "Quick Insert": "Quick Insert",

                // Spcial Characters
                "Special Characters": "Special Characters",
                "Latin": "Latin",
                "Greek": "Greek",
                "Cyrillic": "Cyrillic",
                "Punctuation": "Punctuation",
                "Currency": "Currency",
                "Arrows": "Arrows",
                "Math": "Math",
                "Misc": "Misc",

                // Print.
                "Print": "Print",

                // Spell Checker.
                "Spell Checker": "Spell Checker",

                // Help
                "Help": "Help",
                "Shortcuts": "Shortcuts",
                "Inline Editor": "Inline Editor",
                "Show the editor": "Show the editor",
                "Common actions": "Common actions",
                "Copy": "Copy",
                "Cut": "Cut",
                "Paste": "Paste",
                "Basic Formatting": "Basic Formatting",
                "Increase quote level": "Increase quote level",
                "Decrease quote level": "Decrease quote level",
                "Image / Video": "Image / Video",
                "Resize larger": "Resize larger",
                "Resize smaller": "Resize smaller",
                "Table": "Table",
                "Select table cell": "Select table cell",
                "Extend selection one cell": "Extend selection one cell",
                "Extend selection one row": "Extend selection one row",
                "Navigation": "Navigation",
                "Focus popup / toolbar": "Focus popup / toolbar",
                "Return focus to previous position": "Return focus to previous position",

                // Embed.ly
                "Embed URL": "Embed URL",
                "Paste in a URL to embed": "Paste in a URL to embed",

                // Word Paste.
                "The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?": "The pasted content is coming from a formatted document. Do you want to keep the format or clean it up?",
                "Keep": "Keep",
                "Clean": "Clean",
                "Word Paste Detected": "Paste Detected"
            }
        },
        "id": "en-ie",
        "pluralCat": function (n, opt_precision) { var i = n | 0; var vf = getVF(n, opt_precision); if (i == 1 && vf.v == 0) { return PLURAL_CATEGORY.ONE; } return PLURAL_CATEGORY.OTHER; }

    });
}])
;
angular.module("app.locale.en-us", [
'tmh.dynamicLocale'
])

.run(['tmhDynamicLocaleCache', function (tmhDynamicLocaleCache) {
    var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
    function getDecimals(n) {
        n = n + '';
        var i = n.indexOf('.');
        return (i == -1) ? 0 : n.length - i - 1;
    }

    function getVF(n, opt_precision) {
        var v = opt_precision;

        if (undefined === v) {
            v = Math.min(getDecimals(n), 3);
        }

        var base = Math.pow(10, v);
        var f = ((n * base) | 0) % base;
        return { v: v, f: f };
    }
    tmhDynamicLocaleCache.put('en-us', {
        "DATETIME_FORMATS": {
            "AMPMS": [
              "AM",
              "PM"
            ],
            "DAY": [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday"
            ],
            "MONTH": [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December"
            ],
            "SHORTDAY": [
              "Sun",
              "Mon",
              "Tue",
              "Wed",
              "Thu",
              "Fri",
              "Sat"
            ],
            "SHORTMONTH": [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec"
            ],
            "fullDate": "EEEE, MMMM d, y",
            "longDate": "MMMM d, y",
            "medium": "MMM d, y h:mm:ss a",
            "mediumDate": "MMM d, y",
            "mediumTime": "h:mm:ss a",
            "short": "M/d/yy h:mm a",
            "shortDate": "M/d/y",
            "shortTime": "h:mm a"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "$",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
              {
                  "gSize": 3,
                  "lgSize": 3,
                  "maxFrac": 3,
                  "minFrac": 0,
                  "minInt": 1,
                  "negPre": "-",
                  "negSuf": "",
                  "posPre": "",
                  "posSuf": ""
              },
              {
                  "gSize": 3,
                  "lgSize": 3,
                  "maxFrac": 2,
                  "minFrac": 2,
                  "minInt": 1,
                  "negPre": "\u00a4-",
                  "negSuf": "",
                  "posPre": "\u00a4",
                  "posSuf": ""
              }
            ]
        },
        "FROALA": {
            "translation": {
                // Place holder
                "Type something": "Type something",

                // Basic formatting
                "Bold": "Bold",
                "Italic": "Italic",
                "Underline": "Underline",
                "Strikethrough": "Strikethrough",

                // Main buttons
                "Insert": "Insert",
                "Delete": "Delete",
                "Cancel": "Cancel",
                "OK": "OK",
                "Back": "Back",
                "Remove": "Remove",
                "More": "More",
                "Update": "Update",
                "Style": "Style",

                // Font
                "Font Family": "Font Family",
                "Font Size": "Font Size",

                // Colors
                "Colors": "Colours",
                "Background": "Background",
                "Text": "Text",
                "HEX Color": "HEX Colour",

                // Paragraphs
                "Paragraph Format": "Paragraph Format",
                "Normal": "Normal",
                "Code": "Code",
                "Heading 1": "Heading 1",
                "Heading 2": "Heading 2",
                "Heading 3": "Heading 3",
                "Heading 4": "Heading 4",

                // Style
                "Paragraph Style": "Paragraph Style",
                "Inline Style": "Inline Style",

                // Alignment
                "Align": "Align",
                "Align Left": "Align Left",
                "Align Center": "Align Centre",
                "Align Right": "Alight Right",
                "Align Justify": "Align Justify",
                "None": "None",

                // Lists
                "Ordered List": "Ordered List",
                "Unordered List": "Unordered List",

                // Indent
                "Decrease Indent": "Decrease Indent",
                "Increase Indent": "Increase Indent",

                // Links
                "Insert Link": "Insert Link",
                "Open in new tab": "Open in new tab",
                "Open Link": "Open Link",
                "Edit Link": "Edit Link",
                "Unlink": "Unlink",
                "Choose Link": "Choose Link",

                // Images
                "Insert Image": "Insert Image",
                "Upload Image": "Upload Image",
                "By URL": "By URL",
                "Browse": "Browse",
                "Drop image": "Drop image",
                "or click": "or click",
                "Manage Images": "Manage Images",
                "Loading": "Loading",
                "Deleting": "Deleting",
                "Tags": "Tags",
                "Are you sure? Image will be deleted.": "Are you sure? Image will be deleted.",
                "Replace": "Replace",
                "Uploading": "Uploading",
                "Loading image": "Loading image",
                "Display": "Display",
                "Inline": "Inline",
                "Break Text": "Break Text",
                "Alternative Text": "Alternative Text",
                "Change Size": "Change Size",
                "Width": "Width",
                "Height": "Height",
                "Something went wrong. Please try again.": "Something went wrong. Please try again.",
                "Image Caption": "Image Caption",
                "Advanced Edit": "Advanced Edit",

                // Video
                "Insert Video": "Insert Video",
                "Embedded Code": "Embedded Code",
                "Paste in a video URL": "Paste in a video URL",
                "Drop video": "Drop video",
                "Your browser does not support HTML5 video.": "Your browser does not support HTML5 video.",
                "Upload Video": "Upload Video",

                // Tables
                "Insert Table": "Insert Table",
                "Table Header": "Table Header",
                "Remove Table": "Remove Table",
                "Table Style": "Table Style",
                "Horizontal Align": "Horizontal Align",
                "Row": "Row",
                "Insert row above": "Insert row above",
                "Insert row below": "Insert row below",
                "Delete row": "Delete row",
                "Column": "Column",
                "Insert column before": "Insert column before",
                "Insert column after": "Insert column after",
                "Delete column": "Delete column",
                "Cell": "Cell",
                "Merge cells": "Merge cells",
                "Horizontal split": "Horizontal split",
                "Vertical split": "Vertical split",
                "Cell Background": "Cell Background",
                "Vertical Align": "Vertical Align",
                "Top": "Top",
                "Middle": "Middle",
                "Bottom": "Bottom",
                "Align Top": "Align Top",
                "Align Middle": "Align Middle",
                "Align Bottom": "Align Bottom",
                "Cell Style": "Cell Style",

                // Files
                "Upload File": "Upload File",
                "Drop file": "Drop file",

                // Emoticons
                "Emoticons": "Emoticons",

                // Line breaker
                "Break": "Break",

                // Math
                "Subscript": "Subscript",
                "Superscript": "Superscript",

                // Full screen
                "Fullscreen": "Fullscreen",

                // Horizontal line
                "Insert Horizontal Line": "Insert Horizontal Line",

                // Clear formatting
                "Clear Formatting": "Cell Formatting",

                // Undo, redo
                "Undo": "Undo",
                "Redo": "Redo",

                // Select all
                "Select All": "Select All",

                // Code view
                "Code View": "Code View",

                // Quote
                "Quote": "Quote",
                "Increase": "Increase",
                "Decrease": "Decrease",

                // Quick Insert
                "Quick Insert": "Quick Insert",

                // Spcial Characters
                "Special Characters": "Special Characters",
                "Latin": "Latin",
                "Greek": "Greek",
                "Cyrillic": "Cyrillic",
                "Punctuation": "Punctuation",
                "Currency": "Currency",
                "Arrows": "Arrows",
                "Math": "Math",
                "Misc": "Misc",

                // Print.
                "Print": "Print",

                // Spell Checker.
                "Spell Checker": "Spell Checker",

                // Help
                "Help": "Help",
                "Shortcuts": "Shortcuts",
                "Inline Editor": "Inline Editor",
                "Show the editor": "Show the editor",
                "Common actions": "Common actions",
                "Copy": "Copy",
                "Cut": "Cut",
                "Paste": "Paste",
                "Basic Formatting": "Basic Formatting",
                "Increase quote level": "Increase quote level",
                "Decrease quote level": "Decrease quote level",
                "Image / Video": "Image / Video",
                "Resize larger": "Resize larger",
                "Resize smaller": "Resize smaller",
                "Table": "Table",
                "Select table cell": "Select table cell",
                "Extend selection one cell": "Extend selection one cell",
                "Extend selection one row": "Extend selection one row",
                "Navigation": "Navigation",
                "Focus popup / toolbar": "Focus popup / toolbar",
                "Return focus to previous position": "Return focus to previous position",

                // Embed.ly
                "Embed URL": "Embed URL",
                "Paste in a URL to embed": "Paste in a URL to embed",

                // Word Paste.
                "The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?": "The pasted content is coming from a formatted document. Do you want to keep the format or clean it up?",
                "Keep": "Keep",
                "Clean": "Clean",
                "Word Paste Detected": "Paste Detected"
            }
        },
        "id": "en-us",
        "pluralCat": function (n, opt_precision) { var i = n | 0; var vf = getVF(n, opt_precision); if (i == 1 && vf.v == 0) { return PLURAL_CATEGORY.ONE; } return PLURAL_CATEGORY.OTHER; }
    });
}])
;
angular.module("app.locale.es-cl", [
'tmh.dynamicLocale'
])

.run(['tmhDynamicLocaleCache', function (tmhDynamicLocaleCache) {
    var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };

    tmhDynamicLocaleCache.put('es-cl', {
        "DATETIME_FORMATS": {
            "AMPMS": [
              "a. m.",
              "p. m."
            ],
            "DAY": [
              "domingo",
              "lunes",
              "martes",
              "mi\u00e9rcoles",
              "jueves",
              "viernes",
              "s\u00e1bado"
            ],
            "ERANAMES": [
              "antes de Cristo",
              "despu\u00e9s de Cristo"
            ],
            "ERAS": [
              "a. C.",
              "d. C."
            ],
            "FIRSTDAYOFWEEK": 0,
            "MONTH": [
              "enero",
              "febrero",
              "marzo",
              "abril",
              "mayo",
              "junio",
              "julio",
              "agosto",
              "septiembre",
              "octubre",
              "noviembre",
              "diciembre"
            ],
            "SHORTDAY": [
              "dom.",
              "lun.",
              "mar.",
              "mi\u00e9.",
              "jue.",
              "vie.",
              "s\u00e1b."
            ],
            "SHORTMONTH": [
              "ene.",
              "feb.",
              "mar.",
              "abr.",
              "may.",
              "jun.",
              "jul.",
              "ago.",
              "sept.",
              "oct.",
              "nov.",
              "dic."
            ],
            "STANDALONEMONTH": [
              "Enero",
              "Febrero",
              "Marzo",
              "Abril",
              "Mayo",
              "Junio",
              "Julio",
              "Agosto",
              "Septiembre",
              "Octubre",
              "Noviembre",
              "Diciembre"
            ],
            "WEEKENDRANGE": [
              5,
              6
            ],
            "fullDate": "EEEE, d 'de' MMMM 'de' y",
            "longDate": "d 'de' MMMM 'de' y",
            "medium": "dd-MM-y h:mm:ss a",
            "mediumDate": "dd-MM-y",
            "mediumTime": "h:mm:ss a",
            "short": "dd-MM-yy h:mm a",
            "shortDate": "dd-MM-yy",
            "shortTime": "h:mm a"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "$",
            "DECIMAL_SEP": ",",
            "GROUP_SEP": ".",
            "PATTERNS": [
              {
                  "gSize": 3,
                  "lgSize": 3,
                  "maxFrac": 3,
                  "minFrac": 0,
                  "minInt": 1,
                  "negPre": "-",
                  "negSuf": "",
                  "posPre": "",
                  "posSuf": ""
              },
              {
                  "gSize": 3,
                  "lgSize": 3,
                  "maxFrac": 2,
                  "minFrac": 2,
                  "minInt": 1,
                  "negPre": "\u00a4-",
                  "negSuf": "",
                  "posPre": "\u00a4",
                  "posSuf": ""
              }
            ]
        },
        "FROALA": {
            "translation": {
            // Place holder
                "Type something": "Escriba algo",

                // Basic formatting
                "Bold": "Negrita",
                "Italic": "It\u00e1lica",
                "Underline": "Subrayado",
                "Strikethrough": "Tachado",

                // Main buttons
                "Insert": "Insertar",
                "Delete": "Borrar",
                "Cancel": "Cancelar",
                "OK": "Ok",
                "Back": "Atr\u00e1s",
                "Remove": "Quitar",
                "More": "M\u00e1s",
                "Update": "Actualizaci\u00f3n",
                "Style": "Estilo",

                // Font
                "Font Family": "Familia de fuentes",
                "Font Size": "Tama\u00f1o de fuente",

                // Colors
                "Colors": "Colores",
                "Background": "Fondo",
                "Text": "Texto",
                "HEX Color": "Color hexadecimal",

                // Paragraphs
                "Paragraph Format": "Formato de p\u00e1rrafo",
                "Normal": "Normal",
                "Code": "C\u00f3digo",
                "Heading 1": "Encabezado 1",
                "Heading 2": "Encabezado 2",
                "Heading 3": "Encabezado 3",
                "Heading 4": "Encabezado 4",

                // Style
                "Paragraph Style": "Estilo de p\u00e1rrafo",
                "Inline Style": "Estilo en l\u00ednea",

                // Alignment
                "Align": "Alinear",
                "Align Left": "Alinear a la izquierda",
                "Align Center": "Alinear al centro",
                "Align Right": "Alinear a la derecha",
                "Align Justify": "Justificar",
                "None": "Ninguno",

                // Lists
                "Ordered List": "Lista ordenada",
                "Unordered List": "Lista desordenada",

                // Indent
                "Decrease Indent": "Reducir sangr\u00eda",
                "Increase Indent": "Aumentar sangr\u00eda",

                // Links
                "Insert Link": "Insertar enlace",
                "Open in new tab": "Abrir en una nueva pesta\u00F1a",
                "Open Link": "Abrir enlace",
                "Edit Link": "Editar enlace",
                "Unlink": "Quitar enlace",
                "Choose Link": "Elegir enlace",

                // Images
                "Insert Image": "Insertar imagen",
                "Upload Image": "Cargar imagen",
                "By URL": "Por URL",
                "Browse": "Examinar",
                "Drop image": "Soltar la imagen",
                "or click": "o haga clic en",
                "Manage Images": "Administrar im\u00e1genes",
                "Loading": "Cargando",
                "Deleting": "Borrado",
                "Tags": "Etiquetas",
                "Are you sure? Image will be deleted.": "\u00bfEst\u00e1 seguro? Imagen ser\u00e1 borrada.",
                "Replace": "Reemplazar",
                "Uploading": "Carga",
                "Loading image": "Cargando imagen",
                "Display": "Mostrar",
                "Inline": "En l\u00ednea",
                "Break Text": "Romper texto",
                "Alternative Text": "Texto alternativo",
                "Change Size": "Cambiar tama\u00f1o",
                "Width": "Ancho",
                "Height": "Altura",
                "Something went wrong. Please try again.": "Algo sali\u00f3 mal. Por favor, vuelva a intentarlo.",
                "Image Caption": "Captura de imagen",
                "Advanced Edit": "Edición avanzada",

                // Video
                "Insert Video": "Insertar video",
                "Embedded Code": "C\u00f3digo incrustado",
                "Paste in a video URL": "Pegar en una URL de video",
                "Drop video": "Soltar video",
                "Your browser does not support HTML5 video.": "Su navegador no es compatible con video html5.",
                "Upload Video": "Subir video",

                // Tables
                "Insert Table": "Insertar tabla",
                "Table Header": "Encabezado de la tabla",
                "Remove Table": "Retire la tabla",
                "Table Style": "Estilo de tabla",
                "Horizontal Align": "Alinear horizontal",
                "Row": "Fila",
                "Insert row above": "Insertar fila antes",
                "Insert row below": "Insertar fila despu\u00e9s",
                "Delete row": "Eliminar fila",
                "Column": "Columna",
                "Insert column before": "Insertar columna antes",
                "Insert column after": "Insertar columna despu\u00e9s",
                "Delete column": "Eliminar columna",
                "Cell": "Celda",
                "Merge cells": "Combinar celdas",
                "Horizontal split": "Divisi\u00f3n horizontal",
                "Vertical split": "Divisi\u00f3n vertical",
                "Cell Background": "Fondo de la celda",
                "Vertical Align": "Alinear vertical",
                "Top": "Cima",
                "Middle": "Medio",
                "Bottom": "Del fondo",
                "Align Top": "Alinear a la parte superior",
                "Align Middle": "Alinear media",
                "Align Bottom": "Alinear abajo",
                "Cell Style": "Estilo de celda",

                // Files
                "Upload File": "Subir archivo",
                "Drop file": "Soltar archivo",

                // Emoticons
                "Emoticons": "Emoticones",
                "Grinning face": "Sonriendo cara",
                "Grinning face with smiling eyes": "Sonriendo cara con ojos sonrientes",
                "Face with tears of joy": "Cara con l\u00e1grimas de alegr\u00eda",
                "Smiling face with open mouth": "Cara sonriente con la boca abierta",
                "Smiling face with open mouth and smiling eyes": "Cara sonriente con la boca abierta y los ojos sonrientes",
                "Smiling face with open mouth and cold sweat": "Cara sonriente con la boca abierta y el sudor fr\u00edo",
                "Smiling face with open mouth and tightly-closed eyes": "Cara sonriente con la boca abierta y los ojos fuertemente cerrados",
                "Smiling face with halo": "Cara sonriente con halo",
                "Smiling face with horns": "Cara sonriente con cuernos",
                "Winking face": "Gui\u00f1o de la cara",
                "Smiling face with smiling eyes": "Cara sonriente con ojos sonrientes",
                "Face savoring delicious food": "Care saborear una deliciosa comida",
                "Relieved face": "Cara Aliviado",
                "Smiling face with heart-shaped eyes": "Cara sonriente con los ojos en forma de coraz\u00f3n",
                "Smiling face with sunglasses": "Cara sonriente con gafas de sol",
                "Smirking face": "Sonriendo cara",
                "Neutral face": "Cara neutral",
                "Expressionless face": "Rostro inexpresivo",
                "Unamused face": "Cara no divertido",
                "Face with cold sweat": "Cara con sudor fr\u00edo",
                "Pensive face": "Rostro pensativo",
                "Confused face": "Cara confusa",
                "Confounded face": "Cara Averg\u00fc\u00e9ncense",
                "Kissing face": "Besar la cara",
                "Face throwing a kiss": "Cara lanzando un beso",
                "Kissing face with smiling eyes": "Besar a cara con ojos sonrientes",
                "Kissing face with closed eyes": "Besar a cara con los ojos cerrados",
                "Face with stuck out tongue": "Cara con la lengua pegada",
                "Face with stuck out tongue and winking eye": "Cara con pegado a la lengua y los ojos gui\u00f1o",
                "Face with stuck out tongue and tightly-closed eyes": "Cara con la lengua pegada a y los ojos fuertemente cerrados",
                "Disappointed face": "Cara decepcionado",
                "Worried face": "Cara de preocupaci\u00f3n",
                "Angry face": "Cara enojada",
                "Pouting face": "Que pone mala cara",
                "Crying face": "Cara llorando",
                "Persevering face": "Perseverar cara",
                "Face with look of triumph": "Cara con expresi\u00f3n de triunfo",
                "Disappointed but relieved face": "Decepcionado pero el rostro aliviado",
                "Frowning face with open mouth": "Con el ce\u00f1o fruncido la cara con la boca abierta",
                "Anguished face": "Rostro angustiado",
                "Fearful face": "Cara Temeroso",
                "Weary face": "Rostro cansado",
                "Sleepy face": "Rostro so\u00f1oliento",
                "Tired face": "Rostro cansado",
                "Grimacing face": "Haciendo una mueca cara",
                "Loudly crying face": "Llorando en voz alta la cara",
                "Face with open mouth": "Cara con la boca abierta",
                "Hushed face": "Cara callada",
                "Face with open mouth and cold sweat": "Cara con la boca abierta y el sudor frío",
                "Face screaming in fear": "Cara gritando de miedo",
                "Astonished face": "Cara asombrosa",
                "Flushed face": "Cara enrojecida",
                "Sleeping face": "Rostro dormido",
                "Dizzy face": "Cara Mareado",
                "Face without mouth": "Cara sin boca",
                "Face with medical mask": "Cara con la m\u00e1scara m\u00e9dica",

                // Line breaker
                "Break": "Romper",

                // Math
                "Subscript": "Sub\u00edndice",
                "Superscript": "Super\u00edndice",

                // Full screen
                "Fullscreen": "Pantalla completa",

                // Horizontal line
                "Insert Horizontal Line": "Insertar l\u00ednea horizontal",

                // Clear formatting
                "Clear Formatting": "Quitar el formato",

                // Undo, redo
                "Undo": "Deshacer",
                "Redo": "Rehacer",

                // Select all
                "Select All": "Seleccionar todo",

                // Code view
                "Code View": "Vista de c\u00f3digo",

                // Quote
                "Quote": "Cita",
                "Increase": "Aumentar",
                "Decrease": "Disminuci\u00f3n",

                // Quick Insert
                "Quick Insert": "Inserci\u00f3n r\u00e1pida",

                // Spcial Characters
                "Special Characters": "Caracteres especiales",
                "Latin": "Latín",
                "Greek": "Griego",
                "Cyrillic": "Cirílico",
                "Punctuation": "Puntuación",
                "Currency": "Moneda",
                "Arrows": "Flechas",
                "Math": "Mates",
                "Misc": "Misc",

                // Print.
                "Print": "Impresión",

                // Spell Checker.
                "Spell Checker": "Corrector ortográfico",

                // Help
                "Help": "Ayuda",
                "Shortcuts": "Atajos",
                "Inline Editor": "Editor en línea",
                "Show the editor": "Mostrar al editor",
                "Common actions": "Acciones comunes",
                "Copy": "Dupdo",
                "Cut": "Cortar",
                "Paste": "Pegar",
                "Basic Formatting": "Formato básico",
                "Increase quote level": "Aumentar el nivel de cotización",
                "Decrease quote level": "Disminuir el nivel de cotización",
                "Image / Video": "Imagen / video",
                "Resize larger": "Redimensionar más grande",
                "Resize smaller": "Redimensionar más pequeño",
                "Table": "Mesa",
                "Select table cell": "Celda de tabla select",
                "Extend selection one cell": "Ampliar la selección una celda",
                "Extend selection one row": "Ampliar la selección una fila",
                "Navigation": "Navegación",
                "Focus popup / toolbar": "Focus popup / toolbar",
                "Return focus to previous position": "Volver al foco a la posición anterior",

                // Embed.ly
                "Embed URL": "URL de inserción",
                "Paste in a URL to embed": "Pegar en una url para incrustar",

                // Word Paste.
                "The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?": "El contenido pegado viene de un documento formateado. ¿Quieres mantener el formato o limpiarlo?",
                "Keep": "Guardar",
                "Clean": "Limpiar",
                "Word Paste Detected": "Pegar detectado"
            }
        },
        "id": "es-cl",
        "localeID": "es_CL",
        "pluralCat": function (n, opt_precision) { if (n == 1) { return PLURAL_CATEGORY.ONE; } return PLURAL_CATEGORY.OTHER; }
    });
}])
;
angular.module("app.locale.no", [
'tmh.dynamicLocale'
])

.run(['tmhDynamicLocaleCache', function (tmhDynamicLocaleCache) {
    var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };

    tmhDynamicLocaleCache.put('no', {
        "DATETIME_FORMATS": {
            "AMPMS": [
              "a.m.",
              "p.m."
            ],
            "DAY": [
              "s\u00f8ndag",
              "mandag",
              "tirsdag",
              "onsdag",
              "torsdag",
              "fredag",
              "l\u00f8rdag"
            ],
            "MONTH": [
              "januar",
              "februar",
              "mars",
              "april",
              "mai",
              "juni",
              "juli",
              "august",
              "september",
              "oktober",
              "november",
              "desember"
            ],
            "SHORTDAY": [
              "s\u00f8n.",
              "man.",
              "tir.",
              "ons.",
              "tor.",
              "fre.",
              "l\u00f8r."
            ],
            "SHORTMONTH": [
              "jan.",
              "feb.",
              "mar.",
              "apr.",
              "mai",
              "jun.",
              "jul.",
              "aug.",
              "sep.",
              "okt.",
              "nov.",
              "des."
            ],
            "fullDate": "EEEE d. MMMM y",
            "longDate": "d. MMMM y",
            "medium": "d. MMM y HH.mm.ss",
            "mediumDate": "d. MMM y",
            "mediumTime": "HH.mm.ss",
            "short": "dd.MM.y HH.mm",
            "shortDate": "dd.MM.y",
            "shortTime": "HH.mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "kr",
            "DECIMAL_SEP": ",",
            "GROUP_SEP": "\u00a0",
            "PATTERNS": [
              {
                  "gSize": 3,
                  "lgSize": 3,
                  "maxFrac": 3,
                  "minFrac": 0,
                  "minInt": 1,
                  "negPre": "-",
                  "negSuf": "",
                  "posPre": "",
                  "posSuf": ""
              },
              {
                  "gSize": 3,
                  "lgSize": 3,
                  "maxFrac": 2,
                  "minFrac": 2,
                  "minInt": 1,
                  "negPre": "\u00a4\u00a0-",
                  "negSuf": "",
                  "posPre": "\u00a4\u00a0",
                  "posSuf": ""
              }
            ]
        },
        "FROALA": {
                    "translation": {
                // Place holder
                    "Type something": "Skriv noe",

                    // Basic formatting
                    "Bold": "Fet",
                    "Italic": "Kursiv",
                    "Underline": "Understreket",
                    "Strikethrough": "Gjennomstreket",

                    // Main buttons
                    "Insert": "Sett",
                    "Delete": "Slett",
                    "Cancel": "Avbryt",
                    "OK": "OK",
                    "Back": "Tilbake",
                    "Remove": "Fjern",
                    "More": "Mer",
                    "Update": "Oppdatering",
                    "Style": "Stil",

                    // Font
                    "Font Family": "Skriftsnitt",
                    "Font Size": "St\u00f8rrelse",

                    // Colors
                    "Colors": "Farger",
                    "Background": "Bakgrunn",
                    "Text": "Tekst",
                    "HEX Color": "Heksefarge",

                    // Paragraphs
                    "Paragraph Format": "Stiler",
                    "Normal": "Normal",
                    "Code": "Kode",
                    "Heading 1": "Overskrift 1",
                    "Heading 2": "Overskrift 2",
                    "Heading 3": "Overskrift 3",
                    "Heading 4": "Overskrift 4",

                    // Style
                    "Paragraph Style": "Avsnittsstil",
                    "Inline Style": "P\u00e5 linje stil",

                    // Alignment
                    "Align": "Justering",
                    "Align Left": "Venstrejustert",
                    "Align Center": "Midtstilt",
                    "Align Right": "H\u00f8yrejustert",
                    "Align Justify": "Juster alle linjer",
                    "None": "None",

                    // Lists
                    "Ordered List": "Ordnet liste",
                    "Unordered List": "Uordnet liste",

                    // Indent
                    "Decrease Indent": "Reduser innrykk",
                    "Increase Indent": "\u00d8k innrykk",

                    // Links
                    "Insert Link": "Sett inn lenke",
                    "Open in new tab": "\u00c5pne i ny fane",
                    "Open Link": "\u00c5pne lenke",
                    "Edit Link": "Rediger lenke",
                    "Unlink": "Fjern lenke",
                    "Choose Link": "Velge lenke",

                    // Images
                    "Insert Image": "Sett inn bilde",
                    "Upload Image": "Last opp bilde",
                    "By URL": "Ved URL",
                    "Browse": "Bla",
                    "Drop image": "Slippe bilde",
                    "or click": "eller klikk",
                    "Manage Images": "Bildebehandling",
                    "Loading": "Lasting",
                    "Deleting": "Slette",
                    "Tags": "Tags",
                    "Are you sure? Image will be deleted.": "Er du sikker? Bildet vil bli slettet.",
                    "Replace": "Erstatte",
                    "Uploading": "Opplasting",
                    "Loading image": "Lasting bilde",
                    "Display": "Utstilling",
                    "Inline": "P\u00e5 linje",
                    "Break Text": "Brudd tekst",
                    "Alternative Text": "Alternativ tekst",
                    "Change Size": "Endre st\u00f8rrelse",
                    "Width": "Bredde",
                    "Height": "H\u00f8yde",
                    "Something went wrong. Please try again.": "Noe gikk galt. V\u00e6r s\u00e5 snill, pr\u00f8v p\u00e5 nytt.",
                    "Image Caption": "Bilde bildetekst",
                    "Advanced Edit": "Avansert redigering",

                    // Video
                    "Insert Video": "Sett inn video",
                    "Embedded Code": "Embedded kode",
                    "Paste in a video URL": "Lim inn i en video-url",
                    "Drop video": "Slipp video",
                    "Your browser does not support HTML5 video.": "Nettleseren din støtter ikke html5 video.",
                    "Upload Video": "Last opp video",

                    // Tables
                    "Insert Table": "Sett inn tabell",
                    "Table Header": "Tabell header",
                    "Remove Table": "Fjern tabell",
                    "Table Style": "Tabell stil",
                    "Horizontal Align": "Horisontal justering",
                    "Row": "Rad",
                    "Insert row above": "Sett inn rad f\u00f8r",
                    "Insert row below": "Sett in rad etter",
                    "Delete row": "Slett rad",
                    "Column": "Kolonne",
                    "Insert column before": "Sett inn kolonne f\u00f8r",
                    "Insert column after": "Sett inn kolonne etter",
                    "Delete column": "Slett kolonne",
                    "Cell": "Celle",
                    "Merge cells": "Sl\u00e5 sammen celler",
                    "Horizontal split": "Horisontalt delt",
                    "Vertical split": "Vertikal split",
                    "Cell Background": "Celle bakgrunn",
                    "Vertical Align": "Vertikal justering",
                    "Top": "Topp",
                    "Middle": "Midten",
                    "Bottom": "Bunn",
                    "Align Top": "Justere toppen",
                    "Align Middle": "Justere midten",
                    "Align Bottom": "Justere bunnen",
                    "Cell Style": "Celle stil",

                    // Files
                    "Upload File": "Opplastingsfil",
                    "Drop file": "Slippe fil",

                    // Emoticons
                    "Emoticons": "Emoticons",
                    "Grinning face": "Flirer ansikt",
                    "Grinning face with smiling eyes": "Flirer ansikt med smilende \u00f8yne",
                    "Face with tears of joy": "Ansikt med t\u00e5rer av glede",
                    "Smiling face with open mouth": "Smilende ansikt med \u00e5pen munn",
                    "Smiling face with open mouth and smiling eyes": "Smilende ansikt med \u00e5pen munn og smilende \u00f8yne",
                    "Smiling face with open mouth and cold sweat": "Smilende ansikt med \u00e5pen munn og kald svette",
                    "Smiling face with open mouth and tightly-closed eyes": "Smilende ansikt med \u00e5pen munn og tett lukkede \u00f8yne",
                    "Smiling face with halo": "Smilende ansikt med glorie",
                    "Smiling face with horns": "Smilende ansikt med horn",
                    "Winking face": "Blunk ansikt",
                    "Smiling face with smiling eyes": "Smilende ansikt med smilende \u00f8yne",
                    "Face savoring delicious food": "M\u00f8te nyter deilig mat",
                    "Relieved face": "Lettet ansikt",
                    "Smiling face with heart-shaped eyes": "Smilende ansikt med hjerteformede \u00f8yne",
                    "Smiling face with sunglasses": "Smilende ansikt med solbriller",
                    "Smirking face": "Tilfreds ansikt",
                    "Neutral face": "N\u00f8ytral ansikt",
                    "Expressionless face": "Uttrykksl\u00f8st ansikt",
                    "Unamused face": "Ikke moret ansikt",
                    "Face with cold sweat": "Ansikt med kald svette",
                    "Pensive face": "Tankefull ansikt",
                    "Confused face": "Forvirret ansikt",
                    "Confounded face": "Skamme ansikt",
                    "Kissing face": "Kyssing ansikt",
                    "Face throwing a kiss": "Ansikt kaste et kyss",
                    "Kissing face with smiling eyes": "Kyssing ansikt med smilende \u00f8yne",
                    "Kissing face with closed eyes": "Kyssing ansiktet med lukkede \u00f8yne",
                    "Face with stuck out tongue": "Ansikt med stakk ut tungen",
                    "Face with stuck out tongue and winking eye": "Ansikt med stakk ut tungen og blunke \u00f8ye",
                    "Face with stuck out tongue and tightly-closed eyes": "Ansikt med fast ut tungen og tett lukket \u00f8yne",
                    "Disappointed face": "Skuffet ansikt",
                    "Worried face": "Bekymret ansikt",
                    "Angry face": "Sint ansikt",
                    "Pouting face": "Trutmunn ansikt",
                    "Crying face": "Gr\u00e5ter ansikt",
                    "Persevering face": "Utholdende ansikt",
                    "Face with look of triumph": "Ansikt med utseendet til triumf",
                    "Disappointed but relieved face": "Skuffet men lettet ansikt",
                    "Frowning face with open mouth": "Rynke ansikt med \u00e5pen munn",
                    "Anguished face": "Forpint ansikt",
                    "Fearful face": "Engstelig ansikt",
                    "Weary face": "Slitne ansiktet",
                    "Sleepy face": "S\u00f8vnig ansikt",
                    "Tired face": "Tr\u00f8tt ansikt",
                    "Grimacing face": "Griner ansikt",
                    "Loudly crying face": "H\u00f8ylytt gr\u00e5tende ansikt",
                    "Face with open mouth": "Ansikt med \u00e5pen munn",
                    "Hushed face": "Lavm\u00e6lt ansikt",
                    "Face with open mouth and cold sweat": "Ansikt med \u00e5pen munn og kald svette",
                    "Face screaming in fear": "Ansikt skriker i frykt",
                    "Astonished face": "Forbauset ansikt",
                    "Flushed face": "Flushed ansikt",
                    "Sleeping face": "Sovende ansikt",
                    "Dizzy face": "Svimmel ansikt",
                    "Face without mouth": "Ansikt uten munn",
                    "Face with medical mask": "Ansikt med medisinsk maske",

                    // Line breaker
                    "Break": "Brudd",

                    // Math
                    "Subscript": "Senket skrift",
                    "Superscript": "Hevet skrift",

                    // Full screen
                    "Fullscreen": "Full skjerm",

                    // Horizontal line
                    "Insert Horizontal Line": "Sett inn horisontal linje",

                    // Clear formatting
                    "Clear Formatting": "Fjerne formatering",

                    // Undo, redo
                    "Undo": "Angre",
                    "Redo": "Utf\u00f8r likevel",

                    // Select all
                    "Select All": "Marker alt",

                    // Code view
                    "Code View": "Kodevisning",

                    // Quote
                    "Quote": "Sitat",
                    "Increase": "\u00d8ke",
                    "Decrease": "Nedgang",

                    // Quick Insert
                    "Quick Insert": "Hurtiginnsats",

                    // Spcial Characters
                    "Special Characters": "Spesielle karakterer",
                    "Latin": "Latin",
                    "Greek": "Gresk",
                    "Cyrillic": "Kyrilliske",
                    "Punctuation": "Tegnsetting",
                    "Currency": "Valuta",
                    "Arrows": "Piler",
                    "Math": "Matte",
                    "Misc": "Misc",

                    // Print.
                    "Print": "Skrive ut",

                    // Spell Checker.
                    "Spell Checker": "Stavekontroll",

                    // Help
                    "Help": "Hjelp",
                    "Shortcuts": "Snarveier",
                    "Inline Editor": "Inline editor",
                    "Show the editor": "Vis redaktøren",
                    "Common actions": "Felles handlinger",
                    "Copy": "Kopiere",
                    "Cut": "Kutte opp",
                    "Paste": "Lim inn",
                    "Basic Formatting": "Grunnleggende formatering",
                    "Increase quote level": "Øke tilbudsnivået",
                    "Decrease quote level": "Redusere tilbudsnivå",
                    "Image / Video": "Bilde / video",
                    "Resize larger": "Endre størrelsen større",
                    "Resize smaller": "Endre størrelsen mindre",
                    "Table": "Bord",
                    "Select table cell": "Velg tabellcelle",
                    "Extend selection one cell": "Utvide valg en celle",
                    "Extend selection one row": "Utvide valg en rad",
                    "Navigation": "Navigasjon",
                    "Focus popup / toolbar": "Fokus popup / verktøylinje",
                    "Return focus to previous position": "Returnere fokus til tidligere posisjon",

                    // Embed.ly
                    "Embed URL": "Legge inn nettadressen",
                    "Paste in a URL to embed": "Lim inn i en URL for å legge inn",

                    // Word Paste.
                    "The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?": "Det innlimte innholdet kommer fra et formatert dokument. Ønsker du å beholde formateringen eller fjerne den?",
                    "Keep": "Beholde",
                    "Clean": "Ren",
                    "Paste Detected": "Lim inn funnet"
            }
        },
        "id": "no",
        "pluralCat": function (n, opt_precision) { if (n == 1) { return PLURAL_CATEGORY.ONE; } return PLURAL_CATEGORY.OTHER; }
    });
}])
;
/*!
 * Image Compressor v1.1.4
 * https://xkeshi.github.io/image-compressor
 *
 * Copyright 2017-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2018-06-20T07:28:41.051Z
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ImageCompressor = factory());
}(this, (function () { 'use strict';

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var canvasToBlob = createCommonjsModule(function (module) {
	(function (window) {

	  var CanvasPrototype =
	    window.HTMLCanvasElement && window.HTMLCanvasElement.prototype;
	  var hasBlobConstructor =
	    window.Blob &&
	    (function () {
	      try {
	        return Boolean(new Blob())
	      } catch (e) {
	        return false
	      }
	    })();
	  var hasArrayBufferViewSupport =
	    hasBlobConstructor &&
	    window.Uint8Array &&
	    (function () {
	      try {
	        return new Blob([new Uint8Array(100)]).size === 100
	      } catch (e) {
	        return false
	      }
	    })();
	  var BlobBuilder =
	    window.BlobBuilder ||
	    window.WebKitBlobBuilder ||
	    window.MozBlobBuilder ||
	    window.MSBlobBuilder;
	  var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/;
	  var dataURLtoBlob =
	    (hasBlobConstructor || BlobBuilder) &&
	    window.atob &&
	    window.ArrayBuffer &&
	    window.Uint8Array &&
	    function (dataURI) {
	      var matches,
	        mediaType,
	        isBase64,
	        dataString,
	        byteString,
	        arrayBuffer,
	        intArray,
	        i,
	        bb;
	      // Parse the dataURI components as per RFC 2397
	      matches = dataURI.match(dataURIPattern);
	      if (!matches) {
	        throw new Error('invalid data URI')
	      }
	      // Default to text/plain;charset=US-ASCII
	      mediaType = matches[2]
	        ? matches[1]
	        : 'text/plain' + (matches[3] || ';charset=US-ASCII');
	      isBase64 = !!matches[4];
	      dataString = dataURI.slice(matches[0].length);
	      if (isBase64) {
	        // Convert base64 to raw binary data held in a string:
	        byteString = atob(dataString);
	      } else {
	        // Convert base64/URLEncoded data component to raw binary:
	        byteString = decodeURIComponent(dataString);
	      }
	      // Write the bytes of the string to an ArrayBuffer:
	      arrayBuffer = new ArrayBuffer(byteString.length);
	      intArray = new Uint8Array(arrayBuffer);
	      for (i = 0; i < byteString.length; i += 1) {
	        intArray[i] = byteString.charCodeAt(i);
	      }
	      // Write the ArrayBuffer (or ArrayBufferView) to a blob:
	      if (hasBlobConstructor) {
	        return new Blob([hasArrayBufferViewSupport ? intArray : arrayBuffer], {
	          type: mediaType
	        })
	      }
	      bb = new BlobBuilder();
	      bb.append(arrayBuffer);
	      return bb.getBlob(mediaType)
	    };
	  if (window.HTMLCanvasElement && !CanvasPrototype.toBlob) {
	    if (CanvasPrototype.mozGetAsFile) {
	      CanvasPrototype.toBlob = function (callback, type, quality) {
	        var self = this;
	        setTimeout(function () {
	          if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) {
	            callback(dataURLtoBlob(self.toDataURL(type, quality)));
	          } else {
	            callback(self.mozGetAsFile('blob', type));
	          }
	        });
	      };
	    } else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
	      CanvasPrototype.toBlob = function (callback, type, quality) {
	        var self = this;
	        setTimeout(function () {
	          callback(dataURLtoBlob(self.toDataURL(type, quality)));
	        });
	      };
	    }
	  }
	  if (typeof undefined === 'function' && undefined.amd) {
	    undefined(function () {
	      return dataURLtoBlob
	    });
	  } else if (module.exports) {
	    module.exports = dataURLtoBlob;
	  } else {
	    window.dataURLtoBlob = dataURLtoBlob;
	  }
	})(window);
	});

	/* globals Blob */
	var toString = Object.prototype.toString;

	var isBlob = function (x) {
		return x instanceof Blob || toString.call(x) === '[object Blob]';
	};

	var DEFAULTS = {
	  /**
	   * Indicates if read the image's Exif Orientation information,
	   * and then rotate or flip the image automatically.
	   * @type {boolean}
	   */
	  checkOrientation: true,

	  /**
	   * The max width of the output image.
	   * @type {number}
	   */
	  maxWidth: Infinity,

	  /**
	   * The max height of the output image.
	   * @type {number}
	   */
	  maxHeight: Infinity,

	  /**
	   * The min width of the output image.
	   * @type {number}
	   */
	  minWidth: 0,

	  /**
	   * The min height of the output image.
	   * @type {number}
	   */
	  minHeight: 0,

	  /**
	   * The width of the output image.
	   * If not specified, the natural width of the source image will be used.
	   * @type {number}
	   */
	  width: undefined,

	  /**
	   * The height of the output image.
	   * If not specified, the natural height of the source image will be used.
	   * @type {number}
	   */
	  height: undefined,

	  /**
	   * The quality of the output image.
	   * It must be a number between `0` and `1`,
	   * and only available for `image/jpeg` and `image/webp` images.
	   * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
	   * @type {number}
	   */
	  quality: 0.8,

	  /**
	   * The mime type of the output image.
	   * By default, the original mime type of the source image file will be used.
	   * @type {string}
	   */
	  mimeType: 'auto',

	  /**
	   * PNG files over this value (5M by default) will be converted to JPEGs.
	   * To disable this, just set the value to `Infinity`.
	   * Check out {@link https://github.com/xkeshi/image-compressor/issues/2 #2}.
	   * @type {number}
	   */
	  convertSize: 5000000,

	  /**
	   * The hook function to execute before draw the image into the canvas for compression.
	   * @type {Function}
	   * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
	   * @param {HTMLCanvasElement} canvas - The canvas for compression.
	   * @example
	   * function (context, canvas) { context.fillStyle = '#fff' }
	   */
	  beforeDraw: null,

	  /**
	   * The hook function to execute after drew the image into the canvas for compression.
	   * @type {Function}
	   * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
	   * @param {HTMLCanvasElement} canvas - The canvas for compression.
	   * @example
	   * function (context, canvas) { context.filter = grayscale(100%) }
	   */
	  drew: null,

	  /**
	   * The hook function to execute when success to compress the image.
	   * @type {Function}
	   * @param {File} file - The compressed image File object.
	   * @example
	   * function (file) { console.log(file) }
	   */
	  success: null,

	  /**
	   * The hook function to execute when fail to compress the image.
	   * @type {Function}
	   * @param {Error} err - An Error object.
	   * @example
	   * function (err) { console.log(err.message) }
	   */
	  error: null
	};

	var REGEXP_IMAGE_TYPE = /^image\/.+$/;

	/**
	 * Check if the given value is a mime type of image.
	 * @param {*} value - The value to check.
	 * @returns {boolean} Returns `true` if the given is a mime type of image, else `false`.
	 */
	function isImageType(value) {
	  return REGEXP_IMAGE_TYPE.test(value);
	}

	/**
	 * Convert image type to extension.
	 * @param {string} value - The image type to convert.
	 * @param {boolean} [includeDot=true] - Include a leading dot or not.
	 * @returns {boolean} Returns the image extension.
	 */
	function imageTypeToExtension(value) {
	  var includeDot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	  var extension = isImageType(value) ? value.substr(6) : '';

	  if (extension === 'jpeg') {
	    extension = 'jpg';
	  }

	  if (extension && includeDot) {
	    extension = '.' + extension;
	  }

	  return extension;
	}

	var fromCharCode = String.fromCharCode;

	/**
	 * Get string from char code in data view.
	 * @param {DataView} dataView - The data view for read.
	 * @param {number} start - The start index.
	 * @param {number} length - The read length.
	 * @returns {string} The read result.
	 */

	function getStringFromCharCode(dataView, start, length) {
	  var str = '';
	  var i = void 0;

	  length += start;

	  for (i = start; i < length; i += 1) {
	    str += fromCharCode(dataView.getUint8(i));
	  }

	  return str;
	}

	var _window = window,
	    btoa = _window.btoa;

	/**
	 * Transform array buffer to Data URL.
	 * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
	 * @param {string} mimeType - The mime type of the Data URL.
	 * @returns {string} The result Data URL.
	 */

	function arrayBufferToDataURL(arrayBuffer, mimeType) {
	  var uint8 = new Uint8Array(arrayBuffer);
	  var data = '';

	  // TypedArray.prototype.forEach is not supported in some browsers as IE.
	  if (typeof uint8.forEach === 'function') {
	    uint8.forEach(function (value) {
	      data += fromCharCode(value);
	    });
	  } else {
	    var length = uint8.length;


	    for (var i = 0; i < length; i += 1) {
	      data += fromCharCode(uint8[i]);
	    }
	  }

	  return 'data:' + mimeType + ';base64,' + btoa(data);
	}

	/**
	 * Get orientation value from given array buffer.
	 * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
	 * @returns {number} The read orientation value.
	 */
	function getOrientation(arrayBuffer) {
	  var dataView = new DataView(arrayBuffer);
	  var orientation = void 0;
	  var littleEndian = void 0;
	  var app1Start = void 0;
	  var ifdStart = void 0;

	  // Only handle JPEG image (start by 0xFFD8)
	  if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
	    var length = dataView.byteLength;
	    var offset = 2;

	    while (offset < length) {
	      if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
	        app1Start = offset;
	        break;
	      }

	      offset += 1;
	    }
	  }

	  if (app1Start) {
	    var exifIDCode = app1Start + 4;
	    var tiffOffset = app1Start + 10;

	    if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
	      var endianness = dataView.getUint16(tiffOffset);

	      littleEndian = endianness === 0x4949;

	      if (littleEndian || endianness === 0x4D4D /* bigEndian */) {
	          if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
	            var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

	            if (firstIFDOffset >= 0x00000008) {
	              ifdStart = tiffOffset + firstIFDOffset;
	            }
	          }
	        }
	    }
	  }

	  if (ifdStart) {
	    var _length = dataView.getUint16(ifdStart, littleEndian);
	    var _offset = void 0;
	    var i = void 0;

	    for (i = 0; i < _length; i += 1) {
	      _offset = ifdStart + i * 12 + 2;

	      if (dataView.getUint16(_offset, littleEndian) === 0x0112 /* Orientation */) {
	          // 8 is the offset of the current tag's value
	          _offset += 8;

	          // Get the original orientation value
	          orientation = dataView.getUint16(_offset, littleEndian);

	          // Override the orientation with its default value
	          dataView.setUint16(_offset, 1, littleEndian);
	          break;
	        }
	    }
	  }

	  return orientation;
	}

	/**
	 * Parse Exif Orientation value.
	 * @param {number} orientation - The orientation to parse.
	 * @returns {Object} The parsed result.
	 */
	function parseOrientation(orientation) {
	  var rotate = 0;
	  var scaleX = 1;
	  var scaleY = 1;

	  switch (orientation) {
	    // Flip horizontal
	    case 2:
	      scaleX = -1;
	      break;

	    // Rotate left 180°
	    case 3:
	      rotate = -180;
	      break;

	    // Flip vertical
	    case 4:
	      scaleY = -1;
	      break;

	    // Flip vertical and rotate right 90°
	    case 5:
	      rotate = 90;
	      scaleY = -1;
	      break;

	    // Rotate right 90°
	    case 6:
	      rotate = 90;
	      break;

	    // Flip horizontal and rotate right 90°
	    case 7:
	      rotate = 90;
	      scaleX = -1;
	      break;

	    // Rotate left 90°
	    case 8:
	      rotate = -90;
	      break;

	    default:
	  }

	  return {
	    rotate: rotate,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}

	var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/i;

	/**
	 * Normalize decimal number.
	 * Check out {@link http://0.30000000000000004.com/}
	 * @param {number} value - The value to normalize.
	 * @param {number} [times=100000000000] - The times for normalizing.
	 * @returns {number} Returns the normalized number.
	 */
	function normalizeDecimalNumber(value) {
	  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;

	  return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
	}

	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	var _window$1 = window,
	    ArrayBuffer$1 = _window$1.ArrayBuffer,
	    FileReader = _window$1.FileReader;

	var URL = window.URL || window.webkitURL;
	var REGEXP_EXTENSION = /\.\w+$/;

	/**
	 * Creates a new image compressor.
	 * @class
	 */

	var ImageCompressor = function () {
	  /**
	   * The constructor of ImageCompressor.
	   * @param {File|Blob} file - The target image file for compressing.
	   * @param {Object} [options] - The options for compressing.
	   */
	  function ImageCompressor(file, options) {
	    classCallCheck(this, ImageCompressor);

	    this.result = null;

	    if (file) {
	      this.compress(file, options);
	    }
	  }

	  /**
	   * The main compress method.
	   * @param {File|Blob} file - The target image file for compressing.
	   * @param {Object} [options] - The options for compressing.
	   * @returns {Promise} - A Promise instance.
	   */


	  createClass(ImageCompressor, [{
	    key: 'compress',
	    value: function compress(file, options) {
	      var _this = this;

	      var image = new Image();

	      options = _extends({}, DEFAULTS, options);

	      if (!ArrayBuffer$1) {
	        options.checkOrientation = false;
	      }

	      return new Promise(function (resolve, reject) {
	        if (!isBlob(file)) {
	          reject(new Error('The first argument must be a File or Blob object.'));
	          return;
	        }

	        var mimeType = file.type;

	        if (!isImageType(mimeType)) {
	          reject(new Error('The first argument must be an image File or Blob object.'));
	          return;
	        }

	        if (!URL && !FileReader) {
	          reject(new Error('The current browser does not support image compression.'));
	          return;
	        }

	        if (URL && !options.checkOrientation) {
	          resolve({
	            url: URL.createObjectURL(file)
	          });
	        } else if (FileReader) {
	          var reader = new FileReader();
	          var checkOrientation = options.checkOrientation && mimeType === 'image/jpeg';

	          reader.onload = function (_ref) {
	            var target = _ref.target;
	            var result = target.result;


	            resolve(checkOrientation ? _extends({
	              url: arrayBufferToDataURL(result, mimeType)
	            }, parseOrientation(getOrientation(result))) : {
	              url: result
	            });
	          };
	          reader.onabort = function () {
	            reject(new Error('Aborted to load the image with FileReader.'));
	          };
	          reader.onerror = function () {
	            reject(new Error('Failed to load the image with FileReader.'));
	          };

	          if (checkOrientation) {
	            reader.readAsArrayBuffer(file);
	          } else {
	            reader.readAsDataURL(file);
	          }
	        }
	      }).then(function (data) {
	        return new Promise(function (resolve, reject) {
	          image.onload = function () {
	            return resolve(_extends({}, data, {
	              naturalWidth: image.naturalWidth,
	              naturalHeight: image.naturalHeight
	            }));
	          };
	          image.onabort = function () {
	            reject(new Error('Aborted to load the image.'));
	          };
	          image.onerror = function () {
	            reject(new Error('Failed to load the image.'));
	          };
	          image.alt = file.name;
	          image.src = data.url;
	        });
	      }).then(function (_ref2) {
	        var naturalWidth = _ref2.naturalWidth,
	            naturalHeight = _ref2.naturalHeight,
	            _ref2$rotate = _ref2.rotate,
	            rotate = _ref2$rotate === undefined ? 0 : _ref2$rotate,
	            _ref2$scaleX = _ref2.scaleX,
	            scaleX = _ref2$scaleX === undefined ? 1 : _ref2$scaleX,
	            _ref2$scaleY = _ref2.scaleY,
	            scaleY = _ref2$scaleY === undefined ? 1 : _ref2$scaleY;
	        return new Promise(function (resolve) {
	          var canvas = document.createElement('canvas');
	          var context = canvas.getContext('2d');
	          var aspectRatio = naturalWidth / naturalHeight;
	          var maxWidth = Math.max(options.maxWidth, 0) || Infinity;
	          var maxHeight = Math.max(options.maxHeight, 0) || Infinity;
	          var minWidth = Math.max(options.minWidth, 0) || 0;
	          var minHeight = Math.max(options.minHeight, 0) || 0;
	          var width = naturalWidth;
	          var height = naturalHeight;

	          if (maxWidth < Infinity && maxHeight < Infinity) {
	            if (maxHeight * aspectRatio > maxWidth) {
	              maxHeight = maxWidth / aspectRatio;
	            } else {
	              maxWidth = maxHeight * aspectRatio;
	            }
	          } else if (maxWidth < Infinity) {
	            maxHeight = maxWidth / aspectRatio;
	          } else if (maxHeight < Infinity) {
	            maxWidth = maxHeight * aspectRatio;
	          }

	          if (minWidth > 0 && minHeight > 0) {
	            if (minHeight * aspectRatio > minWidth) {
	              minHeight = minWidth / aspectRatio;
	            } else {
	              minWidth = minHeight * aspectRatio;
	            }
	          } else if (minWidth > 0) {
	            minHeight = minWidth / aspectRatio;
	          } else if (minHeight > 0) {
	            minWidth = minHeight * aspectRatio;
	          }

	          if (options.width > 0) {
	            var _options = options;
	            width = _options.width;

	            height = width / aspectRatio;
	          } else if (options.height > 0) {
	            var _options2 = options;
	            height = _options2.height;

	            width = height * aspectRatio;
	          }

	          width = Math.min(Math.max(width, minWidth), maxWidth);
	          height = Math.min(Math.max(height, minHeight), maxHeight);

	          var destX = -width / 2;
	          var destY = -height / 2;
	          var destWidth = width;
	          var destHeight = height;

	          if (Math.abs(rotate) % 180 === 90) {
	            var _width$height = {
	              width: height,
	              height: width
	            };
	            width = _width$height.width;
	            height = _width$height.height;
	          }

	          canvas.width = normalizeDecimalNumber(width);
	          canvas.height = normalizeDecimalNumber(height);

	          if (!isImageType(options.mimeType)) {
	            options.mimeType = file.type;
	          }

	          var defaultFillStyle = 'transparent';

	          // Converts PNG files over the `convertSize` to JPEGs.
	          if (file.size > options.convertSize && options.mimeType === 'image/png') {
	            defaultFillStyle = '#fff';
	            options.mimeType = 'image/jpeg';
	          }

	          // Override the default fill color (#000, black)
	          context.fillStyle = defaultFillStyle;
	          context.fillRect(0, 0, width, height);
	          context.save();
	          context.translate(width / 2, height / 2);
	          context.rotate(rotate * Math.PI / 180);
	          context.scale(scaleX, scaleY);

	          if (options.beforeDraw) {
	            options.beforeDraw.call(_this, context, canvas);
	          }

	          context.drawImage(image, Math.floor(normalizeDecimalNumber(destX)), Math.floor(normalizeDecimalNumber(destY)), Math.floor(normalizeDecimalNumber(destWidth)), Math.floor(normalizeDecimalNumber(destHeight)));

	          if (options.drew) {
	            options.drew.call(_this, context, canvas);
	          }

	          context.restore();

	          var done = function done(result) {
	            resolve({
	              naturalWidth: naturalWidth,
	              naturalHeight: naturalHeight,
	              result: result
	            });
	          };

	          if (canvas.toBlob) {
	            canvas.toBlob(done, options.mimeType, options.quality);
	          } else {
	            done(canvasToBlob(canvas.toDataURL(options.mimeType, options.quality)));
	          }
	        });
	      }).then(function (_ref3) {
	        var naturalWidth = _ref3.naturalWidth,
	            naturalHeight = _ref3.naturalHeight,
	            result = _ref3.result;

	        if (URL && !options.checkOrientation) {
	          URL.revokeObjectURL(image.src);
	        }

	        if (result) {
	          // Returns original file if the result is greater than it and without size related options
	          if (result.size > file.size && options.mimeType === file.type && !(options.width > naturalWidth || options.height > naturalHeight || options.minWidth > naturalWidth || options.minHeight > naturalHeight)) {
	            result = file;
	          } else {
	            var date = new Date();

	            result.lastModified = date.getTime();
	            result.lastModifiedDate = date;
	            result.name = file.name;

	            // Convert the extension to match its type
	            if (result.name && result.type !== file.type) {
	              result.name = result.name.replace(REGEXP_EXTENSION, imageTypeToExtension(result.type));
	            }
	          }
	        } else {
	          // Returns original file if the result is null in some cases.
	          result = file;
	        }

	        _this.result = result;

	        if (options.success) {
	          options.success.call(_this, result);
	        }

	        return Promise.resolve(result);
	      }).catch(function (err) {
	        if (!(options && options.error)) {
	          throw err;
	        }

	        options.error.call(_this, err);
	      });
	    }
	  }]);
	  return ImageCompressor;
	}();

	return ImageCompressor;

})));

/**
 * angular-strap
 * @version v2.3.6 - 2015-11-14
 * @link http://mgcrea.github.io/angular-strap
 * @author Olivier Louvignes <olivier@mg-crea.com> (https://github.com/mgcrea)
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function(window, document, undefined) {
  'use strict';
  angular.module('mgcrea.ngStrap.tooltip', [ 'mgcrea.ngStrap.core', 'mgcrea.ngStrap.helpers.dimensions' ]).provider('$bsTooltip', function() {
    var defaults = this.defaults = {
      animation: 'am-fade',
      customClass: '',
      prefixClass: 'tooltip',
      prefixEvent: 'tooltip',
      container: false,
      target: false,
      placement: 'top',
      templateUrl: 'tooltip/tooltip.tpl.html',
      template: '',
      contentTemplate: false,
      trigger: 'hover focus',
      keyboard: false,
      html: false,
      show: false,
      title: '',
      type: '',
      delay: 0,
      autoClose: false,
      bsEnabled: true,
      viewport: {
        selector: 'body',
        padding: 0
      }
    };
    this.$get = [ '$window', '$rootScope', '$bsCompiler', '$q', '$templateCache', '$http', '$animate', '$sce', 'dimensions', '$$rAF', '$timeout', function($window, $rootScope, $bsCompiler, $q, $templateCache, $http, $animate, $sce, dimensions, $$rAF, $timeout) {
      var trim = String.prototype.trim;
      var isTouch = 'createTouch' in $window.document;
      var htmlReplaceRegExp = /ng-bind="/gi;
      var $body = angular.element($window.document);
      function TooltipFactory(element, config) {
        var $bsTooltip = {};
        var options = $bsTooltip.$options = angular.extend({}, defaults, config);
        var promise = $bsTooltip.$promise = $bsCompiler.compile(options);
        var scope = $bsTooltip.$scope = options.scope && options.scope.$new() || $rootScope.$new();
        var nodeName = element[0].nodeName.toLowerCase();
        if (options.delay && angular.isString(options.delay)) {
          var split = options.delay.split(',').map(parseFloat);
          options.delay = split.length > 1 ? {
            show: split[0],
            hide: split[1]
          } : split[0];
        }
        $bsTooltip.$id = options.id || element.attr('id') || '';
        if (options.title) {
          scope.title = $sce.trustAsHtml(options.title);
        }
        scope.$setEnabled = function(isEnabled) {
          scope.$$postDigest(function() {
            $bsTooltip.setEnabled(isEnabled);
          });
        };
        scope.$hide = function() {
          scope.$$postDigest(function() {
            $bsTooltip.hide();
          });
        };
        scope.$show = function() {
          scope.$$postDigest(function() {
            $bsTooltip.show();
          });
        };
        scope.$toggle = function() {
          scope.$$postDigest(function() {
            $bsTooltip.toggle();
          });
        };
        $bsTooltip.$isShown = scope.$isShown = false;
        var timeout, hoverState;
        var compileData, tipElement, tipContainer, tipScope;
        promise.then(function(data) {
          compileData = data;
          $bsTooltip.init();
        });
        $bsTooltip.init = function() {
          if (options.delay && angular.isNumber(options.delay)) {
            options.delay = {
              show: options.delay,
              hide: options.delay
            };
          }
          if (options.container === 'self') {
            tipContainer = element;
          } else if (angular.isElement(options.container)) {
            tipContainer = options.container;
          } else if (options.container) {
            tipContainer = findElement(options.container);
          }
          bindTriggerEvents();
          if (options.target) {
            options.target = angular.isElement(options.target) ? options.target : findElement(options.target);
          }
          if (options.show) {
            scope.$$postDigest(function() {
              options.trigger === 'focus' ? element[0].focus() : $bsTooltip.show();
            });
          }
        };
        $bsTooltip.destroy = function() {
          unbindTriggerEvents();
          destroyTipElement();
          scope.$destroy();
        };
        $bsTooltip.enter = function() {
          clearTimeout(timeout);
          hoverState = 'in';
          if (!options.delay || !options.delay.show) {
            return $bsTooltip.show();
          }
          timeout = setTimeout(function() {
            if (hoverState === 'in') $bsTooltip.show();
          }, options.delay.show);
        };
        $bsTooltip.show = function() {
          if (!options.bsEnabled || $bsTooltip.$isShown) return;
          scope.$emit(options.prefixEvent + '.show.before', $bsTooltip);
          var parent, after;
          if (options.container) {
            parent = tipContainer;
            if (tipContainer[0].lastChild) {
              after = angular.element(tipContainer[0].lastChild);
            } else {
              after = null;
            }
          } else {
            parent = null;
            after = element;
          }
          if (tipElement) destroyTipElement();
          tipScope = $bsTooltip.$scope.$new();
          tipElement = $bsTooltip.$element = compileData.link(tipScope, function(clonedElement, scope) {});
          tipElement.css({
            top: '-9999px',
            left: '-9999px',
            right: 'auto',
            display: 'block',
            visibility: 'hidden'
          });
          if (options.animation) tipElement.addClass(options.animation);
          if (options.type) tipElement.addClass(options.prefixClass + '-' + options.type);
          if (options.customClass) tipElement.addClass(options.customClass);
          after ? after.after(tipElement) : parent.prepend(tipElement);
          $bsTooltip.$isShown = scope.$isShown = true;
          safeDigest(scope);
          $bsTooltip.$applyPlacement();
          if (angular.version.minor <= 2) {
            $animate.enter(tipElement, parent, after, enterAnimateCallback);
          } else {
            $animate.enter(tipElement, parent, after).then(enterAnimateCallback);
          }
          safeDigest(scope);
          $$rAF(function() {
            if (tipElement) tipElement.css({
              visibility: 'visible'
            });
            if (options.keyboard) {
              if (options.trigger !== 'focus') {
                $bsTooltip.focus();
              }
              bindKeyboardEvents();
            }
          });
          if (options.autoClose) {
            bindAutoCloseEvents();
          }
        };
        function enterAnimateCallback() {
          scope.$emit(options.prefixEvent + '.show', $bsTooltip);
        }
        $bsTooltip.leave = function() {
          clearTimeout(timeout);
          hoverState = 'out';
          if (!options.delay || !options.delay.hide) {
            return $bsTooltip.hide();
          }
          timeout = setTimeout(function() {
            if (hoverState === 'out') {
              $bsTooltip.hide();
            }
          }, options.delay.hide);
        };
        var _blur;
        var _tipToHide;
        $bsTooltip.hide = function(blur) {
          if (!$bsTooltip.$isShown) return;
          scope.$emit(options.prefixEvent + '.hide.before', $bsTooltip);
          _blur = blur;
          _tipToHide = tipElement;
          if (angular.version.minor <= 2) {
            $animate.leave(tipElement, leaveAnimateCallback);
          } else {
            $animate.leave(tipElement).then(leaveAnimateCallback);
          }
          $bsTooltip.$isShown = scope.$isShown = false;
          safeDigest(scope);
          if (options.keyboard && tipElement !== null) {
            unbindKeyboardEvents();
          }
          if (options.autoClose && tipElement !== null) {
            unbindAutoCloseEvents();
          }
        };
        function leaveAnimateCallback() {
          scope.$emit(options.prefixEvent + '.hide', $bsTooltip);
          if (tipElement === _tipToHide) {
            if (_blur && options.trigger === 'focus') {
              return element[0].blur();
            }
            destroyTipElement();
          }
        }
        $bsTooltip.toggle = function() {
          $bsTooltip.$isShown ? $bsTooltip.leave() : $bsTooltip.enter();
        };
        $bsTooltip.focus = function() {
          tipElement[0].focus();
        };
        $bsTooltip.setEnabled = function(isEnabled) {
          options.bsEnabled = isEnabled;
        };
        $bsTooltip.setViewport = function(viewport) {
          options.viewport = viewport;
        };
        $bsTooltip.$applyPlacement = function() {
          if (!tipElement) return;
          var placement = options.placement, autoToken = /\s?auto?\s?/i, autoPlace = autoToken.test(placement);
          if (autoPlace) {
            placement = placement.replace(autoToken, '') || defaults.placement;
          }
          tipElement.addClass(options.placement);
          var elementPosition = getPosition(), tipWidth = tipElement.prop('offsetWidth'), tipHeight = tipElement.prop('offsetHeight');
          $bsTooltip.$viewport = options.viewport && findElement(options.viewport.selector || options.viewport);
          if (autoPlace) {
            var originalPlacement = placement;
            var viewportPosition = getPosition($bsTooltip.$viewport);
            if (/top/.test(originalPlacement) && elementPosition.bottom + tipHeight > viewportPosition.bottom) {
              placement = originalPlacement.replace('top', 'bottom');
            } else if (/bottom/.test(originalPlacement) && elementPosition.top - tipHeight < viewportPosition.top) {
              placement = originalPlacement.replace('bottom', 'top');
            }
            if (/left/.test(originalPlacement) && elementPosition.left - tipWidth < viewportPosition.left) {
              placement = placement.replace('left', 'right');
            } else if (/right/.test(originalPlacement) && elementPosition.right + tipWidth > viewportPosition.width) {
              placement = placement.replace('right', 'left');
            }
            tipElement.removeClass(originalPlacement).addClass(placement);
          }
          var tipPosition = getCalculatedOffset(placement, elementPosition, tipWidth, tipHeight);
          applyPlacement(tipPosition, placement);
        };
        $bsTooltip.$onKeyUp = function(evt) {
          if (evt.which === 27 && $bsTooltip.$isShown) {
            $bsTooltip.hide();
            evt.stopPropagation();
          }
        };
        $bsTooltip.$onFocusKeyUp = function(evt) {
          if (evt.which === 27) {
            element[0].blur();
            evt.stopPropagation();
          }
        };
        $bsTooltip.$onFocusElementMouseDown = function(evt) {
          evt.preventDefault();
          evt.stopPropagation();
          $bsTooltip.$isShown ? element[0].blur() : element[0].focus();
        };
        function bindTriggerEvents() {
          var triggers = options.trigger.split(' ');
          angular.forEach(triggers, function(trigger) {
            if (trigger === 'click') {
              element.on('click', $bsTooltip.toggle);
            } else if (trigger !== 'manual') {
              element.on(trigger === 'hover' ? 'mouseenter' : 'focus', $bsTooltip.enter);
              element.on(trigger === 'hover' ? 'mouseleave' : 'blur', $bsTooltip.leave);
              nodeName === 'button' && trigger !== 'hover' && element.on(isTouch ? 'touchstart' : 'mousedown', $bsTooltip.$onFocusElementMouseDown);
            }
          });
        }
        function unbindTriggerEvents() {
          var triggers = options.trigger.split(' ');
          for (var i = triggers.length; i--; ) {
            var trigger = triggers[i];
            if (trigger === 'click') {
              element.off('click', $bsTooltip.toggle);
            } else if (trigger !== 'manual') {
              element.off(trigger === 'hover' ? 'mouseenter' : 'focus', $bsTooltip.enter);
              element.off(trigger === 'hover' ? 'mouseleave' : 'blur', $bsTooltip.leave);
              nodeName === 'button' && trigger !== 'hover' && element.off(isTouch ? 'touchstart' : 'mousedown', $bsTooltip.$onFocusElementMouseDown);
            }
          }
        }
        function bindKeyboardEvents() {
          if (options.trigger !== 'focus') {
            tipElement.on('keyup', $bsTooltip.$onKeyUp);
          } else {
            element.on('keyup', $bsTooltip.$onFocusKeyUp);
          }
        }
        function unbindKeyboardEvents() {
          if (options.trigger !== 'focus') {
            tipElement.off('keyup', $bsTooltip.$onKeyUp);
          } else {
            element.off('keyup', $bsTooltip.$onFocusKeyUp);
          }
        }
        var _autoCloseEventsBinded = false;
        function bindAutoCloseEvents() {
          $timeout(function() {
            tipElement.on('click', stopEventPropagation);
            $body.on('click', $bsTooltip.hide);
            _autoCloseEventsBinded = true;
          }, 0, false);
        }
        function unbindAutoCloseEvents() {
          if (_autoCloseEventsBinded) {
            tipElement.off('click', stopEventPropagation);
            $body.off('click', $bsTooltip.hide);
            _autoCloseEventsBinded = false;
          }
        }
        function stopEventPropagation(event) {
          event.stopPropagation();
        }
        function getPosition($element) {
          $element = $element || (options.target || element);
          var el = $element[0], isBody = el.tagName === 'BODY';
          var elRect = el.getBoundingClientRect();
          var rect = {};
          for (var p in elRect) {
            rect[p] = elRect[p];
          }
          if (rect.width === null) {
            rect = angular.extend({}, rect, {
              width: elRect.right - elRect.left,
              height: elRect.bottom - elRect.top
            });
          }
          var elOffset = isBody ? {
            top: 0,
            left: 0
          } : dimensions.offset(el), scroll = {
            scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.prop('scrollTop') || 0
          }, outerDims = isBody ? {
            width: document.documentElement.clientWidth,
            height: $window.innerHeight
          } : null;
          return angular.extend({}, rect, scroll, outerDims, elOffset);
        }
        function getCalculatedOffset(placement, position, actualWidth, actualHeight) {
          var offset;
          var split = placement.split('-');
          switch (split[0]) {
           case 'right':
            offset = {
              top: position.top + position.height / 2 - actualHeight / 2,
              left: position.left + position.width
            };
            break;

           case 'bottom':
            offset = {
              top: position.top + position.height,
              left: position.left + position.width / 2 - actualWidth / 2
            };
            break;

           case 'left':
            offset = {
              top: position.top + position.height / 2 - actualHeight / 2,
              left: position.left - actualWidth
            };
            break;

           default:
            offset = {
              top: position.top - actualHeight,
              left: position.left + position.width / 2 - actualWidth / 2
            };
            break;
          }
          if (!split[1]) {
            return offset;
          }
          if (split[0] === 'top' || split[0] === 'bottom') {
            switch (split[1]) {
             case 'left':
              offset.left = position.left;
              break;

             case 'right':
              offset.left = position.left + position.width - actualWidth;
            }
          } else if (split[0] === 'left' || split[0] === 'right') {
            switch (split[1]) {
             case 'top':
              offset.top = position.top - actualHeight + position.height;
              break;

             case 'bottom':
              offset.top = position.top;
            }
          }
          return offset;
        }
        function applyPlacement(offset, placement) {
          var tip = tipElement[0], width = tip.offsetWidth, height = tip.offsetHeight;
          var marginTop = parseInt(dimensions.css(tip, 'margin-top'), 10), marginLeft = parseInt(dimensions.css(tip, 'margin-left'), 10);
          if (isNaN(marginTop)) marginTop = 0;
          if (isNaN(marginLeft)) marginLeft = 0;
          offset.top = offset.top + marginTop;
          offset.left = offset.left + marginLeft;
          dimensions.setOffset(tip, angular.extend({
            using: function(props) {
              tipElement.css({
                top: Math.round(props.top) + 'px',
                left: Math.round(props.left) + 'px',
                right: ''
              });
            }
          }, offset), 0);
          var actualWidth = tip.offsetWidth, actualHeight = tip.offsetHeight;
          if (placement === 'top' && actualHeight !== height) {
            offset.top = offset.top + height - actualHeight;
          }
          if (/top-left|top-right|bottom-left|bottom-right/.test(placement)) return;
          var delta = getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
          if (delta.left) {
            offset.left += delta.left;
          } else {
            offset.top += delta.top;
          }
          dimensions.setOffset(tip, offset);
          if (/top|right|bottom|left/.test(placement)) {
            var isVertical = /top|bottom/.test(placement), arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight, arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';
            replaceArrow(arrowDelta, tip[arrowOffsetPosition], isVertical);
          }
        }
        function getViewportAdjustedDelta(placement, position, actualWidth, actualHeight) {
          var delta = {
            top: 0,
            left: 0
          };
          if (!$bsTooltip.$viewport) return delta;
          var viewportPadding = options.viewport && options.viewport.padding || 0;
          var viewportDimensions = getPosition($bsTooltip.$viewport);
          if (/right|left/.test(placement)) {
            var topEdgeOffset = position.top - viewportPadding - viewportDimensions.scroll;
            var bottomEdgeOffset = position.top + viewportPadding - viewportDimensions.scroll + actualHeight;
            if (topEdgeOffset < viewportDimensions.top) {
              delta.top = viewportDimensions.top - topEdgeOffset;
            } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
              delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
            }
          } else {
            var leftEdgeOffset = position.left - viewportPadding;
            var rightEdgeOffset = position.left + viewportPadding + actualWidth;
            if (leftEdgeOffset < viewportDimensions.left) {
              delta.left = viewportDimensions.left - leftEdgeOffset;
            } else if (rightEdgeOffset > viewportDimensions.right) {
              delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
            }
          }
          return delta;
        }
        function replaceArrow(delta, dimension, isHorizontal) {
          var $arrow = findElement('.tooltip-arrow, .arrow', tipElement[0]);
          $arrow.css(isHorizontal ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isHorizontal ? 'top' : 'left', '');
        }
        function destroyTipElement() {
          clearTimeout(timeout);
          if ($bsTooltip.$isShown && tipElement !== null) {
            if (options.autoClose) {
              unbindAutoCloseEvents();
            }
            if (options.keyboard) {
              unbindKeyboardEvents();
            }
          }
          if (tipScope) {
            tipScope.$destroy();
            tipScope = null;
          }
          if (tipElement) {
            tipElement.remove();
            tipElement = $bsTooltip.$element = null;
          }
        }
        return $bsTooltip;
      }
      function safeDigest(scope) {
        scope.$$phase || scope.$root && scope.$root.$$phase || scope.$digest();
      }
      function findElement(query, element) {
        return angular.element((element || document).querySelectorAll(query));
      }
      var fetchPromises = {};
      function fetchTemplate(template) {
        if (fetchPromises[template]) return fetchPromises[template];
        return fetchPromises[template] = $http.get(template, {
          cache: $templateCache
        }).then(function(res) {
          return res.data;
        });
      }
      return TooltipFactory;
    } ];
  }).directive('bsTooltip', [ '$window', '$location', '$sce', '$bsTooltip', '$$rAF', function($window, $location, $sce, $bsTooltip, $$rAF) {
    return {
      restrict: 'EAC',
      scope: true,
      link: function postLink(scope, element, attr, transclusion) {
        var options = {
          scope: scope
        };
        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'backdropAnimation', 'type', 'customClass', 'id' ], function(key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach([ 'html', 'container' ], function(key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
        });
        var dataTarget = element.attr('data-target');
        if (angular.isDefined(dataTarget)) {
          if (falseValueRegExp.test(dataTarget)) options.target = false; else options.target = dataTarget;
        }
        if (!scope.hasOwnProperty('title')) {
          scope.title = '';
        }
        attr.$observe('title', function(newValue) {
          if (angular.isDefined(newValue) || !scope.hasOwnProperty('title')) {
            var oldValue = scope.title;
            scope.title = $sce.trustAsHtml(newValue);
            angular.isDefined(oldValue) && $$rAF(function() {
              tooltip && tooltip.$applyPlacement();
            });
          }
        });
        attr.bsTooltip && scope.$watch(attr.bsTooltip, function(newValue, oldValue) {
          if (angular.isObject(newValue)) {
            angular.extend(scope, newValue);
          } else {
            scope.title = newValue;
          }
          angular.isDefined(oldValue) && $$rAF(function() {
            tooltip && tooltip.$applyPlacement();
          });
        }, true);
        attr.bsShow && scope.$watch(attr.bsShow, function(newValue, oldValue) {
          if (!tooltip || !angular.isDefined(newValue)) return;
          if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(tooltip),?/i);
          newValue === true ? tooltip.show() : tooltip.hide();
        });
        attr.bsEnabled && scope.$watch(attr.bsEnabled, function(newValue, oldValue) {
          if (!tooltip || !angular.isDefined(newValue)) return;
          if (angular.isString(newValue)) newValue = !!newValue.match(/true|1|,?(tooltip),?/i);
          newValue === false ? tooltip.setEnabled(false) : tooltip.setEnabled(true);
        });
        attr.viewport && scope.$watch(attr.viewport, function(newValue) {
          if (!tooltip || !angular.isDefined(newValue)) return;
          tooltip.setViewport(newValue);
        });
        var tooltip = $bsTooltip(element, options);
        scope.$on('$destroy', function() {
          if (tooltip) tooltip.destroy();
          options = null;
          tooltip = null;
        });
      }
    };
  } ]);
  angular.module('mgcrea.ngStrap.typeahead', [ 'mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.helpers.parseOptions' ]).provider('$typeahead', function() {
    var defaults = this.defaults = {
      animation: 'am-fade',
      prefixClass: 'typeahead',
      prefixEvent: '$typeahead',
      placement: 'bottom-left',
      templateUrl: 'typeahead/typeahead.tpl.html',
      trigger: 'focus',
      container: false,
      keyboard: true,
      html: false,
      delay: 0,
      minLength: 1,
      filter: 'bsAsyncFilter',
      limit: 6,
      autoSelect: false,
      comparator: '',
      trimValue: true
    };
    this.$get = [ '$window', '$rootScope', '$bsTooltip', '$$rAF', '$timeout', function($window, $rootScope, $bsTooltip, $$rAF, $timeout) {
      var bodyEl = angular.element($window.document.body);
      function TypeaheadFactory(element, controller, config) {
        var $typeahead = {};
        var options = angular.extend({}, defaults, config);
        $typeahead = $bsTooltip(element, options);
        var parentScope = config.scope;
        var scope = $typeahead.$scope;
        scope.$resetMatches = function() {
          scope.$matches = [];
          scope.$activeIndex = options.autoSelect ? 0 : -1;
        };
        scope.$resetMatches();
        scope.$activate = function(index) {
          scope.$$postDigest(function() {
            $typeahead.activate(index);
          });
        };
        scope.$select = function(index, evt) {
          scope.$$postDigest(function() {
            $typeahead.select(index);
          });
        };
        scope.$isVisible = function() {
          return $typeahead.$isVisible();
        };
        $typeahead.update = function(matches) {
          scope.$matches = matches;
          if (scope.$activeIndex >= matches.length) {
            scope.$activeIndex = options.autoSelect ? 0 : -1;
          }
          safeDigest(scope);
          $$rAF($typeahead.$applyPlacement);
        };
        $typeahead.activate = function(index) {
          scope.$activeIndex = index;
        };
        $typeahead.select = function(index) {
          if (index === -1) return;
          var value = scope.$matches[index].value;
          controller.$setViewValue(value);
          controller.$render();
          scope.$resetMatches();
          if (parentScope) parentScope.$digest();
          scope.$emit(options.prefixEvent + '.select', value, index, $typeahead);
        };
        $typeahead.$isVisible = function() {
          if (!options.minLength || !controller) {
            return !!scope.$matches.length;
          }
          return scope.$matches.length && angular.isString(controller.$viewValue) && controller.$viewValue.length >= options.minLength;
        };
        $typeahead.$getIndex = function(value) {
          var l = scope.$matches.length, i = l;
          if (!l) return;
          for (i = l; i--; ) {
            if (scope.$matches[i].value === value) break;
          }
          if (i < 0) return;
          return i;
        };
        $typeahead.$onMouseDown = function(evt) {
          evt.preventDefault();
          evt.stopPropagation();
        };
        $typeahead.$onKeyDown = function(evt) {
          if (!/(38|40|13)/.test(evt.keyCode)) return;
          if ($typeahead.$isVisible() && !(evt.keyCode === 13 && scope.$activeIndex === -1)) {
            evt.preventDefault();
            evt.stopPropagation();
          }
          if (evt.keyCode === 13 && scope.$matches.length) {
            $typeahead.select(scope.$activeIndex);
          } else if (evt.keyCode === 38 && scope.$activeIndex > 0) scope.$activeIndex--; else if (evt.keyCode === 40 && scope.$activeIndex < scope.$matches.length - 1) scope.$activeIndex++; else if (angular.isUndefined(scope.$activeIndex)) scope.$activeIndex = 0;
          scope.$digest();
        };
        var show = $typeahead.show;
        $typeahead.show = function() {
          show();
          $timeout(function() {
            $typeahead.$element && $typeahead.$element.on('mousedown', $typeahead.$onMouseDown);
            if (options.keyboard) {
              element && element.on('keydown', $typeahead.$onKeyDown);
            }
          }, 0, false);
        };
        var hide = $typeahead.hide;
        $typeahead.hide = function() {
          $typeahead.$element && $typeahead.$element.off('mousedown', $typeahead.$onMouseDown);
          if (options.keyboard) {
            element && element.off('keydown', $typeahead.$onKeyDown);
          }
          if (!options.autoSelect) $typeahead.activate(-1);
          hide();
        };
        return $typeahead;
      }
      function safeDigest(scope) {
        scope.$$phase || scope.$root && scope.$root.$$phase || scope.$digest();
      }
      TypeaheadFactory.defaults = defaults;
      return TypeaheadFactory;
    } ];
  }).filter('bsAsyncFilter', [ '$filter', function($filter) {
    return function(array, expression, comparator) {
      if (array && angular.isFunction(array.then)) {
        return array.then(function(results) {
          return $filter('filter')(results, expression, comparator);
        });
      } else {
        return $filter('filter')(array, expression, comparator);
      }
    };
  } ]).directive('bsTypeahead', [ '$window', '$parse', '$q', '$typeahead', '$parseOptions', function($window, $parse, $q, $typeahead, $parseOptions) {
    var defaults = $typeahead.defaults;
    return {
      restrict: 'EAC',
      require: 'ngModel',
      link: function postLink(scope, element, attr, controller) {
        var options = {
          scope: scope
        };
        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'filter', 'limit', 'minLength', 'watchOptions', 'selectMode', 'autoSelect', 'comparator', 'id', 'prefixEvent', 'prefixClass' ], function(key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach([ 'html', 'container', 'trimValue' ], function(key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
        });
        if (!element.attr('autocomplete')) element.attr('autocomplete', 'off');
        var filter = options.filter || defaults.filter;
        var limit = options.limit || defaults.limit;
        var comparator = options.comparator || defaults.comparator;
        var bsOptions = attr.bsOptions;
        if (filter) bsOptions += ' | ' + filter + ':$viewValue';
        if (comparator) bsOptions += ':' + comparator;
        if (limit) bsOptions += ' | limitTo:' + limit;
        var parsedOptions = $parseOptions(bsOptions);
        var typeahead = $typeahead(element, controller, options);
        if (options.watchOptions) {
          var watchedOptions = parsedOptions.$match[7].replace(/\|.+/, '').replace(/\(.*\)/g, '').trim();
          scope.$watchCollection(watchedOptions, function(newValue, oldValue) {
            parsedOptions.valuesFn(scope, controller).then(function(values) {
              typeahead.update(values);
              controller.$render();
            });
          });
        }
        scope.$watch(attr.ngModel, function(newValue, oldValue) {
          scope.$modelValue = newValue;
          parsedOptions.valuesFn(scope, controller).then(function(values) {
            if (options.selectMode && !values.length && newValue.length > 0) {
              controller.$setViewValue(controller.$viewValue.substring(0, controller.$viewValue.length - 1));
              return;
            }
            if (values.length > limit) values = values.slice(0, limit);
            typeahead.update(values);
            controller.$render();
          });
        });
        controller.$formatters.push(function(modelValue) {
          var displayValue = parsedOptions.displayValue(modelValue);
          if (displayValue) {
            return displayValue;
          }
          if (modelValue && typeof modelValue !== 'object') {
            return modelValue;
          }
          return '';
        });
        controller.$render = function() {
          if (controller.$isEmpty(controller.$viewValue)) {
            return element.val('');
          }
          var index = typeahead.$getIndex(controller.$modelValue);
          var selected = angular.isDefined(index) ? typeahead.$scope.$matches[index].label : controller.$viewValue;
          selected = angular.isObject(selected) ? parsedOptions.displayValue(selected) : selected;
          var value = selected ? selected.toString().replace(/<(?:.|\n)*?>/gm, '') : '';
          element.val(options.trimValue === false ? value : value.trim());
        };
        scope.$on('$destroy', function() {
          if (typeahead) typeahead.destroy();
          options = null;
          typeahead = null;
        });
      }
    };
  } ]);
  angular.module('mgcrea.ngStrap.tab', []).provider('$tab', function() {
    var defaults = this.defaults = {
      animation: 'am-fade',
      template: 'tab/tab.tpl.html',
      navClass: 'nav-tabs',
      activeClass: 'active'
    };
    var controller = this.controller = function($scope, $element, $attrs) {
      var self = this;
      self.$options = angular.copy(defaults);
      angular.forEach([ 'animation', 'navClass', 'activeClass' ], function(key) {
        if (angular.isDefined($attrs[key])) self.$options[key] = $attrs[key];
      });
      $scope.$navClass = self.$options.navClass;
      $scope.$activeClass = self.$options.activeClass;
      self.$panes = $scope.$panes = [];
      self.$activePaneChangeListeners = self.$viewChangeListeners = [];
      self.$push = function(pane) {
        if (angular.isUndefined(self.$panes.$active)) {
          $scope.$setActive(pane.name || 0);
        }
        self.$panes.push(pane);
      };
      self.$remove = function(pane) {
        var index = self.$panes.indexOf(pane);
        var active = self.$panes.$active;
        var activeIndex;
        if (angular.isString(active)) {
          activeIndex = self.$panes.map(function(pane) {
            return pane.name;
          }).indexOf(active);
        } else {
          activeIndex = self.$panes.$active;
        }
        self.$panes.splice(index, 1);
        if (index < activeIndex) {
          activeIndex--;
        } else if (index === activeIndex && activeIndex === self.$panes.length) {
          activeIndex--;
        }
        if (activeIndex >= 0 && activeIndex < self.$panes.length) {
          self.$setActive(self.$panes[activeIndex].name || activeIndex);
        } else {
          self.$setActive();
        }
      };
      self.$setActive = $scope.$setActive = function(value) {
        self.$panes.$active = value;
        self.$activePaneChangeListeners.forEach(function(fn) {
          fn();
        });
      };
      self.$isActive = $scope.$isActive = function($pane, $index) {
        return self.$panes.$active === $pane.name || self.$panes.$active === $index;
      };
    };
    this.$get = function() {
      var $tab = {};
      $tab.defaults = defaults;
      $tab.controller = controller;
      return $tab;
    };
  }).directive('bsTabs', [ '$window', '$animate', '$tab', '$parse', function($window, $animate, $tab, $parse) {
    var defaults = $tab.defaults;
    return {
      require: [ '?ngModel', 'bsTabs' ],
      transclude: true,
      scope: true,
      controller: [ '$scope', '$element', '$attrs', $tab.controller ],
      templateUrl: function(element, attr) {
        return attr.template || defaults.template;
      },
      link: function postLink(scope, element, attrs, controllers) {
        var ngModelCtrl = controllers[0];
        var bsTabsCtrl = controllers[1];
        if (ngModelCtrl) {
          bsTabsCtrl.$activePaneChangeListeners.push(function() {
            ngModelCtrl.$setViewValue(bsTabsCtrl.$panes.$active);
          });
          ngModelCtrl.$formatters.push(function(modelValue) {
            bsTabsCtrl.$setActive(modelValue);
            return modelValue;
          });
        }
        if (attrs.bsActivePane) {
          var parsedBsActivePane = $parse(attrs.bsActivePane);
          bsTabsCtrl.$activePaneChangeListeners.push(function() {
            parsedBsActivePane.assign(scope, bsTabsCtrl.$panes.$active);
          });
          scope.$watch(attrs.bsActivePane, function(newValue, oldValue) {
            bsTabsCtrl.$setActive(newValue);
          }, true);
        }
      }
    };
  } ]).directive('bsPane', [ '$window', '$animate', '$sce', function($window, $animate, $sce) {
    return {
      require: [ '^?ngModel', '^bsTabs' ],
      scope: true,
      link: function postLink(scope, element, attrs, controllers) {
        var ngModelCtrl = controllers[0];
        var bsTabsCtrl = controllers[1];
        element.addClass('tab-pane');
        attrs.$observe('title', function(newValue, oldValue) {
          scope.title = $sce.trustAsHtml(newValue);
        });
        scope.name = attrs.name;
        if (bsTabsCtrl.$options.animation) {
          element.addClass(bsTabsCtrl.$options.animation);
        }
        attrs.$observe('disabled', function(newValue, oldValue) {
          scope.disabled = scope.$eval(newValue);
        });
        bsTabsCtrl.$push(scope);
        scope.$on('$destroy', function() {
          bsTabsCtrl.$remove(scope);
        });
        function render() {
          var index = bsTabsCtrl.$panes.indexOf(scope);
          $animate[bsTabsCtrl.$isActive(scope, index) ? 'addClass' : 'removeClass'](element, bsTabsCtrl.$options.activeClass);
        }
        bsTabsCtrl.$activePaneChangeListeners.push(function() {
          render();
        });
        render();
      }
    };
  } ]);
  angular.module('mgcrea.ngStrap.timepicker', [ 'mgcrea.ngStrap.helpers.dateParser', 'mgcrea.ngStrap.helpers.dateFormatter', 'mgcrea.ngStrap.tooltip' ]).provider('$timepicker', function() {
    var defaults = this.defaults = {
      animation: 'am-fade',
      prefixClass: 'timepicker',
      placement: 'bottom-left',
      templateUrl: 'timepicker/timepicker.tpl.html',
      trigger: 'focus',
      container: false,
      keyboard: true,
      html: false,
      delay: 0,
      useNative: true,
      timeType: 'date',
      timeFormat: 'shortTime',
      timezone: null,
      modelTimeFormat: null,
      autoclose: false,
      minTime: -Infinity,
      maxTime: +Infinity,
      length: 5,
      hourStep: 1,
      minuteStep: 5,
      secondStep: 5,
      roundDisplay: false,
      iconUp: 'glyphicon glyphicon-chevron-up',
      iconDown: 'glyphicon glyphicon-chevron-down',
      arrowBehavior: 'pager'
    };
    this.$get = [ '$window', '$document', '$rootScope', '$sce', '$dateFormatter', '$bsTooltip', '$timeout', function($window, $document, $rootScope, $sce, $dateFormatter, $bsTooltip, $timeout) {
      var isNative = /(ip(a|o)d|iphone|android)/gi.test($window.navigator.userAgent);
      var isTouch = 'createTouch' in $window.document && isNative;
      if (!defaults.lang) {
        defaults.lang = $dateFormatter.getDefaultLocale();
      }
      function timepickerFactory(element, controller, config) {
        var $timepicker = $bsTooltip(element, angular.extend({}, defaults, config));
        var parentScope = config.scope;
        var options = $timepicker.$options;
        var scope = $timepicker.$scope;
        var lang = options.lang;
        var formatDate = function(date, format, timezone) {
          return $dateFormatter.formatDate(date, format, lang, timezone);
        };
        function floorMinutes(time) {
          var coeff = 1e3 * 60 * options.minuteStep;
          return new Date(Math.floor(time.getTime() / coeff) * coeff);
        }
        var selectedIndex = 0;
        var defaultDate = options.roundDisplay ? floorMinutes(new Date()) : new Date();
        var startDate = controller.$dateValue || defaultDate;
        var viewDate = {
          hour: startDate.getHours(),
          meridian: startDate.getHours() < 12,
          minute: startDate.getMinutes(),
          second: startDate.getSeconds(),
          millisecond: startDate.getMilliseconds()
        };
        var format = $dateFormatter.getDatetimeFormat(options.timeFormat, lang);
        var hoursFormat = $dateFormatter.hoursFormat(format), timeSeparator = $dateFormatter.timeSeparator(format), minutesFormat = $dateFormatter.minutesFormat(format), secondsFormat = $dateFormatter.secondsFormat(format), showSeconds = $dateFormatter.showSeconds(format), showAM = $dateFormatter.showAM(format);
        scope.$iconUp = options.iconUp;
        scope.$iconDown = options.iconDown;
        scope.$select = function(date, index) {
          $timepicker.select(date, index);
        };
        scope.$moveIndex = function(value, index) {
          $timepicker.$moveIndex(value, index);
        };
        scope.$switchMeridian = function(date) {
          $timepicker.switchMeridian(date);
        };
        $timepicker.update = function(date) {
          if (angular.isDate(date) && !isNaN(date.getTime())) {
            $timepicker.$date = date;
            angular.extend(viewDate, {
              hour: date.getHours(),
              minute: date.getMinutes(),
              second: date.getSeconds(),
              millisecond: date.getMilliseconds()
            });
            $timepicker.$build();
          } else if (!$timepicker.$isBuilt) {
            $timepicker.$build();
          }
        };
        $timepicker.select = function(date, index, keep) {
          if (!controller.$dateValue || isNaN(controller.$dateValue.getTime())) controller.$dateValue = new Date(1970, 0, 1);
          if (!angular.isDate(date)) date = new Date(date);
          if (index === 0) controller.$dateValue.setHours(date.getHours()); else if (index === 1) controller.$dateValue.setMinutes(date.getMinutes()); else if (index === 2) controller.$dateValue.setSeconds(date.getSeconds());
          controller.$setViewValue(angular.copy(controller.$dateValue));
          controller.$render();
          if (options.autoclose && !keep) {
            $timeout(function() {
              $timepicker.hide(true);
            });
          }
        };
        $timepicker.switchMeridian = function(date) {
          if (!controller.$dateValue || isNaN(controller.$dateValue.getTime())) {
            return;
          }
          var hours = (date || controller.$dateValue).getHours();
          controller.$dateValue.setHours(hours < 12 ? hours + 12 : hours - 12);
          controller.$setViewValue(angular.copy(controller.$dateValue));
          controller.$render();
        };
        $timepicker.$build = function() {
          var i, midIndex = scope.midIndex = parseInt(options.length / 2, 10);
          var hours = [], hour;
          for (i = 0; i < options.length; i++) {
            hour = new Date(1970, 0, 1, viewDate.hour - (midIndex - i) * options.hourStep);
            hours.push({
              date: hour,
              label: formatDate(hour, hoursFormat),
              selected: $timepicker.$date && $timepicker.$isSelected(hour, 0),
              disabled: $timepicker.$isDisabled(hour, 0)
            });
          }
          var minutes = [], minute;
          for (i = 0; i < options.length; i++) {
            minute = new Date(1970, 0, 1, 0, viewDate.minute - (midIndex - i) * options.minuteStep);
            minutes.push({
              date: minute,
              label: formatDate(minute, minutesFormat),
              selected: $timepicker.$date && $timepicker.$isSelected(minute, 1),
              disabled: $timepicker.$isDisabled(minute, 1)
            });
          }
          var seconds = [], second;
          for (i = 0; i < options.length; i++) {
            second = new Date(1970, 0, 1, 0, 0, viewDate.second - (midIndex - i) * options.secondStep);
            seconds.push({
              date: second,
              label: formatDate(second, secondsFormat),
              selected: $timepicker.$date && $timepicker.$isSelected(second, 2),
              disabled: $timepicker.$isDisabled(second, 2)
            });
          }
          var rows = [];
          for (i = 0; i < options.length; i++) {
            if (showSeconds) {
              rows.push([ hours[i], minutes[i], seconds[i] ]);
            } else {
              rows.push([ hours[i], minutes[i] ]);
            }
          }
          scope.rows = rows;
          scope.showSeconds = showSeconds;
          scope.showAM = showAM;
          scope.isAM = ($timepicker.$date || hours[midIndex].date).getHours() < 12;
          scope.timeSeparator = timeSeparator;
          $timepicker.$isBuilt = true;
        };
        $timepicker.$isSelected = function(date, index) {
          if (!$timepicker.$date) return false; else if (index === 0) {
            return date.getHours() === $timepicker.$date.getHours();
          } else if (index === 1) {
            return date.getMinutes() === $timepicker.$date.getMinutes();
          } else if (index === 2) {
            return date.getSeconds() === $timepicker.$date.getSeconds();
          }
        };
        $timepicker.$isDisabled = function(date, index) {
          var selectedTime;
          if (index === 0) {
            selectedTime = date.getTime() + viewDate.minute * 6e4 + viewDate.second * 1e3;
          } else if (index === 1) {
            selectedTime = date.getTime() + viewDate.hour * 36e5 + viewDate.second * 1e3;
          } else if (index === 2) {
            selectedTime = date.getTime() + viewDate.hour * 36e5 + viewDate.minute * 6e4;
          }
          return selectedTime < options.minTime * 1 || selectedTime > options.maxTime * 1;
        };
        scope.$arrowAction = function(value, index) {
          if (options.arrowBehavior === 'picker') {
            $timepicker.$setTimeByStep(value, index);
          } else {
            $timepicker.$moveIndex(value, index);
          }
        };
        $timepicker.$setTimeByStep = function(value, index) {
          var newDate = new Date($timepicker.$date || startDate);
          var hours = newDate.getHours();
          var minutes = newDate.getMinutes();
          var seconds = newDate.getSeconds();
          if (index === 0) {
            newDate.setHours(hours - parseInt(options.hourStep, 10) * value);
          } else if (index === 1) {
            newDate.setMinutes(minutes - parseInt(options.minuteStep, 10) * value);
          } else if (index === 2) {
            newDate.setSeconds(seconds - parseInt(options.secondStep, 10) * value);
          }
          $timepicker.select(newDate, index, true);
        };
        $timepicker.$moveIndex = function(value, index) {
          var targetDate;
          if (index === 0) {
            targetDate = new Date(1970, 0, 1, viewDate.hour + value * options.length, viewDate.minute, viewDate.second);
            angular.extend(viewDate, {
              hour: targetDate.getHours()
            });
          } else if (index === 1) {
            targetDate = new Date(1970, 0, 1, viewDate.hour, viewDate.minute + value * options.length * options.minuteStep, viewDate.second);
            angular.extend(viewDate, {
              minute: targetDate.getMinutes()
            });
          } else if (index === 2) {
            targetDate = new Date(1970, 0, 1, viewDate.hour, viewDate.minute, viewDate.second + value * options.length * options.secondStep);
            angular.extend(viewDate, {
              second: targetDate.getSeconds()
            });
          }
          $timepicker.$build();
        };
        $timepicker.$onMouseDown = function(evt) {
          if (evt.target.nodeName.toLowerCase() !== 'input') evt.preventDefault();
          evt.stopPropagation();
          if (isTouch) {
            var targetEl = angular.element(evt.target);
            if (targetEl[0].nodeName.toLowerCase() !== 'button') {
              targetEl = targetEl.parent();
            }
            targetEl.triggerHandler('click');
          }
        };
        $timepicker.$onKeyDown = function(evt) {
          if (!/(38|37|39|40|13)/.test(evt.keyCode) || evt.shiftKey || evt.altKey) return;
          evt.preventDefault();
          evt.stopPropagation();
          if (evt.keyCode === 13) {
            $timepicker.hide(true);
            return;
          }
          var newDate = new Date($timepicker.$date);
          var hours = newDate.getHours(), hoursLength = formatDate(newDate, hoursFormat).length;
          var minutes = newDate.getMinutes(), minutesLength = formatDate(newDate, minutesFormat).length;
          var seconds = newDate.getSeconds(), secondsLength = formatDate(newDate, secondsFormat).length;
          var sepLength = 1;
          var lateralMove = /(37|39)/.test(evt.keyCode);
          var count = 2 + showSeconds * 1 + showAM * 1;
          if (lateralMove) {
            if (evt.keyCode === 37) selectedIndex = selectedIndex < 1 ? count - 1 : selectedIndex - 1; else if (evt.keyCode === 39) selectedIndex = selectedIndex < count - 1 ? selectedIndex + 1 : 0;
          }
          var selectRange = [ 0, hoursLength ];
          var incr = 0;
          if (evt.keyCode === 38) incr = -1;
          if (evt.keyCode === 40) incr = +1;
          var isSeconds = selectedIndex === 2 && showSeconds;
          var isMeridian = selectedIndex === 2 && !showSeconds || selectedIndex === 3 && showSeconds;
          if (selectedIndex === 0) {
            newDate.setHours(hours + incr * parseInt(options.hourStep, 10));
            hoursLength = formatDate(newDate, hoursFormat).length;
            selectRange = [ 0, hoursLength ];
          } else if (selectedIndex === 1) {
            newDate.setMinutes(minutes + incr * parseInt(options.minuteStep, 10));
            minutesLength = formatDate(newDate, minutesFormat).length;
            selectRange = [ hoursLength + sepLength, minutesLength ];
          } else if (isSeconds) {
            newDate.setSeconds(seconds + incr * parseInt(options.secondStep, 10));
            secondsLength = formatDate(newDate, secondsFormat).length;
            selectRange = [ hoursLength + sepLength + minutesLength + sepLength, secondsLength ];
          } else if (isMeridian) {
            if (!lateralMove) $timepicker.switchMeridian();
            selectRange = [ hoursLength + sepLength + minutesLength + sepLength + (secondsLength + sepLength) * showSeconds, 2 ];
          }
          $timepicker.select(newDate, selectedIndex, true);
          createSelection(selectRange[0], selectRange[1]);
          parentScope.$digest();
        };
        function createSelection(start, length) {
          var end = start + length;
          if (element[0].createTextRange) {
            var selRange = element[0].createTextRange();
            selRange.collapse(true);
            selRange.moveStart('character', start);
            selRange.moveEnd('character', end);
            selRange.select();
          } else if (element[0].setSelectionRange) {
            element[0].setSelectionRange(start, end);
          } else if (angular.isUndefined(element[0].selectionStart)) {
            element[0].selectionStart = start;
            element[0].selectionEnd = end;
          }
        }
        function focusElement() {
          element[0].focus();
        }
        var _init = $timepicker.init;
        $timepicker.init = function() {
          if (isNative && options.useNative) {
            element.prop('type', 'time');
            element.css('-webkit-appearance', 'textfield');
            return;
          } else if (isTouch) {
            element.prop('type', 'text');
            element.attr('readonly', 'true');
            element.on('click', focusElement);
          }
          _init();
        };
        var _destroy = $timepicker.destroy;
        $timepicker.destroy = function() {
          if (isNative && options.useNative) {
            element.off('click', focusElement);
          }
          _destroy();
        };
        var _show = $timepicker.show;
        $timepicker.show = function() {
          if (!isTouch && element.attr('readonly') || element.attr('disabled')) return;
          _show();
          $timeout(function() {
            $timepicker.$element && $timepicker.$element.on(isTouch ? 'touchstart' : 'mousedown', $timepicker.$onMouseDown);
            if (options.keyboard) {
              element && element.on('keydown', $timepicker.$onKeyDown);
            }
          }, 0, false);
        };
        var _hide = $timepicker.hide;
        $timepicker.hide = function(blur) {
          if (!$timepicker.$isShown) return;
          $timepicker.$element && $timepicker.$element.off(isTouch ? 'touchstart' : 'mousedown', $timepicker.$onMouseDown);
          if (options.keyboard) {
            element && element.off('keydown', $timepicker.$onKeyDown);
          }
          _hide(blur);
        };
        return $timepicker;
      }
      timepickerFactory.defaults = defaults;
      return timepickerFactory;
    } ];
  }).directive('bsTimepicker', [ '$window', '$parse', '$q', '$dateFormatter', '$dateParser', '$timepicker', function($window, $parse, $q, $dateFormatter, $dateParser, $timepicker) {
    var defaults = $timepicker.defaults;
    var isNative = /(ip(a|o)d|iphone|android)/gi.test($window.navigator.userAgent);
    return {
      restrict: 'EAC',
      require: 'ngModel',
      link: function postLink(scope, element, attr, controller) {
        var options = {
          scope: scope
        };
        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'autoclose', 'timeType', 'timeFormat', 'timezone', 'modelTimeFormat', 'useNative', 'hourStep', 'minuteStep', 'secondStep', 'length', 'arrowBehavior', 'iconUp', 'iconDown', 'roundDisplay', 'id', 'prefixClass', 'prefixEvent' ], function(key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach([ 'html', 'container', 'autoclose', 'useNative', 'roundDisplay' ], function(key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
        });
        attr.bsShow && scope.$watch(attr.bsShow, function(newValue, oldValue) {
          if (!timepicker || !angular.isDefined(newValue)) return;
          if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(timepicker),?/i);
          newValue === true ? timepicker.show() : timepicker.hide();
        });
        if (isNative && (options.useNative || defaults.useNative)) options.timeFormat = 'HH:mm';
        var timepicker = $timepicker(element, controller, options);
        options = timepicker.$options;
        var lang = options.lang;
        var formatDate = function(date, format, timezone) {
          return $dateFormatter.formatDate(date, format, lang, timezone);
        };
        var dateParser = $dateParser({
          format: options.timeFormat,
          lang: lang
        });
        angular.forEach([ 'minTime', 'maxTime' ], function(key) {
          angular.isDefined(attr[key]) && attr.$observe(key, function(newValue) {
            timepicker.$options[key] = dateParser.getTimeForAttribute(key, newValue);
            !isNaN(timepicker.$options[key]) && timepicker.$build();
            validateAgainstMinMaxTime(controller.$dateValue);
          });
        });
        scope.$watch(attr.ngModel, function(newValue, oldValue) {
          timepicker.update(controller.$dateValue);
        }, true);
        function validateAgainstMinMaxTime(parsedTime) {
          if (!angular.isDate(parsedTime)) return;
          var isMinValid = isNaN(options.minTime) || new Date(parsedTime.getTime()).setFullYear(1970, 0, 1) >= options.minTime;
          var isMaxValid = isNaN(options.maxTime) || new Date(parsedTime.getTime()).setFullYear(1970, 0, 1) <= options.maxTime;
          var isValid = isMinValid && isMaxValid;
          controller.$setValidity('date', isValid);
          controller.$setValidity('min', isMinValid);
          controller.$setValidity('max', isMaxValid);
          if (!isValid) {
            return;
          }
          controller.$dateValue = parsedTime;
        }
        controller.$parsers.unshift(function(viewValue) {
          var date;
          if (!viewValue) {
            controller.$setValidity('date', true);
            return null;
          }
          var parsedTime = angular.isDate(viewValue) ? viewValue : dateParser.parse(viewValue, controller.$dateValue);
          if (!parsedTime || isNaN(parsedTime.getTime())) {
            controller.$setValidity('date', false);
            return undefined;
          } else {
            validateAgainstMinMaxTime(parsedTime);
          }
          if (options.timeType === 'string') {
            date = dateParser.timezoneOffsetAdjust(parsedTime, options.timezone, true);
            return formatDate(date, options.modelTimeFormat || options.timeFormat);
          }
          date = dateParser.timezoneOffsetAdjust(controller.$dateValue, options.timezone, true);
          if (options.timeType === 'number') {
            return date.getTime();
          } else if (options.timeType === 'unix') {
            return date.getTime() / 1e3;
          } else if (options.timeType === 'iso') {
            return date.toISOString();
          } else {
            return new Date(date);
          }
        });
        controller.$formatters.push(function(modelValue) {
          var date;
          if (angular.isUndefined(modelValue) || modelValue === null) {
            date = NaN;
          } else if (angular.isDate(modelValue)) {
            date = modelValue;
          } else if (options.timeType === 'string') {
            date = dateParser.parse(modelValue, null, options.modelTimeFormat);
          } else if (options.timeType === 'unix') {
            date = new Date(modelValue * 1e3);
          } else {
            date = new Date(modelValue);
          }
          controller.$dateValue = dateParser.timezoneOffsetAdjust(date, options.timezone);
          return getTimeFormattedString();
        });
        controller.$render = function() {
          element.val(getTimeFormattedString());
        };
        function getTimeFormattedString() {
          return !controller.$dateValue || isNaN(controller.$dateValue.getTime()) ? '' : formatDate(controller.$dateValue, options.timeFormat);
        }
        scope.$on('$destroy', function() {
          if (timepicker) timepicker.destroy();
          options = null;
          timepicker = null;
        });
      }
    };
  } ]);
  angular.module('mgcrea.ngStrap.scrollspy', [ 'mgcrea.ngStrap.helpers.debounce', 'mgcrea.ngStrap.helpers.dimensions' ]).provider('$scrollspy', function() {
    var spies = this.$$spies = {};
    var defaults = this.defaults = {
      debounce: 150,
      throttle: 100,
      offset: 100
    };
    this.$get = [ '$window', '$document', '$rootScope', 'dimensions', 'debounce', 'throttle', function($window, $document, $rootScope, dimensions, debounce, throttle) {
      var windowEl = angular.element($window);
      var docEl = angular.element($document.prop('documentElement'));
      var bodyEl = angular.element($window.document.body);
      function nodeName(element, name) {
        return element[0].nodeName && element[0].nodeName.toLowerCase() === name.toLowerCase();
      }
      function ScrollSpyFactory(config) {
        var options = angular.extend({}, defaults, config);
        if (!options.element) options.element = bodyEl;
        var isWindowSpy = nodeName(options.element, 'body');
        var scrollEl = isWindowSpy ? windowEl : options.element;
        var scrollId = isWindowSpy ? 'window' : options.id;
        if (spies[scrollId]) {
          spies[scrollId].$$count++;
          return spies[scrollId];
        }
        var $scrollspy = {};
        var unbindViewContentLoaded, unbindIncludeContentLoaded;
        var trackedElements = $scrollspy.$trackedElements = [];
        var sortedElements = [];
        var activeTarget;
        var debouncedCheckPosition;
        var throttledCheckPosition;
        var debouncedCheckOffsets;
        var viewportHeight;
        var scrollTop;
        $scrollspy.init = function() {
          this.$$count = 1;
          debouncedCheckPosition = debounce(this.checkPosition, options.debounce);
          throttledCheckPosition = throttle(this.checkPosition, options.throttle);
          scrollEl.on('click', this.checkPositionWithEventLoop);
          windowEl.on('resize', debouncedCheckPosition);
          scrollEl.on('scroll', throttledCheckPosition);
          debouncedCheckOffsets = debounce(this.checkOffsets, options.debounce);
          unbindViewContentLoaded = $rootScope.$on('$viewContentLoaded', debouncedCheckOffsets);
          unbindIncludeContentLoaded = $rootScope.$on('$includeContentLoaded', debouncedCheckOffsets);
          debouncedCheckOffsets();
          if (scrollId) {
            spies[scrollId] = $scrollspy;
          }
        };
        $scrollspy.destroy = function() {
          this.$$count--;
          if (this.$$count > 0) {
            return;
          }
          scrollEl.off('click', this.checkPositionWithEventLoop);
          windowEl.off('resize', debouncedCheckPosition);
          scrollEl.off('scroll', throttledCheckPosition);
          unbindViewContentLoaded();
          unbindIncludeContentLoaded();
          if (scrollId) {
            delete spies[scrollId];
          }
        };
        $scrollspy.checkPosition = function() {
          if (!sortedElements.length) return;
          scrollTop = (isWindowSpy ? $window.pageYOffset : scrollEl.prop('scrollTop')) || 0;
          viewportHeight = Math.max($window.innerHeight, docEl.prop('clientHeight'));
          if (scrollTop < sortedElements[0].offsetTop && activeTarget !== sortedElements[0].target) {
            return $scrollspy.$activateElement(sortedElements[0]);
          }
          for (var i = sortedElements.length; i--; ) {
            if (angular.isUndefined(sortedElements[i].offsetTop) || sortedElements[i].offsetTop === null) continue;
            if (activeTarget === sortedElements[i].target) continue;
            if (scrollTop < sortedElements[i].offsetTop) continue;
            if (sortedElements[i + 1] && scrollTop > sortedElements[i + 1].offsetTop) continue;
            return $scrollspy.$activateElement(sortedElements[i]);
          }
        };
        $scrollspy.checkPositionWithEventLoop = function() {
          setTimeout($scrollspy.checkPosition, 1);
        };
        $scrollspy.$activateElement = function(element) {
          if (activeTarget) {
            var activeElement = $scrollspy.$getTrackedElement(activeTarget);
            if (activeElement) {
              activeElement.source.removeClass('active');
              if (nodeName(activeElement.source, 'li') && nodeName(activeElement.source.parent().parent(), 'li')) {
                activeElement.source.parent().parent().removeClass('active');
              }
            }
          }
          activeTarget = element.target;
          element.source.addClass('active');
          if (nodeName(element.source, 'li') && nodeName(element.source.parent().parent(), 'li')) {
            element.source.parent().parent().addClass('active');
          }
        };
        $scrollspy.$getTrackedElement = function(target) {
          return trackedElements.filter(function(obj) {
            return obj.target === target;
          })[0];
        };
        $scrollspy.checkOffsets = function() {
          angular.forEach(trackedElements, function(trackedElement) {
            var targetElement = document.querySelector(trackedElement.target);
            trackedElement.offsetTop = targetElement ? dimensions.offset(targetElement).top : null;
            if (options.offset && trackedElement.offsetTop !== null) trackedElement.offsetTop -= options.offset * 1;
          });
          sortedElements = trackedElements.filter(function(el) {
            return el.offsetTop !== null;
          }).sort(function(a, b) {
            return a.offsetTop - b.offsetTop;
          });
          debouncedCheckPosition();
        };
        $scrollspy.trackElement = function(target, source) {
          trackedElements.push({
            target: target,
            source: source
          });
        };
        $scrollspy.untrackElement = function(target, source) {
          var toDelete;
          for (var i = trackedElements.length; i--; ) {
            if (trackedElements[i].target === target && trackedElements[i].source === source) {
              toDelete = i;
              break;
            }
          }
          trackedElements = trackedElements.splice(toDelete, 1);
        };
        $scrollspy.activate = function(i) {
          trackedElements[i].addClass('active');
        };
        $scrollspy.init();
        return $scrollspy;
      }
      return ScrollSpyFactory;
    } ];
  }).directive('bsScrollspy', [ '$rootScope', 'debounce', 'dimensions', '$scrollspy', function($rootScope, debounce, dimensions, $scrollspy) {
    return {
      restrict: 'EAC',
      link: function postLink(scope, element, attr) {
        var options = {
          scope: scope
        };
        angular.forEach([ 'offset', 'target' ], function(key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });
        var scrollspy = $scrollspy(options);
        scrollspy.trackElement(options.target, element);
        scope.$on('$destroy', function() {
          if (scrollspy) {
            scrollspy.untrackElement(options.target, element);
            scrollspy.destroy();
          }
          options = null;
          scrollspy = null;
        });
      }
    };
  } ]).directive('bsScrollspyList', [ '$rootScope', 'debounce', 'dimensions', '$scrollspy', function($rootScope, debounce, dimensions, $scrollspy) {
    return {
      restrict: 'A',
      compile: function postLink(element, attr) {
        var children = element[0].querySelectorAll('li > a[href]');
        angular.forEach(children, function(child) {
          var childEl = angular.element(child);
          childEl.parent().attr('bs-scrollspy', '').attr('data-target', childEl.attr('href'));
        });
      }
    };
  } ]);
  angular.module('mgcrea.ngStrap.select', [ 'mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.helpers.parseOptions' ]).provider('$select', function() {
    var defaults = this.defaults = {
      animation: 'am-fade',
      prefixClass: 'select',
      prefixEvent: '$select',
      placement: 'bottom-left',
      templateUrl: 'select/select.tpl.html',
      trigger: 'focus',
      container: false,
      keyboard: true,
      html: false,
      delay: 0,
      multiple: false,
      allNoneButtons: false,
      sort: true,
      caretHtml: '&nbsp;<span class="caret"></span>',
      placeholder: 'Choose among the following...',
      allText: 'All',
      noneText: 'None',
      maxLength: 3,
      maxLengthHtml: 'selected',
      iconCheckmark: 'glyphicon glyphicon-ok'
    };
    this.$get = [ '$window', '$document', '$rootScope', '$bsTooltip', '$timeout', function($window, $document, $rootScope, $bsTooltip, $timeout) {
      var bodyEl = angular.element($window.document.body);
      var isNative = /(ip(a|o)d|iphone|android)/gi.test($window.navigator.userAgent);
      var isTouch = 'createTouch' in $window.document && isNative;
      function SelectFactory(element, controller, config) {
        var $select = {};
        var options = angular.extend({}, defaults, config);
        $select = $bsTooltip(element, options);
        var scope = $select.$scope;
        scope.$matches = [];
        if (options.multiple) {
          scope.$activeIndex = [];
        } else {
          scope.$activeIndex = -1;
        }
        scope.$isMultiple = options.multiple;
        scope.$showAllNoneButtons = options.allNoneButtons && options.multiple;
        scope.$iconCheckmark = options.iconCheckmark;
        scope.$allText = options.allText;
        scope.$noneText = options.noneText;
        scope.$activate = function(index) {
          scope.$$postDigest(function() {
            $select.activate(index);
          });
        };
        scope.$select = function(index, evt) {
          scope.$$postDigest(function() {
            $select.select(index);
          });
        };
        scope.$isVisible = function() {
          return $select.$isVisible();
        };
        scope.$isActive = function(index) {
          return $select.$isActive(index);
        };
        scope.$selectAll = function() {
          for (var i = 0; i < scope.$matches.length; i++) {
            if (!scope.$isActive(i)) {
              scope.$select(i);
            }
          }
        };
        scope.$selectNone = function() {
          for (var i = 0; i < scope.$matches.length; i++) {
            if (scope.$isActive(i)) {
              scope.$select(i);
            }
          }
        };
        $select.update = function(matches) {
          scope.$matches = matches;
          $select.$updateActiveIndex();
        };
        $select.activate = function(index) {
          if (options.multiple) {
            $select.$isActive(index) ? scope.$activeIndex.splice(scope.$activeIndex.indexOf(index), 1) : scope.$activeIndex.push(index);
            if (options.sort) scope.$activeIndex.sort(function(a, b) {
              return a - b;
            });
          } else {
            scope.$activeIndex = index;
          }
          return scope.$activeIndex;
        };
        $select.select = function(index) {
          var value = scope.$matches[index].value;
          scope.$apply(function() {
            $select.activate(index);
            if (options.multiple) {
              controller.$setViewValue(scope.$activeIndex.map(function(index) {
                if (angular.isUndefined(scope.$matches[index])) {
                  return null;
                }
                return scope.$matches[index].value;
              }));
            } else {
              controller.$setViewValue(value);
              $select.hide();
            }
          });
          scope.$emit(options.prefixEvent + '.select', value, index, $select);
        };
        $select.$updateActiveIndex = function() {
          if (options.multiple) {
            if (angular.isArray(controller.$modelValue)) {
              scope.$activeIndex = controller.$modelValue.map(function(value) {
                return $select.$getIndex(value);
              });
            } else {
              scope.$activeIndex = [];
            }
          } else {
            if (angular.isDefined(controller.$modelValue) && scope.$matches.length) {
              scope.$activeIndex = $select.$getIndex(controller.$modelValue);
            } else {
              scope.$activeIndex = -1;
            }
          }
        };
        $select.$isVisible = function() {
          if (!options.minLength || !controller) {
            return scope.$matches.length;
          }
          return scope.$matches.length && controller.$viewValue.length >= options.minLength;
        };
        $select.$isActive = function(index) {
          if (options.multiple) {
            return scope.$activeIndex.indexOf(index) !== -1;
          } else {
            return scope.$activeIndex === index;
          }
        };
        $select.$getIndex = function(value) {
          var l = scope.$matches.length, i = l;
          if (!l) return;
          for (i = l; i--; ) {
            if (scope.$matches[i].value === value) break;
          }
          if (i < 0) return;
          return i;
        };
        $select.$onMouseDown = function(evt) {
          evt.preventDefault();
          evt.stopPropagation();
          if (isTouch) {
            var targetEl = angular.element(evt.target);
            targetEl.triggerHandler('click');
          }
        };
        $select.$onKeyDown = function(evt) {
          if (!/(9|13|38|40)/.test(evt.keyCode)) return;
          if (evt.keyCode !== 9) {
            evt.preventDefault();
            evt.stopPropagation();
          }
          if (options.multiple && evt.keyCode === 9) {
            return $select.hide();
          }
          if (!options.multiple && (evt.keyCode === 13 || evt.keyCode === 9)) {
            return $select.select(scope.$activeIndex);
          }
          if (!options.multiple) {
            if (evt.keyCode === 38 && scope.$activeIndex > 0) scope.$activeIndex--; else if (evt.keyCode === 38 && scope.$activeIndex < 0) scope.$activeIndex = scope.$matches.length - 1; else if (evt.keyCode === 40 && scope.$activeIndex < scope.$matches.length - 1) scope.$activeIndex++; else if (angular.isUndefined(scope.$activeIndex)) scope.$activeIndex = 0;
            scope.$digest();
          }
        };
        $select.$isIE = function() {
          var ua = $window.navigator.userAgent;
          return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0;
        };
        $select.$selectScrollFix = function(e) {
          if ($document[0].activeElement.tagName === 'UL') {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.target.focus();
          }
        };
        var _show = $select.show;
        $select.show = function() {
          _show();
          if (options.multiple) {
            $select.$element.addClass('select-multiple');
          }
          $timeout(function() {
            $select.$element.on(isTouch ? 'touchstart' : 'mousedown', $select.$onMouseDown);
            if (options.keyboard) {
              element.on('keydown', $select.$onKeyDown);
            }
          }, 0, false);
        };
        var _hide = $select.hide;
        $select.hide = function() {
          if (!options.multiple && angular.isUndefined(controller.$modelValue)) {
            scope.$activeIndex = -1;
          }
          $select.$element.off(isTouch ? 'touchstart' : 'mousedown', $select.$onMouseDown);
          if (options.keyboard) {
            element.off('keydown', $select.$onKeyDown);
          }
          _hide(true);
        };
        return $select;
      }
      SelectFactory.defaults = defaults;
      return SelectFactory;
    } ];
  }).directive('bsSelect', [ '$window', '$parse', '$q', '$select', '$parseOptions', function($window, $parse, $q, $select, $parseOptions) {
    var defaults = $select.defaults;
    return {
      restrict: 'EAC',
      require: 'ngModel',
      link: function postLink(scope, element, attr, controller) {
        var options = {
          scope: scope,
          placeholder: defaults.placeholder
        };
        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'placeholder', 'allNoneButtons', 'maxLength', 'maxLengthHtml', 'allText', 'noneText', 'iconCheckmark', 'autoClose', 'id', 'sort', 'caretHtml', 'prefixClass', 'prefixEvent' ], function(key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach([ 'html', 'container', 'allNoneButtons', 'sort' ], function(key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
        });
        var dataMultiple = element.attr('data-multiple');
        if (angular.isDefined(dataMultiple)) {
          if (falseValueRegExp.test(dataMultiple)) options.multiple = false; else options.multiple = dataMultiple;
        }
        if (element[0].nodeName.toLowerCase() === 'select') {
          var inputEl = element;
          inputEl.css('display', 'none');
          element = angular.element('<button type="button" class="btn btn-default"></button>');
          inputEl.after(element);
        }
        var parsedOptions = $parseOptions(attr.bsOptions);
        var select = $select(element, controller, options);
        if (select.$isIE()) {
          element[0].addEventListener('blur', select.$selectScrollFix);
        }
        var watchedOptions = parsedOptions.$match[7].replace(/\|.+/, '').trim();
        scope.$watch(watchedOptions, function(newValue, oldValue) {
          parsedOptions.valuesFn(scope, controller).then(function(values) {
            select.update(values);
            controller.$render();
          });
        }, true);
        scope.$watch(attr.ngModel, function(newValue, oldValue) {
          select.$updateActiveIndex();
          controller.$render();
        }, true);
        controller.$render = function() {
          var selected, index;
          if (options.multiple && angular.isArray(controller.$modelValue)) {
            selected = controller.$modelValue.map(function(value) {
              index = select.$getIndex(value);
              return angular.isDefined(index) ? select.$scope.$matches[index].label : false;
            }).filter(angular.isDefined);
            if (selected.length > (options.maxLength || defaults.maxLength)) {
              selected = selected.length + ' ' + (options.maxLengthHtml || defaults.maxLengthHtml);
            } else {
              selected = selected.join(', ');
            }
          } else {
            index = select.$getIndex(controller.$modelValue);
            selected = angular.isDefined(index) ? select.$scope.$matches[index].label : false;
          }
          element.html((selected ? selected : options.placeholder) + (options.caretHtml ? options.caretHtml : defaults.caretHtml));
        };
        if (options.multiple) {
          controller.$isEmpty = function(value) {
            return !value || value.length === 0;
          };
        }
        scope.$on('$destroy', function() {
          if (select) select.destroy();
          options = null;
          select = null;
        });
      }
    };
  } ]);
  angular.module('mgcrea.ngStrap.popover', [ 'mgcrea.ngStrap.tooltip' ]).provider('$popover', function() {
    var defaults = this.defaults = {
      animation: 'am-fade',
      customClass: '',
      container: false,
      target: false,
      placement: 'right',
      templateUrl: 'popover/popover.tpl.html',
      contentTemplate: false,
      trigger: 'click',
      keyboard: true,
      html: false,
      title: '',
      content: '',
      delay: 0,
      autoClose: false
    };
    this.$get = [ '$bsTooltip', function($bsTooltip) {
      function PopoverFactory(element, config) {
        var options = angular.extend({}, defaults, config);
        var $popover = $bsTooltip(element, options);
        if (options.content) {
          $popover.$scope.content = options.content;
        }
        return $popover;
      }
      return PopoverFactory;
    } ];
  }).directive('bsNgPopover', [ '$window', '$sce', '$popover', function($window, $sce, $popover) {
    var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;
    return {
      restrict: 'EAC',
      scope: true,
      link: function postLink(scope, element, attr) {
        var options = {
          scope: scope
        };
        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'customClass', 'autoClose', 'id', 'prefixClass', 'prefixEvent' ], function(key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach([ 'html', 'container', 'autoClose' ], function(key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
        });
        var dataTarget = element.attr('data-target');
        if (angular.isDefined(dataTarget)) {
          if (falseValueRegExp.test(dataTarget)) options.target = false; else options.target = dataTarget;
        }
        angular.forEach([ 'title', 'content' ], function(key) {
          attr[key] && attr.$observe(key, function(newValue, oldValue) {
            scope[key] = $sce.trustAsHtml(newValue);
            angular.isDefined(oldValue) && requestAnimationFrame(function() {
              popover && popover.$applyPlacement();
            });
          });
        });
        attr.bsPopover && scope.$watch(attr.bsPopover, function(newValue, oldValue) {
          if (angular.isObject(newValue)) {
            angular.extend(scope, newValue);
          } else {
            scope.content = newValue;
          }
          angular.isDefined(oldValue) && requestAnimationFrame(function() {
            popover && popover.$applyPlacement();
          });
        }, true);
        attr.bsShow && scope.$watch(attr.bsShow, function(newValue, oldValue) {
          if (!popover || !angular.isDefined(newValue)) return;
          if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(popover),?/i);
          newValue === true ? popover.show() : popover.hide();
        });
        attr.viewport && scope.$watch(attr.viewport, function(newValue) {
          if (!popover || !angular.isDefined(newValue)) return;
          popover.setViewport(newValue);
        });
        var popover = $popover(element, options);
        scope.$on('$destroy', function() {
          if (popover) popover.destroy();
          options = null;
          popover = null;
        });
      }
    };
  } ]);
  angular.version.minor < 3 && angular.version.dot < 14 && angular.module('ng').factory('$$rAF', [ '$window', '$timeout', function($window, $timeout) {
    var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame || $window.mozRequestAnimationFrame;
    var cancelAnimationFrame = $window.cancelAnimationFrame || $window.webkitCancelAnimationFrame || $window.mozCancelAnimationFrame || $window.webkitCancelRequestAnimationFrame;
    var rafSupported = !!requestAnimationFrame;
    var raf = rafSupported ? function(fn) {
      var id = requestAnimationFrame(fn);
      return function() {
        cancelAnimationFrame(id);
      };
    } : function(fn) {
      var timer = $timeout(fn, 16.66, false);
      return function() {
        $timeout.cancel(timer);
      };
    };
    raf.supported = rafSupported;
    return raf;
  } ]);
  angular.module('mgcrea.ngStrap.helpers.parseOptions', []).provider('$parseOptions', function() {
    var defaults = this.defaults = {
      regexp: /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/
    };
    this.$get = [ '$parse', '$q', function($parse, $q) {
      function ParseOptionsFactory(attr, config) {
        var $parseOptions = {};
        var options = angular.extend({}, defaults, config);
        $parseOptions.$values = [];
        var match, displayFn, valueName, keyName, groupByFn, valueFn, valuesFn;
        $parseOptions.init = function() {
          $parseOptions.$match = match = attr.match(options.regexp);
          displayFn = $parse(match[2] || match[1]), valueName = match[4] || match[6], keyName = match[5], 
          groupByFn = $parse(match[3] || ''), valueFn = $parse(match[2] ? match[1] : valueName), 
          valuesFn = $parse(match[7]);
        };
        $parseOptions.valuesFn = function(scope, controller) {
          return $q.when(valuesFn(scope, controller)).then(function(values) {
            if (!angular.isArray(values)) {
              values = [];
            }
            $parseOptions.$values = values.length ? parseValues(values, scope) : [];
            return $parseOptions.$values;
          });
        };
        $parseOptions.displayValue = function(modelValue) {
          var scope = {};
          scope[valueName] = modelValue;
          return displayFn(scope);
        };
        function parseValues(values, scope) {
          return values.map(function(match, index) {
            var locals = {}, label, value;
            locals[valueName] = match;
            label = displayFn(scope, locals);
            value = valueFn(scope, locals);
            return {
              label: label,
              value: value,
              index: index
            };
          });
        }
        $parseOptions.init();
        return $parseOptions;
      }
      return ParseOptionsFactory;
    } ];
  });
  angular.module('mgcrea.ngStrap.helpers.dimensions', []).factory('dimensions', [ '$document', '$window', function($document, $window) {
    var jqLite = angular.element;
    var fn = {};
    var nodeName = fn.nodeName = function(element, name) {
      return element.nodeName && element.nodeName.toLowerCase() === name.toLowerCase();
    };
    fn.css = function(element, prop, extra) {
      var value;
      if (element.currentStyle) {
        value = element.currentStyle[prop];
      } else if (window.getComputedStyle) {
        value = window.getComputedStyle(element)[prop];
      } else {
        value = element.style[prop];
      }
      return extra === true ? parseFloat(value) || 0 : value;
    };
    fn.offset = function(element) {
      var boxRect = element.getBoundingClientRect();
      var docElement = element.ownerDocument;
      return {
        width: boxRect.width || element.offsetWidth,
        height: boxRect.height || element.offsetHeight,
        top: boxRect.top + (window.pageYOffset || docElement.documentElement.scrollTop) - (docElement.documentElement.clientTop || 0),
        left: boxRect.left + (window.pageXOffset || docElement.documentElement.scrollLeft) - (docElement.documentElement.clientLeft || 0)
      };
    };
    fn.setOffset = function(element, options, i) {
      var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = fn.css(element, 'position'), curElem = angular.element(element), props = {};
      if (position === 'static') {
        element.style.position = 'relative';
      }
      curOffset = fn.offset(element);
      curCSSTop = fn.css(element, 'top');
      curCSSLeft = fn.css(element, 'left');
      calculatePosition = (position === 'absolute' || position === 'fixed') && (curCSSTop + curCSSLeft).indexOf('auto') > -1;
      if (calculatePosition) {
        curPosition = fn.position(element);
        curTop = curPosition.top;
        curLeft = curPosition.left;
      } else {
        curTop = parseFloat(curCSSTop) || 0;
        curLeft = parseFloat(curCSSLeft) || 0;
      }
      if (angular.isFunction(options)) {
        options = options.call(element, i, curOffset);
      }
      if (options.top !== null) {
        props.top = options.top - curOffset.top + curTop;
      }
      if (options.left !== null) {
        props.left = options.left - curOffset.left + curLeft;
      }
      if ('using' in options) {
        options.using.call(curElem, props);
      } else {
        curElem.css({
          top: props.top + 'px',
          left: props.left + 'px'
        });
      }
    };
    fn.position = function(element) {
      var offsetParentRect = {
        top: 0,
        left: 0
      }, offsetParentElement, offset;
      if (fn.css(element, 'position') === 'fixed') {
        offset = element.getBoundingClientRect();
      } else {
        offsetParentElement = offsetParent(element);
        offset = fn.offset(element);
        if (!nodeName(offsetParentElement, 'html')) {
          offsetParentRect = fn.offset(offsetParentElement);
        }
        offsetParentRect.top += fn.css(offsetParentElement, 'borderTopWidth', true);
        offsetParentRect.left += fn.css(offsetParentElement, 'borderLeftWidth', true);
      }
      return {
        width: element.offsetWidth,
        height: element.offsetHeight,
        top: offset.top - offsetParentRect.top - fn.css(element, 'marginTop', true),
        left: offset.left - offsetParentRect.left - fn.css(element, 'marginLeft', true)
      };
    };
    var offsetParent = function offsetParentElement(element) {
      var docElement = element.ownerDocument;
      var offsetParent = element.offsetParent || docElement;
      if (nodeName(offsetParent, '#document')) return docElement.documentElement;
      while (offsetParent && !nodeName(offsetParent, 'html') && fn.css(offsetParent, 'position') === 'static') {
        offsetParent = offsetParent.offsetParent;
      }
      return offsetParent || docElement.documentElement;
    };
    fn.height = function(element, outer) {
      var value = element.offsetHeight;
      if (outer) {
        value += fn.css(element, 'marginTop', true) + fn.css(element, 'marginBottom', true);
      } else {
        value -= fn.css(element, 'paddingTop', true) + fn.css(element, 'paddingBottom', true) + fn.css(element, 'borderTopWidth', true) + fn.css(element, 'borderBottomWidth', true);
      }
      return value;
    };
    fn.width = function(element, outer) {
      var value = element.offsetWidth;
      if (outer) {
        value += fn.css(element, 'marginLeft', true) + fn.css(element, 'marginRight', true);
      } else {
        value -= fn.css(element, 'paddingLeft', true) + fn.css(element, 'paddingRight', true) + fn.css(element, 'borderLeftWidth', true) + fn.css(element, 'borderRightWidth', true);
      }
      return value;
    };
    return fn;
  } ]);
  angular.module('mgcrea.ngStrap.helpers.debounce', []).factory('debounce', [ '$timeout', function($timeout) {
    return function(func, wait, immediate) {
      var timeout = null;
      return function() {
        var context = this, args = arguments, callNow = immediate && !timeout;
        if (timeout) {
          $timeout.cancel(timeout);
        }
        timeout = $timeout(function later() {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        }, wait, false);
        if (callNow) {
          func.apply(context, args);
        }
        return timeout;
      };
    };
  } ]).factory('throttle', [ '$timeout', function($timeout) {
    return function(func, wait, options) {
      var timeout = null;
      options || (options = {});
      return function() {
        var context = this, args = arguments;
        if (!timeout) {
          if (options.leading !== false) {
            func.apply(context, args);
          }
          timeout = $timeout(function later() {
            timeout = null;
            if (options.trailing !== false) {
              func.apply(context, args);
            }
          }, wait, false);
        }
      };
    };
  } ]);
  angular.module('mgcrea.ngStrap.helpers.dateParser', []).provider('$dateParser', [ '$localeProvider', function($localeProvider) {
    function ParseDate() {
      this.year = 1970;
      this.month = 0;
      this.day = 1;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
      this.milliseconds = 0;
    }
    ParseDate.prototype.setMilliseconds = function(value) {
      this.milliseconds = value;
    };
    ParseDate.prototype.setSeconds = function(value) {
      this.seconds = value;
    };
    ParseDate.prototype.setMinutes = function(value) {
      this.minutes = value;
    };
    ParseDate.prototype.setHours = function(value) {
      this.hours = value;
    };
    ParseDate.prototype.getHours = function() {
      return this.hours;
    };
    ParseDate.prototype.setDate = function(value) {
      this.day = value;
    };
    ParseDate.prototype.setMonth = function(value) {
      this.month = value;
    };
    ParseDate.prototype.setFullYear = function(value) {
      this.year = value;
    };
    ParseDate.prototype.fromDate = function(value) {
      this.year = value.getFullYear();
      this.month = value.getMonth();
      this.day = value.getDate();
      this.hours = value.getHours();
      this.minutes = value.getMinutes();
      this.seconds = value.getSeconds();
      this.milliseconds = value.getMilliseconds();
      return this;
    };
    ParseDate.prototype.toDate = function() {
      return new Date(this.year, this.month, this.day, this.hours, this.minutes, this.seconds, this.milliseconds);
    };
    var proto = ParseDate.prototype;
    function noop() {}
    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
    function indexOfCaseInsensitive(array, value) {
      var len = array.length, str = value.toString().toLowerCase();
      for (var i = 0; i < len; i++) {
        if (array[i].toLowerCase() === str) {
          return i;
        }
      }
      return -1;
    }
    var defaults = this.defaults = {
      format: 'shortDate',
      strict: false
    };
    this.$get = [ '$locale', 'dateFilter', function($locale, dateFilter) {
      var DateParserFactory = function(config) {
        var options = angular.extend({}, defaults, config);
        var $dateParser = {};
        var regExpMap = {
          sss: '[0-9]{3}',
          ss: '[0-5][0-9]',
          s: options.strict ? '[1-5]?[0-9]' : '[0-9]|[0-5][0-9]',
          mm: '[0-5][0-9]',
          m: options.strict ? '[1-5]?[0-9]' : '[0-9]|[0-5][0-9]',
          HH: '[01][0-9]|2[0-3]',
          H: options.strict ? '1?[0-9]|2[0-3]' : '[01]?[0-9]|2[0-3]',
          hh: '[0][1-9]|[1][012]',
          h: options.strict ? '[1-9]|1[012]' : '0?[1-9]|1[012]',
          a: 'AM|PM',
          EEEE: $locale.DATETIME_FORMATS.DAY.join('|'),
          EEE: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
          dd: '0[1-9]|[12][0-9]|3[01]',
          d: options.strict ? '[1-9]|[1-2][0-9]|3[01]' : '0?[1-9]|[1-2][0-9]|3[01]',
          MMMM: $locale.DATETIME_FORMATS.MONTH.join('|'),
          MMM: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
          MM: '0[1-9]|1[012]',
          M: options.strict ? '[1-9]|1[012]' : '0?[1-9]|1[012]',
          yyyy: '[1]{1}[0-9]{3}|[2]{1}[0-9]{3}',
          yy: '[0-9]{2}',
          y: options.strict ? '-?(0|[1-9][0-9]{0,3})' : '-?0*[0-9]{1,4}'
        };
        var setFnMap = {
          sss: proto.setMilliseconds,
          ss: proto.setSeconds,
          s: proto.setSeconds,
          mm: proto.setMinutes,
          m: proto.setMinutes,
          HH: proto.setHours,
          H: proto.setHours,
          hh: proto.setHours,
          h: proto.setHours,
          EEEE: noop,
          EEE: noop,
          dd: proto.setDate,
          d: proto.setDate,
          a: function(value) {
            var hours = this.getHours() % 12;
            return this.setHours(value.match(/pm/i) ? hours + 12 : hours);
          },
          MMMM: function(value) {
            return this.setMonth(indexOfCaseInsensitive($locale.DATETIME_FORMATS.MONTH, value));
          },
          MMM: function(value) {
            return this.setMonth(indexOfCaseInsensitive($locale.DATETIME_FORMATS.SHORTMONTH, value));
          },
          MM: function(value) {
            return this.setMonth(1 * value - 1);
          },
          M: function(value) {
            return this.setMonth(1 * value - 1);
          },
          yyyy: proto.setFullYear,
          yy: function(value) {
            return this.setFullYear(2e3 + 1 * value);
          },
          y: function(value) {
            return 1 * value <= 50 && value.length === 2 ? this.setFullYear(2e3 + 1 * value) : this.setFullYear(1 * value);
          }
        };
        var regex, setMap;
        $dateParser.init = function() {
          $dateParser.$format = $locale.DATETIME_FORMATS[options.format] || options.format;
          regex = regExpForFormat($dateParser.$format);
          setMap = setMapForFormat($dateParser.$format);
        };
        $dateParser.isValid = function(date) {
          if (angular.isDate(date)) return !isNaN(date.getTime());
          return regex.test(date);
        };
        $dateParser.parse = function(value, baseDate, format, timezone) {
          if (format) format = $locale.DATETIME_FORMATS[format] || format;
          if (angular.isDate(value)) value = dateFilter(value, format || $dateParser.$format, timezone);
          var formatRegex = format ? regExpForFormat(format) : regex;
          var formatSetMap = format ? setMapForFormat(format) : setMap;
          var matches = formatRegex.exec(value);
          if (!matches) return false;
          var date = baseDate && !isNaN(baseDate.getTime()) ? new ParseDate().fromDate(baseDate) : new ParseDate().fromDate(new Date(1970, 0, 1, 0));
          for (var i = 0; i < matches.length - 1; i++) {
            formatSetMap[i] && formatSetMap[i].call(date, matches[i + 1]);
          }
          var newDate = date.toDate();
          if (parseInt(date.day, 10) !== newDate.getDate()) {
            return false;
          }
          return newDate;
        };
        $dateParser.getDateForAttribute = function(key, value) {
          var date;
          if (value === 'today') {
            var today = new Date();
            date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (key === 'maxDate' ? 1 : 0), 0, 0, 0, key === 'minDate' ? 0 : -1);
          } else if (angular.isString(value) && value.match(/^".+"$/)) {
            date = new Date(value.substr(1, value.length - 2));
          } else if (isNumeric(value)) {
            date = new Date(parseInt(value, 10));
          } else if (angular.isString(value) && 0 === value.length) {
            date = key === 'minDate' ? -Infinity : +Infinity;
          } else {
            date = new Date(value);
          }
          return date;
        };
        $dateParser.getTimeForAttribute = function(key, value) {
          var time;
          if (value === 'now') {
            time = new Date().setFullYear(1970, 0, 1);
          } else if (angular.isString(value) && value.match(/^".+"$/)) {
            time = new Date(value.substr(1, value.length - 2)).setFullYear(1970, 0, 1);
          } else if (isNumeric(value)) {
            time = new Date(parseInt(value, 10)).setFullYear(1970, 0, 1);
          } else if (angular.isString(value) && 0 === value.length) {
            time = key === 'minTime' ? -Infinity : +Infinity;
          } else {
            time = $dateParser.parse(value, new Date(1970, 0, 1, 0));
          }
          return time;
        };
        $dateParser.daylightSavingAdjust = function(date) {
          if (!date) {
            return null;
          }
          date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
          return date;
        };
        $dateParser.timezoneOffsetAdjust = function(date, timezone, undo) {
          if (!date) {
            return null;
          }
          if (timezone && timezone === 'UTC') {
            date = new Date(date.getTime());
            date.setMinutes(date.getMinutes() + (undo ? -1 : 1) * date.getTimezoneOffset());
          }
          return date;
        };
        function regExpForFormat(format) {
          var re = buildDateAbstractRegex(format);
          return buildDateParseRegex(re);
        }
        function buildDateAbstractRegex(format) {
          var escapedFormat = escapeReservedSymbols(format);
          var escapedLiteralFormat = escapedFormat.replace(/''/g, '\\\'');
          var literalRegex = /('(?:\\'|.)*?')/;
          var formatParts = escapedLiteralFormat.split(literalRegex);
          var dateElements = Object.keys(regExpMap);
          var dateRegexParts = [];
          angular.forEach(formatParts, function(part) {
            if (isFormatStringLiteral(part)) {
              part = trimLiteralEscapeChars(part);
            } else {
              for (var i = 0; i < dateElements.length; i++) {
                part = part.split(dateElements[i]).join('${' + i + '}');
              }
            }
            dateRegexParts.push(part);
          });
          return dateRegexParts.join('');
        }
        function escapeReservedSymbols(text) {
          return text.replace(/\\/g, '[\\\\]').replace(/-/g, '[-]').replace(/\./g, '[.]').replace(/\*/g, '[*]').replace(/\+/g, '[+]').replace(/\?/g, '[?]').replace(/\$/g, '[$]').replace(/\^/g, '[^]').replace(/\//g, '[/]').replace(/\\s/g, '[\\s]');
        }
        function isFormatStringLiteral(text) {
          return /^'.*'$/.test(text);
        }
        function trimLiteralEscapeChars(text) {
          return text.replace(/^'(.*)'$/, '$1');
        }
        function buildDateParseRegex(abstractRegex) {
          var dateElements = Object.keys(regExpMap);
          var re = abstractRegex;
          for (var i = 0; i < dateElements.length; i++) {
            re = re.split('${' + i + '}').join('(' + regExpMap[dateElements[i]] + ')');
          }
          return new RegExp('^' + re + '$', [ 'i' ]);
        }
        function setMapForFormat(format) {
          var re = buildDateAbstractRegex(format);
          return buildDateParseValuesMap(re);
        }
        function buildDateParseValuesMap(abstractRegex) {
          var dateElements = Object.keys(regExpMap);
          var valuesRegex = new RegExp('\\${(\\d+)}', 'g');
          var valuesMatch, keyIndex, valueKey, valueFunction;
          var valuesFunctionMap = [];
          while ((valuesMatch = valuesRegex.exec(abstractRegex)) !== null) {
            keyIndex = valuesMatch[1];
            valueKey = dateElements[keyIndex];
            valueFunction = setFnMap[valueKey];
            valuesFunctionMap.push(valueFunction);
          }
          return valuesFunctionMap;
        }
        $dateParser.init();
        return $dateParser;
      };
      return DateParserFactory;
    } ];
  } ]);
  angular.module('mgcrea.ngStrap.helpers.dateFormatter', []).service('$dateFormatter', [ '$locale', 'dateFilter', function($locale, dateFilter) {
    this.getDefaultLocale = function() {
      return $locale.id;
    };
    this.getDatetimeFormat = function(format, lang) {
      return $locale.DATETIME_FORMATS[format] || format;
    };
    this.weekdaysShort = function(lang) {
      return $locale.DATETIME_FORMATS.SHORTDAY;
    };
    function splitTimeFormat(format) {
      return /(h+)([:\.])?(m+)([:\.])?(s*)[ ]?(a?)/i.exec(format).slice(1);
    }
    this.hoursFormat = function(timeFormat) {
      return splitTimeFormat(timeFormat)[0];
    };
    this.minutesFormat = function(timeFormat) {
      return splitTimeFormat(timeFormat)[2];
    };
    this.secondsFormat = function(timeFormat) {
      return splitTimeFormat(timeFormat)[4];
    };
    this.timeSeparator = function(timeFormat) {
      return splitTimeFormat(timeFormat)[1];
    };
    this.showSeconds = function(timeFormat) {
      return !!splitTimeFormat(timeFormat)[4];
    };
    this.showAM = function(timeFormat) {
      return !!splitTimeFormat(timeFormat)[5];
    };
    this.formatDate = function(date, format, lang, timezone) {
      return dateFilter(date, format, timezone);
    };
  } ]);
  angular.module('mgcrea.ngStrap.core', []).service('$bsCompiler', bsCompilerService);
  function bsCompilerService($q, $http, $injector, $compile, $controller, $templateCache) {
    this.compile = function(options) {
      if (options.template && /\.html$/.test(options.template)) {
        console.warn('Deprecated use of `template` option to pass a file. Please use the `templateUrl` option instead.');
        options.templateUrl = options.template;
        options.template = '';
      }
      var templateUrl = options.templateUrl;
      var template = options.template || '';
      var controller = options.controller;
      var controllerAs = options.controllerAs;
      var resolve = angular.copy(options.resolve || {});
      var locals = angular.copy(options.locals || {});
      var transformTemplate = options.transformTemplate || angular.identity;
      var bindToController = options.bindToController;
      angular.forEach(resolve, function(value, key) {
        if (angular.isString(value)) {
          resolve[key] = $injector.get(value);
        } else {
          resolve[key] = $injector.invoke(value);
        }
      });
      angular.extend(resolve, locals);
      if (template) {
        resolve.$template = $q.when(template);
      } else if (templateUrl) {
        resolve.$template = fetchTemplate(templateUrl);
      } else {
        throw new Error('Missing `template` / `templateUrl` option.');
      }
      if (options.contentTemplate) {
        resolve.$template = $q.all([ resolve.$template, fetchTemplate(options.contentTemplate) ]).then(function(templates) {
          var templateEl = angular.element(templates[0]);
          var contentEl = findElement('[ng-bind="content"]', templateEl[0]).removeAttr('ng-bind').html(templates[1]);
          if (!options.templateUrl) contentEl.next().remove();
          return templateEl[0].outerHTML;
        });
      }
      return $q.all(resolve).then(function(locals) {
        var template = transformTemplate(locals.$template);
        if (options.html) {
          template = template.replace(/ng-bind="/gi, 'ng-bind-html="');
        }
        var element = angular.element('<div>').html(template.trim()).contents();
        var linkFn = $compile(element);
        return {
          locals: locals,
          element: element,
          link: function link(scope) {
            locals.$scope = scope;
            if (controller) {
              var invokeCtrl = $controller(controller, locals, true);
              if (bindToController) {
                angular.extend(invokeCtrl.instance, locals);
              }
              var ctrl = angular.isObject(invokeCtrl) ? invokeCtrl : invokeCtrl();
              element.data('$ngControllerController', ctrl);
              element.children().data('$ngControllerController', ctrl);
              if (controllerAs) {
                scope[controllerAs] = ctrl;
              }
            }
            return linkFn.apply(null, arguments);
          }
        };
      });
    };
    function findElement(query, element) {
      return angular.element((element || document).querySelectorAll(query));
    }
    var fetchPromises = {};
    function fetchTemplate(template) {
      if (fetchPromises[template]) return fetchPromises[template];
      return fetchPromises[template] = $http.get(template, {
        cache: $templateCache
      }).then(function(res) {
        return res.data;
      });
    }
  }
  bsCompilerService.$inject = [ '$q', '$http', '$injector', '$compile', '$controller', '$templateCache' ];
  angular.module('mgcrea.ngStrap.navbar', []).provider('$navbar', function() {
    var defaults = this.defaults = {
      activeClass: 'active',
      routeAttr: 'data-match-route',
      strict: false
    };
    this.$get = function() {
      return {
        defaults: defaults
      };
    };
  }).directive('bsNavbar', [ '$window', '$location', '$navbar', function($window, $location, $navbar) {
    var defaults = $navbar.defaults;
    return {
      restrict: 'A',
      link: function postLink(scope, element, attr, controller) {
        var options = angular.copy(defaults);
        angular.forEach(Object.keys(defaults), function(key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });
        scope.$watch(function() {
          return $location.path();
        }, function(newValue, oldValue) {
          var liElements = element[0].querySelectorAll('li[' + options.routeAttr + ']');
          angular.forEach(liElements, function(li) {
            var liElement = angular.element(li);
            var pattern = liElement.attr(options.routeAttr).replace('/', '\\/');
            if (options.strict) {
              pattern = '^' + pattern + '$';
            }
            var regexp = new RegExp(pattern, 'i');
            if (regexp.test(newValue)) {
              liElement.addClass(options.activeClass);
            } else {
              liElement.removeClass(options.activeClass);
            }
          });
        });
      }
    };
  } ]);
  angular.module('mgcrea.ngStrap.modal', [ 'mgcrea.ngStrap.core', 'mgcrea.ngStrap.helpers.dimensions' ]).provider('$modal', function() {
    var defaults = this.defaults = {
      animation: 'am-fade',
      backdropAnimation: 'am-fade',
      prefixClass: 'modal',
      prefixEvent: 'modal',
      placement: 'top',
      templateUrl: 'modal/modal.tpl.html',
      template: '',
      contentTemplate: false,
      container: false,
      element: null,
      backdrop: true,
      keyboard: true,
      html: false,
      show: true
    };
    this.$get = [ '$window', '$rootScope', '$bsCompiler', '$animate', '$timeout', '$sce', 'dimensions', function($window, $rootScope, $bsCompiler, $animate, $timeout, $sce, dimensions) {
      var forEach = angular.forEach;
      var trim = String.prototype.trim;
      var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;
      var bodyElement = angular.element($window.document.body);
      var backdropCount = 0;
      var dialogBaseZindex = 1050;
      var backdropBaseZindex = 1040;
      function ModalFactory(config) {
        var $modal = {};
        var options = $modal.$options = angular.extend({}, defaults, config);
        var promise = $modal.$promise = $bsCompiler.compile(options);
        var scope = $modal.$scope = options.scope && options.scope.$new() || $rootScope.$new();
        if (!options.element && !options.container) {
          options.container = 'body';
        }
        $modal.$id = options.id || options.element && options.element.attr('id') || '';
        forEach([ 'title', 'content' ], function(key) {
          if (options[key]) scope[key] = $sce.trustAsHtml(options[key]);
        });
        scope.$hide = function() {
          scope.$$postDigest(function() {
            $modal.hide();
          });
        };
        scope.$show = function() {
          scope.$$postDigest(function() {
            $modal.show();
          });
        };
        scope.$toggle = function() {
          scope.$$postDigest(function() {
            $modal.toggle();
          });
        };
        $modal.$isShown = scope.$isShown = false;
        var compileData, modalElement, modalScope;
        var backdropElement = angular.element('<div class="' + options.prefixClass + '-backdrop"/>');
        backdropElement.css({
          position: 'fixed',
          top: '0px',
          left: '0px',
          bottom: '0px',
          right: '0px'
        });
        promise.then(function(data) {
          compileData = data;
          $modal.init();
        });
        $modal.init = function() {
          if (options.show) {
            scope.$$postDigest(function() {
              $modal.show();
            });
          }
        };
        $modal.destroy = function() {
          destroyModalElement();
          if (backdropElement) {
            backdropElement.remove();
            backdropElement = null;
          }
          scope.$destroy();
        };
        $modal.show = function() {
          if ($modal.$isShown) return;
          var parent, after;
          if (angular.isElement(options.container)) {
            parent = options.container;
            after = options.container[0].lastChild ? angular.element(options.container[0].lastChild) : null;
          } else {
            if (options.container) {
              parent = findElement(options.container);
              after = parent[0] && parent[0].lastChild ? angular.element(parent[0].lastChild) : null;
            } else {
              parent = null;
              after = options.element;
            }
          }
          if (modalElement) destroyModalElement();
          modalScope = $modal.$scope.$new();
          modalElement = $modal.$element = compileData.link(modalScope, function(clonedElement, scope) {});
          if (options.backdrop) {
            modalElement.css({
              'z-index': dialogBaseZindex + backdropCount * 20
            });
            backdropElement.css({
              'z-index': backdropBaseZindex + backdropCount * 20
            });
            backdropCount++;
          }
          if (scope.$emit(options.prefixEvent + '.show.before', $modal).defaultPrevented) {
            return;
          }
          modalElement.css({
            display: 'block'
          }).addClass(options.placement);
          if (options.animation) {
            if (options.backdrop) {
              backdropElement.addClass(options.backdropAnimation);
            }
            modalElement.addClass(options.animation);
          }
          if (options.backdrop) {
            $animate.enter(backdropElement, bodyElement, null);
          }
          if (angular.version.minor <= 2) {
            $animate.enter(modalElement, parent, after, enterAnimateCallback);
          } else {
            $animate.enter(modalElement, parent, after).then(enterAnimateCallback);
          }
          $modal.$isShown = scope.$isShown = true;
          safeDigest(scope);
          var el = modalElement[0];
          requestAnimationFrame(function() {
            el.focus();
          });
          bodyElement.addClass(options.prefixClass + '-open');
          if (options.animation) {
            bodyElement.addClass(options.prefixClass + '-with-' + options.animation);
          }
          bindBackdropEvents();
          bindKeyboardEvents();
        };
        function enterAnimateCallback() {
          scope.$emit(options.prefixEvent + '.show', $modal);
        }
        $modal.hide = function() {
          if (!$modal.$isShown) return;
          if (options.backdrop) {
            backdropCount--;
          }
          if (scope.$emit(options.prefixEvent + '.hide.before', $modal).defaultPrevented) {
            return;
          }
          if (angular.version.minor <= 2) {
            $animate.leave(modalElement, leaveAnimateCallback);
          } else {
            $animate.leave(modalElement).then(leaveAnimateCallback);
          }
          if (options.backdrop) {
            $animate.leave(backdropElement);
          }
          $modal.$isShown = scope.$isShown = false;
          safeDigest(scope);
          unbindBackdropEvents();
          unbindKeyboardEvents();
        };
        function leaveAnimateCallback() {
          scope.$emit(options.prefixEvent + '.hide', $modal);
          bodyElement.removeClass(options.prefixClass + '-open');
          if (options.animation) {
            bodyElement.removeClass(options.prefixClass + '-with-' + options.animation);
          }
        }
        $modal.toggle = function() {
          $modal.$isShown ? $modal.hide() : $modal.show();
        };
        $modal.focus = function() {
          modalElement[0].focus();
        };
        $modal.$onKeyUp = function(evt) {
          if (evt.which === 27 && $modal.$isShown) {
            $modal.hide();
            evt.stopPropagation();
          }
        };
        function bindBackdropEvents() {
          if (options.backdrop) {
            modalElement.on('click', hideOnBackdropClick);
            backdropElement.on('click', hideOnBackdropClick);
            backdropElement.on('wheel', preventEventDefault);
          }
        }
        function unbindBackdropEvents() {
          if (options.backdrop) {
            modalElement.off('click', hideOnBackdropClick);
            backdropElement.off('click', hideOnBackdropClick);
            backdropElement.off('wheel', preventEventDefault);
          }
        }
        function bindKeyboardEvents() {
          if (options.keyboard) {
            modalElement.on('keyup', $modal.$onKeyUp);
          }
        }
        function unbindKeyboardEvents() {
          if (options.keyboard) {
            modalElement.off('keyup', $modal.$onKeyUp);
          }
        }
        function hideOnBackdropClick(evt) {
          if (evt.target !== evt.currentTarget) return;
          options.backdrop === 'static' ? $modal.focus() : $modal.hide();
        }
        function preventEventDefault(evt) {
          evt.preventDefault();
        }
        function destroyModalElement() {
          if ($modal.$isShown && modalElement !== null) {
            unbindBackdropEvents();
            unbindKeyboardEvents();
          }
          if (modalScope) {
            modalScope.$destroy();
            modalScope = null;
          }
          if (modalElement) {
            modalElement.remove();
            modalElement = $modal.$element = null;
          }
        }
        return $modal;
      }
      function safeDigest(scope) {
        scope.$$phase || scope.$root && scope.$root.$$phase || scope.$digest();
      }
      function findElement(query, element) {
        return angular.element((element || document).querySelectorAll(query));
      }
      return ModalFactory;
    } ];
  }).directive('bsModal', [ '$window', '$sce', '$modal', function($window, $sce, $modal) {
    return {
      restrict: 'EAC',
      scope: true,
      link: function postLink(scope, element, attr, transclusion) {
        var options = {
          scope: scope,
          element: element,
          show: false
        };
        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'backdrop', 'keyboard', 'html', 'container', 'animation', 'backdropAnimation', 'id', 'prefixEvent', 'prefixClass' ], function(key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach([ 'backdrop', 'keyboard', 'html', 'container' ], function(key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
        });
        angular.forEach([ 'title', 'content' ], function(key) {
          attr[key] && attr.$observe(key, function(newValue, oldValue) {
            scope[key] = $sce.trustAsHtml(newValue);
          });
        });
        attr.bsModal && scope.$watch(attr.bsModal, function(newValue, oldValue) {
          if (angular.isObject(newValue)) {
            angular.extend(scope, newValue);
          } else {
            scope.content = newValue;
          }
        }, true);
        var modal = $modal(options);
        element.on(attr.trigger || 'click', modal.toggle);
        scope.$on('$destroy', function() {
          if (modal) modal.destroy();
          options = null;
          modal = null;
        });
      }
    };
  } ]);
  angular.module('mgcrea.ngStrap.dropdown', [ 'mgcrea.ngStrap.tooltip' ]).provider('$dropdown', function() {
    var defaults = this.defaults = {
      animation: 'am-fade',
      prefixClass: 'dropdown',
      prefixEvent: 'dropdown',
      placement: 'bottom-left',
      templateUrl: 'dropdown/dropdown.tpl.html',
      trigger: 'click',
      container: false,
      keyboard: true,
      html: false,
      delay: 0
    };
    this.$get = [ '$window', '$rootScope', '$bsTooltip', '$timeout', function($window, $rootScope, $bsTooltip, $timeout) {
      var bodyEl = angular.element($window.document.body);
      var matchesSelector = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector;
      function DropdownFactory(element, config) {
        var $dropdown = {};
        var options = angular.extend({}, defaults, config);
        var scope = $dropdown.$scope = options.scope && options.scope.$new() || $rootScope.$new();
        $dropdown = $bsTooltip(element, options);
        var parentEl = element.parent();
        $dropdown.$onKeyDown = function(evt) {
          if (!/(38|40)/.test(evt.keyCode)) return;
          evt.preventDefault();
          evt.stopPropagation();
          var items = angular.element($dropdown.$element[0].querySelectorAll('li:not(.divider) a'));
          if (!items.length) return;
          var index;
          angular.forEach(items, function(el, i) {
            if (matchesSelector && matchesSelector.call(el, ':focus')) index = i;
          });
          if (evt.keyCode === 38 && index > 0) index--; else if (evt.keyCode === 40 && index < items.length - 1) index++; else if (angular.isUndefined(index)) index = 0;
          items.eq(index)[0].focus();
        };
        var show = $dropdown.show;
        $dropdown.show = function() {
          show();
          $timeout(function() {
            options.keyboard && $dropdown.$element && $dropdown.$element.on('keydown', $dropdown.$onKeyDown);
            bodyEl.on('click', onBodyClick);
          }, 0, false);
          parentEl.hasClass('dropdown') && parentEl.addClass('open');
        };
        var hide = $dropdown.hide;
        $dropdown.hide = function() {
          if (!$dropdown.$isShown) return;
          options.keyboard && $dropdown.$element && $dropdown.$element.off('keydown', $dropdown.$onKeyDown);
          bodyEl.off('click', onBodyClick);
          parentEl.hasClass('dropdown') && parentEl.removeClass('open');
          hide();
        };
        var destroy = $dropdown.destroy;
        $dropdown.destroy = function() {
          bodyEl.off('click', onBodyClick);
          destroy();
        };
        function onBodyClick(evt) {
          if (evt.target === element[0]) return;
          return evt.target !== element[0] && $dropdown.hide();
        }
        return $dropdown;
      }
      return DropdownFactory;
    } ];
  }).directive('bsDropdown', [ '$window', '$sce', '$dropdown', function($window, $sce, $dropdown) {
    return {
      restrict: 'EAC',
      scope: true,
      compile: function(tElement, tAttrs) {
        if (!tAttrs.bsDropdown) {
          var nextSibling = tElement[0].nextSibling;
          while (nextSibling && nextSibling.nodeType !== 1) {
            nextSibling = nextSibling.nextSibling;
          }
          if (nextSibling.classList.contains('dropdown-menu')) {
            tAttrs.template = nextSibling.outerHTML;
            tAttrs.templateUrl = undefined;
            nextSibling.parentNode.removeChild(nextSibling);
          }
        }
        return function postLink(scope, element, attr) {
          var options = {
            scope: scope
          };
          angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'id', 'autoClose' ], function(key) {
            if (angular.isDefined(tAttrs[key])) options[key] = tAttrs[key];
          });
          var falseValueRegExp = /^(false|0|)$/i;
          angular.forEach([ 'html', 'container' ], function(key) {
            if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
          });
          attr.bsDropdown && scope.$watch(attr.bsDropdown, function(newValue, oldValue) {
            scope.content = newValue;
          }, true);
          attr.bsShow && scope.$watch(attr.bsShow, function(newValue, oldValue) {
            if (!dropdown || !angular.isDefined(newValue)) return;
            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(dropdown),?/i);
            newValue === true ? dropdown.show() : dropdown.hide();
          });
          var dropdown = $dropdown(element, options);
          scope.$on('$destroy', function() {
            if (dropdown) dropdown.destroy();
            options = null;
            dropdown = null;
          });
        };
      }
    };
  } ]);
  angular.module('mgcrea.ngStrap.aside', [ 'mgcrea.ngStrap.modal' ]).provider('$aside', function() {
    var defaults = this.defaults = {
      animation: 'am-fade-and-slide-right',
      prefixClass: 'aside',
      prefixEvent: 'aside',
      placement: 'right',
      templateUrl: 'aside/aside.tpl.html',
      contentTemplate: false,
      container: false,
      element: null,
      backdrop: true,
      keyboard: true,
      html: false,
      show: true
    };
    this.$get = [ '$modal', function($modal) {
      function AsideFactory(config) {
        var $aside = {};
        var options = angular.extend({}, defaults, config);
        $aside = $modal(options);
        return $aside;
      }
      return AsideFactory;
    } ];
  }).directive('bsAside', [ '$window', '$sce', '$aside', function($window, $sce, $aside) {
    var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;
    return {
      restrict: 'EAC',
      scope: true,
      link: function postLink(scope, element, attr, transclusion) {
        var options = {
          scope: scope,
          element: element,
          show: false
        };
        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'backdrop', 'keyboard', 'html', 'container', 'animation' ], function(key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach([ 'backdrop', 'keyboard', 'html', 'container' ], function(key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
        });
        angular.forEach([ 'title', 'content' ], function(key) {
          attr[key] && attr.$observe(key, function(newValue, oldValue) {
            scope[key] = $sce.trustAsHtml(newValue);
          });
        });
        attr.bsAside && scope.$watch(attr.bsAside, function(newValue, oldValue) {
          if (angular.isObject(newValue)) {
            angular.extend(scope, newValue);
          } else {
            scope.content = newValue;
          }
        }, true);
        var aside = $aside(options);
        element.on(attr.trigger || 'click', aside.toggle);
        scope.$on('$destroy', function() {
          if (aside) aside.destroy();
          options = null;
          aside = null;
        });
      }
    };
  } ]);
  angular.module('mgcrea.ngStrap.datepicker', [ 'mgcrea.ngStrap.helpers.dateParser', 'mgcrea.ngStrap.helpers.dateFormatter', 'mgcrea.ngStrap.tooltip' ]).provider('$datepicker', function() {
    var defaults = this.defaults = {
      animation: 'am-fade',
      prefixClass: 'datepicker',
      placement: 'bottom-left',
      templateUrl: 'datepicker/datepicker.tpl.html',
      trigger: 'focus',
      container: false,
      keyboard: true,
      html: false,
      delay: 0,
      useNative: false,
      dateType: 'date',
      dateFormat: 'shortDate',
      timezone: null,
      modelDateFormat: null,
      dayFormat: 'dd',
      monthFormat: 'MMM',
      yearFormat: 'yyyy',
      monthTitleFormat: 'MMMM yyyy',
      yearTitleFormat: 'yyyy',
      strictFormat: false,
      autoclose: false,
      minDate: -Infinity,
      maxDate: +Infinity,
      startView: 0,
      minView: 0,
      startWeek: 0,
      daysOfWeekDisabled: '',
      iconLeft: 'glyphicon glyphicon-chevron-left',
      iconRight: 'glyphicon glyphicon-chevron-right'
    };
    this.$get = [ '$window', '$document', '$rootScope', '$sce', '$dateFormatter', 'datepickerViews', '$bsTooltip', '$timeout', function($window, $document, $rootScope, $sce, $dateFormatter, datepickerViews, $bsTooltip, $timeout) {
      var isNative = /(ip(a|o)d|iphone|android)/gi.test($window.navigator.userAgent);
      var isTouch = 'createTouch' in $window.document && isNative;
      if (!defaults.lang) defaults.lang = $dateFormatter.getDefaultLocale();
      function DatepickerFactory(element, controller, config) {
        var $datepicker = $bsTooltip(element, angular.extend({}, defaults, config));
        var parentScope = config.scope;
        var options = $datepicker.$options;
        var scope = $datepicker.$scope;
        if (options.startView) options.startView -= options.minView;
        var pickerViews = datepickerViews($datepicker);
        $datepicker.$views = pickerViews.views;
        var viewDate = pickerViews.viewDate;
        scope.$mode = options.startView;
        scope.$iconLeft = options.iconLeft;
        scope.$iconRight = options.iconRight;
        var $picker = $datepicker.$views[scope.$mode];
        scope.$select = function(date) {
          $datepicker.select(date);
        };
        scope.$selectPane = function(value) {
          $datepicker.$selectPane(value);
        };
        scope.$toggleMode = function() {
          $datepicker.setMode((scope.$mode + 1) % $datepicker.$views.length);
        };
        $datepicker.update = function(date) {
          if (angular.isDate(date) && !isNaN(date.getTime())) {
            $datepicker.$date = date;
            $picker.update.call($picker, date);
          }
          $datepicker.$build(true);
        };
        $datepicker.updateDisabledDates = function(dateRanges) {
          options.disabledDateRanges = dateRanges;
          for (var i = 0, l = scope.rows.length; i < l; i++) {
            angular.forEach(scope.rows[i], $datepicker.$setDisabledEl);
          }
        };
        $datepicker.select = function(date, keep) {
          if (!angular.isDate(controller.$dateValue)) controller.$dateValue = new Date(date);
          if (!scope.$mode || keep) {
            controller.$setViewValue(angular.copy(date));
            controller.$render();
            if (options.autoclose && !keep) {
              $timeout(function() {
                $datepicker.hide(true);
              });
            }
          } else {
            angular.extend(viewDate, {
              year: date.getFullYear(),
              month: date.getMonth(),
              date: date.getDate()
            });
            $datepicker.setMode(scope.$mode - 1);
            $datepicker.$build();
          }
        };
        $datepicker.setMode = function(mode) {
          scope.$mode = mode;
          $picker = $datepicker.$views[scope.$mode];
          $datepicker.$build();
        };
        $datepicker.$build = function(pristine) {
          if (pristine === true && $picker.built) return;
          if (pristine === false && !$picker.built) return;
          $picker.build.call($picker);
        };
        $datepicker.$updateSelected = function() {
          for (var i = 0, l = scope.rows.length; i < l; i++) {
            angular.forEach(scope.rows[i], updateSelected);
          }
        };
        $datepicker.$isSelected = function(date) {
          return $picker.isSelected(date);
        };
        $datepicker.$setDisabledEl = function(el) {
          el.disabled = $picker.isDisabled(el.date);
        };
        $datepicker.$selectPane = function(value) {
          var steps = $picker.steps;
          var targetDate = new Date(Date.UTC(viewDate.year + (steps.year || 0) * value, viewDate.month + (steps.month || 0) * value, 1));
          angular.extend(viewDate, {
            year: targetDate.getUTCFullYear(),
            month: targetDate.getUTCMonth(),
            date: targetDate.getUTCDate()
          });
          $datepicker.$build();
        };
        $datepicker.$onMouseDown = function(evt) {
          evt.preventDefault();
          evt.stopPropagation();
          if (isTouch) {
            var targetEl = angular.element(evt.target);
            if (targetEl[0].nodeName.toLowerCase() !== 'button') {
              targetEl = targetEl.parent();
            }
            targetEl.triggerHandler('click');
          }
        };
        $datepicker.$onKeyDown = function(evt) {
          if (!/(38|37|39|40|13)/.test(evt.keyCode) || evt.shiftKey || evt.altKey) return;
          evt.preventDefault();
          evt.stopPropagation();
          if (evt.keyCode === 13) {
            if (!scope.$mode) {
              $datepicker.hide(true);
            } else {
              scope.$apply(function() {
                $datepicker.setMode(scope.$mode - 1);
              });
            }
            return;
          }
          $picker.onKeyDown(evt);
          parentScope.$digest();
        };
        function updateSelected(el) {
          el.selected = $datepicker.$isSelected(el.date);
        }
        function focusElement() {
          element[0].focus();
        }
        var _init = $datepicker.init;
        $datepicker.init = function() {
          if (isNative && options.useNative) {
            element.prop('type', 'date');
            element.css('-webkit-appearance', 'textfield');
            return;
          } else if (isTouch) {
            element.prop('type', 'text');
            element.attr('readonly', 'true');
            element.on('click', focusElement);
          }
          _init();
        };
        var _destroy = $datepicker.destroy;
        $datepicker.destroy = function() {
          if (isNative && options.useNative) {
            element.off('click', focusElement);
          }
          _destroy();
        };
        var _show = $datepicker.show;
        $datepicker.show = function() {
          if (!isTouch && element.attr('readonly') || element.attr('disabled')) return;
          _show();
          $timeout(function() {
            if (!$datepicker.$isShown) return;
            $datepicker.$element.on(isTouch ? 'touchstart' : 'mousedown', $datepicker.$onMouseDown);
            if (options.keyboard) {
              element.on('keydown', $datepicker.$onKeyDown);
            }
          }, 0, false);
        };
        var _hide = $datepicker.hide;
        $datepicker.hide = function(blur) {
          if (!$datepicker.$isShown) return;
          $datepicker.$element.off(isTouch ? 'touchstart' : 'mousedown', $datepicker.$onMouseDown);
          if (options.keyboard) {
            element.off('keydown', $datepicker.$onKeyDown);
          }
          _hide(blur);
        };
        return $datepicker;
      }
      DatepickerFactory.defaults = defaults;
      return DatepickerFactory;
    } ];
  }).directive('bsDatepicker', [ '$window', '$parse', '$q', '$dateFormatter', '$dateParser', '$datepicker', function($window, $parse, $q, $dateFormatter, $dateParser, $datepicker) {
    var defaults = $datepicker.defaults;
    var isNative = /(ip(a|o)d|iphone|android)/gi.test($window.navigator.userAgent);
    return {
      restrict: 'EAC',
      require: 'ngModel',
      link: function postLink(scope, element, attr, controller) {
        var options = {
          scope: scope
        };
        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'autoclose', 'dateType', 'dateFormat', 'timezone', 'modelDateFormat', 'dayFormat', 'strictFormat', 'startWeek', 'startDate', 'useNative', 'lang', 'startView', 'minView', 'iconLeft', 'iconRight', 'daysOfWeekDisabled', 'id', 'prefixClass', 'prefixEvent' ], function(key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach([ 'html', 'container', 'autoclose', 'useNative' ], function(key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
            options[key] = false;
          }
        });
        var datepicker = $datepicker(element, controller, options);
        options = datepicker.$options;
        if (isNative && options.useNative) options.dateFormat = 'yyyy-MM-dd';
        var lang = options.lang;
        var formatDate = function(date, format) {
          return $dateFormatter.formatDate(date, format, lang);
        };
        var dateParser = $dateParser({
          format: options.dateFormat,
          lang: lang,
          strict: options.strictFormat
        });
        attr.bsShow && scope.$watch(attr.bsShow, function(newValue, oldValue) {
          if (!datepicker || !angular.isDefined(newValue)) return;
          if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(datepicker),?/i);
          newValue === true ? datepicker.show() : datepicker.hide();
        });
        angular.forEach([ 'minDate', 'maxDate' ], function(key) {
          angular.isDefined(attr[key]) && attr.$observe(key, function(newValue) {
            datepicker.$options[key] = dateParser.getDateForAttribute(key, newValue);
            !isNaN(datepicker.$options[key]) && datepicker.$build(false);
            validateAgainstMinMaxDate(controller.$dateValue);
          });
        });
        angular.isDefined(attr.dateFormat) && attr.$observe('dateFormat', function(newValue) {
          datepicker.$options.dateFormat = newValue;
        });
        scope.$watch(attr.ngModel, function(newValue, oldValue) {
          datepicker.update(controller.$dateValue);
        }, true);
        function normalizeDateRanges(ranges) {
          if (!ranges || !ranges.length) return null;
          return ranges;
        }
        if (angular.isDefined(attr.disabledDates)) {
          scope.$watch(attr.disabledDates, function(disabledRanges, previousValue) {
            disabledRanges = normalizeDateRanges(disabledRanges);
            previousValue = normalizeDateRanges(previousValue);
            if (disabledRanges) {
              datepicker.updateDisabledDates(disabledRanges);
            }
          });
        }
        function validateAgainstMinMaxDate(parsedDate) {
          if (!angular.isDate(parsedDate)) return;
          var isMinValid = isNaN(datepicker.$options.minDate) || parsedDate.getTime() >= datepicker.$options.minDate;
          var isMaxValid = isNaN(datepicker.$options.maxDate) || parsedDate.getTime() <= datepicker.$options.maxDate;
          var isValid = isMinValid && isMaxValid;
          controller.$setValidity('date', isValid);
          controller.$setValidity('min', isMinValid);
          controller.$setValidity('max', isMaxValid);
          if (isValid) controller.$dateValue = parsedDate;
        }
        controller.$parsers.unshift(function(viewValue) {
          var date;
          if (!viewValue) {
            controller.$setValidity('date', true);
            return null;
          }
          var parsedDate = dateParser.parse(viewValue, controller.$dateValue);
          if (!parsedDate || isNaN(parsedDate.getTime())) {
            controller.$setValidity('date', false);
            return;
          } else {
            validateAgainstMinMaxDate(parsedDate);
          }
          if (options.dateType === 'string') {
            date = dateParser.timezoneOffsetAdjust(parsedDate, options.timezone, true);
            return formatDate(date, options.modelDateFormat || options.dateFormat);
          }
          date = dateParser.timezoneOffsetAdjust(controller.$dateValue, options.timezone, true);
          if (options.dateType === 'number') {
            return date.getTime();
          } else if (options.dateType === 'unix') {
            return date.getTime() / 1e3;
          } else if (options.dateType === 'iso') {
            return date.toISOString();
          } else {
            return new Date(date);
          }
        });
        controller.$formatters.push(function(modelValue) {
          var date;
          if (angular.isUndefined(modelValue) || modelValue === null) {
            date = NaN;
          } else if (angular.isDate(modelValue)) {
            date = modelValue;
          } else if (options.dateType === 'string') {
            date = dateParser.parse(modelValue, null, options.modelDateFormat);
          } else if (options.dateType === 'unix') {
            date = new Date(modelValue * 1e3);
          } else {
            date = new Date(modelValue);
          }
          controller.$dateValue = dateParser.timezoneOffsetAdjust(date, options.timezone);
          return getDateFormattedString();
        });
        controller.$render = function() {
          element.val(getDateFormattedString());
        };
        function getDateFormattedString() {
          return !controller.$dateValue || isNaN(controller.$dateValue.getTime()) ? '' : formatDate(controller.$dateValue, options.dateFormat);
        }
        scope.$on('$destroy', function() {
          if (datepicker) datepicker.destroy();
          options = null;
          datepicker = null;
        });
      }
    };
  } ]).provider('datepickerViews', function() {
    var defaults = this.defaults = {
      dayFormat: 'dd',
      daySplit: 7
    };
    function split(arr, size) {
      var arrays = [];
      while (arr.length > 0) {
        arrays.push(arr.splice(0, size));
      }
      return arrays;
    }
    function mod(n, m) {
      return (n % m + m) % m;
    }
    this.$get = [ '$dateFormatter', '$dateParser', '$sce', function($dateFormatter, $dateParser, $sce) {
      return function(picker) {
        var scope = picker.$scope;
        var options = picker.$options;
        var lang = options.lang;
        var formatDate = function(date, format) {
          return $dateFormatter.formatDate(date, format, lang);
        };
        var dateParser = $dateParser({
          format: options.dateFormat,
          lang: lang,
          strict: options.strictFormat
        });
        var weekDaysMin = $dateFormatter.weekdaysShort(lang);
        var weekDaysLabels = weekDaysMin.slice(options.startWeek).concat(weekDaysMin.slice(0, options.startWeek));
        var weekDaysLabelsHtml = $sce.trustAsHtml('<th class="dow text-center">' + weekDaysLabels.join('</th><th class="dow text-center">') + '</th>');
        var startDate = picker.$date || (options.startDate ? dateParser.getDateForAttribute('startDate', options.startDate) : new Date());
        var viewDate = {
          year: startDate.getFullYear(),
          month: startDate.getMonth(),
          date: startDate.getDate()
        };
        var views = [ {
          format: options.dayFormat,
          split: 7,
          steps: {
            month: 1
          },
          update: function(date, force) {
            if (!this.built || force || date.getFullYear() !== viewDate.year || date.getMonth() !== viewDate.month) {
              angular.extend(viewDate, {
                year: picker.$date.getFullYear(),
                month: picker.$date.getMonth(),
                date: picker.$date.getDate()
              });
              picker.$build();
            } else if (date.getDate() !== viewDate.date || date.getDate() === 1) {
              viewDate.date = picker.$date.getDate();
              picker.$updateSelected();
            }
          },
          build: function() {
            var firstDayOfMonth = new Date(viewDate.year, viewDate.month, 1), firstDayOfMonthOffset = firstDayOfMonth.getTimezoneOffset();
            var firstDate = new Date(+firstDayOfMonth - mod(firstDayOfMonth.getDay() - options.startWeek, 7) * 864e5), firstDateOffset = firstDate.getTimezoneOffset();
            var today = dateParser.timezoneOffsetAdjust(new Date(), options.timezone).toDateString();
            if (firstDateOffset !== firstDayOfMonthOffset) firstDate = new Date(+firstDate + (firstDateOffset - firstDayOfMonthOffset) * 6e4);
            var days = [], day;
            for (var i = 0; i < 42; i++) {
              day = dateParser.daylightSavingAdjust(new Date(firstDate.getFullYear(), firstDate.getMonth(), firstDate.getDate() + i));
              days.push({
                date: day,
                isToday: day.toDateString() === today,
                label: formatDate(day, this.format),
                selected: picker.$date && this.isSelected(day),
                muted: day.getMonth() !== viewDate.month,
                disabled: this.isDisabled(day)
              });
            }
            scope.title = formatDate(firstDayOfMonth, options.monthTitleFormat);
            scope.showLabels = true;
            scope.labels = weekDaysLabelsHtml;
            scope.rows = split(days, this.split);
            this.built = true;
          },
          isSelected: function(date) {
            return picker.$date && date.getFullYear() === picker.$date.getFullYear() && date.getMonth() === picker.$date.getMonth() && date.getDate() === picker.$date.getDate();
          },
          isDisabled: function(date) {
            var time = date.getTime();
            if (time < options.minDate || time > options.maxDate) return true;
            if (options.daysOfWeekDisabled.indexOf(date.getDay()) !== -1) return true;
            if (options.disabledDateRanges) {
              for (var i = 0; i < options.disabledDateRanges.length; i++) {
                if (time >= options.disabledDateRanges[i].start && time <= options.disabledDateRanges[i].end) {
                  return true;
                }
              }
            }
            return false;
          },
          onKeyDown: function(evt) {
            if (!picker.$date) {
              return;
            }
            var actualTime = picker.$date.getTime();
            var newDate;
            if (evt.keyCode === 37) newDate = new Date(actualTime - 1 * 864e5); else if (evt.keyCode === 38) newDate = new Date(actualTime - 7 * 864e5); else if (evt.keyCode === 39) newDate = new Date(actualTime + 1 * 864e5); else if (evt.keyCode === 40) newDate = new Date(actualTime + 7 * 864e5);
            if (!this.isDisabled(newDate)) picker.select(newDate, true);
          }
        }, {
          name: 'month',
          format: options.monthFormat,
          split: 4,
          steps: {
            year: 1
          },
          update: function(date, force) {
            if (!this.built || date.getFullYear() !== viewDate.year) {
              angular.extend(viewDate, {
                year: picker.$date.getFullYear(),
                month: picker.$date.getMonth(),
                date: picker.$date.getDate()
              });
              picker.$build();
            } else if (date.getMonth() !== viewDate.month) {
              angular.extend(viewDate, {
                month: picker.$date.getMonth(),
                date: picker.$date.getDate()
              });
              picker.$updateSelected();
            }
          },
          build: function() {
            var firstMonth = new Date(viewDate.year, 0, 1);
            var months = [], month;
            for (var i = 0; i < 12; i++) {
              month = new Date(viewDate.year, i, 1);
              months.push({
                date: month,
                label: formatDate(month, this.format),
                selected: picker.$isSelected(month),
                disabled: this.isDisabled(month)
              });
            }
            scope.title = formatDate(month, options.yearTitleFormat);
            scope.showLabels = false;
            scope.rows = split(months, this.split);
            this.built = true;
          },
          isSelected: function(date) {
            return picker.$date && date.getFullYear() === picker.$date.getFullYear() && date.getMonth() === picker.$date.getMonth();
          },
          isDisabled: function(date) {
            var lastDate = +new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return lastDate < options.minDate || date.getTime() > options.maxDate;
          },
          onKeyDown: function(evt) {
            if (!picker.$date) {
              return;
            }
            var actualMonth = picker.$date.getMonth();
            var newDate = new Date(picker.$date);
            if (evt.keyCode === 37) newDate.setMonth(actualMonth - 1); else if (evt.keyCode === 38) newDate.setMonth(actualMonth - 4); else if (evt.keyCode === 39) newDate.setMonth(actualMonth + 1); else if (evt.keyCode === 40) newDate.setMonth(actualMonth + 4);
            if (!this.isDisabled(newDate)) picker.select(newDate, true);
          }
        }, {
          name: 'year',
          format: options.yearFormat,
          split: 4,
          steps: {
            year: 12
          },
          update: function(date, force) {
            if (!this.built || force || parseInt(date.getFullYear() / 20, 10) !== parseInt(viewDate.year / 20, 10)) {
              angular.extend(viewDate, {
                year: picker.$date.getFullYear(),
                month: picker.$date.getMonth(),
                date: picker.$date.getDate()
              });
              picker.$build();
            } else if (date.getFullYear() !== viewDate.year) {
              angular.extend(viewDate, {
                year: picker.$date.getFullYear(),
                month: picker.$date.getMonth(),
                date: picker.$date.getDate()
              });
              picker.$updateSelected();
            }
          },
          build: function() {
            var firstYear = viewDate.year - viewDate.year % (this.split * 3);
            var years = [], year;
            for (var i = 0; i < 12; i++) {
              year = new Date(firstYear + i, 0, 1);
              years.push({
                date: year,
                label: formatDate(year, this.format),
                selected: picker.$isSelected(year),
                disabled: this.isDisabled(year)
              });
            }
            scope.title = years[0].label + '-' + years[years.length - 1].label;
            scope.showLabels = false;
            scope.rows = split(years, this.split);
            this.built = true;
          },
          isSelected: function(date) {
            return picker.$date && date.getFullYear() === picker.$date.getFullYear();
          },
          isDisabled: function(date) {
            var lastDate = +new Date(date.getFullYear() + 1, 0, 0);
            return lastDate < options.minDate || date.getTime() > options.maxDate;
          },
          onKeyDown: function(evt) {
            if (!picker.$date) {
              return;
            }
            var actualYear = picker.$date.getFullYear(), newDate = new Date(picker.$date);
            if (evt.keyCode === 37) newDate.setYear(actualYear - 1); else if (evt.keyCode === 38) newDate.setYear(actualYear - 4); else if (evt.keyCode === 39) newDate.setYear(actualYear + 1); else if (evt.keyCode === 40) newDate.setYear(actualYear + 4);
            if (!this.isDisabled(newDate)) picker.select(newDate, true);
          }
        } ];
        return {
          views: options.minView ? Array.prototype.slice.call(views, options.minView) : views,
          viewDate: viewDate
        };
      };
    } ];
  });
  angular.module('mgcrea.ngStrap.collapse', []).provider('$collapse', function() {
    var defaults = this.defaults = {
      animation: 'am-collapse',
      disallowToggle: false,
      activeClass: 'in',
      startCollapsed: false,
      allowMultiple: false
    };
    var controller = this.controller = function($scope, $element, $attrs) {
      var self = this;
      self.$options = angular.copy(defaults);
      angular.forEach([ 'animation', 'disallowToggle', 'activeClass', 'startCollapsed', 'allowMultiple' ], function(key) {
        if (angular.isDefined($attrs[key])) self.$options[key] = $attrs[key];
      });
      var falseValueRegExp = /^(false|0|)$/i;
      angular.forEach([ 'disallowToggle', 'startCollapsed', 'allowMultiple' ], function(key) {
        if (angular.isDefined($attrs[key]) && falseValueRegExp.test($attrs[key])) {
          self.$options[key] = false;
        }
      });
      self.$toggles = [];
      self.$targets = [];
      self.$viewChangeListeners = [];
      self.$registerToggle = function(element) {
        self.$toggles.push(element);
      };
      self.$registerTarget = function(element) {
        self.$targets.push(element);
      };
      self.$unregisterToggle = function(element) {
        var index = self.$toggles.indexOf(element);
        self.$toggles.splice(index, 1);
      };
      self.$unregisterTarget = function(element) {
        var index = self.$targets.indexOf(element);
        self.$targets.splice(index, 1);
        if (self.$options.allowMultiple) {
          deactivateItem(element);
        }
        fixActiveItemIndexes(index);
        self.$viewChangeListeners.forEach(function(fn) {
          fn();
        });
      };
      self.$targets.$active = !self.$options.startCollapsed ? [ 0 ] : [];
      self.$setActive = $scope.$setActive = function(value) {
        if (angular.isArray(value)) {
          self.$targets.$active = value;
        } else if (!self.$options.disallowToggle) {
          isActive(value) ? deactivateItem(value) : activateItem(value);
        } else {
          activateItem(value);
        }
        self.$viewChangeListeners.forEach(function(fn) {
          fn();
        });
      };
      self.$activeIndexes = function() {
        return self.$options.allowMultiple ? self.$targets.$active : self.$targets.$active.length === 1 ? self.$targets.$active[0] : -1;
      };
      function fixActiveItemIndexes(index) {
        var activeIndexes = self.$targets.$active;
        for (var i = 0; i < activeIndexes.length; i++) {
          if (index < activeIndexes[i]) {
            activeIndexes[i] = activeIndexes[i] - 1;
          }
          if (activeIndexes[i] === self.$targets.length) {
            activeIndexes[i] = self.$targets.length - 1;
          }
        }
      }
      function isActive(value) {
        var activeItems = self.$targets.$active;
        return activeItems.indexOf(value) === -1 ? false : true;
      }
      function deactivateItem(value) {
        var index = self.$targets.$active.indexOf(value);
        if (index !== -1) {
          self.$targets.$active.splice(index, 1);
        }
      }
      function activateItem(value) {
        if (!self.$options.allowMultiple) {
          self.$targets.$active.splice(0, 1);
        }
        if (self.$targets.$active.indexOf(value) === -1) {
          self.$targets.$active.push(value);
        }
      }
    };
    this.$get = function() {
      var $collapse = {};
      $collapse.defaults = defaults;
      $collapse.controller = controller;
      return $collapse;
    };
  }).directive('bsCollapse', [ '$window', '$animate', '$collapse', function($window, $animate, $collapse) {
    var defaults = $collapse.defaults;
    return {
      require: [ '?ngModel', 'bsCollapse' ],
      controller: [ '$scope', '$element', '$attrs', $collapse.controller ],
      link: function postLink(scope, element, attrs, controllers) {
        var ngModelCtrl = controllers[0];
        var bsCollapseCtrl = controllers[1];
        if (ngModelCtrl) {
          bsCollapseCtrl.$viewChangeListeners.push(function() {
            ngModelCtrl.$setViewValue(bsCollapseCtrl.$activeIndexes());
          });
          ngModelCtrl.$formatters.push(function(modelValue) {
            if (angular.isArray(modelValue)) {
              bsCollapseCtrl.$setActive(modelValue);
            } else {
              var activeIndexes = bsCollapseCtrl.$activeIndexes();
              if (angular.isArray(activeIndexes)) {
                if (activeIndexes.indexOf(modelValue * 1) === -1) {
                  bsCollapseCtrl.$setActive(modelValue * 1);
                }
              } else if (activeIndexes !== modelValue * 1) {
                bsCollapseCtrl.$setActive(modelValue * 1);
              }
            }
            return modelValue;
          });
        }
      }
    };
  } ]).directive('bsCollapseToggle', function() {
    return {
      require: [ '^?ngModel', '^bsCollapse' ],
      link: function postLink(scope, element, attrs, controllers) {
        var ngModelCtrl = controllers[0];
        var bsCollapseCtrl = controllers[1];
        element.attr('data-toggle', 'collapse');
        bsCollapseCtrl.$registerToggle(element);
        scope.$on('$destroy', function() {
          bsCollapseCtrl.$unregisterToggle(element);
        });
        element.on('click', function() {
          var index = attrs.bsCollapseToggle && attrs.bsCollapseToggle !== 'bs-collapse-toggle' ? attrs.bsCollapseToggle : bsCollapseCtrl.$toggles.indexOf(element);
          bsCollapseCtrl.$setActive(index * 1);
          scope.$apply();
        });
      }
    };
  }).directive('bsCollapseTarget', [ '$animate', function($animate) {
    return {
      require: [ '^?ngModel', '^bsCollapse' ],
      link: function postLink(scope, element, attrs, controllers) {
        var ngModelCtrl = controllers[0];
        var bsCollapseCtrl = controllers[1];
        element.addClass('collapse');
        if (bsCollapseCtrl.$options.animation) {
          element.addClass(bsCollapseCtrl.$options.animation);
        }
        bsCollapseCtrl.$registerTarget(element);
        scope.$on('$destroy', function() {
          bsCollapseCtrl.$unregisterTarget(element);
        });
        function render() {
          var index = bsCollapseCtrl.$targets.indexOf(element);
          var active = bsCollapseCtrl.$activeIndexes();
          var action = 'removeClass';
          if (angular.isArray(active)) {
            if (active.indexOf(index) !== -1) {
              action = 'addClass';
            }
          } else if (index === active) {
            action = 'addClass';
          }
          $animate[action](element, bsCollapseCtrl.$options.activeClass);
        }
        bsCollapseCtrl.$viewChangeListeners.push(function() {
          render();
        });
        render();
      }
    };
  } ]);
  angular.module('mgcrea.ngStrap.button', []).provider('$button', function() {
    var defaults = this.defaults = {
      activeClass: 'active',
      toggleEvent: 'click'
    };
    this.$get = function() {
      return {
        defaults: defaults
      };
    };
  }).directive('bsCheckboxGroup', function() {
    return {
      restrict: 'A',
      require: 'ngModel',
      compile: function postLink(element, attr) {
        element.attr('data-toggle', 'buttons');
        element.removeAttr('ng-model');
        var children = element[0].querySelectorAll('input[type="checkbox"]');
        angular.forEach(children, function(child) {
          var childEl = angular.element(child);
          childEl.attr('bs-checkbox', '');
          childEl.attr('ng-model', attr.ngModel + '.' + childEl.attr('value'));
        });
      }
    };
  }).directive('bsCheckbox', [ '$button', '$$rAF', function($button, $$rAF) {
    var defaults = $button.defaults;
    var constantValueRegExp = /^(true|false|\d+)$/;
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function postLink(scope, element, attr, controller) {
        var options = defaults;
        var isInput = element[0].nodeName === 'INPUT';
        var activeElement = isInput ? element.parent() : element;
        var trueValue = angular.isDefined(attr.trueValue) ? attr.trueValue : true;
        if (constantValueRegExp.test(attr.trueValue)) {
          trueValue = scope.$eval(attr.trueValue);
        }
        var falseValue = angular.isDefined(attr.falseValue) ? attr.falseValue : false;
        if (constantValueRegExp.test(attr.falseValue)) {
          falseValue = scope.$eval(attr.falseValue);
        }
        var hasExoticValues = typeof trueValue !== 'boolean' || typeof falseValue !== 'boolean';
        if (hasExoticValues) {
          controller.$parsers.push(function(viewValue) {
            return viewValue ? trueValue : falseValue;
          });
          controller.$formatters.push(function(modelValue) {
            return angular.equals(modelValue, trueValue);
          });
          scope.$watch(attr.ngModel, function(newValue, oldValue) {
            controller.$render();
          });
        }
        controller.$render = function() {
          var isActive = angular.equals(controller.$modelValue, trueValue);
          $$rAF(function() {
            if (isInput) element[0].checked = isActive;
            activeElement.toggleClass(options.activeClass, isActive);
          });
        };
        element.bind(options.toggleEvent, function() {
          scope.$apply(function() {
            if (!isInput) {
              controller.$setViewValue(!activeElement.hasClass('active'));
            }
            if (!hasExoticValues) {
              controller.$render();
            }
          });
        });
      }
    };
  } ]).directive('bsRadioGroup', function() {
    return {
      restrict: 'A',
      require: 'ngModel',
      compile: function postLink(element, attr) {
        element.attr('data-toggle', 'buttons');
        element.removeAttr('ng-model');
        var children = element[0].querySelectorAll('input[type="radio"]');
        angular.forEach(children, function(child) {
          angular.element(child).attr('bs-radio', '');
          angular.element(child).attr('ng-model', attr.ngModel);
        });
      }
    };
  }).directive('bsRadio', [ '$button', '$$rAF', function($button, $$rAF) {
    var defaults = $button.defaults;
    var constantValueRegExp = /^(true|false|\d+)$/;
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function postLink(scope, element, attr, controller) {
        var options = defaults;
        var isInput = element[0].nodeName === 'INPUT';
        var activeElement = isInput ? element.parent() : element;
        var value;
        attr.$observe('value', function(v) {
          value = constantValueRegExp.test(v) ? scope.$eval(v) : v;
          controller.$render();
        });
        controller.$render = function() {
          var isActive = angular.equals(controller.$modelValue, value);
          $$rAF(function() {
            if (isInput) element[0].checked = isActive;
            activeElement.toggleClass(options.activeClass, isActive);
          });
        };
        element.bind(options.toggleEvent, function() {
          scope.$apply(function() {
            controller.$setViewValue(value);
            controller.$render();
          });
        });
      }
    };
  } ]);
  angular.module('mgcrea.ngStrap.alert', [ 'mgcrea.ngStrap.modal' ]).provider('$alert', function() {
    var defaults = this.defaults = {
      animation: 'am-fade',
      prefixClass: 'alert',
      prefixEvent: 'alert',
      placement: null,
      templateUrl: 'alert/alert.tpl.html',
      container: false,
      element: null,
      backdrop: false,
      keyboard: true,
      show: true,
      duration: false,
      type: false,
      dismissable: true
    };
    this.$get = [ '$modal', '$timeout', function($modal, $timeout) {
      function AlertFactory(config) {
        var $alert = {};
        var options = angular.extend({}, defaults, config);
        $alert = $modal(options);
        $alert.$scope.dismissable = !!options.dismissable;
        if (options.type) {
          $alert.$scope.type = options.type;
        }
        var show = $alert.show;
        if (options.duration) {
          $alert.show = function() {
            show();
            $timeout(function() {
              $alert.hide();
            }, options.duration * 1e3);
          };
        }
        return $alert;
      }
      return AlertFactory;
    } ];
  }).directive('bsAlert', [ '$window', '$sce', '$alert', function($window, $sce, $alert) {
    var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;
    return {
      restrict: 'EAC',
      scope: true,
      link: function postLink(scope, element, attr, transclusion) {
        var options = {
          scope: scope,
          element: element,
          show: false
        };
        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'keyboard', 'html', 'container', 'animation', 'duration', 'dismissable' ], function(key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach([ 'keyboard', 'html', 'container', 'dismissable' ], function(key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
        });
        if (!scope.hasOwnProperty('title')) {
          scope.title = '';
        }
        angular.forEach([ 'title', 'content', 'type' ], function(key) {
          attr[key] && attr.$observe(key, function(newValue, oldValue) {
            scope[key] = $sce.trustAsHtml(newValue);
          });
        });
        attr.bsAlert && scope.$watch(attr.bsAlert, function(newValue, oldValue) {
          if (angular.isObject(newValue)) {
            angular.extend(scope, newValue);
          } else {
            scope.content = newValue;
          }
        }, true);
        var alert = $alert(options);
        element.on(attr.trigger || 'click', alert.toggle);
        scope.$on('$destroy', function() {
          if (alert) alert.destroy();
          options = null;
          alert = null;
        });
      }
    };
  } ]);
  angular.module('mgcrea.ngStrap.affix', [ 'mgcrea.ngStrap.helpers.dimensions', 'mgcrea.ngStrap.helpers.debounce' ]).provider('$affix', function() {
    var defaults = this.defaults = {
      offsetTop: 'auto',
      inlineStyles: true
    };
    this.$get = [ '$window', 'debounce', 'dimensions', function($window, debounce, dimensions) {
      var bodyEl = angular.element($window.document.body);
      var windowEl = angular.element($window);
      function AffixFactory(element, config) {
        var $affix = {};
        var options = angular.extend({}, defaults, config);
        var targetEl = options.target;
        var reset = 'affix affix-top affix-bottom', setWidth = false, initialAffixTop = 0, initialOffsetTop = 0, offsetTop = 0, offsetBottom = 0, affixed = null, unpin = null;
        var parent = element.parent();
        if (options.offsetParent) {
          if (options.offsetParent.match(/^\d+$/)) {
            for (var i = 0; i < options.offsetParent * 1 - 1; i++) {
              parent = parent.parent();
            }
          } else {
            parent = angular.element(options.offsetParent);
          }
        }
        $affix.init = function() {
          this.$parseOffsets();
          initialOffsetTop = dimensions.offset(element[0]).top + initialAffixTop;
          setWidth = !element[0].style.width;
          targetEl.on('scroll', this.checkPosition);
          targetEl.on('click', this.checkPositionWithEventLoop);
          windowEl.on('resize', this.$debouncedOnResize);
          this.checkPosition();
          this.checkPositionWithEventLoop();
        };
        $affix.destroy = function() {
          targetEl.off('scroll', this.checkPosition);
          targetEl.off('click', this.checkPositionWithEventLoop);
          windowEl.off('resize', this.$debouncedOnResize);
        };
        $affix.checkPositionWithEventLoop = function() {
          setTimeout($affix.checkPosition, 1);
        };
        $affix.checkPosition = function() {
          var scrollTop = getScrollTop();
          var position = dimensions.offset(element[0]);
          var elementHeight = dimensions.height(element[0]);
          var affix = getRequiredAffixClass(unpin, position, elementHeight);
          if (affixed === affix) return;
          affixed = affix;
          if (affix === 'top') {
            unpin = null;
            if (setWidth) {
              element.css('width', '');
            }
            if (options.inlineStyles) {
              element.css('position', options.offsetParent ? '' : 'relative');
              element.css('top', '');
            }
          } else if (affix === 'bottom') {
            if (options.offsetUnpin) {
              unpin = -(options.offsetUnpin * 1);
            } else {
              unpin = position.top - scrollTop;
            }
            if (setWidth) {
              element.css('width', '');
            }
            if (options.inlineStyles) {
              element.css('position', options.offsetParent ? '' : 'relative');
              element.css('top', options.offsetParent ? '' : bodyEl[0].offsetHeight - offsetBottom - elementHeight - initialOffsetTop + 'px');
            }
          } else {
            unpin = null;
            if (setWidth) {
              element.css('width', element[0].offsetWidth + 'px');
            }
            if (options.inlineStyles) {
              element.css('position', 'fixed');
              element.css('top', initialAffixTop + 'px');
            }
          }
          element.removeClass(reset).addClass('affix' + (affix !== 'middle' ? '-' + affix : ''));
        };
        $affix.$onResize = function() {
          $affix.$parseOffsets();
          $affix.checkPosition();
        };
        $affix.$debouncedOnResize = debounce($affix.$onResize, 50);
        $affix.$parseOffsets = function() {
          var initialPosition = element.css('position');
          if (options.inlineStyles) {
            element.css('position', options.offsetParent ? '' : 'relative');
          }
          if (options.offsetTop) {
            if (options.offsetTop === 'auto') {
              options.offsetTop = '+0';
            }
            if (options.offsetTop.match(/^[-+]\d+$/)) {
              initialAffixTop = -options.offsetTop * 1;
              if (options.offsetParent) {
                offsetTop = dimensions.offset(parent[0]).top + options.offsetTop * 1;
              } else {
                offsetTop = dimensions.offset(element[0]).top - dimensions.css(element[0], 'marginTop', true) + options.offsetTop * 1;
              }
            } else {
              offsetTop = options.offsetTop * 1;
            }
          }
          if (options.offsetBottom) {
            if (options.offsetParent && options.offsetBottom.match(/^[-+]\d+$/)) {
              offsetBottom = getScrollHeight() - (dimensions.offset(parent[0]).top + dimensions.height(parent[0])) + options.offsetBottom * 1 + 1;
            } else {
              offsetBottom = options.offsetBottom * 1;
            }
          }
          if (options.inlineStyles) {
            element.css('position', initialPosition);
          }
        };
        function getRequiredAffixClass(unpin, position, elementHeight) {
          var scrollTop = getScrollTop();
          var scrollHeight = getScrollHeight();
          if (scrollTop <= offsetTop) {
            return 'top';
          } else if (unpin !== null && scrollTop + unpin <= position.top) {
            return 'middle';
          } else if (offsetBottom !== null && position.top + elementHeight + initialAffixTop >= scrollHeight - offsetBottom) {
            return 'bottom';
          } else {
            return 'middle';
          }
        }
        function getScrollTop() {
          return targetEl[0] === $window ? $window.pageYOffset : targetEl[0].scrollTop;
        }
        function getScrollHeight() {
          return targetEl[0] === $window ? $window.document.body.scrollHeight : targetEl[0].scrollHeight;
        }
        $affix.init();
        return $affix;
      }
      return AffixFactory;
    } ];
  }).directive('bsAffix', [ '$affix', '$window', function($affix, $window) {
    return {
      restrict: 'EAC',
      require: '^?bsAffixTarget',
      link: function postLink(scope, element, attr, affixTarget) {
        var options = {
          scope: scope,
          target: affixTarget ? affixTarget.$element : angular.element($window)
        };
        angular.forEach([ 'offsetTop', 'offsetBottom', 'offsetParent', 'offsetUnpin', 'inlineStyles' ], function(key) {
          if (angular.isDefined(attr[key])) {
            var option = attr[key];
            if (/true/i.test(option)) option = true;
            if (/false/i.test(option)) option = false;
            options[key] = option;
          }
        });
        var affix = $affix(element, options);
        scope.$on('$destroy', function() {
          affix && affix.destroy();
          options = null;
          affix = null;
        });
      }
    };
  } ]).directive('bsAffixTarget', function() {
    return {
      controller: [ '$element', function($element) {
        this.$element = $element;
      } ]
    };
  });
  angular.module('mgcrea.ngStrap', [ 'mgcrea.ngStrap.modal', 'mgcrea.ngStrap.aside', 'mgcrea.ngStrap.alert', 'mgcrea.ngStrap.button', 'mgcrea.ngStrap.select', 'mgcrea.ngStrap.datepicker', 'mgcrea.ngStrap.timepicker', 'mgcrea.ngStrap.navbar', 'mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.popover', 'mgcrea.ngStrap.dropdown', 'mgcrea.ngStrap.typeahead', 'mgcrea.ngStrap.scrollspy', 'mgcrea.ngStrap.affix', 'mgcrea.ngStrap.tab', 'mgcrea.ngStrap.collapse' ]);
})(window, document);
/**
 * angular-strap
 * @version v2.3.6 - 2015-11-14
 * @link http://mgcrea.github.io/angular-strap
 * @author Olivier Louvignes <olivier@mg-crea.com> (https://github.com/mgcrea)
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function(window, document, undefined) {
  'use strict';
  angular.module('mgcrea.ngStrap.alert').run([ '$templateCache', function($templateCache) {
    $templateCache.put('alert/alert.tpl.html', '<div class="alert" ng-class="[type ? \'alert-\' + type : null]"><button type="button" class="close" ng-if="dismissable" ng-click="$hide()">&times;</button> <strong ng-bind="title"></strong>&nbsp;<span ng-bind-html="content"></span></div>');
  } ]);
  angular.module('mgcrea.ngStrap.datepicker').run([ '$templateCache', function($templateCache) {
    $templateCache.put('datepicker/datepicker.tpl.html', '<div class="dropdown-menu datepicker" ng-class="\'datepicker-mode-\' + $mode" style="max-width: 320px"><table style="table-layout: fixed; height: 100%; width: 100%"><thead><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$selectPane(-1)"><i class="{{$iconLeft}}"></i></button></th><th colspan="{{ rows[0].length - 2 }}"><button tabindex="-1" type="button" class="btn btn-default btn-block text-strong" ng-click="$toggleMode()"><strong style="text-transform: capitalize" ng-bind="title"></strong></button></th><th><button tabindex="-1" type="button" class="btn btn-default pull-right" ng-click="$selectPane(+1)"><i class="{{$iconRight}}"></i></button></th></tr><tr ng-if="showLabels" ng-bind-html="labels"></tr></thead><tbody><tr ng-repeat="(i, row) in rows" height="{{ 100 / rows.length }}%"><td class="text-center" ng-repeat="(j, el) in row"><button tabindex="-1" type="button" class="btn btn-default" style="width: 100%" ng-class="{\'btn-primary\': el.selected, \'btn-info btn-today\': el.isToday && !el.selected}" ng-click="$select(el.date)" ng-disabled="el.disabled"><span ng-class="{\'text-muted\': el.muted}" ng-bind="el.label"></span></button></td></tr></tbody></table></div>');
  } ]);
  angular.module('mgcrea.ngStrap.aside').run([ '$templateCache', function($templateCache) {
    $templateCache.put('aside/aside.tpl.html', '<div class="aside" tabindex="-1" role="dialog"><div class="aside-dialog"><div class="aside-content"><div class="aside-header" ng-show="title"><button type="button" class="close" ng-click="$hide()">&times;</button><h4 class="aside-title" ng-bind="title"></h4></div><div class="aside-body" ng-bind="content"></div><div class="aside-footer"><button type="button" class="btn btn-default" ng-click="$hide()">Close</button></div></div></div></div>');
  } ]);
  angular.module('mgcrea.ngStrap.dropdown').run([ '$templateCache', function($templateCache) {
    $templateCache.put('dropdown/dropdown.tpl.html', '<ul tabindex="-1" class="dropdown-menu" role="menu" ng-show="content && content.length"><li role="presentation" ng-class="{divider: item.divider, active: item.active}" ng-repeat="item in content"><a role="menuitem" tabindex="-1" ng-href="{{item.href}}" ng-if="!item.divider && item.href" target="{{item.target || \'\'}}" ng-bind="item.text"></a> <a role="menuitem" tabindex="-1" href="javascript:void(0)" ng-if="!item.divider && item.click" ng-click="$eval(item.click);$hide()" ng-bind="item.text"></a></li></ul>');
  } ]);
  angular.module('mgcrea.ngStrap.modal').run([ '$templateCache', function($templateCache) {
    $templateCache.put('modal/modal.tpl.html', '<div class="modal" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header" ng-show="title"><button type="button" class="close" aria-label="Close" ng-click="$hide()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" ng-bind="title"></h4></div><div class="modal-body" ng-bind="content"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$hide()">Close</button></div></div></div></div>');
  } ]);
  angular.module('mgcrea.ngStrap.popover').run([ '$templateCache', function($templateCache) {
    $templateCache.put('popover/popover.tpl.html', '<div class="popover" tabindex="-1"><div class="arrow"></div><h3 class="popover-title" ng-bind="title" ng-show="title"></h3><div class="popover-content" ng-bind="content"></div></div>');
  } ]);
  angular.module('mgcrea.ngStrap.select').run([ '$templateCache', function($templateCache) {
    $templateCache.put('select/select.tpl.html', '<ul tabindex="-1" class="select dropdown-menu" ng-show="$isVisible()" role="select"><li ng-if="$showAllNoneButtons"><div class="btn-group" style="margin-bottom: 5px; margin-left: 5px"><button type="button" class="btn btn-default btn-xs" ng-click="$selectAll()">{{$allText}}</button> <button type="button" class="btn btn-default btn-xs" ng-click="$selectNone()">{{$noneText}}</button></div></li><li role="presentation" ng-repeat="match in $matches" ng-class="{active: $isActive($index)}"><a style="cursor: default" role="menuitem" tabindex="-1" ng-click="$select($index, $event)"><i class="{{$iconCheckmark}} pull-right" ng-if="$isMultiple && $isActive($index)"></i> <span ng-bind="match.label"></span></a></li></ul>');
  } ]);
  angular.module('mgcrea.ngStrap.timepicker').run([ '$templateCache', function($templateCache) {
    $templateCache.put('timepicker/timepicker.tpl.html', '<div class="dropdown-menu timepicker" style="min-width: 0px;width: auto"><table height="100%"><thead><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 0)"><i class="{{ $iconUp }}"></i></button></th><th>&nbsp;</th><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 1)"><i class="{{ $iconUp }}"></i></button></th><th>&nbsp;</th><th><button ng-if="showSeconds" tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 2)"><i class="{{ $iconUp }}"></i></button></th></tr></thead><tbody><tr ng-repeat="(i, row) in rows"><td class="text-center"><button tabindex="-1" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[0].selected}" ng-click="$select(row[0].date, 0)" ng-disabled="row[0].disabled"><span ng-class="{\'text-muted\': row[0].muted}" ng-bind="row[0].label"></span></button></td><td><span ng-bind="i == midIndex ? timeSeparator : \' \'"></span></td><td class="text-center"><button tabindex="-1" ng-if="row[1].date" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[1].selected}" ng-click="$select(row[1].date, 1)" ng-disabled="row[1].disabled"><span ng-class="{\'text-muted\': row[1].muted}" ng-bind="row[1].label"></span></button></td><td><span ng-bind="i == midIndex ? timeSeparator : \' \'"></span></td><td class="text-center"><button tabindex="-1" ng-if="showSeconds && row[2].date" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[2].selected}" ng-click="$select(row[2].date, 2)" ng-disabled="row[2].disabled"><span ng-class="{\'text-muted\': row[2].muted}" ng-bind="row[2].label"></span></button></td><td ng-if="showAM">&nbsp;</td><td ng-if="showAM"><button tabindex="-1" ng-show="i == midIndex - !isAM * 1" style="width: 100%" type="button" ng-class="{\'btn-primary\': !!isAM}" class="btn btn-default" ng-click="$switchMeridian()" ng-disabled="el.disabled">AM</button> <button tabindex="-1" ng-show="i == midIndex + 1 - !isAM * 1" style="width: 100%" type="button" ng-class="{\'btn-primary\': !isAM}" class="btn btn-default" ng-click="$switchMeridian()" ng-disabled="el.disabled">PM</button></td></tr></tbody><tfoot><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 0)"><i class="{{ $iconDown }}"></i></button></th><th>&nbsp;</th><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 1)"><i class="{{ $iconDown }}"></i></button></th><th>&nbsp;</th><th><button ng-if="showSeconds" tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 2)"><i class="{{ $iconDown }}"></i></button></th></tr></tfoot></table></div>');
  } ]);
  angular.module('mgcrea.ngStrap.tab').run([ '$templateCache', function($templateCache) {
    $templateCache.put('tab/tab.tpl.html', '<ul class="nav" ng-class="$navClass" role="tablist"><li role="presentation" ng-repeat="$pane in $panes track by $index" ng-class="[ $isActive($pane, $index) ? $activeClass : \'\', $pane.disabled ? \'disabled\' : \'\' ]"><a role="tab" data-toggle="tab" ng-click="!$pane.disabled && $setActive($pane.name || $index)" data-index="{{ $index }}" ng-bind-html="$pane.title" aria-controls="$pane.title"></a></li></ul><div ng-transclude class="tab-content"></div>');
  } ]);
  angular.module('mgcrea.ngStrap.typeahead').run([ '$templateCache', function($templateCache) {
    $templateCache.put('typeahead/typeahead.tpl.html', '<ul tabindex="-1" class="typeahead dropdown-menu" ng-show="$isVisible()" role="select"><li role="presentation" ng-repeat="match in $matches" ng-class="{active: $index == $activeIndex}"><a role="menuitem" tabindex="-1" ng-click="$select($index, $event)" ng-bind="match.label"></a></li></ul>');
  } ]);
  angular.module('mgcrea.ngStrap.tooltip').run([ '$templateCache', function($templateCache) {
    $templateCache.put('tooltip/tooltip.tpl.html', '<div class="tooltip in" ng-show="title"><div class="tooltip-arrow"></div><div class="tooltip-inner" ng-bind="title"></div></div>');
  } ]);
})(window, document);
/* 
 * Angular JS Multi Select
 * Creates a dropdown-like button with checkboxes. 
 *
 * Project started on: Tue, 14 Jan 2014 - 5:18:02 PM
 * Current version: 4.0.0
 * 
 * Released under the MIT License
 * --------------------------------------------------------------------------------
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Ignatius Steven (https://github.com/isteven)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy 
 * of this software and associated documentation files (the "Software"), to deal 
 * in the Software without restriction, including without limitation the rights 
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell 
 * copies of the Software, and to permit persons to whom the Software is 
 * furnished to do so, subject to the following conditions: 
 *
 * The above copyright notice and this permission notice shall be included in all 
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR 
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, 
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE 
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER 
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE 
 * SOFTWARE.
 * --------------------------------------------------------------------------------
 */

'use strict'

angular.module( 'isteven-multi-select', ['ng'] ).directive( 'istevenMultiSelect' , [ '$sce', '$timeout', '$templateCache', function ( $sce, $timeout, $templateCache ) {
    return {
        restrict: 
            'AE',

        scope: 
        {   
            // models
            inputModel      : '=',
            outputModel     : '=',

            // settings based on attribute
            isDisabled      : '=',

            // callbacks
            onClear         : '&',  
            onClose         : '&',
            onSearchChange  : '&',  
            onItemClick     : '&',            
            onOpen          : '&', 
            onReset         : '&',  
            onSelectAll     : '&',  
            onSelectNone    : '&',  

            // i18n
            translation     : '='   
        },
        
        /* 
         * The rest are attributes. They don't need to be parsed / binded, so we can safely access them by value.
         * - buttonLabel, directiveId, helperElements, itemLabel, maxLabels, orientation, selectionMode, minSearchLength,
         *   tickProperty, disableProperty, groupProperty, searchProperty, maxHeight, outputProperties
         */
                                                         
         templateUrl: 
            'isteven-multi-select.htm',                            

        link: function ( $scope, element, attrs ) {                       

            $scope.backUp           = [];
            $scope.varButtonLabel   = '';               
            $scope.spacingProperty  = '';
            $scope.indexProperty    = '';                        
            $scope.orientationH     = false;
            $scope.orientationV     = true;
            $scope.filteredModel    = [];
            $scope.inputLabel       = { labelFilter: '' };                        
            $scope.tabIndex         = 0;            
            $scope.lang             = {};
            $scope.helperStatus     = {
                all     : true,
                none    : true,
                reset   : true,
                filter  : true
            };

            var 
                prevTabIndex        = 0,
                helperItems         = [],
                helperItemsLength   = 0,
                checkBoxLayer       = '',
                scrolled            = false,
                selectedItems       = [],
                formElements        = [],
                vMinSearchLength    = 0,
                clickedItem         = null                

            // v3.0.0
            // clear button clicked
            $scope.clearClicked = function( e ) {                
                $scope.inputLabel.labelFilter = '';
                $scope.updateFilter();
                $scope.select( 'clear', e );                
            }

            // A little hack so that AngularJS ng-repeat can loop using start and end index like a normal loop
            // http://stackoverflow.com/questions/16824853/way-to-ng-repeat-defined-number-of-times-instead-of-repeating-over-array
            $scope.numberToArray = function( num ) {
                return new Array( num );   
            }

            // Call this function when user type on the filter field
            $scope.searchChanged = function() {                                                
                if ( $scope.inputLabel.labelFilter.length < vMinSearchLength && $scope.inputLabel.labelFilter.length > 0 ) {
                    return false;
                }                
                $scope.updateFilter();
            }

            $scope.updateFilter = function()
            {      
                // we check by looping from end of input-model
                $scope.filteredModel = [];
                var i = 0;

                if ( typeof $scope.inputModel === 'undefined' ) {
                    return false;                   
                }

                for( i = $scope.inputModel.length - 1; i >= 0; i-- ) {

                    // if it's group end, we push it to filteredModel[];
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === false ) {
                        $scope.filteredModel.push( $scope.inputModel[ i ] );
                    }
                    
                    // if it's data 
                    var gotData = false;
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] === 'undefined' ) {                        
                        
                        // If we set the search-key attribute, we use this loop. 
                        if ( typeof attrs.searchProperty !== 'undefined' && attrs.searchProperty !== '' ) {

                            for (var key in $scope.inputModel[ i ]  ) {
                                if ( 
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
                                    && attrs.searchProperty.indexOf( key ) > -1
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }                        
                        }
                        // if there's no search-key attribute, we use this one. Much better on performance.
                        else {
                            for ( var key in $scope.inputModel[ i ]  ) {
                                if ( 
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }                        
                        }

                        if ( gotData === true ) {    
                            // push
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }

                    // if it's group start
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === true ) {

                        if ( typeof $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] !== 'undefined' 
                                && $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] === false ) {
                            $scope.filteredModel.pop();
                        }
                        else {
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }
                }                

                $scope.filteredModel.reverse();  
                
                $timeout( function() {                    

                    $scope.getFormElements();               
                    
                    // Callback: on filter change                      
                    if ( $scope.inputLabel.labelFilter.length > vMinSearchLength ) {

                        var filterObj = [];

                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' ) {                   
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                                                    
                                    var tempObj = angular.copy( value );
                                    var index = filterObj.push( tempObj );                                
                                    delete filterObj[ index - 1 ][ $scope.indexProperty ];
                                    delete filterObj[ index - 1 ][ $scope.spacingProperty ];      
                                }
                            }
                        });

                        $scope.onSearchChange({ 
                            data: 
                            {
                                keyword: $scope.inputLabel.labelFilter, 
                                result: filterObj 
                            } 
                        });
                    }
                },0);
            };

            // List all the input elements. We need this for our keyboard navigation.
            // This function will be called everytime the filter is updated. 
            // Depending on the size of filtered mode, might not good for performance, but oh well..
            $scope.getFormElements = function() {                                     
                formElements = [];

                var 
                    selectButtons   = [],
                    inputField      = [],
                    checkboxes      = [],
                    clearButton     = [];
                
                // If available, then get select all, select none, and reset buttons
                if ( $scope.helperStatus.all || $scope.helperStatus.none || $scope.helperStatus.reset ) {                                                       
                    selectButtons = element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );                    
                    // If available, then get the search box and the clear button
                    if ( $scope.helperStatus.filter ) {                                            
                        // Get helper - search and clear button. 
                        inputField =    element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'input' );                    
                        clearButton =   element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'button' );                        
                    }
                }
                else {
                    if ( $scope.helperStatus.filter ) {   
                        // Get helper - search and clear button. 
                        inputField =    element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'input' );                    
                        clearButton =   element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
                    }
                }
               
                // Get checkboxes
                if ( !$scope.helperStatus.all && !$scope.helperStatus.none && !$scope.helperStatus.reset && !$scope.helperStatus.filter ) {
                    checkboxes = element.children().children().next()[ 0 ].getElementsByTagName( 'input' );
                }
                else {
                    checkboxes = element.children().children().next().children().next()[ 0 ].getElementsByTagName( 'input' );
                }

                // Push them into global array formElements[] 
                for ( var i = 0; i < selectButtons.length ; i++ )   { formElements.push( selectButtons[ i ] );  }
                for ( var i = 0; i < inputField.length ; i++ )      { formElements.push( inputField[ i ] );     }
                for ( var i = 0; i < clearButton.length ; i++ )     { formElements.push( clearButton[ i ] );    }
                for ( var i = 0; i < checkboxes.length ; i++ )      { formElements.push( checkboxes[ i ] );     }                                
            }            

            // check if an item has attrs.groupProperty (be it true or false)
            $scope.isGroupMarker = function( item , type ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === type ) return true; 
                return false;
            }

            $scope.removeGroupEndMarker = function( item ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) return false; 
                return true;
            }                       

            // call this function when an item is clicked
            $scope.syncItems = function( item, e, ng_repeat_index ) {                                      

                e.preventDefault();
                e.stopPropagation();

                // if the directive is globaly disabled, do nothing
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
                    return false;
                }

                // if item is disabled, do nothing
                if ( typeof attrs.isDisabled !== 'undefined' && $scope.isDisabled === true ) {                        
                    return false;
                }                                

                // if end group marker is clicked, do nothing
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) {
                    return false;
                }                

                var index = $scope.filteredModel.indexOf( item );       

                // if the start of group marker is clicked ( only for multiple selection! )
                // how it works:
                // - if, in a group, there are items which are not selected, then they all will be selected
                // - if, in a group, all items are selected, then they all will be de-selected                
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === true ) {                                  

                    // this is only for multiple selection, so if selection mode is single, do nothing
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        return false;
                    }
                    
                    var i,j,k;
                    var startIndex = 0;
                    var endIndex = $scope.filteredModel.length - 1;
                    var tempArr = [];

                    // nest level is to mark the depth of the group.
                    // when you get into a group (start group marker), nestLevel++
                    // when you exit a group (end group marker), nextLevel--
                    var nestLevel = 0;                    

                    // we loop throughout the filtered model (not whole model)
                    for( i = index ; i < $scope.filteredModel.length ; i++) {  

                        // this break will be executed when we're done processing each group
                        if ( nestLevel === 0 && i > index ) 
                        {
                            break;
                        }
                    
                        if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === true ) {
                            
                            // To cater multi level grouping
                            if ( tempArr.length === 0 ) {
                                startIndex = i + 1; 
                            }                            
                            nestLevel = nestLevel + 1;
                        }                                                

                        // if group end
                        else if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === false ) {

                            nestLevel = nestLevel - 1;                            

                            // cek if all are ticked or not                            
                            if ( tempArr.length > 0 && nestLevel === 0 ) {                                

                                var allTicked = true;       

                                endIndex = i;

                                for ( j = 0; j < tempArr.length ; j++ ) {                                
                                    if ( typeof tempArr[ j ][ $scope.tickProperty ] !== 'undefined' &&  tempArr[ j ][ $scope.tickProperty ] === false ) {
                                        allTicked = false;
                                        break;
                                    }
                                }                                                                                    

                                if ( allTicked === true ) {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                        }
                                    }                                
                                }

                                else {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;                                                
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;

                                            }                                            
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;
                                            }
                                        }
                                    }                                
                                }                                                                                    
                            }
                        }
            
                        // if data
                        else {                            
                            tempArr.push( $scope.filteredModel[ i ] );                                                                                    
                        }
                    }                                 
                }

                // if an item (not group marker) is clicked
                else {

                    // If it's single selection mode
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        
                        // first, set everything to false
                        for( i=0 ; i < $scope.filteredModel.length ; i++) {                            
                            $scope.filteredModel[ i ][ $scope.tickProperty ] = false;                            
                        }        
                        for( i=0 ; i < $scope.inputModel.length ; i++) {                            
                            $scope.inputModel[ i ][ $scope.tickProperty ] = false;                            
                        }        
                        
                        // then set the clicked item to true
                        $scope.filteredModel[ index ][ $scope.tickProperty ] = true;                                                                 
                    }   

                    // Multiple
                    else {
                        $scope.filteredModel[ index ][ $scope.tickProperty ]   = !$scope.filteredModel[ index ][ $scope.tickProperty ];
                    }

                    // we refresh input model as well
                    var inputModelIndex = $scope.filteredModel[ index ][ $scope.indexProperty ];                                        
                    $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = $scope.filteredModel[ index ][ $scope.tickProperty ];                    
                }                                  

                // we execute the callback function here
                clickedItem = angular.copy( item );                                                    
                if ( clickedItem !== null && clickedItem !== undefined ) {                        
                    $timeout( function() {
                        if ($scope !== null && $scope !== undefined) {

                            if ($scope["indexProperty"] !== undefined 
                                && $scope["indexProperty"] !== null
                                && clickedItem !== undefined
                                && clickedItem !== null
                                && clickedItem[ $scope.indexProperty ] !== null
                                && clickedItem[ $scope.indexProperty ] !== undefined) {
                                delete clickedItem[ $scope.indexProperty ];
                            }

                            if ($scope["spacingProperty"] !== undefined 
                                && $scope["spacingProperty"] !== null
                                && clickedItem !== undefined
                                && clickedItem !== null
                                && clickedItem[ $scope.spacingProperty ] !== undefined
                                && clickedItem[ $scope.spacingProperty ] !== null) {
                                delete clickedItem[ $scope.spacingProperty ];
                            }

                            $scope.onItemClick( { data: clickedItem } );
                            clickedItem = null;                    
                        }

                    }, 0 );                                                 
                }                                    
                
                $scope.refreshOutputModel();
                $scope.refreshButton();                              

                // We update the index here
                prevTabIndex = $scope.tabIndex;
                $scope.tabIndex = ng_repeat_index + helperItemsLength;
                                
                // Set focus on the hidden checkbox 
                e.target.focus();

                // set & remove CSS style
                $scope.removeFocusStyle( prevTabIndex );
                $scope.setFocusStyle( $scope.tabIndex );

                if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                    // on single selection mode, we then hide the checkbox layer
                    $scope.toggleCheckboxes( e );       
                }
            }     

            // update $scope.outputModel
            $scope.refreshOutputModel = function() {            
                
                $scope.outputModel  = [];
                var 
                    outputProps     = [],
                    tempObj         = {};

                // v4.0.0
                if ( typeof attrs.outputProperties !== 'undefined' ) {                    
                    outputProps = attrs.outputProperties.split(' ');                
                    angular.forEach( $scope.inputModel, function( value, key ) {                    
                        if ( 
                            typeof value !== 'undefined' 
                            && typeof value[ attrs.groupProperty ] === 'undefined' 
                            && value[ $scope.tickProperty ] === true 
                        ) {
                            tempObj         = {};
                            angular.forEach( value, function( value1, key1 ) {                                
                                if ( outputProps.indexOf( key1 ) > -1 ) {                                                                         
                                    tempObj[ key1 ] = value1;                                    
                                }
                            });
                            var index = $scope.outputModel.push( tempObj );                                                               
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
                        }
                    });         
                }
                else {
                    angular.forEach( $scope.inputModel, function( value, key ) {                    
                        if ( 
                            typeof value !== 'undefined' 
                            && typeof value[ attrs.groupProperty ] === 'undefined' 
                            && value[ $scope.tickProperty ] === true 
                        ) {
                            var temp = angular.copy( value );
                            var index = $scope.outputModel.push( temp );                                                               
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
                        }
                    });         
                }
            }

            // refresh button label
            $scope.refreshButton = function() {

                $scope.varButtonLabel   = '';                
                var ctr                 = 0;                  

                // refresh button label...
                if ( $scope.outputModel.length === 0 ) {
                    // https://github.com/isteven/angular-multi-select/pull/19                    
                    $scope.varButtonLabel = $scope.lang.nothingSelected;
                }
                else {                
                    var tempMaxLabels = $scope.outputModel.length;
                    if ( typeof attrs.maxLabels !== 'undefined' && attrs.maxLabels !== '' ) {
                        tempMaxLabels = attrs.maxLabels;
                    }

                    // if max amount of labels displayed..
                    if ( $scope.outputModel.length > tempMaxLabels ) {
                        $scope.more = true;
                    }
                    else {
                        $scope.more = false;
                    }                
                    
                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if ( typeof value !== 'undefined' && value[ attrs.tickProperty ] === true ) {                        
                            if ( ctr < tempMaxLabels ) {                            
                                $scope.varButtonLabel += ( $scope.varButtonLabel.length > 0 ? '</div>, <div class="buttonLabel">' : '<div class="buttonLabel">') + $scope.writeLabel( value, 'buttonLabel' );
                            }
                            ctr++;
                        }
                    });                

                    if ( $scope.more === true ) {
                        // https://github.com/isteven/angular-multi-select/pull/16
                        if (tempMaxLabels > 0) {
                            $scope.varButtonLabel += ', ... ';
                        }
                        $scope.varButtonLabel += '(' + $scope.outputModel.length + ')';                        
                    }
                }
                $scope.varButtonLabel = $sce.trustAsHtml( $scope.varButtonLabel + '<span class="caret"></span>' );                
            }

            // Check if a checkbox is disabled or enabled. It will check the granular control (disableProperty) and global control (isDisabled)
            // Take note that the granular control has higher priority.
            $scope.itemIsDisabled = function( item ) {
                
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
                    return true;
                }
                else {             
                    if ( $scope.isDisabled === true ) {                        
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                
            }

            // A simple function to parse the item label settings. Used on the buttons and checkbox labels.
            $scope.writeLabel = function( item, type ) {
                
                // type is either 'itemLabel' or 'buttonLabel'
                var temp    = attrs[ type ].split( ' ' );                    
                var label   = '';                

                angular.forEach( temp, function( value, key ) {                    
                    item[ value ] && ( label += '&nbsp;' + value.split( '.' ).reduce( function( prev, current ) {
                        return prev[ current ]; 
                    }, item ));        
                });
                
                if ( type.toUpperCase() === 'BUTTONLABEL' ) {                    
                    return label;
                }
                return $sce.trustAsHtml( label );
            }                                

            // UI operations to show/hide checkboxes based on click event..
            $scope.toggleCheckboxes = function( e ) {                                    
                
                // We grab the button
                var clickedEl = element.children()[0];

                // Just to make sure.. had a bug where key events were recorded twice
                angular.element( document ).off( 'click', $scope.externalClickListener );
                angular.element( document ).off( 'keydown', $scope.keyboardListener );        

                // The idea below was taken from another multi-select directive - https://github.com/amitava82/angular-multiselect 
                // His version is awesome if you need a more simple multi-select approach.                                

                // close
                if ( angular.element( checkBoxLayer ).hasClass( 'show' )) {                         

                    angular.element( checkBoxLayer ).removeClass( 'show' );                    
                    angular.element( clickedEl ).removeClass( 'buttonClicked' );                    
                    angular.element( document ).off( 'click', $scope.externalClickListener );
                    angular.element( document ).off( 'keydown', $scope.keyboardListener );                                    

                    // clear the focused element;
                    $scope.removeFocusStyle( $scope.tabIndex );
                    if ( typeof formElements[ $scope.tabIndex ] !== 'undefined' ) {
                        formElements[ $scope.tabIndex ].blur();
                    }

                    // close callback
                    $timeout( function() {
                        $scope.onClose();
                    }, 0 );

                    // set focus on button again
                    element.children().children()[ 0 ].focus();
                } 
                // open
                else                 
                {    
                    // clear filter
                    $scope.inputLabel.labelFilter = '';                
                    $scope.updateFilter();                                

                    helperItems = [];
                    helperItemsLength = 0;

                    angular.element( checkBoxLayer ).addClass( 'show' );
                    angular.element( clickedEl ).addClass( 'buttonClicked' );       

                    // Attach change event listener on the input filter. 
                    // We need this because ng-change is apparently not an event listener.                    
                    angular.element( document ).on( 'click', $scope.externalClickListener );
                    angular.element( document ).on( 'keydown', $scope.keyboardListener );  

                    // to get the initial tab index, depending on how many helper elements we have. 
                    // priority is to always focus it on the input filter                                                                
                    $scope.getFormElements();
                    $scope.tabIndex = 0;

                    var helperContainer = angular.element( element[ 0 ].querySelector( '.helperContainer' ) )[0];                
                    
                    if ( typeof helperContainer !== 'undefined' ) {
                        for ( var i = 0; i < helperContainer.getElementsByTagName( 'BUTTON' ).length ; i++ ) {
                            helperItems[ i ] = helperContainer.getElementsByTagName( 'BUTTON' )[ i ];
                        }
                        helperItemsLength = helperItems.length + helperContainer.getElementsByTagName( 'INPUT' ).length;
                    }
                    
                    // focus on the filter element on open. 
                    if ( element[ 0 ].querySelector( '.inputFilter' ) ) {                        
                        element[ 0 ].querySelector( '.inputFilter' ).focus();    
                        $scope.tabIndex = $scope.tabIndex + helperItemsLength - 2;
                        // blur button in vain
                        angular.element( element ).children()[ 0 ].blur();
                    }
                    // if there's no filter then just focus on the first checkbox item
                    else {                  
                        if ( !$scope.isDisabled ) {                        
                            $scope.tabIndex = $scope.tabIndex + helperItemsLength;
                            if ( $scope.inputModel && $scope.inputModel.length > 0 ) {
                                formElements[ $scope.tabIndex ].focus();
                                $scope.setFocusStyle( $scope.tabIndex );
                                // blur button in vain
                                angular.element( element ).children()[ 0 ].blur();
                            }                            
                        }
                    }                          

                    // open callback
                    $scope.onOpen();
                }                            
            }
            
            // handle clicks outside the button / multi select layer
            $scope.externalClickListener = function( e ) {                   

                var targetsArr = element.find( e.target.tagName );
                for (var i = 0; i < targetsArr.length; i++) {                                        
                    if ( e.target == targetsArr[i] ) {
                        return;
                    }
                }

                angular.element( checkBoxLayer.previousSibling ).removeClass( 'buttonClicked' );                    
                angular.element( checkBoxLayer ).removeClass( 'show' );
                angular.element( document ).off( 'click', $scope.externalClickListener ); 
                angular.element( document ).off( 'keydown', $scope.keyboardListener );                
                
                // close callback                
                $timeout( function() {
                    $scope.onClose();
                }, 0 );

                // set focus on button again
                element.children().children()[ 0 ].focus();
            }
   
            // select All / select None / reset buttons
            $scope.select = function( type, e ) {

                var helperIndex = helperItems.indexOf( e.target );
                $scope.tabIndex = helperIndex;

                switch( type.toUpperCase() ) {
                    case 'ALL':
                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                                
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
                                    value[ $scope.tickProperty ] = true;
                                }
                            }
                        });                            
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                  
                        $scope.onSelectAll();                                                
                        break;
                    case 'NONE':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
                                    value[ $scope.tickProperty ] = false;
                                }
                            }
                        });               
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                                          
                        $scope.onSelectNone();                        
                        break;
                    case 'RESET':            
                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
                            if ( typeof value[ attrs.groupProperty ] === 'undefined' && typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
                                var temp = value[ $scope.indexProperty ];                                
                                value[ $scope.tickProperty ] = $scope.backUp[ temp ][ $scope.tickProperty ];
                            }
                        });               
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                                          
                        $scope.onReset();                        
                        break;
                    case 'CLEAR':
                        $scope.tabIndex = $scope.tabIndex + 1;
                        $scope.onClear();    
                        break;
                    case 'FILTER':                        
                        $scope.tabIndex = helperItems.length - 1;
                        break;
                    default:                        
                }                                                                                 
            }            

            // just to create a random variable name                
            function genRandomString( length ) {                
                var possible    = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
                var temp        = '';
                for( var i=0; i < length; i++ ) {
                     temp += possible.charAt( Math.floor( Math.random() * possible.length ));
                }
                return temp;
            }

            // count leading spaces
            $scope.prepareGrouping = function() {
                var spacing     = 0;                                                
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.spacingProperty ] = spacing;                    
                    if ( value[ attrs.groupProperty ] === true ) {
                        spacing+=2;
                    }                    
                    else if ( value[ attrs.groupProperty ] === false ) {
                        spacing-=2;
                    }                 
                });
            }

            // prepare original index
            $scope.prepareIndex = function() {
                var ctr = 0;
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.indexProperty ] = ctr;
                    ctr++;
                });
            }

            // navigate using up and down arrow
            $scope.keyboardListener = function( e ) { 
                
                var key = e.keyCode ? e.keyCode : e.which;      
                var isNavigationKey = false;                                                

                // ESC key (close)
                if ( key === 27 ) {
                    e.preventDefault();                   
                    e.stopPropagation();
                    $scope.toggleCheckboxes( e );
                }                    
                
                
                // next element ( tab, down & right key )                    
                else if ( key === 40 || key === 39 || ( !e.shiftKey && key == 9 ) ) {                    
                    
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex; 
                    $scope.tabIndex++;                         
                    if ( $scope.tabIndex > formElements.length - 1 ) {
                        $scope.tabIndex = 0;
                        prevTabIndex = formElements.length - 1; 
                    }                                                            
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
                        $scope.tabIndex++;
                        if ( $scope.tabIndex > formElements.length - 1 ) {
                            $scope.tabIndex = 0;                            
                        }                                                                                    
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }
                    }              
                }
                  
                // prev element ( shift+tab, up & left key )
                else if ( key === 38 || key === 37 || ( e.shiftKey && key == 9 ) ) { 
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex; 
                    $scope.tabIndex--;                              
                    if ( $scope.tabIndex < 0 ) {
                        $scope.tabIndex = formElements.length - 1;
                        prevTabIndex = 0;
                    }                                         
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {                        
                        $scope.tabIndex--;
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }                                            
                        if ( $scope.tabIndex < 0 ) {
                            $scope.tabIndex = formElements.length - 1;
                        }                             
                    }                                                     
                }                    

                if ( isNavigationKey === true ) {                                         
                    
                    e.preventDefault();

                    // set focus on the checkbox                    
                    formElements[ $scope.tabIndex ].focus();    
                    var actEl = document.activeElement;                     
                    
                    if ( actEl.type.toUpperCase() === 'CHECKBOX' ) {                                                   
                        $scope.setFocusStyle( $scope.tabIndex );
                        $scope.removeFocusStyle( prevTabIndex );
                    }                    
                    else {
                        $scope.removeFocusStyle( prevTabIndex );
                        $scope.removeFocusStyle( helperItemsLength );
                        $scope.removeFocusStyle( formElements.length - 1 );
                    } 
                }                

                isNavigationKey = false;
            }

            // set (add) CSS style on selected row
            $scope.setFocusStyle = function( tabIndex ) {                                
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().addClass( 'multiSelectFocus' );                        
            }

            // remove CSS style on selected row
            $scope.removeFocusStyle = function( tabIndex ) {                
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().removeClass( 'multiSelectFocus' );
            }

            /*********************
             *********************             
             *
             * 1) Initializations
             *
             *********************
             *********************/

            // attrs to $scope - attrs-$scope - attrs - $scope
            // Copy some properties that will be used on the template. They need to be in the $scope.
            $scope.groupProperty    = attrs.groupProperty;   
            $scope.tickProperty     = attrs.tickProperty;
            $scope.directiveId      = attrs.directiveId;
            
            // Unfortunately I need to add these grouping properties into the input model
            var tempStr = genRandomString( 5 );
            $scope.indexProperty = 'idx_' + tempStr;
            $scope.spacingProperty = 'spc_' + tempStr;         

            // set orientation css            
            if ( typeof attrs.orientation !== 'undefined' ) {

                if ( attrs.orientation.toUpperCase() === 'HORIZONTAL' ) {                    
                    $scope.orientationH = true;
                    $scope.orientationV = false;
                }
                else 
                {
                    $scope.orientationH = false;
                    $scope.orientationV = true;
                }
            }            

            // get elements required for DOM operation
            checkBoxLayer = element.children().children().next()[0];

            // set max-height property if provided
            if ( typeof attrs.maxHeight !== 'undefined' ) {                
                var layer = element.children().children().children()[0];
                angular.element( layer ).attr( "style", "height:" + attrs.maxHeight + "; overflow-y:scroll;" );                                
            }

            // some flags for easier checking            
            for ( var property in $scope.helperStatus ) {
                if ( $scope.helperStatus.hasOwnProperty( property )) {                    
                    if ( 
                        typeof attrs.helperElements !== 'undefined' 
                        && attrs.helperElements.toUpperCase().indexOf( property.toUpperCase() ) === -1 
                    ) {
                        $scope.helperStatus[ property ] = false;
                    }
                }
            }
            if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' )  {
                $scope.helperStatus[ 'all' ] = false;
                $scope.helperStatus[ 'none' ] = false;
            }

            // helper button icons.. I guess you can use html tag here if you want to. 
            $scope.icon        = {};            
            $scope.icon.selectAll  = '&#10003;';    // a tick icon
            $scope.icon.selectNone = '&times;';     // x icon
            $scope.icon.reset      = '&#8630;';     // undo icon            
            // this one is for the selected items
            $scope.icon.tickMark   = '&#10003;';    // a tick icon 

            // configurable button labels                       
            if ( typeof attrs.translation !== 'undefined' ) {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;' + $scope.translation.selectAll );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;' + $scope.translation.selectNone );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;' + $scope.translation.reset );
                $scope.lang.search          = $scope.translation.search;                
                $scope.lang.nothingSelected = $sce.trustAsHtml( $scope.translation.nothingSelected );                
            }
            else {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;Select All' );                
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;Select None' );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;Reset' );
                $scope.lang.search          = 'Search...';
                $scope.lang.nothingSelected = 'None Selected';                
            }
            $scope.icon.tickMark = $sce.trustAsHtml( $scope.icon.tickMark );
                
            // min length of keyword to trigger the filter function
            if ( typeof attrs.MinSearchLength !== 'undefined' && parseInt( attrs.MinSearchLength ) > 0 ) {
                vMinSearchLength = Math.floor( parseInt( attrs.MinSearchLength ) );
            }

            /*******************************************************
             *******************************************************
             *
             * 2) Logic starts here, initiated by watch 1 & watch 2
             *
             *******************************************************
             *******************************************************/
            
            // watch1, for changes in input model property
            // updates multi-select when user select/deselect a single checkbox programatically
            // https://github.com/isteven/angular-multi-select/issues/8            
            $scope.$watch( 'inputModel' , function( newVal ) {                                 
                if ( newVal ) {                            
                    $scope.refreshOutputModel();                                    
                    $scope.refreshButton();                                                  
                }
            }, true );
            
            // watch2 for changes in input model as a whole
            // this on updates the multi-select when a user load a whole new input-model. We also update the $scope.backUp variable
            $scope.$watch( 'inputModel' , function( newVal ) {  
                if ( newVal ) {
                    $scope.backUp = angular.copy( $scope.inputModel );    
                    $scope.updateFilter();
                    $scope.prepareGrouping();
                    $scope.prepareIndex();                                                              
                    $scope.refreshOutputModel();                
                    $scope.refreshButton();                                                                                                                 
                }
            });                        

            // watch for changes in directive state (disabled or enabled)
            $scope.$watch( 'isDisabled' , function( newVal ) {         
                $scope.isDisabled = newVal;                               
            });            
            
            // this is for touch enabled devices. We don't want to hide checkboxes on scroll. 
            var onTouchStart = function (e) {
                $timeout(function() {
                    $scope.$apply(function() {
                        $scope.scrolled = false;
                    });
                });
            };
            angular.element( document ).bind( 'touchstart', onTouchStart);
            var onTouchMove = function (e) {
                $timeout(function() {
            	    $scope.$apply( function() {
            		    $scope.scrolled = true;                
            	    });
                });
            };
            angular.element( document ).bind( 'touchmove', onTouchMove);            

            // unbind document events to prevent memory leaks
            $scope.$on( '$destroy', function () {
			    angular.element( document ).unbind( 'touchstart', onTouchStart);
            	angular.element( document ).unbind( 'touchmove', onTouchMove);
            });
        }
    }
}]).run( [ '$templateCache' , function( $templateCache ) {
    var template = 
        '<span class="multiSelect inlineBlock">' +
            // main button
            '<button id="{{directiveId}}" type="button"' +                
                'ng-click="toggleCheckboxes( $event ); refreshSelectedItems(); refreshButton(); prepareGrouping; prepareIndex();"' +
                'ng-bind-html="varButtonLabel"' +
                'ng-disabled="disable-button"' +
            '>' +
            '</button>' +
            // overlay layer
            '<div class="checkboxLayer">' +
                // container of the helper elements
                '<div class="helperContainer" ng-if="helperStatus.filter || helperStatus.all || helperStatus.none || helperStatus.reset ">' +
                    // container of the first 3 buttons, select all, none and reset
                    '<div class="line" ng-if="helperStatus.all || helperStatus.none || helperStatus.reset ">' +
                        // select all
                        '<button type="button" class="helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.all"' +
                            'ng-click="select( \'all\', $event );"' +
                            'ng-bind-html="lang.selectAll">' +
                        '</button>'+
                        // select none
                        '<button type="button" class="helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.none"' +
                            'ng-click="select( \'none\', $event );"' +
                            'ng-bind-html="lang.selectNone">' +
                        '</button>'+
                        // reset
                        '<button type="button" class="helperButton reset"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.reset"' +
                            'ng-click="select( \'reset\', $event );"' +
                            'ng-bind-html="lang.reset">'+
                        '</button>' +
                    '</div>' +
                    // the search box
                    '<div class="line" style="position:relative" ng-if="helperStatus.filter">'+
                        // textfield                
                        '<input placeholder="{{lang.search}}" type="text"' +
                            'ng-click="select( \'filter\', $event )" '+
                            'ng-model="inputLabel.labelFilter" '+
                            'ng-change="searchChanged()" class="inputFilter"'+
                            '/>'+
                        // clear button
                        '<button type="button" class="clearButton" ng-click="clearClicked( $event )" >×</button> '+
                    '</div> '+
                '</div> '+
                // selection items
                '<div class="checkBoxContainer">'+
                    '<div '+
                        'ng-repeat="item in filteredModel | filter:removeGroupEndMarker" class="multiSelectItem"'+
                        'ng-class="{selected: item[ tickProperty ], horizontal: orientationH, vertical: orientationV, multiSelectGroup:item[ groupProperty ], disabled:itemIsDisabled( item )}"'+
                        'ng-click="syncItems( item, $event, $index );" '+
                        'ng-mouseleave="removeFocusStyle( tabIndex );"> '+
                        // this is the spacing for grouped items
                        '<div class="acol" ng-if="item[ spacingProperty ] > 0" ng-repeat="i in numberToArray( item[ spacingProperty ] ) track by $index">'+                        
                    '</div>  '+        
                    '<div class="acol">'+
                        '<label>'+                                
                            // input, so that it can accept focus on keyboard click
                            '<input class="checkbox focusable" type="checkbox" '+
                                'ng-disabled="itemIsDisabled( item )" '+
                                'ng-checked="item[ tickProperty ]" '+
                                'ng-click="syncItems( item, $event, $index )" />'+
                            // item label using ng-bind-hteml
                            '<span '+
                                'ng-class="{disabled:itemIsDisabled( item )}" '+
                                'ng-bind-html="writeLabel( item, \'itemLabel\' )">'+
                            '</span>'+
                        '</label>'+
                    '</div>'+
                    // the tick/check mark
                    '<span class="tickMark" ng-if="item[ groupProperty ] !== true && item[ tickProperty ] === true" ng-bind-html="icon.tickMark"></span>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</span>';
	$templateCache.put( 'isteven-multi-select.htm' , template );
}]); 

/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
var DO_NOT_EXPORT_CODEPAGE=true;var DO_NOT_EXPORT_JSZIP=true;(function(e){if("object"==typeof exports&&"undefined"!=typeof module&&"undefined"==typeof DO_NOT_EXPORT_JSZIP)module.exports=e();else if("function"==typeof define&&define.amd&&"undefined"==typeof DO_NOT_EXPORT_JSZIP){JSZipSync=e();define([],e)}else{var r;"undefined"!=typeof window?r=window:"undefined"!=typeof global?r=global:"undefined"!=typeof $&&$.global?r=$.global:"undefined"!=typeof self&&(r=self),r.JSZipSync=e()}})(function(){var e,r,t;return function a(e,r,t){function n(s,f){if(!r[s]){if(!e[s]){var o=typeof require=="function"&&require;if(!f&&o)return o(s,!0);if(i)return i(s,!0);throw new Error("Cannot find module '"+s+"'")}var l=r[s]={exports:{}};e[s][0].call(l.exports,function(r){var t=e[s][1][r];return n(t?t:r)},l,l.exports,a,e,r,t)}return r[s].exports}var i=typeof require=="function"&&require;for(var s=0;s<t.length;s++)n(t[s]);return n}({1:[function(e,r,t){"use strict";var a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";t.encode=function(e,r){var t="";var n,i,s,f,o,l,c;var h=0;while(h<e.length){n=e.charCodeAt(h++);i=e.charCodeAt(h++);s=e.charCodeAt(h++);f=n>>2;o=(n&3)<<4|i>>4;l=(i&15)<<2|s>>6;c=s&63;if(isNaN(i)){l=c=64}else if(isNaN(s)){c=64}t=t+a.charAt(f)+a.charAt(o)+a.charAt(l)+a.charAt(c)}return t};t.decode=function(e,r){var t="";var n,i,s;var f,o,l,c;var h=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(h<e.length){f=a.indexOf(e.charAt(h++));o=a.indexOf(e.charAt(h++));l=a.indexOf(e.charAt(h++));c=a.indexOf(e.charAt(h++));n=f<<2|o>>4;i=(o&15)<<4|l>>2;s=(l&3)<<6|c;t=t+String.fromCharCode(n);if(l!=64){t=t+String.fromCharCode(i)}if(c!=64){t=t+String.fromCharCode(s)}}return t}},{}],2:[function(e,r,t){"use strict";function a(){this.compressedSize=0;this.uncompressedSize=0;this.crc32=0;this.compressionMethod=null;this.compressedContent=null}a.prototype={getContent:function(){return null},getCompressedContent:function(){return null}};r.exports=a},{}],3:[function(e,r,t){"use strict";t.STORE={magic:"\0\0",compress:function(e){return e},uncompress:function(e){return e},compressInputType:null,uncompressInputType:null};t.DEFLATE=e("./flate")},{"./flate":8}],4:[function(e,r,t){"use strict";var a=e("./utils");var n=[0,1996959894,3993919788,2567524794,124634137,1886057615,3915621685,2657392035,249268274,2044508324,3772115230,2547177864,162941995,2125561021,3887607047,2428444049,498536548,1789927666,4089016648,2227061214,450548861,1843258603,4107580753,2211677639,325883990,1684777152,4251122042,2321926636,335633487,1661365465,4195302755,2366115317,997073096,1281953886,3579855332,2724688242,1006888145,1258607687,3524101629,2768942443,901097722,1119000684,3686517206,2898065728,853044451,1172266101,3705015759,2882616665,651767980,1373503546,3369554304,3218104598,565507253,1454621731,3485111705,3099436303,671266974,1594198024,3322730930,2970347812,795835527,1483230225,3244367275,3060149565,1994146192,31158534,2563907772,4023717930,1907459465,112637215,2680153253,3904427059,2013776290,251722036,2517215374,3775830040,2137656763,141376813,2439277719,3865271297,1802195444,476864866,2238001368,4066508878,1812370925,453092731,2181625025,4111451223,1706088902,314042704,2344532202,4240017532,1658658271,366619977,2362670323,4224994405,1303535960,984961486,2747007092,3569037538,1256170817,1037604311,2765210733,3554079995,1131014506,879679996,2909243462,3663771856,1141124467,855842277,2852801631,3708648649,1342533948,654459306,3188396048,3373015174,1466479909,544179635,3110523913,3462522015,1591671054,702138776,2966460450,3352799412,1504918807,783551873,3082640443,3233442989,3988292384,2596254646,62317068,1957810842,3939845945,2647816111,81470997,1943803523,3814918930,2489596804,225274430,2053790376,3826175755,2466906013,167816743,2097651377,4027552580,2265490386,503444072,1762050814,4150417245,2154129355,426522225,1852507879,4275313526,2312317920,282753626,1742555852,4189708143,2394877945,397917763,1622183637,3604390888,2714866558,953729732,1340076626,3518719985,2797360999,1068828381,1219638859,3624741850,2936675148,906185462,1090812512,3747672003,2825379669,829329135,1181335161,3412177804,3160834842,628085408,1382605366,3423369109,3138078467,570562233,1426400815,3317316542,2998733608,733239954,1555261956,3268935591,3050360625,752459403,1541320221,2607071920,3965973030,1969922972,40735498,2617837225,3943577151,1913087877,83908371,2512341634,3803740692,2075208622,213261112,2463272603,3855990285,2094854071,198958881,2262029012,4057260610,1759359992,534414190,2176718541,4139329115,1873836001,414664567,2282248934,4279200368,1711684554,285281116,2405801727,4167216745,1634467795,376229701,2685067896,3608007406,1308918612,956543938,2808555105,3495958263,1231636301,1047427035,2932959818,3654703836,1088359270,936918e3,2847714899,3736837829,1202900863,817233897,3183342108,3401237130,1404277552,615818150,3134207493,3453421203,1423857449,601450431,3009837614,3294710456,1567103746,711928724,3020668471,3272380065,1510334235,755167117];r.exports=function i(e,r){if(typeof e==="undefined"||!e.length){return 0}var t=a.getTypeOf(e)!=="string";if(typeof r=="undefined"){r=0}var i=0;var s=0;var f=0;r=r^-1;for(var o=0,l=e.length;o<l;o++){f=t?e[o]:e.charCodeAt(o);s=(r^f)&255;i=n[s];r=r>>>8^i}return r^-1}},{"./utils":21}],5:[function(e,r,t){"use strict";var a=e("./utils");function n(e){this.data=null;this.length=0;this.index=0}n.prototype={checkOffset:function(e){this.checkIndex(this.index+e)},checkIndex:function(e){if(this.length<e||e<0){throw new Error("End of data reached (data length = "+this.length+", asked index = "+e+"). Corrupted zip ?")}},setIndex:function(e){this.checkIndex(e);this.index=e},skip:function(e){this.setIndex(this.index+e)},byteAt:function(e){},readInt:function(e){var r=0,t;this.checkOffset(e);for(t=this.index+e-1;t>=this.index;t--){r=(r<<8)+this.byteAt(t)}this.index+=e;return r},readString:function(e){return a.transformTo("string",this.readData(e))},readData:function(e){},lastIndexOfSignature:function(e){},readDate:function(){var e=this.readInt(4);return new Date((e>>25&127)+1980,(e>>21&15)-1,e>>16&31,e>>11&31,e>>5&63,(e&31)<<1)}};r.exports=n},{"./utils":21}],6:[function(e,r,t){"use strict";t.base64=false;t.binary=false;t.dir=false;t.createFolders=false;t.date=null;t.compression=null;t.comment=null},{}],7:[function(e,r,t){"use strict";var a=e("./utils");t.string2binary=function(e){return a.string2binary(e)};t.string2Uint8Array=function(e){return a.transformTo("uint8array",e)};t.uint8Array2String=function(e){return a.transformTo("string",e)};t.string2Blob=function(e){var r=a.transformTo("arraybuffer",e);return a.arrayBuffer2Blob(r)};t.arrayBuffer2Blob=function(e){return a.arrayBuffer2Blob(e)};t.transformTo=function(e,r){return a.transformTo(e,r)};t.getTypeOf=function(e){return a.getTypeOf(e)};t.checkSupport=function(e){return a.checkSupport(e)};t.MAX_VALUE_16BITS=a.MAX_VALUE_16BITS;t.MAX_VALUE_32BITS=a.MAX_VALUE_32BITS;t.pretty=function(e){return a.pretty(e)};t.findCompression=function(e){return a.findCompression(e)};t.isRegExp=function(e){return a.isRegExp(e)}},{"./utils":21}],8:[function(e,r,t){"use strict";var a=typeof Uint8Array!=="undefined"&&typeof Uint16Array!=="undefined"&&typeof Uint32Array!=="undefined";var n=e("pako");t.uncompressInputType=a?"uint8array":"array";t.compressInputType=a?"uint8array":"array";t.magic="\b\0";t.compress=function(e){return n.deflateRaw(e)};t.uncompress=function(e){return n.inflateRaw(e)}},{pako:24}],9:[function(e,r,t){"use strict";var a=e("./base64");function n(e,r){if(!(this instanceof n))return new n(e,r);this.files={};this.comment=null;this.root="";if(e){this.load(e,r)}this.clone=function(){var e=new n;for(var r in this){if(typeof this[r]!=="function"){e[r]=this[r]}}return e}}n.prototype=e("./object");n.prototype.load=e("./load");n.support=e("./support");n.defaults=e("./defaults");n.utils=e("./deprecatedPublicUtils");n.base64={encode:function(e){return a.encode(e)},decode:function(e){return a.decode(e)}};n.compressions=e("./compressions");r.exports=n},{"./base64":1,"./compressions":3,"./defaults":6,"./deprecatedPublicUtils":7,"./load":10,"./object":13,"./support":17}],10:[function(e,r,t){"use strict";var a=e("./base64");var n=e("./zipEntries");r.exports=function(e,r){var t,i,s,f;r=r||{};if(r.base64){e=a.decode(e)}i=new n(e,r);t=i.files;for(s=0;s<t.length;s++){f=t[s];this.file(f.fileName,f.decompressed,{binary:true,optimizedBinaryString:true,date:f.date,dir:f.dir,comment:f.fileComment.length?f.fileComment:null,createFolders:r.createFolders})}if(i.zipComment.length){this.comment=i.zipComment}return this}},{"./base64":1,"./zipEntries":22}],11:[function(e,r,t){(function(e){"use strict";var t=function(){};if(typeof e!=="undefined"){var a=!e.from;if(!a)try{e.from("foo","utf8")}catch(n){a=true}t=a?function(r,t){return t?new e(r,t):new e(r)}:e.from.bind(e);if(!e.alloc)e.alloc=function(r){return new e(r)}}r.exports=function(r,a){return typeof r=="number"?e.alloc(r):t(r,a)};r.exports.test=function(r){return e.isBuffer(r)}}).call(this,typeof Buffer!=="undefined"?Buffer:undefined)},{}],12:[function(e,r,t){"use strict";var a=e("./uint8ArrayReader");function n(e){this.data=e;this.length=this.data.length;this.index=0}n.prototype=new a;n.prototype.readData=function(e){this.checkOffset(e);var r=this.data.slice(this.index,this.index+e);this.index+=e;return r};r.exports=n},{"./uint8ArrayReader":18}],13:[function(e,r,t){"use strict";var a=e("./support");var n=e("./utils");var i=e("./crc32");var s=e("./signature");var f=e("./defaults");var o=e("./base64");var l=e("./compressions");var c=e("./compressedObject");var h=e("./nodeBuffer");var u=e("./utf8");var d=e("./stringWriter");var p=e("./uint8ArrayWriter");var v=function(e){if(e._data instanceof c){e._data=e._data.getContent();e.options.binary=true;e.options.base64=false;if(n.getTypeOf(e._data)==="uint8array"){var r=e._data;e._data=new Uint8Array(r.length);if(r.length!==0){e._data.set(r,0)}}}return e._data};var g=function(e){var r=v(e),t=n.getTypeOf(r);if(t==="string"){if(!e.options.binary){if(a.nodebuffer){return h(r,"utf-8")}}return e.asBinary()}return r};var m=function(e){var r=v(this);if(r===null||typeof r==="undefined"){return""}if(this.options.base64){r=o.decode(r)}if(e&&this.options.binary){r=T.utf8decode(r)}else{r=n.transformTo("string",r)}if(!e&&!this.options.binary){r=n.transformTo("string",T.utf8encode(r))}return r};var b=function(e,r,t){this.name=e;this.dir=t.dir;this.date=t.date;this.comment=t.comment;this._data=r;this.options=t;this._initialMetadata={dir:t.dir,date:t.date}};b.prototype={asText:function(){return m.call(this,true)},asBinary:function(){return m.call(this,false)},asNodeBuffer:function(){var e=g(this);return n.transformTo("nodebuffer",e)},asUint8Array:function(){var e=g(this);return n.transformTo("uint8array",e)},asArrayBuffer:function(){return this.asUint8Array().buffer}};var w=function(e,r){var t="",a;for(a=0;a<r;a++){t+=String.fromCharCode(e&255);e=e>>>8}return t};var C=function(){var e={},r,t;for(r=0;r<arguments.length;r++){for(t in arguments[r]){if(arguments[r].hasOwnProperty(t)&&typeof e[t]==="undefined"){e[t]=arguments[r][t]}}}return e};var E=function(e){e=e||{};if(e.base64===true&&(e.binary===null||e.binary===undefined)){e.binary=true}e=C(e,f);e.date=e.date||new Date;if(e.compression!==null)e.compression=e.compression.toUpperCase();return e};var k=function(e,r,t){var a=n.getTypeOf(r),i;t=E(t);if(t.createFolders&&(i=S(e))){A.call(this,i,true)}if(t.dir||r===null||typeof r==="undefined"){t.base64=false;t.binary=false;r=null}else if(a==="string"){if(t.binary&&!t.base64){if(t.optimizedBinaryString!==true){r=n.string2binary(r)}}}else{t.base64=false;t.binary=true;if(!a&&!(r instanceof c)){throw new Error("The data of '"+e+"' is in an unsupported format !")}if(a==="arraybuffer"){r=n.transformTo("uint8array",r)}}var s=new b(e,r,t);this.files[e]=s;return s};var S=function(e){if(e.slice(-1)=="/"){e=e.substring(0,e.length-1)}var r=e.lastIndexOf("/");return r>0?e.substring(0,r):""};var A=function(e,r){if(e.slice(-1)!="/"){e+="/"}r=typeof r!=="undefined"?r:false;if(!this.files[e]){k.call(this,e,null,{dir:true,createFolders:r})}return this.files[e]};var _=function(e,r){var t=new c,a;if(e._data instanceof c){t.uncompressedSize=e._data.uncompressedSize;t.crc32=e._data.crc32;if(t.uncompressedSize===0||e.dir){r=l["STORE"];t.compressedContent="";t.crc32=0}else if(e._data.compressionMethod===r.magic){t.compressedContent=e._data.getCompressedContent()}else{a=e._data.getContent();t.compressedContent=r.compress(n.transformTo(r.compressInputType,a))}}else{a=g(e);if(!a||a.length===0||e.dir){r=l["STORE"];a=""}t.uncompressedSize=a.length;t.crc32=i(a);t.compressedContent=r.compress(n.transformTo(r.compressInputType,a))}t.compressedSize=t.compressedContent.length;t.compressionMethod=r.magic;return t};var B=function(e,r,t,a){var f=t.compressedContent,o=n.transformTo("string",u.utf8encode(r.name)),l=r.comment||"",c=n.transformTo("string",u.utf8encode(l)),h=o.length!==r.name.length,d=c.length!==l.length,p=r.options,v,g,m="",b="",C="",E,k;if(r._initialMetadata.dir!==r.dir){E=r.dir}else{E=p.dir}if(r._initialMetadata.date!==r.date){k=r.date}else{k=p.date}v=k.getHours();v=v<<6;v=v|k.getMinutes();v=v<<5;v=v|k.getSeconds()/2;g=k.getFullYear()-1980;g=g<<4;g=g|k.getMonth()+1;g=g<<5;g=g|k.getDate();if(h){b=w(1,1)+w(i(o),4)+o;m+="up"+w(b.length,2)+b}if(d){C=w(1,1)+w(this.crc32(c),4)+c;m+="uc"+w(C.length,2)+C}var S="";S+="\n\0";S+=h||d?"\0\b":"\0\0";S+=t.compressionMethod;S+=w(v,2);S+=w(g,2);S+=w(t.crc32,4);S+=w(t.compressedSize,4);S+=w(t.uncompressedSize,4);S+=w(o.length,2);S+=w(m.length,2);var A=s.LOCAL_FILE_HEADER+S+o+m;var _=s.CENTRAL_FILE_HEADER+"\0"+S+w(c.length,2)+"\0\0"+"\0\0"+(E===true?"\0\0\0":"\0\0\0\0")+w(a,4)+o+m+c;return{fileRecord:A,dirRecord:_,compressedObject:t}};var T={load:function(e,r){throw new Error("Load method is not defined. Is the file jszip-load.js included ?")},filter:function(e){var r=[],t,a,n,i;for(t in this.files){if(!this.files.hasOwnProperty(t)){continue}n=this.files[t];i=new b(n.name,n._data,C(n.options));a=t.slice(this.root.length,t.length);if(t.slice(0,this.root.length)===this.root&&e(a,i)){r.push(i)}}return r},file:function(e,r,t){if(arguments.length===1){if(n.isRegExp(e)){var a=e;return this.filter(function(e,r){return!r.dir&&a.test(e)})}else{return this.filter(function(r,t){return!t.dir&&r===e})[0]||null}}else{e=this.root+e;k.call(this,e,r,t)}return this},folder:function(e){if(!e){return this}if(n.isRegExp(e)){return this.filter(function(r,t){return t.dir&&e.test(r)})}var r=this.root+e;var t=A.call(this,r);var a=this.clone();a.root=t.name;return a},remove:function(e){e=this.root+e;var r=this.files[e];if(!r){if(e.slice(-1)!="/"){e+="/"}r=this.files[e]}if(r&&!r.dir){delete this.files[e]}else{var t=this.filter(function(r,t){return t.name.slice(0,e.length)===e});for(var a=0;a<t.length;a++){delete this.files[t[a].name]}}return this},generate:function(e){e=C(e||{},{base64:true,compression:"STORE",type:"base64",comment:null});n.checkSupport(e.type);var r=[],t=0,a=0,i,f,c=n.transformTo("string",this.utf8encode(e.comment||this.comment||""));for(var h in this.files){if(!this.files.hasOwnProperty(h)){continue}var u=this.files[h];var v=u.options.compression||e.compression.toUpperCase();var g=l[v];if(!g){throw new Error(v+" is not a valid compression method !")}var m=_.call(this,u,g);var b=B.call(this,h,u,m,t);t+=b.fileRecord.length+m.compressedSize;a+=b.dirRecord.length;r.push(b)}var E="";E=s.CENTRAL_DIRECTORY_END+"\0\0"+"\0\0"+w(r.length,2)+w(r.length,2)+w(a,4)+w(t,4)+w(c.length,2)+c;var k=e.type.toLowerCase();if(k==="uint8array"||k==="arraybuffer"||k==="blob"||k==="nodebuffer"){i=new p(t+a+E.length)}else{i=new d(t+a+E.length)}for(f=0;f<r.length;f++){i.append(r[f].fileRecord);i.append(r[f].compressedObject.compressedContent)}for(f=0;f<r.length;f++){i.append(r[f].dirRecord)}i.append(E);var S=i.finalize();switch(e.type.toLowerCase()){case"uint8array":;case"arraybuffer":;case"nodebuffer":return n.transformTo(e.type.toLowerCase(),S);case"blob":return n.arrayBuffer2Blob(n.transformTo("arraybuffer",S));case"base64":return e.base64?o.encode(S):S;default:return S;}},crc32:function(e,r){return i(e,r)},utf8encode:function(e){return n.transformTo("string",u.utf8encode(e))},utf8decode:function(e){return u.utf8decode(e)}};r.exports=T},{"./base64":1,"./compressedObject":2,"./compressions":3,"./crc32":4,"./defaults":6,"./nodeBuffer":11,"./signature":14,"./stringWriter":16,"./support":17,"./uint8ArrayWriter":19,"./utf8":20,"./utils":21}],14:[function(e,r,t){"use strict";t.LOCAL_FILE_HEADER="PK";t.CENTRAL_FILE_HEADER="PK";t.CENTRAL_DIRECTORY_END="PK";t.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK";t.ZIP64_CENTRAL_DIRECTORY_END="PK";t.DATA_DESCRIPTOR="PK\b"},{}],15:[function(e,r,t){"use strict";var a=e("./dataReader");var n=e("./utils");function i(e,r){this.data=e;if(!r){this.data=n.string2binary(this.data)}this.length=this.data.length;this.index=0}i.prototype=new a;i.prototype.byteAt=function(e){return this.data.charCodeAt(e)};i.prototype.lastIndexOfSignature=function(e){return this.data.lastIndexOf(e)};i.prototype.readData=function(e){this.checkOffset(e);var r=this.data.slice(this.index,this.index+e);this.index+=e;return r};r.exports=i},{"./dataReader":5,"./utils":21}],16:[function(e,r,t){"use strict";var a=e("./utils");var n=function(){this.data=[]};n.prototype={append:function(e){e=a.transformTo("string",e);this.data.push(e)},finalize:function(){return this.data.join("")}};r.exports=n},{"./utils":21}],17:[function(e,r,t){(function(e){"use strict";t.base64=true;t.array=true;t.string=true;t.arraybuffer=typeof ArrayBuffer!=="undefined"&&typeof Uint8Array!=="undefined";t.nodebuffer=typeof e!=="undefined";t.uint8array=typeof Uint8Array!=="undefined";if(typeof ArrayBuffer==="undefined"){t.blob=false}else{var r=new ArrayBuffer(0);try{t.blob=new Blob([r],{type:"application/zip"}).size===0}catch(a){try{var n=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder||window.MSBlobBuilder;var i=new n;i.append(r);t.blob=i.getBlob("application/zip").size===0}catch(a){t.blob=false}}}}).call(this,typeof Buffer!=="undefined"?Buffer:undefined)},{}],18:[function(e,r,t){"use strict";var a=e("./dataReader");function n(e){if(e){this.data=e;this.length=this.data.length;this.index=0}}n.prototype=new a;n.prototype.byteAt=function(e){return this.data[e]};n.prototype.lastIndexOfSignature=function(e){var r=e.charCodeAt(0),t=e.charCodeAt(1),a=e.charCodeAt(2),n=e.charCodeAt(3);for(var i=this.length-4;i>=0;--i){if(this.data[i]===r&&this.data[i+1]===t&&this.data[i+2]===a&&this.data[i+3]===n){return i}}return-1};n.prototype.readData=function(e){this.checkOffset(e);if(e===0){return new Uint8Array(0)}var r=this.data.subarray(this.index,this.index+e);this.index+=e;return r};r.exports=n},{"./dataReader":5}],19:[function(e,r,t){"use strict";var a=e("./utils");var n=function(e){this.data=new Uint8Array(e);this.index=0};n.prototype={append:function(e){if(e.length!==0){e=a.transformTo("uint8array",e);this.data.set(e,this.index);this.index+=e.length}},finalize:function(){return this.data}};r.exports=n},{"./utils":21}],20:[function(e,r,t){"use strict";var a=e("./utils");var n=e("./support");var i=e("./nodeBuffer");var s=new Array(256);for(var f=0;f<256;f++){s[f]=f>=252?6:f>=248?5:f>=240?4:f>=224?3:f>=192?2:1}s[254]=s[254]=1;var o=function(e){var r,t,a,i,s,f=e.length,o=0;for(i=0;i<f;i++){t=e.charCodeAt(i);if((t&64512)===55296&&i+1<f){a=e.charCodeAt(i+1);if((a&64512)===56320){t=65536+(t-55296<<10)+(a-56320);i++}}o+=t<128?1:t<2048?2:t<65536?3:4}if(n.uint8array){r=new Uint8Array(o)}else{r=new Array(o)}for(s=0,i=0;s<o;i++){t=e.charCodeAt(i);if((t&64512)===55296&&i+1<f){a=e.charCodeAt(i+1);if((a&64512)===56320){t=65536+(t-55296<<10)+(a-56320);i++}}if(t<128){r[s++]=t}else if(t<2048){r[s++]=192|t>>>6;r[s++]=128|t&63}else if(t<65536){r[s++]=224|t>>>12;r[s++]=128|t>>>6&63;r[s++]=128|t&63}else{r[s++]=240|t>>>18;r[s++]=128|t>>>12&63;r[s++]=128|t>>>6&63;r[s++]=128|t&63}}return r};var l=function(e,r){var t;r=r||e.length;if(r>e.length){r=e.length}t=r-1;while(t>=0&&(e[t]&192)===128){t--}if(t<0){return r}if(t===0){return r}return t+s[e[t]]>r?t:r};var c=function(e){var r,t,n,i,f;var o=e.length;var l=new Array(o*2);for(n=0,t=0;t<o;){i=e[t++];if(i<128){l[n++]=i;continue}f=s[i];if(f>4){l[n++]=65533;t+=f-1;continue}i&=f===2?31:f===3?15:7;while(f>1&&t<o){i=i<<6|e[t++]&63;f--}if(f>1){l[n++]=65533;continue}if(i<65536){l[n++]=i}else{i-=65536;l[n++]=55296|i>>10&1023;l[n++]=56320|i&1023}}if(l.length!==n){if(l.subarray){l=l.subarray(0,n)}else{l.length=n}}return a.applyFromCharCode(l)};t.utf8encode=function h(e){if(n.nodebuffer){return i(e,"utf-8")}return o(e)};t.utf8decode=function u(e){if(n.nodebuffer){return a.transformTo("nodebuffer",e).toString("utf-8")}e=a.transformTo(n.uint8array?"uint8array":"array",e);var r=[],t=0,i=e.length,s=65536;while(t<i){var f=l(e,Math.min(t+s,i));if(n.uint8array){r.push(c(e.subarray(t,f)))}else{r.push(c(e.slice(t,f)))}t=f}return r.join("")}},{"./nodeBuffer":11,"./support":17,"./utils":21}],21:[function(e,r,t){"use strict";var a=e("./support");var n=e("./compressions");var i=e("./nodeBuffer");t.string2binary=function(e){var r="";for(var t=0;t<e.length;t++){r+=String.fromCharCode(e.charCodeAt(t)&255)}return r};t.arrayBuffer2Blob=function(e){t.checkSupport("blob");try{return new Blob([e],{type:"application/zip"})}catch(r){try{var a=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder||window.MSBlobBuilder;var n=new a;n.append(e);return n.getBlob("application/zip")}catch(r){throw new Error("Bug : can't construct the Blob.")}}};function s(e){return e}function f(e,r){for(var t=0;t<e.length;++t){r[t]=e.charCodeAt(t)&255}return r}function o(e){var r=65536;var a=[],n=e.length,s=t.getTypeOf(e),f=0,o=true;try{switch(s){case"uint8array":String.fromCharCode.apply(null,new Uint8Array(0));break;case"nodebuffer":String.fromCharCode.apply(null,i(0));break;}}catch(l){o=false}if(!o){var c="";for(var h=0;h<e.length;h++){c+=String.fromCharCode(e[h])}return c}while(f<n&&r>1){try{if(s==="array"||s==="nodebuffer"){a.push(String.fromCharCode.apply(null,e.slice(f,Math.min(f+r,n))))}else{a.push(String.fromCharCode.apply(null,e.subarray(f,Math.min(f+r,n))))}f+=r}catch(l){r=Math.floor(r/2)}}return a.join("")}t.applyFromCharCode=o;function l(e,r){for(var t=0;t<e.length;t++){r[t]=e[t]}return r}var c={};c["string"]={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return c["string"]["uint8array"](e).buffer},uint8array:function(e){return f(e,new Uint8Array(e.length))},nodebuffer:function(e){return f(e,i(e.length))}};c["array"]={string:o,array:s,arraybuffer:function(e){return new Uint8Array(e).buffer},uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return i(e)}};c["arraybuffer"]={string:function(e){return o(new Uint8Array(e))},array:function(e){return l(new Uint8Array(e),new Array(e.byteLength))},arraybuffer:s,uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return i(new Uint8Array(e))}};c["uint8array"]={string:o,array:function(e){return l(e,new Array(e.length))},arraybuffer:function(e){return e.buffer},uint8array:s,nodebuffer:function(e){return i(e)}};c["nodebuffer"]={string:o,array:function(e){return l(e,new Array(e.length))},arraybuffer:function(e){return c["nodebuffer"]["uint8array"](e).buffer},uint8array:function(e){return l(e,new Uint8Array(e.length))},nodebuffer:s};t.transformTo=function(e,r){if(!r){r=""}if(!e){return r}t.checkSupport(e);var a=t.getTypeOf(r);var n=c[a][e](r);return n};t.getTypeOf=function(e){if(typeof e==="string"){return"string"}if(Object.prototype.toString.call(e)==="[object Array]"){return"array"}if(a.nodebuffer&&i.test(e)){return"nodebuffer"}if(a.uint8array&&e instanceof Uint8Array){return"uint8array"}if(a.arraybuffer&&e instanceof ArrayBuffer){return"arraybuffer"}};t.checkSupport=function(e){var r=a[e.toLowerCase()];if(!r){throw new Error(e+" is not supported by this browser")}};t.MAX_VALUE_16BITS=65535;t.MAX_VALUE_32BITS=-1;t.pretty=function(e){var r="",t,a;for(a=0;a<(e||"").length;a++){t=e.charCodeAt(a);r+="\\x"+(t<16?"0":"")+t.toString(16).toUpperCase()}return r};t.findCompression=function(e){for(var r in n){if(!n.hasOwnProperty(r)){continue}if(n[r].magic===e){return n[r]}}return null};t.isRegExp=function(e){return Object.prototype.toString.call(e)==="[object RegExp]"}},{"./compressions":3,"./nodeBuffer":11,"./support":17}],22:[function(e,r,t){"use strict";var a=e("./stringReader");var n=e("./nodeBufferReader");var i=e("./uint8ArrayReader");var s=e("./utils");var f=e("./signature");var o=e("./zipEntry");var l=e("./support");var c=e("./object");function h(e,r){this.files=[];this.loadOptions=r;if(e){this.load(e)}}h.prototype={checkSignature:function(e){var r=this.reader.readString(4);if(r!==e){throw new Error("Corrupted zip or bug : unexpected signature "+"("+s.pretty(r)+", expected "+s.pretty(e)+")")}},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2);this.diskWithCentralDirStart=this.reader.readInt(2);this.centralDirRecordsOnThisDisk=this.reader.readInt(2);this.centralDirRecords=this.reader.readInt(2);this.centralDirSize=this.reader.readInt(4);this.centralDirOffset=this.reader.readInt(4);this.zipCommentLength=this.reader.readInt(2);this.zipComment=this.reader.readString(this.zipCommentLength);this.zipComment=c.utf8decode(this.zipComment)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8);this.versionMadeBy=this.reader.readString(2);this.versionNeeded=this.reader.readInt(2);this.diskNumber=this.reader.readInt(4);this.diskWithCentralDirStart=this.reader.readInt(4);this.centralDirRecordsOnThisDisk=this.reader.readInt(8);this.centralDirRecords=this.reader.readInt(8);this.centralDirSize=this.reader.readInt(8);this.centralDirOffset=this.reader.readInt(8);this.zip64ExtensibleData={};var e=this.zip64EndOfCentralSize-44,r=0,t,a,n;while(r<e){t=this.reader.readInt(2);a=this.reader.readInt(4);n=this.reader.readString(a);this.zip64ExtensibleData[t]={id:t,length:a,value:n}}},readBlockZip64EndOfCentralLocator:function(){this.diskWithZip64CentralDirStart=this.reader.readInt(4);this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8);this.disksCount=this.reader.readInt(4);if(this.disksCount>1){throw new Error("Multi-volumes zip are not supported")}},readLocalFiles:function(){var e,r;for(e=0;e<this.files.length;e++){r=this.files[e];this.reader.setIndex(r.localHeaderOffset);this.checkSignature(f.LOCAL_FILE_HEADER);r.readLocalPart(this.reader);r.handleUTF8()}},readCentralDir:function(){var e;this.reader.setIndex(this.centralDirOffset);while(this.reader.readString(4)===f.CENTRAL_FILE_HEADER){e=new o({zip64:this.zip64},this.loadOptions);e.readCentralPart(this.reader);this.files.push(e)}},readEndOfCentral:function(){var e=this.reader.lastIndexOfSignature(f.CENTRAL_DIRECTORY_END);if(e===-1){throw new Error("Corrupted zip : can't find end of central directory")}this.reader.setIndex(e);this.checkSignature(f.CENTRAL_DIRECTORY_END);this.readBlockEndOfCentral();if(this.diskNumber===s.MAX_VALUE_16BITS||this.diskWithCentralDirStart===s.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===s.MAX_VALUE_16BITS||this.centralDirRecords===s.MAX_VALUE_16BITS||this.centralDirSize===s.MAX_VALUE_32BITS||this.centralDirOffset===s.MAX_VALUE_32BITS){this.zip64=true;e=this.reader.lastIndexOfSignature(f.ZIP64_CENTRAL_DIRECTORY_LOCATOR);if(e===-1){throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator")}this.reader.setIndex(e);this.checkSignature(f.ZIP64_CENTRAL_DIRECTORY_LOCATOR);this.readBlockZip64EndOfCentralLocator();this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);this.checkSignature(f.ZIP64_CENTRAL_DIRECTORY_END);this.readBlockZip64EndOfCentral()}},prepareReader:function(e){var r=s.getTypeOf(e);if(r==="string"&&!l.uint8array){this.reader=new a(e,this.loadOptions.optimizedBinaryString)}else if(r==="nodebuffer"){this.reader=new n(e)}else{this.reader=new i(s.transformTo("uint8array",e))}},load:function(e){this.prepareReader(e);this.readEndOfCentral();this.readCentralDir();this.readLocalFiles()}};r.exports=h},{"./nodeBufferReader":12,"./object":13,"./signature":14,"./stringReader":15,"./support":17,"./uint8ArrayReader":18,"./utils":21,"./zipEntry":23}],23:[function(e,r,t){"use strict";var a=e("./stringReader");var n=e("./utils");var i=e("./compressedObject");var s=e("./object");function f(e,r){this.options=e;this.loadOptions=r}f.prototype={isEncrypted:function(){return(this.bitFlag&1)===1},useUTF8:function(){return(this.bitFlag&2048)===2048},prepareCompressedContent:function(e,r,t){return function(){var a=e.index;e.setIndex(r);var n=e.readData(t);e.setIndex(a);return n}},prepareContent:function(e,r,t,a,i){return function(){var e=n.transformTo(a.uncompressInputType,this.getCompressedContent());var r=a.uncompress(e);if(r.length!==i){throw new Error("Bug : uncompressed data size mismatch")}return r}},readLocalPart:function(e){var r,t;e.skip(22);this.fileNameLength=e.readInt(2);t=e.readInt(2);this.fileName=e.readString(this.fileNameLength);e.skip(t);if(this.compressedSize==-1||this.uncompressedSize==-1){throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory "+"(compressedSize == -1 || uncompressedSize == -1)")}r=n.findCompression(this.compressionMethod);if(r===null){throw new Error("Corrupted zip : compression "+n.pretty(this.compressionMethod)+" unknown (inner file : "+this.fileName+")")}this.decompressed=new i;this.decompressed.compressedSize=this.compressedSize;this.decompressed.uncompressedSize=this.uncompressedSize;this.decompressed.crc32=this.crc32;this.decompressed.compressionMethod=this.compressionMethod;this.decompressed.getCompressedContent=this.prepareCompressedContent(e,e.index,this.compressedSize,r);this.decompressed.getContent=this.prepareContent(e,e.index,this.compressedSize,r,this.uncompressedSize);if(this.loadOptions.checkCRC32){this.decompressed=n.transformTo("string",this.decompressed.getContent());if(s.crc32(this.decompressed)!==this.crc32){throw new Error("Corrupted zip : CRC32 mismatch")}}},readCentralPart:function(e){this.versionMadeBy=e.readString(2);this.versionNeeded=e.readInt(2);this.bitFlag=e.readInt(2);this.compressionMethod=e.readString(2);this.date=e.readDate();this.crc32=e.readInt(4);this.compressedSize=e.readInt(4);this.uncompressedSize=e.readInt(4);this.fileNameLength=e.readInt(2);this.extraFieldsLength=e.readInt(2);this.fileCommentLength=e.readInt(2);this.diskNumberStart=e.readInt(2);this.internalFileAttributes=e.readInt(2);this.externalFileAttributes=e.readInt(4);this.localHeaderOffset=e.readInt(4);if(this.isEncrypted()){throw new Error("Encrypted zip are not supported")}this.fileName=e.readString(this.fileNameLength);this.readExtraFields(e);this.parseZIP64ExtraField(e);this.fileComment=e.readString(this.fileCommentLength);this.dir=this.externalFileAttributes&16?true:false},parseZIP64ExtraField:function(e){if(!this.extraFields[1]){return}var r=new a(this.extraFields[1].value);if(this.uncompressedSize===n.MAX_VALUE_32BITS){this.uncompressedSize=r.readInt(8)}if(this.compressedSize===n.MAX_VALUE_32BITS){this.compressedSize=r.readInt(8)}if(this.localHeaderOffset===n.MAX_VALUE_32BITS){this.localHeaderOffset=r.readInt(8)}if(this.diskNumberStart===n.MAX_VALUE_32BITS){this.diskNumberStart=r.readInt(4)}},readExtraFields:function(e){var r=e.index,t,a,n;this.extraFields=this.extraFields||{};while(e.index<r+this.extraFieldsLength){t=e.readInt(2);a=e.readInt(2);n=e.readString(a);this.extraFields[t]={id:t,length:a,value:n}}},handleUTF8:function(){if(this.useUTF8()){this.fileName=s.utf8decode(this.fileName);this.fileComment=s.utf8decode(this.fileComment)}else{var e=this.findExtraFieldUnicodePath();if(e!==null){this.fileName=e}var r=this.findExtraFieldUnicodeComment();if(r!==null){this.fileComment=r}}},findExtraFieldUnicodePath:function(){var e=this.extraFields[28789];if(e){var r=new a(e.value);if(r.readInt(1)!==1){return null}if(s.crc32(this.fileName)!==r.readInt(4)){
return null}return s.utf8decode(r.readString(e.length-5))}return null},findExtraFieldUnicodeComment:function(){var e=this.extraFields[25461];if(e){var r=new a(e.value);if(r.readInt(1)!==1){return null}if(s.crc32(this.fileComment)!==r.readInt(4)){return null}return s.utf8decode(r.readString(e.length-5))}return null}};r.exports=f},{"./compressedObject":2,"./object":13,"./stringReader":15,"./utils":21}],24:[function(e,r,t){"use strict";var a=e("./lib/utils/common").assign;var n=e("./lib/deflate");var i=e("./lib/inflate");var s=e("./lib/zlib/constants");var f={};a(f,n,i,s);r.exports=f},{"./lib/deflate":25,"./lib/inflate":26,"./lib/utils/common":27,"./lib/zlib/constants":30}],25:[function(e,r,t){"use strict";var a=e("./zlib/deflate.js");var n=e("./utils/common");var i=e("./utils/strings");var s=e("./zlib/messages");var f=e("./zlib/zstream");var o=0;var l=4;var c=0;var h=1;var u=-1;var d=0;var p=8;var v=function(e){this.options=n.assign({level:u,method:p,chunkSize:16384,windowBits:15,memLevel:8,strategy:d,to:""},e||{});var r=this.options;if(r.raw&&r.windowBits>0){r.windowBits=-r.windowBits}else if(r.gzip&&r.windowBits>0&&r.windowBits<16){r.windowBits+=16}this.err=0;this.msg="";this.ended=false;this.chunks=[];this.strm=new f;this.strm.avail_out=0;var t=a.deflateInit2(this.strm,r.level,r.method,r.windowBits,r.memLevel,r.strategy);if(t!==c){throw new Error(s[t])}if(r.header){a.deflateSetHeader(this.strm,r.header)}};v.prototype.push=function(e,r){var t=this.strm;var s=this.options.chunkSize;var f,u;if(this.ended){return false}u=r===~~r?r:r===true?l:o;if(typeof e==="string"){t.input=i.string2buf(e)}else{t.input=e}t.next_in=0;t.avail_in=t.input.length;do{if(t.avail_out===0){t.output=new n.Buf8(s);t.next_out=0;t.avail_out=s}f=a.deflate(t,u);if(f!==h&&f!==c){this.onEnd(f);this.ended=true;return false}if(t.avail_out===0||t.avail_in===0&&u===l){if(this.options.to==="string"){this.onData(i.buf2binstring(n.shrinkBuf(t.output,t.next_out)))}else{this.onData(n.shrinkBuf(t.output,t.next_out))}}}while((t.avail_in>0||t.avail_out===0)&&f!==h);if(u===l){f=a.deflateEnd(this.strm);this.onEnd(f);this.ended=true;return f===c}return true};v.prototype.onData=function(e){this.chunks.push(e)};v.prototype.onEnd=function(e){if(e===c){if(this.options.to==="string"){this.result=this.chunks.join("")}else{this.result=n.flattenChunks(this.chunks)}}this.chunks=[];this.err=e;this.msg=this.strm.msg};function g(e,r){var t=new v(r);t.push(e,true);if(t.err){throw t.msg}return t.result}function m(e,r){r=r||{};r.raw=true;return g(e,r)}function b(e,r){r=r||{};r.gzip=true;return g(e,r)}t.Deflate=v;t.deflate=g;t.deflateRaw=m;t.gzip=b},{"./utils/common":27,"./utils/strings":28,"./zlib/deflate.js":32,"./zlib/messages":37,"./zlib/zstream":39}],26:[function(e,r,t){"use strict";var a=e("./zlib/inflate.js");var n=e("./utils/common");var i=e("./utils/strings");var s=e("./zlib/constants");var f=e("./zlib/messages");var o=e("./zlib/zstream");var l=e("./zlib/gzheader");var c=function(e){this.options=n.assign({chunkSize:16384,windowBits:0,to:""},e||{});var r=this.options;if(r.raw&&r.windowBits>=0&&r.windowBits<16){r.windowBits=-r.windowBits;if(r.windowBits===0){r.windowBits=-15}}if(r.windowBits>=0&&r.windowBits<16&&!(e&&e.windowBits)){r.windowBits+=32}if(r.windowBits>15&&r.windowBits<48){if((r.windowBits&15)===0){r.windowBits|=15}}this.err=0;this.msg="";this.ended=false;this.chunks=[];this.strm=new o;this.strm.avail_out=0;var t=a.inflateInit2(this.strm,r.windowBits);if(t!==s.Z_OK){throw new Error(f[t])}this.header=new l;a.inflateGetHeader(this.strm,this.header)};c.prototype.push=function(e,r){var t=this.strm;var f=this.options.chunkSize;var o,l;var c,h,u;if(this.ended){return false}l=r===~~r?r:r===true?s.Z_FINISH:s.Z_NO_FLUSH;if(typeof e==="string"){t.input=i.binstring2buf(e)}else{t.input=e}t.next_in=0;t.avail_in=t.input.length;do{if(t.avail_out===0){t.output=new n.Buf8(f);t.next_out=0;t.avail_out=f}o=a.inflate(t,s.Z_NO_FLUSH);if(o!==s.Z_STREAM_END&&o!==s.Z_OK){this.onEnd(o);this.ended=true;return false}if(t.next_out){if(t.avail_out===0||o===s.Z_STREAM_END||t.avail_in===0&&l===s.Z_FINISH){if(this.options.to==="string"){c=i.utf8border(t.output,t.next_out);h=t.next_out-c;u=i.buf2string(t.output,c);t.next_out=h;t.avail_out=f-h;if(h){n.arraySet(t.output,t.output,c,h,0)}this.onData(u)}else{this.onData(n.shrinkBuf(t.output,t.next_out))}}}}while(t.avail_in>0&&o!==s.Z_STREAM_END);if(o===s.Z_STREAM_END){l=s.Z_FINISH}if(l===s.Z_FINISH){o=a.inflateEnd(this.strm);this.onEnd(o);this.ended=true;return o===s.Z_OK}return true};c.prototype.onData=function(e){this.chunks.push(e)};c.prototype.onEnd=function(e){if(e===s.Z_OK){if(this.options.to==="string"){this.result=this.chunks.join("")}else{this.result=n.flattenChunks(this.chunks)}}this.chunks=[];this.err=e;this.msg=this.strm.msg};function h(e,r){var t=new c(r);t.push(e,true);if(t.err){throw t.msg}return t.result}function u(e,r){r=r||{};r.raw=true;return h(e,r)}t.Inflate=c;t.inflate=h;t.inflateRaw=u;t.ungzip=h},{"./utils/common":27,"./utils/strings":28,"./zlib/constants":30,"./zlib/gzheader":33,"./zlib/inflate.js":35,"./zlib/messages":37,"./zlib/zstream":39}],27:[function(e,r,t){"use strict";var a=typeof Uint8Array!=="undefined"&&typeof Uint16Array!=="undefined"&&typeof Int32Array!=="undefined";t.assign=function(e){var r=Array.prototype.slice.call(arguments,1);while(r.length){var t=r.shift();if(!t){continue}if(typeof t!=="object"){throw new TypeError(t+"must be non-object")}for(var a in t){if(t.hasOwnProperty(a)){e[a]=t[a]}}}return e};t.shrinkBuf=function(e,r){if(e.length===r){return e}if(e.subarray){return e.subarray(0,r)}e.length=r;return e};var n={arraySet:function(e,r,t,a,n){if(r.subarray&&e.subarray){e.set(r.subarray(t,t+a),n);return}for(var i=0;i<a;i++){e[n+i]=r[t+i]}},flattenChunks:function(e){var r,t,a,n,i,s;a=0;for(r=0,t=e.length;r<t;r++){a+=e[r].length}s=new Uint8Array(a);n=0;for(r=0,t=e.length;r<t;r++){i=e[r];s.set(i,n);n+=i.length}return s}};var i={arraySet:function(e,r,t,a,n){for(var i=0;i<a;i++){e[n+i]=r[t+i]}},flattenChunks:function(e){return[].concat.apply([],e)}};t.setTyped=function(e){if(e){t.Buf8=Uint8Array;t.Buf16=Uint16Array;t.Buf32=Int32Array;t.assign(t,n)}else{t.Buf8=Array;t.Buf16=Array;t.Buf32=Array;t.assign(t,i)}};t.setTyped(a)},{}],28:[function(e,r,t){"use strict";var a=e("./common");var n=true;var i=true;try{String.fromCharCode.apply(null,[0])}catch(s){n=false}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(s){i=false}var f=new a.Buf8(256);for(var o=0;o<256;o++){f[o]=o>=252?6:o>=248?5:o>=240?4:o>=224?3:o>=192?2:1}f[254]=f[254]=1;t.string2buf=function(e){var r,t,n,i,s,f=e.length,o=0;for(i=0;i<f;i++){t=e.charCodeAt(i);if((t&64512)===55296&&i+1<f){n=e.charCodeAt(i+1);if((n&64512)===56320){t=65536+(t-55296<<10)+(n-56320);i++}}o+=t<128?1:t<2048?2:t<65536?3:4}r=new a.Buf8(o);for(s=0,i=0;s<o;i++){t=e.charCodeAt(i);if((t&64512)===55296&&i+1<f){n=e.charCodeAt(i+1);if((n&64512)===56320){t=65536+(t-55296<<10)+(n-56320);i++}}if(t<128){r[s++]=t}else if(t<2048){r[s++]=192|t>>>6;r[s++]=128|t&63}else if(t<65536){r[s++]=224|t>>>12;r[s++]=128|t>>>6&63;r[s++]=128|t&63}else{r[s++]=240|t>>>18;r[s++]=128|t>>>12&63;r[s++]=128|t>>>6&63;r[s++]=128|t&63}}return r};function l(e,r){if(r<65537){if(e.subarray&&i||!e.subarray&&n){return String.fromCharCode.apply(null,a.shrinkBuf(e,r))}}var t="";for(var s=0;s<r;s++){t+=String.fromCharCode(e[s])}return t}t.buf2binstring=function(e){return l(e,e.length)};t.binstring2buf=function(e){var r=new a.Buf8(e.length);for(var t=0,n=r.length;t<n;t++){r[t]=e.charCodeAt(t)}return r};t.buf2string=function(e,r){var t,a,n,i;var s=r||e.length;var o=new Array(s*2);for(a=0,t=0;t<s;){n=e[t++];if(n<128){o[a++]=n;continue}i=f[n];if(i>4){o[a++]=65533;t+=i-1;continue}n&=i===2?31:i===3?15:7;while(i>1&&t<s){n=n<<6|e[t++]&63;i--}if(i>1){o[a++]=65533;continue}if(n<65536){o[a++]=n}else{n-=65536;o[a++]=55296|n>>10&1023;o[a++]=56320|n&1023}}return l(o,a)};t.utf8border=function(e,r){var t;r=r||e.length;if(r>e.length){r=e.length}t=r-1;while(t>=0&&(e[t]&192)===128){t--}if(t<0){return r}if(t===0){return r}return t+f[e[t]]>r?t:r}},{"./common":27}],29:[function(e,r,t){"use strict";function a(e,r,t,a){var n=e&65535|0,i=e>>>16&65535|0,s=0;while(t!==0){s=t>2e3?2e3:t;t-=s;do{n=n+r[a++]|0;i=i+n|0}while(--s);n%=65521;i%=65521}return n|i<<16|0}r.exports=a},{}],30:[function(e,r,t){r.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},{}],31:[function(e,r,t){"use strict";function a(){var e,r=[];for(var t=0;t<256;t++){e=t;for(var a=0;a<8;a++){e=e&1?3988292384^e>>>1:e>>>1}r[t]=e}return r}var n=a();function i(e,r,t,a){var i=n,s=a+t;e=e^-1;for(var f=a;f<s;f++){e=e>>>8^i[(e^r[f])&255]}return e^-1}r.exports=i},{}],32:[function(e,r,t){"use strict";var a=e("../utils/common");var n=e("./trees");var i=e("./adler32");var s=e("./crc32");var f=e("./messages");var o=0;var l=1;var c=3;var h=4;var u=5;var d=0;var p=1;var v=-2;var g=-3;var m=-5;var b=-1;var w=1;var C=2;var E=3;var k=4;var S=0;var A=2;var _=8;var B=9;var T=15;var y=8;var x=29;var I=256;var R=I+1+x;var D=30;var O=19;var F=2*R+1;var P=15;var N=3;var L=258;var M=L+N+1;var U=32;var H=42;var W=69;var V=73;var z=91;var X=103;var G=113;var j=666;var K=1;var Y=2;var $=3;var Z=4;var Q=3;function J(e,r){e.msg=f[r];return r}function q(e){return(e<<1)-(e>4?9:0)}function ee(e){var r=e.length;while(--r>=0){e[r]=0}}function re(e){var r=e.state;var t=r.pending;if(t>e.avail_out){t=e.avail_out}if(t===0){return}a.arraySet(e.output,r.pending_buf,r.pending_out,t,e.next_out);e.next_out+=t;r.pending_out+=t;e.total_out+=t;e.avail_out-=t;r.pending-=t;if(r.pending===0){r.pending_out=0}}function te(e,r){n._tr_flush_block(e,e.block_start>=0?e.block_start:-1,e.strstart-e.block_start,r);e.block_start=e.strstart;re(e.strm)}function ae(e,r){e.pending_buf[e.pending++]=r}function ne(e,r){e.pending_buf[e.pending++]=r>>>8&255;e.pending_buf[e.pending++]=r&255}function ie(e,r,t,n){var f=e.avail_in;if(f>n){f=n}if(f===0){return 0}e.avail_in-=f;a.arraySet(r,e.input,e.next_in,f,t);if(e.state.wrap===1){e.adler=i(e.adler,r,f,t)}else if(e.state.wrap===2){e.adler=s(e.adler,r,f,t)}e.next_in+=f;e.total_in+=f;return f}function se(e,r){var t=e.max_chain_length;var a=e.strstart;var n;var i;var s=e.prev_length;var f=e.nice_match;var o=e.strstart>e.w_size-M?e.strstart-(e.w_size-M):0;var l=e.window;var c=e.w_mask;var h=e.prev;var u=e.strstart+L;var d=l[a+s-1];var p=l[a+s];if(e.prev_length>=e.good_match){t>>=2}if(f>e.lookahead){f=e.lookahead}do{n=r;if(l[n+s]!==p||l[n+s-1]!==d||l[n]!==l[a]||l[++n]!==l[a+1]){continue}a+=2;n++;do{}while(l[++a]===l[++n]&&l[++a]===l[++n]&&l[++a]===l[++n]&&l[++a]===l[++n]&&l[++a]===l[++n]&&l[++a]===l[++n]&&l[++a]===l[++n]&&l[++a]===l[++n]&&a<u);i=L-(u-a);a=u-L;if(i>s){e.match_start=r;s=i;if(i>=f){break}d=l[a+s-1];p=l[a+s]}}while((r=h[r&c])>o&&--t!==0);if(s<=e.lookahead){return s}return e.lookahead}function fe(e){var r=e.w_size;var t,n,i,s,f;do{s=e.window_size-e.lookahead-e.strstart;if(e.strstart>=r+(r-M)){a.arraySet(e.window,e.window,r,r,0);e.match_start-=r;e.strstart-=r;e.block_start-=r;n=e.hash_size;t=n;do{i=e.head[--t];e.head[t]=i>=r?i-r:0}while(--n);n=r;t=n;do{i=e.prev[--t];e.prev[t]=i>=r?i-r:0}while(--n);s+=r}if(e.strm.avail_in===0){break}n=ie(e.strm,e.window,e.strstart+e.lookahead,s);e.lookahead+=n;if(e.lookahead+e.insert>=N){f=e.strstart-e.insert;e.ins_h=e.window[f];e.ins_h=(e.ins_h<<e.hash_shift^e.window[f+1])&e.hash_mask;while(e.insert){e.ins_h=(e.ins_h<<e.hash_shift^e.window[f+N-1])&e.hash_mask;e.prev[f&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=f;f++;e.insert--;if(e.lookahead+e.insert<N){break}}}}while(e.lookahead<M&&e.strm.avail_in!==0)}function oe(e,r){var t=65535;if(t>e.pending_buf_size-5){t=e.pending_buf_size-5}for(;;){if(e.lookahead<=1){fe(e);if(e.lookahead===0&&r===o){return K}if(e.lookahead===0){break}}e.strstart+=e.lookahead;e.lookahead=0;var a=e.block_start+t;if(e.strstart===0||e.strstart>=a){e.lookahead=e.strstart-a;e.strstart=a;te(e,false);if(e.strm.avail_out===0){return K}}if(e.strstart-e.block_start>=e.w_size-M){te(e,false);if(e.strm.avail_out===0){return K}}}e.insert=0;if(r===h){te(e,true);if(e.strm.avail_out===0){return $}return Z}if(e.strstart>e.block_start){te(e,false);if(e.strm.avail_out===0){return K}}return K}function le(e,r){var t;var a;for(;;){if(e.lookahead<M){fe(e);if(e.lookahead<M&&r===o){return K}if(e.lookahead===0){break}}t=0;if(e.lookahead>=N){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+N-1])&e.hash_mask;t=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}if(t!==0&&e.strstart-t<=e.w_size-M){e.match_length=se(e,t)}if(e.match_length>=N){a=n._tr_tally(e,e.strstart-e.match_start,e.match_length-N);e.lookahead-=e.match_length;if(e.match_length<=e.max_lazy_match&&e.lookahead>=N){e.match_length--;do{e.strstart++;e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+N-1])&e.hash_mask;t=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}while(--e.match_length!==0);e.strstart++}else{e.strstart+=e.match_length;e.match_length=0;e.ins_h=e.window[e.strstart];e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask}}else{a=n._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++}if(a){te(e,false);if(e.strm.avail_out===0){return K}}}e.insert=e.strstart<N-1?e.strstart:N-1;if(r===h){te(e,true);if(e.strm.avail_out===0){return $}return Z}if(e.last_lit){te(e,false);if(e.strm.avail_out===0){return K}}return Y}function ce(e,r){var t;var a;var i;for(;;){if(e.lookahead<M){fe(e);if(e.lookahead<M&&r===o){return K}if(e.lookahead===0){break}}t=0;if(e.lookahead>=N){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+N-1])&e.hash_mask;t=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}e.prev_length=e.match_length;e.prev_match=e.match_start;e.match_length=N-1;if(t!==0&&e.prev_length<e.max_lazy_match&&e.strstart-t<=e.w_size-M){e.match_length=se(e,t);if(e.match_length<=5&&(e.strategy===w||e.match_length===N&&e.strstart-e.match_start>4096)){e.match_length=N-1}}if(e.prev_length>=N&&e.match_length<=e.prev_length){i=e.strstart+e.lookahead-N;a=n._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-N);e.lookahead-=e.prev_length-1;e.prev_length-=2;do{if(++e.strstart<=i){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+N-1])&e.hash_mask;t=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}}while(--e.prev_length!==0);e.match_available=0;e.match_length=N-1;e.strstart++;if(a){te(e,false);if(e.strm.avail_out===0){return K}}}else if(e.match_available){a=n._tr_tally(e,0,e.window[e.strstart-1]);if(a){te(e,false)}e.strstart++;e.lookahead--;if(e.strm.avail_out===0){return K}}else{e.match_available=1;e.strstart++;e.lookahead--}}if(e.match_available){a=n._tr_tally(e,0,e.window[e.strstart-1]);e.match_available=0}e.insert=e.strstart<N-1?e.strstart:N-1;if(r===h){te(e,true);if(e.strm.avail_out===0){return $}return Z}if(e.last_lit){te(e,false);if(e.strm.avail_out===0){return K}}return Y}function he(e,r){var t;var a;var i,s;var f=e.window;for(;;){if(e.lookahead<=L){fe(e);if(e.lookahead<=L&&r===o){return K}if(e.lookahead===0){break}}e.match_length=0;if(e.lookahead>=N&&e.strstart>0){i=e.strstart-1;a=f[i];if(a===f[++i]&&a===f[++i]&&a===f[++i]){s=e.strstart+L;do{}while(a===f[++i]&&a===f[++i]&&a===f[++i]&&a===f[++i]&&a===f[++i]&&a===f[++i]&&a===f[++i]&&a===f[++i]&&i<s);e.match_length=L-(s-i);if(e.match_length>e.lookahead){e.match_length=e.lookahead}}}if(e.match_length>=N){t=n._tr_tally(e,1,e.match_length-N);e.lookahead-=e.match_length;e.strstart+=e.match_length;e.match_length=0}else{t=n._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++}if(t){te(e,false);if(e.strm.avail_out===0){return K}}}e.insert=0;if(r===h){te(e,true);if(e.strm.avail_out===0){return $}return Z}if(e.last_lit){te(e,false);if(e.strm.avail_out===0){return K}}return Y}function ue(e,r){var t;for(;;){if(e.lookahead===0){fe(e);if(e.lookahead===0){if(r===o){return K}break}}e.match_length=0;t=n._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++;if(t){te(e,false);if(e.strm.avail_out===0){return K}}}e.insert=0;if(r===h){te(e,true);if(e.strm.avail_out===0){return $}return Z}if(e.last_lit){te(e,false);if(e.strm.avail_out===0){return K}}return Y}var de=function(e,r,t,a,n){this.good_length=e;this.max_lazy=r;this.nice_length=t;this.max_chain=a;this.func=n};var pe;pe=[new de(0,0,0,0,oe),new de(4,4,8,4,le),new de(4,5,16,8,le),new de(4,6,32,32,le),new de(4,4,16,16,ce),new de(8,16,32,32,ce),new de(8,16,128,128,ce),new de(8,32,128,256,ce),new de(32,128,258,1024,ce),new de(32,258,258,4096,ce)];function ve(e){e.window_size=2*e.w_size;ee(e.head);e.max_lazy_match=pe[e.level].max_lazy;e.good_match=pe[e.level].good_length;e.nice_match=pe[e.level].nice_length;e.max_chain_length=pe[e.level].max_chain;e.strstart=0;e.block_start=0;e.lookahead=0;e.insert=0;e.match_length=e.prev_length=N-1;e.match_available=0;e.ins_h=0}function ge(){this.strm=null;this.status=0;this.pending_buf=null;this.pending_buf_size=0;this.pending_out=0;this.pending=0;this.wrap=0;this.gzhead=null;this.gzindex=0;this.method=_;this.last_flush=-1;this.w_size=0;this.w_bits=0;this.w_mask=0;this.window=null;this.window_size=0;this.prev=null;this.head=null;this.ins_h=0;this.hash_size=0;this.hash_bits=0;this.hash_mask=0;this.hash_shift=0;this.block_start=0;this.match_length=0;this.prev_match=0;this.match_available=0;this.strstart=0;this.match_start=0;this.lookahead=0;this.prev_length=0;this.max_chain_length=0;this.max_lazy_match=0;this.level=0;this.strategy=0;this.good_match=0;this.nice_match=0;this.dyn_ltree=new a.Buf16(F*2);this.dyn_dtree=new a.Buf16((2*D+1)*2);this.bl_tree=new a.Buf16((2*O+1)*2);ee(this.dyn_ltree);ee(this.dyn_dtree);ee(this.bl_tree);this.l_desc=null;this.d_desc=null;this.bl_desc=null;this.bl_count=new a.Buf16(P+1);this.heap=new a.Buf16(2*R+1);ee(this.heap);this.heap_len=0;this.heap_max=0;this.depth=new a.Buf16(2*R+1);ee(this.depth);this.l_buf=0;this.lit_bufsize=0;this.last_lit=0;this.d_buf=0;this.opt_len=0;this.static_len=0;this.matches=0;this.insert=0;this.bi_buf=0;this.bi_valid=0}function me(e){var r;if(!e||!e.state){return J(e,v)}e.total_in=e.total_out=0;e.data_type=A;r=e.state;r.pending=0;r.pending_out=0;if(r.wrap<0){r.wrap=-r.wrap}r.status=r.wrap?H:G;e.adler=r.wrap===2?0:1;r.last_flush=o;n._tr_init(r);return d}function be(e){var r=me(e);if(r===d){ve(e.state)}return r}function we(e,r){if(!e||!e.state){return v}if(e.state.wrap!==2){return v}e.state.gzhead=r;return d}function Ce(e,r,t,n,i,s){if(!e){return v}var f=1;if(r===b){r=6}if(n<0){f=0;n=-n}else if(n>15){f=2;n-=16}if(i<1||i>B||t!==_||n<8||n>15||r<0||r>9||s<0||s>k){return J(e,v)}if(n===8){n=9}var o=new ge;e.state=o;o.strm=e;o.wrap=f;o.gzhead=null;o.w_bits=n;o.w_size=1<<o.w_bits;o.w_mask=o.w_size-1;o.hash_bits=i+7;o.hash_size=1<<o.hash_bits;o.hash_mask=o.hash_size-1;o.hash_shift=~~((o.hash_bits+N-1)/N);o.window=new a.Buf8(o.w_size*2);o.head=new a.Buf16(o.hash_size);o.prev=new a.Buf16(o.w_size);o.lit_bufsize=1<<i+6;o.pending_buf_size=o.lit_bufsize*4;o.pending_buf=new a.Buf8(o.pending_buf_size);o.d_buf=o.lit_bufsize>>1;o.l_buf=(1+2)*o.lit_bufsize;o.level=r;o.strategy=s;o.method=t;return be(e)}function Ee(e,r){return Ce(e,r,_,T,y,S)}function ke(e,r){var t,a;var i,f;if(!e||!e.state||r>u||r<0){return e?J(e,v):v}a=e.state;if(!e.output||!e.input&&e.avail_in!==0||a.status===j&&r!==h){return J(e,e.avail_out===0?m:v)}a.strm=e;t=a.last_flush;a.last_flush=r;if(a.status===H){if(a.wrap===2){e.adler=0;ae(a,31);ae(a,139);ae(a,8);if(!a.gzhead){ae(a,0);ae(a,0);ae(a,0);ae(a,0);ae(a,0);ae(a,a.level===9?2:a.strategy>=C||a.level<2?4:0);ae(a,Q);a.status=G}else{ae(a,(a.gzhead.text?1:0)+(a.gzhead.hcrc?2:0)+(!a.gzhead.extra?0:4)+(!a.gzhead.name?0:8)+(!a.gzhead.comment?0:16));ae(a,a.gzhead.time&255);ae(a,a.gzhead.time>>8&255);ae(a,a.gzhead.time>>16&255);ae(a,a.gzhead.time>>24&255);ae(a,a.level===9?2:a.strategy>=C||a.level<2?4:0);ae(a,a.gzhead.os&255);if(a.gzhead.extra&&a.gzhead.extra.length){ae(a,a.gzhead.extra.length&255);ae(a,a.gzhead.extra.length>>8&255)}if(a.gzhead.hcrc){e.adler=s(e.adler,a.pending_buf,a.pending,0)}a.gzindex=0;a.status=W}}else{var g=_+(a.w_bits-8<<4)<<8;var b=-1;if(a.strategy>=C||a.level<2){b=0}else if(a.level<6){b=1}else if(a.level===6){b=2}else{b=3}g|=b<<6;if(a.strstart!==0){g|=U}g+=31-g%31;a.status=G;ne(a,g);if(a.strstart!==0){ne(a,e.adler>>>16);ne(a,e.adler&65535)}e.adler=1}}if(a.status===W){if(a.gzhead.extra){i=a.pending;while(a.gzindex<(a.gzhead.extra.length&65535)){if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i){e.adler=s(e.adler,a.pending_buf,a.pending-i,i)}re(e);i=a.pending;if(a.pending===a.pending_buf_size){break}}ae(a,a.gzhead.extra[a.gzindex]&255);a.gzindex++}if(a.gzhead.hcrc&&a.pending>i){e.adler=s(e.adler,a.pending_buf,a.pending-i,i)}if(a.gzindex===a.gzhead.extra.length){a.gzindex=0;a.status=V}}else{a.status=V}}if(a.status===V){if(a.gzhead.name){i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i){e.adler=s(e.adler,a.pending_buf,a.pending-i,i)}re(e);i=a.pending;if(a.pending===a.pending_buf_size){f=1;break}}if(a.gzindex<a.gzhead.name.length){f=a.gzhead.name.charCodeAt(a.gzindex++)&255}else{f=0}ae(a,f)}while(f!==0);if(a.gzhead.hcrc&&a.pending>i){e.adler=s(e.adler,a.pending_buf,a.pending-i,i)}if(f===0){a.gzindex=0;a.status=z}}else{a.status=z}}if(a.status===z){if(a.gzhead.comment){i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i){e.adler=s(e.adler,a.pending_buf,a.pending-i,i)}re(e);i=a.pending;if(a.pending===a.pending_buf_size){f=1;break}}if(a.gzindex<a.gzhead.comment.length){f=a.gzhead.comment.charCodeAt(a.gzindex++)&255}else{f=0}ae(a,f)}while(f!==0);if(a.gzhead.hcrc&&a.pending>i){e.adler=s(e.adler,a.pending_buf,a.pending-i,i)}if(f===0){a.status=X}}else{a.status=X}}if(a.status===X){if(a.gzhead.hcrc){if(a.pending+2>a.pending_buf_size){re(e)}if(a.pending+2<=a.pending_buf_size){ae(a,e.adler&255);ae(a,e.adler>>8&255);e.adler=0;a.status=G}}else{a.status=G}}if(a.pending!==0){re(e);if(e.avail_out===0){a.last_flush=-1;return d}}else if(e.avail_in===0&&q(r)<=q(t)&&r!==h){return J(e,m)}if(a.status===j&&e.avail_in!==0){return J(e,m)}if(e.avail_in!==0||a.lookahead!==0||r!==o&&a.status!==j){var w=a.strategy===C?ue(a,r):a.strategy===E?he(a,r):pe[a.level].func(a,r);if(w===$||w===Z){a.status=j}if(w===K||w===$){if(e.avail_out===0){a.last_flush=-1}return d}if(w===Y){if(r===l){n._tr_align(a)}else if(r!==u){n._tr_stored_block(a,0,0,false);if(r===c){ee(a.head);if(a.lookahead===0){a.strstart=0;a.block_start=0;a.insert=0}}}re(e);if(e.avail_out===0){a.last_flush=-1;return d}}}if(r!==h){return d}if(a.wrap<=0){return p}if(a.wrap===2){ae(a,e.adler&255);ae(a,e.adler>>8&255);ae(a,e.adler>>16&255);ae(a,e.adler>>24&255);ae(a,e.total_in&255);ae(a,e.total_in>>8&255);ae(a,e.total_in>>16&255);ae(a,e.total_in>>24&255)}else{ne(a,e.adler>>>16);ne(a,e.adler&65535)}re(e);if(a.wrap>0){a.wrap=-a.wrap}return a.pending!==0?d:p}function Se(e){var r;if(!e||!e.state){return v}r=e.state.status;if(r!==H&&r!==W&&r!==V&&r!==z&&r!==X&&r!==G&&r!==j){return J(e,v)}e.state=null;return r===G?J(e,g):d}t.deflateInit=Ee;t.deflateInit2=Ce;t.deflateReset=be;t.deflateResetKeep=me;t.deflateSetHeader=we;t.deflate=ke;t.deflateEnd=Se;t.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":27,"./adler32":29,"./crc32":31,"./messages":37,"./trees":38}],33:[function(e,r,t){"use strict";function a(){this.text=0;this.time=0;this.xflags=0;this.os=0;this.extra=null;this.extra_len=0;this.name="";this.comment="";this.hcrc=0;this.done=false}r.exports=a},{}],34:[function(e,r,t){"use strict";var a=30;var n=12;r.exports=function i(e,r){var t;var i;var s;var f;var o;var l;var c;var h;var u;var d;var p;var v;var g;var m;var b;var w;var C;var E;var k;var S;var A;var _;var B;var T,y;t=e.state;i=e.next_in;T=e.input;s=i+(e.avail_in-5);f=e.next_out;y=e.output;o=f-(r-e.avail_out);l=f+(e.avail_out-257);c=t.dmax;h=t.wsize;u=t.whave;d=t.wnext;p=t.window;v=t.hold;g=t.bits;m=t.lencode;b=t.distcode;w=(1<<t.lenbits)-1;C=(1<<t.distbits)-1;e:do{if(g<15){v+=T[i++]<<g;g+=8;v+=T[i++]<<g;g+=8}E=m[v&w];r:for(;;){k=E>>>24;v>>>=k;g-=k;k=E>>>16&255;if(k===0){y[f++]=E&65535}else if(k&16){S=E&65535;k&=15;if(k){if(g<k){v+=T[i++]<<g;g+=8}S+=v&(1<<k)-1;v>>>=k;g-=k}if(g<15){v+=T[i++]<<g;g+=8;v+=T[i++]<<g;g+=8}E=b[v&C];t:for(;;){k=E>>>24;v>>>=k;g-=k;k=E>>>16&255;if(k&16){A=E&65535;k&=15;if(g<k){v+=T[i++]<<g;g+=8;if(g<k){v+=T[i++]<<g;g+=8}}A+=v&(1<<k)-1;if(A>c){e.msg="invalid distance too far back";t.mode=a;break e}v>>>=k;g-=k;k=f-o;if(A>k){k=A-k;if(k>u){if(t.sane){e.msg="invalid distance too far back";t.mode=a;break e}}_=0;B=p;if(d===0){_+=h-k;if(k<S){S-=k;do{y[f++]=p[_++]}while(--k);_=f-A;B=y}}else if(d<k){_+=h+d-k;k-=d;if(k<S){S-=k;do{y[f++]=p[_++]}while(--k);_=0;if(d<S){k=d;S-=k;do{y[f++]=p[_++]}while(--k);_=f-A;B=y}}}else{_+=d-k;if(k<S){S-=k;do{y[f++]=p[_++]}while(--k);_=f-A;B=y}}while(S>2){y[f++]=B[_++];y[f++]=B[_++];y[f++]=B[_++];S-=3}if(S){y[f++]=B[_++];if(S>1){y[f++]=B[_++]}}}else{_=f-A;do{y[f++]=y[_++];y[f++]=y[_++];y[f++]=y[_++];S-=3}while(S>2);if(S){y[f++]=y[_++];if(S>1){y[f++]=y[_++]}}}}else if((k&64)===0){E=b[(E&65535)+(v&(1<<k)-1)];continue t}else{e.msg="invalid distance code";t.mode=a;break e}break}}else if((k&64)===0){E=m[(E&65535)+(v&(1<<k)-1)];continue r}else if(k&32){t.mode=n;break e}else{e.msg="invalid literal/length code";t.mode=a;break e}break}}while(i<s&&f<l);S=g>>3;i-=S;g-=S<<3;v&=(1<<g)-1;e.next_in=i;e.next_out=f;e.avail_in=i<s?5+(s-i):5-(i-s);e.avail_out=f<l?257+(l-f):257-(f-l);t.hold=v;t.bits=g;return}},{}],35:[function(e,r,t){"use strict";var a=e("../utils/common");var n=e("./adler32");var i=e("./crc32");var s=e("./inffast");var f=e("./inftrees");var o=0;var l=1;var c=2;var h=4;var u=5;var d=6;var p=0;var v=1;var g=2;var m=-2;var b=-3;var w=-4;var C=-5;var E=8;var k=1;var S=2;var A=3;var _=4;var B=5;var T=6;var y=7;var x=8;var I=9;var R=10;var D=11;var O=12;var F=13;var P=14;var N=15;var L=16;var M=17;var U=18;var H=19;var W=20;var V=21;var z=22;var X=23;var G=24;var j=25;var K=26;var Y=27;var $=28;var Z=29;var Q=30;var J=31;var q=32;var ee=852;var re=592;var te=15;var ae=te;function ne(e){return(e>>>24&255)+(e>>>8&65280)+((e&65280)<<8)+((e&255)<<24)}function ie(){this.mode=0;this.last=false;this.wrap=0;this.havedict=false;this.flags=0;this.dmax=0;this.check=0;this.total=0;this.head=null;this.wbits=0;this.wsize=0;this.whave=0;this.wnext=0;this.window=null;this.hold=0;this.bits=0;this.length=0;this.offset=0;this.extra=0;this.lencode=null;this.distcode=null;this.lenbits=0;this.distbits=0;this.ncode=0;this.nlen=0;this.ndist=0;this.have=0;this.next=null;this.lens=new a.Buf16(320);this.work=new a.Buf16(288);this.lendyn=null;this.distdyn=null;this.sane=0;this.back=0;this.was=0}function se(e){var r;if(!e||!e.state){return m}r=e.state;e.total_in=e.total_out=r.total=0;e.msg="";if(r.wrap){e.adler=r.wrap&1}r.mode=k;r.last=0;r.havedict=0;r.dmax=32768;r.head=null;r.hold=0;r.bits=0;r.lencode=r.lendyn=new a.Buf32(ee);r.distcode=r.distdyn=new a.Buf32(re);r.sane=1;r.back=-1;return p}function fe(e){var r;if(!e||!e.state){return m}r=e.state;r.wsize=0;r.whave=0;r.wnext=0;return se(e)}function oe(e,r){var t;var a;if(!e||!e.state){return m}a=e.state;if(r<0){t=0;r=-r}else{t=(r>>4)+1;if(r<48){r&=15}}if(r&&(r<8||r>15)){return m}if(a.window!==null&&a.wbits!==r){a.window=null}a.wrap=t;a.wbits=r;return fe(e)}function le(e,r){var t;var a;if(!e){return m}a=new ie;e.state=a;a.window=null;t=oe(e,r);if(t!==p){e.state=null}return t}function ce(e){return le(e,ae)}var he=true;var ue,de;function pe(e){if(he){var r;ue=new a.Buf32(512);de=new a.Buf32(32);r=0;while(r<144){e.lens[r++]=8}while(r<256){e.lens[r++]=9}while(r<280){e.lens[r++]=7}while(r<288){e.lens[r++]=8}f(l,e.lens,0,288,ue,0,e.work,{bits:9});r=0;while(r<32){e.lens[r++]=5}f(c,e.lens,0,32,de,0,e.work,{bits:5});he=false}e.lencode=ue;e.lenbits=9;e.distcode=de;e.distbits=5}function ve(e,r,t,n){var i;var s=e.state;if(s.window===null){s.wsize=1<<s.wbits;s.wnext=0;s.whave=0;s.window=new a.Buf8(s.wsize)}if(n>=s.wsize){a.arraySet(s.window,r,t-s.wsize,s.wsize,0);s.wnext=0;s.whave=s.wsize}else{i=s.wsize-s.wnext;if(i>n){i=n}a.arraySet(s.window,r,t-n,i,s.wnext);n-=i;if(n){a.arraySet(s.window,r,t-n,n,0);s.wnext=n;s.whave=s.wsize}else{s.wnext+=i;if(s.wnext===s.wsize){s.wnext=0}if(s.whave<s.wsize){s.whave+=i}}}return 0}function ge(e,r){var t;var ee,re;var te;var ae;var ie,se;var fe;var oe;var le,ce;var he;var ue;var de;var ge=0;var me,be,we;var Ce,Ee,ke;var Se;var Ae;var _e=new a.Buf8(4);var Be;var Te;var ye=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&e.avail_in!==0){return m}t=e.state;if(t.mode===O){t.mode=F}ae=e.next_out;re=e.output;se=e.avail_out;te=e.next_in;ee=e.input;ie=e.avail_in;fe=t.hold;oe=t.bits;le=ie;ce=se;Ae=p;e:for(;;){switch(t.mode){case k:if(t.wrap===0){t.mode=F;break}while(oe<16){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(t.wrap&2&&fe===35615){t.check=0;_e[0]=fe&255;_e[1]=fe>>>8&255;t.check=i(t.check,_e,2,0);fe=0;oe=0;t.mode=S;break}t.flags=0;if(t.head){t.head.done=false}if(!(t.wrap&1)||(((fe&255)<<8)+(fe>>8))%31){e.msg="incorrect header check";t.mode=Q;break}if((fe&15)!==E){e.msg="unknown compression method";t.mode=Q;break}fe>>>=4;oe-=4;Se=(fe&15)+8;if(t.wbits===0){t.wbits=Se}else if(Se>t.wbits){e.msg="invalid window size";t.mode=Q;break}t.dmax=1<<Se;e.adler=t.check=1;t.mode=fe&512?R:O;fe=0;oe=0;break;case S:while(oe<16){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.flags=fe;if((t.flags&255)!==E){e.msg="unknown compression method";t.mode=Q;break}if(t.flags&57344){e.msg="unknown header flags set";t.mode=Q;break}if(t.head){t.head.text=fe>>8&1}if(t.flags&512){_e[0]=fe&255;_e[1]=fe>>>8&255;t.check=i(t.check,_e,2,0)}fe=0;oe=0;t.mode=A;case A:while(oe<32){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(t.head){t.head.time=fe}if(t.flags&512){_e[0]=fe&255;_e[1]=fe>>>8&255;_e[2]=fe>>>16&255;_e[3]=fe>>>24&255;t.check=i(t.check,_e,4,0)}fe=0;oe=0;t.mode=_;case _:while(oe<16){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(t.head){t.head.xflags=fe&255;t.head.os=fe>>8}if(t.flags&512){_e[0]=fe&255;_e[1]=fe>>>8&255;t.check=i(t.check,_e,2,0)}fe=0;oe=0;t.mode=B;case B:if(t.flags&1024){while(oe<16){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.length=fe;if(t.head){t.head.extra_len=fe}if(t.flags&512){_e[0]=fe&255;_e[1]=fe>>>8&255;t.check=i(t.check,_e,2,0)}fe=0;oe=0}else if(t.head){t.head.extra=null}t.mode=T;case T:if(t.flags&1024){he=t.length;if(he>ie){he=ie}if(he){if(t.head){Se=t.head.extra_len-t.length;if(!t.head.extra){t.head.extra=new Array(t.head.extra_len)}a.arraySet(t.head.extra,ee,te,he,Se)}if(t.flags&512){t.check=i(t.check,ee,he,te)}ie-=he;te+=he;t.length-=he}if(t.length){break e}}t.length=0;t.mode=y;case y:if(t.flags&2048){if(ie===0){break e}he=0;do{Se=ee[te+he++];if(t.head&&Se&&t.length<65536){t.head.name+=String.fromCharCode(Se)}}while(Se&&he<ie);if(t.flags&512){t.check=i(t.check,ee,he,te)}ie-=he;te+=he;if(Se){break e}}else if(t.head){t.head.name=null}t.length=0;t.mode=x;case x:if(t.flags&4096){if(ie===0){break e}he=0;do{Se=ee[te+he++];if(t.head&&Se&&t.length<65536){t.head.comment+=String.fromCharCode(Se)}}while(Se&&he<ie);if(t.flags&512){t.check=i(t.check,ee,he,te)}ie-=he;te+=he;if(Se){break e}}else if(t.head){t.head.comment=null}t.mode=I;case I:if(t.flags&512){while(oe<16){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(fe!==(t.check&65535)){e.msg="header crc mismatch";t.mode=Q;break}fe=0;oe=0}if(t.head){t.head.hcrc=t.flags>>9&1;t.head.done=true}e.adler=t.check=0;t.mode=O;break;case R:while(oe<32){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}e.adler=t.check=ne(fe);fe=0;oe=0;t.mode=D;case D:if(t.havedict===0){e.next_out=ae;e.avail_out=se;e.next_in=te;e.avail_in=ie;t.hold=fe;t.bits=oe;return g}e.adler=t.check=1;t.mode=O;case O:if(r===u||r===d){break e};case F:if(t.last){fe>>>=oe&7;
oe-=oe&7;t.mode=Y;break}while(oe<3){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.last=fe&1;fe>>>=1;oe-=1;switch(fe&3){case 0:t.mode=P;break;case 1:pe(t);t.mode=W;if(r===d){fe>>>=2;oe-=2;break e}break;case 2:t.mode=M;break;case 3:e.msg="invalid block type";t.mode=Q;}fe>>>=2;oe-=2;break;case P:fe>>>=oe&7;oe-=oe&7;while(oe<32){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if((fe&65535)!==(fe>>>16^65535)){e.msg="invalid stored block lengths";t.mode=Q;break}t.length=fe&65535;fe=0;oe=0;t.mode=N;if(r===d){break e};case N:t.mode=L;case L:he=t.length;if(he){if(he>ie){he=ie}if(he>se){he=se}if(he===0){break e}a.arraySet(re,ee,te,he,ae);ie-=he;te+=he;se-=he;ae+=he;t.length-=he;break}t.mode=O;break;case M:while(oe<14){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.nlen=(fe&31)+257;fe>>>=5;oe-=5;t.ndist=(fe&31)+1;fe>>>=5;oe-=5;t.ncode=(fe&15)+4;fe>>>=4;oe-=4;if(t.nlen>286||t.ndist>30){e.msg="too many length or distance symbols";t.mode=Q;break}t.have=0;t.mode=U;case U:while(t.have<t.ncode){while(oe<3){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.lens[ye[t.have++]]=fe&7;fe>>>=3;oe-=3}while(t.have<19){t.lens[ye[t.have++]]=0}t.lencode=t.lendyn;t.lenbits=7;Be={bits:t.lenbits};Ae=f(o,t.lens,0,19,t.lencode,0,t.work,Be);t.lenbits=Be.bits;if(Ae){e.msg="invalid code lengths set";t.mode=Q;break}t.have=0;t.mode=H;case H:while(t.have<t.nlen+t.ndist){for(;;){ge=t.lencode[fe&(1<<t.lenbits)-1];me=ge>>>24;be=ge>>>16&255;we=ge&65535;if(me<=oe){break}if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(we<16){fe>>>=me;oe-=me;t.lens[t.have++]=we}else{if(we===16){Te=me+2;while(oe<Te){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}fe>>>=me;oe-=me;if(t.have===0){e.msg="invalid bit length repeat";t.mode=Q;break}Se=t.lens[t.have-1];he=3+(fe&3);fe>>>=2;oe-=2}else if(we===17){Te=me+3;while(oe<Te){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}fe>>>=me;oe-=me;Se=0;he=3+(fe&7);fe>>>=3;oe-=3}else{Te=me+7;while(oe<Te){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}fe>>>=me;oe-=me;Se=0;he=11+(fe&127);fe>>>=7;oe-=7}if(t.have+he>t.nlen+t.ndist){e.msg="invalid bit length repeat";t.mode=Q;break}while(he--){t.lens[t.have++]=Se}}}if(t.mode===Q){break}if(t.lens[256]===0){e.msg="invalid code -- missing end-of-block";t.mode=Q;break}t.lenbits=9;Be={bits:t.lenbits};Ae=f(l,t.lens,0,t.nlen,t.lencode,0,t.work,Be);t.lenbits=Be.bits;if(Ae){e.msg="invalid literal/lengths set";t.mode=Q;break}t.distbits=6;t.distcode=t.distdyn;Be={bits:t.distbits};Ae=f(c,t.lens,t.nlen,t.ndist,t.distcode,0,t.work,Be);t.distbits=Be.bits;if(Ae){e.msg="invalid distances set";t.mode=Q;break}t.mode=W;if(r===d){break e};case W:t.mode=V;case V:if(ie>=6&&se>=258){e.next_out=ae;e.avail_out=se;e.next_in=te;e.avail_in=ie;t.hold=fe;t.bits=oe;s(e,ce);ae=e.next_out;re=e.output;se=e.avail_out;te=e.next_in;ee=e.input;ie=e.avail_in;fe=t.hold;oe=t.bits;if(t.mode===O){t.back=-1}break}t.back=0;for(;;){ge=t.lencode[fe&(1<<t.lenbits)-1];me=ge>>>24;be=ge>>>16&255;we=ge&65535;if(me<=oe){break}if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(be&&(be&240)===0){Ce=me;Ee=be;ke=we;for(;;){ge=t.lencode[ke+((fe&(1<<Ce+Ee)-1)>>Ce)];me=ge>>>24;be=ge>>>16&255;we=ge&65535;if(Ce+me<=oe){break}if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}fe>>>=Ce;oe-=Ce;t.back+=Ce}fe>>>=me;oe-=me;t.back+=me;t.length=we;if(be===0){t.mode=K;break}if(be&32){t.back=-1;t.mode=O;break}if(be&64){e.msg="invalid literal/length code";t.mode=Q;break}t.extra=be&15;t.mode=z;case z:if(t.extra){Te=t.extra;while(oe<Te){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.length+=fe&(1<<t.extra)-1;fe>>>=t.extra;oe-=t.extra;t.back+=t.extra}t.was=t.length;t.mode=X;case X:for(;;){ge=t.distcode[fe&(1<<t.distbits)-1];me=ge>>>24;be=ge>>>16&255;we=ge&65535;if(me<=oe){break}if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if((be&240)===0){Ce=me;Ee=be;ke=we;for(;;){ge=t.distcode[ke+((fe&(1<<Ce+Ee)-1)>>Ce)];me=ge>>>24;be=ge>>>16&255;we=ge&65535;if(Ce+me<=oe){break}if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}fe>>>=Ce;oe-=Ce;t.back+=Ce}fe>>>=me;oe-=me;t.back+=me;if(be&64){e.msg="invalid distance code";t.mode=Q;break}t.offset=we;t.extra=be&15;t.mode=G;case G:if(t.extra){Te=t.extra;while(oe<Te){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.offset+=fe&(1<<t.extra)-1;fe>>>=t.extra;oe-=t.extra;t.back+=t.extra}if(t.offset>t.dmax){e.msg="invalid distance too far back";t.mode=Q;break}t.mode=j;case j:if(se===0){break e}he=ce-se;if(t.offset>he){he=t.offset-he;if(he>t.whave){if(t.sane){e.msg="invalid distance too far back";t.mode=Q;break}}if(he>t.wnext){he-=t.wnext;ue=t.wsize-he}else{ue=t.wnext-he}if(he>t.length){he=t.length}de=t.window}else{de=re;ue=ae-t.offset;he=t.length}if(he>se){he=se}se-=he;t.length-=he;do{re[ae++]=de[ue++]}while(--he);if(t.length===0){t.mode=V}break;case K:if(se===0){break e}re[ae++]=t.length;se--;t.mode=V;break;case Y:if(t.wrap){while(oe<32){if(ie===0){break e}ie--;fe|=ee[te++]<<oe;oe+=8}ce-=se;e.total_out+=ce;t.total+=ce;if(ce){e.adler=t.check=t.flags?i(t.check,re,ce,ae-ce):n(t.check,re,ce,ae-ce)}ce=se;if((t.flags?fe:ne(fe))!==t.check){e.msg="incorrect data check";t.mode=Q;break}fe=0;oe=0}t.mode=$;case $:if(t.wrap&&t.flags){while(oe<32){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(fe!==(t.total&4294967295)){e.msg="incorrect length check";t.mode=Q;break}fe=0;oe=0}t.mode=Z;case Z:Ae=v;break e;case Q:Ae=b;break e;case J:return w;case q:;default:return m;}}e.next_out=ae;e.avail_out=se;e.next_in=te;e.avail_in=ie;t.hold=fe;t.bits=oe;if(t.wsize||ce!==e.avail_out&&t.mode<Q&&(t.mode<Y||r!==h)){if(ve(e,e.output,e.next_out,ce-e.avail_out)){t.mode=J;return w}}le-=e.avail_in;ce-=e.avail_out;e.total_in+=le;e.total_out+=ce;t.total+=ce;if(t.wrap&&ce){e.adler=t.check=t.flags?i(t.check,re,ce,e.next_out-ce):n(t.check,re,ce,e.next_out-ce)}e.data_type=t.bits+(t.last?64:0)+(t.mode===O?128:0)+(t.mode===W||t.mode===N?256:0);if((le===0&&ce===0||r===h)&&Ae===p){Ae=C}return Ae}function me(e){if(!e||!e.state){return m}var r=e.state;if(r.window){r.window=null}e.state=null;return p}function be(e,r){var t;if(!e||!e.state){return m}t=e.state;if((t.wrap&2)===0){return m}t.head=r;r.done=false;return p}t.inflateReset=fe;t.inflateReset2=oe;t.inflateResetKeep=se;t.inflateInit=ce;t.inflateInit2=le;t.inflate=ge;t.inflateEnd=me;t.inflateGetHeader=be;t.inflateInfo="pako inflate (from Nodeca project)"},{"../utils/common":27,"./adler32":29,"./crc32":31,"./inffast":34,"./inftrees":36}],36:[function(e,r,t){"use strict";var a=e("../utils/common");var n=15;var i=852;var s=592;var f=0;var o=1;var l=2;var c=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0];var h=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78];var u=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0];var d=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];r.exports=function p(e,r,t,v,g,m,b,w){var C=w.bits;var E=0;var k=0;var S=0,A=0;var _=0;var B=0;var T=0;var y=0;var x=0;var I=0;var R;var D;var O;var F;var P;var N=null;var L=0;var M;var U=new a.Buf16(n+1);var H=new a.Buf16(n+1);var W=null;var V=0;var z,X,G;for(E=0;E<=n;E++){U[E]=0}for(k=0;k<v;k++){U[r[t+k]]++}_=C;for(A=n;A>=1;A--){if(U[A]!==0){break}}if(_>A){_=A}if(A===0){g[m++]=1<<24|64<<16|0;g[m++]=1<<24|64<<16|0;w.bits=1;return 0}for(S=1;S<A;S++){if(U[S]!==0){break}}if(_<S){_=S}y=1;for(E=1;E<=n;E++){y<<=1;y-=U[E];if(y<0){return-1}}if(y>0&&(e===f||A!==1)){return-1}H[1]=0;for(E=1;E<n;E++){H[E+1]=H[E]+U[E]}for(k=0;k<v;k++){if(r[t+k]!==0){b[H[r[t+k]]++]=k}}if(e===f){N=W=b;M=19}else if(e===o){N=c;L-=257;W=h;V-=257;M=256}else{N=u;W=d;M=-1}I=0;k=0;E=S;P=m;B=_;T=0;O=-1;x=1<<_;F=x-1;if(e===o&&x>i||e===l&&x>s){return 1}var j=0;for(;;){j++;z=E-T;if(b[k]<M){X=0;G=b[k]}else if(b[k]>M){X=W[V+b[k]];G=N[L+b[k]]}else{X=32+64;G=0}R=1<<E-T;D=1<<B;S=D;do{D-=R;g[P+(I>>T)+D]=z<<24|X<<16|G|0}while(D!==0);R=1<<E-1;while(I&R){R>>=1}if(R!==0){I&=R-1;I+=R}else{I=0}k++;if(--U[E]===0){if(E===A){break}E=r[t+b[k]]}if(E>_&&(I&F)!==O){if(T===0){T=_}P+=S;B=E-T;y=1<<B;while(B+T<A){y-=U[B+T];if(y<=0){break}B++;y<<=1}x+=1<<B;if(e===o&&x>i||e===l&&x>s){return 1}O=I&F;g[O]=_<<24|B<<16|P-m|0}}if(I!==0){g[P+I]=E-T<<24|64<<16|0}w.bits=_;return 0}},{"../utils/common":27}],37:[function(e,r,t){"use strict";r.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},{}],38:[function(e,r,t){"use strict";var a=e("../utils/common");var n=4;var i=0;var s=1;var f=2;function o(e){var r=e.length;while(--r>=0){e[r]=0}}var l=0;var c=1;var h=2;var u=3;var d=258;var p=29;var v=256;var g=v+1+p;var m=30;var b=19;var w=2*g+1;var C=15;var E=16;var k=7;var S=256;var A=16;var _=17;var B=18;var T=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];var y=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];var x=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];var I=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];var R=512;var D=new Array((g+2)*2);o(D);var O=new Array(m*2);o(O);var F=new Array(R);o(F);var P=new Array(d-u+1);o(P);var N=new Array(p);o(N);var L=new Array(m);o(L);var M=function(e,r,t,a,n){this.static_tree=e;this.extra_bits=r;this.extra_base=t;this.elems=a;this.max_length=n;this.has_stree=e&&e.length};var U;var H;var W;var V=function(e,r){this.dyn_tree=e;this.max_code=0;this.stat_desc=r};function z(e){return e<256?F[e]:F[256+(e>>>7)]}function X(e,r){e.pending_buf[e.pending++]=r&255;e.pending_buf[e.pending++]=r>>>8&255}function G(e,r,t){if(e.bi_valid>E-t){e.bi_buf|=r<<e.bi_valid&65535;X(e,e.bi_buf);e.bi_buf=r>>E-e.bi_valid;e.bi_valid+=t-E}else{e.bi_buf|=r<<e.bi_valid&65535;e.bi_valid+=t}}function j(e,r,t){G(e,t[r*2],t[r*2+1])}function K(e,r){var t=0;do{t|=e&1;e>>>=1;t<<=1}while(--r>0);return t>>>1}function Y(e){if(e.bi_valid===16){X(e,e.bi_buf);e.bi_buf=0;e.bi_valid=0}else if(e.bi_valid>=8){e.pending_buf[e.pending++]=e.bi_buf&255;e.bi_buf>>=8;e.bi_valid-=8}}function $(e,r){var t=r.dyn_tree;var a=r.max_code;var n=r.stat_desc.static_tree;var i=r.stat_desc.has_stree;var s=r.stat_desc.extra_bits;var f=r.stat_desc.extra_base;var o=r.stat_desc.max_length;var l;var c,h;var u;var d;var p;var v=0;for(u=0;u<=C;u++){e.bl_count[u]=0}t[e.heap[e.heap_max]*2+1]=0;for(l=e.heap_max+1;l<w;l++){c=e.heap[l];u=t[t[c*2+1]*2+1]+1;if(u>o){u=o;v++}t[c*2+1]=u;if(c>a){continue}e.bl_count[u]++;d=0;if(c>=f){d=s[c-f]}p=t[c*2];e.opt_len+=p*(u+d);if(i){e.static_len+=p*(n[c*2+1]+d)}}if(v===0){return}do{u=o-1;while(e.bl_count[u]===0){u--}e.bl_count[u]--;e.bl_count[u+1]+=2;e.bl_count[o]--;v-=2}while(v>0);for(u=o;u!==0;u--){c=e.bl_count[u];while(c!==0){h=e.heap[--l];if(h>a){continue}if(t[h*2+1]!==u){e.opt_len+=(u-t[h*2+1])*t[h*2];t[h*2+1]=u}c--}}}function Z(e,r,t){var a=new Array(C+1);var n=0;var i;var s;for(i=1;i<=C;i++){a[i]=n=n+t[i-1]<<1}for(s=0;s<=r;s++){var f=e[s*2+1];if(f===0){continue}e[s*2]=K(a[f]++,f)}}function Q(){var e;var r;var t;var a;var n;var i=new Array(C+1);t=0;for(a=0;a<p-1;a++){N[a]=t;for(e=0;e<1<<T[a];e++){P[t++]=a}}P[t-1]=a;n=0;for(a=0;a<16;a++){L[a]=n;for(e=0;e<1<<y[a];e++){F[n++]=a}}n>>=7;for(;a<m;a++){L[a]=n<<7;for(e=0;e<1<<y[a]-7;e++){F[256+n++]=a}}for(r=0;r<=C;r++){i[r]=0}e=0;while(e<=143){D[e*2+1]=8;e++;i[8]++}while(e<=255){D[e*2+1]=9;e++;i[9]++}while(e<=279){D[e*2+1]=7;e++;i[7]++}while(e<=287){D[e*2+1]=8;e++;i[8]++}Z(D,g+1,i);for(e=0;e<m;e++){O[e*2+1]=5;O[e*2]=K(e,5)}U=new M(D,T,v+1,g,C);H=new M(O,y,0,m,C);W=new M(new Array(0),x,0,b,k)}function J(e){var r;for(r=0;r<g;r++){e.dyn_ltree[r*2]=0}for(r=0;r<m;r++){e.dyn_dtree[r*2]=0}for(r=0;r<b;r++){e.bl_tree[r*2]=0}e.dyn_ltree[S*2]=1;e.opt_len=e.static_len=0;e.last_lit=e.matches=0}function q(e){if(e.bi_valid>8){X(e,e.bi_buf)}else if(e.bi_valid>0){e.pending_buf[e.pending++]=e.bi_buf}e.bi_buf=0;e.bi_valid=0}function ee(e,r,t,n){q(e);if(n){X(e,t);X(e,~t)}a.arraySet(e.pending_buf,e.window,r,t,e.pending);e.pending+=t}function re(e,r,t,a){var n=r*2;var i=t*2;return e[n]<e[i]||e[n]===e[i]&&a[r]<=a[t]}function te(e,r,t){var a=e.heap[t];var n=t<<1;while(n<=e.heap_len){if(n<e.heap_len&&re(r,e.heap[n+1],e.heap[n],e.depth)){n++}if(re(r,a,e.heap[n],e.depth)){break}e.heap[t]=e.heap[n];t=n;n<<=1}e.heap[t]=a}function ae(e,r,t){var a;var n;var i=0;var s;var f;if(e.last_lit!==0){do{a=e.pending_buf[e.d_buf+i*2]<<8|e.pending_buf[e.d_buf+i*2+1];n=e.pending_buf[e.l_buf+i];i++;if(a===0){j(e,n,r)}else{s=P[n];j(e,s+v+1,r);f=T[s];if(f!==0){n-=N[s];G(e,n,f)}a--;s=z(a);j(e,s,t);f=y[s];if(f!==0){a-=L[s];G(e,a,f)}}}while(i<e.last_lit)}j(e,S,r)}function ne(e,r){var t=r.dyn_tree;var a=r.stat_desc.static_tree;var n=r.stat_desc.has_stree;var i=r.stat_desc.elems;var s,f;var o=-1;var l;e.heap_len=0;e.heap_max=w;for(s=0;s<i;s++){if(t[s*2]!==0){e.heap[++e.heap_len]=o=s;e.depth[s]=0}else{t[s*2+1]=0}}while(e.heap_len<2){l=e.heap[++e.heap_len]=o<2?++o:0;t[l*2]=1;e.depth[l]=0;e.opt_len--;if(n){e.static_len-=a[l*2+1]}}r.max_code=o;for(s=e.heap_len>>1;s>=1;s--){te(e,t,s)}l=i;do{s=e.heap[1];e.heap[1]=e.heap[e.heap_len--];te(e,t,1);f=e.heap[1];e.heap[--e.heap_max]=s;e.heap[--e.heap_max]=f;t[l*2]=t[s*2]+t[f*2];e.depth[l]=(e.depth[s]>=e.depth[f]?e.depth[s]:e.depth[f])+1;t[s*2+1]=t[f*2+1]=l;e.heap[1]=l++;te(e,t,1)}while(e.heap_len>=2);e.heap[--e.heap_max]=e.heap[1];$(e,r);Z(t,o,e.bl_count)}function ie(e,r,t){var a;var n=-1;var i;var s=r[0*2+1];var f=0;var o=7;var l=4;if(s===0){o=138;l=3}r[(t+1)*2+1]=65535;for(a=0;a<=t;a++){i=s;s=r[(a+1)*2+1];if(++f<o&&i===s){continue}else if(f<l){e.bl_tree[i*2]+=f}else if(i!==0){if(i!==n){e.bl_tree[i*2]++}e.bl_tree[A*2]++}else if(f<=10){e.bl_tree[_*2]++}else{e.bl_tree[B*2]++}f=0;n=i;if(s===0){o=138;l=3}else if(i===s){o=6;l=3}else{o=7;l=4}}}function se(e,r,t){var a;var n=-1;var i;var s=r[0*2+1];var f=0;var o=7;var l=4;if(s===0){o=138;l=3}for(a=0;a<=t;a++){i=s;s=r[(a+1)*2+1];if(++f<o&&i===s){continue}else if(f<l){do{j(e,i,e.bl_tree)}while(--f!==0)}else if(i!==0){if(i!==n){j(e,i,e.bl_tree);f--}j(e,A,e.bl_tree);G(e,f-3,2)}else if(f<=10){j(e,_,e.bl_tree);G(e,f-3,3)}else{j(e,B,e.bl_tree);G(e,f-11,7)}f=0;n=i;if(s===0){o=138;l=3}else if(i===s){o=6;l=3}else{o=7;l=4}}}function fe(e){var r;ie(e,e.dyn_ltree,e.l_desc.max_code);ie(e,e.dyn_dtree,e.d_desc.max_code);ne(e,e.bl_desc);for(r=b-1;r>=3;r--){if(e.bl_tree[I[r]*2+1]!==0){break}}e.opt_len+=3*(r+1)+5+5+4;return r}function oe(e,r,t,a){var n;G(e,r-257,5);G(e,t-1,5);G(e,a-4,4);for(n=0;n<a;n++){G(e,e.bl_tree[I[n]*2+1],3)}se(e,e.dyn_ltree,r-1);se(e,e.dyn_dtree,t-1)}function le(e){var r=4093624447;var t;for(t=0;t<=31;t++,r>>>=1){if(r&1&&e.dyn_ltree[t*2]!==0){return i}}if(e.dyn_ltree[9*2]!==0||e.dyn_ltree[10*2]!==0||e.dyn_ltree[13*2]!==0){return s}for(t=32;t<v;t++){if(e.dyn_ltree[t*2]!==0){return s}}return i}var ce=false;function he(e){if(!ce){Q();ce=true}e.l_desc=new V(e.dyn_ltree,U);e.d_desc=new V(e.dyn_dtree,H);e.bl_desc=new V(e.bl_tree,W);e.bi_buf=0;e.bi_valid=0;J(e)}function ue(e,r,t,a){G(e,(l<<1)+(a?1:0),3);ee(e,r,t,true)}function de(e){G(e,c<<1,3);j(e,S,D);Y(e)}function pe(e,r,t,a){var i,s;var o=0;if(e.level>0){if(e.strm.data_type===f){e.strm.data_type=le(e)}ne(e,e.l_desc);ne(e,e.d_desc);o=fe(e);i=e.opt_len+3+7>>>3;s=e.static_len+3+7>>>3;if(s<=i){i=s}}else{i=s=t+5}if(t+4<=i&&r!==-1){ue(e,r,t,a)}else if(e.strategy===n||s===i){G(e,(c<<1)+(a?1:0),3);ae(e,D,O)}else{G(e,(h<<1)+(a?1:0),3);oe(e,e.l_desc.max_code+1,e.d_desc.max_code+1,o+1);ae(e,e.dyn_ltree,e.dyn_dtree)}J(e);if(a){q(e)}}function ve(e,r,t){e.pending_buf[e.d_buf+e.last_lit*2]=r>>>8&255;e.pending_buf[e.d_buf+e.last_lit*2+1]=r&255;e.pending_buf[e.l_buf+e.last_lit]=t&255;e.last_lit++;if(r===0){e.dyn_ltree[t*2]++}else{e.matches++;r--;e.dyn_ltree[(P[t]+v+1)*2]++;e.dyn_dtree[z(r)*2]++}return e.last_lit===e.lit_bufsize-1}t._tr_init=he;t._tr_stored_block=ue;t._tr_flush_block=pe;t._tr_tally=ve;t._tr_align=de},{"../utils/common":27}],39:[function(e,r,t){"use strict";function a(){this.input=null;this.next_in=0;this.avail_in=0;this.total_in=0;this.output=null;this.next_out=0;this.avail_out=0;this.total_out=0;this.msg="";this.state=null;this.data_type=2;this.adler=0}r.exports=a},{}]},{},[9])(9)});var cptable={version:"1.14.0"};cptable[437]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[620]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[737]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[850]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[852]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[857]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[861]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[865]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[866]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[874]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[895]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[932]=function(){var e=[],r={},t=[],a;t[0]="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");for(a=0;a!=t[0].length;++a)if(t[0][a].charCodeAt(0)!==65533){r[t[0][a]]=0+a;e[0+a]=t[0][a]}t[129]="����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");for(a=0;a!=t[129].length;++a)if(t[129][a].charCodeAt(0)!==65533){r[t[129][a]]=33024+a;e[33024+a]=t[129][a]}t[130]="�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");for(a=0;a!=t[130].length;++a)if(t[130][a].charCodeAt(0)!==65533){r[t[130][a]]=33280+a;e[33280+a]=t[130][a]}t[131]="����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");for(a=0;a!=t[131].length;++a)if(t[131][a].charCodeAt(0)!==65533){r[t[131][a]]=33536+a;e[33536+a]=t[131][a]}t[132]="����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");for(a=0;a!=t[132].length;++a)if(t[132][a].charCodeAt(0)!==65533){r[t[132][a]]=33792+a;e[33792+a]=t[132][a]}t[135]="����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[135].length;++a)if(t[135][a].charCodeAt(0)!==65533){r[t[135][a]]=34560+a;e[34560+a]=t[135][a]}t[136]="���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");for(a=0;a!=t[136].length;++a)if(t[136][a].charCodeAt(0)!==65533){r[t[136][a]]=34816+a;e[34816+a]=t[136][a]}t[137]="����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");for(a=0;a!=t[137].length;++a)if(t[137][a].charCodeAt(0)!==65533){r[t[137][a]]=35072+a;e[35072+a]=t[137][a]}t[138]="����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");for(a=0;a!=t[138].length;++a)if(t[138][a].charCodeAt(0)!==65533){r[t[138][a]]=35328+a;e[35328+a]=t[138][a]}t[139]="����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");for(a=0;a!=t[139].length;++a)if(t[139][a].charCodeAt(0)!==65533){r[t[139][a]]=35584+a;e[35584+a]=t[139][a]}t[140]="����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");for(a=0;a!=t[140].length;++a)if(t[140][a].charCodeAt(0)!==65533){r[t[140][a]]=35840+a;e[35840+a]=t[140][a]}t[141]="����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");for(a=0;a!=t[141].length;++a)if(t[141][a].charCodeAt(0)!==65533){r[t[141][a]]=36096+a;e[36096+a]=t[141][a]}t[142]="����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");for(a=0;a!=t[142].length;++a)if(t[142][a].charCodeAt(0)!==65533){r[t[142][a]]=36352+a;e[36352+a]=t[142][a]}t[143]="����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");for(a=0;a!=t[143].length;++a)if(t[143][a].charCodeAt(0)!==65533){r[t[143][a]]=36608+a;e[36608+a]=t[143][a]}t[144]="����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");for(a=0;a!=t[144].length;++a)if(t[144][a].charCodeAt(0)!==65533){r[t[144][a]]=36864+a;e[36864+a]=t[144][a]}t[145]="����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");for(a=0;a!=t[145].length;++a)if(t[145][a].charCodeAt(0)!==65533){r[t[145][a]]=37120+a;e[37120+a]=t[145][a]}t[146]="����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");for(a=0;a!=t[146].length;++a)if(t[146][a].charCodeAt(0)!==65533){r[t[146][a]]=37376+a;e[37376+a]=t[146][a]}t[147]="����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");for(a=0;a!=t[147].length;++a)if(t[147][a].charCodeAt(0)!==65533){r[t[147][a]]=37632+a;e[37632+a]=t[147][a]}t[148]="����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");for(a=0;a!=t[148].length;++a)if(t[148][a].charCodeAt(0)!==65533){r[t[148][a]]=37888+a;e[37888+a]=t[148][a]}t[149]="����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");for(a=0;a!=t[149].length;++a)if(t[149][a].charCodeAt(0)!==65533){r[t[149][a]]=38144+a;e[38144+a]=t[149][a]}t[150]="����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");for(a=0;a!=t[150].length;++a)if(t[150][a].charCodeAt(0)!==65533){r[t[150][a]]=38400+a;e[38400+a]=t[150][a]}t[151]="����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");for(a=0;a!=t[151].length;++a)if(t[151][a].charCodeAt(0)!==65533){r[t[151][a]]=38656+a;e[38656+a]=t[151][a]}t[152]="����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");for(a=0;a!=t[152].length;++a)if(t[152][a].charCodeAt(0)!==65533){r[t[152][a]]=38912+a;e[38912+a]=t[152][a]}t[153]="����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");for(a=0;a!=t[153].length;++a)if(t[153][a].charCodeAt(0)!==65533){r[t[153][a]]=39168+a;e[39168+a]=t[153][a]}t[154]="����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");for(a=0;a!=t[154].length;++a)if(t[154][a].charCodeAt(0)!==65533){r[t[154][a]]=39424+a;e[39424+a]=t[154][a]}t[155]="����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");for(a=0;a!=t[155].length;++a)if(t[155][a].charCodeAt(0)!==65533){r[t[155][a]]=39680+a;e[39680+a]=t[155][a]}t[156]="����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");for(a=0;a!=t[156].length;++a)if(t[156][a].charCodeAt(0)!==65533){r[t[156][a]]=39936+a;e[39936+a]=t[156][a]}t[157]="����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");for(a=0;a!=t[157].length;++a)if(t[157][a].charCodeAt(0)!==65533){r[t[157][a]]=40192+a;e[40192+a]=t[157][a]}t[158]="����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");for(a=0;a!=t[158].length;++a)if(t[158][a].charCodeAt(0)!==65533){r[t[158][a]]=40448+a;e[40448+a]=t[158][a]}t[159]="����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
for(a=0;a!=t[159].length;++a)if(t[159][a].charCodeAt(0)!==65533){r[t[159][a]]=40704+a;e[40704+a]=t[159][a]}t[224]="����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");for(a=0;a!=t[224].length;++a)if(t[224][a].charCodeAt(0)!==65533){r[t[224][a]]=57344+a;e[57344+a]=t[224][a]}t[225]="����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");for(a=0;a!=t[225].length;++a)if(t[225][a].charCodeAt(0)!==65533){r[t[225][a]]=57600+a;e[57600+a]=t[225][a]}t[226]="����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");for(a=0;a!=t[226].length;++a)if(t[226][a].charCodeAt(0)!==65533){r[t[226][a]]=57856+a;e[57856+a]=t[226][a]}t[227]="����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");for(a=0;a!=t[227].length;++a)if(t[227][a].charCodeAt(0)!==65533){r[t[227][a]]=58112+a;e[58112+a]=t[227][a]}t[228]="����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");for(a=0;a!=t[228].length;++a)if(t[228][a].charCodeAt(0)!==65533){r[t[228][a]]=58368+a;e[58368+a]=t[228][a]}t[229]="����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");for(a=0;a!=t[229].length;++a)if(t[229][a].charCodeAt(0)!==65533){r[t[229][a]]=58624+a;e[58624+a]=t[229][a]}t[230]="����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");for(a=0;a!=t[230].length;++a)if(t[230][a].charCodeAt(0)!==65533){r[t[230][a]]=58880+a;e[58880+a]=t[230][a]}t[231]="����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");for(a=0;a!=t[231].length;++a)if(t[231][a].charCodeAt(0)!==65533){r[t[231][a]]=59136+a;e[59136+a]=t[231][a]}t[232]="����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");for(a=0;a!=t[232].length;++a)if(t[232][a].charCodeAt(0)!==65533){r[t[232][a]]=59392+a;e[59392+a]=t[232][a]}t[233]="����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");for(a=0;a!=t[233].length;++a)if(t[233][a].charCodeAt(0)!==65533){r[t[233][a]]=59648+a;e[59648+a]=t[233][a]}t[234]="����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[234].length;++a)if(t[234][a].charCodeAt(0)!==65533){r[t[234][a]]=59904+a;e[59904+a]=t[234][a]}t[237]="����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");for(a=0;a!=t[237].length;++a)if(t[237][a].charCodeAt(0)!==65533){r[t[237][a]]=60672+a;e[60672+a]=t[237][a]}t[238]="����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");for(a=0;a!=t[238].length;++a)if(t[238][a].charCodeAt(0)!==65533){r[t[238][a]]=60928+a;e[60928+a]=t[238][a]}t[250]="����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");for(a=0;a!=t[250].length;++a)if(t[250][a].charCodeAt(0)!==65533){r[t[250][a]]=64e3+a;e[64e3+a]=t[250][a]}t[251]="����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");for(a=0;a!=t[251].length;++a)if(t[251][a].charCodeAt(0)!==65533){r[t[251][a]]=64256+a;e[64256+a]=t[251][a]}t[252]="����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[252].length;++a)if(t[252][a].charCodeAt(0)!==65533){r[t[252][a]]=64512+a;e[64512+a]=t[252][a]}return{enc:r,dec:e}}();cptable[936]=function(){var e=[],r={},t=[],a;t[0]="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[0].length;++a)if(t[0][a].charCodeAt(0)!==65533){r[t[0][a]]=0+a;e[0+a]=t[0][a]}t[129]="����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");for(a=0;a!=t[129].length;++a)if(t[129][a].charCodeAt(0)!==65533){r[t[129][a]]=33024+a;e[33024+a]=t[129][a]}t[130]="����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");for(a=0;a!=t[130].length;++a)if(t[130][a].charCodeAt(0)!==65533){r[t[130][a]]=33280+a;e[33280+a]=t[130][a]}t[131]="����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");for(a=0;a!=t[131].length;++a)if(t[131][a].charCodeAt(0)!==65533){r[t[131][a]]=33536+a;e[33536+a]=t[131][a]}t[132]="����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");for(a=0;a!=t[132].length;++a)if(t[132][a].charCodeAt(0)!==65533){r[t[132][a]]=33792+a;e[33792+a]=t[132][a]}t[133]="����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");for(a=0;a!=t[133].length;++a)if(t[133][a].charCodeAt(0)!==65533){r[t[133][a]]=34048+a;e[34048+a]=t[133][a]}t[134]="����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");for(a=0;a!=t[134].length;++a)if(t[134][a].charCodeAt(0)!==65533){r[t[134][a]]=34304+a;e[34304+a]=t[134][a]}t[135]="����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");for(a=0;a!=t[135].length;++a)if(t[135][a].charCodeAt(0)!==65533){r[t[135][a]]=34560+a;e[34560+a]=t[135][a]}t[136]="����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");for(a=0;a!=t[136].length;++a)if(t[136][a].charCodeAt(0)!==65533){r[t[136][a]]=34816+a;e[34816+a]=t[136][a]}t[137]="����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");for(a=0;a!=t[137].length;++a)if(t[137][a].charCodeAt(0)!==65533){r[t[137][a]]=35072+a;e[35072+a]=t[137][a]}t[138]="����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");for(a=0;a!=t[138].length;++a)if(t[138][a].charCodeAt(0)!==65533){r[t[138][a]]=35328+a;e[35328+a]=t[138][a]}t[139]="����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");for(a=0;a!=t[139].length;++a)if(t[139][a].charCodeAt(0)!==65533){r[t[139][a]]=35584+a;e[35584+a]=t[139][a]}t[140]="����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");for(a=0;a!=t[140].length;++a)if(t[140][a].charCodeAt(0)!==65533){r[t[140][a]]=35840+a;e[35840+a]=t[140][a]}t[141]="����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");for(a=0;a!=t[141].length;++a)if(t[141][a].charCodeAt(0)!==65533){r[t[141][a]]=36096+a;e[36096+a]=t[141][a]}t[142]="����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");for(a=0;a!=t[142].length;++a)if(t[142][a].charCodeAt(0)!==65533){r[t[142][a]]=36352+a;e[36352+a]=t[142][a]}t[143]="����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");for(a=0;a!=t[143].length;++a)if(t[143][a].charCodeAt(0)!==65533){r[t[143][a]]=36608+a;e[36608+a]=t[143][a]}t[144]="����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");for(a=0;a!=t[144].length;++a)if(t[144][a].charCodeAt(0)!==65533){r[t[144][a]]=36864+a;e[36864+a]=t[144][a]}t[145]="����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");for(a=0;a!=t[145].length;++a)if(t[145][a].charCodeAt(0)!==65533){r[t[145][a]]=37120+a;e[37120+a]=t[145][a]}t[146]="����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");for(a=0;a!=t[146].length;++a)if(t[146][a].charCodeAt(0)!==65533){r[t[146][a]]=37376+a;e[37376+a]=t[146][a]}t[147]="����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");for(a=0;a!=t[147].length;++a)if(t[147][a].charCodeAt(0)!==65533){r[t[147][a]]=37632+a;e[37632+a]=t[147][a]}t[148]="����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");for(a=0;a!=t[148].length;++a)if(t[148][a].charCodeAt(0)!==65533){r[t[148][a]]=37888+a;e[37888+a]=t[148][a]}t[149]="����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");for(a=0;a!=t[149].length;++a)if(t[149][a].charCodeAt(0)!==65533){r[t[149][a]]=38144+a;e[38144+a]=t[149][a]}t[150]="����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");for(a=0;a!=t[150].length;++a)if(t[150][a].charCodeAt(0)!==65533){r[t[150][a]]=38400+a;e[38400+a]=t[150][a]}t[151]="����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");for(a=0;a!=t[151].length;++a)if(t[151][a].charCodeAt(0)!==65533){r[t[151][a]]=38656+a;e[38656+a]=t[151][a]}t[152]="����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");for(a=0;a!=t[152].length;++a)if(t[152][a].charCodeAt(0)!==65533){r[t[152][a]]=38912+a;e[38912+a]=t[152][a]}t[153]="����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");for(a=0;a!=t[153].length;++a)if(t[153][a].charCodeAt(0)!==65533){r[t[153][a]]=39168+a;e[39168+a]=t[153][a]}t[154]="����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");for(a=0;a!=t[154].length;++a)if(t[154][a].charCodeAt(0)!==65533){r[t[154][a]]=39424+a;e[39424+a]=t[154][a]}t[155]="����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");for(a=0;a!=t[155].length;++a)if(t[155][a].charCodeAt(0)!==65533){r[t[155][a]]=39680+a;e[39680+a]=t[155][a]}t[156]="����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");for(a=0;a!=t[156].length;++a)if(t[156][a].charCodeAt(0)!==65533){r[t[156][a]]=39936+a;e[39936+a]=t[156][a]}t[157]="����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");for(a=0;a!=t[157].length;++a)if(t[157][a].charCodeAt(0)!==65533){r[t[157][a]]=40192+a;e[40192+a]=t[157][a]}t[158]="����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");for(a=0;a!=t[158].length;++a)if(t[158][a].charCodeAt(0)!==65533){r[t[158][a]]=40448+a;e[40448+a]=t[158][a]}t[159]="����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");for(a=0;a!=t[159].length;++a)if(t[159][a].charCodeAt(0)!==65533){r[t[159][a]]=40704+a;e[40704+a]=t[159][a]}t[160]="����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");for(a=0;a!=t[160].length;++a)if(t[160][a].charCodeAt(0)!==65533){r[t[160][a]]=40960+a;e[40960+a]=t[160][a]}t[161]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");for(a=0;a!=t[161].length;++a)if(t[161][a].charCodeAt(0)!==65533){r[t[161][a]]=41216+a;e[41216+a]=t[161][a]}t[162]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");for(a=0;a!=t[162].length;++a)if(t[162][a].charCodeAt(0)!==65533){r[t[162][a]]=41472+a;e[41472+a]=t[162][a]}t[163]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");for(a=0;a!=t[163].length;++a)if(t[163][a].charCodeAt(0)!==65533){r[t[163][a]]=41728+a;e[41728+a]=t[163][a]}t[164]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");for(a=0;a!=t[164].length;++a)if(t[164][a].charCodeAt(0)!==65533){r[t[164][a]]=41984+a;e[41984+a]=t[164][a]}t[165]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");for(a=0;a!=t[165].length;++a)if(t[165][a].charCodeAt(0)!==65533){r[t[165][a]]=42240+a;e[42240+a]=t[165][a]}t[166]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");for(a=0;a!=t[166].length;++a)if(t[166][a].charCodeAt(0)!==65533){r[t[166][a]]=42496+a;e[42496+a]=t[166][a]}t[167]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");for(a=0;a!=t[167].length;++a)if(t[167][a].charCodeAt(0)!==65533){r[t[167][a]]=42752+a;e[42752+a]=t[167][a]}t[168]="����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");for(a=0;a!=t[168].length;++a)if(t[168][a].charCodeAt(0)!==65533){r[t[168][a]]=43008+a;e[43008+a]=t[168][a]}t[169]="����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");for(a=0;a!=t[169].length;++a)if(t[169][a].charCodeAt(0)!==65533){r[t[169][a]]=43264+a;e[43264+a]=t[169][a]}t[170]="����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[170].length;++a)if(t[170][a].charCodeAt(0)!==65533){r[t[170][a]]=43520+a;e[43520+a]=t[170][a]}t[171]="����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[171].length;++a)if(t[171][a].charCodeAt(0)!==65533){r[t[171][a]]=43776+a;e[43776+a]=t[171][a]}t[172]="����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[172].length;++a)if(t[172][a].charCodeAt(0)!==65533){r[t[172][a]]=44032+a;e[44032+a]=t[172][a]}t[173]="����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[173].length;++a)if(t[173][a].charCodeAt(0)!==65533){r[t[173][a]]=44288+a;e[44288+a]=t[173][a]}t[174]="����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[174].length;++a)if(t[174][a].charCodeAt(0)!==65533){r[t[174][a]]=44544+a;e[44544+a]=t[174][a]}t[175]="����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[175].length;++a)if(t[175][a].charCodeAt(0)!==65533){r[t[175][a]]=44800+a;e[44800+a]=t[175][a]}t[176]="����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");for(a=0;a!=t[176].length;++a)if(t[176][a].charCodeAt(0)!==65533){r[t[176][a]]=45056+a;e[45056+a]=t[176][a]}t[177]="����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");for(a=0;a!=t[177].length;++a)if(t[177][a].charCodeAt(0)!==65533){r[t[177][a]]=45312+a;e[45312+a]=t[177][a]}t[178]="����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");for(a=0;a!=t[178].length;++a)if(t[178][a].charCodeAt(0)!==65533){r[t[178][a]]=45568+a;e[45568+a]=t[178][a]}t[179]="����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");for(a=0;a!=t[179].length;++a)if(t[179][a].charCodeAt(0)!==65533){r[t[179][a]]=45824+a;e[45824+a]=t[179][a]}t[180]="����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");for(a=0;a!=t[180].length;++a)if(t[180][a].charCodeAt(0)!==65533){r[t[180][a]]=46080+a;e[46080+a]=t[180][a]}t[181]="����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");for(a=0;a!=t[181].length;++a)if(t[181][a].charCodeAt(0)!==65533){r[t[181][a]]=46336+a;e[46336+a]=t[181][a]}t[182]="����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");for(a=0;a!=t[182].length;++a)if(t[182][a].charCodeAt(0)!==65533){r[t[182][a]]=46592+a;e[46592+a]=t[182][a]}t[183]="����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");for(a=0;a!=t[183].length;++a)if(t[183][a].charCodeAt(0)!==65533){r[t[183][a]]=46848+a;e[46848+a]=t[183][a]}t[184]="����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");for(a=0;a!=t[184].length;++a)if(t[184][a].charCodeAt(0)!==65533){r[t[184][a]]=47104+a;e[47104+a]=t[184][a]}t[185]="����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");for(a=0;a!=t[185].length;++a)if(t[185][a].charCodeAt(0)!==65533){r[t[185][a]]=47360+a;e[47360+a]=t[185][a]}t[186]="����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");for(a=0;a!=t[186].length;++a)if(t[186][a].charCodeAt(0)!==65533){r[t[186][a]]=47616+a;e[47616+a]=t[186][a]}t[187]="����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");for(a=0;a!=t[187].length;++a)if(t[187][a].charCodeAt(0)!==65533){r[t[187][a]]=47872+a;e[47872+a]=t[187][a]}t[188]="����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");for(a=0;a!=t[188].length;++a)if(t[188][a].charCodeAt(0)!==65533){r[t[188][a]]=48128+a;e[48128+a]=t[188][a]}t[189]="����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");for(a=0;a!=t[189].length;++a)if(t[189][a].charCodeAt(0)!==65533){r[t[189][a]]=48384+a;e[48384+a]=t[189][a]}t[190]="����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");for(a=0;a!=t[190].length;++a)if(t[190][a].charCodeAt(0)!==65533){r[t[190][a]]=48640+a;e[48640+a]=t[190][a]}t[191]="����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");for(a=0;a!=t[191].length;++a)if(t[191][a].charCodeAt(0)!==65533){r[t[191][a]]=48896+a;e[48896+a]=t[191][a]}t[192]="����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");for(a=0;a!=t[192].length;++a)if(t[192][a].charCodeAt(0)!==65533){r[t[192][a]]=49152+a;e[49152+a]=t[192][a]}t[193]="����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");for(a=0;a!=t[193].length;++a)if(t[193][a].charCodeAt(0)!==65533){r[t[193][a]]=49408+a;e[49408+a]=t[193][a]}t[194]="����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");for(a=0;a!=t[194].length;++a)if(t[194][a].charCodeAt(0)!==65533){r[t[194][a]]=49664+a;e[49664+a]=t[194][a]}t[195]="����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
for(a=0;a!=t[195].length;++a)if(t[195][a].charCodeAt(0)!==65533){r[t[195][a]]=49920+a;e[49920+a]=t[195][a]}t[196]="����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");for(a=0;a!=t[196].length;++a)if(t[196][a].charCodeAt(0)!==65533){r[t[196][a]]=50176+a;e[50176+a]=t[196][a]}t[197]="����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");for(a=0;a!=t[197].length;++a)if(t[197][a].charCodeAt(0)!==65533){r[t[197][a]]=50432+a;e[50432+a]=t[197][a]}t[198]="����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");for(a=0;a!=t[198].length;++a)if(t[198][a].charCodeAt(0)!==65533){r[t[198][a]]=50688+a;e[50688+a]=t[198][a]}t[199]="����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");for(a=0;a!=t[199].length;++a)if(t[199][a].charCodeAt(0)!==65533){r[t[199][a]]=50944+a;e[50944+a]=t[199][a]}t[200]="����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");for(a=0;a!=t[200].length;++a)if(t[200][a].charCodeAt(0)!==65533){r[t[200][a]]=51200+a;e[51200+a]=t[200][a]}t[201]="����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");for(a=0;a!=t[201].length;++a)if(t[201][a].charCodeAt(0)!==65533){r[t[201][a]]=51456+a;e[51456+a]=t[201][a]}t[202]="����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");for(a=0;a!=t[202].length;++a)if(t[202][a].charCodeAt(0)!==65533){r[t[202][a]]=51712+a;e[51712+a]=t[202][a]}t[203]="����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");for(a=0;a!=t[203].length;++a)if(t[203][a].charCodeAt(0)!==65533){r[t[203][a]]=51968+a;e[51968+a]=t[203][a]}t[204]="����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");for(a=0;a!=t[204].length;++a)if(t[204][a].charCodeAt(0)!==65533){r[t[204][a]]=52224+a;e[52224+a]=t[204][a]}t[205]="����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");for(a=0;a!=t[205].length;++a)if(t[205][a].charCodeAt(0)!==65533){r[t[205][a]]=52480+a;e[52480+a]=t[205][a]}t[206]="����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");for(a=0;a!=t[206].length;++a)if(t[206][a].charCodeAt(0)!==65533){r[t[206][a]]=52736+a;e[52736+a]=t[206][a]}t[207]="����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");for(a=0;a!=t[207].length;++a)if(t[207][a].charCodeAt(0)!==65533){r[t[207][a]]=52992+a;e[52992+a]=t[207][a]}t[208]="����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");for(a=0;a!=t[208].length;++a)if(t[208][a].charCodeAt(0)!==65533){r[t[208][a]]=53248+a;e[53248+a]=t[208][a]}t[209]="����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");for(a=0;a!=t[209].length;++a)if(t[209][a].charCodeAt(0)!==65533){r[t[209][a]]=53504+a;e[53504+a]=t[209][a]}t[210]="����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");for(a=0;a!=t[210].length;++a)if(t[210][a].charCodeAt(0)!==65533){r[t[210][a]]=53760+a;e[53760+a]=t[210][a]}t[211]="����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");for(a=0;a!=t[211].length;++a)if(t[211][a].charCodeAt(0)!==65533){r[t[211][a]]=54016+a;e[54016+a]=t[211][a]}t[212]="����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");for(a=0;a!=t[212].length;++a)if(t[212][a].charCodeAt(0)!==65533){r[t[212][a]]=54272+a;e[54272+a]=t[212][a]}t[213]="����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");for(a=0;a!=t[213].length;++a)if(t[213][a].charCodeAt(0)!==65533){r[t[213][a]]=54528+a;e[54528+a]=t[213][a]}t[214]="����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");for(a=0;a!=t[214].length;++a)if(t[214][a].charCodeAt(0)!==65533){r[t[214][a]]=54784+a;e[54784+a]=t[214][a]}t[215]="����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");for(a=0;a!=t[215].length;++a)if(t[215][a].charCodeAt(0)!==65533){r[t[215][a]]=55040+a;e[55040+a]=t[215][a]}t[216]="����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");for(a=0;a!=t[216].length;++a)if(t[216][a].charCodeAt(0)!==65533){r[t[216][a]]=55296+a;e[55296+a]=t[216][a]}t[217]="����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");for(a=0;a!=t[217].length;++a)if(t[217][a].charCodeAt(0)!==65533){r[t[217][a]]=55552+a;e[55552+a]=t[217][a]}t[218]="����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");for(a=0;a!=t[218].length;++a)if(t[218][a].charCodeAt(0)!==65533){r[t[218][a]]=55808+a;e[55808+a]=t[218][a]}t[219]="����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");for(a=0;a!=t[219].length;++a)if(t[219][a].charCodeAt(0)!==65533){r[t[219][a]]=56064+a;e[56064+a]=t[219][a]}t[220]="����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");for(a=0;a!=t[220].length;++a)if(t[220][a].charCodeAt(0)!==65533){r[t[220][a]]=56320+a;e[56320+a]=t[220][a]}t[221]="����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");for(a=0;a!=t[221].length;++a)if(t[221][a].charCodeAt(0)!==65533){r[t[221][a]]=56576+a;e[56576+a]=t[221][a]}t[222]="����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");for(a=0;a!=t[222].length;++a)if(t[222][a].charCodeAt(0)!==65533){r[t[222][a]]=56832+a;e[56832+a]=t[222][a]}t[223]="����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");for(a=0;a!=t[223].length;++a)if(t[223][a].charCodeAt(0)!==65533){r[t[223][a]]=57088+a;e[57088+a]=t[223][a]}t[224]="����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");for(a=0;a!=t[224].length;++a)if(t[224][a].charCodeAt(0)!==65533){r[t[224][a]]=57344+a;e[57344+a]=t[224][a]}t[225]="����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");for(a=0;a!=t[225].length;++a)if(t[225][a].charCodeAt(0)!==65533){r[t[225][a]]=57600+a;e[57600+a]=t[225][a]}t[226]="����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");for(a=0;a!=t[226].length;++a)if(t[226][a].charCodeAt(0)!==65533){r[t[226][a]]=57856+a;e[57856+a]=t[226][a]}t[227]="����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");for(a=0;a!=t[227].length;++a)if(t[227][a].charCodeAt(0)!==65533){r[t[227][a]]=58112+a;e[58112+a]=t[227][a]}t[228]="����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");for(a=0;a!=t[228].length;++a)if(t[228][a].charCodeAt(0)!==65533){r[t[228][a]]=58368+a;e[58368+a]=t[228][a]}t[229]="����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");for(a=0;a!=t[229].length;++a)if(t[229][a].charCodeAt(0)!==65533){r[t[229][a]]=58624+a;e[58624+a]=t[229][a]}t[230]="����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");for(a=0;a!=t[230].length;++a)if(t[230][a].charCodeAt(0)!==65533){r[t[230][a]]=58880+a;e[58880+a]=t[230][a]}t[231]="����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");for(a=0;a!=t[231].length;++a)if(t[231][a].charCodeAt(0)!==65533){r[t[231][a]]=59136+a;e[59136+a]=t[231][a]}t[232]="����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");for(a=0;a!=t[232].length;++a)if(t[232][a].charCodeAt(0)!==65533){r[t[232][a]]=59392+a;e[59392+a]=t[232][a]}t[233]="����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");for(a=0;a!=t[233].length;++a)if(t[233][a].charCodeAt(0)!==65533){r[t[233][a]]=59648+a;e[59648+a]=t[233][a]}t[234]="����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");for(a=0;a!=t[234].length;++a)if(t[234][a].charCodeAt(0)!==65533){r[t[234][a]]=59904+a;e[59904+a]=t[234][a]}t[235]="����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");for(a=0;a!=t[235].length;++a)if(t[235][a].charCodeAt(0)!==65533){r[t[235][a]]=60160+a;e[60160+a]=t[235][a]}t[236]="����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");for(a=0;a!=t[236].length;++a)if(t[236][a].charCodeAt(0)!==65533){r[t[236][a]]=60416+a;e[60416+a]=t[236][a]}t[237]="����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");for(a=0;a!=t[237].length;++a)if(t[237][a].charCodeAt(0)!==65533){r[t[237][a]]=60672+a;e[60672+a]=t[237][a]}t[238]="����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");for(a=0;a!=t[238].length;++a)if(t[238][a].charCodeAt(0)!==65533){r[t[238][a]]=60928+a;e[60928+a]=t[238][a]}t[239]="����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");for(a=0;a!=t[239].length;++a)if(t[239][a].charCodeAt(0)!==65533){r[t[239][a]]=61184+a;e[61184+a]=t[239][a]}t[240]="����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");for(a=0;a!=t[240].length;++a)if(t[240][a].charCodeAt(0)!==65533){r[t[240][a]]=61440+a;e[61440+a]=t[240][a]}t[241]="����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");for(a=0;a!=t[241].length;++a)if(t[241][a].charCodeAt(0)!==65533){r[t[241][a]]=61696+a;e[61696+a]=t[241][a]}t[242]="����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");for(a=0;a!=t[242].length;++a)if(t[242][a].charCodeAt(0)!==65533){r[t[242][a]]=61952+a;e[61952+a]=t[242][a]}t[243]="����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");for(a=0;a!=t[243].length;++a)if(t[243][a].charCodeAt(0)!==65533){r[t[243][a]]=62208+a;e[62208+a]=t[243][a]}t[244]="����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");for(a=0;a!=t[244].length;++a)if(t[244][a].charCodeAt(0)!==65533){r[t[244][a]]=62464+a;e[62464+a]=t[244][a]}t[245]="����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");for(a=0;a!=t[245].length;++a)if(t[245][a].charCodeAt(0)!==65533){r[t[245][a]]=62720+a;e[62720+a]=t[245][a]}t[246]="����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");for(a=0;a!=t[246].length;++a)if(t[246][a].charCodeAt(0)!==65533){r[t[246][a]]=62976+a;e[62976+a]=t[246][a]}t[247]="����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");for(a=0;a!=t[247].length;++a)if(t[247][a].charCodeAt(0)!==65533){r[t[247][a]]=63232+a;e[63232+a]=t[247][a]}t[248]="����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[248].length;++a)if(t[248][a].charCodeAt(0)!==65533){r[t[248][a]]=63488+a;e[63488+a]=t[248][a]}t[249]="����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[249].length;++a)if(t[249][a].charCodeAt(0)!==65533){r[t[249][a]]=63744+a;e[63744+a]=t[249][a]}t[250]="����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[250].length;++a)if(t[250][a].charCodeAt(0)!==65533){r[t[250][a]]=64e3+a;e[64e3+a]=t[250][a]}t[251]="����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[251].length;++a)if(t[251][a].charCodeAt(0)!==65533){r[t[251][a]]=64256+a;e[64256+a]=t[251][a]}t[252]="����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[252].length;++a)if(t[252][a].charCodeAt(0)!==65533){r[t[252][a]]=64512+a;e[64512+a]=t[252][a]}t[253]="����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[253].length;++a)if(t[253][a].charCodeAt(0)!==65533){r[t[253][a]]=64768+a;e[64768+a]=t[253][a]}t[254]="����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[254].length;++a)if(t[254][a].charCodeAt(0)!==65533){r[t[254][a]]=65024+a;e[65024+a]=t[254][a]}return{enc:r,dec:e}}();cptable[949]=function(){var e=[],r={},t=[],a;t[0]="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[0].length;++a)if(t[0][a].charCodeAt(0)!==65533){r[t[0][a]]=0+a;e[0+a]=t[0][a]}t[129]="�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");for(a=0;a!=t[129].length;++a)if(t[129][a].charCodeAt(0)!==65533){r[t[129][a]]=33024+a;e[33024+a]=t[129][a]}t[130]="�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");for(a=0;a!=t[130].length;++a)if(t[130][a].charCodeAt(0)!==65533){r[t[130][a]]=33280+a;e[33280+a]=t[130][a]}t[131]="�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");for(a=0;a!=t[131].length;++a)if(t[131][a].charCodeAt(0)!==65533){r[t[131][a]]=33536+a;e[33536+a]=t[131][a]}t[132]="�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");for(a=0;a!=t[132].length;++a)if(t[132][a].charCodeAt(0)!==65533){r[t[132][a]]=33792+a;e[33792+a]=t[132][a]}t[133]="�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");for(a=0;a!=t[133].length;++a)if(t[133][a].charCodeAt(0)!==65533){r[t[133][a]]=34048+a;e[34048+a]=t[133][a]}t[134]="�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");for(a=0;a!=t[134].length;++a)if(t[134][a].charCodeAt(0)!==65533){r[t[134][a]]=34304+a;e[34304+a]=t[134][a]}t[135]="�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");for(a=0;a!=t[135].length;++a)if(t[135][a].charCodeAt(0)!==65533){r[t[135][a]]=34560+a;e[34560+a]=t[135][a]}t[136]="�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");for(a=0;a!=t[136].length;++a)if(t[136][a].charCodeAt(0)!==65533){r[t[136][a]]=34816+a;e[34816+a]=t[136][a]}t[137]="�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");for(a=0;a!=t[137].length;++a)if(t[137][a].charCodeAt(0)!==65533){r[t[137][a]]=35072+a;e[35072+a]=t[137][a]}t[138]="�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");for(a=0;a!=t[138].length;++a)if(t[138][a].charCodeAt(0)!==65533){r[t[138][a]]=35328+a;e[35328+a]=t[138][a]}t[139]="�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");for(a=0;a!=t[139].length;++a)if(t[139][a].charCodeAt(0)!==65533){r[t[139][a]]=35584+a;e[35584+a]=t[139][a]}t[140]="�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");for(a=0;a!=t[140].length;++a)if(t[140][a].charCodeAt(0)!==65533){r[t[140][a]]=35840+a;e[35840+a]=t[140][a]}t[141]="�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");for(a=0;a!=t[141].length;++a)if(t[141][a].charCodeAt(0)!==65533){r[t[141][a]]=36096+a;e[36096+a]=t[141][a]}t[142]="�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");for(a=0;a!=t[142].length;++a)if(t[142][a].charCodeAt(0)!==65533){r[t[142][a]]=36352+a;e[36352+a]=t[142][a]}t[143]="�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");for(a=0;a!=t[143].length;++a)if(t[143][a].charCodeAt(0)!==65533){r[t[143][a]]=36608+a;e[36608+a]=t[143][a]}t[144]="�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");for(a=0;a!=t[144].length;++a)if(t[144][a].charCodeAt(0)!==65533){r[t[144][a]]=36864+a;e[36864+a]=t[144][a]}t[145]="�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");for(a=0;a!=t[145].length;++a)if(t[145][a].charCodeAt(0)!==65533){r[t[145][a]]=37120+a;e[37120+a]=t[145][a]}t[146]="�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");for(a=0;a!=t[146].length;++a)if(t[146][a].charCodeAt(0)!==65533){r[t[146][a]]=37376+a;e[37376+a]=t[146][a]}t[147]="�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");for(a=0;a!=t[147].length;++a)if(t[147][a].charCodeAt(0)!==65533){r[t[147][a]]=37632+a;e[37632+a]=t[147][a]}t[148]="�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");for(a=0;a!=t[148].length;++a)if(t[148][a].charCodeAt(0)!==65533){r[t[148][a]]=37888+a;e[37888+a]=t[148][a]}t[149]="�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");for(a=0;a!=t[149].length;++a)if(t[149][a].charCodeAt(0)!==65533){r[t[149][a]]=38144+a;e[38144+a]=t[149][a]}t[150]="�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");for(a=0;a!=t[150].length;++a)if(t[150][a].charCodeAt(0)!==65533){r[t[150][a]]=38400+a;e[38400+a]=t[150][a]}t[151]="�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");for(a=0;a!=t[151].length;++a)if(t[151][a].charCodeAt(0)!==65533){r[t[151][a]]=38656+a;e[38656+a]=t[151][a]}t[152]="�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
for(a=0;a!=t[152].length;++a)if(t[152][a].charCodeAt(0)!==65533){r[t[152][a]]=38912+a;e[38912+a]=t[152][a]}t[153]="�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");for(a=0;a!=t[153].length;++a)if(t[153][a].charCodeAt(0)!==65533){r[t[153][a]]=39168+a;e[39168+a]=t[153][a]}t[154]="�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");for(a=0;a!=t[154].length;++a)if(t[154][a].charCodeAt(0)!==65533){r[t[154][a]]=39424+a;e[39424+a]=t[154][a]}t[155]="�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");for(a=0;a!=t[155].length;++a)if(t[155][a].charCodeAt(0)!==65533){r[t[155][a]]=39680+a;e[39680+a]=t[155][a]}t[156]="�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");for(a=0;a!=t[156].length;++a)if(t[156][a].charCodeAt(0)!==65533){r[t[156][a]]=39936+a;e[39936+a]=t[156][a]}t[157]="�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");for(a=0;a!=t[157].length;++a)if(t[157][a].charCodeAt(0)!==65533){r[t[157][a]]=40192+a;e[40192+a]=t[157][a]}t[158]="�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");for(a=0;a!=t[158].length;++a)if(t[158][a].charCodeAt(0)!==65533){r[t[158][a]]=40448+a;e[40448+a]=t[158][a]}t[159]="�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");for(a=0;a!=t[159].length;++a)if(t[159][a].charCodeAt(0)!==65533){r[t[159][a]]=40704+a;e[40704+a]=t[159][a]}t[160]="�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");for(a=0;a!=t[160].length;++a)if(t[160][a].charCodeAt(0)!==65533){r[t[160][a]]=40960+a;e[40960+a]=t[160][a]}t[161]="�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");for(a=0;a!=t[161].length;++a)if(t[161][a].charCodeAt(0)!==65533){r[t[161][a]]=41216+a;e[41216+a]=t[161][a]}t[162]="�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");for(a=0;a!=t[162].length;++a)if(t[162][a].charCodeAt(0)!==65533){r[t[162][a]]=41472+a;e[41472+a]=t[162][a]}t[163]="�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");for(a=0;a!=t[163].length;++a)if(t[163][a].charCodeAt(0)!==65533){r[t[163][a]]=41728+a;e[41728+a]=t[163][a]}t[164]="�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");for(a=0;a!=t[164].length;++a)if(t[164][a].charCodeAt(0)!==65533){r[t[164][a]]=41984+a;e[41984+a]=t[164][a]}t[165]="�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");for(a=0;a!=t[165].length;++a)if(t[165][a].charCodeAt(0)!==65533){r[t[165][a]]=42240+a;e[42240+a]=t[165][a]}t[166]="�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");for(a=0;a!=t[166].length;++a)if(t[166][a].charCodeAt(0)!==65533){r[t[166][a]]=42496+a;e[42496+a]=t[166][a]}t[167]="�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");for(a=0;a!=t[167].length;++a)if(t[167][a].charCodeAt(0)!==65533){r[t[167][a]]=42752+a;e[42752+a]=t[167][a]}t[168]="�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");for(a=0;a!=t[168].length;++a)if(t[168][a].charCodeAt(0)!==65533){r[t[168][a]]=43008+a;e[43008+a]=t[168][a]}t[169]="�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");for(a=0;a!=t[169].length;++a)if(t[169][a].charCodeAt(0)!==65533){r[t[169][a]]=43264+a;e[43264+a]=t[169][a]}t[170]="�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");for(a=0;a!=t[170].length;++a)if(t[170][a].charCodeAt(0)!==65533){r[t[170][a]]=43520+a;e[43520+a]=t[170][a]}t[171]="�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");for(a=0;a!=t[171].length;++a)if(t[171][a].charCodeAt(0)!==65533){r[t[171][a]]=43776+a;e[43776+a]=t[171][a]}t[172]="�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");for(a=0;a!=t[172].length;++a)if(t[172][a].charCodeAt(0)!==65533){r[t[172][a]]=44032+a;e[44032+a]=t[172][a]}t[173]="�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[173].length;++a)if(t[173][a].charCodeAt(0)!==65533){r[t[173][a]]=44288+a;e[44288+a]=t[173][a]}t[174]="�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[174].length;++a)if(t[174][a].charCodeAt(0)!==65533){r[t[174][a]]=44544+a;e[44544+a]=t[174][a]}t[175]="�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[175].length;++a)if(t[175][a].charCodeAt(0)!==65533){r[t[175][a]]=44800+a;e[44800+a]=t[175][a]}t[176]="�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");for(a=0;a!=t[176].length;++a)if(t[176][a].charCodeAt(0)!==65533){r[t[176][a]]=45056+a;e[45056+a]=t[176][a]}t[177]="�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");for(a=0;a!=t[177].length;++a)if(t[177][a].charCodeAt(0)!==65533){r[t[177][a]]=45312+a;e[45312+a]=t[177][a]}t[178]="�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");for(a=0;a!=t[178].length;++a)if(t[178][a].charCodeAt(0)!==65533){r[t[178][a]]=45568+a;e[45568+a]=t[178][a]}t[179]="�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");for(a=0;a!=t[179].length;++a)if(t[179][a].charCodeAt(0)!==65533){r[t[179][a]]=45824+a;e[45824+a]=t[179][a]}t[180]="�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");for(a=0;a!=t[180].length;++a)if(t[180][a].charCodeAt(0)!==65533){r[t[180][a]]=46080+a;e[46080+a]=t[180][a]}t[181]="�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");for(a=0;a!=t[181].length;++a)if(t[181][a].charCodeAt(0)!==65533){r[t[181][a]]=46336+a;e[46336+a]=t[181][a]}t[182]="�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");for(a=0;a!=t[182].length;++a)if(t[182][a].charCodeAt(0)!==65533){r[t[182][a]]=46592+a;e[46592+a]=t[182][a]}t[183]="�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");for(a=0;a!=t[183].length;++a)if(t[183][a].charCodeAt(0)!==65533){r[t[183][a]]=46848+a;e[46848+a]=t[183][a]}t[184]="�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");for(a=0;a!=t[184].length;++a)if(t[184][a].charCodeAt(0)!==65533){r[t[184][a]]=47104+a;e[47104+a]=t[184][a]}t[185]="�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");for(a=0;a!=t[185].length;++a)if(t[185][a].charCodeAt(0)!==65533){r[t[185][a]]=47360+a;e[47360+a]=t[185][a]}t[186]="�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");for(a=0;a!=t[186].length;++a)if(t[186][a].charCodeAt(0)!==65533){r[t[186][a]]=47616+a;e[47616+a]=t[186][a]}t[187]="�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");for(a=0;a!=t[187].length;++a)if(t[187][a].charCodeAt(0)!==65533){r[t[187][a]]=47872+a;e[47872+a]=t[187][a]}t[188]="�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");for(a=0;a!=t[188].length;++a)if(t[188][a].charCodeAt(0)!==65533){r[t[188][a]]=48128+a;e[48128+a]=t[188][a]}t[189]="�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");for(a=0;a!=t[189].length;++a)if(t[189][a].charCodeAt(0)!==65533){r[t[189][a]]=48384+a;e[48384+a]=t[189][a]}t[190]="�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");for(a=0;a!=t[190].length;++a)if(t[190][a].charCodeAt(0)!==65533){r[t[190][a]]=48640+a;e[48640+a]=t[190][a]}t[191]="�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");for(a=0;a!=t[191].length;++a)if(t[191][a].charCodeAt(0)!==65533){r[t[191][a]]=48896+a;e[48896+a]=t[191][a]}t[192]="�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");for(a=0;a!=t[192].length;++a)if(t[192][a].charCodeAt(0)!==65533){r[t[192][a]]=49152+a;e[49152+a]=t[192][a]}t[193]="�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");for(a=0;a!=t[193].length;++a)if(t[193][a].charCodeAt(0)!==65533){r[t[193][a]]=49408+a;e[49408+a]=t[193][a]}t[194]="�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");for(a=0;a!=t[194].length;++a)if(t[194][a].charCodeAt(0)!==65533){r[t[194][a]]=49664+a;e[49664+a]=t[194][a]}t[195]="�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");for(a=0;a!=t[195].length;++a)if(t[195][a].charCodeAt(0)!==65533){r[t[195][a]]=49920+a;e[49920+a]=t[195][a]}t[196]="�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");for(a=0;a!=t[196].length;++a)if(t[196][a].charCodeAt(0)!==65533){r[t[196][a]]=50176+a;e[50176+a]=t[196][a]}t[197]="�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");for(a=0;a!=t[197].length;++a)if(t[197][a].charCodeAt(0)!==65533){r[t[197][a]]=50432+a;e[50432+a]=t[197][a]}t[198]="�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");for(a=0;a!=t[198].length;++a)if(t[198][a].charCodeAt(0)!==65533){r[t[198][a]]=50688+a;e[50688+a]=t[198][a]}t[199]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");for(a=0;a!=t[199].length;++a)if(t[199][a].charCodeAt(0)!==65533){r[t[199][a]]=50944+a;e[50944+a]=t[199][a]}t[200]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");for(a=0;a!=t[200].length;++a)if(t[200][a].charCodeAt(0)!==65533){r[t[200][a]]=51200+a;e[51200+a]=t[200][a]}t[202]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");for(a=0;a!=t[202].length;++a)if(t[202][a].charCodeAt(0)!==65533){r[t[202][a]]=51712+a;e[51712+a]=t[202][a]}t[203]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");for(a=0;a!=t[203].length;++a)if(t[203][a].charCodeAt(0)!==65533){r[t[203][a]]=51968+a;e[51968+a]=t[203][a]}t[204]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");for(a=0;a!=t[204].length;++a)if(t[204][a].charCodeAt(0)!==65533){r[t[204][a]]=52224+a;e[52224+a]=t[204][a]}t[205]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");for(a=0;a!=t[205].length;++a)if(t[205][a].charCodeAt(0)!==65533){r[t[205][a]]=52480+a;e[52480+a]=t[205][a]}t[206]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");for(a=0;a!=t[206].length;++a)if(t[206][a].charCodeAt(0)!==65533){r[t[206][a]]=52736+a;e[52736+a]=t[206][a]}t[207]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");for(a=0;a!=t[207].length;++a)if(t[207][a].charCodeAt(0)!==65533){r[t[207][a]]=52992+a;e[52992+a]=t[207][a]}t[208]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");for(a=0;a!=t[208].length;++a)if(t[208][a].charCodeAt(0)!==65533){r[t[208][a]]=53248+a;e[53248+a]=t[208][a]}t[209]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");for(a=0;a!=t[209].length;++a)if(t[209][a].charCodeAt(0)!==65533){r[t[209][a]]=53504+a;e[53504+a]=t[209][a]}t[210]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");for(a=0;a!=t[210].length;++a)if(t[210][a].charCodeAt(0)!==65533){r[t[210][a]]=53760+a;e[53760+a]=t[210][a]}t[211]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");for(a=0;a!=t[211].length;++a)if(t[211][a].charCodeAt(0)!==65533){r[t[211][a]]=54016+a;e[54016+a]=t[211][a]}t[212]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");for(a=0;a!=t[212].length;++a)if(t[212][a].charCodeAt(0)!==65533){r[t[212][a]]=54272+a;e[54272+a]=t[212][a]}t[213]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");for(a=0;a!=t[213].length;++a)if(t[213][a].charCodeAt(0)!==65533){r[t[213][a]]=54528+a;e[54528+a]=t[213][a]}t[214]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");for(a=0;a!=t[214].length;++a)if(t[214][a].charCodeAt(0)!==65533){r[t[214][a]]=54784+a;e[54784+a]=t[214][a]}t[215]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");for(a=0;a!=t[215].length;++a)if(t[215][a].charCodeAt(0)!==65533){r[t[215][a]]=55040+a;e[55040+a]=t[215][a]}t[216]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");for(a=0;a!=t[216].length;++a)if(t[216][a].charCodeAt(0)!==65533){r[t[216][a]]=55296+a;e[55296+a]=t[216][a]}t[217]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");for(a=0;a!=t[217].length;++a)if(t[217][a].charCodeAt(0)!==65533){r[t[217][a]]=55552+a;e[55552+a]=t[217][a]}t[218]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");for(a=0;a!=t[218].length;++a)if(t[218][a].charCodeAt(0)!==65533){r[t[218][a]]=55808+a;e[55808+a]=t[218][a]}t[219]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");for(a=0;a!=t[219].length;++a)if(t[219][a].charCodeAt(0)!==65533){r[t[219][a]]=56064+a;e[56064+a]=t[219][a]}t[220]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");for(a=0;a!=t[220].length;++a)if(t[220][a].charCodeAt(0)!==65533){r[t[220][a]]=56320+a;e[56320+a]=t[220][a]}t[221]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");for(a=0;a!=t[221].length;++a)if(t[221][a].charCodeAt(0)!==65533){r[t[221][a]]=56576+a;e[56576+a]=t[221][a]}t[222]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");for(a=0;a!=t[222].length;++a)if(t[222][a].charCodeAt(0)!==65533){r[t[222][a]]=56832+a;e[56832+a]=t[222][a]}t[223]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");for(a=0;a!=t[223].length;++a)if(t[223][a].charCodeAt(0)!==65533){r[t[223][a]]=57088+a;e[57088+a]=t[223][a]}t[224]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");for(a=0;a!=t[224].length;++a)if(t[224][a].charCodeAt(0)!==65533){r[t[224][a]]=57344+a;e[57344+a]=t[224][a]}t[225]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");for(a=0;a!=t[225].length;++a)if(t[225][a].charCodeAt(0)!==65533){r[t[225][a]]=57600+a;e[57600+a]=t[225][a]}t[226]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");for(a=0;a!=t[226].length;++a)if(t[226][a].charCodeAt(0)!==65533){r[t[226][a]]=57856+a;e[57856+a]=t[226][a]}t[227]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");for(a=0;a!=t[227].length;++a)if(t[227][a].charCodeAt(0)!==65533){r[t[227][a]]=58112+a;e[58112+a]=t[227][a]}t[228]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");for(a=0;a!=t[228].length;++a)if(t[228][a].charCodeAt(0)!==65533){r[t[228][a]]=58368+a;e[58368+a]=t[228][a]}t[229]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");for(a=0;a!=t[229].length;++a)if(t[229][a].charCodeAt(0)!==65533){r[t[229][a]]=58624+a;e[58624+a]=t[229][a]}t[230]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");for(a=0;a!=t[230].length;++a)if(t[230][a].charCodeAt(0)!==65533){r[t[230][a]]=58880+a;e[58880+a]=t[230][a]}t[231]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");for(a=0;a!=t[231].length;++a)if(t[231][a].charCodeAt(0)!==65533){r[t[231][a]]=59136+a;e[59136+a]=t[231][a]}t[232]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");for(a=0;a!=t[232].length;++a)if(t[232][a].charCodeAt(0)!==65533){r[t[232][a]]=59392+a;e[59392+a]=t[232][a]}t[233]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");for(a=0;a!=t[233].length;++a)if(t[233][a].charCodeAt(0)!==65533){r[t[233][a]]=59648+a;e[59648+a]=t[233][a]}t[234]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");for(a=0;a!=t[234].length;++a)if(t[234][a].charCodeAt(0)!==65533){r[t[234][a]]=59904+a;e[59904+a]=t[234][a]}t[235]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");for(a=0;a!=t[235].length;++a)if(t[235][a].charCodeAt(0)!==65533){r[t[235][a]]=60160+a;e[60160+a]=t[235][a]}t[236]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");for(a=0;a!=t[236].length;++a)if(t[236][a].charCodeAt(0)!==65533){r[t[236][a]]=60416+a;e[60416+a]=t[236][a]}t[237]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
for(a=0;a!=t[237].length;++a)if(t[237][a].charCodeAt(0)!==65533){r[t[237][a]]=60672+a;e[60672+a]=t[237][a]}t[238]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");for(a=0;a!=t[238].length;++a)if(t[238][a].charCodeAt(0)!==65533){r[t[238][a]]=60928+a;e[60928+a]=t[238][a]}t[239]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");for(a=0;a!=t[239].length;++a)if(t[239][a].charCodeAt(0)!==65533){r[t[239][a]]=61184+a;e[61184+a]=t[239][a]}t[240]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");for(a=0;a!=t[240].length;++a)if(t[240][a].charCodeAt(0)!==65533){r[t[240][a]]=61440+a;e[61440+a]=t[240][a]}t[241]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");for(a=0;a!=t[241].length;++a)if(t[241][a].charCodeAt(0)!==65533){r[t[241][a]]=61696+a;e[61696+a]=t[241][a]}t[242]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");for(a=0;a!=t[242].length;++a)if(t[242][a].charCodeAt(0)!==65533){r[t[242][a]]=61952+a;e[61952+a]=t[242][a]}t[243]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");for(a=0;a!=t[243].length;++a)if(t[243][a].charCodeAt(0)!==65533){r[t[243][a]]=62208+a;e[62208+a]=t[243][a]}t[244]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");for(a=0;a!=t[244].length;++a)if(t[244][a].charCodeAt(0)!==65533){r[t[244][a]]=62464+a;e[62464+a]=t[244][a]}t[245]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");for(a=0;a!=t[245].length;++a)if(t[245][a].charCodeAt(0)!==65533){r[t[245][a]]=62720+a;e[62720+a]=t[245][a]}t[246]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");for(a=0;a!=t[246].length;++a)if(t[246][a].charCodeAt(0)!==65533){r[t[246][a]]=62976+a;e[62976+a]=t[246][a]}t[247]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");for(a=0;a!=t[247].length;++a)if(t[247][a].charCodeAt(0)!==65533){r[t[247][a]]=63232+a;e[63232+a]=t[247][a]}t[248]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");for(a=0;a!=t[248].length;++a)if(t[248][a].charCodeAt(0)!==65533){r[t[248][a]]=63488+a;e[63488+a]=t[248][a]}t[249]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");for(a=0;a!=t[249].length;++a)if(t[249][a].charCodeAt(0)!==65533){r[t[249][a]]=63744+a;e[63744+a]=t[249][a]}t[250]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");for(a=0;a!=t[250].length;++a)if(t[250][a].charCodeAt(0)!==65533){r[t[250][a]]=64e3+a;e[64e3+a]=t[250][a]}t[251]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");for(a=0;a!=t[251].length;++a)if(t[251][a].charCodeAt(0)!==65533){r[t[251][a]]=64256+a;e[64256+a]=t[251][a]}t[252]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");for(a=0;a!=t[252].length;++a)if(t[252][a].charCodeAt(0)!==65533){r[t[252][a]]=64512+a;e[64512+a]=t[252][a]}t[253]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");for(a=0;a!=t[253].length;++a)if(t[253][a].charCodeAt(0)!==65533){r[t[253][a]]=64768+a;e[64768+a]=t[253][a]}return{enc:r,dec:e}}();cptable[950]=function(){var e=[],r={},t=[],a;t[0]="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[0].length;++a)if(t[0][a].charCodeAt(0)!==65533){r[t[0][a]]=0+a;e[0+a]=t[0][a]}t[161]="����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");for(a=0;a!=t[161].length;++a)if(t[161][a].charCodeAt(0)!==65533){r[t[161][a]]=41216+a;e[41216+a]=t[161][a]}t[162]="����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");for(a=0;a!=t[162].length;++a)if(t[162][a].charCodeAt(0)!==65533){r[t[162][a]]=41472+a;e[41472+a]=t[162][a]}t[163]="����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");for(a=0;a!=t[163].length;++a)if(t[163][a].charCodeAt(0)!==65533){r[t[163][a]]=41728+a;e[41728+a]=t[163][a]}t[164]="����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");for(a=0;a!=t[164].length;++a)if(t[164][a].charCodeAt(0)!==65533){r[t[164][a]]=41984+a;e[41984+a]=t[164][a]}t[165]="����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");for(a=0;a!=t[165].length;++a)if(t[165][a].charCodeAt(0)!==65533){r[t[165][a]]=42240+a;e[42240+a]=t[165][a]}t[166]="����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");for(a=0;a!=t[166].length;++a)if(t[166][a].charCodeAt(0)!==65533){r[t[166][a]]=42496+a;e[42496+a]=t[166][a]}t[167]="����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");for(a=0;a!=t[167].length;++a)if(t[167][a].charCodeAt(0)!==65533){r[t[167][a]]=42752+a;e[42752+a]=t[167][a]}t[168]="����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");for(a=0;a!=t[168].length;++a)if(t[168][a].charCodeAt(0)!==65533){r[t[168][a]]=43008+a;e[43008+a]=t[168][a]}t[169]="����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");for(a=0;a!=t[169].length;++a)if(t[169][a].charCodeAt(0)!==65533){r[t[169][a]]=43264+a;e[43264+a]=t[169][a]}t[170]="����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");for(a=0;a!=t[170].length;++a)if(t[170][a].charCodeAt(0)!==65533){r[t[170][a]]=43520+a;e[43520+a]=t[170][a]}t[171]="����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");for(a=0;a!=t[171].length;++a)if(t[171][a].charCodeAt(0)!==65533){r[t[171][a]]=43776+a;e[43776+a]=t[171][a]}t[172]="����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");for(a=0;a!=t[172].length;++a)if(t[172][a].charCodeAt(0)!==65533){r[t[172][a]]=44032+a;e[44032+a]=t[172][a]}t[173]="����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");for(a=0;a!=t[173].length;++a)if(t[173][a].charCodeAt(0)!==65533){r[t[173][a]]=44288+a;e[44288+a]=t[173][a]}t[174]="����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");for(a=0;a!=t[174].length;++a)if(t[174][a].charCodeAt(0)!==65533){r[t[174][a]]=44544+a;e[44544+a]=t[174][a]}t[175]="����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");for(a=0;a!=t[175].length;++a)if(t[175][a].charCodeAt(0)!==65533){r[t[175][a]]=44800+a;e[44800+a]=t[175][a]}t[176]="����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");for(a=0;a!=t[176].length;++a)if(t[176][a].charCodeAt(0)!==65533){r[t[176][a]]=45056+a;e[45056+a]=t[176][a]}t[177]="����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");for(a=0;a!=t[177].length;++a)if(t[177][a].charCodeAt(0)!==65533){r[t[177][a]]=45312+a;e[45312+a]=t[177][a]}t[178]="����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");for(a=0;a!=t[178].length;++a)if(t[178][a].charCodeAt(0)!==65533){r[t[178][a]]=45568+a;e[45568+a]=t[178][a]}t[179]="����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");for(a=0;a!=t[179].length;++a)if(t[179][a].charCodeAt(0)!==65533){r[t[179][a]]=45824+a;e[45824+a]=t[179][a]}t[180]="����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");for(a=0;a!=t[180].length;++a)if(t[180][a].charCodeAt(0)!==65533){r[t[180][a]]=46080+a;e[46080+a]=t[180][a]}t[181]="����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");for(a=0;a!=t[181].length;++a)if(t[181][a].charCodeAt(0)!==65533){r[t[181][a]]=46336+a;e[46336+a]=t[181][a]}t[182]="����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");for(a=0;a!=t[182].length;++a)if(t[182][a].charCodeAt(0)!==65533){r[t[182][a]]=46592+a;e[46592+a]=t[182][a]}t[183]="����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");for(a=0;a!=t[183].length;++a)if(t[183][a].charCodeAt(0)!==65533){r[t[183][a]]=46848+a;e[46848+a]=t[183][a]}t[184]="����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");for(a=0;a!=t[184].length;++a)if(t[184][a].charCodeAt(0)!==65533){r[t[184][a]]=47104+a;e[47104+a]=t[184][a]}t[185]="����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");for(a=0;a!=t[185].length;++a)if(t[185][a].charCodeAt(0)!==65533){r[t[185][a]]=47360+a;e[47360+a]=t[185][a]}t[186]="����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");for(a=0;a!=t[186].length;++a)if(t[186][a].charCodeAt(0)!==65533){r[t[186][a]]=47616+a;e[47616+a]=t[186][a]}t[187]="����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");for(a=0;a!=t[187].length;++a)if(t[187][a].charCodeAt(0)!==65533){r[t[187][a]]=47872+a;e[47872+a]=t[187][a]}t[188]="����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");for(a=0;a!=t[188].length;++a)if(t[188][a].charCodeAt(0)!==65533){r[t[188][a]]=48128+a;e[48128+a]=t[188][a]}t[189]="����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");for(a=0;a!=t[189].length;++a)if(t[189][a].charCodeAt(0)!==65533){r[t[189][a]]=48384+a;e[48384+a]=t[189][a]}t[190]="����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");for(a=0;a!=t[190].length;++a)if(t[190][a].charCodeAt(0)!==65533){r[t[190][a]]=48640+a;e[48640+a]=t[190][a]}t[191]="����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");for(a=0;a!=t[191].length;++a)if(t[191][a].charCodeAt(0)!==65533){r[t[191][a]]=48896+a;e[48896+a]=t[191][a]}t[192]="����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");for(a=0;a!=t[192].length;++a)if(t[192][a].charCodeAt(0)!==65533){r[t[192][a]]=49152+a;e[49152+a]=t[192][a]}t[193]="����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");for(a=0;a!=t[193].length;++a)if(t[193][a].charCodeAt(0)!==65533){r[t[193][a]]=49408+a;e[49408+a]=t[193][a]}t[194]="����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");for(a=0;a!=t[194].length;++a)if(t[194][a].charCodeAt(0)!==65533){r[t[194][a]]=49664+a;e[49664+a]=t[194][a]}t[195]="����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");for(a=0;a!=t[195].length;++a)if(t[195][a].charCodeAt(0)!==65533){r[t[195][a]]=49920+a;e[49920+a]=t[195][a]}t[196]="����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");for(a=0;a!=t[196].length;++a)if(t[196][a].charCodeAt(0)!==65533){r[t[196][a]]=50176+a;e[50176+a]=t[196][a]}t[197]="����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");for(a=0;a!=t[197].length;++a)if(t[197][a].charCodeAt(0)!==65533){r[t[197][a]]=50432+a;e[50432+a]=t[197][a]}t[198]="����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[198].length;++a)if(t[198][a].charCodeAt(0)!==65533){r[t[198][a]]=50688+a;e[50688+a]=t[198][a]}t[201]="����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");for(a=0;a!=t[201].length;++a)if(t[201][a].charCodeAt(0)!==65533){r[t[201][a]]=51456+a;e[51456+a]=t[201][a]}t[202]="����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");for(a=0;a!=t[202].length;++a)if(t[202][a].charCodeAt(0)!==65533){r[t[202][a]]=51712+a;e[51712+a]=t[202][a]}t[203]="����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");for(a=0;a!=t[203].length;++a)if(t[203][a].charCodeAt(0)!==65533){r[t[203][a]]=51968+a;e[51968+a]=t[203][a]}t[204]="����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");for(a=0;a!=t[204].length;++a)if(t[204][a].charCodeAt(0)!==65533){r[t[204][a]]=52224+a;e[52224+a]=t[204][a]}t[205]="����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");for(a=0;a!=t[205].length;++a)if(t[205][a].charCodeAt(0)!==65533){r[t[205][a]]=52480+a;e[52480+a]=t[205][a]}t[206]="����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");for(a=0;a!=t[206].length;++a)if(t[206][a].charCodeAt(0)!==65533){r[t[206][a]]=52736+a;e[52736+a]=t[206][a]}t[207]="����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");for(a=0;a!=t[207].length;++a)if(t[207][a].charCodeAt(0)!==65533){r[t[207][a]]=52992+a;e[52992+a]=t[207][a]}t[208]="����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");for(a=0;a!=t[208].length;++a)if(t[208][a].charCodeAt(0)!==65533){r[t[208][a]]=53248+a;e[53248+a]=t[208][a]}t[209]="����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");for(a=0;a!=t[209].length;++a)if(t[209][a].charCodeAt(0)!==65533){r[t[209][a]]=53504+a;e[53504+a]=t[209][a]}t[210]="����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");for(a=0;a!=t[210].length;++a)if(t[210][a].charCodeAt(0)!==65533){r[t[210][a]]=53760+a;e[53760+a]=t[210][a]}t[211]="����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");for(a=0;a!=t[211].length;++a)if(t[211][a].charCodeAt(0)!==65533){r[t[211][a]]=54016+a;e[54016+a]=t[211][a]}t[212]="����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");for(a=0;a!=t[212].length;++a)if(t[212][a].charCodeAt(0)!==65533){r[t[212][a]]=54272+a;e[54272+a]=t[212][a]}t[213]="����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");for(a=0;a!=t[213].length;++a)if(t[213][a].charCodeAt(0)!==65533){r[t[213][a]]=54528+a;e[54528+a]=t[213][a]}t[214]="����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");for(a=0;a!=t[214].length;++a)if(t[214][a].charCodeAt(0)!==65533){r[t[214][a]]=54784+a;e[54784+a]=t[214][a]}t[215]="����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");for(a=0;a!=t[215].length;++a)if(t[215][a].charCodeAt(0)!==65533){r[t[215][a]]=55040+a;e[55040+a]=t[215][a]}t[216]="����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");for(a=0;a!=t[216].length;++a)if(t[216][a].charCodeAt(0)!==65533){r[t[216][a]]=55296+a;e[55296+a]=t[216][a]}t[217]="����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");for(a=0;a!=t[217].length;++a)if(t[217][a].charCodeAt(0)!==65533){r[t[217][a]]=55552+a;e[55552+a]=t[217][a]}t[218]="����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");for(a=0;a!=t[218].length;++a)if(t[218][a].charCodeAt(0)!==65533){r[t[218][a]]=55808+a;e[55808+a]=t[218][a]}t[219]="����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");for(a=0;a!=t[219].length;++a)if(t[219][a].charCodeAt(0)!==65533){r[t[219][a]]=56064+a;e[56064+a]=t[219][a]}t[220]="����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");for(a=0;a!=t[220].length;++a)if(t[220][a].charCodeAt(0)!==65533){r[t[220][a]]=56320+a;e[56320+a]=t[220][a]}t[221]="����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");for(a=0;a!=t[221].length;++a)if(t[221][a].charCodeAt(0)!==65533){r[t[221][a]]=56576+a;e[56576+a]=t[221][a]}t[222]="����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");for(a=0;a!=t[222].length;++a)if(t[222][a].charCodeAt(0)!==65533){r[t[222][a]]=56832+a;e[56832+a]=t[222][a]}t[223]="����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");for(a=0;a!=t[223].length;++a)if(t[223][a].charCodeAt(0)!==65533){r[t[223][a]]=57088+a;e[57088+a]=t[223][a]}t[224]="����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");for(a=0;a!=t[224].length;++a)if(t[224][a].charCodeAt(0)!==65533){r[t[224][a]]=57344+a;e[57344+a]=t[224][a]}t[225]="����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");for(a=0;a!=t[225].length;++a)if(t[225][a].charCodeAt(0)!==65533){r[t[225][a]]=57600+a;e[57600+a]=t[225][a]}t[226]="����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");for(a=0;a!=t[226].length;++a)if(t[226][a].charCodeAt(0)!==65533){r[t[226][a]]=57856+a;e[57856+a]=t[226][a]}t[227]="����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");for(a=0;a!=t[227].length;++a)if(t[227][a].charCodeAt(0)!==65533){r[t[227][a]]=58112+a;e[58112+a]=t[227][a]}t[228]="����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");for(a=0;a!=t[228].length;++a)if(t[228][a].charCodeAt(0)!==65533){r[t[228][a]]=58368+a;e[58368+a]=t[228][a]}t[229]="����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
for(a=0;a!=t[229].length;++a)if(t[229][a].charCodeAt(0)!==65533){r[t[229][a]]=58624+a;e[58624+a]=t[229][a]}t[230]="����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");for(a=0;a!=t[230].length;++a)if(t[230][a].charCodeAt(0)!==65533){r[t[230][a]]=58880+a;e[58880+a]=t[230][a]}t[231]="����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");for(a=0;a!=t[231].length;++a)if(t[231][a].charCodeAt(0)!==65533){r[t[231][a]]=59136+a;e[59136+a]=t[231][a]}t[232]="����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");for(a=0;a!=t[232].length;++a)if(t[232][a].charCodeAt(0)!==65533){r[t[232][a]]=59392+a;e[59392+a]=t[232][a]}t[233]="����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");for(a=0;a!=t[233].length;++a)if(t[233][a].charCodeAt(0)!==65533){r[t[233][a]]=59648+a;e[59648+a]=t[233][a]}t[234]="����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");for(a=0;a!=t[234].length;++a)if(t[234][a].charCodeAt(0)!==65533){r[t[234][a]]=59904+a;e[59904+a]=t[234][a]}t[235]="����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");for(a=0;a!=t[235].length;++a)if(t[235][a].charCodeAt(0)!==65533){r[t[235][a]]=60160+a;e[60160+a]=t[235][a]}t[236]="����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");for(a=0;a!=t[236].length;++a)if(t[236][a].charCodeAt(0)!==65533){r[t[236][a]]=60416+a;e[60416+a]=t[236][a]}t[237]="����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");for(a=0;a!=t[237].length;++a)if(t[237][a].charCodeAt(0)!==65533){r[t[237][a]]=60672+a;e[60672+a]=t[237][a]}t[238]="����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");for(a=0;a!=t[238].length;++a)if(t[238][a].charCodeAt(0)!==65533){r[t[238][a]]=60928+a;e[60928+a]=t[238][a]}t[239]="����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");for(a=0;a!=t[239].length;++a)if(t[239][a].charCodeAt(0)!==65533){r[t[239][a]]=61184+a;e[61184+a]=t[239][a]}t[240]="����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");for(a=0;a!=t[240].length;++a)if(t[240][a].charCodeAt(0)!==65533){r[t[240][a]]=61440+a;e[61440+a]=t[240][a]}t[241]="����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");for(a=0;a!=t[241].length;++a)if(t[241][a].charCodeAt(0)!==65533){r[t[241][a]]=61696+a;e[61696+a]=t[241][a]}t[242]="����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");for(a=0;a!=t[242].length;++a)if(t[242][a].charCodeAt(0)!==65533){r[t[242][a]]=61952+a;e[61952+a]=t[242][a]}t[243]="����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");for(a=0;a!=t[243].length;++a)if(t[243][a].charCodeAt(0)!==65533){r[t[243][a]]=62208+a;e[62208+a]=t[243][a]}t[244]="����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");for(a=0;a!=t[244].length;++a)if(t[244][a].charCodeAt(0)!==65533){r[t[244][a]]=62464+a;e[62464+a]=t[244][a]}t[245]="����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");for(a=0;a!=t[245].length;++a)if(t[245][a].charCodeAt(0)!==65533){r[t[245][a]]=62720+a;e[62720+a]=t[245][a]}t[246]="����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");for(a=0;a!=t[246].length;++a)if(t[246][a].charCodeAt(0)!==65533){r[t[246][a]]=62976+a;e[62976+a]=t[246][a]}t[247]="����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");for(a=0;a!=t[247].length;++a)if(t[247][a].charCodeAt(0)!==65533){r[t[247][a]]=63232+a;e[63232+a]=t[247][a]}t[248]="����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");for(a=0;a!=t[248].length;++a)if(t[248][a].charCodeAt(0)!==65533){r[t[248][a]]=63488+a;e[63488+a]=t[248][a]}t[249]="����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");for(a=0;a!=t[249].length;++a)if(t[249][a].charCodeAt(0)!==65533){r[t[249][a]]=63744+a;e[63744+a]=t[249][a]}return{enc:r,dec:e}}();cptable[1250]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1251]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1252]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1253]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1254]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1255]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1256]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1257]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1258]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1e4]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[10006]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[10007]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[10008]=function(){var e=[],r={},t=[],a;t[0]="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");for(a=0;a!=t[0].length;++a)if(t[0][a].charCodeAt(0)!==65533){r[t[0][a]]=0+a;e[0+a]=t[0][a]}t[161]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");for(a=0;a!=t[161].length;++a)if(t[161][a].charCodeAt(0)!==65533){r[t[161][a]]=41216+a;e[41216+a]=t[161][a]}t[162]="���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");for(a=0;a!=t[162].length;++a)if(t[162][a].charCodeAt(0)!==65533){r[t[162][a]]=41472+a;e[41472+a]=t[162][a]}t[163]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");for(a=0;a!=t[163].length;++a)if(t[163][a].charCodeAt(0)!==65533){r[t[163][a]]=41728+a;e[41728+a]=t[163][a]}t[164]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");for(a=0;a!=t[164].length;++a)if(t[164][a].charCodeAt(0)!==65533){r[t[164][a]]=41984+a;e[41984+a]=t[164][a]}t[165]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");for(a=0;a!=t[165].length;++a)if(t[165][a].charCodeAt(0)!==65533){r[t[165][a]]=42240+a;e[42240+a]=t[165][a]}t[166]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");for(a=0;a!=t[166].length;++a)if(t[166][a].charCodeAt(0)!==65533){r[t[166][a]]=42496+a;e[42496+a]=t[166][a]}t[167]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");for(a=0;a!=t[167].length;++a)if(t[167][a].charCodeAt(0)!==65533){r[t[167][a]]=42752+a;e[42752+a]=t[167][a]}t[168]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");for(a=0;a!=t[168].length;++a)if(t[168][a].charCodeAt(0)!==65533){r[t[168][a]]=43008+a;e[43008+a]=t[168][a]}t[169]="��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");for(a=0;a!=t[169].length;++a)if(t[169][a].charCodeAt(0)!==65533){r[t[169][a]]=43264+a;e[43264+a]=t[169][a]}t[176]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");for(a=0;a!=t[176].length;++a)if(t[176][a].charCodeAt(0)!==65533){r[t[176][a]]=45056+a;e[45056+a]=t[176][a]}t[177]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");for(a=0;a!=t[177].length;++a)if(t[177][a].charCodeAt(0)!==65533){r[t[177][a]]=45312+a;e[45312+a]=t[177][a]}t[178]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");for(a=0;a!=t[178].length;++a)if(t[178][a].charCodeAt(0)!==65533){r[t[178][a]]=45568+a;e[45568+a]=t[178][a]}t[179]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");for(a=0;a!=t[179].length;++a)if(t[179][a].charCodeAt(0)!==65533){r[t[179][a]]=45824+a;e[45824+a]=t[179][a]}t[180]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");for(a=0;a!=t[180].length;++a)if(t[180][a].charCodeAt(0)!==65533){r[t[180][a]]=46080+a;e[46080+a]=t[180][a]}t[181]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");for(a=0;a!=t[181].length;++a)if(t[181][a].charCodeAt(0)!==65533){r[t[181][a]]=46336+a;e[46336+a]=t[181][a]}t[182]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");for(a=0;a!=t[182].length;++a)if(t[182][a].charCodeAt(0)!==65533){r[t[182][a]]=46592+a;e[46592+a]=t[182][a]}t[183]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");for(a=0;a!=t[183].length;++a)if(t[183][a].charCodeAt(0)!==65533){r[t[183][a]]=46848+a;e[46848+a]=t[183][a]}t[184]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");for(a=0;a!=t[184].length;++a)if(t[184][a].charCodeAt(0)!==65533){r[t[184][a]]=47104+a;e[47104+a]=t[184][a]}t[185]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");for(a=0;a!=t[185].length;++a)if(t[185][a].charCodeAt(0)!==65533){r[t[185][a]]=47360+a;e[47360+a]=t[185][a]}t[186]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");for(a=0;a!=t[186].length;++a)if(t[186][a].charCodeAt(0)!==65533){r[t[186][a]]=47616+a;e[47616+a]=t[186][a]}t[187]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");for(a=0;a!=t[187].length;++a)if(t[187][a].charCodeAt(0)!==65533){r[t[187][a]]=47872+a;e[47872+a]=t[187][a]}t[188]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");for(a=0;a!=t[188].length;++a)if(t[188][a].charCodeAt(0)!==65533){r[t[188][a]]=48128+a;e[48128+a]=t[188][a]}t[189]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");for(a=0;a!=t[189].length;++a)if(t[189][a].charCodeAt(0)!==65533){r[t[189][a]]=48384+a;e[48384+a]=t[189][a]}t[190]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");for(a=0;a!=t[190].length;++a)if(t[190][a].charCodeAt(0)!==65533){r[t[190][a]]=48640+a;e[48640+a]=t[190][a]}t[191]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");for(a=0;a!=t[191].length;++a)if(t[191][a].charCodeAt(0)!==65533){r[t[191][a]]=48896+a;e[48896+a]=t[191][a]}t[192]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");for(a=0;a!=t[192].length;++a)if(t[192][a].charCodeAt(0)!==65533){r[t[192][a]]=49152+a;e[49152+a]=t[192][a]}t[193]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");for(a=0;a!=t[193].length;++a)if(t[193][a].charCodeAt(0)!==65533){r[t[193][a]]=49408+a;e[49408+a]=t[193][a]}t[194]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");for(a=0;a!=t[194].length;++a)if(t[194][a].charCodeAt(0)!==65533){r[t[194][a]]=49664+a;e[49664+a]=t[194][a]}t[195]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");for(a=0;a!=t[195].length;++a)if(t[195][a].charCodeAt(0)!==65533){r[t[195][a]]=49920+a;e[49920+a]=t[195][a]}t[196]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");for(a=0;a!=t[196].length;++a)if(t[196][a].charCodeAt(0)!==65533){r[t[196][a]]=50176+a;e[50176+a]=t[196][a]}t[197]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");for(a=0;a!=t[197].length;++a)if(t[197][a].charCodeAt(0)!==65533){r[t[197][a]]=50432+a;e[50432+a]=t[197][a]}t[198]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");for(a=0;a!=t[198].length;++a)if(t[198][a].charCodeAt(0)!==65533){r[t[198][a]]=50688+a;e[50688+a]=t[198][a]}t[199]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");for(a=0;a!=t[199].length;++a)if(t[199][a].charCodeAt(0)!==65533){r[t[199][a]]=50944+a;e[50944+a]=t[199][a]}t[200]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");for(a=0;a!=t[200].length;++a)if(t[200][a].charCodeAt(0)!==65533){r[t[200][a]]=51200+a;e[51200+a]=t[200][a]}t[201]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");for(a=0;a!=t[201].length;++a)if(t[201][a].charCodeAt(0)!==65533){r[t[201][a]]=51456+a;e[51456+a]=t[201][a]}t[202]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");for(a=0;a!=t[202].length;++a)if(t[202][a].charCodeAt(0)!==65533){r[t[202][a]]=51712+a;e[51712+a]=t[202][a]}t[203]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");for(a=0;a!=t[203].length;++a)if(t[203][a].charCodeAt(0)!==65533){r[t[203][a]]=51968+a;e[51968+a]=t[203][a]}t[204]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");for(a=0;a!=t[204].length;++a)if(t[204][a].charCodeAt(0)!==65533){r[t[204][a]]=52224+a;e[52224+a]=t[204][a]}t[205]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");for(a=0;a!=t[205].length;++a)if(t[205][a].charCodeAt(0)!==65533){r[t[205][a]]=52480+a;e[52480+a]=t[205][a]}t[206]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");for(a=0;a!=t[206].length;++a)if(t[206][a].charCodeAt(0)!==65533){r[t[206][a]]=52736+a;e[52736+a]=t[206][a]}t[207]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");for(a=0;a!=t[207].length;++a)if(t[207][a].charCodeAt(0)!==65533){r[t[207][a]]=52992+a;e[52992+a]=t[207][a]}t[208]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");for(a=0;a!=t[208].length;++a)if(t[208][a].charCodeAt(0)!==65533){r[t[208][a]]=53248+a;e[53248+a]=t[208][a]}t[209]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");for(a=0;a!=t[209].length;++a)if(t[209][a].charCodeAt(0)!==65533){r[t[209][a]]=53504+a;e[53504+a]=t[209][a]}t[210]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");for(a=0;a!=t[210].length;++a)if(t[210][a].charCodeAt(0)!==65533){r[t[210][a]]=53760+a;e[53760+a]=t[210][a]}t[211]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");for(a=0;a!=t[211].length;++a)if(t[211][a].charCodeAt(0)!==65533){r[t[211][a]]=54016+a;e[54016+a]=t[211][a]}t[212]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");for(a=0;a!=t[212].length;++a)if(t[212][a].charCodeAt(0)!==65533){r[t[212][a]]=54272+a;e[54272+a]=t[212][a]}t[213]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");for(a=0;a!=t[213].length;++a)if(t[213][a].charCodeAt(0)!==65533){r[t[213][a]]=54528+a;e[54528+a]=t[213][a]}t[214]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");for(a=0;a!=t[214].length;++a)if(t[214][a].charCodeAt(0)!==65533){r[t[214][a]]=54784+a;e[54784+a]=t[214][a]}t[215]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");for(a=0;a!=t[215].length;++a)if(t[215][a].charCodeAt(0)!==65533){
r[t[215][a]]=55040+a;e[55040+a]=t[215][a]}t[216]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");for(a=0;a!=t[216].length;++a)if(t[216][a].charCodeAt(0)!==65533){r[t[216][a]]=55296+a;e[55296+a]=t[216][a]}t[217]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");for(a=0;a!=t[217].length;++a)if(t[217][a].charCodeAt(0)!==65533){r[t[217][a]]=55552+a;e[55552+a]=t[217][a]}t[218]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");for(a=0;a!=t[218].length;++a)if(t[218][a].charCodeAt(0)!==65533){r[t[218][a]]=55808+a;e[55808+a]=t[218][a]}t[219]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");for(a=0;a!=t[219].length;++a)if(t[219][a].charCodeAt(0)!==65533){r[t[219][a]]=56064+a;e[56064+a]=t[219][a]}t[220]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");for(a=0;a!=t[220].length;++a)if(t[220][a].charCodeAt(0)!==65533){r[t[220][a]]=56320+a;e[56320+a]=t[220][a]}t[221]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");for(a=0;a!=t[221].length;++a)if(t[221][a].charCodeAt(0)!==65533){r[t[221][a]]=56576+a;e[56576+a]=t[221][a]}t[222]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");for(a=0;a!=t[222].length;++a)if(t[222][a].charCodeAt(0)!==65533){r[t[222][a]]=56832+a;e[56832+a]=t[222][a]}t[223]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");for(a=0;a!=t[223].length;++a)if(t[223][a].charCodeAt(0)!==65533){r[t[223][a]]=57088+a;e[57088+a]=t[223][a]}t[224]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");for(a=0;a!=t[224].length;++a)if(t[224][a].charCodeAt(0)!==65533){r[t[224][a]]=57344+a;e[57344+a]=t[224][a]}t[225]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");for(a=0;a!=t[225].length;++a)if(t[225][a].charCodeAt(0)!==65533){r[t[225][a]]=57600+a;e[57600+a]=t[225][a]}t[226]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");for(a=0;a!=t[226].length;++a)if(t[226][a].charCodeAt(0)!==65533){r[t[226][a]]=57856+a;e[57856+a]=t[226][a]}t[227]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");for(a=0;a!=t[227].length;++a)if(t[227][a].charCodeAt(0)!==65533){r[t[227][a]]=58112+a;e[58112+a]=t[227][a]}t[228]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");for(a=0;a!=t[228].length;++a)if(t[228][a].charCodeAt(0)!==65533){r[t[228][a]]=58368+a;e[58368+a]=t[228][a]}t[229]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");for(a=0;a!=t[229].length;++a)if(t[229][a].charCodeAt(0)!==65533){r[t[229][a]]=58624+a;e[58624+a]=t[229][a]}t[230]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");for(a=0;a!=t[230].length;++a)if(t[230][a].charCodeAt(0)!==65533){r[t[230][a]]=58880+a;e[58880+a]=t[230][a]}t[231]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");for(a=0;a!=t[231].length;++a)if(t[231][a].charCodeAt(0)!==65533){r[t[231][a]]=59136+a;e[59136+a]=t[231][a]}t[232]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");for(a=0;a!=t[232].length;++a)if(t[232][a].charCodeAt(0)!==65533){r[t[232][a]]=59392+a;e[59392+a]=t[232][a]}t[233]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");for(a=0;a!=t[233].length;++a)if(t[233][a].charCodeAt(0)!==65533){r[t[233][a]]=59648+a;e[59648+a]=t[233][a]}t[234]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");for(a=0;a!=t[234].length;++a)if(t[234][a].charCodeAt(0)!==65533){r[t[234][a]]=59904+a;e[59904+a]=t[234][a]}t[235]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");for(a=0;a!=t[235].length;++a)if(t[235][a].charCodeAt(0)!==65533){r[t[235][a]]=60160+a;e[60160+a]=t[235][a]}t[236]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");for(a=0;a!=t[236].length;++a)if(t[236][a].charCodeAt(0)!==65533){r[t[236][a]]=60416+a;e[60416+a]=t[236][a]}t[237]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");for(a=0;a!=t[237].length;++a)if(t[237][a].charCodeAt(0)!==65533){r[t[237][a]]=60672+a;e[60672+a]=t[237][a]}t[238]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");for(a=0;a!=t[238].length;++a)if(t[238][a].charCodeAt(0)!==65533){r[t[238][a]]=60928+a;e[60928+a]=t[238][a]}t[239]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");for(a=0;a!=t[239].length;++a)if(t[239][a].charCodeAt(0)!==65533){r[t[239][a]]=61184+a;e[61184+a]=t[239][a]}t[240]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");for(a=0;a!=t[240].length;++a)if(t[240][a].charCodeAt(0)!==65533){r[t[240][a]]=61440+a;e[61440+a]=t[240][a]}t[241]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");for(a=0;a!=t[241].length;++a)if(t[241][a].charCodeAt(0)!==65533){r[t[241][a]]=61696+a;e[61696+a]=t[241][a]}t[242]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");for(a=0;a!=t[242].length;++a)if(t[242][a].charCodeAt(0)!==65533){r[t[242][a]]=61952+a;e[61952+a]=t[242][a]}t[243]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");for(a=0;a!=t[243].length;++a)if(t[243][a].charCodeAt(0)!==65533){r[t[243][a]]=62208+a;e[62208+a]=t[243][a]}t[244]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");for(a=0;a!=t[244].length;++a)if(t[244][a].charCodeAt(0)!==65533){r[t[244][a]]=62464+a;e[62464+a]=t[244][a]}t[245]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");for(a=0;a!=t[245].length;++a)if(t[245][a].charCodeAt(0)!==65533){r[t[245][a]]=62720+a;e[62720+a]=t[245][a]}t[246]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");for(a=0;a!=t[246].length;++a)if(t[246][a].charCodeAt(0)!==65533){r[t[246][a]]=62976+a;e[62976+a]=t[246][a]}t[247]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");for(a=0;a!=t[247].length;++a)if(t[247][a].charCodeAt(0)!==65533){r[t[247][a]]=63232+a;e[63232+a]=t[247][a]}return{enc:r,dec:e}}();cptable[10029]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[10079]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[10081]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();if(typeof module!=="undefined"&&module.exports&&typeof DO_NOT_EXPORT_CODEPAGE==="undefined")module.exports=cptable;(function(e,r){"use strict";if(typeof cptable==="undefined"){if(typeof require!=="undefined"){var t=cptable;if(typeof module!=="undefined"&&module.exports&&typeof DO_NOT_EXPORT_CODEPAGE==="undefined")module.exports=r(t);else e.cptable=r(t)}else throw new Error("cptable not found")}else cptable=r(cptable)})(this,function(e){"use strict";var r={1200:"utf16le",1201:"utf16be",12000:"utf32le",12001:"utf32be",16969:"utf64le",20127:"ascii",65000:"utf7",65001:"utf8"};var t=[874,1250,1251,1252,1253,1254,1255,1256,1e4];var a=[932,936,949,950];var n=[65001];var i={};var s={};var f={};var o={};var l=function F(e){return String.fromCharCode(e)};var c=function P(e){return e.charCodeAt(0)};var h=typeof Buffer!=="undefined";var u=function(){};if(h){var d=!Buffer.from;if(!d)try{Buffer.from("foo","utf8")}catch(p){d=true}u=d?function(e,r){return r?new Buffer(e,r):new Buffer(e)}:Buffer.from.bind(Buffer);if(!Buffer.allocUnsafe)Buffer.allocUnsafe=function(e){return new Buffer(e)};var v=1024,g=Buffer.allocUnsafe(v);var m=function N(e){var r=Buffer.allocUnsafe(65536);for(var t=0;t<65536;++t)r[t]=0;var a=Object.keys(e),n=a.length;for(var i=0,s=a[i];i<n;++i){if(!(s=a[i]))continue;r[s.charCodeAt(0)]=e[s]}return r};var b=function L(r){var t=m(e[r].enc);return function a(e,r){var a=e.length;var n,i=0,s=0,f=0,o=0;if(typeof e==="string"){n=Buffer.allocUnsafe(a);for(i=0;i<a;++i)n[i]=t[e.charCodeAt(i)]}else if(Buffer.isBuffer(e)){n=Buffer.allocUnsafe(2*a);s=0;for(i=0;i<a;++i){f=e[i];if(f<128)n[s++]=t[f];else if(f<224){n[s++]=t[((f&31)<<6)+(e[i+1]&63)];++i}else if(f<240){n[s++]=t[((f&15)<<12)+((e[i+1]&63)<<6)+(e[i+2]&63)];i+=2}else{o=((f&7)<<18)+((e[i+1]&63)<<12)+((e[i+2]&63)<<6)+(e[i+3]&63);i+=3;if(o<65536)n[s++]=t[o];else{o-=65536;n[s++]=t[55296+(o>>10&1023)];n[s++]=t[56320+(o&1023)]}}}n=n.slice(0,s)}else{n=Buffer.allocUnsafe(a);for(i=0;i<a;++i)n[i]=t[e[i].charCodeAt(0)]}if(!r||r==="buf")return n;if(r!=="arr")return n.toString("binary");return[].slice.call(n)}};var w=function M(r){var t=e[r].dec;var a=Buffer.allocUnsafe(131072),n=0,i="";for(n=0;n<t.length;++n){if(!(i=t[n]))continue;var s=i.charCodeAt(0);a[2*n]=s&255;a[2*n+1]=s>>8}return function f(e){var r=e.length,t=0,n=0;if(2*r>v){v=2*r;g=Buffer.allocUnsafe(v)}if(Buffer.isBuffer(e)){for(t=0;t<r;t++){n=2*e[t];g[2*t]=a[n];g[2*t+1]=a[n+1]}}else if(typeof e==="string"){for(t=0;t<r;t++){n=2*e.charCodeAt(t);g[2*t]=a[n];g[2*t+1]=a[n+1]}}else{for(t=0;t<r;t++){n=2*e[t];g[2*t]=a[n];g[2*t+1]=a[n+1]}}return g.slice(0,2*r).toString("ucs2")}};var C=function U(r){var t=e[r].enc;var a=Buffer.allocUnsafe(131072);for(var n=0;n<131072;++n)a[n]=0;var i=Object.keys(t);for(var s=0,f=i[s];s<i.length;++s){if(!(f=i[s]))continue;var o=f.charCodeAt(0);a[2*o]=t[f]&255;a[2*o+1]=t[f]>>8}return function l(e,r){var t=e.length,n=Buffer.allocUnsafe(2*t),i=0,s=0,f=0,o=0,l=0;if(typeof e==="string"){for(i=o=0;i<t;++i){s=e.charCodeAt(i)*2;n[o++]=a[s+1]||a[s];if(a[s+1]>0)n[o++]=a[s]}n=n.slice(0,o)}else if(Buffer.isBuffer(e)){for(i=o=0;i<t;++i){l=e[i];if(l<128)s=l;else if(l<224){s=((l&31)<<6)+(e[i+1]&63);++i}else if(l<240){s=((l&15)<<12)+((e[i+1]&63)<<6)+(e[i+2]&63);i+=2}else{s=((l&7)<<18)+((e[i+1]&63)<<12)+((e[i+2]&63)<<6)+(e[i+3]&63);i+=3}if(s<65536){s*=2;n[o++]=a[s+1]||a[s];if(a[s+1]>0)n[o++]=a[s]}else{f=s-65536;s=2*(55296+(f>>10&1023));n[o++]=a[s+1]||a[s];if(a[s+1]>0)n[o++]=a[s];s=2*(56320+(f&1023));n[o++]=a[s+1]||a[s];if(a[s+1]>0)n[o++]=a[s]}}n=n.slice(0,o)}else{for(i=o=0;i<t;i++){s=e[i].charCodeAt(0)*2;n[o++]=a[s+1]||a[s];if(a[s+1]>0)n[o++]=a[s]}}if(!r||r==="buf")return n;if(r!=="arr")return n.toString("binary");return[].slice.call(n)}};var E=function H(r){var t=e[r].dec;var a=Buffer.allocUnsafe(131072),n=0,i,s=0,f=0,o=0;for(o=0;o<65536;++o){a[2*o]=255;a[2*o+1]=253}for(n=0;n<t.length;++n){if(!(i=t[n]))continue;s=i.charCodeAt(0);f=2*n;a[f]=s&255;a[f+1]=s>>8}return function l(e){var r=e.length,t=Buffer.allocUnsafe(2*r),n=0,i=0,s=0;if(Buffer.isBuffer(e)){for(n=0;n<r;n++){i=2*e[n];if(a[i]===255&&a[i+1]===253){i=2*((e[n]<<8)+e[n+1]);++n}t[s++]=a[i];t[s++]=a[i+1]}}else if(typeof e==="string"){for(n=0;n<r;n++){i=2*e.charCodeAt(n);if(a[i]===255&&a[i+1]===253){i=2*((e.charCodeAt(n)<<8)+e.charCodeAt(n+1));++n}t[s++]=a[i];t[s++]=a[i+1]}}else{for(n=0;n<r;n++){i=2*e[n];if(a[i]===255&&a[i+1]===253){i=2*((e[n]<<8)+e[n+1]);++n}t[s++]=a[i];t[s++]=a[i+1]}}return t.slice(0,s).toString("ucs2")}};i[65001]=function W(e){if(typeof e==="string")return W(e.split("").map(c));var r=e.length,t=0,a=0;if(4*r>v){v=4*r;g=Buffer.allocUnsafe(v)}var n=0;if(r>=3&&e[0]==239)if(e[1]==187&&e[2]==191)n=3;for(var i=1,s=0,f=0;n<r;n+=i){i=1;f=e[n];if(f<128)t=f;else if(f<224){t=(f&31)*64+(e[n+1]&63);i=2}else if(f<240){t=((f&15)<<12)+(e[n+1]&63)*64+(e[n+2]&63);i=3}else{t=(f&7)*262144+((e[n+1]&63)<<12)+(e[n+2]&63)*64+(e[n+3]&63);i=4}if(t<65536){g[s++]=t&255;g[s++]=t>>8}else{t-=65536;a=55296+(t>>10&1023);t=56320+(t&1023);g[s++]=a&255;g[s++]=a>>>8;g[s++]=t&255;g[s++]=t>>>8&255}}return g.slice(0,s).toString("ucs2")};s[65001]=function V(e,r){if(h&&Buffer.isBuffer(e)){if(!r||r==="buf")return e;if(r!=="arr")return e.toString("binary");return[].slice.call(e)}var t=e.length,a=0,n=0,i=0;var s=typeof e==="string";if(4*t>v){v=4*t;g=Buffer.allocUnsafe(v)}for(var f=0;f<t;++f){a=s?e.charCodeAt(f):e[f].charCodeAt(0);if(a<=127)g[i++]=a;else if(a<=2047){g[i++]=192+(a>>6);g[i++]=128+(a&63)}else if(a>=55296&&a<=57343){a-=55296;++f;n=(s?e.charCodeAt(f):e[f].charCodeAt(0))-56320+(a<<10);g[i++]=240+(n>>>18&7);g[i++]=144+(n>>>12&63);g[i++]=128+(n>>>6&63);g[i++]=128+(n&63)}else{g[i++]=224+(a>>12);g[i++]=128+(a>>6&63);g[i++]=128+(a&63)}}if(!r||r==="buf")return g.slice(0,i);if(r!=="arr")return g.slice(0,i).toString("binary");return[].slice.call(g,0,i)}}var k=function z(){if(h){if(f[t[0]])return;var r=0,l=0;for(r=0;r<t.length;++r){l=t[r];if(e[l]){f[l]=w(l);o[l]=b(l)}}for(r=0;r<a.length;++r){l=a[r];if(e[l]){f[l]=E(l);o[l]=C(l)}}for(r=0;r<n.length;++r){l=n[r];if(i[l])f[l]=i[l];if(s[l])o[l]=s[l]}}};var S=function(e,r){void r;return""};var A=function X(e){delete f[e];delete o[e]};var _=function G(){if(h){if(!f[t[0]])return;t.forEach(A);a.forEach(A);n.forEach(A)}x=S;I=0};var B={encache:k,decache:_,sbcs:t,dbcs:a};k();var T="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";var y="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";var x=S,I=0;var R=function j(t,a,n){if(t===I&&x){return x(a,n)}if(o[t]){x=o[I=t];return x(a,n)}if(h&&Buffer.isBuffer(a))a=a.toString("utf8");var i=a.length;var s=h?Buffer.allocUnsafe(4*i):[],f=0,c=0,d=0,p=0;var v=e[t],g,m="";var b=typeof a==="string";if(v&&(g=v.enc))for(c=0;c<i;++c,++d){f=g[b?a.charAt(c):a[c]];if(f>255){s[d]=f>>8;s[++d]=f&255}else s[d]=f&255}else if(m=r[t])switch(m){case"utf8":if(h&&b){s=u(a,m);d=s.length;break}for(c=0;c<i;++c,++d){f=b?a.charCodeAt(c):a[c].charCodeAt(0);if(f<=127)s[d]=f;else if(f<=2047){s[d]=192+(f>>6);s[++d]=128+(f&63)}else if(f>=55296&&f<=57343){f-=55296;p=(b?a.charCodeAt(++c):a[++c].charCodeAt(0))-56320+(f<<10);s[d]=240+(p>>>18&7);s[++d]=144+(p>>>12&63);s[++d]=128+(p>>>6&63);s[++d]=128+(p&63)}else{s[d]=224+(f>>12);s[++d]=128+(f>>6&63);s[++d]=128+(f&63)}}break;case"ascii":if(h&&typeof a==="string"){s=u(a,m);d=s.length;break}for(c=0;c<i;++c,++d){f=b?a.charCodeAt(c):a[c].charCodeAt(0);if(f<=127)s[d]=f;else throw new Error("bad ascii "+f)}break;case"utf16le":if(h&&typeof a==="string"){s=u(a,m);d=s.length;break}for(c=0;c<i;++c){f=b?a.charCodeAt(c):a[c].charCodeAt(0);s[d++]=f&255;s[d++]=f>>8}break;case"utf16be":for(c=0;c<i;++c){f=b?a.charCodeAt(c):a[c].charCodeAt(0);s[d++]=f>>8;s[d++]=f&255}break;case"utf32le":for(c=0;c<i;++c){f=b?a.charCodeAt(c):a[c].charCodeAt(0);if(f>=55296&&f<=57343)f=65536+(f-55296<<10)+(a[++c].charCodeAt(0)-56320);s[d++]=f&255;f>>=8;s[d++]=f&255;f>>=8;s[d++]=f&255;f>>=8;s[d++]=f&255}break;case"utf32be":for(c=0;c<i;++c){f=b?a.charCodeAt(c):a[c].charCodeAt(0);if(f>=55296&&f<=57343)f=65536+(f-55296<<10)+(a[++c].charCodeAt(0)-56320);s[d+3]=f&255;f>>=8;s[d+2]=f&255;f>>=8;s[d+1]=f&255;f>>=8;s[d]=f&255;d+=4}break;case"utf7":for(c=0;c<i;c++){var w=b?a.charAt(c):a[c].charAt(0);if(w==="+"){s[d++]=43;s[d++]=45;continue}if(y.indexOf(w)>-1){s[d++]=w.charCodeAt(0);continue}var C=j(1201,w);s[d++]=43;s[d++]=T.charCodeAt(C[0]>>2);s[d++]=T.charCodeAt(((C[0]&3)<<4)+((C[1]||0)>>4));s[d++]=T.charCodeAt(((C[1]&15)<<2)+((C[2]||0)>>6));s[d++]=45}break;default:throw new Error("Unsupported magic: "+t+" "+r[t]);}else throw new Error("Unrecognized CP: "+t);s=s.slice(0,d);if(!h)return n=="str"?s.map(l).join(""):s;if(!n||n==="buf")return s;if(n!=="arr")return s.toString("binary");return[].slice.call(s)};var D=function K(t,a){var n;if(n=f[t])return n(a);if(typeof a==="string")return K(t,a.split("").map(c));var i=a.length,s=new Array(i),o="",l=0,u=0,d=1,p=0,v=0;var g=e[t],m,b="";if(g&&(m=g.dec)){for(u=0;u<i;u+=d){d=2;o=m[(a[u]<<8)+a[u+1]];if(!o){d=1;o=m[a[u]]}if(!o)throw new Error("Unrecognized code: "+a[u]+" "+a[u+d-1]+" "+u+" "+d+" "+m[a[u]]);s[p++]=o}}else if(b=r[t])switch(b){case"utf8":if(i>=3&&a[0]==239)if(a[1]==187&&a[2]==191)u=3;for(;u<i;u+=d){d=1;if(a[u]<128)l=a[u];else if(a[u]<224){l=(a[u]&31)*64+(a[u+1]&63);d=2}else if(a[u]<240){l=((a[u]&15)<<12)+(a[u+1]&63)*64+(a[u+2]&63);d=3}else{l=(a[u]&7)*262144+((a[u+1]&63)<<12)+(a[u+2]&63)*64+(a[u+3]&63);d=4}if(l<65536){s[p++]=String.fromCharCode(l)}else{l-=65536;v=55296+(l>>10&1023);l=56320+(l&1023);s[p++]=String.fromCharCode(v);s[p++]=String.fromCharCode(l)}}break;case"ascii":if(h&&Buffer.isBuffer(a))return a.toString(b);for(u=0;u<i;u++)s[u]=String.fromCharCode(a[u]);p=i;break;case"utf16le":if(i>=2&&a[0]==255)if(a[1]==254)u=2;if(h&&Buffer.isBuffer(a))return a.toString(b);d=2;for(;u+1<i;u+=d){s[p++]=String.fromCharCode((a[u+1]<<8)+a[u])}break;case"utf16be":if(i>=2&&a[0]==254)if(a[1]==255)u=2;d=2;for(;u+1<i;u+=d){s[p++]=String.fromCharCode((a[u]<<8)+a[u+1])}break;case"utf32le":if(i>=4&&a[0]==255)if(a[1]==254&&a[2]===0&&a[3]===0)u=4;d=4;for(;u<i;u+=d){l=(a[u+3]<<24)+(a[u+2]<<16)+(a[u+1]<<8)+a[u];if(l>65535){l-=65536;s[p++]=String.fromCharCode(55296+(l>>10&1023));s[p++]=String.fromCharCode(56320+(l&1023))}else s[p++]=String.fromCharCode(l)}break;case"utf32be":if(i>=4&&a[3]==255)if(a[2]==254&&a[1]===0&&a[0]===0)u=4;d=4;for(;u<i;u+=d){l=(a[u]<<24)+(a[u+1]<<16)+(a[u+2]<<8)+a[u+3];if(l>65535){l-=65536;s[p++]=String.fromCharCode(55296+(l>>10&1023));s[p++]=String.fromCharCode(56320+(l&1023))}else s[p++]=String.fromCharCode(l)}break;case"utf7":if(i>=4&&a[0]==43&&a[1]==47&&a[2]==118){if(i>=5&&a[3]==56&&a[4]==45)u=5;else if(a[3]==56||a[3]==57||a[3]==43||a[3]==47)u=4}for(;u<i;u+=d){if(a[u]!==43){d=1;s[p++]=String.fromCharCode(a[u]);continue}d=1;if(a[u+1]===45){d=2;s[p++]="+";continue}while(String.fromCharCode(a[u+d]).match(/[A-Za-z0-9+\/]/))d++;var w=0;if(a[u+d]===45){++d;w=1}var C=[];var E="";var k=0,S=0,A=0;var _=0,B=0,y=0,x=0;for(var I=1;I<d-w;){_=T.indexOf(String.fromCharCode(a[u+I++]));B=T.indexOf(String.fromCharCode(a[u+I++]));k=_<<2|B>>4;C.push(k);y=T.indexOf(String.fromCharCode(a[u+I++]));if(y===-1)break;S=(B&15)<<4|y>>2;C.push(S);x=T.indexOf(String.fromCharCode(a[u+I++]));if(x===-1)break;A=(y&3)<<6|x;if(x<64)C.push(A)}E=K(1201,C);for(I=0;I<E.length;++I)s[p++]=E.charAt(I)}break;default:throw new Error("Unsupported magic: "+t+" "+r[t]);}else throw new Error("Unrecognized CP: "+t);return s.slice(0,p).join("")};var O=function Y(t){return!!(e[t]||r[t])};e.utils={decode:D,encode:R,hascp:O,magic:r,cache:B};return e});var XLSX={};function make_xlsx_lib(e){e.version="0.14.0";var r=1200,t=1252;if(typeof module!=="undefined"&&typeof require!=="undefined"){if(typeof cptable==="undefined"){if(typeof global!=="undefined")global.cptable=undefined;else if(typeof window!=="undefined")window.cptable=undefined}}var a=[874,932,936,949,950];for(var n=0;n<=8;++n)a.push(1250+n);var i={0:1252,1:65001,2:65001,77:1e4,128:932,129:949,130:1361,134:936,136:950,161:1253,162:1254,163:1258,177:1255,178:1256,186:1257,204:1251,222:874,238:1250,255:1252,69:6969};var s=function(e){if(a.indexOf(e)==-1)return;t=i[0]=e};function f(){s(1252)}var o=function(e){r=e;s(e)};function l(){o(1200);f()}function c(e){var r=[];for(var t=0,a=e.length;t<a;++t)r[t]=e.charCodeAt(t);return r}function h(e){var r=[];for(var t=0;t<e.length>>1;++t)r[t]=String.fromCharCode(e.charCodeAt(2*t)+(e.charCodeAt(2*t+1)<<8));return r.join("")}function u(e){var r=[];for(var t=0;t<e.length>>1;++t)r[t]=String.fromCharCode(e.charCodeAt(2*t+1)+(e.charCodeAt(2*t)<<8));return r.join("")}var d=function(e){var r=e.charCodeAt(0),t=e.charCodeAt(1);if(r==255&&t==254)return h(e.slice(2));if(r==254&&t==255)return u(e.slice(2));if(r==65279)return e.slice(1);return e};var p=function Hg(e){return String.fromCharCode(e)};if(typeof cptable!=="undefined"){o=function(e){r=e};d=function(e){if(e.charCodeAt(0)===255&&e.charCodeAt(1)===254){return cptable.utils.decode(1200,c(e.slice(2)))}return e};p=function Wg(e){if(r===1200)return String.fromCharCode(e);return cptable.utils.decode(r,[e&255,e>>8])[0]}}var v=null;var g=true;var m=function Vg(){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";return{encode:function(r){var t="";var a=0,n=0,i=0,s=0,f=0,o=0,l=0;for(var c=0;c<r.length;){a=r.charCodeAt(c++);s=a>>2;n=r.charCodeAt(c++);f=(a&3)<<4|n>>4;i=r.charCodeAt(c++);o=(n&15)<<2|i>>6;l=i&63;if(isNaN(n)){o=l=64}else if(isNaN(i)){l=64}t+=e.charAt(s)+e.charAt(f)+e.charAt(o)+e.charAt(l)}return t},decode:function r(t){var a="";var n=0,i=0,s=0,f=0,o=0,l=0,c=0;t=t.replace(/[^\w\+\/\=]/g,"");for(var h=0;h<t.length;){f=e.indexOf(t.charAt(h++));o=e.indexOf(t.charAt(h++));n=f<<2|o>>4;a+=String.fromCharCode(n);l=e.indexOf(t.charAt(h++));i=(o&15)<<4|l>>2;if(l!==64){a+=String.fromCharCode(i)}c=e.indexOf(t.charAt(h++));s=(l&3)<<6|c;if(c!==64){a+=String.fromCharCode(s)}}return a}}}();var b=typeof Buffer!=="undefined"&&typeof process!=="undefined"&&typeof process.versions!=="undefined"&&!!process.versions.node;var w=function(){};if(typeof Buffer!=="undefined"){var C=!Buffer.from;if(!C)try{Buffer.from("foo","utf8")}catch(E){C=true}w=C?function(e,r){return r?new Buffer(e,r):new Buffer(e)}:Buffer.from.bind(Buffer);if(!Buffer.alloc)Buffer.alloc=function(e){return new Buffer(e)};if(!Buffer.allocUnsafe)Buffer.allocUnsafe=function(e){return new Buffer(e)}}function k(e){return b?Buffer.alloc(e):new Array(e)}function S(e){return b?Buffer.allocUnsafe(e):new Array(e)}var A=function zg(e){if(b)return w(e,"binary");return e.split("").map(function(e){return e.charCodeAt(0)&255})};function _(e){if(typeof ArrayBuffer==="undefined")return A(e);var r=new ArrayBuffer(e.length),t=new Uint8Array(r);for(var a=0;a!=e.length;++a)t[a]=e.charCodeAt(a)&255;return r}function B(e){if(Array.isArray(e))return e.map(xp).join("");var r=[];for(var t=0;t<e.length;++t)r[t]=xp(e[t]);return r.join("")}function T(e){if(typeof Uint8Array==="undefined")throw new Error("Unsupported");return new Uint8Array(e)}function y(e){if(typeof ArrayBuffer=="undefined")throw new Error("Unsupported");if(e instanceof ArrayBuffer)return y(new Uint8Array(e));var r=new Array(e.length);for(var t=0;t<e.length;++t)r[t]=e[t];return r}var x=function(e){return[].concat.apply([],e)};var I=/\u0000/g,R=/[\u0001-\u0006]/g;var D={};var O=function Xg(e){e.version="0.10.2";function r(e){var r="",t=e.length-1;while(t>=0)r+=e.charAt(t--);return r}function t(e,r){var t="";while(t.length<r)t+=e;return t}function a(e,r){var a=""+e;return a.length>=r?a:t("0",r-a.length)+a}function n(e,r){var a=""+e;return a.length>=r?a:t(" ",r-a.length)+a}function i(e,r){var a=""+e;return a.length>=r?a:a+t(" ",r-a.length)}function s(e,r){var a=""+Math.round(e);return a.length>=r?a:t("0",r-a.length)+a}function f(e,r){var a=""+e;return a.length>=r?a:t("0",r-a.length)+a}var o=Math.pow(2,32);function l(e,r){if(e>o||e<-o)return s(e,r);var t=Math.round(e);return f(t,r)}function c(e,r){r=r||0;return e.length>=7+r&&(e.charCodeAt(r)|32)===103&&(e.charCodeAt(r+1)|32)===101&&(e.charCodeAt(r+2)|32)===110&&(e.charCodeAt(r+3)|32)===101&&(e.charCodeAt(r+4)|32)===114&&(e.charCodeAt(r+5)|32)===97&&(e.charCodeAt(r+6)|32)===108}var h=[["Sun","Sunday"],["Mon","Monday"],["Tue","Tuesday"],["Wed","Wednesday"],["Thu","Thursday"],["Fri","Friday"],["Sat","Saturday"]];var u=[["J","Jan","January"],["F","Feb","February"],["M","Mar","March"],["A","Apr","April"],["M","May","May"],["J","Jun","June"],["J","Jul","July"],["A","Aug","August"],["S","Sep","September"],["O","Oct","October"],["N","Nov","November"],["D","Dec","December"]];function d(e){e[0]="General";e[1]="0";e[2]="0.00";e[3]="#,##0";e[4]="#,##0.00";e[9]="0%";e[10]="0.00%";e[11]="0.00E+00";e[12]="# ?/?";e[13]="# ??/??";e[14]="m/d/yy";e[15]="d-mmm-yy";e[16]="d-mmm";e[17]="mmm-yy";e[18]="h:mm AM/PM";e[19]="h:mm:ss AM/PM";e[20]="h:mm";e[21]="h:mm:ss";e[22]="m/d/yy h:mm";e[37]="#,##0 ;(#,##0)";e[38]="#,##0 ;[Red](#,##0)";e[39]="#,##0.00;(#,##0.00)";e[40]="#,##0.00;[Red](#,##0.00)";e[45]="mm:ss";e[46]="[h]:mm:ss";e[47]="mmss.0";e[48]="##0.0E+0";e[49]="@";e[56]='"上午/下午 "hh"時"mm"分"ss"秒 "';e[65535]="General"}var p={};d(p);function v(e,r,t){var a=e<0?-1:1;var n=e*a;var i=0,s=1,f=0;var o=1,l=0,c=0;var h=Math.floor(n);while(l<r){h=Math.floor(n);f=h*s+i;c=h*l+o;if(n-h<5e-8)break;n=1/(n-h);i=s;s=f;o=l;l=c}if(c>r){if(l>r){c=o;f=i}else{c=l;f=s}}if(!t)return[0,a*f,c];var u=Math.floor(a*f/c);return[u,a*f-u*c,c]}function g(e,r,t){if(e>2958465||e<0)return null;var a=e|0,n=Math.floor(86400*(e-a)),i=0;var s=[];var f={D:a,T:n,u:86400*(e-a)-n,y:0,m:0,d:0,H:0,M:0,S:0,q:0};if(Math.abs(f.u)<1e-6)f.u=0;if(r&&r.date1904)a+=1462;if(f.u>.9999){f.u=0;if(++n==86400){f.T=n=0;++a;++f.D}}if(a===60){s=t?[1317,10,29]:[1900,2,29];i=3}else if(a===0){s=t?[1317,8,29]:[1900,1,0];i=6}else{if(a>60)--a;var o=new Date(1900,0,1);o.setDate(o.getDate()+a-1);s=[o.getFullYear(),o.getMonth()+1,o.getDate()];i=o.getDay();if(a<60)i=(i+6)%7;if(t)i=A(o,s)}f.y=s[0];f.m=s[1];f.d=s[2];f.S=n%60;n=Math.floor(n/60);f.M=n%60;n=Math.floor(n/60);f.H=n;f.q=i;return f}e.parse_date_code=g;var m=new Date(1899,11,31,0,0,0);var b=m.getTime();var w=new Date(1900,2,1,0,0,0);function C(e,r){var t=e.getTime();if(r)t-=1461*24*60*60*1e3;else if(e>=w)t+=24*60*60*1e3;return(t-(b+(e.getTimezoneOffset()-m.getTimezoneOffset())*6e4))/(24*60*60*1e3)}function E(e){return e.toString(10)}e._general_int=E;var k=function M(){var e=/\.(\d*[1-9])0+$/,r=/\.0*$/,t=/\.(\d*[1-9])0+/,a=/\.0*[Ee]/,n=/(E[+-])(\d)$/;function i(e){var r=e<0?12:11;var t=o(e.toFixed(12));
if(t.length<=r)return t;t=e.toPrecision(10);if(t.length<=r)return t;return e.toExponential(5)}function s(r){var t=r.toFixed(11).replace(e,".$1");if(t.length>(r<0?12:11))t=r.toPrecision(6);return t}function f(e){for(var r=0;r!=e.length;++r)if((e.charCodeAt(r)|32)===101)return e.replace(t,".$1").replace(a,"E").replace("e","E").replace(n,"$10$2");return e}function o(t){return t.indexOf(".")>-1?t.replace(r,"").replace(e,".$1"):t}return function l(e){var r=Math.floor(Math.log(Math.abs(e))*Math.LOG10E),t;if(r>=-4&&r<=-1)t=e.toPrecision(10+r);else if(Math.abs(r)<=9)t=i(e);else if(r===10)t=e.toFixed(10).substr(0,12);else t=s(e);return o(f(t))}}();e._general_num=k;function S(e,r){switch(typeof e){case"string":return e;case"boolean":return e?"TRUE":"FALSE";case"number":return(e|0)===e?E(e):k(e);case"undefined":return"";case"object":if(e==null)return"";if(e instanceof Date)return N(14,C(e,r&&r.date1904),r);}throw new Error("unsupported value in General format: "+e)}e._general=S;function A(){return 0}function _(e,r,t,n){var i="",s=0,f=0,o=t.y,l,c=0;switch(e){case 98:o=t.y+543;case 121:switch(r.length){case 1:;case 2:l=o%100;c=2;break;default:l=o%1e4;c=4;break;}break;case 109:switch(r.length){case 1:;case 2:l=t.m;c=r.length;break;case 3:return u[t.m-1][1];case 5:return u[t.m-1][0];default:return u[t.m-1][2];}break;case 100:switch(r.length){case 1:;case 2:l=t.d;c=r.length;break;case 3:return h[t.q][0];default:return h[t.q][1];}break;case 104:switch(r.length){case 1:;case 2:l=1+(t.H+11)%12;c=r.length;break;default:throw"bad hour format: "+r;}break;case 72:switch(r.length){case 1:;case 2:l=t.H;c=r.length;break;default:throw"bad hour format: "+r;}break;case 77:switch(r.length){case 1:;case 2:l=t.M;c=r.length;break;default:throw"bad minute format: "+r;}break;case 115:if(r!="s"&&r!="ss"&&r!=".0"&&r!=".00"&&r!=".000")throw"bad second format: "+r;if(t.u===0&&(r=="s"||r=="ss"))return a(t.S,r.length);if(n>=2)f=n===3?1e3:100;else f=n===1?10:1;s=Math.round(f*(t.S+t.u));if(s>=60*f)s=0;if(r==="s")return s===0?"0":""+s/f;i=a(s,2+n);if(r==="ss")return i.substr(0,2);return"."+i.substr(2,r.length-1);case 90:switch(r){case"[h]":;case"[hh]":l=t.D*24+t.H;break;case"[m]":;case"[mm]":l=(t.D*24+t.H)*60+t.M;break;case"[s]":;case"[ss]":l=((t.D*24+t.H)*60+t.M)*60+Math.round(t.S+t.u);break;default:throw"bad abstime format: "+r;}c=r.length===3?1:2;break;case 101:l=o;c=1;}if(c>0)return a(l,c);else return""}function B(e){var r=3;if(e.length<=r)return e;var t=e.length%r,a=e.substr(0,t);for(;t!=e.length;t+=r)a+=(a.length>0?",":"")+e.substr(t,r);return a}var T=function U(){var e=/%/g;function s(r,a,n){var i=a.replace(e,""),s=a.length-i.length;return T(r,i,n*Math.pow(10,2*s))+t("%",s)}function f(e,r,t){var a=r.length-1;while(r.charCodeAt(a-1)===44)--a;return T(e,r.substr(0,a),t/Math.pow(10,3*(r.length-a)))}function o(e,r){var t;var a=e.indexOf("E")-e.indexOf(".")-1;if(e.match(/^#+0.0E\+0$/)){if(r==0)return"0.0E+0";else if(r<0)return"-"+o(e,-r);var n=e.indexOf(".");if(n===-1)n=e.indexOf("E");var i=Math.floor(Math.log(r)*Math.LOG10E)%n;if(i<0)i+=n;t=(r/Math.pow(10,i)).toPrecision(a+1+(n+i)%n);if(t.indexOf("e")===-1){var s=Math.floor(Math.log(r)*Math.LOG10E);if(t.indexOf(".")===-1)t=t.charAt(0)+"."+t.substr(1)+"E+"+(s-t.length+i);else t+="E+"+(s-i);while(t.substr(0,2)==="0."){t=t.charAt(0)+t.substr(2,n)+"."+t.substr(2+n);t=t.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.")}t=t.replace(/\+-/,"-")}t=t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function(e,r,t,a){return r+t+a.substr(0,(n+i)%n)+"."+a.substr(i)+"E"})}else t=r.toExponential(a);if(e.match(/E\+00$/)&&t.match(/e[+-]\d$/))t=t.substr(0,t.length-1)+"0"+t.charAt(t.length-1);if(e.match(/E\-/)&&t.match(/e\+/))t=t.replace(/e\+/,"e");return t.replace("e","E")}var c=/# (\?+)( ?)\/( ?)(\d+)/;function h(e,r,i){var s=parseInt(e[4],10),f=Math.round(r*s),o=Math.floor(f/s);var l=f-o*s,c=s;return i+(o===0?"":""+o)+" "+(l===0?t(" ",e[1].length+1+e[4].length):n(l,e[1].length)+e[2]+"/"+e[3]+a(c,e[4].length))}function u(e,r,a){return a+(r===0?"":""+r)+t(" ",e[1].length+2+e[4].length)}var d=/^#*0*\.([0#]+)/;var p=/\).*[0#]/;var g=/\(###\) ###\\?-####/;function m(e){var r="",t;for(var a=0;a!=e.length;++a)switch(t=e.charCodeAt(a)){case 35:break;case 63:r+=" ";break;case 48:r+="0";break;default:r+=String.fromCharCode(t);}return r}function b(e,r){var t=Math.pow(10,r);return""+Math.round(e*t)/t}function w(e,r){if(r<(""+Math.round((e-Math.floor(e))*Math.pow(10,r))).length){return 0}return Math.round((e-Math.floor(e))*Math.pow(10,r))}function C(e,r){if(r<(""+Math.round((e-Math.floor(e))*Math.pow(10,r))).length){return 1}return 0}function E(e){if(e<2147483647&&e>-2147483648)return""+(e>=0?e|0:e-1|0);return""+Math.floor(e)}function k(e,u,S){if(e.charCodeAt(0)===40&&!u.match(p)){var A=u.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(S>=0)return k("n",A,S);return"("+k("n",A,-S)+")"}if(u.charCodeAt(u.length-1)===44)return f(e,u,S);if(u.indexOf("%")!==-1)return s(e,u,S);if(u.indexOf("E")!==-1)return o(u,S);if(u.charCodeAt(0)===36)return"$"+k(e,u.substr(u.charAt(1)==" "?2:1),S);var _;var y,x,I,R=Math.abs(S),D=S<0?"-":"";if(u.match(/^00+$/))return D+l(R,u.length);if(u.match(/^[#?]+$/)){_=l(S,0);if(_==="0")_="";return _.length>u.length?_:m(u.substr(0,u.length-_.length))+_}if(y=u.match(c))return h(y,R,D);if(u.match(/^#+0+$/))return D+l(R,u.length-u.indexOf("0"));if(y=u.match(d)){_=b(S,y[1].length).replace(/^([^\.]+)$/,"$1."+m(y[1])).replace(/\.$/,"."+m(y[1])).replace(/\.(\d*)$/,function(e,r){return"."+r+t("0",m(y[1]).length-r.length)});return u.indexOf("0.")!==-1?_:_.replace(/^0\./,".")}u=u.replace(/^#+([0.])/,"$1");if(y=u.match(/^(0*)\.(#*)$/)){return D+b(R,y[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,y[1].length?"0.":".")}if(y=u.match(/^#{1,3},##0(\.?)$/))return D+B(l(R,0));if(y=u.match(/^#,##0\.([#0]*0)$/)){return S<0?"-"+k(e,u,-S):B(""+(Math.floor(S)+C(S,y[1].length)))+"."+a(w(S,y[1].length),y[1].length)}if(y=u.match(/^#,#*,#0/))return k(e,u.replace(/^#,#*,/,""),S);if(y=u.match(/^([0#]+)(\\?-([0#]+))+$/)){_=r(k(e,u.replace(/[\\-]/g,""),S));x=0;return r(r(u.replace(/\\/g,"")).replace(/[0#]/g,function(e){return x<_.length?_.charAt(x++):e==="0"?"0":""}))}if(u.match(g)){_=k(e,"##########",S);return"("+_.substr(0,3)+") "+_.substr(3,3)+"-"+_.substr(6)}var O="";if(y=u.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){x=Math.min(y[4].length,7);I=v(R,Math.pow(10,x)-1,false);_=""+D;O=T("n",y[1],I[1]);if(O.charAt(O.length-1)==" ")O=O.substr(0,O.length-1)+"0";_+=O+y[2]+"/"+y[3];O=i(I[2],x);if(O.length<y[4].length)O=m(y[4].substr(y[4].length-O.length))+O;_+=O;return _}if(y=u.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){x=Math.min(Math.max(y[1].length,y[4].length),7);I=v(R,Math.pow(10,x)-1,true);return D+(I[0]||(I[1]?"":"0"))+" "+(I[1]?n(I[1],x)+y[2]+"/"+y[3]+i(I[2],x):t(" ",2*x+1+y[2].length+y[3].length))}if(y=u.match(/^[#0?]+$/)){_=l(S,0);if(u.length<=_.length)return _;return m(u.substr(0,u.length-_.length))+_}if(y=u.match(/^([#0?]+)\.([#0]+)$/)){_=""+S.toFixed(Math.min(y[2].length,10)).replace(/([^0])0+$/,"$1");x=_.indexOf(".");var F=u.indexOf(".")-x,P=u.length-_.length-F;return m(u.substr(0,F)+_+u.substr(u.length-P))}if(y=u.match(/^00,000\.([#0]*0)$/)){x=w(S,y[1].length);return S<0?"-"+k(e,u,-S):B(E(S)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function(e){return"00,"+(e.length<3?a(0,3-e.length):"")+e})+"."+a(x,y[1].length)}switch(u){case"###,##0.00":return k(e,"#,##0.00",S);case"###,###":;case"##,###":;case"#,###":var N=B(l(R,0));return N!=="0"?D+N:"";case"###,###.00":return k(e,"###,##0.00",S).replace(/^0\./,".");case"#,###.00":return k(e,"#,##0.00",S).replace(/^0\./,".");default:;}throw new Error("unsupported format |"+u+"|")}function S(e,r,t){var a=r.length-1;while(r.charCodeAt(a-1)===44)--a;return T(e,r.substr(0,a),t/Math.pow(10,3*(r.length-a)))}function A(r,a,n){var i=a.replace(e,""),s=a.length-i.length;return T(r,i,n*Math.pow(10,2*s))+t("%",s)}function _(e,r){var t;var a=e.indexOf("E")-e.indexOf(".")-1;if(e.match(/^#+0.0E\+0$/)){if(r==0)return"0.0E+0";else if(r<0)return"-"+_(e,-r);var n=e.indexOf(".");if(n===-1)n=e.indexOf("E");var i=Math.floor(Math.log(r)*Math.LOG10E)%n;if(i<0)i+=n;t=(r/Math.pow(10,i)).toPrecision(a+1+(n+i)%n);if(!t.match(/[Ee]/)){var s=Math.floor(Math.log(r)*Math.LOG10E);if(t.indexOf(".")===-1)t=t.charAt(0)+"."+t.substr(1)+"E+"+(s-t.length+i);else t+="E+"+(s-i);t=t.replace(/\+-/,"-")}t=t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function(e,r,t,a){return r+t+a.substr(0,(n+i)%n)+"."+a.substr(i)+"E"})}else t=r.toExponential(a);if(e.match(/E\+00$/)&&t.match(/e[+-]\d$/))t=t.substr(0,t.length-1)+"0"+t.charAt(t.length-1);if(e.match(/E\-/)&&t.match(/e\+/))t=t.replace(/e\+/,"e");return t.replace("e","E")}function y(e,s,f){if(e.charCodeAt(0)===40&&!s.match(p)){var o=s.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(f>=0)return y("n",o,f);return"("+y("n",o,-f)+")"}if(s.charCodeAt(s.length-1)===44)return S(e,s,f);if(s.indexOf("%")!==-1)return A(e,s,f);if(s.indexOf("E")!==-1)return _(s,f);if(s.charCodeAt(0)===36)return"$"+y(e,s.substr(s.charAt(1)==" "?2:1),f);var l;var h,b,w,C=Math.abs(f),E=f<0?"-":"";if(s.match(/^00+$/))return E+a(C,s.length);if(s.match(/^[#?]+$/)){l=""+f;if(f===0)l="";return l.length>s.length?l:m(s.substr(0,s.length-l.length))+l}if(h=s.match(c))return u(h,C,E);if(s.match(/^#+0+$/))return E+a(C,s.length-s.indexOf("0"));if(h=s.match(d)){l=(""+f).replace(/^([^\.]+)$/,"$1."+m(h[1])).replace(/\.$/,"."+m(h[1]));l=l.replace(/\.(\d*)$/,function(e,r){return"."+r+t("0",m(h[1]).length-r.length)});return s.indexOf("0.")!==-1?l:l.replace(/^0\./,".")}s=s.replace(/^#+([0.])/,"$1");if(h=s.match(/^(0*)\.(#*)$/)){return E+(""+C).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,h[1].length?"0.":".")}if(h=s.match(/^#{1,3},##0(\.?)$/))return E+B(""+C);if(h=s.match(/^#,##0\.([#0]*0)$/)){return f<0?"-"+y(e,s,-f):B(""+f)+"."+t("0",h[1].length)}if(h=s.match(/^#,#*,#0/))return y(e,s.replace(/^#,#*,/,""),f);if(h=s.match(/^([0#]+)(\\?-([0#]+))+$/)){l=r(y(e,s.replace(/[\\-]/g,""),f));b=0;return r(r(s.replace(/\\/g,"")).replace(/[0#]/g,function(e){return b<l.length?l.charAt(b++):e==="0"?"0":""}))}if(s.match(g)){l=y(e,"##########",f);return"("+l.substr(0,3)+") "+l.substr(3,3)+"-"+l.substr(6)}var k="";if(h=s.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){b=Math.min(h[4].length,7);w=v(C,Math.pow(10,b)-1,false);l=""+E;k=T("n",h[1],w[1]);if(k.charAt(k.length-1)==" ")k=k.substr(0,k.length-1)+"0";l+=k+h[2]+"/"+h[3];k=i(w[2],b);if(k.length<h[4].length)k=m(h[4].substr(h[4].length-k.length))+k;l+=k;return l}if(h=s.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){b=Math.min(Math.max(h[1].length,h[4].length),7);w=v(C,Math.pow(10,b)-1,true);return E+(w[0]||(w[1]?"":"0"))+" "+(w[1]?n(w[1],b)+h[2]+"/"+h[3]+i(w[2],b):t(" ",2*b+1+h[2].length+h[3].length))}if(h=s.match(/^[#0?]+$/)){l=""+f;if(s.length<=l.length)return l;return m(s.substr(0,s.length-l.length))+l}if(h=s.match(/^([#0]+)\.([#0]+)$/)){l=""+f.toFixed(Math.min(h[2].length,10)).replace(/([^0])0+$/,"$1");b=l.indexOf(".");var x=s.indexOf(".")-b,I=s.length-l.length-x;return m(s.substr(0,x)+l+s.substr(s.length-I))}if(h=s.match(/^00,000\.([#0]*0)$/)){return f<0?"-"+y(e,s,-f):B(""+f).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function(e){return"00,"+(e.length<3?a(0,3-e.length):"")+e})+"."+a(0,h[1].length)}switch(s){case"###,###":;case"##,###":;case"#,###":var R=B(""+C);return R!=="0"?E+R:"";default:if(s.match(/\.[0#?]*$/))return y(e,s.slice(0,s.lastIndexOf(".")),f)+m(s.slice(s.lastIndexOf(".")));}throw new Error("unsupported format |"+s+"|")}return function x(e,r,t){return(t|0)===t?y(e,r,t):k(e,r,t)}}();function y(e){var r=[];var t=false;for(var a=0,n=0;a<e.length;++a)switch(e.charCodeAt(a)){case 34:t=!t;break;case 95:;case 42:;case 92:++a;break;case 59:r[r.length]=e.substr(n,a-n);n=a+1;}r[r.length]=e.substr(n);if(t===true)throw new Error("Format |"+e+"| unterminated string ");return r}e._split=y;var x=/\[[HhMmSs]*\]/;function I(e){var r=0,t="",a="";while(r<e.length){switch(t=e.charAt(r)){case"G":if(c(e,r))r+=6;r++;break;case'"':for(;e.charCodeAt(++r)!==34&&r<e.length;)++r;++r;break;case"\\":r+=2;break;case"_":r+=2;break;case"@":++r;break;case"B":;case"b":if(e.charAt(r+1)==="1"||e.charAt(r+1)==="2")return true;case"M":;case"D":;case"Y":;case"H":;case"S":;case"E":;case"m":;case"d":;case"y":;case"h":;case"s":;case"e":;case"g":return true;case"A":;case"a":if(e.substr(r,3).toUpperCase()==="A/P")return true;if(e.substr(r,5).toUpperCase()==="AM/PM")return true;++r;break;case"[":a=t;while(e.charAt(r++)!=="]"&&r<e.length)a+=e.charAt(r);if(a.match(x))return true;break;case".":;case"0":;case"#":while(r<e.length&&("0#?.,E+-%".indexOf(t=e.charAt(++r))>-1||t=="\\"&&e.charAt(r+1)=="-"&&"0#".indexOf(e.charAt(r+2))>-1)){}break;case"?":while(e.charAt(++r)===t){}break;case"*":++r;if(e.charAt(r)==" "||e.charAt(r)=="*")++r;break;case"(":;case")":++r;break;case"1":;case"2":;case"3":;case"4":;case"5":;case"6":;case"7":;case"8":;case"9":while(r<e.length&&"0123456789".indexOf(e.charAt(++r))>-1){}break;case" ":++r;break;default:++r;break;}}return false}e.is_date=I;function R(e,r,t,a){var n=[],i="",s=0,f="",o="t",l,h,u;var d="H";while(s<e.length){switch(f=e.charAt(s)){case"G":if(!c(e,s))throw new Error("unrecognized character "+f+" in "+e);n[n.length]={t:"G",v:"General"};s+=7;break;case'"':for(i="";(u=e.charCodeAt(++s))!==34&&s<e.length;)i+=String.fromCharCode(u);n[n.length]={t:"t",v:i};++s;break;case"\\":var p=e.charAt(++s),v=p==="("||p===")"?p:"t";n[n.length]={t:v,v:p};++s;break;case"_":n[n.length]={t:"t",v:" "};s+=2;break;case"@":n[n.length]={t:"T",v:r};++s;break;case"B":;case"b":if(e.charAt(s+1)==="1"||e.charAt(s+1)==="2"){if(l==null){l=g(r,t,e.charAt(s+1)==="2");if(l==null)return""}n[n.length]={t:"X",v:e.substr(s,2)};o=f;s+=2;break};case"M":;case"D":;case"Y":;case"H":;case"S":;case"E":f=f.toLowerCase();case"m":;case"d":;case"y":;case"h":;case"s":;case"e":;case"g":if(r<0)return"";if(l==null){l=g(r,t);if(l==null)return""}i=f;while(++s<e.length&&e.charAt(s).toLowerCase()===f)i+=f;if(f==="m"&&o.toLowerCase()==="h")f="M";if(f==="h")f=d;n[n.length]={t:f,v:i};o=f;break;case"A":;case"a":var m={t:f,v:f};if(l==null)l=g(r,t);if(e.substr(s,3).toUpperCase()==="A/P"){if(l!=null)m.v=l.H>=12?"P":"A";m.t="T";d="h";s+=3}else if(e.substr(s,5).toUpperCase()==="AM/PM"){if(l!=null)m.v=l.H>=12?"PM":"AM";m.t="T";s+=5;d="h"}else{m.t="t";++s}if(l==null&&m.t==="T")return"";n[n.length]=m;o=f;break;case"[":i=f;while(e.charAt(s++)!=="]"&&s<e.length)i+=e.charAt(s);if(i.slice(-1)!=="]")throw'unterminated "[" block: |'+i+"|";if(i.match(x)){if(l==null){l=g(r,t);if(l==null)return""}n[n.length]={t:"Z",v:i.toLowerCase()};o=i.charAt(1)}else if(i.indexOf("$")>-1){i=(i.match(/\$([^-\[\]]*)/)||[])[1]||"$";if(!I(e))n[n.length]={t:"t",v:i}}break;case".":if(l!=null){i=f;while(++s<e.length&&(f=e.charAt(s))==="0")i+=f;n[n.length]={t:"s",v:i};break};case"0":;case"#":i=f;while(++s<e.length&&"0#?.,E+-%".indexOf(f=e.charAt(s))>-1||f=="\\"&&e.charAt(s+1)=="-"&&s<e.length-2&&"0#".indexOf(e.charAt(s+2))>-1)i+=f;n[n.length]={t:"n",v:i};break;case"?":i=f;while(e.charAt(++s)===f)i+=f;n[n.length]={t:f,v:i};o=f;break;case"*":++s;if(e.charAt(s)==" "||e.charAt(s)=="*")++s;break;case"(":;case")":n[n.length]={t:a===1?"t":f,v:f};++s;break;case"1":;case"2":;case"3":;case"4":;case"5":;case"6":;case"7":;case"8":;case"9":i=f;while(s<e.length&&"0123456789".indexOf(e.charAt(++s))>-1)i+=e.charAt(s);n[n.length]={t:"D",v:i};break;case" ":n[n.length]={t:f,v:f};++s;break;default:if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(f)===-1)throw new Error("unrecognized character "+f+" in "+e);n[n.length]={t:"t",v:f};++s;break;}}var b=0,w=0,C;for(s=n.length-1,o="t";s>=0;--s){switch(n[s].t){case"h":;case"H":n[s].t=d;o="h";if(b<1)b=1;break;case"s":if(C=n[s].v.match(/\.0+$/))w=Math.max(w,C[0].length-1);if(b<3)b=3;case"d":;case"y":;case"M":;case"e":o=n[s].t;break;case"m":if(o==="s"){n[s].t="M";if(b<2)b=2}break;case"X":break;case"Z":if(b<1&&n[s].v.match(/[Hh]/))b=1;if(b<2&&n[s].v.match(/[Mm]/))b=2;if(b<3&&n[s].v.match(/[Ss]/))b=3;}}switch(b){case 0:break;case 1:if(l.u>=.5){l.u=0;++l.S}if(l.S>=60){l.S=0;++l.M}if(l.M>=60){l.M=0;++l.H}break;case 2:if(l.u>=.5){l.u=0;++l.S}if(l.S>=60){l.S=0;++l.M}break;}var E="",k;for(s=0;s<n.length;++s){switch(n[s].t){case"t":;case"T":;case" ":;case"D":break;case"X":n[s].v="";n[s].t=";";break;case"d":;case"m":;case"y":;case"h":;case"H":;case"M":;case"s":;case"e":;case"b":;case"Z":n[s].v=_(n[s].t.charCodeAt(0),n[s].v,l,w);n[s].t="t";break;case"n":;case"(":;case"?":k=s+1;while(n[k]!=null&&((f=n[k].t)==="?"||f==="D"||(f===" "||f==="t")&&n[k+1]!=null&&(n[k+1].t==="?"||n[k+1].t==="t"&&n[k+1].v==="/")||n[s].t==="("&&(f===" "||f==="n"||f===")")||f==="t"&&(n[k].v==="/"||n[k].v===" "&&n[k+1]!=null&&n[k+1].t=="?"))){n[s].v+=n[k].v;n[k]={v:"",t:";"};++k}E+=n[s].v;s=k-1;break;case"G":n[s].t="t";n[s].v=S(r,t);break;}}var A="",B,y;if(E.length>0){if(E.charCodeAt(0)==40){B=r<0&&E.charCodeAt(0)===45?-r:r;y=T("(",E,B)}else{B=r<0&&a>1?-r:r;y=T("n",E,B);if(B<0&&n[0]&&n[0].t=="t"){y=y.substr(1);n[0].v="-"+n[0].v}}k=y.length-1;var R=n.length;for(s=0;s<n.length;++s)if(n[s]!=null&&n[s].t!="t"&&n[s].v.indexOf(".")>-1){R=s;break}var D=n.length;if(R===n.length&&y.indexOf("E")===-1){for(s=n.length-1;s>=0;--s){if(n[s]==null||"n?(".indexOf(n[s].t)===-1)continue;if(k>=n[s].v.length-1){k-=n[s].v.length;n[s].v=y.substr(k+1,n[s].v.length)}else if(k<0)n[s].v="";else{n[s].v=y.substr(0,k+1);k=-1}n[s].t="t";D=s}if(k>=0&&D<n.length)n[D].v=y.substr(0,k+1)+n[D].v}else if(R!==n.length&&y.indexOf("E")===-1){k=y.indexOf(".")-1;for(s=R;s>=0;--s){if(n[s]==null||"n?(".indexOf(n[s].t)===-1)continue;h=n[s].v.indexOf(".")>-1&&s===R?n[s].v.indexOf(".")-1:n[s].v.length-1;A=n[s].v.substr(h+1);for(;h>=0;--h){if(k>=0&&(n[s].v.charAt(h)==="0"||n[s].v.charAt(h)==="#"))A=y.charAt(k--)+A}n[s].v=A;n[s].t="t";D=s}if(k>=0&&D<n.length)n[D].v=y.substr(0,k+1)+n[D].v;k=y.indexOf(".")+1;for(s=R;s<n.length;++s){if(n[s]==null||"n?(".indexOf(n[s].t)===-1&&s!==R)continue;h=n[s].v.indexOf(".")>-1&&s===R?n[s].v.indexOf(".")+1:0;A=n[s].v.substr(0,h);for(;h<n[s].v.length;++h){if(k<y.length)A+=y.charAt(k++)}n[s].v=A;n[s].t="t";D=s}}}for(s=0;s<n.length;++s)if(n[s]!=null&&"n(?".indexOf(n[s].t)>-1){B=a>1&&r<0&&s>0&&n[s-1].v==="-"?-r:r;n[s].v=T(n[s].t,n[s].v,B);n[s].t="t"}var O="";for(s=0;s!==n.length;++s)if(n[s]!=null)O+=n[s].v;return O}e._eval=R;var D=/\[[=<>]/;var O=/\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;function F(e,r){if(r==null)return false;var t=parseFloat(r[2]);switch(r[1]){case"=":if(e==t)return true;break;case">":if(e>t)return true;break;case"<":if(e<t)return true;break;case"<>":if(e!=t)return true;break;case">=":if(e>=t)return true;break;case"<=":if(e<=t)return true;break;}return false}function P(e,r){var t=y(e);var a=t.length,n=t[a-1].indexOf("@");if(a<4&&n>-1)--a;if(t.length>4)throw new Error("cannot find right format for |"+t.join("|")+"|");if(typeof r!=="number")return[4,t.length===4||n>-1?t[t.length-1]:"@"];switch(t.length){case 1:t=n>-1?["General","General","General",t[0]]:[t[0],t[0],t[0],"@"];break;case 2:t=n>-1?[t[0],t[0],t[0],t[1]]:[t[0],t[1],t[0],"@"];break;case 3:t=n>-1?[t[0],t[1],t[0],t[2]]:[t[0],t[1],t[2],"@"];break;case 4:break;}var i=r>0?t[0]:r<0?t[1]:t[2];if(t[0].indexOf("[")===-1&&t[1].indexOf("[")===-1)return[a,i];if(t[0].match(D)!=null||t[1].match(D)!=null){var s=t[0].match(O);var f=t[1].match(O);return F(r,s)?[a,t[0]]:F(r,f)?[a,t[1]]:[a,t[s!=null&&f!=null?2:1]]}return[a,i]}function N(e,r,t){if(t==null)t={};var a="";switch(typeof e){case"string":if(e=="m/d/yy"&&t.dateNF)a=t.dateNF;else a=e;break;case"number":if(e==14&&t.dateNF)a=t.dateNF;else a=(t.table!=null?t.table:p)[e];break;}if(c(a,0))return S(r,t);if(r instanceof Date)r=C(r,t.date1904);var n=P(a,r);if(c(n[1]))return S(r,t);if(r===true)r="TRUE";else if(r===false)r="FALSE";else if(r===""||r==null)return"";return R(n[1],r,t,n[0])}function L(e,r){if(typeof r!="number"){r=+r||-1;for(var t=0;t<392;++t){if(p[t]==undefined){if(r<0)r=t;continue}if(p[t]==e){r=t;break}}if(r<0)r=391}p[r]=e;return r}e.load=L;e._table=p;e.get_table=function H(){return p};e.load_table=function W(e){for(var r=0;r!=392;++r)if(e[r]!==undefined)L(e[r],r)};e.init_table=d;e.format=N};O(D);var F={"General Number":"General","General Date":D._table[22],"Long Date":"dddd, mmmm dd, yyyy","Medium Date":D._table[15],"Short Date":D._table[14],"Long Time":D._table[19],"Medium Time":D._table[18],"Short Time":D._table[20],Currency:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',Fixed:D._table[2],Standard:D._table[4],Percent:D._table[10],Scientific:D._table[11],"Yes/No":'"Yes";"Yes";"No";@',"True/False":'"True";"True";"False";@',"On/Off":'"Yes";"Yes";"No";@'};var P={5:'"$"#,##0_);\\("$"#,##0\\)',6:'"$"#,##0_);[Red]\\("$"#,##0\\)',7:'"$"#,##0.00_);\\("$"#,##0.00\\)',8:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',23:"General",24:"General",25:"General",26:"General",27:"m/d/yy",28:"m/d/yy",29:"m/d/yy",30:"m/d/yy",31:"m/d/yy",32:"h:mm:ss",33:"h:mm:ss",34:"h:mm:ss",35:"h:mm:ss",36:"m/d/yy",41:'_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',42:'_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',43:'_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',44:'_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',50:"m/d/yy",51:"m/d/yy",52:"m/d/yy",53:"m/d/yy",54:"m/d/yy",55:"m/d/yy",56:"m/d/yy",57:"m/d/yy",58:"m/d/yy",59:"0",60:"0.00",61:"#,##0",62:"#,##0.00",63:'"$"#,##0_);\\("$"#,##0\\)',64:'"$"#,##0_);[Red]\\("$"#,##0\\)',65:'"$"#,##0.00_);\\("$"#,##0.00\\)',66:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',67:"0%",68:"0.00%",69:"# ?/?",70:"# ??/??",71:"m/d/yy",72:"m/d/yy",73:"d-mmm-yy",74:"d-mmm",75:"mmm-yy",76:"h:mm",77:"h:mm:ss",78:"m/d/yy h:mm",79:"mm:ss",80:"[h]:mm:ss",81:"mmss.0"};var N=/[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;function L(e){var r=typeof e=="number"?D._table[e]:e;r=r.replace(N,"(\\d+)");return new RegExp("^"+r+"$")}function M(e,r,t){var a=-1,n=-1,i=-1,s=-1,f=-1,o=-1;(r.match(N)||[]).forEach(function(e,r){var l=parseInt(t[r+1],10);switch(e.toLowerCase().charAt(0)){case"y":a=l;break;case"d":i=l;break;case"h":s=l;break;case"s":o=l;break;case"m":if(s>=0)f=l;else n=l;break;}});if(o>=0&&f==-1&&n>=0){f=n;n=-1}var l=(""+(a>=0?a:(new Date).getFullYear())).slice(-4)+"-"+("00"+(n>=1?n:1)).slice(-2)+"-"+("00"+(i>=1?i:1)).slice(-2);if(l.length==7)l="0"+l;if(l.length==8)l="20"+l;var c=("00"+(s>=0?s:0)).slice(-2)+":"+("00"+(f>=0?f:0)).slice(-2)+":"+("00"+(o>=0?o:0)).slice(-2);if(s==-1&&f==-1&&o==-1)return l;if(a==-1&&n==-1&&i==-1)return c;return l+"T"+c}var U=true;var H;(function(e){e(H={})})(function(e){e.version="1.2.0";function r(){var e=0,r=new Array(256);for(var t=0;t!=256;++t){e=t;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;r[t]=e}return typeof Int32Array!=="undefined"?new Int32Array(r):r}var t=r();function a(e,r){var a=r^-1,n=e.length-1;for(var i=0;i<n;){a=a>>>8^t[(a^e.charCodeAt(i++))&255];a=a>>>8^t[(a^e.charCodeAt(i++))&255]}if(i===n)a=a>>>8^t[(a^e.charCodeAt(i))&255];return a^-1}function n(e,r){if(e.length>1e4)return i(e,r);var a=r^-1,n=e.length-3;for(var s=0;s<n;){a=a>>>8^t[(a^e[s++])&255];a=a>>>8^t[(a^e[s++])&255];a=a>>>8^t[(a^e[s++])&255];a=a>>>8^t[(a^e[s++])&255]}while(s<n+3)a=a>>>8^t[(a^e[s++])&255];return a^-1}function i(e,r){var a=r^-1,n=e.length-7;for(var i=0;i<n;){a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255]}while(i<n+7)a=a>>>8^t[(a^e[i++])&255];return a^-1}function s(e,r){var a=r^-1;for(var n=0,i=e.length,s,f;n<i;){s=e.charCodeAt(n++);if(s<128){a=a>>>8^t[(a^s)&255]}else if(s<2048){a=a>>>8^t[(a^(192|s>>6&31))&255];a=a>>>8^t[(a^(128|s&63))&255]}else if(s>=55296&&s<57344){s=(s&1023)+64;f=e.charCodeAt(n++)&1023;a=a>>>8^t[(a^(240|s>>8&7))&255];a=a>>>8^t[(a^(128|s>>2&63))&255];a=a>>>8^t[(a^(128|f>>6&15|(s&3)<<4))&255];a=a>>>8^t[(a^(128|f&63))&255]}else{a=a>>>8^t[(a^(224|s>>12&15))&255];a=a>>>8^t[(a^(128|s>>6&63))&255];a=a>>>8^t[(a^(128|s&63))&255]}}return a^-1}e.table=t;e.bstr=a;e.buf=n;e.str=s});var W=function Gg(){var e={};e.version="1.1.0";function r(e,r){var t=e.split("/"),a=r.split("/");for(var n=0,i=0,s=Math.min(t.length,a.length);n<s;++n){if(i=t[n].length-a[n].length)return i;if(t[n]!=a[n])return t[n]<a[n]?-1:1}return t.length-a.length}function t(e){if(e.charAt(e.length-1)=="/")return e.slice(0,-1).indexOf("/")===-1?e:t(e.slice(0,-1));var r=e.lastIndexOf("/");return r===-1?e:e.slice(0,r+1)}function a(e){if(e.charAt(e.length-1)=="/")return a(e.slice(0,-1));var r=e.lastIndexOf("/");return r===-1?e:e.slice(r+1)}function n(e,r){if(typeof r==="string")r=new Date(r);var t=r.getHours();t=t<<6|r.getMinutes();t=t<<5|r.getSeconds()>>>1;e._W(2,t);var a=r.getFullYear()-1980;a=a<<4|r.getMonth()+1;a=a<<5|r.getDate();e._W(2,a)}function i(e){var r=e._R(2)&65535;var t=e._R(2)&65535;var a=new Date;var n=t&31;t>>>=5;var i=t&15;t>>>=4;a.setMilliseconds(0);a.setFullYear(t+1980);a.setMonth(i-1);a.setDate(n);var s=r&31;r>>>=5;var f=r&63;r>>>=6;a.setHours(r);a.setMinutes(f);a.setSeconds(s<<1);return a}function s(e){zr(e,0);var r={};var t=0;while(e.l<=e.length-4){var a=e._R(2);var n=e._R(2),i=e.l+n;var s={};switch(a){case 21589:{t=e._R(1);if(t&1)s.mtime=e._R(4);if(n>5){if(t&2)s.atime=e._R(4);if(t&4)s.ctime=e._R(4)}if(s.mtime)s.mt=new Date(s.mtime*1e3)}break;}e.l=i;r[a]=s}return r}var f;function o(){return f||(f=require("fs"))}function l(e,r){if(e[0]==80&&e[1]==75)return Be(e,r);if(e.length<512)throw new Error("CFB file size "+e.length+" < 512");var t=3;var a=512;var n=0;var i=0;var s=0;var f=0;var o=0;var l=[];var p=e.slice(0,512);zr(p,0);var g=c(p);t=g[0];switch(t){case 3:a=512;break;case 4:a=4096;break;case 0:if(g[1]==0)return Be(e,r);default:throw new Error("Major Version: Expected 3 or 4 saw "+t);}if(a!==512){p=e.slice(0,a);zr(p,28)}var m=e.slice(0,a);h(p,t);var b=p._R(4,"i");if(t===3&&b!==0)throw new Error("# Directory Sectors: Expected 0 saw "+b);p.l+=4;s=p._R(4,"i");p.l+=4;p.chk("00100000","Mini Stream Cutoff Size: ");f=p._R(4,"i");n=p._R(4,"i");o=p._R(4,"i");i=p._R(4,"i");for(var E=-1,k=0;k<109;++k){E=p._R(4,"i");if(E<0)break;l[k]=E}var S=u(e,a);v(o,i,S,a,l);var A=w(S,s,l,a);A[s].name="!Directory";if(n>0&&f!==N)A[f].name="!MiniFAT";A[l[0]].name="!FAT";A.fat_addrs=l;A.ssz=a;var _={},B=[],T=[],y=[];C(s,A,S,B,n,_,T,f);d(T,y,B);B.shift();var x={FileIndex:T,FullPaths:y};if(r&&r.raw)x.raw={header:m,sectors:S};return x}function c(e){if(e[e.l]==80&&e[e.l+1]==75)return[0,0];e.chk(L,"Header Signature: ");e.chk(U,"CLSID: ");var r=e._R(2,"u");return[e._R(2,"u"),r]}function h(e,r){var t=9;e.l+=2;switch(t=e._R(2)){case 9:if(r!=3)throw new Error("Sector Shift: Expected 9 saw "+t);break;case 12:if(r!=4)throw new Error("Sector Shift: Expected 12 saw "+t);break;default:throw new Error("Sector Shift: Expected 9 or 12 saw "+t);}e.chk("0600","Mini Sector Shift: ");e.chk("000000000000","Reserved: ")}function u(e,r){var t=Math.ceil(e.length/r)-1;var a=[];for(var n=1;n<t;++n)a[n-1]=e.slice(n*r,(n+1)*r);a[t-1]=e.slice(t*r);return a}function d(e,r,t){var a=0,n=0,i=0,s=0,f=0,o=t.length;var l=[],c=[];for(;a<o;++a){l[a]=c[a]=a;r[a]=t[a]}for(;f<c.length;++f){a=c[f];n=e[a].L;i=e[a].R;s=e[a].C;if(l[a]===a){if(n!==-1&&l[n]!==n)l[a]=l[n];if(i!==-1&&l[i]!==i)l[a]=l[i]}if(s!==-1)l[s]=a;if(n!==-1){l[n]=l[a];if(c.lastIndexOf(n)<f)c.push(n)}if(i!==-1){l[i]=l[a];if(c.lastIndexOf(i)<f)c.push(i)}}for(a=1;a<o;++a)if(l[a]===a){if(i!==-1&&l[i]!==i)l[a]=l[i];else if(n!==-1&&l[n]!==n)l[a]=l[n]}for(a=1;a<o;++a){if(e[a].type===0)continue;f=l[a];if(f===0)r[a]=r[0]+"/"+r[a];else while(f!==0&&f!==l[f]){r[a]=r[f]+"/"+r[a];f=l[f]}l[a]=0}r[0]+="/";for(a=1;a<o;++a){if(e[a].type!==2)r[a]+="/"}}function p(e,r,t){var a=e.start,n=e.size;var i=[];var s=a;while(t&&n>0&&s>=0){i.push(r.slice(s*P,s*P+P));n-=P;s=Pr(t,s*4)}if(i.length===0)return Gr(0);return x(i).slice(0,e.size)}function v(e,r,t,a,n){var i=N;if(e===N){if(r!==0)throw new Error("DIFAT chain shorter than expected")}else if(e!==-1){var s=t[e],f=(a>>>2)-1;if(!s)return;for(var o=0;o<f;++o){if((i=Pr(s,o*4))===N)break;n.push(i)}v(Pr(s,a-4),r-1,t,a,n)}}function g(e,r,t,a,n){var i=[],s=[];if(!n)n=[];var f=a-1,o=0,l=0;for(o=r;o>=0;){n[o]=true;i[i.length]=o;s.push(e[o]);var c=t[Math.floor(o*4/a)];l=o*4&f;if(a<4+l)throw new Error("FAT boundary crossed: "+o+" 4 "+a);if(!e[c])break;o=Pr(e[c],l)}return{nodes:i,data:cr([s])}}function w(e,r,t,a){var n=e.length,i=[];var s=[],f=[],o=[];var l=a-1,c=0,h=0,u=0,d=0;for(c=0;c<n;++c){f=[];u=c+r;if(u>=n)u-=n;if(s[u])continue;o=[];for(h=u;h>=0;){s[h]=true;f[f.length]=h;o.push(e[h]);var p=t[Math.floor(h*4/a)];d=h*4&l;if(a<4+d)throw new Error("FAT boundary crossed: "+h+" 4 "+a);if(!e[p])break;h=Pr(e[p],d)}i[u]={nodes:f,data:cr([o])}}return i}function C(e,r,t,a,n,i,s,f){var o=0,l=a.length?2:0;var c=r[e].data;var h=0,u=0,d;for(;h<c.length;h+=128){var v=c.slice(h,h+128);zr(v,64);u=v._R(2);d=ur(v,0,u-l);a.push(d);var m={name:d,type:v._R(1),color:v._R(1),L:v._R(4,"i"),R:v._R(4,"i"),C:v._R(4,"i"),clsid:v._R(16),state:v._R(4,"i"),start:0,size:0};var b=v._R(2)+v._R(2)+v._R(2)+v._R(2);if(b!==0)m.ct=E(v,v.l-8);var w=v._R(2)+v._R(2)+v._R(2)+v._R(2);if(w!==0)m.mt=E(v,v.l-8);m.start=v._R(4,"i");m.size=v._R(4,"i");if(m.size<0&&m.start<0){m.size=m.type=0;m.start=N;m.name=""}if(m.type===5){o=m.start;if(n>0&&o!==N)r[o].name="!StreamData"}else if(m.size>=4096){m.storage="fat";if(r[m.start]===undefined)r[m.start]=g(t,m.start,r.fat_addrs,r.ssz);r[m.start].name=m.name;m.content=r[m.start].data.slice(0,m.size)}else{m.storage="minifat";if(m.size<0)m.size=0;else if(o!==N&&m.start!==N&&r[o]){m.content=p(m,r[o].data,(r[f]||{}).data)}}if(m.content)zr(m.content,0);i[d]=m;s.push(m)}}function E(e,r){return new Date((Fr(e,r+4)/1e7*Math.pow(2,32)+Fr(e,r)/1e7-11644473600)*1e3)}function _(e,r){o();return l(f.readFileSync(e),r)}function B(e,r){switch(r&&r.type||"base64"){case"file":return _(e,r);case"base64":return l(A(m.decode(e)),r);case"binary":return l(A(e),r);}return l(e,r)}function T(e,r){var t=r||{},a=t.root||"Root Entry";if(!e.FullPaths)e.FullPaths=[];if(!e.FileIndex)e.FileIndex=[];if(e.FullPaths.length!==e.FileIndex.length)throw new Error("inconsistent CFB structure");if(e.FullPaths.length===0){e.FullPaths[0]=a+"/";e.FileIndex[0]={name:a,type:5}}if(t.CLSID)e.FileIndex[0].clsid=t.CLSID;y(e)}function y(e){var r="Sh33tJ5";if(W.find(e,"/"+r))return;var t=Gr(4);t[0]=55;t[1]=t[3]=50;t[2]=54;e.FileIndex.push({name:r,type:2,content:t,size:4,L:69,R:69,C:69});e.FullPaths.push(e.FullPaths[0]+r);D(e)}function D(e,n){T(e);var i=false,s=false;for(var f=e.FullPaths.length-1;f>=0;--f){var o=e.FileIndex[f];switch(o.type){case 0:if(s)i=true;else{e.FileIndex.pop();e.FullPaths.pop()}break;case 1:;case 2:;case 5:s=true;if(isNaN(o.R*o.L*o.C))i=true;if(o.R>-1&&o.L>-1&&o.R==o.L)i=true;break;default:i=true;break;}}if(!i&&!n)return;var l=new Date(1987,1,19),c=0;var h=[];for(f=0;f<e.FullPaths.length;++f){if(e.FileIndex[f].type===0)continue;h.push([e.FullPaths[f],e.FileIndex[f]])}for(f=0;f<h.length;++f){var u=t(h[f][0]);s=false;for(c=0;c<h.length;++c)if(h[c][0]===u)s=true;if(!s)h.push([u,{name:a(u).replace("/",""),type:1,clsid:U,ct:l,mt:l,content:null}])}h.sort(function(e,t){return r(e[0],t[0])});e.FullPaths=[];e.FileIndex=[];for(f=0;f<h.length;++f){e.FullPaths[f]=h[f][0];e.FileIndex[f]=h[f][1]}for(f=0;f<h.length;++f){var d=e.FileIndex[f];var p=e.FullPaths[f];d.name=a(p).replace("/","");d.L=d.R=d.C=-(d.color=1);d.size=d.content?d.content.length:0;d.start=0;d.clsid=d.clsid||U;if(f===0){d.C=h.length>1?1:-1;d.size=0;d.type=5}else if(p.slice(-1)=="/"){for(c=f+1;c<h.length;++c)if(t(e.FullPaths[c])==p)break;d.C=c>=h.length?-1:c;for(c=f+1;c<h.length;++c)if(t(e.FullPaths[c])==t(p))break;
d.R=c>=h.length?-1:c;d.type=1}else{if(t(e.FullPaths[f+1]||"")==t(p))d.R=f+1;d.type=2}}}function O(e,r){var t=r||{};D(e);if(t.fileType=="zip")return ye(e,t);var a=function(e){var r=0,t=0;for(var a=0;a<e.FileIndex.length;++a){var n=e.FileIndex[a];if(!n.content)continue;var i=n.content.length;if(i>0){if(i<4096)r+=i+63>>6;else t+=i+511>>9}}var s=e.FullPaths.length+3>>2;var f=r+7>>3;var o=r+127>>7;var l=f+t+s+o;var c=l+127>>7;var h=c<=109?0:Math.ceil((c-109)/127);while(l+c+h+127>>7>c)h=++c<=109?0:Math.ceil((c-109)/127);var u=[1,h,c,o,s,t,r,0];e.FileIndex[0].size=r<<6;u[7]=(e.FileIndex[0].start=u[0]+u[1]+u[2]+u[3]+u[4]+u[5])+(u[6]+7>>3);return u}(e);var n=Gr(a[7]<<9);var i=0,s=0;{for(i=0;i<8;++i)n._W(1,M[i]);for(i=0;i<8;++i)n._W(2,0);n._W(2,62);n._W(2,3);n._W(2,65534);n._W(2,9);n._W(2,6);for(i=0;i<3;++i)n._W(2,0);n._W(4,0);n._W(4,a[2]);n._W(4,a[0]+a[1]+a[2]+a[3]-1);n._W(4,0);n._W(4,1<<12);n._W(4,a[3]?a[0]+a[1]+a[2]-1:N);n._W(4,a[3]);n._W(-4,a[1]?a[0]-1:N);n._W(4,a[1]);for(i=0;i<109;++i)n._W(-4,i<a[2]?a[1]+i:-1)}if(a[1]){for(s=0;s<a[1];++s){for(;i<236+s*127;++i)n._W(-4,i<a[2]?a[1]+i:-1);n._W(-4,s===a[1]-1?N:s+1)}}var f=function(e){for(s+=e;i<s-1;++i)n._W(-4,i+1);if(e){++i;n._W(-4,N)}};s=i=0;for(s+=a[1];i<s;++i)n._W(-4,V.DIFSECT);for(s+=a[2];i<s;++i)n._W(-4,V.FATSECT);f(a[3]);f(a[4]);var o=0,l=0;var c=e.FileIndex[0];for(;o<e.FileIndex.length;++o){c=e.FileIndex[o];if(!c.content)continue;l=c.content.length;if(l<4096)continue;c.start=s;f(l+511>>9)}f(a[6]+7>>3);while(n.l&511)n._W(-4,V.ENDOFCHAIN);s=i=0;for(o=0;o<e.FileIndex.length;++o){c=e.FileIndex[o];if(!c.content)continue;l=c.content.length;if(!l||l>=4096)continue;c.start=s;f(l+63>>6)}while(n.l&511)n._W(-4,V.ENDOFCHAIN);for(i=0;i<a[4]<<2;++i){var h=e.FullPaths[i];if(!h||h.length===0){for(o=0;o<17;++o)n._W(4,0);for(o=0;o<3;++o)n._W(4,-1);for(o=0;o<12;++o)n._W(4,0);continue}c=e.FileIndex[i];if(i===0)c.start=c.size?c.start-1:N;var u=i===0&&t.root||c.name;l=2*(u.length+1);n._W(64,u,"utf16le");n._W(2,l);n._W(1,c.type);n._W(1,c.color);n._W(-4,c.L);n._W(-4,c.R);n._W(-4,c.C);if(!c.clsid)for(o=0;o<4;++o)n._W(4,0);else n._W(16,c.clsid,"hex");n._W(4,c.state||0);n._W(4,0);n._W(4,0);n._W(4,0);n._W(4,0);n._W(4,c.start);n._W(4,c.size);n._W(4,0)}for(i=1;i<e.FileIndex.length;++i){c=e.FileIndex[i];if(c.size>=4096){n.l=c.start+1<<9;for(o=0;o<c.size;++o)n._W(1,c.content[o]);for(;o&511;++o)n._W(1,0)}}for(i=1;i<e.FileIndex.length;++i){c=e.FileIndex[i];if(c.size>0&&c.size<4096){for(o=0;o<c.size;++o)n._W(1,c.content[o]);for(;o&63;++o)n._W(1,0)}}while(n.l<n.length)n._W(1,0);return n}function F(e,r){var t=e.FullPaths.map(function(e){return e.toUpperCase()});var a=t.map(function(e){var r=e.split("/");return r[r.length-(e.slice(-1)=="/"?2:1)]});var n=false;if(r.charCodeAt(0)===47){n=true;r=t[0].slice(0,-1)+r}else n=r.indexOf("/")!==-1;var i=r.toUpperCase();var s=n===true?t.indexOf(i):a.indexOf(i);if(s!==-1)return e.FileIndex[s];var f=!i.match(R);i=i.replace(I,"");if(f)i=i.replace(R,"!");for(s=0;s<t.length;++s){if((f?t[s].replace(R,"!"):t[s]).replace(I,"")==i)return e.FileIndex[s];if((f?a[s].replace(R,"!"):a[s]).replace(I,"")==i)return e.FileIndex[s]}return null}var P=64;var N=-2;var L="d0cf11e0a1b11ae1";var M=[208,207,17,224,161,177,26,225];var U="00000000000000000000000000000000";var V={MAXREGSECT:-6,DIFSECT:-4,FATSECT:-3,ENDOFCHAIN:N,FREESECT:-1,HEADER_SIGNATURE:L,HEADER_MINOR_VERSION:"3e00",MAXREGSID:-6,NOSTREAM:-1,HEADER_CLSID:U,EntryTypes:["unknown","storage","stream","lockbytes","property","root"]};function z(e,r,t){o();var a=O(e,t);f.writeFileSync(r,a)}function X(e){var r=new Array(e.length);for(var t=0;t<e.length;++t)r[t]=String.fromCharCode(e[t]);return r.join("")}function G(e,r){var t=O(e,r);switch(r&&r.type){case"file":o();f.writeFileSync(r.filename,t);return t;case"binary":return X(t);case"base64":return m.encode(X(t));}return t}var j;function K(e){try{var r=e.InflateRaw;var t=new r;t._processChunk(new Uint8Array([3,0]),t._finishFlushFlag);if(t.bytesRead)j=e;else throw new Error("zlib does not expose bytesRead")}catch(a){console.error("cannot use native zlib: "+(a.message||a))}}function Y(e,r){if(!j)return Ae(e,r);var t=j.InflateRaw;var a=new t;var n=a._processChunk(e.slice(e.l),a._finishFlushFlag);e.l+=a.bytesRead;return n}function $(e){return j?j.deflateRawSync(e):ue(e)}var Z=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];var Q=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258];var J=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577];function q(e){var r=(e<<1|e<<11)&139536|(e<<5|e<<15)&558144;return(r>>16|r>>8|r)&255}var ee=typeof Uint8Array!=="undefined";var re=ee?new Uint8Array(1<<8):[];for(var te=0;te<1<<8;++te)re[te]=q(te);function ae(e,r){var t=re[e&255];if(r<=8)return t>>>8-r;t=t<<8|re[e>>8&255];if(r<=16)return t>>>16-r;t=t<<8|re[e>>16&255];return t>>>24-r}function ne(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=6?0:e[a+1]<<8))>>>t&3}function ie(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=5?0:e[a+1]<<8))>>>t&7}function se(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=4?0:e[a+1]<<8))>>>t&15}function fe(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=3?0:e[a+1]<<8))>>>t&31}function oe(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=1?0:e[a+1]<<8))>>>t&127}function le(e,r,t){var a=r&7,n=r>>>3,i=(1<<t)-1;var s=e[n]>>>a;if(t<8-a)return s&i;s|=e[n+1]<<8-a;if(t<16-a)return s&i;s|=e[n+2]<<16-a;if(t<24-a)return s&i;s|=e[n+3]<<24-a;return s&i}function ce(e,r){var t=e.length,a=2*t>r?2*t:r+5,n=0;if(t>=r)return e;if(b){var i=S(a);if(e.copy)e.copy(i);else for(;n<e.length;++n)i[n]=e[n];return i}else if(ee){var s=new Uint8Array(a);if(s.set)s.set(e);else for(;n<e.length;++n)s[n]=e[n];return s}e.length=a;return e}function he(e){var r=new Array(e);for(var t=0;t<e;++t)r[t]=0;return r}var ue=function(){var e=function(){return function e(r,t){var a=0;while(a<r.length){var n=Math.min(65535,r.length-a);var i=a+n==r.length;t._W(1,+i);t._W(2,n);t._W(2,~n&65535);while(n-- >0)t[t.l++]=r[a++]}return t.l}}();return function(r){var t=Gr(50+Math.floor(r.length*1.1));var a=e(r,t);return t.slice(0,a)}}();function de(e,r,t){var a=1,n=0,i=0,s=0,f=0,o=e.length;var l=ee?new Uint16Array(32):he(32);for(i=0;i<32;++i)l[i]=0;for(i=o;i<t;++i)e[i]=0;o=e.length;var c=ee?new Uint16Array(o):he(o);for(i=0;i<o;++i){l[n=e[i]]++;if(a<n)a=n;c[i]=0}l[0]=0;for(i=1;i<=a;++i)l[i+16]=f=f+l[i-1]<<1;for(i=0;i<o;++i){f=e[i];if(f!=0)c[i]=l[f+16]++}var h=0;for(i=0;i<o;++i){h=e[i];if(h!=0){f=ae(c[i],a)>>a-h;for(s=(1<<a+4-h)-1;s>=0;--s)r[f|s<<h]=h&15|i<<4}}return a}var pe=ee?new Uint16Array(512):he(512);var ve=ee?new Uint16Array(32):he(32);if(!ee){for(var ge=0;ge<512;++ge)pe[ge]=0;for(ge=0;ge<32;++ge)ve[ge]=0}(function(){var e=[];var r=0;for(;r<32;r++)e.push(5);de(e,ve,32);var t=[];r=0;for(;r<=143;r++)t.push(8);for(;r<=255;r++)t.push(9);for(;r<=279;r++)t.push(7);for(;r<=287;r++)t.push(8);de(t,pe,288)})();var me=ee?new Uint16Array(32768):he(32768);var be=ee?new Uint16Array(32768):he(32768);var we=ee?new Uint16Array(128):he(128);var Ce=1,Ee=1;function ke(e,r){var t=fe(e,r)+257;r+=5;var a=fe(e,r)+1;r+=5;var n=se(e,r)+4;r+=4;var i=0;var s=ee?new Uint8Array(19):he(19);var f=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];var o=1;var l=ee?new Uint8Array(8):he(8);var c=ee?new Uint8Array(8):he(8);var h=s.length;for(var u=0;u<n;++u){s[Z[u]]=i=ie(e,r);if(o<i)o=i;l[i]++;r+=3}var d=0;l[0]=0;for(u=1;u<=o;++u)c[u]=d=d+l[u-1]<<1;for(u=0;u<h;++u)if((d=s[u])!=0)f[u]=c[d]++;var p=0;for(u=0;u<h;++u){p=s[u];if(p!=0){d=re[f[u]]>>8-p;for(var v=(1<<7-p)-1;v>=0;--v)we[d|v<<p]=p&7|u<<3}}var g=[];o=1;for(;g.length<t+a;){d=we[oe(e,r)];r+=d&7;switch(d>>>=3){case 16:i=3+ne(e,r);r+=2;d=g[g.length-1];while(i-- >0)g.push(d);break;case 17:i=3+ie(e,r);r+=3;while(i-- >0)g.push(0);break;case 18:i=11+oe(e,r);r+=7;while(i-- >0)g.push(0);break;default:g.push(d);if(o<d)o=d;break;}}var m=g.slice(0,t),b=g.slice(t);for(u=t;u<286;++u)m[u]=0;for(u=a;u<30;++u)b[u]=0;Ce=de(m,me,286);Ee=de(b,be,30);return r}function Se(e,r){if(e[0]==3&&!(e[1]&3)){return[k(r),2]}var t=0;var a=0;var n=S(r?r:1<<18);var i=0;var s=n.length>>>0;var f=0,o=0;while((a&1)==0){a=ie(e,t);t+=3;if(a>>>1==0){if(t&7)t+=8-(t&7);var l=e[t>>>3]|e[(t>>>3)+1]<<8;t+=32;if(!r&&s<i+l){n=ce(n,i+l);s=n.length}if(typeof e.copy==="function"){e.copy(n,i,t>>>3,(t>>>3)+l);i+=l;t+=8*l}else while(l-- >0){n[i++]=e[t>>>3];t+=8}continue}else if(a>>>1==1){f=9;o=5}else{t=ke(e,t);f=Ce;o=Ee}if(!r&&s<i+32767){n=ce(n,i+32767);s=n.length}for(;;){var c=le(e,t,f);var h=a>>>1==1?pe[c]:me[c];t+=h&15;h>>>=4;if((h>>>8&255)===0)n[i++]=h;else if(h==256)break;else{h-=257;var u=h<8?0:h-4>>2;if(u>5)u=0;var d=i+Q[h];if(u>0){d+=le(e,t,u);t+=u}c=le(e,t,o);h=a>>>1==1?ve[c]:be[c];t+=h&15;h>>>=4;var p=h<4?0:h-2>>1;var v=J[h];if(p>0){v+=le(e,t,p);t+=p}if(!r&&s<d){n=ce(n,d);s=n.length}while(i<d){n[i]=n[i-v];++i}}}}return[r?n:n.slice(0,i),t+7>>>3]}function Ae(e,r){var t=e.slice(e.l||0);var a=Se(t,r);e.l+=a[1];return a[0]}function _e(e,r){if(e){if(typeof console!=="undefined")console.error(r)}else throw new Error(r)}function Be(e,r){var t=e;zr(t,0);var a=[],n=[];var i={FileIndex:a,FullPaths:n};T(i,{root:r.root});var f=t.length-4;while((t[f]!=80||t[f+1]!=75||t[f+2]!=5||t[f+3]!=6)&&f>=0)--f;t.l=f+4;t.l+=4;var o=t._R(2);t.l+=6;var l=t._R(4);t.l=l;for(f=0;f<o;++f){t.l+=20;var c=t._R(4);var h=t._R(4);var u=t._R(2);var d=t._R(2);var p=t._R(2);t.l+=8;var v=t._R(4);var g=s(t.slice(t.l+u,t.l+u+d));t.l+=u+d+p;var m=t.l;t.l=v+4;Te(t,c,h,i,g);t.l=m}return i}function Te(e,r,t,a,n){e.l+=2;var f=e._R(2);var o=e._R(2);var l=i(e);if(f&8257)throw new Error("Unsupported ZIP encryption");var c=e._R(4);var h=e._R(4);var u=e._R(4);var d=e._R(2);var p=e._R(2);var v="";for(var g=0;g<d;++g)v+=String.fromCharCode(e[e.l++]);if(p){var m=s(e.slice(e.l,e.l+p));if((m[21589]||{}).mt)l=m[21589].mt;if(((n||{})[21589]||{}).mt)l=n[21589].mt}e.l+=p;var b=e.slice(e.l,e.l+h);switch(o){case 8:b=Y(e,u);break;case 0:break;default:throw new Error("Unsupported ZIP Compression method "+o);}var w=false;if(f&8){c=e._R(4);if(c==134695760){c=e._R(4);w=true}h=e._R(4);u=e._R(4)}if(h!=r)_e(w,"Bad compressed size: "+r+" != "+h);if(u!=t)_e(w,"Bad uncompressed size: "+t+" != "+u);var C=H.buf(b,0);if(c!=C)_e(w,"Bad CRC32 checksum: "+c+" != "+C);Ie(a,v,b,{unsafe:true,mt:l})}function ye(e,r){var t=r||{};var a=[],i=[];var s=Gr(1);var f=t.compression?8:0,o=0;var l=false;if(l)o|=8;var c=0,h=0;var u=0,d=0;var p=e.FullPaths[0],v=p,g=e.FileIndex[0];var m=[];var b=0;for(c=1;c<e.FullPaths.length;++c){v=e.FullPaths[c].slice(p.length);g=e.FileIndex[c];if(!g.size||!g.content||v=="Sh33tJ5")continue;var w=u;var C=Gr(v.length);for(h=0;h<v.length;++h)C._W(1,v.charCodeAt(h)&127);C=C.slice(0,C.l);m[d]=H.buf(g.content,0);var E=g.content;if(f==8)E=$(E);s=Gr(30);s._W(4,67324752);s._W(2,20);s._W(2,o);s._W(2,f);if(g.mt)n(s,g.mt);else s._W(4,0);s._W(-4,o&8?0:m[d]);s._W(4,o&8?0:E.length);s._W(4,o&8?0:g.content.length);s._W(2,C.length);s._W(2,0);u+=s.length;a.push(s);u+=C.length;a.push(C);u+=E.length;a.push(E);if(o&8){s=Gr(12);s._W(-4,m[d]);s._W(4,E.length);s._W(4,g.content.length);u+=s.l;a.push(s)}s=Gr(46);s._W(4,33639248);s._W(2,0);s._W(2,20);s._W(2,o);s._W(2,f);s._W(4,0);s._W(-4,m[d]);s._W(4,E.length);s._W(4,g.content.length);s._W(2,C.length);s._W(2,0);s._W(2,0);s._W(2,0);s._W(2,0);s._W(4,0);s._W(4,w);b+=s.l;i.push(s);b+=C.length;i.push(C);++d}s=Gr(22);s._W(4,101010256);s._W(2,0);s._W(2,0);s._W(2,d);s._W(2,d);s._W(4,b);s._W(4,u);s._W(2,0);return x([x(a),x(i),s])}function xe(e){var r={};T(r,e);return r}function Ie(e,r,t,n){var i=n&&n.unsafe;if(!i)T(e);var s=!i&&W.find(e,r);if(!s){var f=e.FullPaths[0];if(r.slice(0,f.length)==f)f=r;else{if(f.slice(-1)!="/")f+="/";f=(f+r).replace("//","/")}s={name:a(r),type:2};e.FileIndex.push(s);e.FullPaths.push(f);if(!i)W.utils.cfb_gc(e)}s.content=t;s.size=t?t.length:0;if(n){if(n.CLSID)s.clsid=n.CLSID;if(n.mt)s.mt=n.mt;if(n.ct)s.ct=n.ct}return s}function Re(e,r){T(e);var t=W.find(e,r);if(t)for(var a=0;a<e.FileIndex.length;++a)if(e.FileIndex[a]==t){e.FileIndex.splice(a,1);e.FullPaths.splice(a,1);return true}return false}function De(e,r,t){T(e);var n=W.find(e,r);if(n)for(var i=0;i<e.FileIndex.length;++i)if(e.FileIndex[i]==n){e.FileIndex[i].name=a(t);e.FullPaths[i]=t;return true}return false}function Oe(e){D(e,true)}e.find=F;e.read=B;e.parse=l;e.write=G;e.writeFile=z;e.utils={cfb_new:xe,cfb_add:Ie,cfb_del:Re,cfb_mov:De,cfb_gc:Oe,ReadShift:Lr,CheckField:Vr,prep_blob:zr,bconcat:x,use_zlib:K,_deflateRaw:ue,_inflateRaw:Ae,consts:V};return e}();if(typeof require!=="undefined"&&typeof module!=="undefined"&&typeof U==="undefined"){module.exports=W}var V;if(typeof require!=="undefined")try{V=require("fs")}catch(E){}function z(e){if(typeof e==="string")return _(e);if(Array.isArray(e))return T(e);return e}function X(e,r,t){if(typeof V!=="undefined"&&V.writeFileSync)return t?V.writeFileSync(e,r,t):V.writeFileSync(e,r);var a=t=="utf8"?Xe(r):r;if(typeof IE_SaveFile!=="undefined")return IE_SaveFile(a,e);if(typeof Blob!=="undefined"){var n=new Blob([z(a)],{type:"application/octet-stream"});if(typeof navigator!=="undefined"&&navigator.msSaveBlob)return navigator.msSaveBlob(n,e);if(typeof saveAs!=="undefined")return saveAs(n,e);if(typeof URL!=="undefined"&&typeof document!=="undefined"&&document.createElement&&URL.createObjectURL){var i=URL.createObjectURL(n);if(typeof chrome==="object"&&typeof(chrome.downloads||{}).download=="function"){if(URL.revokeObjectURL&&typeof setTimeout!=="undefined")setTimeout(function(){URL.revokeObjectURL(i)},6e4);return chrome.downloads.download({url:i,filename:e,saveAs:true})}var s=document.createElement("a");if(s.download!=null){s.download=e;s.href=i;document.body.appendChild(s);s.click();document.body.removeChild(s);if(URL.revokeObjectURL&&typeof setTimeout!=="undefined")setTimeout(function(){URL.revokeObjectURL(i)},6e4);return i}}}if(typeof $!=="undefined"&&typeof File!=="undefined"&&typeof Folder!=="undefined")try{var f=File(e);f.open("w");f.encoding="binary";if(Array.isArray(r))r=B(r);f.write(r);f.close();return r}catch(o){if(!o.message||!o.message.match(/onstruct/))throw o}throw new Error("cannot save file "+e)}function G(e){if(typeof V!=="undefined")return V.readFileSync(e);if(typeof $!=="undefined"&&typeof File!=="undefined"&&typeof Folder!=="undefined")try{var r=File(e);r.open("r");r.encoding="binary";var t=r.read();r.close();return t}catch(a){if(!a.message||!a.message.match(/onstruct/))throw a}throw new Error("Cannot access file "+e)}function j(e){var r=Object.keys(e),t=[];for(var a=0;a<r.length;++a)if(e.hasOwnProperty(r[a]))t.push(r[a]);return t}function K(e,r){var t=[],a=j(e);for(var n=0;n!==a.length;++n)if(t[e[a[n]][r]]==null)t[e[a[n]][r]]=a[n];return t}function Y(e){var r=[],t=j(e);for(var a=0;a!==t.length;++a)r[e[t[a]]]=t[a];return r}function Z(e){var r=[],t=j(e);for(var a=0;a!==t.length;++a)r[e[t[a]]]=parseInt(t[a],10);return r}function Q(e){var r=[],t=j(e);for(var a=0;a!==t.length;++a){if(r[e[t[a]]]==null)r[e[t[a]]]=[];r[e[t[a]]].push(t[a])}return r}var J=new Date(1899,11,30,0,0,0);var q=J.getTime()+((new Date).getTimezoneOffset()-J.getTimezoneOffset())*6e4;function ee(e,r){var t=e.getTime();if(r)t-=1462*24*60*60*1e3;return(t-q)/(24*60*60*1e3)}function re(e){var r=new Date;r.setTime(e*24*60*60*1e3+q);return r}function te(e){var r=0,t=0,a=false;var n=e.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);if(!n)throw new Error("|"+e+"| is not an ISO8601 Duration");for(var i=1;i!=n.length;++i){if(!n[i])continue;t=1;if(i>3)a=true;switch(n[i].slice(n[i].length-1)){case"Y":throw new Error("Unsupported ISO Duration Field: "+n[i].slice(n[i].length-1));case"D":t*=24;case"H":t*=60;case"M":if(!a)throw new Error("Unsupported ISO Duration Field: M");else t*=60;case"S":break;}r+=t*parseInt(n[i],10)}return r}var ae=new Date("2017-02-19T19:06:09.000Z");if(isNaN(ae.getFullYear()))ae=new Date("2/19/17");var ne=ae.getFullYear()==2017;function ie(e,r){var t=new Date(e);if(ne){if(r>0)t.setTime(t.getTime()+t.getTimezoneOffset()*60*1e3);else if(r<0)t.setTime(t.getTime()-t.getTimezoneOffset()*60*1e3);return t}if(e instanceof Date)return e;if(ae.getFullYear()==1917&&!isNaN(t.getFullYear())){var a=t.getFullYear();if(e.indexOf(""+a)>-1)return t;t.setFullYear(t.getFullYear()+100);return t}var n=e.match(/\d+/g)||["2017","2","19","0","0","0"];var i=new Date(+n[0],+n[1]-1,+n[2],+n[3]||0,+n[4]||0,+n[5]||0);if(e.indexOf("Z")>-1)i=new Date(i.getTime()-i.getTimezoneOffset()*60*1e3);return i}function se(e){var r="";for(var t=0;t!=e.length;++t)r+=String.fromCharCode(e[t]);return r}function fe(e){if(typeof JSON!="undefined"&&!Array.isArray(e))return JSON.parse(JSON.stringify(e));if(typeof e!="object"||e==null)return e;if(e instanceof Date)return new Date(e.getTime());var r={};for(var t in e)if(e.hasOwnProperty(t))r[t]=fe(e[t]);return r}function oe(e,r){var t="";while(t.length<r)t+=e;return t}function le(e){var r=Number(e);if(!isNaN(r))return r;var t=1;var a=e.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g,function(){t*=100;return""});if(!isNaN(r=Number(a)))return r/t;a=a.replace(/[(](.*)[)]/,function(e,r){t=-t;return r});if(!isNaN(r=Number(a)))return r/t;return r}function ce(e){var r=new Date(e),t=new Date(NaN);var a=r.getYear(),n=r.getMonth(),i=r.getDate();if(isNaN(i))return t;if(a<0||a>8099)return t;if((n>0||i>1)&&a!=101)return r;if(e.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/))return r;if(e.match(/[^-0-9:,\/\\]/))return t;return r}var he="abacaba".split(/(:?b)/i).length==5;function ue(e,r,t){if(he||typeof r=="string")return e.split(r);var a=e.split(r),n=[a[0]];for(var i=1;i<a.length;++i){n.push(t);n.push(a[i])}return n}function de(e){if(!e)return null;if(e.data)return d(e.data);if(e.asNodeBuffer&&b)return d(e.asNodeBuffer().toString("binary"));if(e.asBinary)return d(e.asBinary());if(e._data&&e._data.getContent)return d(se(Array.prototype.slice.call(e._data.getContent(),0)));return null}function pe(e){if(!e)return null;if(e.data)return c(e.data);if(e.asNodeBuffer&&b)return e.asNodeBuffer();if(e._data&&e._data.getContent){var r=e._data.getContent();if(typeof r=="string")return c(r);return Array.prototype.slice.call(r)}return null}function ve(e){return e&&e.name.slice(-4)===".bin"?pe(e):de(e)}function ge(e,r){var t=j(e.files);var a=r.toLowerCase(),n=a.replace(/\//g,"\\");for(var i=0;i<t.length;++i){var s=t[i].toLowerCase();if(a==s||n==s)return e.files[t[i]]}return null}function me(e,r){var t=ge(e,r);if(t==null)throw new Error("Cannot find file "+r+" in zip");return t}function be(e,r,t){if(!t)return ve(me(e,r));if(!r)return null;try{return be(e,r)}catch(a){return null}}function we(e,r,t){if(!t)return de(me(e,r));if(!r)return null;try{return we(e,r)}catch(a){return null}}function Ce(e){var r=j(e.files),t=[];for(var a=0;a<r.length;++a)if(r[a].slice(-1)!="/")t.push(r[a]);return t.sort()}var Ee;if(typeof JSZipSync!=="undefined")Ee=JSZipSync;if(typeof exports!=="undefined"){if(typeof module!=="undefined"&&module.exports){if(typeof Ee==="undefined")Ee=undefined}}function ke(e,r){var t=r.split("/");if(r.slice(-1)!="/")t.pop();var a=e.split("/");while(a.length!==0){var n=a.shift();if(n==="..")t.pop();else if(n!==".")t.push(n)}return t.join("/")}var Se='<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';var Ae=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;var _e=/<[\/\?]?[a-zA-Z0-9:]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s?[\/\?]?>/g;if(!Se.match(_e))_e=/<[^>]*>/g;var Be=/<\w*:/,Te=/<(\/?)\w+:/;function ye(e,r){var t={};var a=0,n=0;for(;a!==e.length;++a)if((n=e.charCodeAt(a))===32||n===10||n===13)break;if(!r)t[0]=e.slice(0,a);if(a===e.length)return t;var i=e.match(Ae),s=0,f="",o=0,l="",c="",h=1;if(i)for(o=0;o!=i.length;++o){c=i[o];for(n=0;n!=c.length;++n)if(c.charCodeAt(n)===61)break;l=c.slice(0,n).trim();while(c.charCodeAt(n+1)==32)++n;h=(a=c.charCodeAt(n+1))==34||a==39?1:0;f=c.slice(n+1+h,c.length-h);for(s=0;s!=l.length;++s)if(l.charCodeAt(s)===58)break;if(s===l.length){if(l.indexOf("_")>0)l=l.slice(0,l.indexOf("_"));t[l]=f;t[l.toLowerCase()]=f}else{var u=(s===5&&l.slice(0,5)==="xmlns"?"xmlns":"")+l.slice(s+1);if(t[u]&&l.slice(s-3,s)=="ext")continue;t[u]=f;t[u.toLowerCase()]=f}}return t}function xe(e){return e.replace(Te,"<$1")}var Ie={"&quot;":'"',"&apos;":"'","&gt;":">","&lt;":"<","&amp;":"&"};var Re=Y(Ie);var De=function(){var e=/&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/g,r=/_x([\da-fA-F]{4})_/g;return function t(a){var n=a+"",i=n.indexOf("<![CDATA[");if(i==-1)return n.replace(e,function(e,r){return Ie[e]||String.fromCharCode(parseInt(r,e.indexOf("x")>-1?16:10))||e}).replace(r,function(e,r){return String.fromCharCode(parseInt(r,16))});var s=n.indexOf("]]>");return t(n.slice(0,i))+n.slice(i+9,s)+t(n.slice(s+3))}}();var Oe=/[&<>'"]/g,Fe=/[\u0000-\u0008\u000b-\u001f]/g;function Pe(e){var r=e+"";return r.replace(Oe,function(e){return Re[e]}).replace(Fe,function(e){return"_x"+("000"+e.charCodeAt(0).toString(16)).slice(-4)+"_"})}function Ne(e){return Pe(e).replace(/ /g,"_x0020_")}var Le=/[\u0000-\u001f]/g;function Me(e){var r=e+"";return r.replace(Oe,function(e){return Re[e]}).replace(/\n/g,"<br/>").replace(Le,function(e){return"&#x"+("000"+e.charCodeAt(0).toString(16)).slice(-4)+";"})}function Ue(e){var r=e+"";return r.replace(Oe,function(e){return Re[e]}).replace(Le,function(e){return"&#x"+e.charCodeAt(0).toString(16).toUpperCase()+";"})}var He=function(){var e=/&#(\d+);/g;function r(e,r){return String.fromCharCode(parseInt(r,10))}return function t(a){return a.replace(e,r)}}();var We=function(){return function e(r){return r.replace(/(\r\n|[\r\n])/g,"&#10;")}}();function Ve(e){switch(e){case 1:;case true:;case"1":;case"true":;case"TRUE":return true;default:return false;}}var ze=function jg(e){var r="",t=0,a=0,n=0,i=0,s=0,f=0;while(t<e.length){a=e.charCodeAt(t++);if(a<128){r+=String.fromCharCode(a);continue}n=e.charCodeAt(t++);if(a>191&&a<224){s=(a&31)<<6;s|=n&63;r+=String.fromCharCode(s);continue}i=e.charCodeAt(t++);if(a<240){r+=String.fromCharCode((a&15)<<12|(n&63)<<6|i&63);continue}s=e.charCodeAt(t++);f=((a&7)<<18|(n&63)<<12|(i&63)<<6|s&63)-65536;r+=String.fromCharCode(55296+(f>>>10&1023));r+=String.fromCharCode(56320+(f&1023))}return r};var Xe=function(e){var r=[],t=0,a=0,n=0;while(t<e.length){a=e.charCodeAt(t++);switch(true){case a<128:r.push(String.fromCharCode(a));break;case a<2048:r.push(String.fromCharCode(192+(a>>6)));r.push(String.fromCharCode(128+(a&63)));break;case a>=55296&&a<57344:a-=55296;n=e.charCodeAt(t++)-56320+(a<<10);r.push(String.fromCharCode(240+(n>>18&7)));r.push(String.fromCharCode(144+(n>>12&63)));r.push(String.fromCharCode(128+(n>>6&63)));r.push(String.fromCharCode(128+(n&63)));break;default:r.push(String.fromCharCode(224+(a>>12)));r.push(String.fromCharCode(128+(a>>6&63)));r.push(String.fromCharCode(128+(a&63)));}}return r.join("")};if(b){var Ge=function Kg(e){var r=Buffer.alloc(2*e.length),t,a,n=1,i=0,s=0,f;for(a=0;a<e.length;a+=n){n=1;if((f=e.charCodeAt(a))<128)t=f;else if(f<224){t=(f&31)*64+(e.charCodeAt(a+1)&63);n=2}else if(f<240){t=(f&15)*4096+(e.charCodeAt(a+1)&63)*64+(e.charCodeAt(a+2)&63);n=3}else{n=4;t=(f&7)*262144+(e.charCodeAt(a+1)&63)*4096+(e.charCodeAt(a+2)&63)*64+(e.charCodeAt(a+3)&63);t-=65536;s=55296+(t>>>10&1023);t=56320+(t&1023)}if(s!==0){r[i++]=s&255;r[i++]=s>>>8;s=0}r[i++]=t%256;r[i++]=t>>>8}return r.slice(0,i).toString("ucs2")};var je="foo bar bazâð£";if(ze(je)==Ge(je))ze=Ge;var Ke=function Yg(e){return w(e,"binary").toString("utf8")};if(ze(je)==Ke(je))ze=Ke;Xe=function(e){return w(e,"utf8").toString("binary")}}var Ye=function(){var e={};return function r(t,a){var n=t+"|"+(a||"");if(e[n])return e[n];return e[n]=new RegExp("<(?:\\w+:)?"+t+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+t+">",a||"")}}();var $e=function(){var e=[["nbsp"," "],["middot","·"],["quot",'"'],["apos","'"],["gt",">"],["lt","<"],["amp","&"]].map(function(e){return[new RegExp("&"+e[0]+";","g"),e[1]]});return function r(t){var a=t.replace(/^[\t\n\r ]+/,"").replace(/[\t\n\r ]+$/,"").replace(/[\t\n\r ]+/g," ").replace(/<\s*[bB][rR]\s*\/?>/g,"\n").replace(/<[^>]*>/g,"");for(var n=0;n<e.length;++n)a=a.replace(e[n][0],e[n][1]);return a}}();var Ze=function(){var e={};return function r(t){if(e[t]!==undefined)return e[t];return e[t]=new RegExp("<(?:vt:)?"+t+">([\\s\\S]*?)</(?:vt:)?"+t+">","g")}}();var Qe=/<\/?(?:vt:)?variant>/g,Je=/<(?:vt:)([^>]*)>([\s\S]*)</;function qe(e,r){var t=ye(e);var a=e.match(Ze(t.baseType))||[];var n=[];if(a.length!=t.size){if(r.WTF)throw new Error("unexpected vector length "+a.length+" != "+t.size);return n}a.forEach(function(e){var r=e.replace(Qe,"").match(Je);if(r)n.push({v:ze(r[2]),t:r[1]})});return n}var er=/(^\s|\s$|\n)/;function rr(e,r){return"<"+e+(r.match(er)?' xml:space="preserve"':"")+">"+r+"</"+e+">"}function tr(e){return j(e).map(function(r){return" "+r+'="'+e[r]+'"'}).join("")}function ar(e,r,t){return"<"+e+(t!=null?tr(t):"")+(r!=null?(r.match(er)?' xml:space="preserve"':"")+">"+r+"</"+e:"/")+">"}function nr(e,r){try{return e.toISOString().replace(/\.\d*/,"")}catch(t){if(r)throw t}return""}function ir(e){switch(typeof e){case"string":return ar("vt:lpwstr",e);case"number":return ar((e|0)==e?"vt:i4":"vt:r8",String(e));case"boolean":return ar("vt:bool",e?"true":"false");}if(e instanceof Date)return ar("vt:filetime",nr(e));throw new Error("Unable to serialize "+e)}var sr={dc:"http://purl.org/dc/elements/1.1/",dcterms:"http://purl.org/dc/terms/",dcmitype:"http://purl.org/dc/dcmitype/",mx:"http://schemas.microsoft.com/office/mac/excel/2008/main",r:"http://schemas.openxmlformats.org/officeDocument/2006/relationships",sjs:"http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",vt:"http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",xsi:"http://www.w3.org/2001/XMLSchema-instance",xsd:"http://www.w3.org/2001/XMLSchema"};sr.main=["http://schemas.openxmlformats.org/spreadsheetml/2006/main","http://purl.oclc.org/ooxml/spreadsheetml/main","http://schemas.microsoft.com/office/excel/2006/main","http://schemas.microsoft.com/office/excel/2006/2"];var fr={o:"urn:schemas-microsoft-com:office:office",x:"urn:schemas-microsoft-com:office:excel",ss:"urn:schemas-microsoft-com:office:spreadsheet",dt:"uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",mv:"http://macVmlSchemaUri",v:"urn:schemas-microsoft-com:vml",html:"http://www.w3.org/TR/REC-html40"};function or(e,r){var t=1-2*(e[r+7]>>>7);var a=((e[r+7]&127)<<4)+(e[r+6]>>>4&15);var n=e[r+6]&15;for(var i=5;i>=0;--i)n=n*256+e[r+i];if(a==2047)return n==0?t*Infinity:NaN;if(a==0)a=-1022;else{a-=1023;n+=Math.pow(2,52)}return t*Math.pow(2,a-52)*n}function lr(e,r,t){var a=(r<0||1/r==-Infinity?1:0)<<7,n=0,i=0;var s=a?-r:r;if(!isFinite(s)){n=2047;i=isNaN(r)?26985:0}else if(s==0)n=i=0;else{n=Math.floor(Math.log(s)/Math.LN2);i=s*Math.pow(2,52-n);if(n<=-1023&&(!isFinite(i)||i<Math.pow(2,52))){n=-1022}else{i-=Math.pow(2,52);n+=1023}}for(var f=0;f<=5;++f,i/=256)e[t+f]=i&255;e[t+6]=(n&15)<<4|i&15;e[t+7]=n>>4|a}var cr=function(e){var r=[],t=10240;for(var a=0;a<e[0].length;++a)if(e[0][a])for(var n=0,i=e[0][a].length;n<i;n+=t)r.push.apply(r,e[0][a].slice(n,n+t));return r};var hr=cr;var ur=function(e,r,t){var a=[];for(var n=r;n<t;n+=2)a.push(String.fromCharCode(Dr(e,n)));return a.join("").replace(I,"")};var dr=ur;var pr=function(e,r,t){var a=[];for(var n=r;n<r+t;++n)a.push(("0"+e[n].toString(16)).slice(-2));return a.join("")};var vr=pr;var gr=function(e,r,t){var a=[];for(var n=r;n<t;n++)a.push(String.fromCharCode(Rr(e,n)));return a.join("")};var mr=gr;var br=function(e,r){var t=Fr(e,r);return t>0?gr(e,r+4,r+4+t-1):""};var wr=br;var Cr=function(e,r){var t=Fr(e,r);return t>0?gr(e,r+4,r+4+t-1):""};var Er=Cr;var kr=function(e,r){var t=2*Fr(e,r);return t>0?gr(e,r+4,r+4+t-1):""};var Sr=kr;var Ar,_r;Ar=_r=function $g(e,r){var t=Fr(e,r);return t>0?ur(e,r+4,r+4+t):""};var Br=function(e,r){var t=Fr(e,r);return t>0?gr(e,r+4,r+4+t):""};var Tr=Br;var yr,xr;yr=xr=function(e,r){return or(e,r)};var Ir=function Zg(e){return Array.isArray(e)};if(b){ur=function(e,r,t){if(!Buffer.isBuffer(e))return dr(e,r,t);return e.toString("utf16le",r,t).replace(I,"")};pr=function(e,r,t){return Buffer.isBuffer(e)?e.toString("hex",r,r+t):vr(e,r,t)};br=function Qg(e,r){if(!Buffer.isBuffer(e))return wr(e,r);var t=e.readUInt32LE(r);return t>0?e.toString("utf8",r+4,r+4+t-1):""};Cr=function Jg(e,r){if(!Buffer.isBuffer(e))return Er(e,r);var t=e.readUInt32LE(r);return t>0?e.toString("utf8",r+4,r+4+t-1):""};kr=function qg(e,r){if(!Buffer.isBuffer(e))return Sr(e,r);var t=2*e.readUInt32LE(r);return e.toString("utf16le",r+4,r+4+t-1)};Ar=function em(e,r){if(!Buffer.isBuffer(e))return _r(e,r);var t=e.readUInt32LE(r);return e.toString("utf16le",r+4,r+4+t)};Br=function rm(e,r){if(!Buffer.isBuffer(e))return Tr(e,r);var t=e.readUInt32LE(r);return e.toString("utf8",r+4,r+4+t)};gr=function tm(e,r,t){return Buffer.isBuffer(e)?e.toString("utf8",r,t):mr(e,r,t)};cr=function(e){return e[0].length>0&&Buffer.isBuffer(e[0][0])?Buffer.concat(e[0]):hr(e)};x=function(e){return Buffer.isBuffer(e[0])?Buffer.concat(e):[].concat.apply([],e)};yr=function am(e,r){if(Buffer.isBuffer(e))return e.readDoubleLE(r);return xr(e,r)};Ir=function nm(e){return Buffer.isBuffer(e)||Array.isArray(e)}}if(typeof cptable!=="undefined"){ur=function(e,r,t){return cptable.utils.decode(1200,e.slice(r,t)).replace(I,"")};gr=function(e,r,t){return cptable.utils.decode(65001,e.slice(r,t))};br=function(e,r){var a=Fr(e,r);return a>0?cptable.utils.decode(t,e.slice(r+4,r+4+a-1)):""};Cr=function(e,t){var a=Fr(e,t);return a>0?cptable.utils.decode(r,e.slice(t+4,t+4+a-1)):""};kr=function(e,r){var t=2*Fr(e,r);return t>0?cptable.utils.decode(1200,e.slice(r+4,r+4+t-1)):""};Ar=function(e,r){var t=Fr(e,r);return t>0?cptable.utils.decode(1200,e.slice(r+4,r+4+t)):""};Br=function(e,r){var t=Fr(e,r);return t>0?cptable.utils.decode(65001,e.slice(r+4,r+4+t)):""}}var Rr=function(e,r){return e[r]};var Dr=function(e,r){return e[r+1]*(1<<8)+e[r]};var Or=function(e,r){var t=e[r+1]*(1<<8)+e[r];return t<32768?t:(65535-t+1)*-1};var Fr=function(e,r){return e[r+3]*(1<<24)+(e[r+2]<<16)+(e[r+1]<<8)+e[r]};var Pr=function(e,r){return e[r+3]<<24|e[r+2]<<16|e[r+1]<<8|e[r]};var Nr=function(e,r){return e[r]<<24|e[r+1]<<16|e[r+2]<<8|e[r+3]};function Lr(e,t){var a="",n,i,s=[],f,o,l,c;switch(t){case"dbcs":c=this.l;if(b&&Buffer.isBuffer(this))a=this.slice(this.l,this.l+2*e).toString("utf16le");else for(l=0;l<e;++l){a+=String.fromCharCode(Dr(this,c));c+=2}e*=2;break;case"utf8":a=gr(this,this.l,this.l+e);break;case"utf16le":e*=2;a=ur(this,this.l,this.l+e);break;case"wstr":if(typeof cptable!=="undefined")a=cptable.utils.decode(r,this.slice(this.l,this.l+2*e));else return Lr.call(this,e,"dbcs");e=2*e;break;case"lpstr-ansi":a=br(this,this.l);e=4+Fr(this,this.l);break;case"lpstr-cp":a=Cr(this,this.l);e=4+Fr(this,this.l);break;case"lpwstr":a=kr(this,this.l);e=4+2*Fr(this,this.l);break;case"lpp4":e=4+Fr(this,this.l);a=Ar(this,this.l);if(e&2)e+=2;break;case"8lpp4":e=4+Fr(this,this.l);a=Br(this,this.l);if(e&3)e+=4-(e&3);break;case"cstr":e=0;a="";while((f=Rr(this,this.l+e++))!==0)s.push(p(f));a=s.join("");
break;case"_wstr":e=0;a="";while((f=Dr(this,this.l+e))!==0){s.push(p(f));e+=2}e+=2;a=s.join("");break;case"dbcs-cont":a="";c=this.l;for(l=0;l<e;++l){if(this.lens&&this.lens.indexOf(c)!==-1){f=Rr(this,c);this.l=c+1;o=Lr.call(this,e-l,f?"dbcs-cont":"sbcs-cont");return s.join("")+o}s.push(p(Dr(this,c)));c+=2}a=s.join("");e*=2;break;case"cpstr":if(typeof cptable!=="undefined"){a=cptable.utils.decode(r,this.slice(this.l,this.l+e));break};case"sbcs-cont":a="";c=this.l;for(l=0;l!=e;++l){if(this.lens&&this.lens.indexOf(c)!==-1){f=Rr(this,c);this.l=c+1;o=Lr.call(this,e-l,f?"dbcs-cont":"sbcs-cont");return s.join("")+o}s.push(p(Rr(this,c)));c+=1}a=s.join("");break;default:switch(e){case 1:n=Rr(this,this.l);this.l++;return n;case 2:n=(t==="i"?Or:Dr)(this,this.l);this.l+=2;return n;case 4:;case-4:if(t==="i"||(this[this.l+3]&128)===0){n=(e>0?Pr:Nr)(this,this.l);this.l+=4;return n}else{i=Fr(this,this.l);this.l+=4}return i;case 8:;case-8:if(t==="f"){if(e==8)i=yr(this,this.l);else i=yr([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]],0);this.l+=8;return i}else e=8;case 16:a=pr(this,this.l,e);break;};}this.l+=e;return a}var Mr=function(e,r,t){e[t]=r&255;e[t+1]=r>>>8&255;e[t+2]=r>>>16&255;e[t+3]=r>>>24&255};var Ur=function(e,r,t){e[t]=r&255;e[t+1]=r>>8&255;e[t+2]=r>>16&255;e[t+3]=r>>24&255};var Hr=function(e,r,t){e[t]=r&255;e[t+1]=r>>>8&255};function Wr(e,r,t){var a=0,n=0;if(t==="dbcs"){for(n=0;n!=r.length;++n)Hr(this,r.charCodeAt(n),this.l+2*n);a=2*r.length}else if(t==="sbcs"){r=r.replace(/[^\x00-\x7F]/g,"_");for(n=0;n!=r.length;++n)this[this.l+n]=r.charCodeAt(n)&255;a=r.length}else if(t==="hex"){for(;n<e;++n){this[this.l++]=parseInt(r.slice(2*n,2*n+2),16)||0}return this}else if(t==="utf16le"){var i=Math.min(this.l+e,this.length);for(n=0;n<Math.min(r.length,e);++n){var s=r.charCodeAt(n);this[this.l++]=s&255;this[this.l++]=s>>8}while(this.l<i)this[this.l++]=0;return this}else switch(e){case 1:a=1;this[this.l]=r&255;break;case 2:a=2;this[this.l]=r&255;r>>>=8;this[this.l+1]=r&255;break;case 3:a=3;this[this.l]=r&255;r>>>=8;this[this.l+1]=r&255;r>>>=8;this[this.l+2]=r&255;break;case 4:a=4;Mr(this,r,this.l);break;case 8:a=8;if(t==="f"){lr(this,r,this.l);break};case 16:break;case-4:a=4;Ur(this,r,this.l);break;}this.l+=a;return this}function Vr(e,r){var t=pr(this,this.l,e.length>>1);if(t!==e)throw new Error(r+"Expected "+e+" saw "+t);this.l+=e.length>>1}function zr(e,r){e.l=r;e._R=Lr;e.chk=Vr;e._W=Wr}function Xr(e,r){e.l+=r}function Gr(e){var r=k(e);zr(r,0);return r}function jr(e,r,t){if(!e)return;var a,n,i;zr(e,e.l||0);var s=e.length,f=0,o=0;while(e.l<s){f=e._R(1);if(f&128)f=(f&127)+((e._R(1)&127)<<7);var l=hv[f]||hv[65535];a=e._R(1);i=a&127;for(n=1;n<4&&a&128;++n)i+=((a=e._R(1))&127)<<7*n;o=e.l+i;var c=(l.f||Xr)(e,i,t);e.l=o;if(r(c,l.n,f))return}}function Kr(){var e=[],r=b?256:2048;var t=function o(e){var r=Gr(e);zr(r,0);return r};var a=t(r);var n=function l(){if(!a)return;if(a.length>a.l){a=a.slice(0,a.l);a.l=a.length}if(a.length>0)e.push(a);a=null};var i=function c(e){if(a&&e<a.length-a.l)return a;n();return a=t(Math.max(e+1,r))};var s=function h(){n();return cr([e])};var f=function u(e){n();a=e;if(a.l==null)a.l=a.length;i(r)};return{next:i,push:f,end:s,_bufs:e}}function Yr(e,r,t,a){var n=+uv[r],i;if(isNaN(n))return;if(!a)a=hv[n].p||(t||[]).length||0;i=1+(n>=128?1:0)+1;if(a>=128)++i;if(a>=16384)++i;if(a>=2097152)++i;var s=e.next(i);if(n<=127)s._W(1,n);else{s._W(1,(n&127)+128);s._W(1,n>>7)}for(var f=0;f!=4;++f){if(a>=128){s._W(1,(a&127)+128);a>>=7}else{s._W(1,a);break}}if(a>0&&Ir(t))e.push(t)}function $r(e,r,t){var a=fe(e);if(r.s){if(a.cRel)a.c+=r.s.c;if(a.rRel)a.r+=r.s.r}else{if(a.cRel)a.c+=r.c;if(a.rRel)a.r+=r.r}if(!t||t.biff<12){while(a.c>=256)a.c-=256;while(a.r>=65536)a.r-=65536}return a}function Zr(e,r,t){var a=fe(e);a.s=$r(a.s,r.s,t);a.e=$r(a.e,r.s,t);return a}function Qr(e,r){if(e.cRel&&e.c<0){e=fe(e);e.c+=r>8?16384:256}if(e.rRel&&e.r<0){e=fe(e);e.r+=r>8?1048576:r>5?65536:16384}var t=ht(e);if(e.cRel===0)t=ft(t);if(e.rRel===0)t=at(t);return t}function Jr(e,r){if(e.s.r==0&&!e.s.rRel){if(e.e.r==(r.biff>=12?1048575:r.biff>=8?65536:16384)&&!e.e.rRel){return(e.s.cRel?"":"$")+st(e.s.c)+":"+(e.e.cRel?"":"$")+st(e.e.c)}}if(e.s.c==0&&!e.s.cRel){if(e.e.c==(r.biff>=12?65535:255)&&!e.e.cRel){return(e.s.rRel?"":"$")+tt(e.s.r)+":"+(e.e.rRel?"":"$")+tt(e.e.r)}}return Qr(e.s,r.biff)+":"+Qr(e.e,r.biff)}var qr={};var et=function(e,r){var t;if(typeof r!=="undefined")t=r;else if(typeof require!=="undefined"){try{t=undefined}catch(a){t=null}}e.rc4=function(e,r){var t=new Array(256);var a=0,n=0,i=0,s=0;for(n=0;n!=256;++n)t[n]=n;for(n=0;n!=256;++n){i=i+t[n]+e[n%e.length].charCodeAt(0)&255;s=t[n];t[n]=t[i];t[i]=s}n=i=0;var f=Buffer(r.length);for(a=0;a!=r.length;++a){n=n+1&255;i=(i+t[n])%256;s=t[n];t[n]=t[i];t[i]=s;f[a]=r[a]^t[t[n]+t[i]&255]}return f};e.md5=function(e){if(!t)throw new Error("Unsupported crypto");return t.createHash("md5").update(e).digest("hex")}};et(qr,typeof crypto!=="undefined"?crypto:undefined);function rt(e){return parseInt(nt(e),10)-1}function tt(e){return""+(e+1)}function at(e){return e.replace(/([A-Z]|^)(\d+)$/,"$1$$$2")}function nt(e){return e.replace(/\$(\d+)$/,"$1")}function it(e){var r=ot(e),t=0,a=0;for(;a!==r.length;++a)t=26*t+r.charCodeAt(a)-64;return t-1}function st(e){var r="";for(++e;e;e=Math.floor((e-1)/26))r=String.fromCharCode((e-1)%26+65)+r;return r}function ft(e){return e.replace(/^([A-Z])/,"$$$1")}function ot(e){return e.replace(/^\$([A-Z])/,"$1")}function lt(e){return e.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(",")}function ct(e){var r=lt(e);return{c:it(r[0]),r:rt(r[1])}}function ht(e){return st(e.c)+tt(e.r)}function ut(e){var r=e.split(":").map(ct);return{s:r[0],e:r[r.length-1]}}function dt(e,r){if(typeof r==="undefined"||typeof r==="number"){return dt(e.s,e.e)}if(typeof e!=="string")e=ht(e);if(typeof r!=="string")r=ht(r);return e==r?e:e+":"+r}function pt(e){var r={s:{c:0,r:0},e:{c:0,r:0}};var t=0,a=0,n=0;var i=e.length;for(t=0;a<i;++a){if((n=e.charCodeAt(a)-64)<1||n>26)break;t=26*t+n}r.s.c=--t;for(t=0;a<i;++a){if((n=e.charCodeAt(a)-48)<0||n>9)break;t=10*t+n}r.s.r=--t;if(a===i||e.charCodeAt(++a)===58){r.e.c=r.s.c;r.e.r=r.s.r;return r}for(t=0;a!=i;++a){if((n=e.charCodeAt(a)-64)<1||n>26)break;t=26*t+n}r.e.c=--t;for(t=0;a!=i;++a){if((n=e.charCodeAt(a)-48)<0||n>9)break;t=10*t+n}r.e.r=--t;return r}function vt(e,r){var t=e.t=="d"&&r instanceof Date;if(e.z!=null)try{return e.w=D.format(e.z,t?ee(r):r)}catch(a){}try{return e.w=D.format((e.XF||{}).numFmtId||(t?14:0),t?ee(r):r)}catch(a){return""+r}}function gt(e,r,t){if(e==null||e.t==null||e.t=="z")return"";if(e.w!==undefined)return e.w;if(e.t=="d"&&!e.z&&t&&t.dateNF)e.z=t.dateNF;if(r==undefined)return vt(e,e.v);return vt(e,r)}function mt(e,r){var t=r&&r.sheet?r.sheet:"Sheet1";var a={};a[t]=e;return{SheetNames:[t],Sheets:a}}function bt(e,r,t){var a=t||{};var n=e?Array.isArray(e):a.dense;if(v!=null&&n==null)n=v;var i=e||(n?[]:{});var s=0,f=0;if(i&&a.origin!=null){if(typeof a.origin=="number")s=a.origin;else{var o=typeof a.origin=="string"?ct(a.origin):a.origin;s=o.r;f=o.c}}var l={s:{c:1e7,r:1e7},e:{c:0,r:0}};if(i["!ref"]){var c=pt(i["!ref"]);l.s.c=c.s.c;l.s.r=c.s.r;l.e.c=Math.max(l.e.c,c.e.c);l.e.r=Math.max(l.e.r,c.e.r);if(s==-1)l.e.r=s=c.e.r+1}for(var h=0;h!=r.length;++h){if(!r[h])continue;if(!Array.isArray(r[h]))throw new Error("aoa_to_sheet expects an array of arrays");for(var u=0;u!=r[h].length;++u){if(typeof r[h][u]==="undefined")continue;var d={v:r[h][u]};if(Array.isArray(d.v)){d.f=r[h][u][1];d.v=d.v[0]}var p=s+h,g=f+u;if(l.s.r>p)l.s.r=p;if(l.s.c>g)l.s.c=g;if(l.e.r<p)l.e.r=p;if(l.e.c<g)l.e.c=g;if(d.v===null){if(d.f)d.t="n";else if(!a.cellStubs)continue;else d.t="z"}else if(typeof d.v==="number")d.t="n";else if(typeof d.v==="boolean")d.t="b";else if(d.v instanceof Date){d.z=a.dateNF||D._table[14];if(a.cellDates){d.t="d";d.w=D.format(d.z,ee(d.v))}else{d.t="n";d.v=ee(d.v);d.w=D.format(d.z,d.v)}}else d.t="s";if(n){if(!i[p])i[p]=[];i[p][g]=d}else{var m=ht({c:g,r:p});i[m]=d}}}if(l.s.c<1e7)i["!ref"]=dt(l);return i}function wt(e,r){return bt(null,e,r)}function Ct(e,r){if(!r)r=Gr(4);r._W(4,e);return r}function Et(e){var r=e._R(4);return r===0?"":e._R(r,"dbcs")}function kt(e,r){var t=false;if(r==null){t=true;r=Gr(4+2*e.length)}r._W(4,e.length);if(e.length>0)r._W(0,e,"dbcs");return t?r.slice(0,r.l):r}function St(e){return{ich:e._R(2),ifnt:e._R(2)}}function At(e,r){if(!r)r=Gr(4);r._W(2,e.ich||0);r._W(2,e.ifnt||0);return r}function _t(e,r){var t=e.l;var a=e._R(1);var n=Et(e);var i=[];var s={t:n,h:n};if((a&1)!==0){var f=e._R(4);for(var o=0;o!=f;++o)i.push(St(e));s.r=i}else s.r=[{ich:0,ifnt:0}];e.l=t+r;return s}function Bt(e,r){var t=false;if(r==null){t=true;r=Gr(15+4*e.t.length)}r._W(1,0);kt(e.t,r);return t?r.slice(0,r.l):r}var Tt=_t;function yt(e,r){var t=false;if(r==null){t=true;r=Gr(23+4*e.t.length)}r._W(1,1);kt(e.t,r);r._W(4,1);At({ich:0,ifnt:0},r);return t?r.slice(0,r.l):r}function xt(e){var r=e._R(4);var t=e._R(2);t+=e._R(1)<<16;e.l++;return{c:r,iStyleRef:t}}function It(e,r){if(r==null)r=Gr(8);r._W(-4,e.c);r._W(3,e.iStyleRef||e.s);r._W(1,0);return r}var Rt=Et;var Dt=kt;function Ot(e){var r=e._R(4);return r===0||r===4294967295?"":e._R(r,"dbcs")}function Ft(e,r){var t=false;if(r==null){t=true;r=Gr(127)}r._W(4,e.length>0?e.length:4294967295);if(e.length>0)r._W(0,e,"dbcs");return t?r.slice(0,r.l):r}var Pt=Et;var Nt=Ot;var Lt=Ft;function Mt(e){var r=e.slice(e.l,e.l+4);var t=r[0]&1,a=r[0]&2;e.l+=4;r[0]&=252;var n=a===0?yr([0,0,0,0,r[0],r[1],r[2],r[3]],0):Pr(r,0)>>2;return t?n/100:n}function Ut(e,r){if(r==null)r=Gr(4);var t=0,a=0,n=e*100;if(e==(e|0)&&e>=-(1<<29)&&e<1<<29){a=1}else if(n==(n|0)&&n>=-(1<<29)&&n<1<<29){a=1;t=1}if(a)r._W(-4,((t?n:e)<<2)+(t+2));else throw new Error("unsupported RkNumber "+e)}function Ht(e){var r={s:{},e:{}};r.s.r=e._R(4);r.e.r=e._R(4);r.s.c=e._R(4);r.e.c=e._R(4);return r}function Wt(e,r){if(!r)r=Gr(16);r._W(4,e.s.r);r._W(4,e.e.r);r._W(4,e.s.c);r._W(4,e.e.c);return r}var Vt=Ht;var zt=Wt;function Xt(e){return e._R(8,"f")}function Gt(e,r){return(r||Gr(8))._W(8,e,"f")}var jt={0:"#NULL!",7:"#DIV/0!",15:"#VALUE!",23:"#REF!",29:"#NAME?",36:"#NUM!",42:"#N/A",43:"#GETTING_DATA",255:"#WTF?"};var Kt=Z(jt);function Yt(e){var r={};var t=e._R(1);var a=t>>>1;var n=e._R(1);var i=e._R(2,"i");var s=e._R(1);var f=e._R(1);var o=e._R(1);e.l++;switch(a){case 0:r.auto=1;break;case 1:r.index=n;var l=ka[n];if(l)r.rgb=Yf(l);break;case 2:r.rgb=Yf([s,f,o]);break;case 3:r.theme=n;break;}if(i!=0)r.tint=i>0?i/32767:i/32768;return r}function $t(e,r){if(!r)r=Gr(8);if(!e||e.auto){r._W(4,0);r._W(4,0);return r}if(e.index){r._W(1,2);r._W(1,e.index)}else if(e.theme){r._W(1,6);r._W(1,e.theme)}else{r._W(1,5);r._W(1,0)}var t=e.tint||0;if(t>0)t*=32767;else if(t<0)t*=32768;r._W(2,t);if(!e.rgb){r._W(2,0);r._W(1,0);r._W(1,0)}else{var a=e.rgb||"FFFFFF";r._W(1,parseInt(a.slice(0,2),16));r._W(1,parseInt(a.slice(2,4),16));r._W(1,parseInt(a.slice(4,6),16));r._W(1,255)}return r}function Zt(e){var r=e._R(1);e.l++;var t={fItalic:r&2,fStrikeout:r&8,fOutline:r&16,fShadow:r&32,fCondense:r&64,fExtend:r&128};return t}function Qt(e,r){if(!r)r=Gr(2);var t=(e.italic?2:0)|(e.strike?8:0)|(e.outline?16:0)|(e.shadow?32:0)|(e.condense?64:0)|(e.extend?128:0);r._W(1,t);r._W(1,0);return r}function Jt(e,r){var t={2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"};var a=e._R(4);switch(a){case 0:return"";case 4294967295:;case 4294967294:return t[e._R(4)]||"";}if(a>400)throw new Error("Unsupported Clipboard: "+a.toString(16));e.l-=4;return e._R(0,r==1?"lpstr":"lpwstr")}function qt(e){return Jt(e,1)}function ea(e){return Jt(e,2)}var ra=2;var ta=3;var aa=11;var na=12;var ia=19;var sa=30;var fa=64;var oa=65;var la=71;var ca=4096;var ha=80;var ua=81;var da=[ha,ua];var pa={1:{n:"CodePage",t:ra},2:{n:"Category",t:ha},3:{n:"PresentationFormat",t:ha},4:{n:"ByteCount",t:ta},5:{n:"LineCount",t:ta},6:{n:"ParagraphCount",t:ta},7:{n:"SlideCount",t:ta},8:{n:"NoteCount",t:ta},9:{n:"HiddenCount",t:ta},10:{n:"MultimediaClipCount",t:ta},11:{n:"ScaleCrop",t:aa},12:{n:"HeadingPairs",t:ca|na},13:{n:"TitlesOfParts",t:ca|sa},14:{n:"Manager",t:ha},15:{n:"Company",t:ha},16:{n:"LinksUpToDate",t:aa},17:{n:"CharacterCount",t:ta},19:{n:"SharedDoc",t:aa},22:{n:"HyperlinksChanged",t:aa},23:{n:"AppVersion",t:ta,p:"version"},24:{n:"DigSig",t:oa},26:{n:"ContentType",t:ha},27:{n:"ContentStatus",t:ha},28:{n:"Language",t:ha},29:{n:"Version",t:ha},255:{}};var va={1:{n:"CodePage",t:ra},2:{n:"Title",t:ha},3:{n:"Subject",t:ha},4:{n:"Author",t:ha},5:{n:"Keywords",t:ha},6:{n:"Comments",t:ha},7:{n:"Template",t:ha},8:{n:"LastAuthor",t:ha},9:{n:"RevNumber",t:ha},10:{n:"EditTime",t:fa},11:{n:"LastPrinted",t:fa},12:{n:"CreatedDate",t:fa},13:{n:"ModifiedDate",t:fa},14:{n:"PageCount",t:ta},15:{n:"WordCount",t:ta},16:{n:"CharCount",t:ta},17:{n:"Thumbnail",t:la},18:{n:"Application",t:ha},19:{n:"DocSecurity",t:ta},255:{}};var ga={2147483648:{n:"Locale",t:ia},2147483651:{n:"Behavior",t:ia},1919054434:{}};(function(){for(var e in ga)if(ga.hasOwnProperty(e))pa[e]=va[e]=ga[e]})();var ma=K(pa,"n");var ba=K(va,"n");var wa={1:"US",2:"CA",3:"",7:"RU",20:"EG",30:"GR",31:"NL",32:"BE",33:"FR",34:"ES",36:"HU",39:"IT",41:"CH",43:"AT",44:"GB",45:"DK",46:"SE",47:"NO",48:"PL",49:"DE",52:"MX",55:"BR",61:"AU",64:"NZ",66:"TH",81:"JP",82:"KR",84:"VN",86:"CN",90:"TR",105:"JS",213:"DZ",216:"MA",218:"LY",351:"PT",354:"IS",358:"FI",420:"CZ",886:"TW",961:"LB",962:"JO",963:"SY",964:"IQ",965:"KW",966:"SA",971:"AE",972:"IL",974:"QA",981:"IR",65535:"US"};var Ca=[null,"solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];function Ea(e){return e.map(function(e){return[e>>16&255,e>>8&255,e&255]})}var ka=Ea([0,16777215,16711680,65280,255,16776960,16711935,65535,0,16777215,16711680,65280,255,16776960,16711935,65535,8388608,32768,128,8421376,8388736,32896,12632256,8421504,10066431,10040166,16777164,13434879,6684774,16744576,26316,13421823,128,16711935,16776960,65535,8388736,8388608,32896,255,52479,13434879,13434828,16777113,10079487,16751052,13408767,16764057,3368703,3394764,10079232,16763904,16750848,16737792,6710937,9868950,13158,3381606,13056,3355392,10040064,10040166,3355545,3355443,16777215,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);var Sa={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":"workbooks","application/vnd.ms-excel.binIndexWs":"TODO","application/vnd.ms-excel.intlmacrosheet":"TODO","application/vnd.ms-excel.binIndexMs":"TODO","application/vnd.openxmlformats-package.core-properties+xml":"coreprops","application/vnd.openxmlformats-officedocument.custom-properties+xml":"custprops","application/vnd.openxmlformats-officedocument.extended-properties+xml":"extprops","application/vnd.openxmlformats-officedocument.customXmlProperties+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty":"TODO","application/vnd.ms-excel.pivotTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml":"TODO","application/vnd.ms-office.chartcolorstyle+xml":"TODO","application/vnd.ms-office.chartstyle+xml":"TODO","application/vnd.ms-excel.calcChain":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings":"TODO","application/vnd.ms-office.activeX":"TODO","application/vnd.ms-office.activeX+xml":"TODO","application/vnd.ms-excel.attachedToolbars":"TODO","application/vnd.ms-excel.connections":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":"TODO","application/vnd.ms-excel.externalLink":"links","application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml":"links","application/vnd.ms-excel.sheetMetadata":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml":"TODO","application/vnd.ms-excel.pivotCacheDefinition":"TODO","application/vnd.ms-excel.pivotCacheRecords":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml":"TODO","application/vnd.ms-excel.queryTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml":"TODO","application/vnd.ms-excel.userNames":"TODO","application/vnd.ms-excel.revisionHeaders":"TODO","application/vnd.ms-excel.revisionLog":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml":"TODO","application/vnd.ms-excel.tableSingleCells":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml":"TODO","application/vnd.ms-excel.slicer":"TODO","application/vnd.ms-excel.slicerCache":"TODO","application/vnd.ms-excel.slicer+xml":"TODO","application/vnd.ms-excel.slicerCache+xml":"TODO","application/vnd.ms-excel.wsSortMap":"TODO","application/vnd.ms-excel.table":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":"TODO","application/vnd.openxmlformats-officedocument.theme+xml":"themes","application/vnd.openxmlformats-officedocument.themeOverride+xml":"TODO","application/vnd.ms-excel.Timeline+xml":"TODO","application/vnd.ms-excel.TimelineCache+xml":"TODO","application/vnd.ms-office.vbaProject":"vba","application/vnd.ms-office.vbaProjectSignature":"vba","application/vnd.ms-office.volatileDependencies":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml":"TODO","application/vnd.ms-excel.controlproperties+xml":"TODO","application/vnd.openxmlformats-officedocument.model+data":"TODO","application/vnd.ms-excel.Survey+xml":"TODO","application/vnd.openxmlformats-officedocument.drawing+xml":"drawings","application/vnd.openxmlformats-officedocument.drawingml.chart+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml":"TODO","application/vnd.openxmlformats-officedocument.vmlDrawing":"TODO","application/vnd.openxmlformats-package.relationships+xml":"rels","application/vnd.openxmlformats-officedocument.oleObject":"TODO","image/png":"TODO",sheet:"js"};var Aa=function(){var e={workbooks:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",xlsm:"application/vnd.ms-excel.sheet.macroEnabled.main+xml",xlsb:"application/vnd.ms-excel.sheet.binary.macroEnabled.main",xlam:"application/vnd.ms-excel.addin.macroEnabled.main+xml",xltx:"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"},strs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",xlsb:"application/vnd.ms-excel.sharedStrings"},comments:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",xlsb:"application/vnd.ms-excel.comments"},sheets:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",xlsb:"application/vnd.ms-excel.worksheet"},charts:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",xlsb:"application/vnd.ms-excel.chartsheet"},dialogs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",xlsb:"application/vnd.ms-excel.dialogsheet"},macros:{xlsx:"application/vnd.ms-excel.macrosheet+xml",xlsb:"application/vnd.ms-excel.macrosheet"},styles:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",xlsb:"application/vnd.ms-excel.styles"}};j(e).forEach(function(r){["xlsm","xlam"].forEach(function(t){if(!e[r][t])e[r][t]=e[r].xlsx})});j(e).forEach(function(r){j(e[r]).forEach(function(t){Sa[e[r][t]]=r})});return e}();var _a=Q(Sa);sr.CT="http://schemas.openxmlformats.org/package/2006/content-types";function Ba(){return{workbooks:[],sheets:[],charts:[],dialogs:[],macros:[],rels:[],strs:[],comments:[],links:[],coreprops:[],extprops:[],custprops:[],themes:[],styles:[],calcchains:[],vba:[],drawings:[],TODO:[],xmlns:""}}function Ta(e){var r=Ba();if(!e||!e.match)return r;var t={};(e.match(_e)||[]).forEach(function(e){var a=ye(e);switch(a[0].replace(Be,"<")){case"<?xml":break;case"<Types":r.xmlns=a["xmlns"+(a[0].match(/<(\w+):/)||["",""])[1]];break;case"<Default":t[a.Extension]=a.ContentType;break;case"<Override":if(r[Sa[a.ContentType]]!==undefined)r[Sa[a.ContentType]].push(a.PartName);break;}});if(r.xmlns!==sr.CT)throw new Error("Unknown Namespace: "+r.xmlns);r.calcchain=r.calcchains.length>0?r.calcchains[0]:"";r.sst=r.strs.length>0?r.strs[0]:"";r.style=r.styles.length>0?r.styles[0]:"";r.defaults=t;delete r.calcchains;return r}var ya=ar("Types",null,{xmlns:sr.CT,"xmlns:xsd":sr.xsd,"xmlns:xsi":sr.xsi});var xa=[["xml","application/xml"],["bin","application/vnd.ms-excel.sheet.binary.macroEnabled.main"],["vml","application/vnd.openxmlformats-officedocument.vmlDrawing"],["bmp","image/bmp"],["png","image/png"],["gif","image/gif"],["emf","image/x-emf"],["wmf","image/x-wmf"],["jpg","image/jpeg"],["jpeg","image/jpeg"],["tif","image/tiff"],["tiff","image/tiff"],["pdf","application/pdf"],["rels",_a.rels[0]]].map(function(e){return ar("Default",null,{Extension:e[0],ContentType:e[1]})});function Ia(e,r){var t=[],a;t[t.length]=Se;t[t.length]=ya;t=t.concat(xa);var n=function(n){if(e[n]&&e[n].length>0){a=e[n][0];t[t.length]=ar("Override",null,{PartName:(a[0]=="/"?"":"/")+a,ContentType:Aa[n][r.bookType||"xlsx"]})}};var i=function(a){(e[a]||[]).forEach(function(e){t[t.length]=ar("Override",null,{PartName:(e[0]=="/"?"":"/")+e,ContentType:Aa[a][r.bookType||"xlsx"]})})};var s=function(r){(e[r]||[]).forEach(function(e){t[t.length]=ar("Override",null,{PartName:(e[0]=="/"?"":"/")+e,ContentType:_a[r][0]})})};n("workbooks");i("sheets");i("charts");s("themes");["strs","styles"].forEach(n);["coreprops","extprops","custprops"].forEach(s);s("vba");s("comments");s("drawings");if(t.length>2){t[t.length]="</Types>";t[1]=t[1].replace("/>",">")}return t.join("")}var Ra={WB:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",SHEET:"http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",HLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",VML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",VBA:"http://schemas.microsoft.com/office/2006/relationships/vbaProject"};function Da(e){var r=e.lastIndexOf("/");return e.slice(0,r+1)+"_rels/"+e.slice(r+1)+".rels"}function Oa(e,r){if(!e)return e;if(r.charAt(0)!=="/"){r="/"+r}var t={};var a={};(e.match(_e)||[]).forEach(function(e){var n=ye(e);if(n[0]==="<Relationship"){var i={};i.Type=n.Type;i.Target=n.Target;i.Id=n.Id;i.TargetMode=n.TargetMode;var s=n.TargetMode==="External"?n.Target:ke(n.Target,r);t[s]=i;a[n.Id]=i}});t["!id"]=a;return t}sr.RELS="http://schemas.openxmlformats.org/package/2006/relationships";var Fa=ar("Relationships",null,{xmlns:sr.RELS});function Pa(e){var r=[Se,Fa];j(e["!id"]).forEach(function(t){r[r.length]=ar("Relationship",null,e["!id"][t])});if(r.length>2){r[r.length]="</Relationships>";r[1]=r[1].replace("/>",">")}return r.join("")}function Na(e,r,t,a,n){if(!n)n={};if(!e["!id"])e["!id"]={};if(r<0)for(r=1;e["!id"]["rId"+r];++r){}n.Id="rId"+r;n.Type=a;n.Target=t;if(n.Type==Ra.HLINK)n.TargetMode="External";if(e["!id"][n.Id])throw new Error("Cannot rewrite rId "+r);e["!id"][n.Id]=n;e[("/"+n.Target).replace("//","/")]=n;return r}var La="application/vnd.oasis.opendocument.spreadsheet";function Ma(e,r){var t=Mp(e);var a;var n;while(a=Up.exec(t))switch(a[3]){case"manifest":break;case"file-entry":n=ye(a[0],false);if(n.path=="/"&&n.type!==La)throw new Error("This OpenDocument is not a spreadsheet");break;case"encryption-data":;case"algorithm":;case"start-key-generation":;case"key-derivation":throw new Error("Unsupported ODS Encryption");default:if(r&&r.WTF)throw a;}}function Ua(e){var r=[Se];r.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');r.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');for(var t=0;t<e.length;++t)r.push('  <manifest:file-entry manifest:full-path="'+e[t][0]+'" manifest:media-type="'+e[t][1]+'"/>\n');r.push("</manifest:manifest>");return r.join("")}function Ha(e,r,t){return['  <rdf:Description rdf:about="'+e+'">\n','    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/'+(t||"odf")+"#"+r+'"/>\n',"  </rdf:Description>\n"].join("")}function Wa(e,r){return['  <rdf:Description rdf:about="'+e+'">\n','    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="'+r+'"/>\n',"  </rdf:Description>\n"].join("")}function Va(e){var r=[Se];r.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');for(var t=0;t!=e.length;++t){r.push(Ha(e[t][0],e[t][1]));r.push(Wa("",e[t][0]))}r.push(Ha("","Document","pkg"));r.push("</rdf:RDF>");return r.join("")}var za=function(){var r='<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet'+"JS "+e.version+"</meta:generator></office:meta></office:document-meta>";return function t(){return r}}();var Xa=[["cp:category","Category"],["cp:contentStatus","ContentStatus"],["cp:keywords","Keywords"],["cp:lastModifiedBy","LastAuthor"],["cp:lastPrinted","LastPrinted"],["cp:revision","RevNumber"],["cp:version","Version"],["dc:creator","Author"],["dc:description","Comments"],["dc:identifier","Identifier"],["dc:language","Language"],["dc:subject","Subject"],["dc:title","Title"],["dcterms:created","CreatedDate","date"],["dcterms:modified","ModifiedDate","date"]];sr.CORE_PROPS="http://schemas.openxmlformats.org/package/2006/metadata/core-properties";Ra.CORE_PROPS="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties";var Ga=function(){var e=new Array(Xa.length);for(var r=0;r<Xa.length;++r){var t=Xa[r];var a="(?:"+t[0].slice(0,t[0].indexOf(":"))+":)"+t[0].slice(t[0].indexOf(":")+1);e[r]=new RegExp("<"+a+"[^>]*>([\\s\\S]*?)</"+a+">")}return e}();function ja(e){var r={};e=ze(e);for(var t=0;t<Xa.length;++t){var a=Xa[t],n=e.match(Ga[t]);if(n!=null&&n.length>0)r[a[1]]=n[1];if(a[2]==="date"&&r[a[1]])r[a[1]]=ie(r[a[1]])}return r}var Ka=ar("cp:coreProperties",null,{"xmlns:cp":sr.CORE_PROPS,"xmlns:dc":sr.dc,"xmlns:dcterms":sr.dcterms,"xmlns:dcmitype":sr.dcmitype,"xmlns:xsi":sr.xsi});function Ya(e,r,t,a,n){if(n[e]!=null||r==null||r==="")return;n[e]=r;a[a.length]=t?ar(e,r,t):rr(e,r)}function $a(e,r){var t=r||{};var a=[Se,Ka],n={};if(!e&&!t.Props)return a.join("");if(e){if(e.CreatedDate!=null)Ya("dcterms:created",typeof e.CreatedDate==="string"?e.CreatedDate:nr(e.CreatedDate,t.WTF),{"xsi:type":"dcterms:W3CDTF"},a,n);if(e.ModifiedDate!=null)Ya("dcterms:modified",typeof e.ModifiedDate==="string"?e.ModifiedDate:nr(e.ModifiedDate,t.WTF),{"xsi:type":"dcterms:W3CDTF"},a,n)}for(var i=0;i!=Xa.length;++i){var s=Xa[i];var f=t.Props&&t.Props[s[1]]!=null?t.Props[s[1]]:e?e[s[1]]:null;if(f===true)f="1";else if(f===false)f="0";else if(typeof f=="number")f=String(f);if(f!=null)Ya(s[0],f,null,a,n)}if(a.length>2){a[a.length]="</cp:coreProperties>";a[1]=a[1].replace("/>",">")}return a.join("")}var Za=[["Application","Application","string"],["AppVersion","AppVersion","string"],["Company","Company","string"],["DocSecurity","DocSecurity","string"],["Manager","Manager","string"],["HyperlinksChanged","HyperlinksChanged","bool"],["SharedDoc","SharedDoc","bool"],["LinksUpToDate","LinksUpToDate","bool"],["ScaleCrop","ScaleCrop","bool"],["HeadingPairs","HeadingPairs","raw"],["TitlesOfParts","TitlesOfParts","raw"]];sr.EXT_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";Ra.EXT_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties";var Qa=["Worksheets","SheetNames","NamedRanges","DefinedNames","Chartsheets","ChartNames"];function Ja(e,r,t,a){var n=[];if(typeof e=="string")n=qe(e,a);else for(var i=0;i<e.length;++i)n=n.concat(e[i].map(function(e){return{v:e}}));var s=typeof r=="string"?qe(r,a).map(function(e){return e.v}):r;var f=0,o=0;if(s.length>0)for(var l=0;l!==n.length;l+=2){o=+n[l+1].v;switch(n[l].v){case"Worksheets":;case"工作表":;case"Листы":;case"أوراق العمل":;case"ワークシート":;case"גליונות עבודה":;case"Arbeitsblätter":;case"Çalışma Sayfaları":;case"Feuilles de calcul":;case"Fogli di lavoro":;case"Folhas de cálculo":;case"Planilhas":;case"Regneark":;case"Werkbladen":t.Worksheets=o;t.SheetNames=s.slice(f,f+o);break;case"Named Ranges":;case"名前付き一覧":;case"Benannte Bereiche":;case"Navngivne områder":t.NamedRanges=o;t.DefinedNames=s.slice(f,f+o);break;case"Charts":;case"Diagramme":t.Chartsheets=o;t.ChartNames=s.slice(f,f+o);break;}f+=o}}function qa(e,r,t){var a={};if(!r)r={};e=ze(e);Za.forEach(function(t){switch(t[2]){case"string":r[t[1]]=(e.match(Ye(t[0]))||[])[1];break;case"bool":r[t[1]]=(e.match(Ye(t[0]))||[])[1]==="true";break;case"raw":var n=e.match(new RegExp("<"+t[0]+"[^>]*>([\\s\\S]*?)</"+t[0]+">"));if(n&&n.length>0)a[t[1]]=n[1];break;}});if(a.HeadingPairs&&a.TitlesOfParts)Ja(a.HeadingPairs,a.TitlesOfParts,r,t);return r}var en=ar("Properties",null,{xmlns:sr.EXT_PROPS,"xmlns:vt":sr.vt});function rn(e){var r=[],t=ar;if(!e)e={};e.Application="SheetJS";r[r.length]=Se;r[r.length]=en;Za.forEach(function(a){if(e[a[1]]===undefined)return;var n;switch(a[2]){case"string":n=String(e[a[1]]);break;case"bool":n=e[a[1]]?"true":"false";break;}if(n!==undefined)r[r.length]=t(a[0],n)});r[r.length]=t("HeadingPairs",t("vt:vector",t("vt:variant","<vt:lpstr>Worksheets</vt:lpstr>")+t("vt:variant",t("vt:i4",String(e.Worksheets))),{size:2,baseType:"variant"}));r[r.length]=t("TitlesOfParts",t("vt:vector",e.SheetNames.map(function(e){return"<vt:lpstr>"+Pe(e)+"</vt:lpstr>"}).join(""),{size:e.Worksheets,baseType:"lpstr"}));if(r.length>2){r[r.length]="</Properties>";r[1]=r[1].replace("/>",">")}return r.join("")}sr.CUST_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";Ra.CUST_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties";var tn=/<[^>]+>[^<]*/g;function an(e,r){var t={},a="";var n=e.match(tn);if(n)for(var i=0;i!=n.length;++i){var s=n[i],f=ye(s);switch(f[0]){case"<?xml":break;case"<Properties":break;case"<property":a=f.name;break;case"</property>":a=null;break;default:if(s.indexOf("<vt:")===0){var o=s.split(">");var l=o[0].slice(4),c=o[1];switch(l){case"lpstr":;case"bstr":;case"lpwstr":t[a]=De(c);break;case"bool":t[a]=Ve(c);break;case"i1":;case"i2":;case"i4":;case"i8":;case"int":;case"uint":
t[a]=parseInt(c,10);break;case"r4":;case"r8":;case"decimal":t[a]=parseFloat(c);break;case"filetime":;case"date":t[a]=ie(c);break;case"cy":;case"error":t[a]=De(c);break;default:if(l.slice(-1)=="/")break;if(r.WTF&&typeof console!=="undefined")console.warn("Unexpected",s,l,o);}}else if(s.slice(0,2)==="</"){}else if(r.WTF)throw new Error(s);}}return t}var nn=ar("Properties",null,{xmlns:sr.CUST_PROPS,"xmlns:vt":sr.vt});function sn(e){var r=[Se,nn];if(!e)return r.join("");var t=1;j(e).forEach(function a(n){++t;r[r.length]=ar("property",ir(e[n]),{fmtid:"{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",pid:t,name:n})});if(r.length>2){r[r.length]="</Properties>";r[1]=r[1].replace("/>",">")}return r.join("")}var fn={Title:"Title",Subject:"Subject",Author:"Author",Keywords:"Keywords",Comments:"Description",LastAuthor:"LastAuthor",RevNumber:"Revision",Application:"AppName",LastPrinted:"LastPrinted",CreatedDate:"Created",ModifiedDate:"LastSaved",Category:"Category",Manager:"Manager",Company:"Company",AppVersion:"Version",ContentStatus:"ContentStatus",Identifier:"Identifier",Language:"Language"};var on=Y(fn);function ln(e,r,t){r=on[r]||r;e[r]=t}function cn(e,r){var t=[];j(fn).map(function(e){for(var r=0;r<Xa.length;++r)if(Xa[r][1]==e)return Xa[r];for(r=0;r<Za.length;++r)if(Za[r][1]==e)return Za[r];throw e}).forEach(function(a){if(e[a[1]]==null)return;var n=r&&r.Props&&r.Props[a[1]]!=null?r.Props[a[1]]:e[a[1]];switch(a[2]){case"date":n=new Date(n).toISOString().replace(/\.\d*Z/,"Z");break;}if(typeof n=="number")n=String(n);else if(n===true||n===false){n=n?"1":"0"}else if(n instanceof Date)n=new Date(n).toISOString().replace(/\.\d*Z/,"");t.push(rr(fn[a[1]]||a[1],n))});return ar("DocumentProperties",t.join(""),{xmlns:fr.o})}function hn(e,r){var t=["Worksheets","SheetNames"];var a="CustomDocumentProperties";var n=[];if(e)j(e).forEach(function(r){if(!e.hasOwnProperty(r))return;for(var a=0;a<Xa.length;++a)if(r==Xa[a][1])return;for(a=0;a<Za.length;++a)if(r==Za[a][1])return;for(a=0;a<t.length;++a)if(r==t[a])return;var i=e[r];var s="string";if(typeof i=="number"){s="float";i=String(i)}else if(i===true||i===false){s="boolean";i=i?"1":"0"}else i=String(i);n.push(ar(Ne(r),i,{"dt:dt":s}))});if(r)j(r).forEach(function(t){if(!r.hasOwnProperty(t))return;if(e&&e.hasOwnProperty(t))return;var a=r[t];var i="string";if(typeof a=="number"){i="float";a=String(a)}else if(a===true||a===false){i="boolean";a=a?"1":"0"}else if(a instanceof Date){i="dateTime.tz";a=a.toISOString()}else a=String(a);n.push(ar(Ne(t),a,{"dt:dt":i}))});return"<"+a+' xmlns="'+fr.o+'">'+n.join("")+"</"+a+">"}function un(e){var r=e._R(4),t=e._R(4);return new Date((t/1e7*Math.pow(2,32)+r/1e7-11644473600)*1e3).toISOString().replace(/\.000/,"")}function dn(e){var r=typeof e=="string"?new Date(Date.parse(e)):e;var t=r.getTime()/1e3+11644473600;var a=t%Math.pow(2,32),n=(t-a)/Math.pow(2,32);a*=1e7;n*=1e7;var i=a/Math.pow(2,32)|0;if(i>0){a=a%Math.pow(2,32);n+=i}var s=Gr(8);s._W(4,a);s._W(4,n);return s}function pn(e,r,t){var a=e.l;var n=e._R(0,"lpstr-cp");if(t)while(e.l-a&3)++e.l;return n}function vn(e,r,t){var a=e._R(0,"lpwstr");if(t)e.l+=4-(a.length+1&3)&3;return a}function gn(e,r,t){if(r===31)return vn(e);return pn(e,r,t)}function mn(e,r,t){return gn(e,r,t===false?0:4)}function bn(e,r){if(!r)throw new Error("VtUnalignedString must have positive length");return gn(e,r,0)}function wn(e){var r=e._R(4);var t=[];for(var a=0;a!=r;++a)t[a]=e._R(0,"lpstr-cp").replace(I,"");return t}function Cn(e){return wn(e)}function En(e){var r=Tn(e,ua);var t=Tn(e,ta);return[r,t]}function kn(e){var r=e._R(4);var t=[];for(var a=0;a!=r/2;++a)t.push(En(e));return t}function Sn(e){return kn(e)}function An(e,r){var t=e._R(4);var a={};for(var n=0;n!=t;++n){var i=e._R(4);var s=e._R(4);a[i]=e._R(s,r===1200?"utf16le":"utf8").replace(I,"").replace(R,"!");if(r===1200&&s%2)e.l+=2}if(e.l&3)e.l=e.l>>2+1<<2;return a}function _n(e){var r=e._R(4);var t=e.slice(e.l,e.l+r);e.l+=r;if((r&3)>0)e.l+=4-(r&3)&3;return t}function Bn(e){var r={};r.Size=e._R(4);e.l+=r.Size+3-(r.Size-1)%4;return r}function Tn(e,r,t){var a=e._R(2),n,i=t||{};e.l+=2;if(r!==na)if(a!==r&&da.indexOf(r)===-1)throw new Error("Expected type "+r+" saw "+a);switch(r===na?a:r){case 2:n=e._R(2,"i");if(!i.raw)e.l+=2;return n;case 3:n=e._R(4,"i");return n;case 11:return e._R(4)!==0;case 19:n=e._R(4);return n;case 30:return pn(e,a,4).replace(I,"");case 31:return vn(e);case 64:return un(e);case 65:return _n(e);case 71:return Bn(e);case 80:return mn(e,a,!i.raw).replace(I,"");case 81:return bn(e,a).replace(I,"");case 4108:return Sn(e);case 4126:return Cn(e);default:throw new Error("TypedPropertyValue unrecognized type "+r+" "+a);}}function yn(e,r){var t=Gr(4),a=Gr(4);t._W(4,e==80?31:e);switch(e){case 3:a._W(-4,r);break;case 5:a=Gr(8);a._W(8,r,"f");break;case 11:a._W(4,r?1:0);break;case 64:a=dn(r);break;case 31:;case 80:a=Gr(4+2*(r.length+1)+(r.length%2?0:2));a._W(4,r.length+1);a._W(0,r,"dbcs");while(a.l!=a.length)a._W(1,0);break;default:throw new Error("TypedPropertyValue unrecognized type "+e+" "+r);}return x([t,a])}function xn(e,r){var t=e.l;var a=e._R(4);var n=e._R(4);var i=[],s=0;var f=0;var l=-1,c={};for(s=0;s!=n;++s){var h=e._R(4);var u=e._R(4);i[s]=[h,u+t]}i.sort(function(e,r){return e[1]-r[1]});var d={};for(s=0;s!=n;++s){if(e.l!==i[s][1]){var p=true;if(s>0&&r)switch(r[i[s-1][0]].t){case 2:if(e.l+2===i[s][1]){e.l+=2;p=false}break;case 80:if(e.l<=i[s][1]){e.l=i[s][1];p=false}break;case 4108:if(e.l<=i[s][1]){e.l=i[s][1];p=false}break;}if((!r||s==0)&&e.l<=i[s][1]){p=false;e.l=i[s][1]}if(p)throw new Error("Read Error: Expected address "+i[s][1]+" at "+e.l+" :"+s)}if(r){var v=r[i[s][0]];d[v.n]=Tn(e,v.t,{raw:true});if(v.p==="version")d[v.n]=String(d[v.n]>>16)+"."+("0000"+String(d[v.n]&65535)).slice(-4);if(v.n=="CodePage")switch(d[v.n]){case 0:d[v.n]=1252;case 874:;case 932:;case 936:;case 949:;case 950:;case 1250:;case 1251:;case 1253:;case 1254:;case 1255:;case 1256:;case 1257:;case 1258:;case 1e4:;case 1200:;case 1201:;case 1252:;case 65e3:;case-536:;case 65001:;case-535:o(f=d[v.n]>>>0&65535);break;default:throw new Error("Unsupported CodePage: "+d[v.n]);}}else{if(i[s][0]===1){f=d.CodePage=Tn(e,ra);o(f);if(l!==-1){var g=e.l;e.l=i[l][1];c=An(e,f);e.l=g}}else if(i[s][0]===0){if(f===0){l=s;e.l=i[s+1][1];continue}c=An(e,f)}else{var m=c[i[s][0]];var b;switch(e[e.l]){case 65:e.l+=4;b=_n(e);break;case 30:e.l+=4;b=mn(e,e[e.l-4]).replace(/\u0000+$/,"");break;case 31:e.l+=4;b=mn(e,e[e.l-4]).replace(/\u0000+$/,"");break;case 3:e.l+=4;b=e._R(4,"i");break;case 19:e.l+=4;b=e._R(4);break;case 5:e.l+=4;b=e._R(8,"f");break;case 11:e.l+=4;b=Mn(e,4);break;case 64:e.l+=4;b=ie(un(e));break;default:throw new Error("unparsed value: "+e[e.l]);}d[m]=b}}}e.l=t+a;return d}var In=["CodePage","Thumbnail","_PID_LINKBASE","_PID_HLINKS","SystemIdentifier","FMTID"].concat(Qa);function Rn(e){switch(typeof e){case"boolean":return 11;case"number":return(e|0)==e?3:5;case"string":return 31;case"object":if(e instanceof Date)return 64;break;}return-1}function Dn(e,r,t){var a=Gr(8),n=[],i=[];var s=8,f=0;var o=Gr(8),l=Gr(8);o._W(4,2);o._W(4,1200);l._W(4,1);i.push(o);n.push(l);s+=8+o.length;if(!r){l=Gr(8);l._W(4,0);n.unshift(l);var c=[Gr(4)];c[0]._W(4,e.length);for(f=0;f<e.length;++f){var h=e[f][0];o=Gr(4+4+2*(h.length+1)+(h.length%2?0:2));o._W(4,f+2);o._W(4,h.length+1);o._W(0,h,"dbcs");while(o.l!=o.length)o._W(1,0);c.push(o)}o=x(c);i.unshift(o);s+=8+o.length}for(f=0;f<e.length;++f){if(r&&!r[e[f][0]])continue;if(In.indexOf(e[f][0])>-1)continue;if(e[f][1]==null)continue;var u=e[f][1],d=0;if(r){d=+r[e[f][0]];var p=t[d];if(p.p=="version"&&typeof u=="string"){var v=u.split(".");u=(+v[0]<<16)+(+v[1]||0)}o=yn(p.t,u)}else{var g=Rn(u);if(g==-1){g=31;u=String(u)}o=yn(g,u)}i.push(o);l=Gr(8);l._W(4,!r?2+f:d);n.push(l);s+=8+o.length}var m=8*(i.length+1);for(f=0;f<i.length;++f){n[f]._W(4,m);m+=i[f].length}a._W(4,s);a._W(4,i.length);return x([a].concat(n).concat(i))}function On(e,r,t){var a=e.content;if(!a)return{};zr(a,0);var n,i,s,f,o=0;a.chk("feff","Byte Order: ");a._R(2);var l=a._R(4);var c=a._R(16);if(c!==W.utils.consts.HEADER_CLSID&&c!==t)throw new Error("Bad PropertySet CLSID "+c);n=a._R(4);if(n!==1&&n!==2)throw new Error("Unrecognized #Sets: "+n);i=a._R(16);f=a._R(4);if(n===1&&f!==a.l)throw new Error("Length mismatch: "+f+" !== "+a.l);else if(n===2){s=a._R(16);o=a._R(4)}var h=xn(a,r);var u={SystemIdentifier:l};for(var d in h)u[d]=h[d];u.FMTID=i;if(n===1)return u;if(o-a.l==2)a.l+=2;if(a.l!==o)throw new Error("Length mismatch 2: "+a.l+" !== "+o);var p;try{p=xn(a,null)}catch(v){}for(d in p)u[d]=p[d];u.FMTID=[i,s];return u}function Fn(e,r,t,a,n,i){var s=Gr(n?68:48);var f=[s];s._W(2,65534);s._W(2,0);s._W(4,842412599);s._W(16,W.utils.consts.HEADER_CLSID,"hex");s._W(4,n?2:1);s._W(16,r,"hex");s._W(4,n?68:48);var o=Dn(e,t,a);f.push(o);if(n){var l=Dn(n,null,null);s._W(16,i,"hex");s._W(4,68+o.length);f.push(l)}return x(f)}function Pn(e,r){e._R(r);return null}function Nn(e,r){if(!r)r=Gr(e);for(var t=0;t<e;++t)r._W(1,0);return r}function Ln(e,r,t){var a=[],n=e.l+r;while(e.l<n)a.push(t(e,n-e.l));if(n!==e.l)throw new Error("Slurp error");return a}function Mn(e,r){return e._R(r)===1}function Un(e,r){if(!r)r=Gr(2);r._W(2,+!!e);return r}function Hn(e){return e._R(2,"u")}function Wn(e,r){if(!r)r=Gr(2);r._W(2,e);return r}function Vn(e,r){return Ln(e,r,Hn)}function zn(e){var r=e._R(1),t=e._R(1);return t===1?r:r===1}function Xn(e,r,t){if(!t)t=Gr(2);t._W(1,+e);t._W(1,r=="e"?1:0);return t}function Gn(e,t,a){var n=e._R(a&&a.biff>=12?2:1);var i="sbcs-cont";var s=r;if(a&&a.biff>=8)r=1200;if(!a||a.biff==8){var f=e._R(1);if(f){i="dbcs-cont"}}else if(a.biff==12){i="wstr"}if(a.biff>=2&&a.biff<=5)i="cpstr";var o=n?e._R(n,i):"";r=s;return o}function jn(e){var t=r;r=1200;var a=e._R(2),n=e._R(1);var i=n&4,s=n&8;var f=1+(n&1);var o=0,l;var c={};if(s)o=e._R(2);if(i)l=e._R(4);var h=f==2?"dbcs-cont":"sbcs-cont";var u=a===0?"":e._R(a,h);if(s)e.l+=4*o;if(i)e.l+=l;c.t=u;if(!s){c.raw="<t>"+c.t+"</t>";c.r=c.t}r=t;return c}function Kn(e,r,t){var a;if(t){if(t.biff>=2&&t.biff<=5)return e._R(r,"cpstr");if(t.biff>=12)return e._R(r,"dbcs-cont")}var n=e._R(1);if(n===0){a=e._R(r,"sbcs-cont")}else{a=e._R(r,"dbcs-cont")}return a}function Yn(e,r,t){var a=e._R(t&&t.biff==2?1:2);if(a===0){e.l++;return""}return Kn(e,a,t)}function $n(e,r,t){if(t.biff>5)return Yn(e,r,t);var a=e._R(1);if(a===0){e.l++;return""}return e._R(a,t.biff<=4||!e.lens?"cpstr":"sbcs-cont")}function Zn(e,r,t){if(!t)t=Gr(3+2*e.length);t._W(2,e.length);t._W(1,1);t._W(31,e,"utf16le");return t}function Qn(e){var r=e._R(1);e.l++;var t=e._R(2);e.l+=2;return[r,t]}function Jn(e){var r=e._R(4),t=e.l;var a=false;if(r>24){e.l+=r-24;if(e._R(16)==="795881f43b1d7f48af2c825dc4852763")a=true;e.l=t}var n=e._R((a?r-24:r)>>1,"utf16le").replace(I,"");if(a)e.l+=24;return n}function qn(e){e.l+=2;var r=e._R(0,"lpstr-ansi");e.l+=2;if(e._R(2)!=57005)throw new Error("Bad FileMoniker");var t=e._R(4);if(t===0)return r.replace(/\\/g,"/");var a=e._R(4);if(e._R(2)!=3)throw new Error("Bad FileMoniker");var n=e._R(a>>1,"utf16le").replace(I,"");return n}function ei(e,r){var t=e._R(16);r-=16;switch(t){case"e0c9ea79f9bace118c8200aa004ba90b":return Jn(e,r);case"0303000000000000c000000000000046":return qn(e,r);default:throw new Error("Unsupported Moniker "+t);}}function ri(e){var r=e._R(4);var t=r>0?e._R(r,"utf16le").replace(I,""):"";return t}function ti(e,r){var t=e.l+r;var a=e._R(4);if(a!==2)throw new Error("Unrecognized streamVersion: "+a);var n=e._R(2);e.l+=2;var i,s,f,o,l="",c,h;if(n&16)i=ri(e,t-e.l);if(n&128)s=ri(e,t-e.l);if((n&257)===257)f=ri(e,t-e.l);if((n&257)===1)o=ei(e,t-e.l);if(n&8)l=ri(e,t-e.l);if(n&32)c=e._R(16);if(n&64)h=un(e);e.l=t;var u=s||f||o||"";if(u&&l)u+="#"+l;if(!u)u="#"+l;var d={Target:u};if(c)d.guid=c;if(h)d.time=h;if(i)d.Tooltip=i;return d}function ai(e){var r=Gr(512),t=0;var a=e.Target;var n=a.indexOf("#")>-1?31:23;switch(a.charAt(0)){case"#":n=28;break;case".":n&=~2;break;}r._W(4,2);r._W(4,n);var i=[8,6815827,6619237,4849780,83];for(t=0;t<i.length;++t)r._W(4,i[t]);if(n==28){a=a.slice(1);r._W(4,a.length+1);for(t=0;t<a.length;++t)r._W(2,a.charCodeAt(t));r._W(2,0)}else if(n&2){i="e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(t=0;t<i.length;++t)r._W(1,parseInt(i[t],16));r._W(4,2*(a.length+1));for(t=0;t<a.length;++t)r._W(2,a.charCodeAt(t));r._W(2,0)}else{i="03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");for(t=0;t<i.length;++t)r._W(1,parseInt(i[t],16));var s=0;while(a.slice(s*3,s*3+3)=="../"||a.slice(s*3,s*3+3)=="..\\")++s;r._W(2,s);r._W(4,a.length+1);for(t=0;t<a.length;++t)r._W(1,a.charCodeAt(t)&255);r._W(1,0);r._W(2,65535);r._W(2,57005);for(t=0;t<6;++t)r._W(4,0)}return r.slice(0,r.l)}function ni(e){var r=e._R(1),t=e._R(1),a=e._R(1),n=e._R(1);return[r,t,a,n]}function ii(e,r){var t=ni(e,r);t[3]=0;return t}function si(e){var r=e._R(2);var t=e._R(2);var a=e._R(2);return{r:r,c:t,ixfe:a}}function fi(e,r,t,a){if(!a)a=Gr(6);a._W(2,e);a._W(2,r);a._W(2,t||0);return a}function oi(e){var r=e._R(2);var t=e._R(2);e.l+=8;return{type:r,flags:t}}function li(e,r,t){return r===0?"":$n(e,r,t)}function ci(e,r,t){var a=t.biff>8?4:2;var n=e._R(a),i=e._R(a,"i"),s=e._R(a,"i");return[n,i,s]}function hi(e){var r=e._R(2);var t=Mt(e);return[r,t]}function ui(e,r,t){e.l+=4;r-=4;var a=e.l+r;var n=Gn(e,r,t);var i=e._R(2);a-=e.l;if(i!==a)throw new Error("Malformed AddinUdf: padding = "+a+" != "+i);e.l+=i;return n}function di(e){var r=e._R(2);var t=e._R(2);var a=e._R(2);var n=e._R(2);return{s:{c:a,r:r},e:{c:n,r:t}}}function pi(e,r){if(!r)r=Gr(8);r._W(2,e.s.r);r._W(2,e.e.r);r._W(2,e.s.c);r._W(2,e.e.c);return r}function vi(e){var r=e._R(2);var t=e._R(2);var a=e._R(1);var n=e._R(1);return{s:{c:a,r:r},e:{c:n,r:t}}}var gi=vi;function mi(e){e.l+=4;var r=e._R(2);var t=e._R(2);var a=e._R(2);e.l+=12;return[t,r,a]}function bi(e){var r={};e.l+=4;e.l+=16;r.fSharedNote=e._R(2);e.l+=4;return r}function wi(e){var r={};e.l+=4;e.cf=e._R(2);return r}function Ci(e){e.l+=2;e.l+=e._R(2)}var Ei={0:Ci,4:Ci,5:Ci,6:Ci,7:wi,8:Ci,9:Ci,10:Ci,11:Ci,12:Ci,13:bi,14:Ci,15:Ci,16:Ci,17:Ci,18:Ci,19:Ci,20:Ci,21:mi};function ki(e,r){var t=e.l+r;var a=[];while(e.l<t){var n=e._R(2);e.l-=2;try{a.push(Ei[n](e,t-e.l))}catch(i){e.l=t;return a}}if(e.l!=t)e.l=t;return a}function Si(e,r){var t={BIFFVer:0,dt:0};t.BIFFVer=e._R(2);r-=2;if(r>=2){t.dt=e._R(2);e.l-=2}switch(t.BIFFVer){case 1536:;case 1280:;case 1024:;case 768:;case 512:;case 2:;case 7:break;default:if(r>6)throw new Error("Unexpected BIFF Ver "+t.BIFFVer);}e._R(r);return t}function Ai(e,r,t){var a=1536,n=16;switch(t.bookType){case"biff8":break;case"biff5":a=1280;n=8;break;case"biff4":a=4;n=6;break;case"biff3":a=3;n=6;break;case"biff2":a=2;n=4;break;case"xla":break;default:throw new Error("unsupported BIFF version");}var i=Gr(n);i._W(2,a);i._W(2,r);if(n>4)i._W(2,29282);if(n>6)i._W(2,1997);if(n>8){i._W(2,49161);i._W(2,1);i._W(2,1798);i._W(2,0)}return i}function _i(e,r){if(r===0)return 1200;if(e._R(2)!==1200){}return 1200}function Bi(e,r,t){if(t.enc){e.l+=r;return""}var a=e.l;var n=$n(e,0,t);e._R(r+a-e.l);return n}function Ti(e,r){var t=!r||r.biff==8;var a=Gr(t?112:54);a._W(r.biff==8?2:1,7);if(t)a._W(1,0);a._W(4,859007059);a._W(4,5458548|(t?0:536870912));while(a.l<a.length)a._W(1,t?0:32);return a}function yi(e,r,t){var a=t&&t.biff==8||r==2?e._R(2):(e.l+=r,0);return{fDialog:a&16}}function xi(e,r,t){var a=e._R(4);var n=e._R(1)&3;var i=e._R(1);switch(i){case 0:i="Worksheet";break;case 1:i="Macrosheet";break;case 2:i="Chartsheet";break;case 6:i="VBAModule";break;}var s=Gn(e,0,t);if(s.length===0)s="Sheet1";return{pos:a,hs:n,dt:i,name:s}}function Ii(e,r){var t=!r||r.biff>=8?2:1;var a=Gr(8+t*e.name.length);a._W(4,e.pos);a._W(1,e.hs||0);a._W(1,e.dt);a._W(1,e.name.length);if(r.biff>=8)a._W(1,1);a._W(t*e.name.length,e.name,r.biff<8?"sbcs":"utf16le");var n=a.slice(0,a.l);n.l=a.l;return n}function Ri(e,r){var t=e.l+r;var a=e._R(4);var n=e._R(4);var i=[];for(var s=0;s!=n&&e.l<t;++s){i.push(jn(e))}i.Count=a;i.Unique=n;return i}function Di(e,r){var t={};t.dsst=e._R(2);e.l+=r-2;return t}function Oi(e){var r={};r.r=e._R(2);r.c=e._R(2);r.cnt=e._R(2)-r.c;var t=e._R(2);e.l+=4;var a=e._R(1);e.l+=3;if(a&7)r.level=a&7;if(a&32)r.hidden=true;if(a&64)r.hpt=t/20;return r}function Fi(e){var r=oi(e);if(r.type!=2211)throw new Error("Invalid Future Record "+r.type);var t=e._R(4);return t!==0}function Pi(e){e._R(2);return e._R(4)}function Ni(e,r,t){var a=0;if(!(t&&t.biff==2)){a=e._R(2)}var n=e._R(2);if(t&&t.biff==2){a=1-(n>>15);n&=32767}var i={Unsynced:a&1,DyZero:(a&2)>>1,ExAsc:(a&4)>>2,ExDsc:(a&8)>>3};return[i,n]}function Li(e){var r=e._R(2),t=e._R(2),a=e._R(2),n=e._R(2);var i=e._R(2),s=e._R(2),f=e._R(2);var o=e._R(2),l=e._R(2);return{Pos:[r,t],Dim:[a,n],Flags:i,CurTab:s,FirstTab:f,Selected:o,TabRatio:l}}function Mi(){var e=Gr(18);e._W(2,0);e._W(2,0);e._W(2,29280);e._W(2,17600);e._W(2,56);e._W(2,0);e._W(2,0);e._W(2,1);e._W(2,500);return e}function Ui(e,r,t){if(t&&t.biff>=2&&t.biff<8)return{};var a=e._R(2);return{RTL:a&64}}function Hi(e){var r=Gr(18),t=1718;if(e&&e.RTL)t|=64;r._W(2,t);r._W(4,0);r._W(4,64);r._W(4,0);r._W(4,0);return r}function Wi(e,r,t){var a={dyHeight:e._R(2),fl:e._R(2)};switch(t&&t.biff||8){case 2:break;case 3:;case 4:e.l+=2;break;default:e.l+=10;break;}a.name=Gn(e,0,t);return a}function Vi(e,r){var t=e.name||"Arial";var a=r&&r.biff==5,n=a?15+t.length:16+2*t.length;var i=Gr(n);i._W(2,(e.sz||12)*20);i._W(4,0);i._W(2,400);i._W(4,0);i._W(2,0);i._W(1,t.length);if(!a)i._W(1,1);i._W((a?1:2)*t.length,t,a?"sbcs":"utf16le");return i}function zi(e){var r=si(e);r.isst=e._R(4);return r}function Xi(e,r,t){var a=e.l+r;var n=si(e,6);if(t.biff==2)e.l++;var i=Yn(e,a-e.l,t);n.val=i;return n}function Gi(e,r,t,a,n){var i=!n||n.biff==8;var s=Gr(6+2+ +i+(1+i)*t.length);fi(e,r,a,s);s._W(2,t.length);if(i)s._W(1,1);s._W((1+i)*t.length,t,i?"utf16le":"sbcs");return s}function ji(e,r,t){var a=e._R(2);var n=$n(e,0,t);return[a,n]}function Ki(e,r,t,a){var n=t&&t.biff==5;if(!a)a=Gr(n?3+r.length:5+2*r.length);a._W(2,e);a._W(n?1:2,r.length);if(!n)a._W(1,1);a._W((n?1:2)*r.length,r,n?"sbcs":"utf16le");var i=a.length>a.l?a.slice(0,a.l):a;if(i.l==null)i.l=i.length;return i}var Yi=$n;function $i(e,r,t){var a=e.l+r;var n=t.biff==8||!t.biff?4:2;var i=e._R(n),s=e._R(n);var f=e._R(2),o=e._R(2);e.l=a;return{s:{r:i,c:f},e:{r:s,c:o}}}function Zi(e,r){var t=r.biff==8||!r.biff?4:2;var a=Gr(2*t+6);a._W(t,e.s.r);a._W(t,e.e.r+1);a._W(2,e.s.c);a._W(2,e.e.c+1);a._W(2,0);return a}function Qi(e){var r=e._R(2),t=e._R(2);var a=hi(e);return{r:r,c:t,ixfe:a[0],rknum:a[1]}}function Ji(e,r){var t=e.l+r-2;var a=e._R(2),n=e._R(2);var i=[];while(e.l<t)i.push(hi(e));if(e.l!==t)throw new Error("MulRK read error");var s=e._R(2);if(i.length!=s-n+1)throw new Error("MulRK length mismatch");return{r:a,c:n,C:s,rkrec:i}}function qi(e,r){var t=e.l+r-2;var a=e._R(2),n=e._R(2);var i=[];while(e.l<t)i.push(e._R(2));if(e.l!==t)throw new Error("MulBlank read error");var s=e._R(2);if(i.length!=s-n+1)throw new Error("MulBlank length mismatch");return{r:a,c:n,C:s,ixfe:i}}function es(e,r,t,a){var n={};var i=e._R(4),s=e._R(4);var f=e._R(4),o=e._R(2);n.patternType=Ca[f>>26];if(!a.cellStyles)return n;n.alc=i&7;n.fWrap=i>>3&1;n.alcV=i>>4&7;n.fJustLast=i>>7&1;n.trot=i>>8&255;n.cIndent=i>>16&15;n.fShrinkToFit=i>>20&1;n.iReadOrder=i>>22&2;n.fAtrNum=i>>26&1;n.fAtrFnt=i>>27&1;n.fAtrAlc=i>>28&1;n.fAtrBdr=i>>29&1;n.fAtrPat=i>>30&1;n.fAtrProt=i>>31&1;n.dgLeft=s&15;n.dgRight=s>>4&15;n.dgTop=s>>8&15;n.dgBottom=s>>12&15;n.icvLeft=s>>16&127;n.icvRight=s>>23&127;n.grbitDiag=s>>30&3;n.icvTop=f&127;n.icvBottom=f>>7&127;n.icvDiag=f>>14&127;n.dgDiag=f>>21&15;n.icvFore=o&127;n.icvBack=o>>7&127;n.fsxButton=o>>14&1;return n}function rs(e,r,t){var a={};a.ifnt=e._R(2);a.numFmtId=e._R(2);a.flags=e._R(2);a.fStyle=a.flags>>2&1;r-=6;a.data=es(e,r,a.fStyle,t);return a}function ts(e,r,t,a){var n=t&&t.biff==5;if(!a)a=Gr(n?16:20);a._W(2,0);if(e.style){a._W(2,e.numFmtId||0);a._W(2,65524)}else{a._W(2,e.numFmtId||0);a._W(2,r<<4)}a._W(4,0);a._W(4,0);if(!n)a._W(4,0);a._W(2,0);return a}function as(e){e.l+=4;var r=[e._R(2),e._R(2)];if(r[0]!==0)r[0]--;if(r[1]!==0)r[1]--;if(r[0]>7||r[1]>7)throw new Error("Bad Gutters: "+r.join("|"));return r}function ns(e){var r=Gr(8);r._W(4,0);r._W(2,e[0]?e[0]+1:0);r._W(2,e[1]?e[1]+1:0);return r}function is(e,r,t){var a=si(e,6);if(t.biff==2)++e.l;var n=zn(e,2);a.val=n;a.t=n===true||n===false?"b":"e";return a}function ss(e,r,t,a,n,i){var s=Gr(8);fi(e,r,a,s);Xn(t,i,s);return s}function fs(e){var r=si(e,6);var t=Xt(e,8);r.val=t;return r}function os(e,r,t,a){var n=Gr(14);fi(e,r,a,n);Gt(t,n);return n}var ls=li;function cs(e,r,t){var a=e.l+r;var n=e._R(2);var i=e._R(2);t.sbcch=i;if(i==1025||i==14849)return[i,n];if(i<1||i>255)throw new Error("Unexpected SupBook type: "+i);var s=Kn(e,i);var f=[];while(a>e.l)f.push(Yn(e));return[i,n,s,f]}function hs(e,r,t){var a=e._R(2);var n;var i={fBuiltIn:a&1,fWantAdvise:a>>>1&1,fWantPict:a>>>2&1,fOle:a>>>3&1,fOleLink:a>>>4&1,cf:a>>>5&1023,fIcon:a>>>15&1};if(t.sbcch===14849)n=ui(e,r-2,t);i.body=n||e._R(r-2);if(typeof n==="string")i.Name=n;return i}var us=["_xlnm.Consolidate_Area","_xlnm.Auto_Open","_xlnm.Auto_Close","_xlnm.Extract","_xlnm.Database","_xlnm.Criteria","_xlnm.Print_Area","_xlnm.Print_Titles","_xlnm.Recorder","_xlnm.Data_Form","_xlnm.Auto_Activate","_xlnm.Auto_Deactivate","_xlnm.Sheet_Title","_xlnm._FilterDatabase"];function ds(e,r,t){var a=e.l+r;var n=e._R(2);var i=e._R(1);var s=e._R(1);var f=e._R(t&&t.biff==2?1:2);var o=0;if(!t||t.biff>=5){if(t.biff!=5)e.l+=2;o=e._R(2);if(t.biff==5)e.l+=2;e.l+=4}var l=Kn(e,s,t);if(n&32)l=us[l.charCodeAt(0)];var c=a-e.l;if(t&&t.biff==2)--c;var h=a==e.l||f===0?[]:yh(e,c,t,f);return{chKey:i,Name:l,itab:o,rgce:h}}function ps(e,r,t){if(t.biff<8)return vs(e,r,t);var a=[],n=e.l+r,i=e._R(t.biff>8?4:2);while(i--!==0)a.push(ci(e,t.biff>8?12:6,t));if(e.l!=n)throw new Error("Bad ExternSheet: "+e.l+" != "+n);return a}function vs(e,r,t){if(e[e.l+1]==3)e[e.l]++;var a=Gn(e,r,t);return a.charCodeAt(0)==3?a.slice(1):a}function gs(e,r,t){if(t.biff<8){e.l+=r;return}var a=e._R(2);var n=e._R(2);var i=Kn(e,a,t);var s=Kn(e,n,t);return[i,s]}function ms(e,r,t){var a=vi(e,6);e.l++;var n=e._R(1);r-=8;return[xh(e,r,t),n,a]}function bs(e,r,t){var a=gi(e,6);switch(t.biff){case 2:e.l++;r-=7;break;case 3:;case 4:e.l+=2;r-=8;break;default:e.l+=6;r-=12;}return[a,Bh(e,r,t,a)]}function ws(e){var r=e._R(4)!==0;var t=e._R(4)!==0;var a=e._R(4);return[r,t,a]}function Cs(e,r,t){if(t.biff<8)return;var a=e._R(2),n=e._R(2);var i=e._R(2),s=e._R(2);var f=$n(e,0,t);if(t.biff<8)e._R(1);return[{r:a,c:n},f,s,i]}function Es(e,r,t){return Cs(e,r,t)}function ks(e,r){var t=[];var a=e._R(2);while(a--)t.push(di(e,r));return t}function Ss(e){var r=Gr(2+e.length*8);r._W(2,e.length);for(var t=0;t<e.length;++t)pi(e[t],r);return r}function As(e,r,t){if(t&&t.biff<8)return Bs(e,r,t);var a=mi(e,22);var n=ki(e,r-22,a[1]);return{cmo:a,ft:n}}var _s=[];_s[8]=function(e,r){var t=e.l+r;e.l+=10;var a=e._R(2);e.l+=4;e.l+=2;e.l+=2;e.l+=2;e.l+=4;var n=e._R(1);e.l+=n;e.l=t;return{fmt:a}};function Bs(e,r,t){e.l+=4;var a=e._R(2);var n=e._R(2);var i=e._R(2);e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=6;r-=36;var s=[];s.push((_s[a]||Xr)(e,r,t));return{cmo:[n,a,i],ft:s}}function Ts(e,r,t){var a=e.l;var n="";try{e.l+=4;var i=(t.lastobj||{cmo:[0,0]}).cmo[1];var s;if([0,5,7,11,12,14].indexOf(i)==-1)e.l+=6;else s=Qn(e,6,t);var f=e._R(2);e._R(2);Hn(e,2);var o=e._R(2);e.l+=o;for(var l=1;l<e.lens.length-1;++l){if(e.l-a!=e.lens[l])throw new Error("TxO: bad continue record");var c=e[e.l];var h=Kn(e,e.lens[l+1]-e.lens[l]-1);n+=h;if(n.length>=(c?f:2*f))break}if(n.length!==f&&n.length!==f*2){throw new Error("cchText: "+f+" != "+n.length)}e.l=a+r;return{t:n}}catch(u){e.l=a+r;return{t:n}}}function ys(e,r){var t=di(e,8);e.l+=16;var a=ti(e,r-24);return[t,a]}function xs(e){var r=Gr(24);var t=ct(e[0]);r._W(2,t.r);r._W(2,t.r);r._W(2,t.c);r._W(2,t.c);var a="d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(var n=0;n<16;++n)r._W(1,parseInt(a[n],16));return x([r,ai(e[1])])}function Is(e,r){e._R(2);var t=di(e,8);var a=e._R((r-10)/2,"dbcs-cont");a=a.replace(I,"");return[t,a]}function Rs(e){var r=e[1].Tooltip;var t=Gr(10+2*(r.length+1));t._W(2,2048);var a=ct(e[0]);t._W(2,a.r);t._W(2,a.r);t._W(2,a.c);t._W(2,a.c);for(var n=0;n<r.length;++n)t._W(2,r.charCodeAt(n));t._W(2,0);return t}function Ds(e){var r=[0,0],t;t=e._R(2);r[0]=wa[t]||t;t=e._R(2);r[1]=wa[t]||t;return r}function Os(e){if(!e)e=Gr(4);e._W(2,1);e._W(2,1);return e}function Fs(e){var r=e._R(2);var t=[];while(r-- >0)t.push(ii(e,8));return t}function Ps(e){var r=e._R(2);var t=[];while(r-- >0)t.push(ii(e,8));return t}function Ns(e){e.l+=2;var r={cxfs:0,crc:0};r.cxfs=e._R(2);r.crc=e._R(4);return r}function Ls(e,r,t){if(!t.cellStyles)return Xr(e,r);var a=t&&t.biff>=12?4:2;var n=e._R(a);var i=e._R(a);var s=e._R(a);var f=e._R(a);var o=e._R(2);if(a==2)e.l+=2;return{s:n,e:i,w:s,ixfe:f,flags:o}}function Ms(e,r){var t={};if(r<32)return t;e.l+=16;t.header=Xt(e,8);t.footer=Xt(e,8);e.l+=2;return t}function Us(e,r,t){var a={area:false};if(t.biff!=5){e.l+=r;return a}var n=e._R(1);e.l+=3;if(n&16)a.area=true;return a}function Hs(e){var r=Gr(2*e);for(var t=0;t<e;++t)r._W(2,t+1);return r}var Ws=si;var Vs=Vn;var zs=Yn;function Xs(e){var r=e._R(2);var t=e._R(2);var a=e._R(4);var n={fmt:r,env:t,len:a,data:e.slice(e.l,e.l+a)};e.l+=a;return n}function Gs(e,r,t){var a=si(e,6);++e.l;var n=$n(e,r-7,t);a.t="str";a.val=n;return a}function js(e){var r=si(e,6);++e.l;var t=Xt(e,8);r.t="n";r.val=t;return r}function Ks(e,r,t){var a=Gr(15);gv(a,e,r);a._W(8,t,"f");return a}function Ys(e){var r=si(e,6);++e.l;var t=e._R(2);r.t="n";r.val=t;return r}function $s(e,r,t){var a=Gr(9);gv(a,e,r);a._W(2,t);return a}function Zs(e){var r=e._R(1);if(r===0){e.l++;return""}return e._R(r,"sbcs-cont")}function Qs(e,r){e.l+=6;e.l+=2;e.l+=1;e.l+=3;e.l+=1;e.l+=r-13}function Js(e,r,t){var a=e.l+r;var n=si(e,6);var i=e._R(2);var s=Kn(e,i,t);e.l=a;n.t="str";n.val=s;return n}var qs=function(){var e={1:437,2:850,3:1252,4:1e4,100:852,101:866,102:865,103:861,104:895,105:620,106:737,107:857,120:950,121:949,122:936,123:932,124:874,125:1255,126:1256,150:10007,151:10029,152:10006,200:1250,201:1251,202:1254,203:1253,0:20127,8:865,9:437,10:850,11:437,13:437,14:850,15:437,16:850,17:437,18:850,19:932,20:850,21:437,22:850,23:865,24:437,25:437,26:850,27:437,28:863,29:850,31:852,34:852,35:852,36:860,37:850,38:866,55:850,64:852,77:936,78:949,79:950,80:874,87:1252,88:1252,89:1252,255:16969};function r(r,t){var a=[];var n=k(1);switch(t.type){case"base64":n=A(m.decode(r));break;case"binary":n=A(r);break;case"buffer":;case"array":n=r;break;}zr(n,0);var i=n._R(1);var s=false;var f=false,o=false;switch(i){case 2:;case 3:break;case 48:f=true;s=true;break;case 49:f=true;break;case 131:s=true;break;case 139:s=true;break;case 140:s=true;o=true;break;case 245:s=true;break;default:throw new Error("DBF Unsupported Version: "+i.toString(16));}var l=0,c=0;if(i==2)l=n._R(2);n.l+=3;if(i!=2)l=n._R(4);if(i!=2)c=n._R(2);var h=n._R(2);var u=1252;if(i!=2){n.l+=16;n._R(1);if(n[n.l]!==0)u=e[n[n.l]];n.l+=1;n.l+=2}if(o)n.l+=36;var d=[],p={};var v=c-10-(f?264:0),g=o?32:11;while(i==2?n.l<n.length&&n[n.l]!=13:n.l<v){p={};p.name=cptable.utils.decode(u,n.slice(n.l,n.l+g)).replace(/[\u0000\r\n].*$/g,"");n.l+=g;p.type=String.fromCharCode(n._R(1));if(i!=2&&!o)p.offset=n._R(4);p.len=n._R(1);if(i==2)p.offset=n._R(2);p.dec=n._R(1);if(p.name.length)d.push(p);if(i!=2)n.l+=o?13:14;switch(p.type){case"B":if((!f||p.len!=8)&&t.WTF)console.log("Skipping "+p.name+":"+p.type);break;case"G":;case"P":if(t.WTF)console.log("Skipping "+p.name+":"+p.type);break;case"C":;case"D":;case"F":;case"I":;case"L":;case"M":;case"N":;case"O":;case"T":;case"Y":;case"0":;case"@":;case"+":break;default:throw new Error("Unknown Field Type: "+p.type);}}if(n[n.l]!==13)n.l=c-1;else if(i==2)n.l=521;if(i!=2){if(n._R(1)!==13)throw new Error("DBF Terminator not found "+n.l+" "+n[n.l]);n.l=c}var b=0,w=0;a[0]=[];for(w=0;w!=d.length;++w)a[0][w]=d[w].name;while(l-- >0){if(n[n.l]===42){n.l+=h;continue}++n.l;a[++b]=[];w=0;for(w=0;w!=d.length;++w){var C=n.slice(n.l,n.l+d[w].len);n.l+=d[w].len;zr(C,0);var E=cptable.utils.decode(u,C);switch(d[w].type){case"C":a[b][w]=cptable.utils.decode(u,C);a[b][w]=a[b][w].trim();break;case"D":if(E.length===8)a[b][w]=new Date(+E.slice(0,4),+E.slice(4,6)-1,+E.slice(6,8));else a[b][w]=E;break;case"F":a[b][w]=parseFloat(E.trim());break;case"+":;case"I":a[b][w]=o?C._R(-4,"i")^2147483648:C._R(4,"i");break;case"L":switch(E.toUpperCase()){case"Y":;case"T":a[b][w]=true;break;case"N":;case"F":a[b][w]=false;break;case" ":;case"?":a[b][w]=false;break;default:throw new Error("DBF Unrecognized L:|"+E+"|");}break;case"M":if(!s)throw new Error("DBF Unexpected MEMO for type "+i.toString(16));a[b][w]="##MEMO##"+(o?parseInt(E.trim(),10):C._R(4));break;case"N":a[b][w]=+E.replace(/\u0000/g,"").trim();break;case"@":a[b][w]=new Date(C._R(-8,"f")-621356832e5);break;case"T":a[b][w]=new Date((C._R(4)-2440588)*864e5+C._R(4));
break;case"Y":a[b][w]=C._R(4,"i")/1e4;break;case"O":a[b][w]=-C._R(-8,"f");break;case"B":if(f&&d[w].len==8){a[b][w]=C._R(8,"f");break};case"G":;case"P":C.l+=d[w].len;break;case"0":if(d[w].name==="_NullFlags")break;default:throw new Error("DBF Unsupported data type "+d[w].type);}}}if(i!=2)if(n.l<n.length&&n[n.l++]!=26)throw new Error("DBF EOF Marker missing "+(n.l-1)+" of "+n.length+" "+n[n.l-1].toString(16));if(t&&t.sheetRows)a=a.slice(0,t.sheetRows);return a}function t(e,t){var a=t||{};if(!a.dateNF)a.dateNF="yyyymmdd";return wt(r(e,a),a)}function a(e,r){try{return mt(t(e,r),r)}catch(a){if(r&&r.WTF)throw a}return{SheetNames:[],Sheets:{}}}var n={B:8,C:250,L:1,D:8,"?":0,"":0};function i(e,r){var t=r||{};if(t.type=="string")throw new Error("Cannot write DBF to JS string");var a=Kr();var i=Rg(e,{header:1,cellDates:true});var s=i[0],f=i.slice(1);var o=0,l=0,c=0,h=1;for(o=0;o<s.length;++o){if(o==null)continue;++c;if(typeof s[o]==="number")s[o]=s[o].toString(10);if(typeof s[o]!=="string")throw new Error("DBF Invalid column name "+s[o]+" |"+typeof s[o]+"|");if(s.indexOf(s[o])!==o)for(l=0;l<1024;++l)if(s.indexOf(s[o]+"_"+l)==-1){s[o]+="_"+l;break}}var u=pt(e["!ref"]);var d=[];for(o=0;o<=u.e.c-u.s.c;++o){var p=[];for(l=0;l<f.length;++l){if(f[l][o]!=null)p.push(f[l][o])}if(p.length==0||s[o]==null){d[o]="?";continue}var v="",g="";for(l=0;l<p.length;++l){switch(typeof p[l]){case"number":g="B";break;case"string":g="C";break;case"boolean":g="L";break;case"object":g=p[l]instanceof Date?"D":"C";break;default:g="C";}v=v&&v!=g?"C":g;if(v=="C")break}h+=n[v]||0;d[o]=v}var m=a.next(32);m._W(4,318902576);m._W(4,f.length);m._W(2,296+32*c);m._W(2,h);for(o=0;o<4;++o)m._W(4,0);m._W(4,768);for(o=0,l=0;o<s.length;++o){if(s[o]==null)continue;var b=a.next(32);var w=(s[o].slice(-10)+"\0\0\0\0\0\0\0\0\0\0\0").slice(0,11);b._W(1,w,"sbcs");b._W(1,d[o]=="?"?"C":d[o],"sbcs");b._W(4,l);b._W(1,n[d[o]]||0);b._W(1,0);b._W(1,2);b._W(4,0);b._W(1,0);b._W(4,0);b._W(4,0);l+=n[d[o]]||0}var C=a.next(264);C._W(4,13);for(o=0;o<65;++o)C._W(4,0);for(o=0;o<f.length;++o){var E=a.next(h);E._W(1,0);for(l=0;l<s.length;++l){if(s[l]==null)continue;switch(d[l]){case"L":E._W(1,f[o][l]==null?63:f[o][l]?84:70);break;case"B":E._W(8,f[o][l]||0,"f");break;case"D":if(!f[o][l])E._W(8,"00000000","sbcs");else{E._W(4,("0000"+f[o][l].getFullYear()).slice(-4),"sbcs");E._W(2,("00"+(f[o][l].getMonth()+1)).slice(-2),"sbcs");E._W(2,("00"+f[o][l].getDate()).slice(-2),"sbcs")}break;case"C":var k=String(f[o][l]||"");E._W(1,k,"sbcs");for(c=0;c<250-k.length;++c)E._W(1,32);break;}}}a.next(1)._W(1,26);return a.end()}return{to_workbook:a,to_sheet:t,from_sheet:i}}();var ef=function(){function e(e,t){switch(t.type){case"base64":return r(m.decode(e),t);case"binary":return r(e,t);case"buffer":return r(e.toString("binary"),t);case"array":return r(se(e),t);}throw new Error("Unrecognized type "+t.type)}function r(e,r){var t=e.split(/[\n\r]+/),a=-1,n=-1,i=0,s=0,f=[];var o=[];var l=null;var c={},h=[],u=[],d=[];var p=0,v;for(;i!==t.length;++i){p=0;var g=t[i].trim();var m=g.replace(/;;/g,"").split(";").map(function(e){return e.replace(/\u0001/g,";")});var b=m[0],w;if(g.length>0)switch(b){case"ID":break;case"E":break;case"B":break;case"O":break;case"P":if(m[1].charAt(0)=="P")o.push(g.slice(3).replace(/;;/g,";"));break;case"C":var C=false,E=false;for(s=1;s<m.length;++s)switch(m[s].charAt(0)){case"X":n=parseInt(m[s].slice(1))-1;E=true;break;case"Y":a=parseInt(m[s].slice(1))-1;if(!E)n=0;for(v=f.length;v<=a;++v)f[v]=[];break;case"K":w=m[s].slice(1);if(w.charAt(0)==='"')w=w.slice(1,w.length-1);else if(w==="TRUE")w=true;else if(w==="FALSE")w=false;else if(!isNaN(le(w))){w=le(w);if(l!==null&&D.is_date(l))w=re(w)}else if(!isNaN(ce(w).getDate())){w=ie(w)}if(typeof cptable!=="undefined"&&typeof w=="string"&&(r||{}).type!="string"&&(r||{}).codepage)w=cptable.utils.decode(r.codepage,w);C=true;break;case"E":var k=Xl(m[s].slice(1),{r:a,c:n});f[a][n]=[f[a][n],k];break;default:if(r&&r.WTF)throw new Error("SYLK bad record "+g);}if(C){f[a][n]=w;l=null}break;case"F":var S=0;for(s=1;s<m.length;++s)switch(m[s].charAt(0)){case"X":n=parseInt(m[s].slice(1))-1;++S;break;case"Y":a=parseInt(m[s].slice(1))-1;for(v=f.length;v<=a;++v)f[v]=[];break;case"M":p=parseInt(m[s].slice(1))/20;break;case"F":break;case"G":break;case"P":l=o[parseInt(m[s].slice(1))];break;case"S":break;case"D":break;case"N":break;case"W":d=m[s].slice(1).split(" ");for(v=parseInt(d[0],10);v<=parseInt(d[1],10);++v){p=parseInt(d[2],10);u[v-1]=p===0?{hidden:true}:{wch:p};fo(u[v-1])}break;case"C":n=parseInt(m[s].slice(1))-1;if(!u[n])u[n]={};break;case"R":a=parseInt(m[s].slice(1))-1;if(!h[a])h[a]={};if(p>0){h[a].hpt=p;h[a].hpx=ho(p)}else if(p===0)h[a].hidden=true;break;default:if(r&&r.WTF)throw new Error("SYLK bad record "+g);}if(S<1)l=null;break;default:if(r&&r.WTF)throw new Error("SYLK bad record "+g);}}if(h.length>0)c["!rows"]=h;if(u.length>0)c["!cols"]=u;if(r&&r.sheetRows)f=f.slice(0,r.sheetRows);return[f,c]}function t(r,t){var a=e(r,t);var n=a[0],i=a[1];var s=wt(n,t);j(i).forEach(function(e){s[e]=i[e]});return s}function a(e,r){return mt(t(e,r),r)}function n(e,r,t,a){var n="C;Y"+(t+1)+";X"+(a+1)+";K";switch(e.t){case"n":n+=e.v||0;if(e.f&&!e.F)n+=";E"+jl(e.f,{r:t,c:a});break;case"b":n+=e.v?"TRUE":"FALSE";break;case"e":n+=e.w||e.v;break;case"d":n+='"'+(e.w||e.v)+'"';break;case"s":n+='"'+e.v.replace(/"/g,"")+'"';break;}return n}function i(e,r){r.forEach(function(r,t){var a="F;W"+(t+1)+" "+(t+1)+" ";if(r.hidden)a+="0";else{if(typeof r.width=="number")r.wpx=to(r.width);if(typeof r.wpx=="number")r.wch=ao(r.wpx);if(typeof r.wch=="number")a+=Math.round(r.wch)}if(a.charAt(a.length-1)!=" ")e.push(a)})}function s(e,r){r.forEach(function(r,t){var a="F;";if(r.hidden)a+="M0;";else if(r.hpt)a+="M"+20*r.hpt+";";else if(r.hpx)a+="M"+20*co(r.hpx)+";";if(a.length>2)e.push(a+"R"+(t+1))})}function f(e,r){var t=["ID;PWXL;N;E"],a=[];var f=pt(e["!ref"]),o;var l=Array.isArray(e);var c="\r\n";t.push("P;PGeneral");t.push("F;P0;DG0G8;M255");if(e["!cols"])i(t,e["!cols"]);if(e["!rows"])s(t,e["!rows"]);t.push("B;Y"+(f.e.r-f.s.r+1)+";X"+(f.e.c-f.s.c+1)+";D"+[f.s.c,f.s.r,f.e.c,f.e.r].join(" "));for(var h=f.s.r;h<=f.e.r;++h){for(var u=f.s.c;u<=f.e.c;++u){var d=ht({r:h,c:u});o=l?(e[h]||[])[u]:e[d];if(!o||o.v==null&&(!o.f||o.F))continue;a.push(n(o,e,h,u,r))}}return t.join(c)+c+a.join(c)+c+"E"+c}return{to_workbook:a,to_sheet:t,from_sheet:f}}();var rf=function(){function e(e,t){switch(t.type){case"base64":return r(m.decode(e),t);case"binary":return r(e,t);case"buffer":return r(e.toString("binary"),t);case"array":return r(se(e),t);}throw new Error("Unrecognized type "+t.type)}function r(e,r){var t=e.split("\n"),a=-1,n=-1,i=0,s=[];for(;i!==t.length;++i){if(t[i].trim()==="BOT"){s[++a]=[];n=0;continue}if(a<0)continue;var f=t[i].trim().split(",");var o=f[0],l=f[1];++i;var c=t[i].trim();switch(+o){case-1:if(c==="BOT"){s[++a]=[];n=0;continue}else if(c!=="EOD")throw new Error("Unrecognized DIF special command "+c);break;case 0:if(c==="TRUE")s[a][n]=true;else if(c==="FALSE")s[a][n]=false;else if(!isNaN(le(l)))s[a][n]=le(l);else if(!isNaN(ce(l).getDate()))s[a][n]=ie(l);else s[a][n]=l;++n;break;case 1:c=c.slice(1,c.length-1);s[a][n++]=c!==""?c:null;break;}if(c==="EOD")break}if(r&&r.sheetRows)s=s.slice(0,r.sheetRows);return s}function t(r,t){return wt(e(r,t),t)}function a(e,r){return mt(t(e,r),r)}var n=function(){var e=function t(e,r,a,n,i){e.push(r);e.push(a+","+n);e.push('"'+i.replace(/"/g,'""')+'"')};var r=function a(e,r,t,n){e.push(r+","+t);e.push(r==1?'"'+n.replace(/"/g,'""')+'"':n)};return function n(t){var a=[];var n=pt(t["!ref"]),i;var s=Array.isArray(t);e(a,"TABLE",0,1,"sheetjs");e(a,"VECTORS",0,n.e.r-n.s.r+1,"");e(a,"TUPLES",0,n.e.c-n.s.c+1,"");e(a,"DATA",0,0,"");for(var f=n.s.r;f<=n.e.r;++f){r(a,-1,0,"BOT");for(var o=n.s.c;o<=n.e.c;++o){var l=ht({r:f,c:o});i=s?(t[f]||[])[o]:t[l];if(!i){r(a,1,0,"");continue}switch(i.t){case"n":var c=g?i.w:i.v;if(!c&&i.v!=null)c=i.v;if(c==null){if(g&&i.f&&!i.F)r(a,1,0,"="+i.f);else r(a,1,0,"")}else r(a,0,c,"V");break;case"b":r(a,0,i.v?1:0,i.v?"TRUE":"FALSE");break;case"s":r(a,1,0,!g||isNaN(i.v)?i.v:'="'+i.v+'"');break;case"d":if(!i.w)i.w=D.format(i.z||D._table[14],ee(ie(i.v)));if(g)r(a,0,i.w,"V");else r(a,1,0,i.w);break;default:r(a,1,0,"");}}}r(a,-1,0,"EOD");var h="\r\n";var u=a.join(h);return u}}();return{to_workbook:a,to_sheet:t,from_sheet:n}}();var tf=function(){function e(e){return e.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n")}function r(e){return e.replace(/\\/g,"\\b").replace(/:/g,"\\c").replace(/\n/g,"\\n")}function t(r,t){var a=r.split("\n"),n=-1,i=-1,s=0,f=[];for(;s!==a.length;++s){var o=a[s].trim().split(":");if(o[0]!=="cell")continue;var l=ct(o[1]);if(f.length<=l.r)for(n=f.length;n<=l.r;++n)if(!f[n])f[n]=[];n=l.r;i=l.c;switch(o[2]){case"t":f[n][i]=e(o[3]);break;case"v":f[n][i]=+o[3];break;case"vtf":var c=o[o.length-1];case"vtc":switch(o[3]){case"nl":f[n][i]=+o[4]?true:false;break;default:f[n][i]=+o[4];break;}if(o[2]=="vtf")f[n][i]=[f[n][i],c];}}if(t&&t.sheetRows)f=f.slice(0,t.sheetRows);return f}function a(e,r){return wt(t(e,r),r)}function n(e,r){return mt(a(e,r),r)}var i=["socialcalc:version:1.5","MIME-Version: 1.0","Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"].join("\n");var s=["--SocialCalcSpreadsheetControlSave","Content-type: text/plain; charset=UTF-8"].join("\n")+"\n";var f=["# SocialCalc Spreadsheet Control Save","part:sheet"].join("\n");var o="--SocialCalcSpreadsheetControlSave--";function l(e){if(!e||!e["!ref"])return"";var t=[],a=[],n,i="";var s=ut(e["!ref"]);var f=Array.isArray(e);for(var o=s.s.r;o<=s.e.r;++o){for(var l=s.s.c;l<=s.e.c;++l){i=ht({r:o,c:l});n=f?(e[o]||[])[l]:e[i];if(!n||n.v==null||n.t==="z")continue;a=["cell",i,"t"];switch(n.t){case"s":;case"str":a.push(r(n.v));break;case"n":if(!n.f){a[2]="v";a[3]=n.v}else{a[2]="vtf";a[3]="n";a[4]=n.v;a[5]=r(n.f)}break;case"b":a[2]="vt"+(n.f?"f":"c");a[3]="nl";a[4]=n.v?"1":"0";a[5]=r(n.f||(n.v?"TRUE":"FALSE"));break;case"d":var c=ee(ie(n.v));a[2]="vtc";a[3]="nd";a[4]=""+c;a[5]=n.w||D.format(n.z||D._table[14],c);break;case"e":continue;}t.push(a.join(":"))}}t.push("sheet:c:"+(s.e.c-s.s.c+1)+":r:"+(s.e.r-s.s.r+1)+":tvf:1");t.push("valueformat:1:text-wiki");return t.join("\n")}function c(e){return[i,s,f,s,l(e),o].join("\n")}return{to_workbook:n,to_sheet:a,from_sheet:c}}();var af=function(){function e(e,r,t,a,n){if(n.raw)r[t][a]=e;else if(e==="TRUE")r[t][a]=true;else if(e==="FALSE")r[t][a]=false;else if(e===""){}else if(!isNaN(le(e)))r[t][a]=le(e);else if(!isNaN(ce(e).getDate()))r[t][a]=ie(e);else r[t][a]=e}function r(r,t){var a=t||{};var n=[];if(!r||r.length===0)return n;var i=r.split(/[\r\n]/);var s=i.length-1;while(s>=0&&i[s].length===0)--s;var f=10,o=0;var l=0;for(;l<=s;++l){o=i[l].indexOf(" ");if(o==-1)o=i[l].length;else o++;f=Math.max(f,o)}for(l=0;l<=s;++l){n[l]=[];var c=0;e(i[l].slice(0,f).trim(),n,l,c,a);for(c=1;c<=(i[l].length-f)/10+1;++c)e(i[l].slice(f+(c-1)*10,f+c*10).trim(),n,l,c,a)}if(a.sheetRows)n=n.slice(0,a.sheetRows);return n}var t={44:",",9:"\t",59:";"};var a={44:3,9:2,59:1};function n(e){var r={},n=false,i=0,s=0;for(;i<e.length;++i){if((s=e.charCodeAt(i))==34)n=!n;else if(!n&&s in t)r[s]=(r[s]||0)+1}s=[];for(i in r)if(r.hasOwnProperty(i)){s.push([r[i],i])}if(!s.length){r=a;for(i in r)if(r.hasOwnProperty(i)){s.push([r[i],i])}}s.sort(function(e,r){return e[0]-r[0]||a[e[1]]-a[r[1]]});return t[s.pop()[1]]}function i(e,r){var t=r||{};var a="";if(v!=null&&t.dense==null)t.dense=v;var i=t.dense?[]:{};var s={s:{c:0,r:0},e:{c:0,r:0}};if(e.slice(0,4)=="sep="&&e.charCodeAt(5)==10){a=e.charAt(4);e=e.slice(6)}else a=n(e.slice(0,1024));var f=0,o=0,l=0;var c=0,h=0,u=a.charCodeAt(0),d=false,p=0;e=e.replace(/\r\n/gm,"\n");var g=t.dateNF!=null?L(t.dateNF):null;function m(){var r=e.slice(c,h);var a={};if(r.charAt(0)=='"'&&r.charAt(r.length-1)=='"')r=r.slice(1,-1).replace(/""/g,'"');if(r.length===0)a.t="z";else if(t.raw){a.t="s";a.v=r}else if(r.trim().length===0){a.t="s";a.v=r}else if(r.charCodeAt(0)==61){if(r.charCodeAt(1)==34&&r.charCodeAt(r.length-1)==34){a.t="s";a.v=r.slice(2,-1).replace(/""/g,'"')}else if($l(r)){a.t="n";a.f=r.slice(1)}else{a.t="s";a.v=r}}else if(r=="TRUE"){a.t="b";a.v=true}else if(r=="FALSE"){a.t="b";a.v=false}else if(!isNaN(l=le(r))){a.t="n";if(t.cellText!==false)a.w=r;a.v=l}else if(!isNaN(ce(r).getDate())||g&&r.match(g)){a.z=t.dateNF||D._table[14];var n=0;if(g&&r.match(g)){r=M(r,t.dateNF,r.match(g)||[]);n=1}if(t.cellDates){a.t="d";a.v=ie(r,n)}else{a.t="n";a.v=ee(ie(r,n))}if(t.cellText!==false)a.w=D.format(a.z,a.v instanceof Date?ee(a.v):a.v);if(!t.cellNF)delete a.z}else{a.t="s";a.v=r}if(a.t=="z"){}else if(t.dense){if(!i[f])i[f]=[];i[f][o]=a}else i[ht({c:o,r:f})]=a;c=h+1;if(s.e.c<o)s.e.c=o;if(s.e.r<f)s.e.r=f;if(p==u)++o;else{o=0;++f;if(t.sheetRows&&t.sheetRows<=f)return true}}e:for(;h<e.length;++h)switch(p=e.charCodeAt(h)){case 34:d=!d;break;case u:;case 10:;case 13:if(!d&&m())break e;break;default:break;}if(h-c>0)m();i["!ref"]=dt(s);return i}function s(e,t){if(e.slice(0,4)=="sep=")return i(e,t);if(e.indexOf("\t")>=0||e.indexOf(",")>=0||e.indexOf(";")>=0)return i(e,t);return wt(r(e,t),t)}function f(e,r){var t="",a=r.type=="string"?[0,0,0,0]:cg(e,r);switch(r.type){case"base64":t=m.decode(e);break;case"binary":t=e;break;case"buffer":if(r.codepage==65001)t=e.toString("utf8");else if(r.codepage&&typeof cptable!=="undefined")t=cptable.utils.decode(r.codepage,e);else t=e.toString("binary");break;case"array":t=se(e);break;case"string":t=e;break;default:throw new Error("Unrecognized type "+r.type);}if(a[0]==239&&a[1]==187&&a[2]==191)t=ze(t.slice(3));else if(r.type=="binary"&&typeof cptable!=="undefined"&&r.codepage)t=cptable.utils.decode(r.codepage,cptable.utils.encode(1252,t));if(t.slice(0,19)=="socialcalc:version:")return tf.to_sheet(r.type=="string"?t:ze(t),r);return s(t,r)}function o(e,r){return mt(f(e,r),r)}function l(e){var r=[];var t=pt(e["!ref"]),a;var n=Array.isArray(e);for(var i=t.s.r;i<=t.e.r;++i){var s=[];for(var f=t.s.c;f<=t.e.c;++f){var o=ht({r:i,c:f});a=n?(e[i]||[])[f]:e[o];if(!a||a.v==null){s.push("          ");continue}var l=(a.w||(gt(a),a.w)||"").slice(0,10);while(l.length<10)l+=" ";s.push(l+(f===0?" ":""))}r.push(s.join(""))}return r.join("\n")}return{to_workbook:o,to_sheet:f,from_sheet:l}}();function nf(e,r){var t=r||{},a=!!t.WTF;t.WTF=true;try{var n=ef.to_workbook(e,t);t.WTF=a;return n}catch(i){t.WTF=a;if(!i.message.match(/SYLK bad record ID/)&&a)throw i;return af.to_workbook(e,r)}}var sf=function(){function e(e,r,t){if(!e)return;zr(e,e.l||0);var a=t.Enum||w;while(e.l<e.length){var n=e._R(2);var i=a[n]||a[255];var s=e._R(2);var f=e.l+s;var o=(i.f||Xr)(e,s,t);e.l=f;if(r(o,i.n,n))return}}function r(e,r){switch(r.type){case"base64":return t(A(m.decode(e)),r);case"binary":return t(A(e),r);case"buffer":;case"array":return t(e,r);}throw"Unsupported type "+r.type}function t(r,t){if(!r)return r;var a=t||{};if(v!=null&&a.dense==null)a.dense=v;var n=a.dense?[]:{},i="Sheet1",s=0;var f={},o=[i];var l={s:{r:0,c:0},e:{r:0,c:0}};var c=a.sheetRows||0;if(r[2]==2)a.Enum=w;else if(r[2]==26)a.Enum=C;else if(r[2]==14){a.Enum=C;a.qpro=true;r.l=0}else throw new Error("Unrecognized LOTUS BOF "+r[2]);e(r,function(e,t,h){if(r[2]==2)switch(h){case 0:a.vers=e;if(e>=4096)a.qpro=true;break;case 6:l=e;break;case 15:if(!a.qpro)e[1].v=e[1].v.slice(1);case 13:;case 14:;case 16:;case 51:if(h==14&&(e[2]&112)==112&&(e[2]&15)>1&&(e[2]&15)<15){e[1].z=a.dateNF||D._table[14];if(a.cellDates){e[1].t="d";e[1].v=re(e[1].v)}}if(a.dense){if(!n[e[0].r])n[e[0].r]=[];n[e[0].r][e[0].c]=e[1]}else n[ht(e[0])]=e[1];break;}else switch(h){case 22:e[1].v=e[1].v.slice(1);case 23:;case 24:;case 25:;case 37:;case 39:;case 40:if(e[3]>s){n["!ref"]=dt(l);f[i]=n;n=a.dense?[]:{};l={s:{r:0,c:0},e:{r:0,c:0}};s=e[3];i="Sheet"+(s+1);o.push(i)}if(c>0&&e[0].r>=c)break;if(a.dense){if(!n[e[0].r])n[e[0].r]=[];n[e[0].r][e[0].c]=e[1]}else n[ht(e[0])]=e[1];if(l.e.c<e[0].c)l.e.c=e[0].c;if(l.e.r<e[0].r)l.e.r=e[0].r;break;default:break;}},a);n["!ref"]=dt(l);f[i]=n;return{SheetNames:o,Sheets:f}}function a(e){var r={s:{c:0,r:0},e:{c:0,r:0}};r.s.c=e._R(2);r.s.r=e._R(2);r.e.c=e._R(2);r.e.r=e._R(2);if(r.s.c==65535)r.s.c=r.e.c=r.s.r=r.e.r=0;return r}function n(e,r,t){var a=[{c:0,r:0},{t:"n",v:0},0];if(t.qpro&&t.vers!=20768){a[0].c=e._R(1);e.l++;a[0].r=e._R(2);e.l+=2}else{a[2]=e._R(1);a[0].c=e._R(2);a[0].r=e._R(2)}return a}function i(e,r,t){var a=e.l+r;var i=n(e,r,t);i[1].t="s";if(t.vers==20768){e.l++;var s=e._R(1);i[1].v=e._R(s,"utf8");return i}if(t.qpro)e.l++;i[1].v=e._R(a-e.l,"cstr");return i}function s(e,r,t){var a=n(e,r,t);a[1].v=e._R(2,"i");return a}function f(e,r,t){var a=n(e,r,t);a[1].v=e._R(8,"f");return a}function o(e,r,t){var a=e.l+r;var i=n(e,r,t);i[1].v=e._R(8,"f");if(t.qpro)e.l=a;else{var s=e._R(2);e.l+=s}return i}function l(e){var r=[{c:0,r:0},{t:"n",v:0},0];r[0].r=e._R(2);r[3]=e[e.l++];r[0].c=e[e.l++];return r}function c(e,r){var t=l(e,r);t[1].t="s";t[1].v=e._R(r-4,"cstr");return t}function h(e,r){var t=l(e,r);t[1].v=e._R(2);var a=t[1].v>>1;if(t[1].v&1){switch(a&7){case 1:a=(a>>3)*500;break;case 2:a=(a>>3)/20;break;case 4:a=(a>>3)/2e3;break;case 6:a=(a>>3)/16;break;case 7:a=(a>>3)/64;break;default:throw"unknown NUMBER_18 encoding "+(a&7);}}t[1].v=a;return t}function u(e,r){var t=l(e,r);var a=e._R(4);var n=e._R(4);var i=e._R(2);if(i==65535){t[1].v=0;return t}var s=i&32768;i=(i&32767)-16446;t[1].v=(s*2-1)*((i>0?n<<i:n>>>-i)+(i>-32?a<<i+32:a>>>-(i+32)));return t}function d(e,r){var t=u(e,14);e.l+=r-14;return t}function p(e,r){var t=l(e,r);var a=e._R(4);t[1].v=a>>6;return t}function g(e,r){var t=l(e,r);var a=e._R(8,"f");t[1].v=a;return t}function b(e,r){var t=g(e,14);e.l+=r-10;return t}var w={0:{n:"BOF",f:Hn},1:{n:"EOF"},2:{n:"CALCMODE"},3:{n:"CALCORDER"},4:{n:"SPLIT"},5:{n:"SYNC"},6:{n:"RANGE",f:a},7:{n:"WINDOW1"},8:{n:"COLW1"},9:{n:"WINTWO"},10:{n:"COLW2"},11:{n:"NAME"},12:{n:"BLANK"},13:{n:"INTEGER",f:s},14:{n:"NUMBER",f:f},15:{n:"LABEL",f:i},16:{n:"FORMULA",f:o},24:{n:"TABLE"},25:{n:"ORANGE"},26:{n:"PRANGE"},27:{n:"SRANGE"},28:{n:"FRANGE"},29:{n:"KRANGE1"},32:{n:"HRANGE"},35:{n:"KRANGE2"},36:{n:"PROTEC"},37:{n:"FOOTER"},38:{n:"HEADER"},39:{n:"SETUP"},40:{n:"MARGINS"},41:{n:"LABELFMT"},42:{n:"TITLES"},43:{n:"SHEETJS"},45:{n:"GRAPH"},46:{n:"NGRAPH"},47:{n:"CALCCOUNT"},48:{n:"UNFORMATTED"},49:{n:"CURSORW12"},50:{n:"WINDOW"},51:{n:"STRING",f:i},55:{n:"PASSWORD"},56:{n:"LOCKED"},60:{n:"QUERY"},61:{n:"QUERYNAME"},62:{n:"PRINT"},63:{n:"PRINTNAME"},64:{n:"GRAPH2"},65:{n:"GRAPHNAME"},66:{n:"ZOOM"},67:{n:"SYMSPLIT"},68:{n:"NSROWS"},69:{n:"NSCOLS"},70:{n:"RULER"},71:{n:"NNAME"},72:{n:"ACOMM"},73:{n:"AMACRO"},74:{n:"PARSE"},255:{n:"",f:Xr}};var C={0:{n:"BOF"},1:{n:"EOF"},3:{n:"??"},4:{n:"??"},5:{n:"??"},6:{n:"??"},7:{n:"??"},9:{n:"??"},10:{n:"??"},11:{n:"??"},12:{n:"??"},14:{n:"??"},15:{n:"??"},16:{n:"??"},17:{n:"??"},18:{n:"??"},19:{n:"??"},21:{n:"??"},22:{n:"LABEL16",f:c},23:{n:"NUMBER17",f:u},24:{n:"NUMBER18",f:h},25:{n:"FORMULA19",f:d},26:{n:"??"},27:{n:"??"},28:{n:"??"},29:{n:"??"},30:{n:"??"},31:{n:"??"},33:{n:"??"},37:{n:"NUMBER25",f:p},39:{n:"NUMBER27",f:g},40:{n:"FORMULA28",f:b},255:{n:"",f:Xr}};return{to_workbook:r}}();var ff=function im(){var e=Ye("t"),r=Ye("rPr"),t=/<(?:\w+:)?r>/g,a=/<\/(?:\w+:)?r>/,n=/\r\n/g;var s=function o(e,r,t){var a={},n=65001,s="";var f=false;var o=e.match(_e),l=0;if(o)for(;l!=o.length;++l){var c=ye(o[l]);switch(c[0].replace(/\w*:/g,"")){case"<condense":break;case"<extend":break;case"<shadow":if(!c.val)break;case"<shadow>":;case"<shadow/>":a.shadow=1;break;case"</shadow>":break;case"<charset":if(c.val=="1")break;n=i[parseInt(c.val,10)];break;case"<outline":if(!c.val)break;case"<outline>":;case"<outline/>":a.outline=1;break;case"</outline>":break;case"<rFont":a.name=c.val;break;case"<sz":a.sz=c.val;break;case"<strike":if(!c.val)break;case"<strike>":;case"<strike/>":a.strike=1;break;case"</strike>":break;case"<u":if(!c.val)break;switch(c.val){case"double":a.uval="double";break;case"singleAccounting":a.uval="single-accounting";break;case"doubleAccounting":a.uval="double-accounting";break;};case"<u>":;case"<u/>":a.u=1;break;case"</u>":break;case"<b":if(c.val=="0")break;case"<b>":;case"<b/>":a.b=1;break;case"</b>":break;case"<i":if(c.val=="0")break;case"<i>":;case"<i/>":a.i=1;break;case"</i>":break;case"<color":if(c.rgb)a.color=c.rgb.slice(2,8);break;case"<family":a.family=c.val;break;case"<vertAlign":s=c.val;break;case"<scheme":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":f=true;break;case"</ext>":f=false;break;default:if(c[0].charCodeAt(1)!==47&&!f)throw new Error("Unrecognized rich format "+c[0]);}}var h=[];if(a.u)h.push("text-decoration: underline;");if(a.uval)h.push("text-underline-style:"+a.uval+";");if(a.sz)h.push("font-size:"+a.sz+"pt;");if(a.outline)h.push("text-effect: outline;");if(a.shadow)h.push("text-shadow: auto;");r.push('<span style="'+h.join("")+'">');if(a.b){r.push("<b>");t.push("</b>")}if(a.i){r.push("<i>");t.push("</i>")}if(a.strike){r.push("<s>");t.push("</s>")}if(s=="superscript")s="sup";else if(s=="subscript")s="sub";if(s!=""){r.push("<"+s+">");t.push("</"+s+">")}t.push("</span>");return n};function f(t){var a=[[],"",[]];var i=t.match(e);if(!i)return"";a[1]=i[1];var f=t.match(r);if(f)s(f[1],a[0],a[2]);return a[0].join("")+a[1].replace(n,"<br/>")+a[2].join("")}return function l(e){return e.replace(t,"").split(a).map(f).join("")}}();var of=/<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,lf=/<(?:\w+:)?r>/;var cf=/<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;function hf(e,r){var t=r?r.cellHTML:true;var a={};if(!e)return null;if(e.match(/^\s*<(?:\w+:)?t[^>]*>/)){a.t=De(ze(e.slice(e.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));a.r=ze(e);if(t)a.h=Me(a.t)}else if(e.match(lf)){a.r=ze(e);a.t=De(ze((e.replace(cf,"").match(of)||[]).join("").replace(_e,"")));if(t)a.h=ff(a.r)}return a}var uf=/<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;var df=/<(?:\w+:)?(?:si|sstItem)>/g;var pf=/<\/(?:\w+:)?(?:si|sstItem)>/;function vf(e,r){var t=[],a="";if(!e)return t;var n=e.match(uf);if(n){a=n[2].replace(df,"").split(pf);for(var i=0;i!=a.length;++i){var s=hf(a[i].trim(),r);if(s!=null)t[t.length]=s}n=ye(n[1]);t.Count=n.count;t.Unique=n.uniqueCount}return t}Ra.SST="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";var gf=/^\s|\s$|[\t\n\r]/;function mf(e,r){if(!r.bookSST)return"";var t=[Se];t[t.length]=ar("sst",null,{xmlns:sr.main[0],count:e.Count,uniqueCount:e.Unique});for(var a=0;a!=e.length;++a){if(e[a]==null)continue;var n=e[a];var i="<si>";if(n.r)i+=n.r;else{i+="<t";if(!n.t)n.t="";if(n.t.match(gf))i+=' xml:space="preserve"';i+=">"+Pe(n.t)+"</t>"}i+="</si>";t[t.length]=i}if(t.length>2){t[t.length]="</sst>";t[1]=t[1].replace("/>",">")}return t.join("")}function bf(e){return[e._R(4),e._R(4)]}function wf(e,r){var t=[];var a=false;jr(e,function n(e,i,s){switch(s){case 159:t.Count=e[0];t.Unique=e[1];break;case 19:t.push(e);break;case 160:return true;case 35:a=true;break;case 36:a=false;break;default:if(i.indexOf("Begin")>0){}else if(i.indexOf("End")>0){}if(!a||r.WTF)throw new Error("Unexpected record "+s+" "+i);}});return t}function Cf(e,r){if(!r)r=Gr(8);r._W(4,e.Count);r._W(4,e.Unique);return r}var Ef=Bt;function kf(e){var r=Kr();Yr(r,"BrtBeginSst",Cf(e));for(var t=0;t<e.length;++t)Yr(r,"BrtSSTItem",Ef(e[t]));Yr(r,"BrtEndSst");return r.end()}function Sf(e){if(typeof cptable!=="undefined")return cptable.utils.encode(t,e);var r=[],a=e.split("");for(var n=0;n<a.length;++n)r[n]=a[n].charCodeAt(0);return r}function Af(e,r){var t={};t.Major=e._R(2);t.Minor=e._R(2);if(r>=4)e.l+=r-4;return t}function _f(e){var r={};r.id=e._R(0,"lpp4");r.R=Af(e,4);r.U=Af(e,4);r.W=Af(e,4);return r}function Bf(e){var r=e._R(4);var t=e.l+r-4;var a={};var n=e._R(4);var i=[];while(n-- >0)i.push({t:e._R(4),v:e._R(0,"lpp4")});a.name=e._R(0,"lpp4");a.comps=i;if(e.l!=t)throw new Error("Bad DataSpaceMapEntry: "+e.l+" != "+t);return a}function Tf(e){var r=[];e.l+=4;var t=e._R(4);while(t-- >0)r.push(Bf(e));return r}function yf(e){var r=[];e.l+=4;var t=e._R(4);while(t-- >0)r.push(e._R(0,"lpp4"));return r}function xf(e){var r={};e._R(4);e.l+=4;r.id=e._R(0,"lpp4");r.name=e._R(0,"lpp4");r.R=Af(e,4);r.U=Af(e,4);r.W=Af(e,4);return r}function If(e){var r=xf(e);r.ename=e._R(0,"8lpp4");r.blksz=e._R(4);r.cmode=e._R(4);if(e._R(4)!=4)throw new Error("Bad !Primary record");return r}function Rf(e,r){var t=e.l+r;var a={};a.Flags=e._R(4)&63;e.l+=4;a.AlgID=e._R(4);var n=false;switch(a.AlgID){case 26126:;case 26127:;case 26128:n=a.Flags==36;break;case 26625:n=a.Flags==4;break;case 0:n=a.Flags==16||a.Flags==4||a.Flags==36;break;default:throw"Unrecognized encryption algorithm: "+a.AlgID;}if(!n)throw new Error("Encryption Flags/AlgID mismatch");a.AlgIDHash=e._R(4);a.KeySize=e._R(4);a.ProviderType=e._R(4);e.l+=8;a.CSPName=e._R(t-e.l>>1,"utf16le");e.l=t;return a}function Df(e,r){var t={},a=e.l+r;e.l+=4;t.Salt=e.slice(e.l,e.l+16);e.l+=16;t.Verifier=e.slice(e.l,e.l+16);e.l+=16;e._R(4);t.VerifierHash=e.slice(e.l,a);e.l=a;return t}function Of(e){var r=Af(e);switch(r.Minor){case 2:return[r.Minor,Ff(e,r)];case 3:return[r.Minor,Pf(e,r)];case 4:return[r.Minor,Nf(e,r)];}throw new Error("ECMA-376 Encrypted file unrecognized Version: "+r.Minor)}function Ff(e){var r=e._R(4);if((r&63)!=36)throw new Error("EncryptionInfo mismatch");var t=e._R(4);var a=Rf(e,t);var n=Df(e,e.length-e.l);return{t:"Std",h:a,v:n}}function Pf(){throw new Error("File is password-protected: ECMA-376 Extensible")}function Nf(e){var r=["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];e.l+=4;var t=e._R(e.length-e.l,"utf8");var a={};t.replace(_e,function n(e){var t=ye(e);switch(xe(t[0])){case"<?xml":break;case"<encryption":;case"</encryption>":break;case"<keyData":r.forEach(function(e){a[e]=t[e]});break;case"<dataIntegrity":a.encryptedHmacKey=t.encryptedHmacKey;a.encryptedHmacValue=t.encryptedHmacValue;break;case"<keyEncryptors>":;case"<keyEncryptors":a.encs=[];break;case"</keyEncryptors>":break;case"<keyEncryptor":a.uri=t.uri;break;case"</keyEncryptor>":break;case"<encryptedKey":a.encs.push(t);break;default:throw t[0];}});return a}function Lf(e,r){var t={};var a=t.EncryptionVersionInfo=Af(e,4);r-=4;if(a.Minor!=2)throw new Error("unrecognized minor version code: "+a.Minor);if(a.Major>4||a.Major<2)throw new Error("unrecognized major version code: "+a.Major);t.Flags=e._R(4);r-=4;var n=e._R(4);r-=4;t.EncryptionHeader=Rf(e,n);r-=n;t.EncryptionVerifier=Df(e,r);return t}function Mf(e){var r={};var t=r.EncryptionVersionInfo=Af(e,4);if(t.Major!=1||t.Minor!=1)throw"unrecognized version code "+t.Major+" : "+t.Minor;r.Salt=e._R(16);r.EncryptedVerifier=e._R(16);r.EncryptedVerifierHash=e._R(16);return r}function Uf(e){var r=0,t;var a=Sf(e);var n=a.length+1,i,s;var f,o,l;t=k(n);t[0]=a.length;for(i=1;i!=n;++i)t[i]=a[i-1];for(i=n-1;i>=0;--i){s=t[i];f=(r&16384)===0?0:1;o=r<<1&32767;l=f|o;r=l^s}return r^52811}var Hf=function(){var e=[187,255,255,186,255,255,185,128,0,190,15,0,191,15,0];var r=[57840,7439,52380,33984,4364,3600,61902,12606,6258,57657,54287,34041,10252,43370,20163];var t=[44796,19929,39858,10053,20106,40212,10761,31585,63170,64933,60267,50935,40399,11199,17763,35526,1453,2906,5812,11624,23248,885,1770,3540,7080,14160,28320,56640,55369,41139,20807,41614,21821,43642,17621,28485,56970,44341,19019,38038,14605,29210,60195,50791,40175,10751,21502,43004,24537,18387,36774,3949,7898,15796,31592,63184,47201,24803,49606,37805,14203,28406,56812,17824,35648,1697,3394,6788,13576,27152,43601,17539,35078,557,1114,2228,4456,30388,60776,51953,34243,7079,14158,28316,14128,28256,56512,43425,17251,34502,7597,13105,26210,52420,35241,883,1766,3532,4129,8258,16516,33032,4657,9314,18628];var a=function(e){return(e/2|e*128)&255};var n=function(e,r){return a(e^r)};var i=function(e){var a=r[e.length-1];var n=104;for(var i=e.length-1;i>=0;--i){var s=e[i];for(var f=0;f!=7;++f){if(s&64)a^=t[n];s*=2;--n}}return a};return function(r){var t=Sf(r);var a=i(t);var s=t.length;var f=k(16);for(var o=0;o!=16;++o)f[o]=0;var l,c,h;if((s&1)===1){l=a>>8;f[s]=n(e[0],l);--s;l=a&255;c=t[t.length-1];f[s]=n(c,l)}while(s>0){--s;l=a>>8;f[s]=n(t[s],l);--s;l=a&255;f[s]=n(t[s],l)}s=15;h=15-t.length;while(h>0){l=a>>8;f[s]=n(e[h],l);--s;--h;l=a&255;f[s]=n(t[s],l);--s;--h}return f}}();var Wf=function(e,r,t,a,n){if(!n)n=r;if(!a)a=Hf(e);var i,s;for(i=0;i!=r.length;++i){s=r[i];s^=a[t];s=(s>>5|s<<3)&255;n[i]=s;++t}return[n,t,a]};var Vf=function(e){var r=0,t=Hf(e);return function(e){var a=Wf("",e,r,t);r=a[1];return a[0]}};function zf(e,r,t,a){var n={key:Hn(e),verificationBytes:Hn(e)};if(t.password)n.verifier=Uf(t.password);a.valid=n.verificationBytes===n.verifier;if(a.valid)a.insitu=Vf(t.password);return n}function Xf(e,r,t){var a=t||{};a.Info=e._R(2);e.l-=2;if(a.Info===1)a.Data=Mf(e,r);else a.Data=Lf(e,r);return a}function Gf(e,r,t){var a={Type:t.biff>=8?e._R(2):0};if(a.Type)Xf(e,r-2,a);else zf(e,t.biff>=8?r:r-2,t,a);return a}var jf=function(){function e(e,t){switch(t.type){case"base64":return r(m.decode(e),t);case"binary":return r(e,t);case"buffer":return r(e.toString("binary"),t);case"array":return r(se(e),t);}throw new Error("Unrecognized type "+t.type)}function r(e,r){var t=r||{};var a=t.dense?[]:{};var n={s:{c:0,r:0},e:{c:0,r:0}};if(!e.match(/\\trowd/))throw new Error("RTF missing table");a["!ref"]=dt(n);return a}function t(r,t){return mt(e(r,t),t)}function a(e){var r=["{\\rtf1\\ansi"];var t=pt(e["!ref"]),a;var n=Array.isArray(e);for(var i=t.s.r;i<=t.e.r;++i){r.push("\\trowd\\trautofit1");for(var s=t.s.c;s<=t.e.c;++s)r.push("\\cellx"+(s+1));r.push("\\pard\\intbl");for(s=t.s.c;s<=t.e.c;++s){var f=ht({r:i,c:s});a=n?(e[i]||[])[s]:e[f];if(!a||a.v==null&&(!a.f||a.F))continue;r.push(" "+(a.w||(gt(a),a.w)));r.push("\\cell")}r.push("\\pard\\intbl\\row")}return r.join("")+"}"}return{to_workbook:t,to_sheet:e,from_sheet:a}}();function Kf(e){var r=e.slice(e[0]==="#"?1:0).slice(0,6);return[parseInt(r.slice(0,2),16),parseInt(r.slice(2,4),16),parseInt(r.slice(4,6),16)]}function Yf(e){for(var r=0,t=1;r!=3;++r)t=t*256+(e[r]>255?255:e[r]<0?0:e[r]);return t.toString(16).toUpperCase().slice(1)}function $f(e){var r=e[0]/255,t=e[1]/255,a=e[2]/255;var n=Math.max(r,t,a),i=Math.min(r,t,a),s=n-i;if(s===0)return[0,0,r];var f=0,o=0,l=n+i;o=s/(l>1?2-l:l);switch(n){case r:f=((t-a)/s+6)%6;break;case t:f=(a-r)/s+2;break;case a:f=(r-t)/s+4;break;}return[f/6,o,l/2]}function Zf(e){var r=e[0],t=e[1],a=e[2];var n=t*2*(a<.5?a:1-a),i=a-n/2;var s=[i,i,i],f=6*r;var o;if(t!==0)switch(f|0){case 0:;case 6:o=n*f;s[0]+=n;s[1]+=o;break;case 1:o=n*(2-f);s[0]+=o;s[1]+=n;break;case 2:o=n*(f-2);s[1]+=n;s[2]+=o;break;case 3:o=n*(4-f);s[1]+=o;s[2]+=n;break;case 4:o=n*(f-4);s[2]+=n;s[0]+=o;break;case 5:o=n*(6-f);s[2]+=o;s[0]+=n;break;}for(var l=0;l!=3;++l)s[l]=Math.round(s[l]*255);return s}function Qf(e,r){if(r===0)return e;var t=$f(Kf(e));if(r<0)t[2]=t[2]*(1+r);else t[2]=1-(1-t[2])*(1-r);return Yf(Zf(t))}var Jf=6,qf=15,eo=1,ro=Jf;function to(e){return Math.floor((e+Math.round(128/ro)/256)*ro)}function ao(e){return Math.floor((e-5)/ro*100+.5)/100}function no(e){return Math.round((e*ro+5)/ro*256)/256}function io(e){return no(ao(to(e)))}function so(e){var r=Math.abs(e-io(e)),t=ro;if(r>.005)for(ro=eo;ro<qf;++ro)if(Math.abs(e-io(e))<=r){r=Math.abs(e-io(e));t=ro}ro=t}function fo(e){
if(e.width){e.wpx=to(e.width);e.wch=ao(e.wpx);e.MDW=ro}else if(e.wpx){e.wch=ao(e.wpx);e.width=no(e.wch);e.MDW=ro}else if(typeof e.wch=="number"){e.width=no(e.wch);e.wpx=to(e.width);e.MDW=ro}if(e.customWidth)delete e.customWidth}var oo=96,lo=oo;function co(e){return e*96/lo}function ho(e){return e*lo/96}var uo={None:"none",Solid:"solid",Gray50:"mediumGray",Gray75:"darkGray",Gray25:"lightGray",HorzStripe:"darkHorizontal",VertStripe:"darkVertical",ReverseDiagStripe:"darkDown",DiagStripe:"darkUp",DiagCross:"darkGrid",ThickDiagCross:"darkTrellis",ThinHorzStripe:"lightHorizontal",ThinVertStripe:"lightVertical",ThinReverseDiagStripe:"lightDown",ThinHorzCross:"lightGrid"};function po(e,r,t,a){r.Borders=[];var n={};var i=false;e[0].match(_e).forEach(function(e){var t=ye(e);switch(xe(t[0])){case"<borders":;case"<borders>":;case"</borders>":break;case"<border":;case"<border>":;case"<border/>":n={};if(t.diagonalUp){n.diagonalUp=t.diagonalUp}if(t.diagonalDown){n.diagonalDown=t.diagonalDown}r.Borders.push(n);break;case"</border>":break;case"<left/>":break;case"<left":;case"<left>":break;case"</left>":break;case"<right/>":break;case"<right":;case"<right>":break;case"</right>":break;case"<top/>":break;case"<top":;case"<top>":break;case"</top>":break;case"<bottom/>":break;case"<bottom":;case"<bottom>":break;case"</bottom>":break;case"<diagonal":;case"<diagonal>":;case"<diagonal/>":break;case"</diagonal>":break;case"<horizontal":;case"<horizontal>":;case"<horizontal/>":break;case"</horizontal>":break;case"<vertical":;case"<vertical>":;case"<vertical/>":break;case"</vertical>":break;case"<start":;case"<start>":;case"<start/>":break;case"</start>":break;case"<end":;case"<end>":;case"<end/>":break;case"</end>":break;case"<color":;case"<color>":break;case"<color/>":;case"</color>":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":i=true;break;case"</ext>":i=false;break;default:if(a&&a.WTF){if(!i)throw new Error("unrecognized "+t[0]+" in borders")};}})}function vo(e,r,t,a){r.Fills=[];var n={};var i=false;e[0].match(_e).forEach(function(e){var t=ye(e);switch(xe(t[0])){case"<fills":;case"<fills>":;case"</fills>":break;case"<fill>":;case"<fill":;case"<fill/>":n={};r.Fills.push(n);break;case"</fill>":break;case"<gradientFill>":break;case"<gradientFill":;case"</gradientFill>":r.Fills.push(n);n={};break;case"<patternFill":;case"<patternFill>":if(t.patternType)n.patternType=t.patternType;break;case"<patternFill/>":;case"</patternFill>":break;case"<bgColor":if(!n.bgColor)n.bgColor={};if(t.indexed)n.bgColor.indexed=parseInt(t.indexed,10);if(t.theme)n.bgColor.theme=parseInt(t.theme,10);if(t.tint)n.bgColor.tint=parseFloat(t.tint);if(t.rgb)n.bgColor.rgb=t.rgb.slice(-6);break;case"<bgColor/>":;case"</bgColor>":break;case"<fgColor":if(!n.fgColor)n.fgColor={};if(t.theme)n.fgColor.theme=parseInt(t.theme,10);if(t.tint)n.fgColor.tint=parseFloat(t.tint);if(t.rgb)n.fgColor.rgb=t.rgb.slice(-6);break;case"<fgColor/>":;case"</fgColor>":break;case"<stop":;case"<stop/>":break;case"</stop>":break;case"<color":;case"<color/>":break;case"</color>":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":i=true;break;case"</ext>":i=false;break;default:if(a&&a.WTF){if(!i)throw new Error("unrecognized "+t[0]+" in fills")};}})}function go(e,r,t,a){r.Fonts=[];var n={};var s=false;e[0].match(_e).forEach(function(e){var f=ye(e);switch(xe(f[0])){case"<fonts":;case"<fonts>":;case"</fonts>":break;case"<font":;case"<font>":break;case"</font>":;case"<font/>":r.Fonts.push(n);n={};break;case"<name":if(f.val)n.name=f.val;break;case"<name/>":;case"</name>":break;case"<b":n.bold=f.val?Ve(f.val):1;break;case"<b/>":n.bold=1;break;case"<i":n.italic=f.val?Ve(f.val):1;break;case"<i/>":n.italic=1;break;case"<u":switch(f.val){case"none":n.underline=0;break;case"single":n.underline=1;break;case"double":n.underline=2;break;case"singleAccounting":n.underline=33;break;case"doubleAccounting":n.underline=34;break;}break;case"<u/>":n.underline=1;break;case"<strike":n.strike=f.val?Ve(f.val):1;break;case"<strike/>":n.strike=1;break;case"<outline":n.outline=f.val?Ve(f.val):1;break;case"<outline/>":n.outline=1;break;case"<shadow":n.shadow=f.val?Ve(f.val):1;break;case"<shadow/>":n.shadow=1;break;case"<condense":n.condense=f.val?Ve(f.val):1;break;case"<condense/>":n.condense=1;break;case"<extend":n.extend=f.val?Ve(f.val):1;break;case"<extend/>":n.extend=1;break;case"<sz":if(f.val)n.sz=+f.val;break;case"<sz/>":;case"</sz>":break;case"<vertAlign":if(f.val)n.vertAlign=f.val;break;case"<vertAlign/>":;case"</vertAlign>":break;case"<family":if(f.val)n.family=parseInt(f.val,10);break;case"<family/>":;case"</family>":break;case"<scheme":if(f.val)n.scheme=f.val;break;case"<scheme/>":;case"</scheme>":break;case"<charset":if(f.val=="1")break;f.codepage=i[parseInt(f.val,10)];break;case"<color":if(!n.color)n.color={};if(f.auto)n.color.auto=Ve(f.auto);if(f.rgb)n.color.rgb=f.rgb.slice(-6);else if(f.indexed){n.color.index=parseInt(f.indexed,10);var o=ka[n.color.index];if(n.color.index==81)o=ka[1];if(!o)throw new Error(e);n.color.rgb=o[0].toString(16)+o[1].toString(16)+o[2].toString(16)}else if(f.theme){n.color.theme=parseInt(f.theme,10);if(f.tint)n.color.tint=parseFloat(f.tint);if(f.theme&&t.themeElements&&t.themeElements.clrScheme){n.color.rgb=Qf(t.themeElements.clrScheme[n.color.theme].rgb,n.color.tint||0)}}break;case"<color/>":;case"</color>":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":s=true;break;case"</ext>":s=false;break;default:if(a&&a.WTF){if(!s)throw new Error("unrecognized "+f[0]+" in fonts")};}})}function mo(e,r,t){r.NumberFmt=[];var a=j(D._table);for(var n=0;n<a.length;++n)r.NumberFmt[a[n]]=D._table[a[n]];var i=e[0].match(_e);if(!i)return;for(n=0;n<i.length;++n){var s=ye(i[n]);switch(xe(s[0])){case"<numFmts":;case"</numFmts>":;case"<numFmts/>":;case"<numFmts>":break;case"<numFmt":{var f=De(ze(s.formatCode)),o=parseInt(s.numFmtId,10);r.NumberFmt[o]=f;if(o>0){if(o>392){for(o=392;o>60;--o)if(r.NumberFmt[o]==null)break;r.NumberFmt[o]=f}D.load(f,o)}}break;case"</numFmt>":break;default:if(t.WTF)throw new Error("unrecognized "+s[0]+" in numFmts");}}}function bo(e){var r=["<numFmts>"];[[5,8],[23,26],[41,44],[50,392]].forEach(function(t){for(var a=t[0];a<=t[1];++a)if(e[a]!=null)r[r.length]=ar("numFmt",null,{numFmtId:a,formatCode:Pe(e[a])})});if(r.length===1)return"";r[r.length]="</numFmts>";r[0]=ar("numFmts",null,{count:r.length-2}).replace("/>",">");return r.join("")}var wo=["numFmtId","fillId","fontId","borderId","xfId"];var Co=["applyAlignment","applyBorder","applyFill","applyFont","applyNumberFormat","applyProtection","pivotButton","quotePrefix"];function Eo(e,r,t){r.CellXf=[];var a;var n=false;e[0].match(_e).forEach(function(e){var i=ye(e),s=0;switch(xe(i[0])){case"<cellXfs":;case"<cellXfs>":;case"<cellXfs/>":;case"</cellXfs>":break;case"<xf":;case"<xf/>":a=i;delete a[0];for(s=0;s<wo.length;++s)if(a[wo[s]])a[wo[s]]=parseInt(a[wo[s]],10);for(s=0;s<Co.length;++s)if(a[Co[s]])a[Co[s]]=Ve(a[Co[s]]);if(a.numFmtId>392){for(s=392;s>60;--s)if(r.NumberFmt[a.numFmtId]==r.NumberFmt[s]){a.numFmtId=s;break}}r.CellXf.push(a);break;case"</xf>":break;case"<alignment":;case"<alignment/>":var f={};if(i.vertical)f.vertical=i.vertical;if(i.horizontal)f.horizontal=i.horizontal;if(i.textRotation!=null)f.textRotation=i.textRotation;if(i.indent)f.indent=i.indent;if(i.wrapText)f.wrapText=i.wrapText;a.alignment=f;break;case"</alignment>":break;case"<protection":;case"</protection>":;case"<protection/>":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":n=true;break;case"</ext>":n=false;break;default:if(t&&t.WTF){if(!n)throw new Error("unrecognized "+i[0]+" in cellXfs")};}})}function ko(e){var r=[];r[r.length]=ar("cellXfs",null);e.forEach(function(e){r[r.length]=ar("xf",null,e)});r[r.length]="</cellXfs>";if(r.length===2)return"";r[0]=ar("cellXfs",null,{count:r.length-2}).replace("/>",">");return r.join("")}var So=function sm(){var e=/<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;var r=/<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;var t=/<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;var a=/<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;var n=/<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;return function i(s,f,o){var l={};if(!s)return l;s=s.replace(/<!--([\s\S]*?)-->/gm,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");var c;if(c=s.match(e))mo(c,l,o);if(c=s.match(a))go(c,l,f,o);if(c=s.match(t))vo(c,l,f,o);if(c=s.match(n))po(c,l,f,o);if(c=s.match(r))Eo(c,l,o);return l}}();var Ao=ar("styleSheet",null,{xmlns:sr.main[0],"xmlns:vt":sr.vt});Ra.STY="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";function _o(e,r){var t=[Se,Ao],a;if(e.SSF&&(a=bo(e.SSF))!=null)t[t.length]=a;t[t.length]='<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';t[t.length]='<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';t[t.length]='<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';t[t.length]='<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';if(a=ko(r.cellXfs))t[t.length]=a;t[t.length]='<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';t[t.length]='<dxfs count="0"/>';t[t.length]='<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';if(t.length>2){t[t.length]="</styleSheet>";t[1]=t[1].replace("/>",">")}return t.join("")}function Bo(e,r){var t=e._R(2);var a=Et(e,r-2);return[t,a]}function To(e,r,t){if(!t)t=Gr(6+4*r.length);t._W(2,e);kt(r,t);var a=t.length>t.l?t.slice(0,t.l):t;if(t.l==null)t.l=t.length;return a}function yo(e,r,t){var a={};a.sz=e._R(2)/20;var n=Zt(e,2,t);if(n.fCondense)a.condense=1;if(n.fExtend)a.extend=1;if(n.fShadow)a.shadow=1;if(n.fOutline)a.outline=1;if(n.fStrikeout)a.strike=1;if(n.fItalic)a.italic=1;var i=e._R(2);if(i===700)a.bold=1;switch(e._R(2)){case 1:a.vertAlign="superscript";break;case 2:a.vertAlign="subscript";break;}var s=e._R(1);if(s!=0)a.underline=s;var f=e._R(1);if(f>0)a.family=f;var o=e._R(1);if(o>0)a.charset=o;e.l++;a.color=Yt(e,8);switch(e._R(1)){case 1:a.scheme="major";break;case 2:a.scheme="minor";break;}a.name=Et(e,r-21);return a}function xo(e,r){if(!r)r=Gr(25+4*32);r._W(2,e.sz*20);Qt(e,r);r._W(2,e.bold?700:400);var t=0;if(e.vertAlign=="superscript")t=1;else if(e.vertAlign=="subscript")t=2;r._W(2,t);r._W(1,e.underline||0);r._W(1,e.family||0);r._W(1,e.charset||0);r._W(1,0);$t(e.color,r);var a=0;if(e.scheme=="major")a=1;if(e.scheme=="minor")a=2;r._W(1,a);kt(e.name,r);return r.length>r.l?r.slice(0,r.l):r}var Io=["none","solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];var Ro=Y(Io);var Do=Xr;function Oo(e,r){if(!r)r=Gr(4*3+8*7+16*1);var t=Ro[e.patternType];if(t==null)t=40;r._W(4,t);var a=0;if(t!=40){$t({auto:1},r);$t({auto:1},r);for(;a<12;++a)r._W(4,0)}else{for(;a<4;++a)r._W(4,0);for(;a<12;++a)r._W(4,0)}return r.length>r.l?r.slice(0,r.l):r}function Fo(e,r){var t=e.l+r;var a=e._R(2);var n=e._R(2);e.l=t;return{ixfe:a,numFmtId:n}}function Po(e,r,t){if(!t)t=Gr(16);t._W(2,r||0);t._W(2,e.numFmtId||0);t._W(2,0);t._W(2,0);t._W(2,0);t._W(1,0);t._W(1,0);t._W(1,0);t._W(1,0);t._W(1,0);t._W(1,0);return t}function No(e,r){if(!r)r=Gr(10);r._W(1,0);r._W(1,0);r._W(4,0);r._W(4,0);return r}var Lo=Xr;function Mo(e,r){if(!r)r=Gr(51);r._W(1,0);No(null,r);No(null,r);No(null,r);No(null,r);No(null,r);return r.length>r.l?r.slice(0,r.l):r}function Uo(e,r){if(!r)r=Gr(12+4*10);r._W(4,e.xfId);r._W(2,1);r._W(1,+e.builtinId);r._W(1,0);Ft(e.name||"",r);return r.length>r.l?r.slice(0,r.l):r}function Ho(e,r,t){var a=Gr(4+256*2*4);a._W(4,e);Ft(r,a);Ft(t,a);return a.length>a.l?a.slice(0,a.l):a}function Wo(e,r,t){var a={};a.NumberFmt=[];for(var n in D._table)a.NumberFmt[n]=D._table[n];a.CellXf=[];a.Fonts=[];var i=[];var s=false;jr(e,function f(e,n,o){switch(o){case 44:a.NumberFmt[e[0]]=e[1];D.load(e[1],e[0]);break;case 43:a.Fonts.push(e);if(e.color.theme!=null&&r&&r.themeElements&&r.themeElements.clrScheme){e.color.rgb=Qf(r.themeElements.clrScheme[e.color.theme].rgb,e.color.tint||0)}break;case 1025:break;case 45:break;case 46:break;case 47:if(i[i.length-1]=="BrtBeginCellXFs"){a.CellXf.push(e)}break;case 48:;case 507:;case 572:;case 475:break;case 1171:;case 2102:;case 1130:;case 512:;case 2095:;case 3072:break;case 35:s=true;break;case 36:s=false;break;case 37:i.push(n);break;case 38:i.pop();break;default:if((n||"").indexOf("Begin")>0)i.push(n);else if((n||"").indexOf("End")>0)i.pop();else if(!s||t.WTF)throw new Error("Unexpected record "+o+" "+n);}});return a}function Vo(e,r){if(!r)return;var t=0;[[5,8],[23,26],[41,44],[50,392]].forEach(function(e){for(var a=e[0];a<=e[1];++a)if(r[a]!=null)++t});if(t==0)return;Yr(e,"BrtBeginFmts",Ct(t));[[5,8],[23,26],[41,44],[50,392]].forEach(function(t){for(var a=t[0];a<=t[1];++a)if(r[a]!=null)Yr(e,"BrtFmt",To(a,r[a]))});Yr(e,"BrtEndFmts")}function zo(e){var r=1;if(r==0)return;Yr(e,"BrtBeginFonts",Ct(r));Yr(e,"BrtFont",xo({sz:12,color:{theme:1},name:"Calibri",family:2,scheme:"minor"}));Yr(e,"BrtEndFonts")}function Xo(e){var r=2;if(r==0)return;Yr(e,"BrtBeginFills",Ct(r));Yr(e,"BrtFill",Oo({patternType:"none"}));Yr(e,"BrtFill",Oo({patternType:"gray125"}));Yr(e,"BrtEndFills")}function Go(e){var r=1;if(r==0)return;Yr(e,"BrtBeginBorders",Ct(r));Yr(e,"BrtBorder",Mo({}));Yr(e,"BrtEndBorders")}function jo(e){var r=1;Yr(e,"BrtBeginCellStyleXFs",Ct(r));Yr(e,"BrtXF",Po({numFmtId:0,fontId:0,fillId:0,borderId:0},65535));Yr(e,"BrtEndCellStyleXFs")}function Ko(e,r){Yr(e,"BrtBeginCellXFs",Ct(r.length));r.forEach(function(r){Yr(e,"BrtXF",Po(r,0))});Yr(e,"BrtEndCellXFs")}function Yo(e){var r=1;Yr(e,"BrtBeginStyles",Ct(r));Yr(e,"BrtStyle",Uo({xfId:0,builtinId:0,name:"Normal"}));Yr(e,"BrtEndStyles")}function $o(e){var r=0;Yr(e,"BrtBeginDXFs",Ct(r));Yr(e,"BrtEndDXFs")}function Zo(e){var r=0;Yr(e,"BrtBeginTableStyles",Ho(r,"TableStyleMedium9","PivotStyleMedium4"));Yr(e,"BrtEndTableStyles")}function Qo(){return}function Jo(e,r){var t=Kr();Yr(t,"BrtBeginStyleSheet");Vo(t,e.SSF);zo(t,e);Xo(t,e);Go(t,e);jo(t,e);Ko(t,r.cellXfs);Yo(t,e);$o(t,e);Zo(t,e);Qo(t,e);Yr(t,"BrtEndStyleSheet");return t.end()}Ra.THEME="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";function qo(e,r,t){r.themeElements.clrScheme=[];var a={};(e[0].match(_e)||[]).forEach(function(e){var n=ye(e);switch(n[0]){case"<a:clrScheme":;case"</a:clrScheme>":break;case"<a:srgbClr":a.rgb=n.val;break;case"<a:sysClr":a.rgb=n.lastClr;break;case"<a:dk1>":;case"</a:dk1>":;case"<a:lt1>":;case"</a:lt1>":;case"<a:dk2>":;case"</a:dk2>":;case"<a:lt2>":;case"</a:lt2>":;case"<a:accent1>":;case"</a:accent1>":;case"<a:accent2>":;case"</a:accent2>":;case"<a:accent3>":;case"</a:accent3>":;case"<a:accent4>":;case"</a:accent4>":;case"<a:accent5>":;case"</a:accent5>":;case"<a:accent6>":;case"</a:accent6>":;case"<a:hlink>":;case"</a:hlink>":;case"<a:folHlink>":;case"</a:folHlink>":if(n[0].charAt(1)==="/"){r.themeElements.clrScheme.push(a);a={}}else{a.name=n[0].slice(3,n[0].length-1)}break;default:if(t&&t.WTF)throw new Error("Unrecognized "+n[0]+" in clrScheme");}})}function el(){}function rl(){}var tl=/<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;var al=/<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;var nl=/<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;function il(e,r,t){r.themeElements={};var a;[["clrScheme",tl,qo],["fontScheme",al,el],["fmtScheme",nl,rl]].forEach(function(n){if(!(a=e.match(n[1])))throw new Error(n[0]+" not found in themeElements");n[2](a,r,t)})}var sl=/<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;function fl(e,r){if(!e||e.length===0)return fl(ol());var t;var a={};if(!(t=e.match(sl)))throw new Error("themeElements not found in theme");il(t[0],a,r);return a}function ol(e,r){if(r&&r.themeXLSX)return r.themeXLSX;var t=[Se];t[t.length]='<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';t[t.length]="<a:themeElements>";t[t.length]='<a:clrScheme name="Office">';t[t.length]='<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';t[t.length]='<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';t[t.length]='<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';t[t.length]='<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';t[t.length]='<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';t[t.length]='<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';t[t.length]='<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';t[t.length]='<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';t[t.length]='<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';t[t.length]='<a:accent6><a:srgbClr val="F79646"/></a:accent6>';t[t.length]='<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';t[t.length]='<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';t[t.length]="</a:clrScheme>";t[t.length]='<a:fontScheme name="Office">';t[t.length]="<a:majorFont>";t[t.length]='<a:latin typeface="Cambria"/>';t[t.length]='<a:ea typeface=""/>';t[t.length]='<a:cs typeface=""/>';t[t.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';t[t.length]='<a:font script="Hang" typeface="맑은 고딕"/>';t[t.length]='<a:font script="Hans" typeface="宋体"/>';t[t.length]='<a:font script="Hant" typeface="新細明體"/>';t[t.length]='<a:font script="Arab" typeface="Times New Roman"/>';t[t.length]='<a:font script="Hebr" typeface="Times New Roman"/>';t[t.length]='<a:font script="Thai" typeface="Tahoma"/>';t[t.length]='<a:font script="Ethi" typeface="Nyala"/>';t[t.length]='<a:font script="Beng" typeface="Vrinda"/>';t[t.length]='<a:font script="Gujr" typeface="Shruti"/>';t[t.length]='<a:font script="Khmr" typeface="MoolBoran"/>';t[t.length]='<a:font script="Knda" typeface="Tunga"/>';t[t.length]='<a:font script="Guru" typeface="Raavi"/>';t[t.length]='<a:font script="Cans" typeface="Euphemia"/>';t[t.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';t[t.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';t[t.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';t[t.length]='<a:font script="Thaa" typeface="MV Boli"/>';t[t.length]='<a:font script="Deva" typeface="Mangal"/>';t[t.length]='<a:font script="Telu" typeface="Gautami"/>';t[t.length]='<a:font script="Taml" typeface="Latha"/>';t[t.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';t[t.length]='<a:font script="Orya" typeface="Kalinga"/>';t[t.length]='<a:font script="Mlym" typeface="Kartika"/>';t[t.length]='<a:font script="Laoo" typeface="DokChampa"/>';t[t.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';t[t.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';t[t.length]='<a:font script="Viet" typeface="Times New Roman"/>';t[t.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';t[t.length]='<a:font script="Geor" typeface="Sylfaen"/>';t[t.length]="</a:majorFont>";t[t.length]="<a:minorFont>";t[t.length]='<a:latin typeface="Calibri"/>';t[t.length]='<a:ea typeface=""/>';t[t.length]='<a:cs typeface=""/>';t[t.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';t[t.length]='<a:font script="Hang" typeface="맑은 고딕"/>';t[t.length]='<a:font script="Hans" typeface="宋体"/>';t[t.length]='<a:font script="Hant" typeface="新細明體"/>';t[t.length]='<a:font script="Arab" typeface="Arial"/>';t[t.length]='<a:font script="Hebr" typeface="Arial"/>';t[t.length]='<a:font script="Thai" typeface="Tahoma"/>';t[t.length]='<a:font script="Ethi" typeface="Nyala"/>';t[t.length]='<a:font script="Beng" typeface="Vrinda"/>';t[t.length]='<a:font script="Gujr" typeface="Shruti"/>';t[t.length]='<a:font script="Khmr" typeface="DaunPenh"/>';t[t.length]='<a:font script="Knda" typeface="Tunga"/>';t[t.length]='<a:font script="Guru" typeface="Raavi"/>';t[t.length]='<a:font script="Cans" typeface="Euphemia"/>';t[t.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';t[t.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';t[t.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';t[t.length]='<a:font script="Thaa" typeface="MV Boli"/>';t[t.length]='<a:font script="Deva" typeface="Mangal"/>';t[t.length]='<a:font script="Telu" typeface="Gautami"/>';t[t.length]='<a:font script="Taml" typeface="Latha"/>';t[t.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';t[t.length]='<a:font script="Orya" typeface="Kalinga"/>';t[t.length]='<a:font script="Mlym" typeface="Kartika"/>';t[t.length]='<a:font script="Laoo" typeface="DokChampa"/>';t[t.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';t[t.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';t[t.length]='<a:font script="Viet" typeface="Arial"/>';t[t.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';t[t.length]='<a:font script="Geor" typeface="Sylfaen"/>';t[t.length]="</a:minorFont>";t[t.length]="</a:fontScheme>";t[t.length]='<a:fmtScheme name="Office">';t[t.length]="<a:fillStyleLst>";t[t.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:lin ang="16200000" scaled="1"/>';t[t.length]="</a:gradFill>";t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:lin ang="16200000" scaled="0"/>';t[t.length]="</a:gradFill>";t[t.length]="</a:fillStyleLst>";t[t.length]="<a:lnStyleLst>";t[t.length]='<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';t[t.length]='<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';t[t.length]='<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';t[t.length]="</a:lnStyleLst>";t[t.length]="<a:effectStyleLst>";t[t.length]="<a:effectStyle>";t[t.length]="<a:effectLst>";t[t.length]='<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';t[t.length]="</a:effectLst>";t[t.length]="</a:effectStyle>";t[t.length]="<a:effectStyle>";t[t.length]="<a:effectLst>";t[t.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';t[t.length]="</a:effectLst>";t[t.length]="</a:effectStyle>";t[t.length]="<a:effectStyle>";t[t.length]="<a:effectLst>";t[t.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';t[t.length]="</a:effectLst>";t[t.length]='<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';t[t.length]='<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';t[t.length]="</a:effectStyle>";t[t.length]="</a:effectStyleLst>";t[t.length]="<a:bgFillStyleLst>";t[t.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';t[t.length]="</a:gradFill>";t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';t[t.length]="</a:gradFill>";t[t.length]="</a:bgFillStyleLst>";t[t.length]="</a:fmtScheme>";t[t.length]="</a:themeElements>";t[t.length]="<a:objectDefaults>";t[t.length]="<a:spDef>";t[t.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';t[t.length]="</a:spDef>";t[t.length]="<a:lnDef>";t[t.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';t[t.length]="</a:lnDef>";t[t.length]="</a:objectDefaults>";t[t.length]="<a:extraClrSchemeLst/>";t[t.length]="</a:theme>";return t.join("")}function ll(e,r,t){var a=e.l+r;var n=e._R(4);if(n===124226)return;if(!t.cellStyles||!Ee){e.l=a;return}var i=e.slice(e.l);e.l=a;var s;try{s=new Ee(i)}catch(f){return}var o=we(s,"theme/theme/theme1.xml",true);if(!o)return;return fl(o,t)}function cl(e){return e._R(4)}function hl(e){var r={};r.xclrType=e._R(2);r.nTintShade=e._R(2);switch(r.xclrType){case 0:e.l+=4;break;case 1:r.xclrValue=ul(e,4);break;case 2:r.xclrValue=ni(e,4);break;case 3:r.xclrValue=cl(e,4);break;case 4:e.l+=4;break;}e.l+=8;return r}function ul(e,r){return Xr(e,r)}function dl(e,r){return Xr(e,r)}function pl(e){var r=e._R(2);var t=e._R(2)-4;var a=[r];switch(r){case 4:;case 5:;case 7:;case 8:;case 9:;case 10:;case 11:;case 13:a[1]=hl(e,t);break;case 6:a[1]=dl(e,t);break;case 14:;case 15:a[1]=e._R(t===1?1:2);break;default:throw new Error("Unrecognized ExtProp type: "+r+" "+t);}return a}function vl(e,r){var t=e.l+r;e.l+=2;var a=e._R(2);e.l+=2;var n=e._R(2);var i=[];while(n-- >0)i.push(pl(e,t-e.l));return{ixfe:a,ext:i}}function gl(e,r){r.forEach(function(e){switch(e[0]){case 4:break;case 5:break;case 6:break;case 7:break;case 8:break;case 9:break;case 10:break;case 11:break;case 13:break;case 14:break;case 15:break;}})}function ml(e){var r=[];if(!e)return r;var t=1;(e.match(_e)||[]).forEach(function(e){var a=ye(e);switch(a[0]){case"<?xml":break;case"<calcChain":;case"<calcChain>":;case"</calcChain>":break;case"<c":delete a[0];if(a.i)t=a.i;else a.i=t;r.push(a);break;}});return r}function bl(e){var r={};r.i=e._R(4);var t={};t.r=e._R(4);t.c=e._R(4);r.r=ht(t);var a=e._R(1);if(a&2)r.l="1";if(a&8)r.a="1";return r}function wl(e,r,t){var a=[];var n=false;jr(e,function i(e,r,s){switch(s){case 63:a.push(e);break;default:if((r||"").indexOf("Begin")>0){}else if((r||"").indexOf("End")>0){}else if(!n||t.WTF)throw new Error("Unexpected record "+s+" "+r);}});return a}function Cl(){}function El(e,r,t){if(!e)return e;var a=t||{};var n=false,i=false;jr(e,function s(e,r,t){if(i)return;switch(t){case 359:;case 363:;case 364:;case 366:;case 367:;case 368:;case 369:;case 370:;case 371:;case 472:;case 577:;case 578:;case 579:;case 580:;case 581:;case 582:;case 583:;case 584:;case 585:;case 586:;case 587:break;case 35:n=true;break;case 36:n=false;break;default:if((r||"").indexOf("Begin")>0){}else if((r||"").indexOf("End")>0){}else if(!n||a.WTF)throw new Error("Unexpected record "+t.toString(16)+" "+r);}},a)}Ra.IMG="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";Ra.DRAW="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";function kl(e,r){if(!e)return"??";var t=(e.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];return r["!id"][t].Target}var Sl=1024;function Al(e,r){var t=[21600,21600];var a=["m0,0l0",t[1],t[0],t[1],t[0],"0xe"].join(",");var n=[ar("xml",null,{"xmlns:v":fr.v,"xmlns:o":fr.o,"xmlns:x":fr.x,"xmlns:mv":fr.mv}).replace(/\/>/,">"),ar("o:shapelayout",ar("o:idmap",null,{"v:ext":"edit",data:e}),{"v:ext":"edit"}),ar("v:shapetype",[ar("v:stroke",null,{joinstyle:"miter"}),ar("v:path",null,{gradientshapeok:"t","o:connecttype":"rect"})].join(""),{id:"_x0000_t202","o:spt":202,coordsize:t.join(","),path:a})];while(Sl<e*1e3)Sl+=1e3;r.forEach(function(e){var r=ct(e[0]);n=n.concat(["<v:shape"+tr({id:"_x0000_s"+ ++Sl,type:"#_x0000_t202",style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10"+(e[1].hidden?";visibility:hidden":""),fillcolor:"#ECFAD4",strokecolor:"#edeaa1"})+">",ar("v:fill",ar("o:fill",null,{type:"gradientUnscaled","v:ext":"view"}),{color2:"#BEFF82",angle:"-180",type:"gradient"}),ar("v:shadow",null,{on:"t",obscured:"t"}),ar("v:path",null,{"o:connecttype":"none"}),'<v:textbox><div style="text-align:left"></div></v:textbox>','<x:ClientData ObjectType="Note">',"<x:MoveWithCells/>","<x:SizeWithCells/>",rr("x:Anchor",[r.c,0,r.r,0,r.c+3,100,r.r+5,100].join(",")),rr("x:AutoFill","False"),rr("x:Row",String(r.r)),rr("x:Column",String(r.c)),e[1].hidden?"":"<x:Visible/>","</x:ClientData>","</v:shape>"])});n.push("</xml>");return n.join("")}Ra.CMNT="http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";function _l(e,r,t,a,n){for(var i=0;i!=r.length;++i){var s=r[i];var f=bp(be(e,s.replace(/^\//,""),true),s,n);if(!f||!f.length)continue;var o=j(t);for(var l=0;l!=o.length;++l){var c=o[l];var h=a[c];if(h){var u=h[s];if(u)Bl(c,t[c],f)}}}}function Bl(e,r,t){var a=Array.isArray(r);var n,i;t.forEach(function(e){if(a){i=ct(e.ref);if(!r[i.r])r[i.r]=[];n=r[i.r][i.c]}else n=r[e.ref];if(!n){n={};if(a)r[i.r][i.c]=n;else r[e.ref]=n;var t=pt(r["!ref"]||"BDWGO1000001:A1");var s=ct(e.ref);if(t.s.r>s.r)t.s.r=s.r;if(t.e.r<s.r)t.e.r=s.r;if(t.s.c>s.c)t.s.c=s.c;if(t.e.c<s.c)t.e.c=s.c;var f=dt(t);if(f!==r["!ref"])r["!ref"]=f}if(!n.c)n.c=[];var o={a:e.author,t:e.t,r:e.r};if(e.h)o.h=e.h;n.c.push(o)})}function Tl(e,r){if(e.match(/<(?:\w+:)?comments *\/>/))return[];var t=[];var a=[];var n=e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);if(n&&n[1])n[1].split(/<\/\w*:?author>/).forEach(function(e){if(e===""||e.trim()==="")return;var r=e.match(/<(?:\w+:)?author[^>]*>(.*)/);if(r)t.push(r[1])});var i=e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);if(i&&i[1])i[1].split(/<\/\w*:?comment>/).forEach(function(e){if(e===""||e.trim()==="")return;var n=e.match(/<(?:\w+:)?comment[^>]*>/);if(!n)return;var i=ye(n[0]);var s={author:i.authorId&&t[i.authorId]||"sheetjsghost",ref:i.ref,guid:i.guid};var f=ct(i.ref);if(r.sheetRows&&r.sheetRows<=f.r)return;
var o=e.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);var l=!!o&&!!o[1]&&hf(o[1])||{r:"",t:"",h:""};s.r=l.r;if(l.r=="<t></t>")l.t=l.h="";s.t=l.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");if(r.cellHTML)s.h=l.h;a.push(s)});return a}var yl=ar("comments",null,{xmlns:sr.main[0]});function xl(e){var r=[Se,yl];var t=[];r.push("<authors>");e.forEach(function(e){e[1].forEach(function(e){var a=Pe(e.a);if(t.indexOf(a)>-1)return;t.push(a);r.push("<author>"+a+"</author>")})});r.push("</authors>");r.push("<commentList>");e.forEach(function(e){e[1].forEach(function(a){r.push('<comment ref="'+e[0]+'" authorId="'+t.indexOf(Pe(a.a))+'"><text>');r.push(rr("t",a.t==null?"":a.t));r.push("</text></comment>")})});r.push("</commentList>");if(r.length>2){r[r.length]="</comments>";r[1]=r[1].replace("/>",">")}return r.join("")}function Il(e){var r={};r.iauthor=e._R(4);var t=Vt(e,16);r.rfx=t.s;r.ref=ht(t.s);e.l+=16;return r}function Rl(e,r){if(r==null)r=Gr(36);r._W(4,e[1].iauthor);zt(e[0],r);r._W(4,0);r._W(4,0);r._W(4,0);r._W(4,0);return r}var Dl=Et;function Ol(e){return kt(e.slice(0,54))}function Fl(e,r){var t=[];var a=[];var n={};var i=false;jr(e,function s(e,f,o){switch(o){case 632:a.push(e);break;case 635:n=e;break;case 637:n.t=e.t;n.h=e.h;n.r=e.r;break;case 636:n.author=a[n.iauthor];delete n.iauthor;if(r.sheetRows&&r.sheetRows<=n.rfx.r)break;if(!n.t)n.t="";delete n.rfx;t.push(n);break;case 3072:break;case 35:i=true;break;case 36:i=false;break;case 37:break;case 38:break;default:if((f||"").indexOf("Begin")>0){}else if((f||"").indexOf("End")>0){}else if(!i||r.WTF)throw new Error("Unexpected record "+o+" "+f);}});return t}function Pl(e){var r=Kr();var t=[];Yr(r,"BrtBeginComments");Yr(r,"BrtBeginCommentAuthors");e.forEach(function(e){e[1].forEach(function(e){if(t.indexOf(e.a)>-1)return;t.push(e.a.slice(0,54));Yr(r,"BrtCommentAuthor",Ol(e.a))})});Yr(r,"BrtEndCommentAuthors");Yr(r,"BrtBeginCommentList");e.forEach(function(e){e[1].forEach(function(a){a.iauthor=t.indexOf(a.a);var n={s:ct(e[0]),e:ct(e[0])};Yr(r,"BrtBeginComment",Rl([n,a]));if(a.t&&a.t.length>0)Yr(r,"BrtCommentText",yt(a));Yr(r,"BrtEndComment");delete a.iauthor})});Yr(r,"BrtEndCommentList");Yr(r,"BrtEndComments");return r.end()}var Nl="application/vnd.ms-office.vbaProject";function Ll(e){var r=W.utils.cfb_new({root:"R"});e.FullPaths.forEach(function(t,a){if(t.slice(-1)==="/"||!t.match(/_VBA_PROJECT_CUR/))return;var n=t.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/,"");W.utils.cfb_add(r,n,e.FileIndex[a].content)});return W.write(r)}function Ml(e,r){r.FullPaths.forEach(function(t,a){if(a==0)return;var n=t.replace(/[^\/]*[\/]/,"/_VBA_PROJECT_CUR/");if(n.slice(-1)!=="/")W.utils.cfb_add(e,n,r.FileIndex[a].content)})}var Ul=["xlsb","xlsm","xlam","biff8","xla"];Ra.DS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";Ra.MS="http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";function Hl(){return{"!type":"dialog"}}function Wl(){return{"!type":"dialog"}}function Vl(){return{"!type":"macro"}}function zl(){return{"!type":"macro"}}var Xl=function(){var e=/(^|[^A-Za-z])R(\[?)(-?\d+|)\]?C(\[?)(-?\d+|)\]?/g;var r={r:0,c:0};function t(e,t,a,n,i,s){var f=n.length>0?parseInt(n,10)|0:0,o=s.length>0?parseInt(s,10)|0:0;if(o<0&&i.length===0)o=0;var l=false,c=false;if(i.length>0||s.length==0)l=true;if(l)o+=r.c;else--o;if(a.length>0||n.length==0)c=true;if(c)f+=r.r;else--f;return t+(l?"":"$")+st(o)+(c?"":"$")+tt(f)}return function a(n,i){r=i;return n.replace(e,t)}}();var Gl=/(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)([1-9]\d{0,5}|10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6])(?![_.\(A-Za-z0-9])/g;var jl=function(){return function e(r,t){return r.replace(Gl,function(e,r,a,n,i,s){var f=it(n)-(a?0:t.c);var o=rt(s)-(i?0:t.r);var l=o==0?"":!i?"["+o+"]":o+1;var c=f==0?"":!a?"["+f+"]":f+1;return r+"R"+l+"C"+c})}}();function Kl(e,r){return e.replace(Gl,function(e,t,a,n,i,s){return t+(a=="$"?a+n:st(it(n)+r.c))+(i=="$"?i+s:tt(rt(s)+r.r))})}function Yl(e,r,t){var a=ut(r),n=a.s,i=ct(t);var s={r:i.r-n.r,c:i.c-n.c};return Kl(e,s)}function $l(e){if(e.length==1)return false;return true}function Zl(e){return e.replace(/_xlfn\./g,"")}function Ql(e){e.l+=1;return}function Jl(e,r){var t=e._R(r==1?1:2);return[t&16383,t>>14&1,t>>15&1]}function ql(e,r,t){var a=2;if(t){if(t.biff>=2&&t.biff<=5)return ec(e,r,t);else if(t.biff==12)a=4}var n=e._R(a),i=e._R(a);var s=Jl(e,2);var f=Jl(e,2);return{s:{r:n,c:s[0],cRel:s[1],rRel:s[2]},e:{r:i,c:f[0],cRel:f[1],rRel:f[2]}}}function ec(e){var r=Jl(e,2),t=Jl(e,2);var a=e._R(1);var n=e._R(1);return{s:{r:r[0],c:a,cRel:r[1],rRel:r[2]},e:{r:t[0],c:n,cRel:t[1],rRel:t[2]}}}function rc(e,r,t){if(t.biff<8)return ec(e,r,t);var a=e._R(t.biff==12?4:2),n=e._R(t.biff==12?4:2);var i=Jl(e,2);var s=Jl(e,2);return{s:{r:a,c:i[0],cRel:i[1],rRel:i[2]},e:{r:n,c:s[0],cRel:s[1],rRel:s[2]}}}function tc(e,r,t){if(t&&t.biff>=2&&t.biff<=5)return ac(e,r,t);var a=e._R(t&&t.biff==12?4:2);var n=Jl(e,2);return{r:a,c:n[0],cRel:n[1],rRel:n[2]}}function ac(e){var r=Jl(e,2);var t=e._R(1);return{r:r[0],c:t,cRel:r[1],rRel:r[2]}}function nc(e){var r=e._R(2);var t=e._R(2);return{r:r,c:t&255,fQuoted:!!(t&16384),cRel:t>>15,rRel:t>>15}}function ic(e,r,t){var a=t&&t.biff?t.biff:8;if(a>=2&&a<=5)return sc(e,r,t);var n=e._R(a>=12?4:2);var i=e._R(2);var s=(i&16384)>>14,f=(i&32768)>>15;i&=16383;if(f==1)while(n>524287)n-=1048576;if(s==1)while(i>8191)i=i-16384;return{r:n,c:i,cRel:s,rRel:f}}function sc(e){var r=e._R(2);var t=e._R(1);var a=(r&32768)>>15,n=(r&16384)>>14;r&=16383;if(a==1&&r>=8192)r=r-16384;if(n==1&&t>=128)t=t-256;return{r:r,c:t,cRel:n,rRel:a}}function fc(e,r,t){var a=(e[e.l++]&96)>>5;var n=ql(e,t.biff>=2&&t.biff<=5?6:8,t);return[a,n]}function oc(e,r,t){var a=(e[e.l++]&96)>>5;var n=e._R(2,"i");var i=8;if(t)switch(t.biff){case 5:e.l+=12;i=6;break;case 12:i=12;break;}var s=ql(e,i,t);return[a,n,s]}function lc(e,r,t){var a=(e[e.l++]&96)>>5;e.l+=t&&t.biff>8?12:t.biff<8?6:8;return[a]}function cc(e,r,t){var a=(e[e.l++]&96)>>5;var n=e._R(2);var i=8;if(t)switch(t.biff){case 5:e.l+=12;i=6;break;case 12:i=12;break;}e.l+=i;return[a,n]}function hc(e,r,t){var a=(e[e.l++]&96)>>5;var n=rc(e,r-1,t);return[a,n]}function uc(e,r,t){var a=(e[e.l++]&96)>>5;e.l+=t.biff==2?6:t.biff==12?14:7;return[a]}function dc(e){var r=e[e.l+1]&1;var t=1;e.l+=4;return[r,t]}function pc(e,r,t){e.l+=2;var a=e._R(t&&t.biff==2?1:2);var n=[];for(var i=0;i<=a;++i)n.push(e._R(t&&t.biff==2?1:2));return n}function vc(e,r,t){var a=e[e.l+1]&255?1:0;e.l+=2;return[a,e._R(t&&t.biff==2?1:2)]}function gc(e,r,t){var a=e[e.l+1]&255?1:0;e.l+=2;return[a,e._R(t&&t.biff==2?1:2)]}function mc(e){var r=e[e.l+1]&255?1:0;e.l+=2;return[r,e._R(2)]}function bc(e,r,t){var a=e[e.l+1]&255?1:0;e.l+=t&&t.biff==2?3:4;return[a]}function wc(e){var r=e._R(1),t=e._R(1);return[r,t]}function Cc(e){e._R(2);return wc(e,2)}function Ec(e){e._R(2);return wc(e,2)}function kc(e,r,t){var a=(e[e.l]&96)>>5;e.l+=1;var n=tc(e,0,t);return[a,n]}function Sc(e,r,t){var a=(e[e.l]&96)>>5;e.l+=1;var n=ic(e,0,t);return[a,n]}function Ac(e,r,t){var a=(e[e.l]&96)>>5;e.l+=1;var n=e._R(2);if(t&&t.biff==5)e.l+=12;var i=tc(e,0,t);return[a,n,i]}function _c(e,r,t){var a=(e[e.l]&96)>>5;e.l+=1;var n=e._R(t&&t.biff<=3?1:2);return[Uh[n],Mh[n],a]}function Bc(e,r,t){var a=e[e.l++];var n=e._R(1),i=t&&t.biff<=3?[a==88?-1:0,e._R(1)]:Tc(e);return[n,(i[0]===0?Mh:Lh)[i[1]]]}function Tc(e){return[e[e.l+1]>>7,e._R(2)&32767]}function yc(e,r,t){e.l+=t&&t.biff==2?3:4;return}function xc(e,r,t){e.l++;if(t&&t.biff==12)return[e._R(4,"i"),0];var a=e._R(2);var n=e._R(t&&t.biff==2?1:2);return[a,n]}function Ic(e){e.l++;return jt[e._R(1)]}function Rc(e){e.l++;return e._R(2)}function Dc(e){e.l++;return e._R(1)!==0}function Oc(e){e.l++;return Xt(e,8)}function Fc(e,r,t){e.l++;return Gn(e,r-1,t)}function Pc(e,r){var t=[e._R(1)];if(r==12)switch(t[0]){case 2:t[0]=4;break;case 4:t[0]=16;break;case 0:t[0]=1;break;case 1:t[0]=2;break;}switch(t[0]){case 4:t[1]=Mn(e,1)?"TRUE":"FALSE";if(r!=12)e.l+=7;break;case 37:;case 16:t[1]=jt[e[e.l]];e.l+=r==12?4:8;break;case 0:e.l+=8;break;case 1:t[1]=Xt(e,8);break;case 2:t[1]=$n(e,0,{biff:r>0&&r<8?2:r});break;default:throw new Error("Bad SerAr: "+t[0]);}return t}function Nc(e,r,t){var a=e._R(t.biff==12?4:2);var n=[];for(var i=0;i!=a;++i)n.push((t.biff==12?Vt:di)(e,8));return n}function Lc(e,r,t){var a=0,n=0;if(t.biff==12){a=e._R(4);n=e._R(4)}else{n=1+e._R(1);a=1+e._R(2)}if(t.biff>=2&&t.biff<8){--a;if(--n==0)n=256}for(var i=0,s=[];i!=a&&(s[i]=[]);++i)for(var f=0;f!=n;++f)s[i][f]=Pc(e,t.biff);return s}function Mc(e,r,t){var a=e._R(1)>>>5&3;var n=!t||t.biff>=8?4:2;var i=e._R(n);switch(t.biff){case 2:e.l+=5;break;case 3:;case 4:e.l+=8;break;case 5:e.l+=12;break;}return[a,0,i]}function Uc(e,r,t){if(t.biff==5)return Hc(e,r,t);var a=e._R(1)>>>5&3;var n=e._R(2);var i=e._R(4);return[a,n,i]}function Hc(e){var r=e._R(1)>>>5&3;var t=e._R(2,"i");e.l+=8;var a=e._R(2);e.l+=12;return[r,t,a]}function Wc(e,r,t){var a=e._R(1)>>>5&3;e.l+=t&&t.biff==2?3:4;var n=e._R(t&&t.biff==2?1:2);return[a,n]}function Vc(e,r,t){var a=e._R(1)>>>5&3;var n=e._R(t&&t.biff==2?1:2);return[a,n]}function zc(e,r,t){var a=e._R(1)>>>5&3;e.l+=4;if(t.biff<8)e.l--;if(t.biff==12)e.l+=2;return[a]}function Xc(e,r,t){var a=(e[e.l++]&96)>>5;var n=e._R(2);var i=4;if(t)switch(t.biff){case 5:i=15;break;case 12:i=6;break;}e.l+=i;return[a,n]}var Gc=Xr;var jc=Xr;var Kc=Xr;function Yc(e,r,t){e.l+=2;return[nc(e,4,t)]}function $c(e){e.l+=6;return[]}var Zc=Yc;var Qc=$c;var Jc=$c;var qc=Yc;function eh(e){e.l+=2;return[Hn(e),e._R(2)&1]}var rh=Yc;var th=eh;var ah=$c;var nh=Yc;var ih=Yc;var sh=["Data","All","Headers","??","?Data2","??","?DataHeaders","??","Totals","??","??","??","?DataTotals","??","??","??","?Current"];function fh(e){e.l+=2;var r=e._R(2);var t=e._R(2);var a=e._R(4);var n=e._R(2);var i=e._R(2);var s=sh[t>>2&31];return{ixti:r,coltype:t&3,rt:s,idx:a,c:n,C:i}}function oh(e){e.l+=2;return[e._R(4)]}function lh(e,r,t){e.l+=5;e.l+=2;e.l+=t.biff==2?1:4;return["PTGSHEET"]}function ch(e,r,t){e.l+=t.biff==2?4:5;return["PTGENDSHEET"]}function hh(e){var r=e._R(1)>>>5&3;var t=e._R(2);return[r,t]}function uh(e){var r=e._R(1)>>>5&3;var t=e._R(2);return[r,t]}function dh(e){e.l+=4;return[0,0]}var ph={1:{n:"PtgExp",f:xc},2:{n:"PtgTbl",f:Kc},3:{n:"PtgAdd",f:Ql},4:{n:"PtgSub",f:Ql},5:{n:"PtgMul",f:Ql},6:{n:"PtgDiv",f:Ql},7:{n:"PtgPower",f:Ql},8:{n:"PtgConcat",f:Ql},9:{n:"PtgLt",f:Ql},10:{n:"PtgLe",f:Ql},11:{n:"PtgEq",f:Ql},12:{n:"PtgGe",f:Ql},13:{n:"PtgGt",f:Ql},14:{n:"PtgNe",f:Ql},15:{n:"PtgIsect",f:Ql},16:{n:"PtgUnion",f:Ql},17:{n:"PtgRange",f:Ql},18:{n:"PtgUplus",f:Ql},19:{n:"PtgUminus",f:Ql},20:{n:"PtgPercent",f:Ql},21:{n:"PtgParen",f:Ql},22:{n:"PtgMissArg",f:Ql},23:{n:"PtgStr",f:Fc},26:{n:"PtgSheet",f:lh},27:{n:"PtgEndSheet",f:ch},28:{n:"PtgErr",f:Ic},29:{n:"PtgBool",f:Dc},30:{n:"PtgInt",f:Rc},31:{n:"PtgNum",f:Oc},32:{n:"PtgArray",f:uc},33:{n:"PtgFunc",f:_c},34:{n:"PtgFuncVar",f:Bc},35:{n:"PtgName",f:Mc},36:{n:"PtgRef",f:kc},37:{n:"PtgArea",f:fc},38:{n:"PtgMemArea",f:Wc},39:{n:"PtgMemErr",f:Gc},40:{n:"PtgMemNoMem",f:jc},41:{n:"PtgMemFunc",f:Vc},42:{n:"PtgRefErr",f:zc},43:{n:"PtgAreaErr",f:lc},44:{n:"PtgRefN",f:Sc},45:{n:"PtgAreaN",f:hc},46:{n:"PtgMemAreaN",f:hh},47:{n:"PtgMemNoMemN",f:uh},57:{n:"PtgNameX",f:Uc},58:{n:"PtgRef3d",f:Ac},59:{n:"PtgArea3d",f:oc},60:{n:"PtgRefErr3d",f:Xc},61:{n:"PtgAreaErr3d",f:cc},255:{}};var vh={64:32,96:32,65:33,97:33,66:34,98:34,67:35,99:35,68:36,100:36,69:37,101:37,70:38,102:38,71:39,103:39,72:40,104:40,73:41,105:41,74:42,106:42,75:43,107:43,76:44,108:44,77:45,109:45,78:46,110:46,79:47,111:47,88:34,120:34,89:57,121:57,90:58,122:58,91:59,123:59,92:60,124:60,93:61,125:61};(function(){for(var e in vh)ph[e]=ph[vh[e]]})();var gh={1:{n:"PtgElfLel",f:eh},2:{n:"PtgElfRw",f:nh},3:{n:"PtgElfCol",f:Zc},6:{n:"PtgElfRwV",f:ih},7:{n:"PtgElfColV",f:qc},10:{n:"PtgElfRadical",f:rh},11:{n:"PtgElfRadicalS",f:ah},13:{n:"PtgElfColS",f:Qc},15:{n:"PtgElfColSV",f:Jc},16:{n:"PtgElfRadicalLel",f:th},25:{n:"PtgList",f:fh},29:{n:"PtgSxName",f:oh},255:{}};var mh={0:{n:"PtgAttrNoop",f:dh},1:{n:"PtgAttrSemi",f:bc},2:{n:"PtgAttrIf",f:gc},4:{n:"PtgAttrChoose",f:pc},8:{n:"PtgAttrGoto",f:vc},16:{n:"PtgAttrSum",f:yc},32:{n:"PtgAttrBaxcel",f:dc},64:{n:"PtgAttrSpace",f:Cc},65:{n:"PtgAttrSpaceSemi",f:Ec},128:{n:"PtgAttrIfError",f:mc},255:{}};mh[33]=mh[32];function bh(e,r,t,a){if(a.biff<8)return Xr(e,r);var n=e.l+r;var i=[];for(var s=0;s!==t.length;++s){switch(t[s][0]){case"PtgArray":t[s][1]=Lc(e,0,a);i.push(t[s][1]);break;case"PtgMemArea":t[s][2]=Nc(e,t[s][1],a);i.push(t[s][2]);break;case"PtgExp":if(a&&a.biff==12){t[s][1][1]=e._R(4);i.push(t[s][1])}break;case"PtgList":;case"PtgElfRadicalS":;case"PtgElfColS":;case"PtgElfColSV":throw"Unsupported "+t[s][0];default:break;}}r=n-e.l;if(r!==0)i.push(Xr(e,r));return i}function wh(e,r,t){var a=e.l+r;var n,i,s=[];while(a!=e.l){r=a-e.l;i=e[e.l];n=ph[i];if(i===24||i===25)n=(i===24?gh:mh)[e[e.l+1]];if(!n||!n.f){Xr(e,r)}else{s.push([n.n,n.f(e,r,t)])}}return s}function Ch(e){var r=[];for(var t=0;t<e.length;++t){var a=e[t],n=[];for(var i=0;i<a.length;++i){var s=a[i];if(s)switch(s[0]){case 2:n.push('"'+s[1].replace(/"/g,'""')+'"');break;default:n.push(s[1]);}else n.push("")}r.push(n.join(","))}return r.join(";")}var Eh={PtgAdd:"+",PtgConcat:"&",PtgDiv:"/",PtgEq:"=",PtgGe:">=",PtgGt:">",PtgLe:"<=",PtgLt:"<",PtgMul:"*",PtgNe:"<>",PtgPower:"^",PtgSub:"-"};function kh(e,r){if(!e&&!(r&&r.biff<=5&&r.biff>=2))throw new Error("empty sheet name");if(e.indexOf(" ")>-1)return"'"+e+"'";return e}function Sh(e,r,t){if(!e)return"SH33TJSERR0";if(!e.XTI)return"SH33TJSERR6";var a=e.XTI[r];if(t.biff>8&&!e.XTI[r])return e.SheetNames[r];if(t.biff<8){if(r>1e4)r-=65536;if(r<0)r=-r;return r==0?"":e.XTI[r-1]}if(!a)return"SH33TJSERR1";var n="";if(t.biff>8)switch(e[a[0]][0]){case 357:n=a[1]==-1?"#REF":e.SheetNames[a[1]];return a[1]==a[2]?n:n+":"+e.SheetNames[a[2]];case 358:if(t.SID!=null)return e.SheetNames[t.SID];return"SH33TJSSAME"+e[a[0]][0];case 355:;default:return"SH33TJSSRC"+e[a[0]][0];}switch(e[a[0]][0][0]){case 1025:n=a[1]==-1?"#REF":e.SheetNames[a[1]]||"SH33TJSERR3";return a[1]==a[2]?n:n+":"+e.SheetNames[a[2]];case 14849:return"SH33TJSERR8";default:if(!e[a[0]][0][3])return"SH33TJSERR2";n=a[1]==-1?"#REF":e[a[0]][0][3][a[1]]||"SH33TJSERR4";return a[1]==a[2]?n:n+":"+e[a[0]][0][3][a[2]];}}function Ah(e,r,t){return kh(Sh(e,r,t),t)}function _h(e,r,t,a,n){var i=n&&n.biff||8;var s={s:{c:0,r:0},e:{c:0,r:0}};var f=[],o,l,c,h=0,u=0,d,p="";if(!e[0]||!e[0][0])return"";var v=-1,g="";for(var m=0,b=e[0].length;m<b;++m){var w=e[0][m];switch(w[0]){case"PtgUminus":f.push("-"+f.pop());break;case"PtgUplus":f.push("+"+f.pop());break;case"PtgPercent":f.push(f.pop()+"%");break;case"PtgAdd":;case"PtgConcat":;case"PtgDiv":;case"PtgEq":;case"PtgGe":;case"PtgGt":;case"PtgLe":;case"PtgLt":;case"PtgMul":;case"PtgNe":;case"PtgPower":;case"PtgSub":o=f.pop();l=f.pop();if(v>=0){switch(e[0][v][1][0]){case 0:g=oe(" ",e[0][v][1][1]);break;case 1:g=oe("\r",e[0][v][1][1]);break;default:g="";if(n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+e[0][v][1][0]);}l=l+g;v=-1}f.push(l+Eh[w[0]]+o);break;case"PtgIsect":o=f.pop();l=f.pop();f.push(l+" "+o);break;case"PtgUnion":o=f.pop();l=f.pop();f.push(l+","+o);break;case"PtgRange":o=f.pop();l=f.pop();f.push(l+":"+o);break;case"PtgAttrChoose":break;case"PtgAttrGoto":break;case"PtgAttrIf":break;case"PtgAttrIfError":break;case"PtgRef":c=$r(w[1][1],s,n);f.push(Qr(c,i));break;case"PtgRefN":c=t?$r(w[1][1],t,n):w[1][1];f.push(Qr(c,i));break;case"PtgRef3d":h=w[1][1];c=$r(w[1][2],s,n);p=Ah(a,h,n);var C=p;f.push(p+"!"+Qr(c,i));break;case"PtgFunc":;case"PtgFuncVar":var E=w[1][0],k=w[1][1];if(!E)E=0;E&=127;var S=E==0?[]:f.slice(-E);f.length-=E;if(k==="User")k=S.shift();f.push(k+"("+S.join(",")+")");break;case"PtgBool":f.push(w[1]?"TRUE":"FALSE");break;case"PtgInt":f.push(w[1]);break;case"PtgNum":f.push(String(w[1]));break;case"PtgStr":f.push('"'+w[1]+'"');break;case"PtgErr":f.push(w[1]);break;case"PtgAreaN":d=Zr(w[1][1],t?{s:t}:s,n);f.push(Jr(d,n));break;case"PtgArea":d=Zr(w[1][1],s,n);f.push(Jr(d,n));break;case"PtgArea3d":h=w[1][1];d=w[1][2];p=Ah(a,h,n);f.push(p+"!"+Jr(d,n));break;case"PtgAttrSum":f.push("SUM("+f.pop()+")");break;case"PtgAttrBaxcel":;case"PtgAttrSemi":break;case"PtgName":u=w[1][2];var A=(a.names||[])[u-1]||(a[0]||[])[u];var _=A?A.Name:"SH33TJSNAME"+String(u);if(_ in Hh)_=Hh[_];f.push(_);break;case"PtgNameX":var B=w[1][1];u=w[1][2];var T;if(n.biff<=5){if(B<0)B=-B;if(a[B])T=a[B][u]}else{var y="";if(((a[B]||[])[0]||[])[0]==14849){}else if(((a[B]||[])[0]||[])[0]==1025){if(a[B][u]&&a[B][u].itab>0){y=a.SheetNames[a[B][u].itab-1]+"!"}}else y=a.SheetNames[u-1]+"!";if(a[B]&&a[B][u])y+=a[B][u].Name;else if(a[0]&&a[0][u])y+=a[0][u].Name;else y+="SH33TJSERRX";f.push(y);break}if(!T)T={Name:"SH33TJSERRY"};f.push(T.Name);break;case"PtgParen":var x="(",I=")";if(v>=0){g="";switch(e[0][v][1][0]){case 2:x=oe(" ",e[0][v][1][1])+x;break;case 3:x=oe("\r",e[0][v][1][1])+x;break;case 4:I=oe(" ",e[0][v][1][1])+I;break;case 5:I=oe("\r",e[0][v][1][1])+I;break;default:if(n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+e[0][v][1][0]);}v=-1}f.push(x+f.pop()+I);break;case"PtgRefErr":f.push("#REF!");break;case"PtgRefErr3d":f.push("#REF!");break;case"PtgExp":c={c:w[1][1],r:w[1][0]};var R={c:t.c,r:t.r};if(a.sharedf[ht(c)]){var D=a.sharedf[ht(c)];f.push(_h(D,s,R,a,n))}else{var O=false;for(o=0;o!=a.arrayf.length;++o){l=a.arrayf[o];if(c.c<l[0].s.c||c.c>l[0].e.c)continue;if(c.r<l[0].s.r||c.r>l[0].e.r)continue;f.push(_h(l[1],s,R,a,n));O=true;break}if(!O)f.push(w[1])}break;case"PtgArray":f.push("{"+Ch(w[1])+"}");break;case"PtgMemArea":break;case"PtgAttrSpace":;case"PtgAttrSpaceSemi":v=m;break;case"PtgTbl":break;case"PtgMemErr":break;case"PtgMissArg":f.push("");break;case"PtgAreaErr":f.push("#REF!");break;case"PtgAreaErr3d":f.push("#REF!");break;case"PtgList":f.push("Table"+w[1].idx+"[#"+w[1].rt+"]");break;case"PtgMemAreaN":;case"PtgMemNoMemN":;case"PtgAttrNoop":;case"PtgSheet":;case"PtgEndSheet":break;case"PtgMemFunc":break;case"PtgMemNoMem":break;case"PtgElfCol":;case"PtgElfColS":;case"PtgElfColSV":;case"PtgElfColV":;case"PtgElfLel":;case"PtgElfRadical":;case"PtgElfRadicalLel":;case"PtgElfRadicalS":;case"PtgElfRw":;case"PtgElfRwV":throw new Error("Unsupported ELFs");case"PtgSxName":throw new Error("Unrecognized Formula Token: "+String(w));default:throw new Error("Unrecognized Formula Token: "+String(w));}var F=["PtgAttrSpace","PtgAttrSpaceSemi","PtgAttrGoto"];if(n.biff!=3)if(v>=0&&F.indexOf(e[0][m][0])==-1){w=e[0][v];var P=true;switch(w[1][0]){case 4:P=false;case 0:g=oe(" ",w[1][1]);break;case 5:P=false;case 1:g=oe("\r",w[1][1]);break;default:g="";if(n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+w[1][0]);}f.push((P?g:"")+f.pop()+(P?"":g));v=-1}}if(f.length>1&&n.WTF)throw new Error("bad formula stack");return f[0]}function Bh(e,r,t){var a=e.l+r,n=t.biff==2?1:2;var i,s=e._R(n);if(s==65535)return[[],Xr(e,r-2)];var f=wh(e,s,t);if(r!==s+n)i=bh(e,r-s-n,f,t);e.l=a;return[f,i]}function Th(e,r,t){var a=e.l+r,n=t.biff==2?1:2;var i,s=e._R(n);if(s==65535)return[[],Xr(e,r-2)];var f=wh(e,s,t);if(r!==s+n)i=bh(e,r-s-n,f,t);e.l=a;return[f,i]}function yh(e,r,t,a){var n=e.l+r;var i=wh(e,a,t);var s;if(n!==e.l)s=bh(e,n-e.l,i,t);return[i,s]}function xh(e,r,t){var a=e.l+r;var n,i=e._R(2);var s=wh(e,i,t);if(i==65535)return[[],Xr(e,r-2)];if(r!==i+2)n=bh(e,a-i-2,s,t);return[s,n]}function Ih(e){var r;if(Dr(e,e.l+6)!==65535)return[Xt(e),"n"];switch(e[e.l]){case 0:e.l+=8;return["String","s"];case 1:r=e[e.l+2]===1;e.l+=8;return[r,"b"];case 2:r=e[e.l+2];e.l+=8;return[r,"e"];case 3:e.l+=8;return["","s"];}return[]}function Rh(e,r,t){var a=e.l+r;var n=si(e,6);if(t.biff==2)++e.l;var i=Ih(e,8);var s=e._R(1);if(t.biff!=2){e._R(1);if(t.biff>=5){e._R(4)}}var f=Th(e,a-e.l,t);return{cell:n,val:i[0],formula:f,shared:s>>3&1,tt:i[1]}}function Dh(e,r,t){var a=e._R(4);var n=wh(e,a,t);var i=e._R(4);var s=i>0?bh(e,i,n,t):null;return[n,s]}var Oh=Dh;var Fh=Dh;var Ph=Dh;var Nh=Dh;var Lh={0:"BEEP",1:"OPEN",2:"OPEN.LINKS",3:"CLOSE.ALL",4:"SAVE",5:"SAVE.AS",6:"FILE.DELETE",7:"PAGE.SETUP",8:"PRINT",9:"PRINTER.SETUP",10:"QUIT",11:"NEW.WINDOW",12:"ARRANGE.ALL",13:"WINDOW.SIZE",14:"WINDOW.MOVE",15:"FULL",16:"CLOSE",17:"RUN",22:"SET.PRINT.AREA",23:"SET.PRINT.TITLES",24:"SET.PAGE.BREAK",25:"REMOVE.PAGE.BREAK",26:"FONT",27:"DISPLAY",28:"PROTECT.DOCUMENT",29:"PRECISION",30:"A1.R1C1",31:"CALCULATE.NOW",32:"CALCULATION",34:"DATA.FIND",35:"EXTRACT",36:"DATA.DELETE",37:"SET.DATABASE",38:"SET.CRITERIA",39:"SORT",40:"DATA.SERIES",41:"TABLE",42:"FORMAT.NUMBER",43:"ALIGNMENT",44:"STYLE",45:"BORDER",46:"CELL.PROTECTION",47:"COLUMN.WIDTH",48:"UNDO",49:"CUT",50:"COPY",51:"PASTE",52:"CLEAR",53:"PASTE.SPECIAL",54:"EDIT.DELETE",55:"INSERT",56:"FILL.RIGHT",57:"FILL.DOWN",61:"DEFINE.NAME",62:"CREATE.NAMES",63:"FORMULA.GOTO",64:"FORMULA.FIND",65:"SELECT.LAST.CELL",66:"SHOW.ACTIVE.CELL",67:"GALLERY.AREA",68:"GALLERY.BAR",69:"GALLERY.COLUMN",70:"GALLERY.LINE",71:"GALLERY.PIE",72:"GALLERY.SCATTER",73:"COMBINATION",74:"PREFERRED",75:"ADD.OVERLAY",76:"GRIDLINES",77:"SET.PREFERRED",78:"AXES",79:"LEGEND",80:"ATTACH.TEXT",81:"ADD.ARROW",82:"SELECT.CHART",83:"SELECT.PLOT.AREA",84:"PATTERNS",85:"MAIN.CHART",86:"OVERLAY",87:"SCALE",88:"FORMAT.LEGEND",89:"FORMAT.TEXT",90:"EDIT.REPEAT",91:"PARSE",92:"JUSTIFY",93:"HIDE",94:"UNHIDE",95:"WORKSPACE",96:"FORMULA",97:"FORMULA.FILL",98:"FORMULA.ARRAY",99:"DATA.FIND.NEXT",100:"DATA.FIND.PREV",101:"FORMULA.FIND.NEXT",102:"FORMULA.FIND.PREV",103:"ACTIVATE",104:"ACTIVATE.NEXT",105:"ACTIVATE.PREV",106:"UNLOCKED.NEXT",107:"UNLOCKED.PREV",108:"COPY.PICTURE",109:"SELECT",110:"DELETE.NAME",111:"DELETE.FORMAT",112:"VLINE",113:"HLINE",114:"VPAGE",115:"HPAGE",116:"VSCROLL",117:"HSCROLL",118:"ALERT",119:"NEW",120:"CANCEL.COPY",121:"SHOW.CLIPBOARD",122:"MESSAGE",124:"PASTE.LINK",125:"APP.ACTIVATE",126:"DELETE.ARROW",127:"ROW.HEIGHT",128:"FORMAT.MOVE",129:"FORMAT.SIZE",130:"FORMULA.REPLACE",131:"SEND.KEYS",132:"SELECT.SPECIAL",133:"APPLY.NAMES",134:"REPLACE.FONT",135:"FREEZE.PANES",136:"SHOW.INFO",137:"SPLIT",138:"ON.WINDOW",139:"ON.DATA",140:"DISABLE.INPUT",142:"OUTLINE",143:"LIST.NAMES",144:"FILE.CLOSE",145:"SAVE.WORKBOOK",146:"DATA.FORM",147:"COPY.CHART",148:"ON.TIME",149:"WAIT",150:"FORMAT.FONT",151:"FILL.UP",152:"FILL.LEFT",153:"DELETE.OVERLAY",155:"SHORT.MENUS",159:"SET.UPDATE.STATUS",161:"COLOR.PALETTE",162:"DELETE.STYLE",163:"WINDOW.RESTORE",164:"WINDOW.MAXIMIZE",166:"CHANGE.LINK",167:"CALCULATE.DOCUMENT",168:"ON.KEY",169:"APP.RESTORE",170:"APP.MOVE",171:"APP.SIZE",172:"APP.MINIMIZE",173:"APP.MAXIMIZE",174:"BRING.TO.FRONT",175:"SEND.TO.BACK",185:"MAIN.CHART.TYPE",186:"OVERLAY.CHART.TYPE",187:"SELECT.END",188:"OPEN.MAIL",189:"SEND.MAIL",190:"STANDARD.FONT",191:"CONSOLIDATE",192:"SORT.SPECIAL",193:"GALLERY.3D.AREA",194:"GALLERY.3D.COLUMN",195:"GALLERY.3D.LINE",196:"GALLERY.3D.PIE",197:"VIEW.3D",198:"GOAL.SEEK",199:"WORKGROUP",200:"FILL.GROUP",201:"UPDATE.LINK",202:"PROMOTE",203:"DEMOTE",204:"SHOW.DETAIL",206:"UNGROUP",207:"OBJECT.PROPERTIES",208:"SAVE.NEW.OBJECT",209:"SHARE",210:"SHARE.NAME",211:"DUPLICATE",212:"APPLY.STYLE",213:"ASSIGN.TO.OBJECT",214:"OBJECT.PROTECTION",215:"HIDE.OBJECT",216:"SET.EXTRACT",217:"CREATE.PUBLISHER",218:"SUBSCRIBE.TO",219:"ATTRIBUTES",220:"SHOW.TOOLBAR",222:"PRINT.PREVIEW",223:"EDIT.COLOR",224:"SHOW.LEVELS",225:"FORMAT.MAIN",226:"FORMAT.OVERLAY",227:"ON.RECALC",228:"EDIT.SERIES",229:"DEFINE.STYLE",240:"LINE.PRINT",243:"ENTER.DATA",249:"GALLERY.RADAR",250:"MERGE.STYLES",251:"EDITION.OPTIONS",252:"PASTE.PICTURE",253:"PASTE.PICTURE.LINK",254:"SPELLING",256:"ZOOM",259:"INSERT.OBJECT",260:"WINDOW.MINIMIZE",265:"SOUND.NOTE",266:"SOUND.PLAY",267:"FORMAT.SHAPE",268:"EXTEND.POLYGON",269:"FORMAT.AUTO",272:"GALLERY.3D.BAR",273:"GALLERY.3D.SURFACE",274:"FILL.AUTO",276:"CUSTOMIZE.TOOLBAR",277:"ADD.TOOL",278:"EDIT.OBJECT",279:"ON.DOUBLECLICK",280:"ON.ENTRY",281:"WORKBOOK.ADD",282:"WORKBOOK.MOVE",283:"WORKBOOK.COPY",284:"WORKBOOK.OPTIONS",285:"SAVE.WORKSPACE",288:"CHART.WIZARD",289:"DELETE.TOOL",290:"MOVE.TOOL",291:"WORKBOOK.SELECT",292:"WORKBOOK.ACTIVATE",293:"ASSIGN.TO.TOOL",295:"COPY.TOOL",296:"RESET.TOOL",297:"CONSTRAIN.NUMERIC",298:"PASTE.TOOL",302:"WORKBOOK.NEW",305:"SCENARIO.CELLS",306:"SCENARIO.DELETE",307:"SCENARIO.ADD",308:"SCENARIO.EDIT",309:"SCENARIO.SHOW",310:"SCENARIO.SHOW.NEXT",311:"SCENARIO.SUMMARY",312:"PIVOT.TABLE.WIZARD",313:"PIVOT.FIELD.PROPERTIES",314:"PIVOT.FIELD",315:"PIVOT.ITEM",316:"PIVOT.ADD.FIELDS",318:"OPTIONS.CALCULATION",319:"OPTIONS.EDIT",320:"OPTIONS.VIEW",321:"ADDIN.MANAGER",322:"MENU.EDITOR",323:"ATTACH.TOOLBARS",324:"VBAActivate",325:"OPTIONS.CHART",328:"VBA.INSERT.FILE",330:"VBA.PROCEDURE.DEFINITION",336:"ROUTING.SLIP",338:"ROUTE.DOCUMENT",339:"MAIL.LOGON",342:"INSERT.PICTURE",343:"EDIT.TOOL",344:"GALLERY.DOUGHNUT",350:"CHART.TREND",352:"PIVOT.ITEM.PROPERTIES",354:"WORKBOOK.INSERT",355:"OPTIONS.TRANSITION",356:"OPTIONS.GENERAL",370:"FILTER.ADVANCED",373:"MAIL.ADD.MAILER",374:"MAIL.DELETE.MAILER",375:"MAIL.REPLY",376:"MAIL.REPLY.ALL",377:"MAIL.FORWARD",378:"MAIL.NEXT.LETTER",379:"DATA.LABEL",380:"INSERT.TITLE",381:"FONT.PROPERTIES",382:"MACRO.OPTIONS",383:"WORKBOOK.HIDE",384:"WORKBOOK.UNHIDE",385:"WORKBOOK.DELETE",386:"WORKBOOK.NAME",388:"GALLERY.CUSTOM",390:"ADD.CHART.AUTOFORMAT",391:"DELETE.CHART.AUTOFORMAT",392:"CHART.ADD.DATA",393:"AUTO.OUTLINE",394:"TAB.ORDER",395:"SHOW.DIALOG",396:"SELECT.ALL",397:"UNGROUP.SHEETS",398:"SUBTOTAL.CREATE",399:"SUBTOTAL.REMOVE",400:"RENAME.OBJECT",412:"WORKBOOK.SCROLL",413:"WORKBOOK.NEXT",414:"WORKBOOK.PREV",415:"WORKBOOK.TAB.SPLIT",416:"FULL.SCREEN",417:"WORKBOOK.PROTECT",420:"SCROLLBAR.PROPERTIES",421:"PIVOT.SHOW.PAGES",422:"TEXT.TO.COLUMNS",423:"FORMAT.CHARTTYPE",424:"LINK.FORMAT",425:"TRACER.DISPLAY",430:"TRACER.NAVIGATE",431:"TRACER.CLEAR",432:"TRACER.ERROR",433:"PIVOT.FIELD.GROUP",434:"PIVOT.FIELD.UNGROUP",435:"CHECKBOX.PROPERTIES",436:"LABEL.PROPERTIES",437:"LISTBOX.PROPERTIES",438:"EDITBOX.PROPERTIES",439:"PIVOT.REFRESH",440:"LINK.COMBO",441:"OPEN.TEXT",442:"HIDE.DIALOG",443:"SET.DIALOG.FOCUS",444:"ENABLE.OBJECT",445:"PUSHBUTTON.PROPERTIES",446:"SET.DIALOG.DEFAULT",447:"FILTER",448:"FILTER.SHOW.ALL",449:"CLEAR.OUTLINE",450:"FUNCTION.WIZARD",451:"ADD.LIST.ITEM",452:"SET.LIST.ITEM",453:"REMOVE.LIST.ITEM",454:"SELECT.LIST.ITEM",455:"SET.CONTROL.VALUE",456:"SAVE.COPY.AS",458:"OPTIONS.LISTS.ADD",459:"OPTIONS.LISTS.DELETE",460:"SERIES.AXES",461:"SERIES.X",462:"SERIES.Y",463:"ERRORBAR.X",464:"ERRORBAR.Y",465:"FORMAT.CHART",466:"SERIES.ORDER",467:"MAIL.LOGOFF",468:"CLEAR.ROUTING.SLIP",469:"APP.ACTIVATE.MICROSOFT",470:"MAIL.EDIT.MAILER",471:"ON.SHEET",472:"STANDARD.WIDTH",473:"SCENARIO.MERGE",474:"SUMMARY.INFO",475:"FIND.FILE",476:"ACTIVE.CELL.FONT",477:"ENABLE.TIPWIZARD",478:"VBA.MAKE.ADDIN",480:"INSERTDATATABLE",481:"WORKGROUP.OPTIONS",482:"MAIL.SEND.MAILER",485:"AUTOCORRECT",489:"POST.DOCUMENT",491:"PICKLIST",493:"VIEW.SHOW",494:"VIEW.DEFINE",495:"VIEW.DELETE",509:"SHEET.BACKGROUND",510:"INSERT.MAP.OBJECT",511:"OPTIONS.MENONO",517:"MSOCHECKS",518:"NORMAL",519:"LAYOUT",520:"RM.PRINT.AREA",521:"CLEAR.PRINT.AREA",522:"ADD.PRINT.AREA",523:"MOVE.BRK",545:"HIDECURR.NOTE",546:"HIDEALL.NOTES",547:"DELETE.NOTE",548:"TRAVERSE.NOTES",549:"ACTIVATE.NOTES",620:"PROTECT.REVISIONS",621:"UNPROTECT.REVISIONS",647:"OPTIONS.ME",653:"WEB.PUBLISH",667:"NEWWEBQUERY",673:"PIVOT.TABLE.CHART",753:"OPTIONS.SAVE",755:"OPTIONS.SPELL",808:"HIDEALL.INKANNOTS"};var Mh={0:"COUNT",1:"IF",2:"ISNA",3:"ISERROR",4:"SUM",5:"AVERAGE",6:"MIN",7:"MAX",8:"ROW",9:"COLUMN",10:"NA",11:"NPV",12:"STDEV",13:"DOLLAR",14:"FIXED",15:"SIN",16:"COS",17:"TAN",18:"ATAN",19:"PI",20:"SQRT",21:"EXP",22:"LN",23:"LOG10",24:"ABS",25:"INT",26:"SIGN",27:"ROUND",28:"LOOKUP",29:"INDEX",30:"REPT",31:"MID",32:"LEN",33:"VALUE",34:"TRUE",35:"FALSE",36:"AND",37:"OR",38:"NOT",39:"MOD",40:"DCOUNT",41:"DSUM",42:"DAVERAGE",43:"DMIN",44:"DMAX",45:"DSTDEV",46:"VAR",47:"DVAR",48:"TEXT",49:"LINEST",50:"TREND",51:"LOGEST",52:"GROWTH",53:"GOTO",54:"HALT",55:"RETURN",56:"PV",57:"FV",58:"NPER",59:"PMT",60:"RATE",61:"MIRR",62:"IRR",63:"RAND",64:"MATCH",65:"DATE",66:"TIME",67:"DAY",68:"MONTH",69:"YEAR",70:"WEEKDAY",71:"HOUR",72:"MINUTE",73:"SECOND",74:"NOW",75:"AREAS",76:"ROWS",77:"COLUMNS",78:"OFFSET",79:"ABSREF",80:"RELREF",81:"ARGUMENT",82:"SEARCH",83:"TRANSPOSE",84:"ERROR",85:"STEP",86:"TYPE",87:"ECHO",88:"SET.NAME",89:"CALLER",90:"DEREF",91:"WINDOWS",92:"SERIES",93:"DOCUMENTS",94:"ACTIVE.CELL",95:"SELECTION",96:"RESULT",97:"ATAN2",98:"ASIN",99:"ACOS",100:"CHOOSE",101:"HLOOKUP",102:"VLOOKUP",103:"LINKS",104:"INPUT",105:"ISREF",106:"GET.FORMULA",107:"GET.NAME",108:"SET.VALUE",109:"LOG",110:"EXEC",111:"CHAR",112:"LOWER",113:"UPPER",114:"PROPER",115:"LEFT",116:"RIGHT",117:"EXACT",118:"TRIM",119:"REPLACE",120:"SUBSTITUTE",121:"CODE",122:"NAMES",123:"DIRECTORY",124:"FIND",125:"CELL",126:"ISERR",127:"ISTEXT",128:"ISNUMBER",129:"ISBLANK",130:"T",131:"N",132:"FOPEN",133:"FCLOSE",134:"FSIZE",135:"FREADLN",136:"FREAD",137:"FWRITELN",138:"FWRITE",139:"FPOS",140:"DATEVALUE",141:"TIMEVALUE",142:"SLN",143:"SYD",144:"DDB",145:"GET.DEF",146:"REFTEXT",147:"TEXTREF",148:"INDIRECT",149:"REGISTER",150:"CALL",151:"ADD.BAR",152:"ADD.MENU",153:"ADD.COMMAND",154:"ENABLE.COMMAND",155:"CHECK.COMMAND",156:"RENAME.COMMAND",157:"SHOW.BAR",158:"DELETE.MENU",159:"DELETE.COMMAND",160:"GET.CHART.ITEM",161:"DIALOG.BOX",162:"CLEAN",163:"MDETERM",164:"MINVERSE",165:"MMULT",166:"FILES",167:"IPMT",168:"PPMT",169:"COUNTA",170:"CANCEL.KEY",171:"FOR",172:"WHILE",173:"BREAK",174:"NEXT",175:"INITIATE",176:"REQUEST",177:"POKE",178:"EXECUTE",179:"TERMINATE",180:"RESTART",181:"HELP",182:"GET.BAR",183:"PRODUCT",184:"FACT",185:"GET.CELL",186:"GET.WORKSPACE",187:"GET.WINDOW",188:"GET.DOCUMENT",189:"DPRODUCT",190:"ISNONTEXT",191:"GET.NOTE",192:"NOTE",193:"STDEVP",194:"VARP",195:"DSTDEVP",196:"DVARP",197:"TRUNC",198:"ISLOGICAL",199:"DCOUNTA",200:"DELETE.BAR",201:"UNREGISTER",204:"USDOLLAR",205:"FINDB",206:"SEARCHB",207:"REPLACEB",208:"LEFTB",209:"RIGHTB",210:"MIDB",211:"LENB",212:"ROUNDUP",213:"ROUNDDOWN",214:"ASC",215:"DBCS",216:"RANK",219:"ADDRESS",220:"DAYS360",221:"TODAY",222:"VDB",223:"ELSE",224:"ELSE.IF",225:"END.IF",226:"FOR.CELL",227:"MEDIAN",228:"SUMPRODUCT",229:"SINH",230:"COSH",231:"TANH",232:"ASINH",233:"ACOSH",234:"ATANH",235:"DGET",236:"CREATE.OBJECT",237:"VOLATILE",238:"LAST.ERROR",239:"CUSTOM.UNDO",240:"CUSTOM.REPEAT",241:"FORMULA.CONVERT",242:"GET.LINK.INFO",243:"TEXT.BOX",244:"INFO",245:"GROUP",246:"GET.OBJECT",247:"DB",248:"PAUSE",251:"RESUME",252:"FREQUENCY",253:"ADD.TOOLBAR",254:"DELETE.TOOLBAR",255:"User",256:"RESET.TOOLBAR",257:"EVALUATE",258:"GET.TOOLBAR",259:"GET.TOOL",260:"SPELLING.CHECK",261:"ERROR.TYPE",262:"APP.TITLE",263:"WINDOW.TITLE",264:"SAVE.TOOLBAR",265:"ENABLE.TOOL",266:"PRESS.TOOL",267:"REGISTER.ID",268:"GET.WORKBOOK",269:"AVEDEV",270:"BETADIST",271:"GAMMALN",272:"BETAINV",273:"BINOMDIST",274:"CHIDIST",275:"CHIINV",276:"COMBIN",277:"CONFIDENCE",278:"CRITBINOM",279:"EVEN",280:"EXPONDIST",281:"FDIST",282:"FINV",283:"FISHER",284:"FISHERINV",285:"FLOOR",286:"GAMMADIST",287:"GAMMAINV",288:"CEILING",289:"HYPGEOMDIST",290:"LOGNORMDIST",291:"LOGINV",292:"NEGBINOMDIST",293:"NORMDIST",294:"NORMSDIST",295:"NORMINV",296:"NORMSINV",297:"STANDARDIZE",298:"ODD",299:"PERMUT",300:"POISSON",301:"TDIST",302:"WEIBULL",303:"SUMXMY2",304:"SUMX2MY2",305:"SUMX2PY2",306:"CHITEST",307:"CORREL",308:"COVAR",309:"FORECAST",310:"FTEST",311:"INTERCEPT",312:"PEARSON",313:"RSQ",314:"STEYX",315:"SLOPE",
316:"TTEST",317:"PROB",318:"DEVSQ",319:"GEOMEAN",320:"HARMEAN",321:"SUMSQ",322:"KURT",323:"SKEW",324:"ZTEST",325:"LARGE",326:"SMALL",327:"QUARTILE",328:"PERCENTILE",329:"PERCENTRANK",330:"MODE",331:"TRIMMEAN",332:"TINV",334:"MOVIE.COMMAND",335:"GET.MOVIE",336:"CONCATENATE",337:"POWER",338:"PIVOT.ADD.DATA",339:"GET.PIVOT.TABLE",340:"GET.PIVOT.FIELD",341:"GET.PIVOT.ITEM",342:"RADIANS",343:"DEGREES",344:"SUBTOTAL",345:"SUMIF",346:"COUNTIF",347:"COUNTBLANK",348:"SCENARIO.GET",349:"OPTIONS.LISTS.GET",350:"ISPMT",351:"DATEDIF",352:"DATESTRING",353:"NUMBERSTRING",354:"ROMAN",355:"OPEN.DIALOG",356:"SAVE.DIALOG",357:"VIEW.GET",358:"GETPIVOTDATA",359:"HYPERLINK",360:"PHONETIC",361:"AVERAGEA",362:"MAXA",363:"MINA",364:"STDEVPA",365:"VARPA",366:"STDEVA",367:"VARA",368:"BAHTTEXT",369:"THAIDAYOFWEEK",370:"THAIDIGIT",371:"THAIMONTHOFYEAR",372:"THAINUMSOUND",373:"THAINUMSTRING",374:"THAISTRINGLENGTH",375:"ISTHAIDIGIT",376:"ROUNDBAHTDOWN",377:"ROUNDBAHTUP",378:"THAIYEAR",379:"RTD",380:"CUBEVALUE",381:"CUBEMEMBER",382:"CUBEMEMBERPROPERTY",383:"CUBERANKEDMEMBER",384:"HEX2BIN",385:"HEX2DEC",386:"HEX2OCT",387:"DEC2BIN",388:"DEC2HEX",389:"DEC2OCT",390:"OCT2BIN",391:"OCT2HEX",392:"OCT2DEC",393:"BIN2DEC",394:"BIN2OCT",395:"BIN2HEX",396:"IMSUB",397:"IMDIV",398:"IMPOWER",399:"IMABS",400:"IMSQRT",401:"IMLN",402:"IMLOG2",403:"IMLOG10",404:"IMSIN",405:"IMCOS",406:"IMEXP",407:"IMARGUMENT",408:"IMCONJUGATE",409:"IMAGINARY",410:"IMREAL",411:"COMPLEX",412:"IMSUM",413:"IMPRODUCT",414:"SERIESSUM",415:"FACTDOUBLE",416:"SQRTPI",417:"QUOTIENT",418:"DELTA",419:"GESTEP",420:"ISEVEN",421:"ISODD",422:"MROUND",423:"ERF",424:"ERFC",425:"BESSELJ",426:"BESSELK",427:"BESSELY",428:"BESSELI",429:"XIRR",430:"XNPV",431:"PRICEMAT",432:"YIELDMAT",433:"INTRATE",434:"RECEIVED",435:"DISC",436:"PRICEDISC",437:"YIELDDISC",438:"TBILLEQ",439:"TBILLPRICE",440:"TBILLYIELD",441:"PRICE",442:"YIELD",443:"DOLLARDE",444:"DOLLARFR",445:"NOMINAL",446:"EFFECT",447:"CUMPRINC",448:"CUMIPMT",449:"EDATE",450:"EOMONTH",451:"YEARFRAC",452:"COUPDAYBS",453:"COUPDAYS",454:"COUPDAYSNC",455:"COUPNCD",456:"COUPNUM",457:"COUPPCD",458:"DURATION",459:"MDURATION",460:"ODDLPRICE",461:"ODDLYIELD",462:"ODDFPRICE",463:"ODDFYIELD",464:"RANDBETWEEN",465:"WEEKNUM",466:"AMORDEGRC",467:"AMORLINC",468:"CONVERT",724:"SHEETJS",469:"ACCRINT",470:"ACCRINTM",471:"WORKDAY",472:"NETWORKDAYS",473:"GCD",474:"MULTINOMIAL",475:"LCM",476:"FVSCHEDULE",477:"CUBEKPIMEMBER",478:"CUBESET",479:"CUBESETCOUNT",480:"IFERROR",481:"COUNTIFS",482:"SUMIFS",483:"AVERAGEIF",484:"AVERAGEIFS"};var Uh={2:1,3:1,10:0,15:1,16:1,17:1,18:1,19:0,20:1,21:1,22:1,23:1,24:1,25:1,26:1,27:2,30:2,31:3,32:1,33:1,34:0,35:0,38:1,39:2,40:3,41:3,42:3,43:3,44:3,45:3,47:3,48:2,53:1,61:3,63:0,65:3,66:3,67:1,68:1,69:1,70:1,71:1,72:1,73:1,74:0,75:1,76:1,77:1,79:2,80:2,83:1,85:0,86:1,89:0,90:1,94:0,95:0,97:2,98:1,99:1,101:3,102:3,105:1,106:1,108:2,111:1,112:1,113:1,114:1,117:2,118:1,119:4,121:1,126:1,127:1,128:1,129:1,130:1,131:1,133:1,134:1,135:1,136:2,137:2,138:2,140:1,141:1,142:3,143:4,144:4,161:1,162:1,163:1,164:1,165:2,172:1,175:2,176:2,177:3,178:2,179:1,184:1,186:1,189:3,190:1,195:3,196:3,197:1,198:1,199:3,201:1,207:4,210:3,211:1,212:2,213:2,214:1,215:1,225:0,229:1,230:1,231:1,232:1,233:1,234:1,235:3,244:1,247:4,252:2,257:1,261:1,271:1,273:4,274:2,275:2,276:2,277:3,278:3,279:1,280:3,281:3,282:3,283:1,284:1,285:2,286:4,287:3,288:2,289:4,290:3,291:3,292:3,293:4,294:1,295:3,296:1,297:3,298:1,299:2,300:3,301:3,302:4,303:2,304:2,305:2,306:2,307:2,308:2,309:3,310:2,311:2,312:2,313:2,314:2,315:2,316:4,325:2,326:2,327:2,328:2,331:2,332:2,337:2,342:1,343:1,346:2,347:1,350:4,351:3,352:1,353:2,360:1,368:1,369:1,370:1,371:1,372:1,373:1,374:1,375:1,376:1,377:1,378:1,382:3,385:1,392:1,393:1,396:2,397:2,398:2,399:1,400:1,401:1,402:1,403:1,404:1,405:1,406:1,407:1,408:1,409:1,410:1,414:4,415:1,416:1,417:2,420:1,421:1,422:2,424:1,425:2,426:2,427:2,428:2,430:3,438:3,439:3,440:3,443:2,444:2,445:2,446:2,447:6,448:6,449:2,450:2,464:2,468:3,476:2,479:1,480:2,65535:0};var Hh={"_xlfn.ACOT":"ACOT","_xlfn.ACOTH":"ACOTH","_xlfn.AGGREGATE":"AGGREGATE","_xlfn.ARABIC":"ARABIC","_xlfn.AVERAGEIF":"AVERAGEIF","_xlfn.AVERAGEIFS":"AVERAGEIFS","_xlfn.BASE":"BASE","_xlfn.BETA.DIST":"BETA.DIST","_xlfn.BETA.INV":"BETA.INV","_xlfn.BINOM.DIST":"BINOM.DIST","_xlfn.BINOM.DIST.RANGE":"BINOM.DIST.RANGE","_xlfn.BINOM.INV":"BINOM.INV","_xlfn.BITAND":"BITAND","_xlfn.BITLSHIFT":"BITLSHIFT","_xlfn.BITOR":"BITOR","_xlfn.BITRSHIFT":"BITRSHIFT","_xlfn.BITXOR":"BITXOR","_xlfn.CEILING.MATH":"CEILING.MATH","_xlfn.CEILING.PRECISE":"CEILING.PRECISE","_xlfn.CHISQ.DIST":"CHISQ.DIST","_xlfn.CHISQ.DIST.RT":"CHISQ.DIST.RT","_xlfn.CHISQ.INV":"CHISQ.INV","_xlfn.CHISQ.INV.RT":"CHISQ.INV.RT","_xlfn.CHISQ.TEST":"CHISQ.TEST","_xlfn.COMBINA":"COMBINA","_xlfn.CONCAT":"CONCAT","_xlfn.CONFIDENCE.NORM":"CONFIDENCE.NORM","_xlfn.CONFIDENCE.T":"CONFIDENCE.T","_xlfn.COT":"COT","_xlfn.COTH":"COTH","_xlfn.COUNTIFS":"COUNTIFS","_xlfn.COVARIANCE.P":"COVARIANCE.P","_xlfn.COVARIANCE.S":"COVARIANCE.S","_xlfn.CSC":"CSC","_xlfn.CSCH":"CSCH","_xlfn.DAYS":"DAYS","_xlfn.DECIMAL":"DECIMAL","_xlfn.ECMA.CEILING":"ECMA.CEILING","_xlfn.ERF.PRECISE":"ERF.PRECISE","_xlfn.ERFC.PRECISE":"ERFC.PRECISE","_xlfn.EXPON.DIST":"EXPON.DIST","_xlfn.F.DIST":"F.DIST","_xlfn.F.DIST.RT":"F.DIST.RT","_xlfn.F.INV":"F.INV","_xlfn.F.INV.RT":"F.INV.RT","_xlfn.F.TEST":"F.TEST","_xlfn.FILTERXML":"FILTERXML","_xlfn.FLOOR.MATH":"FLOOR.MATH","_xlfn.FLOOR.PRECISE":"FLOOR.PRECISE","_xlfn.FORECAST.ETS":"FORECAST.ETS","_xlfn.FORECAST.ETS.CONFINT":"FORECAST.ETS.CONFINT","_xlfn.FORECAST.ETS.SEASONALITY":"FORECAST.ETS.SEASONALITY","_xlfn.FORECAST.ETS.STAT":"FORECAST.ETS.STAT","_xlfn.FORECAST.LINEAR":"FORECAST.LINEAR","_xlfn.FORMULATEXT":"FORMULATEXT","_xlfn.GAMMA":"GAMMA","_xlfn.GAMMA.DIST":"GAMMA.DIST","_xlfn.GAMMA.INV":"GAMMA.INV","_xlfn.GAMMALN.PRECISE":"GAMMALN.PRECISE","_xlfn.GAUSS":"GAUSS","_xlfn.HYPGEOM.DIST":"HYPGEOM.DIST","_xlfn.IFERROR":"IFERROR","_xlfn.IFNA":"IFNA","_xlfn.IFS":"IFS","_xlfn.IMCOSH":"IMCOSH","_xlfn.IMCOT":"IMCOT","_xlfn.IMCSC":"IMCSC","_xlfn.IMCSCH":"IMCSCH","_xlfn.IMSEC":"IMSEC","_xlfn.IMSECH":"IMSECH","_xlfn.IMSINH":"IMSINH","_xlfn.IMTAN":"IMTAN","_xlfn.ISFORMULA":"ISFORMULA","_xlfn.ISO.CEILING":"ISO.CEILING","_xlfn.ISOWEEKNUM":"ISOWEEKNUM","_xlfn.LOGNORM.DIST":"LOGNORM.DIST","_xlfn.LOGNORM.INV":"LOGNORM.INV","_xlfn.MAXIFS":"MAXIFS","_xlfn.MINIFS":"MINIFS","_xlfn.MODE.MULT":"MODE.MULT","_xlfn.MODE.SNGL":"MODE.SNGL","_xlfn.MUNIT":"MUNIT","_xlfn.NEGBINOM.DIST":"NEGBINOM.DIST","_xlfn.NETWORKDAYS.INTL":"NETWORKDAYS.INTL","_xlfn.NIGBINOM":"NIGBINOM","_xlfn.NORM.DIST":"NORM.DIST","_xlfn.NORM.INV":"NORM.INV","_xlfn.NORM.S.DIST":"NORM.S.DIST","_xlfn.NORM.S.INV":"NORM.S.INV","_xlfn.NUMBERVALUE":"NUMBERVALUE","_xlfn.PDURATION":"PDURATION","_xlfn.PERCENTILE.EXC":"PERCENTILE.EXC","_xlfn.PERCENTILE.INC":"PERCENTILE.INC","_xlfn.PERCENTRANK.EXC":"PERCENTRANK.EXC","_xlfn.PERCENTRANK.INC":"PERCENTRANK.INC","_xlfn.PERMUTATIONA":"PERMUTATIONA","_xlfn.PHI":"PHI","_xlfn.POISSON.DIST":"POISSON.DIST","_xlfn.QUARTILE.EXC":"QUARTILE.EXC","_xlfn.QUARTILE.INC":"QUARTILE.INC","_xlfn.QUERYSTRING":"QUERYSTRING","_xlfn.RANK.AVG":"RANK.AVG","_xlfn.RANK.EQ":"RANK.EQ","_xlfn.RRI":"RRI","_xlfn.SEC":"SEC","_xlfn.SECH":"SECH","_xlfn.SHEET":"SHEET","_xlfn.SHEETS":"SHEETS","_xlfn.SKEW.P":"SKEW.P","_xlfn.STDEV.P":"STDEV.P","_xlfn.STDEV.S":"STDEV.S","_xlfn.SUMIFS":"SUMIFS","_xlfn.SWITCH":"SWITCH","_xlfn.T.DIST":"T.DIST","_xlfn.T.DIST.2T":"T.DIST.2T","_xlfn.T.DIST.RT":"T.DIST.RT","_xlfn.T.INV":"T.INV","_xlfn.T.INV.2T":"T.INV.2T","_xlfn.T.TEST":"T.TEST","_xlfn.TEXTJOIN":"TEXTJOIN","_xlfn.UNICHAR":"UNICHAR","_xlfn.UNICODE":"UNICODE","_xlfn.VAR.P":"VAR.P","_xlfn.VAR.S":"VAR.S","_xlfn.WEBSERVICE":"WEBSERVICE","_xlfn.WEIBULL.DIST":"WEIBULL.DIST","_xlfn.WORKDAY.INTL":"WORKDAY.INTL","_xlfn.XOR":"XOR","_xlfn.Z.TEST":"Z.TEST"};function Wh(e){if(e.slice(0,3)=="of:")e=e.slice(3);if(e.charCodeAt(0)==61){e=e.slice(1);if(e.charCodeAt(0)==61)e=e.slice(1)}e=e.replace(/COM\.MICROSOFT\./g,"");e=e.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g,function(e,r){return r.replace(/\./g,"")});e=e.replace(/\[.(#[A-Z]*[?!])\]/g,"$1");return e.replace(/[;~]/g,",").replace(/\|/g,";")}function Vh(e){var r="of:="+e.replace(Gl,"$1[.$2$3$4$5]").replace(/\]:\[/g,":");return r.replace(/;/g,"|").replace(/,/g,";")}function zh(e){var r=e.split(":");var t=r[0].split(".")[0];return[t,r[0].split(".")[1]+(r.length>1?":"+(r[1].split(".")[1]||r[1].split(".")[0]):"")]}function Xh(e){return e.replace(/\./,"!")}var Gh={};var jh={};Ra.WS=["http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet","http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"];var Kh=typeof Map!=="undefined";function Yh(e,r,t){var a=0,n=e.length;if(t){if(Kh?t.has(r):t.hasOwnProperty(r)){var i=Kh?t.get(r):t[r];for(;a<i.length;++a){if(e[i[a]].t===r){e.Count++;return i[a]}}}}else for(;a<n;++a){if(e[a].t===r){e.Count++;return a}}e[n]={t:r};e.Count++;e.Unique++;if(t){if(Kh){if(!t.has(r))t.set(r,[]);t.get(r).push(n)}else{if(!t.hasOwnProperty(r))t[r]=[];t[r].push(n)}}return n}function $h(e,r){var t={min:e+1,max:e+1};var a=-1;if(r.MDW)ro=r.MDW;if(r.width!=null)t.customWidth=1;else if(r.wpx!=null)a=ao(r.wpx);else if(r.wch!=null)a=r.wch;if(a>-1){t.width=no(a);t.customWidth=1}else if(r.width!=null)t.width=r.width;if(r.hidden)t.hidden=true;return t}function Zh(e,r){if(!e)return;var t=[.7,.7,.75,.75,.3,.3];if(r=="xlml")t=[1,1,1,1,.5,.5];if(e.left==null)e.left=t[0];if(e.right==null)e.right=t[1];if(e.top==null)e.top=t[2];if(e.bottom==null)e.bottom=t[3];if(e.header==null)e.header=t[4];if(e.footer==null)e.footer=t[5]}function Qh(e,r,t){var a=t.revssf[r.z!=null?r.z:"General"];var n=60,i=e.length;if(a==null&&t.ssf){for(;n<392;++n)if(t.ssf[n]==null){D.load(r.z,n);t.ssf[n]=r.z;t.revssf[r.z]=a=n;break}}for(n=0;n!=i;++n)if(e[n].numFmtId===a)return n;e[i]={numFmtId:a,fontId:0,fillId:0,borderId:0,xfId:0,applyNumberFormat:1};return i}function Jh(e,r,t,a,n,i){if(e.t==="z")return;if(e.t==="d"&&typeof e.v==="string")e.v=ie(e.v);try{if(a.cellNF)e.z=D._table[r]}catch(s){if(a.WTF)throw s}if(!a||a.cellText!==false)try{if(D._table[r]==null)D.load(P[r]||"General",r);if(e.t==="e")e.w=e.w||jt[e.v];else if(r===0){if(e.t==="n"){if((e.v|0)===e.v)e.w=D._general_int(e.v);else e.w=D._general_num(e.v)}else if(e.t==="d"){var f=ee(e.v);if((f|0)===f)e.w=D._general_int(f);else e.w=D._general_num(f)}else if(e.v===undefined)return"";else e.w=D._general(e.v,jh)}else if(e.t==="d")e.w=D.format(r,ee(e.v),jh);else e.w=D.format(r,e.v,jh)}catch(s){if(a.WTF)throw s}if(!a.cellStyles)return;if(t!=null)try{e.s=i.Fills[t];if(e.s.fgColor&&e.s.fgColor.theme&&!e.s.fgColor.rgb){e.s.fgColor.rgb=Qf(n.themeElements.clrScheme[e.s.fgColor.theme].rgb,e.s.fgColor.tint||0);if(a.WTF)e.s.fgColor.raw_rgb=n.themeElements.clrScheme[e.s.fgColor.theme].rgb}if(e.s.bgColor&&e.s.bgColor.theme){e.s.bgColor.rgb=Qf(n.themeElements.clrScheme[e.s.bgColor.theme].rgb,e.s.bgColor.tint||0);if(a.WTF)e.s.bgColor.raw_rgb=n.themeElements.clrScheme[e.s.bgColor.theme].rgb}}catch(s){if(a.WTF&&i.Fills)throw s}}function qh(e,r,t){if(e&&e["!ref"]){var a=pt(e["!ref"]);if(a.e.c<a.s.c||a.e.r<a.s.r)throw new Error("Bad range ("+t+"): "+e["!ref"])}}function eu(e,r){var t=pt(r);if(t.s.r<=t.e.r&&t.s.c<=t.e.c&&t.s.r>=0&&t.s.c>=0)e["!ref"]=dt(t)}var ru=/<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;var tu=/<(?:\w+:)?sheetData>([\s\S]*)<\/(?:\w+:)?sheetData>/;var au=/<(?:\w:)?hyperlink [^>]*>/gm;var nu=/"(\w*:\w*)"/;var iu=/<(?:\w:)?col[^>]*[\/]?>/g;var su=/<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;var fu=/<(?:\w:)?pageMargins[^>]*\/>/g;var ou=/<(?:\w:)?sheetPr(?:[^>a-z][^>]*)?\/>/;var lu=/<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;function cu(e,r,t,a,n,i,s){if(!e)return e;if(v!=null&&r.dense==null)r.dense=v;var f=r.dense?[]:{};var o={s:{r:2e6,c:2e6},e:{r:0,c:0}};var l="",c="";var h=e.match(tu);if(h){l=e.slice(0,h.index);c=e.slice(h.index+h[0].length)}else l=c=e;var u=l.match(ou);if(u)uu(u[0],f,n,t);var d=(l.match(/<(?:\w*:)?dimension/)||{index:-1}).index;if(d>0){var p=l.slice(d,d+50).match(nu);if(p)eu(f,p[1])}var g=l.match(lu);if(g&&g[1])ku(g[1],n);var m=[];if(r.cellStyles){var b=l.match(iu);if(b)mu(m,b)}if(h)_u(h[1],f,r,o,i,s);var w=c.match(su);if(w)f["!autofilter"]=wu(w[0]);var C=[];var E=c.match(ru);if(E)for(d=0;d!=E.length;++d)C[d]=pt(E[d].slice(E[d].indexOf('"')+1));var k=c.match(au);if(k)pu(f,k,a);var S=c.match(fu);if(S)f["!margins"]=vu(ye(S[0]));if(!f["!ref"]&&o.e.c>=o.s.c&&o.e.r>=o.s.r)f["!ref"]=dt(o);if(r.sheetRows>0&&f["!ref"]){var A=pt(f["!ref"]);if(r.sheetRows<=+A.e.r){A.e.r=r.sheetRows-1;if(A.e.r>o.e.r)A.e.r=o.e.r;if(A.e.r<A.s.r)A.s.r=A.e.r;if(A.e.c>o.e.c)A.e.c=o.e.c;if(A.e.c<A.s.c)A.s.c=A.e.c;f["!fullref"]=f["!ref"];f["!ref"]=dt(A)}}if(m.length>0)f["!cols"]=m;if(C.length>0)f["!merges"]=C;return f}function hu(e){if(e.length===0)return"";var r='<mergeCells count="'+e.length+'">';for(var t=0;t!=e.length;++t)r+='<mergeCell ref="'+dt(e[t])+'"/>';return r+"</mergeCells>"}function uu(e,r,t,a){var n=ye(e);if(!t.Sheets[a])t.Sheets[a]={};if(n.codeName)t.Sheets[a].CodeName=n.codeName}function du(e){var r={sheet:1};var t=["objects","scenarios","selectLockedCells","selectUnlockedCells"];var a=["formatColumns","formatRows","formatCells","insertColumns","insertRows","insertHyperlinks","deleteColumns","deleteRows","sort","autoFilter","pivotTables"];t.forEach(function(t){if(e[t]!=null&&e[t])r[t]="1"});a.forEach(function(t){if(e[t]!=null&&!e[t])r[t]="0"});if(e.password)r.password=Uf(e.password).toString(16).toUpperCase();return ar("sheetProtection",null,r)}function pu(e,r,t){var a=Array.isArray(e);for(var n=0;n!=r.length;++n){var i=ye(ze(r[n]),true);if(!i.ref)return;var s=((t||{})["!id"]||[])[i.id];if(s){i.Target=s.Target;if(i.location)i.Target+="#"+i.location}else{i.Target="#"+i.location;s={Target:i.Target,TargetMode:"Internal"}}i.Rel=s;if(i.tooltip){i.Tooltip=i.tooltip;delete i.tooltip}var f=pt(i.ref);for(var o=f.s.r;o<=f.e.r;++o)for(var l=f.s.c;l<=f.e.c;++l){var c=ht({c:l,r:o});if(a){if(!e[o])e[o]=[];if(!e[o][l])e[o][l]={t:"z",v:undefined};e[o][l].l=i}else{if(!e[c])e[c]={t:"z",v:undefined};e[c].l=i}}}}function vu(e){var r={};["left","right","top","bottom","header","footer"].forEach(function(t){if(e[t])r[t]=parseFloat(e[t])});return r}function gu(e){Zh(e);return ar("pageMargins",null,e)}function mu(e,r){var t=false;for(var a=0;a!=r.length;++a){var n=ye(r[a],true);if(n.hidden)n.hidden=Ve(n.hidden);var i=parseInt(n.min,10)-1,s=parseInt(n.max,10)-1;delete n.min;delete n.max;n.width=+n.width;if(!t&&n.width){t=true;so(n.width)}fo(n);while(i<=s)e[i++]=fe(n)}}function bu(e,r){var t=["<cols>"],a;for(var n=0;n!=r.length;++n){if(!(a=r[n]))continue;t[t.length]=ar("col",null,$h(n,a))}t[t.length]="</cols>";return t.join("")}function wu(e){var r={ref:(e.match(/ref="([^"]*)"/)||[])[1]};return r}function Cu(e){return ar("autoFilter",null,{ref:e.ref})}var Eu=/<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/>/;function ku(e,r){(e.match(Eu)||[]).forEach(function(e){var t=ye(e);if(Ve(t.rightToLeft)){if(!r.Views)r.Views=[{}];if(!r.Views[0])r.Views[0]={};r.Views[0].RTL=true}})}function Su(e,r,t,a){var n={workbookViewId:"0"};if((((a||{}).Workbook||{}).Views||[])[0])n.rightToLeft=a.Workbook.Views[0].RTL?"1":"0";return ar("sheetViews",ar("sheetView",null,n),{})}function Au(e,r,t,a){if(e.v===undefined&&e.f===undefined||e.t==="z")return"";var n="";var i=e.t,s=e.v;switch(e.t){case"b":n=e.v?"1":"0";break;case"n":n=""+e.v;break;case"e":n=jt[e.v];break;case"d":if(a.cellDates)n=ie(e.v,-1).toISOString();else{e=fe(e);e.t="n";n=""+(e.v=ee(ie(e.v)))}if(typeof e.z==="undefined")e.z=D._table[14];break;default:n=e.v;break;}var f=rr("v",Pe(n)),o={r:r};var l=Qh(a.cellXfs,e,a);if(l!==0)o.s=l;switch(e.t){case"n":break;case"d":o.t="d";break;case"b":o.t="b";break;case"e":o.t="e";break;default:if(e.v==null){delete e.t;break}if(a.bookSST){f=rr("v",""+Yh(a.Strings,e.v,a.revStrings));o.t="s";break}o.t="str";break;}if(e.t!=i){e.t=i;e.v=s}if(e.f){var c=e.F&&e.F.slice(0,r.length)==r?{t:"array",ref:e.F}:null;f=ar("f",Pe(e.f),c)+(e.v!=null?f:"")}if(e.l)t["!links"].push([r,e.l]);if(e.c)t["!comments"].push([r,e.c]);return ar("c",f,o)}var _u=function(){var e=/<(?:\w+:)?c[ >]/,r=/<\/(?:\w+:)?row>/;var t=/r=["']([^"']*)["']/,a=/<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;var n=/ref=["']([^"']*)["']/;var i=Ye("v"),s=Ye("f");return function f(o,l,c,h,u,d){var p=0,v="",g=[],m=[],b=0,w=0,C=0,E="",k;var S,A=0,_=0;var B,T;var y=0,x=0;var I=Array.isArray(d.CellXf),R;var O=[];var F=[];var P=Array.isArray(l);var N=[],L={},M=false;for(var U=o.split(r),H=0,W=U.length;H!=W;++H){v=U[H].trim();var V=v.length;if(V===0)continue;for(p=0;p<V;++p)if(v.charCodeAt(p)===62)break;++p;S=ye(v.slice(0,p),true);A=S.r!=null?parseInt(S.r,10):A+1;_=-1;if(c.sheetRows&&c.sheetRows<A)continue;if(h.s.r>A-1)h.s.r=A-1;if(h.e.r<A-1)h.e.r=A-1;if(c&&c.cellStyles){L={};M=false;if(S.ht){M=true;L.hpt=parseFloat(S.ht);L.hpx=ho(L.hpt)}if(S.hidden=="1"){M=true;L.hidden=true}if(S.outlineLevel!=null){M=true;L.level=+S.outlineLevel}if(M)N[A-1]=L}g=v.slice(p).split(e);for(p=0;p!=g.length;++p){v=g[p].trim();if(v.length===0)continue;m=v.match(t);b=p;w=0;C=0;v="<c "+(v.slice(0,1)=="<"?">":"")+v;if(m!=null&&m.length===2){b=0;E=m[1];for(w=0;w!=E.length;++w){if((C=E.charCodeAt(w)-64)<1||C>26)break;b=26*b+C}--b;_=b}else++_;for(w=0;w!=v.length;++w)if(v.charCodeAt(w)===62)break;++w;S=ye(v.slice(0,w),true);if(!S.r)S.r=ht({r:A-1,c:_});E=v.slice(w);k={t:""};if((m=E.match(i))!=null&&m[1]!=="")k.v=De(m[1]);if(c.cellFormula){if((m=E.match(s))!=null&&m[1]!==""){k.f=Zl(De(ze(m[1])));if(m[0].indexOf('t="array"')>-1){k.F=(E.match(n)||[])[1];if(k.F.indexOf(":")>-1)O.push([pt(k.F),k.F])}else if(m[0].indexOf('t="shared"')>-1){T=ye(m[0]);F[parseInt(T.si,10)]=[T,Zl(De(ze(m[1])))]}}else if(m=E.match(/<f[^>]*\/>/)){T=ye(m[0]);if(F[T.si])k.f=Yl(F[T.si][1],F[T.si][0].ref,S.r)}var z=ct(S.r);for(w=0;w<O.length;++w)if(z.r>=O[w][0].s.r&&z.r<=O[w][0].e.r)if(z.c>=O[w][0].s.c&&z.c<=O[w][0].e.c)k.F=O[w][1]}if(S.t==null&&k.v===undefined){if(k.f||k.F){k.v=0;k.t="n"}else if(!c.sheetStubs)continue;else k.t="z"}else k.t=S.t||"n";if(h.s.c>_)h.s.c=_;if(h.e.c<_)h.e.c=_;switch(k.t){case"n":if(k.v==""||k.v==null){if(!c.sheetStubs)continue;k.t="z"}else k.v=parseFloat(k.v);break;case"s":if(typeof k.v=="undefined"){if(!c.sheetStubs)continue;k.t="z"}else{B=Gh[parseInt(k.v,10)];k.v=B.t;k.r=B.r;if(c.cellHTML)k.h=B.h}break;case"str":k.t="s";k.v=k.v!=null?ze(k.v):"";if(c.cellHTML)k.h=Me(k.v);break;case"inlineStr":m=E.match(a);k.t="s";if(m!=null&&(B=hf(m[1])))k.v=B.t;else k.v="";break;case"b":k.v=Ve(k.v);break;case"d":if(c.cellDates)k.v=ie(k.v,1);else{k.v=ee(ie(k.v,1));k.t="n"}break;case"e":if(!c||c.cellText!==false)k.w=k.v;k.v=Kt[k.v];break;}y=x=0;if(I&&S.s!==undefined){R=d.CellXf[S.s];if(R!=null){if(R.numFmtId!=null)y=R.numFmtId;if(c.cellStyles){if(R.fillId!=null)x=R.fillId}}}Jh(k,y,x,c,u,d);if(c.cellDates&&I&&k.t=="n"&&D.is_date(D._table[y])){k.t="d";k.v=re(k.v)}if(P){var X=ct(S.r);if(!l[X.r])l[X.r]=[];l[X.r][X.c]=k}else l[S.r]=k}}if(N.length>0)l["!rows"]=N}}();function Bu(e,r,t,a){var n=[],i=[],s=pt(e["!ref"]),f="",o,l="",c=[],h=0,u=0,d=e["!rows"];var p=Array.isArray(e);var v={r:l},g,m=-1;for(u=s.s.c;u<=s.e.c;++u)c[u]=st(u);for(h=s.s.r;h<=s.e.r;++h){i=[];l=tt(h);for(u=s.s.c;u<=s.e.c;++u){o=c[u]+l;var b=p?(e[h]||[])[u]:e[o];if(b===undefined)continue;if((f=Au(b,o,e,r,t,a))!=null)i.push(f)}if(i.length>0||d&&d[h]){v={r:l};if(d&&d[h]){g=d[h];if(g.hidden)v.hidden=1;m=-1;if(g.hpx)m=co(g.hpx);else if(g.hpt)m=g.hpt;if(m>-1){v.ht=m;v.customHeight=1}if(g.level){v.outlineLevel=g.level}}n[n.length]=ar("row",i.join(""),v)}}if(d)for(;h<d.length;++h){if(d&&d[h]){v={r:h+1};g=d[h];if(g.hidden)v.hidden=1;m=-1;if(g.hpx)m=co(g.hpx);else if(g.hpt)m=g.hpt;if(m>-1){v.ht=m;v.customHeight=1}if(g.level){v.outlineLevel=g.level}n[n.length]=ar("row","",v)}}return n.join("")}var Tu=ar("worksheet",null,{xmlns:sr.main[0],"xmlns:r":sr.r});function yu(e,r,t,a){var n=[Se,Tu];var i=t.SheetNames[e],s=0,f="";var o=t.Sheets[i];if(o==null)o={};var l=o["!ref"]||"A1";var c=pt(l);if(c.e.c>16383||c.e.r>1048575){if(r.WTF)throw new Error("Range "+l+" exceeds format limit A1:XFD1048576");c.e.c=Math.min(c.e.c,16383);c.e.r=Math.min(c.e.c,1048575);l=dt(c)}if(!a)a={};o["!comments"]=[];o["!drawing"]=[];if(r.bookType!=="xlsx"&&t.vbaraw){var h=t.SheetNames[e];try{if(t.Workbook)h=t.Workbook.Sheets[e].CodeName||h}catch(u){}n[n.length]=ar("sheetPr",null,{codeName:Pe(h)})}n[n.length]=ar("dimension",null,{ref:l});n[n.length]=Su(o,r,e,t);if(r.sheetFormat)n[n.length]=ar("sheetFormatPr",null,{defaultRowHeight:r.sheetFormat.defaultRowHeight||"16",baseColWidth:r.sheetFormat.baseColWidth||"10",outlineLevelRow:r.sheetFormat.outlineLevelRow||"7"});if(o["!cols"]!=null&&o["!cols"].length>0)n[n.length]=bu(o,o["!cols"]);n[s=n.length]="<sheetData/>";o["!links"]=[];if(o["!ref"]!=null){f=Bu(o,r,e,t,a);if(f.length>0)n[n.length]=f}if(n.length>s+1){n[n.length]="</sheetData>";n[s]=n[s].replace("/>",">")}if(o["!protect"]!=null)n[n.length]=du(o["!protect"]);if(o["!autofilter"]!=null)n[n.length]=Cu(o["!autofilter"]);if(o["!merges"]!=null&&o["!merges"].length>0)n[n.length]=hu(o["!merges"]);var d=-1,p,v=-1;if(o["!links"].length>0){n[n.length]="<hyperlinks>";o["!links"].forEach(function(e){if(!e[1].Target)return;p={ref:e[0]};if(e[1].Target.charAt(0)!="#"){v=Na(a,-1,Pe(e[1].Target).replace(/#.*$/,""),Ra.HLINK);p["r:id"]="rId"+v}if((d=e[1].Target.indexOf("#"))>-1)p.location=Pe(e[1].Target.slice(d+1));if(e[1].Tooltip)p.tooltip=Pe(e[1].Tooltip);n[n.length]=ar("hyperlink",null,p)});n[n.length]="</hyperlinks>"}delete o["!links"];if(o["!margins"]!=null)n[n.length]=gu(o["!margins"]);n[n.length]="";if(!r||r.ignoreEC||r.ignoreEC==void 0)n[n.length]=rr("ignoredErrors",ar("ignoredError",null,{numberStoredAsText:1,sqref:l}));if(o["!drawing"].length>0){v=Na(a,-1,"../drawings/drawing"+(e+1)+".xml",Ra.DRAW);n[n.length]=ar("drawing",null,{"r:id":"rId"+v})}else delete o["!drawing"];if(o["!comments"].length>0){v=Na(a,-1,"../drawings/vmlDrawing"+(e+1)+".vml",Ra.VML);n[n.length]=ar("legacyDrawing",null,{"r:id":"rId"+v});o["!legacy"]=v}if(n.length>2){n[n.length]="</worksheet>";n[1]=n[1].replace("/>",">")}return n.join("")}function xu(e,r){var t={};var a=e.l+r;t.r=e._R(4);e.l+=4;var n=e._R(2);e.l+=1;var i=e._R(1);e.l=a;if(i&7)t.level=i&7;if(i&16)t.hidden=true;if(i&32)t.hpt=n/20;return t}function Iu(e,r,t){var a=Gr(17+8*16);var n=(t["!rows"]||[])[e]||{};a._W(4,e);a._W(4,0);var i=320;if(n.hpx)i=co(n.hpx)*20;else if(n.hpt)i=n.hpt*20;a._W(2,i);a._W(1,0);var s=0;if(n.level)s|=n.level;if(n.hidden)s|=16;if(n.hpx||n.hpt)s|=32;a._W(1,s);a._W(1,0);var f=0,o=a.l;a.l+=4;var l={r:e,c:0};for(var c=0;c<16;++c){if(r.s.c>c+1<<10||r.e.c<c<<10)continue;var h=-1,u=-1;for(var d=c<<10;d<c+1<<10;++d){l.c=d;var p=Array.isArray(t)?(t[l.r]||[])[l.c]:t[ht(l)];if(p){if(h<0)h=d;u=d}}if(h<0)continue;++f;a._W(4,h);a._W(4,u)}var v=a.l;a.l=o;a._W(4,f);a.l=v;return a.length>a.l?a.slice(0,a.l):a}function Ru(e,r,t,a){var n=Iu(a,t,r);if(n.length>17||(r["!rows"]||[])[a])Yr(e,"BrtRowHdr",n)}var Du=Vt;var Ou=zt;function Fu(){}function Pu(e,r){var t={};e.l+=19;t.name=Rt(e,r-19);return t}function Nu(e,r){if(r==null)r=Gr(84+4*e.length);for(var t=0;t<3;++t)r._W(1,0);$t({auto:1},r);r._W(-4,-1);r._W(-4,-1);Dt(e,r);return r.slice(0,r.l)}function Lu(e){var r=xt(e);return[r]}function Mu(e,r,t){if(t==null)t=Gr(8);return It(r,t)}function Uu(e){var r=xt(e);var t=e._R(1);return[r,t,"b"]}function Hu(e,r,t){if(t==null)t=Gr(9);It(r,t);t._W(1,e.v?1:0);return t}function Wu(e){var r=xt(e);var t=e._R(1);return[r,t,"e"]}function Vu(e){var r=xt(e);var t=e._R(4);return[r,t,"s"]}function zu(e,r,t){if(t==null)t=Gr(12);It(r,t);t._W(4,r.v);return t}function Xu(e){var r=xt(e);var t=Xt(e);return[r,t,"n"]}function Gu(e,r,t){if(t==null)t=Gr(16);It(r,t);Gt(e.v,t);return t}function ju(e){var r=xt(e);var t=Mt(e);return[r,t,"n"]}function Ku(e,r,t){if(t==null)t=Gr(12);It(r,t);Ut(e.v,t);return t}function Yu(e){var r=xt(e);var t=Et(e);return[r,t,"str"]}function $u(e,r,t){if(t==null)t=Gr(12+4*e.v.length);It(r,t);kt(e.v,t);return t.length>t.l?t.slice(0,t.l):t}function Zu(e,r,t){var a=e.l+r;var n=xt(e);n.r=t["!row"];var i=e._R(1);var s=[n,i,"b"];if(t.cellFormula){e.l+=2;var f=Fh(e,a-e.l,t);s[3]=_h(f,null,n,t.supbooks,t)}else e.l=a;return s}function Qu(e,r,t){var a=e.l+r;var n=xt(e);n.r=t["!row"];var i=e._R(1);var s=[n,i,"e"];if(t.cellFormula){e.l+=2;var f=Fh(e,a-e.l,t);s[3]=_h(f,null,n,t.supbooks,t)}else e.l=a;return s}function Ju(e,r,t){var a=e.l+r;var n=xt(e);n.r=t["!row"];var i=Xt(e);var s=[n,i,"n"];if(t.cellFormula){e.l+=2;var f=Fh(e,a-e.l,t);s[3]=_h(f,null,n,t.supbooks,t)}else e.l=a;return s}function qu(e,r,t){var a=e.l+r;var n=xt(e);n.r=t["!row"];var i=Et(e);var s=[n,i,"str"];if(t.cellFormula){e.l+=2;var f=Fh(e,a-e.l,t);s[3]=_h(f,null,n,t.supbooks,t)}else e.l=a;return s}var ed=Vt;var rd=zt;function td(e,r){if(r==null)r=Gr(4);r._W(4,e);return r}function ad(e,r){var t=e.l+r;var a=Vt(e,16);var n=Ot(e);var i=Et(e);var s=Et(e);var f=Et(e);e.l=t;var o={rfx:a,relId:n,loc:i,display:f};if(s)o.Tooltip=s;return o}function nd(e,r){var t=Gr(50+4*(e[1].Target.length+(e[1].Tooltip||"").length));zt({s:ct(e[0]),e:ct(e[0])},t);Lt("rId"+r,t);var a=e[1].Target.indexOf("#");var n=a==-1?"":e[1].Target.slice(a+1);kt(n||"",t);kt(e[1].Tooltip||"",t);kt("",t);return t.slice(0,t.l)}function id(e,r,t){var a=e.l+r;var n=Ht(e,16);var i=e._R(1);var s=[n];s[2]=i;if(t.cellFormula){var f=Oh(e,a-e.l,t);s[1]=f}else e.l=a;return s}function sd(e,r,t){var a=e.l+r;var n=Vt(e,16);var i=[n];if(t.cellFormula){var s=Nh(e,a-e.l,t);i[1]=s;e.l=a}else e.l=a;return i}function fd(e,r,t){if(t==null)t=Gr(18);var a=$h(e,r);t._W(-4,e);t._W(-4,e);t._W(4,(a.width||10)*256);t._W(4,0);var n=0;if(r.hidden)n|=1;if(typeof a.width=="number")n|=2;t._W(1,n);t._W(1,0);return t}var od=["left","right","top","bottom","header","footer"];function ld(e){var r={};od.forEach(function(t){r[t]=Xt(e,8)});return r}function cd(e,r){if(r==null)r=Gr(6*8);Zh(e);od.forEach(function(t){Gt(e[t],r)});return r}function hd(e){var r=e._R(2);e.l+=28;return{RTL:r&32}}function ud(e,r,t){if(t==null)t=Gr(30);var a=924;if((((r||{}).Views||[])[0]||{}).RTL)a|=32;t._W(2,a);t._W(4,0);t._W(4,0);t._W(4,0);t._W(1,0);t._W(1,0);t._W(2,0);t._W(2,100);t._W(2,0);t._W(2,0);t._W(2,0);t._W(4,0);return t}function dd(e){var r=Gr(24);r._W(4,4);r._W(4,1);zt(e,r);return r}function pd(e,r){if(r==null)r=Gr(16*4+2);r._W(2,e.password?Uf(e.password):0);r._W(4,1);[["objects",false],["scenarios",false],["formatCells",true],["formatColumns",true],["formatRows",true],["insertColumns",true],["insertRows",true],["insertHyperlinks",true],["deleteColumns",true],["deleteRows",true],["selectLockedCells",false],["sort",true],["autoFilter",true],["pivotTables",true],["selectUnlockedCells",false]].forEach(function(t){if(t[1])r._W(4,e[t[0]]!=null&&!e[t[0]]?1:0);else r._W(4,e[t[0]]!=null&&e[t[0]]?0:1)});return r}function vd(e,r,t,a,n,i,s){if(!e)return e;var f=r||{};if(!a)a={"!id":{}};if(v!=null&&f.dense==null)f.dense=v;var o=f.dense?[]:{};var l;var c={s:{r:2e6,c:2e6},e:{r:0,c:0}};var h=false,u=false;var d,p,g,m,b,w,C,E,k;var S=[];f.biff=12;f["!row"]=0;var A=0,_=false;var B=[];var T={};var y=f.supbooks||[[]];y.sharedf=T;y.arrayf=B;y.SheetNames=n.SheetNames||n.Sheets.map(function(e){return e.name});if(!f.supbooks){f.supbooks=y;if(n.Names)for(var x=0;x<n.Names.length;++x)y[0][x+1]=n.Names[x]}var I=[],R=[];var O=false;jr(e,function P(e,r,v){if(u)return;switch(v){case 148:l=e;break;case 0:d=e;if(f.sheetRows&&f.sheetRows<=d.r)u=true;E=tt(m=d.r);f["!row"]=d.r;if(e.hidden||e.hpt||e.level!=null){if(e.hpt)e.hpx=ho(e.hpt);R[e.r]=e}break;case 2:;case 3:;case 4:;case 5:;case 6:;case 7:;case 8:;case 9:;case 10:;case 11:p={t:e[2]};switch(e[2]){case"n":p.v=e[1];break;case"s":C=Gh[e[1]];p.v=C.t;p.r=C.r;break;case"b":p.v=e[1]?true:false;break;case"e":p.v=e[1];if(f.cellText!==false)p.w=jt[p.v];break;case"str":p.t="s";p.v=e[1];break;}if(g=s.CellXf[e[0].iStyleRef])Jh(p,g.numFmtId,null,f,i,s);b=e[0].c;if(f.dense){if(!o[m])o[m]=[];o[m][b]=p}else o[st(b)+E]=p;if(f.cellFormula){_=false;for(A=0;A<B.length;++A){var x=B[A];if(d.r>=x[0].s.r&&d.r<=x[0].e.r)if(b>=x[0].s.c&&b<=x[0].e.c){p.F=dt(x[0]);_=true}}if(!_&&e.length>3)p.f=e[3]}if(c.s.r>d.r)c.s.r=d.r;if(c.s.c>b)c.s.c=b;if(c.e.r<d.r)c.e.r=d.r;if(c.e.c<b)c.e.c=b;if(f.cellDates&&g&&p.t=="n"&&D.is_date(D._table[g.numFmtId])){var F=D.parse_date_code(p.v);if(F){p.t="d";p.v=new Date(F.y,F.m-1,F.d,F.H,F.M,F.S,F.u)}}break;case 1:if(!f.sheetStubs||h)break;p={t:"z",v:undefined};b=e[0].c;if(f.dense){if(!o[m])o[m]=[];o[m][b]=p}else o[st(b)+E]=p;if(c.s.r>d.r)c.s.r=d.r;if(c.s.c>b)c.s.c=b;if(c.e.r<d.r)c.e.r=d.r;if(c.e.c<b)c.e.c=b;break;case 176:S.push(e);break;case 494:var P=a["!id"][e.relId];if(P){e.Target=P.Target;if(e.loc)e.Target+="#"+e.loc;e.Rel=P}else if(e.relId==""){e.Target="#"+e.loc}for(m=e.rfx.s.r;m<=e.rfx.e.r;++m)for(b=e.rfx.s.c;b<=e.rfx.e.c;++b){if(f.dense){if(!o[m])o[m]=[];if(!o[m][b])o[m][b]={t:"z",v:undefined};o[m][b].l=e}else{w=ht({c:b,r:m});if(!o[w])o[w]={t:"z",v:undefined};o[w].l=e}}break;case 426:if(!f.cellFormula)break;B.push(e);k=f.dense?o[m][b]:o[st(b)+E];k.f=_h(e[1],c,{r:d.r,c:b},y,f);k.F=dt(e[0]);break;case 427:if(!f.cellFormula)break;T[ht(e[0].s)]=e[1];k=f.dense?o[m][b]:o[st(b)+E];k.f=_h(e[1],c,{r:d.r,c:b},y,f);break;case 60:if(!f.cellStyles)break;while(e.e>=e.s){I[e.e--]={width:e.w/256,hidden:!!(e.flags&1)};if(!O){O=true;so(e.w/256)}fo(I[e.e+1])}break;case 161:o["!autofilter"]={ref:dt(e)};break;case 476:o["!margins"]=e;break;case 147:if(!n.Sheets[t])n.Sheets[t]={};if(e.name)n.Sheets[t].CodeName=e.name;break;case 137:if(!n.Views)n.Views=[{}];if(!n.Views[0])n.Views[0]={};if(e.RTL)n.Views[0].RTL=true;break;case 485:break;case 175:;case 644:;case 625:;case 562:;case 396:;case 1112:;case 1146:;case 471:;case 1050:;case 649:;case 1105:;case 49:;case 589:;case 607:;case 564:;case 1055:;case 168:;case 174:;case 1180:;case 499:;case 64:;case 1053:;case 550:;case 171:;case 167:;case 1177:;case 169:;case 1181:;case 551:;case 552:;case 661:;case 639:;case 478:;case 151:;case 537:;case 477:;case 536:;case 1103:;case 680:;case 1104:;case 1024:;case 152:;case 663:;case 535:;case 678:;case 504:;case 1043:;case 428:;case 170:;case 3072:;case 50:;case 2070:;case 1045:break;case 35:h=true;break;case 36:h=false;break;case 37:break;case 38:break;default:if((r||"").indexOf("Begin")>0){}else if((r||"").indexOf("End")>0){}else if(!h||f.WTF)throw new Error("Unexpected record "+v+" "+r);}},f);delete f.supbooks;delete f["!row"];if(!o["!ref"]&&(c.s.r<2e6||l&&(l.e.r>0||l.e.c>0||l.s.r>0||l.s.c>0)))o["!ref"]=dt(l||c);if(f.sheetRows&&o["!ref"]){var F=pt(o["!ref"]);if(f.sheetRows<=+F.e.r){F.e.r=f.sheetRows-1;if(F.e.r>c.e.r)F.e.r=c.e.r;if(F.e.r<F.s.r)F.s.r=F.e.r;if(F.e.c>c.e.c)F.e.c=c.e.c;if(F.e.c<F.s.c)F.s.c=F.e.c;o["!fullref"]=o["!ref"];o["!ref"]=dt(F)}}if(S.length>0)o["!merges"]=S;if(I.length>0)o["!cols"]=I;if(R.length>0)o["!rows"]=R;return o}function gd(e,r,t,a,n,i){if(r.v===undefined)return"";var s="";switch(r.t){case"b":s=r.v?"1":"0";break;case"d":r=fe(r);r.z=r.z||D._table[14];r.v=ee(ie(r.v));r.t="n";break;case"n":;case"e":s=""+r.v;break;default:s=r.v;break;}var f={r:t,c:a};f.s=Qh(n.cellXfs,r,n);if(r.l)i["!links"].push([ht(f),r.l]);if(r.c)i["!comments"].push([ht(f),r.c]);switch(r.t){case"s":;case"str":if(n.bookSST){s=Yh(n.Strings,r.v,n.revStrings);f.t="s";f.v=s;Yr(e,"BrtCellIsst",zu(r,f))}else{f.t="str";Yr(e,"BrtCellSt",$u(r,f))}return;case"n":if(r.v==(r.v|0)&&r.v>-1e3&&r.v<1e3)Yr(e,"BrtCellRk",Ku(r,f));else Yr(e,"BrtCellReal",Gu(r,f));return;case"b":f.t="b";Yr(e,"BrtCellBool",Hu(r,f));return;case"e":f.t="e";break;}Yr(e,"BrtCellBlank",Mu(r,f))}function md(e,r,t,a){var n=pt(r["!ref"]||"A1"),i,s="",f=[];Yr(e,"BrtBeginSheetData");
var o=Array.isArray(r);var l=n.e.r;if(r["!rows"])l=Math.max(n.e.r,r["!rows"].length-1);for(var c=n.s.r;c<=l;++c){s=tt(c);Ru(e,r,n,c);if(c<=n.e.r)for(var h=n.s.c;h<=n.e.c;++h){if(c===n.s.r)f[h]=st(h);i=f[h]+s;var u=o?(r[c]||[])[h]:r[i];if(!u)continue;gd(e,u,c,h,a,r)}}Yr(e,"BrtEndSheetData")}function bd(e,r){if(!r||!r["!merges"])return;Yr(e,"BrtBeginMergeCells",td(r["!merges"].length));r["!merges"].forEach(function(r){Yr(e,"BrtMergeCell",rd(r))});Yr(e,"BrtEndMergeCells")}function wd(e,r){if(!r||!r["!cols"])return;Yr(e,"BrtBeginColInfos");r["!cols"].forEach(function(r,t){if(r)Yr(e,"BrtColInfo",fd(t,r))});Yr(e,"BrtEndColInfos")}function Cd(e,r){if(!r||!r["!ref"])return;Yr(e,"BrtBeginCellIgnoreECs");Yr(e,"BrtCellIgnoreEC",dd(pt(r["!ref"])));Yr(e,"BrtEndCellIgnoreECs")}function Ed(e,r,t){r["!links"].forEach(function(r){if(!r[1].Target)return;var a=Na(t,-1,r[1].Target.replace(/#.*$/,""),Ra.HLINK);Yr(e,"BrtHLink",nd(r,a))});delete r["!links"]}function kd(e,r,t,a){if(r["!comments"].length>0){var n=Na(a,-1,"../drawings/vmlDrawing"+(t+1)+".vml",Ra.VML);Yr(e,"BrtLegacyDrawing",Lt("rId"+n));r["!legacy"]=n}}function Sd(e,r){if(!r["!autofilter"])return;Yr(e,"BrtBeginAFilter",zt(pt(r["!autofilter"].ref)));Yr(e,"BrtEndAFilter")}function Ad(e,r,t){Yr(e,"BrtBeginWsViews");{Yr(e,"BrtBeginWsView",ud(r,t));Yr(e,"BrtEndWsView")}Yr(e,"BrtEndWsViews")}function _d(){}function Bd(e,r){if(!r["!protect"])return;Yr(e,"BrtSheetProtection",pd(r["!protect"]))}function Td(e,r,t,a){var n=Kr();var i=t.SheetNames[e],s=t.Sheets[i]||{};var f=i;try{if(t&&t.Workbook)f=t.Workbook.Sheets[e].CodeName||f}catch(o){}var l=pt(s["!ref"]||"A1");if(l.e.c>16383||l.e.r>1048575){if(r.WTF)throw new Error("Range "+(s["!ref"]||"A1")+" exceeds format limit A1:XFD1048576");l.e.c=Math.min(l.e.c,16383);l.e.r=Math.min(l.e.c,1048575)}s["!links"]=[];s["!comments"]=[];Yr(n,"BrtBeginSheet");if(t.vbaraw)Yr(n,"BrtWsProp",Nu(f));Yr(n,"BrtWsDim",Ou(l));Ad(n,s,t.Workbook);_d(n,s);wd(n,s,e,r,t);md(n,s,e,r,t);Bd(n,s);Sd(n,s);bd(n,s);Ed(n,s,a);if(s["!margins"])Yr(n,"BrtMargins",cd(s["!margins"]));if(!r||r.ignoreEC||r.ignoreEC==void 0)Cd(n,s);kd(n,s,e,a);Yr(n,"BrtEndSheet");return n.end()}function yd(e){var r=[];(e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/gm)||[]).forEach(function(e){var t=e.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);if(!t)return;r[+t[1]]=+t[2]});var t=De((e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/)||["","General"])[1]);return[r,t]}function xd(e,r,t,a,n,i){var s=i||{"!type":"chart"};if(!e)return i;var f=0,o=0,l="A";var c={s:{r:2e6,c:2e6},e:{r:0,c:0}};(e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(e){var r=yd(e);c.s.r=c.s.c=0;c.e.c=f;l=st(f);r[0].forEach(function(e,t){s[l+tt(t)]={t:"n",v:e,z:r[1]};o=t});if(c.e.r<o)c.e.r=o;++f});if(f>0)s["!ref"]=dt(c);return s}Ra.CS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";var Id=ar("chartsheet",null,{xmlns:sr.main[0],"xmlns:r":sr.r});function Rd(e,r,t,a,n){if(!e)return e;if(!a)a={"!id":{}};var i={"!type":"chart","!chart":null,"!rel":""};var s;var f=e.match(ou);if(f)uu(f[0],i,n,t);if(s=e.match(/drawing r:id="(.*?)"/))i["!rel"]=s[1];if(a["!id"][i["!rel"]])i["!chart"]=a["!id"][i["!rel"]];return i}function Dd(e,r,t,a){var n=[Se,Id];n[n.length]=ar("drawing",null,{"r:id":"rId1"});Na(a,-1,"../drawings/drawing"+(e+1)+".xml",Ra.DRAW);if(n.length>2){n[n.length]="</chartsheet>";n[1]=n[1].replace("/>",">")}return n.join("")}function Od(e,r){e.l+=10;var t=Et(e,r-10);return{name:t}}function Fd(e,r,t,a,n){if(!e)return e;if(!a)a={"!id":{}};var i={"!type":"chart","!chart":null,"!rel":""};var s=[];var f=false;jr(e,function o(e,a,l){switch(l){case 550:i["!rel"]=e;break;case 651:if(!n.Sheets[t])n.Sheets[t]={};if(e.name)n.Sheets[t].CodeName=e.name;break;case 562:;case 652:;case 669:;case 679:;case 551:;case 552:;case 476:;case 3072:break;case 35:f=true;break;case 36:f=false;break;case 37:s.push(a);break;case 38:s.pop();break;default:if((a||"").indexOf("Begin")>0)s.push(a);else if((a||"").indexOf("End")>0)s.pop();else if(!f||r.WTF)throw new Error("Unexpected record "+l+" "+a);}},r);if(a["!id"][i["!rel"]])i["!chart"]=a["!id"][i["!rel"]];return i}function Pd(){var e=Kr();Yr(e,"BrtBeginSheet");Yr(e,"BrtEndSheet");return e.end()}var Nd=[["allowRefreshQuery",false,"bool"],["autoCompressPictures",true,"bool"],["backupFile",false,"bool"],["checkCompatibility",false,"bool"],["CodeName",""],["date1904",false,"bool"],["defaultThemeVersion",0,"int"],["filterPrivacy",false,"bool"],["hidePivotFieldList",false,"bool"],["promptedSolutions",false,"bool"],["publishItems",false,"bool"],["refreshAllConnections",false,"bool"],["saveExternalLinkValues",true,"bool"],["showBorderUnselectedTables",true,"bool"],["showInkAnnotation",true,"bool"],["showObjects","all"],["showPivotChartFilter",false,"bool"],["updateLinks","userSet"]];var Ld=[["activeTab",0,"int"],["autoFilterDateGrouping",true,"bool"],["firstSheet",0,"int"],["minimized",false,"bool"],["showHorizontalScroll",true,"bool"],["showSheetTabs",true,"bool"],["showVerticalScroll",true,"bool"],["tabRatio",600,"int"],["visibility","visible"]];var Md=[];var Ud=[["calcCompleted","true"],["calcMode","auto"],["calcOnSave","true"],["concurrentCalc","true"],["fullCalcOnLoad","false"],["fullPrecision","true"],["iterate","false"],["iterateCount","100"],["iterateDelta","0.001"],["refMode","A1"]];function Hd(e,r){for(var t=0;t!=e.length;++t){var a=e[t];for(var n=0;n!=r.length;++n){var i=r[n];if(a[i[0]]==null)a[i[0]]=i[1];else switch(i[2]){case"bool":if(typeof a[i[0]]=="string")a[i[0]]=Ve(a[i[0]]);break;case"int":if(typeof a[i[0]]=="string")a[i[0]]=parseInt(a[i[0]],10);break;}}}}function Wd(e,r){for(var t=0;t!=r.length;++t){var a=r[t];if(e[a[0]]==null)e[a[0]]=a[1];else switch(a[2]){case"bool":if(typeof e[a[0]]=="string")e[a[0]]=Ve(e[a[0]]);break;case"int":if(typeof e[a[0]]=="string")e[a[0]]=parseInt(e[a[0]],10);break;}}}function Vd(e){Wd(e.WBProps,Nd);Wd(e.CalcPr,Ud);Hd(e.WBView,Ld);Hd(e.Sheets,Md);jh.date1904=Ve(e.WBProps.date1904)}function zd(e){if(!e.Workbook)return"false";if(!e.Workbook.WBProps)return"false";return Ve(e.Workbook.WBProps.date1904)?"true":"false"}var Xd="][*?/\\".split("");function Gd(e,r){if(e.length>31){if(r)return false;throw new Error("Sheet names cannot exceed 31 chars")}var t=true;Xd.forEach(function(a){if(e.indexOf(a)==-1)return;if(!r)throw new Error("Sheet name cannot contain : \\ / ? * [ ]");t=false});return t}function jd(e,r,t){e.forEach(function(a,n){Gd(a);for(var i=0;i<n;++i)if(a==e[i])throw new Error("Duplicate Sheet Name: "+a);if(t){var s=r&&r[n]&&r[n].CodeName||a;if(s.charCodeAt(0)==95&&s.length>22)throw new Error("Bad Code Name: Worksheet"+s)}})}function Kd(e){if(!e||!e.SheetNames||!e.Sheets)throw new Error("Invalid Workbook");if(!e.SheetNames.length)throw new Error("Workbook is empty");var r=e.Workbook&&e.Workbook.Sheets||[];jd(e.SheetNames,r,!!e.vbaraw);for(var t=0;t<e.SheetNames.length;++t)qh(e.Sheets[e.SheetNames[t]],e.SheetNames[t],t)}var Yd=/<\w+:workbook/;function $d(e,r){if(!e)throw new Error("Could not find file");var t={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},Names:[],xmlns:""};var a=false,n="xmlns";var i={},s=0;e.replace(_e,function f(o,l){var c=ye(o);switch(xe(c[0])){case"<?xml":break;case"<workbook":if(o.match(Yd))n="xmlns"+o.match(/<(\w+):/)[1];t.xmlns=c[n];break;case"</workbook>":break;case"<fileVersion":delete c[0];t.AppVersion=c;break;case"<fileVersion/>":;case"</fileVersion>":break;case"<fileSharing":;case"<fileSharing/>":break;case"<workbookPr":;case"<workbookPr/>":Nd.forEach(function(e){if(c[e[0]]==null)return;switch(e[2]){case"bool":t.WBProps[e[0]]=Ve(c[e[0]]);break;case"int":t.WBProps[e[0]]=parseInt(c[e[0]],10);break;default:t.WBProps[e[0]]=c[e[0]];}});if(c.codeName)t.WBProps.CodeName=c.codeName;break;case"</workbookPr>":break;case"<workbookProtection":break;case"<workbookProtection/>":break;case"<bookViews":;case"<bookViews>":;case"</bookViews>":break;case"<workbookView":;case"<workbookView/>":delete c[0];t.WBView.push(c);break;case"</workbookView>":break;case"<sheets":;case"<sheets>":;case"</sheets>":break;case"<sheet":switch(c.state){case"hidden":c.Hidden=1;break;case"veryHidden":c.Hidden=2;break;default:c.Hidden=0;}delete c.state;c.name=De(ze(c.name));delete c[0];t.Sheets.push(c);break;case"</sheet>":break;case"<functionGroups":;case"<functionGroups/>":break;case"<functionGroup":break;case"<externalReferences":;case"</externalReferences>":;case"<externalReferences>":break;case"<externalReference":break;case"<definedNames/>":break;case"<definedNames>":;case"<definedNames":a=true;break;case"</definedNames>":a=false;break;case"<definedName":{i={};i.Name=ze(c.name);if(c.comment)i.Comment=c.comment;if(c.localSheetId)i.Sheet=+c.localSheetId;s=l+o.length}break;case"</definedName>":{i.Ref=De(ze(e.slice(s,l)));t.Names.push(i)}break;case"<definedName/>":break;case"<calcPr":delete c[0];t.CalcPr=c;break;case"<calcPr/>":delete c[0];t.CalcPr=c;break;case"</calcPr>":break;case"<oleSize":break;case"<customWorkbookViews>":;case"</customWorkbookViews>":;case"<customWorkbookViews":break;case"<customWorkbookView":;case"</customWorkbookView>":break;case"<pivotCaches>":;case"</pivotCaches>":;case"<pivotCaches":break;case"<pivotCache":break;case"<smartTagPr":;case"<smartTagPr/>":break;case"<smartTagTypes":;case"<smartTagTypes>":;case"</smartTagTypes>":break;case"<smartTagType":break;case"<webPublishing":;case"<webPublishing/>":break;case"<fileRecoveryPr":;case"<fileRecoveryPr/>":break;case"<webPublishObjects>":;case"<webPublishObjects":;case"</webPublishObjects>":break;case"<webPublishObject":break;case"<extLst":;case"<extLst>":;case"</extLst>":;case"<extLst/>":break;case"<ext":a=true;break;case"</ext>":a=false;break;case"<ArchID":break;case"<AlternateContent":;case"<AlternateContent>":a=true;break;case"</AlternateContent>":a=false;break;case"<revisionPtr":break;default:if(!a&&r.WTF)throw new Error("unrecognized "+c[0]+" in workbook");}return o});if(sr.main.indexOf(t.xmlns)===-1)throw new Error("Unknown Namespace: "+t.xmlns);Vd(t);return t}var Zd=ar("workbook",null,{xmlns:sr.main[0],"xmlns:r":sr.r});function Qd(e){var r=[Se];r[r.length]=Zd;var t=e.Workbook&&(e.Workbook.Names||[]).length>0;var a={codeName:"ThisWorkbook"};if(e.Workbook&&e.Workbook.WBProps){Nd.forEach(function(r){if(e.Workbook.WBProps[r[0]]==null)return;if(e.Workbook.WBProps[r[0]]==r[1])return;a[r[0]]=e.Workbook.WBProps[r[0]]});if(e.Workbook.WBProps.CodeName){a.codeName=e.Workbook.WBProps.CodeName;delete a.CodeName}}r[r.length]=ar("workbookPr",null,a);r[r.length]="<sheets>";var n=e.Workbook&&e.Workbook.Sheets||[];for(var i=0;i!=e.SheetNames.length;++i){var s={name:Pe(e.SheetNames[i].slice(0,31))};s.sheetId=""+(i+1);s["r:id"]="rId"+(i+1);if(n[i])switch(n[i].Hidden){case 1:s.state="hidden";break;case 2:s.state="veryHidden";break;}r[r.length]=ar("sheet",null,s)}r[r.length]="</sheets>";if(t){r[r.length]="<definedNames>";if(e.Workbook&&e.Workbook.Names)e.Workbook.Names.forEach(function(e){var t={name:e.Name};if(e.Comment)t.comment=e.Comment;if(e.Sheet!=null)t.localSheetId=""+e.Sheet;if(!e.Ref)return;r[r.length]=ar("definedName",String(e.Ref),t)});r[r.length]="</definedNames>"}if(r.length>2){r[r.length]="</workbook>";r[1]=r[1].replace("/>",">")}return r.join("")}function Jd(e,r){var t={};t.Hidden=e._R(4);t.iTabID=e._R(4);t.strRelID=Nt(e,r-8);t.name=Et(e);return t}function qd(e,r){if(!r)r=Gr(127);r._W(4,e.Hidden);r._W(4,e.iTabID);Lt(e.strRelID,r);kt(e.name.slice(0,31),r);return r.length>r.l?r.slice(0,r.l):r}function ep(e,r){var t={};var a=e._R(4);t.defaultThemeVersion=e._R(4);var n=r>8?Et(e):"";if(n.length>0)t.CodeName=n;t.autoCompressPictures=!!(a&65536);t.backupFile=!!(a&64);t.checkCompatibility=!!(a&4096);t.date1904=!!(a&1);t.filterPrivacy=!!(a&8);t.hidePivotFieldList=!!(a&1024);t.promptedSolutions=!!(a&16);t.publishItems=!!(a&2048);t.refreshAllConnections=!!(a&262144);t.saveExternalLinkValues=!!(a&128);t.showBorderUnselectedTables=!!(a&4);t.showInkAnnotation=!!(a&32);t.showObjects=["all","placeholders","none"][a>>13&3];t.showPivotChartFilter=!!(a&32768);t.updateLinks=["userSet","never","always"][a>>8&3];return t}function rp(e,r){if(!r)r=Gr(72);var t=0;if(e){if(e.filterPrivacy)t|=8}r._W(4,t);r._W(4,0);Dt(e&&e.CodeName||"ThisWorkbook",r);return r.slice(0,r.l)}function tp(e,r){var t={};e._R(4);t.ArchID=e._R(4);e.l+=r-8;return t}function ap(e,r,t){var a=e.l+r;e.l+=4;e.l+=1;var n=e._R(4);var i=Pt(e);var s=Ph(e,0,t);var f=Ot(e);e.l=a;var o={Name:i,Ptg:s};if(n<268435455)o.Sheet=n;if(f)o.Comment=f;return o}function np(e,r){var t={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},xmlns:""};var a=false;if(!r)r={};r.biff=12;var n=[];var i=[[]];i.SheetNames=[];i.XTI=[];jr(e,function s(e,f,o){switch(o){case 156:i.SheetNames.push(e.name);t.Sheets.push(e);break;case 153:t.WBProps=e;break;case 39:if(e.Sheet!=null)r.SID=e.Sheet;e.Ref=_h(e.Ptg,null,null,i,r);delete r.SID;delete e.Ptg;n.push(e);break;case 1036:break;case 357:;case 358:;case 355:;case 667:if(!i[0].length)i[0]=[o,e];else i.push([o,e]);i[i.length-1].XTI=[];break;case 362:if(i.length===0){i[0]=[];i[0].XTI=[]}i[i.length-1].XTI=i[i.length-1].XTI.concat(e);i.XTI=i.XTI.concat(e);break;case 361:break;case 3072:;case 3073:;case 2071:;case 534:;case 677:;case 158:;case 157:;case 610:;case 2050:;case 155:;case 548:;case 676:;case 128:;case 665:;case 2128:;case 2125:;case 549:;case 2053:;case 596:;case 2076:;case 2075:;case 2082:;case 397:;case 154:;case 1117:;case 553:;case 2091:break;case 35:a=true;break;case 36:a=false;break;case 37:break;case 38:break;case 16:break;default:if((f||"").indexOf("Begin")>0){}else if((f||"").indexOf("End")>0){}else if(!a||r.WTF)throw new Error("Unexpected record "+o+" "+f);}},r);Vd(t);t.Names=n;t.supbooks=i;return t}function ip(e,r){Yr(e,"BrtBeginBundleShs");for(var t=0;t!=r.SheetNames.length;++t){var a=r.Workbook&&r.Workbook.Sheets&&r.Workbook.Sheets[t]&&r.Workbook.Sheets[t].Hidden||0;var n={Hidden:a,iTabID:t+1,strRelID:"rId"+(t+1),name:r.SheetNames[t]};Yr(e,"BrtBundleSh",qd(n))}Yr(e,"BrtEndBundleShs")}function sp(r,t){if(!t)t=Gr(127);for(var a=0;a!=4;++a)t._W(4,0);kt("SheetJS",t);kt(e.version,t);kt(e.version,t);kt("7262",t);t.length=t.l;return t.length>t.l?t.slice(0,t.l):t}function fp(e,r){if(!r)r=Gr(29);r._W(-4,0);r._W(-4,460);r._W(4,28800);r._W(4,17600);r._W(4,500);r._W(4,e);r._W(4,e);var t=120;r._W(1,t);return r.length>r.l?r.slice(0,r.l):r}function op(e,r){if(!r.Workbook||!r.Workbook.Sheets)return;var t=r.Workbook.Sheets;var a=0,n=-1,i=-1;for(;a<t.length;++a){if(!t[a]||!t[a].Hidden&&n==-1)n=a;else if(t[a].Hidden==1&&i==-1)i=a}if(i>n)return;Yr(e,"BrtBeginBookViews");Yr(e,"BrtBookView",fp(n));Yr(e,"BrtEndBookViews")}function lp(e,r){var t=Kr();Yr(t,"BrtBeginBook");Yr(t,"BrtFileVersion",sp());Yr(t,"BrtWbProp",rp(e.Workbook&&e.Workbook.WBProps||null));op(t,e,r);ip(t,e,r);Yr(t,"BrtEndBook");return t.end()}function cp(e,r,t){if(r.slice(-4)===".bin")return np(e,t);return $d(e,t)}function hp(e,r,t,a,n,i,s,f){if(r.slice(-4)===".bin")return vd(e,a,t,n,i,s,f);return cu(e,a,t,n,i,s,f)}function up(e,r,t,a,n,i,s,f){if(r.slice(-4)===".bin")return Fd(e,a,t,n,i,s,f);return Rd(e,a,t,n,i,s,f)}function dp(e,r,t,a,n,i,s,f){if(r.slice(-4)===".bin")return Vl(e,a,t,n,i,s,f);return zl(e,a,t,n,i,s,f)}function pp(e,r,t,a,n,i,s,f){if(r.slice(-4)===".bin")return Hl(e,a,t,n,i,s,f);return Wl(e,a,t,n,i,s,f)}function vp(e,r,t,a){if(r.slice(-4)===".bin")return Wo(e,t,a);return So(e,t,a)}function gp(e,r,t){return fl(e,t)}function mp(e,r,t){if(r.slice(-4)===".bin")return wf(e,t);return vf(e,t)}function bp(e,r,t){if(r.slice(-4)===".bin")return Fl(e,t);return Tl(e,t)}function wp(e,r,t){if(r.slice(-4)===".bin")return wl(e,r,t);return ml(e,r,t)}function Cp(e,r,t){if(r.slice(-4)===".bin")return El(e,r,t);return Cl(e,r,t)}function Ep(e,r,t){return(r.slice(-4)===".bin"?lp:Qd)(e,t)}function kp(e,r,t,a,n){return(r.slice(-4)===".bin"?Td:yu)(e,t,a,n)}function Sp(e,r,t,a,n){return(r.slice(-4)===".bin"?Pd:Dd)(e,t,a,n)}function Ap(e,r,t){return(r.slice(-4)===".bin"?Jo:_o)(e,t)}function _p(e,r,t){return(r.slice(-4)===".bin"?kf:mf)(e,t)}function Bp(e,r,t){return(r.slice(-4)===".bin"?Pl:xl)(e,t)}var Tp=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;var yp=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;var xp=function(e){return String.fromCharCode(e)};function Ip(e,r){var t=e.split(/\s+/);var a=[];if(!r)a[0]=t[0];if(t.length===1)return a;var n=e.match(Tp),i,s,f,o;if(n)for(o=0;o!=n.length;++o){i=n[o].match(yp);if((s=i[1].indexOf(":"))===-1)a[i[1]]=i[2].slice(1,i[2].length-1);else{if(i[1].slice(0,6)==="xmlns:")f="xmlns"+i[1].slice(6);else f=i[1].slice(s+1);a[f]=i[2].slice(1,i[2].length-1)}}return a}function Rp(e){var r=e.split(/\s+/);var t={};if(r.length===1)return t;var a=e.match(Tp),n,i,s,f;if(a)for(f=0;f!=a.length;++f){n=a[f].match(yp);if((i=n[1].indexOf(":"))===-1)t[n[1]]=n[2].slice(1,n[2].length-1);else{if(n[1].slice(0,6)==="xmlns:")s="xmlns"+n[1].slice(6);else s=n[1].slice(i+1);t[s]=n[2].slice(1,n[2].length-1)}}return t}function Dp(e,r){var t=F[e]||De(e);if(t==="General")return D._general(r);return D.format(t,r)}function Op(e,r,t,a){var n=a;switch((t[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]){case"boolean":n=Ve(a);break;case"i2":;case"int":n=parseInt(a,10);break;case"r4":;case"float":n=parseFloat(a);break;case"date":;case"dateTime.tz":n=ie(a);break;case"i8":;case"string":;case"fixed":;case"uuid":;case"bin.base64":break;default:throw new Error("bad custprop:"+t[0]);}e[De(r)]=n}function Fp(e,r,t){if(e.t==="z")return;if(!t||t.cellText!==false)try{if(e.t==="e"){e.w=e.w||jt[e.v]}else if(r==="General"){if(e.t==="n"){if((e.v|0)===e.v)e.w=D._general_int(e.v);else e.w=D._general_num(e.v)}else e.w=D._general(e.v)}else e.w=Dp(r||"General",e.v)}catch(a){if(t.WTF)throw a}try{var n=F[r]||r||"General";if(t.cellNF)e.z=n;if(t.cellDates&&e.t=="n"&&D.is_date(n)){var i=D.parse_date_code(e.v);if(i){e.t="d";e.v=new Date(i.y,i.m-1,i.d,i.H,i.M,i.S,i.u)}}}catch(a){if(t.WTF)throw a}}function Pp(e,r,t){if(t.cellStyles){if(r.Interior){var a=r.Interior;if(a.Pattern)a.patternType=uo[a.Pattern]||a.Pattern}}e[r.ID]=r}function Np(e,r,t,a,n,i,s,f,o,l){var c="General",h=a.StyleID,u={};l=l||{};var d=[];var p=0;if(h===undefined&&f)h=f.StyleID;if(h===undefined&&s)h=s.StyleID;while(i[h]!==undefined){if(i[h].nf)c=i[h].nf;if(i[h].Interior)d.push(i[h].Interior);if(!i[h].Parent)break;h=i[h].Parent}switch(t.Type){case"Boolean":a.t="b";a.v=Ve(e);break;case"String":a.t="s";a.r=He(De(e));a.v=e.indexOf("<")>-1?De(r):a.r;break;case"DateTime":if(e.slice(-1)!="Z")e+="Z";a.v=(ie(e)-new Date(Date.UTC(1899,11,30)))/(24*60*60*1e3);if(a.v!==a.v)a.v=De(e);else if(a.v<60)a.v=a.v-1;if(!c||c=="General")c="yyyy-mm-dd";case"Number":if(a.v===undefined)a.v=+e;if(!a.t)a.t="n";break;case"Error":a.t="e";a.v=Kt[e];if(l.cellText!==false)a.w=e;break;default:a.t="s";a.v=He(r||e);break;}Fp(a,c,l);if(l.cellFormula!==false){if(a.Formula){var v=De(a.Formula);if(v.charCodeAt(0)==61)v=v.slice(1);a.f=Xl(v,n);delete a.Formula;if(a.ArrayRange=="RC")a.F=Xl("RC:RC",n);else if(a.ArrayRange){a.F=Xl(a.ArrayRange,n);o.push([pt(a.F),a.F])}}else{for(p=0;p<o.length;++p)if(n.r>=o[p][0].s.r&&n.r<=o[p][0].e.r)if(n.c>=o[p][0].s.c&&n.c<=o[p][0].e.c)a.F=o[p][1]}}if(l.cellStyles){d.forEach(function(e){if(!u.patternType&&e.patternType)u.patternType=e.patternType});a.s=u}if(a.StyleID!==undefined)a.ixfe=a.StyleID}function Lp(e){e.t=e.v||"";e.t=e.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");e.v=e.w=e.ixfe=undefined}function Mp(e){if(b&&Buffer.isBuffer(e))return e.toString("utf8");if(typeof e==="string")return e;if(typeof Uint8Array!=="undefined"&&e instanceof Uint8Array)return ze(B(y(e)));throw new Error("Bad input format: expected Buffer or string")}var Up=/<(\/?)([^\s?>!\/:]*:|)([^\s?>:\/]+)[^>]*>/gm;function Hp(e,r){var t=r||{};O(D);var a=d(Mp(e));if(t.type=="binary"||t.type=="array"||t.type=="base64"){if(typeof cptable!=="undefined")a=cptable.utils.decode(65001,c(a));else a=ze(a)}var n=a.slice(0,1024).toLowerCase(),i=false;if(n.indexOf("<?xml")==-1)["html","table","head","meta","script","style","div"].forEach(function(e){if(n.indexOf("<"+e)>=0)i=true});if(i)return Dv.to_workbook(a,t);var s;var f=[],o;if(v!=null&&t.dense==null)t.dense=v;var l={},h=[],u=t.dense?[]:{},p="";var g={},m={},b={};var w=Ip('<Data ss:Type="String">'),C=0;var E=0,k=0;var S={s:{r:2e6,c:2e6},e:{r:0,c:0}};var A={},_={};var B="",T=0;var y=[];var x={},I={},R=0,P=[];var N=[],L={};var M=[],U,H=false;var W=[];var V=[],z={},X=0,G=0;var j={Sheets:[],WBProps:{date1904:false}},K={};Up.lastIndex=0;a=a.replace(/<!--([\s\S]*?)-->/gm,"");while(s=Up.exec(a))switch(s[3]){case"Data":if(f[f.length-1][1])break;if(s[1]==="/")Np(a.slice(C,s.index),B,w,f[f.length-1][0]=="Comment"?L:m,{c:E,r:k},A,M[E],b,W,t);else{B="";w=Ip(s[0]);C=s.index+s[0].length}break;case"Cell":if(s[1]==="/"){if(N.length>0)m.c=N;if((!t.sheetRows||t.sheetRows>k)&&m.v!==undefined){if(t.dense){if(!u[k])u[k]=[];u[k][E]=m}else u[st(E)+tt(k)]=m}if(m.HRef){m.l={Target:m.HRef};if(m.HRefScreenTip)m.l.Tooltip=m.HRefScreenTip;delete m.HRef;delete m.HRefScreenTip}if(m.MergeAcross||m.MergeDown){X=E+(parseInt(m.MergeAcross,10)|0);G=k+(parseInt(m.MergeDown,10)|0);y.push({s:{c:E,r:k},e:{c:X,r:G}})}if(!t.sheetStubs){if(m.MergeAcross)E=X+1;else++E}else if(m.MergeAcross||m.MergeDown){for(var Y=E;Y<=X;++Y){for(var $=k;$<=G;++$){if(Y>E||$>k){if(t.dense){if(!u[$])u[$]=[];u[$][Y]={t:"z"}}else u[st(Y)+tt($)]={t:"z"}}}}E=X+1}else++E}else{m=Rp(s[0]);if(m.Index)E=+m.Index-1;if(E<S.s.c)S.s.c=E;if(E>S.e.c)S.e.c=E;if(s[0].slice(-2)==="/>")++E;N=[]}break;case"Row":if(s[1]==="/"||s[0].slice(-2)==="/>"){if(k<S.s.r)S.s.r=k;if(k>S.e.r)S.e.r=k;if(s[0].slice(-2)==="/>"){b=Ip(s[0]);if(b.Index)k=+b.Index-1}E=0;++k}else{b=Ip(s[0]);if(b.Index)k=+b.Index-1;z={};if(b.AutoFitHeight=="0"||b.Height){z.hpx=parseInt(b.Height,10);z.hpt=co(z.hpx);V[k]=z}if(b.Hidden=="1"){z.hidden=true;V[k]=z}}break;case"Worksheet":if(s[1]==="/"){if((o=f.pop())[0]!==s[3])throw new Error("Bad state: "+o.join("|"));h.push(p);if(S.s.r<=S.e.r&&S.s.c<=S.e.c){u["!ref"]=dt(S);if(t.sheetRows&&t.sheetRows<=S.e.r){u["!fullref"]=u["!ref"];S.e.r=t.sheetRows-1;u["!ref"]=dt(S)}}if(y.length)u["!merges"]=y;if(M.length>0)u["!cols"]=M;if(V.length>0)u["!rows"]=V;l[p]=u}else{S={s:{r:2e6,c:2e6},e:{r:0,c:0}};k=E=0;f.push([s[3],false]);o=Ip(s[0]);p=De(o.Name);u=t.dense?[]:{};y=[];W=[];V=[];K={name:p,Hidden:0};j.Sheets.push(K)}break;case"Table":if(s[1]==="/"){if((o=f.pop())[0]!==s[3])throw new Error("Bad state: "+o.join("|"))}else if(s[0].slice(-2)=="/>")break;else{g=Ip(s[0]);f.push([s[3],false]);M=[];H=false}break;case"Style":if(s[1]==="/")Pp(A,_,t);else _=Ip(s[0]);break;case"NumberFormat":_.nf=De(Ip(s[0]).Format||"General");if(F[_.nf])_.nf=F[_.nf];for(var Z=0;Z!=392;++Z)if(D._table[Z]==_.nf)break;if(Z==392)for(Z=57;Z!=392;++Z)if(D._table[Z]==null){D.load(_.nf,Z);break}break;case"Column":if(f[f.length-1][0]!=="Table")break;U=Ip(s[0]);if(U.Hidden){U.hidden=true;delete U.Hidden}if(U.Width)U.wpx=parseInt(U.Width,10);if(!H&&U.wpx>10){H=true;ro=Jf;for(var Q=0;Q<M.length;++Q)if(M[Q])fo(M[Q])}if(H)fo(U);M[U.Index-1||M.length]=U;for(var J=0;J<+U.Span;++J)M[M.length]=fe(U);break;case"NamedRange":if(!j.Names)j.Names=[];var q=ye(s[0]);var ee={Name:q.Name,Ref:Xl(q.RefersTo.slice(1),{r:0,c:0})};if(j.Sheets.length>0)ee.Sheet=j.Sheets.length-1;j.Names.push(ee);break;case"NamedCell":break;case"B":break;case"I":break;case"U":break;case"S":break;case"Sub":break;case"Sup":break;case"Span":break;case"Border":break;case"Alignment":break;case"Borders":break;case"Font":if(s[0].slice(-2)==="/>")break;else if(s[1]==="/")B+=a.slice(T,s.index);else T=s.index+s[0].length;break;case"Interior":if(!t.cellStyles)break;_.Interior=Ip(s[0]);break;case"Protection":break;case"Author":;case"Title":;case"Description":;case"Created":;case"Keywords":;case"Subject":;case"Category":;case"Company":;case"LastAuthor":;case"LastSaved":;case"LastPrinted":;case"Version":;case"Revision":;case"TotalTime":;case"HyperlinkBase":;case"Manager":;case"ContentStatus":;case"Identifier":;case"Language":;case"AppName":if(s[0].slice(-2)==="/>")break;else if(s[1]==="/")ln(x,s[3],a.slice(R,s.index));else R=s.index+s[0].length;break;case"Paragraphs":break;case"Styles":;case"Workbook":if(s[1]==="/"){if((o=f.pop())[0]!==s[3])throw new Error("Bad state: "+o.join("|"))}else f.push([s[3],false]);break;case"Comment":if(s[1]==="/"){if((o=f.pop())[0]!==s[3])throw new Error("Bad state: "+o.join("|"));Lp(L);N.push(L)}else{f.push([s[3],false]);o=Ip(s[0]);L={a:o.Author}}break;case"AutoFilter":if(s[1]==="/"){if((o=f.pop())[0]!==s[3])throw new Error("Bad state: "+o.join("|"))}else if(s[0].charAt(s[0].length-2)!=="/"){var re=Ip(s[0]);u["!autofilter"]={ref:Xl(re.Range).replace(/\$/g,"")};f.push([s[3],true])}break;case"Name":break;case"ComponentOptions":;case"DocumentProperties":;case"CustomDocumentProperties":;case"OfficeDocumentSettings":;case"PivotTable":;case"PivotCache":;case"Names":;case"MapInfo":;case"PageBreaks":;case"QueryTable":;case"DataValidation":;case"Sorting":;case"Schema":;case"data":;case"ConditionalFormatting":;case"SmartTagType":;case"SmartTags":;case"ExcelWorkbook":;case"WorkbookOptions":;case"WorksheetOptions":if(s[1]==="/"){if((o=f.pop())[0]!==s[3])throw new Error("Bad state: "+o.join("|"))}else if(s[0].charAt(s[0].length-2)!=="/")f.push([s[3],true]);break;default:if(f.length==0&&s[3]=="document")return Uv(a,t);if(f.length==0&&s[3]=="UOF")return Uv(a,t);var te=true;switch(f[f.length-1][0]){case"OfficeDocumentSettings":switch(s[3]){case"AllowPNG":break;case"RemovePersonalInformation":break;case"DownloadComponents":break;case"LocationOfComponents":break;case"Colors":break;case"Color":break;case"Index":break;case"RGB":break;case"PixelsPerInch":break;case"TargetScreenSize":break;case"ReadOnlyRecommended":break;default:te=false;}break;case"ComponentOptions":switch(s[3]){case"Toolbar":break;case"HideOfficeLogo":break;case"SpreadsheetAutoFit":break;case"Label":break;case"Caption":break;case"MaxHeight":break;case"MaxWidth":break;case"NextSheetNumber":break;default:te=false;}break;case"ExcelWorkbook":switch(s[3]){case"Date1904":j.WBProps.date1904=true;break;case"WindowHeight":break;case"WindowWidth":break;case"WindowTopX":break;case"WindowTopY":break;case"TabRatio":break;case"ProtectStructure":break;case"ProtectWindows":break;case"ActiveSheet":break;case"DisplayInkNotes":break;case"FirstVisibleSheet":break;case"SupBook":break;case"SheetName":break;case"SheetIndex":break;case"SheetIndexFirst":break;case"SheetIndexLast":break;case"Dll":break;case"AcceptLabelsInFormulas":break;case"DoNotSaveLinkValues":break;case"Iteration":break;case"MaxIterations":break;case"MaxChange":break;case"Path":break;case"Xct":break;case"Count":break;case"SelectedSheets":break;case"Calculation":break;case"Uncalced":break;case"StartupPrompt":break;case"Crn":break;case"ExternName":break;case"Formula":break;case"ColFirst":break;case"ColLast":break;case"WantAdvise":break;case"Boolean":break;case"Error":break;case"Text":break;case"OLE":break;case"NoAutoRecover":break;case"PublishObjects":break;case"DoNotCalculateBeforeSave":break;case"Number":break;case"RefModeR1C1":break;case"EmbedSaveSmartTags":break;default:te=false;}break;case"WorkbookOptions":switch(s[3]){case"OWCVersion":break;case"Height":break;case"Width":break;default:te=false;}break;case"WorksheetOptions":switch(s[3]){case"Visible":if(s[0].slice(-2)==="/>"){}else if(s[1]==="/")switch(a.slice(R,s.index)){case"SheetHidden":K.Hidden=1;break;case"SheetVeryHidden":K.Hidden=2;break;}else R=s.index+s[0].length;break;case"Header":if(!u["!margins"])Zh(u["!margins"]={},"xlml");u["!margins"].header=ye(s[0]).Margin;break;case"Footer":if(!u["!margins"])Zh(u["!margins"]={},"xlml");u["!margins"].footer=ye(s[0]).Margin;break;case"PageMargins":var ae=ye(s[0]);if(!u["!margins"])Zh(u["!margins"]={},"xlml");if(ae.Top)u["!margins"].top=ae.Top;if(ae.Left)u["!margins"].left=ae.Left;if(ae.Right)u["!margins"].right=ae.Right;if(ae.Bottom)u["!margins"].bottom=ae.Bottom;break;case"DisplayRightToLeft":if(!j.Views)j.Views=[];if(!j.Views[0])j.Views[0]={};j.Views[0].RTL=true;break;case"Unsynced":break;case"Print":break;case"Panes":break;case"Scale":break;case"Pane":break;case"Number":break;case"Layout":break;case"PageSetup":break;case"Selected":break;case"ProtectObjects":break;case"EnableSelection":break;case"ProtectScenarios":break;case"ValidPrinterInfo":break;case"HorizontalResolution":break;case"VerticalResolution":break;case"NumberofCopies":break;case"ActiveRow":break;case"ActiveCol":break;case"ActivePane":break;case"TopRowVisible":break;case"TopRowBottomPane":break;case"LeftColumnVisible":break;case"LeftColumnRightPane":break;case"FitToPage":break;case"RangeSelection":break;case"PaperSizeIndex":break;case"PageLayoutZoom":break;case"PageBreakZoom":break;case"FilterOn":break;case"DoNotDisplayGridlines":break;case"SplitHorizontal":break;case"SplitVertical":break;case"FreezePanes":break;case"FrozenNoSplit":break;case"FitWidth":break;case"FitHeight":break;case"CommentsLayout":break;case"Zoom":break;case"LeftToRight":break;case"Gridlines":break;case"AllowSort":break;case"AllowFilter":break;case"AllowInsertRows":break;case"AllowDeleteRows":break;case"AllowInsertCols":break;case"AllowDeleteCols":break;case"AllowInsertHyperlinks":break;case"AllowFormatCells":break;case"AllowSizeCols":break;case"AllowSizeRows":break;case"NoSummaryRowsBelowDetail":break;case"TabColorIndex":break;case"DoNotDisplayHeadings":break;case"ShowPageLayoutZoom":break;case"NoSummaryColumnsRightDetail":break;case"BlackAndWhite":break;case"DoNotDisplayZeros":break;case"DisplayPageBreak":break;case"RowColHeadings":break;case"DoNotDisplayOutline":break;case"NoOrientation":break;case"AllowUsePivotTables":break;case"ZeroHeight":break;case"ViewableRange":break;case"Selection":break;case"ProtectContents":break;default:te=false;}break;case"PivotTable":;case"PivotCache":switch(s[3]){case"ImmediateItemsOnDrop":break;case"ShowPageMultipleItemLabel":break;case"CompactRowIndent":break;case"Location":break;case"PivotField":break;case"Orientation":break;case"LayoutForm":break;case"LayoutSubtotalLocation":break;case"LayoutCompactRow":break;case"Position":break;case"PivotItem":break;case"DataType":break;case"DataField":break;case"SourceName":break;case"ParentField":break;case"PTLineItems":break;case"PTLineItem":break;case"CountOfSameItems":break;case"Item":break;case"ItemType":break;case"PTSource":break;case"CacheIndex":break;case"ConsolidationReference":break;case"FileName":break;case"Reference":break;case"NoColumnGrand":break;case"NoRowGrand":break;case"BlankLineAfterItems":break;case"Hidden":break;case"Subtotal":break;case"BaseField":break;case"MapChildItems":break;case"Function":break;case"RefreshOnFileOpen":break;case"PrintSetTitles":break;case"MergeLabels":break;case"DefaultVersion":break;case"RefreshName":break;case"RefreshDate":break;case"RefreshDateCopy":break;case"VersionLastRefresh":break;case"VersionLastUpdate":break;case"VersionUpdateableMin":break;case"VersionRefreshableMin":break;case"Calculation":break;default:te=false;}break;case"PageBreaks":switch(s[3]){case"ColBreaks":break;case"ColBreak":break;case"RowBreaks":break;case"RowBreak":break;case"ColStart":break;case"ColEnd":break;case"RowEnd":break;default:te=false;}break;case"AutoFilter":switch(s[3]){case"AutoFilterColumn":break;case"AutoFilterCondition":break;case"AutoFilterAnd":break;case"AutoFilterOr":break;default:te=false;}break;case"QueryTable":switch(s[3]){case"Id":break;case"AutoFormatFont":break;case"AutoFormatPattern":break;case"QuerySource":break;case"QueryType":break;case"EnableRedirections":break;case"RefreshedInXl9":break;case"URLString":break;case"HTMLTables":break;case"Connection":break;case"CommandText":break;case"RefreshInfo":break;case"NoTitles":break;case"NextId":break;case"ColumnInfo":break;case"OverwriteCells":break;case"DoNotPromptForFile":break;case"TextWizardSettings":break;case"Source":break;case"Number":
break;case"Decimal":break;case"ThousandSeparator":break;case"TrailingMinusNumbers":break;case"FormatSettings":break;case"FieldType":break;case"Delimiters":break;case"Tab":break;case"Comma":break;case"AutoFormatName":break;case"VersionLastEdit":break;case"VersionLastRefresh":break;default:te=false;}break;case"Sorting":;case"ConditionalFormatting":;case"DataValidation":switch(s[3]){case"Range":break;case"Type":break;case"Min":break;case"Max":break;case"Sort":break;case"Descending":break;case"Order":break;case"CaseSensitive":break;case"Value":break;case"ErrorStyle":break;case"ErrorMessage":break;case"ErrorTitle":break;case"CellRangeList":break;case"InputMessage":break;case"InputTitle":break;case"ComboHide":break;case"InputHide":break;case"Condition":break;case"Qualifier":break;case"UseBlank":break;case"Value1":break;case"Value2":break;case"Format":break;default:te=false;}break;case"MapInfo":;case"Schema":;case"data":switch(s[3]){case"Map":break;case"Entry":break;case"Range":break;case"XPath":break;case"Field":break;case"XSDType":break;case"FilterOn":break;case"Aggregate":break;case"ElementType":break;case"AttributeType":break;case"schema":;case"element":;case"complexType":;case"datatype":;case"all":;case"attribute":;case"extends":break;case"row":break;default:te=false;}break;case"SmartTags":break;default:te=false;break;}if(te)break;if(!f[f.length-1][1])throw"Unrecognized tag: "+s[3]+"|"+f.join("|");if(f[f.length-1][0]==="CustomDocumentProperties"){if(s[0].slice(-2)==="/>")break;else if(s[1]==="/")Op(I,s[3],P,a.slice(R,s.index));else{P=s;R=s.index+s[0].length}break}if(t.WTF)throw"Unrecognized tag: "+s[3]+"|"+f.join("|");}var ne={};if(!t.bookSheets&&!t.bookProps)ne.Sheets=l;ne.SheetNames=h;ne.Workbook=j;ne.SSF=D.get_table();ne.Props=x;ne.Custprops=I;return ne}function Wp(e,r){rg(r=r||{});switch(r.type||"base64"){case"base64":return Hp(m.decode(e),r);case"binary":;case"buffer":;case"file":return Hp(e,r);case"array":return Hp(B(e),r);}}function Vp(e,r){var t=[];if(e.Props)t.push(cn(e.Props,r));if(e.Custprops)t.push(hn(e.Props,e.Custprops,r));return t.join("")}function zp(){return""}function Xp(e,r){var t=['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];r.cellXfs.forEach(function(e,r){var a=[];a.push(ar("NumberFormat",null,{"ss:Format":Pe(D._table[e.numFmtId])}));t.push(ar("Style",a.join(""),{"ss:ID":"s"+(21+r)}))});return ar("Styles",t.join(""))}function Gp(e){return ar("NamedRange",null,{"ss:Name":e.Name,"ss:RefersTo":"="+jl(e.Ref,{r:0,c:0})})}function jp(e){if(!((e||{}).Workbook||{}).Names)return"";var r=e.Workbook.Names;var t=[];for(var a=0;a<r.length;++a){var n=r[a];if(n.Sheet!=null)continue;if(n.Name.match(/^_xlfn\./))continue;t.push(Gp(n))}return ar("Names",t.join(""))}function Kp(e,r,t,a){if(!e)return"";if(!((a||{}).Workbook||{}).Names)return"";var n=a.Workbook.Names;var i=[];for(var s=0;s<n.length;++s){var f=n[s];if(f.Sheet!=t)continue;if(f.Name.match(/^_xlfn\./))continue;i.push(Gp(f))}return i.join("")}function Yp(e,r,t,a){if(!e)return"";var n=[];if(e["!margins"]){n.push("<PageSetup>");if(e["!margins"].header)n.push(ar("Header",null,{"x:Margin":e["!margins"].header}));if(e["!margins"].footer)n.push(ar("Footer",null,{"x:Margin":e["!margins"].footer}));n.push(ar("PageMargins",null,{"x:Bottom":e["!margins"].bottom||"0.75","x:Left":e["!margins"].left||"0.7","x:Right":e["!margins"].right||"0.7","x:Top":e["!margins"].top||"0.75"}));n.push("</PageSetup>")}if(a&&a.Workbook&&a.Workbook.Sheets&&a.Workbook.Sheets[t]){if(a.Workbook.Sheets[t].Hidden)n.push(ar("Visible",a.Workbook.Sheets[t].Hidden==1?"SheetHidden":"SheetVeryHidden",{}));else{for(var i=0;i<t;++i)if(a.Workbook.Sheets[i]&&!a.Workbook.Sheets[i].Hidden)break;if(i==t)n.push("<Selected/>")}}if(((((a||{}).Workbook||{}).Views||[])[0]||{}).RTL)n.push("<DisplayRightToLeft/>");if(e["!protect"]){n.push(rr("ProtectContents","True"));if(e["!protect"].objects)n.push(rr("ProtectObjects","True"));if(e["!protect"].scenarios)n.push(rr("ProtectScenarios","True"));if(e["!protect"].selectLockedCells!=null&&!e["!protect"].selectLockedCells)n.push(rr("EnableSelection","NoSelection"));else if(e["!protect"].selectUnlockedCells!=null&&!e["!protect"].selectUnlockedCells)n.push(rr("EnableSelection","UnlockedCells"));[["formatCells","AllowFormatCells"],["formatColumns","AllowSizeCols"],["formatRows","AllowSizeRows"],["insertColumns","AllowInsertCols"],["insertRows","AllowInsertRows"],["insertHyperlinks","AllowInsertHyperlinks"],["deleteColumns","AllowDeleteCols"],["deleteRows","AllowDeleteRows"],["sort","AllowSort"],["autoFilter","AllowFilter"],["pivotTables","AllowUsePivotTables"]].forEach(function(r){if(e["!protect"][r[0]])n.push("<"+r[1]+"/>")})}if(n.length==0)return"";return ar("WorksheetOptions",n.join(""),{xmlns:fr.x})}function $p(e){return e.map(function(e){var r=We(e.t||"");var t=ar("ss:Data",r,{xmlns:"http://www.w3.org/TR/REC-html40"});return ar("Comment",t,{"ss:Author":e.a})}).join("")}function Zp(e,r,t,a,n,i,s){if(!e||e.v==undefined&&e.f==undefined)return"";var f={};if(e.f)f["ss:Formula"]="="+Pe(jl(e.f,s));if(e.F&&e.F.slice(0,r.length)==r){var o=ct(e.F.slice(r.length+1));f["ss:ArrayRange"]="RC:R"+(o.r==s.r?"":"["+(o.r-s.r)+"]")+"C"+(o.c==s.c?"":"["+(o.c-s.c)+"]")}if(e.l&&e.l.Target){f["ss:HRef"]=Pe(e.l.Target);if(e.l.Tooltip)f["x:HRefScreenTip"]=Pe(e.l.Tooltip)}if(t["!merges"]){var l=t["!merges"];for(var c=0;c!=l.length;++c){if(l[c].s.c!=s.c||l[c].s.r!=s.r)continue;if(l[c].e.c>l[c].s.c)f["ss:MergeAcross"]=l[c].e.c-l[c].s.c;if(l[c].e.r>l[c].s.r)f["ss:MergeDown"]=l[c].e.r-l[c].s.r}}var h="",u="";switch(e.t){case"z":return"";case"n":h="Number";u=String(e.v);break;case"b":h="Boolean";u=e.v?"1":"0";break;case"e":h="Error";u=jt[e.v];break;case"d":h="DateTime";u=new Date(e.v).toISOString();if(e.z==null)e.z=e.z||D._table[14];break;case"s":h="String";u=Ue(e.v||"");break;}var d=Qh(a.cellXfs,e,a);f["ss:StyleID"]="s"+(21+d);f["ss:Index"]=s.c+1;var p=e.v!=null?u:"";var v='<Data ss:Type="'+h+'">'+p+"</Data>";if((e.c||[]).length>0)v+=$p(e.c);return ar("Cell",v,f)}function Qp(e,r){var t='<Row ss:Index="'+(e+1)+'"';if(r){if(r.hpt&&!r.hpx)r.hpx=ho(r.hpt);if(r.hpx)t+=' ss:AutoFitHeight="0" ss:Height="'+r.hpx+'"';if(r.hidden)t+=' ss:Hidden="1"'}return t+">"}function Jp(e,r,t,a){if(!e["!ref"])return"";var n=pt(e["!ref"]);var i=e["!merges"]||[],s=0;var f=[];if(e["!cols"])e["!cols"].forEach(function(e,r){fo(e);var t=!!e.width;var a=$h(r,e);var n={"ss:Index":r+1};if(t)n["ss:Width"]=to(a.width);if(e.hidden)n["ss:Hidden"]="1";f.push(ar("Column",null,n))});var o=Array.isArray(e);for(var l=n.s.r;l<=n.e.r;++l){var c=[Qp(l,(e["!rows"]||[])[l])];for(var h=n.s.c;h<=n.e.c;++h){var u=false;for(s=0;s!=i.length;++s){if(i[s].s.c>h)continue;if(i[s].s.r>l)continue;if(i[s].e.c<h)continue;if(i[s].e.r<l)continue;if(i[s].s.c!=h||i[s].s.r!=l)u=true;break}if(u)continue;var d={r:l,c:h};var p=ht(d),v=o?(e[l]||[])[h]:e[p];c.push(Zp(v,p,e,r,t,a,d))}c.push("</Row>");if(c.length>2)f.push(c.join(""))}return f.join("")}function qp(e,r,t){var a=[];var n=t.SheetNames[e];var i=t.Sheets[n];var s=i?Kp(i,r,e,t):"";if(s.length>0)a.push("<Names>"+s+"</Names>");s=i?Jp(i,r,e,t):"";if(s.length>0)a.push("<Table>"+s+"</Table>");a.push(Yp(i,r,e,t));return a.join("")}function ev(e,r){if(!r)r={};if(!e.SSF)e.SSF=D.get_table();if(e.SSF){O(D);D.load_table(e.SSF);r.revssf=Z(e.SSF);r.revssf[e.SSF[65535]]=0;r.ssf=e.SSF;r.cellXfs=[];Qh(r.cellXfs,{},{revssf:{General:0}})}var t=[];t.push(Vp(e,r));t.push(zp(e,r));t.push("");t.push("");for(var a=0;a<e.SheetNames.length;++a)t.push(ar("Worksheet",qp(a,r,e),{"ss:Name":Pe(e.SheetNames[a])}));t[2]=Xp(e,r);t[3]=jp(e,r);return Se+ar("Workbook",t.join(""),{xmlns:fr.ss,"xmlns:o":fr.o,"xmlns:x":fr.x,"xmlns:ss":fr.ss,"xmlns:dt":fr.dt,"xmlns:html":fr.html})}function rv(e){var r={};var t=e.content;t.l=28;r.AnsiUserType=t._R(0,"lpstr-ansi");r.AnsiClipboardFormat=qt(t);if(t.length-t.l<=4)return r;var a=t._R(4);if(a==0||a>40)return r;t.l-=4;r.Reserved1=t._R(0,"lpstr-ansi");if(t.length-t.l<=4)return r;a=t._R(4);if(a!==1907505652)return r;r.UnicodeClipboardFormat=ea(t);a=t._R(4);if(a==0||a>40)return r;t.l-=4;r.Reserved2=t._R(0,"lpwstr")}function tv(e,r,t,a){var n=t;var i=[];var s=r.slice(r.l,r.l+n);if(a&&a.enc&&a.enc.insitu)switch(e.n){case"BOF":;case"FilePass":;case"FileLock":;case"InterfaceHdr":;case"RRDInfo":;case"RRDHead":;case"UsrExcl":break;default:if(s.length===0)break;a.enc.insitu(s);}i.push(s);r.l+=n;var f=dv[Dr(r,r.l)];var o=0;while(f!=null&&f.n.slice(0,8)==="Continue"){n=Dr(r,r.l+2);o=r.l+4;if(f.n=="ContinueFrt")o+=4;else if(f.n.slice(0,11)=="ContinueFrt")o+=12;i.push(r.slice(o,r.l+4+n));r.l+=4+n;f=dv[Dr(r,r.l)]}var l=x(i);zr(l,0);var c=0;l.lens=[];for(var h=0;h<i.length;++h){l.lens.push(c);c+=i[h].length}return e.f(l,l.length,a)}function av(e,r,t){if(e.t==="z")return;if(!e.XF)return;var a=0;try{a=e.z||e.XF.numFmtId||0;if(r.cellNF)e.z=D._table[a]}catch(n){if(r.WTF)throw n}if(!r||r.cellText!==false)try{if(e.t==="e"){e.w=e.w||jt[e.v]}else if(a===0||a=="General"){if(e.t==="n"){if((e.v|0)===e.v)e.w=D._general_int(e.v);else e.w=D._general_num(e.v)}else e.w=D._general(e.v)}else e.w=D.format(a,e.v,{date1904:!!t})}catch(n){if(r.WTF)throw n}if(r.cellDates&&a&&e.t=="n"&&D.is_date(D._table[a]||String(a))){var i=D.parse_date_code(e.v);if(i){e.t="d";e.v=new Date(i.y,i.m-1,i.d,i.H,i.M,i.S,i.u)}}}function nv(e,r,t){return{v:e,ixfe:r,t:t}}function iv(e,r){var t={opts:{}};var a={};if(v!=null&&r.dense==null)r.dense=v;var n=r.dense?[]:{};var i={};var s={};var f=null;var l=[];var c="";var h={};var u,d="",p,g,m,b;var w={};var C=[];var E;var k;var S=true;var A=[];var _=[];var B={Sheets:[],WBProps:{date1904:false},Views:[{}]},T={};var y=function be(e){if(e<8)return ka[e];if(e<64)return _[e-8]||ka[e];return ka[e]};var x=function we(e,r,t){var a=r.XF.data;if(!a||!a.patternType||!t||!t.cellStyles)return;r.s={};r.s.patternType=a.patternType;var n;if(n=Yf(y(a.icvFore))){r.s.fgColor={rgb:n}}if(n=Yf(y(a.icvBack))){r.s.bgColor={rgb:n}}};var I=function Ce(e,r,t){if(z>1)return;if(t.sheetRows&&e.r>=t.sheetRows)S=false;if(!S)return;if(t.cellStyles&&r.XF&&r.XF.data)x(e,r,t);delete r.ixfe;delete r.XF;u=e;d=ht(e);if(s.s){if(e.r<s.s.r)s.s.r=e.r;if(e.c<s.s.c)s.s.c=e.c}if(s.e){if(e.r+1>s.e.r)s.e.r=e.r+1;if(e.c+1>s.e.c)s.e.c=e.c+1}if(t.cellFormula&&r.f){for(var a=0;a<C.length;++a){if(C[a][0].s.c>e.c||C[a][0].s.r>e.r)continue;if(C[a][0].e.c<e.c||C[a][0].e.r<e.r)continue;r.F=dt(C[a][0]);if(C[a][0].s.c!=e.c||C[a][0].s.r!=e.r)delete r.f;if(r.f)r.f=""+_h(C[a][1],s,e,W,R);break}}{if(t.dense){if(!n[e.r])n[e.r]=[];n[e.r][e.c]=r}else n[d]=r}};var R={enc:false,sbcch:0,snames:[],sharedf:w,arrayf:C,rrtabid:[],lastuser:"",biff:8,codepage:0,winlocked:0,cellStyles:!!r&&!!r.cellStyles,WTF:!!r&&!!r.wtf};if(r.password)R.password=r.password;var O;var F=[];var P=[];var N=[],L=[];var M=0,U=0;var H=false;var W=[];W.SheetNames=R.snames;W.sharedf=R.sharedf;W.arrayf=R.arrayf;W.names=[];W.XTI=[];var V="";var z=0;var X=0,G=[];var K=[];var Y;R.codepage=1200;o(1200);var $=false;while(e.l<e.length-1){var Z=e.l;var Q=e._R(2);if(Q===0&&V==="EOF")break;var J=e.l===e.length?0:e._R(2);var q=dv[Q];if(q&&q.f){if(r.bookSheets){if(V==="BoundSheet8"&&q.n!=="BoundSheet8")break}V=q.n;if(q.r===2||q.r==12){var ee=e._R(2);J-=2;if(!R.enc&&ee!==Q&&((ee&255)<<8|ee>>8)!==Q)throw new Error("rt mismatch: "+ee+"!="+Q);if(q.r==12){e.l+=10;J-=10}}var re;if(q.n==="EOF")re=q.f(e,J,R);else re=tv(q,e,J,R);var te=q.n;if(z==0&&te!="BOF")continue;switch(te){case"Date1904":t.opts.Date1904=B.WBProps.date1904=re;break;case"WriteProtect":t.opts.WriteProtect=true;break;case"FilePass":if(!R.enc)e.l=0;R.enc=re;if(!r.password)throw new Error("File is password-protected");if(re.valid==null)throw new Error("Encryption scheme unsupported");if(!re.valid)throw new Error("Password is incorrect");break;case"WriteAccess":R.lastuser=re;break;case"FileSharing":break;case"CodePage":switch(re){case 21010:re=1200;break;case 32768:re=1e4;break;case 32769:re=1252;break;}o(R.codepage=re);$=true;break;case"RRTabId":R.rrtabid=re;break;case"WinProtect":R.winlocked=re;break;case"Template":break;case"BookBool":break;case"UsesELFs":break;case"MTRSettings":break;case"RefreshAll":;case"CalcCount":;case"CalcDelta":;case"CalcIter":;case"CalcMode":;case"CalcPrecision":;case"CalcSaveRecalc":t.opts[te]=re;break;case"CalcRefMode":R.CalcRefMode=re;break;case"Uncalced":break;case"ForceFullCalculation":t.opts.FullCalc=re;break;case"WsBool":if(re.fDialog)n["!type"]="dialog";break;case"XF":A.push(re);break;case"ExtSST":break;case"BookExt":break;case"RichTextStream":break;case"BkHim":break;case"SupBook":W.push([re]);W[W.length-1].XTI=[];break;case"ExternName":W[W.length-1].push(re);break;case"Index":break;case"Lbl":Y={Name:re.Name,Ref:_h(re.rgce,s,null,W,R)};if(re.itab>0)Y.Sheet=re.itab-1;W.names.push(Y);if(!W[0]){W[0]=[];W[0].XTI=[]}W[W.length-1].push(re);if(re.Name=="_xlnm._FilterDatabase"&&re.itab>0)if(re.rgce&&re.rgce[0]&&re.rgce[0][0]&&re.rgce[0][0][0]=="PtgArea3d")K[re.itab-1]={ref:dt(re.rgce[0][0][1][2])};break;case"ExternCount":R.ExternCount=re;break;case"ExternSheet":if(W.length==0){W[0]=[];W[0].XTI=[]}W[W.length-1].XTI=W[W.length-1].XTI.concat(re);W.XTI=W.XTI.concat(re);break;case"NameCmt":if(R.biff<8)break;if(Y!=null)Y.Comment=re[1];break;case"Protect":n["!protect"]=re;break;case"Password":if(re!==0&&R.WTF)console.error("Password verifier: "+re);break;case"Prot4Rev":;case"Prot4RevPass":break;case"BoundSheet8":{i[re.pos]=re;R.snames.push(re.name)}break;case"EOF":{if(--z)break;if(s.e){if(s.e.r>0&&s.e.c>0){s.e.r--;s.e.c--;n["!ref"]=dt(s);if(r.sheetRows&&r.sheetRows<=s.e.r){var ae=s.e.r;s.e.r=r.sheetRows-1;n["!fullref"]=n["!ref"];n["!ref"]=dt(s);s.e.r=ae}s.e.r++;s.e.c++}if(F.length>0)n["!merges"]=F;if(P.length>0)n["!objects"]=P;if(N.length>0)n["!cols"]=N;if(L.length>0)n["!rows"]=L;B.Sheets.push(T)}if(c==="")h=n;else a[c]=n;n=r.dense?[]:{}}break;case"BOF":{if(R.biff===8)R.biff={9:2,521:3,1033:4}[Q]||{512:2,768:3,1024:4,1280:5,1536:8,2:2,7:2}[re.BIFFVer]||8;if(R.biff==8&&re.BIFFVer==0&&re.dt==16)R.biff=2;if(z++)break;S=true;n=r.dense?[]:{};if(R.biff<8&&!$){$=true;o(R.codepage=r.codepage||1252)}if(R.biff<5){if(c==="")c="Sheet1";s={s:{r:0,c:0},e:{r:0,c:0}};var ne={pos:e.l-J,name:c};i[ne.pos]=ne;R.snames.push(c)}else c=(i[Z]||{name:""}).name;if(re.dt==32)n["!type"]="chart";if(re.dt==64)n["!type"]="macro";F=[];P=[];R.arrayf=C=[];N=[];L=[];M=U=0;H=false;T={Hidden:(i[Z]||{hs:0}).hs,name:c}}break;case"Number":;case"BIFF2NUM":;case"BIFF2INT":{if(n["!type"]=="chart")if(r.dense?(n[re.r]||[])[re.c]:n[ht({c:re.c,r:re.r})])++re.c;E={ixfe:re.ixfe,XF:A[re.ixfe]||{},v:re.val,t:"n"};if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:re.c,r:re.r},E,r)}break;case"BoolErr":{E={ixfe:re.ixfe,XF:A[re.ixfe],v:re.val,t:re.t};if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:re.c,r:re.r},E,r)}break;case"RK":{E={ixfe:re.ixfe,XF:A[re.ixfe],v:re.rknum,t:"n"};if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:re.c,r:re.r},E,r)}break;case"MulRk":{for(var ie=re.c;ie<=re.C;++ie){var se=re.rkrec[ie-re.c][0];E={ixfe:se,XF:A[se],v:re.rkrec[ie-re.c][1],t:"n"};if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:ie,r:re.r},E,r)}}break;case"Formula":{if(re.val=="String"){f=re;break}E=nv(re.val,re.cell.ixfe,re.tt);E.XF=A[E.ixfe];if(r.cellFormula){var fe=re.formula;if(fe&&fe[0]&&fe[0][0]&&fe[0][0][0]=="PtgExp"){var oe=fe[0][0][1][0],le=fe[0][0][1][1];var ce=ht({r:oe,c:le});if(w[ce])E.f=""+_h(re.formula,s,re.cell,W,R);else E.F=((r.dense?(n[oe]||[])[le]:n[ce])||{}).F}else E.f=""+_h(re.formula,s,re.cell,W,R)}if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I(re.cell,E,r);f=re}break;case"String":{if(f){f.val=re;E=nv(re,f.cell.ixfe,"s");E.XF=A[E.ixfe];if(r.cellFormula){E.f=""+_h(f.formula,s,f.cell,W,R)}if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I(f.cell,E,r);f=null}else throw new Error("String record expects Formula")}break;case"Array":{C.push(re);var he=ht(re[0].s);p=r.dense?(n[re[0].s.r]||[])[re[0].s.c]:n[he];if(r.cellFormula&&p){if(!f)break;if(!he||!p)break;p.f=""+_h(re[1],s,re[0],W,R);p.F=dt(re[0])}}break;case"ShrFmla":{if(!S)break;if(!r.cellFormula)break;if(d){if(!f)break;w[ht(f.cell)]=re[0];p=r.dense?(n[f.cell.r]||[])[f.cell.c]:n[ht(f.cell)];(p||{}).f=""+_h(re[0],s,u,W,R)}}break;case"LabelSst":E=nv(l[re.isst].t,re.ixfe,"s");E.XF=A[E.ixfe];if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:re.c,r:re.r},E,r);break;case"Blank":if(r.sheetStubs){E={ixfe:re.ixfe,XF:A[re.ixfe],t:"z"};if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:re.c,r:re.r},E,r)}break;case"MulBlank":if(r.sheetStubs){for(var ue=re.c;ue<=re.C;++ue){var de=re.ixfe[ue-re.c];E={ixfe:de,XF:A[de],t:"z"};if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:ue,r:re.r},E,r)}}break;case"RString":;case"Label":;case"BIFF2STR":E=nv(re.val,re.ixfe,"s");E.XF=A[E.ixfe];if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:re.c,r:re.r},E,r);break;case"Dimensions":{if(z===1)s=re}break;case"SST":{l=re}break;case"Format":{if(R.biff==4){G[X++]=re[1];for(var pe=0;pe<X+163;++pe)if(D._table[pe]==re[1])break;if(pe>=163)D.load(re[1],X+163)}else D.load(re[1],re[0])}break;case"BIFF2FORMAT":{G[X++]=re;for(var ve=0;ve<X+163;++ve)if(D._table[ve]==re)break;if(ve>=163)D.load(re,X+163)}break;case"MergeCells":F=F.concat(re);break;case"Obj":P[re.cmo[0]]=R.lastobj=re;break;case"TxO":R.lastobj.TxO=re;break;case"ImData":R.lastobj.ImData=re;break;case"HLink":{for(b=re[0].s.r;b<=re[0].e.r;++b)for(m=re[0].s.c;m<=re[0].e.c;++m){p=r.dense?(n[b]||[])[m]:n[ht({c:m,r:b})];if(p)p.l=re[1]}}break;case"HLinkTooltip":{for(b=re[0].s.r;b<=re[0].e.r;++b)for(m=re[0].s.c;m<=re[0].e.c;++m){p=r.dense?(n[b]||[])[m]:n[ht({c:m,r:b})];if(p&&p.l)p.l.Tooltip=re[1]}}break;case"Note":{if(R.biff<=5&&R.biff>=2)break;p=r.dense?(n[re[0].r]||[])[re[0].c]:n[ht(re[0])];var ge=P[re[2]];if(!p)break;if(!p.c)p.c=[];g={a:re[1],t:ge.TxO.t};p.c.push(g)}break;default:switch(q.n){case"ClrtClient":break;case"XFExt":gl(A[re.ixfe],re.ext);break;case"DefColWidth":M=re;break;case"DefaultRowHeight":U=re[1];break;case"ColInfo":{if(!R.cellStyles)break;while(re.e>=re.s){N[re.e--]={width:re.w/256};if(!H){H=true;so(re.w/256)}fo(N[re.e+1])}}break;case"Row":{var me={};if(re.level!=null){L[re.r]=me;me.level=re.level}if(re.hidden){L[re.r]=me;me.hidden=true}if(re.hpt){L[re.r]=me;me.hpt=re.hpt;me.hpx=ho(re.hpt)}}break;case"LeftMargin":;case"RightMargin":;case"TopMargin":;case"BottomMargin":if(!n["!margins"])Zh(n["!margins"]={});n["!margins"][te.slice(0,-6).toLowerCase()]=re;break;case"Setup":if(!n["!margins"])Zh(n["!margins"]={});n["!margins"].header=re.header;n["!margins"].footer=re.footer;break;case"Window2":if(re.RTL)B.Views[0].RTL=true;break;case"Header":break;case"Footer":break;case"HCenter":break;case"VCenter":break;case"Pls":break;case"GCW":break;case"LHRecord":break;case"DBCell":break;case"EntExU2":break;case"SxView":break;case"Sxvd":break;case"SXVI":break;case"SXVDEx":break;case"SxIvd":break;case"SXString":break;case"Sync":break;case"Addin":break;case"SXDI":break;case"SXLI":break;case"SXEx":break;case"QsiSXTag":break;case"Selection":break;case"Feat":break;case"FeatHdr":;case"FeatHdr11":break;case"Feature11":;case"Feature12":;case"List12":break;case"Country":k=re;break;case"RecalcId":break;case"DxGCol":break;case"Fbi":;case"Fbi2":;case"GelFrame":break;case"Font":break;case"XFCRC":break;case"Style":break;case"StyleExt":break;case"Palette":_=re;break;case"Theme":O=re;break;case"ScenarioProtect":break;case"ObjProtect":break;case"CondFmt12":break;case"Table":break;case"TableStyles":break;case"TableStyle":break;case"TableStyleElement":break;case"SXStreamID":break;case"SXVS":break;case"DConRef":break;case"SXAddl":break;case"DConBin":break;case"DConName":break;case"SXPI":break;case"SxFormat":break;case"SxSelect":break;case"SxRule":break;case"SxFilt":break;case"SxItm":break;case"SxDXF":break;case"ScenMan":break;case"DCon":break;case"CellWatch":break;case"PrintRowCol":break;case"PrintGrid":break;case"PrintSize":break;case"XCT":break;case"CRN":break;case"Scl":{}break;case"SheetExt":{}break;case"SheetExtOptional":{}break;case"ObNoMacros":{}break;case"ObProj":{}break;case"CodeName":{if(!c)B.WBProps.CodeName=re||"ThisWorkbook";else T.CodeName=re||T.name}break;case"GUIDTypeLib":{}break;case"WOpt":break;case"PhoneticInfo":break;case"OleObjectSize":break;case"DXF":;case"DXFN":;case"DXFN12":;case"DXFN12List":;case"DXFN12NoCB":break;case"Dv":;case"DVal":break;case"BRAI":;case"Series":;case"SeriesText":break;case"DConn":break;case"DbOrParamQry":break;case"DBQueryExt":break;case"OleDbConn":break;case"ExtString":break;case"IFmtRecord":break;case"CondFmt":;case"CF":;case"CF12":;case"CFEx":break;case"Excel9File":break;case"Units":break;case"InterfaceHdr":;case"Mms":;case"InterfaceEnd":;case"DSF":break;case"BuiltInFnGroupCount":break;case"Window1":;case"HideObj":;case"GridSet":;case"Guts":;case"UserBView":;case"UserSViewBegin":;case"UserSViewEnd":;case"Pane":break;default:switch(q.n){case"Dat":;case"Begin":;case"End":;case"StartBlock":;case"EndBlock":;case"Frame":;case"Area":;case"Axis":;case"AxisLine":;case"Tick":break;case"AxesUsed":;case"CrtLayout12":;case"CrtLayout12A":;case"CrtLink":;case"CrtLine":;case"CrtMlFrt":;case"CrtMlFrtContinue":break;case"LineFormat":;case"AreaFormat":;case"Chart":;case"Chart3d":;case"Chart3DBarShape":;case"ChartFormat":;case"ChartFrtInfo":break;case"PlotArea":;case"PlotGrowth":break;case"SeriesList":;case"SerParent":;case"SerAuxTrend":break;case"DataFormat":;case"SerToCrt":;case"FontX":break;case"CatSerRange":;case"AxcExt":;case"SerFmt":break;case"ShtProps":break;case"DefaultText":;case"Text":;case"CatLab":break;case"DataLabExtContents":break;case"Legend":;case"LegendException":break;case"Pie":;case"Scatter":break;case"PieFormat":;case"MarkerFormat":break;case"StartObject":;case"EndObject":break;case"AlRuns":;case"ObjectLink":break;case"SIIndex":break;case"AttachedLabel":;case"YMult":break;case"Line":;case"Bar":break;case"Surf":break;case"AxisParent":break;case"Pos":break;case"ValueRange":break;case"SXViewEx9":break;case"SXViewLink":break;case"PivotChartBits":break;case"SBaseRef":break;case"TextPropsStream":break;case"LnExt":break;case"MkrExt":break;case"CrtCoopt":break;case"Qsi":;case"Qsif":;case"Qsir":;case"QsiSXTag":break;case"TxtQry":break;case"FilterMode":break;case"AutoFilter":;case"AutoFilterInfo":break;case"AutoFilter12":break;case"DropDownObjIds":break;case"Sort":break;case"SortData":break;case"ShapePropsStream":break;case"MsoDrawing":;case"MsoDrawingGroup":;case"MsoDrawingSelection":break;case"WebPub":;case"AutoWebPub":break;case"HeaderFooter":;case"HFPicture":;case"PLV":;case"HorizontalPageBreaks":;case"VerticalPageBreaks":break;case"Backup":;case"CompressPictures":;case"Compat12":break;case"Continue":;case"ContinueFrt12":break;case"FrtFontList":;case"FrtWrapper":break;default:switch(q.n){case"TabIdConf":;case"Radar":;case"RadarArea":;case"DropBar":;case"Intl":;case"CoordList":;case"SerAuxErrBar":break;case"BIFF2FONTCLR":;case"BIFF2FMTCNT":;case"BIFF2FONTXTRA":break;case"BIFF2XF":;case"BIFF3XF":;case"BIFF4XF":break;case"BIFF4FMTCNT":;case"BIFF2ROW":;case"BIFF2WINDOW2":break;case"SCENARIO":;case"DConBin":;case"PicF":;case"DataLabExt":;case"Lel":;case"BopPop":;case"BopPopCustom":;case"RealTimeData":;case"Name":break;case"LHNGraph":;case"FnGroupName":;case"AddMenu":;case"LPr":break;case"ListObj":;case"ListField":break;case"RRSort":break;case"BigName":break;case"ToolbarHdr":;case"ToolbarEnd":break;case"DDEObjName":break;case"FRTArchId$":break;default:if(r.WTF)throw"Unrecognized Record "+q.n;};};};}}else e.l+=J}t.SheetNames=j(i).sort(function(e,r){return Number(e)-Number(r)}).map(function(e){return i[e].name});if(!r.bookSheets)t.Sheets=a;if(t.Sheets)K.forEach(function(e,r){t.Sheets[t.SheetNames[r]]["!autofilter"]=e});t.Preamble=h;t.Strings=l;t.SSF=D.get_table();if(R.enc)t.Encryption=R.enc;if(O)t.Themes=O;t.Metadata={};if(k!==undefined)t.Metadata.Country=k;if(W.names.length>0)B.Names=W.names;t.Workbook=B;return t}var sv={SI:"e0859ff2f94f6810ab9108002b27b3d9",DSI:"02d5cdd59c2e1b10939708002b2cf9ae",UDI:"05d5cdd59c2e1b10939708002b2cf9ae"};function fv(e,r,t){var a=W.find(e,"!DocumentSummaryInformation");if(a&&a.size>0)try{var n=On(a,pa,sv.DSI);for(var i in n)r[i]=n[i]}catch(s){if(t.WTF)throw s}var f=W.find(e,"!SummaryInformation");if(f&&f.size>0)try{var o=On(f,va,sv.SI);for(var l in o)if(r[l]==null)r[l]=o[l]}catch(s){if(t.WTF)throw s}if(r.HeadingPairs&&r.TitlesOfParts){Ja(r.HeadingPairs,r.TitlesOfParts,r,t);delete r.HeadingPairs;delete r.TitlesOfParts}}function ov(e,r){var t=[],a=[],n=[];var i=0,s;if(e.Props){s=j(e.Props);for(i=0;i<s.length;++i)(ma.hasOwnProperty(s[i])?t:ba.hasOwnProperty(s[i])?a:n).push([s[i],e.Props[s[i]]])}if(e.Custprops){s=j(e.Custprops);for(i=0;i<s.length;++i)if(!(e.Props||{}).hasOwnProperty(s[i]))(ma.hasOwnProperty(s[i])?t:ba.hasOwnProperty(s[i])?a:n).push([s[i],e.Custprops[s[i]]])}var f=[];for(i=0;i<n.length;++i){if(In.indexOf(n[i][0])>-1)continue;if(n[i][1]==null)continue;f.push(n[i])}if(a.length)W.utils.cfb_add(r,"/SummaryInformation",Fn(a,sv.SI,ba,va));if(t.length||f.length)W.utils.cfb_add(r,"/DocumentSummaryInformation",Fn(t,sv.DSI,ma,pa,f.length?f:null,sv.UDI))}function lv(e,r){if(!r)r={};rg(r);l();if(r.codepage)s(r.codepage);var t,a;if(e.FullPaths){if(W.find(e,"/encryption"))throw new Error("File is password-protected");t=W.find(e,"!CompObj");a=W.find(e,"/Workbook")||W.find(e,"/Book")}else{switch(r.type){case"base64":e=A(m.decode(e));break;case"binary":e=A(e);break;case"buffer":break;case"array":if(!Array.isArray(e))e=Array.prototype.slice.call(e);break;}zr(e,0);a={content:e}}var n;var i;if(t)rv(t);if(r.bookProps&&!r.bookSheets)n={};else{var f=b?"buffer":"array";if(a&&a.content)n=iv(a.content,r);else if((i=W.find(e,"PerfectOffice_MAIN"))&&i.content)n=sf.to_workbook(i.content,(r.type=f,r));else if((i=W.find(e,"NativeContent_MAIN"))&&i.content)n=sf.to_workbook(i.content,(r.type=f,r));else throw new Error("Cannot find Workbook stream");if(r.bookVBA&&e.FullPaths&&W.find(e,"/_VBA_PROJECT_CUR/VBA/dir"))n.vbaraw=Ll(e)}var o={};if(e.FullPaths)fv(e,o,r);n.Props=n.Custprops=o;if(r.bookFiles)n.cfb=e;return n}function cv(e,r){var t=r||{};var a=W.utils.cfb_new({root:"R"});var n="/Workbook";switch(t.bookType||"xls"){case"xls":t.bookType="biff8";case"xla":if(!t.bookType)t.bookType="xla";case"biff8":n="/Workbook";t.biff=8;break;case"biff5":n="/Book";t.biff=5;break;default:throw new Error("invalid type "+t.bookType+" for XLS CFB");}W.utils.cfb_add(a,n,Rv(e,t));if(t.biff==8&&(e.Props||e.Custprops))ov(e,a);if(t.biff==8&&e.vbaraw)Ml(a,W.read(e.vbaraw,{type:typeof e.vbaraw=="string"?"binary":"buffer"}));return a}var hv={0:{n:"BrtRowHdr",f:xu},1:{n:"BrtCellBlank",f:Lu},2:{n:"BrtCellRk",f:ju},3:{n:"BrtCellError",f:Wu},4:{n:"BrtCellBool",f:Uu},5:{n:"BrtCellReal",f:Xu},6:{n:"BrtCellSt",f:Yu},7:{n:"BrtCellIsst",f:Vu},8:{n:"BrtFmlaString",f:qu},9:{n:"BrtFmlaNum",f:Ju},10:{n:"BrtFmlaBool",f:Zu},11:{n:"BrtFmlaError",f:Qu},16:{n:"BrtFRTArchID$",f:tp},19:{n:"BrtSSTItem",f:_t},20:{n:"BrtPCDIMissing"},21:{n:"BrtPCDINumber"},22:{n:"BrtPCDIBoolean"},23:{n:"BrtPCDIError"},24:{n:"BrtPCDIString"},25:{n:"BrtPCDIDatetime"},26:{n:"BrtPCDIIndex"},27:{n:"BrtPCDIAMissing"},28:{n:"BrtPCDIANumber"},29:{n:"BrtPCDIABoolean"},30:{n:"BrtPCDIAError"},31:{n:"BrtPCDIAString"},32:{n:"BrtPCDIADatetime"},33:{n:"BrtPCRRecord"},34:{n:"BrtPCRRecordDt"},35:{n:"BrtFRTBegin"},36:{n:"BrtFRTEnd"},37:{n:"BrtACBegin"},38:{n:"BrtACEnd"},39:{n:"BrtName",f:ap},40:{n:"BrtIndexRowBlock"},42:{n:"BrtIndexBlock"},43:{n:"BrtFont",f:yo},44:{n:"BrtFmt",f:Bo},45:{n:"BrtFill",f:Do},46:{n:"BrtBorder",f:Lo},47:{n:"BrtXF",f:Fo},48:{n:"BrtStyle"},49:{n:"BrtCellMeta"},50:{n:"BrtValueMeta"},51:{n:"BrtMdb"},52:{n:"BrtBeginFmd"},53:{n:"BrtEndFmd"},54:{n:"BrtBeginMdx"},55:{n:"BrtEndMdx"},56:{n:"BrtBeginMdxTuple"},57:{n:"BrtEndMdxTuple"},58:{n:"BrtMdxMbrIstr"},59:{n:"BrtStr"},60:{n:"BrtColInfo",f:Ls},62:{n:"BrtCellRString"},63:{n:"BrtCalcChainItem$",f:bl},64:{n:"BrtDVal"},65:{n:"BrtSxvcellNum"},66:{n:"BrtSxvcellStr"},67:{n:"BrtSxvcellBool"},68:{n:"BrtSxvcellErr"},69:{n:"BrtSxvcellDate"},70:{n:"BrtSxvcellNil"},128:{n:"BrtFileVersion"},129:{n:"BrtBeginSheet"},130:{n:"BrtEndSheet"},131:{n:"BrtBeginBook",f:Xr,p:0},132:{n:"BrtEndBook"},133:{n:"BrtBeginWsViews"},134:{n:"BrtEndWsViews"},135:{n:"BrtBeginBookViews"},136:{n:"BrtEndBookViews"},137:{n:"BrtBeginWsView",f:hd},138:{n:"BrtEndWsView"},139:{n:"BrtBeginCsViews"},140:{n:"BrtEndCsViews"},141:{n:"BrtBeginCsView"},142:{n:"BrtEndCsView"},143:{n:"BrtBeginBundleShs"},144:{n:"BrtEndBundleShs"},145:{n:"BrtBeginSheetData"},146:{n:"BrtEndSheetData"},147:{n:"BrtWsProp",f:Pu},148:{n:"BrtWsDim",f:Du,p:16},151:{n:"BrtPane"},152:{n:"BrtSel"},153:{n:"BrtWbProp",f:ep},154:{n:"BrtWbFactoid"},155:{n:"BrtFileRecover"},156:{n:"BrtBundleSh",f:Jd},157:{n:"BrtCalcProp"},158:{n:"BrtBookView"},159:{n:"BrtBeginSst",f:bf},160:{n:"BrtEndSst"},161:{n:"BrtBeginAFilter",f:Vt},162:{n:"BrtEndAFilter"},163:{n:"BrtBeginFilterColumn"},164:{n:"BrtEndFilterColumn"},165:{n:"BrtBeginFilters"},166:{n:"BrtEndFilters"},167:{n:"BrtFilter"},168:{n:"BrtColorFilter"},169:{n:"BrtIconFilter"},170:{n:"BrtTop10Filter"},171:{n:"BrtDynamicFilter"},172:{n:"BrtBeginCustomFilters"},173:{n:"BrtEndCustomFilters"},174:{n:"BrtCustomFilter"},175:{n:"BrtAFilterDateGroupItem"},176:{n:"BrtMergeCell",f:ed},177:{n:"BrtBeginMergeCells"},178:{n:"BrtEndMergeCells"},179:{n:"BrtBeginPivotCacheDef"},180:{n:"BrtEndPivotCacheDef"},181:{n:"BrtBeginPCDFields"},182:{n:"BrtEndPCDFields"},183:{n:"BrtBeginPCDField"},184:{n:"BrtEndPCDField"},185:{n:"BrtBeginPCDSource"},186:{n:"BrtEndPCDSource"},187:{n:"BrtBeginPCDSRange"},188:{n:"BrtEndPCDSRange"},189:{n:"BrtBeginPCDFAtbl"},190:{n:"BrtEndPCDFAtbl"},191:{n:"BrtBeginPCDIRun"},192:{n:"BrtEndPCDIRun"},193:{n:"BrtBeginPivotCacheRecords"},194:{n:"BrtEndPivotCacheRecords"},195:{n:"BrtBeginPCDHierarchies"},196:{n:"BrtEndPCDHierarchies"},197:{n:"BrtBeginPCDHierarchy"},198:{n:"BrtEndPCDHierarchy"},199:{n:"BrtBeginPCDHFieldsUsage"},200:{n:"BrtEndPCDHFieldsUsage"},201:{n:"BrtBeginExtConnection"},202:{n:"BrtEndExtConnection"},203:{n:"BrtBeginECDbProps"},204:{n:"BrtEndECDbProps"},205:{n:"BrtBeginECOlapProps"},206:{n:"BrtEndECOlapProps"},207:{n:"BrtBeginPCDSConsol"},208:{n:"BrtEndPCDSConsol"},209:{n:"BrtBeginPCDSCPages"},210:{n:"BrtEndPCDSCPages"},211:{n:"BrtBeginPCDSCPage"},212:{n:"BrtEndPCDSCPage"},213:{n:"BrtBeginPCDSCPItem"},214:{n:"BrtEndPCDSCPItem"},215:{n:"BrtBeginPCDSCSets"},216:{n:"BrtEndPCDSCSets"},217:{n:"BrtBeginPCDSCSet"},218:{n:"BrtEndPCDSCSet"},219:{n:"BrtBeginPCDFGroup"},220:{n:"BrtEndPCDFGroup"},221:{n:"BrtBeginPCDFGItems"},222:{n:"BrtEndPCDFGItems"},223:{n:"BrtBeginPCDFGRange"},224:{n:"BrtEndPCDFGRange"},225:{n:"BrtBeginPCDFGDiscrete"},226:{n:"BrtEndPCDFGDiscrete"},227:{n:"BrtBeginPCDSDTupleCache"},228:{n:"BrtEndPCDSDTupleCache"},229:{n:"BrtBeginPCDSDTCEntries"},230:{n:"BrtEndPCDSDTCEntries"},231:{n:"BrtBeginPCDSDTCEMembers"},232:{n:"BrtEndPCDSDTCEMembers"},233:{n:"BrtBeginPCDSDTCEMember"},234:{n:"BrtEndPCDSDTCEMember"},235:{n:"BrtBeginPCDSDTCQueries"},236:{n:"BrtEndPCDSDTCQueries"},237:{n:"BrtBeginPCDSDTCQuery"},238:{n:"BrtEndPCDSDTCQuery"},239:{n:"BrtBeginPCDSDTCSets"},240:{n:"BrtEndPCDSDTCSets"},241:{n:"BrtBeginPCDSDTCSet"},242:{n:"BrtEndPCDSDTCSet"},243:{n:"BrtBeginPCDCalcItems"},244:{n:"BrtEndPCDCalcItems"},245:{n:"BrtBeginPCDCalcItem"},246:{n:"BrtEndPCDCalcItem"},247:{n:"BrtBeginPRule"},248:{n:"BrtEndPRule"},249:{n:"BrtBeginPRFilters"},250:{n:"BrtEndPRFilters"},251:{n:"BrtBeginPRFilter"},252:{n:"BrtEndPRFilter"},253:{n:"BrtBeginPNames"},254:{n:"BrtEndPNames"},255:{n:"BrtBeginPName"},256:{n:"BrtEndPName"},257:{n:"BrtBeginPNPairs"},258:{n:"BrtEndPNPairs"},259:{n:"BrtBeginPNPair"},260:{n:"BrtEndPNPair"},261:{n:"BrtBeginECWebProps"},262:{n:"BrtEndECWebProps"},263:{n:"BrtBeginEcWpTables"},264:{n:"BrtEndECWPTables"},265:{n:"BrtBeginECParams"},266:{n:"BrtEndECParams"},267:{n:"BrtBeginECParam"},268:{n:"BrtEndECParam"},269:{n:"BrtBeginPCDKPIs"},270:{n:"BrtEndPCDKPIs"},271:{n:"BrtBeginPCDKPI"},272:{n:"BrtEndPCDKPI"},273:{n:"BrtBeginDims"},274:{n:"BrtEndDims"},275:{n:"BrtBeginDim"},
276:{n:"BrtEndDim"},277:{n:"BrtIndexPartEnd"},278:{n:"BrtBeginStyleSheet"},279:{n:"BrtEndStyleSheet"},280:{n:"BrtBeginSXView"},281:{n:"BrtEndSXVI"},282:{n:"BrtBeginSXVI"},283:{n:"BrtBeginSXVIs"},284:{n:"BrtEndSXVIs"},285:{n:"BrtBeginSXVD"},286:{n:"BrtEndSXVD"},287:{n:"BrtBeginSXVDs"},288:{n:"BrtEndSXVDs"},289:{n:"BrtBeginSXPI"},290:{n:"BrtEndSXPI"},291:{n:"BrtBeginSXPIs"},292:{n:"BrtEndSXPIs"},293:{n:"BrtBeginSXDI"},294:{n:"BrtEndSXDI"},295:{n:"BrtBeginSXDIs"},296:{n:"BrtEndSXDIs"},297:{n:"BrtBeginSXLI"},298:{n:"BrtEndSXLI"},299:{n:"BrtBeginSXLIRws"},300:{n:"BrtEndSXLIRws"},301:{n:"BrtBeginSXLICols"},302:{n:"BrtEndSXLICols"},303:{n:"BrtBeginSXFormat"},304:{n:"BrtEndSXFormat"},305:{n:"BrtBeginSXFormats"},306:{n:"BrtEndSxFormats"},307:{n:"BrtBeginSxSelect"},308:{n:"BrtEndSxSelect"},309:{n:"BrtBeginISXVDRws"},310:{n:"BrtEndISXVDRws"},311:{n:"BrtBeginISXVDCols"},312:{n:"BrtEndISXVDCols"},313:{n:"BrtEndSXLocation"},314:{n:"BrtBeginSXLocation"},315:{n:"BrtEndSXView"},316:{n:"BrtBeginSXTHs"},317:{n:"BrtEndSXTHs"},318:{n:"BrtBeginSXTH"},319:{n:"BrtEndSXTH"},320:{n:"BrtBeginISXTHRws"},321:{n:"BrtEndISXTHRws"},322:{n:"BrtBeginISXTHCols"},323:{n:"BrtEndISXTHCols"},324:{n:"BrtBeginSXTDMPS"},325:{n:"BrtEndSXTDMPs"},326:{n:"BrtBeginSXTDMP"},327:{n:"BrtEndSXTDMP"},328:{n:"BrtBeginSXTHItems"},329:{n:"BrtEndSXTHItems"},330:{n:"BrtBeginSXTHItem"},331:{n:"BrtEndSXTHItem"},332:{n:"BrtBeginMetadata"},333:{n:"BrtEndMetadata"},334:{n:"BrtBeginEsmdtinfo"},335:{n:"BrtMdtinfo"},336:{n:"BrtEndEsmdtinfo"},337:{n:"BrtBeginEsmdb"},338:{n:"BrtEndEsmdb"},339:{n:"BrtBeginEsfmd"},340:{n:"BrtEndEsfmd"},341:{n:"BrtBeginSingleCells"},342:{n:"BrtEndSingleCells"},343:{n:"BrtBeginList"},344:{n:"BrtEndList"},345:{n:"BrtBeginListCols"},346:{n:"BrtEndListCols"},347:{n:"BrtBeginListCol"},348:{n:"BrtEndListCol"},349:{n:"BrtBeginListXmlCPr"},350:{n:"BrtEndListXmlCPr"},351:{n:"BrtListCCFmla"},352:{n:"BrtListTrFmla"},353:{n:"BrtBeginExternals"},354:{n:"BrtEndExternals"},355:{n:"BrtSupBookSrc",f:Nt},357:{n:"BrtSupSelf"},358:{n:"BrtSupSame"},359:{n:"BrtSupTabs"},360:{n:"BrtBeginSupBook"},361:{n:"BrtPlaceholderName"},362:{n:"BrtExternSheet",f:ps},363:{n:"BrtExternTableStart"},364:{n:"BrtExternTableEnd"},366:{n:"BrtExternRowHdr"},367:{n:"BrtExternCellBlank"},368:{n:"BrtExternCellReal"},369:{n:"BrtExternCellBool"},370:{n:"BrtExternCellError"},371:{n:"BrtExternCellString"},372:{n:"BrtBeginEsmdx"},373:{n:"BrtEndEsmdx"},374:{n:"BrtBeginMdxSet"},375:{n:"BrtEndMdxSet"},376:{n:"BrtBeginMdxMbrProp"},377:{n:"BrtEndMdxMbrProp"},378:{n:"BrtBeginMdxKPI"},379:{n:"BrtEndMdxKPI"},380:{n:"BrtBeginEsstr"},381:{n:"BrtEndEsstr"},382:{n:"BrtBeginPRFItem"},383:{n:"BrtEndPRFItem"},384:{n:"BrtBeginPivotCacheIDs"},385:{n:"BrtEndPivotCacheIDs"},386:{n:"BrtBeginPivotCacheID"},387:{n:"BrtEndPivotCacheID"},388:{n:"BrtBeginISXVIs"},389:{n:"BrtEndISXVIs"},390:{n:"BrtBeginColInfos"},391:{n:"BrtEndColInfos"},392:{n:"BrtBeginRwBrk"},393:{n:"BrtEndRwBrk"},394:{n:"BrtBeginColBrk"},395:{n:"BrtEndColBrk"},396:{n:"BrtBrk"},397:{n:"BrtUserBookView"},398:{n:"BrtInfo"},399:{n:"BrtCUsr"},400:{n:"BrtUsr"},401:{n:"BrtBeginUsers"},403:{n:"BrtEOF"},404:{n:"BrtUCR"},405:{n:"BrtRRInsDel"},406:{n:"BrtRREndInsDel"},407:{n:"BrtRRMove"},408:{n:"BrtRREndMove"},409:{n:"BrtRRChgCell"},410:{n:"BrtRREndChgCell"},411:{n:"BrtRRHeader"},412:{n:"BrtRRUserView"},413:{n:"BrtRRRenSheet"},414:{n:"BrtRRInsertSh"},415:{n:"BrtRRDefName"},416:{n:"BrtRRNote"},417:{n:"BrtRRConflict"},418:{n:"BrtRRTQSIF"},419:{n:"BrtRRFormat"},420:{n:"BrtRREndFormat"},421:{n:"BrtRRAutoFmt"},422:{n:"BrtBeginUserShViews"},423:{n:"BrtBeginUserShView"},424:{n:"BrtEndUserShView"},425:{n:"BrtEndUserShViews"},426:{n:"BrtArrFmla",f:id},427:{n:"BrtShrFmla",f:sd},428:{n:"BrtTable"},429:{n:"BrtBeginExtConnections"},430:{n:"BrtEndExtConnections"},431:{n:"BrtBeginPCDCalcMems"},432:{n:"BrtEndPCDCalcMems"},433:{n:"BrtBeginPCDCalcMem"},434:{n:"BrtEndPCDCalcMem"},435:{n:"BrtBeginPCDHGLevels"},436:{n:"BrtEndPCDHGLevels"},437:{n:"BrtBeginPCDHGLevel"},438:{n:"BrtEndPCDHGLevel"},439:{n:"BrtBeginPCDHGLGroups"},440:{n:"BrtEndPCDHGLGroups"},441:{n:"BrtBeginPCDHGLGroup"},442:{n:"BrtEndPCDHGLGroup"},443:{n:"BrtBeginPCDHGLGMembers"},444:{n:"BrtEndPCDHGLGMembers"},445:{n:"BrtBeginPCDHGLGMember"},446:{n:"BrtEndPCDHGLGMember"},447:{n:"BrtBeginQSI"},448:{n:"BrtEndQSI"},449:{n:"BrtBeginQSIR"},450:{n:"BrtEndQSIR"},451:{n:"BrtBeginDeletedNames"},452:{n:"BrtEndDeletedNames"},453:{n:"BrtBeginDeletedName"},454:{n:"BrtEndDeletedName"},455:{n:"BrtBeginQSIFs"},456:{n:"BrtEndQSIFs"},457:{n:"BrtBeginQSIF"},458:{n:"BrtEndQSIF"},459:{n:"BrtBeginAutoSortScope"},460:{n:"BrtEndAutoSortScope"},461:{n:"BrtBeginConditionalFormatting"},462:{n:"BrtEndConditionalFormatting"},463:{n:"BrtBeginCFRule"},464:{n:"BrtEndCFRule"},465:{n:"BrtBeginIconSet"},466:{n:"BrtEndIconSet"},467:{n:"BrtBeginDatabar"},468:{n:"BrtEndDatabar"},469:{n:"BrtBeginColorScale"},470:{n:"BrtEndColorScale"},471:{n:"BrtCFVO"},472:{n:"BrtExternValueMeta"},473:{n:"BrtBeginColorPalette"},474:{n:"BrtEndColorPalette"},475:{n:"BrtIndexedColor"},476:{n:"BrtMargins",f:ld},477:{n:"BrtPrintOptions"},478:{n:"BrtPageSetup"},479:{n:"BrtBeginHeaderFooter"},480:{n:"BrtEndHeaderFooter"},481:{n:"BrtBeginSXCrtFormat"},482:{n:"BrtEndSXCrtFormat"},483:{n:"BrtBeginSXCrtFormats"},484:{n:"BrtEndSXCrtFormats"},485:{n:"BrtWsFmtInfo",f:Fu},486:{n:"BrtBeginMgs"},487:{n:"BrtEndMGs"},488:{n:"BrtBeginMGMaps"},489:{n:"BrtEndMGMaps"},490:{n:"BrtBeginMG"},491:{n:"BrtEndMG"},492:{n:"BrtBeginMap"},493:{n:"BrtEndMap"},494:{n:"BrtHLink",f:ad},495:{n:"BrtBeginDCon"},496:{n:"BrtEndDCon"},497:{n:"BrtBeginDRefs"},498:{n:"BrtEndDRefs"},499:{n:"BrtDRef"},500:{n:"BrtBeginScenMan"},501:{n:"BrtEndScenMan"},502:{n:"BrtBeginSct"},503:{n:"BrtEndSct"},504:{n:"BrtSlc"},505:{n:"BrtBeginDXFs"},506:{n:"BrtEndDXFs"},507:{n:"BrtDXF"},508:{n:"BrtBeginTableStyles"},509:{n:"BrtEndTableStyles"},510:{n:"BrtBeginTableStyle"},511:{n:"BrtEndTableStyle"},512:{n:"BrtTableStyleElement"},513:{n:"BrtTableStyleClient"},514:{n:"BrtBeginVolDeps"},515:{n:"BrtEndVolDeps"},516:{n:"BrtBeginVolType"},517:{n:"BrtEndVolType"},518:{n:"BrtBeginVolMain"},519:{n:"BrtEndVolMain"},520:{n:"BrtBeginVolTopic"},521:{n:"BrtEndVolTopic"},522:{n:"BrtVolSubtopic"},523:{n:"BrtVolRef"},524:{n:"BrtVolNum"},525:{n:"BrtVolErr"},526:{n:"BrtVolStr"},527:{n:"BrtVolBool"},528:{n:"BrtBeginCalcChain$"},529:{n:"BrtEndCalcChain$"},530:{n:"BrtBeginSortState"},531:{n:"BrtEndSortState"},532:{n:"BrtBeginSortCond"},533:{n:"BrtEndSortCond"},534:{n:"BrtBookProtection"},535:{n:"BrtSheetProtection"},536:{n:"BrtRangeProtection"},537:{n:"BrtPhoneticInfo"},538:{n:"BrtBeginECTxtWiz"},539:{n:"BrtEndECTxtWiz"},540:{n:"BrtBeginECTWFldInfoLst"},541:{n:"BrtEndECTWFldInfoLst"},542:{n:"BrtBeginECTwFldInfo"},548:{n:"BrtFileSharing"},549:{n:"BrtOleSize"},550:{n:"BrtDrawing",f:Nt},551:{n:"BrtLegacyDrawing"},552:{n:"BrtLegacyDrawingHF"},553:{n:"BrtWebOpt"},554:{n:"BrtBeginWebPubItems"},555:{n:"BrtEndWebPubItems"},556:{n:"BrtBeginWebPubItem"},557:{n:"BrtEndWebPubItem"},558:{n:"BrtBeginSXCondFmt"},559:{n:"BrtEndSXCondFmt"},560:{n:"BrtBeginSXCondFmts"},561:{n:"BrtEndSXCondFmts"},562:{n:"BrtBkHim"},564:{n:"BrtColor"},565:{n:"BrtBeginIndexedColors"},566:{n:"BrtEndIndexedColors"},569:{n:"BrtBeginMRUColors"},570:{n:"BrtEndMRUColors"},572:{n:"BrtMRUColor"},573:{n:"BrtBeginDVals"},574:{n:"BrtEndDVals"},577:{n:"BrtSupNameStart"},578:{n:"BrtSupNameValueStart"},579:{n:"BrtSupNameValueEnd"},580:{n:"BrtSupNameNum"},581:{n:"BrtSupNameErr"},582:{n:"BrtSupNameSt"},583:{n:"BrtSupNameNil"},584:{n:"BrtSupNameBool"},585:{n:"BrtSupNameFmla"},586:{n:"BrtSupNameBits"},587:{n:"BrtSupNameEnd"},588:{n:"BrtEndSupBook"},589:{n:"BrtCellSmartTagProperty"},590:{n:"BrtBeginCellSmartTag"},591:{n:"BrtEndCellSmartTag"},592:{n:"BrtBeginCellSmartTags"},593:{n:"BrtEndCellSmartTags"},594:{n:"BrtBeginSmartTags"},595:{n:"BrtEndSmartTags"},596:{n:"BrtSmartTagType"},597:{n:"BrtBeginSmartTagTypes"},598:{n:"BrtEndSmartTagTypes"},599:{n:"BrtBeginSXFilters"},600:{n:"BrtEndSXFilters"},601:{n:"BrtBeginSXFILTER"},602:{n:"BrtEndSXFilter"},603:{n:"BrtBeginFills"},604:{n:"BrtEndFills"},605:{n:"BrtBeginCellWatches"},606:{n:"BrtEndCellWatches"},607:{n:"BrtCellWatch"},608:{n:"BrtBeginCRErrs"},609:{n:"BrtEndCRErrs"},610:{n:"BrtCrashRecErr"},611:{n:"BrtBeginFonts"},612:{n:"BrtEndFonts"},613:{n:"BrtBeginBorders"},614:{n:"BrtEndBorders"},615:{n:"BrtBeginFmts"},616:{n:"BrtEndFmts"},617:{n:"BrtBeginCellXFs"},618:{n:"BrtEndCellXFs"},619:{n:"BrtBeginStyles"},620:{n:"BrtEndStyles"},625:{n:"BrtBigName"},626:{n:"BrtBeginCellStyleXFs"},627:{n:"BrtEndCellStyleXFs"},628:{n:"BrtBeginComments"},629:{n:"BrtEndComments"},630:{n:"BrtBeginCommentAuthors"},631:{n:"BrtEndCommentAuthors"},632:{n:"BrtCommentAuthor",f:Dl},633:{n:"BrtBeginCommentList"},634:{n:"BrtEndCommentList"},635:{n:"BrtBeginComment",f:Il},636:{n:"BrtEndComment"},637:{n:"BrtCommentText",f:Tt},638:{n:"BrtBeginOleObjects"},639:{n:"BrtOleObject"},640:{n:"BrtEndOleObjects"},641:{n:"BrtBeginSxrules"},642:{n:"BrtEndSxRules"},643:{n:"BrtBeginActiveXControls"},644:{n:"BrtActiveX"},645:{n:"BrtEndActiveXControls"},646:{n:"BrtBeginPCDSDTCEMembersSortBy"},648:{n:"BrtBeginCellIgnoreECs"},649:{n:"BrtCellIgnoreEC"},650:{n:"BrtEndCellIgnoreECs"},651:{n:"BrtCsProp",f:Od},652:{n:"BrtCsPageSetup"},653:{n:"BrtBeginUserCsViews"},654:{n:"BrtEndUserCsViews"},655:{n:"BrtBeginUserCsView"},656:{n:"BrtEndUserCsView"},657:{n:"BrtBeginPcdSFCIEntries"},658:{n:"BrtEndPCDSFCIEntries"},659:{n:"BrtPCDSFCIEntry"},660:{n:"BrtBeginListParts"},661:{n:"BrtListPart"},662:{n:"BrtEndListParts"},663:{n:"BrtSheetCalcProp"},664:{n:"BrtBeginFnGroup"},665:{n:"BrtFnGroup"},666:{n:"BrtEndFnGroup"},667:{n:"BrtSupAddin"},668:{n:"BrtSXTDMPOrder"},669:{n:"BrtCsProtection"},671:{n:"BrtBeginWsSortMap"},672:{n:"BrtEndWsSortMap"},673:{n:"BrtBeginRRSort"},674:{n:"BrtEndRRSort"},675:{n:"BrtRRSortItem"},676:{n:"BrtFileSharingIso"},677:{n:"BrtBookProtectionIso"},678:{n:"BrtSheetProtectionIso"},679:{n:"BrtCsProtectionIso"},680:{n:"BrtRangeProtectionIso"},1024:{n:"BrtRwDescent"},1025:{n:"BrtKnownFonts"},1026:{n:"BrtBeginSXTupleSet"},1027:{n:"BrtEndSXTupleSet"},1028:{n:"BrtBeginSXTupleSetHeader"},1029:{n:"BrtEndSXTupleSetHeader"},1030:{n:"BrtSXTupleSetHeaderItem"},1031:{n:"BrtBeginSXTupleSetData"},1032:{n:"BrtEndSXTupleSetData"},1033:{n:"BrtBeginSXTupleSetRow"},1034:{n:"BrtEndSXTupleSetRow"},1035:{n:"BrtSXTupleSetRowItem"},1036:{n:"BrtNameExt"},1037:{n:"BrtPCDH14"},1038:{n:"BrtBeginPCDCalcMem14"},1039:{n:"BrtEndPCDCalcMem14"},1040:{n:"BrtSXTH14"},1041:{n:"BrtBeginSparklineGroup"},1042:{n:"BrtEndSparklineGroup"},1043:{n:"BrtSparkline"},1044:{n:"BrtSXDI14"},1045:{n:"BrtWsFmtInfoEx14"},1046:{n:"BrtBeginConditionalFormatting14"},1047:{n:"BrtEndConditionalFormatting14"},1048:{n:"BrtBeginCFRule14"},1049:{n:"BrtEndCFRule14"},1050:{n:"BrtCFVO14"},1051:{n:"BrtBeginDatabar14"},1052:{n:"BrtBeginIconSet14"},1053:{n:"BrtDVal14"},1054:{n:"BrtBeginDVals14"},1055:{n:"BrtColor14"},1056:{n:"BrtBeginSparklines"},1057:{n:"BrtEndSparklines"},1058:{n:"BrtBeginSparklineGroups"},1059:{n:"BrtEndSparklineGroups"},1061:{n:"BrtSXVD14"},1062:{n:"BrtBeginSXView14"},1063:{n:"BrtEndSXView14"},1064:{n:"BrtBeginSXView16"},1065:{n:"BrtEndSXView16"},1066:{n:"BrtBeginPCD14"},1067:{n:"BrtEndPCD14"},1068:{n:"BrtBeginExtConn14"},1069:{n:"BrtEndExtConn14"},1070:{n:"BrtBeginSlicerCacheIDs"},1071:{n:"BrtEndSlicerCacheIDs"},1072:{n:"BrtBeginSlicerCacheID"},1073:{n:"BrtEndSlicerCacheID"},1075:{n:"BrtBeginSlicerCache"},1076:{n:"BrtEndSlicerCache"},1077:{n:"BrtBeginSlicerCacheDef"},1078:{n:"BrtEndSlicerCacheDef"},1079:{n:"BrtBeginSlicersEx"},1080:{n:"BrtEndSlicersEx"},1081:{n:"BrtBeginSlicerEx"},1082:{n:"BrtEndSlicerEx"},1083:{n:"BrtBeginSlicer"},1084:{n:"BrtEndSlicer"},1085:{n:"BrtSlicerCachePivotTables"},1086:{n:"BrtBeginSlicerCacheOlapImpl"},1087:{n:"BrtEndSlicerCacheOlapImpl"},1088:{n:"BrtBeginSlicerCacheLevelsData"},1089:{n:"BrtEndSlicerCacheLevelsData"},1090:{n:"BrtBeginSlicerCacheLevelData"},1091:{n:"BrtEndSlicerCacheLevelData"},1092:{n:"BrtBeginSlicerCacheSiRanges"},1093:{n:"BrtEndSlicerCacheSiRanges"},1094:{n:"BrtBeginSlicerCacheSiRange"},1095:{n:"BrtEndSlicerCacheSiRange"},1096:{n:"BrtSlicerCacheOlapItem"},1097:{n:"BrtBeginSlicerCacheSelections"},1098:{n:"BrtSlicerCacheSelection"},1099:{n:"BrtEndSlicerCacheSelections"},1100:{n:"BrtBeginSlicerCacheNative"},1101:{n:"BrtEndSlicerCacheNative"},1102:{n:"BrtSlicerCacheNativeItem"},1103:{n:"BrtRangeProtection14"},1104:{n:"BrtRangeProtectionIso14"},1105:{n:"BrtCellIgnoreEC14"},1111:{n:"BrtList14"},1112:{n:"BrtCFIcon"},1113:{n:"BrtBeginSlicerCachesPivotCacheIDs"},1114:{n:"BrtEndSlicerCachesPivotCacheIDs"},1115:{n:"BrtBeginSlicers"},1116:{n:"BrtEndSlicers"},1117:{n:"BrtWbProp14"},1118:{n:"BrtBeginSXEdit"},1119:{n:"BrtEndSXEdit"},1120:{n:"BrtBeginSXEdits"},1121:{n:"BrtEndSXEdits"},1122:{n:"BrtBeginSXChange"},1123:{n:"BrtEndSXChange"},1124:{n:"BrtBeginSXChanges"},1125:{n:"BrtEndSXChanges"},1126:{n:"BrtSXTupleItems"},1128:{n:"BrtBeginSlicerStyle"},1129:{n:"BrtEndSlicerStyle"},1130:{n:"BrtSlicerStyleElement"},1131:{n:"BrtBeginStyleSheetExt14"},1132:{n:"BrtEndStyleSheetExt14"},1133:{n:"BrtBeginSlicerCachesPivotCacheID"},1134:{n:"BrtEndSlicerCachesPivotCacheID"},1135:{n:"BrtBeginConditionalFormattings"},1136:{n:"BrtEndConditionalFormattings"},1137:{n:"BrtBeginPCDCalcMemExt"},1138:{n:"BrtEndPCDCalcMemExt"},1139:{n:"BrtBeginPCDCalcMemsExt"},1140:{n:"BrtEndPCDCalcMemsExt"},1141:{n:"BrtPCDField14"},1142:{n:"BrtBeginSlicerStyles"},1143:{n:"BrtEndSlicerStyles"},1144:{n:"BrtBeginSlicerStyleElements"},1145:{n:"BrtEndSlicerStyleElements"},1146:{n:"BrtCFRuleExt"},1147:{n:"BrtBeginSXCondFmt14"},1148:{n:"BrtEndSXCondFmt14"},1149:{n:"BrtBeginSXCondFmts14"},1150:{n:"BrtEndSXCondFmts14"},1152:{n:"BrtBeginSortCond14"},1153:{n:"BrtEndSortCond14"},1154:{n:"BrtEndDVals14"},1155:{n:"BrtEndIconSet14"},1156:{n:"BrtEndDatabar14"},1157:{n:"BrtBeginColorScale14"},1158:{n:"BrtEndColorScale14"},1159:{n:"BrtBeginSxrules14"},1160:{n:"BrtEndSxrules14"},1161:{n:"BrtBeginPRule14"},1162:{n:"BrtEndPRule14"},1163:{n:"BrtBeginPRFilters14"},1164:{n:"BrtEndPRFilters14"},1165:{n:"BrtBeginPRFilter14"},1166:{n:"BrtEndPRFilter14"},1167:{n:"BrtBeginPRFItem14"},1168:{n:"BrtEndPRFItem14"},1169:{n:"BrtBeginCellIgnoreECs14"},1170:{n:"BrtEndCellIgnoreECs14"},1171:{n:"BrtDxf14"},1172:{n:"BrtBeginDxF14s"},1173:{n:"BrtEndDxf14s"},1177:{n:"BrtFilter14"},1178:{n:"BrtBeginCustomFilters14"},1180:{n:"BrtCustomFilter14"},1181:{n:"BrtIconFilter14"},1182:{n:"BrtPivotCacheConnectionName"},2048:{n:"BrtBeginDecoupledPivotCacheIDs"},2049:{n:"BrtEndDecoupledPivotCacheIDs"},2050:{n:"BrtDecoupledPivotCacheID"},2051:{n:"BrtBeginPivotTableRefs"},2052:{n:"BrtEndPivotTableRefs"},2053:{n:"BrtPivotTableRef"},2054:{n:"BrtSlicerCacheBookPivotTables"},2055:{n:"BrtBeginSxvcells"},2056:{n:"BrtEndSxvcells"},2057:{n:"BrtBeginSxRow"},2058:{n:"BrtEndSxRow"},2060:{n:"BrtPcdCalcMem15"},2067:{n:"BrtQsi15"},2068:{n:"BrtBeginWebExtensions"},2069:{n:"BrtEndWebExtensions"},2070:{n:"BrtWebExtension"},2071:{n:"BrtAbsPath15"},2072:{n:"BrtBeginPivotTableUISettings"},2073:{n:"BrtEndPivotTableUISettings"},2075:{n:"BrtTableSlicerCacheIDs"},2076:{n:"BrtTableSlicerCacheID"},2077:{n:"BrtBeginTableSlicerCache"},2078:{n:"BrtEndTableSlicerCache"},2079:{n:"BrtSxFilter15"},2080:{n:"BrtBeginTimelineCachePivotCacheIDs"},2081:{n:"BrtEndTimelineCachePivotCacheIDs"},2082:{n:"BrtTimelineCachePivotCacheID"},2083:{n:"BrtBeginTimelineCacheIDs"},2084:{n:"BrtEndTimelineCacheIDs"},2085:{n:"BrtBeginTimelineCacheID"},2086:{n:"BrtEndTimelineCacheID"},2087:{n:"BrtBeginTimelinesEx"},2088:{n:"BrtEndTimelinesEx"},2089:{n:"BrtBeginTimelineEx"},2090:{n:"BrtEndTimelineEx"},2091:{n:"BrtWorkBookPr15"},2092:{n:"BrtPCDH15"},2093:{n:"BrtBeginTimelineStyle"},2094:{n:"BrtEndTimelineStyle"},2095:{n:"BrtTimelineStyleElement"},2096:{n:"BrtBeginTimelineStylesheetExt15"},2097:{n:"BrtEndTimelineStylesheetExt15"},2098:{n:"BrtBeginTimelineStyles"},2099:{n:"BrtEndTimelineStyles"},2100:{n:"BrtBeginTimelineStyleElements"},2101:{n:"BrtEndTimelineStyleElements"},2102:{n:"BrtDxf15"},2103:{n:"BrtBeginDxfs15"},2104:{n:"brtEndDxfs15"},2105:{n:"BrtSlicerCacheHideItemsWithNoData"},2106:{n:"BrtBeginItemUniqueNames"},2107:{n:"BrtEndItemUniqueNames"},2108:{n:"BrtItemUniqueName"},2109:{n:"BrtBeginExtConn15"},2110:{n:"BrtEndExtConn15"},2111:{n:"BrtBeginOledbPr15"},2112:{n:"BrtEndOledbPr15"},2113:{n:"BrtBeginDataFeedPr15"},2114:{n:"BrtEndDataFeedPr15"},2115:{n:"BrtTextPr15"},2116:{n:"BrtRangePr15"},2117:{n:"BrtDbCommand15"},2118:{n:"BrtBeginDbTables15"},2119:{n:"BrtEndDbTables15"},2120:{n:"BrtDbTable15"},2121:{n:"BrtBeginDataModel"},2122:{n:"BrtEndDataModel"},2123:{n:"BrtBeginModelTables"},2124:{n:"BrtEndModelTables"},2125:{n:"BrtModelTable"},2126:{n:"BrtBeginModelRelationships"},2127:{n:"BrtEndModelRelationships"},2128:{n:"BrtModelRelationship"},2129:{n:"BrtBeginECTxtWiz15"},2130:{n:"BrtEndECTxtWiz15"},2131:{n:"BrtBeginECTWFldInfoLst15"},2132:{n:"BrtEndECTWFldInfoLst15"},2133:{n:"BrtBeginECTWFldInfo15"},2134:{n:"BrtFieldListActiveItem"},2135:{n:"BrtPivotCacheIdVersion"},2136:{n:"BrtSXDI15"},2137:{n:"BrtBeginModelTimeGroupings"},2138:{n:"BrtEndModelTimeGroupings"},2139:{n:"BrtBeginModelTimeGrouping"},2140:{n:"BrtEndModelTimeGrouping"},2141:{n:"BrtModelTimeGroupingCalcCol"},3072:{n:"BrtUid"},3073:{n:"BrtRevisionPtr"},65535:{n:""}};var uv=K(hv,"n");var dv={3:{n:"BIFF2NUM",f:js},4:{n:"BIFF2STR",f:Gs},6:{n:"Formula",f:Rh},9:{n:"BOF",f:Si},10:{n:"EOF",f:Pn},12:{n:"CalcCount",f:Hn},13:{n:"CalcMode",f:Hn},14:{n:"CalcPrecision",f:Mn},15:{n:"CalcRefMode",f:Mn},16:{n:"CalcDelta",f:Xt},17:{n:"CalcIter",f:Mn},18:{n:"Protect",f:Mn},19:{n:"Password",f:Hn},20:{n:"Header",f:ls},21:{n:"Footer",f:ls},23:{n:"ExternSheet",f:ps},24:{n:"Lbl",f:ds},25:{n:"WinProtect",f:Mn},26:{n:"VerticalPageBreaks"},27:{n:"HorizontalPageBreaks"},28:{n:"Note",f:Es},29:{n:"Selection"},34:{n:"Date1904",f:Mn},35:{n:"ExternName",f:hs},38:{n:"LeftMargin",f:Xt},39:{n:"RightMargin",f:Xt},40:{n:"TopMargin",f:Xt},41:{n:"BottomMargin",f:Xt},42:{n:"PrintRowCol",f:Mn},43:{n:"PrintGrid",f:Mn},47:{n:"FilePass",f:Gf},49:{n:"Font",f:Wi},51:{n:"PrintSize",f:Hn},60:{n:"Continue"},61:{n:"Window1",f:Li},64:{n:"Backup",f:Mn},65:{n:"Pane"},66:{n:"CodePage",f:Hn},77:{n:"Pls"},80:{n:"DCon"},81:{n:"DConRef"},82:{n:"DConName"},85:{n:"DefColWidth",f:Hn},89:{n:"XCT"},90:{n:"CRN"},91:{n:"FileSharing"},92:{n:"WriteAccess",f:Bi},93:{n:"Obj",f:As},94:{n:"Uncalced"},95:{n:"CalcSaveRecalc",f:Mn},96:{n:"Template"},97:{n:"Intl"},99:{n:"ObjProtect",f:Mn},125:{n:"ColInfo",f:Ls},128:{n:"Guts",f:as},129:{n:"WsBool",f:yi},130:{n:"GridSet",f:Hn},131:{n:"HCenter",f:Mn},132:{n:"VCenter",f:Mn},133:{n:"BoundSheet8",f:xi},134:{n:"WriteProtect"},140:{n:"Country",f:Ds},141:{n:"HideObj",f:Hn},144:{n:"Sort"},146:{n:"Palette",f:Ps},151:{n:"Sync"},152:{n:"LPr"},153:{n:"DxGCol"},154:{n:"FnGroupName"},155:{n:"FilterMode"},156:{n:"BuiltInFnGroupCount",f:Hn},157:{n:"AutoFilterInfo"},158:{n:"AutoFilter"},160:{n:"Scl",f:Vs},161:{n:"Setup",f:Ms},174:{n:"ScenMan"},175:{n:"SCENARIO"},176:{n:"SxView"},177:{n:"Sxvd"},178:{n:"SXVI"},180:{n:"SxIvd"},181:{n:"SXLI"},182:{n:"SXPI"},184:{n:"DocRoute"},185:{n:"RecipName"},189:{n:"MulRk",f:Ji},190:{n:"MulBlank",f:qi},193:{n:"Mms",f:Pn},197:{n:"SXDI"},198:{n:"SXDB"},199:{n:"SXFDB"},200:{n:"SXDBB"},201:{n:"SXNum"},202:{n:"SxBool",f:Mn},203:{n:"SxErr"},204:{n:"SXInt"},205:{n:"SXString"},206:{n:"SXDtr"},207:{n:"SxNil"},208:{n:"SXTbl"},209:{n:"SXTBRGIITM"},210:{n:"SxTbpg"},211:{n:"ObProj"},213:{n:"SXStreamID"},215:{n:"DBCell"},216:{n:"SXRng"},217:{n:"SxIsxoper"},218:{n:"BookBool",f:Hn},220:{n:"DbOrParamQry"},221:{n:"ScenarioProtect",f:Mn},222:{n:"OleObjectSize"},224:{n:"XF",f:rs},225:{n:"InterfaceHdr",f:_i},226:{n:"InterfaceEnd",f:Pn},227:{n:"SXVS"},229:{n:"MergeCells",f:ks},233:{n:"BkHim"},235:{n:"MsoDrawingGroup"},236:{n:"MsoDrawing"},237:{n:"MsoDrawingSelection"},239:{n:"PhoneticInfo"},240:{n:"SxRule"},241:{n:"SXEx"},242:{n:"SxFilt"},244:{n:"SxDXF"},245:{n:"SxItm"},246:{n:"SxName"},247:{n:"SxSelect"},248:{n:"SXPair"},249:{n:"SxFmla"},251:{n:"SxFormat"},252:{n:"SST",f:Ri},253:{n:"LabelSst",f:zi},255:{n:"ExtSST",f:Di},256:{n:"SXVDEx"},259:{n:"SXFormula"},290:{n:"SXDBEx"},311:{n:"RRDInsDel"},312:{n:"RRDHead"},315:{n:"RRDChgCell"},317:{n:"RRTabId",f:Vn},318:{n:"RRDRenSheet"},319:{n:"RRSort"},320:{n:"RRDMove"},330:{n:"RRFormat"},331:{n:"RRAutoFmt"},333:{n:"RRInsertSh"},334:{n:"RRDMoveBegin"},335:{n:"RRDMoveEnd"},336:{n:"RRDInsDelBegin"},337:{n:"RRDInsDelEnd"},338:{n:"RRDConflict"},339:{n:"RRDDefName"},340:{n:"RRDRstEtxp"},351:{n:"LRng"},352:{n:"UsesELFs",f:Mn},353:{n:"DSF",f:Pn},401:{n:"CUsr"},402:{n:"CbUsr"},403:{n:"UsrInfo"},404:{n:"UsrExcl"},405:{n:"FileLock"},406:{n:"RRDInfo"},407:{n:"BCUsrs"},408:{n:"UsrChk"},425:{n:"UserBView"},426:{n:"UserSViewBegin"},427:{n:"UserSViewEnd"},428:{n:"RRDUserView"},429:{n:"Qsi"},430:{n:"SupBook",f:cs},431:{n:"Prot4Rev",f:Mn},432:{n:"CondFmt"},433:{n:"CF"},434:{n:"DVal"},437:{n:"DConBin"},438:{n:"TxO",f:Ts},439:{n:"RefreshAll",f:Mn},440:{n:"HLink",f:ys},441:{n:"Lel"},442:{n:"CodeName",f:Yn},443:{n:"SXFDBType"},444:{n:"Prot4RevPass",f:Hn},445:{n:"ObNoMacros"},446:{n:"Dv"},448:{n:"Excel9File",f:Pn},449:{n:"RecalcId",f:Pi,r:2},450:{n:"EntExU2",f:Pn},512:{n:"Dimensions",f:$i},513:{n:"Blank",f:Ws},515:{n:"Number",f:fs},516:{n:"Label",f:Xi},517:{n:"BoolErr",f:is},518:{n:"Formula",f:Rh},519:{n:"String",f:zs},520:{n:"Row",f:Oi},523:{n:"Index"},545:{n:"Array",f:bs},549:{n:"DefaultRowHeight",f:Ni},566:{n:"Table"},574:{n:"Window2",f:Ui},638:{n:"RK",f:Qi},659:{n:"Style"},1030:{n:"Formula",f:Rh},1048:{n:"BigName"},1054:{n:"Format",f:ji},1084:{n:"ContinueBigName"},1212:{n:"ShrFmla",f:ms},2048:{n:"HLinkTooltip",f:Is},2049:{n:"WebPub"},2050:{n:"QsiSXTag"},2051:{n:"DBQueryExt"},2052:{n:"ExtString"},2053:{n:"TxtQry"},2054:{n:"Qsir"},2055:{n:"Qsif"},2056:{n:"RRDTQSIF"},2057:{n:"BOF",f:Si},2058:{n:"OleDbConn"},2059:{n:"WOpt"},2060:{n:"SXViewEx"},2061:{n:"SXTH"},2062:{n:"SXPIEx"},2063:{n:"SXVDTEx"},2064:{n:"SXViewEx9"},2066:{n:"ContinueFrt"},2067:{n:"RealTimeData"},2128:{n:"ChartFrtInfo"},2129:{n:"FrtWrapper"},2130:{n:"StartBlock"},2131:{n:"EndBlock"},2132:{n:"StartObject"},2133:{n:"EndObject"},2134:{n:"CatLab"},2135:{n:"YMult"},2136:{n:"SXViewLink"},2137:{n:"PivotChartBits"},2138:{n:"FrtFontList"},2146:{n:"SheetExt"},2147:{n:"BookExt",r:12},2148:{n:"SXAddl"},2149:{n:"CrErr"},2150:{n:"HFPicture"},2151:{n:"FeatHdr",f:Pn},2152:{n:"Feat"},2154:{n:"DataLabExt"},2155:{n:"DataLabExtContents"},2156:{n:"CellWatch"},2161:{n:"FeatHdr11"},2162:{n:"Feature11"},2164:{n:"DropDownObjIds"},2165:{n:"ContinueFrt11"},2166:{n:"DConn"},2167:{n:"List12"},2168:{n:"Feature12"},2169:{n:"CondFmt12"},2170:{n:"CF12"},2171:{n:"CFEx"},2172:{n:"XFCRC",f:Ns,r:12},2173:{n:"XFExt",f:vl,r:12},2174:{n:"AutoFilter12"},2175:{n:"ContinueFrt12"},2180:{n:"MDTInfo"},2181:{n:"MDXStr"},2182:{n:"MDXTuple"},2183:{n:"MDXSet"},2184:{n:"MDXProp"},2185:{n:"MDXKPI"},2186:{n:"MDB"},2187:{n:"PLV"},2188:{n:"Compat12",f:Mn,r:12},2189:{n:"DXF"},2190:{n:"TableStyles",r:12},2191:{n:"TableStyle"},2192:{n:"TableStyleElement"},2194:{n:"StyleExt"},2195:{n:"NamePublish"},2196:{n:"NameCmt",f:gs,r:12},2197:{n:"SortData"},2198:{n:"Theme",f:ll,r:12},2199:{n:"GUIDTypeLib"},2200:{n:"FnGrp12"},2201:{n:"NameFnGrp12"},2202:{n:"MTRSettings",f:ws,r:12},2203:{n:"CompressPictures",f:Pn},2204:{n:"HeaderFooter"},2205:{n:"CrtLayout12"},2206:{n:"CrtMlFrt"},2207:{n:"CrtMlFrtContinue"},2211:{n:"ForceFullCalculation",f:Fi},2212:{n:"ShapePropsStream"},2213:{n:"TextPropsStream"},2214:{n:"RichTextStream"},2215:{n:"CrtLayout12A"},4097:{n:"Units"},4098:{n:"Chart"},4099:{n:"Series"},4102:{n:"DataFormat"},4103:{n:"LineFormat"},4105:{n:"MarkerFormat"},4106:{n:"AreaFormat"},4107:{n:"PieFormat"},4108:{n:"AttachedLabel"},4109:{n:"SeriesText"},4116:{n:"ChartFormat"},4117:{n:"Legend"},4118:{n:"SeriesList"},4119:{n:"Bar"},4120:{n:"Line"},4121:{n:"Pie"},4122:{n:"Area"},4123:{n:"Scatter"},4124:{n:"CrtLine"},4125:{n:"Axis"},4126:{n:"Tick"},4127:{n:"ValueRange"},4128:{n:"CatSerRange"},4129:{n:"AxisLine"},4130:{n:"CrtLink"},4132:{n:"DefaultText"},4133:{n:"Text"},4134:{n:"FontX",f:Hn},4135:{n:"ObjectLink"},4146:{n:"Frame"},4147:{n:"Begin"},4148:{n:"End"},4149:{n:"PlotArea"},4154:{n:"Chart3d"},4156:{n:"PicF"},4157:{n:"DropBar"},4158:{n:"Radar"},4159:{n:"Surf"},4160:{n:"RadarArea"},4161:{n:"AxisParent"},4163:{n:"LegendException"},4164:{n:"ShtProps",f:Us},4165:{n:"SerToCrt"},4166:{n:"AxesUsed"},4168:{n:"SBaseRef"},4170:{n:"SerParent"},4171:{n:"SerAuxTrend"},4174:{n:"IFmtRecord"},4175:{n:"Pos"},4176:{n:"AlRuns"},4177:{n:"BRAI"},4187:{n:"SerAuxErrBar"},4188:{n:"ClrtClient",f:Fs},4189:{n:"SerFmt"},4191:{n:"Chart3DBarShape"},4192:{n:"Fbi"},4193:{n:"BopPop"},4194:{n:"AxcExt"},4195:{n:"Dat"},4196:{n:"PlotGrowth"},4197:{n:"SIIndex"},4198:{n:"GelFrame"},4199:{n:"BopPopCustom"},4200:{n:"Fbi2"},0:{n:"Dimensions",f:$i},2:{n:"BIFF2INT",f:Ys},5:{n:"BoolErr",f:is},7:{n:"String",f:Zs},8:{n:"BIFF2ROW"},11:{n:"Index"},22:{n:"ExternCount",f:Hn},30:{n:"BIFF2FORMAT",f:Yi},31:{n:"BIFF2FMTCNT"},32:{n:"BIFF2COLINFO"},33:{n:"Array",f:bs},37:{n:"DefaultRowHeight",f:Ni},50:{n:"BIFF2FONTXTRA",f:Qs},52:{n:"DDEObjName"},62:{n:"BIFF2WINDOW2"},67:{n:"BIFF2XF"},69:{n:"BIFF2FONTCLR"},86:{n:"BIFF4FMTCNT"},126:{n:"RK"},127:{n:"ImData",f:Xs},135:{n:"Addin"},136:{n:"Edg"},137:{n:"Pub"},145:{n:"Sub"},148:{n:"LHRecord"},149:{n:"LHNGraph"},150:{n:"Sound"},169:{n:"CoordList"},171:{n:"GCW"},188:{n:"ShrFmla"},191:{n:"ToolbarHdr"},192:{n:"ToolbarEnd"},194:{n:"AddMenu"},195:{n:"DelMenu"},214:{n:"RString",f:Js},223:{n:"UDDesc"},234:{n:"TabIdConf"},354:{n:"XL5Modify"},421:{n:"FileSharing2"},521:{n:"BOF",f:Si},536:{n:"Lbl",f:ds},547:{n:"ExternName",f:hs},561:{n:"Font"},579:{n:"BIFF3XF"},1033:{n:"BOF",f:Si},1091:{n:"BIFF4XF"},2157:{n:"FeatInfo"},2163:{n:"FeatInfo11"},2177:{n:"SXAddl12"},2240:{n:"AutoWebPub"},2241:{n:"ListObj"},2242:{n:"ListField"},2243:{n:"ListDV"},2244:{n:"ListCondFmt"},2245:{n:"ListCF"},2246:{n:"FMQry"},2247:{n:"FMSQry"},2248:{n:"PLV"},2249:{n:"LnExt"},2250:{n:"MkrExt"},2251:{n:"CrtCoopt"},2262:{n:"FRTArchId$",r:12},29282:{}};var pv=K(dv,"n");function vv(e,r,t,a){var n=+r||+pv[r];if(isNaN(n))return;var i=a||(t||[]).length||0;var s=e.next(4);s._W(2,n);s._W(2,i);if(i>0&&Ir(t))e.push(t)}function gv(e,r,t){if(!e)e=Gr(7);e._W(2,r);e._W(2,t);e._W(2,0);e._W(1,0);return e}function mv(e,r,t,a){var n=Gr(9);gv(n,e,r);if(a=="e"){n._W(1,t);n._W(1,1)}else{n._W(1,t?1:0);n._W(1,0)}return n}function bv(e,r,t){var a=Gr(8+2*t.length);gv(a,e,r);a._W(1,t.length);a._W(t.length,t,"sbcs");return a.l<a.length?a.slice(0,a.l):a}function wv(e,r,t,a){if(r.v!=null)switch(r.t){case"d":;case"n":var n=r.t=="d"?ee(ie(r.v)):r.v;if(n==(n|0)&&n>=0&&n<65536)vv(e,2,$s(t,a,n));else vv(e,3,Ks(t,a,n));return;case"b":;case"e":vv(e,5,mv(t,a,r.v,r.t));return;case"s":;case"str":vv(e,4,bv(t,a,r.v));return;}vv(e,1,gv(null,t,a))}function Cv(e,r,t,a){var n=Array.isArray(r);var i=pt(r["!ref"]||"A1"),s,f="",o=[];if(i.e.c>255||i.e.r>16383){if(a.WTF)throw new Error("Range "+(r["!ref"]||"A1")+" exceeds format limit A1:IV16384");i.e.c=Math.min(i.e.c,255);i.e.r=Math.min(i.e.c,16383);s=dt(i)}for(var l=i.s.r;l<=i.e.r;++l){f=tt(l);for(var c=i.s.c;c<=i.e.c;++c){if(l===i.s.r)o[c]=st(c);s=o[c]+f;var h=n?(r[l]||[])[c]:r[s];if(!h)continue;wv(e,h,l,c,a)}}}function Ev(e,r){var t=r||{};if(v!=null&&t.dense==null)t.dense=v;var a=Kr();var n=0;for(var i=0;i<e.SheetNames.length;++i)if(e.SheetNames[i]==t.sheet)n=i;if(n==0&&!!t.sheet&&e.SheetNames[0]!=t.sheet)throw new Error("Sheet not found: "+t.sheet);vv(a,9,Ai(e,16,t));Cv(a,e.Sheets[e.SheetNames[n]],n,t,e);vv(a,10);return a.end()}function kv(e,r,t){vv(e,"Font",Vi({sz:12,color:{theme:1},name:"Arial",family:2,scheme:"minor"},t))}function Sv(e,r,t){if(!r)return;[[5,8],[23,26],[41,44],[50,392]].forEach(function(a){for(var n=a[0];n<=a[1];++n)if(r[n]!=null)vv(e,"Format",Ki(n,r[n],t))})}function Av(e,r){var t=Gr(19);t._W(4,2151);t._W(4,0);t._W(4,0);t._W(2,3);t._W(1,1);t._W(4,0);vv(e,"FeatHdr",t);t=Gr(39);t._W(4,2152);t._W(4,0);t._W(4,0);t._W(2,3);t._W(1,0);t._W(4,0);t._W(2,1);t._W(4,4);t._W(2,0);pi(pt(r["!ref"]||"A1"),t);t._W(4,4);vv(e,"Feat",t)}function _v(e,r){for(var t=0;t<16;++t)vv(e,"XF",ts({numFmtId:0,style:true},0,r));r.cellXfs.forEach(function(t){vv(e,"XF",ts(t,0,r))})}function Bv(e,r){for(var t=0;t<r["!links"].length;++t){var a=r["!links"][t];vv(e,"HLink",xs(a));if(a[1].Tooltip)vv(e,"HLinkTooltip",Rs(a))}delete r["!links"]}function Tv(e,r,t,a,n){var i=16+Qh(n.cellXfs,r,n);if(r.v!=null)switch(r.t){case"d":;case"n":var s=r.t=="d"?ee(ie(r.v)):r.v;vv(e,"Number",os(t,a,s,i,n));return;case"b":;case"e":vv(e,517,ss(t,a,r.v,i,n,r.t));return;case"s":;case"str":vv(e,"Label",Gi(t,a,r.v,i,n));return;}vv(e,"Blank",fi(t,a,i))}function yv(e,r,t){var a=Kr();var n=t.SheetNames[e],i=t.Sheets[n]||{};var s=(t||{}).Workbook||{};var f=(s.Sheets||[])[e]||{};var o=Array.isArray(i);var l=r.biff==8;var c,h="",u=[];var d=pt(i["!ref"]||"A1");var p=l?65536:16384;if(d.e.c>255||d.e.r>=p){if(r.WTF)throw new Error("Range "+(i["!ref"]||"A1")+" exceeds format limit A1:IV16384");d.e.c=Math.min(d.e.c,255);d.e.r=Math.min(d.e.c,p-1)}vv(a,2057,Ai(t,16,r));vv(a,"CalcMode",Wn(1));vv(a,"CalcCount",Wn(100));vv(a,"CalcRefMode",Un(true));vv(a,"CalcIter",Un(false));vv(a,"CalcDelta",Gt(.001));vv(a,"CalcSaveRecalc",Un(true));vv(a,"PrintRowCol",Un(false));vv(a,"PrintGrid",Un(false));vv(a,"GridSet",Wn(1));vv(a,"Guts",ns([0,0]));vv(a,"HCenter",Un(false));vv(a,"VCenter",Un(false));vv(a,512,Zi(d,r));if(l)i["!links"]=[];for(var v=d.s.r;v<=d.e.r;++v){h=tt(v);for(var g=d.s.c;g<=d.e.c;++g){if(v===d.s.r)u[g]=st(g);c=u[g]+h;var m=o?(i[v]||[])[g]:i[c];if(!m)continue;Tv(a,m,v,g,r);if(l&&m.l)i["!links"].push([c,m.l])}}var b=f.CodeName||f.name||n;if(l&&s.Views)vv(a,"Window2",Hi(s.Views[0]));if(l&&(i["!merges"]||[]).length)vv(a,"MergeCells",Ss(i["!merges"]));if(l)Bv(a,i);vv(a,"CodeName",Zn(b,r));if(l)Av(a,i);vv(a,"EOF");return a.end()}function xv(e,r,t){var a=Kr();var n=(e||{}).Workbook||{};var i=n.Sheets||[];var s=n.WBProps||{};var f=t.biff==8,o=t.biff==5;vv(a,2057,Ai(e,5,t));if(t.bookType=="xla")vv(a,"Addin");vv(a,"InterfaceHdr",f?Wn(1200):null);vv(a,"Mms",Nn(2));if(o)vv(a,"ToolbarHdr");if(o)vv(a,"ToolbarEnd");vv(a,"InterfaceEnd");vv(a,"WriteAccess",Ti("SheetJS",t));vv(a,"CodePage",Wn(f?1200:1252));if(f)vv(a,"DSF",Wn(0));if(f)vv(a,"Excel9File");vv(a,"RRTabId",Hs(e.SheetNames.length));if(f&&e.vbaraw){vv(a,"ObProj");var l=s.CodeName||"ThisWorkbook";vv(a,"CodeName",Zn(l,t))}vv(a,"BuiltInFnGroupCount",Wn(17));vv(a,"WinProtect",Un(false));vv(a,"Protect",Un(false));vv(a,"Password",Wn(0));if(f)vv(a,"Prot4Rev",Un(false));if(f)vv(a,"Prot4RevPass",Wn(0));vv(a,"Window1",Mi(t));vv(a,"Backup",Un(false));vv(a,"HideObj",Wn(0));vv(a,"Date1904",Un(zd(e)=="true"));vv(a,"CalcPrecision",Un(true));if(f)vv(a,"RefreshAll",Un(false));vv(a,"BookBool",Wn(0));kv(a,e,t);Sv(a,e.SSF,t);_v(a,t);if(f)vv(a,"UsesELFs",Un(false));var c=a.end();var h=Kr();if(f)vv(h,"Country",Os());vv(h,"EOF");var u=h.end();var d=Kr();var p=0,v=0;for(v=0;v<e.SheetNames.length;++v)p+=(f?12:11)+(f?2:1)*e.SheetNames[v].length;var g=c.length+p+u.length;for(v=0;v<e.SheetNames.length;++v){var m=i[v]||{};vv(d,"BoundSheet8",Ii({pos:g,hs:m.Hidden||0,dt:0,name:e.SheetNames[v]},t));g+=r[v].length}var b=d.end();if(p!=b.length)throw new Error("BS8 "+p+" != "+b.length);var w=[];if(c.length)w.push(c);if(b.length)w.push(b);if(u.length)w.push(u);return cr([w])}function Iv(e,r){var t=r||{};var a=[];if(e&&!e.SSF){e.SSF=D.get_table()}if(e&&e.SSF){O(D);D.load_table(e.SSF);t.revssf=Z(e.SSF);t.revssf[e.SSF[65535]]=0;t.ssf=e.SSF}t.cellXfs=[];t.Strings=[];t.Strings.Count=0;t.Strings.Unique=0;Qh(t.cellXfs,{},{revssf:{General:0}});for(var n=0;n<e.SheetNames.length;++n)a[a.length]=yv(n,t,e);a.unshift(xv(e,a,t));return cr([a])}function Rv(e,r){var t=r||{};switch(t.biff||2){case 8:;case 5:return Iv(e,r);case 4:;case 3:;case 2:return Ev(e,r);}throw new Error("invalid type "+t.bookType+" for BIFF")}var Dv=function(){function e(e,r){var t=r||{};if(v!=null&&t.dense==null)t.dense=v;
var a=t.dense?[]:{};var n=e.match(/<table/i);if(!n)throw new Error("Invalid HTML: could not find <table>");var i=e.match(/<\/table/i);var s=n.index,f=i&&i.index||e.length;var o=ue(e.slice(s,f),/(:?<tr[^>]*>)/i,"<tr>");var l=-1,c=0,h=0,u=0;var d={s:{r:1e7,c:1e7},e:{r:0,c:0}};var p=[];for(s=0;s<o.length;++s){var g=o[s].trim();var m=g.slice(0,3).toLowerCase();if(m=="<tr"){++l;if(t.sheetRows&&t.sheetRows<=l){--l;break}c=0;continue}if(m!="<td"&&m!="<th")continue;var b=g.split(/<\/t[dh]>/i);for(f=0;f<b.length;++f){var w=b[f].trim();if(!w.match(/<t[dh]/i))continue;var C=w,E=0;while(C.charAt(0)=="<"&&(E=C.indexOf(">"))>-1)C=C.slice(E+1);var k=ye(w.slice(0,w.indexOf(">")));u=k.colspan?+k.colspan:1;if((h=+k.rowspan)>1||u>1)p.push({s:{r:l,c:c},e:{r:l+(h||1)-1,c:c+u-1}});var S=k.t||"";if(!C.length){c+=u;continue}C=$e(C);if(d.s.r>l)d.s.r=l;if(d.e.r<l)d.e.r=l;if(d.s.c>c)d.s.c=c;if(d.e.c<c)d.e.c=c;if(!C.length)continue;var A={t:"s",v:C};if(t.raw||!C.trim().length||S=="s"){}else if(C==="TRUE")A={t:"b",v:true};else if(C==="FALSE")A={t:"b",v:false};else if(!isNaN(le(C)))A={t:"n",v:le(C)};else if(!isNaN(ce(C).getDate())){A={t:"d",v:ie(C)};if(!t.cellDates)A={t:"n",v:ee(A.v)};A.z=t.dateNF||D._table[14]}if(t.dense){if(!a[l])a[l]=[];a[l][c]=A}else a[ht({r:l,c:c})]=A;c+=u}}a["!ref"]=dt(d);return a}function r(r,t){return mt(e(r,t),t)}function t(e,r,t,a){var n=e["!merges"]||[];var i=[];for(var s=r.s.c;s<=r.e.c;++s){var f=0,o=0;for(var l=0;l<n.length;++l){if(n[l].s.r>t||n[l].s.c>s)continue;if(n[l].e.r<t||n[l].e.c<s)continue;if(n[l].s.r<t||n[l].s.c<s){f=-1;break}f=n[l].e.r-n[l].s.r+1;o=n[l].e.c-n[l].s.c+1;break}if(f<0)continue;var c=ht({r:t,c:s});var h=a.dense?(e[t]||[])[s]:e[c];var u={};if(f>1)u.rowspan=f;if(o>1)u.colspan=o;var d=h&&h.v!=null&&(h.h||Me(h.w||(gt(h),h.w)||""))||"";u.t=h&&h.t||"z";if(a.editable)d='<span contenteditable="true">'+d+"</span>";u.id="sjs-"+c;i.push(ar("td",d,u))}var p="<tr>";return p+i.join("")+"</tr>"}function a(e,r,t){var a=[];return a.join("")+"<table"+(t&&t.id?' id="'+t.id+'"':"")+">"}var n='<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';var i="</body></html>";function s(e,r){var s=r||{};var f=s.header!=null?s.header:n;var o=s.footer!=null?s.footer:i;var l=[f];var c=ut(e["!ref"]);s.dense=Array.isArray(e);l.push(a(e,c,s));for(var h=c.s.r;h<=c.e.r;++h)l.push(t(e,c,h,s));l.push("</table>"+o);return l.join("")}return{to_workbook:r,to_sheet:e,_row:t,BEGIN:n,END:i,_preamble:a,from_sheet:s}}();function Ov(e,r){var t=r||{};if(v!=null)t.dense=v;var a=t.dense?[]:{};var n=e.getElementsByTagName("tr");var i=t.sheetRows||1e7;var s={s:{r:0,c:0},e:{r:0,c:0}};var f=[],o=0;var l=[];var c=0,h=0,u,d,p,g;for(;c<n.length&&h<i;++c){var m=n[c];if(Pv(m)){if(t.display)continue;l[h]={hidden:true}}var b=m.children;for(u=d=0;u<b.length;++u){var w=b[u];if(t.display&&Pv(w))continue;var C=$e(w.innerHTML);for(o=0;o<f.length;++o){var E=f[o];if(E.s.c==d&&E.s.r<=h&&h<=E.e.r){d=E.e.c+1;o=-1}}g=+w.getAttribute("colspan")||1;if((p=+w.getAttribute("rowspan"))>0||g>1)f.push({s:{r:h,c:d},e:{r:h+(p||1)-1,c:d+g-1}});var k={t:"s",v:C};var S=w.getAttribute("t")||"";if(C!=null){if(C.length==0)k.t=S||"z";else if(t.raw||C.trim().length==0||S=="s"){}else if(C==="TRUE")k={t:"b",v:true};else if(C==="FALSE")k={t:"b",v:false};else if(!isNaN(le(C)))k={t:"n",v:le(C)};else if(!isNaN(ce(C).getDate())){k={t:"d",v:ie(C)};if(!t.cellDates)k={t:"n",v:ee(k.v)};k.z=t.dateNF||D._table[14]}}if(t.dense){if(!a[h])a[h]=[];a[h][d]=k}else a[ht({c:d,r:h})]=k;if(s.e.c<d)s.e.c=d;d+=g}++h}if(f.length)a["!merges"]=f;if(l.length)a["!rows"]=l;s.e.r=h-1;a["!ref"]=dt(s);if(h>=i)a["!fullref"]=dt((s.e.r=n.length-c+h-1,s));return a}function Fv(e,r){return mt(Ov(e,r),r)}function Pv(e){var r="";var t=Nv(e);if(t)r=t(e).getPropertyValue("display");if(!r)r=e.style.display;return r==="none"}function Nv(e){if(e.ownerDocument.defaultView&&typeof e.ownerDocument.defaultView.getComputedStyle==="function")return e.ownerDocument.defaultView.getComputedStyle;if(typeof getComputedStyle==="function")return getComputedStyle;return null}var Lv=function(){var e=function(e){return De(e.replace(/[\t\r\n]/g," ").trim().replace(/ +/g," ").replace(/<text:s\/>/g," ").replace(/<text:s text:c="(\d+)"\/>/g,function(e,r){return Array(parseInt(r,10)+1).join(" ")}).replace(/<text:tab[^>]*\/>/g,"\t").replace(/<text:line-break\/>/g,"\n").replace(/<[^>]*>/g,""))};var r={day:["d","dd"],month:["m","mm"],year:["y","yy"],hours:["h","hh"],minutes:["m","mm"],seconds:["s","ss"],"am-pm":["A/P","AM/PM"],"day-of-week":["ddd","dddd"],era:["e","ee"],quarter:["\\Qm",'m\\"th quarter"']};return function t(a,n){var i=n||{};if(v!=null&&i.dense==null)i.dense=v;var s=Mp(a);var f=[],o;var l;var c={name:""},h="",u=0;var d;var p;var g={},m=[];var b=i.dense?[]:{};var w,C;var E={value:""};var k="",S=0,A;var _=-1,B=-1,T={s:{r:1e6,c:1e7},e:{r:0,c:0}};var y=0;var x={};var I=[],R={},D=0,O=0;var F=[],P=1,N=1;var L=[];var M={Names:[]};var U={};var H=["",""];var W=[],V={};var z="",X=0;var G=false,j=false;var K=0;Up.lastIndex=0;s=s.replace(/<!--([\s\S]*?)-->/gm,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");while(w=Up.exec(s))switch(w[3]=w[3].replace(/_.*$/,"")){case"table":;case"工作表":if(w[1]==="/"){if(T.e.c>=T.s.c&&T.e.r>=T.s.r)b["!ref"]=dt(T);if(i.sheetRows>0&&i.sheetRows<=T.e.r){b["!fullref"]=b["!ref"];T.e.r=i.sheetRows-1;b["!ref"]=dt(T)}if(I.length)b["!merges"]=I;if(F.length)b["!rows"]=F;d.name=d["名称"]||d.name;if(typeof JSON!=="undefined")JSON.stringify(d);m.push(d.name);g[d.name]=b;j=false}else if(w[0].charAt(w[0].length-2)!=="/"){d=ye(w[0],false);_=B=-1;T.s.r=T.s.c=1e7;T.e.r=T.e.c=0;b=i.dense?[]:{};I=[];F=[];j=true}break;case"table-row-group":if(w[1]==="/")--y;else++y;break;case"table-row":;case"行":if(w[1]==="/"){_+=P;P=1;break}p=ye(w[0],false);if(p["行号"])_=p["行号"]-1;else if(_==-1)_=0;P=+p["number-rows-repeated"]||1;if(P<10)for(K=0;K<P;++K)if(y>0)F[_+K]={level:y};B=-1;break;case"covered-table-cell":++B;if(i.sheetStubs){if(i.dense){if(!b[_])b[_]=[];b[_][B]={t:"z"}}else b[ht({r:_,c:B})]={t:"z"}}break;case"table-cell":;case"数据":if(w[0].charAt(w[0].length-2)==="/"){++B;E=ye(w[0],false);N=parseInt(E["number-columns-repeated"]||"1",10);C={t:"z",v:null};if(E.formula&&i.cellFormula!=false)C.f=Wh(De(E.formula));if((E["数据类型"]||E["value-type"])=="string"){C.t="s";C.v=De(E["string-value"]||"");if(i.dense){if(!b[_])b[_]=[];b[_][B]=C}else{b[ht({r:_,c:B})]=C}}B+=N-1}else if(w[1]!=="/"){++B;N=1;var Y=P?_+P-1:_;if(B>T.e.c)T.e.c=B;if(B<T.s.c)T.s.c=B;if(_<T.s.r)T.s.r=_;if(Y>T.e.r)T.e.r=Y;E=ye(w[0],false);W=[];V={};C={t:E["数据类型"]||E["value-type"],v:null};if(i.cellFormula){if(E.formula)E.formula=De(E.formula);if(E["number-matrix-columns-spanned"]&&E["number-matrix-rows-spanned"]){D=parseInt(E["number-matrix-rows-spanned"],10)||0;O=parseInt(E["number-matrix-columns-spanned"],10)||0;R={s:{r:_,c:B},e:{r:_+D-1,c:B+O-1}};C.F=dt(R);L.push([R,C.F])}if(E.formula)C.f=Wh(E.formula);else for(K=0;K<L.length;++K)if(_>=L[K][0].s.r&&_<=L[K][0].e.r)if(B>=L[K][0].s.c&&B<=L[K][0].e.c)C.F=L[K][1]}if(E["number-columns-spanned"]||E["number-rows-spanned"]){D=parseInt(E["number-rows-spanned"],10)||0;O=parseInt(E["number-columns-spanned"],10)||0;R={s:{r:_,c:B},e:{r:_+D-1,c:B+O-1}};I.push(R)}if(E["number-columns-repeated"])N=parseInt(E["number-columns-repeated"],10);switch(C.t){case"boolean":C.t="b";C.v=Ve(E["boolean-value"]);break;case"float":C.t="n";C.v=parseFloat(E.value);break;case"percentage":C.t="n";C.v=parseFloat(E.value);break;case"currency":C.t="n";C.v=parseFloat(E.value);break;case"date":C.t="d";C.v=ie(E["date-value"]);if(!i.cellDates){C.t="n";C.v=ee(C.v)}C.z="m/d/yy";break;case"time":C.t="n";C.v=te(E["time-value"])/86400;break;case"number":C.t="n";C.v=parseFloat(E["数据数值"]);break;default:if(C.t==="string"||C.t==="text"||!C.t){C.t="s";if(E["string-value"]!=null)k=De(E["string-value"])}else throw new Error("Unsupported value type "+C.t);}}else{G=false;if(C.t==="s"){C.v=k||"";G=S==0}if(U.Target)C.l=U;if(W.length>0){C.c=W;W=[]}if(k&&i.cellText!==false)C.w=k;if(!G||i.sheetStubs){if(!(i.sheetRows&&i.sheetRows<=_)){for(var $=0;$<P;++$){N=parseInt(E["number-columns-repeated"]||"1",10);if(i.dense){if(!b[_+$])b[_+$]=[];b[_+$][B]=$==0?C:fe(C);while(--N>0)b[_+$][B+N]=fe(C)}else{b[ht({r:_+$,c:B})]=C;while(--N>0)b[ht({r:_+$,c:B+N})]=fe(C)}if(T.e.c<=B)T.e.c=B}}}N=parseInt(E["number-columns-repeated"]||"1",10);B+=N-1;N=0;C={};k=""}U={};break;case"document":;case"document-content":;case"电子表格文档":;case"spreadsheet":;case"主体":;case"scripts":;case"styles":;case"font-face-decls":if(w[1]==="/"){if((o=f.pop())[0]!==w[3])throw"Bad state: "+o}else if(w[0].charAt(w[0].length-2)!=="/")f.push([w[3],true]);break;case"annotation":if(w[1]==="/"){if((o=f.pop())[0]!==w[3])throw"Bad state: "+o;V.t=k;V.a=z;W.push(V)}else if(w[0].charAt(w[0].length-2)!=="/"){f.push([w[3],false])}z="";X=0;k="";S=0;break;case"creator":if(w[1]==="/"){z=s.slice(X,w.index)}else X=w.index+w[0].length;break;case"meta":;case"元数据":;case"settings":;case"config-item-set":;case"config-item-map-indexed":;case"config-item-map-entry":;case"config-item-map-named":;case"shapes":;case"frame":;case"text-box":;case"image":;case"data-pilot-tables":;case"list-style":;case"form":;case"dde-links":;case"event-listeners":;case"chart":if(w[1]==="/"){if((o=f.pop())[0]!==w[3])throw"Bad state: "+o}else if(w[0].charAt(w[0].length-2)!=="/")f.push([w[3],false]);k="";S=0;break;case"scientific-number":break;case"currency-symbol":break;case"currency-style":break;case"number-style":;case"percentage-style":;case"date-style":;case"time-style":if(w[1]==="/"){x[c.name]=h;if((o=f.pop())[0]!==w[3])throw"Bad state: "+o}else if(w[0].charAt(w[0].length-2)!=="/"){h="";c=ye(w[0],false);f.push([w[3],true])}break;case"script":break;case"libraries":break;case"automatic-styles":break;case"master-styles":break;case"default-style":;case"page-layout":break;case"style":break;case"map":break;case"font-face":break;case"paragraph-properties":break;case"table-properties":break;case"table-column-properties":break;case"table-row-properties":break;case"table-cell-properties":break;case"number":switch(f[f.length-1][0]){case"time-style":;case"date-style":l=ye(w[0],false);h+=r[w[3]][l.style==="long"?1:0];break;}break;case"fraction":break;case"day":;case"month":;case"year":;case"era":;case"day-of-week":;case"week-of-year":;case"quarter":;case"hours":;case"minutes":;case"seconds":;case"am-pm":switch(f[f.length-1][0]){case"time-style":;case"date-style":l=ye(w[0],false);h+=r[w[3]][l.style==="long"?1:0];break;}break;case"boolean-style":break;case"boolean":break;case"text-style":break;case"text":if(w[0].slice(-2)==="/>")break;else if(w[1]==="/")switch(f[f.length-1][0]){case"number-style":;case"date-style":;case"time-style":h+=s.slice(u,w.index);break;}else u=w.index+w[0].length;break;case"named-range":l=ye(w[0],false);H=zh(l["cell-range-address"]);var Z={Name:l.name,Ref:H[0]+"!"+H[1]};if(j)Z.Sheet=m.length;M.Names.push(Z);break;case"text-content":break;case"text-properties":break;case"embedded-text":break;case"body":;case"电子表格":break;case"forms":break;case"table-column":break;case"table-header-rows":break;case"table-rows":break;case"table-column-group":break;case"table-header-columns":break;case"table-columns":break;case"null-date":break;case"graphic-properties":break;case"calculation-settings":break;case"named-expressions":break;case"label-range":break;case"label-ranges":break;case"named-expression":break;case"sort":break;case"sort-by":break;case"sort-groups":break;case"tab":break;case"line-break":break;case"span":break;case"p":;case"文本串":if(w[1]==="/"&&(!E||!E["string-value"]))k=(k.length>0?k+"\n":"")+e(s.slice(S,w.index),A);else{A=ye(w[0],false);S=w.index+w[0].length}break;case"s":break;case"database-range":if(w[1]==="/")break;try{H=zh(ye(w[0])["target-range-address"]);g[H[0]]["!autofilter"]={ref:H[1]}}catch(Q){}break;case"date":break;case"object":break;case"title":;case"标题":break;case"desc":break;case"binary-data":break;case"table-source":break;case"scenario":break;case"iteration":break;case"content-validations":break;case"content-validation":break;case"help-message":break;case"error-message":break;case"database-ranges":break;case"filter":break;case"filter-and":break;case"filter-or":break;case"filter-condition":break;case"list-level-style-bullet":break;case"list-level-style-number":break;case"list-level-properties":break;case"sender-firstname":;case"sender-lastname":;case"sender-initials":;case"sender-title":;case"sender-position":;case"sender-email":;case"sender-phone-private":;case"sender-fax":;case"sender-company":;case"sender-phone-work":;case"sender-street":;case"sender-city":;case"sender-postal-code":;case"sender-country":;case"sender-state-or-province":;case"author-name":;case"author-initials":;case"chapter":;case"file-name":;case"template-name":;case"sheet-name":break;case"event-listener":break;case"initial-creator":;case"creation-date":;case"print-date":;case"generator":;case"document-statistic":;case"user-defined":;case"editing-duration":;case"editing-cycles":break;case"config-item":break;case"page-number":break;case"page-count":break;case"time":break;case"cell-range-source":break;case"detective":break;case"operation":break;case"highlighted-range":break;case"data-pilot-table":;case"source-cell-range":;case"source-service":;case"data-pilot-field":;case"data-pilot-level":;case"data-pilot-subtotals":;case"data-pilot-subtotal":;case"data-pilot-members":;case"data-pilot-member":;case"data-pilot-display-info":;case"data-pilot-sort-info":;case"data-pilot-layout-info":;case"data-pilot-field-reference":;case"data-pilot-groups":;case"data-pilot-group":;case"data-pilot-group-member":break;case"rect":break;case"dde-connection-decls":;case"dde-connection-decl":;case"dde-link":;case"dde-source":break;case"properties":break;case"property":break;case"a":if(w[1]!=="/"){U=ye(w[0],false);if(!U.href)break;U.Target=U.href;delete U.href;if(U.Target.charAt(0)=="#"&&U.Target.indexOf(".")>-1){H=zh(U.Target.slice(1));U.Target="#"+H[0]+"!"+H[1]}}break;case"table-protection":break;case"data-pilot-grand-total":break;case"office-document-common-attrs":break;default:switch(w[2]){case"dc:":;case"calcext:":;case"loext:":;case"ooo:":;case"chartooo:":;case"draw:":;case"style:":;case"chart:":;case"form:":;case"uof:":;case"表:":;case"字:":break;default:if(i.WTF)throw new Error(w);};}var J={Sheets:g,SheetNames:m,Workbook:M};if(i.bookSheets)delete J.Sheets;return J}}();function Mv(e,r){r=r||{};var t=!!ge(e,"objectdata");if(t)Ma(be(e,"META-INF/manifest.xml"),r);var a=we(e,"content.xml");if(!a)throw new Error("Missing content.xml in "+(t?"ODS":"UOF")+" file");var n=Lv(t?a:ze(a),r);if(ge(e,"meta.xml"))n.Props=ja(be(e,"meta.xml"));return n}function Uv(e,r){return Lv(e,r)}var Hv=function(){var e="<office:document-styles "+tr({"xmlns:office":"urn:oasis:names:tc:opendocument:xmlns:office:1.0","xmlns:table":"urn:oasis:names:tc:opendocument:xmlns:table:1.0","xmlns:style":"urn:oasis:names:tc:opendocument:xmlns:style:1.0","xmlns:text":"urn:oasis:names:tc:opendocument:xmlns:text:1.0","xmlns:draw":"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0","xmlns:fo":"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:number":"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0","xmlns:svg":"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0","xmlns:of":"urn:oasis:names:tc:opendocument:xmlns:of:1.2","office:version":"1.2"})+"></office:document-styles>";return function r(){return Se+e}}();var Wv=function(){var e=function(e){return Pe(e).replace(/  +/g,function(e){return'<text:s text:c="'+e.length+'"/>'}).replace(/\t/g,"<text:tab/>").replace(/\n/g,"<text:line-break/>").replace(/^ /,"<text:s/>").replace(/ $/,"<text:s/>")};var r="          <table:table-cell />\n";var t="          <table:covered-table-cell/>\n";var a=function(a,n,i){var s=[];s.push('      <table:table table:name="'+Pe(n.SheetNames[i])+'">\n');var f=0,o=0,l=ut(a["!ref"]);var c=a["!merges"]||[],h=0;var u=Array.isArray(a);for(f=0;f<l.s.r;++f)s.push("        <table:table-row></table:table-row>\n");for(;f<=l.e.r;++f){s.push("        <table:table-row>\n");for(o=0;o<l.s.c;++o)s.push(r);for(;o<=l.e.c;++o){var d=false,p={},v="";for(h=0;h!=c.length;++h){if(c[h].s.c>o)continue;if(c[h].s.r>f)continue;if(c[h].e.c<o)continue;if(c[h].e.r<f)continue;if(c[h].s.c!=o||c[h].s.r!=f)d=true;p["table:number-columns-spanned"]=c[h].e.c-c[h].s.c+1;p["table:number-rows-spanned"]=c[h].e.r-c[h].s.r+1;break}if(d){s.push(t);continue}var g=ht({r:f,c:o}),m=u?(a[f]||[])[o]:a[g];if(m&&m.f){p["table:formula"]=Pe(Vh(m.f));if(m.F){if(m.F.slice(0,g.length)==g){var b=ut(m.F);p["table:number-matrix-columns-spanned"]=b.e.c-b.s.c+1;p["table:number-matrix-rows-spanned"]=b.e.r-b.s.r+1}}}if(!m){s.push(r);continue}switch(m.t){case"b":v=m.v?"TRUE":"FALSE";p["office:value-type"]="boolean";p["office:boolean-value"]=m.v?"true":"false";break;case"n":v=m.w||String(m.v||0);p["office:value-type"]="float";p["office:value"]=m.v||0;break;case"s":;case"str":v=m.v;p["office:value-type"]="string";break;case"d":v=m.w||ie(m.v).toISOString();p["office:value-type"]="date";p["office:date-value"]=ie(m.v).toISOString();p["table:style-name"]="ce1";break;default:s.push(r);continue;}var w=e(v);if(m.l&&m.l.Target){var C=m.l.Target;C=C.charAt(0)=="#"?"#"+Xh(C.slice(1)):C;w=ar("text:a",w,{"xlink:href":C})}s.push("          "+ar("table:table-cell",ar("text:p",w,{}),p)+"\n")}s.push("        </table:table-row>\n")}s.push("      </table:table>\n");return s.join("")};var n=function(e){e.push(" <office:automatic-styles>\n");e.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');e.push('   <number:month number:style="long"/>\n');e.push("   <number:text>/</number:text>\n");e.push('   <number:day number:style="long"/>\n');e.push("   <number:text>/</number:text>\n");e.push("   <number:year/>\n");e.push("  </number:date-style>\n");e.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');e.push(" </office:automatic-styles>\n")};return function i(e,r){var t=[Se];var i=tr({"xmlns:office":"urn:oasis:names:tc:opendocument:xmlns:office:1.0","xmlns:table":"urn:oasis:names:tc:opendocument:xmlns:table:1.0","xmlns:style":"urn:oasis:names:tc:opendocument:xmlns:style:1.0","xmlns:text":"urn:oasis:names:tc:opendocument:xmlns:text:1.0","xmlns:draw":"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0","xmlns:fo":"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:meta":"urn:oasis:names:tc:opendocument:xmlns:meta:1.0","xmlns:number":"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0","xmlns:presentation":"urn:oasis:names:tc:opendocument:xmlns:presentation:1.0","xmlns:svg":"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0","xmlns:chart":"urn:oasis:names:tc:opendocument:xmlns:chart:1.0","xmlns:dr3d":"urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0","xmlns:math":"http://www.w3.org/1998/Math/MathML","xmlns:form":"urn:oasis:names:tc:opendocument:xmlns:form:1.0","xmlns:script":"urn:oasis:names:tc:opendocument:xmlns:script:1.0","xmlns:ooo":"http://openoffice.org/2004/office","xmlns:ooow":"http://openoffice.org/2004/writer","xmlns:oooc":"http://openoffice.org/2004/calc","xmlns:dom":"http://www.w3.org/2001/xml-events","xmlns:xforms":"http://www.w3.org/2002/xforms","xmlns:xsd":"http://www.w3.org/2001/XMLSchema","xmlns:xsi":"http://www.w3.org/2001/XMLSchema-instance","xmlns:sheet":"urn:oasis:names:tc:opendocument:sh33tjs:1.0","xmlns:rpt":"http://openoffice.org/2005/report","xmlns:of":"urn:oasis:names:tc:opendocument:xmlns:of:1.2","xmlns:xhtml":"http://www.w3.org/1999/xhtml","xmlns:grddl":"http://www.w3.org/2003/g/data-view#","xmlns:tableooo":"http://openoffice.org/2009/table","xmlns:drawooo":"http://openoffice.org/2010/draw","xmlns:calcext":"urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0","xmlns:loext":"urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0","xmlns:field":"urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0","xmlns:formx":"urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0","xmlns:css3t":"http://www.w3.org/TR/css3-text/","office:version":"1.2"});var s=tr({"xmlns:config":"urn:oasis:names:tc:opendocument:xmlns:config:1.0","office:mimetype":"application/vnd.oasis.opendocument.spreadsheet"});if(r.bookType=="fods")t.push("<office:document"+i+s+">\n");else t.push("<office:document-content"+i+">\n");n(t);t.push("  <office:body>\n");t.push("    <office:spreadsheet>\n");for(var f=0;f!=e.SheetNames.length;++f)t.push(a(e.Sheets[e.SheetNames[f]],e,f,r));t.push("    </office:spreadsheet>\n");t.push("  </office:body>\n");if(r.bookType=="fods")t.push("</office:document>");else t.push("</office:document-content>");return t.join("")}}();function Vv(e,r){if(r.bookType=="fods")return Wv(e,r);var t=new Ee;var a="";var n=[];var i=[];a="mimetype";t.file(a,"application/vnd.oasis.opendocument.spreadsheet");a="content.xml";t.file(a,Wv(e,r));n.push([a,"text/xml"]);i.push([a,"ContentFile"]);a="styles.xml";t.file(a,Hv(e,r));n.push([a,"text/xml"]);i.push([a,"StylesFile"]);a="meta.xml";t.file(a,za());n.push([a,"text/xml"]);i.push([a,"MetadataFile"]);a="manifest.rdf";t.file(a,Va(i));n.push([a,"application/rdf+xml"]);a="META-INF/manifest.xml";t.file(a,Ua(n));return t}function zv(e,r){if(!r)return 0;var t=e.SheetNames.indexOf(r);if(t==-1)throw new Error("Sheet not found: "+r);return t}function Xv(e){return function r(t,a){var n=zv(t,a.sheet);return e.from_sheet(t.Sheets[t.SheetNames[n]],a,t)}}var Gv=Xv(Dv);var jv=Xv({from_sheet:Fg});var Kv=Xv(ef);var Yv=Xv(rf);var $v=Xv(af);var Zv=Xv(jf);var Qv=Xv({from_sheet:Pg});var Jv=Xv(qs);var qv=Xv(tf);function eg(e){return function r(t){for(var a=0;a!=e.length;++a){var n=e[a];if(t[n[0]]===undefined)t[n[0]]=n[1];if(n[2]==="n")t[n[0]]=Number(t[n[0]])}}}var rg=eg([["cellNF",false],["cellHTML",true],["cellFormula",true],["cellStyles",false],["cellText",true],["cellDates",false],["sheetStubs",false],["sheetRows",0,"n"],["bookDeps",false],["bookSheets",false],["bookProps",false],["bookFiles",false],["bookVBA",false],["password",""],["WTF",false]]);var tg=eg([["cellDates",false],["bookSST",false],["bookType","xlsx"],["compression",false],["WTF",false]]);function ag(e){if(Ra.WS.indexOf(e)>-1)return"sheet";if(Ra.CS&&e==Ra.CS)return"chart";if(Ra.DS&&e==Ra.DS)return"dialog";if(Ra.MS&&e==Ra.MS)return"macro";return e&&e.length?e:"sheet"}function ng(e,r){if(!e)return 0;try{e=r.map(function a(r){if(!r.id)r.id=r.strRelID;return[r.name,e["!id"][r.id].Target,ag(e["!id"][r.id].Type)]})}catch(t){return null}return!e||e.length===0?null:e}function ig(e,r,t,a,n,i,s,f,o,l,c,h){try{i[a]=Oa(we(e,t,true),r);var u=be(e,r);var d;switch(f){case"sheet":d=hp(u,r,n,o,i[a],l,c,h);break;case"chart":d=up(u,r,n,o,i[a],l,c,h);if(!d||!d["!chart"])break;var p=ke(d["!chart"].Target,r);var v=Da(p);var g=kl(we(e,p,true),Oa(we(e,v,true),p));var m=ke(g,p);var b=Da(m);d=xd(we(e,m,true),m,o,Oa(we(e,b,true),m),l,d);break;case"macro":d=dp(u,r,n,o,i[a],l,c,h);break;case"dialog":d=pp(u,r,n,o,i[a],l,c,h);break;}s[a]=d}catch(w){if(o.WTF)throw w}}function sg(e){return e.charAt(0)=="/"?e.slice(1):e}function fg(e,r){O(D);r=r||{};rg(r);if(ge(e,"META-INF/manifest.xml"))return Mv(e,r);if(ge(e,"objectdata.xml"))return Mv(e,r);if(ge(e,"Index/Document.iwa"))throw new Error("Unsupported NUMBERS file");var t=Ce(e);var a=Ta(we(e,"[Content_Types].xml"));var n=false;var i,s;if(a.workbooks.length===0){s="xl/workbook.xml";if(be(e,s,true))a.workbooks.push(s)}if(a.workbooks.length===0){s="xl/workbook.bin";if(!be(e,s,true))throw new Error("Could not find workbook");a.workbooks.push(s);n=true}if(a.workbooks[0].slice(-3)=="bin")n=true;var f={};var o={};if(!r.bookSheets&&!r.bookProps){Gh=[];if(a.sst)try{Gh=mp(be(e,sg(a.sst)),a.sst,r)}catch(l){if(r.WTF)throw l}if(r.cellStyles&&a.themes.length)f=gp(we(e,a.themes[0].replace(/^\//,""),true)||"",a.themes[0],r);if(a.style)o=vp(be(e,sg(a.style)),a.style,f,r)}a.links.map(function(t){return Cp(be(e,sg(t)),t,r)});var c=cp(be(e,sg(a.workbooks[0])),a.workbooks[0],r);var h={},u="";if(a.coreprops.length){u=be(e,sg(a.coreprops[0]),true);if(u)h=ja(u);if(a.extprops.length!==0){u=be(e,sg(a.extprops[0]),true);if(u)qa(u,h,r)}}var d={};if(!r.bookSheets||r.bookProps){if(a.custprops.length!==0){u=we(e,sg(a.custprops[0]),true);if(u)d=an(u,r)}}var p={};if(r.bookSheets||r.bookProps){if(c.Sheets)i=c.Sheets.map(function y(e){return e.name});else if(h.Worksheets&&h.SheetNames.length>0)i=h.SheetNames;if(r.bookProps){p.Props=h;p.Custprops=d}if(r.bookSheets&&typeof i!=="undefined")p.SheetNames=i;if(r.bookSheets?p.SheetNames:r.bookProps)return p}i={};var v={};if(r.bookDeps&&a.calcchain)v=wp(be(e,sg(a.calcchain)),a.calcchain,r);var g=0;var m={};var b,w;{var C=c.Sheets;h.Worksheets=C.length;h.SheetNames=[];for(var E=0;E!=C.length;++E){h.SheetNames[E]=C[E].name}}var k=n?"bin":"xml";var S=a.workbooks[0].lastIndexOf("/");var A=(a.workbooks[0].slice(0,S+1)+"_rels/"+a.workbooks[0].slice(S+1)+".rels").replace(/^\//,"");if(!ge(e,A))A="xl/_rels/workbook."+k+".rels";var _=Oa(we(e,A,true),A);if(_)_=ng(_,c.Sheets);var B=be(e,"xl/worksheets/sheet.xml",true)?1:0;for(g=0;g!=h.Worksheets;++g){var T="sheet";if(_&&_[g]){b="xl/"+_[g][1].replace(/[\/]?xl\//,"");if(!ge(e,b))b=_[g][1];if(!ge(e,b))b=A.replace(/_rels\/.*$/,"")+_[g][1];T=_[g][2]}else{b="xl/worksheets/sheet"+(g+1-B)+"."+k;b=b.replace(/sheet0\./,"sheet.")}w=b.replace(/^(.*)(\/)([^\/]*)$/,"$1/_rels/$3.rels");ig(e,b,w,h.SheetNames[g],g,m,i,T,r,c,f,o)}if(a.comments)_l(e,a.comments,i,m,r);p={Directory:a,Workbook:c,Props:h,Custprops:d,Deps:v,Sheets:i,SheetNames:h.SheetNames,Strings:Gh,Styles:o,Themes:f,SSF:D.get_table()};if(r.bookFiles){p.keys=t;p.files=e.files}if(r.bookVBA){if(a.vba.length>0)p.vbaraw=be(e,sg(a.vba[0]),true);else if(a.defaults&&a.defaults.bin===Nl)p.vbaraw=be(e,"xl/vbaProject.bin",true)}return p}function og(e,r){var t=r||{};var a="Workbook",n=W.find(e,a);try{a="/!DataSpaces/Version";n=W.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);_f(n.content);a="/!DataSpaces/DataSpaceMap";n=W.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);var i=Tf(n.content);if(i.length!==1||i[0].comps.length!==1||i[0].comps[0].t!==0||i[0].name!=="StrongEncryptionDataSpace"||i[0].comps[0].v!=="EncryptedPackage")throw new Error("ECMA-376 Encrypted file bad "+a);a="/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace";n=W.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);var s=yf(n.content);if(s.length!=1||s[0]!="StrongEncryptionTransform")throw new Error("ECMA-376 Encrypted file bad "+a);a="/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary";n=W.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);If(n.content)}catch(f){}a="/EncryptionInfo";n=W.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);var o=Of(n.content);a="/EncryptedPackage";n=W.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);if(o[0]==4&&typeof decrypt_agile!=="undefined")return decrypt_agile(o[1],n.content,t.password||"",t);if(o[0]==2&&typeof decrypt_std76!=="undefined")return decrypt_std76(o[1],n.content,t.password||"",t);throw new Error("File is password-protected")}function lg(e,r){Sl=1024;if(r.bookType=="ods")return Vv(e,r);if(e&&!e.SSF){e.SSF=D.get_table()}if(e&&e.SSF){O(D);D.load_table(e.SSF);r.revssf=Z(e.SSF);r.revssf[e.SSF[65535]]=0;r.ssf=e.SSF}r.rels={};r.wbrels={};r.Strings=[];r.Strings.Count=0;r.Strings.Unique=0;if(Kh)r.revStrings=new Map;else{r.revStrings={};r.revStrings.foo=[];delete r.revStrings.foo}var t=r.bookType=="xlsb"?"bin":"xml";var a=Ul.indexOf(r.bookType)>-1;var n=Ba();tg(r=r||{});var i=new Ee;var s="",f=0;r.cellXfs=[];Qh(r.cellXfs,{},{revssf:{General:0}});if(!e.Props)e.Props={};s="docProps/core.xml";i.file(s,$a(e.Props,r));n.coreprops.push(s);Na(r.rels,2,s,Ra.CORE_PROPS);s="docProps/app.xml";if(e.Props&&e.Props.SheetNames){}else if(!e.Workbook||!e.Workbook.Sheets)e.Props.SheetNames=e.SheetNames;else{var o=[];for(var l=0;l<e.SheetNames.length;++l)if((e.Workbook.Sheets[l]||{}).Hidden!=2)o.push(e.SheetNames[l]);e.Props.SheetNames=o}e.Props.Worksheets=e.Props.SheetNames.length;i.file(s,rn(e.Props,r));n.extprops.push(s);Na(r.rels,3,s,Ra.EXT_PROPS);if(e.Custprops!==e.Props&&j(e.Custprops||{}).length>0){s="docProps/custom.xml";i.file(s,sn(e.Custprops,r));n.custprops.push(s);Na(r.rels,4,s,Ra.CUST_PROPS)}for(f=1;f<=e.SheetNames.length;++f){var c={"!id":{}};var h=e.Sheets[e.SheetNames[f-1]];var u=(h||{})["!type"]||"sheet";switch(u){case"chart":;default:s="xl/worksheets/sheet"+f+"."+t;i.file(s,kp(f-1,s,r,e,c));n.sheets.push(s);Na(r.wbrels,-1,"worksheets/sheet"+f+"."+t,Ra.WS[0]);}if(h){var d=h["!comments"];if(d&&d.length>0){var p="xl/comments"+f+"."+t;i.file(p,Bp(d,p,r));n.comments.push(p);Na(c,-1,"../comments"+f+"."+t,Ra.CMNT)}if(h["!legacy"]){i.file("xl/drawings/vmlDrawing"+f+".vml",Al(f,h["!comments"]))}delete h["!comments"];delete h["!legacy"]}if(c["!id"].rId1)i.file(Da(s),Pa(c))}if(r.Strings!=null&&r.Strings.length>0){s="xl/sharedStrings."+t;i.file(s,_p(r.Strings,s,r));n.strs.push(s);Na(r.wbrels,-1,"sharedStrings."+t,Ra.SST)}s="xl/workbook."+t;i.file(s,Ep(e,s,r));n.workbooks.push(s);Na(r.rels,1,s,Ra.WB);s="xl/theme/theme1.xml";i.file(s,ol(e.Themes,r));n.themes.push(s);Na(r.wbrels,-1,"theme/theme1.xml",Ra.THEME);s="xl/styles."+t;i.file(s,Ap(e,s,r));n.styles.push(s);Na(r.wbrels,-1,"styles."+t,Ra.STY);if(e.vbaraw&&a){s="xl/vbaProject.bin";i.file(s,e.vbaraw);n.vba.push(s);Na(r.wbrels,-1,"vbaProject.bin",Ra.VBA)}i.file("[Content_Types].xml",Ia(n,r));i.file("_rels/.rels",Pa(r.rels));i.file("xl/_rels/workbook."+t+".rels",Pa(r.wbrels));delete r.revssf;delete r.ssf;return i}function cg(e,r){var t="";switch((r||{}).type||"base64"){case"buffer":return[e[0],e[1],e[2],e[3]];case"base64":t=m.decode(e.slice(0,24));break;case"binary":t=e;break;case"array":return[e[0],e[1],e[2],e[3]];default:throw new Error("Unrecognized type "+(r&&r.type||"undefined"));}return[t.charCodeAt(0),t.charCodeAt(1),t.charCodeAt(2),t.charCodeAt(3)]}function hg(e,r){if(W.find(e,"EncryptedPackage"))return og(e,r);return lv(e,r)}function ug(e,r){var t,a=e;var n=r||{};if(!n.type)n.type=b&&Buffer.isBuffer(e)?"buffer":"base64";switch(n.type){case"base64":t=new Ee(a,{base64:true});break;case"binary":;case"array":t=new Ee(a,{base64:false});break;case"buffer":t=new Ee(a);break;default:throw new Error("Unrecognized type "+n.type);}return fg(t,n)}function dg(e,r){var t=0;e:while(t<e.length)switch(e.charCodeAt(t)){case 10:;case 13:;case 32:++t;break;case 60:return Wp(e.slice(t),r);default:break e;}return af.to_workbook(e,r)}function pg(e,r){var t="",a=cg(e,r);switch(r.type){case"base64":t=m.decode(e);break;case"binary":t=e;break;case"buffer":t=e.toString("binary");break;case"array":t=se(e);break;default:throw new Error("Unrecognized type "+r.type);}if(a[0]==239&&a[1]==187&&a[2]==191)t=ze(t);return dg(t,r)}function vg(e,r){var t=e;if(r.type=="base64")t=m.decode(t);t=cptable.utils.decode(1200,t.slice(2),"str");r.type="binary";return dg(t,r)}function gg(e){return!e.match(/[^\x00-\x7F]/)?e:Xe(e)}function mg(e,r,t,a){if(a){t.type="string";return af.to_workbook(e,t)}return af.to_workbook(r,t)}function bg(e,r){l();if(typeof ArrayBuffer!=="undefined"&&e instanceof ArrayBuffer)return bg(new Uint8Array(e),r);var t=e,a=[0,0,0,0],n=false;var i=r||{};jh={};if(i.dateNF)jh.dateNF=i.dateNF;if(!i.type)i.type=b&&Buffer.isBuffer(e)?"buffer":"base64";if(i.type=="file"){i.type=b?"buffer":"binary";t=G(e)}if(i.type=="string"){n=true;i.type="binary";i.codepage=65001;t=gg(e)}if(i.type=="array"&&typeof Uint8Array!=="undefined"&&e instanceof Uint8Array&&typeof ArrayBuffer!=="undefined"){var s=new ArrayBuffer(3),f=new Uint8Array(s);f.foo="bar";if(!f.foo){i=fe(i);i.type="array";return bg(y(t),i)}}switch((a=cg(t,i))[0]){case 208:return hg(W.read(t,i),i);case 9:
return lv(t,i);case 60:return Wp(t,i);case 73:if(a[1]===68)return nf(t,i);break;case 84:if(a[1]===65&&a[2]===66&&a[3]===76)return rf.to_workbook(t,i);break;case 80:return a[1]===75&&a[2]<9&&a[3]<9?ug(t,i):mg(e,t,i,n);case 239:return a[3]===60?Wp(t,i):mg(e,t,i,n);case 255:if(a[1]===254){return vg(t,i)}break;case 0:if(a[1]===0&&a[2]>=2&&a[3]===0)return sf.to_workbook(t,i);break;case 3:;case 131:;case 139:;case 140:return qs.to_workbook(t,i);case 123:if(a[1]===92&&a[2]===114&&a[3]===116)return jf.to_workbook(t,i);break;case 10:;case 13:;case 32:return pg(t,i);}if(a[2]<=12&&a[3]<=31)return qs.to_workbook(t,i);return mg(e,t,i,n)}function wg(e,r){var t=r||{};t.type="file";return bg(e,t)}function Cg(e,r){switch(r.type){case"base64":;case"binary":break;case"buffer":;case"array":r.type="";break;case"file":return X(r.file,W.write(e,{type:b?"buffer":""}));case"string":throw new Error("'string' output type invalid for '"+r.bookType+"' files");default:throw new Error("Unrecognized type "+r.type);}return W.write(e,r)}function Eg(e,r){var t=r||{};var a=lg(e,t);var n={};if(t.compression)n.compression="DEFLATE";if(t.password)n.type=b?"nodebuffer":"string";else switch(t.type){case"base64":n.type="base64";break;case"binary":n.type="string";break;case"string":throw new Error("'string' output type invalid for '"+t.bookType+"' files");case"buffer":;case"file":n.type=b?"nodebuffer":"string";break;default:throw new Error("Unrecognized type "+t.type);}var i=a.generate(n);if(t.password&&typeof encrypt_agile!=="undefined")return Cg(encrypt_agile(i,t.password),t);if(t.type==="file")return X(t.file,i);return t.type=="string"?ze(i):i}function kg(e,r){var t=r||{};var a=cv(e,t);return Cg(a,t)}function Sg(e,r,t){if(!t)t="";var a=t+e;switch(r.type){case"base64":return m.encode(Xe(a));case"binary":return Xe(a);case"string":return e;case"file":return X(r.file,a,"utf8");case"buffer":{if(b)return w(a,"utf8");else return Sg(a,{type:"binary"}).split("").map(function(e){return e.charCodeAt(0)})};}throw new Error("Unrecognized type "+r.type)}function Ag(e,r){switch(r.type){case"base64":return m.encode(e);case"binary":return e;case"string":return e;case"file":return X(r.file,e,"binary");case"buffer":{if(b)return w(e,"binary");else return e.split("").map(function(e){return e.charCodeAt(0)})};}throw new Error("Unrecognized type "+r.type)}function _g(e,r){switch(r.type){case"string":;case"base64":;case"binary":var t="";for(var a=0;a<e.length;++a)t+=String.fromCharCode(e[a]);return r.type=="base64"?m.encode(t):r.type=="string"?ze(t):t;case"file":return X(r.file,e);case"buffer":return e;default:throw new Error("Unrecognized type "+r.type);}}function Bg(e,r){Kd(e);var t=r||{};if(t.type=="array"){t.type="binary";var a=Bg(e,t);t.type="array";return _(a)}switch(t.bookType||"xlsb"){case"xml":;case"xlml":return Sg(ev(e,t),t);case"slk":;case"sylk":return Sg(Kv(e,t),t);case"htm":;case"html":return Sg(Gv(e,t),t);case"txt":return Ag(Qv(e,t),t);case"csv":return Sg(jv(e,t),t,"\ufeff");case"dif":return Sg(Yv(e,t),t);case"dbf":return _g(Jv(e,t),t);case"prn":return Sg($v(e,t),t);case"rtf":return Sg(Zv(e,t),t);case"eth":return Sg(qv(e,t),t);case"fods":return Sg(Vv(e,t),t);case"biff2":if(!t.biff)t.biff=2;case"biff3":if(!t.biff)t.biff=3;case"biff4":if(!t.biff)t.biff=4;return _g(Rv(e,t),t);case"biff5":if(!t.biff)t.biff=5;case"biff8":;case"xla":;case"xls":if(!t.biff)t.biff=8;return kg(e,t);case"xlsx":;case"xlsm":;case"xlam":;case"xlsb":;case"ods":return Eg(e,t);default:throw new Error("Unrecognized bookType |"+t.bookType+"|");}}function Tg(e){if(e.bookType)return;var r={xls:"biff8",htm:"html",slk:"sylk",socialcalc:"eth",Sh33tJS:"WTF"};var t=e.file.slice(e.file.lastIndexOf(".")).toLowerCase();if(t.match(/^\.[a-z]+$/))e.bookType=t.slice(1);e.bookType=r[e.bookType]||e.bookType}function yg(e,r,t){var a=t||{};a.type="file";a.file=r;Tg(a);return Bg(e,a)}function xg(e,r,t,a){var n=t||{};n.type="file";n.file=e;Tg(n);n.type="buffer";var i=a;if(!(i instanceof Function))i=t;return V.writeFile(e,Bg(r,n),i)}function Ig(e,r,t,a,n,i,s,f){var o=tt(t);var l=f.defval,c=f.raw||!f.hasOwnProperty("raw");var h=true;var u=n===1?[]:{};if(n!==1){if(Object.defineProperty)try{Object.defineProperty(u,"__rowNum__",{value:t,enumerable:false})}catch(d){u.__rowNum__=t}else u.__rowNum__=t}if(!s||e[t])for(var p=r.s.c;p<=r.e.c;++p){var v=s?e[t][p]:e[a[p]+o];if(v===undefined||v.t===undefined){if(l===undefined)continue;if(i[p]!=null){u[i[p]]=l}continue}var g=v.v;switch(v.t){case"z":if(g==null)break;continue;case"e":g=void 0;break;case"s":;case"d":;case"b":;case"n":break;default:throw new Error("unrecognized type "+v.t);}if(i[p]!=null){if(g==null){if(l!==undefined)u[i[p]]=l;else if(c&&g===null)u[i[p]]=null;else continue}else{u[i[p]]=c?g:gt(v,g,f)}if(g!=null)h=false}}return{row:u,isempty:h}}function Rg(e,r){if(e==null||e["!ref"]==null)return[];var t={t:"n",v:0},a=0,n=1,i=[],s=0,f="";var o={s:{r:0,c:0},e:{r:0,c:0}};var l=r||{};var c=l.range!=null?l.range:e["!ref"];if(l.header===1)a=1;else if(l.header==="A")a=2;else if(Array.isArray(l.header))a=3;switch(typeof c){case"string":o=pt(c);break;case"number":o=pt(e["!ref"]);o.s.r=c;break;default:o=c;}if(a>0)n=0;var h=tt(o.s.r);var u=[];var d=[];var p=0,v=0;var g=Array.isArray(e);var m=o.s.r,b=0,w=0;if(g&&!e[m])e[m]=[];for(b=o.s.c;b<=o.e.c;++b){u[b]=st(b);t=g?e[m][b]:e[u[b]+h];switch(a){case 1:i[b]=b-o.s.c;break;case 2:i[b]=u[b];break;case 3:i[b]=l.header[b-o.s.c];break;default:if(t==null)t={w:"__EMPTY",t:"s"};f=s=gt(t,null,l);v=0;for(w=0;w<i.length;++w)if(i[w]==f)f=s+"_"+ ++v;i[b]=f;}}for(m=o.s.r+n;m<=o.e.r;++m){var C=Ig(e,o,m,u,a,i,g,l);if(C.isempty===false||(a===1?l.blankrows!==false:!!l.blankrows))d[p++]=C.row}d.length=p;return d}var Dg=/"/g;function Og(e,r,t,a,n,i,s,f){var o=true;var l=[],c="",h=tt(t);for(var u=r.s.c;u<=r.e.c;++u){if(!a[u])continue;var d=f.dense?(e[t]||[])[u]:e[a[u]+h];if(d==null)c="";else if(d.v!=null){o=false;c=""+gt(d,null,f);for(var p=0,v=0;p!==c.length;++p)if((v=c.charCodeAt(p))===n||v===i||v===34){c='"'+c.replace(Dg,'""')+'"';break}if(c=="ID")c='"ID"'}else if(d.f!=null&&!d.F){o=false;c="="+d.f;if(c.indexOf(",")>=0)c='"'+c.replace(Dg,'""')+'"'}else c="";l.push(c)}if(f.blankrows===false&&o)return null;return l.join(s)}function Fg(e,r){var t=[];var a=r==null?{}:r;if(e==null||e["!ref"]==null)return"";var n=pt(e["!ref"]);var i=a.FS!==undefined?a.FS:",",s=i.charCodeAt(0);var f=a.RS!==undefined?a.RS:"\n",o=f.charCodeAt(0);var l=new RegExp((i=="|"?"\\|":i)+"+$");var c="",h=[];a.dense=Array.isArray(e);var u=a.skipHidden&&e["!cols"]||[];var d=a.skipHidden&&e["!rows"]||[];for(var p=n.s.c;p<=n.e.c;++p)if(!(u[p]||{}).hidden)h[p]=st(p);for(var v=n.s.r;v<=n.e.r;++v){if((d[v]||{}).hidden)continue;c=Og(e,n,v,h,s,o,i,a);if(c==null){continue}if(a.strip)c=c.replace(l,"");t.push(c+f)}delete a.dense;return t.join("")}function Pg(e,r){if(!r)r={};r.FS="\t";r.RS="\n";var t=Fg(e,r);if(typeof cptable=="undefined"||r.type=="string")return t;var a=cptable.utils.encode(1200,t,"str");return String.fromCharCode(255)+String.fromCharCode(254)+a}function Ng(e){var r="",t,a="";if(e==null||e["!ref"]==null)return[];var n=pt(e["!ref"]),i="",s=[],f;var o=[];var l=Array.isArray(e);for(f=n.s.c;f<=n.e.c;++f)s[f]=st(f);for(var c=n.s.r;c<=n.e.r;++c){i=tt(c);for(f=n.s.c;f<=n.e.c;++f){r=s[f]+i;t=l?(e[c]||[])[f]:e[r];a="";if(t===undefined)continue;else if(t.F!=null){r=t.F;if(!t.f)continue;a=t.f;if(r.indexOf(":")==-1)r=r+":"+r}if(t.f!=null)a=t.f;else if(t.t=="z")continue;else if(t.t=="n"&&t.v!=null)a=""+t.v;else if(t.t=="b")a=t.v?"TRUE":"FALSE";else if(t.w!==undefined)a="'"+t.w;else if(t.v===undefined)continue;else if(t.t=="s")a="'"+t.v;else a=""+t.v;o[o.length]=r+"="+a}}return o}function Lg(e,r,t){var a=t||{};var n=+!a.skipHeader;var i=e||{};var s=0,f=0;if(i&&a.origin!=null){if(typeof a.origin=="number")s=a.origin;else{var o=typeof a.origin=="string"?ct(a.origin):a.origin;s=o.r;f=o.c}}var l;var c={s:{c:0,r:0},e:{c:f,r:s+r.length-1+n}};if(i["!ref"]){var h=pt(i["!ref"]);c.e.c=Math.max(c.e.c,h.e.c);c.e.r=Math.max(c.e.r,h.e.r);if(s==-1){s=c.e.r+1;c.e.r=s+r.length-1+n}}var u=a.header||[],d=0;r.forEach(function(e,r){j(e).forEach(function(t){if((d=u.indexOf(t))==-1)u[d=u.length]=t;var o=e[t];var c="z";var h="";if(o&&typeof o==="object"&&!(o instanceof Date)){i[ht({c:f+d,r:s+r+n})]=o}else{if(typeof o=="number")c="n";else if(typeof o=="boolean")c="b";else if(typeof o=="string")c="s";else if(o instanceof Date){c="d";if(!a.cellDates){c="n";o=ee(o)}h=a.dateNF||D._table[14]}i[ht({c:f+d,r:s+r+n})]=l={t:c,v:o};if(h)l.z=h}})});c.e.c=Math.max(c.e.c,f+u.length-1);var p=tt(s);if(n)for(d=0;d<u.length;++d)i[st(d+f)+p]={t:"s",v:u[d]};i["!ref"]=dt(c);return i}function Mg(e,r){return Lg(null,e,r)}var Ug={encode_col:st,encode_row:tt,encode_cell:ht,encode_range:dt,decode_col:it,decode_row:rt,split_cell:lt,decode_cell:ct,decode_range:ut,format_cell:gt,get_formulae:Ng,make_csv:Fg,make_json:Rg,make_formulae:Ng,sheet_add_aoa:bt,sheet_add_json:Lg,aoa_to_sheet:wt,json_to_sheet:Mg,table_to_sheet:Ov,table_to_book:Fv,sheet_to_csv:Fg,sheet_to_txt:Pg,sheet_to_json:Rg,sheet_to_html:Dv.from_sheet,sheet_to_dif:rf.from_sheet,sheet_to_slk:ef.from_sheet,sheet_to_eth:tf.from_sheet,sheet_to_formulae:Ng,sheet_to_row_object_array:Rg};(function(e){e.consts=e.consts||{};function r(r){r.forEach(function(r){e.consts[r[0]]=r[1]})}function t(e,r,t){return e[r]!=null?e[r]:e[r]=t}function a(e,r,t){if(typeof r=="string")return e[r]||(e[r]={t:"z"});if(typeof r!="number")return a(e,ht(r));return a(e,ht({r:r,c:t||0}))}function n(e,r){if(typeof r=="number"){if(r>=0&&e.SheetNames.length>r)return r;throw new Error("Cannot find sheet # "+r)}else if(typeof r=="string"){var t=e.SheetNames.indexOf(r);if(t>-1)return t;throw new Error("Cannot find sheet name |"+r+"|")}else throw new Error("Cannot find sheet |"+r+"|")}e.book_new=function(){return{SheetNames:[],Sheets:{}}};e.book_append_sheet=function(e,r,t){if(!t)for(var a=1;a<=65535;++a)if(e.SheetNames.indexOf(t="Sheet"+a)==-1)break;if(!t)throw new Error("Too many worksheets");Gd(t);if(e.SheetNames.indexOf(t)>=0)throw new Error("Worksheet with name |"+t+"| already exists!");e.SheetNames.push(t);e.Sheets[t]=r};e.book_set_sheet_visibility=function(e,r,a){t(e,"Workbook",{});t(e.Workbook,"Sheets",[]);var i=n(e,r);t(e.Workbook.Sheets,i,{});switch(a){case 0:;case 1:;case 2:break;default:throw new Error("Bad sheet visibility setting "+a);}e.Workbook.Sheets[i].Hidden=a};r([["SHEET_VISIBLE",0],["SHEET_HIDDEN",1],["SHEET_VERY_HIDDEN",2]]);e.cell_set_number_format=function(e,r){e.z=r;return e};e.cell_set_hyperlink=function(e,r,t){if(!r){delete e.l}else{e.l={Target:r};if(t)e.l.Tooltip=t}return e};e.cell_set_internal_link=function(r,t,a){return e.cell_set_hyperlink(r,"#"+t,a)};e.cell_add_comment=function(e,r,t){if(!e.c)e.c=[];e.c.push({t:r,a:t||"SheetJS"})};e.sheet_set_array_formula=function(e,r,t){var n=typeof r!="string"?r:pt(r);var i=typeof r=="string"?r:dt(r);for(var s=n.s.r;s<=n.e.r;++s)for(var f=n.s.c;f<=n.e.c;++f){var o=a(e,s,f);o.t="n";o.F=i;delete o.v;if(s==n.s.r&&f==n.s.c)o.f=t}return e};return e})(Ug);if(b&&typeof require!="undefined")(function(){var r={}.Readable;var t=function(e,t){var a=r();var n=t==null?{}:t;if(e==null||e["!ref"]==null){a.push(null);return a}var i=pt(e["!ref"]);var s=n.FS!==undefined?n.FS:",",f=s.charCodeAt(0);var o=n.RS!==undefined?n.RS:"\n",l=o.charCodeAt(0);var c=new RegExp((s=="|"?"\\|":s)+"+$");var h="",u=[];n.dense=Array.isArray(e);var d=n.skipHidden&&e["!cols"]||[];var p=n.skipHidden&&e["!rows"]||[];for(var v=i.s.c;v<=i.e.c;++v)if(!(d[v]||{}).hidden)u[v]=st(v);var g=i.s.r;var m=false;a._read=function(){if(!m){m=true;return a.push("\ufeff")}if(g>i.e.r)return a.push(null);while(g<=i.e.r){++g;if((p[g-1]||{}).hidden)continue;h=Og(e,i,g-1,u,f,l,s,n);if(h!=null){if(n.strip)h=h.replace(c,"");a.push(h+o);break}}};return a};var a=function(e,t){var a=r();var n=t||{};var i=n.header!=null?n.header:Dv.BEGIN;var s=n.footer!=null?n.footer:Dv.END;a.push(i);var f=ut(e["!ref"]);n.dense=Array.isArray(e);a.push(Dv._preamble(e,f,n));var o=f.s.r;var l=false;a._read=function(){if(o>f.e.r){if(!l){l=true;a.push("</table>"+s)}return a.push(null)}while(o<=f.e.r){a.push(Dv._row(e,f,o,n));++o;break}};return a};var n=function(e,t){var a=r({objectMode:true});if(e==null||e["!ref"]==null){a.push(null);return a}var n={t:"n",v:0},i=0,s=1,f=[],o=0,l="";var c={s:{r:0,c:0},e:{r:0,c:0}};var h=t||{};var u=h.range!=null?h.range:e["!ref"];if(h.header===1)i=1;else if(h.header==="A")i=2;else if(Array.isArray(h.header))i=3;switch(typeof u){case"string":c=pt(u);break;case"number":c=pt(e["!ref"]);c.s.r=u;break;default:c=u;}if(i>0)s=0;var d=tt(c.s.r);var p=[];var v=0;var g=Array.isArray(e);var m=c.s.r,b=0,w=0;if(g&&!e[m])e[m]=[];for(b=c.s.c;b<=c.e.c;++b){p[b]=st(b);n=g?e[m][b]:e[p[b]+d];switch(i){case 1:f[b]=b-c.s.c;break;case 2:f[b]=p[b];break;case 3:f[b]=h.header[b-c.s.c];break;default:if(n==null)n={w:"__EMPTY",t:"s"};l=o=gt(n,null,h);v=0;for(w=0;w<f.length;++w)if(f[w]==l)l=o+"_"+ ++v;f[b]=l;}}m=c.s.r+s;a._read=function(){if(m>c.e.r)return a.push(null);while(m<=c.e.r){++m;var r=Ig(e,c,m,p,i,f,g,h);if(r.isempty===false||(i===1?h.blankrows!==false:!!h.blankrows)){a.push(r.row);break}}};return a};e.stream={to_json:n,to_html:a,to_csv:t}})();e.parse_xlscfb=lv;e.parse_ods=Mv;e.parse_fods=Uv;e.write_ods=Vv;e.parse_zip=fg;e.read=bg;e.readFile=wg;e.readFileSync=wg;e.write=Bg;e.writeFile=yg;e.writeFileSync=yg;e.writeFileAsync=xg;e.utils=Ug;e.SSF=D;e.CFB=W}if(typeof exports!=="undefined")make_xlsx_lib(exports);else if(typeof module!=="undefined"&&module.exports)make_xlsx_lib(module.exports);else if(typeof define==="function"&&define.amd)define("xlsx",function(){if(!XLSX.version)make_xlsx_lib(XLSX);return XLSX});else make_xlsx_lib(XLSX);var XLS=XLSX,ODS=XLSX;

/// <reference path="../_typings.ts"/>
var app;
(function (app) {
    var common;
    (function (common) {
        // *** Modules need to be populated to be correctly defined, otherwise they will give warnings. null fixes this ***/
        var directives;
        (function (directives) {
            null;
        })(directives = common.directives || (common.directives = {}));
        var filters;
        (function (filters) {
            null;
        })(filters = common.filters || (common.filters = {}));
        var services;
        (function (services) {
            null;
        })(services = common.services || (common.services = {}));
        /**
         * Register new filter.
         *
         * @param className
         * @param services
         */
        function registerFilter(className, services) {
            if (services === void 0) { services = []; }
            var filter = className.toLowerCase();
            services.push(function () { return (new app.common.filters[className]()).filter; });
            angular.module('app.common.filters').filter(filter, services);
        }
        common.registerFilter = registerFilter;
        /**
         * Register new directive.
         *
         * @param className
         * @param services
         */
        function registerDirective(className, services) {
            if (services === void 0) { services = []; }
            var directive = className[0].toLowerCase() + className.slice(1);
            services.push(function () { return new app.common.directives[className](); });
            angular.module('app.common.directives').directive(directive, services);
        }
        common.registerDirective = registerDirective;
        /**
         * Register new service.
         *
         * @param className
         * @param services
         */
        function registerService(className, services) {
            if (services === void 0) { services = []; }
            var service = className[0].toLowerCase() + className.slice(1);
            services.push(app.common.services[className]);
            angular.module('app.common.services').service(service, services);
        }
        common.registerService = registerService;
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

'use strict';
// Create and register modules
var modules = ['app.web.controllers', 'app.web.directives', 'app.web.filters', 'app.web.services', 'app.common.filters', 'app.common.directives', 'app.common.services'];
modules.forEach(function (mod) { return angular.module(mod, []); });
// *** Push ngRoute or $routeProvider won't work ***
// Angular modules 
modules.push("ngAnimate");
//modules.push("ngRoute");
modules.push("ui.router");
modules.push('ngSanitize');
modules.push('app.web');
// Custom modules 
modules.push("common");
//modules.push("common.bootstrap");
modules.push("breeze.angular");
modules.push("app.locale.en-gb");
modules.push("app.locale.en-us");
modules.push("app.locale.en-ca");
modules.push("app.locale.en-ie");
modules.push("app.locale.no");
modules.push("app.locale.es-cl");
// 3rd Party Modules
modules.push("ui.bootstrap");
modules.push("ui.grid");
modules.push("ui.grid.autoResize");
modules.push('ngCookies');
modules.push('pascalprecht.translate');
modules.push('http-auth-interceptor');
modules.push('tmh.dynamicLocale');
modules.push('daterangepicker');
modules.push('isteven-multi-select');
modules.push('ngDialog');
modules.push('mgo-angular-wizard');
modules.push('angular-loading-bar');
modules.push('angular-md5');
modules.push('av-grid');
modules.push('av-popover');
modules.push('angular-jwt');
modules.push('flow');
modules.push('ngHolder');
modules.push('SignalR');
modules.push('ngPasswordStrength');
modules.push('uiGmapgoogle-maps');
modules.push('angucomplete-alt');
modules.push('ngMessages');
modules.push('fcsa-number');
modules.push('monospaced.elastic');
modules.push('ngIdle');
modules.push('angular-pdfjs');
modules.push('ngFileSaver');
modules.push('mgcrea.ngStrap');
modules.push('ngclipboard');
modules.push('ng.deviceDetector');
modules.push('froala');
modules.push("config.env");
angular.module('app.web', modules);
angular.module('app.web').config(["$httpProvider", function ($httpProvider) { }]);
angular.module('app.web').run(['breeze', function () { }]);
var app;
(function (app) {
    var web;
    (function (web) {
        // *** Modules need to be populated to be correctly defined, otherwise they will give warnings. null fixes this ***/
        var controllers;
        (function (controllers) {
            null;
        })(controllers = web.controllers || (web.controllers = {}));
        var directives;
        (function (directives) {
            null;
        })(directives = web.directives || (web.directives = {}));
        var filters;
        (function (filters) {
            null;
        })(filters = web.filters || (web.filters = {}));
        var services;
        (function (services) {
            null;
        })(services = web.services || (web.services = {}));
        /**
         * Register new controller.
         *
         * @param className
         * @param services
         */
        function registerController(className, services) {
            if (services === void 0) { services = []; }
            var controller = 'app.web.controllers.' + className;
            services.push(app.web.controllers[className]);
            angular.module('app.web').controller(controller, services);
        }
        web.registerController = registerController;
        /**
         * Register new filter.
         *
         * @param className
         * @param services
         */
        function registerFilter(className, services) {
            if (services === void 0) { services = []; }
            var filter = className.toLowerCase();
            services.push(function () { return (new app.web.filters[className]()).filter; });
            angular.module('app.web.filters').filter(filter, services);
        }
        web.registerFilter = registerFilter;
        /**
         * Register new directive.
         *
         * @param className
         * @param services
         */
        function registerDirective(className, services) {
            if (services === void 0) { services = []; }
            var directive = className[0].toLowerCase() + className.slice(1);
            services.push(function () { return new app.web.directives[className](); });
            angular.module('app.web.directives').directive(directive, services);
        }
        web.registerDirective = registerDirective;
        /**
         * Register new directive.
         * the class should implement a static factory() method
         *
         * @param className
         */
        function registerDirectiveViaFactory(className) {
            var directive = className[0].toLowerCase() + className.slice(1);
            angular.module('app.web.directives').directive(directive, app.web.directives[className].factory());
        }
        web.registerDirectiveViaFactory = registerDirectiveViaFactory;
        /**
         * Register new service.
         *
         * @param className
         * @param services
         */
        function registerService(className, services) {
            if (services === void 0) { services = []; }
            var service = className[0].toLowerCase() + className.slice(1);
            services.push(app.web.services[className]);
            angular.module('app.web.services').service(service, services);
        }
        web.registerService = registerService;
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

/// <reference path="_typings.web.ts"/>
(function () {
    'use strict';
    var appWeb = angular.module('app.web');
    // Configure Toastr
    //toastr.options.timeOut = 4000;
    //toastr.options.positionClass = 'toast-bottom-right';
    // For use with the HotTowel-Angular-Breeze add-on that uses Breeze
    var remoteServiceName = 'breeze/Breeze';
    var events = {
        controllerActivateSuccess: 'controller.activateSuccess',
        spinnerToggle: 'spinner.toggle'
    };
    var config = {
        appErrorPrefix: '[HT Error] ',
        docTitle: 'HotTowel: ',
        events: events,
        remoteServiceName: remoteServiceName,
        version: '2.1.0',
        debug: true
    };
    appWeb.value('config', config);
    appWeb.config(['$logProvider', function ($logProvider) {
            // turn debugging off/on (no info or warn)
            if ($logProvider.debugEnabled) {
                $logProvider.debugEnabled(true);
            }
        }]);
    appWeb.config(['$httpProvider', 'jwtInterceptorProvider', '$injector', function Config($httpProvider, jwtInterceptorProvider, $injector) {
            jwtInterceptorProvider.tokenGetter = ['config',
                'jwtHelper', '$http', 'authenticationService', function (config, jwtHelper, $http, authenticationService) {
                    var credentials = authenticationService.credentialsGet();
                    //skip html
                    if (_.includes(config.url, '.htm', config.url.length - 5) || _.includes(config.url, 'ui-grid')) {
                        return null;
                    }
                    if (credentials && jwtHelper.isTokenExpired(credentials.Token)) {
                        // This is a promise of a JWT id_token
                        return authenticationService.refreshToken().then(function (response) {
                            return response.access_token;
                        });
                    }
                    else if (credentials) {
                        return credentials.Token;
                    }
                    else {
                        return undefined;
                    }
                }
            ];
            $httpProvider.interceptors.push('jwtInterceptor');
        }]);
    //#region Configure the common services via commonConfig
    appWeb.config(['commonConfigProvider', function (cfg) {
            cfg.config.controllerActivateSuccessEvent = config.events.controllerActivateSuccess;
            cfg.config.spinnerToggleEvent = config.events.spinnerToggle;
        }]);
    appWeb.config([
        ('cfpLoadingBarProvider'), function (cfpLoadingBarProvider) {
            cfpLoadingBarProvider.includeSpinner = true;
            cfpLoadingBarProvider.includeBar = false;
            cfpLoadingBarProvider.spinnerTemplate = '<div class="loader" id="busyIndicator"><div class="fadeMe"></div><div class="vetProgress">' +
                '<h4 style = "text-align: center" id="busyIndicatorContent">&nbsp</h4><div class="progress progress-striped active  page-progress-bar">' +
                '<div class="bar"></div></div></div></div>';
        }
    ]);
    appWeb.config(['KeepaliveProvider', 'IdleProvider', 'ENV', function (KeepaliveProvider, IdleProvider, env) {
            IdleProvider.idle(env.idleTime);
            IdleProvider.timeout(env.idleCountdown);
            KeepaliveProvider.interval(10);
        }]);
    appWeb.run(['Idle', function (Idle) {
            Idle.watch();
        }]);
    appWeb.run(["$rootScope", "$state", "$document", "loginModal", "authenticationService", function ($rootScope, $state, $document, loginModal, authenticationService) {
        $rootScope.$on('cfpLoadingBar:loading', function () {
            if ($document.find('#busyIndicatorContent') != null && !_.isUndefined(app.localizer) && !_.isEmpty(app.localizer.resource)) {
                $document.find('#busyIndicatorContent').text(app.localizer.resource.PleaseWait);
            }
        });
        authenticationService.initialize();
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            var requireLogin = toState.data.requireLogin;
            if (requireLogin && !authenticationService.isAutheticated()) {
                event.preventDefault();
                return $state.go('login');
            }
        });
    }]);
    // merely depending on the 'breeze' service configures Breeze for Angular
    appWeb.run(['breeze', function (breeze) {
            // get the current Breeze AJAX adapter (assume it is 'jQuery')
            var ajaxAdapter = breeze.config.getAdapterInstance('ajax');
            ajaxAdapter.requestInterceptor = function (requestInfo) {
                //donot show busyindicator when draft beeing updated
                if (requestInfo.config.url.indexOf('SaveChanges') > 0 && requestInfo.config.data && requestInfo.config.data.search('AssessmentId') < 0)
                    requestInfo.config.ignoreLoadingBar = true;
            };
        }]);
    //#endregion
})();

var app;
(function (app) {
    var constants;
    (function (constants) {
        constants.entityNames = {
            activeSubstance: "ActiveSubstance",
            address: "Address",
            allowedReg: "AllowedRegistration",
            area: "Area",
            assessment: "Assessment",
            assessmentFollowUpStatus: "AssessmentFollowUpStatus",
            assessmentType: "AssessmentType",
            assessmentTypeGroup: "AssessmentTypeGroup",
            attribute: "Attribute",
            attributeMetadata: "AttributeMetadata",
            attributeMetadataEnum: "AttributeMetadataEnum",
            attributeMetadataType: "AttributeMetadataType",
            attributeType: "AttributeType",
            audit: "Audit",
            company: "Company",
            companyAddress: "CompanyAddress",
            companyBu: "CompanyBU",
            companyBuAddress: "CompanyBUAddress",
            companyContactPerson: "CompanyContactPerson",
            companyBUContactPerson: "CompanyBUContactPerson",
            country: "Country",
            customer: "Customer",
            customerAddress: "CustomerAddress",
            customerBu: "CustomerBU",
            customerBuAddress: "CustomerBUAddress",
            customerContactPerson: "CustomerContactPerson",
            customerBUContactPerson: "CustomerBUContactPerson",
            contactPerson: "ContactPerson",
            dictionary: "Dictionary",
            event: "Event",
            fishgroup: "Fishgroup",
            generation: "Generation",
            language: "Language",
            localization: "Localization",
            measureUnit: "MeasureUnit",
            navigationOption: "NavigationOption",
            notification: "Notification",
            notificationType: "NotificationType",
            operation: "Operation",
            password: "Password",
            prescription: "Prescription",
            prescriptionFile: "PrescriptionFile",
            prescriptionReport: "PrescriptionReport",
            productionStage: "ProductionStage",
            quarantineType: "QuarantineType",
            region: "Region",
            securityLevel: "SecurityLevel",
            sentMail: "SentMail",
            site: "Site",
            siteAddress: "SiteAddress",
            siteContactPerson: "SiteContactPerson",
            siteLicenseNumber: "SiteLicenseNumber",
            siteVetContactPerson: "SiteVetContactPerson",
            supplier: "Supplier",
            diagnosis: "Diagnosis",
            supplierType: "SupplierType",
            species: "Specie",
            templateItem: "TemplateItem",
            template: "Template",
            templateGroup: "TemplateGroup",
            templateRegistration: "TemplateRegistration",
            treatmentProduct: "TreatmentProduct",
            treatmentProductIndication: "TreatmentProductIndication",
            treatmentProductProducer: "TreatmentProductProducer",
            regionalAuthority: "RegionalAuthority",
            treeNode: "TreeNode",
            user: "User",
            applicationUser: "AccountUser",
            assessmentDiscriminator: "assessmentDiscriminator",
            assessmentIdentifier: "assessmentIdentifier",
            userSetting: "UserSetting",
            userSettingType: "UserSettingType",
            assessmentReport: "assessmentReport",
            userAssessment: "UserAssessment",
            userReturnModel: "UserReturnModel",
            userBusinessObject: "UserBusinessObject"
        };
        constants.attributeMetadataType = {
            Default: 1,
            MaxFutureDays: 3,
            Required: 4,
            Aggregation: 5,
            Enum: 6,
            Expression: 7,
            EnumDataType: 8,
            LabelDataType: 11,
            FarmerMappingRule: 12,
            DecidesRule: 13,
            Information: 14
        };
        constants.attributeMetadata = {
            ShowTextIfEmpty: "ShowTextIfEmpty" + ":"
        };
        constants.OptimumImageSize = {
            Width: 800,
            Height: 598
        };
        constants.enumDataType = {
            Double: "Double",
            Integer: "Integer",
            String: "String"
        };
        constants.timelineMarkType = {
            Assessment: "Assessment",
            Event: "Event"
        };
        constants.errorType = {
            None: "None",
            Number: "Number",
            InvalidExpDate: "InvalidDate"
        };
        constants.attributeType = {
            Double: "Double",
            Integer: "Integer",
            Text: "Text",
            Enum: "Enum",
            Boolean: "Boolean",
            Date: "Date",
            Comment: "Comment",
            File: "File",
            Expression: "Expression",
            BusinessRule: "Business rule",
            Chart: "Chart",
            Multiselect: "Multiselect",
            BooleanNullable: "BooleanNullable"
        };
        constants.resourceNames = {
            activeSubstanceResource: "ActiveSubstances",
            allowedRegResource: "AllowedRegistrations",
            assessmentResource: "Assessments",
            assessmentDTOResource: "AssessmentDTOs",
            assessmentTypeResource: "AssessmentTypes",
            assessmentTypeGroupResource: "assessmentTypeGroups",
            attributes: "Attributes",
            templateGroupResource: "TemplateGroups",
            templateRegistrationResource: "TemplateRegistrations",
            customerResource: "Customers",
            customerBUResource: "CustomerBUs",
            siteResource: "Sites",
            companyResource: "Companies",
            companyBUResource: "CompanyBUs",
            areaResource: "Areas",
            regionResource: "Regions",
            operationResource: "Operations",
            contactPersonResource: "ContactPersons",
            siteContactPersonResource: "SiteContactPersons",
            assessmentDiscriminatorResource: "AssessmentDiscriminators",
            assessmentIdentifierResource: "AssessmentIdentifier",
            userSettingResource: "UserSettings",
            userSettingTypeResource: "UserSettingTypes",
            fishGroups: "FishGroups",
            siteVetContactPersonResource: "SiteVetContactPersons",
            assessmentReports: "AssessmentReports",
            assessmentFollowUpStatuses: "assessmentFollowUpStatuses",
            audits: "Audits",
            languages: "Languages",
            auditTypes: "AuditTypes",
            sentMailResource: "SentMails",
            eventResource: "Events",
            generations: "Generations",
            securityLevelResource: "SecurityLevels",
            navigationMenuResource: "NavigationMenus",
            navigationOptionResource: "NavigationOptions",
            navigationSubOptionResource: "NavigationSubOptions",
            navigationURLResource: "NavigationURLs",
            operationUnitTypesResource: "OperationUnitTypes",
            roleOperationUnitTypeResource: "RoleOperationUnitTypes",
            roleResource: "Roles",
            attributeMetadatas: "AttributeMetadatas",
            attributeMetadataEnums: "AttributeMetadataEnums",
            userAssessments: "userAssessments",
            userBusinessObjectResource: "UserBusinessObjects",
            prescriptionResource: "Prescriptions",
            prescriptionFileResource: "PrescriptionFiles",
            prescriptionReports: "PrescriptionReports",
            treatmentProductResource: "TreatmentProducts",
            regionalAuthorityResource: "RegionalAuthorities",
            speciesResource: "Species",
            productionStageResource: "ProductionStages",
            measureUnitResource: "measureUnits",
            treatmentProductIndicationResource: "TreatmentProductIndications",
            treatmentProductProducerResource: "TreatmentProductProducers",
            supplierTypeResource: "SupplierTypes",
            supplierResource: "Suppliers",
            diagnosisResource: "Diagnoses",
            quarantineTypeResources: "QuarantineTypes",
            countryResources: "Countries"
        };
        constants.angulari18LMapping = {
            'nb-no': "no",
            'nn-no': "no",
            'nb': "no",
            'nn': "no"
        };
        constants.supportedCultures = [
            {
                code: "en-GB",
                displayName: "English (United Kingdom)"
            },
            {
                code: "en-US",
                displayName: "English (United States)"
            }, {
                code: "en-CA",
                displayName: "English (Canada)"
            }, {
                code: "en-IE",
                displayName: "English (Ireland)"
            }, {
                code: "nb-NO",
                displayName: "Norsk, bokmål (Norge)"
            }, {
                code: "es-CL",
                displayName: "Español (Chile)"
            }
        ];
        (function (operation) {
            operation[operation["NEW"] = 0] = "NEW";
            operation[operation["EDIT"] = 1] = "EDIT";
            operation[operation["RECOVERYDRAFT"] = 2] = "RECOVERYDRAFT";
        })(constants.operation || (constants.operation = {}));
        var operation = constants.operation;
        ;
        constants.assessmentStatus = { DRAFT: "Draft", COMPLETED: "Completed" };
        constants.assessmentSyncStatus = { SYNCED: "Synced", NON_SYNCED: "Non-Synced" };
        constants.metaDataExpressionAttributePattern = /\{([^}]+)\}/g;
        constants.userSettingNames = {
            sortingUserSetting: "Mobile_AssessmentSorting"
        };
        constants.broadcastEventNames = {
            assessmentTypeSelected: "assessmentTypeSelected",
            assessmentsSort: "assessmentsSort",
            assessmentsFilter: "assessmentsFilter",
            assessmentsReload: "assessmentsReload",
            registrationCompleted: "registartionCompleted",
            collapseAllOpenAssessments: "collapseAllOpenAssessments",
            addFishGroup: "addFishGroup",
            syncDatabase: "syncDatabase",
            syncDatabaseCompleted: "syncDatabaseCompleted",
            errorOccured: "errorOccured",
            authLoginRequired: "event:auth-loginRequired",
            authLoginConfirmed: "event:auth-loginConfirmed",
            authLogoutCompleted: "event:auth-logoutCompleted",
            authLoginFailed: "event:auth-loginFailed",
            noConnection: "event:noConnection",
            hasConnection: "hasConnection",
            goToStep: "goToStep",
            navigationObjectIdChanged: "navigationObjectIdChanged",
            navigationLevelIdChanged: "navigationLevelIdChanged",
            navigationCustomerChanged: "navigationCustomerChanged",
            eventRegistrationCompleted: "eventRegistrationCompleted",
            mailSent: "mailSent",
            refreshMenus: "refreshMenus",
            serverErrorOccured: "serverErrorOccured",
            clientErrorOccured: "clientErrorOccured",
            nonBlockingErrorOccured: "nonBlockingErrorOccured",
            switchMapView: "switchMapView",
            mapViewDataLoaded: "mapViewDataLoaded",
            assessmentViewType: "assessmentViewType",
            siteSelected: "siteSelected",
            assessmentListType: "assessmentListType",
            logAction: "logAction",
            routingEvent: "routingEvent",
            refreshMapView: "refreshMapView",
            assessmentTypeGroup: "assessmentTypeGroup",
            prescriptionFilter: "prescriptionFilter",
            treatmentProductRegistrationCompleted: "treatmentProductRegistrationCompleted",
            supplierRegistrationCompleted: "supplierRegistrationCompleted",
            treatmentProductProducerRegistrationCompleted: "treatmentProductProducerRegistrationCompleted",
            ionicViewEnter: "$ionicView.enter",
            attributeEnumRegistrationCompleted: "attributeEnumRegistrationCompleted",
            tokenExpired: "loginTokenExpired",
            refreshTable: "refreshTable",
            refreshMultiRow: "refreshMultiRow",
            idleTimeStart: "idleTimeStart"
        };
        constants.devicePlatform = {
            android: "Android",
            iOS: "iOS",
            undefined: "Undefined"
        };
        constants.deviceType = {
            WebApp: 0,
            IPad: 1,
            AndroidTablet: 2,
            WindowsTablet: 3
        };
        constants.deviceTypeWeb = "Web App";
        constants.siteTypes = {
            all: -1,
            notSpecified: 1,
            marine: 2,
            freshwater: 3,
            breeding: 4,
            processing: 5
        };
        constants.assessmentTypes = {
            harvest: 1,
            liceTreatment: 2,
            preLiceTreatment: 3,
            preTransfer: 4,
            seawater: 5,
            vaccination: 6,
            preVaccination: 7
        };
        constants.fileSystemFolders = {
            assessmentReports: "AssessmentReports",
            prescriptionReports: "PrescriptionReports",
            reports: "Reports",
            picturesCompleted: "PicturesCompleted",
            picturesDraft: "PicturesDraft",
            backup: "Backup"
        };
        constants.reportStatus = {
            loaded: "Loaded",
            loading: "Loading",
            failed: "Failed"
        };
        constants.fileCategory = {
            visit: 1,
            expierence: 2,
            prescription: 3,
        };
        constants.errorMessages = {
            inValidNumber: "Please enter a valid number.",
            inValiDate: "Please enter a valid date."
        };
        constants.operationUnitLevels = {
            company: "0",
            companyBU: "1",
            customer: "2",
            customerBU: "3",
            operation: "4",
            region: "5",
            area: "6",
            site: "7"
        };
        constants.getOperationUnitLevelName = function (operationUnitLevelId) {
            for (var name in constants.operationUnitLevels) {
                if (constants.operationUnitLevels.hasOwnProperty(name)) {
                    if (constants.operationUnitLevels[name] == operationUnitLevelId) {
                        return name;
                    }
                }
            }
        };
        constants.getOperationUnitLevelId = function (operationUnitLevelName) {
            for (var name in constants.operationUnitLevels) {
                if (constants.operationUnitLevels.hasOwnProperty(name)) {
                    if (name == operationUnitLevelName) {
                        return constants.operationUnitLevels[name];
                    }
                }
            }
        };
        constants.cascadingAttributesForCalculation = [52, 54, 128]; //'Latitudinal deviation (mm)', 'Longitudinal deviation (mm)', 'Precision score'
        constants.assessmentListViews = {
            assessment: "assessment list",
            status: "status",
            timeline: "timeline",
            customerPortalStatus: "customerPortalStatus",
            customerPortalAssessment: "customerPortalAssessmentsList",
            upcomingEvents: "upcomingEvents",
            template: "template",
            customerPortalTemplate: "customerPortalTemplate"
        };
        constants.assessmentProperties = {
            followUp: "followUp",
            assessmentType: "assessmentType",
            assessmentGroup: "assessmentGroup",
            assessmentIdentifier: "assessmentIdentifier",
            representative: "representative",
            customer: "customer",
            companyBU: "companyBU",
            site: "site",
            siteFishgroup: "siteFishgroup",
            visitType: "visitType"
        };
        constants.assessmentTypeProperties = {
            assessmentTypeGroup: "assessmentTypeGroup"
        };
        constants.auditProperties = {
            auditingType: "auditingType"
        };
        constants.prescriptionProperties = {
            specie: "specie",
            productionStage: "productionStage",
            treatmentProduct: "treatmentProduct",
            amountMeasure: "amountMeasure",
            site: "site"
        };
        constants.treatmentProductProperties = {
            treatmentProductProducer: "treatmentProductProducer",
            activeSubstance: "activeSubstance",
            companyBU: "companyBU"
        };
        (function (auditTypes) {
            auditTypes[auditTypes["Create"] = 1] = "Create";
            auditTypes[auditTypes["Update"] = 2] = "Update";
            auditTypes[auditTypes["Delete"] = 3] = "Delete";
            auditTypes[auditTypes["Lock"] = 4] = "Lock";
            auditTypes[auditTypes["Unlock"] = 5] = "Unlock";
            auditTypes[auditTypes["Activate"] = 6] = "Activate";
            auditTypes[auditTypes["Deactivate"] = 7] = "Deactivate";
        })(constants.auditTypes || (constants.auditTypes = {}));
        var auditTypes = constants.auditTypes;
        ;
        constants.menuNames = {
            importExport: "ImpExp",
            registration: "Reg",
            user: "User",
            admin: "Admin",
            tab: "Tab",
            assessment: "Assessment",
            event: "Event",
            processCube: "ProcessCube",
            mapType: "MapType",
            gridRow: "GridRow",
            setup: "Setup",
            template: "Template"
        };
        constants.gridRowMenus = {
            event: "event",
            prescription: "prescription",
            treatmentProduct: "treatmentProduct",
            setupOptions: "SetupOptions",
            draftPrescription: "DraftPrescription"
        };
        constants.dialogSize = {
            defaultSize: "",
            hidden: "ngdialog-hidden",
            extraSmall: "ngdialog-xs",
            small: "ngdialog-sm",
            medium: "ngdialog-md",
            large: "ngdialog-lg",
            extraLarge: "ngdialog-xl"
        };
        constants.accessControlRoles = {
            Veterinary: "Veterinary",
            Administrator: "Administrator",
            Host: "Host",
            Customer: "AC_Customer",
            Developer: "Developer",
            Welfare: "Welfare"
        };
        constants.accessControlPermissions = {
            none: 0,
            read: 1,
            full: 2
        };
        constants.accessControlPermissionIdGet = function (accessType) {
            for (var name in constants.accessControlPermissions) {
                if (constants.accessControlPermissions.hasOwnProperty(name)) {
                    if (name == accessType.toLowerCase()) {
                        return constants.accessControlPermissions[name];
                    }
                }
            }
            return -1;
        };
        constants.chartTypes = {
            precisionScore: 1,
            visceralMelanin: 2,
            parietalMelanin: 3,
            speilbergScore: 4,
            percentileVisceralMelanin: 5,
            percentileParietalMelanin: 6,
            percentileSpeilbergScore: 7
        };
        constants.chartStageTypes = {
            harvest: 1,
            preTransfer: 4,
            seaWater: 5
        };
        constants.mapViewType = {
            assessments: 1,
            events: 2
        };
        constants.precisionScoreComparisonTypes = {
            vaccinationMethod: 1,
            MachineType: 2,
            VaccinationCrew: 3
        };
        constants.chartSerieTypes = {
            column: "column",
            spline: "spline",
            errorbar: "errorbar",
            scatter: "scatter",
            line: "line"
        };
        constants.benchmarkingChartGroups = {
            precisionScore: "PrecisionScore",
            sideEffects: "SideEffects",
            percentilesSideEffects: "PercentilesSideEffects",
            averagesSideEffects: "AverageSideEffects"
        };
        constants.logActions = {
            sort: "Sort",
            filter: "Filter",
            filterCompleted: "Filter completed",
            refreshAssessments: "Refresh assessments",
            refreshAssessmentsCompleted: "Refresh assessments completed",
            refreshEvents: 'Refresh events',
            refreshEventsCompleted: "Refresh events completed",
            refreshPrescriptions: "Refresh prescriptions",
            refreshPrescriptionsCompleted: "Refresh prescriptions completed",
            saveDraft: "Save draft",
            save: "Save",
            syncStarted: "SyncStarted",
            syncFailed: "SyncFailed",
            syncSuccess: "SyncSuccess",
            deleteAssessment: "DeleteAssessment",
            deletePrescription: "DeletePrescription",
            createAssessment: "CreateAssessment",
            createPrescription: "CreatePrescription",
            clearStorage: "Clear storage",
            login: "Login",
            logout: "Logout",
            error: "Error",
            pictureAdd: "pictureAdd",
            pictureUpdate: "pictureUpdate",
            pictureDelete: "pictureDelete"
        };
        constants.fileNames = {
            breezeStorage: "aquavet.mobile",
            logFile: "log_v2.txt",
            logFileEnc: "log_v2.enc",
            storageZip: "storage.txt",
            localStorage: "localStorage.txt"
        };
        constants.synchornizationState = {
            none: "none",
            success: "success",
            failed: "failed",
            started: "started"
        };
        constants.applicationType = {
            mobileApp: "MobileApp",
            webApp: "WebApp"
        };
        constants.sortTypes = {
            ascending: "asc",
            descending: "desc",
            none: "none",
            notSortable: "no"
        };
        constants.applications = {
            aquavet: "aquavet",
            aquacare: "aquacare"
        };
        constants.actionType = {
            toggleActive: 'toggleActive',
            edit: 'edit',
            delete: 'delete'
        };
        constants.addressType = {
            visit: 1,
            postal: 2,
            invoice: 3,
            delivery: 4
        };
        constants.farmerMappingColumns3 = {
            FarmerUnit: 'unitName',
            FarmerFishgroup: 'fishGroupName',
            FarmerCount: 'closeCount',
            FarmerAvgWeightGrams: 'closeWeight',
            FarmerBiomassKg: 'closeBiomass',
            FarmerMortalityCount: 'mortalityCount',
            FarmerCountPct: 'mortalityPct',
            FarmerVaccine: 'vaccineName',
            FarmerTrend: 'trend',
            FarmerVaccineLastDate: 'lastVaccinationDate',
            FarmerTreatmentProduct: 'treatmentProductName',
            FarmerLastTreatment: 'lastTreatmentDate',
            FarmerWeek: 'weekNumber',
            FarmerLiceMobile: 'mobile',
            FarmerFemaleOvigorous: 'femaleOvigorous',
            FarmerChalimus: 'chalimus',
            FarmerCaligus: 'scottishLice',
            FarmerTotalLice: 'liceTotal',
            Temperature6_17: 'temperature',
            OxygenAvgMin: 'oxygen',
            Salinity33_34: 'salinity',
            ProductionDensity: 'density'
        };
        constants.farmerTemplates = {
            Visit_Inventory: 'Visit_Inventory',
            Visit_Mortality: 'Visit_Mortality',
            Visit_Treatments: 'Visit_Treatments',
            Visit_Vaccination: 'Visit_Vaccination',
            Visit_LiceCounting: 'Visit_LiceCounting',
            Visit_Environment: 'Visit_Environment',
            Welfare_Inventory: 'Welfare_Inventory',
            Welfare_Environmental_Indicators: 'Welfare_Environmental_Indicators',
            Welfare_Cleanerfish_Welfare: 'Welfare_Cleanerfish_Welfare'
        };
        constants.farmerMappingColumns = {
            Visit_Inventory: {
                FarmerUnit: 'unitName',
                FarmerFishgroup: 'fishGroupName',
                FarmerCount: 'closeCount',
                FarmerAvgWeightGrams: 'closeWeight',
                FarmerBiomassKg: 'closeBiomass',
            },
            Visit_Mortality: {
                FarmerUnit: 'unitName',
                FarmerCount: 'mortalityCount',
                FarmerMortalityCount: 'mortalityCount',
                FarmerCountPct: 'mortalityPct',
                FarmerTrend: 'trend'
            },
            Visit_Treatments: {
                FarmerTreatmentProduct: 'treatmentProductName',
                FarmerLastTreatment: 'lastTreatmentDate',
            },
            Visit_Vaccination: {
                FarmerUnit: 'unitName',
                FarmerVaccine: 'vaccineName',
                FarmerVaccineLastDate: 'lastVaccinationDate'
            },
            Visit_Environment: {
                ObjectName: 'objectName',
                ReadingType: 'readingType',
                Value: 'value'
            },
            Visit_LiceCounting: {
                FarmerLastTreatment: 'lastTreatmentDate',
                FarmerWeek: 'weekNumber',
                FarmerLiceMobile: 'mobile',
                FarmerFemaleOvigorous: 'femaleOvigorous',
                FarmerChalimus: 'chalimus',
                FarmerCaligus: 'scottishLice',
                FarmerTotalLice: 'liceTotal'
            },
            Welfare_Inventory: {},
            Welfare_Environmental_Indicators: {
                Temperature6_17: 'temperature',
                OxygenAvgMin: 'oxygen',
                Salinity33_34: 'salinity',
                ProductionDensity: 'density'
            },
            Welfare_Cleanerfish_Welfare: {
                LastMonthAvgMortalityPercCleanerFish: 'mortalityPerc'
            }
        };
        constants.SupplierTypePharmacyIndex = 0;
        constants.SupplierTypeFeedCompanyIndex = 1;
    })(constants = app.constants || (app.constants = {}));
})(app || (app = {}));

// Include in index.html so that app level exceptions are handled.
// Exclude from testRunner.html which should run exactly what it wants to run
(function () {
    'use strict';
    var app = angular.module('app.web');
    // Configure by setting an optional string value for appErrorPrefix.
    // Accessible via config.appErrorPrefix (via config value).
    app.config(['$provide', function ($provide) {
            $provide.decorator('$exceptionHandler', ['$delegate', '$injector', 'config', 'logger', extendExceptionHandler]);
        }]);
    // Extend the $exceptionHandler service to also display a toast and broadcast event.
    function extendExceptionHandler($delegate, $injector, config, logger) {
        var appErrorPrefix = config.appErrorPrefix;
        var logError = logger.getLogFn('app', 'error');
        return function (exception, cause) {
            $delegate(exception, cause);
            if (appErrorPrefix && exception.message && exception.message.indexOf(appErrorPrefix) === 0) {
                return;
            }
            var errorData = { exception: exception, cause: cause };
            var msg = appErrorPrefix + exception.message;
            logError(msg, errorData, true);
            var rScope = $injector.get('$rootScope');
            rScope.$broadcast('clientErrorOccured', exception);
        };
    }
})();

(function () {
    "use strict";
    var application = angular.module("app.web");
    // Collect the states
    application.constant("states", getStates());
    function stateConfigurator($stateProvider, $urlRouterProvider, states) {
        states.forEach(function (s) {
            $stateProvider.state(s);
        });
    }
    // Configure the states and state resolvers
    application.config([
        "$stateProvider",
        "$urlRouterProvider",
        "states",
        stateConfigurator
    ]);
    function getStates() {
        return [
            {
                name: "login",
                url: "/login",
                templateUrl: "modules/login/login.html",
                title: "login",
                settings: {
                    nav: 1,
                    content: '<i class="fa fa-dashboard"></i> Dashboard'
                },
                data: {
                    requireLogin: false
                }
            },
            {
                name: "noaccess",
                url: "/noaccess",
                templateUrl: "modules/noaccess/noaccess.html",
                title: "noaccess",
                settings: {
                    nav: 1,
                    content: '<i class="fa fa-dashboard"></i> Dashboard'
                },
                data: {
                    requireLogin: false
                }
            },
            {
                name: "loginCustomerPortal",
                url: "/loginCustomerPortal",
                templateUrl: "modules/login/login.customer.portal.html",
                title: "login",
                settings: {
                    nav: 1,
                    content: '<i class="fa fa-dashboard"></i> Dashboard'
                },
                data: {
                    requireLogin: false
                }
            },
            {
                name: "resetpassword",
                url: "/resetpassword",
                templateUrl: "modules/reset_password/reset.password.html",
                title: "resetpassword",
                settings: {
                    nav: 1,
                    content: '<i class="fa fa-dashboard"></i> Dashboard'
                },
                data: {
                    requireLogin: false
                }
            },
            {
                name: "confirmDetails",
                url: "/confirmDetails",
                templateUrl: "modules/login/confirm.details.html",
                title: "confirmDetails",
                settings: {
                    nav: 1,
                    content: '<i class="fa fa-dashboard"></i> Dashboard'
                },
                data: {
                    requireLogin: false
                }
            },
            {
                name: "app",
                abstract: true,
                title: "welcome",
                settings: {
                    nav: 1,
                    content: '<i class="fa fa-dashboard"></i> Dashboard'
                },
                data: {
                    requireLogin: false
                }
            },
            {
                name: "shell",
                url: "/shell/:isCustomerPortalInAFa",
                templateUrl: function (parameters) {
                    if (parameters.isCustomerPortalInAFa) {
                        return "layout/shell.iframe.html";
                    }
                    else {
                        return "layout/shell.html";
                    }
                },
                title: "shell",
                settings: {
                    nav: 1,
                    content: '<i class="fa fa-dashboard"></i> Dashboard'
                },
                data: {
                    requireLogin: true
                },
                resolve: {
                    datacontext: [
                        "$q",
                        "$location",
                        "sharedDatacontext",
                        "assessmentDatacontext",
                        "mailDatacontext",
                        "upcomingEventDatacontext",
                        "navigationService",
                        "authenticationService",
                        "navigationDatacontext",
                        "customerPortalDatacontext",
                        "userManagementDatacontext",
                        "prescriptionDatacontext",
                        "supplierDatacontext",
                        "treatmentProductProducerDatacontext",
                        "attributeDatacontext",
                        function ($q, $location, sharedDatacontext, assessmentDatacontext, mailDatacontext, upcomingEventDatacontext, navigationService, authenticationService, navigationDatacontext, customerPortalDatacontext, userManagementDataContext, prescriptionDatacontext, supplierDatacontext, treatmentProductProducerDatacontext, attributeDataContext) {
                            return navigationService.checkServer().then(function () {
                                return $q
                                    .all([
                                    navigationService.getOrganisationTreeItems(),
                                    navigationService.getNavigationOptions(),
                                    $location.search().siteId
                                        ? navigationService.getUserCustomerId($location.search().siteId)
                                        : navigationService.getDefaultBusinessObject(),
                                    authenticationService.getCurrentUserCulture()
                                ])
                                    .then(function () {
                                    if ($location.search().siteId) {
                                        //going from AquaFarmer customer portal
                                        var result = navigationService.goToCustomerPortalSite(parseInt($location.search().siteId), $location.search().assessmentId, decodeURIComponent($location.search().siteName), $location.search().assessmentDate);
                                        if (!result)
                                            return $q.when();
                                    }
                                    return sharedDatacontext.init().then(function () {
                                        return assessmentDatacontext
                                            .initializeAssessmentDatacontext(sharedDatacontext.assessmentUnitOfWork)
                                            .then(function () {
                                            return mailDatacontext
                                                .init(sharedDatacontext.mailUnitOfWork)
                                                .then(function () {
                                                return $q
                                                    .all([
                                                    navigationService.initializeMenuItems(),
                                                    upcomingEventDatacontext.init(sharedDatacontext.eventUnitOfWork),
                                                    navigationDatacontext.init(sharedDatacontext.navigatoinUnitOfWork),
                                                    customerPortalDatacontext.init(sharedDatacontext.customerPortalUnitOfWork),
                                                    userManagementDataContext.init(sharedDatacontext.userManagementUnitOfWork),
                                                    prescriptionDatacontext.init(sharedDatacontext.assessmentUnitOfWork),
                                                    supplierDatacontext.init(sharedDatacontext.prescriptionUnitOfWork),
                                                    treatmentProductProducerDatacontext.init(sharedDatacontext.prescriptionUnitOfWork),
                                                    attributeDataContext.init(sharedDatacontext.attributeUnitOfWork)
                                                ])
                                                    .then(function () {
                                                    if (app.common.utils.refreshCachedData) {
                                                        return authenticationService.changeLanguage();
                                                    }
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        }
                    ],
                    pythonHandler: [
                        "pythonHandler",
                        function (pythonHandler) {
                            return pythonHandler.initializePythonHandler();
                        }
                    ]
                }
            },
            {
                name: "app.admin",
                url: "/admin",
                title: "admin",
                templateUrl: "admin/admin.html",
                settings: {
                    nav: 2,
                    content: '<i class="fa fa-lock"></i> Admin'
                },
                controller: "admin"
            },
            {
                name: "shell.assessments",
                url: "/",
                params: { view: null, type: null, assessmentTypeId: null },
                templateUrl: "modules/assessment_list/assessment.list.html",
                title: "assessments",
                settings: {
                    nav: 1,
                    content: '<i class="fa fa-dashboard"></i> Dashboard'
                },
                data: {
                    requireLogin: true
                },
                views: {
                    "main-content": {
                        templateUrl: "modules/assessment_list/assessment.list.html"
                    }
                }
            },
            {
                name: "shell.labtests",
                url: "/labtests",
                params: { view: "template", type: "Visit_LabTests" },
                templateUrl: "modules/assessment_list/assessment.list.html",
                title: "labtests",
                settings: {
                    nav: 1,
                    content: '<i class="fa fa-dashboard"></i> Dashboard'
                },
                data: {
                    requireLogin: true
                },
                views: {
                    "main-content": {
                        templateUrl: "modules/assessment_list/assessment.list.html"
                    }
                }
            },
            {
                name: "shell.upcomingevents",
                url: "/upcomingevents",
                params: { view: null, type: null },
                templateUrl: "modules/upcoming_events/upcoming.events.html",
                title: "upcomingevents",
                settings: {
                    nav: 1,
                    content: '<i class="fa fa-dashboard"></i> Dashboard'
                },
                data: {
                    requireLogin: true
                },
                views: {
                    "main-content": {
                        templateUrl: "modules/upcoming_events/upcoming.events.html"
                    }
                }
            },
            {
                name: "shell.prescriptions",
                url: "/prescriptions",
                params: { view: null, type: null },
                templateUrl: "modules/prescription/prescription.list.html",
                title: "prescriptions",
                settings: {
                    nav: 1,
                    content: '<i class="fa fa-dashboard"></i> Dashboard'
                },
                data: {
                    requireLogin: true
                },
                views: {
                    "main-content": {
                        templateUrl: "modules/prescription/prescription.list.html"
                    }
                }
            },
            {
                name: "shell.mycontact",
                url: "/mycontact",
                //templateUrl: 'modules/status_list/status.list.html',
                title: "mycontact",
                settings: {
                    nav: 1,
                    content: '<i class="fa fa-dashboard"></i> Dashboard'
                },
                data: {
                    requireLogin: true,
                    listview: "mycontact"
                },
                views: {
                    "main-content": {
                        templateUrl: "modules/my_contact/mycontact.html"
                    }
                }
            },
            {
                name: "shell.benchmarking",
                url: "/benchmarking",
                //templateUrl: 'modules/status_list/status.list.html',
                title: "benchmarking",
                settings: {
                    nav: 1,
                    content: '<i class="fa fa-dashboard"></i> Dashboard'
                },
                data: {
                    requireLogin: true,
                    listview: "benchmarking"
                },
                views: {
                    "main-content": {
                        templateUrl: "modules/benchmarking/benchmarking.html"
                    }
                }
            }
        ];
    }
})();

/*global angular:true, browser:true */

/**
 * @license HTTP Auth Interceptor Module for AngularJS
 * (c) 2012 Witold Szczerba
 * License: MIT
 */
(function () {
    'use strict';

    angular.module('http-auth-interceptor', ['http-auth-interceptor-buffer'])

    .factory('authService', ['$rootScope', 'httpBuffer', function ($rootScope, httpBuffer) {
        return {
            /**
             * Call this function to indicate that authentication was successfull and trigger a
             * retry of all deferred requests.
             * @param data an optional argument to pass on to $broadcast which may be useful for
             * example if you need to pass through details of the user that was logged in
             */
            loginConfirmed: function (data, configUpdater) {
                var updater = configUpdater || function (config) { return config; };
                $rootScope.$broadcast('event:auth-loginConfirmed', data);
                httpBuffer.retryAll(updater);
            },

            /**
             * Call this function to indicate that authentication should not proceed.
             * All deferred requests will be abandoned or rejected (if reason is provided).
             * @param data an optional argument to pass on to $broadcast.
             * @param reason if provided, the requests are rejected; abandoned otherwise.
             */
            loginCancelled: function (data, reason) {
                httpBuffer.rejectAll(reason);
                $rootScope.$broadcast('event:auth-loginCancelled', data);
            }
        };
    }])

    /**
     * $http interceptor.
     * On 401 response (without 'ignoreAuthModule' option) stores the request
     * and broadcasts 'event:angular-auth-loginRequired'.
     */
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push(['$rootScope', '$q', '$injector', 'httpBuffer', function ($rootScope, $q, $injector, httpBuffer) {
            return {
                responseError: function (rejection) {
                    if (rejection && rejection.error=== "invalid_grant") {
                        $rootScope.$broadcast('event:auth-loginRequired', rejection);
                    }
                    else if (rejection.status === 0) {
                        $rootScope.$broadcast("event:noConnection");
                    }
else if (rejection.status === 400 && rejection.data && rejection.data.error === "invalid_grant" && rejection.data.error_description !== "ErrorUserNameOrPassword") {
                        var authenticationService = $injector.get('authenticationService');
                        var env = $injector.get('ENV');
                        if (env.client_id === app.constants.applicationType.webApp) {
                            authenticationService.logoutDesktop();
                            location.reload();
                        }
                    } else if ((rejection.status === 401 || (rejection.data && rejection.data.ExceptionMessage != null && rejection.data.ExceptionMessage == "Unauthorized access")) && !rejection.config.ignoreAuthModule) {
                        var authenticationService = $injector.get('authenticationService');
                        authenticationService.refreshToken().then(function () {
                            //success
                            var deferred = $q.defer();
                            // rejection.config.transformResponse = null;
                            // rejection.config.transformRequest = null;
                            httpBuffer.append(rejection.config, deferred);
                            $rootScope.$broadcast('event:auth-loginConfirmed', rejection);
                            return deferred.promise;
                        }, function (exception) {
                            //err
                            var deferred = $q.defer();

                            if (exception.error !== "invalid_grant") {
                                httpBuffer.append(rejection.config, deferred);
                                $rootScope.$broadcast('event:auth-loginRequired', rejection);
                            }

                            return deferred.promise;
                        });


                    }

                    // otherwise, default behaviour
                    return $q.reject(rejection);
                },
              
                request: function (config) {

                    config.headers = config.headers || {};

                    config.headers.TimeZone = app.common.utils.getTimeZone();

                    var authenticationService = $injector.get('authenticationService');
                    var skipTokenValidation = config.url.indexOf("/oauth/token") > 0;
                    var credentials = authenticationService.credentialsGet();

                    if (skipTokenValidation && credentials != null) {
                        config.headers.Authorization = 'Bearer ' + credentials.Token;
                    }

                    return config;
                }
            };
        }]);
    }]);

    /**
     * Private module, a utility, required internally by 'http-auth-interceptor'.
     */
    angular.module('http-auth-interceptor-buffer', [])

    .factory('httpBuffer', ['$injector', function ($injector) {
        /** Holds all the requests, so they can be re-requested in future. */
        var buffer = [];

        /** Service initialized later because of circular dependency problem. */
        var $http;

        function retryHttpRequest(config, deferred) {
            function successCallback(response) {
                deferred.resolve(response);
            }
            function errorCallback(response) {
                deferred.reject(response);
            }
            $http = $http || $injector.get('$http');
            $http(config).then(successCallback, errorCallback);
        }

        return {
            /**
             * Appends HTTP request configuration object with deferred response attached to buffer.
             */
            append: function (config, deferred) {
                buffer.push({
                    config: config,
                    deferred: deferred
                });
            },

            /**
             * Abandon or reject (if reason provided) all the buffered requests.
             */
            rejectAll: function (reason) {
                if (reason) {
                    for (var i = 0; i < buffer.length; ++i) {
                        buffer[i].deferred.reject(reason);
                    }
                }
                buffer = [];
            },

            /**
             * Retries all the buffered requests clears the buffer.
             */
            retryAll: function (updater) {
                for (var i = 0; i < buffer.length; ++i) {
                    retryHttpRequest(updater(buffer[i].config), buffer[i].deferred);
                }
                buffer = [];
            }
        };
    }]);
})();
(function () {
    var fcsaNumberModule,
      __hasProp = {}.hasOwnProperty;

    fcsaNumberModule = angular.module('fcsa-number', []);

    fcsaNumberModule.directive('fcsaNumber', [
      'fcsaNumberConfig', '$locale', function (fcsaNumberConfig, $locale) {
          var addCommasToInteger, controlKeys, defaultOptions, getOptions, hasMultipleDecimals, isNotControlKey, isNotDigit, isNumber, makeIsValid, makeMaxDecimals, makeMaxDigits, makeMaxNumber, makeMinNumber
          defaultOptions = fcsaNumberConfig.defaultOptions;
            getOptions = function(scope) {
                var option, options, value, _ref;
                options = angular.copy(defaultOptions);
                if (scope.options != null) {
                    _ref = scope.$eval(scope.options);
                    for (option in _ref) {
                        if (!__hasProp.call(_ref, option)) continue;
                        value = _ref[option];
                        options[option] = value;
                    }
                }
                options.decimalSeparator = $locale.NUMBER_FORMATS.DECIMAL_SEP;
                options.decimalSeparatorRegExp = $locale.NUMBER_FORMATS.DECIMAL_SEP == "." ? "\\." : $locale.NUMBER_FORMATS.DECIMAL_SEP;
                options.thousandSeparator = $locale.NUMBER_FORMATS.GROUP_SEP;
                options.thousandSeparatorRegExp = $locale.NUMBER_FORMATS.GROUP_SEP == "." ? "\\." : $locale.NUMBER_FORMATS.GROUP_SEP;
                return options;
            };
          isNumber = function (val) {
              return !isNaN(parseFloat(val)) && isFinite(val);
          };
          isNotDigit = function (which) {
              return which < 44 || which > 57 || which === 47;
          };
          controlKeys = [0, 8, 13];
          isNotControlKey = function (which) {
              return controlKeys.indexOf(which) === -1;
          };
          hasMultipleDecimals = function (val, options) {
              return (val != null) && val.toString().split(options.decimalSeparator).length > 2;
          };
          makeMaxDecimals = function (maxDecimals, options) {
              var regexString, validRegex;
              if (maxDecimals > 0) {
                  regexString = "^-?\\d*" + options.decimalSeparatorRegExp + "?\\d{0," + maxDecimals + "}$";
              } else {
                  regexString = "^-?\\d*$";
              }
              validRegex = new RegExp(regexString);
              return function (val) {
                  return validRegex.test(val);
              };
          };
          makeMaxNumber = function (maxNumber) {
              return function (val, number) {
                  return number <= maxNumber;
              };
          };
          makeMinNumber = function (minNumber) {
              return function (val, number) {
                  return number >= minNumber;
              };
          };
          makeMaxDigits = function (maxDigits, options) {
              var validRegex;
              validRegex = new RegExp("^-?\\d{0," + maxDigits + "}(" + options.decimalSeparatorRegExp + "\\d*)?$");
              return function (val) {
                  return validRegex.test(val);
              };
          };
          makeIsValid = function (options) {
              var validations;
              validations = [];
              if (options.maxDecimals != null) {
                  validations.push(makeMaxDecimals(options.maxDecimals, options));
              }
              if (options.max != null) {
                  validations.push(makeMaxNumber(options.max, options));
              }
              if (options.min != null) {
                  validations.push(makeMinNumber(options.min, options));
              }
              if (options.maxDigits != null) {
                  validations.push(makeMaxDigits(options.maxDigits, options));
              }
              return function (val) {
                  var i, number, _i, _ref;
                  if (!isNumber(val.replace(",", "."))) {
                      return false;
                  }
                  if (hasMultipleDecimals(val, options)) {
                      return false;
                  }
                  number = Number(val);
                  for (i = _i = 0, _ref = validations.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
                      if (!validations[i](val, number, options)) {
                          return false;
                      }
                  }
                  return true;
              };
          };
          addCommasToInteger = function (val, options) {
              var commas, decimals, wholeNumbers;
              decimals = val.indexOf(options.decimalSeparator) == -1 ? '' : val.replace(new RegExp("^\\d+(?=" + options.decimalSeparatorRegExp + ")"), '');
              wholeNumbers = val.replace(new RegExp("(" + options.decimalSeparatorRegExp + "\\d*)$"), '');
              commas = wholeNumbers.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + options.thousandSeparator);
              return "" + commas + decimals;
          };
          return {
              restrict: 'A',
              require: 'ngModel',
              scope: {
                  options: '@fcsaNumber'
              },
              link: function (scope, elem, attrs, ngModelCtrl) {
                  var isValid, options;
                  options = getOptions(scope);
                  isValid = makeIsValid(options);
                  ngModelCtrl.$options.allowInvalid = true;
                  ngModelCtrl.$parsers.unshift(function (viewVal) {
                      var noCommasVal;
                      if (viewVal == null)
                          viewVal = "";
                      noCommasVal = viewVal.replace(new RegExp(options.thousandSeparatorRegExp, "g"), '');
                      if (isValid(noCommasVal) || !noCommasVal) {
                          ngModelCtrl.$setValidity('fcsaNumber', true);
                          return noCommasVal;
                      } else {
                          ngModelCtrl.$setValidity('fcsaNumber', false);
                          return viewVal;
                      }
                  });
                  ngModelCtrl.$formatters.push(function (val) {
                      if ((options.nullDisplay != null) && (!val || val === '')) {
                          return options.nullDisplay;
                      }
                      if ((val == null) || !isValid(val)) {
                          return val;
                      }
                      ngModelCtrl.$setValidity('fcsaNumber', true);
                      val = addCommasToInteger(val.toString(), options);
                      if (options.prepend != null) {
                          val = "" + options.prepend + val;
                      }
                      if (options.append != null) {
                          val = "" + val + options.append;
                      }
                      return val;
                  });
                  elem.on('blur', function () {
                      var formatter, viewValue, _i, _len, _ref;
                      ngModelCtrl.$commitViewValue();
                      viewValue = ngModelCtrl.$modelValue;
                      if ((viewValue == null) || !isValid(viewValue)) {
                          return;
                      }
                      _ref = ngModelCtrl.$formatters;
                      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                          formatter = _ref[_i];
                          viewValue = formatter(viewValue);
                      }
                      ngModelCtrl.$viewValue = viewValue;
                      return ngModelCtrl.$render();
                  });
                  elem.on('focus', function () {
                      var val;
                      val = elem.val();
                      if (options.prepend != null) {
                          val = val.replace(options.prepend, '');
                      }
                      if (options.append != null) {
                          val = val.replace(options.append, '');
                      }
                      elem.val(val.replace(new RegExp(options.thousandSeparatorRegExp, "g"), ''));
                      return elem[0].select();
                  });
                  if (options.preventInvalidInput === true) {
                      return elem.on('keypress', function (e) {
                          if (isNotDigit(e.which) && isNotControlKey(e.which)) {
                              return e.preventDefault();
                          }
                      });
                  }
              }
          };
      }
    ]);

    fcsaNumberModule.provider('fcsaNumberConfig', function () {
        var _defaultOptions;
        _defaultOptions = {};
        this.setDefaultOptions = function (defaultOptions) {
            return _defaultOptions = defaultOptions;
        };
        this.$get = function () {
            return {
                defaultOptions: _defaultOptions
            };
        };
    });

}).call(this);

(function (window, angular, jQuery, undefined) {
    'use strict';

    angular.module('froala', [])
        .value('froalaConfig', {})
        .directive('froala', ['froalaConfig', function (froalaConfig) {
            "use strict"; //Scope strict mode to only this directive
            var generatedIds = 0;
            var defaultConfig = {
                immediateAngularModelUpdate: false,
                angularIgnoreAttrs: null
            };

            var innerHtmlAttr = 'innerHTML';

            var scope = {
                froalaOptions: '=froala',
                initFunction: '&froalaInit'
            };

            froalaConfig = froalaConfig || {};

            // Constants
            var MANUAL = "manual";
            var AUTOMATIC = "automatic";
            var SPECIAL_TAGS = ['img', 'button', 'input', 'a'];

            return {
                restrict: 'A',
                require: 'ngModel',
                scope: scope,
                link: function (scope, element, attrs, ngModel) {
                    if (jQuery) element = jQuery(element);

                    var specialTag = false;
                    if (SPECIAL_TAGS.indexOf(element.prop("tagName").toLowerCase()) != -1) {
                        specialTag = true;
                    }

                    var ctrl = {
                        editorInitialized: false
                    };

                    var firstTime = false;

                    scope.initMode = attrs.froalaInit ? MANUAL : AUTOMATIC;

                    ctrl.init = function () {
                        if (!attrs.id) {
                            // generate an ID if not present
                            attrs.$set('id', 'froala-' + generatedIds++);
                        }

                        //init the editor
                        if (scope.initMode === AUTOMATIC) {
                            ctrl.createEditor();
                        }

                        //Instruct ngModel how to update the froala editor
                        ngModel.$render = function () {
                            // Update special tags.
                            if (specialTag) {
                                var tags = ngModel.$modelValue;

                                // add tags on element
                                if (tags) {
                                    for (var attr in tags) {
                                        if (tags.hasOwnProperty(attr) && attr != innerHtmlAttr) {
                                            element.attr(attr, tags[attr]);
                                        }
                                    }
                                    if (tags.hasOwnProperty(innerHtmlAttr)) {
                                        element[0].innerHTML = tags[innerHtmlAttr];
                                    }
                                }
                            }
                            else {
                                if (ctrl.editorInitialized) {
                                    // Set HTML.
                                    element.froalaEditor('html.set', ngModel.$viewValue || '', true);

                                    //This will reset the undo stack everytime the model changes externally. Can we fix this?
                                    element.froalaEditor('undo.reset');
                                    element.froalaEditor('undo.saveStep');
                                }
                            }
                        };

                        ngModel.$isEmpty = function (value) {
                            if (!value) {
                                return true;
                            }

                            if (ctrl.editorInitialized) {
                                return element.froalaEditor('node.isEmpty', jQuery('<div>' + value + '</div>').get(0));
                            }

                            return true;
                        };
                    };

                    ctrl.createEditor = function (froalaInitOptions) {
                        ctrl.listeningEvents = ['froalaEditor'];
                        if (!ctrl.editorInitialized) {
                            froalaInitOptions = (froalaInitOptions || {});
                            ctrl.options = angular.extend({}, defaultConfig, froalaConfig, scope.froalaOptions, froalaInitOptions);

                            ctrl.registerEventsWithCallbacks('froalaEditor.initializationDelayed', function () {
                                ngModel.$render()
                            });

                            ctrl.registerEventsWithCallbacks('froalaEditor.initialized', function () {
                                ctrl.editorInitialized = true;
                            })

                            // Register events provided in the options
                            // Registering events before initializing the editor will bind the initialized event correctly.
                            for (var eventName in ctrl.options.events) {
                                if (ctrl.options.events.hasOwnProperty(eventName)) {
                                    ctrl.registerEventsWithCallbacks(eventName, ctrl.options.events[eventName]);
                                }
                            }

                            element.innerHTML =
                                ctrl.froalaElement = element.froalaEditor(ctrl.options).data('froala.editor').$el;
                            ctrl.froalaEditor = angular.bind(element, element.froalaEditor);
                            ctrl.initListeners();

                            //assign the froala instance to the options object to make methods available in parent scope
                            if (scope.froalaOptions) {
                                scope.froalaOptions.froalaEditor = ctrl.froalaEditor;
                            }
                        }
                    };

                    ctrl.initListeners = function () {
                        if (ctrl.options.immediateAngularModelUpdate) {
                            ctrl.froalaElement.on('froalaEditor.keyup', function () {
                                scope.$evalAsync(ctrl.updateModelView);
                            });
                        }

                        element.on('froalaEditor.contentChanged', function () {
                            scope.$evalAsync(ctrl.updateModelView);
                        });

                        element.bind('$destroy', function () {
                            if (element) {
                                element.froalaEditor('destroy');
                                element = null;
                            }
                        });
                    };

                    ctrl.updateModelView = function () {

                        var modelContent = null;

                        if (specialTag) {
                            var attributeNodes = element[0].attributes;
                            var attrs = {};

                            for (var i = 0; i < attributeNodes.length; i++) {
                                var attrName = attributeNodes[i].name;
                                if (ctrl.options.angularIgnoreAttrs && ctrl.options.angularIgnoreAttrs.indexOf(attrName) != -1) {
                                    continue;
                                }
                                attrs[attrName] = attributeNodes[i].value;
                            }
                            if (element[0].innerHTML) {
                                attrs[innerHtmlAttr] = element[0].innerHTML;
                            }
                            modelContent = attrs;
                        } else {
                            var returnedHtml = element.froalaEditor('html.get');
                            if (angular.isString(returnedHtml)) {
                                modelContent = returnedHtml;
                            }
                        }

                        ngModel.$setViewValue(modelContent);
                        if (!scope.$root.$$phase) {
                            scope.$apply();
                        }
                    };

                    ctrl.registerEventsWithCallbacks = function (eventName, callback) {
                        if (eventName && callback) {
                            ctrl.listeningEvents.push(eventName);
                            element.on(eventName, callback);
                        }
                    };

                    if (scope.initMode === MANUAL) {
                        var _ctrl = ctrl;
                        var controls = {
                            initialize: ctrl.createEditor,
                            destroy: function () {
                                if (_ctrl.froalaEditor) {
                                    _ctrl.froalaEditor('destroy');
                                    _ctrl.editorInitialized = false;
                                }
                            },
                            getEditor: function () {
                                return _ctrl.froalaEditor ? _ctrl.froalaEditor : null;
                            }
                        };
                        scope.initFunction({
                            initControls: controls
                        });
                    }
                    ctrl.init();
                }
            };
        }])
        .directive('froalaView', ['$sce', function ($sce) {
            return {
                restrict: 'ACM',
                scope: false,
                link: function (scope, element, attrs) {
                    element.addClass('fr-view');
                    scope.$watch(attrs.froalaView, function (nv) {
                        if (nv || nv === '') {
                            var explicitlyTrustedValue = $sce.trustAsHtml(nv);
                            element.html(explicitlyTrustedValue.toString());
                        }
                    });
                }
            };
        }]);
})(window, window.angular, window.jQuery);
var app;
(function (app) {
    var enums;
    (function (enums) {
        (function (entityType) {
            entityType[entityType["AccountUser"] = 0] = "AccountUser";
            entityType[entityType["AccountUserMap"] = 1] = "AccountUserMap";
            entityType[entityType["ActiveSubstance"] = 2] = "ActiveSubstance";
            entityType[entityType["ActiveSubstanceMap"] = 3] = "ActiveSubstanceMap";
            entityType[entityType["Activity"] = 4] = "Activity";
            entityType[entityType["Address"] = 5] = "Address";
            entityType[entityType["AddressMap"] = 6] = "AddressMap";
            entityType[entityType["AddressType"] = 7] = "AddressType";
            entityType[entityType["AddressTypeMap"] = 8] = "AddressTypeMap";
            entityType[entityType["AllowedRegistration"] = 9] = "AllowedRegistration";
            entityType[entityType["ApplicationErrorReport"] = 10] = "ApplicationErrorReport";
            entityType[entityType["ApplicationErrorReportWrapper"] = 11] = "ApplicationErrorReportWrapper";
            entityType[entityType["ApplicationSetting"] = 12] = "ApplicationSetting";
            entityType[entityType["ApplicationSettingMap"] = 13] = "ApplicationSettingMap";
            entityType[entityType["ApplicationTypes"] = 14] = "ApplicationTypes";
            entityType[entityType["AquaVetActivityExport"] = 15] = "AquaVetActivityExport";
            entityType[entityType["Area"] = 16] = "Area";
            entityType[entityType["AreaDTO"] = 17] = "AreaDTO";
            entityType[entityType["AreaMap"] = 18] = "AreaMap";
            entityType[entityType["Assessment"] = 19] = "Assessment";
            entityType[entityType["AssessmentDiscriminator"] = 20] = "AssessmentDiscriminator";
            entityType[entityType["AssessmentDTO"] = 21] = "AssessmentDTO";
            entityType[entityType["AssessmentFollowUpStatu"] = 22] = "AssessmentFollowUpStatu";
            entityType[entityType["AssessmentFollowUpStatuMap"] = 23] = "AssessmentFollowUpStatuMap";
            entityType[entityType["AssessmentFollowUpStatus"] = 24] = "AssessmentFollowUpStatus";
            entityType[entityType["AssessmentFollowUpStatusMap"] = 25] = "AssessmentFollowUpStatusMap";
            entityType[entityType["AssessmentMap"] = 26] = "AssessmentMap";
            entityType[entityType["AssessmentReport"] = 27] = "AssessmentReport";
            entityType[entityType["AssessmentSummary"] = 28] = "AssessmentSummary";
            entityType[entityType["AssessmentType"] = 29] = "AssessmentType";
            entityType[entityType["AssessmentTypeEnums"] = 30] = "AssessmentTypeEnums";
            entityType[entityType["AssessmentTypeGroup"] = 31] = "AssessmentTypeGroup";
            entityType[entityType["AssessmentTypeGroupMap"] = 32] = "AssessmentTypeGroupMap";
            entityType[entityType["AssessmentTypeMap"] = 33] = "AssessmentTypeMap";
            entityType[entityType["AssessmentWarning"] = 34] = "AssessmentWarning";
            entityType[entityType["Attribute"] = 35] = "Attribute";
            entityType[entityType["AttributeCategory"] = 36] = "AttributeCategory";
            entityType[entityType["AttributeCategoryMap"] = 37] = "AttributeCategoryMap";
            entityType[entityType["AttributeDetails"] = 38] = "AttributeDetails";
            entityType[entityType["AttributeMap"] = 39] = "AttributeMap";
            entityType[entityType["AttributeMetadata"] = 40] = "AttributeMetadata";
            entityType[entityType["AttributeMetadataEnum"] = 41] = "AttributeMetadataEnum";
            entityType[entityType["AttributeMetadataEnumMap"] = 42] = "AttributeMetadataEnumMap";
            entityType[entityType["AttributeMetadataEnums"] = 43] = "AttributeMetadataEnums";
            entityType[entityType["AttributeMetadataMap"] = 44] = "AttributeMetadataMap";
            entityType[entityType["AttributeMetadataType"] = 45] = "AttributeMetadataType";
            entityType[entityType["AttributeMetadataTypeMap"] = 46] = "AttributeMetadataTypeMap";
            entityType[entityType["AttributeType"] = 47] = "AttributeType";
            entityType[entityType["AttributeTypeMap"] = 48] = "AttributeTypeMap";
            entityType[entityType["Audit"] = 49] = "Audit";
            entityType[entityType["AuditDTO"] = 50] = "AuditDTO";
            entityType[entityType["AuditMap"] = 51] = "AuditMap";
            entityType[entityType["AuditType"] = 52] = "AuditType";
            entityType[entityType["AuditTypeMap"] = 53] = "AuditTypeMap";
            entityType[entityType["AverageScoreChartItem"] = 54] = "AverageScoreChartItem";
            entityType[entityType["BaseObject"] = 55] = "BaseObject";
            entityType[entityType["BranchOffice"] = 56] = "BranchOffice";
            entityType[entityType["BranchOfficeMap"] = 57] = "BranchOfficeMap";
            entityType[entityType["BugReportInfo"] = 58] = "BugReportInfo";
            entityType[entityType["Chart"] = 59] = "Chart";
            entityType[entityType["ChartComparisonOption"] = 60] = "ChartComparisonOption";
            entityType[entityType["ChartItem"] = 61] = "ChartItem";
            entityType[entityType["ChartMap"] = 62] = "ChartMap";
            entityType[entityType["ChartOption"] = 63] = "ChartOption";
            entityType[entityType["Client"] = 64] = "Client";
            entityType[entityType["Company"] = 65] = "Company";
            entityType[entityType["CompanyAddress"] = 66] = "CompanyAddress";
            entityType[entityType["CompanyAddressMap"] = 67] = "CompanyAddressMap";
            entityType[entityType["CompanyBU"] = 68] = "CompanyBU";
            entityType[entityType["CompanyBUAddress"] = 69] = "CompanyBUAddress";
            entityType[entityType["CompanyBUAddressMap"] = 70] = "CompanyBUAddressMap";
            entityType[entityType["CompanyBUContactPerson"] = 71] = "CompanyBUContactPerson";
            entityType[entityType["CompanyBUContactPersonMap"] = 72] = "CompanyBUContactPersonMap";
            entityType[entityType["CompanyBuDTO"] = 73] = "CompanyBuDTO";
            entityType[entityType["CompanyBUMap"] = 74] = "CompanyBUMap";
            entityType[entityType["CompanyContactPerson"] = 75] = "CompanyContactPerson";
            entityType[entityType["CompanyContactPersonMap"] = 76] = "CompanyContactPersonMap";
            entityType[entityType["CompanyDTO"] = 77] = "CompanyDTO";
            entityType[entityType["CompanyMap"] = 78] = "CompanyMap";
            entityType[entityType["ContactPerson"] = 79] = "ContactPerson";
            entityType[entityType["ContactPersonMap"] = 80] = "ContactPersonMap";
            entityType[entityType["ContactType"] = 81] = "ContactType";
            entityType[entityType["ContactTypeMap"] = 82] = "ContactTypeMap";
            entityType[entityType["Country"] = 83] = "Country";
            entityType[entityType["CountryMap"] = 84] = "CountryMap";
            entityType[entityType["CrmImportSitePlacement"] = 85] = "CrmImportSitePlacement";
            entityType[entityType["CrmImportUpdatedObject"] = 86] = "CrmImportUpdatedObject";
            entityType[entityType["Currency"] = 87] = "Currency";
            entityType[entityType["CurrencyMap"] = 88] = "CurrencyMap";
            entityType[entityType["Customer"] = 89] = "Customer";
            entityType[entityType["CustomerAddress"] = 90] = "CustomerAddress";
            entityType[entityType["CustomerAddressMap"] = 91] = "CustomerAddressMap";
            entityType[entityType["CustomerBU"] = 92] = "CustomerBU";
            entityType[entityType["CustomerBUAddress"] = 93] = "CustomerBUAddress";
            entityType[entityType["CustomerBUAddressMap"] = 94] = "CustomerBUAddressMap";
            entityType[entityType["CustomerBUContactPerson"] = 95] = "CustomerBUContactPerson";
            entityType[entityType["CustomerBUContactPersonMap"] = 96] = "CustomerBUContactPersonMap";
            entityType[entityType["CustomerBuDTO"] = 97] = "CustomerBuDTO";
            entityType[entityType["CustomerBUMap"] = 98] = "CustomerBUMap";
            entityType[entityType["CustomerContactPerson"] = 99] = "CustomerContactPerson";
            entityType[entityType["CustomerContactPersonMap"] = 100] = "CustomerContactPersonMap";
            entityType[entityType["CustomerDTO"] = 101] = "CustomerDTO";
            entityType[entityType["CustomerMap"] = 102] = "CustomerMap";
            entityType[entityType["CustomerUserBusinessObject"] = 103] = "CustomerUserBusinessObject";
            entityType[entityType["DbVersion"] = 104] = "DbVersion";
            entityType[entityType["DbVersionMap"] = 105] = "DbVersionMap";
            entityType[entityType["DbVersionType"] = 106] = "DbVersionType";
            entityType[entityType["DbversionTypeMap"] = 107] = "DbversionTypeMap";
            entityType[entityType["DeviceType"] = 108] = "DeviceType";
            entityType[entityType["DeviceTypeMap"] = 109] = "DeviceTypeMap";
            entityType[entityType["Diagnosis"] = 110] = "Diagnosis";
            entityType[entityType["DiagnosisMap"] = 111] = "DiagnosisMap";
            entityType[entityType["Dictionary"] = 112] = "Dictionary";
            entityType[entityType["DictionaryMap"] = 113] = "DictionaryMap";
            entityType[entityType["ELMAH_Error"] = 114] = "ELMAH_Error";
            entityType[entityType["ELMAH_ErrorMap"] = 115] = "ELMAH_ErrorMap";
            entityType[entityType["Event"] = 116] = "Event";
            entityType[entityType["EventDTO"] = 117] = "EventDTO";
            entityType[entityType["EventMap"] = 118] = "EventMap";
            entityType[entityType["Experience"] = 119] = "Experience";
            entityType[entityType["ExperienceFile"] = 120] = "ExperienceFile";
            entityType[entityType["ExperienceFileMap"] = 121] = "ExperienceFileMap";
            entityType[entityType["ExperienceMap"] = 122] = "ExperienceMap";
            entityType[entityType["ExternalLoginConfirmationViewModel"] = 123] = "ExternalLoginConfirmationViewModel";
            entityType[entityType["ExternalLoginListViewModel"] = 124] = "ExternalLoginListViewModel";
            entityType[entityType["File"] = 125] = "File";
            entityType[entityType["File1"] = 126] = "File1";
            entityType[entityType["File1Map"] = 127] = "File1Map";
            entityType[entityType["FileCategory"] = 128] = "FileCategory";
            entityType[entityType["FileCategoryMap"] = 129] = "FileCategoryMap";
            entityType[entityType["FileMap"] = 130] = "FileMap";
            entityType[entityType["FileRepositoryDbVersion"] = 131] = "FileRepositoryDbVersion";
            entityType[entityType["FileRepositoryDbVersionMap"] = 132] = "FileRepositoryDbVersionMap";
            entityType[entityType["FilesToImport"] = 133] = "FilesToImport";
            entityType[entityType["FilesToImportMap"] = 134] = "FilesToImportMap";
            entityType[entityType["FileType"] = 135] = "FileType";
            entityType[entityType["FileType1"] = 136] = "FileType1";
            entityType[entityType["FileType1Map"] = 137] = "FileType1Map";
            entityType[entityType["FileTypeMap"] = 138] = "FileTypeMap";
            entityType[entityType["Fishgroup"] = 139] = "Fishgroup";
            entityType[entityType["FishgroupMap"] = 140] = "FishgroupMap";
            entityType[entityType["FishSampleData"] = 141] = "FishSampleData";
            entityType[entityType["Folder"] = 142] = "Folder";
            entityType[entityType["FolderMap"] = 143] = "FolderMap";
            entityType[entityType["FolderOperationUnit"] = 144] = "FolderOperationUnit";
            entityType[entityType["FolderOperationUnitMap"] = 145] = "FolderOperationUnitMap";
            entityType[entityType["ForgotPasswordViewModel"] = 146] = "ForgotPasswordViewModel";
            entityType[entityType["ForgotViewModel"] = 147] = "ForgotViewModel";
            entityType[entityType["Generation"] = 148] = "Generation";
            entityType[entityType["GenerationMap"] = 149] = "GenerationMap";
            entityType[entityType["Image"] = 150] = "Image";
            entityType[entityType["ImageLogo"] = 151] = "ImageLogo";
            entityType[entityType["ImageLogoMap"] = 152] = "ImageLogoMap";
            entityType[entityType["ImageMap"] = 153] = "ImageMap";
            entityType[entityType["IntegrationLog"] = 154] = "IntegrationLog";
            entityType[entityType["IntegrationLogMap"] = 155] = "IntegrationLogMap";
            entityType[entityType["IntegrationServiceConfiguration"] = 156] = "IntegrationServiceConfiguration";
            entityType[entityType["IntegrationServiceConfigurationMap"] = 157] = "IntegrationServiceConfigurationMap";
            entityType[entityType["LabTest"] = 158] = "LabTest";
            entityType[entityType["LabTestDiagnosi"] = 159] = "LabTestDiagnosi";
            entityType[entityType["LabTestDiagnosiMap"] = 160] = "LabTestDiagnosiMap";
            entityType[entityType["LabTestMap"] = 161] = "LabTestMap";
            entityType[entityType["Language"] = 162] = "Language";
            entityType[entityType["LanguageMap"] = 163] = "LanguageMap";
            entityType[entityType["Localization"] = 164] = "Localization";
            entityType[entityType["LocalizationMap"] = 165] = "LocalizationMap";
            entityType[entityType["Login"] = 166] = "Login";
            entityType[entityType["LoginViewModel"] = 167] = "LoginViewModel";
            entityType[entityType["MainOffice"] = 168] = "MainOffice";
            entityType[entityType["MainOfficeMap"] = 169] = "MainOfficeMap";
            entityType[entityType["MeasureUnit"] = 170] = "MeasureUnit";
            entityType[entityType["MeasureUnitMap"] = 171] = "MeasureUnitMap";
            entityType[entityType["MobileLog"] = 172] = "MobileLog";
            entityType[entityType["MobileLogMap"] = 173] = "MobileLogMap";
            entityType[entityType["NavigationMenu"] = 174] = "NavigationMenu";
            entityType[entityType["NavigationMenuMap"] = 175] = "NavigationMenuMap";
            entityType[entityType["NavigationOption"] = 176] = "NavigationOption";
            entityType[entityType["NavigationOptionMap"] = 177] = "NavigationOptionMap";
            entityType[entityType["NavigationSubOption"] = 178] = "NavigationSubOption";
            entityType[entityType["NavigationSubOptionMap"] = 179] = "NavigationSubOptionMap";
            entityType[entityType["NavigationURL"] = 180] = "NavigationURL";
            entityType[entityType["NavigationURLMap"] = 181] = "NavigationURLMap";
            entityType[entityType["NotAssignedAccount"] = 182] = "NotAssignedAccount";
            entityType[entityType["NotAssignedAccountMap"] = 183] = "NotAssignedAccountMap";
            entityType[entityType["NotAssignedAddress"] = 184] = "NotAssignedAddress";
            entityType[entityType["NotAssignedAddressMap"] = 185] = "NotAssignedAddressMap";
            entityType[entityType["Notification"] = 186] = "Notification";
            entityType[entityType["NotificationMap"] = 187] = "NotificationMap";
            entityType[entityType["NotificationType"] = 188] = "NotificationType";
            entityType[entityType["NotificationTypeMap"] = 189] = "NotificationTypeMap";
            entityType[entityType["Operation"] = 190] = "Operation";
            entityType[entityType["OperationDTO"] = 191] = "OperationDTO";
            entityType[entityType["OperationMap"] = 192] = "OperationMap";
            entityType[entityType["OperationType"] = 193] = "OperationType";
            entityType[entityType["OperationTypeMap"] = 194] = "OperationTypeMap";
            entityType[entityType["OperationUnitType"] = 195] = "OperationUnitType";
            entityType[entityType["OperationUnitTypeMap"] = 196] = "OperationUnitTypeMap";
            entityType[entityType["Password"] = 197] = "Password";
            entityType[entityType["PercentileChartData"] = 198] = "PercentileChartData";
            entityType[entityType["PercentileChartItem"] = 199] = "PercentileChartItem";
            entityType[entityType["PercentileSummary"] = 200] = "PercentileSummary";
            entityType[entityType["PhoneCall"] = 201] = "PhoneCall";
            entityType[entityType["PhoneCallMap"] = 202] = "PhoneCallMap";
            entityType[entityType["PrecisionScoreDetail"] = 203] = "PrecisionScoreDetail";
            entityType[entityType["PrecisionScoreKeyNumbers"] = 204] = "PrecisionScoreKeyNumbers";
            entityType[entityType["Prescription"] = 205] = "Prescription";
            entityType[entityType["PrescriptionDTO"] = 206] = "PrescriptionDTO";
            entityType[entityType["PrescriptionMap"] = 207] = "PrescriptionMap";
            entityType[entityType["PrescriptionReport"] = 208] = "PrescriptionReport";
            entityType[entityType["PrescriptionSummary"] = 209] = "PrescriptionSummary";
            entityType[entityType["ProductionStage"] = 210] = "ProductionStage";
            entityType[entityType["ProductionStageMap"] = 211] = "ProductionStageMap";
            entityType[entityType["PvFlag"] = 212] = "PvFlag";
            entityType[entityType["QuarantineType"] = 213] = "QuarantineType";
            entityType[entityType["QuarantineTypeMap"] = 214] = "QuarantineTypeMap";
            entityType[entityType["RefreshToken"] = 215] = "RefreshToken";
            entityType[entityType["Region"] = 216] = "Region";
            entityType[entityType["RegionalAuthority"] = 217] = "RegionalAuthority";
            entityType[entityType["RegionalAuthorityMap"] = 218] = "RegionalAuthorityMap";
            entityType[entityType["RegionDTO"] = 219] = "RegionDTO";
            entityType[entityType["RegionMap"] = 220] = "RegionMap";
            entityType[entityType["RegisterViewModel"] = 221] = "RegisterViewModel";
            entityType[entityType["RegistrationType"] = 222] = "RegistrationType";
            entityType[entityType["RegistrationTypeMap"] = 223] = "RegistrationTypeMap";
            entityType[entityType["ResetPasswordViewModel"] = 224] = "ResetPasswordViewModel";
            entityType[entityType["Revision"] = 225] = "Revision";
            entityType[entityType["RevisionArchiveFile"] = 226] = "RevisionArchiveFile";
            entityType[entityType["RevisionArchiveFileMap"] = 227] = "RevisionArchiveFileMap";
            entityType[entityType["RevisionMap"] = 228] = "RevisionMap";
            entityType[entityType["Role"] = 229] = "Role";
            entityType[entityType["RoleMap"] = 230] = "RoleMap";
            entityType[entityType["RoleNavigationOptionDefault"] = 231] = "RoleNavigationOptionDefault";
            entityType[entityType["RoleNavigationOptionDefaultMap"] = 232] = "RoleNavigationOptionDefaultMap";
            entityType[entityType["RoleOperationUnitType"] = 233] = "RoleOperationUnitType";
            entityType[entityType["RoleOperationUnitTypeMap"] = 234] = "RoleOperationUnitTypeMap";
            entityType[entityType["SecurityLevel"] = 235] = "SecurityLevel";
            entityType[entityType["SecurityLevelMap"] = 236] = "SecurityLevelMap";
            entityType[entityType["SentMail"] = 237] = "SentMail";
            entityType[entityType["SentMailDTO"] = 238] = "SentMailDTO";
            entityType[entityType["SentMailMap"] = 239] = "SentMailMap";
            entityType[entityType["Series"] = 240] = "Series";
            entityType[entityType["SeriesMap"] = 241] = "SeriesMap";
            entityType[entityType["SideEffectKeyNumbers"] = 242] = "SideEffectKeyNumbers";
            entityType[entityType["SideEffectsScoreDetail"] = 243] = "SideEffectsScoreDetail";
            entityType[entityType["SideEffectsScoreItem"] = 244] = "SideEffectsScoreItem";
            entityType[entityType["SignatureByUser"] = 245] = "SignatureByUser";
            entityType[entityType["SignatureByUserMap"] = 246] = "SignatureByUserMap";
            entityType[entityType["Site"] = 247] = "Site";
            entityType[entityType["SiteAddress"] = 248] = "SiteAddress";
            entityType[entityType["SiteAddressMap"] = 249] = "SiteAddressMap";
            entityType[entityType["SiteContactPerson"] = 250] = "SiteContactPerson";
            entityType[entityType["SiteContactPersonMap"] = 251] = "SiteContactPersonMap";
            entityType[entityType["SiteDTO"] = 252] = "SiteDTO";
            entityType[entityType["SiteLicenseNumber"] = 253] = "SiteLicenseNumber";
            entityType[entityType["SiteLicenseNumberMap"] = 254] = "SiteLicenseNumberMap";
            entityType[entityType["SiteMap"] = 255] = "SiteMap";
            entityType[entityType["SiteType"] = 256] = "SiteType";
            entityType[entityType["SiteTypeMap"] = 257] = "SiteTypeMap";
            entityType[entityType["SiteVetContactPerson"] = 258] = "SiteVetContactPerson";
            entityType[entityType["SiteVetContactPersonMap"] = 259] = "SiteVetContactPersonMap";
            entityType[entityType["Specie"] = 260] = "Specie";
            entityType[entityType["SpecieMap"] = 261] = "SpecieMap";
            entityType[entityType["State"] = 262] = "State";
            entityType[entityType["Supplier"] = 263] = "Supplier";
            entityType[entityType["SupplierMap"] = 264] = "SupplierMap";
            entityType[entityType["SupplierType"] = 265] = "SupplierType";
            entityType[entityType["SupplierTypeMap"] = 266] = "SupplierTypeMap";
            entityType[entityType["Template"] = 267] = "Template";
            entityType[entityType["TemplateType"] = 268] = "TemplateType";
            entityType[entityType["TemplateGroup"] = 269] = "TemplateGroup";
            entityType[entityType["TemplateGroupMap"] = 270] = "TemplateGroupMap";
            entityType[entityType["TemplateItem"] = 271] = "TemplateItem";
            entityType[entityType["TemplateItemMap"] = 272] = "TemplateItemMap";
            entityType[entityType["TemplateMap"] = 273] = "TemplateMap";
            entityType[entityType["TemplateTypeMap"] = 274] = "TemplateTypeMap";
            entityType[entityType["TemplateRegistration"] = 275] = "TemplateRegistration";
            entityType[entityType["TemplateRegistrationDTO"] = 276] = "TemplateRegistrationDTO";
            entityType[entityType["TemplateRegistrationMap"] = 277] = "TemplateRegistrationMap";
            entityType[entityType["Title"] = 278] = "Title";
            entityType[entityType["TitleMap"] = 279] = "TitleMap";
            entityType[entityType["TreatmentProduct"] = 280] = "TreatmentProduct";
            entityType[entityType["TreatmentProductIndication"] = 281] = "TreatmentProductIndication";
            entityType[entityType["TreatmentProductIndicationMap"] = 282] = "TreatmentProductIndicationMap";
            entityType[entityType["TreatmentProductMap"] = 283] = "TreatmentProductMap";
            entityType[entityType["TreatmentProductProducer"] = 284] = "TreatmentProductProducer";
            entityType[entityType["TreatmentProductProducerMap"] = 285] = "TreatmentProductProducerMap";
            entityType[entityType["TreeNode"] = 286] = "TreeNode";
            entityType[entityType["TreeNodeMap"] = 287] = "TreeNodeMap";
            entityType[entityType["User"] = 288] = "User";
            entityType[entityType["UserAccess"] = 289] = "UserAccess";
            entityType[entityType["UserAccessMap"] = 290] = "UserAccessMap";
            entityType[entityType["UserAccessRights"] = 291] = "UserAccessRights";
            entityType[entityType["UserAssessment"] = 292] = "UserAssessment";
            entityType[entityType["UserAssessmentMap"] = 293] = "UserAssessmentMap";
            entityType[entityType["UserBusinessObject"] = 294] = "UserBusinessObject";
            entityType[entityType["UserBusinessObjectMap"] = 295] = "UserBusinessObjectMap";
            entityType[entityType["UserMap"] = 296] = "UserMap";
            entityType[entityType["UserNavigation"] = 297] = "UserNavigation";
            entityType[entityType["UserNavigationOptionDefault"] = 298] = "UserNavigationOptionDefault";
            entityType[entityType["UserNavigationOptionDefaultMap"] = 299] = "UserNavigationOptionDefaultMap";
            entityType[entityType["UserSetting"] = 300] = "UserSetting";
            entityType[entityType["UserSettingMap"] = 301] = "UserSettingMap";
            entityType[entityType["UserSettingType"] = 302] = "UserSettingType";
            entityType[entityType["UserSettingTypeMap"] = 303] = "UserSettingTypeMap";
            entityType[entityType["VaccinationAssessment"] = 304] = "VaccinationAssessment";
            entityType[entityType["VaccineItem"] = 305] = "VaccineItem";
            entityType[entityType["VaccineOrder"] = 306] = "VaccineOrder";
            entityType[entityType["VaccineOrderDetail"] = 307] = "VaccineOrderDetail";
            entityType[entityType["VaccineOrderDetailMap"] = 308] = "VaccineOrderDetailMap";
            entityType[entityType["VaccineOrderMap"] = 309] = "VaccineOrderMap";
            entityType[entityType["VaccinePrecisionScoreItem"] = 310] = "VaccinePrecisionScoreItem";
            entityType[entityType["vAssessmentFollowUpStatu"] = 311] = "vAssessmentFollowUpStatu";
            entityType[entityType["vAssessmentFollowUpStatuMap"] = 312] = "vAssessmentFollowUpStatuMap";
            entityType[entityType["vAssessmentType"] = 313] = "vAssessmentType";
            entityType[entityType["vAssessmentTypeMap"] = 314] = "vAssessmentTypeMap";
            entityType[entityType["vAttribute"] = 315] = "vAttribute";
            entityType[entityType["vAttributeCategory"] = 316] = "vAttributeCategory";
            entityType[entityType["vAttributeCategoryMap"] = 317] = "vAttributeCategoryMap";
            entityType[entityType["vAttributeMap"] = 318] = "vAttributeMap";
            entityType[entityType["vAttributeMetadata"] = 319] = "vAttributeMetadata";
            entityType[entityType["vAttributeMetadataEnum"] = 320] = "vAttributeMetadataEnum";
            entityType[entityType["vAttributeMetadataEnumMap"] = 321] = "vAttributeMetadataEnumMap";
            entityType[entityType["vAttributeMetadataMap"] = 322] = "vAttributeMetadataMap";
            entityType[entityType["VerifyCodeViewModel"] = 323] = "VerifyCodeViewModel";
            entityType[entityType["VerifyUserDetails"] = 324] = "VerifyUserDetails";
            entityType[entityType["VetContactType"] = 325] = "VetContactType";
            entityType[entityType["VetContactTypeMap"] = 326] = "VetContactTypeMap";
            entityType[entityType["Visit"] = 327] = "Visit";
            entityType[entityType["VisitFile"] = 328] = "VisitFile";
            entityType[entityType["VisitFileMap"] = 329] = "VisitFileMap";
            entityType[entityType["VisitImage"] = 330] = "VisitImage";
            entityType[entityType["VisitImageMap"] = 331] = "VisitImageMap";
            entityType[entityType["VisitMap"] = 332] = "VisitMap";
            entityType[entityType["VisitReportUser"] = 333] = "VisitReportUser";
            entityType[entityType["VisitReportUserMap"] = 334] = "VisitReportUserMap";
            entityType[entityType["VisitType"] = 335] = "VisitType";
            entityType[entityType["VisitTypeMap"] = 336] = "VisitTypeMap";
            entityType[entityType["VisitUser"] = 337] = "VisitUser";
            entityType[entityType["VisitUserMap"] = 338] = "VisitUserMap";
            entityType[entityType["vLocalization"] = 339] = "vLocalization";
            entityType[entityType["vLocalizationMap"] = 340] = "vLocalizationMap";
            entityType[entityType["vNavigation"] = 341] = "vNavigation";
            entityType[entityType["vNavigationMap"] = 342] = "vNavigationMap";
            entityType[entityType["vTemplate"] = 343] = "vTemplate";
            entityType[entityType["vTemplateGroup"] = 344] = "vTemplateGroup";
            entityType[entityType["vTemplateGroupMap"] = 345] = "vTemplateGroupMap";
            entityType[entityType["vTemplateItem"] = 346] = "vTemplateItem";
            entityType[entityType["vTemplateItemMap"] = 347] = "vTemplateItemMap";
            entityType[entityType["vTemplateMap"] = 348] = "vTemplateMap";
            entityType[entityType["vTemplateRegistration"] = 349] = "vTemplateRegistration";
            entityType[entityType["vTemplateRegistrationMap"] = 350] = "vTemplateRegistrationMap";
            entityType[entityType["vTree"] = 351] = "vTree";
            entityType[entityType["vTreeHierarchy"] = 352] = "vTreeHierarchy";
            entityType[entityType["vTreeHierarchyMap"] = 353] = "vTreeHierarchyMap";
            entityType[entityType["vTreeMap"] = 354] = "vTreeMap";
        })(enums.entityType || (enums.entityType = {}));
        var entityType = enums.entityType;
    })(enums = app.enums || (app.enums = {}));
})(app || (app = {}));

String.prototype.toCamelCase = function () {
    return this
        .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
        .replace(/\s/g, '')
        .replace(/^(.)/, function ($1) { return $1.toLowerCase(); });
};
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};
String.prototype.startsWith = function (str) {
    return this.indexOf(str) === 0;
};
String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
        position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
String.prototype.format = function () {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != 'undefined'
            ? args[number]
            : match;
    });
};

Date.prototype.toNewUtcDate = function () {
    return new Date(this.getTime() - this.getTimezoneOffset() * 60000);
};
Date.prototype.toUtcDateISOFormat = function () {
    return this.getFullYear() + '-' + ('0' + (this.getMonth() + 1)).slice(-2) + '-' + ('0' + this.getDate()).slice(-2);
};

function sortByProperties(arr, properties) {
    var sortHelpArray = [];
    _.forEach(properties, function (prop) {
        sortHelpArray.push({ property: prop.split('.'), order: prop.split(' ').length > 1 ? prop.split(' ')[1] : 'asc', a: null, b: null });
    });
    arr.sort(function (a, b) {
        _.forEach(sortHelpArray, function (item) {
            var i = 0;
            item.a = a;
            item.b = b;
            while (i < item.property.length) {
                item.a = item.a[item.property[i].split(' ')[0]];
                item.b = item.b[item.property[i].split(' ')[0]];
                i++;
            }
        });
        for (var j = 0; j < sortHelpArray.length; j++) {
            var result = 0;
            if (angular.isDate((sortHelpArray[j].a))) {
                if (sortHelpArray[j].a.getTime() != sortHelpArray[j].b.getTime()) {
                    result = (sortHelpArray[j].a.getTime() < sortHelpArray[j].b.getTime() ? -1 : ((sortHelpArray[j].a.getTime() > sortHelpArray[j].b.getTime()) ? 1 : 0));
                    if (sortHelpArray[j].order == 'desc')
                        result = -(result);
                    return result;
                }
            }
            else {
                if (sortHelpArray.length === 1) {
                    if (sortHelpArray[j].a === null && sortHelpArray[j].b === null)
                        return 0;
                    if (sortHelpArray[j].a === null && sortHelpArray[j].b !== null)
                        return -1;
                    if (sortHelpArray[j].a !== null && sortHelpArray[j].b === null)
                        return 1;
                }
                if (sortHelpArray[j].a != sortHelpArray[j].b) {
                    result = (sortHelpArray[j].a < sortHelpArray[j].b ? -1 : ((sortHelpArray[j].a > sortHelpArray[j].b) ? 1 : 0));
                    if (sortHelpArray[j].order == 'desc')
                        result = -(result);
                    return result;
                }
            }
        }
        return 0;
    });
    if (sortHelpArray.length === 1) {
        var sortPropertyAndOrder = sortHelpArray[0].property;
        var sortProperty = sortPropertyAndOrder[0].split(' ')[0];
        var nullItems = arr.filter(function (item) {
            return item[sortProperty] === null;
        });
        var notNullItems = arr.filter(function (item) {
            return item[sortProperty] !== null;
        });
        var result;
        if (sortHelpArray[0].order === 'asc')
            result = nullItems.concat(notNullItems);
        else
            result = notNullItems.concat(nullItems);
        return result;
    }
    else
        return arr;
}
_.mixin({ 'sortByProperties': this.sortByProperties });

/// <reference path="../../_typings.ts"/>
"use strict";
var app;
(function (app) {
    var common;
    (function (common) {
        var utils;
        (function (utils) {
            function entityIsDetachedOrDeleted(entity) {
                return (entity.entityAspect.entityState.isDeleted() ||
                    entity.entityAspect.entityState.isDetached());
            }
            utils.entityIsDetachedOrDeleted = entityIsDetachedOrDeleted;
            function isNullOrUndefined(val) {
                return angular.isUndefined(val) || val === null;
            }
            utils.isNullOrUndefined = isNullOrUndefined;
            function isNullOrUndefinedOrEmpty(val) {
                return angular.isUndefined(val) || val === null || val === "";
            }
            utils.isNullOrUndefinedOrEmpty = isNullOrUndefinedOrEmpty;
            function removeSpecialCharacters(text) {
                text = text.replace(/\s+/g, "_");
                text = text.replace(/[^a-z0-9_\s]/gi, "").replace(/[_\s]/g, "_");
                return text;
            }
            utils.removeSpecialCharacters = removeSpecialCharacters;
            function getEnumKeyByEnumValue(myEnum, enumValue) {
                var keys = Object.keys(myEnum).filter(function (x) { return myEnum[x] == enumValue; });
                return keys.length > 0 ? keys[0] : null;
            }
            utils.getEnumKeyByEnumValue = getEnumKeyByEnumValue;
            function precise_round(num, decimals) {
                var sign = num >= 0 ? 1 : -1;
                var result = Math.round(num * Math.pow(10, decimals) + sign * 0.001) /
                    Math.pow(10, decimals);
                return _.isNaN(result) ? null : result.toFixed(decimals);
            }
            utils.precise_round = precise_round;
            var Average = (function () {
                function Average() {
                }
                return Average;
            })();
            utils.Average = Average;
            function averageCalculator(items) {
                var result = new Average();
                var count = items.length;
                if (count > 0) {
                    (result.mean = 0),
                        (result.meanAbs = 0),
                        (result.variance = 0),
                        (result.deviation = 0);
                    for (var m, s = 0, sAbs = 0, l = count; l--;) {
                        s += items[l];
                        sAbs += Math.abs(items[l]);
                    }
                    for (m = result.mean = s / count,
                        result.meanAbs = sAbs / count,
                        l = count,
                        s = 0; l--;) {
                        s += Math.pow(items[l] - m, 2);
                    }
                    result.deviation = Math.sqrt((result.variance = s / count));
                }
                return result;
            }
            utils.averageCalculator = averageCalculator;
            function aggregateRows(aggregation, values, attributeType) {
                var averageResult = this.averageCalculator(values);
                switch (aggregation) {
                    case "Sum":
                        return values.reduce(function (a, b) { return a + b; }); // sum
                    case "Avg":
                        if (!isNaN(averageResult.mean))
                            return averageResult.mean;
                        break;
                    case "AvgAbsolute":
                        if (!isNaN(averageResult.meanAbs)) {
                            return averageResult.meanAbs;
                        }
                        break;
                    case "STD":
                        if (!isNaN(averageResult.deviation))
                            return averageResult.deviation;
                        break;
                    case "Min":
                        return Math.min.apply(null, values);
                    case "Max":
                        return Math.max.apply(null, values);
                    case "Count":
                        if (attributeType === app.constants.attributeType.Boolean)
                            return _.filter(values, function (v) {
                                return v != null && v != false;
                            }).length;
                        else
                            return values.length;
                    default:
                        return null;
                }
            }
            utils.aggregateRows = aggregateRows;
            function getLocalizedSpan(value) {
                return "<span translate>" + value + "</span>";
            }
            utils.getLocalizedSpan = getLocalizedSpan;
            utils.refreshCachedData = false;
            function getTimeZone() {
                return window.jstz.determine().name();
            }
            utils.getTimeZone = getTimeZone;
            utils.froalaKey = "zA4D3E4C3kB6B5C4F6F3E3C3F2A5C4D-13LAHYKAJOEe1HQDUH==";
            function mapDtosToEntities(manager, dtos, entityName, keyName, extendWith) {
                return dtos.map(dtoToEntityMapper);
                function dtoToEntityMapper(dto) {
                    var keyValue = dto[keyName];
                    var entity = manager.getEntityByKey(entityName, keyValue);
                    if (!entity) {
                        // We don't have it, so create it as a partial
                        extendWith = $.extend({}, extendWith || defaultExtension);
                        extendWith[keyName] = keyValue;
                        entity = manager.createEntity(entityName, extendWith);
                    }
                    mapToEntity(entity, dto);
                    entity.entityAspect.setUnchanged();
                    return entity;
                }
            }
            utils.mapDtosToEntities = mapDtosToEntities;
            function mapToEntity(entity, dto) {
                // entity is an object with observables
                // dto is from json
                for (var prop in dto) {
                    if (dto.hasOwnProperty(prop)) {
                        if (typeof dto[prop] != "object") {
                            if (entity[prop] instanceof Date) {
                                entity[prop] = moment(dto[prop]).format();
                            }
                            else {
                                entity[prop] = dto[prop];
                            }
                        }
                        else {
                            entity[prop] = dto[prop];
                        }
                    }
                }
                return entity;
            }
            utils.mapToEntity = mapToEntity;
            utils.decimalSeparator = ".";
            function formatDecimal(value) {
                if (value !== undefined && value !== null && value !== "") {
                    var result = value.toString();
                    if (result.indexOf(".") != -1)
                        result = result.replace(".", app.common.utils.decimalSeparator);
                    else
                        result = result.replace(",", app.common.utils.decimalSeparator);
                    return result;
                }
                return value;
            }
            utils.formatDecimal = formatDecimal;
            function unformatDecimal(value) {
                if (app.common.utils.isNullOrUndefined(value))
                    return value;
                return value.toString().replace(",", ".");
            }
            utils.unformatDecimal = unformatDecimal;
            function IsiPad() {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            }
            utils.IsiPad = IsiPad;
            function replaceSpecialChars(text) {
                return text.replace(/å/g, 'aa').replace(/Å/g, 'AA').replace(/ø/g, 'o').replace(/Ø/g, 'O').replace(/æ/g, 'ae').replace(/Æ/g, 'AE');
            }
            utils.replaceSpecialChars = replaceSpecialChars;
            function splitAndGetLast(text, separator) {
                var regex = new RegExp("[^" + separator + "]+$", "gi");
                return text.match(regex)[0];
            }
            utils.splitAndGetLast = splitAndGetLast;
            function getPaginatedItems(items, currentPage, pageSize) {
                var page = currentPage || 1, per_page = pageSize, offset = (currentPage - 1) * per_page, paginatedItems = _.drop(items, offset).slice(0, per_page);
                return {
                    page: page,
                    per_page: per_page,
                    inlineCount: items.length,
                    totalPages: Math.ceil(items.length / per_page),
                    results: paginatedItems
                };
            }
            utils.getPaginatedItems = getPaginatedItems;
            function isReferenceConstraintError(errorMessage) {
                return (errorMessage.indexOf("The DELETE statement conflicted with the REFERENCE constraint") > -1);
            }
            utils.isReferenceConstraintError = isReferenceConstraintError;
            function currentTime() {
                var current = new Date();
                var dd = current.getDate();
                var mm = current.getMonth() + 1; //January is 0!
                var yyyy = current.getFullYear();
                var hh = current.getHours();
                var _m = current.getMinutes();
                var ss = current.getSeconds();
                var result = yyyy.toString() +
                    this.appendZero(mm) +
                    this.appendZero(dd) +
                    "_" +
                    this.appendZero(hh) +
                    this.appendZero(_m) +
                    this.appendZero(ss);
                // console.log("result", result);
                return result;
            }
            utils.currentTime = currentTime;
            function appendZero(value) {
                return value < 10 ? "0" + value.toString() : value.toString();
            }
            utils.appendZero = appendZero;
            function localizeEnumText(metadata, lang) {
                var nonLocalizedValue = metadata.text || metadata.value;
                switch (lang) {
                    case 'en-gb':
                    case 'en-us':
                    case 'en-ca':
                        return metadata.english || nonLocalizedValue;
                    case 'nb-no':
                    case 'nn-no':
                        return metadata.norwegian || nonLocalizedValue;
                    case 'es-cl':
                    case 'es-es':
                        return metadata.spanish || nonLocalizedValue;
                    default:
                        return nonLocalizedValue;
                }
            }
            utils.localizeEnumText = localizeEnumText;
            function getDateFormat(format) {
                // this function's origin is from Web date range picker.
                if (app.common.utils.isNullOrUndefinedOrEmpty(format))
                    return "DD/MM/YYYY";
                if ((format.match(/Y/g) || []).length === 3)
                    format = format.replace("YYY", "YYYY");
                else if ((format.match(/Y/g) || []).length === 2)
                    format = format.replace("YY", "YYYY");
                else if ((format.match(/Y/g) || []).length === 1)
                    format = format.replace("Y", "YYYY");
                return format;
            }
            utils.getDateFormat = getDateFormat;
            function localeCodeGet(languageId) {
                switch (languageId) {
                    case 'es-cl':
                        return 'es-CL';
                    case 'nb-no':
                        return 'nb-NO';
                    case 'en-ie':
                        return 'en-IE';
                    case 'en-ca':
                        return 'en-CA';
                    case 'en-us':
                        return 'en-US';
                    case 'en-gb':
                    default:
                        return 'en-GB';
                }
            }
            utils.localeCodeGet = localeCodeGet;
            function validateArrayEmails(emails) {
                if (app.common.utils.isNullOrUndefined(emails) || emails.length < 1)
                    return false;
                var noFailEmail = true;
                emails.forEach(function (email) {
                    if (app.common.utils.validateEmail(email) === false)
                        noFailEmail = false;
                });
                return noFailEmail;
            }
            utils.validateArrayEmails = validateArrayEmails;
            function validateEmail(email) {
                if (app.common.utils.isNullOrUndefinedOrEmpty(email))
                    return false;
                email = email.trim();
                // REGEX from https://www.w3resource.com/javascript/form/email-validation.php
                var EMAIL_REGEXP = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
                return EMAIL_REGEXP.test(email);
            }
            utils.validateEmail = validateEmail;
            function appendNumberAndUnit(num, unit) {
                var notAllowUnit = ["none", "unknown"];
                if (angular.isUndefined(num) || num === null)
                    return "";
                if (angular.isUndefined(unit)
                    || unit === null
                    || unit === ""
                    || notAllowUnit.indexOf(unit.toLowerCase()) > -1)
                    return num;
                return num + " " + unit;
            }
            utils.appendNumberAndUnit = appendNumberAndUnit;
            utils.PrescriptionFullProperty = ["amount", "biomass", "comments", "dSSN", "fieldAssistant", "isVaccinated", "packaging",
                "pelletSize", "prescriptionDate", "prescriptionId", "prescriptionNumber", "productionStageId", "regionalAuthorityId",
                "siteId", "specieId", "treatmentEnd", "treatmentProductId", "treatmentStart", "units", "userGuide", "weight",
                "prescriptionSaveStatus", "reportProgress", "reportStatus", "syncStatus", "customer", "customerId", "siteName",
                "treatmentProductName", "amountString", "activeSubstance", "inclusionString", "vetFullName", "inclusion",
                "withdrawal", "amountMeasureUnitId", "supplierId", "supplierTypeBitMask"];
            var DraftPrescription = (function () {
                function DraftPrescription() {
                    var _this = this;
                    var full_propertiesArray = utils.PrescriptionFullProperty;
                    full_propertiesArray.forEach(function (pro) {
                        _this[pro] = null;
                    });
                    this.createdTime = moment().toISOString();
                    this.isDraft = true;
                }
                DraftPrescription.prototype.copy = function (prescription) {
                    var _this = this;
                    var copiableProperties_Array = ["amount", "biomass", "comments", "dSSN", "fieldAssistant", "isVaccinated", "packaging", "pelletSize", "prescriptionDate", "prescriptionId",
                        "prescriptionNumber", "productionStageId", "regionalAuthorityId", "siteId", "specieId", "treatmentEnd", "treatmentProductId",
                        "treatmentStart", "units", "userGuide", "weight", "prescriptionSaveStatus", "reportProgress", "reportStatus", "syncStatus", "withdrawal",
                        "amountMeasureUnitId", "supplierId", "supplierTypeBitMask", "siteName"];
                    copiableProperties_Array.forEach(function (pro) {
                        _this[pro] = prescription[pro];
                    });
                    if (prescription["customer"]) {
                        if (prescription["customer"]["name"])
                            this.customer = prescription["customer"]["name"];
                        if (prescription["customer"]["customerId"])
                            this.customerId = prescription["customer"]["customerId"];
                    }
                    if (prescription["site"] && prescription["customer"]["name"]) {
                        this.site = prescription["site"]["name"];
                        this.siteName = this.site;
                    }
                    var treatmentProduct = prescription["treatmentProduct"];
                    if (!app.common.utils.isNullOrUndefined(treatmentProduct)) {
                        if (!app.common.utils.isNullOrUndefined(treatmentProduct["name"]))
                            this.treatmentProductName = treatmentProduct["name"];
                        if (!app.common.utils.isNullOrUndefined(treatmentProduct["amountMeasureUnit"])
                            && !app.common.utils.isNullOrUndefined(treatmentProduct["amountMeasureUnit"]["name"]))
                            this.amountString = app.common.utils.appendNumberAndUnit(this.amount, treatmentProduct["amountMeasureUnit"]["name"]);
                        var activeSubstance = treatmentProduct["activeSubstance"];
                        if (!app.common.utils.isNullOrUndefined(activeSubstance)) {
                            if (!app.common.utils.isNullOrUndefined(activeSubstance["name"]))
                                this.activeSubstance = activeSubstance["name"];
                            if (!app.common.utils.isNullOrUndefined(activeSubstance["inclusion"]))
                                this.inclusion = activeSubstance["inclusion"];
                            if (!app.common.utils.isNullOrUndefined(activeSubstance["inclusionMeasureUnit"])
                                && !app.common.utils.isNullOrUndefined(activeSubstance["inclusionMeasureUnit"]["name"]))
                                this.inclusionString = app.common.utils.appendNumberAndUnit(this.amount * this.inclusion, activeSubstance["inclusionMeasureUnit"]["name"]);
                        }
                    }
                };
                return DraftPrescription;
            })();
            utils.DraftPrescription = DraftPrescription;
            function getInitialPrescriptionParams(draftPrescription) {
                var result = {};
                var definedProperties_Array_Part1 = ["amount", "biomass", "comments", "dSSN", "fieldAssistant", "isVaccinated", "packaging",
                    "pelletSize", "prescriptionNumber", "productionStageId", "regionalAuthorityId", "siteId", "specieId", "isLocked",
                    "treatmentProductId", "units", "userGuide", "weight", "withdrawal", "amountMeasureUnitId", "supplierId", "supplierTypeBitMask"];
                definedProperties_Array_Part1.forEach(function (pro) {
                    if (!app.common.utils.isNullOrUndefined(draftPrescription[pro]))
                        result[pro] = draftPrescription[pro];
                    else
                        result[pro] = null;
                });
                var definedProperties_Array_Part2 = ["prescriptionDate", "treatmentEnd", "treatmentStart"];
                definedProperties_Array_Part2.forEach(function (pro) {
                    if (!app.common.utils.isNullOrUndefined(draftPrescription[pro]))
                        result[pro] = new Date(draftPrescription[pro]);
                    else
                        result[pro] = null;
                });
                return result;
            }
            utils.getInitialPrescriptionParams = getInitialPrescriptionParams;
        })(utils = common.utils || (common.utils = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

/// <reference path="../../_typings.ts"/>
'use strict';
var app;
(function (app) {
    var common;
    (function (common) {
        var data;
        (function (data) {
            var EntityManagerProvider = (function () {
                function EntityManagerProvider(apiEndpoint, addclientEntities, metadata) {
                    if (addclientEntities === void 0) { addclientEntities = true; }
                    if (metadata === void 0) { metadata = null; }
                    breeze.NamingConvention.camelCase.setAsDefault();
                    var serviceName = apiEndpoint;
                    this.localizeValidationMessages();
                    // define the Breeze `DataService` for this app
                    var dataService = new breeze.DataService({
                        serviceName: serviceName,
                        hasServerMetadata: false // don't ask the server for metadata
                    });
                    var validationOptions = new breeze.ValidationOptions({
                        validateOnSave: false
                    });
                    //var metadataStore = metadata ? metadata : new breeze.MetadataStore({ namingConvention: breeze.NamingConvention.camelCase });
                    var metadataStore = new breeze.MetadataStore();
                    if (metadata) {
                        // initialize it from the application's metadata variable
                        metadataStore.importMetadata(metadata);
                    }
                    var options = {
                        dataService: dataService,
                        // every module gets its own metadataStore; they do not share the default
                        metadataStore: metadataStore,
                        validationOptions: validationOptions
                    };
                    if (!this.manager) {
                        this.manager = new breeze.EntityManager(options);
                    }
                    this.extendMetadata(addclientEntities);
                }
                EntityManagerProvider.prototype.create = function () {
                    this.modelBuilder.validators();
                    return this.manager;
                };
                EntityManagerProvider.prototype.getEmptyCopy = function () {
                    this.manager = this.mastermanager.createEmptyCopy();
                    return this.manager;
                };
                EntityManagerProvider.prototype.prepare = function () {
                    return this.manager.fetchMetadata();
                };
                EntityManagerProvider.prototype.extendMetadata = function (addclientEntities) {
                    if (!this.modelBuilder) {
                        this.modelBuilder = new common.model.ModelBuilder(this.manager.metadataStore, addclientEntities);
                        this.mastermanager = this.manager;
                    }
                };
                EntityManagerProvider.prototype.addEntityLevelValidations = function () {
                    this.modelBuilder.addEntityLevelValidators(this.manager.metadataStore);
                };
                EntityManagerProvider.prototype.localizeValidationMessages = function () {
                    if (app.localizer.resource != null) {
                        breeze.Validator.messageTemplates["bool"] = app.localizer.resource.BreezeValidationMessageBool;
                        breeze.Validator.messageTemplates["url"] = app.localizer.resource.BreezeValidationMessageUrl;
                        breeze.Validator.messageTemplates["date"] = app.localizer.resource.BreezeValidationMessageDate;
                        breeze.Validator.messageTemplates["emailAddress"] = app.localizer.resource.BreezeValidationMessageEmailAddress;
                        breeze.Validator.messageTemplates["guid"] = app.localizer.resource.BreezeValidationMessageGuid;
                        breeze.Validator.messageTemplates["integer"] = app.localizer.resource.BreezeValidationMessageInteger;
                        breeze.Validator.messageTemplates["maxLength"] = app.localizer.resource.BreezeValidationMessageMaxLength;
                        breeze.Validator.messageTemplates["number"] = app.localizer.resource.BreezeValidationMessageNumber;
                        breeze.Validator.messageTemplates["phone"] = app.localizer.resource.BreezeValidationMessagePhone;
                        breeze.Validator.messageTemplates["regularExpression"] = app.localizer.resource.BreezeValidationMessageRegularExpression;
                        breeze.Validator.messageTemplates["required"] = app.localizer.resource.BreezeValidationMessageRequired;
                        breeze.Validator.messageTemplates["string"] = app.localizer.resource.BreezeValidationMessageString;
                        breeze.Validator.messageTemplates["stringLength"] = app.localizer.resource.BreezeValidationMessageStringLength;
                    }
                };
                return EntityManagerProvider;
            })();
            data.EntityManagerProvider = EntityManagerProvider;
        })(data = common.data || (common.data = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

/// <reference path="../../_typings.ts"/>
/// <reference path="breeze.partial-entities.ts" />
'use strict';
var app;
(function (app) {
    var common;
    (function (common) {
        var data;
        (function (data_1) {
            var Repository = (function () {
                function Repository(entityManagerProvider, entityTypeName, resourceName, fetchStrategy) {
                    this.activePredicate = new breeze.Predicate("active", breeze.FilterQueryOp.Equals, true);
                    var entityType;
                    this.entityManagerProvider = entityManagerProvider;
                    this.entityTypeName = entityTypeName;
                    this.resourceName = resourceName;
                    this.fetchStrategy = fetchStrategy;
                    if (entityTypeName) {
                        entityType = this.getMetastore().getEntityType(entityTypeName);
                        entityType.setProperties({ defaultResourceName: resourceName });
                        this.getMetastore().setEntityTypeForResourceName(resourceName, entityTypeName);
                    }
                }
                Repository.prototype.newEntityQuery = function (params) {
                    var query = new breeze.EntityQuery(this.resourceName);
                    if (params != null) {
                        query.withParameters(params);
                    }
                    return query;
                };
                Repository.prototype.findById = function (key) {
                    if (!this.entityTypeName)
                        throw new Error("Repository must be created with an entity type specified");
                    return this.manager().fetchEntityByKey(this.entityTypeName, key, true)
                        .then(function (data) {
                        if (!data.entity)
                            throw new Error("Entity not found!");
                        return data.entity;
                    });
                };
                Repository.prototype.findByIdInCache = function (key) {
                    if (!this.entityTypeName)
                        throw new Error("Repository must be created with an entity type specified");
                    return this.manager().getEntityByKey(this.entityTypeName, key);
                };
                Repository.prototype.find = function (predicate) {
                    var query = breeze.EntityQuery
                        .from(this.resourceName)
                        .where(predicate);
                    return this.executeQuery(query);
                };
                Repository.prototype.findInCache = function (predicate, orderBy) {
                    var query = breeze.EntityQuery
                        .from(this.resourceName)
                        .where(predicate);
                    if (orderBy)
                        query = query.orderBy(orderBy);
                    return this.executeCacheQuery(query);
                };
                Repository.prototype.all = function () {
                    var query = breeze.EntityQuery
                        .from(this.resourceName);
                    return this.executeQuery(query);
                };
                Repository.prototype.allInCache = function (onlyActive, orderBy) {
                    if (onlyActive === void 0) { onlyActive = false; }
                    if (orderBy === void 0) { orderBy = null; }
                    var query = breeze.EntityQuery
                        .from(this.resourceName);
                    if (onlyActive)
                        query = query.where(this.activePredicate);
                    if (orderBy)
                        query = query.orderBy(orderBy);
                    return this.executeCacheQuery(query);
                };
                Repository.prototype.executeQuery = function (query) {
                    return this.manager()
                        .executeQuery(query.using(this.fetchStrategy || breeze.FetchStrategy.FromServer))
                        .then(function (data) {
                        return data.results;
                    });
                };
                Repository.prototype.executeQueryWithInlineCount = function (query) {
                    return this.manager()
                        .executeQuery(query.using(this.fetchStrategy || breeze.FetchStrategy.FromServer))
                        .then(function (data) {
                        return { results: data.results, inlineCount: data.inlineCount };
                    });
                };
                Repository.prototype.executeQueryPartial = function (query, mapToEntity, key, inlineCount) {
                    var _this = this;
                    if (inlineCount === void 0) { inlineCount = false; }
                    return this.manager()
                        .executeQuery(query.using(this.fetchStrategy || breeze.FetchStrategy.FromServer))
                        .then(function (data) {
                        var list = app.common.data.mapDtosToEntities(_this.manager(), data.results, mapToEntity, key, undefined);
                        return { results: list, inlineCount: data.inlineCount };
                    });
                };
                Repository.prototype.hasEntitiesInCache = function () {
                    var query = breeze.EntityQuery
                        .from(this.resourceName);
                    return this.executeCacheQuery(query).length;
                };
                Repository.prototype.createEntity = function (initParams, entityState) {
                    return this.manager().createEntity(this.entityTypeName, initParams, entityState);
                };
                Repository.prototype.executeCacheQuery = function (query) {
                    return this.manager().executeQueryLocally(query);
                };
                Repository.prototype.rejectChanges = function (entity) {
                    return entity.entityAspect.rejectChanges();
                };
                Repository.prototype.saveChanges = function (entities) {
                    return this.manager().saveChanges(entities);
                };
                Repository.prototype.exportEntities = function (entities) {
                    return this.manager().exportEntities(entities);
                };
                Repository.prototype.getMetastore = function () {
                    return this.manager().metadataStore;
                };
                Repository.prototype.manager = function () {
                    return this.entityManagerProvider.manager;
                };
                return Repository;
            })();
            data_1.Repository = Repository;
        })(data = common.data || (common.data = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

/// <reference path="../../_typings.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var common;
    (function (common) {
        var data;
        (function (data) {
            var UnitOfWork = (function () {
                function UnitOfWork(entityManagerProvider) {
                    this.provider = entityManagerProvider.create();
                }
                UnitOfWork.prototype.hasChanges = function () {
                    return this.provider.hasChanges();
                };
                UnitOfWork.prototype.saveChanges = function (entities) {
                    return this.provider.saveChanges(entities);
                };
                UnitOfWork.prototype.rejectChanges = function () {
                    this.provider.rejectChanges();
                };
                UnitOfWork.prototype.rejectEntityChanges = function (entity) {
                    return entity.entityAspect.rejectChanges();
                };
                UnitOfWork.prototype.getEntities = function (entityName) {
                    return this.provider.getEntities(entityName);
                };
                UnitOfWork.prototype.validateEntity = function (entity) {
                    return entity.entityAspect.validateEntity();
                };
                UnitOfWork.prototype.detachEntity = function (entity) {
                    return this.provider.detachEntity(entity);
                };
                UnitOfWork.prototype.getValidationErrors = function (entity) {
                    return entity.entityAspect.validationErrors;
                };
                return UnitOfWork;
            })();
            data.UnitOfWork = UnitOfWork;
            var AssessmentUnitOfWork = (function (_super) {
                __extends(AssessmentUnitOfWork, _super);
                function AssessmentUnitOfWork(entityManagerProvider) {
                    _super.call(this, entityManagerProvider);
                    this.assessmentRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.assessment, app.constants.resourceNames.assessmentResource, null);
                    this.allowedRegistrationRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.allowedReg, app.constants.resourceNames.allowedRegResource, null);
                    this.assessmentTypeRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.assessmentType, app.constants.resourceNames.assessmentTypeResource, null);
                    this.assessmentTypeGroupRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.assessmentTypeGroup, app.constants.resourceNames.assessmentTypeGroupResource, null);
                    this.attributeRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.attribute, app.constants.resourceNames.attributes, null);
                    this.templateGroupsRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.templateGroup, app.constants.resourceNames.templateGroupResource, null);
                    this.templateRegistrationRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.templateRegistration, app.constants.resourceNames.templateRegistrationResource, null);
                    this.customerRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.customer, app.constants.resourceNames.customerResource, null);
                    this.siteRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.site, app.constants.resourceNames.siteResource, null);
                    this.companyBUsRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.companyBu, app.constants.resourceNames.companyBUResource, null);
                    this.contactPersonRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.contactPerson, app.constants.resourceNames.contactPersonResource, null);
                    this.assessmentDicriminatorRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.assessmentDiscriminator, app.constants.resourceNames.assessmentDiscriminatorResource, null);
                    this.assessmentIdentifierRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.assessmentIdentifier, app.constants.resourceNames.assessmentIdentifierResource, null);
                    this.fishGroupRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.fishgroup, app.constants.resourceNames.fishGroups, null);
                    this.assessmentReportRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.assessmentReport, app.constants.resourceNames.assessmentReports, null);
                    this.assessmentFollowUpStatusRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.assessmentFollowUpStatus, app.constants.resourceNames.assessmentFollowUpStatuses, null);
                    this.auditRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.audit, app.constants.resourceNames.audits, null);
                    this.languageRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.language, app.constants.resourceNames.languages, null);
                    this.generationsRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.generation, app.constants.resourceNames.generations, null);
                    this.userAssessmentRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.userAssessment, app.constants.resourceNames.userAssessments, null);
                    this.treatmentProductRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.treatmentProduct, app.constants.resourceNames.treatmentProductResource, null);
                    this.suppliersRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.supplier, app.constants.resourceNames.supplierResource, null);
                    this.diagnosesRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.diagnosis, app.constants.resourceNames.diagnosisResource, null);
                    this.eventsRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.event, app.constants.resourceNames.eventResource, null);
                    this.prescriptionsRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.prescription, app.constants.resourceNames.prescriptionResource, null);
                    this.prescriptionReportRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.prescriptionReport, app.constants.resourceNames.prescriptionReports, null);
                    this.regionalAuthorityRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.regionalAuthority, app.constants.resourceNames.regionalAuthorityResource, null);
                    this.speciesRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.species, app.constants.resourceNames.speciesResource, null);
                    this.productionStageRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.productionStage, app.constants.resourceNames.productionStageResource, null);
                    this.measureUnitRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.measureUnit, app.constants.resourceNames.measureUnitResource, null);
                    this.supplierTypeRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.supplierType, app.constants.resourceNames.supplierTypeResource, null);
                    this.treatmentProductProducersRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.treatmentProductProducer, app.constants.resourceNames.treatmentProductProducerResource, null);
                    this.treatmentProductIndicationsRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.treatmentProductIndication, app.constants.resourceNames.treatmentProductIndicationResource, null);
                    this.activeSubstancesRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.activeSubstance, app.constants.resourceNames.activeSubstanceResource, null);
                    this.quarantineTypeRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.quarantineType, app.constants.resourceNames.quarantineTypeResources, null);
                    this.countryRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.country, app.constants.resourceNames.countryResources, null);
                    this.prescriptionfilesRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.prescriptionFile, app.constants.resourceNames.prescriptionFileResource, null);
                }
                return AssessmentUnitOfWork;
            })(UnitOfWork);
            data.AssessmentUnitOfWork = AssessmentUnitOfWork;
            var EventUnitOfWork = (function (_super) {
                __extends(EventUnitOfWork, _super);
                function EventUnitOfWork(entityManagerProvider) {
                    _super.call(this, entityManagerProvider);
                    this.eventRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.event, app.constants.resourceNames.eventResource, null);
                }
                return EventUnitOfWork;
            })(UnitOfWork);
            data.EventUnitOfWork = EventUnitOfWork;
            var SettingsUnitOfWork = (function (_super) {
                __extends(SettingsUnitOfWork, _super);
                function SettingsUnitOfWork(entityManagerProvider) {
                    _super.call(this, entityManagerProvider);
                    this.userSettingRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.userSetting, app.constants.resourceNames.userSettingResource, null);
                    this.userSettingTypeRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.userSettingType, app.constants.resourceNames.userSettingTypeResource, null);
                }
                return SettingsUnitOfWork;
            })(UnitOfWork);
            data.SettingsUnitOfWork = SettingsUnitOfWork;
            var MailUnitOfWork = (function (_super) {
                __extends(MailUnitOfWork, _super);
                function MailUnitOfWork(entityManagerProvider) {
                    _super.call(this, entityManagerProvider);
                    this.mailRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.sentMail, app.constants.resourceNames.sentMailResource, null);
                }
                return MailUnitOfWork;
            })(UnitOfWork);
            data.MailUnitOfWork = MailUnitOfWork;
            var NavigatoinUnitOfWork = (function (_super) {
                __extends(NavigatoinUnitOfWork, _super);
                function NavigatoinUnitOfWork(entityManagerProvider) {
                    _super.call(this, entityManagerProvider);
                    this.securityLevelRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.securityLevel, app.constants.resourceNames.securityLevelResource, null);
                    this.navigationOptionRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.navigationOption, app.constants.resourceNames.navigationOptionResource, null);
                }
                return NavigatoinUnitOfWork;
            })(UnitOfWork);
            data.NavigatoinUnitOfWork = NavigatoinUnitOfWork;
            var CustomerPortalUnitOfWork = (function (_super) {
                __extends(CustomerPortalUnitOfWork, _super);
                function CustomerPortalUnitOfWork(entityManagerProvider) {
                    _super.call(this, entityManagerProvider);
                    this.contactPersonRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.contactPerson, app.constants.resourceNames.contactPersonResource, null);
                }
                return CustomerPortalUnitOfWork;
            })(UnitOfWork);
            data.CustomerPortalUnitOfWork = CustomerPortalUnitOfWork;
            var PrescriptionUnitOfWork = (function (_super) {
                __extends(PrescriptionUnitOfWork, _super);
                function PrescriptionUnitOfWork(entityManagerProvider) {
                    _super.call(this, entityManagerProvider);
                    this.prescriptionRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.prescription, app.constants.resourceNames.prescriptionResource, null);
                    this.treatmentProductRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.treatmentProduct, app.constants.resourceNames.treatmentProductResource, null);
                    this.regionalAuthorityRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.regionalAuthority, app.constants.resourceNames.regionalAuthorityResource, null);
                    this.speciesRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.species, app.constants.resourceNames.speciesResource, null);
                    this.productionStageRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.productionStage, app.constants.resourceNames.productionStageResource, null);
                    this.measureUnitRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.measureUnit, app.constants.resourceNames.measureUnitResource, null);
                    this.suppliersRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.supplier, app.constants.resourceNames.supplierResource, null);
                    this.supplierTypeRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.supplierType, app.constants.resourceNames.supplierTypeResource, null);
                    this.treatmentProductProducersRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.treatmentProductProducer, app.constants.resourceNames.treatmentProductProducerResource, null);
                    this.treatmentProductIndicationsRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.treatmentProductIndication, app.constants.resourceNames.treatmentProductIndicationResource, null);
                    this.activeSubstancesRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.activeSubstance, app.constants.resourceNames.activeSubstanceResource, null);
                    this.quarantineTypeRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.quarantineType, app.constants.resourceNames.quarantineTypeResources, null);
                    this.countryRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.country, app.constants.resourceNames.countryResources, null);
                    this.companyBUsRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.companyBu, app.constants.resourceNames.companyBUResource, null);
                }
                return PrescriptionUnitOfWork;
            })(UnitOfWork);
            data.PrescriptionUnitOfWork = PrescriptionUnitOfWork;
            var AttributeUnitOfWork = (function (_super) {
                __extends(AttributeUnitOfWork, _super);
                function AttributeUnitOfWork(entityManagerProvider) {
                    _super.call(this, entityManagerProvider);
                    this.attributeRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.attribute, app.constants.resourceNames.attributes, null);
                    this.attributeMetadataRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.attributeMetadata, app.constants.resourceNames.attributeMetadatas, null);
                    this.attributeMetadataEnumRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.attributeMetadataEnum, app.constants.resourceNames.attributeMetadataEnums, null);
                }
                return AttributeUnitOfWork;
            })(UnitOfWork);
            data.AttributeUnitOfWork = AttributeUnitOfWork;
            var UserManagementUnitOfWork = (function (_super) {
                __extends(UserManagementUnitOfWork, _super);
                function UserManagementUnitOfWork(entityManagerProvider) {
                    _super.call(this, entityManagerProvider);
                    this.userBusinessObjectRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.userBusinessObject, app.constants.resourceNames.userBusinessObjectResource, null);
                    this.customerRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.customer, app.constants.resourceNames.customerResource, null);
                    this.customerBURepository = new data.Repository(entityManagerProvider, app.constants.entityNames.customerBu, app.constants.resourceNames.customerBUResource, null);
                    this.companyRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.company, app.constants.resourceNames.companyResource, null);
                    this.companyBURepository = new data.Repository(entityManagerProvider, app.constants.entityNames.companyBu, app.constants.resourceNames.companyBUResource, null);
                    this.operationRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.operation, app.constants.resourceNames.operationResource, null);
                    this.regionRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.region, app.constants.resourceNames.regionResource, null);
                    this.areaRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.area, app.constants.resourceNames.areaResource, null);
                    this.siteRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.site, app.constants.resourceNames.siteResource, null);
                    this.securityLevelRepository = new data.Repository(entityManagerProvider, app.constants.entityNames.securityLevel, app.constants.resourceNames.securityLevelResource, null);
                }
                return UserManagementUnitOfWork;
            })(UnitOfWork);
            data.UserManagementUnitOfWork = UserManagementUnitOfWork;
        })(data = common.data || (common.data = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

var defaultExtension = { isPartial: true };
//var mapper = {
//    mapDtosToEntities: mapDtosToEntities
//};
//return mapper;
/**
Map an array of DTO's for a type of entity
to an array of Breeze entities that are managed by
the entity manager and are observables.
    @method mapDtosToEntities
    @param manager {Object} The breeze manager instance
    @param dtos {Object|Array of Object} The objects to map to entities
    @param entityName {String} The name of the entity
    @param keyName {String} The name of the entity key property
    @param mapping {Object=defaultMapping} Object containing the default mapping for the entity
    @returns {Object} breeze entity
**/
var app;
(function (app) {
    var common;
    (function (common) {
        var data;
        (function (data) {
            function mapDtosToEntities(manager, dtos, entityName, keyName, extendWith) {
                return dtos.map(dtoToEntityMapper);
                function dtoToEntityMapper(dto) {
                    var keyValue = dto[keyName];
                    var entity = manager.getEntityByKey(entityName, keyValue);
                    if (!entity) {
                        // We don't have it, so create it as a partial
                        extendWith = $.extend({}, extendWith || defaultExtension);
                        extendWith[keyName] = keyValue;
                        entity = manager.createEntity(entityName, extendWith);
                    }
                    mapToEntity(entity, dto);
                    entity.entityAspect.setUnchanged();
                    return entity;
                }
            }
            data.mapDtosToEntities = mapDtosToEntities;
            function mapToEntity(entity, dto) {
                // entity is an object with observables
                // dto is from json
                for (var prop in dto) {
                    if (dto.hasOwnProperty(prop)) {
                        if (typeof (dto[prop]) != "object") {
                            if (entity[prop] instanceof Date) {
                                entity[prop] = formatDate(dto[prop]);
                            }
                            else {
                                entity[prop] = dto[prop];
                            }
                        }
                        else if (entity[prop] instanceof Array) {
                            if (!_.isEqual(entity[prop], dto[prop]))
                                entity[prop] = dto[prop];
                        }
                        else {
                            entity[prop] = dto[prop];
                        }
                    }
                }
                function formatDate(dateObject) {
                    //return moment(dto[prop]).format();
                    return dateObject;
                }
                return entity;
            }
            data.mapToEntity = mapToEntity;
        })(data = common.data || (common.data = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
//}

/// <reference path="../../_typings.ts"/>
'use strict';
var app;
(function (app) {
    var common;
    (function (common) {
        var data;
        (function (data) {
            var BaseAssessmentDatacontext = (function () {
                // End Abstract Methods
                function BaseAssessmentDatacontext($q, sharedDatacontext) {
                    this.$q = $q;
                    this.sharedDatacontext = sharedDatacontext;
                    this.entityQuery = breeze.EntityQuery;
                    this.breeze = breeze;
                    this.activePredicate = new breeze.Predicate("active", breeze.FilterQueryOp.Equals, true);
                }
                //Abstract Methods
                BaseAssessmentDatacontext.prototype.initializeAssessmentDatacontext = function (froceRemote) { return this.$q.reject('This method is abstract'); };
                BaseAssessmentDatacontext.prototype.getAll = function (froceRemote) { throw new Error('This method is abstract'); };
                BaseAssessmentDatacontext.prototype.getAssessmentReports = function (assessments, customerIds, siteIds, assessmentGroups, nahRepresentatives, fromDate, forceRemote) { throw new Error('This method is abstract'); };
                BaseAssessmentDatacontext.prototype.assessmentReportGet = function (assessmentId) { throw new Error('This method is abstract'); };
                BaseAssessmentDatacontext.prototype.downloadReports = function (reportsToDownload, assessments) { throw new Error('This method is abstract'); };
                BaseAssessmentDatacontext.prototype.save = function (assessment) { throw new Error('This method is abstract'); };
                BaseAssessmentDatacontext.prototype.saveToOfflineStorage = function () { throw new Error('This method is abstract'); };
                BaseAssessmentDatacontext.prototype.sync = function () { throw new Error('This method is abstract'); };
                BaseAssessmentDatacontext.prototype.rejectChanges = function (entity) { throw new Error('This method is abstract'); };
                BaseAssessmentDatacontext.prototype.hasNonSyncedData = function () { throw new Error('This method is abstract'); };
                BaseAssessmentDatacontext.prototype.addEntityLevelValidations = function () { throw new Error('This method is abstract'); };
                BaseAssessmentDatacontext.prototype.changeSynchStatus = function (state) { throw new Error('This method is abstract'); };
                BaseAssessmentDatacontext.prototype.getAllowedRegistrations = function (forceRemote) { throw new Error('This method is abstract'); };
                BaseAssessmentDatacontext.prototype.getAllFromCache = function (resourceName, getOnlyActive, orderBy) {
                    if (getOnlyActive === void 0) { getOnlyActive = false; }
                    if (orderBy === void 0) { orderBy = null; }
                    var query = new breeze.EntityQuery().from(resourceName);
                    if (getOnlyActive)
                        query = query.where(this.activePredicate);
                    if (orderBy)
                        query = query.orderBy(orderBy);
                    return this.assessmentUnitOfWork.assessmentRepository.executeCacheQuery(query);
                };
                BaseAssessmentDatacontext.prototype.createAssessment = function (initParams) {
                    var _this = this;
                    var assessment = this.assessmentUnitOfWork.assessmentRepository.createEntity(initParams, breeze.EntityState.Added);
                    //this.pluginsManager.createFolder(constants.fileSystemFolders.picturesDraft + "/" + assessment.assessmentId);
                    var templateRegistrationParams = [];
                    _.forEach(assessment.templateGroups, function (templateGroup) {
                        if (!templateGroup.hasMultiRows) {
                            _.forEach(templateGroup.template.templateItems, function (templateItem) {
                                templateRegistrationParams.push(_this.initParamsForTemplateRegistration(assessment.assessmentId, templateItem, null));
                            });
                        }
                        else {
                            for (var n = 1; n < templateGroup.initRows + 1; n++) {
                                templateRegistrationParams = templateRegistrationParams.concat(_this.initParamsForMultiRowTemplateRegistration(assessment.assessmentId, templateGroup.template.templateItems, n));
                            }
                            for (var m = 1; m < templateGroup.totalFooterRowsCount + 1; m++) {
                                templateRegistrationParams = templateRegistrationParams.concat(_this.initParamsForMultiRowTemplateRegistration(assessment.assessmentId, templateGroup.template.templateItems, -1 * m));
                            }
                        }
                    });
                    this.createTemplateRegistrations(templateRegistrationParams);
                    return assessment;
                };
                BaseAssessmentDatacontext.prototype.deleteAssessment = function (assessment) {
                    var predicate = new breeze.Predicate('assessmentId', breeze.FilterQueryOp.Equals, assessment.assessmentId);
                    this.deleteTemplateRegistations(this.assessmentUnitOfWork.templateRegistrationRepository.findInCache(predicate));
                    assessment = this.assessmentUnitOfWork.assessmentRepository.findInCache(predicate);
                    if (!app.common.utils.entityIsDetachedOrDeleted(assessment[0])) {
                        if (assessment[0].assessmentId > 0)
                            assessment[0].entityAspect.setDeleted();
                        else
                            this.assessmentUnitOfWork.detachEntity(assessment[0]);
                    }
                    //return this.sharedDatacontext.saveToOfflineStorage();
                };
                BaseAssessmentDatacontext.prototype.deletePrescription = function (prescription) {
                    var predicate = new breeze.Predicate('prescriptionId', breeze.FilterQueryOp.Equals, prescription.prescriptionId);
                    prescription = this.assessmentUnitOfWork.prescriptionsRepository.findInCache(predicate);
                    if (!app.common.utils.entityIsDetachedOrDeleted(prescription[0])) {
                        prescription[0].entityAspect.setDeleted();
                    }
                    //return this.sharedDatacontext.saveToOfflineStorage();
                };
                BaseAssessmentDatacontext.prototype.initParamsForTemplateRegistration = function (assessmentId, templateItem, rowIndex) {
                    return {
                        attributeId: templateItem.attributeId,
                        attributeType: templateItem.attribute.attributeType.name,
                        templateId: templateItem.templateId,
                        rowIndex: rowIndex,
                        assessmentId: assessmentId,
                    };
                };
                BaseAssessmentDatacontext.prototype.initParamsForTemplateRegistrationWithValue = function (assessmentId, templateItem, rowIndex, focusValue, hasPreFilled) {
                    return {
                        attributeId: templateItem.attributeId,
                        attributeType: templateItem.attribute.attributeType.name,
                        templateId: templateItem.templateId,
                        rowIndex: rowIndex,
                        assessmentId: assessmentId,
                        focusValue: focusValue,
                        hasPreFilled: hasPreFilled
                    };
                };
                BaseAssessmentDatacontext.prototype.initParamsForMultiRowTemplateRegistration = function (assessmentId, templateItems, rowIndex) {
                    var _this = this;
                    var multiRowTemplateRegistrationParams = [];
                    _.forEach(templateItems, function (templateItem) {
                        if (rowIndex > 0 || (rowIndex < 0 && (templateItem.attribute.aggregations != undefined && templateItem.attribute.aggregations.length > 0)))
                            multiRowTemplateRegistrationParams.push(_this.initParamsForTemplateRegistration(assessmentId, templateItem, rowIndex));
                    });
                    return multiRowTemplateRegistrationParams;
                };
                BaseAssessmentDatacontext.prototype.createTemplateRegistrations = function (initParams) {
                    var _this = this;
                    var list = [];
                    _.forEach(initParams, function (item) {
                        var tr = _this.assessmentUnitOfWork.templateRegistrationRepository.createEntity(item, breeze.EntityState.Added);
                        if (!tr)
                            return;
                        var defaultValue = _.find(tr.attribute.attributeMetadatas, function (metadata) {
                            return metadata.attributeMetadataTypeId === app.constants.attributeMetadataType.Default;
                        });
                        if (item.hasOwnProperty("focusValue")) {
                            tr.focusValue = item.focusValue;
                        }
                        else if (!app.common.utils.isNullOrUndefined(defaultValue)) {
                            tr.focusValue = parseInt(defaultValue.value);
                        }
                        if (item.hasOwnProperty("hasPreFilled")) {
                            tr.isReadOnly = tr.hasPreFilled = item.hasPreFilled;
                        }
                        list.push(tr);
                    });
                    return list;
                };
                BaseAssessmentDatacontext.prototype.getAssessment = function (assessmentId) {
                    return this.assessmentUnitOfWork.assessmentRepository.findByIdInCache(assessmentId);
                };
                BaseAssessmentDatacontext.prototype.getAssessmentTypes = function () {
                    return this.assessmentUnitOfWork.assessmentTypeRepository.findInCache(this.activePredicate, 'sortOrder');
                };
                BaseAssessmentDatacontext.prototype.getAllowedRegistrationsInCache = function () {
                    if (this.assessmentUnitOfWork)
                        return this.assessmentUnitOfWork.allowedRegistrationRepository.allInCache();
                    else
                        return [];
                };
                BaseAssessmentDatacontext.prototype.getAssessmentTypeGroups = function () {
                    return this.assessmentUnitOfWork.assessmentTypeGroupRepository.findInCache(this.activePredicate, 'sortOrder');
                };
                BaseAssessmentDatacontext.prototype.getTemplateGroupsByAssessmentId = function (assessmentTypeId) {
                    return this.$q.when(this.assessmentUnitOfWork.templateGroupsRepository.executeCacheQuery(this.entityQuery.from(app.constants.resourceNames.templateGroupResource).where('assessmentTypeId', breeze.FilterQueryOp.Equals, assessmentTypeId)));
                };
                BaseAssessmentDatacontext.prototype.getAssessmentLinkList = function (siteId, forceRemote) {
                    if (forceRemote)
                        return this.assessmentUnitOfWork.assessmentRepository.executeQuery(this.entityQuery.from(app.constants.resourceNames.assessmentDTOResource).where('siteId', breeze.FilterQueryOp.Equals, siteId).where('isDraft', breeze.FilterQueryOp.Equals, false).where('assessmentTypeId', breeze.FilterQueryOp.Equals, app.constants.assessmentTypes.vaccination));
                    else
                        return this.$q.when(this.assessmentUnitOfWork.assessmentRepository.executeCacheQuery(this.entityQuery.from(app.constants.resourceNames.assessmentResource).where('siteId', breeze.FilterQueryOp.Equals, siteId).where('isDraft', breeze.FilterQueryOp.Equals, false).where('assessmentTypeId', breeze.FilterQueryOp.Equals, app.constants.assessmentTypes.vaccination)));
                };
                BaseAssessmentDatacontext.prototype.getAttribute = function (attributeId) {
                    return this.assessmentUnitOfWork.attributeRepository.findByIdInCache(attributeId);
                };
                BaseAssessmentDatacontext.prototype.deleteTemplateRegistations = function (templateRegistrations) {
                    _.forEach(templateRegistrations, function (templateRegistration) {
                        if (templateRegistration)
                            if (!app.common.utils.entityIsDetachedOrDeleted(templateRegistration))
                                templateRegistration.entityAspect.setDeleted();
                    });
                };
                BaseAssessmentDatacontext.prototype.addNewRowToMulitiRows = function (assessmentId, templateItems, rowIndex) {
                    return this.createTemplateRegistrations(this.initParamsForMultiRowTemplateRegistration(assessmentId, templateItems, rowIndex));
                };
                BaseAssessmentDatacontext.prototype.getFishgroups = function (siteId, focusDate) {
                    var predicates = this.activePredicate;
                    if (siteId) {
                        var sitePredicate = new breeze.Predicate("siteId", breeze.FilterQueryOp.Equals, siteId);
                        predicates = predicates.and(sitePredicate);
                    }
                    if (focusDate) {
                        var startDatePredicate = new breeze.Predicate("startDate", breeze.FilterQueryOp.LessThanOrEqual, focusDate);
                        var endDatePredicate = (new breeze.Predicate("endDate", breeze.FilterQueryOp.GreaterThanOrEqual, focusDate))
                            .or(new breeze.Predicate("endDate", breeze.FilterQueryOp.Equals, null));
                        var focusDatePredicate = startDatePredicate.and(endDatePredicate);
                        predicates = predicates.and(focusDatePredicate);
                    }
                    return this.assessmentUnitOfWork.fishGroupRepository.findInCache(predicates, "fishgroupName");
                };
                BaseAssessmentDatacontext.prototype.getMaxNumberOfRowForTemplate = function (assessmentId, templateId) {
                    var assessmentPredicate = new breeze.Predicate('assessmentId', breeze.FilterQueryOp.Equals, assessmentId);
                    var templatePredicate = new breeze.Predicate('templateId', breeze.FilterQueryOp.Equals, templateId);
                    var query = this.entityQuery.from(app.constants.resourceNames.templateRegistrationResource).where(assessmentPredicate.and(templatePredicate)).select('rowIndex');
                    var rowIndexes = this.assessmentUnitOfWork.templateRegistrationRepository.executeCacheQuery(query);
                    if (rowIndexes.length == 0)
                        return 0;
                    var maxNumber = _.maxBy(_.map(rowIndexes, 'rowIndex'));
                    return maxNumber < 0 ? 0 : maxNumber;
                };
                BaseAssessmentDatacontext.prototype.getTemplateRegistration = function (assessmentId, templateItem) {
                    var assessmentPredicate = new breeze.Predicate('assessmentId', breeze.FilterQueryOp.Equals, assessmentId);
                    var attributePredicate = new breeze.Predicate('attributeId', breeze.FilterQueryOp.Equals, templateItem.attributeId);
                    var templatePredicate = new breeze.Predicate('templateId', breeze.FilterQueryOp.Equals, templateItem.templateId);
                    return this.assessmentUnitOfWork.templateRegistrationRepository.find(assessmentPredicate.and(templatePredicate.and(attributePredicate)));
                };
                BaseAssessmentDatacontext.prototype.getTemplateRegistrations = function (assessmentId, clearCache) {
                    if (clearCache === void 0) { clearCache = true; }
                    var query = new breeze.EntityQuery().from(app.constants.resourceNames.templateRegistrationResource).withParameters({ assessmentId: assessmentId });
                    //remove all previous template registrations
                    if (clearCache)
                        this.clearCachedEntities('TemplateRegistration');
                    return this.assessmentUnitOfWork.templateRegistrationRepository.executeQuery(query);
                };
                BaseAssessmentDatacontext.prototype.clearCachedEntities = function (entityName) {
                    var _this = this;
                    var cachedEntities = this.assessmentUnitOfWork.getEntities(entityName); // all entities in cache
                    cachedEntities.forEach(function (entity) {
                        _this.assessmentUnitOfWork.detachEntity(entity);
                    });
                };
                BaseAssessmentDatacontext.prototype.getCustomers = function () {
                    return this.assessmentUnitOfWork.customerRepository.findInCache(this.activePredicate, 'name');
                };
                BaseAssessmentDatacontext.prototype.getSites = function (customerId, siteTypeId) {
                    if (siteTypeId === void 0) { siteTypeId = -1; }
                    var query = new breeze.EntityQuery(app.constants.resourceNames.siteResource).where(new breeze.Predicate("area.region.operation.customerBU.customerId", breeze.FilterQueryOp.Equals, customerId))
                        .where(this.activePredicate);
                    if (siteTypeId > -1)
                        query = query.where("siteType.siteTypeId", "==", siteTypeId);
                    return this.assessmentUnitOfWork.siteRepository.executeCacheQuery(query.orderBy('name'));
                };
                BaseAssessmentDatacontext.prototype.getSite = function (siteId) {
                    return this.assessmentUnitOfWork.siteRepository.findByIdInCache(siteId);
                };
                BaseAssessmentDatacontext.prototype.getSiteByName = function (name) {
                    var query = new breeze.EntityQuery(app.constants.resourceNames.siteResource).where(new breeze.Predicate("name", "==", name));
                    var result = this.assessmentUnitOfWork.siteRepository.executeCacheQuery(query);
                    return result.length > 0 ? result[0] : null;
                };
                BaseAssessmentDatacontext.prototype.getNahRepresentatives = function (siteId, includeInactive) {
                    var query = new breeze.EntityQuery(app.constants.resourceNames.contactPersonResource).where(new breeze.Predicate("isVetContact", "==", true).and(breeze.Predicate.create("vetUserId", breeze.FilterQueryOp.NotEquals, null)));
                    if (!includeInactive) {
                        query = query.where(this.activePredicate);
                    }
                    var hasResultsForSite;
                    if (siteId > 0) {
                        var siteVetQuery = new breeze.EntityQuery(app.constants.resourceNames.siteVetContactPersonResource).where(new breeze.Predicate("contactPerson.isVetContact", "==", true));
                        var p = breeze.Predicate.create("siteId", breeze.FilterQueryOp.Equals, siteId);
                        siteVetQuery = siteVetQuery.where(p);
                        var activePred = new breeze.Predicate("contactPerson.active", "==", true);
                        if (!includeInactive) {
                            siteVetQuery = siteVetQuery.where(activePred);
                        }
                        hasResultsForSite = this.assessmentUnitOfWork.contactPersonRepository.executeCacheQuery(siteVetQuery.orderBy('contactPerson.firstName, contactPerson.lastName'));
                    }
                    if (hasResultsForSite && hasResultsForSite.length > 0) {
                        return hasResultsForSite;
                    }
                    return this.assessmentUnitOfWork.contactPersonRepository.executeCacheQuery(query.orderBy('firstName, lastName'));
                };
                BaseAssessmentDatacontext.prototype.getNahRepresentative = function (userId) {
                    var query = new breeze.EntityQuery(app.constants.resourceNames.contactPersonResource).where(new breeze.Predicate("vetUserId", "==", userId));
                    return this.assessmentUnitOfWork.contactPersonRepository.executeCacheQuery(query)[0];
                };
                BaseAssessmentDatacontext.prototype.getSiteContactPersons = function (siteId, getOnlyActive) {
                    if (getOnlyActive === void 0) { getOnlyActive = false; }
                    var query = new breeze.EntityQuery(app.constants.resourceNames.contactPersonResource);
                    if (getOnlyActive) {
                        query = query.where(this.activePredicate);
                    }
                    var hasResultsForSite;
                    if (siteId > 0) {
                        var siteVetQuery = new breeze.EntityQuery(app.constants.resourceNames.siteContactPersonResource);
                        var p = breeze.Predicate.create("siteId", breeze.FilterQueryOp.Equals, siteId);
                        siteVetQuery = siteVetQuery.where(p);
                        var activePred = new breeze.Predicate("contactPerson.active", "==", true);
                        if (getOnlyActive) {
                            siteVetQuery = siteVetQuery.where(activePred);
                        }
                        hasResultsForSite = this.assessmentUnitOfWork.contactPersonRepository.executeCacheQuery(siteVetQuery.orderBy('contactPerson.firstName, contactPerson.lastName'));
                    }
                    if (hasResultsForSite && hasResultsForSite.length > 0) {
                        return hasResultsForSite;
                    }
                    return this.assessmentUnitOfWork.contactPersonRepository.executeCacheQuery(query.orderBy('firstName, lastName'));
                };
                BaseAssessmentDatacontext.prototype.getEvaluators = function () {
                    var query = breeze.EntityQuery.from(app.constants.resourceNames.contactPersonResource).where(this.activePredicate);
                    query = query.where("isExternalContractor", breeze.FilterQueryOp.Equals, true);
                    return this.assessmentUnitOfWork.contactPersonRepository.executeCacheQuery(query);
                };
                BaseAssessmentDatacontext.prototype.getAssessmentGroups = function () {
                    var query = new breeze.EntityQuery(app.constants.resourceNames.assessmentDiscriminatorResource);
                    return this.assessmentUnitOfWork.assessmentDicriminatorRepository.executeCacheQuery(query);
                };
                BaseAssessmentDatacontext.prototype.getAssessmentIdentifier = function () {
                    var query = new breeze.EntityQuery(app.constants.resourceNames.assessmentIdentifierResource);
                    return this.assessmentUnitOfWork.assessmentIdentifierRepository.executeCacheQuery(query);
                };
                BaseAssessmentDatacontext.prototype.getAttributeMetadataEnum = function (attributeName) {
                    var query = new breeze.EntityQuery(app.constants.resourceNames.attributeMetadataEnums);
                    query = query.where("attribute.dictionary.name", breeze.FilterQueryOp.Equals, attributeName);
                    return this.assessmentUnitOfWork.assessmentRepository.executeCacheQuery(query);
                };
                BaseAssessmentDatacontext.prototype.getAssessmentFollowUps = function () {
                    return this.assessmentUnitOfWork.assessmentFollowUpStatusRepository.allInCache();
                };
                BaseAssessmentDatacontext.prototype.getSuppliers = function (companyBUId) {
                    var activateAndFilterByCompany = companyBUId > 0 ? this.activePredicate.and(new breeze.Predicate("companyBUId", breeze.FilterQueryOp.Equals, companyBUId)) : this.activePredicate;
                    return this.assessmentUnitOfWork.suppliersRepository.findInCache(activateAndFilterByCompany, "name");
                };
                BaseAssessmentDatacontext.prototype.getDiagnoses = function () {
                    return this.assessmentUnitOfWork.diagnosesRepository.findInCache(this.activePredicate, 'name');
                };
                BaseAssessmentDatacontext.prototype.getDiagnosisById = function (diagnosisById) {
                    return this.assessmentUnitOfWork.diagnosesRepository.findByIdInCache(diagnosisById);
                };
                BaseAssessmentDatacontext.prototype.getVaccines = function () {
                    var treatmentProducts = this.assessmentUnitOfWork.treatmentProductRepository.findInCache(this.activePredicate, 'name');
                    return _.filter(treatmentProducts, function (treatmentProduct) { return treatmentProduct.usageMask & 4; });
                };
                BaseAssessmentDatacontext.prototype.getPreFillTemplateRegistrations = function (assessment, assessmentDiscriminator, forceRemote) {
                    var _this = this;
                    if (forceRemote === void 0) { forceRemote = false; }
                    if (forceRemote) {
                        this.assessmentUnitOfWork.assessmentRepository.executeQuery(this.entityQuery.from(app.constants.resourceNames.assessmentResource).where('assessmentDiscriminator', breeze.FilterQueryOp.Equals, assessmentDiscriminator)).then(function (assessments) {
                            if (assessments.length === 0)
                                return;
                            var vaccinationAssessment = assessments[0];
                            _this.getTemplateRegistrations(vaccinationAssessment.assessmentId, false).then(function () {
                                _this.fillDataToCurrentAssessment(assessment, vaccinationAssessment);
                            });
                        });
                    }
                    else {
                        var assessments = this.assessmentUnitOfWork.assessmentRepository.executeCacheQuery(this.entityQuery.from(app.constants.resourceNames.assessmentResource).where('assessmentDiscriminator', breeze.FilterQueryOp.Equals, assessmentDiscriminator));
                        if (!assessments.length)
                            return;
                        else
                            this.fillDataToCurrentAssessment(assessment, assessments[0]);
                    }
                };
                BaseAssessmentDatacontext.prototype.fillDataToCurrentAssessment = function (assessment, vaccinationAssessment) {
                    var _this = this;
                    //clear any exisiting profill
                    this.clearPreFillTemplates(assessment);
                    if (assessment) {
                        _.forEach(assessment.templateGroups, function (tg) {
                            var templateRegistrations = _.filter(assessment.templateRegistrations, function (tr) {
                                //find templateitem that has prefillTemplateId
                                var templateItem = _.find(tr.template.templateItems, function (ti) {
                                    return ti.templateId === tr.templateId && ti.attributeId === tr.attributeId && ti.prefillTemplateId !== null;
                                });
                                return (!app.common.utils.isNullOrUndefined(templateItem) && tr.templateId === tg.templateId);
                            });
                            var prefilltemplate = _.find(tg.template.templateItems, function (ti) {
                                return (ti.prefillTemplateId != null);
                            });
                            if (prefilltemplate != null) {
                                var source = _.filter(vaccinationAssessment.templateRegistrations, function (tr) {
                                    return tr.templateId == prefilltemplate.prefillTemplateId;
                                });
                                if (tg.hasMultiRows) {
                                    if (source.length > 0) {
                                        var noOfRows = _.maxBy(source, function (tr) { return tr.rowIndex; }).rowIndex;
                                        _.times(noOfRows, function (n) {
                                            var list = _this.addNewRowToMulitiRows(assessment.assessmentId, tg.template.templateItems, n + 1);
                                            _.forEach(list, function (tr) {
                                                _this.mapToEntity(tr, vaccinationAssessment.templateRegistrations, prefilltemplate, n + 1);
                                            });
                                        });
                                        tg.rows = _.range(noOfRows);
                                    }
                                }
                                else {
                                    if (templateRegistrations.length > 0) {
                                        _.forEach(templateRegistrations, function (tr) {
                                            _this.mapToEntity(tr, vaccinationAssessment.templateRegistrations, prefilltemplate, null);
                                        });
                                    }
                                }
                            }
                        });
                    }
                };
                BaseAssessmentDatacontext.prototype.mapToEntity = function (destinationTemplateReg, sourceTemplateRegs, prefilltemplate, rowIndex) {
                    var sourceTemplateReg = _.find(sourceTemplateRegs, function (tr) {
                        return tr.templateId == prefilltemplate.prefillTemplateId && tr.attributeId == destinationTemplateReg.attributeId && rowIndex == tr.rowIndex;
                    });
                    if (destinationTemplateReg != null && sourceTemplateReg != null) {
                        if (sourceTemplateReg.attribute.attributeType == app.constants.attributeType.Date)
                            destinationTemplateReg.focusValue = new Date(sourceTemplateReg.focusValue);
                        else
                            destinationTemplateReg.focusValue = sourceTemplateReg.focusValue;
                        destinationTemplateReg.hasPreFilled = true;
                        destinationTemplateReg.prefillAssessmentId = sourceTemplateReg.assessmentId;
                    }
                };
                BaseAssessmentDatacontext.prototype.clearPreFillTemplates = function (assessment, setDeleted) {
                    if (setDeleted === void 0) { setDeleted = true; }
                    if (assessment && assessment.assessmentType) {
                        _.forEach(assessment.templateGroups, function (tg) {
                            var templateRegistrations = _.filter(assessment.templateRegistrations, function (tr) {
                                //find templateitem that has prefillTemplateId
                                var templateItem = _.find(tr.template.templateItems, function (ti) {
                                    return ti.templateId === tr.templateId && ti.attributeId === tr.attributeId && ti.prefillTemplateId !== null;
                                });
                                return (!app.common.utils.isNullOrUndefined(templateItem) && tr.templateId === tg.templateId);
                            });
                            _.forEach(templateRegistrations, function (tr) {
                                if (tg.hasMultiRows) {
                                    if (setDeleted)
                                        tr.entityAspect.setDeleted();
                                    else {
                                        tr.entityAspect.setDetached();
                                    }
                                }
                                else {
                                    tr.reset();
                                }
                            });
                            if (templateRegistrations.length > 0 && tg.hasMultiRows)
                                tg.rows = _.range(0);
                        });
                    }
                };
                BaseAssessmentDatacontext.prototype.getFarmerInventory = function (objectKey, siteId, focusDate) {
                    var query = new breeze.EntityQuery('GetFarmerInventory').withParameters({
                        objectKey: objectKey,
                        siteId: siteId,
                        focusDate: focusDate
                    });
                    return this.assessmentUnitOfWork.auditRepository.executeQuery(query);
                };
                BaseAssessmentDatacontext.prototype.getFarmerEnvironment = function (objectKey, siteId, focusDate) {
                    var query = new breeze.EntityQuery('GetFarmerEnvironment').withParameters({
                        objectKey: objectKey,
                        siteId: siteId,
                        focusDate: focusDate
                    });
                    return this.assessmentUnitOfWork.auditRepository.executeQuery(query);
                };
                BaseAssessmentDatacontext.prototype.getFarmerInventoryByRange = function (objectKey, siteId, focusDate, periodDays) {
                    var query = new breeze.EntityQuery('GetFarmerInventoryByRange').withParameters({
                        objectKey: objectKey,
                        siteId: siteId,
                        focusDate: focusDate,
                        periodDays: periodDays
                    });
                    return this.assessmentUnitOfWork.auditRepository.executeQuery(query);
                };
                BaseAssessmentDatacontext.prototype.getCleanerFishDetails = function (objectKey, siteId, focusDate, periodDays) {
                    var query = new breeze.EntityQuery('GetCleanerFishDetails').withParameters({
                        objectKey: objectKey,
                        siteId: siteId,
                        focusDate: focusDate,
                        periodDays: periodDays
                    });
                    return this.assessmentUnitOfWork.auditRepository.executeQuery(query);
                };
                BaseAssessmentDatacontext.prototype.getFarmerMortalities = function (objectKey, siteId, focusDate, periodDays) {
                    var query = new breeze.EntityQuery('GetFarmerMortalities').withParameters({
                        objectKey: objectKey,
                        siteId: siteId,
                        focusDate: focusDate,
                        periodDays: periodDays
                    });
                    return this.assessmentUnitOfWork.auditRepository.executeQuery(query);
                };
                BaseAssessmentDatacontext.prototype.getFarmerLiceCountings = function (objectKey, siteId, focusDate, periodDays) {
                    this.sharedDatacontext.requestNonBlockingUi();
                    var query = new breeze.EntityQuery('GetFarmerLiceCountings').withParameters({
                        objectKey: objectKey,
                        siteId: siteId,
                        focusDate: focusDate,
                        periodDays: periodDays
                    });
                    return this.assessmentUnitOfWork.auditRepository.executeQuery(query);
                };
                BaseAssessmentDatacontext.prototype.getFarmerTreatments = function (objectKey, siteId, focusDate, periodDays) {
                    var query = new breeze.EntityQuery('GetFarmerTreatments').withParameters({
                        objectKey: objectKey,
                        siteId: siteId,
                        focusDate: focusDate,
                        periodDays: periodDays
                    });
                    return this.assessmentUnitOfWork.auditRepository.executeQuery(query);
                };
                BaseAssessmentDatacontext.prototype.getFarmerVaccinations = function (objectKey, siteId, focusDate, periodDays) {
                    var query = new breeze.EntityQuery('GetFarmerVaccinations').withParameters({
                        objectKey: objectKey,
                        siteId: siteId,
                        focusDate: focusDate,
                        periodDays: periodDays
                    });
                    return this.assessmentUnitOfWork.auditRepository.executeQuery(query);
                };
                BaseAssessmentDatacontext.prototype.getIsFarmerIntegrationEnabled = function () {
                    var query = new breeze.EntityQuery('IsFarmerIntegrationEnabled');
                    return this.assessmentUnitOfWork.auditRepository.executeQuery(query);
                };
                BaseAssessmentDatacontext.prototype.GetNoOfDaysFromFarmer = function () {
                    var query = new breeze.EntityQuery('GetNoOfDaysFromFarmer');
                    return this.assessmentUnitOfWork.auditRepository.executeQuery(query);
                };
                return BaseAssessmentDatacontext;
            })();
            data.BaseAssessmentDatacontext = BaseAssessmentDatacontext;
        })(data = common.data || (common.data = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

/// <reference path="../../_typings.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var common;
    (function (common) {
        var data;
        (function (data_1) {
            var BasePrescriptionDatacontext = (function (_super) {
                __extends(BasePrescriptionDatacontext, _super);
                function BasePrescriptionDatacontext(_$q, _sharedDatacontext) {
                    _super.call(this, _$q, _sharedDatacontext);
                    this.entityQuery = breeze.EntityQuery;
                    this.breeze = breeze;
                    this.activePredicate = new breeze.Predicate("active", breeze.FilterQueryOp.Equals, true);
                }
                BasePrescriptionDatacontext.prototype.init = function (assessmentUnitOfWork) {
                    return this.$q.when(this.assessmentUnitOfWork = assessmentUnitOfWork);
                };
                BasePrescriptionDatacontext.prototype.createPrescriptionWithSiteId = function (siteId) {
                    var item = this.createPrescription({
                        prescriptionDate: null,
                        siteId: siteId
                    });
                    return item;
                };
                BasePrescriptionDatacontext.prototype.createPrescription = function (prescriptionInit) {
                    var prescription = this.assessmentUnitOfWork.prescriptionsRepository.createEntity(prescriptionInit, breeze.EntityState.Added);
                    return prescription;
                };
                BasePrescriptionDatacontext.prototype.createFile = function (prescriptionId) {
                    return this.assessmentUnitOfWork.prescriptionfilesRepository.createEntity({ prescriptionId: prescriptionId }, breeze.EntityState.Added);
                };
                BasePrescriptionDatacontext.prototype.getTreatmentProducts = function (companyBUId, isOnline) {
                    if (isOnline === void 0) { isOnline = true; }
                    var activateAndFilterByCompany = companyBUId > 0 ? this.activePredicate.and(new breeze.Predicate("companyBUId", breeze.FilterQueryOp.Equals, companyBUId)) : this.activePredicate;
                    if (!isOnline)
                        return this.$q.when(this.assessmentUnitOfWork.treatmentProductRepository.findInCache(activateAndFilterByCompany, 'name'));
                    else {
                        var treatmentProducts = this.assessmentUnitOfWork.treatmentProductRepository.findInCache(activateAndFilterByCompany, 'name');
                        return this.$q.when(_.filter(treatmentProducts, function (treatmentProduct) {
                            return treatmentProduct.usageMask !== 4 && treatmentProduct.usageMask & 7;
                        }));
                    }
                };
                BasePrescriptionDatacontext.prototype.getTreatmentProductsFromCache = function (companyBUId) {
                    var activateAndFilterByCompany = companyBUId > 0 ? this.activePredicate.and(new breeze.Predicate("companyBUId", breeze.FilterQueryOp.Equals, companyBUId)) : this.activePredicate;
                    return this.assessmentUnitOfWork.treatmentProductRepository.findInCache(activateAndFilterByCompany, 'name');
                };
                BasePrescriptionDatacontext.prototype.getRegionalAuthorities = function (companyBUId) {
                    var activateAndFilterByCompany = companyBUId > 0 ? this.activePredicate.and(new breeze.Predicate("companyBUId", breeze.FilterQueryOp.Equals, companyBUId)) : this.activePredicate;
                    return this.assessmentUnitOfWork.regionalAuthorityRepository.findInCache(activateAndFilterByCompany, 'name');
                };
                BasePrescriptionDatacontext.prototype.getSpecies = function () {
                    return this.assessmentUnitOfWork.speciesRepository.findInCache(this.activePredicate, "name");
                };
                BasePrescriptionDatacontext.prototype.getProductionStages = function () {
                    return this.assessmentUnitOfWork.productionStageRepository.findInCache(this.activePredicate, "sortOrder");
                };
                BasePrescriptionDatacontext.prototype.updateFarmerTreatmentProducts = function (objectKey, page) {
                    var _this = this;
                    if (objectKey === void 0) { objectKey = null; }
                    if (page === void 0) { page = 0; }
                    if (page > 1)
                        return this.$q.resolve("Already loaded");
                    var query = new breeze.EntityQuery('GetFarmerTreatmentProducts').withParameters({
                        objectKey: objectKey
                    });
                    return this.assessmentUnitOfWork.auditRepository.executeQuery(query).then(function () {
                        _this.assessmentUnitOfWork.treatmentProductRepository.all();
                    });
                };
                BasePrescriptionDatacontext.prototype.getMeasureUnits = function () {
                    return this.assessmentUnitOfWork.measureUnitRepository.findInCache(this.activePredicate, "sortOrder");
                };
                BasePrescriptionDatacontext.prototype.save = function () {
                    return this.assessmentUnitOfWork.saveChanges();
                };
                BasePrescriptionDatacontext.prototype.hasChanges = function () {
                    return this.assessmentUnitOfWork.hasChanges();
                };
                BasePrescriptionDatacontext.prototype.validateEntity = function (entity) {
                    return this.assessmentUnitOfWork.validateEntity(entity);
                };
                BasePrescriptionDatacontext.prototype.getValidationErrors = function (prescription) {
                    return prescription.entityAspect.getValidationErrors();
                };
                BasePrescriptionDatacontext.prototype.rejectChangesOnEntity = function (entity) {
                    return this.assessmentUnitOfWork.rejectEntityChanges(entity);
                };
                BasePrescriptionDatacontext.prototype.getPrescriptionById = function (prescriptionId) {
                    return this.assessmentUnitOfWork.prescriptionsRepository.findById(prescriptionId);
                };
                BasePrescriptionDatacontext.prototype.getPrescription = function (prescriptionId) {
                    return this.assessmentUnitOfWork.prescriptionsRepository.findByIdInCache(prescriptionId);
                };
                BasePrescriptionDatacontext.prototype.deletePrescription = function (prescriptionId) {
                    var query = new breeze.EntityQuery('DeletePrescriptionById?prescriptionId=' + prescriptionId);
                    return this.assessmentUnitOfWork.prescriptionsRepository.executeQuery(query)
                        .then(function (data) {
                        console.log('delete [Prescription] from remote data source');
                    })
                        .catch(function (error) {
                        console.log('error: ' + error);
                        return error;
                    });
                };
                BasePrescriptionDatacontext.prototype.createTreatmentProduct = function () {
                    return this.assessmentUnitOfWork.treatmentProductRepository.createEntity({}, breeze.EntityState.Added);
                };
                BasePrescriptionDatacontext.prototype.deleteTreatmentProduct = function (treatmentProductId) {
                    var _this = this;
                    var predicate = new breeze.Predicate('treatmentProductId', breeze.FilterQueryOp.Equals, treatmentProductId);
                    var treatmentProduct = this.assessmentUnitOfWork.treatmentProductRepository.findInCache(predicate);
                    var query = new breeze.EntityQuery('DeleteTreatmentProductById?treatmentProductId=' + treatmentProductId);
                    return this.assessmentUnitOfWork.treatmentProductProducersRepository.executeQuery(query)
                        .then(function (data) {
                        // console.log('delete [TreatmentProduct] from remote data source');
                        if (!app.common.utils.entityIsDetachedOrDeleted(treatmentProduct[0])) {
                            if (treatmentProduct[0].treatmentProductId > 0)
                                treatmentProduct[0].entityAspect.setDeleted();
                            else
                                _this.assessmentUnitOfWork.detachEntity(treatmentProduct[0]);
                        }
                    })
                        .catch(function (error) {
                        console.log('error: ' + error);
                        return error;
                    });
                };
                BasePrescriptionDatacontext.prototype.getTreatmentProductById = function (treatmentProductId) {
                    return this.assessmentUnitOfWork.treatmentProductRepository.findById(treatmentProductId);
                };
                BasePrescriptionDatacontext.prototype.getTreatmentProductByIdInCache = function (treatmentProductId) {
                    return this.assessmentUnitOfWork.treatmentProductRepository.findByIdInCache(treatmentProductId);
                };
                BasePrescriptionDatacontext.prototype.getSuppliers = function (companyBUId) {
                    var activateAndFilterByCompany = companyBUId > 0 ? this.activePredicate.and(new breeze.Predicate("companyBUId", breeze.FilterQueryOp.Equals, companyBUId)) : this.activePredicate;
                    return this.assessmentUnitOfWork.suppliersRepository.findInCache(activateAndFilterByCompany, "name");
                };
                BasePrescriptionDatacontext.prototype.getProducers = function () {
                    return this.assessmentUnitOfWork.treatmentProductProducersRepository.findInCache(this.activePredicate, "name");
                };
                BasePrescriptionDatacontext.prototype.getActiveSubstances = function () {
                    return this.assessmentUnitOfWork.activeSubstancesRepository.findInCache(this.activePredicate, "name");
                };
                BasePrescriptionDatacontext.prototype.getCompanyBUs = function () {
                    return this.assessmentUnitOfWork.companyBUsRepository.findInCache(this.activePredicate, "name");
                };
                BasePrescriptionDatacontext.prototype.getAllActiveSubstances = function () {
                    return this.assessmentUnitOfWork.activeSubstancesRepository.allInCache(false, "name");
                };
                BasePrescriptionDatacontext.prototype.getIndications = function () {
                    var indications = this.assessmentUnitOfWork.treatmentProductIndicationsRepository
                        .findInCache(this.activePredicate, "name");
                    return _.map(indications, function (item) { return _.pick(item, ["treatmentProductIndicationId", "name"]); });
                };
                BasePrescriptionDatacontext.prototype.getQuarantineTypes = function () {
                    return this.assessmentUnitOfWork.quarantineTypeRepository.findInCache(this.activePredicate, "quarantineTypeId");
                };
                BasePrescriptionDatacontext.prototype.createActiveSubstance = function () {
                    return this.assessmentUnitOfWork.activeSubstancesRepository.createEntity({ active: true }, breeze.EntityState.Added);
                };
                BasePrescriptionDatacontext.prototype.saveLockePrescriptionPdf = function (prescriptionId, languageId, title, auditId) {
                    var query = breeze.EntityQuery
                        .from("GetPrescriptionReportFileNameAndSaveAsPdf")
                        .withParameters({
                        prescriptionId: prescriptionId,
                        languageId: languageId,
                        title: title,
                        isLocking: true,
                        auditId: auditId
                    });
                    return this.assessmentUnitOfWork.prescriptionsRepository.executeQuery(query);
                };
                BasePrescriptionDatacontext.prototype.createAudit = function (initParams) {
                    var audit = this.assessmentUnitOfWork.auditRepository.createEntity(initParams, breeze.EntityState.Added);
                    return audit;
                };
                return BasePrescriptionDatacontext;
            })(data_1.BaseAssessmentDatacontext);
            data_1.BasePrescriptionDatacontext = BasePrescriptionDatacontext;
        })(data = common.data || (common.data = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

var app;
(function (app) {
    var common;
    (function (common) {
        var base;
        (function (base) {
            var controllers;
            (function (controllers) {
                var BusinessRuleCalculationValue = (function () {
                    // Constructor
                    function BusinessRuleCalculationValue(registration) {
                        this.registration = registration;
                        this.templateId = registration.templateId;
                        //this.attributeValueCollection.push(registration);
                    }
                    return BusinessRuleCalculationValue;
                })();
                controllers.BusinessRuleCalculationValue = BusinessRuleCalculationValue;
                var AssessmentController = (function () {
                    function AssessmentController($scope, $translate, $q, $timeout, wizardHandler, pythonHandler, appLocalStorage, datacontext, env, busyIndicator) {
                        this.$scope = $scope;
                        this.$translate = $translate;
                        this.$q = $q;
                        this.$timeout = $timeout;
                        this.wizardHandler = wizardHandler;
                        this.pythonHandler = pythonHandler;
                        this.appLocalStorage = appLocalStorage;
                        this.datacontext = datacontext;
                        this.env = env;
                        this.busyIndicator = busyIndicator;
                        this.title = "";
                        this.businessRuleExpressions = [];
                        this.businessRuleResultValues = [];
                        this.businessRuleValues = [];
                        this.nextButtonText = '';
                        this.backButtonText = '';
                        this.lastButtonText = '';
                        this.showBackAndSaveDraftButton = false;
                        this.isLastStep = false;
                        this.hasValidationProblem = false;
                        this.errorMessage = "";
                        this.showFlag = false;
                        this.showDelete = false;
                        this.flagInformation = null;
                        this.isInitialized = false;
                        this.isCanceling = true;
                        this.progressValue = "0";
                        this.rowDeletedAlert = 0;
                        this.rowDeletedAlertVisible = false;
                        this.readonly = false;
                        this.refreshTabIndexLoop = false;
                        this.isFarmerIntegrationOn = false;
                        // End Abstract Methods
                        /*
                        offsetsOnRowIndexes is used to set offset when rows are deleted. offset values are used when selecting rows / saving data.
                        */
                        this.offsetsOnRowIndexes = [];
                        this.$scope.viewModel = this;
                        this.isFarmerIntegrationOn = this.appLocalStorage.farmerIntegerationEnabledGet();
                        this.noOfdaysFromFarmer = this.appLocalStorage.noOfdaysFromFarmerGet();
                    }
                    //Abstract Methods
                    AssessmentController.prototype.loadAssessment = function () { throw new Error('This method is abstract'); };
                    AssessmentController.prototype.save = function (mode) { throw new Error('This method is abstract'); };
                    AssessmentController.prototype.cancel = function () { throw new Error('This method is abstract'); };
                    AssessmentController.prototype.showFlagInformation = function () { throw new Error('This method is abstract'); };
                    AssessmentController.prototype.getImageUploadHeaders = function () { throw new Error('This method is abstract'); };
                    AssessmentController.prototype.isOnline = function () { throw new Error('This method is abstract'); };
                    AssessmentController.prototype.onChangeLabelAndGo = function (direction, toStepIndex, skipThis) { throw new Error('This method is abstract'); };
                    ;
                    AssessmentController.prototype.initOffsetsOnRowIndexes = function (templateGroups) {
                        var _this = this;
                        this.offsetsOnRowIndexes = [];
                        _.forEach(templateGroups, function (tg) {
                            tg.selectedRow = 1;
                            if (tg.template.multiRows) {
                                var templateRegistrations = _this.getTemplateRegistrationsForTemplate(tg.template.templateId); // get current after delete or add
                                var indexedByRowIndex = _.keyBy(templateRegistrations, 'rowIndex');
                                _.forEach(indexedByRowIndex, function (registration) {
                                    _this.offsetsOnRowIndexes.push({ templateId: tg.template.templateId, rowIndex: registration.rowIndex, offset: 0 });
                                });
                            }
                        });
                    };
                    AssessmentController.prototype.showFarmerInfor = function (templateName) {
                        return this.isFarmerIntegrationOn && _.includes(['Visit_Inventory'], templateName);
                    };
                    AssessmentController.prototype.showFarmerPeriodInfor = function (templateName) {
                        return this.isFarmerIntegrationOn && _.includes(['Visit_Mortality', 'Visit_Vaccination', 'Visit_Treatments', 'Visit_LiceCounting', 'Visit_Environment'], templateName);
                    };
                    AssessmentController.prototype.showFarmerAttribute = function (templateItem) {
                        return (templateItem.attribute.dictionary.name != 'ExcludeFarmerData') || (templateItem.attribute.dictionary.name == 'ExcludeFarmerData' && this.isFarmerIntegrationOn && this.assessment.site && this.assessment.site.customer.integrationServiceConfigurationId);
                    };
                    AssessmentController.prototype.getDefaultFollowupStatus = function (assessmentTypeId) {
                        return 1; // No follow up
                    };
                    AssessmentController.prototype.subscribeExpressionCalculations = function (templateRegistrations) {
                        var _this = this;
                        _.forEach(this.businessRuleExpressions, function (expRegistration) {
                            _.forEach(templateRegistrations, function (registration) {
                                if (registration.template.multiRows && expRegistration.multiRows && registration.rowIndex > 0 && !_this.pythonHandler.expressionHasAttribute(expRegistration.expression, registration.attributeId)) {
                                    if (registration.entityAspect.propertyChanged._subscribers === undefined || registration.entityAspect.propertyChanged._subscribers.length < 3)
                                        registration.entityAspect.propertyChanged.subscribe(function (propertyChangedArgs) {
                                            _this.$q.when(_this.updateTotals(registration));
                                        });
                                }
                                if (_this.pythonHandler.expressionHasAttribute(expRegistration.expression, registration.attributeId) || registration.attribute.dictionary.name.indexOf("Receiving tank / pen no.") != -1) {
                                    if (registration.entityAspect.propertyChanged._subscribers === undefined || registration.entityAspect.propertyChanged._subscribers.length < 3)
                                        registration.entityAspect.propertyChanged.subscribe(function (propertyChangedArgs) {
                                            if (propertyChangedArgs.propertyName != 'rowIndex')
                                                _this.$q.when(_this.triggerBusinessRuleCalculation(registration)).then(function () {
                                                    if (!app.common.utils.entityIsDetachedOrDeleted(registration)) {
                                                        if (registration.template && registration.template.multiRows && registration.rowIndex > 0) {
                                                            if (_.includes(app.constants.cascadingAttributesForCalculation, registration.attributeId)) {
                                                                var cascadeAttributeIds = _.filter(app.constants.cascadingAttributesForCalculation, function (attrid) { return attrid != registration.attributeId; });
                                                                _.forEach(cascadeAttributeIds, function (cascadeAttributeId) {
                                                                    var cascadeRegistration = _this.getTemplateRegistrationsFromMultiRowByRowIndex(registration.templateId, cascadeAttributeId, registration.rowIndex);
                                                                    _this.updateTotals(cascadeRegistration);
                                                                });
                                                            }
                                                            _this.updateTotals(registration);
                                                        }
                                                    }
                                                });
                                        });
                                    if (_this.getBusinessRuleCalculationValue(registration) === undefined) {
                                        _this.businessRuleValues.push(new BusinessRuleCalculationValue(registration));
                                    }
                                }
                                //TODO: Had to remove this check to get result fields for Case 73865, but now it loads everything...
                                //else if (registration.attribute.attributeType.name == constants.attributeType.BusinessRule) {
                                if (_this.getBusinessRuleResultValue(registration.templateId, registration.attributeId, registration.rowIndex) === undefined)
                                    _this.businessRuleResultValues.push(registration); //store regist
                                //}
                            }, _this);
                        }, this);
                        this.triggerBusinessRuleCalculation();
                    };
                    // Triggered when values changed
                    AssessmentController.prototype.triggerBusinessRuleCalculation = function (registration) {
                        var _this = this;
                        if (registration === void 0) { registration = null; }
                        var query;
                        var businessRuleResultRegistration;
                        _.forEach(this.businessRuleExpressions, function (expression) {
                            query = null;
                            if (registration != null && !(_this.pythonHandler.expressionHasAttribute(expression.expression, registration.attributeId) || registration.attribute.dictionary.name.indexOf("Receiving tank / pen no.") != -1))
                                return; // stop calling pythonscript when no related attribute changed
                            if (expression.multiRows) {
                                if (registration != null && registration.rowIndex > -1) {
                                    businessRuleResultRegistration = _this.getBusinessRuleResultValue(registration.templateId, expression.resultAttributeId, registration.rowIndex);
                                    if (registration != null && !registration.entityAspect.validateEntity()) {
                                        businessRuleResultRegistration.doubleValue = 0;
                                        return;
                                    }
                                    else if (registration != null && registration.doubleValue === -999) {
                                        businessRuleResultRegistration.doubleValue = null;
                                        return;
                                    }
                                    query = _this.pythonHandler.buildQuery(_this.assessment, _this.businessRuleValues, expression.expression, false, registration.rowIndex);
                                }
                            }
                            else {
                                if (registration != null) {
                                    businessRuleResultRegistration = _this.getBusinessRuleResultValue(registration.templateId, expression.resultAttributeId, registration.rowIndex);
                                }
                                query = _this.pythonHandler.buildQuery(_this.assessment, _this.businessRuleValues, expression.expression, true, 0);
                            }
                            if (query == null)
                                _this.$q.when(expression.result = null);
                            else if (_.includes(query, '-999')) {
                                businessRuleResultRegistration.doubleValue = null;
                            }
                            else {
                                {
                                    //TODO: Find out why DependOn fails when called with empty string parameter - Case 73865
                                    var result = (query == "DependOn('')") ? '' : _this.pythonHandler.execute(query);
                                    if (expression.multiRows && businessRuleResultRegistration != null && businessRuleResultRegistration.doubleValue !== undefined)
                                        try {
                                            if (expression.expression.indexOf("ValidExpiryDate") != -1) {
                                                businessRuleResultRegistration.booleanValue = result ? true : false;
                                                if (_this.pythonHandler.expressionHasAttribute(expression.expression, registration.attributeId) && registration.attribute.dictionary.name.indexOf("Receiving tank / pen no.") == -1) {
                                                    //registration.customError = { haserror: !result, errorType: constants.errorType.InvalidExpDate, value: registration.focusValue, message: constants.errorMessages.inValidNumber };
                                                    var relatedRegs = _this.getRelatedRegistrations(expression.expression, registration);
                                                    _.forEach(relatedRegs, function (reg) {
                                                        reg.customError = { haserror: !result, errorType: app.constants.errorType.InvalidExpDate, value: registration.focusValue, message: app.constants.errorMessages.inValidNumber };
                                                    });
                                                }
                                            }
                                            else {
                                                var rounded = (result != null && result != "") ? parseFloat(result).toFixed(2) : "0";
                                                businessRuleResultRegistration.doubleValue = rounded; //set calculated value per row
                                            }
                                        }
                                        catch (e) {
                                            businessRuleResultRegistration.doubleValue = result; //set calculated value per row
                                        }
                                    else if (expression.expression.indexOf("AssessmentDiscriminatorGet") != -1)
                                        _this.assessment.assessmentDiscriminator = decodeURI(result);
                                    else if (expression.expression.indexOf("GetFlags") != -1) {
                                        expression.result = result;
                                        _this.flagInformation = result;
                                        _this.showFlag = _.some(result, 'isFlagRaised');
                                    }
                                    else if (expression.expression.indexOf("DependOn") != -1 && businessRuleResultRegistration) {
                                        //TODO: focusValue is set, but GUI does not reflect this                            
                                        businessRuleResultRegistration.focusValue = result;
                                    }
                                    else
                                        expression.result = result;
                                }
                            }
                            //console.log("TriggerBusinessRuleCalculation : " + query);
                        });
                    };
                    AssessmentController.prototype.addRow = function (templateGroup) {
                        templateGroup.rows = _.range(templateGroup.rows.length + 1).map(function (row) { return { row: row, selected: templateGroup.rows.length == row, open: false }; });
                        var rowIndex = this.datacontext.getMaxNumberOfRowForTemplate(this.assessment.assessmentId, templateGroup.templateId) + 1;
                        var templateRegistrations = this.datacontext.addNewRowToMulitiRows(this.assessment.assessmentId, templateGroup.template.templateItems, rowIndex);
                        this.offsetsOnRowIndexes.push({ templateId: this.getCurrentTemplateId(), rowIndex: rowIndex, offset: templateGroup.rows.length - rowIndex });
                        this.subscribeExpressionCalculations(templateRegistrations);
                        this.selectItem(templateGroup.template, templateGroup.rows.length);
                        if (templateGroup.hasTotals)
                            this.updateTotalsAll(templateGroup.template);
                        return templateGroup.rows;
                    };
                    AssessmentController.prototype.deleteRow = function (rowIndex, templateGroup) {
                        var _this = this;
                        this.rowDeletedAlert = rowIndex;
                        this.rowDeletedAlertVisible = true;
                        this.datacontext.deleteTemplateRegistations(this.getTemplateRegistrationsForMultiRow(templateGroup.template, rowIndex));
                        //remove all detached and deleted
                        _.remove(this.assessment.templateRegistrations, function (registration) {
                            return app.common.utils.entityIsDetachedOrDeleted(registration);
                        });
                        //remove offset for deleted row.
                        _.remove(this.offsetsOnRowIndexes, function (offsetRow) {
                            return offsetRow.templateId === _this.getCurrentTemplateId() && offsetRow.rowIndex + offsetRow.offset === rowIndex;
                            ;
                        });
                        this.reindexRows(rowIndex, templateGroup.template);
                        templateGroup.rows.splice(rowIndex - 1, 1);
                        if (rowIndex <= templateGroup.selectedRow) {
                            if (templateGroup.selectedRow > templateGroup.rows.length) {
                                templateGroup.selectedRow = templateGroup.rows.length;
                            }
                            else {
                                templateGroup.selectedRow = templateGroup.selectedRow - 1;
                            }
                            this.selectItem(templateGroup, templateGroup.selectedRow);
                        }
                        if (templateGroup.hasTotals)
                            this.updateTotalsAll(templateGroup.template);
                        this.triggerBusinessRuleCalculation();
                    };
                    AssessmentController.prototype.getRelatedRegistrations = function (expression, registration) {
                        var _this = this;
                        return _.filter(this.getTemplateRegistrationsForMultiRow(registration.template, registration.rowIndex), function (reg) {
                            return _this.pythonHandler.expressionHasAttribute(expression, reg.attributeId);
                        });
                    };
                    AssessmentController.prototype.updateTotals = function (registration) {
                        var excludeFromTotalRowIndexes = _.map(_.filter(this.assessment.templateRegistrations, function (templateRegistration) {
                            return templateRegistration.templateId === registration.templateId
                                && templateRegistration.rowIndex > 0
                                && templateRegistration.focusValue === -999; //skip not present values
                        }), function (templateRegistration) {
                            return templateRegistration.rowIndex;
                        });
                        var values = _.map(_.filter(this.assessment.templateRegistrations, function (templateRegistration) {
                            return !app.common.utils.entityIsDetachedOrDeleted(templateRegistration)
                                && templateRegistration.templateId === registration.templateId
                                && templateRegistration.attributeId === registration.attributeId
                                && templateRegistration.rowIndex > 0 && (!(_.includes(excludeFromTotalRowIndexes, templateRegistration.rowIndex) && _.includes(app.constants.cascadingAttributesForCalculation, registration.attributeId)))
                                && (!isNaN(templateRegistration.focusValue != null ? templateRegistration.focusValue.toString().replace(",", ".") : null) || (templateRegistration.attribute.attributeType.name == 'Boolean' && !app.common.utils.isNullOrUndefined(templateRegistration.focusValue)));
                        }), function (templateRegistration) {
                            if (templateRegistration.attribute.attributeType.name === 'Boolean')
                                return templateRegistration.focusValue ? 1 : 0;
                            else
                                return !app.common.utils.isNullOrUndefined(templateRegistration.focusValue) ? parseFloat(app.common.utils.unformatDecimal(templateRegistration.focusValue)) : null;
                        });
                        var aggregatedResult;
                        _.forEach(this.assessment.templateRegistrations, function (templateRegistration) {
                            var precision = 2;
                            if (templateRegistration.templateId === registration.templateId && templateRegistration.attributeId === registration.attributeId && templateRegistration.rowIndex < 0)
                                _.forEach(templateRegistration.attribute.aggregations, function (aggregation) {
                                    aggregatedResult = app.common.utils.aggregateRows(aggregation, values, templateRegistration.attribute.attributeType.name);
                                    if (templateRegistration.rowIndex === -1) {
                                        if (templateRegistration.attribute.attributeType.name === 'Integer' || templateRegistration.attribute.attributeType.name === 'Boolean') {
                                            precision = 0;
                                            templateRegistration.integerValue = app.common.utils.precise_round(aggregatedResult, precision);
                                        }
                                        else {
                                            if (aggregation == 'AvgAbsolute') {
                                                var doublevalue = app.common.utils.precise_round(aggregatedResult, precision);
                                                templateRegistration.doubleValue = doublevalue;
                                                var average = app.common.utils.aggregateRows('Avg', values, templateRegistration.attribute.attributeType.name);
                                                var tendency = average < 0 ? 'tendency_tail' : average > 0 ? 'tendency_head' : 'tendency_no';
                                                templateRegistration.textValue = doublevalue + tendency;
                                                templateRegistration.tooltipValue = tendency;
                                            }
                                            else {
                                                if (aggregation !== 'STD') {
                                                    templateRegistration.doubleValue = app.common.utils.precise_round(aggregatedResult, precision);
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        if (aggregation === 'STD')
                                            templateRegistration.doubleValue = app.common.utils.precise_round(aggregatedResult, precision);
                                    }
                                });
                        });
                    };
                    AssessmentController.prototype.updateTotalsAll = function (template) {
                        var _this = this;
                        var firstRowRegistrations = this.getTemplateRegistrationsForMultiRow(template, 1); //first row
                        _.forEach(firstRowRegistrations, function (registration) {
                            _this.updateTotals(registration);
                        });
                    };
                    AssessmentController.prototype.getBusinessRuleResultValue = function (templateId, attributeId, rowIndex) {
                        var _this = this;
                        return _.find(this.businessRuleResultValues, function (reg) {
                            return _this.matchTemplateRegistrations(reg, { templateId: templateId, attributeId: attributeId, rowIndex: rowIndex });
                        });
                    };
                    AssessmentController.prototype.getBusinessRuleCalculationValue = function (templateRegistration) {
                        var _this = this;
                        return _.find(this.businessRuleValues, function (registration) {
                            return _this.matchTemplateRegistrations(registration.registration, templateRegistration);
                        });
                    };
                    AssessmentController.prototype.matchTemplateRegistrations = function (templateRegistration1, templateRegistration2) {
                        return !app.common.utils.entityIsDetachedOrDeleted(templateRegistration1) && templateRegistration1.templateId === templateRegistration2.templateId && templateRegistration1.attributeId === templateRegistration2.attributeId && templateRegistration1.rowIndex === templateRegistration2.rowIndex;
                    };
                    AssessmentController.prototype.getTemplateRegistrationsFromMultiRowByRowIndex = function (templateId, attributeId, rowIndex) {
                        return _.find(this.assessment.templateRegistrations, function (registration) {
                            return !app.common.utils.entityIsDetachedOrDeleted(registration) && registration.templateId === templateId && registration.attributeId === attributeId && registration.rowIndex === rowIndex;
                        });
                    };
                    AssessmentController.prototype.getMultiRowTemplateRegistrations = function (template) {
                        var _this = this;
                        var templateGroup = _.find(this.assessment.templateGroups, function (tg) {
                            return tg.templateId === template.templateId;
                        });
                        var attributeCount = templateGroup ? templateGroup.template.templateItems.length : 0;
                        var templateRegistrations = _.filter(this.assessment.templateRegistrations, function (registration) {
                            return !app.common.utils.entityIsDetachedOrDeleted(registration) && registration.templateId === template.templateId && registration.rowIndex > 0;
                        });
                        var maxTr = _.maxBy(templateRegistrations, function (tr) {
                            return tr.rowIndex;
                        });
                        var rowCount = 0;
                        if (maxTr) {
                            var offset = _.find(this.offsetsOnRowIndexes, function (offsetRow) {
                                return offsetRow.templateId === _this.getCurrentTemplateId() && offsetRow.rowIndex === maxTr.rowIndex;
                            });
                            rowCount = maxTr.rowIndex + (offset ? offset.offset : 0);
                        }
                        //this.mapFarmerData();
                        if (templateRegistrations.length === 0
                            || templateRegistrations.length >= attributeCount * rowCount)
                            return templateRegistrations;
                        else {
                            _.forEach(templateGroup.template.templateItems, function (ti) {
                                var hasTr = _.some(templateRegistrations, function (tr) {
                                    return tr.templateId === ti.templateId && tr.attributeId === ti.attributeId;
                                });
                                if (!hasTr) {
                                    var templateRegistrationParams = [];
                                    for (var n = 1; n <= rowCount; n++) {
                                        templateRegistrationParams.push(_this.datacontext.initParamsForTemplateRegistration(_this.assessment.assessmentId, ti, n));
                                    }
                                    _this.datacontext.createTemplateRegistrations(templateRegistrationParams);
                                }
                            });
                            return this.getMultiRowTemplateRegistrations(template);
                        }
                    };
                    AssessmentController.prototype.mapFarmerData = function (farmerTemplates) {
                        var _this = this;
                        if (farmerTemplates === void 0) { farmerTemplates = undefined; }
                        _.forEach(this.assessment.templateGroups, function (templateGroup) {
                            if (templateGroup.template.isFromFarmer) {
                                var templateRegistrations = _.filter(_this.assessment.templateRegistrations, function (registration) {
                                    return !app.common.utils.entityIsDetachedOrDeleted(registration) && registration.templateId === templateGroup.template.templateId;
                                });
                                switch (farmerTemplates) {
                                    case app.constants.farmerTemplates.Visit_Inventory:
                                        _this.mapFarmerDataToTemplateRegistration(app.constants.farmerTemplates.Visit_Inventory, _this.farmerInventory, templateGroup.template, templateGroup, templateRegistrations);
                                        break;
                                    case app.constants.farmerTemplates.Visit_Mortality:
                                        _this.mapFarmerDataToTemplateRegistration(app.constants.farmerTemplates.Visit_Mortality, _this.farmerMortality, templateGroup.template, templateGroup, templateRegistrations);
                                        break;
                                    case app.constants.farmerTemplates.Visit_LiceCounting:
                                        _this.mapFarmerDataToTemplateRegistration(app.constants.farmerTemplates.Visit_LiceCounting, _this.farmerLiceCounting, templateGroup.template, templateGroup, templateRegistrations);
                                        break;
                                    case app.constants.farmerTemplates.Visit_Treatments:
                                        _this.mapFarmerDataToTemplateRegistration(app.constants.farmerTemplates.Visit_Treatments, _this.farmerTreatments, templateGroup.template, templateGroup, templateRegistrations);
                                        break;
                                    case app.constants.farmerTemplates.Visit_Vaccination:
                                        _this.mapFarmerDataToTemplateRegistration(app.constants.farmerTemplates.Visit_Vaccination, _this.farmerVaccination, templateGroup.template, templateGroup, templateRegistrations);
                                        break;
                                    case app.constants.farmerTemplates.Visit_Environment:
                                        _this.mapFarmerDataToTemplateRegistration(app.constants.farmerTemplates.Visit_Environment, _this.farmerEnvironment, templateGroup.template, templateGroup, templateRegistrations);
                                        break;
                                    case app.constants.farmerTemplates.Welfare_Environmental_Indicators:
                                        _this.mapFarmerDataToTemplateRegistration(farmerTemplates, _this.farmerInventoryByRange, templateGroup.template, templateGroup, templateRegistrations);
                                        break;
                                    case app.constants.farmerTemplates.Welfare_Cleanerfish_Welfare:
                                        _this.mapFarmerDataToTemplateRegistration(farmerTemplates, _this.farmerCleanerFishDetails, templateGroup.template, templateGroup, templateRegistrations);
                                        break;
                                    default:
                                        _this.mapFarmerDataToTemplateRegistration(app.constants.farmerTemplates.Visit_Inventory, _this.farmerInventory, templateGroup.template, templateGroup, templateRegistrations);
                                        _this.mapFarmerDataToTemplateRegistration(app.constants.farmerTemplates.Visit_Mortality, _this.farmerMortality, templateGroup.template, templateGroup, templateRegistrations);
                                        _this.mapFarmerDataToTemplateRegistration(app.constants.farmerTemplates.Visit_LiceCounting, _this.farmerLiceCounting, templateGroup.template, templateGroup, templateRegistrations);
                                        _this.mapFarmerDataToTemplateRegistration(app.constants.farmerTemplates.Visit_Treatments, _this.farmerTreatments, templateGroup.template, templateGroup, templateRegistrations);
                                        _this.mapFarmerDataToTemplateRegistration(app.constants.farmerTemplates.Visit_Vaccination, _this.farmerVaccination, templateGroup.template, templateGroup, templateRegistrations);
                                        _this.mapFarmerDataToTemplateRegistration(app.constants.farmerTemplates.Visit_Environment, _this.farmerEnvironment, templateGroup.template, templateGroup, templateRegistrations);
                                        break;
                                }
                                _this.getNumberOfRowForTemplate(templateGroup);
                            }
                        });
                    };
                    AssessmentController.prototype.mapFarmerDataToTemplateRegistration = function (templateName, farmerData, template, templateGroup, templateRegistrations) {
                        var _this = this;
                        if (farmerData != undefined && farmerData.length > 0) {
                            // Map farmer data to grid
                            if (template.dictionary.name === templateName) {
                                var rowCount = farmerData !== null ? farmerData.length : 0;
                                _.forEach(templateGroup.template.templateItems, function (ti) {
                                    var attributeName = app.constants.farmerMappingColumns[templateName][ti.attribute.dictionary.name];
                                    var exisitingTemplateReg = _.filter(templateRegistrations, function (tr) {
                                        return tr.templateId === ti.templateId && tr.attributeId === ti.attributeId && attributeName != null;
                                    });
                                    if (exisitingTemplateReg.length > 0) {
                                        _this.datacontext.deleteTemplateRegistations(exisitingTemplateReg);
                                    }
                                    var templateRegistrationParams = [];
                                    if (templateGroup.hasMultiRows)
                                        for (var n = 1; n <= rowCount; n++) {
                                            var focusValue = farmerData[n - 1][attributeName];
                                            templateRegistrationParams.push(_this.datacontext.initParamsForTemplateRegistrationWithValue(_this.assessment.assessmentId, ti, n, focusValue, true));
                                        }
                                    else if (attributeName != undefined) {
                                        var focusValue = null;
                                        if (ti.attribute.farmerDataMappingRule != undefined && ti.attribute.farmerDataMappingRule.length > 0) {
                                            focusValue = 1;
                                            _.forEach(ti.attribute.farmerDataMappingRule, function (rule) {
                                                if (farmerData.length > 0 && (farmerData[0][attributeName + 'Min'] || farmerData[0][attributeName + 'Max'])) {
                                                    switch (rule.rule) {
                                                        case 'GreaterThanOrEqual':
                                                            focusValue = (Boolean(parseInt(focusValue)) && farmerData[0][attributeName + 'Min'] >= rule.value) ? rule.true : rule.false;
                                                            break;
                                                        case 'LessThanOrEqual':
                                                            focusValue = (Boolean(parseInt(focusValue)) && farmerData[0][attributeName + 'Max'] <= rule.value) ? rule.true : rule.false;
                                                            break;
                                                        default:
                                                            focusValue = rule.false;
                                                    }
                                                    ;
                                                }
                                                else {
                                                    focusValue = rule.none;
                                                }
                                            });
                                        }
                                        else if (farmerData.length > 0) {
                                            var focusValue = farmerData[0][attributeName];
                                        }
                                        //var focusValue = farmerData[1][attributeName];
                                        templateRegistrationParams.push(_this.datacontext.initParamsForTemplateRegistrationWithValue(_this.assessment.assessmentId, ti, null, focusValue, focusValue != null));
                                    }
                                    else if (attributeName == undefined && ti.attributeName == 'Comments') {
                                        var exisitingCommentTemplateReg = _.find(templateRegistrations, function (tr) {
                                            return tr.templateId === ti.templateId && tr.attributeId === ti.attributeId;
                                        });
                                        if (app.common.utils.isNullOrUndefined(exisitingCommentTemplateReg)) {
                                            templateRegistrationParams.push(_this.datacontext.initParamsForTemplateRegistrationWithValue(_this.assessment.assessmentId, ti, null, null, false));
                                        }
                                    }
                                    _this.datacontext.createTemplateRegistrations(templateRegistrationParams);
                                });
                            }
                        }
                    };
                    AssessmentController.prototype.getMultiRowTotalTemplateRegistrations = function (template) {
                        return _.filter(this.assessment.templateRegistrations, function (registration) {
                            return !app.common.utils.entityIsDetachedOrDeleted(registration) && registration.templateId === template.templateId && registration.rowIndex < 0;
                        });
                    };
                    AssessmentController.prototype.getTemplateRegistrationsForMultiRow = function (template, rowIndex) {
                        var offset = this.getOffset(this.getCurrentTemplateId(), rowIndex);
                        return _.filter(this.assessment.templateRegistrations, function (registration) {
                            return registration.templateId === template.templateId && registration.rowIndex + (offset ? offset.offset : 0) === rowIndex;
                        });
                    };
                    AssessmentController.prototype.getTemplateRegistrationsByRowIndex = function (templateItem, rowIndex) {
                        var offset = this.getOffset(this.getCurrentTemplateId(), parseInt(rowIndex));
                        if (templateItem && offset) {
                            rowIndex = offset.rowIndex + offset.offset;
                            return this.getTemplateRegistrationsFromMultiRowByRowIndex(templateItem.templateId, templateItem.attributeId, rowIndex);
                        }
                    };
                    AssessmentController.prototype.getTemplateRegistrationsForTotalRows = function (templateItem) {
                        return _.filter(this.assessment.templateRegistrations, function (registration) {
                            return registration.templateId === templateItem.templateId && registration.attributeId === templateItem.attributeId && registration.rowIndex < 0;
                        });
                    };
                    AssessmentController.prototype.selectItem = function (template, rowIndex, useTimeout) {
                        var _this = this;
                        if (useTimeout === void 0) { useTimeout = true; }
                        if (useTimeout)
                            this.$timeout(function () {
                                var tg = _this.getCurrentTemplateGroup();
                                if (tg) {
                                    tg.selectedRow = rowIndex > 0 ? rowIndex : 1;
                                    if (tg.rows && tg.rows.length > 0)
                                        (tg.rows[rowIndex > 0 ? rowIndex - 1 : rowIndex]).selected = true;
                                }
                                _this.selectedRowTemplateRegistrations = _this.getTemplateRegistrationsForMultiRow(template, rowIndex);
                            });
                        else {
                            var tg = this.getCurrentTemplateGroup();
                            if (tg)
                                tg.selectedRow = rowIndex;
                            this.selectedRowTemplateRegistrations = this.getTemplateRegistrationsForMultiRow(template, rowIndex);
                        }
                    };
                    AssessmentController.prototype.changeLabelAndGo = function (direction, toStepIndex, skipThis, saveDraftOnGo, jumpToRow) {
                        var _this = this;
                        if (skipThis === void 0) { skipThis = false; }
                        if (saveDraftOnGo === void 0) { saveDraftOnGo = true; }
                        if (jumpToRow === void 0) { jumpToRow = undefined; }
                        this.$timeout(function () {
                            _this.currentTemplateRegistations = _this.getTemplateRegistrationsForTemplate(_this.getCurrentTemplateId());
                            _this.hasValidationProblem = false;
                            _this.showDelete = false;
                            switch (direction) {
                                case 'jump':
                                    if (!_this.appLocalStorage.applicationStatusGet().validationsEnabled)
                                        toStepIndex == -1 ? _this.wizardHandler.wizard().next() : _this.wizardHandler.wizard().jumpTo(toStepIndex, true);
                                    else if (_this.readonly || _this.validStep(_this.currentTemplateRegistations)) {
                                        toStepIndex == -1 ? _this.wizardHandler.wizard().next() : _this.wizardHandler.wizard().jumpTo(toStepIndex, true);
                                        _this.currentTemplateRegistations = _this.getTemplateRegistrationsForTemplate(_this.getCurrentTemplateId());
                                    }
                                    break;
                                case 'next':
                                    if (!_this.appLocalStorage.applicationStatusGet().validationsEnabled) {
                                        toStepIndex == -1 ? _this.wizardHandler.wizard().next() : _this.wizardHandler.wizard().goTo(toStepIndex, true);
                                        if (!_this.readonly && saveDraftOnGo)
                                            _this.save(app.constants.assessmentStatus.DRAFT);
                                    }
                                    else if (_this.readonly || _this.validStep(_this.currentTemplateRegistations) || skipThis) {
                                        toStepIndex == -1 ? _this.wizardHandler.wizard().next() : _this.wizardHandler.wizard().goTo(toStepIndex, true);
                                        if (!_this.readonly && saveDraftOnGo)
                                            _this.save(app.constants.assessmentStatus.DRAFT);
                                        _this.currentTemplateRegistations = _this.getTemplateRegistrationsForTemplate(_this.getCurrentTemplateId());
                                    }
                                    if (!_this.getCurrentTemplateGroup())
                                        _this.changeLabelAndGo(direction, toStepIndex, true, saveDraftOnGo);
                                    break;
                                case 'back':
                                    toStepIndex == -1 ? _this.wizardHandler.wizard().previous() : _this.wizardHandler.wizard().goTo(toStepIndex, true);
                                    if (!_this.readonly && saveDraftOnGo)
                                        _this.save(app.constants.assessmentStatus.DRAFT);
                                    _this.currentTemplateRegistations = _this.getTemplateRegistrationsForTemplate(_this.getCurrentTemplateId());
                                    if (!_this.getCurrentTemplateGroup())
                                        _this.changeLabelAndGo(direction, toStepIndex, true, saveDraftOnGo);
                                    else
                                        _this.getCurrentTemplateGroup().revisit = true;
                                    break;
                            }
                            if (_this.wizardHandler.wizard().isLastStep()) {
                                if (_this.env.client_id === app.constants.applicationType.mobileApp)
                                    _this.nextButtonText = 'Done';
                                _this.isLastStep = true;
                            }
                            else {
                                if (_this.env.client_id === app.constants.applicationType.mobileApp)
                                    _this.nextButtonText = '';
                                _this.isLastStep = false;
                            }
                            _this.onChangeLabelAndGo(direction, toStepIndex, skipThis);
                            var tg = _this.getCurrentTemplateGroup();
                            if (tg && tg.hasMultiRows) {
                                _this.selectItem(tg.template, app.common.utils.isNullOrUndefined(jumpToRow) ? app.common.utils.isNullOrUndefined(tg.selectedRow) ? 1 : tg.selectedRow : jumpToRow, true); //select default row or the last selected row 
                            }
                            _this.showBackAndSaveDraftButton = !_this.wizardHandler.wizard().isFirstStep();
                        }, 10).then(function () {
                            return _this.$timeout(function () {
                                _this.refreshTabIndexLoop = !_this.refreshTabIndexLoop;
                            }, 500);
                        });
                    };
                    AssessmentController.prototype.hasPreFilled = function (templateGroup) {
                        return _.some(templateGroup.template.templateRegistrations, { 'assessmentId': this.assessment.assessmentId, 'hasPreFilled': true });
                    };
                    AssessmentController.prototype.onHold = function () {
                    };
                    AssessmentController.prototype.getCurrentTemplateGroup = function () {
                        var _this = this;
                        if (!this.assessment.assessmentType)
                            return null;
                        return _.find(this.assessment.templateGroups, function (tg) {
                            return tg.templateId === _this.getCurrentTemplateId();
                        });
                    };
                    AssessmentController.prototype.getCurrentTemplateId = function () {
                        if (!this.wizardHandler.wizard())
                            return null;
                        return parseInt(this.wizardHandler.wizard().getCurrentStep().templateid);
                    };
                    AssessmentController.prototype.validStep = function (templateRegistations) {
                        var _this = this;
                        this.rowsWithValidationErrors = [];
                        var tg = this.getCurrentTemplateGroup();
                        if (!tg)
                            return false;
                        if (tg.required && templateRegistations.length === 0) {
                            this.hasValidationProblem = true;
                            this.errorMessage = this.$translate.instant("Message_AddRow");
                            return false;
                        }
                        this.hasValidationErrors = this.validateTemplateRegistations(tg, templateRegistations);
                        tg.hasErrors = this.hasValidationErrors.length > 0;
                        var hasInvalidExpiryDateError = _.filter(templateRegistations, function (templateRegistation) {
                            return (templateRegistation.customError != null && templateRegistation.customError.haserror != null) && templateRegistation.customError.haserror && templateRegistation.customError.errorType == app.constants.errorType.InvalidExpDate;
                        });
                        if (tg.hasMultiRows && this.hasValidationErrors.length !== 0) {
                            this.rowsWithValidationErrors = _.map(this.hasValidationErrors, function (templateRegistation) {
                                var offset = _.find(_this.offsetsOnRowIndexes, function (offsetRow) {
                                    return offsetRow.templateId === _this.getCurrentTemplateId() && offsetRow.rowIndex === templateRegistation.rowIndex;
                                });
                                return { templateId: templateRegistation.templateId, rowIndex: offset ? (offset.rowIndex + offset.offset) : templateRegistation.rowIndex };
                            });
                        }
                        this.errorMessage = this.$translate.instant("Error_ValidationErrors") + ' ' + (hasInvalidExpiryDateError.length !== 0 ? this.$translate.instant("VaccinationExpiryError") : '');
                        this.hasValidationProblem = this.hasValidationErrors.length !== 0;
                        return this.hasValidationErrors.length === 0;
                    };
                    AssessmentController.prototype.validateTemplateRegistations = function (templateGroup, templateRegistations) {
                        return _.filter(templateRegistations, function (templateRegistation) {
                            return (!templateGroup.hasMultiRows || templateGroup.hasMultiRows && templateRegistation.rowIndex > 0)
                                && (!templateRegistation.entityAspect.validateEntity())
                                || (templateRegistation && templateRegistation.error && templateRegistation.error.haserror)
                                || (templateRegistation.customError != null
                                    && templateRegistation.customError.haserror != null
                                    && templateRegistation.customError.haserror); //validate templateregistrations and skip totalrows
                        });
                    };
                    AssessmentController.prototype.hasError = function (templateItem) {
                        if (templateItem.template.multiRows) {
                            var offset = this.getOffset(templateItem.templateId, this.getCurrentTemplateGroup().selectedRow); //get offset on selected row
                            return _.some(this.hasValidationErrors, function (templateRegistation) {
                                return templateRegistation.templateId === templateItem.templateId && templateRegistation.attributeId === templateItem.attributeId && templateRegistation.rowIndex === offset.rowIndex;
                            });
                        }
                        else
                            return _.some(this.hasValidationErrors, function (templateRegistation) {
                                return templateRegistation.templateId === templateItem.templateId && templateRegistation.attributeId === templateItem.attributeId;
                            });
                    };
                    AssessmentController.prototype.errorMessageGet = function (templateItem) {
                        if (!_.isUndefined(templateItem)) {
                            var validationErrors = templateItem.entityAspect.getValidationErrors();
                            if (templateItem.customError.haserror)
                                return templateItem.customError.message;
                            if (templateItem && templateItem.error && templateItem.error.haserror)
                                return templateItem.error.message;
                            if (validationErrors.length > 0)
                                return this.$translate.instant(validationErrors[0].errorMessage.split(".")[0]) + ".";
                        }
                        return "";
                    };
                    AssessmentController.prototype.rowHasValidationErrors = function (rowIndex, templateId) {
                        return _.some(this.rowsWithValidationErrors, { templateId: templateId, rowIndex: rowIndex });
                    };
                    AssessmentController.prototype.getNumberOfRowForTemplate = function (templateGroup) {
                        if (!templateGroup.hasMultiRows)
                            return;
                        var numberOfRows = this.datacontext.getMaxNumberOfRowForTemplate(this.assessment.assessmentId, templateGroup.templateId);
                        templateGroup.rows = _.range(numberOfRows).map(function (row) { return { row: row, selected: row == 0 }; });
                        return templateGroup.rows;
                    };
                    AssessmentController.prototype.getTemplateRegistration = function (templateItem, createNewIfNotFound) {
                        if (createNewIfNotFound === void 0) { createNewIfNotFound = false; }
                        var tr = _.find(this.assessment.templateRegistrations, function (registration) {
                            return registration.templateId === templateItem.templateId && registration.attributeId === templateItem.attributeId && registration.rowIndex === null;
                        });
                        return tr ? tr : createNewIfNotFound ? this.datacontext.createTemplateRegistrations([this.datacontext.initParamsForTemplateRegistration(this.assessment.assessmentId, templateItem, null)]) : undefined;
                    };
                    AssessmentController.prototype.getTemplateRegistrationByRowIndex = function (templateItem, rowIndex) {
                        return _.find(this.assessment.templateRegistrations, function (registration) {
                            return registration.templateId === templateItem.templateId && registration.attributeId === templateItem.attributeId && registration.rowIndex === rowIndex;
                        });
                    };
                    AssessmentController.prototype.getTemplateRegistrationsForTemplate = function (templateId) {
                        return _.filter(this.assessment.templateRegistrations, function (registration) {
                            return registration.templateId === templateId && !app.common.utils.entityIsDetachedOrDeleted(registration);
                        });
                    };
                    AssessmentController.prototype.reindexRows = function (rowIndex, template) {
                        _.forEach(this.offsetsOnRowIndexes, function (offsetRow) {
                            if (offsetRow.templateId === template.templateId)
                                if (offsetRow.rowIndex + offsetRow.offset > rowIndex)
                                    offsetRow.offset -= 1;
                        });
                    };
                    AssessmentController.prototype.applyRowIndexOffsets = function () {
                        var _this = this;
                        _.forEach(this.offsetsOnRowIndexes, function (offsetRow) {
                            var templateRegistrations = _.filter(_this.assessment.templateRegistrations, function (registration) {
                                return registration.templateId === offsetRow.templateId && registration.rowIndex === offsetRow.rowIndex && !app.common.utils.entityIsDetachedOrDeleted(registration);
                            });
                            //fix rowindex
                            _.forEach(templateRegistrations, function (registration) {
                                registration.rowIndex = offsetRow.rowIndex + offsetRow.offset;
                            });
                            //remove all detached and deleted
                            _.remove(_this.assessment.templateRegistrations, function (registration) {
                                return app.common.utils.entityIsDetachedOrDeleted(registration);
                            });
                            //reset offset
                            offsetRow.rowIndex = offsetRow.rowIndex + offsetRow.offset;
                            offsetRow.offset = 0;
                        });
                    };
                    AssessmentController.prototype.getOffset = function (templateId, rowIndex) {
                        return _.find(this.offsetsOnRowIndexes, function (offsetRow) {
                            return offsetRow.templateId === templateId && offsetRow.rowIndex + offsetRow.offset === rowIndex;
                        });
                    };
                    //when dropdown values change set them to the assessment property and templateRegistration
                    AssessmentController.prototype.onSelectionChange = function (templateItem, selection) {
                        var _this = this;
                        var hasChanged = this.assessment[this.getSelectionProperty(templateItem.attribute.dictionary.name)] !== selection;
                        this.assessment[this.getSelectionProperty(templateItem.attribute.dictionary.name)] = selection;
                        if (this.assessment.templateRegistrations.length === 0)
                            return;
                        if (hasChanged && templateItem.attribute.dictionary.name === 'Customer') {
                            this.assessment.vaccinationCustomerId = selection;
                            this.assessment.seaCustomerId = selection;
                            var templateRegistration = this.getTemplateRegistration(templateItem);
                            if (templateRegistration)
                                templateRegistration.focusValue = selection;
                        }
                        else if (templateItem.attribute.dictionary.name === 'Site' ||
                            templateItem.attribute.dictionary.name === 'ProcessingPlant') {
                            var site = this.datacontext.getSite(selection);
                            this.assessment.site = site;
                            this.assessment.excludeFarmerData = app.common.utils.isNullOrUndefined(this.assessment.excludeFarmerData) ? this.assessment.site ? this.assessment.site.excludeFarmerDataDefault : 0 : this.assessment.excludeFarmerData;
                            if (hasChanged)
                                this.assessment.vaccinationSiteId = selection;
                            var templateRegistration = this.getTemplateRegistration(templateItem);
                            if (templateRegistration)
                                templateRegistration.focusValue =
                                    !app.common.utils.isNullOrUndefined(site) && templateItem.attribute.dictionary.name === 'Site' ? site.name : selection;
                        }
                        else if (templateItem.attribute.dictionary.name === 'VaccinationSite') {
                            var templateRegistration = this.getTemplateRegistration(templateItem);
                            if (templateRegistration)
                                templateRegistration.focusValue =
                                    !app.common.utils.isNullOrUndefined(site) ? this.datacontext.getSiteByName(selection).siteId : selection;
                        }
                        else if (templateItem.attribute.dictionary.name === 'NAHRepresentitive') {
                            var nahRepresentative = selection ? this.datacontext.getNahRepresentative(selection) : undefined;
                            this.assessment.contactPersonNames = [];
                            this.assessment.contactPersonNames.push(nahRepresentative ? nahRepresentative.fullName : undefined);
                            var templateRegistration = this.getTemplateRegistration(templateItem);
                            if (templateRegistration)
                                templateRegistration.focusValue = selection;
                        }
                        else if (templateItem.attribute.dictionary.name === 'AssessmentFollowUp') {
                            var selectedFollowUpId = this.assessment[this.getSelectionProperty(templateItem.attribute.dictionary.name)];
                            this.assessment.followUpStatusId = selectedFollowUpId;
                        }
                        else if (templateItem.attribute.dictionary.name === 'Assessment date') {
                        }
                        else if (templateItem.attribute.dictionary.name === 'VisitType') {
                            this.assessment.visitType = selection;
                            var templateRegistration = this.getTemplateRegistration(templateItem);
                            if (templateRegistration)
                                templateRegistration.focusValue = selection;
                        }
                        else if (templateItem.attribute.dictionary.name === 'ExcludeFarmerData') {
                        }
                        else if (templateItem.attribute.hasDependant) {
                            _.forEach(templateItem.attribute.dependencies, function (dep) {
                                var templateRegistation = _.find(_this.getTemplateRegistrationsForTemplate(templateItem.templateId), function (tr) {
                                    return tr.attributeId == dep.dependedAttributeId;
                                });
                                var inventory = _.find(_this.farmerInventoryByRange, function (inventory) {
                                    return inventory.unitId == selection;
                                });
                                if (inventory != undefined)
                                    templateRegistation.focusValue = inventory[dep.fieldname];
                            });
                        }
                        else {
                            var templateRegistration = this.getTemplateRegistration(templateItem);
                            if (templateRegistration)
                                templateRegistration.focusValue = selection;
                        }
                    };
                    AssessmentController.prototype.onSelectionChangeMultiRow = function (templateItem, selection) {
                        // this.getSelectedItemDetail(templateItem).focusValue = selection;
                    };
                    AssessmentController.prototype.multiselectChange = function (data, templateRegistration) {
                        var _this = this;
                        var attributename = templateRegistration.attribute.dictionary.name;
                        if (attributename == 'ExcludeFarmerData') {
                            this.assessment.excludeFarmerData = 0;
                            _.forEach(templateRegistration.multiselectValue, function (sel) {
                                _this.assessment.excludeFarmerData += Math.pow(2, parseInt(sel.value));
                            });
                        }
                        else
                            this.assessment.contactPersonNames = _.map(templateRegistration.multiselectValue, 'text');
                    };
                    //get collection and selection value for drop downs
                    AssessmentController.prototype.getSelectionModel = function (templateItem) {
                        var _this = this;
                        var attributename = templateItem.attribute.dictionary.name;
                        if (this.getCurrentTemplateGroup().revisit
                            && templateItem.optionSelection
                            && !this.getCurrentTemplateGroup().hasTabsView
                            && attributename != 'AssessmentFollowUp')
                            return templateItem.optionSelection;
                        var optionSelection = new app.model.scopeModel.OptionSelection();
                        switch (attributename) {
                            case 'Assessment date':
                                optionSelection.selectedOption = new Date(this.assessment[this.getSelectionProperty(templateItem.attribute.dictionary.name)]);
                                break;
                            case 'FreshwaterFishgroup':
                            case 'Fishgroup':
                                this.$scope.$watch('viewModel.assessment.' + this.getWatchProperty(templateItem.attribute.dictionary.name), function (newVal, oldVal) {
                                    optionSelection.collection = _.map(_this.datacontext.getFishgroups(_this.assessment[_this.getWatchProperty(templateItem.attribute.dictionary.name)], _this.assessment.assessmentDate), function (fishGroup) {
                                        var fishgroupId = fishGroup.fishgroupId.toString();
                                        return new app.model.scopeModel.OptionItem(fishGroup.fishgroupName, fishgroupId);
                                    });
                                    _this.preSelectOptionSelection(templateItem, optionSelection);
                                });
                                break;
                            case 'NAHRepresentitive':
                                this.$scope.$watch('viewModel.assessment.siteId', function (newVal, oldVal) {
                                    if (_this.assessment.siteId > 0)
                                        optionSelection.collection = _.map(_this.datacontext.getNahRepresentatives(_this.assessment.siteId, _this.readonly), function (siteVetContact) {
                                            if (_.isUndefined(siteVetContact.contactPerson) && siteVetContact.vetUserId) {
                                                return new app.model.scopeModel.OptionItem(siteVetContact.fullName, siteVetContact.vetUserId, siteVetContact.main);
                                            }
                                            else if (siteVetContact.contactPerson.vetUserId) {
                                                return new app.model.scopeModel.OptionItem(siteVetContact.contactPerson.fullName, siteVetContact.contactPerson.vetUserId, siteVetContact.main);
                                            }
                                            return null;
                                        });
                                    if (_this.readonly) {
                                        if (templateItem.attribute.attributeType.name === app.constants.attributeType.Multiselect) {
                                            var nahReprTemp = [];
                                            _.forEach(_this.getTemplateRegistration(templateItem).focusValue.split(','), function (val) {
                                                var element = _.find(optionSelection.collection, { 'value': val });
                                                if (!_.isUndefined(element)) {
                                                    nahReprTemp.push(element.text);
                                                }
                                            });
                                            optionSelection.selectedText = nahReprTemp.join();
                                        }
                                        else {
                                            optionSelection.selectedText = _this.getSelectionText(optionSelection, templateItem, true);
                                        }
                                    }
                                    else {
                                        if (templateItem.attribute.attributeType.name === app.constants.attributeType.Multiselect) {
                                            var multiSelectValue = _this.getTemplateRegistration(templateItem).focusValue;
                                            if (multiSelectValue !== null) {
                                                _.forEach(_this.getTemplateRegistration(templateItem).focusValue.split(','), function (val) {
                                                    var element = _.find(optionSelection.collection, { 'value': val });
                                                    if (!_.isUndefined(element)) {
                                                        element.selected = true;
                                                    }
                                                });
                                            }
                                            else {
                                                _.forEach(optionSelection.collection, function (element) {
                                                    if (!_.isUndefined(element)) {
                                                        if (!_.isUndefined(element.defaultSelected)) {
                                                            element.selected = element.defaultSelected;
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                        else {
                                            _this.setDefaultSelected(optionSelection, templateItem);
                                        }
                                        _this.onSelectionChange(templateItem, optionSelection.selectedOption);
                                    }
                                });
                                break;
                            case 'FishSampleEvaluator':
                                var evaluators = this.datacontext.getEvaluators();
                                evaluators.unshift({ contactPersonId: 0, fullName: app.localizer.resource.NahRepresentative });
                                optionSelection.collection = _.map(evaluators, function (contact) {
                                    return new app.model.scopeModel.OptionItem(contact.fullName, contact.contactPersonId.toString());
                                });
                                if (this.readonly) {
                                    optionSelection.selectedText = this.getSelectionText(optionSelection, templateItem, true);
                                }
                                else {
                                    optionSelection.selectedOption = this.getSelectionValue(optionSelection, templateItem, true);
                                    if (!optionSelection.selectedOption) {
                                        optionSelection.selectedOption = "0";
                                        this.onSelectionChange(templateItem, optionSelection.selectedOption);
                                    }
                                }
                                break;
                            case 'FreshwaterSite':
                            case 'ProcessingPlant':
                            case 'Site':
                            case 'VaccinationSite':
                            case 'SeaSite':
                                this.updateOptionSelection('viewModel.assessment.' + this.getWatchProperty(templateItem.attribute.dictionary.name), optionSelection, function () {
                                    var siteTypeBitMask = _this.assessment.assessmentType.siteTypeBitMask;
                                    var siteAccess = JSON.parse(_this.appLocalStorage.sitesAccessGet());
                                    var sites = _.filter(_this.datacontext.getSites(_this.assessment[_this.getWatchProperty(templateItem.attribute.dictionary.name)], _this.getSiteType(attributename)), function (site) {
                                        var bitVal = Math.pow(2, site.siteTypeId);
                                        return (siteTypeBitMask & bitVal) > 0 && (_this.env.client_id === app.constants.applicationType.webApp || siteAccess.indexOf(site.siteId) >= 0);
                                    });
                                    optionSelection.collection = _.map(sites, function (site) {
                                        var siteId = templateItem.attribute.dictionary.name === 'Site' ? site.siteId : site.siteId.toString();
                                        return new app.model.scopeModel.OptionItem(site.name, siteId);
                                    });
                                    if (_this.readonly) {
                                        optionSelection.selectedText = _this.getSelectionText(optionSelection, templateItem, templateItem.attribute.dictionary.name !== 'Site');
                                    }
                                    else {
                                        optionSelection.selectedOption = _this.getSelectionValue(optionSelection, templateItem, templateItem.attribute.dictionary.name !== 'Site');
                                        _this.onSelectionChange(templateItem, optionSelection.selectedOption);
                                    }
                                });
                                break;
                            case 'AssessmentLink':
                                this.updateOptionSelection('viewModel.assessment.' + this.getWatchProperty(templateItem.attribute.dictionary.name), optionSelection, function () {
                                    _this.datacontext.getAssessmentLinkList(_this.assessment[_this.getWatchProperty(templateItem.attribute.dictionary.name)], _this.deviceType === app.constants.deviceType.WebApp).then(function (assessments) {
                                        optionSelection.collection = _.map(assessments, function (disc) {
                                            return new app.model.scopeModel.OptionItem(disc.assessmentDiscriminator + (disc.fishgroup ? '- (' + disc.fishgroup.fishgroupName + ')' : '') + '- (' + disc.contactPersonNames.join() + ')', disc.assessmentDiscriminator);
                                        });
                                        if (_this.readonly) {
                                            optionSelection.selectedText = _this.getSelectionText(optionSelection, templateItem);
                                        }
                                        else {
                                            optionSelection.selectedOption = _this.getSelectionValue(optionSelection, templateItem);
                                            _this.onSelectionChange(templateItem, optionSelection.selectedOption);
                                        }
                                    });
                                });
                                this.$scope.$watch('viewModel.assessment.assessmentLinkId', function (newValue, oldValue) {
                                    if (oldValue !== newValue)
                                        return _this.preFillData(newValue);
                                });
                                break;
                            case 'FreshwaterCustomer':
                            case 'SeaCustomer':
                            case 'VaccinationCustomer':
                            case 'Customer':
                                optionSelection.collection = _.map(this.datacontext.getCustomers(), function (customer) {
                                    var customerId = templateItem.attribute.dictionary.name === 'Customer' ? customer.customerId : customer.customerId.toString();
                                    if (customerId === _this.assessment.customerId)
                                        _this.assessment.customerName = customer.name;
                                    return new app.model.scopeModel.OptionItem(customer.name, customerId);
                                });
                                if (this.readonly) {
                                    optionSelection.selectedText = this.getSelectionText(optionSelection, templateItem, templateItem.attribute.dictionary.name !== 'Customer');
                                }
                                else {
                                    optionSelection.selectedOption = this.getSelectionValue(optionSelection, templateItem, templateItem.attribute.dictionary.name !== 'Customer');
                                    this.onSelectionChange(templateItem, optionSelection.selectedOption);
                                }
                                break;
                            case 'SeaSiteFishgroup':
                                this.$scope.$watch('viewModel.assessment.' + this.getWatchProperty(templateItem.attribute.dictionary.name), function (newVal, oldVal) {
                                    optionSelection.collection = _.map(_this.datacontext.getFishgroups(_this.assessment[_this.getWatchProperty(templateItem.attribute.dictionary.name)]), function (fishGroup) {
                                        return new app.model.scopeModel.OptionItem(fishGroup.fishgroupName, fishGroup.fishgroupId.toString());
                                    });
                                    if (_this.readonly) {
                                        optionSelection.selectedText = _this.getSelectionText(optionSelection, templateItem, true);
                                    }
                                    else {
                                        optionSelection.selectedOption = _this.getSelectionValue(optionSelection, templateItem, true);
                                        _this.onSelectionChange(templateItem, optionSelection.selectedOption);
                                    }
                                });
                                break;
                            case 'StandardUnitNumber':
                            case 'RandomUnitNumber':
                                // this.$scope.$watch('viewModel.assessment.' + this.getWatchProperty(templateItem.attribute.dictionary.name), (newVal, oldVal) => {
                                //this.$scope.$watch('viewModel.assessment.' + this.getWatchProperty(templateItem.attribute.dictionary.name), (newVal, oldVal) => {
                                //optionSelection.collection = _.map(this.datacontext.getFishgroups(this.assessment.siteId, this.assessment.assessmentDate), (fishGroup: any) => {
                                //    return new app.model.scopeModel.OptionItem(fishGroup.fishgroupName, fishGroup.fishgroupName);
                                //});
                                optionSelection.collection = _.map(this.farmerInventoryByRange, function (inventory) {
                                    return new app.model.scopeModel.OptionItem(inventory.unitName + ' - ' + inventory.fishGroupName, inventory.unitId.toString());
                                });
                                if (this.readonly) {
                                    optionSelection.selectedText = this.getSelectionText(optionSelection, templateItem, true);
                                }
                                else {
                                    optionSelection.selectedOption = this.getSelectionValue(optionSelection, templateItem, true);
                                    this.onSelectionChange(templateItem, optionSelection.selectedOption);
                                }
                                //});
                                break;
                            case 'SiteManager':
                            case 'SeaSiteManager':
                                this.updateOptionSelection('viewModel.assessment.' + this.getWatchProperty(templateItem.attribute.dictionary.name), optionSelection, function () {
                                    var siteId = _this.assessment[_this.getWatchProperty(templateItem.attribute.dictionary.name)];
                                    optionSelection.collection = _.map(_this.datacontext.getSiteContactPersons(siteId), function (contact) {
                                        if (siteId && contact.contactPerson)
                                            return new app.model.scopeModel.OptionItem(contact.contactPerson.fullName, contact.contactPersonId.toString(), contact.main);
                                        else
                                            return new app.model.scopeModel.OptionItem(contact.fullName, contact.contactPersonId.toString());
                                    });
                                    if (_this.readonly) {
                                        optionSelection.selectedText = _this.getSelectionText(optionSelection, templateItem, true);
                                    }
                                    else {
                                        _this.setDefaultSelected(optionSelection, templateItem);
                                        _this.onSelectionChange(templateItem, optionSelection.selectedOption);
                                    }
                                });
                                break;
                            case 'AssessmentFollowUp':
                                optionSelection.collection = _.map(this.datacontext.getAssessmentFollowUps(), function (followUp) {
                                    return new app.model.scopeModel.OptionItem(followUp.dictionary.name, followUp.followUpStatusId);
                                });
                                if (this.readonly) {
                                    optionSelection.selectedText = _.find(optionSelection.collection, { value: this.assessment.followUpStatusId }).text;
                                }
                                else {
                                    optionSelection.selectedOption = this.assessment.followUpStatusId;
                                }
                                break;
                            default:
                                if (attributename == 'TreatmentProduct') {
                                    optionSelection.collection = _.map(this.datacontext.getVaccines(), function (treatmentProduct) {
                                        return new app.model.scopeModel
                                            .OptionItem(treatmentProduct.name + ' - ( ' + treatmentProduct.activeSubstanceName + ':' + treatmentProduct.inclusionWithMeasure + ' )', treatmentProduct.treatmentProductId.toString());
                                    });
                                }
                                else if (attributename == 'Supplier') {
                                    optionSelection.collection = _.map(this.datacontext.getSuppliers(), function (supplier) {
                                        return new app.model.scopeModel.OptionItem(supplier.name, supplier.supplierId.toString());
                                    });
                                }
                                else if (attributename == 'LabTest_Diagnosis') {
                                    optionSelection.collection = _.map(this.datacontext.getDiagnoses(), function (diagnosis) {
                                        return new app.model.scopeModel.OptionItem(diagnosis.name, diagnosis.diagnosisId.toString());
                                    });
                                }
                                else if (attributename == 'LabTest_Fishgroup') {
                                    optionSelection.collection = _.map(this.datacontext.getFishgroups(this.assessment[this.getWatchProperty(templateItem.attribute.dictionary.name)], this.assessment.assessmentDate), function (fishgroup) {
                                        return new app.model.scopeModel.OptionItem(fishgroup.fishgroupName, fishgroup.fishgroupId.toString());
                                    });
                                }
                                else {
                                    var defaultSelectionMetadata = _.find(templateItem.attribute.attributeMetadatas, { 'attributeMetadataTypeId': app.constants.attributeMetadataType.Default });
                                    var attributeMetadataEnums = _.sortBy(templateItem.attribute.attributeMetadataEnums, 'sortOrder');
                                    if (attributename == 'ExcludeFarmerData' && this.assessment.site) {
                                        attributeMetadataEnums = _.filter(attributeMetadataEnums, function (metadata) {
                                            if (_this.assessment.site.siteTypeId == app.constants.siteTypes.marine && metadata.text != 'Exclude vaccinations' || _this.assessment.site.siteTypeId == app.constants.siteTypes.freshwater && metadata.text != 'Exclude lice countings')
                                                return metadata;
                                        });
                                    }
                                    optionSelection.collection = _.map(attributeMetadataEnums, function (metadata) {
                                        return new app.model.scopeModel.OptionItem(app.common.utils.localizeEnumText(metadata, _this.$translate.use().toLowerCase()), templateItem.attribute.enumDataType === app.constants.enumDataType.Double ? parseFloat(metadata.value) : metadata.value, defaultSelectionMetadata ? defaultSelectionMetadata.value == metadata.value : false);
                                    });
                                    this.setDefaultSelected(optionSelection, templateItem);
                                }
                                this.preSelectOptionSelection(templateItem, optionSelection);
                                optionSelection.collection.sort();
                        }
                        if (this.readonly) {
                            var selectedValue = _.find(optionSelection.collection, { value: optionSelection.selectedOption });
                            if (!_.isUndefined(selectedValue))
                                optionSelection.selectedText = selectedValue.text;
                        }
                        templateItem.optionSelection = optionSelection;
                        return optionSelection;
                    };
                    AssessmentController.prototype.preSelectOptionSelection = function (templateItem, optionSelection) {
                        if (templateItem.template.multiRows) {
                            if (this.readonly) {
                                if (templateItem.attribute.attributeType.name === app.constants.attributeType.Multiselect) {
                                    var selectedText = [];
                                    var tr = templateItem;
                                    if (tr.focusValue) {
                                        _.forEach(tr.focusValue.split(','), function (val) {
                                            var element = _.find(optionSelection.collection, { 'value': val });
                                            if (!_.isUndefined(element)) {
                                                selectedText.push(element.text);
                                            }
                                        });
                                        optionSelection.selectedText = selectedText.join();
                                    }
                                }
                                else {
                                    var selectedOptionDetail = this.getSelectedItemDetail(templateItem);
                                    if (!common.utils.isNullOrUndefined(selectedOptionDetail))
                                        optionSelection.selectedOption = this.getSelectedItemDetail(templateItem).focusValue;
                                }
                            }
                            else {
                                var tr = this.getTemplateRegistrationByRowIndex(templateItem, this.getCurrentTemplateGroup().selectedRow);
                                if (tr) {
                                    if (templateItem.attribute.attributeType.name === app.constants.attributeType.Multiselect) {
                                        var multiSelectValue = tr.focusValue;
                                        if (multiSelectValue !== null) {
                                            if (tr.focusValue) {
                                                _.forEach(tr.focusValue.split(','), function (val) {
                                                    var element = _.find(optionSelection.collection, { 'value': val });
                                                    if (!_.isUndefined(element)) {
                                                        element.selected = true;
                                                    }
                                                });
                                            }
                                        }
                                    }
                                    else {
                                        optionSelection.selectedOption = tr.focusValue;
                                    }
                                }
                            }
                        }
                        else {
                            if (this.readonly) {
                                if (templateItem.attribute.attributeType.name === app.constants.attributeType.Multiselect) {
                                    var nahReprTemp = [];
                                    var tr = this.getTemplateRegistration(templateItem);
                                    if (tr.focusValue) {
                                        _.forEach(tr.focusValue.split(','), function (val) {
                                            var element = _.find(optionSelection.collection, { 'value': val });
                                            if (!_.isUndefined(element)) {
                                                nahReprTemp.push(element.text);
                                            }
                                        });
                                        optionSelection.selectedText = nahReprTemp.join();
                                    }
                                }
                                else {
                                    optionSelection.selectedOption = this.getTemplateRegistration(templateItem, true).focusValue;
                                }
                            }
                            else {
                                if (templateItem.attribute.attributeType.name === app.constants.attributeType.Multiselect) {
                                    var multiSelectValue = this.getTemplateRegistration(templateItem).focusValue;
                                    if (multiSelectValue !== null) {
                                        var tr = this.getTemplateRegistration(templateItem);
                                        if (tr.focusValue) {
                                            _.forEach(tr.focusValue.split(','), function (val) {
                                                var element = _.find(optionSelection.collection, { 'value': val });
                                                if (!_.isUndefined(element)) {
                                                    element.selected = true;
                                                }
                                            });
                                        }
                                    }
                                }
                                else {
                                    optionSelection.selectedOption = this.getTemplateRegistration(templateItem, true).focusValue;
                                }
                            }
                        }
                    };
                    AssessmentController.prototype.setDefaultSelected = function (optionSelection, templateItem) {
                        optionSelection.selectedOption = this.getSelectionValue(optionSelection, templateItem, true);
                        if (!optionSelection.selectedOption) {
                            var defaultSelected = _.find(optionSelection.collection, function (rep) {
                                return rep.defaultSelected;
                            });
                            optionSelection.selectedOption = defaultSelected ? defaultSelected.value : undefined;
                        }
                    };
                    AssessmentController.prototype.getSiteType = function (attributename) {
                        return attributename === 'SeaSite' ? app.constants.siteTypes.marine : attributename === 'FreshwaterSite' ? app.constants.siteTypes.freshwater : app.constants.siteTypes.all;
                    };
                    AssessmentController.prototype.getSelectedItemDetail = function (templateItem) {
                        if ((this.selectedRowTemplateRegistrations === undefined || this.selectedRowTemplateRegistrations.length === 0)) {
                            //select first row by default
                            var tg = this.getCurrentTemplateGroup();
                            if (tg)
                                tg.selectedRow = 1;
                            this.selectedRowTemplateRegistrations = this.getTemplateRegistrationsForMultiRow(templateItem.template, 1);
                        }
                        return _.find(this.selectedRowTemplateRegistrations, function (registration) {
                            return registration.templateId === templateItem.templateId && registration.attributeId === templateItem.attributeId; //one row selected at a time
                        });
                    };
                    AssessmentController.prototype.updateOptionSelection = function (watchProperty, optionSelection, callback) {
                        this.$scope.$watch(watchProperty, function (newVal, oldVal) {
                            callback();
                            optionSelection.collection.sort();
                        });
                    };
                    //Clear selections if cascading dropdowns changed. Set selected when on edit
                    AssessmentController.prototype.getSelectionValue = function (optionSelection, templateItem, compareString) {
                        if (compareString === void 0) { compareString = false; }
                        var hasId;
                        var whereValue = this.assessment[this.getSelectionProperty(templateItem.attribute.dictionary.name)];
                        if (!compareString)
                            hasId = _.some(optionSelection.collection, { value: whereValue });
                        else {
                            hasId = _.some(optionSelection.collection, { value: app.common.utils.isNullOrUndefined(whereValue) ? whereValue : whereValue.toString() });
                        }
                        if (hasId)
                            return compareString ? whereValue.toString() : whereValue;
                        else {
                            return undefined;
                        }
                    };
                    AssessmentController.prototype.getSelectionText = function (optionSelection, templateItem, compareString) {
                        if (compareString === void 0) { compareString = false; }
                        var value;
                        var whereValue = this.assessment[this.getSelectionProperty(templateItem.attribute.dictionary.name)];
                        if (!compareString)
                            value = _.find(optionSelection.collection, { value: whereValue });
                        else {
                            value = _.find(optionSelection.collection, { value: app.common.utils.isNullOrUndefined(whereValue) ? whereValue : whereValue.toString() });
                        }
                        if (!_.isUndefined(value))
                            return value.text;
                        else {
                            return "";
                        }
                    };
                    //cascading property to watch on
                    AssessmentController.prototype.getWatchProperty = function (name) {
                        switch (name) {
                            case 'FreshwaterFishgroup':
                                return 'freshwaterSiteId';
                            case 'SiteManager':
                            case 'Fishgroup':
                            case 'LabTest_Fishgroup':
                            case 'StandardFishgroup':
                            case 'RandomFishgroup':
                                return 'siteId';
                            case 'SeaSiteManager':
                            case 'SeaSiteFishgroup':
                                return 'seaSiteId';
                            case 'FreshwaterSite':
                                return 'freshwaterCustomerId';
                            case 'SeaSite':
                                return 'seaCustomerId';
                            case 'VaccinationSite':
                                return 'vaccinationCustomerId';
                            case 'Site':
                            case 'ProcessingPlant':
                                return 'customerId';
                            case 'StandardFishgroup':
                            case 'RandomFishgroup':
                                return 'hasFarmerData';
                            case 'AssessmentLink':
                                return this.assessment.assessmentTypeId === app.constants.assessmentTypes.preTransfer ? 'vaccinationSiteId' : 'freshwaterSiteId';
                        }
                    };
                    //get selection property in this.assessment.
                    // this.assessment[this.getSelectionProperty('Site')] ==> this.assessment.siteId
                    AssessmentController.prototype.getSelectionProperty = function (name) {
                        switch (name) {
                            case 'Assessment date':
                                return 'assessmentDate';
                            case 'FreshwaterFishgroup':
                                return 'freshwaterFishgroupId';
                            case 'Fishgroup':
                            case 'SeaSiteFishgroup':
                                return 'fishgroupId';
                            case 'FreshwaterSite':
                                return 'freshwaterSiteId';
                            case 'SeaSite':
                                return 'seaSiteId';
                            case 'Site':
                            case 'ProcessingPlant':
                                return 'siteId';
                            case 'FreshwaterCustomer':
                                return 'freshwaterCustomerId';
                            case 'SeaCustomer':
                                return 'seaCustomerId';
                            case 'VaccinationCustomer':
                                return 'vaccinationCustomerId';
                            case 'VaccinationSite':
                                return 'vaccinationSiteId';
                            case 'Customer':
                                return 'customerId';
                            case 'AssessmentFollowUp':
                                return 'assessmentFollowUpId';
                            case 'SeaSiteManager':
                            case 'SiteManager':
                                return 'siteManagerId';
                            case 'NAHRepresentitive':
                                return 'nahRepresentitiveId';
                            case 'AssessmentLink':
                                return 'assessmentLinkId';
                            default:
                                return null;
                        }
                    };
                    AssessmentController.prototype.preFillData = function (assessmentDiscriminator) {
                        if (this.assessment.assessmentTypeId === app.constants.assessmentTypes.vaccination)
                            return;
                        if (assessmentDiscriminator != null)
                            return this.datacontext.getPreFillTemplateRegistrations(this.assessment, assessmentDiscriminator, this.deviceType == app.constants.deviceType.WebApp);
                        else if (assessmentDiscriminator == null) {
                            var hasPreFilledData = _.some(this.assessment.templateRegistrations, function (tr) { return tr.prefillAssessmentId !== null; });
                            if (hasPreFilledData)
                                return this.datacontext.clearPreFillTemplates(this.assessment, true);
                            else
                                return null;
                        }
                        return null;
                    };
                    AssessmentController.prototype.formatNumber = function (value) {
                        return app.common.utils.unformatDecimal(value);
                    };
                    AssessmentController.prototype.loadFarmerData = function (assessmentState) {
                        var _this = this;
                        //if (!this.isOnline()) return;
                        switch (assessmentState) {
                            case app.constants.operation.NEW:
                                this.getFarmerData();
                                break;
                            default:
                                if (!this.assessment.hasFarmerData || this.assessment.assessmentTypeName === "Welfare") {
                                    this.getFarmerData();
                                }
                                break;
                        }
                        this.$scope.$watch('viewModel.assessment.assessmentDate', function (newValue, oldValue) {
                            if (oldValue !== newValue)
                                _this.getFarmerData();
                        });
                        this.$scope.$watch('viewModel.assessment.hasFarmerData', function (newValue, oldValue) {
                            if (oldValue === false && newValue === true) {
                                setTimeout(function () {
                                    _this.$scope.$broadcast(app.constants.broadcastEventNames.refreshMultiRow);
                                }, 500);
                            }
                        });
                        if (this.env.client_id === app.constants.applicationType.mobileApp) {
                            this.$scope.$watch('viewModel.assessment.siteId', function (newValue, oldValue) {
                                if (oldValue !== newValue && newValue != null)
                                    _this.getFarmerData();
                            });
                        }
                    };
                    AssessmentController.prototype.getFarmerData = function () {
                        var _this = this;
                        if (!this.isFarmerIntegrationOn || !this.assessment.assessmentType.containsFarmerData)
                            return;
                        this.assessment.hasFarmerData = false;
                        this.customerKey = this.customerKey ? this.customerKey : this.assessment.customerKey;
                        if (!this.customerKey)
                            return;
                        if (!this.isOnline()) {
                            this.farmerInventory = this.farmerLiceCounting = this.farmerMortality = this.farmerTreatments = this.farmerVaccination = this.farmerEnvironment = this.farmerInventoryByRange = [];
                            this.mapFarmerData();
                            return;
                        }
                        this.$timeout(function () {
                            var farmerTemplateGroups = _.filter(_this.assessment.templateGroups, function (tg) {
                                return tg.template.isFromFarmer;
                            });
                            var farmerDataCalls = [];
                            _.forEach(farmerTemplateGroups, function (tg) {
                                farmerDataCalls.push(_this.getFarmerDataCall(tg.template.dictionary.name));
                            });
                            //Try loading inventory first and then load the rest later
                            _this.$q.all(farmerDataCalls).then(function () {
                                _this.assessment.hasFarmerData = true;
                            }).catch(function () {
                                _this.farmerInventory = _this.farmerLiceCounting = _this.farmerMortality = _this.farmerTreatments = _this.farmerVaccination = _this.farmerEnvironment = [];
                                _this.mapFarmerData();
                            });
                        });
                    };
                    AssessmentController.prototype.getFarmerDataCall = function (templatename) {
                        var _this = this;
                        var dataCall;
                        var periodInDays = parseInt(this.noOfdaysFromFarmer);
                        switch (templatename) {
                            case app.constants.farmerTemplates.Visit_Inventory:
                                dataCall = this.datacontext.getFarmerInventory(this.customerKey, this.assessment.siteId, this.assessment.assessmentDate).then(function (data) {
                                    _this.farmerInventory = _.sortBy(data, 'unitName');
                                    _this.mapFarmerData(templatename);
                                });
                                break;
                            case app.constants.farmerTemplates.Welfare_Environmental_Indicators:
                                dataCall = this.datacontext.getFarmerInventoryByRange(this.customerKey, this.assessment.siteId, this.assessment.assessmentDate, periodInDays).then(function (data) {
                                    _this.farmerInventoryByRange = _.sortBy(data, 'unitName');
                                    _this.mapFarmerData(templatename);
                                });
                                break;
                            case app.constants.farmerTemplates.Welfare_Cleanerfish_Welfare:
                                dataCall = this.datacontext.getCleanerFishDetails(this.customerKey, this.assessment.siteId, this.assessment.assessmentDate, periodInDays).then(function (data) {
                                    _this.farmerCleanerFishDetails = data;
                                    _this.mapFarmerData(templatename);
                                });
                                break;
                            case app.constants.farmerTemplates.Visit_Mortality:
                                dataCall = this.datacontext.getFarmerMortalities(this.customerKey, this.assessment.siteId, this.assessment.assessmentDate, periodInDays).then(function (data) {
                                    _this.farmerMortality = _.sortBy(data, 'unitName');
                                    _this.mapFarmerData(templatename);
                                });
                                break;
                            case app.constants.farmerTemplates.Visit_LiceCounting:
                                dataCall = this.datacontext.getFarmerLiceCountings(this.customerKey, this.assessment.siteId, this.assessment.assessmentDate, periodInDays).then(function (data) {
                                    _this.farmerLiceCounting = _.sortBy(data, 'unitName');
                                    _this.mapFarmerData(templatename);
                                });
                                break;
                            case app.constants.farmerTemplates.Visit_Treatments:
                                dataCall = this.datacontext.getFarmerTreatments(this.customerKey, this.assessment.siteId, this.assessment.assessmentDate, periodInDays).then(function (data) {
                                    _this.farmerTreatments = _.sortBy(data, 'unitName');
                                    _this.mapFarmerData(templatename);
                                });
                                break;
                            case app.constants.farmerTemplates.Visit_Vaccination:
                                dataCall = this.datacontext.getFarmerVaccinations(this.customerKey, this.assessment.siteId, this.assessment.assessmentDate, periodInDays).then(function (data) {
                                    _this.farmerVaccination = _.sortBy(data, 'unitName');
                                    _this.mapFarmerData(templatename);
                                });
                                break;
                            case app.constants.farmerTemplates.Visit_Environment:
                                dataCall = this.datacontext.getFarmerEnvironment(this.customerKey, this.assessment.siteId, this.assessment.assessmentDate).then(function (data) {
                                    _this.farmerEnvironment = _.sortBy(data, 'unitName');
                                    _this.mapFarmerData(templatename);
                                });
                                break;
                        }
                        return dataCall;
                    };
                    return AssessmentController;
                })();
                controllers.AssessmentController = AssessmentController;
            })(controllers = base.controllers || (base.controllers = {}));
        })(base = common.base || (common.base = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

var app;
(function (app) {
    var common;
    (function (common) {
        var base;
        (function (base) {
            var services;
            (function (services) {
                var PvFlag = (function () {
                    function PvFlag() {
                    }
                    //comment: string;
                    PvFlag.prototype.comment = function () {
                        if (_.includes(this.name, 'mortality'))
                            return Math.round(this.flaggedPercentage | 0).toString();
                        else {
                            return this.translate.instant('PvFlag_inPercentage').replace('{0}', this.flagCondition).replace('{1}', Math.round(this.flaggedPercentage | 0).toString()) + ' ' + this.translate.instant('PVFlag_OfPopulation');
                        }
                    };
                    return PvFlag;
                })();
                services.PvFlag = PvFlag;
                var PythonHandler = (function () {
                    function PythonHandler($http, $translate, $q, appLocalStorage, assessmentDatacontext, env, apiEndpoint) {
                        this.$http = $http;
                        this.$translate = $translate;
                        this.$q = $q;
                        this.appLocalStorage = appLocalStorage;
                        this.assessmentDatacontext = assessmentDatacontext;
                        this.env = env;
                        this.apiEndpoint = apiEndpoint;
                    }
                    PythonHandler.prototype.initializePythonHandler = function () {
                        var _this = this;
                        if (app.common.utils.refreshCachedData || app.common.utils.isNullOrUndefined(this.appLocalStorage.pythonScriptsGet())) {
                            return this.$http.get(this.apiEndpoint.getPythonEndpoint()).then(function (response) {
                                _this.appLocalStorage.pythonScriptsSet(JSON.stringify(response.data));
                            });
                        }
                        else {
                            return this.$q.when();
                        }
                    };
                    PythonHandler.prototype.execute = function (query) {
                        return this.runit(query);
                    };
                    PythonHandler.prototype.builtinRead = function (x) {
                        if (Sk.builtinFiles === undefined || Sk.builtinFiles["files"][x] === undefined)
                            throw "File not found: '" + x + "'";
                        return Sk.builtinFiles["files"][x];
                    };
                    PythonHandler.prototype.runit = function (functionCall) {
                        var response = JSON.parse(this.appLocalStorage.pythonScriptsGet());
                        var code;
                        var isFlaging = false;
                        if (functionCall.indexOf("AssessmentDiscriminatorGet") != -1) {
                            code = response + '\n\n' + 'result = ' + this.encodeAndReplaceQuotes(functionCall);
                        }
                        else {
                            code = response + '\n\n' + 'result = ' + functionCall;
                            isFlaging = _.includes(functionCall, 'GetFlags');
                        }
                        return this.runSkulpt(code, isFlaging);
                    };
                    PythonHandler.prototype.encodeAndReplaceQuotes = function (value) {
                        return encodeURI(value).replace(/%5C'/g, "\\'");
                    };
                    PythonHandler.prototype.runSkulpt = function (code, isFlaging) {
                        var _this = this;
                        try {
                            Sk.configure({ read: this.builtinRead });
                            var call = eval(Sk.importMainWithBody("<stdin>", false, code)); // execute python script
                            if (isFlaging) {
                                var list = [];
                                _.forEach(call.$d.result.v, function (value) {
                                    var flag = new PvFlag();
                                    flag.translate = _this.$translate;
                                    _.forEach(value.$d, function (dict) {
                                        if (typeof dict === 'object')
                                            switch (dict.items[0].lhs.v) {
                                                case 'Name':
                                                    flag.name = dict.items[0].rhs.v;
                                                    break;
                                                case 'FlaggedPercentage':
                                                    flag.flaggedPercentage = dict.items[0].rhs.v;
                                                    break;
                                                case 'FlaggedCount':
                                                    flag.flaggedCount = dict.items[0].rhs.v;
                                                    break;
                                                case 'IsFlagRaised':
                                                    flag.isFlagRaised = dict.items[0].rhs.v;
                                                    break;
                                                case 'ItemsCount':
                                                    flag.itemsCount = dict.items[0].rhs.v;
                                                    break;
                                                case 'FlagCondition':
                                                    flag.flagCondition = dict.items[0].rhs.v;
                                                    break;
                                                case 'CountCondition':
                                                    flag.countCondition = dict.items[0].rhs.v;
                                                    break;
                                                case 'Comment':
                                                    flag.comment = dict.items[0].rhs.v;
                                                    break;
                                            }
                                    });
                                    list.push(flag);
                                });
                                return list;
                            }
                            else
                                return call.$d.result.v; // get result from skulpt
                        }
                        catch (err) {
                            throw err;
                        }
                    };
                    PythonHandler.prototype.escapeSingleQuoteInString = function (value) {
                        if (typeof (value) == "string")
                            return value.replace(/'/g, "\\'");
                        return value;
                    };
                    PythonHandler.prototype.buildQuery = function (assessment, businessRuleValues, expression, outputsSummary, rowIndex) {
                        var _this = this;
                        if (rowIndex === void 0) { rowIndex = 0; }
                        if (!expression)
                            return null;
                        var query;
                        var queryParameterCollection = [];
                        _.forEach(businessRuleValues, function (val) {
                            if (_this.expressionHasAttribute(expression, val.registration.attributeId)) {
                                var parameter;
                                parameter = _.find(queryParameterCollection, function (param) {
                                    return param.attributeId == val.registration.attributeId;
                                });
                                if (parameter == null) {
                                    parameter = { attributeId: val.registration.attributeId, values: [] };
                                    queryParameterCollection.push(parameter);
                                }
                                if (val.registration.attribute != null) {
                                    var regValue;
                                    if ((val.registration.attribute.dictionary.name === "FreshwaterSite" || val.registration.attribute.dictionary.name === "VaccinationSite") && !app.common.utils.isNullOrUndefined(val.registration.focusValue))
                                        regValue = _this.assessmentDatacontext.getSite(val.registration.focusValue).name;
                                    else if (expression.indexOf('DependOn') !== -1 && val.registration.attribute.dictionary.name === "Site" && !app.common.utils.isNullOrUndefined(val.registration.focusValue))
                                        regValue = _this.assessmentDatacontext.getSiteByName(val.registration.focusValue).siteId;
                                    else
                                        regValue = val.registration.focusValue;
                                    if (regValue != null) {
                                        if (val.registration.attribute.attributeType.name === "Double" || val.registration.attribute.attributeType.name === "Integer") {
                                            regValue = parseFloat(app.common.utils.unformatDecimal(regValue));
                                        }
                                        parameter.values.push({ regValue: _this.escapeSingleQuoteInString(regValue), rowIndex: val.registration.rowIndex });
                                    }
                                }
                            }
                        });
                        query = expression;
                        _.forEach(queryParameterCollection, function (param) {
                            var valuesString;
                            if (outputsSummary)
                                var dataRowValues = _.filter(param.values, function (item) {
                                    return (item.rowIndex > 0 || item.rowIndex == null);
                                });
                            if (dataRowValues != null)
                                valuesString = _.map(dataRowValues, function (val) { return val.regValue; }).toString(); //allrows
                            else {
                                valuesString = _.find(param.values, function (val) { return val.rowIndex === rowIndex; }); //just the row change value
                                valuesString = valuesString != null ? valuesString.regValue : "undefined";
                            }
                            if (query.indexOf('ValidExpiryDate') != -1)
                                valuesString = valuesString != "undefined" ? (new Date(valuesString)).getTime() : (new Date()).getTime();
                            query = query.replace("{AttributeId_" + param.attributeId + "}", valuesString);
                        });
                        //remove attributes with no data
                        var match;
                        var matches = [];
                        while (match = app.constants.metaDataExpressionAttributePattern.exec(query)) {
                            matches.push(match[1]);
                        }
                        if (query.indexOf('AssessmentType') != -1)
                            query = query.replace("{AssessmentType}", assessment.assessmentType.assessmentTypeCode);
                        if (query.indexOf('Year') != -1)
                            query = query.replace("{Year}", assessment.assessmentDate.getFullYear());
                        if (query.indexOf('Month') != -1)
                            query = query.replace("{Month}", assessment.assessmentDate.getMonth() + 1);
                        if (query.indexOf('Day') != -1)
                            query = query.replace("{Day}", assessment.assessmentDate.getDate());
                        if (query.indexOf('UnitList') != -1 && this.assessmentHasNonHistoricalVaccine(assessment.assessmentType))
                            query = query.replace("{UnitList}", this.getUnitListFromMultiRowRegistrations(assessment));
                        if (query != expression)
                            _.forEach(matches, function (m) { return query = query.replace("{" + m + "}", ""); });
                        if (query.indexOf('Attribute') != -1 || query.indexOf('undefined') != -1)
                            return null;
                        return query;
                    };
                    //check if the given expression contains the attribute
                    PythonHandler.prototype.expressionHasAttribute = function (expression, attributeId) {
                        var attributeName = "{AttributeId_" + attributeId + "}";
                        return expression && expression.indexOf(attributeName) != -1;
                    };
                    PythonHandler.prototype.assessmentHasNonHistoricalVaccine = function (assessmentType) {
                        return assessmentType.assessmentTypeId == app.constants.assessmentTypes.vaccination || assessmentType.assessmentTypeId == app.constants.assessmentTypes.preVaccination;
                    };
                    PythonHandler.prototype.isVaccineTemplate = function (template) {
                        return template.dictionary.name.indexOf("Vaccination_Vaccines") != -1;
                    };
                    PythonHandler.prototype.getUnitListFromMultiRowRegistrations = function (assessment) {
                        //var vaccineTemplate = _.find(assessment.assessmentType.templateGroups, (templateGroup: any) => {
                        //    return this.isVaccineTemplate(templateGroup.template);
                        //});
                        var registrationsList = [];
                        _.forEach(assessment.templateRegistrations, function (registration) {
                            if (registration.attribute.dictionary.name.indexOf("Receiving tank / pen no.") != -1) {
                                registrationsList.push(registration);
                            }
                        });
                        var list = _.map(registrationsList, function (reg) { return reg.textValue; });
                        return list;
                    };
                    return PythonHandler;
                })();
                services.PythonHandler = PythonHandler;
            })(services = base.services || (base.services = {}));
        })(base = common.base || (common.base = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

/// <reference path="../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var BaseEditController = (function () {
                function BaseEditController($scope, modalService) {
                    this.$scope = $scope;
                    this.modalService = modalService;
                    this.errorMessage = 'Error_ValidationErrors';
                    this.confirm = {
                        title: app.localizer.resource.ConfirmCancelTitle,
                        message: app.localizer.resource.ConfirmCancelMessage
                    };
                }
                BaseEditController.prototype.closeWindow = function () {
                    this.modalService.close();
                };
                BaseEditController.prototype.rejectChanges = function () {
                    throw "Not implemented";
                };
                BaseEditController.prototype.closeThisDialog = function () {
                    var parent = this.$scope.$parent;
                    this.rejectChanges();
                    parent.closeThisDialog();
                };
                return BaseEditController;
            })();
            controllers.BaseEditController = BaseEditController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

/// <reference path="../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var BaseListController = (function () {
                function BaseListController() {
                }
                return BaseListController;
            })();
            controllers.BaseListController = BaseListController;
            var BaseModalListController = (function (_super) {
                __extends(BaseModalListController, _super);
                function BaseModalListController($scope, modalService) {
                    _super.call(this);
                    this.$scope = $scope;
                    this.modalService = modalService;
                }
                BaseModalListController.prototype.closeWindow = function () {
                    this.modalService.close();
                };
                BaseModalListController.prototype.closeThisDialog = function () {
                    var parent = this.$scope.$parent;
                    parent.closeThisDialog();
                };
                return BaseModalListController;
            })(BaseListController);
            controllers.BaseModalListController = BaseModalListController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

var app;
(function (app) {
    var model;
    (function (model) {
        var clientEntities;
        (function (clientEntities) {
            var AssessmentDiscriminator = (function () {
                function AssessmentDiscriminator() {
                    this.shortName = app.constants.entityNames.assessmentDiscriminator;
                    this.namespace = "Mercatus.AquaVet.Domain.Models.AssessmentDiscriminator";
                    this.autoGeneratedKeyType = breeze.AutoGeneratedKeyType.Identity;
                    this.dataProperties = [
                        new breeze.DataProperty({ name: "assessmentId", dataType: breeze.DataType.Int32, isNullable: false, isPartOfKey: true }),
                        new breeze.DataProperty({ name: "discriminator", dataType: breeze.DataType.String, isNullable: true, isPartOfKey: false }),
                        new breeze.DataProperty({ name: "siteId", dataType: breeze.DataType.Int32, isNullable: false, isPartOfKey: false }),
                        new breeze.DataProperty({ name: "customerId", dataType: breeze.DataType.Int32, isNullable: false, isPartOfKey: false }),
                        new breeze.DataProperty({ name: "contactPersonId", dataType: breeze.DataType.String, isNullable: false, isPartOfKey: false })
                    ];
                }
                return AssessmentDiscriminator;
            })();
            clientEntities.AssessmentDiscriminator = AssessmentDiscriminator;
        })(clientEntities = model.clientEntities || (model.clientEntities = {}));
    })(model = app.model || (app.model = {}));
})(app || (app = {}));

var app;
(function (app) {
    var model;
    (function (model) {
        var clientEntities;
        (function (clientEntities) {
            var AllowedRegistration = (function () {
                function AllowedRegistration() {
                    this.shortName = app.constants.entityNames.allowedReg;
                    this.namespace = "Mercatus.AquaVet.Domain.Models.AllowedRegistration";
                    this.autoGeneratedKeyType = breeze.AutoGeneratedKeyType.Identity;
                    this.dataProperties = [
                        new breeze.DataProperty({ name: "name", dataType: breeze.DataType.String, isNullable: false, isPartOfKey: true })
                    ];
                }
                return AllowedRegistration;
            })();
            clientEntities.AllowedRegistration = AllowedRegistration;
        })(clientEntities = model.clientEntities || (model.clientEntities = {}));
    })(model = app.model || (app.model = {}));
})(app || (app = {}));

var app;
(function (app) {
    var model;
    (function (model) {
        var clientEntities;
        (function (clientEntities) {
            var AssessmentIdentifier = (function () {
                function AssessmentIdentifier() {
                    this.shortName = app.constants.entityNames.assessmentIdentifier;
                    this.namespace = "Mercatus.AquaVet.Domain.Models.AssessmentIdentifier";
                    this.autoGeneratedKeyType = breeze.AutoGeneratedKeyType.Identity;
                    this.dataProperties = [
                        new breeze.DataProperty({ name: "assessmentId", dataType: breeze.DataType.Int32, isNullable: false, isPartOfKey: true }),
                        new breeze.DataProperty({ name: "uniqueId", dataType: breeze.DataType.String, isNullable: true, isPartOfKey: false }),
                        new breeze.DataProperty({ name: "assessmentTypeId", dataType: breeze.DataType.Int32, isNullable: false, isPartOfKey: false }),
                    ];
                }
                return AssessmentIdentifier;
            })();
            clientEntities.AssessmentIdentifier = AssessmentIdentifier;
        })(clientEntities = model.clientEntities || (model.clientEntities = {}));
    })(model = app.model || (app.model = {}));
})(app || (app = {}));

var app;
(function (app) {
    var model;
    (function (model) {
        var clientEntities;
        (function (clientEntities) {
            var AssessmentReport = (function () {
                function AssessmentReport() {
                    this.shortName = app.constants.entityNames.assessmentReport;
                    this.namespace = "Mercatus.AquaVet.Domain.Models.AssessmentReport";
                    this.autoGeneratedKeyType = breeze.AutoGeneratedKeyType.Identity;
                    this.dataProperties = [
                        new breeze.DataProperty({ name: "assessmentId", dataType: breeze.DataType.Int32, isNullable: false, isPartOfKey: true, isUnmapped: true }),
                        new breeze.DataProperty({ name: "fileName", dataType: breeze.DataType.String, isNullable: false, isPartOfKey: false, isUnmapped: true }),
                        new breeze.DataProperty({ name: "isUpdated", dataType: breeze.DataType.Boolean, isNullable: false, isPartOfKey: false, isUnmapped: true }),
                        new breeze.DataProperty({ name: "pdfExists", dataType: breeze.DataType.Boolean, isNullable: false, isPartOfKey: false, isUnmapped: true })
                    ];
                }
                return AssessmentReport;
            })();
            clientEntities.AssessmentReport = AssessmentReport;
        })(clientEntities = model.clientEntities || (model.clientEntities = {}));
    })(model = app.model || (app.model = {}));
})(app || (app = {}));

var app;
(function (app) {
    var model;
    (function (model) {
        var clientEntities;
        (function (clientEntities) {
            var PrescriptionReport = (function () {
                function PrescriptionReport() {
                    this.shortName = app.constants.entityNames.prescriptionReport;
                    this.namespace = "Mercatus.AquaVet.Domain.Models.PrescriptionReport";
                    this.autoGeneratedKeyType = breeze.AutoGeneratedKeyType.Identity;
                    this.dataProperties = [
                        new breeze.DataProperty({ name: "prescriptionId", dataType: breeze.DataType.Int32, isNullable: false, isPartOfKey: true, isUnmapped: true }),
                        new breeze.DataProperty({ name: "fileName", dataType: breeze.DataType.String, isNullable: false, isPartOfKey: false, isUnmapped: true }),
                        new breeze.DataProperty({ name: "isUpdated", dataType: breeze.DataType.Boolean, isNullable: false, isPartOfKey: false, isUnmapped: true }),
                        new breeze.DataProperty({ name: "pdfExists", dataType: breeze.DataType.Boolean, isNullable: false, isPartOfKey: false, isUnmapped: true })
                    ];
                }
                return PrescriptionReport;
            })();
            clientEntities.PrescriptionReport = PrescriptionReport;
        })(clientEntities = model.clientEntities || (model.clientEntities = {}));
    })(model = app.model || (app.model = {}));
})(app || (app = {}));

var app;
(function (app) {
    var common;
    (function (common) {
        var model;
        (function (model) {
            var Notification = (function () {
                function Notification(notificationMessage) {
                    this.notificationMessage = notificationMessage;
                }
                return Notification;
            })();
            model.Notification = Notification;
            var NotificationDetail = (function () {
                function NotificationDetail() {
                }
                return NotificationDetail;
            })();
            model.NotificationDetail = NotificationDetail;
        })(model = common.model || (common.model = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

var app;
(function (app) {
    var common;
    (function (common) {
        var model;
        (function (model) {
            var NavigationOption = (function () {
                function NavigationOption(description, value, visible, sortOrder, menuName, moduleId, objectLevelBitmask, isSelected, data, confirm, title, message, navigationSubOptions) {
                    if (confirm === void 0) { confirm = false; }
                    if (title === void 0) { title = ''; }
                    if (message === void 0) { message = ''; }
                    if (navigationSubOptions === void 0) { navigationSubOptions = null; }
                    this.description = description;
                    this.value = value;
                    this.visible = visible;
                    this.sortOrder = sortOrder;
                    this.menuName = menuName;
                    this.moduleId = moduleId;
                    this.objectLevelBitmask = objectLevelBitmask;
                    this.isSelected = isSelected;
                    this.data = data;
                    this.confirm = confirm;
                    this.title = title;
                    this.message = message;
                    this.navigationSubOptions = navigationSubOptions;
                    this.disabled = false;
                    this.siteTypeBitMask = 255;
                }
                return NavigationOption;
            })();
            model.NavigationOption = NavigationOption;
        })(model = common.model || (common.model = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

var app;
(function (app) {
    var common;
    (function (common) {
        var model;
        (function (model) {
            var AutheticatedUser = (function () {
                function AutheticatedUser() {
                }
                return AutheticatedUser;
            })();
            model.AutheticatedUser = AutheticatedUser;
        })(model = common.model || (common.model = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

/// <reference path="../../_typings.ts"/>
"use strict";
var app;
(function (app) {
    var common;
    (function (common) {
        var model;
        (function (model) {
            var ModelBuilder = (function () {
                function ModelBuilder(metadataStore, addclientEntities) {
                    if (addclientEntities === void 0) { addclientEntities = true; }
                    this.assessmentConstructor = function () {
                        var _this = this;
                        this.assessmentStatus = app.constants.assessmentStatus.COMPLETED;
                        this.customerId = 0;
                        this.customerName = "";
                        this.freshwaterCustomerId = 0;
                        this.freshwaterSiteId = 0;
                        this.freshwaterFishgroupId = 0;
                        this._seaCustomerId = 0;
                        this.seaSiteId = 0;
                        this._vaccinationCustomerId = 0;
                        this._vaccinationSiteId = 0;
                        this.siteManagerId = 0;
                        this._nahRepresentitiveId = "";
                        this.assessmentLinkId = null;
                        this.contactPersonNames = [];
                        this.contactPersonId = "";
                        this.allowValidation = true;
                        this._assessmentSaveStatus = "";
                        this._visitType = "";
                        this._reportStatus = "";
                        this._reportProgress = 0;
                        this.lastSaved = null;
                        this._showDetail = false;
                        this._isLocked = false;
                        this._hasFarmerData = false;
                        this.initVariables = function () {
                            _this.freshwaterCustomerId = _this.getVarValue("FreshwaterCustomer");
                            _this.freshwaterSiteId = _this.getVarValue("FreshwaterSite");
                            _this.freshwaterFishgroupId = _this.getVarValue("FreshwaterFishgroup");
                            _this._nahRepresentitiveId = _this.getVarValue("NAHRepresentitive");
                            _this.assessmentLinkId = _this.getVarValue("AssessmentLink");
                            _this._vaccinationCustomerId = _this.getVarValue("VaccinationCustomer");
                            _this._vaccinationSiteId = _this.getVarValue("VaccinationSite");
                            _this._seaCustomerId = _this.getVarValue("SeaCustomer");
                            _this.seaSiteId = _this.getVarValue("SeaSite");
                            var siteManager = _this.getVarValue("SeaSiteManager");
                            _this.siteManagerId = siteManager
                                ? siteManager
                                : _this.getVarValue("SiteManager");
                            _this.customerId = _this.customerId
                                ? _this.customerId
                                : _this.getVarValue("Customer");
                        };
                        this.getVarValue = function (attrName) {
                            var templateItem;
                            _.forEach(_this.assessmentType.templateGroups, function (tg) {
                                tg.revisit = false;
                                if (!templateItem) {
                                    templateItem = _.find(tg.template.templateItems, function (ti) {
                                        return ti.attributeDictionary.name === attrName;
                                    });
                                }
                            });
                            if (!templateItem)
                                return undefined;
                            var templateRegistration = _.find(_this.templateRegistrations, function (tr) {
                                return (tr.attributeId === templateItem.attributeId &&
                                    tr.templateId === templateItem.templateId);
                            });
                            return templateRegistration
                                ? templateRegistration.focusValue
                                : undefined;
                        };
                    };
                    this.assessmentTypeConstructor = function () {
                        this.businessRuleExpressions = [];
                        this.visible = false;
                    };
                    this.sentMailConstructor = function () {
                        this.nahRepresentativeNames = "";
                    };
                    this.templateGroupConstructor = function (templateGroup) {
                        this.rows = 0;
                        this.selectedRow = 1;
                        this._hasErrors = false;
                        this.revisit = false;
                        this.skip = false;
                    };
                    this.templateRegistrationConstructor = function () {
                        var _this = this;
                        this.fishSampleFile = null;
                        this.fishSamplePicture = null;
                        this._hasPreFilled = false;
                        this.fishSamplePictureSynchronized = true;
                        this.error = {
                            haserror: false,
                            errorType: app.constants.errorType.None,
                            value: ""
                        };
                        this.customError = {
                            haserror: false,
                            errorType: app.constants.errorType.None,
                            value: ""
                        }; //skip ng-validation
                        this.reset = function () {
                            _this.textValue = null;
                            _this.integerValue = null;
                            _this.doubleValue = null;
                            _this.commentValue = null;
                            _this.booleanValue = null;
                            _this.prefillAssessmentId = null;
                            _this.focusValue = null;
                            _this.hasPreFilled = false;
                        };
                    };
                    this.templateItemConstructor = function () {
                        this._optionSelection = null;
                    };
                    this.userBusinessObjectConstructor = function () {
                        this._businessObjectName = null;
                        this._permission = null;
                        this._customerId = null;
                        this._description = null;
                    };
                    this.prescriptionConstructor = function () {
                        this.customerId = 0;
                        this.customerName = "";
                        this._prescriptionSaveStatus = "";
                        this._reportStatus = "";
                        this._reportProgress = 0;
                        this.amountStr = null;
                        this._isLocked = false;
                    };
                    this.treatmentProductConstructor = function () {
                        this.inclusion = null;
                        this.quarantineValue = null;
                        this.usageMask = null;
                        this.indicationMask = null;
                        this.active = true;
                        this.isLocked = false;
                    };
                    this.supplierConstructor = function () {
                        this.inclusion = null;
                        this.quarantineValue = null;
                        this.usageMask = null;
                        this.indicationMask = null;
                        this.active = true;
                    };
                    this.activeSubstanceConstructor = function () { };
                    this.treatmentProductProducerConstructor = function () { };
                    this.regionalAuthorityConstructor = function () { };
                    this.treatmentProductIndicationConstructor = function () {
                        this._selected = false;
                    };
                    this.eventConstructor = function () { };
                    this.eventInitializer = function () { };
                    if (addclientEntities)
                        this.addEntities(metadataStore);
                    this.extendMetadata(metadataStore);
                }
                ModelBuilder.prototype.extendMetadata = function (metadataStore) {
                    this.registerAssessment(metadataStore);
                };
                ModelBuilder.prototype.addEntities = function (metadataStore) {
                    metadataStore.addEntityType(new app.model.clientEntities.AssessmentDiscriminator());
                    metadataStore.addEntityType(new app.model.clientEntities.AllowedRegistration());
                    metadataStore.addEntityType(new app.model.clientEntities.AssessmentIdentifier());
                    metadataStore.addEntityType(new app.model.clientEntities.AssessmentReport());
                    metadataStore.addEntityType(new app.model.clientEntities.PrescriptionReport());
                };
                ModelBuilder.prototype.registerAssessment = function (metadataStore) {
                    var _this = this;
                    var entityNames = app.constants.entityNames;
                    metadataStore.registerEntityTypeCtor(entityNames.address, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.applicationUser, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.allowedReg, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.area, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.attribute, function () { }, this.attributeInitializer);
                    metadataStore.registerEntityTypeCtor(entityNames.attributeMetadata, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.attributeMetadataType, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.attributeMetadataEnum, function () { }, function (entity) {
                        _this.attributeMetadataEnumInitializer(entity);
                    });
                    metadataStore.registerEntityTypeCtor(entityNames.attributeType, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.audit, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.assessment, this.assessmentConstructor, this.assessmentInitializer);
                    metadataStore.registerEntityTypeCtor(entityNames.assessmentDiscriminator, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.assessmentIdentifier, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.assessmentType, this.assessmentTypeConstructor, this.assessmentTypeInitializer);
                    metadataStore.registerEntityTypeCtor(entityNames.assessmentTypeGroup, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.assessmentFollowUpStatus, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.assessmentReport, function () { }, this.reportInitializer);
                    metadataStore.registerEntityTypeCtor(entityNames.prescriptionReport, function () { }, this.reportInitializer);
                    metadataStore.registerEntityTypeCtor(entityNames.contactPerson, function () { }, this.contactPersonInitializer);
                    metadataStore.registerEntityTypeCtor(entityNames.company, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.companyContactPerson, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.companyBu, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.companyBUContactPerson, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.customer, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.customerContactPerson, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.customerBu, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.customerBUContactPerson, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.dictionary, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.event, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.fishgroup, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.language, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.localization, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.notification, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.notificationType, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.operation, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.password, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.region, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.securityLevel, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.sentMail, this.sentMailConstructor);
                    metadataStore.registerEntityTypeCtor(entityNames.site, function () { }, this.siteInitializer);
                    metadataStore.registerEntityTypeCtor(entityNames.siteContactPerson, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.siteVetContactPerson, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.template, function () { }, this.templateInitializer);
                    metadataStore.registerEntityTypeCtor(entityNames.templateGroup, this.templateGroupConstructor, this.templateGroupInitializer);
                    metadataStore.registerEntityTypeCtor(entityNames.templateRegistration, this.templateRegistrationConstructor, function (entity) {
                        _this.templateRegistrationInitializer(entity);
                    });
                    metadataStore.registerEntityTypeCtor(entityNames.templateItem, this.templateItemConstructor, this.templateItemInitializer);
                    metadataStore.registerEntityTypeCtor(entityNames.user, function () { });
                    metadataStore.registerEntityTypeCtor(entityNames.userBusinessObject, this.userBusinessObjectConstructor, this.userBusinessObjectInitializer);
                    metadataStore.registerEntityTypeCtor(entityNames.prescription, this.prescriptionConstructor, function (entity) {
                        _this.prescriptionInitializer(entity);
                    });
                    metadataStore.registerEntityTypeCtor(entityNames.treatmentProduct, this.treatmentProductConstructor, function (entity) {
                        _this.treatmentProductInitializer(entity);
                    });
                    metadataStore.registerEntityTypeCtor(entityNames.supplier, this.supplierConstructor, function (entity) {
                        _this.supplierInitializer(entity);
                    });
                    metadataStore.registerEntityTypeCtor(entityNames.activeSubstance, this.activeSubstanceConstructor, function (entity) {
                        _this.activeSubstanceInitializer(entity);
                    });
                    metadataStore.registerEntityTypeCtor(entityNames.treatmentProductProducer, this.treatmentProductProducerConstructor, function (entity) {
                        _this.treatmentProductProducerInitializer(entity);
                    });
                    metadataStore.registerEntityTypeCtor(entityNames.regionalAuthority, this.regionalAuthorityConstructor, function (entity) {
                        _this.regionalAuthorityInitializer(entity);
                    });
                    metadataStore.registerEntityTypeCtor(entityNames.treatmentProductIndication, this.treatmentProductIndicationConstructor, function (entity) {
                        _this.treatmentProductIndicationInitializer(entity);
                    });
                    metadataStore.registerEntityTypeCtor(entityNames.event, this.eventConstructor, this.eventInitializer);
                };
                ModelBuilder.prototype.validators = function () {
                    this.requiredValidators();
                    this.requiredReferenceValidator();
                    this.onlyFutureDatesValidators();
                };
                ModelBuilder.prototype.requiredValidators = function () {
                    var requiredValidator = new breeze.Validator("requiredValidator", this.requiredValidationFn, {
                        messageTemplate: "RequiredField. {TemplateRegistrationId : %TemplateRegistrationId%, AttributeId : %AttributeId%, TemplateId : %TemplateId%}"
                    });
                    breeze.Validator.register(requiredValidator);
                    return requiredValidator;
                };
                ModelBuilder.prototype.addEntityLevelValidators = function (store) {
                    var templateRegistration = store.getEntityType(app.constants.entityNames.templateRegistration);
                    templateRegistration.validators.push(this.requiredValidators());
                    var prescription = store.getEntityType(app.constants.entityNames.prescription);
                    this.addRequiredReferenceValidatorsForEntity(prescription);
                    var treatmentProduct = store.getEntityType(app.constants.entityNames.treatmentProduct);
                    this.addRequiredReferenceValidatorsForEntity(treatmentProduct);
                };
                ModelBuilder.prototype.addRequiredReferenceValidatorsForEntity = function (type) {
                    var _this = this;
                    var props = type.getProperties();
                    props.forEach(function (prop) {
                        var vals = prop.validators;
                        for (var i = vals.length; i--;) {
                            var val = vals[i];
                            if ((val.context.isRequired || val.name === "required") &&
                                prop.name.indexOf("Id") > 0 &&
                                prop.name
                                    .toLowerCase()
                                    .indexOf(type.shortName.toLowerCase() + "id") == -1) {
                                if (type.getProperty(prop.name.replace("Id", "")))
                                    type
                                        .getProperty(prop.name.replace("Id", ""))
                                        .validators.push(_this.requiredReferenceValidator());
                            }
                        }
                    });
                };
                ModelBuilder.prototype.onlyFutureDatesValidators = function () {
                    var futureDateValidator = new breeze.Validator('allowOnlyFutureDates', // validator name
                    this.allowOnlyFutureDates, // validation function
                    {
                        messageTemplate: 'OnlyFutureDatesAllowed'
                    });
                    breeze.Validator.register(futureDateValidator);
                    return futureDateValidator;
                };
                ModelBuilder.prototype.allowOnlyFutureDates = function (value, context) {
                    if (value == null)
                        return true; // '== null' matches null and empty string
                    return value >= new Date((new Date()).toDateString());
                };
                ModelBuilder.prototype.requiredReferenceValidator = function () {
                    var name = "requireReferenceValidator";
                    var ctx = {
                        messageTemplate: breeze.Validator.messageTemplates["required"],
                        isRequired: true
                    };
                    var requireReferenceValidator = new breeze.Validator(name, valFunction, ctx);
                    breeze.Validator.register(requireReferenceValidator);
                    return requireReferenceValidator;
                    function valFunction(value) {
                        return value ? value.id !== 0 : false;
                    }
                };
                ModelBuilder.prototype.requiredValidationFn = function (entity, context) {
                    var attribute = entity.getProperty("attribute");
                    var rowIndex = entity.getProperty("rowIndex");
                    var templateItem = _.find(attribute.templateItems, function (ti) {
                        return ti.templateId == entity.getProperty("templateId");
                    });
                    var assessment = entity.getProperty("assessment");
                    if (assessment == null)
                        //try getting from context
                        assessment = context.value != null ? context.value.assessment() : null;
                    var allowValidation = entity.getProperty("allowValidation");
                    var required = templateItem.attributeIsRequired !== null ? templateItem.attributeIsRequired : attribute != null ? attribute.required : false;
                    if (rowIndex != null && rowIndex < 0)
                        return true;
                    if (attribute.maxFutureDays !== null && entity.getProperty("focusValue") != null) {
                        var selectedDateValue = entity.getProperty("focusValue");
                        if (moment().startOf("day").add("d", parseInt(attribute.MaxFutureDays)).diff(moment(selectedDateValue).startOf("day")) < 0) {
                            return false;
                        }
                        return true;
                    }
                    if (required && ((assessment != null && assessment.allowValidation) || allowValidation)) {
                        if (attribute.dictionary.name == "Fishgroup" || attribute.dictionary.name == "SeaSiteFishgroup")
                            return true;
                        var focusValue = entity.getProperty("focusValue");
                        if (attribute.dictionary.name == "Assessment date") {
                            if (entity.assessment.assessmentDate == null)
                                return false;
                            if (moment().startOf("day").diff(moment(entity.assessment.assessmentDate).startOf("day")) < 0) {
                                return false;
                            }
                            return true;
                        }
                        context.TemplateRegistrationId = entity.getProperty("templateRegistrationId");
                        context.AttributeId = entity.getProperty("attributeId");
                        context.TemplateId = entity.getProperty("templateId");
                        if (attribute.attributeType.name == "Enum") {
                            return !app.common.utils.isNullOrUndefinedOrEmpty(focusValue);
                        }
                        return (!app.common.utils.isNullOrUndefinedOrEmpty(focusValue) &&
                            (focusValue != "0" && focusValue != 0) || (attribute.requiredAllowZero && (focusValue == "0" || focusValue == 0)));
                    }
                    return true;
                };
                ModelBuilder.prototype.assessmentInitializer = function (assessment) {
                    Object.defineProperty(assessment, "syncStatus", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var isDraft = assessment.isDraft == true &&
                                assessment.deviceTypeId === app.constants.deviceType.IPad;
                            if (isDraft) {
                                assessment.assessmentStatus = app.constants.assessmentStatus.DRAFT;
                            }
                            return this.entityAspect.entityState.name === "Unchanged" && !isDraft
                                ? app.constants.assessmentSyncStatus.SYNCED
                                : app.constants.assessmentSyncStatus.NON_SYNCED;
                        }
                    });
                    Object.defineProperty(assessment, "syncStatusOrder", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var isDraft = assessment.isDraft == true &&
                                assessment.deviceTypeId === app.constants.deviceType.IPad;
                            if (isDraft) {
                                return 1;
                            }
                            return this.entityAspect.entityState.name === "Unchanged" ? 3 : 2;
                        }
                    });
                    Object.defineProperty(assessment, "showDetail", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return assessment._showDetail; },
                        set: function (value) {
                            assessment._showDetail = value;
                        }
                    });
                    Object.defineProperty(assessment, "hasFarmerData", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return assessment._hasFarmerData; },
                        set: function (value) {
                            assessment._hasFarmerData = value;
                        }
                    });
                    Object.defineProperty(assessment, "isLocked", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return assessment._isLocked; },
                        set: function (value) {
                            assessment._isLocked = value;
                        }
                    });
                    Object.defineProperty(assessment, "assessmentSaveStatus", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return assessment._assessmentSaveStatus; },
                        set: function (value) {
                            assessment._assessmentSaveStatus = value;
                        }
                    });
                    Object.defineProperty(assessment, "visitType", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return assessment._visitType; },
                        set: function (value) {
                            assessment._visitType = value;
                        }
                    });
                    Object.defineProperty(assessment, "reportStatus", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return assessment._reportStatus; },
                        set: function (value) {
                            assessment._reportStatus = value;
                        }
                    });
                    Object.defineProperty(assessment, "reportProgress", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return assessment._reportProgress;
                        },
                        set: function (value) {
                            assessment._reportProgress = value;
                        }
                    });
                    Object.defineProperty(assessment, "assessmentTypeName", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return app.localizer.resource[assessment.assessmentType.dictionary.name];
                        }
                    });
                    Object.defineProperty(assessment, "hasFollowUp", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return assessment.assessmentType === null ? true : assessment.assessmentType.followUp;
                        }
                    });
                    Object.defineProperty(assessment, "siteName", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return assessment.site.name;
                        }
                    });
                    Object.defineProperty(assessment, "nahRepresentitiveId", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return assessment._nahRepresentitiveId; },
                        set: function (value) {
                            assessment._nahRepresentitiveId = value;
                        }
                    });
                    Object.defineProperty(assessment, "followup", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return "we";
                        } //TODO try not to do this
                    });
                    Object.defineProperty(assessment, "menu", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return "we";
                        }
                    });
                    Object.defineProperty(assessment, "vaccinationCustomerId", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            assessment._vaccinationCustomerId = assessment._vaccinationCustomerId
                                ? assessment._vaccinationCustomerId
                                : assessment.customerId;
                            return assessment._vaccinationCustomerId;
                        },
                        set: function (value) {
                            assessment._vaccinationCustomerId = value;
                        }
                    });
                    Object.defineProperty(assessment, "vaccinationSiteId", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return assessment._vaccinationSiteId
                                ? assessment._vaccinationSiteId
                                : assessment.siteId;
                        },
                        set: function (value) {
                            assessment._vaccinationSiteId = value ? value : -1;
                        }
                    });
                    Object.defineProperty(assessment, "seaCustomerId", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            assessment._seaCustomerId = assessment._seaCustomerId
                                ? assessment._seaCustomerId
                                : assessment.customerId;
                            return assessment._seaCustomerId;
                        },
                        set: function (value) {
                            assessment._seaCustomerId = value;
                        }
                    });
                    Object.defineProperty(assessment, "templateGroups", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            if (assessment.site) {
                                var siteType = assessment.site.siteTypeId;
                                var bitVal = Math.pow(2, siteType);
                                return _.filter(assessment.assessmentType.templateGroups, function (tg) {
                                    tg.skip = !((tg.siteTypeBitMask & bitVal) > 0 && (!tg.template.isFromFarmer || (tg.template.isFromFarmer && assessment.isFarmerIntegrationOn && assessment.site.customer.integrationServiceConfigurationId)));
                                    return !tg.skip;
                                });
                            }
                            else {
                                return _.filter(assessment.assessmentType.templateGroups, function (tg) {
                                    return (!tg.template.isFromFarmer || (tg.template.isFromFarmer && assessment.isFarmerIntegrationOn));
                                });
                            }
                        }
                    });
                    //Used on edit to load faramer data
                    Object.defineProperty(assessment, "customerKey", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            if (assessment.site && assessment.site.customer) {
                                return "2-" + assessment.site.customer.customerId;
                            }
                            else
                                return null;
                        }
                    });
                };
                ModelBuilder.prototype.attributeMetadataEnumInitializer = function (attributeMetadataEnum) {
                    this.addIsRequired(attributeMetadataEnum);
                    this.addValidationProperties(attributeMetadataEnum);
                    Object.defineProperty(attributeMetadataEnum, "attributeName", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return attributeMetadataEnum.attribute.dictionary.name;
                        }
                    });
                };
                ModelBuilder.prototype.attributeInitializer = function (attribute) {
                    Object.defineProperty(attribute, "aggregations", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return _.map(_.filter(this.attributeMetadatas, function (metadata) {
                                return (metadata.attributeMetadataTypeId ===
                                    app.constants.attributeMetadataType.Aggregation);
                            }), function (metadata) {
                                return metadata.value;
                            });
                        }
                    });
                    Object.defineProperty(attribute, "enumDataType", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var dataType = _.find(this.attributeMetadatas, function (metadata) {
                                return (metadata.attributeMetadataTypeId ===
                                    app.constants.attributeMetadataType.EnumDataType);
                            });
                            return !app.common.utils.isNullOrUndefined(dataType)
                                ? dataType.value
                                : "String";
                        }
                    });
                    Object.defineProperty(attribute, "labelDataType", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var dataType = _.find(this.attributeMetadatas, function (metadata) {
                                return (metadata.attributeMetadataTypeId ===
                                    app.constants.attributeMetadataType.LabelDataType);
                            });
                            return !app.common.utils.isNullOrUndefined(dataType)
                                ? dataType.value.split(";")[0]
                                : "String";
                        }
                    });
                    Object.defineProperty(attribute, "labelDataTypeDecimals", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var dataType = _.find(this.attributeMetadatas, function (metadata) {
                                return (metadata.attributeMetadataTypeId ===
                                    app.constants.attributeMetadataType.LabelDataType);
                            });
                            return !app.common.utils.isNullOrUndefined(dataType)
                                ? dataType.value.split(";")[1] || 0 : 2;
                        }
                    });
                    Object.defineProperty(attribute, "information", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var dataType = _.find(this.attributeMetadatas, function (metadata) {
                                return (metadata.attributeMetadataTypeId ===
                                    app.constants.attributeMetadataType.Information);
                            });
                            return !app.common.utils.isNullOrUndefined(dataType)
                                ? app.localizer.resource[dataType.value] : null;
                        }
                    });
                    Object.defineProperty(attribute, "farmerDataMappingRule", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var dataType = _.filter(this.attributeMetadatas, function (metadata) {
                                return (metadata.attributeMetadataTypeId ===
                                    app.constants.attributeMetadataType.FarmerMappingRule);
                            });
                            return !app.common.utils.isNullOrUndefined(dataType)
                                ? _.map(dataType, function (dt) {
                                    return {
                                        rule: dt.value.split(":")[0], value: dt.value.split(":")[1], true: dt.value.split(":")[2], false: dt.value.split(":")[3], none: dt.value.split(":")[4]
                                    };
                                }) : null;
                        }
                    });
                    Object.defineProperty(attribute, "dependencies", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var dataType = _.filter(this.attributeMetadatas, function (metadata) {
                                return (metadata.attributeMetadataTypeId ===
                                    app.constants.attributeMetadataType.DecidesRule);
                            });
                            return !app.common.utils.isNullOrUndefined(dataType)
                                ? _.map(dataType, function (dt) {
                                    return {
                                        dependedAttributeId: dt.value.split(":")[0], fieldname: dt.value.split(":")[1]
                                    };
                                }) : null;
                        }
                    });
                    Object.defineProperty(attribute, "hasDependant", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return attribute.dependencies.length > 0;
                        }
                    });
                    Object.defineProperty(attribute, "required", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var required = _.find(this.attributeMetadatas, function (metadata) {
                                return (metadata.attributeMetadataTypeId ===
                                    app.constants.attributeMetadataType.Required);
                            });
                            return !app.common.utils.isNullOrUndefined(required);
                        }
                    });
                    Object.defineProperty(attribute, "requiredAllowZero", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var required = _.find(this.attributeMetadatas, function (metadata) {
                                return (metadata.attributeMetadataTypeId ===
                                    app.constants.attributeMetadataType.Required);
                            });
                            return !app.common.utils.isNullOrUndefined(required) && required.value == 'Required:0';
                        }
                    });
                    Object.defineProperty(attribute, "maxFutureDays", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var maxFutureDays = _.find(this.attributeMetadatas, function (metadata) {
                                return (metadata.attributeMetadataTypeId ===
                                    app.constants.attributeMetadataType.MaxFutureDays);
                            });
                            return app.common.utils.isNullOrUndefined(maxFutureDays)
                                ? null
                                : maxFutureDays.value;
                        }
                    });
                };
                ModelBuilder.prototype.assessmentTypeInitializer = function (assessmentType) {
                    _.forEach(assessmentType.templateGroups, function (templateGroup) {
                        _.forEach(templateGroup.template.templateItems, function (templateItem) {
                            //if (templateItem.attribute.attributeType.name === constants.attributeType.BusinessRule) {
                            _.forEach(templateItem.attribute.attributeMetadatas, function (metadata) {
                                if (metadata.attributeMetadataTypeId ===
                                    app.constants.attributeMetadataType.Expression) {
                                    assessmentType.businessRuleExpressions.push(new app.model.scopeModel.BusinessRuleExpression(templateItem.templateId, templateItem.attributeId, templateItem.template.multiRows, metadata.value));
                                }
                            });
                            //}
                        });
                    });
                };
                ModelBuilder.prototype.assessmentTypeGroupInitializer = function (assessmentGroup) { };
                ModelBuilder.prototype.assessmentFollowUpStatusConstructor = function () { };
                ModelBuilder.prototype.assessmentFollowUpStatusInitializer = function () { };
                ModelBuilder.prototype.reportInitializer = function (report) {
                    Object.defineProperty(report, "type", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.assessmentId
                                ? app.constants.entityNames.assessment
                                : app.constants.entityNames.prescription;
                        }
                    });
                    Object.defineProperty(report, "id", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.assessmentId ? this.assessmentId : this.prescriptionId;
                        }
                    });
                };
                ModelBuilder.prototype.contactPersonConstructor = function () { };
                ModelBuilder.prototype.contactPersonInitializer = function (contact) {
                    Object.defineProperty(contact, "fullName", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.firstName + " " + this.lastName;
                        }
                    });
                };
                ModelBuilder.prototype.templateInitializer = function (template) {
                    Object.defineProperty(template, "shortPrefix", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            if (_.includes(angular.lowercase(this.dictionary.name), "fish samples"))
                                return "Fish";
                            else if (_.includes(this.dictionary.name, "Vacc"))
                                return "Vacc.";
                            else
                                return this.dictionary.name;
                        }
                    });
                };
                ModelBuilder.prototype.templateGroupInitializer = function (templateGroup) {
                    templateGroup.skip = false;
                    Object.defineProperty(templateGroup, "totalFooterRowsCount", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            if (this.template == null)
                                return 0;
                            if (this.template.multiRows == false)
                                return 0;
                            var max = 0;
                            _.forEach(templateGroup.template.templateItems, function (ti) {
                                if (ti.attribute.attributeMetadatas.length > 0) {
                                    var aggregation = _.find(ti.attribute.attributeMetadatas, function (metadata) {
                                        return metadata.attributeMetadataTypeId ===
                                            app.constants.attributeMetadataType.Aggregation &&
                                            metadata.sortOrder ===
                                                Math.max.apply(null, _.map(ti.attribute.attributeMetadatas, function (e) { return e.sortOrder; }));
                                    });
                                    if (aggregation != null && max < aggregation.sortOrder + 1)
                                        max = aggregation.sortOrder + 1;
                                }
                            });
                            return max;
                        }
                    });
                    Object.defineProperty(templateGroup, "hasMultiRows", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.template.multiRows > 0;
                        }
                    });
                    Object.defineProperty(templateGroup, "hasTabsView", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.template.templateType.description == 'TabsView';
                        }
                    });
                    Object.defineProperty(templateGroup, "hasAccordionView", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.template.templateType.description == 'AccordionView';
                        }
                    });
                    Object.defineProperty(templateGroup, "hasDefaultView", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.template.templateType.description == 'Default';
                        }
                    });
                    Object.defineProperty(templateGroup, "hasTotals", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return _.includes(this.template.dictionary.name.toLowerCase(), "fish samples");
                        }
                    });
                    Object.defineProperty(templateGroup, "hasErrors", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return templateGroup._hasErrors; },
                        set: function (value) {
                            templateGroup._hasErrors = value;
                        }
                    });
                };
                ModelBuilder.prototype.templateRegistrationInitializer = function (templateRegistration) {
                    var _this = this;
                    this.addIsValidNumber(templateRegistration);
                    //Used in mobile
                    Object.defineProperty(templateRegistration, "fishSamplePicture", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            if (this.attribute &&
                                this.attribute.dictionary &&
                                (this.attribute.dictionary.name === "Picture" || this.attribute.dictionary.name === "File")) {
                                if (this.fishSampleFile == null) {
                                    if (common.utils.isNullOrUndefinedOrEmpty(this.textValue))
                                        return null;
                                    else
                                        this.fishSampleFile =
                                            this.textValue + "?random=" + new Date().toString();
                                }
                                return (common.utils.rootFolderPath +
                                    "/" +
                                    (this.assessment.isDraft
                                        ? app.constants.fileSystemFolders.picturesDraft
                                        : app.constants.fileSystemFolders.picturesCompleted) +
                                    "/" +
                                    this.assessmentId +
                                    "/" +
                                    this.fishSampleFile);
                            }
                            return null;
                        }
                    });
                    Object.defineProperty(templateRegistration, "hasPreFilled", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return (templateRegistration._hasPreFilled ||
                                templateRegistration.prefillAssessmentId || templateRegistration.isReadOnly);
                        },
                        set: function (value) {
                            return (templateRegistration._hasPreFilled = value);
                        }
                    });
                    //Used in web
                    Object.defineProperty(templateRegistration, "imageData", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return templateRegistration._imageData; },
                        set: function (value) {
                            templateRegistration._imageData = value;
                        }
                    });
                    Object.defineProperty(templateRegistration, "multiselectValue", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var self = this;
                            if (!app.common.utils.isNullOrUndefined(this.textValue) &&
                                this.textValue != "") {
                                if (this._multiselectValue == null) {
                                    this._multiselectValue = _.map(this.textValue.split(","), function (val) {
                                        return new app.model.scopeModel.OptionItem(val, val, null, true);
                                    });
                                }
                                return this._multiselectValue;
                            }
                            else {
                                if (this._multiselectValue == null)
                                    this._multiselectValue = [];
                                return this._multiselectValue;
                            }
                        },
                        set: function (value) {
                            this._multiselectValue = value;
                            this.textValue = _.map(value, function (val) {
                                return val.value;
                            });
                        }
                    });
                    Object.defineProperty(templateRegistration, "focusValue", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            if (templateRegistration.attribute == null)
                                return;
                            if (templateRegistration
                                && templateRegistration.error
                                && templateRegistration.error.haserror)
                                return templateRegistration.error.value;
                            switch (templateRegistration.attribute.attributeType.name) {
                                case "Enum":
                                    switch (templateRegistration.attribute.enumDataType) {
                                        case "Double":
                                            if (templateRegistration.rowIndex == -1 &&
                                                templateRegistration.attributeId == 54 &&
                                                !templateRegistration.tooltipValue)
                                                templateRegistration.tooltipValue =
                                                    templateRegistration.textValue;
                                            return templateRegistration.doubleValue;
                                        case "Integer":
                                            return templateRegistration.integerValue;
                                        case "String":
                                            return templateRegistration.textValue;
                                    }
                                case "Double":
                                case "Expression":
                                case "Business rule":
                                    var decimalQuantityToFormatValue;
                                    var tryParseIntResult = parseInt(templateRegistration.attribute.labelDataTypeDecimals);
                                    if (!templateRegistration.attribute.labelDataTypeDecimals || isNaN(tryParseIntResult))
                                        decimalQuantityToFormatValue = 2;
                                    else
                                        decimalQuantityToFormatValue = tryParseIntResult;
                                    return !common.utils.isNullOrUndefined(templateRegistration.doubleValue)
                                        ? common.utils.formatDecimal(common.utils.precise_round(templateRegistration.doubleValue, decimalQuantityToFormatValue))
                                        : templateRegistration.doubleValue;
                                case "Integer":
                                    return common.utils.formatDecimal(templateRegistration.integerValue);
                                case "Text":
                                    if (templateRegistration.attribute.dictionary.name == "InvoiceAddress"
                                        && templateRegistration.assessment.site
                                        && templateRegistration.assessment.site.siteAddresses.length > 0) {
                                        var invoiceAddress = _this.getAddress(templateRegistration.assessment, app.constants.addressType.invoice);
                                        if (invoiceAddress != null)
                                            return invoiceAddress;
                                    }
                                    if (templateRegistration.attribute.dictionary.name == "DeliveryAddress"
                                        && templateRegistration.assessment.site
                                        && templateRegistration.assessment.site.siteAddresses.length > 0) {
                                        var deliveryAddress = _this.getAddress(templateRegistration.assessment, app.constants.addressType.delivery);
                                        if (deliveryAddress != null)
                                            return deliveryAddress;
                                    }
                                    return templateRegistration.textValue;
                                case "Boolean":
                                    return templateRegistration.booleanValue;
                                case "BooleanNullable":
                                    return templateRegistration.booleanValue;
                                case "Date":
                                    return templateRegistration.dateValue;
                                case "Comment":
                                    return templateRegistration.commentValue;
                                case "Multiselect":
                                    return templateRegistration.textValue;
                                case "Label":
                                    switch (templateRegistration.attribute.labelDataType) {
                                        case "Double":
                                            if (templateRegistration.rowIndex == -1 &&
                                                templateRegistration.attributeId == 54 &&
                                                !templateRegistration.tooltipValue)
                                                templateRegistration.tooltipValue =
                                                    templateRegistration.textValue;
                                            return templateRegistration.doubleValue;
                                        case "Integer":
                                            return templateRegistration.integerValue;
                                        case "String":
                                            return templateRegistration.textValue;
                                    }
                                default:
                                    return templateRegistration.textValue;
                            }
                        },
                        set: function (value) {
                            if (this.attribute == null)
                                return;
                            switch (this.attribute.attributeType.name) {
                                case "Enum":
                                    switch (this.attribute.enumDataType) {
                                        case "Double":
                                            this.doubleValue = value;
                                            break;
                                        case "Integer":
                                            this.integerValue = value;
                                            break;
                                        case "String":
                                            this.textValue = value;
                                            break;
                                        default:
                                            this.textValue = value;
                                            break;
                                    }
                                    break;
                                case "Double":
                                case "Expression":
                                case "Business rule":
                                    this.doubleValue = this.isValidNumber(value)
                                        ? common.utils.unformatDecimal(value)
                                        : undefined;
                                    break;
                                case "Integer":
                                    this.integerValue = this.isValidNumber(value)
                                        ? common.utils.unformatDecimal(value)
                                        : undefined;
                                    break;
                                case "Text":
                                    this.textValue = value;
                                    break;
                                case "Boolean":
                                    this.booleanValue = value;
                                    break;
                                case "BooleanNullable":
                                    this.booleanValue = value;
                                    break;
                                case "Date":
                                    this.dateValue = value;
                                    break;
                                case "Comment":
                                    this.commentValue = value;
                                    break;
                                case "Label":
                                    switch (this.attribute.labelDataType) {
                                        case "Double":
                                            this.doubleValue = value;
                                            break;
                                        case "Integer":
                                            this.integerValue = value;
                                            break;
                                        default:
                                            this.textValue = value;
                                            break;
                                    }
                                    break;
                                default:
                                    this.textValue = value;
                                    break;
                            }
                        }
                    });
                    Object.defineProperty(templateRegistration, "textValueForEmptyEnum", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var showTextIfEmptyLength = app.constants.attributeMetadata.ShowTextIfEmpty.length;
                            if (this.textValue && this.textValue.length >= showTextIfEmptyLength)
                                return this.textValue.substring(showTextIfEmptyLength);
                            else
                                return "";
                        },
                        set: function (value) {
                            this.textValue = app.constants.attributeMetadata.ShowTextIfEmpty + value;
                        }
                    });
                    Object.defineProperty(templateRegistration, "forcedTextValueForEnum", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            if (!this.textValue)
                                return false;
                            if (this.textValue.length < app.constants.attributeMetadata.ShowTextIfEmpty.length)
                                return false;
                            if (this.textValue.indexOf(app.constants.attributeMetadata.ShowTextIfEmpty) > -1)
                                return true;
                            return false;
                            // console.log('this.textValue ', this.textValue , this.textValue 
                            //   && this.textValue.indexOf(constants.attributeMetadata.ShowTextIfEmpty) === 0);
                        }
                    });
                };
                ModelBuilder.prototype.templateItemInitializer = function (templateItem) {
                    Object.defineProperty(templateItem, "optionSelection", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return templateItem._optionSelection;
                        },
                        set: function (value) {
                            templateItem._optionSelection = value;
                        }
                    });
                    Object.defineProperty(templateItem, "attributeName", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.attribute.dictionary.name;
                        }
                    });
                    Object.defineProperty(templateItem, "required", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.attributeIsRequired != null
                                ? this.attributeIsRequired
                                    ? "Required"
                                    : ""
                                : this.attribute.required
                                    ? "Required"
                                    : "";
                        }
                    });
                    Object.defineProperty(templateItem, "dropdownDirection", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            if (this.attributeDictionary
                                && this.attributeDictionary.name === 'LabTest_Diagnosis')
                                return 'right';
                            else
                                return 'auto';
                        }
                    });
                    Object.defineProperty(templateItem, "allowTextValueForEmptyEnum", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            if (!this.attribute.attributeMetadatas || this.attribute.attributeMetadatas.length < 1)
                                return false;
                            var allowTextForEmptyEnumMembers = this.attribute.attributeMetadatas.filter(function (metadata) {
                                return metadata["value"] === "ShowTextIfEmpty";
                            });
                            var result = allowTextForEmptyEnumMembers.length > 0;
                            return result;
                        }
                    });
                };
                ModelBuilder.prototype.userBusinessObjectInitializer = function (userBusinessObject) {
                    Object.defineProperty(userBusinessObject, "businessObjectName", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this._businessObjectName;
                        },
                        set: function (value) {
                            this._businessObjectName = value;
                        }
                    });
                    Object.defineProperty(userBusinessObject, "permission", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this._permission;
                        },
                        set: function (value) {
                            this._permission = value;
                        }
                    });
                    Object.defineProperty(userBusinessObject, "customerId", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this._customerId;
                        },
                        set: function (value) {
                            this._customerId = value;
                        }
                    });
                    Object.defineProperty(userBusinessObject, "description", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this._description;
                        },
                        set: function (value) {
                            this._description = value;
                        }
                    });
                };
                ModelBuilder.prototype.siteInitializer = function (site) {
                    Object.defineProperty(site, "customer", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            if (this.area)
                                return this.area.region.operation.customerBU.customer;
                            else
                                return null;
                        }
                    });
                };
                ModelBuilder.prototype.prescriptionInitializer = function (prescription) {
                    // VET-112 comments this line : prescription.weight = null;
                    // VET-112 comments this line :prescription.biomass = null;
                    this.addIsRequired(prescription);
                    this.addValidationProperties(prescription);
                    prescription.entityType
                        .getProperty('prescriptionDate');
                    Object.defineProperty(prescription, "customer", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            if (this.site)
                                return this.site.area.region.operation.customerBU.customer;
                            else
                                return null;
                        }
                    });
                    Object.defineProperty(prescription, "isLocked", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return prescription._isLocked; },
                        set: function (value) {
                            prescription._isLocked = value;
                        }
                    });
                    Object.defineProperty(prescription, "isDraft", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return prescription.prescriptionId < 0; },
                    });
                    Object.defineProperty(prescription, "prescriptionSaveStatus", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return prescription._prescriptionSaveStatus; },
                        set: function (value) {
                            prescription._prescriptionSaveStatus = value;
                        }
                    });
                    Object.defineProperty(prescription, "syncStatus", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.entityAspect.entityState.name === "Unchanged"
                                ? app.constants.assessmentSyncStatus.SYNCED
                                : app.constants.assessmentSyncStatus.NON_SYNCED;
                        }
                    });
                    Object.defineProperty(prescription, "reportStatus", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return prescription._reportStatus; },
                        set: function (value) {
                            prescription._reportStatus = value;
                        }
                    });
                    Object.defineProperty(prescription, "amountStr", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return common.utils.formatDecimal(prescription.amount); },
                        set: function (value) {
                            prescription.amount = common.utils.unformatDecimal(value);
                        }
                    });
                    Object.defineProperty(prescription, "biomassStr", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return common.utils.formatDecimal(prescription.biomass); },
                        set: function (value) {
                            prescription.biomass = common.utils.unformatDecimal(value);
                        }
                    });
                    Object.defineProperty(prescription, "weightStr", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return common.utils.formatDecimal(prescription.weight); },
                        set: function (value) {
                            prescription.weight = common.utils.unformatDecimal(value);
                        }
                    });
                    Object.defineProperty(prescription, "reportProgress", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return prescription._reportProgress;
                        },
                        set: function (value) {
                            prescription._reportProgress = value;
                        }
                    });
                };
                ModelBuilder.prototype.treatmentProductInitializer = function (treatmentProduct) {
                    this.addIsRequired(treatmentProduct);
                    this.addValidationProperties(treatmentProduct);
                    Object.defineProperty(treatmentProduct, "producerName", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.producer == null ? "" : this.producer.name;
                        }
                    });
                    Object.defineProperty(treatmentProduct, "isLocked", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.isFromFarmer;
                        }
                    });
                    Object.defineProperty(treatmentProduct, "companyBUName", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.companyBU.name;
                        }
                    });
                    Object.defineProperty(treatmentProduct, "activeSubstanceName", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.activeSubstance == null ? "" : this.activeSubstance.name;
                        }
                    });
                    Object.defineProperty(treatmentProduct, "quarantineTypeName", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.quarantineType == null ? "" : this.quarantineType.name;
                        }
                    });
                    Object.defineProperty(treatmentProduct, "inclusionMeasureUnitName", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.inclusionMeasureUnit == null
                                ? ""
                                : this.inclusionMeasureUnit.name;
                        }
                    });
                    Object.defineProperty(treatmentProduct, "inclusionWithMeasure", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            if (this.inclusionMeasureUnit == null)
                                return this.inclusionStr;
                            return (this.inclusionStr || "-") + " " + this.inclusionMeasureUnit.name;
                        }
                    });
                    Object.defineProperty(treatmentProduct, "quarantine", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            if (this.quarantineType && this.quarantineType.quarantineTypeId == 1)
                                return this.quarantineType.name;
                            return this.quarantineValue + " " + this.quarantineType.name;
                        }
                    });
                    Object.defineProperty(treatmentProduct, "inclusionStr", {
                        enumerable: true,
                        configurable: true,
                        get: function () { return common.utils.formatDecimal(treatmentProduct.inclusion); },
                        set: function (value) {
                            treatmentProduct.inclusion = common.utils.unformatDecimal(value);
                        }
                    });
                    Object.defineProperty(treatmentProduct, "concentration", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            var roundInclusion = app.common.utils.precise_round(this.inclusion, 2);
                            var notAllowUnit = ["none", "unknown"];
                            var inclusionMeasureUnitName = "";
                            if (!app.common.utils.isNullOrUndefined(this.inclusionMeasureUnit)
                                && !app.common.utils.isNullOrUndefinedOrEmpty(this.inclusionMeasureUnit.name)
                                && notAllowUnit.indexOf(this.inclusionMeasureUnit.name.toLowerCase()) === -1)
                                inclusionMeasureUnitName = this.inclusionMeasureUnit.name;
                            var amountMeasureUnitNameStandardName = "";
                            if (!app.common.utils.isNullOrUndefined(this.amountMeasureUnit)
                                && !app.common.utils.isNullOrUndefinedOrEmpty(this.amountMeasureUnit.name)
                                && notAllowUnit.indexOf(this.amountMeasureUnit.name.toLowerCase()) === -1)
                                amountMeasureUnitNameStandardName = this.amountMeasureUnit.name;
                            var concentrationMeasureUnitName = "";
                            if (this.inclusion > 0 && !app.common.utils.isNullOrUndefinedOrEmpty(inclusionMeasureUnitName)
                                && !app.common.utils.isNullOrUndefinedOrEmpty(amountMeasureUnitNameStandardName))
                                concentrationMeasureUnitName = amountMeasureUnitNameStandardName + "/" + inclusionMeasureUnitName;
                            var result = this.inclusion > 0 ? app.common.utils.appendNumberAndUnit(roundInclusion, concentrationMeasureUnitName) : "";
                            return result;
                        }
                    });
                };
                ModelBuilder.prototype.supplierInitializer = function (supplier) {
                    this.addIsRequired(supplier);
                    this.addValidationProperties(supplier);
                    supplier.entityType
                        .getProperty("email")
                        .validators.push(breeze.Validator.emailAddress());
                    Object.defineProperty(supplier, "supplierTypeName", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.supplierType == null ? "" : this.supplierType.name;
                        }
                    });
                    Object.defineProperty(supplier, "companyBUName", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this.companyBU ? this.companyBU.name : '';
                        }
                    });
                };
                ModelBuilder.prototype.activeSubstanceInitializer = function (supplier) {
                    this.addIsRequired(supplier);
                    this.addValidationProperties(supplier);
                };
                ModelBuilder.prototype.treatmentProductProducerInitializer = function (treatmentProductProducer) {
                    this.addIsRequired(treatmentProductProducer);
                    this.addValidationProperties(treatmentProductProducer);
                    treatmentProductProducer.entityType
                        .getProperty("email")
                        .validators.push(breeze.Validator.emailAddress());
                    treatmentProductProducer.entityType
                        .getProperty("homePage")
                        .validators.push(breeze.Validator.url());
                };
                ModelBuilder.prototype.treatmentProductIndicationInitializer = function (treatmentProductIndication) {
                    Object.defineProperty(treatmentProductIndication, "selected", {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return this._selected;
                        },
                        set: function (value) {
                            this._selected = value;
                        }
                    });
                };
                ModelBuilder.prototype.regionalAuthorityInitializer = function (regionalAuthority) {
                    this.addIsRequired(regionalAuthority);
                    this.addValidationProperties(regionalAuthority);
                };
                ModelBuilder.prototype.addValidationProperties = function (entity) {
                    entity.isValid = function (propertyName) {
                        return entity.entityAspect.validateProperty(propertyName);
                    };
                    entity.getValidationErrors = function () {
                        return entity.entityAspect.getValidationErrors();
                    };
                    entity.getErrorMessage = function (propertyName) {
                        if (!entity.entityAspect.validateProperty(propertyName)) {
                            var validationErrors = entity.entityAspect.getValidationErrors();
                            var message = _.find(validationErrors, function (filter) { return filter.propertyName === propertyName; });
                            if (message != null) {
                                return message.errorMessage;
                            }
                        }
                        return null;
                    };
                    entity.errorMessageGet = function (propertyName) {
                        return entity.getErrorMessage(propertyName);
                    };
                };
                ModelBuilder.prototype.addIsValidNumber = function (entity) {
                    entity.isValidNumber = function (value) {
                        var valueStr = !app.common.utils.isNullOrUndefined(value)
                            ? value.toString()
                            : value;
                        if (!app.common.utils.isNullOrUndefinedOrEmpty(valueStr) &&
                            valueStr.indexOf(".") == valueStr.length - 1) {
                            entity["error"] = {
                                haserror: true,
                                errorType: app.constants.errorType.Number,
                                value: valueStr,
                                message: app.constants.errorMessages.inValidNumber
                            };
                            return false;
                        }
                        else if (app.common.utils.isNullOrUndefinedOrEmpty(valueStr) ||
                            !isNaN(valueStr) ||
                            (!isNaN(valueStr.replace(app.common.utils.decimalSeparator, "")) &&
                                valueStr.indexOf(app.common.utils.decimalSeparator) !=
                                    valueStr.length - 1)) {
                            entity["error"] = {
                                haserror: false,
                                errorType: app.constants.errorType.None,
                                value: undefined,
                                message: ""
                            };
                            return true;
                        }
                        else {
                            entity["error"] = {
                                haserror: true,
                                errorType: app.constants.errorType.Number,
                                value: valueStr,
                                message: app.constants.errorMessages.inValidNumber
                            };
                            return false;
                        }
                    };
                };
                ModelBuilder.prototype.getAddress = function (assessment, addressTypeId) {
                    var siteAddresses = assessment.site.siteAddresses;
                    var siteAddress = _.find(siteAddresses, function (siteAddress) { return siteAddress.addressTypeId === addressTypeId; });
                    if (siteAddress != null) {
                        var address = siteAddress.address.addressLine1 || "";
                        if (siteAddress.address.addressLine2 != null) {
                            address += ", " + siteAddress.address.addressLine2;
                        }
                        return (address +
                            " " +
                            siteAddress.address.zipPostal +
                            " " +
                            siteAddress.address.city);
                    }
                    return null;
                };
                ModelBuilder.prototype.addIsRequired = function (entity) {
                    entity.isRequired = function (propertyName) {
                        //var entity = treatmentProduct;
                        var entityAspect = entity.entityAspect;
                        if (entityAspect != null) {
                            var properties = (entityAspect.entityManager.metadataStore.getEntityType(entityAspect.entity.entityType.shortName)).getProperties();
                            var property = _.find(properties, function (prop) { return prop.name === propertyName; });
                            if (property != null) {
                                if (property.name == "quarantineValue") {
                                    return (entity.quarantineType != null || entity.quarantineTypeId > 1);
                                }
                                return !property.isNullable;
                            }
                        }
                        return false;
                    };
                };
                return ModelBuilder;
            })();
            model.ModelBuilder = ModelBuilder;
        })(model = common.model || (common.model = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

var app;
(function (app) {
    var common;
    (function (common) {
        var model;
        (function (model) {
            var ApplicationStatus = (function () {
                function ApplicationStatus() {
                    this.applicationVersion = "0";
                    this.treeViewTimeStamp = "0";
                }
                return ApplicationStatus;
            })();
            model.ApplicationStatus = ApplicationStatus;
        })(model = common.model || (common.model = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

var app;
(function (app) {
    var model;
    (function (model) {
        var scopeModel;
        (function (scopeModel) {
            var ApplicationErrorReport = (function () {
                function ApplicationErrorReport(userName, technicalErrorMessage, userErrorMessage, numberOfOccurences, lastOccurence, appVersion) {
                    this.userName = userName;
                    this.technicalErrorMessage = technicalErrorMessage;
                    this.userErrorMessage = userErrorMessage;
                    this.numberOfOccurences = numberOfOccurences;
                    this.lastOccurence = lastOccurence;
                    this.appVersion = appVersion;
                }
                return ApplicationErrorReport;
            })();
            scopeModel.ApplicationErrorReport = ApplicationErrorReport;
        })(scopeModel = model.scopeModel || (model.scopeModel = {}));
    })(model = app.model || (app.model = {}));
})(app || (app = {}));

var app;
(function (app) {
    var model;
    (function (model) {
        var scopeModel;
        (function (scopeModel) {
            var ApplicationErrorReportCollection = (function () {
                function ApplicationErrorReportCollection() {
                    this.errorReports = new Array();
                }
                return ApplicationErrorReportCollection;
            })();
            scopeModel.ApplicationErrorReportCollection = ApplicationErrorReportCollection;
        })(scopeModel = model.scopeModel || (model.scopeModel = {}));
    })(model = app.model || (app.model = {}));
})(app || (app = {}));

var app;
(function (app) {
    var model;
    (function (model) {
        var scopeModel;
        (function (scopeModel) {
            var OptionItem = (function () {
                function OptionItem(text, value, defaultSelected, selected) {
                    this.text = text;
                    this.value = value;
                    this.defaultSelected = defaultSelected;
                    this.selected = selected;
                }
                return OptionItem;
            })();
            scopeModel.OptionItem = OptionItem;
            var OptionSelection = (function () {
                function OptionSelection() {
                }
                OptionSelection.prototype.setSelectionOption = function (value, compareString) {
                    if (compareString === void 0) { compareString = false; }
                    var hasId;
                    if (!compareString)
                        hasId = _.some(this.collection, { value: value });
                    else {
                        hasId = _.some(this.collection, { value: app.common.utils.isNullOrUndefined(value) ? value : value.toString() });
                    }
                    if (hasId)
                        this.selectedOption = compareString ? value.toString() : value;
                    else {
                        this.selectedOption = undefined;
                    }
                };
                return OptionSelection;
            })();
            scopeModel.OptionSelection = OptionSelection;
        })(scopeModel = model.scopeModel || (model.scopeModel = {}));
    })(model = app.model || (app.model = {}));
})(app || (app = {}));

var app;
(function (app) {
    var model;
    (function (model) {
        var scopeModel;
        (function (scopeModel) {
            var BusinessRuleExpression = (function () {
                // Constructor
                function BusinessRuleExpression(resultTemplateId, resultAttributeId, multiRows, expression) {
                    this.resultTemplateId = resultTemplateId;
                    this.resultAttributeId = resultAttributeId;
                    this.multiRows = multiRows;
                    this.expression = expression;
                    this.resultTemplateId = resultTemplateId;
                    this.resultAttributeId = resultAttributeId;
                    this.multiRows = multiRows;
                    this.expression = expression;
                }
                return BusinessRuleExpression;
            })();
            scopeModel.BusinessRuleExpression = BusinessRuleExpression;
        })(scopeModel = model.scopeModel || (model.scopeModel = {}));
    })(model = app.model || (app.model = {}));
})(app || (app = {}));

var app;
(function (app) {
    var common;
    (function (common) {
        var model;
        (function (model) {
            var UserSettings = (function () {
                function UserSettings() {
                }
                return UserSettings;
            })();
            model.UserSettings = UserSettings;
        })(model = common.model || (common.model = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

var app;
(function (app) {
    var common;
    (function (common) {
        var model;
        (function (model) {
            var AssessmentWizardData = (function () {
                function AssessmentWizardData(assessmentTypeId, assessmentOperation, siteId, customerId, assessmentId, readonly, jumbToStep, jumpToRow, elancoRepId, fishgroupId) {
                    if (siteId === void 0) { siteId = 0; }
                    if (customerId === void 0) { customerId = 0; }
                    if (assessmentId === void 0) { assessmentId = -1; }
                    if (readonly === void 0) { readonly = false; }
                    if (jumbToStep === void 0) { jumbToStep = 0; }
                    if (jumpToRow === void 0) { jumpToRow = 0; }
                    if (elancoRepId === void 0) { elancoRepId = 0; }
                    if (fishgroupId === void 0) { fishgroupId = null; }
                    this.assessmentTypeId = assessmentTypeId;
                    this.assessmentOperation = assessmentOperation;
                    this.siteId = siteId;
                    this.customerId = customerId;
                    this.assessmentId = assessmentId;
                    this.readonly = readonly;
                    this.jumbToStep = jumbToStep;
                    this.jumpToRow = jumpToRow;
                    this.elancoRepId = elancoRepId;
                    this.fishgroupId = fishgroupId;
                }
                return AssessmentWizardData;
            })();
            model.AssessmentWizardData = AssessmentWizardData;
        })(model = common.model || (common.model = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

/// <reference path="../../_typings.ts" />
/// <reference path="../app.ts" />
var app;
(function (app) {
    var common;
    (function (common) {
        var services;
        (function (services) {
            var NotificationService = (function () {
                function NotificationService($q) {
                    this.$q = $q;
                }
                NotificationService.prototype.getNotifications = function () {
                    var promise = this.$q.defer();
                    // TODO: Replace mocked call with datacontext call
                    promise.resolve(this.getMockedNotifications());
                    return promise.promise;
                };
                NotificationService.prototype.getMockedNotifications = function () {
                    var notifications = new Array();
                    if (Math.floor(Math.random() * 2) + 10 % 2) {
                    }
                    else {
                        notifications.push(new common.model.Notification("Assessment created"));
                        notifications.push(new common.model.Notification("Email sent"));
                        notifications.push(new common.model.Notification("User created"));
                    }
                    return notifications;
                };
                NotificationService.$inject = ['$q'];
                return NotificationService;
            })();
            services.NotificationService = NotificationService;
        })(services = common.services || (common.services = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerService("NotificationService", ['$q']);

/// <reference path="../../_typings.ts" />
/// <reference path="../app.ts" />
var app;
(function (app) {
    var common;
    (function (common) {
        var services;
        (function (services) {
            var NavigationService = (function () {
                function NavigationService($rootScope, $q, $filter, $http, $state, appLocalStorage, apiEndpointService, authenticationService, assessmentDataContext, $translate) {
                    var _this = this;
                    this.$rootScope = $rootScope;
                    this.$q = $q;
                    this.$filter = $filter;
                    this.$http = $http;
                    this.$state = $state;
                    this.appLocalStorage = appLocalStorage;
                    this.apiEndpointService = apiEndpointService;
                    this.authenticationService = authenticationService;
                    this.assessmentDataContext = assessmentDataContext;
                    this.$translate = $translate;
                    this.defaultCustomerId = null;
                    this.selectedAssessmentTypeGroup = null;
                    this.objectKey = null;
                    this.isMapViewSelected = false;
                    this.mapViewType = app.constants.mapViewType.assessments;
                    this.isSiteActive = true;
                    this.nodeList = [];
                    $rootScope.$on(app.constants.broadcastEventNames.routingEvent, function (event, data) {
                        _this.currentState = data;
                    });
                    $rootScope.$on(app.constants.broadcastEventNames.assessmentViewType, function (event, data) {
                        _this.isMapViewSelected = data;
                    });
                    $rootScope.$on(app.constants.broadcastEventNames.switchMapView, function (event, data) {
                        _this.mapViewType = data;
                    });
                    this.currentState = this.authenticationService.isCustomerUser() ? app.constants.assessmentListViews.customerPortalStatus : app.constants.assessmentListViews.status;
                }
                NavigationService.prototype.initializeMenuItems = function () {
                    var _this = this;
                    return this.getNavigationOptions().then(function (result) {
                        var levelId = _this.getLevelId(_this.objectKey);
                        result = _.filter(result, function (item) {
                            return ((item.AccessRightBitMask & _this.accessRightMask) > 0) && levelId === item.LevelId;
                        });
                        if (_this.isOnSiteLevel()) {
                            var siteTypeId = _this.assessmentDataContext.getSite(_this.getObjectId(_this.objectKey)).siteTypeId;
                            _this.assessmentRegistrationMenuItems = new Array();
                            var assessmentTypes = _this.assessmentDataContext.getAssessmentTypes();
                            _.forEach(result, function (navOption) {
                                if (navOption.Name == 'Assessment') {
                                    _.forEach(navOption.UserNavigationSubOptions, function (navSub) {
                                        var moduleId = "MenuCategoryGeneral";
                                        var assessmentType = _.find(assessmentTypes, (function (atype) {
                                            return atype.dictionary.name == navSub.Dictionary.Name;
                                        }));
                                        if (assessmentType && assessmentType.dictionary.name == 'AssessmentType_VaccineOrder') {
                                            moduleId = "AssessmentTypeGroup_PrescriptionVaccineOrder";
                                        }
                                        var navSubOption = new common.model.NavigationOption(assessmentType.dictionary.name, assessmentType.dictionary.name, assessmentType.active, assessmentType.sortOrder, app.constants.menuNames.registration, moduleId, navSub.SecurityLevelBitMask, false, new common.model.AssessmentWizardData(assessmentType.assessmentTypeId, app.constants.operation.NEW, 0, -1));
                                        navSubOption.siteTypeBitMask = assessmentType.siteTypeBitMask;
                                        _this.assessmentRegistrationMenuItems.push(navSubOption);
                                    });
                                }
                            });
                            var bitVal = Math.pow(2, siteTypeId);
                            _this.allMenuItems = (new Array()).concat(_.filter(_this.assessmentRegistrationMenuItems, function (navOption) {
                                return ((navOption.siteTypeBitMask & bitVal) > 0);
                            }));
                        }
                        else {
                            _this.allMenuItems = new Array();
                        }
                        _this.allMenuItems = _.filter(_this.allMenuItems, function (item) {
                            return ((item.objectLevelBitmask & _this.accessRightMask) > 0);
                        });
                        // Setup menu options ( no access check )
                        _this.allMenuItems.push(new common.model.NavigationOption("Edit", "edit", true, 1, app.constants.menuNames.gridRow, 'SetupOptions', 0, false, {}));
                        _this.allMenuItems.push(new common.model.NavigationOption("ShowDetails", "details", true, 1, app.constants.menuNames.gridRow, 'SetupOptions', 0, false, {}));
                        _this.allMenuItems.push(new common.model.NavigationOption("Delete", "delete", true, 1, app.constants.menuNames.gridRow, 'SetupOptions', 0, false, {}, true, app.localizer.resource.ConfirmDelete, app.localizer.resource.ConfirmDeleteMessage));
                        _this.allMenuItems.push(new common.model.NavigationOption("Assessments", "Assessments", true, 1, app.constants.menuNames.mapType, 'Assessments', 0, _this.mapViewType === app.constants.mapViewType.assessments, {}));
                        _this.allMenuItems.push(new common.model.NavigationOption("Events", "Events", true, 2, app.constants.menuNames.mapType, 'Events', 0, _this.mapViewType === app.constants.mapViewType.events, {}));
                        _.forEach(result, function (item) {
                            switch (item.SettingsArea) {
                                case app.constants.menuNames.tab:
                                    _this.allMenuItems.push(new common.model.NavigationOption(item.Name, item.Name.toLowerCase(), item.Visible, item.Rank, item.SettingsArea, item.ModuleId, item.AccessRightBitMask, item.Name.toLowerCase() === _this.currentState.toLowerCase(), {}));
                                    break;
                                case app.constants.menuNames.event:
                                    switch (item.Name) {
                                        case "Delete":
                                            _this.allMenuItems.push(new common.model.NavigationOption(item.Name, item.Name.toLowerCase(), item.Visible, item.Rank, item.SettingsArea, item.ModuleId, item.AccessRightBitMask, false, {}, true, app.localizer.resource.ConfirmDelete, app.localizer.resource.DeleteEventMessage));
                                            break;
                                        default:
                                            _this.allMenuItems.push(new common.model.NavigationOption(item.Name, item.Name.toLowerCase(), item.Visible, item.Rank, item.SettingsArea, "Event", item.AccessRightBitMask, false, {}));
                                    }
                                    break;
                                case app.constants.menuNames.assessment:
                                    switch (item.Name) {
                                        case "Delete":
                                            _this.allMenuItems.push(new common.model.NavigationOption(item.Name, item.Name.toLowerCase(), item.Visible, item.Rank, item.SettingsArea, item.ModuleId, item.AccessRightBitMask, false, {}, true, app.localizer.resource.ConfirmDelete, app.localizer.resource.ConfirmDeleteAssessment));
                                            break;
                                        default:
                                            _this.allMenuItems.push(new common.model.NavigationOption(item.Name, item.Name.toLowerCase(), item.Visible, item.Rank, item.SettingsArea, "Assessment", item.AccessRightBitMask, false, {}));
                                    }
                                    break;
                                case app.constants.menuNames.gridRow:
                                    switch (item.Name) {
                                        case "Delete":
                                            _this.allMenuItems.push(new common.model.NavigationOption(item.Name, item.Name.toLowerCase(), item.Visible, item.Rank, item.SettingsArea, item.ModuleId, item.AccessRightBitMask, false, {}, true, app.localizer.resource.ConfirmDelete, app.localizer.resource.ConfirmDeleteMessage));
                                            break;
                                        default:
                                            _this.allMenuItems.push(new common.model.NavigationOption(item.Name, item.Name.toLowerCase(), item.Visible, item.Rank, item.SettingsArea, item.ModuleId, item.AccessRightBitMask, false, {}));
                                    }
                                    break;
                                default:
                                    _this.allMenuItems.push(new common.model.NavigationOption(item.Name, item.Name.toLowerCase(), item.Visible, item.Rank, item.SettingsArea, item.ModuleId, item.AccessRightBitMask, false, {}));
                            }
                        });
                        if (_.isUndefined(_.find(_this.allMenuItems, { menuName: app.constants.menuNames.tab, isSelected: true }))) {
                            var menuItem = _.find(_this.allMenuItems, { menuName: app.constants.menuNames.tab, value: "status" });
                            if (menuItem)
                                menuItem.isSelected = true;
                            if (_this.authenticationService.isCustomerUser()) {
                                _this.currentState = app.constants.assessmentListViews.customerPortalStatus;
                                _this.$state.go('shell.assessments', { type: 'status', view: app.constants.assessmentListViews.customerPortalStatus });
                            }
                            else {
                                _this.currentState = app.constants.assessmentListViews.status;
                                _this.$state.go('shell.assessments', { type: 'status', view: app.constants.assessmentListViews.status });
                            }
                        }
                        _this.disableMenuItems(app.constants.menuNames.registration, _this.isSiteActive);
                        _this.$rootScope.$broadcast(app.constants.broadcastEventNames.refreshMenus);
                    });
                };
                NavigationService.prototype.getMenuItems = function (menuName) {
                    var moduleId = '';
                    var orginalMenuName = menuName;
                    if (menuName == "Prescription" || menuName == "TreatmentProduct" || menuName == "SetupOptions") {
                        moduleId = menuName;
                        menuName = "GridRow";
                    }
                    var promise = this.$q.defer();
                    var items = this.allMenuItems;
                    var menuItems = this.$filter('orderBy')(items, "[moduleId,sortOrder]");
                    menuItems = this.$filter('filter')(menuItems, { menuName: menuName });
                    if (moduleId != '') {
                        menuItems = this.$filter('filter')(menuItems, { moduleId: moduleId });
                    }
                    if (menuName === 'Reg') {
                        _.remove(menuItems, function (item) {
                            return item.description == 'Assessment';
                        });
                    }
                    if (menuName === 'ImpExp') {
                        if (this.currentState === 'assessments list') {
                            var exportExcelNavOption = new common.model.NavigationOption("ExportToExcel", "export assessments as Excel", true, 0, "ImpExp", "", null, false, null);
                            menuItems.push(exportExcelNavOption);
                        }
                        if (this.currentState === 'prescriptions') {
                            var exportExcelNavOption = new common.model.NavigationOption("ExportToExcel", "export prescriptions as Excel", true, 0, "ImpExp", "", null, false, null);
                            menuItems.push(exportExcelNavOption);
                        }
                    }
                    if (menuName === 'Assessment' && this.authenticationService.isCustomerUser() === false && items.some(function (i) { return i.menuName == 'Edit'; })) {
                        var assessmentFollowUpNavOption = new common.model.NavigationOption("EditFollowUp", "followup", true, 0, "Assessment", "", null, false, null);
                        menuItems.push(assessmentFollowUpNavOption);
                    }
                    if (menuName === 'User' && this.authenticationService.isCustomerUser() === false) {
                        var userManualReportErrorOption = new common.model.NavigationOption("Report an error", "userManualReportError", true, 0, "User", "", null, false, null);
                        menuItems.push(userManualReportErrorOption);
                    }
                    if (orginalMenuName === 'Prescription') {
                        var prescriptionActiveNavOption = new common.model.NavigationOption("Activate", "activate", true, 0, app.constants.menuNames.gridRow, app.constants.gridRowMenus.prescription, null, false, null);
                        var prescriptionDeactiveNavOption = new common.model.NavigationOption("Deactivate", "deactivate", true, 0, app.constants.menuNames.gridRow, app.constants.gridRowMenus.prescription, null, false, null);
                        menuItems.push(prescriptionActiveNavOption);
                        menuItems.push(prescriptionDeactiveNavOption);
                    }
                    if (menuName === 'DraftPrescription') {
                        var editDraftPrescriptionNavOption = new common.model.NavigationOption("Edit", "edit", true, 0, "GridRow", "DraftPrescription", null, false, null);
                        menuItems.push(editDraftPrescriptionNavOption);
                        var deleteDraftPrescriptionNavOption = new common.model.NavigationOption("Delete", "delete", true, 0, "GridRow", "DraftPrescription", null, false, null, true, app.localizer.resource.Alert_Delete_ConfirmTitle, app.localizer.resource.Alert_Delete_ConfirmMessage.format(app.localizer.resource.Prescription));
                        menuItems.push(deleteDraftPrescriptionNavOption);
                    }
                    promise.resolve(menuItems);
                    return promise.promise;
                };
                NavigationService.prototype.getUserCustomerId = function () {
                    var _this = this;
                    var promise = this.$q.defer();
                    this.$http.get(this.apiEndpointService.getApplicationEndpoint() + 'UserCustomerIdGet', { params: { userId: this.authenticationService.credentialsCurrentUserGet().UserId } }).success(function (data, status, headers) {
                        _this.selectedCustomerId = data;
                        promise.resolve(data);
                    }).error(function (err) {
                        promise.reject(err);
                    });
                    return promise.promise;
                };
                NavigationService.prototype.getDefaultBusinessObject = function () {
                    var _this = this;
                    var promise = this.$q.defer();
                    this.$http.get(this.apiEndpointService.getApplicationEndpoint() + 'UserDefaultBusinessObjectGet', { params: { userId: this.authenticationService.credentialsCurrentUserGet().UserId, deviceType: app.constants.deviceTypeWeb } }).success(function (data, status, headers) {
                        _this.objectKey = data.split(',')[0];
                        _this.selectedLevelId = _this.getLevelId(_this.objectKey);
                        _this.selectedObjectId = _this.getObjectId(_this.objectKey);
                        _this.selectedCustomerId = _this.defaultCustomerId = parseInt(data.split(',')[2]);
                        _this.accessRightMask = parseInt(data.split(',')[1]);
                        promise.resolve(data);
                    }).error(function (err) {
                        promise.reject(err);
                    });
                    return promise.promise;
                };
                NavigationService.prototype.getOrganisationTreeItems = function () {
                    var _this = this;
                    var promise = this.$q.defer();
                    var treeViewData = JSON.parse(this.appLocalStorage.treeViewDataGet());
                    var treeViewTimeStamp = treeViewData ? this.appLocalStorage.applicationStatusGet().treeViewTimeStamp : "0";
                    this.$http.get(this.apiEndpointService.getApplicationEndpoint() + 'TreeViewGet', { params: { userId: this.authenticationService.credentialsCurrentUserGet().UserId, deviceType: "Web App", showInactive: false, timeStamp: treeViewTimeStamp } }).success(function (data, status, headers) {
                        if (headers("TreeViewHasChanged") === "1") {
                            var applicationStatus = _this.appLocalStorage.applicationStatusGet();
                            applicationStatus.treeViewTimeStamp = headers("TreeViewTimeStamp");
                            _this.appLocalStorage.applicationStatusSet(applicationStatus);
                            _this.appLocalStorage.treeViewDataSet(JSON.stringify(data));
                            _this.companyName = data.n;
                            treeViewData = data;
                        }
                        else {
                            _this.companyName = treeViewData.n;
                        }
                        _this.treeToArray(treeViewData);
                        promise.resolve(data);
                    }).error(function (err) {
                        promise.reject(err);
                    });
                    return promise.promise;
                };
                NavigationService.prototype.treeToArray = function (root) {
                    if (!root.ch) {
                        this.nodeList.push(root);
                        return;
                    }
                    this.nodeList.push(root);
                    for (var i = 0; i < root.ch.length; i++) {
                        this.treeToArray(root.ch[i]);
                    }
                };
                NavigationService.prototype.getSites = function () {
                    return _.map(_.filter(this.nodeList, function (node) {
                        return node.id[0] === "7";
                    }), function (node) {
                        return { siteId: parseInt(node.id.split('-')[1]), name: node.n };
                    });
                };
                NavigationService.prototype.getCustomerIds = function () {
                    return this.getIds(app.constants.operationUnitLevels.customer);
                };
                NavigationService.prototype.getCustomerId = function (node) {
                    return this.getId(node, app.constants.operationUnitLevels.customer);
                };
                NavigationService.prototype.getIds = function (level) {
                    var treeViewData = JSON.parse(this.appLocalStorage.treeViewDataGet());
                    var ids = new Array();
                    this.getIdsRecursively(treeViewData, ids, level);
                    return ids;
                };
                NavigationService.prototype.getIdsRecursively = function (node, ids, level) {
                    var that = this;
                    if (node.ch != null) {
                        _.forEach((node.ch), function (child) {
                            that.getIdsRecursively(child, ids, level);
                        });
                    }
                    var id = this.getId(node, level);
                    if (id > 0) {
                        ids.push(id);
                    }
                };
                NavigationService.prototype.getSiteIds = function () {
                    return this.getIds(app.constants.operationUnitLevels.site);
                };
                NavigationService.prototype.getSiteId = function (node) {
                    return this.getId(node, app.constants.operationUnitLevels.site);
                };
                NavigationService.prototype.goToCustomerPortalSite = function (siteId, assessmentId, aquaFarmerSiteName, assessmentDate) {
                    var sites = _.filter(this.nodeList, function (node) {
                        return node.id[0] == "7";
                    });
                    var site = _.find(sites, function (site) {
                        return site.id.split('-')[1] == siteId;
                    });
                    if (_.isUndefined(site)) {
                        this.$state.go('noaccess');
                        return false;
                    }
                    else {
                        assessmentId = parseInt(assessmentId);
                        this.objectKey = site.id;
                        this.selectedLevelId = this.getLevelId(this.objectKey);
                        this.selectedObjectId = this.getObjectId(this.objectKey);
                        this.accessRightMask = parseInt(site.arm);
                        this.currentState = assessmentId !== 0
                            ? app.constants.assessmentListViews.customerPortalAssessment
                            : app.constants.assessmentListViews.customerPortalStatus;
                        this.customerPortalAssessmentId = assessmentId;
                        this.customerPortalAssessmentDate = assessmentDate;
                        this.customerPortalTitle = aquaFarmerSiteName.split('"').join('') + " - " + site.n;
                        return true;
                    }
                };
                NavigationService.prototype.disableMenuItems = function (menuName, active) {
                    _.forEach(this.allMenuItems, function (menuItem) {
                        if (menuItem.menuName === menuName)
                            menuItem.disabled = !active;
                    });
                };
                NavigationService.prototype.getId = function (node, level) {
                    var id = node.id;
                    if (id && level == this.getLevelId(id).toString()) {
                        return this.getObjectId(id);
                    }
                    return 0;
                };
                NavigationService.prototype.checkServer = function () {
                    return this.$http.get(this.apiEndpointService.getCheckServerEndpoint());
                };
                NavigationService.prototype.getNavigationOptions = function () {
                    var _this = this;
                    var promise = this.$q.defer();
                    if (_.isEmpty(this.appLocalStorage.navigationOptionsDataGet())) {
                        this.$http.get(this.apiEndpointService.getApplicationEndpoint() + 'NavigationGet', {
                            params: {
                                languageCode: this.authenticationService.credentialsCurrentUserGet().Culture,
                                deviceType: app.constants.deviceTypeWeb
                            }
                        }).success(function (data) {
                            _this.appLocalStorage.navigationOptionsDataSet(JSON.stringify(data));
                            promise.resolve(data);
                        }).error(function (err) {
                            promise.reject(err);
                        });
                    }
                    else {
                        promise.resolve(JSON.parse(this.appLocalStorage.navigationOptionsDataGet()));
                    }
                    return promise.promise;
                };
                NavigationService.prototype.isOnSiteLevel = function () {
                    return this.selectedLevelId == +app.constants.operationUnitLevels.site;
                };
                NavigationService.prototype.isAboveCustomerLevel = function () {
                    return this.selectedLevelId < +app.constants.operationUnitLevels.customer;
                };
                NavigationService.prototype.getLevelId = function (objectKey) {
                    return +objectKey.split("-")[0];
                };
                NavigationService.prototype.getObjectId = function (objectKey) {
                    return +objectKey.split("-")[1];
                };
                NavigationService.prototype.setAccessRightMask = function (accessRightMask) {
                    this.accessRightMask = accessRightMask;
                };
                NavigationService.prototype.setObjectKey = function (newObjectKey, newCustomerKey) {
                    this.previousObjectKey = this.objectKey;
                    this.previousCustomerId = this.selectedCustomerId;
                    this.objectKey = newObjectKey;
                    this.selectedLevelId = this.getLevelId(this.objectKey);
                    this.selectedObjectId = this.getObjectId(this.objectKey);
                    if (newCustomerKey != null) {
                        this.customerKey = newCustomerKey;
                        var customerLevelId = this.getLevelId(newCustomerKey);
                        if (this.selectedLevelId < customerLevelId) {
                            throw new Error("Selected level is higher than customer level");
                        }
                        this.selectedCustomerId = this.getObjectId(newCustomerKey);
                    }
                    else {
                        this.selectedCustomerId = this.defaultCustomerId;
                    }
                    var previousLevelId, previousObjectId;
                    if (this.previousObjectKey != null) {
                        previousLevelId = this.getLevelId(this.previousObjectKey);
                        previousObjectId = this.getObjectId(this.previousObjectKey);
                    }
                    if (this.selectedLevelId != previousLevelId) {
                        this.$rootScope.$broadcast(app.constants.broadcastEventNames.navigationLevelIdChanged, this.selectedLevelId);
                        this.$rootScope.$broadcast(app.constants.broadcastEventNames.navigationObjectIdChanged, this.selectedObjectId);
                    }
                    else {
                        if (this.selectedObjectId != previousObjectId) {
                            this.$rootScope.$broadcast(app.constants.broadcastEventNames.navigationObjectIdChanged, this.selectedObjectId);
                        }
                    }
                    if (this.selectedCustomerId != this.previousCustomerId) {
                        this.$rootScope.$broadcast(app.constants.broadcastEventNames.navigationCustomerChanged, this.selectedCustomerId);
                    }
                    if (this.selectedLevelId != previousLevelId || this.selectedObjectId != previousObjectId) {
                        this.initializeMenuItems();
                    }
                };
                NavigationService.$inject = [
                    '$rootScope',
                    '$q',
                    '$filter',
                    '$http',
                    '$state',
                    'appLocalStorage',
                    'apiEndpointService',
                    'authenticationService',
                    'assessmentDatacontext',
                    '$translate'];
                return NavigationService;
            })();
            services.NavigationService = NavigationService;
        })(services = common.services || (common.services = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerService("NavigationService", app.common.services.NavigationService.$inject);

/// <reference path="../../_typings.ts"/>
var app;
(function (app) {
    var common;
    (function (common) {
        var services;
        (function (services) {
            var AppLocalStorage = (function () {
                function AppLocalStorage($window, env, apiEndpoint) {
                    this.$window = $window;
                    this.env = env;
                    this.apiEndpoint = apiEndpoint;
                    this.storageKeySuffix = '';
                    this.storageKeys = {
                        loggedInUser: 'LoggedInUser',
                        applicationStatus: 'ApplicationStatus',
                        translations: 'translations',
                        NG_TRANSLATE_LANG_KEY: 'NG_TRANSLATE_LANG_KEY',
                        userSettings: 'UserSettings',
                        lastSynced: 'lastSynced',
                        pythonScripts: 'PythonScripts',
                        treeViewData: 'TreeViewData',
                        navigationOptionsData: 'NavigationOptionsData',
                        dbVersion: 'dbVersion',
                        farmerIntegerationEnabled: 'farmerIntegerationEnabled',
                        noOfdaysFromFarmer: "noOfdaysFromFarmer",
                        sitesAccess: "sitesAccess",
                        customersAccess: "customersAccess",
                        draftPrescriptions: "draftPrescriptions"
                    };
                    if (env.client_id === app.constants.applicationType.webApp) {
                        this.storageKeySuffix = "_WEB";
                    }
                    if (env.client_id === app.constants.applicationType.webApp && env.name !== "production") {
                        this.storageKeySuffix = this.storageKeySuffix + "_" + env.name;
                    }
                    this.storageKeys.loggedInUser = this.storageKeys.loggedInUser + this.storageKeySuffix;
                    this.storageKeys.applicationStatus = this.storageKeys.applicationStatus + this.storageKeySuffix;
                    this.storageKeys.translations = this.storageKeys.translations + this.storageKeySuffix;
                    this.storageKeys.userSettings = this.storageKeys.userSettings + this.storageKeySuffix;
                    this.storageKeys.lastSynced = this.storageKeys.lastSynced + this.storageKeySuffix;
                    this.storageKeys.pythonScripts = this.storageKeys.pythonScripts + this.storageKeySuffix;
                    this.storageKeys.treeViewData = this.storageKeys.treeViewData + this.storageKeySuffix;
                    this.storageKeys.navigationOptionsData = this.storageKeys.navigationOptionsData + this.storageKeySuffix;
                    this.storageKeys.farmerIntegerationEnabled = this.storageKeys.farmerIntegerationEnabled + this.storageKeySuffix;
                    var appStatus = this.applicationStatusGet();
                    if (appStatus.useConfigApiEndpoint) {
                        appStatus.apiEndpoint = this.env.apiEndpoint;
                    }
                    if (appStatus.applicationVersion !== env.appVersion) {
                        app.common.utils.refreshCachedData = true;
                        //if (env.client_id === constants.applicationType.webApp) {
                        //    this.$window.localStorage.clear();
                        //}
                        appStatus.applicationVersion = env.appVersion;
                        this.applicationStatusSet(appStatus);
                    }
                }
                AppLocalStorage.prototype.loggedInUserGet = function () {
                    if (this.$window.localStorage.getItem(this.storageKeys.loggedInUser) != null) {
                        return this.$window.localStorage.getItem(this.storageKeys.loggedInUser);
                    }
                    else {
                        return this.$window.sessionStorage.getItem(this.storageKeys.loggedInUser);
                    }
                };
                AppLocalStorage.prototype.loggedInUserSet = function (value, rememberLoggedInUser) {
                    if (rememberLoggedInUser) {
                        this.$window.localStorage.setItem(this.storageKeys.loggedInUser, value);
                    }
                    else {
                        this.$window.sessionStorage.setItem(this.storageKeys.loggedInUser, value);
                    }
                };
                AppLocalStorage.prototype.loggedInUserUpdate = function (value) {
                    if (this.$window.localStorage.getItem(this.storageKeys.loggedInUser) != null) {
                        this.$window.localStorage.setItem(this.storageKeys.loggedInUser, value);
                    }
                    else {
                        this.$window.sessionStorage.setItem(this.storageKeys.loggedInUser, value);
                    }
                };
                AppLocalStorage.prototype.loggedInUserWithRememberMe = function () {
                    return this.$window.localStorage.getItem(this.storageKeys.loggedInUser) != null;
                };
                AppLocalStorage.prototype.loggedInUserClear = function () {
                    this.clearLocalStorage();
                    this.clearSessionStorage();
                };
                AppLocalStorage.prototype.applicationStatusGet = function () {
                    if (_.isEmpty(this.$window.localStorage.getItem(this.storageKeys.applicationStatus))) {
                        var appStatus = new common.model.ApplicationStatus();
                        appStatus.apiEndpoint = this.env.apiEndpoint;
                        appStatus.validationsEnabled = this.env.validationsEnabled;
                        appStatus.useConfigApiEndpoint = true;
                        appStatus.applicationInitialized = false;
                        appStatus.translationsCulture = "";
                        this.applicationStatusSet(appStatus);
                    }
                    return JSON.parse(this.$window.localStorage.getItem(this.storageKeys.applicationStatus));
                };
                AppLocalStorage.prototype.dbVersionGet = function () {
                    return this.$window.sessionStorage.getItem(this.storageKeys.dbVersion);
                };
                AppLocalStorage.prototype.dbVersionSet = function (value) {
                    this.$window.sessionStorage.setItem(this.storageKeys.dbVersion, value);
                };
                AppLocalStorage.prototype.applicationStatusSet = function (value) {
                    this.$window.localStorage.setItem(this.storageKeys.applicationStatus, JSON.stringify(value));
                };
                AppLocalStorage.prototype.translationsGet = function () {
                    return this.$window.localStorage.getItem("translations" + this.storageKeySuffix);
                };
                AppLocalStorage.prototype.translationsSet = function (value) {
                    this.$window.localStorage.setItem("translations" + this.storageKeySuffix, value);
                };
                AppLocalStorage.prototype.ngTranslateLangKeyGet = function () {
                    return this.$window.localStorage.getItem("NG_TRANSLATE_LANG_KEY");
                };
                AppLocalStorage.prototype.clearUserSpecificSettings = function () {
                    this.loggedInUserClear();
                    this.$window.localStorage.removeItem(this.storageKeys.userSettings);
                    this.$window.localStorage.removeItem(this.storageKeys.lastSynced);
                };
                AppLocalStorage.prototype.userSettingsGet = function () {
                    if (_.isEmpty(this.$window.localStorage.getItem(this.storageKeys.userSettings))) {
                        this.userSettingsSet(new common.model.UserSettings);
                    }
                    return JSON.parse(this.$window.localStorage.getItem(this.storageKeys.userSettings));
                };
                AppLocalStorage.prototype.userSettingsSet = function (value) {
                    this.$window.localStorage.setItem(this.storageKeys.userSettings, value == null ? '' : JSON.stringify(value));
                };
                AppLocalStorage.prototype.pythonScriptsGet = function () {
                    return this.$window.localStorage.getItem(this.storageKeys.pythonScripts);
                };
                AppLocalStorage.prototype.pythonScriptsSet = function (value) {
                    this.$window.localStorage.setItem(this.storageKeys.pythonScripts, value);
                };
                AppLocalStorage.prototype.treeViewDataGet = function () {
                    return this.$window.sessionStorage.getItem(this.storageKeys.treeViewData);
                };
                AppLocalStorage.prototype.treeViewDataSet = function (value) {
                    this.$window.sessionStorage.setItem(this.storageKeys.treeViewData, value);
                };
                AppLocalStorage.prototype.navigationOptionsDataGet = function () {
                    return this.$window.sessionStorage.getItem(this.storageKeys.navigationOptionsData);
                };
                AppLocalStorage.prototype.navigationOptionsDataSet = function (value) {
                    this.$window.sessionStorage.setItem(this.storageKeys.navigationOptionsData, value);
                };
                AppLocalStorage.prototype.farmerIntegerationEnabledGet = function () {
                    return this.$window.localStorage.getItem(this.storageKeys.farmerIntegerationEnabled) === 'true';
                };
                AppLocalStorage.prototype.farmerIntegerationEnabledSet = function (value) {
                    this.$window.localStorage.setItem(this.storageKeys.farmerIntegerationEnabled, value.toString());
                };
                AppLocalStorage.prototype.noOfdaysFromFarmerGet = function () {
                    return this.$window.localStorage.getItem(this.storageKeys.noOfdaysFromFarmer);
                };
                AppLocalStorage.prototype.noOfdaysFromFarmerSet = function (value) {
                    this.$window.localStorage.setItem(this.storageKeys.noOfdaysFromFarmer, value.toString());
                };
                AppLocalStorage.prototype.sitesAccessGet = function () {
                    return this.$window.localStorage.getItem(this.storageKeys.sitesAccess);
                };
                AppLocalStorage.prototype.sitesAccessSet = function (value) {
                    this.$window.localStorage.setItem(this.storageKeys.sitesAccess, value);
                };
                AppLocalStorage.prototype.customersAccessGet = function () {
                    return this.$window.localStorage.getItem(this.storageKeys.customersAccess);
                };
                AppLocalStorage.prototype.customersAccessSet = function (value) {
                    this.$window.localStorage.setItem(this.storageKeys.customersAccess, value);
                };
                AppLocalStorage.prototype.clearLocalStorage = function () {
                    this.$window.localStorage.clear();
                };
                AppLocalStorage.prototype.clearSessionStorage = function () {
                    this.$window.sessionStorage.clear();
                };
                AppLocalStorage.prototype.draftPrescriptionsGet = function () {
                    return this.$window.localStorage.getItem(this.storageKeys.draftPrescriptions);
                };
                AppLocalStorage.prototype.draftPrescriptionsSet = function (value) {
                    try {
                        this.$window.localStorage.setItem(this.storageKeys.draftPrescriptions, value);
                    }
                    catch (err) {
                        console.log('storage is full!', JSON.stringify(err));
                    }
                };
                AppLocalStorage.prototype.draftPrescriptionSetOneItem = function (object) {
                    var temp = this.$window.localStorage.getItem(this.storageKeys.draftPrescriptions);
                    var draftPrescriptLocalStorage = temp === null ? [] : JSON.parse(temp);
                    var index = draftPrescriptLocalStorage.indexOf(draftPrescriptLocalStorage.filter(function (pre) {
                        return pre.createdTime === object.createdTime;
                    })[0]);
                    if (index > -1) {
                        draftPrescriptLocalStorage[index] = object;
                    }
                    else {
                        draftPrescriptLocalStorage.push(object);
                    }
                    this.$window.localStorage.setItem(this.storageKeys.draftPrescriptions, JSON.stringify(draftPrescriptLocalStorage));
                };
                AppLocalStorage.prototype.draftPrescriptionsDeleteItem = function (createdTimeString) {
                    var temp = this.$window.localStorage.getItem(this.storageKeys.draftPrescriptions);
                    if (!app.common.utils.isNullOrUndefinedOrEmpty(temp)) {
                        var list_draftPrescriptions = JSON.parse(temp);
                        var filtered_Prescription = list_draftPrescriptions;
                        if (list_draftPrescriptions.length > 0) {
                            filtered_Prescription = list_draftPrescriptions.filter(function (pre) {
                                return pre.createdTime !== createdTimeString;
                            });
                        }
                        this.$window.localStorage.setItem(this.storageKeys.draftPrescriptions, JSON.stringify(filtered_Prescription));
                    }
                };
                AppLocalStorage.prototype.draftPrescriptionsDeleteItemByPrescription = function (prescription) {
                    var draftPrescriptionBeDeleted = this.draftPrescriptionsGetByPrescription(prescription);
                    if (!app.common.utils.isNullOrUndefined(draftPrescriptionBeDeleted)) {
                        this.draftPrescriptionsDeleteItem(draftPrescriptionBeDeleted["createdTime"]);
                    }
                };
                AppLocalStorage.prototype.draftPrescriptionsGetByCreatedTime = function (createdTimeString) {
                    var temp = this.$window.localStorage.getItem(this.storageKeys.draftPrescriptions);
                    if (!app.common.utils.isNullOrUndefinedOrEmpty(temp)) {
                        var list_draftPrescriptions = JSON.parse(temp);
                        var filtered_Prescription = list_draftPrescriptions;
                        if (list_draftPrescriptions.length > 0) {
                            filtered_Prescription = list_draftPrescriptions.filter(function (pre) {
                                return pre.createdTime === createdTimeString;
                            });
                        }
                        if (app.common.utils.isNullOrUndefined(filtered_Prescription) || filtered_Prescription.length < 1)
                            return null;
                        else
                            return filtered_Prescription[0];
                    }
                    else
                        return null;
                };
                AppLocalStorage.prototype.draftPrescriptionsGetByPrescription = function (prescription) {
                    var temp = this.$window.localStorage.getItem(this.storageKeys.draftPrescriptions);
                    if (!app.common.utils.isNullOrUndefinedOrEmpty(temp)) {
                        var list_draftPrescriptions = JSON.parse(temp);
                        var filtered_Prescription = list_draftPrescriptions;
                        if (list_draftPrescriptions.length > 0) {
                            filtered_Prescription = list_draftPrescriptions.filter(function (pre) {
                                return pre.prescriptionId === prescription["prescriptionId"]
                                    && pre.prescriptionNumber === prescription["prescriptionNumber"]
                                    && pre.customerId === prescription["customerId"]
                                    && pre.siteId === prescription["siteId"];
                            });
                        }
                        if (app.common.utils.isNullOrUndefined(filtered_Prescription) || filtered_Prescription.length < 1)
                            return null;
                        else
                            return filtered_Prescription[0];
                    }
                    else
                        return null;
                };
                AppLocalStorage.$inject = ['$window', 'ENV'];
                return AppLocalStorage;
            })();
            services.AppLocalStorage = AppLocalStorage;
        })(services = common.services || (common.services = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
//app.common.registerService('AppLocalStorage', ['$window', 'ENV']); 

/// <reference path="../../_typings.ts" />
/// <reference path="../app.ts" />
var app;
(function (app) {
    var common;
    (function (common) {
        var services;
        (function (services) {
            var FilterService = (function () {
                function FilterService() {
                }
                return FilterService;
            })();
            services.FilterService = FilterService;
        })(services = common.services || (common.services = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerService("FilterService", []);

/// <reference path="../../_typings.ts" />
/// <reference path="../app.ts" />
var app;
(function (app) {
    var common;
    (function (common) {
        var services;
        (function (services) {
            var ApiEndpointService = (function () {
                function ApiEndpointService() {
                }
                ApiEndpointService.prototype.setBaseEndpoint = function (baseEndpoint, deviceTypeId) {
                    this.baseEndpoint = baseEndpoint;
                    this.deviceTypeId = deviceTypeId;
                };
                ApiEndpointService.prototype.getBaseEndpoint = function () {
                    return this.baseEndpoint;
                };
                ApiEndpointService.prototype.getApplicationEndpoint = function () {
                    if (this.deviceTypeId > app.constants.deviceType.WebApp) {
                        this.mainEndpoint = "/api/mobile/";
                    }
                    else {
                        this.mainEndpoint = "/api/application/";
                    }
                    return this.baseEndpoint + this.mainEndpoint;
                };
                ApiEndpointService.prototype.getloginEndpoint = function () {
                    return this.getBaseEndpoint() + '/oauth/token';
                };
                ApiEndpointService.prototype.getUserLanguageEndpoint = function () {
                    return this.getApplicationEndpoint() + "UserLangaugeGet";
                };
                ApiEndpointService.prototype.getLocalizationEndpoint = function () {
                    return this.getApplicationEndpoint() + "localization";
                };
                ApiEndpointService.prototype.getPythonEndpoint = function () {
                    return this.getBaseEndpoint() + '/python.js.axd';
                };
                ApiEndpointService.prototype.getCheckServerEndpoint = function () {
                    return this.getApplicationEndpoint() + '/checkServer';
                };
                ApiEndpointService.prototype.getUploadImageEndPoint = function () {
                    return this.getApplicationEndpoint() + '/UploadPicture';
                };
                ApiEndpointService.prototype.getUploadAssessmentFileEndPoint = function () {
                    return this.getApplicationEndpoint() + '/UploadAssessmentFile';
                };
                ApiEndpointService.prototype.getUploadPrescriptionFileEndPoint = function () {
                    return this.getApplicationEndpoint() + '/UploadPrescriptionFile';
                };
                ApiEndpointService.prototype.getImageOnDemandEndpoint = function () {
                    return this.getApplicationEndpoint() + '/GetPictureForAssessentByName';
                };
                ApiEndpointService.prototype.getUpdateAssessmentImagesFolderEndpoint = function () {
                    return this.getApplicationEndpoint() + '/UpdateAssessmentImagesFolder';
                };
                ApiEndpointService.prototype.getUpdatePrescriptionFilesFolderEndpoint = function () {
                    return this.getApplicationEndpoint() + '/UpdatePrescriptionFilesFolder';
                };
                ApiEndpointService.prototype.getMailEndpoint = function () {
                    return this.getApplicationEndpoint();
                };
                ApiEndpointService.prototype.getUploadAttachmentEndPoint = function () {
                    return this.getApplicationEndpoint() + '/UploadMailAttachment';
                };
                ApiEndpointService.prototype.getOpenAttachmentEndPoint = function () {
                    return this.getApplicationEndpoint() + '/OpenAttachedFile';
                };
                ApiEndpointService.prototype.getOpenAssessmentFileEndPoint = function () {
                    return this.getApplicationEndpoint() + '/OpenAssessmentFile';
                };
                ApiEndpointService.prototype.getOpenPrescriptionFileEndPoint = function () {
                    return this.getApplicationEndpoint() + '/OpenPrescriptionFile';
                };
                ApiEndpointService.prototype.getErrorEndpoint = function () {
                    return this.getApplicationEndpoint() + 'ReportErrors';
                };
                ApiEndpointService.prototype.getUserManagementEndpoint = function () {
                    return this.getBaseEndpoint() + '/api/accounts/';
                };
                ApiEndpointService.prototype.getRefreshTokensEndpoint = function () {
                    return this.getBaseEndpoint() + '/api/refreshTokens/';
                };
                ApiEndpointService.prototype.getOperationUnitEndpoint = function () {
                    return this.getBaseEndpoint() + '/api/opertaionunit/';
                };
                ApiEndpointService.prototype.getProcessCubeEndpoint = function () {
                    return this.getApplicationEndpoint() + 'ProcessCube';
                };
                ApiEndpointService.prototype.getAssessmentDataDumpEndpoint = function () {
                    return this.getApplicationEndpoint() + 'AssessmentDataDumpGet';
                };
                ApiEndpointService.prototype.getErrorReportEndpoint = function () {
                    return this.getBaseEndpoint() + '/BugReport/Report';
                };
                ApiEndpointService.prototype.getAllowRememberMeEndpoint = function () {
                    return this.getApplicationEndpoint() + '/AllowRememberMe';
                };
                return ApiEndpointService;
            })();
            services.ApiEndpointService = ApiEndpointService;
        })(services = common.services || (common.services = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));

/// <reference path="../../_typings.ts"/>
'use strict';
var app;
(function (app) {
    var common;
    (function (common) {
        var services;
        (function (services) {
            services.busyIndicatorContent = {
                Loading: 'AlertLoadingData',
                PleaseWait: 'AlertPleaseWait',
                ConnectingToServer: 'AlertConnectingToServer',
                SyncInProgress: 'AlertSyncInProgress',
                GeneratingReports: 'AlertGeneratingReports',
                UploadingPictures: 'AlertUploadingPictures',
                DraftPictures: 'AlertDraftPictures'
            };
            var BusyIndicator = (function () {
                function BusyIndicator($document, $timeout, $animate, $rootScope, $translate) {
                    this.$document = $document;
                    this.$timeout = $timeout;
                    this.$animate = $animate;
                    this.$rootScope = $rootScope;
                    this.$translate = $translate;
                    this.loader = '<div class="fadeMe"></div><div class="vetProgress">' +
                        '<h4 style = "text-align: center" id="busyIndicatorContent">--Content--</h4><div class="progress progress-striped active  page-progress-bar">' +
                        '<div class="bar"></div></div></div>';
                    this.isVisible = false;
                }
                BusyIndicator.prototype.show = function (content) {
                    if (content === void 0) { content = null; }
                    content = app.common.utils.isNullOrUndefinedOrEmpty(content) ? this.$translate.instant(services.busyIndicatorContent.PleaseWait) : this.$translate.instant(content);
                    if (!this.isVisible) {
                        this.isVisible = true;
                        var parent = document.getElementsByTagName('body')[0];
                        var busyIndicator = document.createElement("div");
                        busyIndicator.setAttribute("id", "busyIndicator");
                        busyIndicator.setAttribute("class", "loader");
                        busyIndicator.innerHTML = this.loader.replace("--Content--", content);
                        parent.appendChild(busyIndicator);
                    }
                    else {
                        var domElement = document.getElementById("busyIndicatorContent");
                        if (!app.common.utils.isNullOrUndefined(domElement))
                            domElement.innerHTML = content;
                    }
                };
                BusyIndicator.prototype.hide = function () {
                    this.isVisible = false;
                    var domElement = document.getElementById("busyIndicator");
                    if (!app.common.utils.isNullOrUndefined(domElement))
                        domElement.parentNode.removeChild(domElement);
                };
                return BusyIndicator;
            })();
            services.BusyIndicator = BusyIndicator;
        })(services = common.services || (common.services = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerService('BusyIndicator', ['$document', '$timeout', '$animate', '$rootScope', '$translate']);

/// <reference path="../../_typings.ts" />
var app;
(function (app) {
    var common;
    (function (common) {
        var services;
        (function (services) {
            services.PaletteBaseColors = [
                '#8bd4d0',
                '#ffb0cd',
                '#fcc46c',
                '#4fb2ce',
                '#add47c',
                '#ff7bac',
                '#00a99d',
                //'#fcc062',
                '#29abe2',
            ];
            services.FontColors = [
                '#2E595D',
                '#004054',
                '#336676',
                '#ffffff'
            ];
            var PaletteService = (function () {
                function PaletteService(baseColors) {
                    if (baseColors === void 0) { baseColors = services.PaletteBaseColors; }
                    this.genCounter = 0;
                    this.undefinedColor = '#C8D6DA';
                    this.baseColors = baseColors;
                    this.limitAnalogous = 14 * this.baseColors.length;
                    this.reset();
                }
                // get next unused color, or indexed color
                PaletteService.prototype.get = function () {
                    if (this.next < this.colors.length) {
                        return this.colors[this.next++];
                    }
                    this.colors.push(this.colorGen());
                    return this.get();
                };
                // get color of index, generate color if it does not exist
                PaletteService.prototype.color = function (index) {
                    if (index >= this.colors.length)
                        this.gen(index + 1);
                    return index >= 0 ? this.colors[index] : this.undefinedColor;
                };
                // return last generated color
                PaletteService.prototype.last = function () {
                    return this.colors[(this.next === 0 ? 1 : this.next) - 1];
                };
                // generate palette with given number of colors and return it
                PaletteService.prototype.gen = function (count) {
                    while (this.colors.length < count) {
                        this.get();
                    }
                    if (this.colors.length > count) {
                        this.colors = this.colors.slice(0, count);
                    }
                    return this.colors;
                };
                // return palette array
                PaletteService.prototype.all = function () {
                    return this.colors;
                };
                // shuffle the palette
                PaletteService.prototype.shuffle = function () {
                    this.colors = _.shuffle(this.colors);
                };
                PaletteService.prototype.reset = function () {
                    this.next = 0;
                    this.colors = this.baseColors.slice();
                };
                PaletteService.prototype.mostReadable = function (colors, baseColor) {
                    if (colors === void 0) { colors = services.FontColors; }
                    if (baseColor === void 0) { baseColor = this.last(); }
                    return tinycolor.mostReadable(baseColor, colors, { includeFallbackColors: false }).toHexString();
                };
                PaletteService.prototype.colorGen = function () {
                    this.genCounter++;
                    var color = tinycolor(this.colors[this.genCounter - 1]).analogous()[1];
                    var limit = this.genCounter / this.limitAnalogous;
                    if (limit >= 1) {
                        color.spin(40 * Math.floor(limit));
                    }
                    return color.toHexString();
                };
                PaletteService.$inject = [];
                return PaletteService;
            })();
            services.PaletteService = PaletteService;
        })(services = common.services || (common.services = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerService('PaletteService', app.common.services.PaletteService.$inject);

/// <reference path="../_typings.web.ts" />
var app;
(function (app) {
    var localizer;
    (function (localizer) {
    })(localizer = app.localizer || (app.localizer = {}));
})(app || (app = {}));
angular.module('pascalprecht.translate').factory('angularTranslateStorage', [
    '$window', function ($window) {
        var langKey;
        return {
            get: function (name) {
                if (!langKey) {
                    langKey = $window.localStorage.getItem(name);
                }
                return langKey;
            },
            set: function (name, value) {
                langKey = value;
                $window.localStorage.setItem(name, value);
            }
        };
    }
]).factory('angularTranslateLoader', [
    '$http', '$q', 'networkConnection', 'appLocalStorage', 'ENV', 'tmhDynamicLocale', '$locale', 'apiEndpointService', function ($http, $q, networkConnection, appLocalStorage, env, tmhDynamicLocale, $locale, apiEndpoint) {
        return function (options) {
            var deferred = $q.defer();
            var appStatus = appLocalStorage.applicationStatusGet();
            if (options.key != "undefined") {
                var translations = appLocalStorage.translationsGet();
                app.localizer.resource = JSON.parse(translations);
                appStatus.applicationInitialized = false;
                appLocalStorage.applicationStatusSet(appStatus);
                var i18NCulture;
                if (app.common.utils.isNullOrUndefinedOrEmpty(appStatus.translationsCulture)) {
                    i18NCulture = "en-gb";
                }
                else {
                    i18NCulture = appStatus.translationsCulture;
                }
                var i18NSuffix = app.constants.angulari18LMapping[i18NCulture.replace('_', '-').toLowerCase()];
                if (translations != null && angular.isDefined(translations) && !app.common.utils.refreshCachedData) {
                    appStatus = appLocalStorage.applicationStatusGet();
                    appStatus.applicationInitialized = true;
                    appLocalStorage.applicationStatusSet(appStatus);
                    deferred.resolve(JSON.parse(translations));
                }
                else {
                    $http.get(apiEndpoint.getLocalizationEndpoint(), { params: { lang: _.isEmpty(appStatus.translationsCulture) ? "en-gb" : appStatus.translationsCulture } }).success(function (translationsResource) {
                        appStatus = appLocalStorage.applicationStatusGet();
                        appStatus.applicationInitialized = true;
                        appLocalStorage.applicationStatusSet(appStatus);
                        app.localizer.resource = translationsResource;
                        appLocalStorage.translationsSet(JSON.stringify(translationsResource));
                        deferred.resolve(translationsResource);
                    }).error(function () {
                        deferred.reject(options.key);
                    });
                }
                tmhDynamicLocale.set(angular.isDefined(i18NSuffix) ? i18NSuffix : i18NCulture.replace('_', '-').toLowerCase()).then(function () {
                    app.common.utils.decimalSeparator = $locale.NUMBER_FORMATS.DECIMAL_SEP;
                });
            }
            else {
                deferred.reject(options.key);
            }
            $http.defaults.headers.common["Accept-Language"] = (_.isEmpty(appStatus.translationsCulture) ? "en-gb" : appStatus.translationsCulture) + "," + (_.isEmpty(appStatus.translationsCulture) ? "en-gb" : appStatus.translationsCulture);
            return deferred.promise;
        };
    }
]).config([
    '$translateProvider', function ($translateProvider) {
        $translateProvider
            .useLoader('angularTranslateLoader')
            .preferredLanguage('en-gb');
        $translateProvider.useLocalStorage();
        $translateProvider.useSanitizeValueStrategy('escapeParameters');
    }
]);

/// <reference path="../../_typings.ts" />
var app;
(function (app) {
    var web;
    (function (web) {
        var utils;
        (function (utils) {
            var permission;
            (function (permission_1) {
                function getSecurityLevelId(securityLevelName, securityLevels) {
                    return _.find(securityLevels, function (securityLevel) {
                        return securityLevel.name.toLowerCase() === securityLevelName.toLowerCase();
                    }).securityLevelId;
                }
                permission_1.getSecurityLevelId = getSecurityLevelId;
                function getExponent(role, permission, securityLevels) {
                    if (permission)
                        return getSecurityLevelId(app.common.utils.getEnumKeyByEnumValue(app.constants.accessControlPermissions, permission) + role, securityLevels);
                    else
                        return -1;
                }
                permission_1.getExponent = getExponent;
                function getPermission(securityLevels, securityLevelBitMask) {
                    var permission = "None";
                    _.forEach(securityLevels, function (securityLevel) {
                        if (securityLevelBitMask & Math.pow(2, securityLevel.securityLevelId)) {
                            permission = securityLevel.name.indexOf('Full') !== -1 ? 'Full' : 'Read';
                        }
                    });
                    return permission;
                }
                permission_1.getPermission = getPermission;
            })(permission = utils.permission || (utils.permission = {}));
        })(utils = web.utils || (web.utils = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

var app;
(function (app) {
    var web;
    (function (web) {
        var utils;
        (function (utils) {
            var tree;
            (function (tree) {
                function findSelectedNode(node, nodes) {
                    var result = false;
                    if (node.sel) {
                        nodes.push(node);
                        result = true;
                    }
                    if (node.ch !== null && result === false) {
                        for (var i = 0; i < node.ch.length; i++) {
                            var item = node.ch[i];
                            result = findSelectedNode(item, nodes);
                            if (result) {
                                nodes.push(node);
                                result = true;
                                break;
                            }
                        }
                    }
                    return result;
                }
                tree.findSelectedNode = findSelectedNode;
                ;
                function treeToArray(root, nodeList) {
                    if (!root.ch) {
                        nodeList.push(root);
                        return;
                    }
                    nodeList.push(root);
                    for (var i = 0; i < root.ch.length; i++) {
                        treeToArray(root.ch[i], nodeList);
                    }
                }
                tree.treeToArray = treeToArray;
                function findNodeById(node, id) {
                    var result = null;
                    if (node.id === id) {
                        result = node;
                    }
                    if (node.ch !== null && result === null) {
                        for (var i = 0; i < node.ch.length; i++) {
                            var item = node.ch[i];
                            result = findNodeById(item, id);
                            if (result !== null) {
                                break;
                            }
                        }
                    }
                    return result;
                }
                tree.findNodeById = findNodeById;
                function shrinkTree(node, defaultKey) {
                    if (defaultKey === void 0) { defaultKey = ""; }
                    if (node.ch !== null) {
                        for (var i = 0; i < node.ch.length; i++) {
                            shrinkTree(node.ch[i], defaultKey);
                        }
                    }
                    if (node.ch !== null && node.ch.length === 1 && node.ch[0].isEn === 0 && node.id !== "-1" && node.ch[0].id !== defaultKey) {
                        if (node.id.indexOf("1-") != 0)
                            node.ch = node.ch[0].ch;
                    }
                }
                tree.shrinkTree = shrinkTree;
                function shrinkTreeFarmer(node, defaultKey) {
                    if (defaultKey === void 0) { defaultKey = ""; }
                    if (node.ch !== null) {
                        for (var i = 0; i < node.ch.length; i++) {
                            shrinkTreeFarmer(node.ch[i], defaultKey);
                        }
                    }
                    if (node.ch !== null && node.ch.length === 1 && node.ch[0].isEn === 0 && node.id !== "-1" && node.ch[0].id !== defaultKey
                        && ((node.id.indexOf("0-") === 0 && node.ch[0].id.indexOf("1-") === 0) || (node.id.indexOf("2-") === 0 && node.ch[0].id.indexOf("3-") === 0))) {
                        if (node.id.indexOf("1-") !== 0)
                            node.ch = node.ch[0].ch;
                    }
                }
                tree.shrinkTreeFarmer = shrinkTreeFarmer;
                function removeEmptyNodes(node, index, parent) {
                    if (node.ch !== null) {
                        for (var i = node.ch.length - 1; i > -1; i--) {
                            removeEmptyNodes(node.ch[i], i, node);
                        }
                    }
                    if ((node.ch === null || node.ch.length === 0) && node.isEn === 0 && node.id !== "-1") {
                        parent.ch.splice(index, 1);
                    }
                }
                tree.removeEmptyNodes = removeEmptyNodes;
            })(tree = utils.tree || (utils.tree = {}));
        })(utils = web.utils || (web.utils = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

var app;
(function (app) {
    var web;
    (function (web) {
        var utils;
        (function (utils) {
            var events;
            (function (events_1) {
                var UpcomingEvent = (function () {
                    function UpcomingEvent() {
                    }
                    return UpcomingEvent;
                })();
                events_1.UpcomingEvent = UpcomingEvent;
                function addToCalendar(events, $translate) {
                    var cal = ics();
                    _.forEach(events, function (event) { return generateCalendarEvent(cal, event, $translate); });
                    cal.download();
                }
                events_1.addToCalendar = addToCalendar;
                function generateCalendarEvent(cal, event, $translate) {
                    var date = event.eventDate.toDateString();
                    var enddate = moment(event.eventDate).add(1, "day").toDate().toDateString(); //Bug in ics.js, must modify enddate
                    var site = event.siteName;
                    var assessmenttype = event.assessmentTypeName;
                    var title = site + ": " + assessmenttype;
                    var fishgroup = event.fishgroupName;
                    fishgroup = fishgroup ? $translate.instant("Ics_Fishgroup") + fishgroup : "";
                    var representative = event.contactName;
                    var comments = event.comments;
                    comments = comments ? $translate.instant("Ics_Comment") + comments : "";
                    var description = $translate.instant("Ics_Description").replace('{0}', title).replace('{1}', representative).replace('{2}', fishgroup).replace('{3}', comments);
                    cal.addEvent(title, description, site, date, enddate);
                }
            })(events = utils.events || (utils.events = {}));
        })(utils = web.utils || (web.utils = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

angular.module('app.common.directives', []).run(['$templateCache', function ($templateCache) {
  "use strict";
  $templateCache.put("app.common/directives/inventory_list/inventory.list.directive.desktop.tpl.html",
    "<div class=row ng-if=isFarmerIntegrationOn><button class=\"btn btn-link\" ng-click=\"selectAll('')\">{{'Action_SelectAll' | translate}}</button> <button class=\"btn btn-link\" ng-click=clearAll()>{{'Action_ClearAll' | translate}}</button></div><div style=\"overflow: auto\" ng-style=inventoryHeightExpression><div class=list-group ng-disabled=disabled><a href=# class=list-group-item ng-repeat=\"inv in farmerInventory\" ng-click=setSelectedUnit(inv) ng-class=\"{'active': inv.isSelected}\"><i class=\"fa fa-circle-o fa-3x pull-right\" ng-if=!inv.isSelected aria-hidden=true></i> <i class=\"fa fa-check-circle-o fa-3x pull-right\" ng-if=inv.isSelected aria-hidden=true></i> <span class=badge ng-style=\"{'background-color': inv.backgroundColor}\">{{'Fishgroup' | translate}}: {{inv.fishGroupName}}</span><h4 class=list-group-item-heading>{{inv.unitName}}</h4><p class=\"list-group-item-text list-group-item-details\"><span translate>FarmerCount</span> {{inv.closeCount | number }} <span translate>Biomass</span> {{inv.closeBiomass | number : 0 }} <span translate>Specie</span> {{inv.species }} <span translate>Generation_YearClass</span> {{inv.generation }}</p></a></div></div><div><h3 class=footer-total><span translate>FarmerCount</span> {{farmerInventoryTotals.closeCount | number }} <span ng-if=!hideTotalBiomass translate>biomass</span> <span ng-if=!hideTotalBiomass>{{farmerInventoryTotals.closeBiomass | number:0 }} </span><span ng-if=!hideTotalBiomass>kg</span> <span ng-if=!hideTotalWeight translate>weight</span> <span ng-if=!hideTotalWeight>{{farmerInventoryTotals.closeWeight | number:1 }} </span><span ng-if=!hideTotalWeight>g</span></h3><div ng-if=hasValidationError class=\"alert alert-danger\" role=alert><span class=\"fa fa-exclamation-triangle\" aria-hidden=true></span> <span translate>Error_SelectAtLeastOneUnit</span></div></div>");
  $templateCache.put("app.common/directives/inventory_list/inventory.list.directive.mobile.tpl.html",
    "<div class=row ng-if=isFarmerIntegrationOn><button class=\"button button-positive\" ng-click=\"selectAll('')\">{{'Action_SelectAll' | translate}}</button> <button class=\"button button-positive button-outline\" ion-button color=light ng-click=clearAll()>{{'Action_ClearAll' | translate}}</button></div><ion-scroll class=multirowscroll ng-style=inventoryHeightExpression><ion-list class=list ng-disabled=disabled><ion-item class=\"item item-avatar\" ng-repeat=\"inv in farmerInventory\" ng-click=setSelectedUnit(inv) ng-class=\"{'active': inv.isSelected}\"><div class=item-image><svg viewBox=\"0 0 190 190\"><path d=M95,188a93,93,0,1,1,93-93A93.11,93.11,0,0,1,95,188Z ng-style=\"{'fill': inv.backgroundColor}\"/><path d=M95,3A92,92,0,1,1,3,95,92.1,92.1,0,0,1,95,3m0-2a94,94,0,1,0,94,94A94,94,0,0,0,95,1Z style=fill:#f1f6f8 /><path d=M81.41,58.58,52.93,75.7,44.11,61.59C56.34,58.11,69.07,59.64,81.41,58.58Zm9.79,46.54,11.55-10.2C92.56,94.7,91.81,95.39,91.2,105.12Zm60.94-34.61a9.29,9.29,0,0,1-1.77,2.78,17.7,17.7,0,0,1-2.1,1.63c-3.42,2.55-8.09,4.74-13.92,6.72-3.9,1.31-22.13,5.83-36.63,9-20.57,3.73-28.78,11.26-31.15,28-.4,2.78.73,3.67,3.75,4.15,5.22.84,10.43,1.75,15.59,2.81,1,.2,1.9.45,2.83.72a3.06,3.06,0,0,1,1.39,5L73.46,149a3,3,0,0,1-4.77-.4l0,0c-8.44-13.33-16.27-26.8-19-41.79-3.1-16.85,5.21-29.22,22.74-38.34a89.45,89.45,0,0,1,41.32-10.3c3.84,0,8.76.46,11.18.56,9,.38,11.38.4,18.58,2.8,4.8,1.44,6,2.1,7.68,3.36C153,66.21,152.88,68.75,152.15,70.51Zm-14.7-2.64c-4.17-1.82-6.41-3.57-8.45-3.44-1.62.11-4.23,2.58-4.13,3.9S127.8,72,129.39,72C131.45,72,133.47,70,137.45,67.87Z style=fill:#fff /></svg> <span class=unit-text>{{inv.unitName}}</span></div><div class=pull-left><h2>{{'Fishgroup' | translate}}: {{inv.fishGroupName}}</h2><p><span translate>FarmerCount</span> {{inv.closeCount | number }} <span translate>Biomass</span> {{inv.closeBiomass | number : 0 }} <span translate>Specie</span> {{inv.species }} <span translate>Generation_YearClass</span> {{inv.generation }}</p></div><div class=pull-right><div class=row><a ng-click=setSelectedUnit(inv)><i class=\"icon ion-android-radio-button-off size-48\" ng-if=!inv.isSelected aria-hidden=true></i> <i class=\"icon ion-android-radio-button-on size-48\" ng-if=inv.isSelected aria-hidden=true></i></a></div></div></ion-item></ion-list></ion-scroll><div class=footer-total><h3><span translate>FarmerCount</span> {{farmerInventoryTotals.closeCount | number }} <span ng-if=!hideTotalBiomass translate>biomass</span> <span ng-if=!hideTotalBiomass>{{farmerInventoryTotals.closeBiomass | number:0 }} </span><span ng-if=!hideTotalBiomass>kg</span> <span ng-if=!hideTotalWeight translate>weight</span> <span ng-if=!hideTotalWeight>{{farmerInventoryTotals.closeWeight | number:1 }} </span><span ng-if=!hideTotalWeight>g</span></h3><div ng-if=hasValidationError class=\"alert alert-danger\" role=alert><span class=\"fa fa-exclamation-triangle\" aria-hidden=true></span> <span translate>Error_SelectAtLeastOneUnit</span></div></div>");
  $templateCache.put("app.common/directives/rich-text-editor/rich.text.editor.directive.tpl.html",
    "<textarea froala=froalaOptions ng-model=templateRegistration.commentValue></textarea>");
  $templateCache.put("app.common/directives/templateItem/templateItem.desktop.html",
    "<div ng-switch=item.attribute.attributeType.name ng-init=\"attrName = item.attributeDictionary.name\"><div ng-switch-default><div ng-if=\"attrName == 'AssessmentFollowUp'\" ng-init=\"optionSelection = getSelectionModel({templateItem:item})\"><div class=form-group><label class=\"control-label text-nowrap\" for={{item.attribute.attributeId}} ng-if=showLabels>{{item.attributeDictionary.name | translate}}</label><div class=\"radio text-nowrap\"><label class=radio ng-repeat=\"optionItem in optionSelection.collection\"><input name=followUp type=radio id=followUp_{{optionItem.value}} value={{optionItem.value}} tabindex=1 ng-change=selectionChange({templateItem:item,selectedOption:optionSelection.selectedOption}) ng-checked=\"optionItem.value == optionSelection.selectedOption\" ng-model=optionSelection.selectedOption>{{optionItem.text | translate}}</label></div></div></div><div class=form-group ng-class=\"{'has-error':(templateRegistration.error.haserror || hasError({templateItem:item})),'required':item.required}\" ng-if=\"attrName != 'AssessmentFollowUp'\"><label class=\"control-label text-nowrap\" ng-show=showLabels ng-class=\"{'validation-error-message':templateRegistration.error.haserror}\">{{item.attributeDictionary.name | translate}}</label><input tabindex={{setTabindex}} class=\"form-control text-right\" fcsa-number=\"{ maxDecimals: 10 }\" ng-model-options=\"{ updateOn: 'default blur', debounce: {'default': 3000, 'blur': 0} }\" ng-class=\"{'validation-error-message':templateRegistration.error.haserror}\" ng-model=templateRegistration.focusValue ng-readonly=templateRegistration.hasPreFilled placeholder=\"{{item.required | translate}}\" ng-required=item.required av-validation-tooltip=errorMessageGet({templateItem:templateRegistration}) av-validation-tooltip-enabled=\"templateRegistration.error.haserror || hasError({templateItem:item})\"></div></div><div ng-switch-when=Text><div class=form-group ng-class=\"{'has-error':hasError({templateItem:item}),'required':item.required}\" ng-if=\"attrName == 'Site' || attrName == 'Customer'|| attrName == 'ProcessingPlant'\" ng-init=\"optionSelection = getSelectionModel({templateItem:item})\"><label class=\"control-label text-nowrap\" for={{item.attribute.attributeId}} ng-if=showLabels>{{item.attributeDictionary.name | translate}}</label><label class=\"form-control well well-sm\" ng-if=\"attrName != 'Customer'\">{{assessment.siteName}}</label><span ng-if=\"assessment.site.siteNumber && attrName == 'Site'\"><span translate>SiteNumber</span> <span>:</span> <span>{{assessment.site.siteNumber}}</span></span><label class=\"form-control well well-sm\" ng-if=\"attrName == 'Customer'\">{{assessment.customerName}}</label></div><div class=blankspace ng-class=\"{'has-error':hasError({templateItem:item})}\" ng-if=\"attrName.indexOf('[Place_Holder')>-1\"><span>{{templateRegistration.focusValue}}</span></div><div class=form-group ng-class=\"{'has-error':hasError({templateItem:item}),'required':item.required}\" ng-if=\"attrName != 'Site' && attrName != 'Customer' && attrName != 'ProcessingPlant' && attrName.indexOf('[Place_Holder')==-1\"><label class=\"control-label text-nowrap\" for={{item.attribute.attributeId}} ng-show=showLabels>{{item.attributeDictionary.name | translate}}</label><input tabindex={{setTabindex}} id={{item.attribute.attributeId}} class=form-control ng-model-options=\"{ updateOn: 'default blur', debounce: {'default': 3000, 'blur': 0} }\" ng-readonly=templateRegistration.hasPreFilled ng-model=templateRegistration.focusValue placeholder=\"{{item.required | translate}}\" ng-required=item.required av-validation-tooltip=errorMessageGet({templateItem:templateRegistration}) av-validation-tooltip-enabled=hasError({templateItem:item})></div></div><div ng-switch-when=Date class=form-group ng-class=\"{'has-error':hasError({templateItem:item}),'required':item.required}\"><label class=\"control-label text-nowrap\" for={{item.attribute.attributeId}} ng-if=showLabels>{{item.attributeDictionary.name | translate}}</label><av-datepicker-single ng-if=\"attrName == 'Assessment date'\" tabindex={{setTabindex}} class=input-group input-class=\"'form-control'\" append-to-body=!showLabels selected-date=assessment.assessmentDate id={{item.attribute.attributeId}} selection-change=selectionChange({templateItem:item,selectedOption:assessment.assessmentDate})></av-datepicker-single><av-datepicker-single ng-if=\"attrName != 'Assessment date'\" tabindex={{setTabindex}} class=input-group input-class=\"'form-control'\" allow-future-dates=true append-to-body=!showLabels selected-date=templateRegistration.focusValue id={{item.attribute.attributeId}} ng-disabled=templateRegistration.hasPreFilled required></av-datepicker-single></div><div ng-switch-when=\"Business rule\" ng-class=\"{'has-error':hasError({templateItem:item}),'required':item.required}\" class=form-group ng-if=\"attrName != 'ValidExpiryDate'\" ng-switch=item.attribute.dictionary.name><label class=\"control-label text-nowrap\" ng-switch-default class=form-group><i class=\"fa fa-calculator placeholder-icon\" ng-if=showLabels></i><div class=\"control-label text-nowrap\" ng-show=showLabels>{{item.attributeDictionary.name | translate}}</div><input tabindex={{setTabindex}} class=\"form-control text-right\" disabled placeholder=\"{{item.attributeDictionary.name | translate}}\" value={{templateRegistration.focusValue}}></label><div ng-switch-when=PvFlags></div></div><div ng-switch-when=Boolean ng-class=\"{'has-error':hasError({templateItem:item}),'required':item.required}\" ng-show=showTemplateItem><div class=form-group><label class=\"control-label text-nowrap\" ng-if=showLabels>{{item.attributeDictionary.name | translate}}</label><div><input tabindex={{setTabindex}} type=checkbox ng-change=selectionChange({templateItem:item,selectedOption:templateRegistration.focusValue}) class=\"control-checkbox form-control text-right\" ng-model=templateRegistration.focusValue></div><div class=track><div class=handle></div></div></div></div><div ng-switch-when=Multiselect class=form-group ng-class=\"{'has-error':hasError({templateItem:item}),'required':item.required}\" ng-show=showTemplateItem ng-init=\"optionSelection = getSelectionModel({templateItem:item})\"><label class=\"control-label text-nowrap\" ng-show=showLabels>{{item.attributeDictionary.name | translate}}</label><div ng-if=\"optionSelection.collection.length > 0 && !templateRegistration.forcedTextValueForEnum\"><isteven-multi-select output-model=templateRegistration.multiselectValue default-label=\"{{'Select' | translate}}\" input-model=optionSelection.collection max-labels=1 helper-elements=\"\" button-label=text item-label=text tick-property=selected tabindex={{setTabindex}} on-item-click=\"multiselectChange({data:templateRegistration.multiselectValue, templateRegistration:templateRegistration})\"></isteven-multi-select></div><div ng-if=\"item.allowTextValueForEmptyEnum \n" +
    "            && (optionSelection.collection.length <= 0 || templateRegistration.forcedTextValueForEnum)\"><input tabindex={{setTabindex}} class=form-control placeholder=\"{{item.attributeDictionary.name | translate}}\" ng-model=templateRegistration.textValueForEmptyEnum></div></div><div ng-switch-when=BooleanNullable class=\"form-group booleanNullable\"><label class=\"control-label text-nowrap\" for={{templateRegistration.templateRegistrationId}} ng-if=showLabels>{{item.attributeDictionary.name | translate}}</label><div class=text-nowrap><label class=radio-inline><input tabindex={{setTabindex}} class=radio-inline id={{templateRegistration.templateRegistrationId}}_yes name={{templateRegistration.templateRegistrationId}} type=radio ng-value=true ng-model=templateRegistration.focusValue>{{'Yes' | translate}}</label><label class=radio-inline><input tabindex={{setTabindex}} class=radio-inline id={{templateRegistration.templateRegistrationId}}_no name={{templateRegistration.templateRegistrationId}} type=radio ng-value=false ng-model=templateRegistration.focusValue>{{'No' | translate}}</label></div></div><div ng-switch-when=Enum class=form-group ng-class=\"{'has-error':hasError({templateItem:item}),'required':item.required}\" ng-init=\"optionSelection = getSelectionModel({templateItem:item})\"><label class=\"control-label text-nowrap\" for={{item.attribute.attributeId}} ng-if=showLabels>{{item.attributeDictionary.name | translate}}</label><div ng-if=\"optionSelection.collection.length > 0 && !templateRegistration.forcedTextValueForEnum\"><av-selector-single ng-if=\"attrName == 'FreshwaterSite'\" ng-required=item.required ng-disabled=templateRegistration.hasPreFilled ng-model=optionSelection.selectedOption empty-list-text=optionSelection.defaultValue options=optionSelection.collection default-text=\"$parent.item.required == 'Required'?'Required':'Select'\" selected-value=optionSelection.selectedOption text-field=\"'text'\" value-field=\"'value'\" set-tabindex={{setTabindex}} callback=selectionChange({templateItem:$parent.item,selectedOption:option.value}) av-validation-tooltip=errorMessageGet({templateItem:templateRegistration}) av-validation-tooltip-enabled=hasError({templateItem:$parent.item})></av-selector-single><av-selector-single ng-if=\"attrName != 'FreshwaterSite' \" ng-required=item.required ng-disabled=templateRegistration.hasPreFilled ng-model=optionSelection.selectedOption options=optionSelection.collection default-text=\"$parent.item.required == 'Required'?'Required':'Select'\" text-field=\"'text'\" value-field=\"'value'\" selected-value=templateRegistration.focusValue set-tabindex={{setTabindex}} callback=selectionChange({templateItem:$parent.item,selectedOption:option.value}) av-validation-tooltip=errorMessageGet({templateItem:templateRegistration}) av-validation-tooltip-enabled=hasError({templateItem:$parent.item})></av-selector-single></div><div ng-if=\"item.allowTextValueForEmptyEnum && (optionSelection.collection.length <= 0 || templateRegistration.forcedTextValueForEnum)\"><input tabindex={{setTabindex}} class=form-control placeholder=\"{{item.attributeDictionary.name | translate}}\" ng-model=templateRegistration.textValueForEmptyEnum></div><a class=\"btn btn-link btn-xs\" ng-if=\"attrName == 'Fishgroup' || attrName == 'SeaSiteFishgroup' || attrName == 'FreshwaterFishgroup'\" ng-click=addFishgroup({attributeName:attrName,optionSelection:optionSelection,templateRegistration:templateRegistration})>{{'AddNew' | translate}}</a></div></div>");
  $templateCache.put("app.common/directives/templateItem/templateItem.desktop.readonly.html",
    "<div ng-switch=item.attribute.attributeType.name ng-init=\"attrName = item.attributeDictionary.name\"><div ng-switch-default><div ng-if=\"attrName == 'AssessmentFollowUp'\" class=form-group ng-init=\"optionSelection = getSelectionModel({templateItem:item})\"><label class=\"control-label text-nowrap\" ng-if=showLabels>{{item.attributeDictionary.name | translate}}</label><label class=\"form-control well well-sm\">{{optionSelection.selectedText | translate}}</label></div><div class=form-group ng-if=\"attrName != 'AssessmentFollowUp'\"><label class=\"control-label text-nowrap\" ng-show=showLabels>{{item.attributeDictionary.name | translate}}</label><label class=\"form-control well well-sm text-right\" ng-if=\"item.attribute.attributeType.name=='Double'\" ng-bind=\"unformatDecimal(templateRegistration.focusValue) | number:item.attribute.labelDataTypeDecimals\"></label><label class=\"form-control well well-sm text-right\" ng-if=\"item.attribute.attributeType.name!='Double'\" ng-bind=\"unformatDecimal(templateRegistration.focusValue) | number\"></label></div></div><div ng-switch-when=Text><div class=form-group ng-if=\"attrName == 'Site' || attrName == 'Customer'|| attrName == 'ProcessingPlant'\" ng-init=\"optionSelection = getSelectionModel({templateItem:item})\"><label class=\"control-label text-nowrap\" for={{item.attribute.attributeId}} ng-if=showLabels>{{item.attributeDictionary.name | translate}}</label><label class=\"form-control well well-sm\" ng-if=\"attrName != 'Customer'\">{{assessment.siteName}}</label><span ng-if=\"assessment.site.siteNumber && attrName == 'Site'\"><span translate>SiteNumber</span> <span>:</span> <span>{{assessment.site.siteNumber}}</span></span><label class=\"form-control well well-sm\" ng-if=\"attrName == 'Customer'\">{{assessment.customerName}}</label></div><div class=blankspace ng-if=\"attrName.indexOf('[Place_Holder')>-1\"><span>{{templateRegistration.focusValue}}</span></div><div class=form-group ng-if=\"attrName != 'Site' && attrName != 'Customer' && attrName != 'ProcessingPlant' && attrName.indexOf('[Place_Holder')==-1\"><label class=\"control-label text-nowrap\" for={{item.attribute.attributeId}} ng-show=showLabels>{{item.attributeDictionary.name | translate}}</label><label class=\"form-control well well-sm\" ng-model=templateRegistration.focusValue>{{templateRegistration.focusValue}}</label></div></div><div ng-switch-when=Label><div class=blankspace ng-class=\"{'has-error':hasError({templateItem:item})}\" ng-if=\"attrName.indexOf('[Place_Holder')>-1\"><span>{{templateRegistration.focusValue}}</span></div><div ng-switch=item.attribute.labelDataType class=form-group ng-class=\"{'has-error':hasError({templateItem:item}),'required':item.required}\" ng-if=\"attrName != 'Site' && attrName != 'Customer' && attrName != 'ProcessingPlant' && attrName.indexOf('[Place_Holder')==-1\"><label ng-switch-when=Trend class=\"form-control well well-sm\" ng-switch=templateRegistration.focusValue><i ng-switch-when=1 class=\"fa fa-arrow-up text-danger\" aria-hidden=true></i> <i ng-switch-when=-1 class=\"fa fa-arrow-down text-success\" aria-hidden=true></i> <i ng-switch-default class=\"fa fa-arrow-right text-warning\" aria-hidden=true></i></label><label ng-switch-default class=\"form-control well well-sm\">{{templateRegistration.focusValue}}</label></div></div><div ng-switch-when=Date class=form-group><label class=\"control-label text-nowrap\" for={{item.attribute.attributeId}} ng-if=showLabels>{{item.attributeDictionary.name | translate}}</label><label ng-if=\"attrName == 'Assessment date'\" class=\"form-control well well-sm\">{{assessment.assessmentDate | dateformat}}</label><label ng-if=\"attrName != 'Assessment date'\" class=\"form-control well well-sm\">{{templateRegistration.focusValue | dateformat}}</label></div><div ng-switch-when=\"Business rule\" class=form-group ng-if=\"attrName != 'ValidExpiryDate'\" ng-switch=item.attribute.dictionary.name style=\"height: 47px\"><div class=form-group ng-switch-default><i class=\"fa fa-calculator placeholder-icon\" ng-if=showLabels></i><label class=\"control-label text-nowrap\" ng-show=showLabels>{{item.attributeDictionary.name | translate}}</label><label class=\"form-control well well-sm text-right\">{{templateRegistration.focusValue}}</label></div><div ng-switch-when=PvFlags><div ng-if=templateRegistration.focusValue><span translate>PvFlagsWarning: {{templateRegistration.focusValue}}</span></div></div></div><div ng-switch-when=Boolean ng-show=showTemplateItem><div class=form-group><label class=\"control-label text-nowrap\" ng-if=showLabels>{{item.attributeDictionary.name | translate}}</label><div class=text-center><input type=checkbox class=\"control-checkbox form-control text-right\" ng-model=templateRegistration.focusValue disabled></div><div class=track><div class=handle></div></div></div></div><div class=form-group ng-switch-when=Multiselect ng-init=\"optionSelection = getSelectionModel({templateItem:item})\"><label class=\"control-label text-nowrap\" ng-show=showLabels>{{item.attributeDictionary.name | translate}}</label><label ng-if=\"attrName != 'NAHRepresentitive'\" class=\"form-control well well-sm\">{{optionSelection.selectedText}}</label><label ng-if=\"attrName == 'NAHRepresentitive'\" class=\"form-control well well-sm\">{{optionSelection.selectedText}}</label></div><div class=\"form-group booleanNullable\" ng-switch-when=BooleanNullable><label class=\"control-label text-nowrap\" for={{templateRegistration.templateRegistrationId}} ng-if=showLabels>{{item.attributeDictionary.name | translate}}</label><div class=text-nowrap><label class=radio-inline><input disabled class=radio-inline id={{templateRegistration.templateRegistrationIdd}}_yes name={{templateRegistration.templateRegistrationId}} type=radio ng-value=true ng-model=templateRegistration.focusValue>{{'Yes' | translate}}</label><label class=radio-inline><input disabled class=radio-inline id={{templateRegistration.templateRegistrationIdd}}_no name={{templateRegistration.templateRegistrationId}} type=radio ng-value=false ng-model=templateRegistration.focusValue>{{'No' | translate}}</label></div></div><div class=form-group ng-switch-when=Enum ng-init=\"optionSelection = getSelectionModel({templateItem:item})\"><label class=\"control-label text-nowrap\" ng-if=showLabels>{{item.attributeDictionary.name | translate}}</label><label class=\"form-control well well-sm\">{{optionSelection.selectedText}}</label></div></div>");
  $templateCache.put("app.common/directives/templateItem/templateItem.html",
    "<div ng-switch=item.attribute.attributeType.name ng-init=\"attrName = item.attributeDictionary.name\"><div ng-switch-default><div ng-if=\"attrName == 'AssessmentFollowUp'\" ng-init=\"optionSelection = getSelectionModel({templateItem:item})\"><div class=\"switch-toggle switch-3 switch-ios followup-toggle-container\"><input ng-repeat-start=\"optionItem in optionSelection.collection\" id=followUp_{{optionItem.value}} name=followUp type=radio ng-checked=\"optionItem.value == optionSelection.selectedOption\" value={{optionItem.value}} ng-model=optionSelection.selectedOption ng-change=selectionChange({templateItem:item,selectedOption:optionSelection.selectedOption})><label ng-repeat-end for=followUp_{{optionItem.value}} ng-class=\"{followUp_{{optionItem.value}}:optionItem.value == optionSelection.selectedOption}\">{{optionItem.text | translate}}</label><a></a></div></div><label class=\"item item-input item-stacked-label\" ng-class=\"{hasError:templateRegistration.error.haserror || hasError({templateItem:item})}\" ng-if=\"attrName != 'AssessmentFollowUp'\"><span class=\"input-label shake-span\" ng-show=showLabels ng-class=\"{'validation-error-message':templateRegistration.error.haserror}\">{{item.attributeDictionary.name | translate}}</span> <input class=\"item item-input item-stacked-label assessment-input pull-left\" fcsa-number=\"{ maxDecimals: 10 }\" pattern=[0-9]* ng-model-options=\"{ updateOn: 'default blur', debounce: {'default': 3000, 'blur': 0} }\" ng-class=\"{'validation-error-message':templateRegistration.error.haserror}\" ng-model=templateRegistration.focusValue ng-readonly=templateRegistration.hasPreFilled placeholder=\"{{item.required | translate}}\" ng-required=item.required></label></div><div ng-switch-when=Text><div class=\"item item-input item-stacked-label item-stacked-select\" ng-class={hasError:hasError({templateItem:item})} ng-if=\"attrName == 'Site' || attrName == 'Customer'|| attrName == 'ProcessingPlant'\" ng-init=\"optionSelection = getSelectionModel({templateItem:item})\"><div class=input-label ng-show=showLabels>{{item.attributeDictionary.name | translate}}</div><div class=\"item item-input item-select\"><span class=input-label ng-show=showLabels>&nbsp;</span><select ng-model=optionSelection.selectedOption ng-required=item.required ng-change=selectionChange({templateItem:item,selectedOption:optionSelection.selectedOption}) ng-options=\"optionItem.value as optionItem.text for optionItem in optionSelection.collection\"><option class=select-item value=\"\">{{item.required == 'Required'?'Required':'Select' | translate}}</option></select></div></div><div class=blankspace ng-class={hasError:hasError({templateItem:item})} ng-if=\"attrName.indexOf('[Place_Holder')>-1\"><span>{{templateRegistration.focusValue}}</span></div><div class=\"item item-input item-stacked-label\" ng-class={hasError:hasError({templateItem:item})} ng-if=\"attrName != 'Site' && attrName != 'Customer' && attrName != 'ProcessingPlant' && attrName.indexOf('[Place_Holder')==-1\"><div class=input-label ng-show=showLabels>{{item.attributeDictionary.name | translate}}</div><input class=\"item item-input item-stacked-label assessment-input pull-left\" ng-model-options=\"{ updateOn: 'default blur', debounce: {'default': 3000, 'blur': 0} }\" ng-readonly=templateRegistration.hasPreFilled ng-model=templateRegistration.focusValue placeholder=\"{{item.required | translate}}\" ng-required=item.required></div></div><div class=\"item item-input item-stacked-label\" ng-switch-when=Label><div class=input-label ng-show=showLabels>{{item.attributeDictionary.name | translate}}</div><div ng-switch=item.attribute.labelDataType class=form-group ng-class=\"{'has-error':hasError({templateItem:item}),'required':item.required}\" ng-if=\"attrName != 'Site' && attrName != 'Customer' && attrName != 'ProcessingPlant' && attrName.indexOf('[Place_Holder')==-1\"><label ng-switch-when=Trend class=\"form-control well well-sm\" ng-switch=templateRegistration.focusValue><i ng-switch-when=1 class=\"fa fa-arrow-up text-danger\" aria-hidden=true></i> <i ng-switch-when=-1 class=\"fa fa-arrow-down text-success\" aria-hidden=true></i> <i ng-switch-default class=\"fa fa-arrow-right text-warning\" aria-hidden=true></i></label><label ng-switch-default class=\"form-control well well-sm\">{{templateRegistration.focusValue}}</label></div></div><div class=\"item item-input item-stacked-label item-stacked-date\" ng-class={hasError:hasError({templateItem:item})} ng-switch-when=Date><div class=input-label ng-show=showLabels>{{item.attributeDictionary.name | translate}}</div><input ng-if=\"attrName == 'Assessment date'\" class=\"item item-input item-stacked-label item-date assessment-input pull-left\" type=date ng-model=assessment.assessmentDate ng-change=selectionChange({templateItem:item,selectedOption:assessment.assessmentDate}) placeholder=\"{{item.required | translate}}\" ng-required=item.required> <input ng-if=\"attrName != 'Assessment date' && !templateRegistration.hasPreFilled\" class=\"item item-input item-stacked-label item-date assessment-input pull-left\" type=date ng-model=templateRegistration.focusValue placeholder=\"{{item.required | translate}}\" ng-disabled=templateRegistration.hasPreFilled><div class=dateInputFieledLabel ng-if=\"attrName == 'Assessment date'\">{{assessment.assessmentDate | date:'shortDate'}}</div><div class=dateInputFieledLabel ng-if=\"attrName != 'Assessment date'\">{{templateRegistration.focusValue | date:'shortDate'}}</div></div><div ng-switch-when=\"Business rule\" ng-if=\"attrName != 'ValidExpiryDate'\" ng-switch=item.attribute.dictionary.name style=\"height: 47px\"><label ng-switch-default class=\"item item-input item-stacked-label\"><i class=\"icon ion-ios7-calculator-outline placeholder-icon\" ng-show=showLabels></i><div class=input-label ng-show=showLabels>{{item.attributeDictionary.name | translate}}</div><input class=\"item item-input item-stacked-label assessment-input pull-left\" disabled placeholder=\"{{item.attributeDictionary.name | translate}}\" value={{templateRegistration.focusValue}}></label><div ng-switch-when=PvFlags><div ng-if=templateRegistration.focusValue><span translate>PvFlagsWarning: {{templateRegistration.focusValue}}</span></div></div></div><div ng-switch-when=Boolean ng-show=showTemplateItem><div class=\"item item-input item-stacked-label item-stacked-toggle\"><div class=item-toggle-label ng-show=showLabels>{{item.attributeDictionary.name | translate}}</div><label class=\"toggle toggle-balanced\"><input type=checkbox ng-model=templateRegistration.focusValue ng-change=selectionChange({templateItem:item,selectedOption:templateRegistration.focusValue})><div class=track><div class=handle></div></div></label></div></div><ng-container ng-switch-when=Multiselect ng-init=\"optionSelection = getSelectionModel({templateItem:item})\" ng-show=showTemplateItem><ng-container ng-if=\"item.attributeName === 'NAHRepresentitive'\"><div class=\"item item-input item-multiselect item-stacked-multi\" ng-class=\"{hasError:hasError({templateItem:item} )}\" ng-style=\"{ 'background-color' : (!optionSelection.collection) ? '#f0f0f0' : 'white' }\"><div class=input-label ng-show=showLabels>{{item.attributeDictionary.name | translate}}</div><ng-container ng-if=\"optionSelection.collection && optionSelection.collection.length > 0\"><multi-select output-model=templateRegistration.multiselectValue on-item-click=\"multiselectChange({ data: data, templateRegistration: templateRegistration })\" default-label=\"{{'Select' | translate}}\" input-model=optionSelection.collection max-labels=0 helper-elements=\"\" button-label=text item-label=text tick-property=selected max-height=250px></multi-select></ng-container></div></ng-container><ng-container ng-if=\"item.attributeName !== 'NAHRepresentitive'\n" +
    "            && !(item.allowTextValueForEmptyEnum \n" +
    "                && (!optionSelection.collection || optionSelection.collection.length <= 0 || templateRegistration.forcedTextValueForEnum))\"><div class=\"item item-input item-multiselect item-stacked-multi\" ng-class=\"{hasError:hasError({templateItem:item} )}\" ng-style=\"{ 'background-color' : (!optionSelection.collection) ? '#f0f0f0' : 'white' }\"><div class=input-label ng-show=showLabels>{{item.attributeDictionary.name | translate}}</div><ng-container ng-if=\"item.dropdownDirection !== 'right'\"><multi-select output-model=templateRegistration.multiselectValue on-item-click=\"multiselectChange({ data: data, templateRegistration: templateRegistration })\" default-label=\"{{'Select' | translate}}\" input-model=optionSelection.collection max-labels=0 helper-elements=\"\" button-label=text item-label=text tick-property=selected></multi-select></ng-container><ng-container ng-if=\"item.dropdownDirection === 'right'\"><multi-select output-model=templateRegistration.multiselectValue on-item-click=\"multiselectChange({ data: data, templateRegistration: templateRegistration })\" default-label=\"{{'Select' | translate}}\" input-model=optionSelection.collection max-labels=0 helper-elements=\"\" button-label=text item-label=text tick-property=selected dropdown-direction=\"'right'\"></multi-select></ng-container></div></ng-container><ng-container ng-if=\"item.attributeName !== 'NAHRepresentitive' \n" +
    "            && item.allowTextValueForEmptyEnum \n" +
    "            && (!optionSelection.collection || optionSelection.collection.length <= 0 || templateRegistration.forcedTextValueForEnum)\"><div class=\"item item-input item-stacked-label\" ng-class={hasError:hasError({templateItem:item})}><div class=input-label ng-show=showLabels>{{item.attributeDictionary.name | translate}}</div><input class=\"item item-input item-stacked-label assessment-input pull-left\" ng-model-options=\"{ updateOn: 'default blur', debounce: {'default': 3000, 'blur': 0} }\" ng-model=templateRegistration.textValueForEmptyEnum></div></ng-container></ng-container><div class=\"item item-input item-stacked-label item-stacked-toggle\" ng-switch-when=BooleanNullable><div class=input-label ng-show=showLabels>{{item.attributeDictionary.name | translate}}</div><div class=item-switch><label class=label-text translate>No</label><nz-toggle tri-toggle ng-model=templateRegistration.focusValue val-true=true val-false=false val-null=null></nz-toggle><label class=label-text translate>Yes</label></div></div><ng-container ng-switch-when=Enum ng-init=\"optionSelection = getSelectionModel({templateItem:item})\"><div ng-if=\"!(item.allowTextValueForEmptyEnum \n" +
    "                && (!optionSelection.collection || optionSelection.collection.length <= 0 || templateRegistration.forcedTextValueForEnum))\" class=\"item item-input item-stacked-label item-stacked-select\" ng-class={hasError:hasError({templateItem:item})}><div class=input-label ng-show=showLabels>{{item.attributeDictionary.name | translate}}</div><div class=\"item item-input item-select\"><span class=input-label ng-show=showLabels>&nbsp;</span><select ng-if=\"attrName == 'FreshwaterSite'\" ng-model=optionSelection.selectedOption ng-required=item.required ng-disabled=templateRegistration.hasPreFilled ng-change=selectionChange({templateItem:item,selectedOption:optionSelection.selectedOption}) ng-options=\"optionItem.value as optionItem.text for optionItem in optionSelection.collection\"><option class=select-item value=\"\">{{item.required == 'Required'?'Required':'Select' | translate}}</option></select><select ng-if=\"attrName != 'FreshwaterSite'\" ng-model=templateRegistration.focusValue ng-required=item.required ng-disabled=templateRegistration.hasPreFilled ng-change=selectionChange({templateItem:item,selectedOption:templateRegistration.focusValue}) ng-options=\"optionItem.value as optionItem.text for optionItem in optionSelection.collection\"><option class=select-item value=\"\">{{item.required == 'Required'?'Required':'Select' | translate}}</option></select></div></div><div ng-if=\"item.allowTextValueForEmptyEnum \n" +
    "                && (!optionSelection.collection || optionSelection.collection.length <= 0 || templateRegistration.forcedTextValueForEnum)\" class=\"item item-input item-stacked-label\" ng-class={hasError:hasError({templateItem:item})}><div class=input-label ng-show=showLabels>{{item.attributeDictionary.name | translate}}</div><input class=\"item item-input item-stacked-label assessment-input pull-left\" ng-model=templateRegistration.textValueForEmptyEnum></div></ng-container></div>");
  $templateCache.put("app.web/directives/assessment/assessment.directive.tpl.html",
    "<wizard next-button-text=viewModel.nextButtonText back-button-text=viewModel.backButtonText last-step-button-text=viewModel.lastButtonText edit-mode=viewModel.editMode name={{viewModel.assessment.assessmentId}}><wz-step class=container-fluid ng-repeat=\"templateGroup in viewModel.assessment.templateGroups\" ng-init=\"rows = viewModel.getNumberOfRowForTemplate(templateGroup)\" title=\"{{templateGroup.template.dictionary.name | translate }}\" templateid={{templateGroup.template.templateId}} show-warning=templateGroup.hasErrors isreadonly=viewModel.readonly><div ng-class=\"{'fullScreen':viewModel.fullScreen}\"><div class=row><div class=col-md-12><div class=pull-left><div class=\"pull-right farmer-data-label\"><div ng-if=viewModel.showFarmerPeriodInfor(templateGroup.template.dictionary.name)><span>: (</span> <span>{{'NoOfDaysFromFarmer' | translate | stringFormat : [viewModel.noOfdaysFromFarmer]}} </span><span>)</span></div><div ng-if=viewModel.showFarmerInfor(templateGroup.template.dictionary.name)><span>: (</span> <span>{{'InventoryFromFarmer' | translate }}</span> <span>)</span></div></div><h4 class=\"pull-right text-info ng-binding\"><strong>{{templateGroup.template.dictionary.name | translate}}</strong></h4></div><button class=\"btn btn-default\" ng-if=\"!viewModel.readonly \n" +
    "                                           && viewModel.editMode \n" +
    "                                           && templateGroup.template.isFromFarmer\" ng-click=viewModel.getFarmerData()>{{ 'UpdateFarmerData' | translate }}</button><div class=\"form-inline pull pull-right\" style=\"margin-right:0px;margin-bottom: 5px\"><div class=\"btn-toolbar justify-content-between\" role=toolbar aria-label=\"Toolbar with button groups\"><div class=\"btn-group btn-group-lg\" role=group aria-label=\"First group\"><button ng-if=templateGroup.hasAccordionView type=button class=\"btn btn-secondary\" ng-click=viewModel.toggleRows(templateGroup) title=\"Expand / Collapse\"><svg ng-if=viewModel.expand width=18 height=18 preserveAspectRatio=\"xMidYMid meet\" viewBox=\"0 0 22 22\" style=\"-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg)\"><path d=\"M14 4H4v10H2V4a2 2 0 0 1 2-2h10v2m4 2H8a2 2 0 0 0-2 2v10h2V8h10V6m4 6v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2m-2 3h-8v2h8v-2z\" fill=#626262 /><rect x=0 y=0 width=18 height=18 fill=\"rgba(0, 0, 0, 0)\"/></svg> <svg ng-if=!viewModel.expand width=18 height=18 preserveAspectRatio=\"xMidYMid meet\" viewBox=\"0 0 22 22\" style=\"-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg)\"><path d=\"M4 2a2 2 0 0 0-2 2v10h2V4h10V2H4m4 4a2 2 0 0 0-2 2v10h2V8h10V6H8m12 6v8h-8v-8h8m0-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2m-1 7h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2z\" fill=#626262 /><rect x=0 y=0 width=18 height=18 fill=\"rgba(0, 0, 0, 0)\"/></svg></button> <button type=button class=\"btn btn-secondary\" ng-if=!viewModel.readonly ng-disabled=\"!viewModel.isLastStep && viewModel.assessment.isDraft\" ng-click=\"viewModel.isLocked=!viewModel.isLocked;viewModel.setLockStatus('True')\" title=\"{{\n" +
    "                                    !viewModel.isLastStep && viewModel.assessment.isDraft ? 'DraftsCannotLock':'LockUnlock' | translate}}\"><i class=fa ng-class=\"{'fa-lock':viewModel.assessment.isLocked,'fa-unlock':!viewModel.assessment.isLocked}\"></i></button> <button type=\"button \" ng-if=\"viewModel.showBackAndSaveDraftButton && !viewModel.readonly\" ng-click=\"viewModel.save('Draft')\" ng-attr-tabindex=\"{{viewModel.isLastStep && viewModel.editMode ? 10004 : 10003}} \" class=\"btn btn-secondary\" title=\"Save \"><i class=\"fa fa-floppy-o\"></i></button> <button type=\"button \" ng-if=\"viewModel.showBackAndSaveDraftButton && !viewModel.readonly\" ng-click=viewModel.previewReport() ng-attr-tabindex=\"{{viewModel.isLastStep && viewModel.editMode ? 10004 : 10003}} \" class=\"btn btn-secondary\" title=\"Preview report \"><i class=\"fa fa-file-text-o\"></i></button></div></div></div><div class=\"saved pull pull-right\"><label><h5><span translate>{{viewModel.assessment.assessmentSaveStatus}}</span> <span ng-show=\"viewModel.assessment.lastSaved \">:&nbsp;{{viewModel.assessment.lastSaved | date:'short' }}</span></h5></label></div></div></div><div class=row><hr></div><div class=row><div class=col-md-12><div class=clearfix style=\"margin-bottom: 4px\"></div><div ng-if=\"viewModel.hasValidationProblem \" class=\"alert alert-danger\" role=\"alert \"><span class=\"fa fa-exclamation-triangle\" aria-hidden=\"true \"></span> <span translate>{{viewModel.errorMessage}}</span></div><div ng-if=\"viewModel.showFlag && viewModel.isLastStep \" class=\"alert alert-info\" role=\"alert \"><strong translate>PvFlagsWarning</strong> <button class=\"btn btn-link\" ng-click=\"viewModel.showFlagInformation() \"><span translate>ShowFlagInformation</span>&nbsp;</button></div></div></div><div ng-if=\"viewModel.getCurrentTemplateGroup().templateId==templateGroup.templateId && !templateGroup.hasMultiRows \"><div style=\"overflow-y: auto; overflow-x: hidden;max-height: calc(100% - 100px)\" av-element-resize ng-style=\"style(200,true,viewModel.hasValidationProblem || (viewModel.showFlag && viewModel.isLastStep)) \"><div class=row ng-repeat=\"(sortOrder, templateItems) in templateGroup.template | groupbysortorder \"><div ng-repeat=\"templateItem in filteredTemplateItems=( templateItems | filter:{attributeName:\n" +
    "                                    '!AssessmentDiscriminator'}) \"><div ng-switch=\"templateItem.attribute.attributeType.name \"><div ng-switch-default class=\"col-xs-4 col-sm-4 col-md-4 col-lg-3\"><template-item ng-if=\"viewModel.readonly \" itemisreadonly=\"true \" type=\"desktop\n" +
    "                                    \" assessment=\"viewModel.assessment \" item=\"templateItem \" template-registration=\"viewModel.getTemplateRegistration(templateItem)\n" +
    "                                    \" get-selection-model=\"::viewModel.getSelectionModel(templateItem) \" selection-change=\"viewModel.onSelectionChange(templateItem, selectedOption, element) \" required has-error=\"viewModel.hasError(templateItem) \" error-message-get=\"viewModel.errorMessageGet(templateItem) \" show-labels=\"true\n" +
    "                                    \" show-template-item=\"viewModel.showFarmerAttribute(templateItem) \" add-fishgroup=\"viewModel.addFishGroup(attributeName) \" set-tabindex=\"{{sortOrder\n" +
    "                                    * 100 + templateItem.columnOrder}} \"></template-item><template-item ng-if=\"!viewModel.readonly \" type=\"desktop \" assessment=\"viewModel.assessment\n" +
    "                                    \" item=\"templateItem \" show-labels=\"true \" template-registration=\"viewModel.getTemplateRegistration(templateItem,true)\n" +
    "                                    \" get-selection-model=\"::viewModel.getSelectionModel(templateItem) \" selection-change=\"viewModel.onSelectionChange(templateItem, selectedOption, element) \" required has-error=\"viewModel.hasError(templateItem) \" error-message-get=\"viewModel.errorMessageGet(templateItem)\n" +
    "                                    \" show-template-item=\"viewModel.showFarmerAttribute(templateItem) \" show-labels=\"true \" add-fishgroup=\"viewModel.addFishGroup(attributeName,optionSelection,templateRegistration) \" set-tabindex=\"{{sortOrder * 100 + templateItem.columnOrder}}\n" +
    "                                    \" multiselect-change=\"viewModel.multiselectChange(data,templateRegistration) \"></template-item></div><div ng-switch-when=\"Header \" class=col-md-9><div class=\"headerbar pull-left\">{{templateItem.attribute.dictionary.name | translate}}</div></div><div ng-switch-when=\"Label \" class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><div class=labelBar>{{templateItem.attribute.dictionary.name | translate}}</div></div><div ng-switch-when=\"Comment \" class=col-md-9><div class=form-group ng-class=\"{ 'has-error':viewModel.hasError(templateItem),\n" +
    "                                    'required':templateItem.attribute.required} \"><div class=control-label>{{templateItem.attribute.dictionary.name | translate}}</div><textarea tabindex=\"{{sortOrder * 100 + templateItem.columnOrder}}\" class=form-control ng-if=\"!viewModel.readonly \" rows=6 ng-model=\"viewModel.getTemplateRegistration(templateItem).commentValue\n" +
    "                                    \" ng-disabled=\"viewModel.getTemplateRegistration(templateItem).hasPreFilled \">\n" +
    "                                                </textarea><label ng-if=\"viewModel.readonly \" class=\"form-control well well-comment\">{{viewModel.getTemplateRegistration(templateItem).commentValue}}</label></div></div><div ng-switch-when=\"Rich Text \" class=col-md-9><div class=form-group ng-class=\"{ 'has-error':viewModel.hasError(templateItem),\n" +
    "                                    'required':templateItem.attribute.required} \"><div class=control-label>{{templateItem.attribute.dictionary.name | translate}}</div><av-rich-text tabindex=\"{{sortOrder * 100 + templateItem.columnOrder}}\n" +
    "                                    \" ng-if=\"!viewModel.readonly \" rows=\"6 \" template-registration=\"viewModel.getTemplateRegistration(templateItem) \"></av-rich-text><div ng-if=\"viewModel.readonly \" class=\"form-control well well-rich-text\" froala-view=\"viewModel.getTemplateRegistration(templateItem).commentValue \"></div></div></div></div></div></div></div></div><div class=no-validation-error-shown ng-if=\"viewModel.getCurrentTemplateGroup().templateId==templateGroup.templateId\n" +
    "                                    && viewModel.getCurrentTemplateGroup().hasMultiRows \" style=\"overflow-y: auto;overflow-x:\n" +
    "                                    hidden\" ng-style=\"{ 'height':viewModel.multiRowHeight} \"><av-multirows template-group=\"templateGroup \" assessment=\"viewModel.assessment \" current-template-id=\"viewModel.getCurrentTemplateGroup().templateId \" get-template-registrations=\"viewModel.getMultiRowTemplateRegistrations(template)\n" +
    "                                    \" get-template-registration=\"viewModel.getSelectedItemDetail(templateItem) \" get-template-registrations-by-row-index=\"viewModel.getTemplateRegistrationsByRowIndex(templateItem,rowIndex) \" select-item=\"viewModel.selectItem(template,rowIndex) \" get-template-registrations-for-total-rows=\"viewModel.getMultiRowTotalTemplateRegistrations(template) \" get-selection-model=\"viewModel.getSelectionModel(templateItem) \" selection-change=\"viewModel.onSelectionChangeMultiRow(templateItem,\n" +
    "                                    selectedOption) \" has-error=\"viewModel.multiRowHasError(templateItem,rowIndex) \" error-message-get=\"viewModel.errorMessageGet(templateItem) \" format-number=\"viewModel.formatNumber(value) \" add-row=\"viewModel.addRow(templateGroup)\n" +
    "                                    \" delete-row=\"viewModel.deleteRow(rowIndex,templateGroup) \" get-manipulated-row-index=\"viewModel.getManipulatedRowIndex(rowIndex) \" image-upload-target=\"viewModel.getImageUploadTarget() \" image-upload-headers=\"viewModel.getImageUploadHeaders() \" attachement-upload-target=\"viewModel.getAttachementUploadTarget() \" open-attached-file=\"viewModel.openAttachedFile(assessmentId, filename) \" get-image-on-demand=\"viewModel.getImageOnDemand(assessmentId,filename) \" isreadonly=\"viewModel.readonly || viewModel.getCurrentTemplateGroup().readOnly \" page-size=30 show-template-item=\"viewModel.showFarmerAttribute(templateItem) \" toggle-size=\"viewModel.hasValidationProblem \"></av-multirows></div></div></wz-step></wizard>");
  $templateCache.put("app.web/directives/assessment_list/assessment.accordion.tpl.html",
    "<div class=\"data-grid panel panel-primary\"><div class=panel-heading><div style=margin-left:5px class=row><div ng-repeat=\"header in ::headers\" ng-class=\"[header.className,{'header-sortable': header.sort!='no'}]\" class=header-text ng-click=sortBy(header)><i class=\"pull-left fa fa-fw\" ng-class=\"{'fa-caret-down': header.sort == 'desc', 'fa-caret-up': header.sort == 'asc', '' : header.sort == 'none'}\"></i>{{header.text}}</div></div></div><div class=panel-body><div loading-container=busy><uib-accordion close-others=true><uib-accordion-group is-open=item.showDetail ng-repeat=\"item in items track by $index\"><uib-accordion-heading is-open=::item.showDetail><div class=row><i class=\"pull-left fa fa-fw\" ng-class=\"{'fa-caret-down': item.showDetail, 'fa-caret-right': !item.showDetail}\"></i><div ng-repeat=\"header in ::headers\" ng-class=\"::getPropertyValue(header.index,'className')\"><av-item item-template=::itemTemplate is-html=\"::getPropertyValue(header.index,'html')\" get-item-property-value=\"::getItemPropertyValue(header.index,'propertyName',item)\" item=::item header=::header></av-item></div></div></uib-accordion-heading><div ng-if=item.showDetail ng-init=\"assessmentWizardData=injectedScope.getwizardData(item)\" class=accordion-detail><div ng-controller=\"app.web.controllers.AssessmentController as assessmentCtrl\"><av-assessment></av-assessment></div></div></uib-accordion-group></uib-accordion></div><div class=\"col-md-12 text-center\"><button ng-if=showLoadMore ng-click=loadData() class=\"btn btn-primary-outline\"><span translate>LoadMore</span></button></div></div></div>");
  $templateCache.put("app.web/directives/assessment_list/assessment.customer.portal.row.tpl.html",
    "<div class=grid-text ng-switch=header.name ng-class=\"{'text-overflow': header.textOverflow}\" ng-attr-title=\"{{header.textOverflow && header.name !== 'Files' ? getItemPropertyValue(header.index,'propertyName',item) : ''}}\"><span ng-switch-when=Date>{{::getItemPropertyValue(header.index,'propertyName',item) | dateformat}}</span> <span ng-switch-when=Site>{{::getItemPropertyValue(header.index,'propertyName',item)}}</span> <span ng-switch-when=\"Assessment gr\">{{::getItemPropertyValue(header.index,'propertyName',item) | assessmentdiscriminator}}</span><div ng-switch-when=\"Follow up\" ng-switch=\"::getItemPropertyValue(header.index,'propertyName',item)\" ng-show=item.hasFollowUp><span ng-switch-when=3 class=\"label label-followup-needed\"><span>{{'FollowUpNeededShort' | translate}}</span> </span><span ng-switch-when=2 class=\"label label-followup-recommended\"><span>{{'FollowUpRecommendedShort' | translate}}</span> </span><span ng-switch-when=1 class=\"label label-followup-notneeded\"><span>{{'NoFollowUpShort' | translate}}</span></span></div><div ng-switch-when=Files stop-event><ul class=padding-left-16 ng-if=\"item && item.files && item.files.length>0\"><li ng-repeat=\"file in item.files track by $index\" ng-click=header.openAttachedFile(item.assessmentId,file) ng-attr-title={{file}}><a tabindex=-1 href=#>{{file}}</a></li></ul></div><span ng-switch-when=\"\"><i ng-if=item.deviceTypeId class=\"fa fa-mobile\"></i> <i ng-if=item.isLocked class=\"fa fa-lock\"></i></span><span ng-switch-when=\"Elanco Repr\">{{::getItemPropertyValue(header.index,'propertyName',item).join()}}</span> <a ng-switch-when=Options stop-event><av-menu type=Assessment assessment=item level=0 hide=header.hide(item)></av-menu></a><span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item) | translate}}</span></div>");
  $templateCache.put("app.web/directives/assessment_list/assessment.grid.tpl.html",
    "<div class=\"data-grid panel panel-primary\"><div class=panel-heading><div class=row><div ng-repeat=\"header in ::headers\" ng-class=\"[header.className,{'header-sortable': header.sort!='no'}]\" class=header-text ng-click=sortBy(header)><i class=\"pull-left fa fa-fw\" ng-class=\"{'fa-caret-down': header.sort == 'desc', 'fa-caret-up': header.sort == 'asc', '' : header.sort == 'none'}\"></i>{{::header.text}}</div></div></div><div class=panel-body><div loading-container=busy><div ng-repeat=\"item in items track by $index\" title={{::popoverData.title}} data-placement={{::popoverData.placement}} data-content={{::popoverData.content}} data-template={{::popoverData.template}} data-delay={{popoverData.delay}} data-trigger={{popoverData.trigger}} data-container=body bs-popover><div class=\"grid grid-flex-row-height\"><div ng-repeat=\"header in ::headers\" ng-class=\"getPropertyValue(header.index,'className')\"><av-item item-template=::itemTemplate is-html=\"::getPropertyValue(header.index,'html')\" get-item-property-value=\"::getItemPropertyValue(header.index,'propertyName',item)\" item=::item header=::header></av-item></div></div></div></div><div class=\"col-md-12 text-center\"><button ng-if=::showLoadMore ng-click=loadData() class=\"btn btn-primary-outline\"><span translate>LoadMore</span></button></div></div></div>");
  $templateCache.put("app.web/directives/assessment_list/assessment.list.directive.tpl.html",
    "<div ng-if=customerMode><av-grid auto-adjust-height=true class=assessment-list headers=headers load-more=loadMore() total-rows=totalRows load-more-text=\"'Load more ..'\" default-sort-property-name=\"'assessmentDate'\" default-sort=\"'desc'\" item-template=itemTemplate type=grid template=app.web/directives/assessment_list/assessment.grid.tpl.html allow-load-on-scroll=true toggle-reload=toggleReload injected-scope=injectedScope></av-grid></div><div ng-if=!customerMode><av-grid auto-adjust-height=true class=assessment-list headers=headers load-more=loadMore() total-rows=totalRows load-more-text=\"'Load more ..'\" default-sort-property-name=\"'assessmentDate'\" default-sort=\"'desc'\" item-template=itemTemplate template=app.web/directives/assessment_list/assessment.accordion.tpl.html allow-load-on-scroll=true toggle-reload=toggleReload injected-scope=injectedScope></av-grid></div>");
  $templateCache.put("app.web/directives/assessment_list/assessment.row.tpl.html",
    "<div class=grid-text ng-switch=header.name ng-class=\"{'text-overflow': header.textOverflow}\" ng-attr-title=\"{{header.textOverflow && header.name !== 'Files' ? getItemPropertyValue(header.index,'propertyName',item) : ''}}\"><span ng-switch-when=Date>{{getItemPropertyValue(header.index,'propertyName',item) | dateformat}}</span> <a ng-switch-when=Site ng-click=header.selectSite(item.customerId,item.siteId) stop-event>{{getItemPropertyValue(header.index,'propertyName',item)}}</a> <span ng-switch-when=\"Assessment gr\">{{getItemPropertyValue(header.index,'propertyName',item) | assessmentdiscriminator}}</span><div ng-switch-when=Files stop-event><ul class=padding-left-16 ng-if=\"item && item.files && item.files.length>0\"><li ng-repeat=\"file in item.files track by $index\" ng-click=header.openAttachedFile(item.assessmentId,file) ng-attr-title={{file}}><a tabindex=-1 href=#>{{file}}</a></li></ul></div><a ng-switch-when=Options stop-event><av-menu type=Assessment assessment=item level=0 confirm=header.confirm(item) hide=header.hide(item) toggle-locking=header.toggleLocking toggle-follow-up=header.toggleFollowUp></av-menu></a><div ng-switch-when=\"Follow up\" ng-switch=\"getItemPropertyValue(header.index,'propertyName',item)\" ng-show=item.hasFollowUp><span ng-switch-when=3 class=\"label label-followup-needed\"><span>{{'FollowUpNeededShort' | translate}}</span> </span><span ng-switch-when=2 class=\"label label-followup-recommended\"><span>{{'FollowUpRecommendedShort' | translate}}</span> </span><span ng-switch-when=1 class=\"label label-followup-notneeded\"><span>{{'NoFollowUpShort' | translate}}</span></span></div><span ng-switch-when=\"\"><i ng-if=item.deviceTypeId class=\"fa fa-mobile\"></i> <i ng-if=item.isDraft class=\"fa fa-pencil-square-o text-danger\"></i> <i ng-if=item.isLocked class=\"fa fa-lock\"></i> <i ng-if=item.isReadByAnyCustomer class=\"fa fa-check\"></i> </span><span ng-switch-when=\"Elanco Repr\">{{getItemPropertyValue(header.index,'propertyName',item).join()}}</span> <span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item) | translate}}</span></div>");
  $templateCache.put("app.web/directives/datepicker-range/datepicker-range.directive.tpl.html",
    "<input date-range-picker class=date-picker ng-class=inputClass ng-model=selectedDateRange ng-change=selectionChange() readonly options=dateOptions ng-required=required placeholder=\"{{required | translate}}\" min=minDate> <span ng-if=\"inputClass !== 'form-control' \" class=add-on-calendar></span><div ng-if=\"inputClass === 'form-control'\" class=input-group-addon style=\"min-width: 30px !important\"><i class=\"fa fa-calendar\"></i></div>");
  $templateCache.put("app.web/directives/datepicker-single/datepicker-single.directive.tpl.html",
    "<input uib-datepicker-popup={{format}} is-open=opened show-button-bar=false class=\"date-picker remove-outline\" datepicker-append-to-body={{appendToBody}} ng-class=inputClass datepicker-options=dateOptions min-date=minDate max-date=maxDate readonly ng-click=open($event) ng-change=selectionChange() custom-class=date-picker ng-model=selectedDate ng-required=required placeholder=\"{{required | translate}}\" ng-keydown=openOnEnter($event) ng-disabled=ngDisabled> <span ng-show=\"inputClass != 'form-control'\" class=add-on-calendar ng-click=open($event) ng-disabled=ngDisabled></span><div ng-show=\"inputClass == 'form-control'\" class=input-group-addon ng-click=open($event) ng-disabled=ngDisabled><i class=\"fa fa-calendar\"></i></div>");
  $templateCache.put("app.web/directives/filter_panel/filter.panel.directive.tpl.html",
    "<div class=pull-right><div class=pull-right><span ng-repeat=\"filter in filterList  | limitTo: quantityOfFiltersPerRow \"><av-selector ng-if=filter.isVisible filter=filter toggle-filter-changed=$parent.toggleFilterChanged()></av-selector></span></div><div id=splitFilter></div><div class=pull-right><span ng-repeat=\"filter in filterList.slice(quantityOfFiltersPerRow)\"><av-selector ng-if=filter.isVisible filter=filter toggle-filter-changed=$parent.toggleFilterChanged()></av-selector></span></div><div id=splitFilter></div></div>");
  $templateCache.put("app.web/directives/input-controls/input.control.text.tpl.html",
    "<div class=form-group ng-class=\"{'has-error':hasError,'required':isRequired, 'has-feedback': feedbackText !=undefined, 'has-feedback-left': feedbackPosition =='before'}\"><label class=control-label ng-class=\"{'sr-only':labelTranslationKey == ''}\" translate>{{labelTranslationKey}}</label><input name={{ngModelProperty}} class=form-control ng-model=ngModel[ngModelProperty] ng-disabled=ngDisabled av-validation-tooltip=errorMessage av-validation-tooltip-enabled=hasError ng-change=textChanged()> <span class=form-control-feedback ng-if=\"feedbackText !=''\" aria-hidden=true>{{feedbackText}}</span></div>");
  $templateCache.put("app.web/directives/menu/menu.directive.tpl.html",
    "<div ng-if=\"(menuType=='Reg' || menuType=='ImpExp') && menuItems.length > 0\" class=\"dropup clearfix\"><span class=dropdown-title>{{title}}&nbsp;</span><div class=btn-group uib-dropdown><button class=\"btn btn-default dropdown-toggle\" type=button uib-dropdown-toggle aria-expanded=true>{{'ChooseAction' | translate}} <span class=caret></span></button><ul class=uib-dropdown-menu role=menu aria-labelledby=dropdownMenu2><li ng-repeat-start=\"(key, value) in menuItemsGrouped\" ng-if=\"isAquaVet && menuType=='Reg'\" role=separator class=header>{{key | translate }}</li><li ng-repeat-end role=presentation ng-repeat=\"item in value | orderBy: 'name'\" ng-click=\"!item.disabled && selectItem(menuItems, item)\" ng-show=item.visible ng-class=\"{'disabled':item.disabled}\"><a role=menuitem tabindex=-1 href=#>{{item.description | translate}}</a></li></ul></div></div><div ng-if=\"(menuType=='Admin' || menuType=='User') &&  menuItems.length > 0\" class=\"dropdown clearfix\"><div class=btn-group uib-dropdown><button type=button class=\"btn btn-xs btn-primary uib-dropdown-toggle nav-button\" uib-dropdown-toggle>{{title | translate}} &nbsp;&nbsp; <span ng-class=\"{'fa-cog': menuType=='Admin', 'fa-user': menuType=='User'}\" class=fa></span></button><ul class=uib-dropdown-menu role=menu aria-labelledby=dropdownMenu2><li ng-repeat=\"item in menuItems\" role=presentation ng-click=\"selectItem(menuItems, item)\" ng-show=item.visible><a role=menuitem tabindex=-1 href=#>{{item.description| translate}}</a></li></ul></div></div><div ng-if=\"menuType=='Setup' && (menuItems|filter:{visible:true}).length > 0\" class=\"drodown clearfix\"><div class=btn-group uib-dropdown><button type=button class=\"btn btn-xs btn-primary uib-dropdown-toggle nav-button\" uib-dropdown-toggle>{{title | translate}} &nbsp;&nbsp; <span class=\"fa fa-cogs\"></span></button><ul class=uib-dropdown-menu role=menu aria-labelledby=dropdownMenu2><li ng-repeat=\"item in menuItems\" role=presentation ng-click=\"selectItem(menuItems, item)\" ng-show=item.visible><a role=menuitem tabindex=-1 href=#>{{item.description| translate}}</a></li></ul></div></div><div ng-if=\"menuType=='Tab' && menuItems.length > 0 && !display\"><ul class=\"nav nav-pills btn-xxs\"><li ng-repeat=\"item in menuItems\" ng-switch=item.value ng-class=\"{active : item.isSelected, dropdown: item.value == 'status'}\" ng-click=\"selectItem(menuItems, item, item.description)\" role=presentation ng-show=item.visible><a ng-switch-default role=menuitem tabindex=-1 href=#>{{item.description | translate}}</a> <a ng-switch-when=timeline ng-if=!isIpad() role=menuitem tabindex=-1 href=#>{{item.description | translate}}</a> <a ng-switch-when=customerportaltimeline ng-if=!isIpad() role=menuitem tabindex=-1 href=#>{{item.description | translate}}</a> <a ng-switch-when=status role=menuitem tabindex=-1 href=#>{{item.description | translate}} <i ng-if=\"item.value == 'status'\" class=fa ng-class=\"{'fa-list-alt' : !isMapView,'fa-globe': isMapView }\" aria-expanded=false></i></a><ul class=dropdown-menu role=menu ng-if=\"item.value == 'status'\" ng-class=\"{'sub-menu': item.isSelected}\"><li role=presentation ng-click=showAssessmentView()><a role=menuitem tabindex=-1 href=#>{{'Tabular view' | translate}}</a></li></ul></li></ul></div><div ng-if=\"menuType=='Tab' && menuItems.length > 0 && display==='sideMenu'\"><i class=\"fa fa-bars fa-2x pull-left\" id=slideMenuButton data-template-url=app.web/directives/menu/sidemenu.tpl.html data-placement=left data-animation=am-fade-and-slide-left bs-aside=aside data-container=body></i></div><div ng-if=\"(menuType=='Event')\" class=gridRowMenu><div class=btn-group uib-dropdown dropdown-append-to-body><button type=button class=\"btn btn-link btn-xs dropdown-toggle pull-right\" uib-dropdown-toggle ng-disabled=disabled ng-click=loadOnClick()><i class=\"fa fa-bars\"></i></button><ul class=\"uib-dropdown-menu pull-left dropdown-grid-row-menu-margin\" role=menu ng-style=\"{'margin-top': -(menuItems.length * 10 + 40)}\"><li ng-repeat=\"item in menuItems\" ng-click=\"selectItem(menuItems, item)\" ng-show=item.visible role=presentation av-confirm confirm-if=item.confirm confirm-title={{item.title}} confirm-message={{item.message}}><a role=menuitem tabindex=-1 href=#>{{item.description | translate}}</a></li></ul></div></div><div ng-if=\"menuType=='MapType' && menuItems.length > 0\" class=map-type-tab-menu><ul class=\"nav nav-pills btn-xxs\"><li ng-repeat=\"item in menuItems\" ng-class=\"{active : item.isSelected}\" ng-click=\"selectItem(menuItems, item)\" role=presentation ng-show=item.visible><a role=menuitem tabindex=-1 href=#>{{item.description | translate}}</a></li></ul></div><div ng-if=\"(menuType=='ProcessCube') && menuItems.length > 0\"><button class=\"btn btn-default\" type=button ng-click=\"selectItem(menuItems, menuItems[0])\">{{'ProcessCube' | translate}} <i class=\"fa fa-spinner fa-pulse\" ng-show=cubeIsProcessing></i></button> <span class=dropdown-title>{{cubeProcessingErrorMessage | translate}}</span></div>");
  $templateCache.put("app.web/directives/menu/menu.options.tpl.html",
    "<div class=btn-group uib-dropdown dropdown-append-to-body><button type=button class=\"btn btn-link btn-xs pull-right\" uib-dropdown-toggle ng-disabled=disabled ng-click=loadOnClick()><i class=\"fa fa-bars\"></i></button><ul class=\"uib-dropdown-menu dropdown-grid-row-menu-margin\" role=menu ng-style=\"{'margin-top': -(menuItems.length * 10 + 40)}\"><li role=menuitem ng-repeat=\"item in menuItems\" ng-click=\"selectItem(menuItems, item)\" ng-if=\"assessment != undefined && item.visible && item.value!='followup' && (item.value != 'lock' || (!assessment.isLocked && !assessment.isDraft)) && (item.value != 'unlock' || assessment.isLocked) && (item.value != 'unlock' || !assessment.isHistorical) && (item.value != 'edit' || !assessment.isLocked)\" role=presentation av-confirm confirm-if=item.confirm confirm-title={{item.title}} confirm-message={{item.message}}><a role=menuitem tabindex=-1 href=#>{{item.description | translate}}</a></li><li role=menuitem ng-repeat=\"item in menuItems\" class=dropdown-submenu ng-if=\"assessment != undefined && !assessment.isLocked && item.visible && item.value=='followup'\"><a class=test tabindex=-1 href=#>{{'EditFollowUp' | translate}}<span class=caret></span></a><ul class=\"dropdown-menu pull-right list-group\"><li><a tabindex=-1 class=list-group-item ng-class=\"{'active':assessment.followUpStatusId==1}\" href=# ng-click=\"selectItem(menuItems, item,1)\">{{'NoFollowUpShort' | translate}}</a></li><li><a tabindex=-1 class=list-group-item ng-class=\"{'active':assessment.followUpStatusId==2}\" href=# ng-click=\"selectItem(menuItems, item,2)\">{{'FollowUpRecommendedShort' | translate}}</a></li><li><a tabindex=-1 class=list-group-item ng-class=\"{'active':assessment.followUpStatusId==3}\" href=# ng-click=\"selectItem(menuItems, item,3)\">{{'FollowUpNeededShort' | translate}}</a></li></ul></li><li role=menuitem ng-repeat=\"item in menuItems\" ng-click=\"selectItem(menuItems, item)\" ng-if=\"ngModel != undefined && item.visible && (item.value != 'lock' || (!ngModel.isLocked && !ngModel.isDraft)) && (item.value != 'unlock' || ngModel.isLocked) && (item.value != 'unlock' || !ngModel.isHistorical) && (item.value != 'edit' || !ngModel.isLocked) && (item.value != 'delete' || !ngModel.isLocked) &&  (item.value != 'details' || ngModel.isLocked)\" role=presentation av-confirm confirm-if=item.confirm confirm-title={{item.title}} confirm-message={{item.message}}><a role=menuitem tabindex=-1 href=#>{{item.description | translate}}</a></li></ul></div>");
  $templateCache.put("app.web/directives/menu/sidemenu.tpl.html",
    "<div class=aside tabindex=-1 role=dialog><div class=aside-dialog><div class=aside-content><div><div class=\"aside-body cbp-spmenu-vertical cbp-spmenu\"><div ng-repeat=\"item in menuItems\" ng-switch=item.value ng-show=item.visible><div ng-switch-when=status><div role=tablist aria-multiselectable=true data-animation=am-collapse style=\"outline: none !important\" allow-multiple=true bs-collapse data-start-collapsed=true><div id=status-side-menu><div class=panel-heading role=tab><h4 class=panel-title><a class=accordion-toggle bs-collapse-toggle><span data-ng-click=\"selectItem(menuItems, item);$hide();\" translate>{{item.description}}</span> <i class=\"fa fa-caret-down pull-right\"></i></a></h4></div><div class=panel-collapse role=tabpanel bs-collapse-target><div class=\"panel-body panel-item\"><a href=# class=text-mlarge data-ng-click=\"selectItem(menuItems, item); $hide();\" style=\"outline: none !important\">{{'Tabular view' | translate}}</a></div></div></div></div></div><div ng-switch-when=\"assessments list \"><div role=tablist aria-multiselectable=true data-animation=am-collapse style=\"outline: none !important\" allow-multiple=true bs-collapse data-start-collapsed=true><div id=status-side-menu><div class=panel-heading role=tab><h4 class=panel-title><a class=accordion-toggle bs-collapse-toggle><span data-ng-click=\"selectItem(menuItems, item);$hide();\" translate>{{item.description}}</span> <i class=\"fa fa-caret-down pull-right\"></i></a></h4></div><div class=panel-collapse role=tabpanel bs-collapse-target><div class=\"panel-body panel-item\"><a href=# class=text-mlarge ng-repeat=\"at in assessmentTypes\" data-ng-click=\"selectItem(menuItems, item, at.assessmentTypeId);$hide();\" style=\"outline: none !important\"><i class=\"fa {{at.dictionary.name.toLowerCase()}} fa-lg fa-fw\"></i> <span translate>{{at.dictionary.name}}</span></a></div></div></div></div></div><div ng-switch-when=timeline ng-if=!isIpad()><div class=panel-heading role=tab><h4 class=panel-title><a data-ng-click=\"selectItem(menuItems, item);$hide();\" ng-class=\"{selected: item.isSelected, dropdown: item.value == 'status'}\"><span translate>{{item.description}}</span></a></h4></div></div><div ng-switch-when=customerportaltimeline ng-if=!isIpad()><div class=panel-heading role=tab><h4 class=panel-title><a data-ng-click=\"selectItem(menuItems, item);$hide();\" ng-class=\"{selected: item.isSelected, dropdown: item.value == 'status'}\"><span translate>{{item.description}}</span></a></h4></div></div><div ng-switch-default><div class=panel-heading role=tab><h4 class=panel-title><a data-ng-click=\"selectItem(menuItems, item);$hide();\" ng-class=\"{selected: item.isSelected, dropdown: item.value == 'status'}\"><span translate>{{item.description}}</span></a></h4></div></div></div><div><div><div role=tablist data-animation=am-collapse style=\"outline: none !important\" bs-collapse data-start-collapsed=true><div id=status-side-menu><div class=panel-heading role=tab><h4 class=panel-title><a class=accordion-toggle bs-collapse-toggle><span translate>Report</span> <i class=\"fa fa-caret-down pull-right\"></i></a></h4></div><div class=panel-collapse role=tabpanel bs-collapse-target><div class=\"panel-body panel-item\"><a href=# class=text-mlarge data-ng-click=\"prepareMedicationReport('user'); $hide();\" style=\"outline: none !important\">{{'MedicationPerUser' | translate}} </a><a href=# class=text-mlarge data-ng-click=\"prepareMedicationReport('customer'); $hide();\" style=\"outline: none !important\">{{'MedicationPerCustomer' | translate}}</a></div></div></div></div></div></div></div></div></div></div></div>");
  $templateCache.put("app.web/directives/multirows/cell.tpl.html",
    "<div class=multi-row ng-switch=col.name ng-init=\"templateItem = col.colDef.templateItem\"><div ng-switch-when=delete class=text-center style=\"margin-top: 1px\"><a ng-disabled=grid.appScope.isreadonly ng-if=!grid.appScope.hasPrefilled ng-click=deleteRow(row);grid.appScope.deleteRow({rowIndex:row.entity.rowIndex,templateGroup:grid.appScope.templateGroup})><span class=\"fa-stack fa-sm\" style=\"vertical-align: -65%\"><i class=\"fa fa-circle fa-stack-2x\"></i> <i class=\"fa fa-times fa-stack-1x fa-inverse\"></i></span></a></div><div ng-switch-when=Comments class=text-center style=\"margin-top: 6px\"><a class=comment-outline data-content=true data-container=body data-placement=left bs-ng-popover data-template=app.web/directives/multirows/comment.tpl.html data-animation=am-flip-x><i class=\"fa fa-comment-o padding\" ng-if=\"!grid.appScope.isreadonly && !row.entity[col.name].commentValue\"></i> <i class=\"fa fa-comment padding\" ng-if=row.entity[col.name].commentValue></i></a></div><div ng-switch-when=ValidExpiryDate></div><div ng-switch-when=Picture class=text-center style=\"margin-top: 6px\"><a data-content=true data-container=body data-placement=left bs-ng-popover data-template=app.web/directives/multirows/uploadImage.tpl.html data-animation=am-flip-x><i class=\"fa fa-camera padding\" ng-if=\"!grid.appScope.isreadonly && row.entity[col.name].textValue == null\"></i> <i class=\"fa fa-file-image-o padding\" ng-if=\"row.entity[col.name].textValue != null\"></i></a></div><div ng-switch-when=File class=\"text-center form-group\" ng-class=\"{'has-error':row.entity[col.name].error.haserror}\"><div ng-if=!grid.appScope.isreadonly class=\"form-control form-control-attachment\" flow-init=\"{target: grid.appScope.attachementUploadTarget(), singleFile: true,testChunks:false,query: { assessmentId: grid.appScope.assessment.assessmentId, source: 'flow_query' }}\" flow-files-submitted=grid.appScope.upload($flow) flow-file-success=grid.appScope.setImageData($flow.files,$message,row.entity[col.name]) flow-file-error=\"grid.appScope.fileErrorHandle( $file, $message,$flow, row.entity[col.name] )\" av-validation-tooltip=grid.appScope.errorMessageGet(row.entity[col.name]) av-validation-tooltip-enabled=row.entity[col.name].error.haserror av-validation-tooltip-placement=left><div ng-if=\"!$flow.files.length && !row.entity[col.name].textValue\"><i class=\"fa fa-paperclip padding\" flow-btn></i></div><a ng-if=\"$flow.files.length || row.entity[col.name].textValue\" data-content=true data-container=body data-placement=left bs-ng-popover data-template=app.web/directives/multirows/uploadFile.tpl.html data-animation=am-flip-x class=\"label-text-overflow file-name\">{{row.entity[col.name].textValue}}</a></div><div ng-if=\"grid.appScope.isreadonly\n" +
    "            && ($flow.files.length || row.entity[col.name].textValue)\" class=form-control><a data-content=true data-container=body data-placement=left bs-ng-popover data-template=app.web/directives/multirows/uploadFile.tpl.html data-animation=am-flip-x class=\"label-text-overflow file-name\">{{row.entity[col.name].textValue}}</a></div></div><div ng-switch-default ng-switch=templateItem.attribute.attributeType.name><div ng-switch-when=Enum class=form-group ng-class=\"{'has-error':grid.appScope.hasError({templateItem:templateItem,rowIndex:row.entity.rowIndex})}\" ng-init=\"optionSelection = grid.appScope.getSelectionModel({templateItem:templateItem})\"><select tabindex=\"{{row.entity.rowIndex*100 + templateItem.sortOrder}}\" class=form-control ng-model=row.entity[col.name].focusValue ng-required=templateItem.required ng-if=\"!grid.appScope.isreadonly  \n" +
    "                    && !row.entity[col.name].hasPreFilled \n" +
    "                    && !row.entity[col.name].forcedTextValueForEnum\n" +
    "                    && optionSelection.collection.length > 0\" ng-change=grid.appScope.selectionChange({templateItem:item,selectedOption:row.entity[col.name].focusValue}) ng-options=\"optionItem.value as optionItem.text for optionItem in optionSelection.collection\"><option class=select-item value=\"\">{{templateItem.required == 'Required'?'Required':'Select' | translate}}</option></select><input ng-model=row.entity[col.name].textValueForEmptyEnum ng-if=\"!grid.appScope.isreadonly  \n" +
    "                    && !row.entity[col.name].hasPreFilled\n" +
    "                    && templateItem.allowTextValueForEmptyEnum\n" +
    "                    && (row.entity[col.name].forcedTextValueForEnum \n" +
    "                        || optionSelection.collection.length <= 0)\"><span ng-if=\"grid.appScope.isreadonly  || row.entity[col.name].hasPreFilled\" ng-init=\"optionSelection = grid.appScope.getSelectionModel({templateItem:row.entity[col.name]})\"><label ng-attr-title={{optionSelection.selectedText}} class=\"form-control well well-sm\">{{ row.entity[col.name].hasPreFilled ? row.entity[col.name].focusValue :optionSelection.selectedText}}</label></span></div><div ng-switch-when=Comment class=\"text-center text-overflow\" style=\"margin-top: 6px\"><a class=comment-outline data-content=true data-container=body data-placement=left bs-ng-popover data-template=app.web/directives/multirows/comment.tpl.html data-animation=am-flip-x><span>{{row.entity[col.name].commentValue}}</span> <i class=\"fa fa-comment-o padding\" ng-if=\"!grid.appScope.isreadonly && !row.entity[col.name].commentValue\"></i></a></div><div ng-switch-when=Multiselect class=form-group ng-class=\"{'has-error':hasError({templateItem:templateItem}),'required':templateItem.required}\" ng-init=\"optionSelection = grid.appScope.getSelectionModel({templateItem:row.entity[col.name]})\"><div ng-if=!grid.appScope.isreadonly><div ng-if=\"optionSelection.collection.length > 0 && !row.entity[col.name].forcedTextValueForEnum\"><isteven-multi-select output-model=row.entity[col.name].multiselectValue default-label=\"{{'Select' | translate}}\" input-model=optionSelection.collection max-labels=1 helper-elements=\"\" button-label=text item-label=text tick-property=selected></isteven-multi-select></div><div ng-if=\"templateItem.allowTextValueForEmptyEnum && (optionSelection.collection.length <= 0 || row.entity[col.name].forcedTextValueForEnum)\"><input class=form-control placeholder=\"{{templateItem.attributeDictionary.name | translate}}\" ng-model=row.entity[col.name].textValueForEmptyEnum></div></div><div ng-if=grid.appScope.isreadonly><label ng-attr-title={{optionSelection.selectedText}} class=\"form-control well well-sm\">{{ optionSelection.selectedText}}</label></div></div><div ng-switch-default><template-item ng-if=\"grid.appScope.isreadonly  || row.entity[col.name].hasPreFilled\" type=desktop assessment=assessment item=templateItem itemisreadonly=true template-registration=row.entity[col.name] get-selection-model=grid.appScope.getSelectionModel({templateItem:templateItem}) selection-change=grid.appScope.selectionChange({templateItem:templateItem,selectedOption:selectedOption}) required has-error=grid.appScope.hasError({templateItem:templateItem,rowIndex:row.entity.rowIndex}) error-message-get=grid.appScope.errorMessageGet({templateItem:row.entity[col.name]}) show-labels=false></template-item><template-item ng-if=\"!(grid.appScope.isreadonly  || row.entity[col.name].hasPreFilled)\" type=desktop assessment=assessment item=templateItem template-registration=row.entity[col.name] get-selection-model=grid.appScope.getSelectionModel({templateItem:templateItem}) selection-change=grid.appScope.selectionChange({templateItem:templateItem,selectedOption:selectedOption}) required set-tabindex=\"{{row.entity.rowIndex*100 + templateItem.sortOrder }}\" has-error=grid.appScope.hasError({templateItem:templateItem,rowIndex:row.entity.rowIndex}) error-message-get=grid.appScope.errorMessageGet({templateItem:row.entity[col.name]}) show-labels=false></template-item></div></div></div>");
  $templateCache.put("app.web/directives/multirows/comment.tpl.html",
    "<div class=popover tabindex=-1 ng-show=content style=\"outline: 0\"><div class=arrow></div><h3 class=popover-title ng-bind-html=title ng-show=title></h3><div class=popover-content><form name=popoverForm><div class=form-group><textarea rows=5 cols=30 av-autofocus tabindex=\"\" ng-disabled=\"grid.appScope.isreadonly || row.entity[col.name].hasPreFilled\" ng-model=row.entity[col.name].commentValue></textarea><a ng-click=$hide() class=\"pull pull-right\" style=\"position: absolute; bottom: 6px; right: 16px\" translate>Action_Close</a></div></form></div></div>");
  $templateCache.put("app.web/directives/multirows/footer.tpl.html",
    "<div ng-switch=col.name><div ng-switch-when=rowHeaderCol class=ui-grid-row ng-repeat=\"row in grid.appScope.totalRows(row,col)\"><div class=\"ui-grid-cell-contents no-overflow\">{{row | translate}}</div></div><div ng-switch-default class=ui-grid-row ng-repeat=\"templateRegistration in grid.appScope.totalRows(row,col)\"><div class=ui-grid-cell-contents ng-class=\"{'text-right':templateRegistration.attribute.attributeType.name != 'Boolean','text-center':templateRegistration.attribute.attributeType.name == 'Boolean'}\" title=\"{{templateRegistration.tooltipValue | translate}}\">{{grid.appScope.getFormattedValue(templateRegistration) | number : (templateRegistration.focusValue ? 2 : 0)}}<i class=\"fa fa-info-circle\" ng-if=templateRegistration.tooltipValue style=\"margin-left: 2px\"></i></div></div></div>");
  $templateCache.put("app.web/directives/multirows/header.tpl.html",
    "<div ng-class=\"{ 'sortable': sortable }\"><div class=ui-grid-cell-contents col-index=renderIndex title=TOOLTIP><span>{{ col.displayName | translate}}</span> <span ui-grid-visible=col.sort.direction ng-class=\"{ 'ui-grid-icon-up-dir': col.sort.direction == asc, 'ui-grid-icon-down-dir': col.sort.direction == desc, 'ui-grid-icon-blank': !col.sort.direction }\">&nbsp;</span></div><div class=ui-grid-column-menu-button ng-if=\"grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false\" ng-click=toggleMenu($event) ng-class=\"{'ui-grid-column-menu-button-last-col': isLastCol}\"><i class=ui-grid-icon-angle-down>&nbsp;</i></div><div ui-grid-filter></div></div>");
  $templateCache.put("app.web/directives/multirows/information.tpl.html",
    "<div class=\"popover pop-info\" tabindex=-1 ng-show=content style=\"outline: 0\"><div class=arrow></div><h3 class=popover-title ng-bind-html=title ng-show=title></h3><div class=popover-content><form name=popoverForm><div><img ng-src={{templateItem.attribute.information}}></div></form></div></div>");
  $templateCache.put("app.web/directives/multirows/multirows.directive.tpl.html",
    "<div ng-if=templateGroup.hasDefaultView><ng-container ng-if=isreadonly><div ng-if=\"gridOptions.data.length>0\"><div ui-grid=gridOptions class=\"myGrid accordion-step-grid-detail-readonly\" ui-grid-auto-resize></div></div></ng-container><ng-container ng-if=!isreadonly><div ng-if=\"gridOptions.data.length>0\"><div ui-grid=gridOptions class=myGrid ui-grid-auto-resize ng-style=\"{'height': gridHeight}\"></div></div></ng-container><a href=# class=\"btn btn-link\" ng-hide=isreadonly ng-click=addRow({templateGroup:templateGroup}) translate>AddNew</a></div><div ng-if=templateGroup.hasTabsView><div style=\"overflow-y: auto; overflow-x: hidden;max-height: calc(100% - 100px)\" av-element-resize ng-style=style(200,true,toggleSize)><uib-tabset class=tabset><uib-tab ng-repeat=\"row in templateGroup.rows\" ng-click=\"selectItem({template:templateGroup.template, rowIndex:$index+1})\" active=row.selected><uib-tab-heading><span>{{'Labtest' | translate}} - {{$index+1}}</span> <span class=pull-right><a ng-if=\"!hasPrefilled && !isreadonly\" ng-click=deleteRow({rowIndex:$index+1,templateGroup:templateGroup})><span class=\"fa-stack fa-sm\"><i class=\"fa fa-times fa-stack-2x\"></i></span></a></span></uib-tab-heading><div ng-if=\"templateGroup.selectedRow==$index+1\"><div class=row ng-repeat=\"(sortOrder, templateItems) in templateGroup.template | groupbysortorder \"><div ng-repeat=\"templateItem in templateItems\"><div ng-switch=templateItem.attribute.attributeType.name><div ng-switch-default class=\"col-xs-4 col-sm-4 col-md-4 col-lg-3\"><template-item ng-if=isreadonly itemisreadonly=true type=desktop assessment=assessment item=templateItem template-registration=getTemplateRegistration({templateItem:templateItem}) get-selection-model=getSelectionModel({templateItem:templateItem}) selection-change=selectionChange({templateItem:templateItem,selectedOption:selectedOption}) required has-error=hasError({templateItem:templateItem,rowIndex:$index+1}) show-labels=true set-tabindex=\"{{sortOrder * 100 + templateItem.columnOrder}}\" show-template-item=showTemplateItem({templateItem:templateItem})></template-item><template-item ng-if=!isreadonly type=desktop assessment=assessment item=templateItem template-registration=getTemplateRegistration({templateItem:templateItem}) get-selection-model=getSelectionModel({templateItem:templateItem}) selection-change=selectionChange({templateItem:templateItem,selectedOption:selectedOption}) required has-error=hasError({templateItem:templateItem,rowIndex:$index+1}) show-labels=true set-tabindex=\"{{sortOrder * 100 + templateItem.columnOrder}}\" show-template-item=showTemplateItem({templateItem:templateItem})></template-item></div><div ng-switch-when=Enum class=\"col-xs-4 col-sm-4 col-md-4 col-lg-3\" ng-class=\"{'has-error':hasError({templateItem:templateItem,rowIndex:getTemplateRegistration({templateItem:templateItem}).rowIndex})}\" ng-init=\"optionSelection = getSelectionModel({templateItem:templateItem})\"><div class=form-group><div class=control-label>{{templateItem.attribute.dictionary.name | translate}}</div><select tabindex=\"{{getTemplateRegistration({templateItem:templateItem}).rowIndex*100 + templateItem.sortOrder}}\" class=form-control ng-model=getTemplateRegistration({templateItem:templateItem}).focusValue ng-required=templateItem.required ng-if=\"!isreadonly  && !getTemplateRegistration({templateItem:templateItem}).hasPreFilled\" ng-change=selectionChange({templateItem:item,selectedOption:getTemplateRegistration({templateItem:templateItem}).focusValue}) ng-options=\"optionItem.value as optionItem.text for optionItem in optionSelection.collection\"><option class=select-item value=\"\">{{templateItem.required == 'Required'?'Required':'Select' | translate}}</option></select><span ng-if=\"isreadonly  || getTemplateRegistration({templateItem:templateItem}).hasPreFilled\" ng-init=\"optionSelection = getSelectionModel({templateItem:templateItem})\"><label ng-attr-title={{optionSelection.selectedText}} class=\"form-control well well-sm\">{{ getTemplateRegistration({templateItem:templateItem}).hasPreFilled ? getTemplateRegistration({templateItem:templateItem}).focusValue :optionSelection.selectedText}}</label></span></div></div><div ng-switch-when=Header class=col-md-9><div class=\"headerbar pull-left\">{{templateItem.attribute.dictionary.name | translate}}</div></div><div ng-switch-when=Label class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><div class=labelBar>{{templateItem.attribute.dictionary.name | translate}}</div></div><div ng-switch-when=Comment class=col-md-9><div class=form-group ng-class=\"{'has-error':hasError({templateItem:templateItem,rowIndex:$index+1}),'required':templateItem.attribute.required}\"><div class=control-label>{{templateItem.attribute.dictionary.name | translate}}</div><textarea tabindex=\"{{sortOrder * 100 + templateItem.columnOrder}}\" class=form-control ng-if=!isreadonly rows=6 ng-model=getTemplateRegistration({templateItem:templateItem}).commentValue ng-disabled=getTemplateRegistration({templateItem:templateItem}).hasPreFilled></textarea><label ng-if=isreadonly class=\"form-control well well-comment\">{{getTemplateRegistration({templateItem:templateItem}).commentValue}}</label></div></div><div ng-switch-when=\"Rich Text\" class=col-md-9><div class=form-group ng-class=\"{'has-error':hasError({templateItem:templateItem,rowIndex:$index+1}),'required':templateItem.attribute.required}\"><div class=control-label>{{templateItem.attribute.dictionary.name | translate}}</div><av-rich-text tabindex=\"{{sortOrder * 100 + templateItem.columnOrder}}\" ng-if=!isreadonly rows=6 template-registration=getTemplateRegistration({templateItem:templateItem})></av-rich-text><div ng-if=isreadonly class=\"form-control well well-rich-text\" froala-view=getTemplateRegistration({templateItem:templateItem}).commentValue></div></div></div></div></div></div></div></uib-tab><uib-tab ng-if=!isreadonly ng-click=addRow({templateGroup:templateGroup})><uib-tab-heading><span><span class=\"fa-stack fa-sm\"><i class=\"fa fa-plus fa-stack-2x\"></i></span></span></uib-tab-heading></uib-tab></uib-tabset></div></div><div ng-if=templateGroup.hasAccordionView><div><div><div style=\"overflow-y: auto; overflow-x: hidden;max-height: calc(100% - 100px)\" av-element-resize ng-style=style(150,true,toggleSize)><uib-accordion close-others=false><div uib-accordion-group class=panel-default ng-repeat=\"row in templateGroup.rows\" is-open=row.open ng-init=\"rowIndex=$index+1\"><uib-accordion-heading><span><span>{{'Fish' | translate}} - {{$index+1}}</span></span> <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': row.open, 'glyphicon-chevron-right': !row.open}\"></i></uib-accordion-heading><ul class=list-group ng-if=row.open><li class=\"list-group-item template-radio-list-item\" ng-repeat=\"(sortOrder, templateItems) in templateGroup.template | groupbysortorder \"><div ng-repeat=\"templateItem in templateItems\"><div ng-switch=templateItem.attribute.attributeType.name><div ng-switch-when=Enum ng-class=\"{'has-error':hasError({templateItem:templateItem,rowIndex:getTemplateRegistration({templateItem:templateItem}).rowIndex})}\" ng-init=\"optionSelection = getSelectionModel({templateItem:templateItem})\"><div class=form-group style=width:max-content><div class=\"control-label pull-left template-radio-label\">{{templateItem.attribute.dictionary.name | translate}}</div><div class=checkbox-inline ng-repeat=\"optionItem in optionSelection.collection\"><input ng-disabled=isreadonly class=\"form-check-input template-radio\" type=radio name={{templateItem.attribute.dictionary.name}}_{{rowIndex}} id={{templateItem.attribute.dictionary.name}}_{{rowIndex}} ng-value={{optionItem.value}} ng-model=getTemplateRegistrationsByRowIndex({templateItem:templateItem,rowIndex:rowIndex}).focusValue><label class=form-check-label for={{templateItem.attribute.dictionary.name}}_{{rowIndex}}>{{optionItem.text}}</label></div><a class=checkbox-inline data-content=true data-container=body data-placement=right bs-ng-popover data-template=app.web/directives/multirows/information.tpl.html data-animation=am-flip-x data-title=\"{{templateItem.attribute.dictionary.name | translate}}\"><span class=fa-stack><i class=\"fa fa-circle-o fa-stack-2x\"></i> <i class=\"fa fa-question fa-stack-1x\"></i></span></a></div></div></div></div></li></ul></div></uib-accordion></div></div></div></div>");
  $templateCache.put("app.web/directives/multirows/rowHeader.tpl.html",
    "<div class=ui-grid-disable-selection><div class=ui-grid-cell-contents><ui-grid-selection-row-header-buttons>{{row.entity.rowIndex}}</ui-grid-selection-row-header-buttons></div></div>");
  $templateCache.put("app.web/directives/multirows/uploadFile.tpl.html",
    "<div class=popover tabindex=-1 ng-show=content style=\"outline: 0\"><div class=arrow></div><h3 class=popover-title ng-bind-html=title ng-show=title></h3><div class=popover-content><form name=popoverForm><div class=form-group ng-init=\"templateRegistration = row.entity[col.name]\"><div><div style=\"padding: 12px; min-width: 150px\"><a ng-click=grid.appScope.openAttachment(templateRegistration)>{{templateRegistration.textValue}}</a></div><a ng-show=\"!grid.appScope.isreadonly && ($flow.files.length || templateRegistration.textValue)\" class=btn style=\"position: absolute; bottom: 0; left: 0; font-weight: normal\" ng-click=grid.appScope.removeImageData($flow,templateRegistration) transalte>Remove</a> <a ng-click=$hide() class=\"pull pull-right\" style=\"position: absolute; bottom: 6px; right: 16px\" translate>Action_Close</a></div></div></form></div></div>");
  $templateCache.put("app.web/directives/multirows/uploadImage.tpl.html",
    "<div class=popover tabindex=-1 ng-show=content style=\"outline: 0\"><div class=arrow></div><h3 class=popover-title ng-bind-html=title ng-show=title></h3><div class=popover-content><form name=popoverForm><div class=form-group ng-init=\"templateRegistration = row.entity[col.name]\"><div flow-init=\"{target: grid.appScope.imageUploadTarget(), singleFile: true,testChunks:false,query: { assessmentId: grid.appScope.assessment.assessmentId, source: 'flow_query' }}\" flow-files-submitted=grid.appScope.upload($flow) flow-file-added=\"grid.appScope.imageAdded($file, $event)\" flow-file-success=grid.appScope.setImageData($flow.files,$message,templateRegistration) flow-image-resize><div class=\"thumbnail thumbnail-size\" ng-if=\"!(!$flow.files.length && templateRegistration.textValue && !grid.appScope.isFlowFile(templateRegistration.imageData))\"><span ng-if=\"!$flow.files.length && !templateRegistration.textValue\" style=\"position: absolute; margin-top: 15%; margin-left: 35%; cursor: pointer\" ng-show=!$flow.files.length flow-btn translate><i class=\"fa fa-camera fa-2x\"></i></span> <img ng-if=\"$flow.files.length || (templateRegistration.textValue && grid.appScope.isFlowFile(templateRegistration.imageData))\" style=\"position: inherit; height: inherit; width: inherit\" flow-img=templateRegistration.imageData> <a ng-show=\"!grid.appScope.isreadonly \n" +
    "                            && ($flow.files.length || templateRegistration.textValue)\" class=btn style=\"position: absolute; bottom: 0; left: 0; font-weight: normal\" ng-click=grid.appScope.removeImageData($flow,templateRegistration) transalte>Remove</a></div><div class=\"thumbnail thumbnail-size\" ng-if=\"!$flow.files.length && templateRegistration.textValue && !grid.appScope.isFlowFile(templateRegistration.imageData)\"><div ng-init=grid.appScope.getImage(templateRegistration,templateRegistration.textValue)></div><img data-ng-src={{templateRegistration.imageData}}> <a ng-show=\"!grid.appScope.isreadonly \n" +
    "                            && ($flow.files.length || templateRegistration.textValue)\" class=btn style=\"position: absolute; bottom: 0; left: 0; font-weight: normal\" ng-click=grid.appScope.removeImageData($flow,templateRegistration) transalte>Remove</a></div><div class=imageUploadMessage style=\"max-width: 200px\"></div></div><a ng-click=$hide() class=\"pull pull-right\" style=\"position: absolute; bottom: 6px; right: 16px\" translate>Action_Close</a></div></form></div></div>");
  $templateCache.put("app.web/directives/notification/notification.directive.tpl.html",
    "<div class=\"dropup clearfix pull-right\"><button id=toastr-target class=\"btn btn-default dropdown-toggle\" data-toggle=dropdown ng-click=getNotifications()><i class=\"fa fa-comment\"></i></button><div id=notification-container class=\"dropdown-menu scroll-menu\"><div class=\"notification notification-info\" ng-show=areNotificationsLoading><div class=notification-title>@Mercatus.AquaVet.Localization._GlobalResources.ApplicationResource.FetchingData</div><div class=loader ng-class=active><div class=\"progress progress-striped active page-progress-bar\" style=\"margin-left: 10px; margin-right: 10px\"><div></div><div class=bar style=\"width: 100%\"></div></div></div></div><div ng-repeat=\"notification in notifications\" class=\"notification notification-info\" ng-if=!areNotificationsLoading><div><div data-part=popovertitlepart><div><div class=notification-message>{{notification.notificationMessage}}</div></div></div></div></div><div ng-if=\"notifications.length == 0\" class=\"notification notification-error\"><div class=notification-message>Warning_NoNotifications</div></div></div></div><span class=\"label label-danger pull-right\" ng-show=\"notificationsCount > 0\">{{notificationsCount}}</span>");
  $templateCache.put("app.web/directives/save-or-cancel/save.or.cancel.directive.tpl.html",
    "<div class=\"form-inline pull-right\"><div class=form-group><a class=\"form-group btn btn-success\" ng-click=save()>{{saveText || 'Action_Save' | translate}}</a></div><span>&nbsp;&nbsp;<small translate>Or</small>&nbsp;<a href=# ng-click=\"close('')\" av-confirm confirm-if=confirmOnClose confirm-title=\"{{'ConfirmCancelTitle' | translate}}\" confirm-message=\"{{'ConfirmCancelMessage' | translate}}\">{{ cancelText || 'Action_Cancel' | translate | lowercase}}</a></span></div>");
  $templateCache.put("app.web/directives/selector-single/selector.single.tpl.html",
    "<div class=btn-group uib-dropdown dropdown-append-to-body uib-keyboard-nav ng-style=ngStyleObject><button ng-disabled=ngDisabled class=\"btn btn-content dropdown-toggle form-control\" uib-dropdown-toggle tabindex={{setTabindex}}><span class=pull-left><placeholder></placeholder><span ng-if=\"options === undefined || (options != undefined && options.length == 0)\">{{emptyListText || defaultText | translate}} </span></span><span class=\"fa fa-caret-down pull-right\"></span></button><ul class=\"uib-dropdown-menu dropdown-menu-scrollable\" role=menu><li ng-repeat=\"option in options\"><a href=# ng-bind=\"{{'option.' + textField}}\" ng-click=select(option) av-confirm confirm-if=confirmIf confirm-title={{confirmTitle}} confirm-message={{confirmMessage}}></a></li><li class=dropdown-header ng-if=\"options == undefined || (options != undefined && options.length == 0)\">{{emptyListText | translate}}</li></ul></div>");
  $templateCache.put("app.web/directives/selector/selector.tpl.html",
    "<span ng-if=selector.filter.showLabel class=\"selector-label text-nowrap\">{{selector.label | translate}} </span><span style=\"display: inline-block\"><isteven-multi-select input-model=selector.list output-model=output button-label=name item-label=name tick-property=selected disable-property=disabled orientation=vertical translation=selector.translation is-disabled=selector.filter.isLocked helper-elements=\"none filter\" max-labels=1 selection-mode={{selector.mode}} on-select-none=selector.selectNone() on-open=selector.fixPosition()></isteven-multi-select></span>");
  $templateCache.put("app.web/directives/template_list/template.list.directive.tpl.html",
    "<av-grid auto-adjust-height=true class=assessment-list headers=headers load-more=loadMore() total-rows=totalRows load-more-text=\"'Load more ..'\" type=grid default-sort-property-name=\"'assessmentDate'\" default-sort=\"'desc'\" item-template=itemTemplate allow-load-on-scroll=true toggle-reload=toggleReload injected-scope=injectedScope></av-grid>");
  $templateCache.put("app.web/directives/template_list/template.row.tpl.html",
    "<div class=grid-text ng-switch=header.name ng-class=\"{'text-overflow': header.textOverflow}\" ng-attr-title=\"{{header.textOverflow ? getItemPropertyValue(header.index,'propertyName',item) : ''}}\"><span ng-switch-when=Date>{{getItemPropertyValue(header.index,'propertyName',item) | dateformat}}</span> <a ng-switch-when=Site ng-click=header.selectSite(item.customerId,item.siteId) stop-event>{{getItemPropertyValue(header.index,'propertyName',item)}}</a> <a ng-switch-when=Options stop-event><av-menu type=Template assessment=item level=0 confirm=header.confirm(item) hide=header.hide(item) toggle-locking=header.toggleLocking toggle-follow-up=header.toggleFollowUp></av-menu></a><span ng-switch-when=\"\"><i ng-if=item.deviceTypeId class=\"fa fa-mobile\"></i> <i ng-if=item.isDraft class=\"fa fa-pencil-square-o text-danger\"></i> <i ng-if=item.isLocked class=\"fa fa-lock\"></i> <i ng-if=item.isReadByAnyCustomer class=\"fa fa-check\"></i> </span><span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item)}}</span></div>");
  $templateCache.put("app.web/directives/timeline/timeline.directive.tpl.html",
    "<div class=timeline><div class=\"timeline timeline-header\" id=header><av-timeline-today style=\"width: 0\" x=todayIndicatorPosition></av-timeline-today><div ng-style=\"{'width' : ((displayYears[0].length + displayYears[1].length - 1) * monthlyWidth) + 'px'}\" class=\"timeline timeline-header-years\"><div class=\"timeline timeline-header-year\" ng-repeat=\"(yrIndex, year) in displayYears\" ng-style=\"{'width':(yrIndex==0?(year.length*monthlyWidth):((year.length-1)*monthlyWidth))+'px'}\"><span ng-if=\"!(yrIndex == 1 && month.currentMonth)\" class=month ng-repeat=\"month in year\">{{month.text}}</span></div></div></div></div><div class=\"timeline timeline-main\"><div class=timeline-content id=content><av-timeline-group timeline-spliter-position=timelineSpliterPosition today-indicator-position=todayIndicatorPosition groups=groups display-years=displayYears svg-height=svgHeight space-between-groups=spaceBetweenGroups></av-timeline-group></div></div>");
  $templateCache.put("app.web/directives/timeline/timeline.group.directive.tpl.html",
    "<svg class=\"timeline timeline-group\" id=svg-group ng-style=\"{'height': svgHeight}\"><line ng-attr-x1={{todayIndicatorPosition}} ng-attr-y1={{y+40}} ng-attr-x2={{todayIndicatorPosition}} y2=100% class=\"timeline timeline-today-line\"></line><g ng-repeat=\"(grIndex, group) in groups\"><g ng-repeat=\"(yrIndex, year) in displayYears\" class=\"timeline timeline-hide\"><g ng-if=\"yrIndex === 0\" ng-repeat=\"(mnIndex, month) in year.slice().reverse()\"><rect ng-attr-width={{month.width-5}} height=31 class=\"timeline timeline-group-monthly\" ng-attr-x={{timelineSpliterPosition-((mnIndex+1)*400)}} ng-attr-y={{y+145+(spaceBetweenGroups*(grIndex))}} style=\"fill: white\"></rect><g ng-if=group.showPast><rect ng-attr-width={{month.width-5}} height=31 class=\"timeline timeline-group-monthly\" ng-attr-x={{timelineSpliterPosition-((mnIndex+1)*400)}} ng-attr-y={{y+145+(spaceBetweenGroups*(grIndex))}}></rect><rect width=150 height=15 class=\"timeline timeline-group-monthly-name\" ng-attr-x={{timelineSpliterPosition-((mnIndex+1)*400)}} ng-attr-y={{y+130+(spaceBetweenGroups*(grIndex))}}></rect><text ng-attr-x={{timelineSpliterPosition+3-((mnIndex+1)*400)}} ng-attr-y={{y+143+(spaceBetweenGroups*(grIndex))}} class=\"timeline timeline-group-monthly-text\">{{month.text}}</text><g av-timeline-marker tooltip-past-visibility=group.tooltipPastVisibility tooltip-id=\"{{grIndex+'_'+yrIndex+'_'+mnIndex}}\" ref-x={{timelineSpliterPosition-((mnIndex+1)*400)}} future=false ref-y={{y+172+(spaceBetweenGroups*grIndex+20)}} year=year month=month markers=group.markers></g></g></g><g ng-if=\"yrIndex === 1\" ng-repeat=\"(mnIndex, month) in year\"><rect ng-attr-width={{month.width-5}} height=31 class=\"timeline timeline-group-monthly\" ng-attr-x={{timelineSpliterPosition+(mnIndex*400)-month.width}} ng-attr-y={{y+145+(spaceBetweenGroups*(grIndex))}} style=\"fill: white\"></rect><g ng-if=group.showFuture><rect ng-attr-width={{month.width-5}} height=31 class=\"timeline timeline-group-monthly\" ng-attr-x={{timelineSpliterPosition+(mnIndex*400)-month.width}} ng-attr-y={{y+145+(spaceBetweenGroups*(grIndex))}}></rect><rect width=150 height=15 class=\"timeline timeline-group-monthly-name\" ng-attr-x={{timelineSpliterPosition+(mnIndex*400)-month.width-(mnIndex?0:dateMargin())}} ng-attr-y={{y+130+(spaceBetweenGroups*(grIndex))}}></rect><text ng-attr-x={{timelineSpliterPosition+3+(mnIndex*400)-month.width-(mnIndex?0:dateMargin())}} ng-attr-y={{y+143+(spaceBetweenGroups*(grIndex))}} class=\"timeline timeline-group-monthly-text\">{{month.text}}</text><g av-timeline-marker tooltip-future-visibility=group.tooltipFutureVisibility tooltip-id=\"{{grIndex+'_'+yrIndex+'_'+mnIndex}}\" ref-x={{timelineSpliterPosition+((mnIndex-1)*400)}} future=true ref-y={{y+172+(spaceBetweenGroups*grIndex+20)}} year=year month=month markers=group.markers></g></g></g></g><g><text class=\"timeline timeline-icon tooltip-link\" ng-attr-x={{todayIndicatorPosition-220}} ng-attr-y={{y+165+(spaceBetweenGroups*grIndex)}} ng-click=togglePast(group)>{{group.showPast ? '&#xf056' : '&#xf055'}}</text></g><rect class=\"timeline timeline-group-holder\" ng-attr-x={{todayIndicatorPosition-200}} ng-attr-y={{y+145+(spaceBetweenGroups*grIndex)}} width=400 height=35 id=svg_5 rx=2 ry=5></rect><text class=\"timeline timeline-group-holder-text\" ng-attr-x={{todayIndicatorPosition}} ng-attr-y=\"{{y+(group.text.split('|').length*(-10))+(178 + $index*15)+(spaceBetweenGroups*grIndex)}}\" ng-repeat=\"str in group.text.split('|') track by $index\">{{str}}</text><g><text class=\"timeline timeline-icon tooltip-link\" ng-attr-x={{todayIndicatorPosition+205}} ng-attr-y={{y+165+(spaceBetweenGroups*grIndex)}} ng-click=toggleFuture(group)>{{group.showFuture ? '&#xf056' : '&#xf055'}}</text></g></g><g id=tooltipHolder></g></svg>");
  $templateCache.put("app.web/directives/timeline/timeline.marker.directive.tpl.html",
    "<g class=\"timeline timeline-markers\"><g ng-repeat=\"marker in markers\"><g ng-if=showMarker(month.year,month.month,marker.date) ng-attr-transform=\"{{'translate('+getX(refX,marker.date,0)+','+refY+')'}}\"><line x1=0 y1=-30 x2=0 ng-attr-y2={{getY(0,270)}} style=stroke:#D0CDCD></line><g ng-repeat=\"activity in marker.activities\" ng-attr-transform=\"{{'translate('+0+','+getMarkerYOffset($parent.$index,$index,markers)+')'}}\"><image x=5 ng-attr-y=\"{{getY(0,5 + $index*20)}}\" ng-attr-xlink:href={{activity.iconPath}} av-fall-back fallback-src=images/AssessmentTypeDefault.png height=15px width=15px></image><text x=20 ng-attr-y=\"{{getY(0,15 + $index*20)}}\" font-size=13 fill=black style=\"font-weight: bold\">{{activity.header | translate}}</text><circle class=tooltip-link cx=0 ng-attr-cy=\"{{getY(0,10 + $index*20)}}\" r=4 stroke=black stroke-width=1 fill=#4797A8 ng-mouseenter=\"showTooltip(activity, getX(refX,marker.date,0), getY(refY,10 + + $index*20 + getMarkerYOffset($parent.$index,$index,markers)))\" ng-mouseleave=\"showDetails = false\"></circle></g><text x=-10 ng-attr-y={{getY(0,-30)}} font-size=11 fill=black>{{marker.date | date:'d'}}</text></g></g><g av-timeline-tooltip ng-attr-id={{tooltipId}} tooltip-x=tooltipX tooltip-y=tooltipY tooltip-data=tooltipData tooltip-type=tooltipType></g></g>");
  $templateCache.put("app.web/directives/timeline/timeline.today.directive.tpl.html",
    "<svg class=\"timeline timeline-today\"><path class=\"timeline timeline-today-path\" ng-attr-d=\"m 5,0 l {{x+105}},0 s 5,0 5,5 l 0,{{height}} s 0,5 -5,5 l -{{width}},0 s -10,2 -10,20 l0,0  s 0,-18 -10,-20 l -{{width}},0 s -5,0 -5,-5 l 0,-{{height}} s 0,-5 5,-5 z\"></path><text ng-attr-x=\"{{x+105-(width + 45)}}\" ng-attr-y={{y+2.5}}>{{content | dateformat}}</text></svg>");
  $templateCache.put("app.web/directives/timeline/timeline.tooltip.directive.tpl.html",
    "<g ng-attr-transform=\"{{'translate('+tooltipX+','+tooltipY+')'}}\"><g transform=translate(5,-30) class=timeline ng-class=\"{'timeline-showDetail': tooltipX , 'timeline-hideDetail':!tooltipX }\"><path transform=\"matrix(0.6816903322325618 0.7316408209911891 -0.7316408209911891 0.6816903322325618 28.62956672049762 3.117559682097891)\" class=\"timeline timeline-tooltip\" width=40.73873873873873 height=39.13063063063065 d=\"M0,0 L40.73873873873873,0 L40.73873873873873,39.13063063063065 L0,39.13063063063065 L0,0 Z \"></path><path transform=\"matrix(1 0 0 1 13.727412560049004 0)\" width={{width}} height={{height}} class=\"timeline timeline-tooltip\" ng-attr-d=\"M0,0 L{{width}},0 L{{width}},{{height}} L0,{{height}} L0,0 Z \"></path><path transform=\"matrix(0.6816903322325618 0.731640820991189 -0.731640820991189 0.6816903322325618 29.96965681058731 2.84954166408005)\" width=40.73873873873873 height=39.13063063063065 stroke-miterlimit=3 stroke=#FFFAFA fill=#F5F9FC d=\"M0,0 L40.73873873873873,0 L40.73873873873873,39.13063063063065 L0,39.13063063063065 L0,0 Z \"></path><path transform=\"matrix(1 0 0 1 13.727412560049004 0)\" width={{width}} height={{headerHeight}} class=\"timeline timeline-tooltip-header\" ng-attr-d=\"M0,1 L{{width-1}},1 L{{width-1}},{{headerHeight-2}} L2,{{headerHeight-2}} L2,1 Z \"></path><g transform=translate(20,15)><text x=0 y=0 font-weight=bold fill=white>{{tooltipData.assessmentDiscriminator}}</text></g><g transform=translate(20,35)><text x=0 y=0 font-weight=bold>{{'Date' | translate}}</text><text x=115 y=0>{{tooltipData.date | dateformat}}</text></g><g transform=translate(20,50)><text x=0 y=0 font-weight=bold>{{'Type' | translate}}</text><text x=115 y=0>{{tooltipData.assessmentType}}</text></g><g transform=translate(20,65)><text x=0 y=0 font-weight=bold>{{'Customer' | translate}}</text><text x=115 y=0>{{tooltipData.customer}}</text></g><g transform=translate(20,80)><text x=0 y=0 font-weight=bold>{{'Site' | translate}}</text><text x=115 y=0>{{tooltipData.site}}</text></g><g transform=translate(20,95)><text x=0 y=0 font-weight=bold>{{'Fishgroup' | translate}}</text><text x=115 y=0>{{tooltipData.fishgroup}}</text></g><g transform=translate(20,110)><text x=0 y=0 font-weight=bold>{{'NAHContact' | translate}}</text><text x=115 y=0>{{tooltipData.contactPerson}}</text></g><g transform=translate(100,125)><a ng-click=showReport(tooltipData) target=_blank ng-if=\"tooltipType == 'Assessment'\"><text x=0 y=15 fill=#254A5D font-weight=bold class=tooltip-link>{{'Action_ShowReport' | translate}}</text></a><a ng-click=\"tooltipX=0\" target=_blank><text x=100 y=15 fill=#254A5D font-weight=bold class=tooltip-link>{{'Close' | translate}}</text></a></g></g></g>");
  $templateCache.put("app.web/directives/tree/tree.directive.tpl.html",
    "<ol class=breadcrumb><li><i class=\"fa fa-sitemap fa-2x text-info\" ng-click=openTree()></i></li><li ng-repeat=\"node in breadcrumbs\"><a href=javascript:void(0); ng-click=setNode(node)>{{node.n}}</a></li></ol>");
  $templateCache.put("app.web/directives/tree/tree.permission.directive.tpl.html",
    "<script type=text/ng-template id=tree_item_renderer.html><div ng-mouseenter=\"$parent.setToEditMode(data)\" ng-mouseleave=\"data.sb=0\">\n" +
    "        <i class=\"po fa-li fa\" ng-class=\"{'fa-caret-down': data.exp===1,'fa-caret-right': (data.exp===0 && data.isEn===0) , 'fa-map-marker':data.isEn===1}\" ng-click=\"$parent.expand(data)\"></i><span ng-style=\"{'color': (data.access>0)?'black':'#949494'}\">{{data.n}}</span>\n" +
    "        <button ng-show=\"data.sb==1 && data.access!=0 && data.access!=-1 && data.parentAccess!=0 && !$parent.isFullAccessRole\" type=\"button\" style=\"font-size:80%;\" class=\"btn btn-xs btn-danger\" ng-click=\"$parent.setPermission(data,'None')\" translate>PermissionNone</button>\n" +
    "        <button ng-show=\"data.sb==1 && (data.access==0 || data.access==-1) && data.parentAccess!=0 && !$parent.isFullAccessRole\" type=\"button\" style=\"font-size:80%;\"  class=\"btn btn-xs btn-success\" ng-click=\"$parent.setPermission(data,'Full')\" translate>PermissionFull</button>\n" +
    "        <button ng-show=\"data.sb==1 && data.access>0\" ng-click=\"$parent.setDefaultObject(data)\" style=\"font-size:80%;\" class=\"btn  btn-xs btn-link\"><i class=\"fa\" style=\"outline: 0;\" ng-class=\"{'fa-star': data.isDefault, 'fa-star-o': !data.isDefault}\"></i></button>\n" +
    "    </div>\n" +
    "    <ul class=\"fa-ul\" ng-if=\"data.exp\"><li ng-repeat=\"data in data.ch\" ng-hide=\"data.show==0\" ng-include=\"'tree_item_renderer.html'\"></li></ul></script><div><div class=\"treePermission node\" ng-if=treeViewData><ul class=fa-ul><li ng-repeat=\"data in treeViewData\" ng-include=\"'tree_item_renderer.html'\"></li></ul></div></div>");
  $templateCache.put("app.web/directives/tree/tree.view.tpl.html",
    "<script type=text/ng-template id=tree_item_renderer.html><i class=\"po fa-li fa\" ng-class=\"{'fa-caret-down': data.exp===1,'fa-caret-right': (data.exp===0 && data.isEn===0) , 'fa-map-marker':data.isEn===1}\"\n" +
    "       ng-click=\"$parent.expand(data)\"></i>\n" +
    "    <span ng-click=\"$parent.selectNode(data)\" ng-class=\"{'selected': data.sel===1 }\">{{data.n}}</span>\n" +
    "    <ul class=\"fa-ul\" ng-if=\"data.exp\"><li ng-repeat=\"data in data.ch\" ng-include=\"'tree_item_renderer.html'\"></li></ul></script><div class=modal-header><div class=form-inline><div class=form-group><div class=input-group><div class=input-group-addon><i class=\"fa fa-search\"></i></div><angucomplete-alt id=ex1 placeholder=\"{{'Search' | translate}}\" pause=400 selected-object=searchNode local-data=nodeList search-fields=n title-field=n description-field=desc minlength=3 clear-selected=true searchfields=title input-class=\"form-control form-control-small\" focus-in=focusin() focus-out=focusout()></angucomplete-alt></div></div></div></div><div class=modal-body><div><div class=\"tree node\" ng-if=treeViewData><ul class=fa-ul><li ng-repeat=\"data in treeViewData\" ng-include=\"'tree_item_renderer.html'\"></li></ul></div></div></div><div ng-show=grayout class=\"tree hideTree\"></div>");
  $templateCache.put("app.web/directives/user-permission/user.permission.directive.tpl.html",
    "<div class=\"panel panel-primary\"><div class=panel-heading><div><span class=\"padding padding-bottom\">{{'Permissions' | translate}}</span><div class=\"pull pull-right btn-group\"><button type=button class=\"btn btn-link add-permission\" ng-disabled=\"isCustomerMode && customerId == null\" title=\"{{isCustomerMode && customerId == null ? 'SelectCustomer' : null | translate}}\" ng-click=openPermissionTree()><i class=\"fa fa-pencil-square-o fa-lg\"></i></button></div></div></div><div class=panel-body><ul class=list-group><li class=list-group-item ng-repeat=\"userBusinessObject in userBusinessObjects\" ng-class=\"{'list-group-item-danger': customerId > 0 && userBusinessObject.customerId != customerId}\"><span class=user-business-object-description>{{userBusinessObject.businessObjectName}} <small title={{userBusinessObject.description}}>{{userBusinessObject.description}} </small></span>&nbsp;<span class=\"label label-default\">{{userBusinessObject.operationUnitType.title | translate}}</span> <span class=\"label label-success\">{{userBusinessObject.permission | translate}}</span><div class=\"btn-group-xs pull-right\"><button id=setDefaultPermissionLink ng-click=setDefault(userBusinessObject) class=\"btn btn-link\" ng-hide=\"userBusinessObject.permission == 'None'\"><i class=fa ng-class=\"{'fa-star':userBusinessObject.isDefault,'fa-star-o':!userBusinessObject.isDefault}\"></i></button> <button id=DeletePermissionLink ng-click=delete(userBusinessObject) class=\"btn btn-link\" ng-show=\"!isFullAccessRole || (isFullAccessRole && userBusinessObject.operationUnitTypeLevelId!=0)\"><span class=\"fa fa-stack fa-sm text-danger\"><i class=\"fa fa-circle fa-stack-2x\"></i> <i class=\"fa fa-times fa-stack-1x fa-inverse\"></i></span></button></div></li><li class=\"list-group-item list-group-item-danger\" ng-show=\"userBusinessObjects.length == 0\" translate>Error_User_SelectPermissionBusinessObject</li></ul></div></div>");
  $templateCache.put("app.web/modules/access_control/access.control.grid.tpl.html",
    "<div class=\"data-grid panel panel-primary\"><div class=panel-heading><div class=row><div ng-repeat=\"header in headers\" ng-class=header.className style=\"white-space: nowrap;overflow: hidden;text-overflow: ellipsis\">{{header.text}}</div></div></div><div class=panel-body><div av-element-resize ng-style=style(200,true) class=panel-group><div ng-repeat-start=\"item in items | orderBy:'category' track by $index\" class=\"panel panel-default\"><div class=panel-heading><div ng-repeat=\"header in headers\" ng-class=\"getPropertyValue(header.index,'className')\" class=panel-title><div class=grid-text ng-switch=header.name><div ng-switch-when=Category><a ng-if=item.hasDetails href=# ng-click=\"item.showDetail = !item.showDetail\"><i class=\"pull-left fa fa-fw\" ng-class=\"{'fa-caret-down': item.showDetail, 'fa-caret-right': !item.showDetail}\"></i> </a>{{getItemPropertyValue(header.index,'propertyName',item) | translate}}</div><span ng-switch-when=None><input type=radio ng-model=item.checked value=0 ng-click=injectedScope.permissionChanged(item.navigationURLId)></span><span ng-switch-when=Read><input type=radio ng-model=item.checked value=1 ng-click=injectedScope.permissionChanged(item.navigationURLId)></span><span ng-switch-when=Full><input type=radio ng-model=item.checked value=2 ng-click=injectedScope.permissionChanged(item.navigationURLId)></span><span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item) | translate}}</span></div></div></div></div><div ng-if=item.showDetail ng-repeat-end=\"\"><div collapse=!item.showDetail><table class=\"table table-condensed table-striped\"><thead><tr class=info><th>{{'Name' | translate}}</th><th>{{'None' | translate}}</th><th>{{'Full' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"subOption in item.navigationSubOptions\"><td translate>{{subOption.name}}</td><td><input type=radio ng-model=subOption.checked value=0 ng-click=injectedScope.permissionChanged(item.navigationURLId,subOption)></td><td><input type=radio ng-model=subOption.checked value=2 ng-click=injectedScope.permissionChanged(item.navigationURLId,subOption)></td></tr></tbody></table></div></div></div></div></div>");
  $templateCache.put("app.web/modules/access_control/role.new.tpl.html",
    "<div id=main_content_wrap class=outer ng-controller=\"app.web.controllers.RoleNewController as viewModel\"><div class=modal-header><h4 class=modal-title>{{viewModel.headerText | translate}}</h4><div class=ngdialog-close ng-click=closeThisDialog()></div></div><div class=modal-body><div class=container-fluid><div class=row><div class=col-md-6><div class=\"form-group required\" ng-class=\"{'has-error':viewModel.hasError('roleName ')}\"><label class=control-label for=roleName>{{'RoleName' | translate}}</label><input ng-model=viewModel.roleName id=roleName></div></div></div><div class=row ng-if=viewModel.hasValidationProblem><div class=col-md-12><div class=\"alert alert-danger\" role=alert><span class=\"fa fa-exclamation-triangle\" aria-hidden=true></span> <span>{{viewModel.errorMessage | translate}}</span></div></div></div></div></div><div class=modal-footer><div style=\"clear: both\"></div><div class=\"pull-left confirm-toolbar\"><button class=\"btn btn-success\" ng-click=viewModel.save()>{{'Action_Save' | translate}}</button> <span>{{'Or' | translate | lowercase}}</span> <a ng-click=viewModel.cancel() href=#>{{'Action_Cancel' | translate | lowercase}}</a></div></div></div>");
  $templateCache.put("app.web/modules/access_control/role.permission.grid.tpl.html",
    "<div class=\"data-grid panel panel-primary\"><div class=panel-heading><div class=row><div ng-repeat=\"header in headers\" ng-class=header.className style=\"white-space: nowrap;overflow: hidden;text-overflow: ellipsis\">{{header.text}}</div></div></div><div class=panel-body><div av-element-resize ng-style=style(100,true) class=panel-group><div ng-repeat=\"item in items | orderBy:'operationUnitTypeLevelId' track by $index \" class=\"panel panel-default\"><div class=panel-heading><div ng-repeat=\"header in headers\" ng-class=\"getPropertyValue(header.index,'className')\" class=panel-title><div class=grid-text ng-switch=header.name><span ng-switch-when=None><input type=radio ng-model=item.checked value=0 ng-click=injectedScope.permissionChanged(item.roleBusinessLevelId)></span><span ng-switch-when=Read><input type=radio ng-model=item.checked value=1 ng-click=injectedScope.permissionChanged(item.roleBusinessLevelId)></span><span ng-switch-when=Full><input type=radio ng-model=item.checked value=2 ng-click=injectedScope.permissionChanged(item.roleBusinessLevelId)></span><span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item) | translate}}</span></div></div></div></div></div></div></div>");
  $templateCache.put("app.web/modules/benchmarking/persentilSideEffectsPopover.tpl.html",
    "<div class=popover tabindex=-1 ng-show=content style=\"width: 500px; max-width: 500px\" ng-attr-id=\"{{'benchmarkingPopoverId_' + content}}\"><div class=arrow></div><h3 class=popover-title ng-bind-html=title ng-show=title></h3><div class=popover-content><button type=button ng-click=viewModel.closeActivePopover() style=\"position: absolute;top: 8px;right: 10px; background-color: #4488d1;border: 1px solid #dddddd;color: white\">&times;</button><div class=container style=width:auto><div id=tabs><ul class=\"nav nav-pills nav-pills-extra-margin\"><li id=KeyNumbersButton ng-class=\"{'active':viewModel.selectedTooltipTAb=='KeyNumbers'}\"><a class=link ng-click=viewModel.showKeyNumbers()>{{'KeyNumbers' | translate}}</a></li></ul></div><div style=\"margin-top: 5px\" ng-if=\"viewModel.keyNumbersObject != undefined\"><div ng-if=\"viewModel.keyNumbersObject.type == 'PercentilChart_DbAverageSelectedSerie'\"><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'TypeName' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.typeName}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'Score' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.attributeValue}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'PercentageOfFishSite' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.sitePercentage}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'SampleSite' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.siteSamples}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'PercentageOfFishDb' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.dbPercentage}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'SampleDb' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.dbSamples}}</small></span></div></div></div><div ng-if=\"viewModel.keyNumbersObject.type == 'PercentilChart_SiteSelectedSerie'\"><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'TypeName' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.typeName}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'AssessmentGroups' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.groups}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'Vaccines' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.vaccines}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'Score' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.attributeValue}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'PercentageOfFishSite' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.sitePercentage}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'SampleSite' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.siteSamples}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'PercentageOfFishDb' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.dbPercentage}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'SampleDb' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.dbSamples}}</small></span></div></div></div><div ng-if=\"viewModel.keyNumbersObject.type == 'AverageScore_DbAverageSelectedSerie'\"><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'TypeName' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.typeName}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'AssessmentGroups' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.groups}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'Vaccines' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.vaccines}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'Score' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.siteScore}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'AverageScore' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.averageDbScore}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'SiteSamples' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.siteSamples}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'DbSamples' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.dbSamples}}</small></span></div></div></div><div ng-if=\"viewModel.keyNumbersObject.type == 'AverageScore_SiteSelectedSerie'\"><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'TypeName' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.typeName}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'Score' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.siteScore}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'AverageScore' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.averageDbScore}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'SiteSamples' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.siteSamples}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'DbSamples' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.dbSamples}}</small></span></div></div></div></div></div></div></div>");
  $templateCache.put("app.web/modules/benchmarking/precisionScorePopover.row.tpl.html",
    "<div class=grid-text ng-switch=header.propertyName><span ng-switch-when=assessmentDate>{{getItemPropertyValue(header.index,'propertyName',item) | dateformat}}</span> <span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item)}}</span></div>");
  $templateCache.put("app.web/modules/benchmarking/precisionScorePopover.tpl.html",
    "<div class=popover tabindex=-1 ng-show=content style=\"width: 500px; max-width: 500px\" ng-attr-id=\"{{'benchmarkingPopoverId_' + content}}\"><div class=arrow></div><h3 class=popover-title ng-bind-html=title ng-show=title></h3><div class=popover-content><button type=button ng-click=viewModel.closeActivePopover() style=\"position: absolute;top: 8px;right: 10px; background-color: #4488d1;border: 1px solid #dddddd;color: white\">&times;</button><div class=container style=width:auto><div id=tabs><ul class=\"nav nav-pills nav-pills-extra-margin\"><li id=KeyNumbersButton ng-class=\"{'active':viewModel.selectedTooltipTAb=='KeyNumbers'}\"><a class=link ng-click=viewModel.showKeyNumbers()>{{'KeyNumbers' | translate}}</a></li><li id=AssessmentsButton ng-class=\"{'active':viewModel.selectedTooltipTAb=='Assessments'}\"><a class=link ng-click=viewModel.showAssessments()>{{'Assessments' | translate}}</a></li></ul></div><div style=\"margin-top: 5px\" ng-if=\"viewModel.keyNumbersObject != undefined\"><div ng-if=\"viewModel.selectedTooltipTAb == 'KeyNumbers'\"><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'GenerationYearClass' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.generationClass}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'AveragePrecisionScore' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.avgPrecisionScore}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'AverageWeight' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.averageWeight}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'StandardDesviationWeight' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.standardDeviation}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'NumberOfSamples' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.numberOfSamples}}</small></span></div></div><div class=row><div class=col-md-3><span class=\"selector-label input-small text-nowrap\">{{'DbNumberOfSamples' | translate}}:<small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.databaseNumberOfSamples}}</small></span></div></div></div><div class=row ng-if=\"viewModel.selectedTooltipTAb == 'Assessments'\"><av-grid headers=viewModel.precisionScoreHeaders type=grid load-more=viewModel.loadData() show-table-grid-lines=false load-more-text=\"'Load more ..'\" allow-load-on-scroll=false toggle-reload=viewModel.toggleReload item-template=viewModel.itemTemplate></av-grid></div></div></div></div></div>");
  $templateCache.put("app.web/modules/benchmarking/sideEffectsPopover.tpl.html",
    "<div class=popover tabindex=-1 ng-show=content style=\"width: 500px; max-width: 500px\" ng-attr-id=\"{{'benchmarkingPopoverId_' + content}}\"><div class=arrow></div><h3 class=popover-title ng-bind-html=title ng-show=title></h3><div class=popover-content><button type=button ng-click=viewModel.closeActivePopover() style=\"position: absolute;top: 8px;right: 10px; background-color: #4488d1;border: 1px solid #dddddd;color: white\">&times;</button><div class=container style=width:auto><div id=tabs><ul class=\"nav nav-pills nav-pills-extra-margin\"><li id=KeyNumbersButton ng-class=\"{'active':viewModel.selectedTooltipTAb=='KeyNumbers'}\"><a class=link ng-click=viewModel.showKeyNumbers()>{{'KeyNumbers' | translate}}</a></li><li id=AssessmentsButton ng-class=\"{'active':viewModel.selectedTooltipTAb=='Assessments'}\"><a class=link ng-click=viewModel.showAssessments()>{{'Assessments' | translate}}</a></li></ul></div><div style=\"margin-top: 5px\" ng-if=\"viewModel.keyNumbersObject != undefined\"><div ng-if=\"viewModel.selectedTooltipTAb == 'KeyNumbers'\"><div class=row><div class=col-md-4><label class=\"selector-label input-small text-nowrap\">{{'AssessmenType' | translate}}:</label></div><div class=col-md-2><small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.assessmentTypeName}}</small></div></div><div class=row><div class=col-md-4><label class=\"selector-label input-small text-nowrap\">{{'AssessmentGroup' | translate}}:</label></div><div class=col-md-2><small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.assessmentGroup}}</small></div></div><div class=row><div class=col-md-4><label class=\"selector-label input-small text-nowrap\">{{'Vaccines' | translate}}:</label></div><div class=col-md-2><small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.vaccines}}</small></div></div><div class=row><div ng-if=viewModel.visceralMelaninChartIsSelected() class=col-md-4><label class=\"selector-label input-small text-nowrap\">{{'AverageVisceralMelaninGroup' | translate}}:</label></div><div ng-if=viewModel.parietalMelaninChartChartIsSelected() class=col-md-4><label class=\"selector-label input-small text-nowrap\">{{'AverageParietalMelaninGroup' | translate}}:</label></div><div ng-if=viewModel.speilbergScoreChatIsSelected() class=col-md-4><label class=\"selector-label input-small text-nowrap\">{{'AverageSpeilbergScoreGroup' | translate}}:</label></div><div class=col-md-1><small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.averageAttributeScore}}</small></div></div><div class=row><div class=col-md-4><label class=\"selector-label input-small text-nowrap\">{{'AverageDatabaseScore' | translate}}:</label></div><div class=col-md-1><small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.averageDatabaseScore}}</small></div></div><div class=row><div class=col-md-4><label class=\"selector-label input-small text-nowrap\">{{'NumberOfSamples' | translate}}:</label></div><div class=col-md-1><small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.numberOfSamples}}</small></div></div><div class=row><div class=col-md-4><label class=\"selector-label input-small text-nowrap\">{{'DbNumberOfSamples' | translate}}:</label></div><div class=col-md-1><small class=\"selector-label input-small\">{{viewModel.keyNumbersObject.databaseNumberOfSamples}}</small></div></div></div><div class=row ng-if=\"viewModel.selectedTooltipTAb == 'Assessments'\"><av-grid style=\"max-height: 200px\" headers=viewModel.sideEffectsHeaders type=table load-more=viewModel.loadData() show-table-grid-lines=false load-more-text=\"'Load more ..'\" allow-load-on-scroll=false toggle-reload=viewModel.toggleReload><div class=grid-text ng-switch=header.propertyName><span ng-switch-when=assessmentDate>{{getItemPropertyValue(header.index,'propertyName',item) | dateformat}}</span> <span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item)}}</span></div></av-grid></div></div></div></div></div>");
  $templateCache.put("app.web/modules/clients/clients.item.tpl.html",
    "<div ng-switch=header.propertyName><div class=grid-text ng-switch-when=Active ng-switch=\"getItemPropertyValue(header.index,'propertyName',item)\"><a ng-switch-when=true ng-click=\"header.action('toggleActive',item)\">{{'Action_Disable'| translate}}</a> <a ng-switch-default ng-click=\"header.action('toggleActive',item)\">{{'Action_Enable' | translate}}</a></div><div class=grid-text ng-switch-when=Edit><a ng-click=\"header.action('edit',item)\">{{'Action_Edit'| translate}}</a></div><div class=grid-text ng-switch-when=Secret ng-switch=\"getItemPropertyValue(header.index,'propertyName',item)\"><button class=\"btn btn-xs btn-link\" ngclipboard data-clipboard-text=\"{{getItemPropertyValue(header.index,'propertyName',item)}}\"><i class=\"fa fa-copy\" style=\"outline: 0\"></i></button></div><div class=grid-text ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item) | translate}}</div></div>");
  $templateCache.put("app.web/modules/mail/mail.item.tpl.html",
    "<div ng-switch=header.name><div class=grid-text ng-switch-when=Options><div ng-switch=header.mailType><a ng-switch-when=Assessment ng-click=\"header.editAndResend(item.sentMailId, item.key, item.assessmentTypeId, item.siteId)\">{{'Action_Edit_And_Resend' | translate}}</a> <a ng-switch-when=Prescription ng-click=\"header.editAndResend(item.sentMailId, item.key, item.siteId)\">{{'Action_Edit_And_Resend' | translate}}</a></div></div><div class=grid-text ng-switch-when=Date>{{getItemPropertyValue(header.index,'propertyName',item) | dateformat}}</div><div class=grid-text ng-switch-when=NAHContactAssessment>{{getItemPropertyValue(header.index,'propertyName',item).join()}}</div><div class=grid-text ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item) | translate}}</div></div>");
  $templateCache.put("app.web/modules/map_view/map.row.tpl.html",
    "<div class=grid-text ng-switch=header.name><span ng-switch-when=Date>{{getItemPropertyValue(header.index,'propertyName',item) | dateformat}}</span> <span ng-switch-when=\"Assessment gr\">{{getItemPropertyValue(header.index,'propertyName',item) | assessmentdiscriminator}}</span><div ng-switch-when=\"Follow up\" ng-switch=\"getItemPropertyValue(header.index,'propertyName',item)\"><span ng-switch-when=3 class=\"label label-followup-needed\"><span>{{'FollowUpNeededShort' | translate}}</span> </span><span ng-switch-when=2 class=\"label label-followup-recommended\"><span>{{'FollowUpRecommendedShort' | translate}}</span> </span><span ng-switch-when=1 class=\"label label-followup-notneeded\"><span>{{'NoFollowUpShort' | translate}}</span></span></div><span ng-switch-when=\"Elanco Repr\">{{getItemPropertyValue(header.index,'propertyName',item).join()}}</span> <span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item)}}</span></div>");
  $templateCache.put("app.web/modules/map_view/map.tpl.html",
    "<div class=container style=\"width: auto\"><div class=row><div class=col-md-10><label class=\"selector-label large text-nowrap\">{{'StatusFor' | translate}}</label><label class=\"selector-label text-nowrap\">{{parameter.SiteName}}</label></div></div><div class=row><div class=col-md-10><label class=\"selector-label text-nowrap\">{{'Company' | translate}}</label><label class=\"selector-label text-nowrap\">{{parameter.CompanyName}}</label></div></div><div class=row><div class=col-md-10><label class=\"selector-label text-nowrap\">{{'Site' | translate}}</label><label class=\"selector-label text-nowrap\">{{parameter.SiteName}}</label></div></div><div class=row><div class=col-md-10><label class=\"selector-label text-nowrap\">{{'SiteContact' | translate}}</label><label class=\"selector-label text-nowrap\">{{parameter.ContactPerson}}</label></div></div><div class=row><div class=col-md-10><label class=\"selector-label text-nowrap\">{{'NAHContact' | translate}}</label><label class=\"selector-label text-nowrap\">{{parameter.VetContactPerson}}</label></div></div><div class=row><div class=col-md-12><av-grid headers=parameter.mapPopoverHeader type=grid dynamic-load=false grid-items=parameter.gridData ng-style=\"{'width':parameter.isMapEventView?'720px':'920px'}\" item-template=\"'modules/map_view/map.row.tpl.html'\" show-table-grid-lines=false allow-load-on-scroll=false></av-grid></div></div></div>");
  $templateCache.put("app.web/modules/map_view/noaddress.tpl.html",
    "<div><div ng-repeat=\"site in  viewModel.undefinedCoordinates\" style=\"float: left\"><span>{{site.siteName}}</span><span ng-if=!$last>,&nbsp;</span><div ng-if=\"$index % 5 == 0\"></div></div></div>");
  $templateCache.put("app.web/modules/prepare_report/prepare.report.tpl.html",
    "<div id=main_content_wrap class=\"outer ngdialog-contect-height\" ng-controller=\"app.web.controllers.PrepareReportController as viewModel\"><div class=modal-header><h4 class=modal-title ng-if=viewModel.isMedicationPerUser translate>MedicationPerUser</h4><h4 class=modal-title ng-if=viewModel.isMedicationPerCustomer translate>MedicationPerCustomer</h4><div class=ngdialog-close ng-click=closeThisDialog()></div></div><section id=main_content class=\"inner main-inner modal-body\" style=\"overflow: hidden\"><div style=\"display: flex\"><div id=filter-list-zone ng-if=viewModel.isShowFilters() style=\"min-width: 200px !important; margin-left: 10px\"><div class=row style=\"margin-bottom: 12px\"><label style=\"margin-left: 4px\" class=text-nowrap translate>DateRange</label><div style=\"width: 200px !important; margin-left: 4px\"><av-datepicker-range id=\"inputReportPeriod \" class=\"input-group input-group-sm\" input-class=\" 'form-control' \" allow-future-dates=\"true \" opens=\" 'right'\" selected-date-range=\"viewModel.dateRange \"></av-datepicker-range></div></div><div class=row style=\"margin-bottom: 12px\" ng-repeat=\"f in viewModel.filterList | orderBy: ['order']\"><label class=text-nowrap translate style=\"margin-left: 4px\">{{f.filterName}}</label><div style=\"width: 200px !important; margin-top: -4px\"><av-selector filter=f.filter></av-selector></div></div><div class=row style=\"width: 100%\"><div style=\"display: flex; justify-content: space-between; margin-left: 4px\"><a title=\"show report \" class=\"btn btn-primary\" ng-click=viewModel.showReport() translate>ShowReport </a><a title=\"show report \" class=\"btn btn-default\" style=\"color: grey; font-weight: lighter; margin-right: -4px\" ng-click=closeThisDialog()>{{'Close' | translate}}</a></div></div></div><div id=pdf-view-zone style=\"min-width: 600px;margin-left: 20px\"><div class=module-content-well av-screen-resize ng-style=style()><div class=\"btn-toolbar pdf-viewer-button-toolbar\" role=toolbar><div class=btn-group role=group><button type=button class=\"btn btn-default\" ng-click=viewModel.selectPage(1) ng-disabled=\"medicationPdfViewer.page==1 || viewModel.isRendering\"><i class=\"fa fa-step-backward\"></i></button> <button type=button class=\"btn btn-default\" ng-click=viewModel.selectPage(medicationPdfViewer.page-1) ng-disabled=\"medicationPdfViewer.page==1 || viewModel.isRendering\"><i class=\"fa fa-lg fa-caret-left\"></i></button><div class=btn-group role=group uib-dropdown><button type=button class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle ng-disabled=viewModel.isRendering>{{'Page' | translate}} {{medicationPdfViewer.page}} {{'of' | translate}} {{medicationPdfViewer.total}} <span class=caret></span></button><ul class=\"uib-dropdown-menu scrollable-dropdown\" role=menu><li ng-repeat=\"item in viewModel.pages track by $index\" ng-click=viewModel.selectPage(item)><a href=#>{{item}}</a></li></ul></div><button type=button class=\"btn btn-default\" ng-click=viewModel.selectPage(medicationPdfViewer.page+1) ng-disabled=\"medicationPdfViewer.page==medicationPdfViewer.total || viewModel.isRendering\"><i class=\"fa fa-lg fa-caret-right\"></i></button> <button type=button class=\"btn btn-default\" ng-click=viewModel.selectPage(medicationPdfViewer.total) ng-disabled=\"medicationPdfViewer.page==medicationPdfViewer.total || viewModel.isRendering\"><i class=\"fa fa-step-forward\"></i></button></div><div class=btn-group role=group><button type=button class=\"btn btn-default\" ng-click=viewModel.saveReport() ng-disabled=viewModel.isRendering><i class=\"fa fa-save\"></i></button></div></div><div pdf-viewer=\"{mouseZoom: false, mousePan: false}\" pdf-url=\"''\" ng-hide=viewModel.isRendering id=medication-pdf-viewer></div><div></div><div class=pdf-viewer-loading ng-show=viewModel.isRendering><i class=\"fa fa-2x fa-spinner fa-spin\"></i></div></div></div></div></section></div>");
  $templateCache.put("app.web/modules/prescription/file.cell.tpl.html",
    "<div class=multi-row ng-switch=col.name><div ng-switch-default class=text-center><input ng-model=row.entity.description></div><div ng-switch-when=delete class=text-center style=\"margin-top: 1px\"><a ng-click=deleteRow(row);grid.appScope.deleteRow(rowRenderIndex)><span class=\"fa-stack fa-sm\" style=\"vertical-align: -65%\"><i class=\"fa fa-circle fa-stack-2x\"></i> <i class=\"fa fa-times fa-stack-1x fa-inverse\"></i></span></a></div><div ng-switch-when=File class=\"text-center form-group\" ng-class=\"{'has-error':row.entity.error.haserror}\"><div class=\"form-control form-control-attachment\" flow-init=\"{target: grid.appScope.attachementUploadTarget(), singleFile: true,testChunks:false,query: { prescriptionId: grid.appScope.prescriptionData.prescriptionId, source: 'flow_query' }}\" flow-files-submitted=grid.appScope.upload($flow) flow-file-success=grid.appScope.setImageData($flow.files,$message,row.entity) flow-file-error=\"grid.appScope.fileErrorHandle( $file, $message,$flow, row.entity)\" av-validation-tooltip=grid.appScope.errorMessageGet(row.entity[col.name]) av-validation-tooltip-enabled=row.entity.error.haserror av-validation-tooltip-placement=left><div ng-if=\"!$flow.files.length && !row.entity.fileName\"><i class=\"fa fa-paperclip padding\" flow-btn></i></div><a ng-if=\"$flow.files.length || row.entity.fileName\" data-content=true data-container=body data-placement=left bs-ng-popover data-template=modules/prescription/uploadFile.tpl.html data-animation=am-flip-x class=\"label-text-overflow file-name\">{{ row.entity.fileName}}</a></div></div></div>");
  $templateCache.put("app.web/modules/prescription/prescription.grid.tpl.html",
    "<div class=\"data-grid panel panel-primary\"><div class=panel-heading><div class=row><div ng-repeat=\"header in ::headers\" ng-class=\"[header.className,{'header-sortable': header.sort!='no'}]\" class=header-text ng-click=sortBy(header)><i class=\"pull-left fa fa-fw\" ng-class=\"{'fa-caret-down': header.sort == 'desc', 'fa-caret-up': header.sort == 'asc', '' : header.sort == 'none'}\"></i>{{::header.text}}</div></div></div><div class=panel-body><div loading-container=busy><div ng-repeat=\"item in items track by $index\" title={{::popoverData.title}} data-placement={{::popoverData.placement}} data-content={{::popoverData.content}} data-template={{::popoverData.template}} data-delay={{popoverData.delay}} data-trigger={{popoverData.trigger}} data-container=body bs-popover><div class=\"grid grid-flex-row-height\"><div ng-repeat=\"header in ::headers\" ng-class=\"getPropertyValue(header.index,'className')\"><av-item item-template=::itemTemplate is-html=\"::getPropertyValue(header.index,'html')\" get-item-property-value=\"::getItemPropertyValue(header.index,'propertyName',item)\" item=::item header=::header></av-item></div></div></div></div><div class=\"col-md-12 text-center\"><button ng-if=::showLoadMore ng-click=loadData() class=\"btn btn-primary-outline\"><span translate>LoadMore</span></button></div></div></div>");
  $templateCache.put("app.web/modules/prescription/prescription.item.tpl.html",
    "<div class=grid-text ng-switch=header.name ng-class=\"{'text-overflow': header.textOverflow}\" ng-attr-title=\"{{::header.textOverflow && header.name !== 'Files' ? getItemPropertyValue(header.index,'propertyName',item) : ''}}\"><div class=grid-text><a ng-switch-when=Site ng-click=header.selectSite(item.siteId) stop-event>{{getItemPropertyValue(header.index,'propertyName',item)}}</a></div><div class=grid-text><a ng-switch-when=Options stop-event><ng-container ng-if=!item.isDraft><av-menu type=Prescription ng-model=item level=0 confirm=header.confirm(item) toggle-locking=header.toggleLocking toggle-activating=header.toggleActivating></av-menu></ng-container><ng-container ng-if=\"item.isDraft && item.isDraft === true\"><av-menu type=DraftPrescription ng-model=item level=0 confirm=header.confirm(item)></av-menu></ng-container></a></div><div><div ng-switch-when=Files stop-event><ul ng-if=\"item.prescriptionFiles.length>0\"><li role=menuitem ng-repeat=\"file in item.prescriptionFiles\" ng-click=header.openAttachedFile(item.prescriptionId,file) ng-attr-title={{file}}><a role=menuitem tabindex=-1 href=#>{{file}}</a></li></ul></div></div><div class=grid-text><span ng-switch-when=Date>{{getItemPropertyValue(header.index,'propertyName',item) | dateformat}}</span></div><div class=grid-text><span ng-switch-when=CreatedTime>{{getItemPropertyValue(header.index,'propertyName',item) | datetimeformat}}</span></div><div class=grid-text><span ng-switch-when=Activating><span ng-if=!item.isActivate class=\"label label-activating-deactivated\"><span>{{'Prescription_Deactivated' | translate}}</span> </span><span ng-if=item.isActivate class=\"label label-activating-activated\"><span>{{'Prescription_Activated' | translate}}</span></span></span></div><span ng-switch-when=\"\"><i ng-if=item.isLocked class=\"fa fa-lock\"></i> <i ng-if=\"item.isDraft && item.isDraft === true\" class=\"fa fa-pencil-square-o text-danger\"></i></span><div class=grid-text><span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item)}}</span></div></div>");
  $templateCache.put("app.web/modules/prescription/rowHeader.tpl.html",
    "<div class=ui-grid-disable-selection><div class=ui-grid-cell-contents><ui-grid-selection-row-header-buttons>{{rowRenderIndex + 1}}</ui-grid-selection-row-header-buttons></div></div>");
  $templateCache.put("app.web/modules/prescription/uploadFile.tpl.html",
    "<div class=popover tabindex=-1 ng-show=content style=\"outline: 0\"><div class=arrow></div><h3 class=popover-title ng-bind-html=title ng-show=title></h3><div class=popover-content><form name=popoverForm><div class=form-group ng-init=\"file = row.entity\"><div><div style=\"padding: 12px; min-width: 150px\"><a ng-click=grid.appScope.openAttachment(file.fileName)>{{file.fileName}}</a></div><a ng-show=\"($flow.files.length || file.fileName)\" class=btn style=\"position: absolute; bottom: 0; left: 0; font-weight: normal\" ng-click=grid.appScope.removeImageData($flow,file) transalte>Remove</a> <a ng-click=$hide() class=\"pull pull-right\" style=\"position: absolute; bottom: 6px; right: 16px\" translate>Action_Close</a></div></div></form></div></div>");
  $templateCache.put("app.web/modules/refreshtoken/refreshtoken.item.tpl.html",
    "<div ng-switch=header.propertyName><div class=grid-text ng-switch-default><div ng-switch=header.name><div class=grid-text ng-switch-when=IssuedUtc>{{getItemPropertyValue(header.index,'propertyName',item) | datetimeformat}}</div><div class=grid-text ng-switch-when=ExpiresUtc>{{getItemPropertyValue(header.index,'propertyName',item) | datetimeformat}}</div><div class=grid-text ng-switch-when=\"\"><a ng-click=\"header.action('Remove',item)\">{{'Action_Logoff_device' | translate}}</a></div><div class=grid-text ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item) | translate}}</div></div></div></div>");
  $templateCache.put("app.web/modules/setup/attribute_enum/attribute_enum.list.item.tpl.html",
    "<div class=grid-text ng-switch=header.name ng-class=\"{'text-overflow': header.textOverflow}\" ng-attr-title=\"{{header.textOverflow ? getItemPropertyValue(header.index,'propertyName',item) : ''}}\"><div class=grid-text ng-if=!item.used><a ng-switch-when=Options stop-event><av-menu type=SetupOptions ng-model=item level=0 confirm=header.confirm(item)></av-menu></a></div><div class=grid-text><span ng-switch-when=Active><i ng-if=item.active class=\"fa fa-check-square-o\"></i> <i ng-if=!item.active class=\"fa fa-square-o\"></i></span></div><div class=grid-text><span ng-switch-when=SortOrder><i class=\"fa fa-chevron-up\" ng-class=\"{'fa-disabled':item.sortOrder == 1}\" ng-click=\"item.sortOrder != 1 && header.changeSort(item,'up')\"></i> <i class=\"fa fa-chevron-down\" ng-class=\"{'fa-disabled':item.sortOrder == $parent.items[$parent.items.length-1].sortOrder}\" ng-click=\"item.sortOrder != $parent.items[$parent.items.length-1].sortOrder && header.changeSort(item,'down')\"></i></span></div><div class=\"grid-text text-center\"><span ng-switch-when=UsedInRegistrations><i ng-class=\"{'fa fa-check':item.used}\"></i></span></div><div class=grid-text><span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item)}}</span></div></div>");
  $templateCache.put("app.web/modules/setup/base_setup/base.setup.item.tpl.html",
    "<div ng-switch=header.propertyName><div class=grid-text ng-switch-when=active ng-switch=\"getItemPropertyValue(header.index,'propertyName',item)\"><a ng-switch-when=true ng-click=\"header.action('toggleActive',item)\">{{'Action_Disable'| translate}}</a> <a ng-switch-default ng-click=\"header.action('toggleActive',item)\">{{'Action_Enable' | translate}}</a></div><div ng-switch-when=\"\"><a ng-click=\"header.action('edit',item)\"><i class=\"fa fa-pencil-square-o\" rel=tooltip title=\"{{'Action_Edit'| translate}}\"></i></a> <span></span> <a av-confirm confirm-if=true confirm-title={{header.confirm.title}} confirm-message={{header.confirm.message}} ng-click=\"header.action('delete',item)\"><i class=\"fa fa-times-circle text-danger\" rel=tooltip title=\"{{'Action_Delete'| translate}}\"></i></a></div><div class=grid-text ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item) | translate}}</div></div>");
  $templateCache.put("app.web/modules/setup/supplier/supplier.list.item.tpl.html",
    "<div class=grid-text ng-switch=header.name ng-class=\"{'text-overflow': header.textOverflow}\" ng-attr-title=\"{{header.textOverflow ? getItemPropertyValue(header.index,'propertyName',item) : ''}}\"><div class=grid-text><a ng-switch-when=Options stop-event><av-menu type=SetupOptions ng-model=item level=0 confirm=header.confirm(item)></av-menu></a></div><div class=grid-text><span ng-switch-when=Active><i ng-if=item.active class=\"fa fa-check-square-o\"></i> <i ng-if=!item.active class=\"fa fa-square-o\"></i></span></div><div class=grid-text><span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item)}}</span></div></div>");
  $templateCache.put("app.web/modules/setup/treatment_product/treatment.product.item.tpl.html",
    "<div class=grid-text ng-switch=header.name ng-class=\"{'text-overflow': header.textOverflow}\" ng-attr-title=\"{{header.textOverflow ? getItemPropertyValue(header.index,'propertyName',item) : ''}}\"><div class=grid-text><a ng-switch-when=Supplierss ng-click=header.selectSite(item.supplierId) stop-event>{{getItemPropertyValue(header.index,'propertyName',item)}}</a></div><div class=grid-text><a ng-switch-when=Options stop-event><av-menu type=SetupOptions ng-model=item level=0 confirm=header.confirm(item)></av-menu></a></div><div class=grid-text><span ng-switch-when=Date>{{getItemPropertyValue(header.index,'propertyName',item) | dateformat}}</span></div><div class=grid-text><span ng-switch-when=Active><i ng-if=item.active class=\"fa fa-check-square-o\"></i> <i ng-if=!item.active class=\"fa fa-square-o\"></i> </span><span ng-switch-when=IsFromFarmer><i ng-if=item.isFromFarmer class=\"fa fa-check-square-o\"></i> <i ng-if=!item.isFromFarmer class=\"fa fa-square-o\"></i></span></div><div class=grid-text><span ng-switch-when=CreatedTime>{{getItemPropertyValue(header.index,'propertyName',item) | datetimeformat}}</span></div><span ng-switch-when=\"\"><i ng-if=item.isLocked class=\"fa fa-lock\"></i></span><div class=grid-text><span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item)}}</span></div></div>");
  $templateCache.put("app.web/modules/setup/treatment_product_producer/treatment.product.producer.list.item.tpl.html",
    "<div class=grid-text ng-switch=header.name ng-class=\"{'text-overflow': header.textOverflow}\" ng-attr-title=\"{{header.textOverflow ? getItemPropertyValue(header.index,'propertyName',item) : ''}}\"><div class=grid-text><a ng-switch-when=Options stop-event><av-menu type=SetupOptions ng-model=item level=0 confirm=header.confirm(item)></av-menu></a></div><div class=grid-text><span ng-switch-when=Active><i ng-if=item.active class=\"fa fa-check-square-o\"></i> <i ng-if=!item.active class=\"fa fa-square-o\"></i></span></div><div class=grid-text><span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item)}}</span></div></div>");
  $templateCache.put("app.web/modules/upcoming_events/event.tpl.html",
    "<div class=\"popover popover-blue event-popover\" tabindex=-1 ng-show=content><div class=arrow></div><h3 class=popover-title ng-bind-html=title ng-show=title></h3><div class=popover-content><div class=\"container-fluid text-nowrap\"><div class=row><div class=col-md-5>{{'Type' | translate}}: {{item.assessmentTypeName}}</div><div class=col-md-7>{{'NAHContact' | translate}}: {{item.contactName}}</div></div><div class=\"row row-height-10\"></div><div class=row><div class=col-md-5>{{'Date' | translate}}: {{item.eventDate | dateformat}}</div><div class=col-md-7>{{'Fishgroup' | translate}}: {{item.fishgroup.fishgroupName}}</div></div><div class=\"row row-height-10\"></div><div class=row><div class=col-md-12>{{'Comments' | translate}}:</div></div><div class=row><div class=col-md-12><div class=form-group><textarea class=\"form-control fix-line-break\" readonly ng-model=item.comments msd-elastic=\\n\\n></textarea></div></div></div></div></div></div>");
  $templateCache.put("app.web/modules/upcoming_events/upcoming.events.item.tpl.html",
    "<div class=grid-text ng-switch=header.name ng-class=\"{'text-overflow': header.textOverflow}\" ng-attr-title=\"{{header.textOverflow ? getItemPropertyValue(header.index,'propertyName',item) : ''}}\"><div class=grid-text><a ng-switch-when=Site ng-click=header.selectSite(item.siteId) stop-event>{{getItemPropertyValue(header.index,'propertyName',item)}}</a></div><div class=grid-text><a ng-switch-when=Options stop-event><av-menu type=Event event=item level=0 confirm=header.confirm(item)></av-menu></a></div><div class=grid-text><span ng-switch-when=Date>{{getItemPropertyValue(header.index,'propertyName',item) | dateformat}}</span></div><div class=grid-text><span ng-switch-default>{{getItemPropertyValue(header.index,'propertyName',item)}}</span></div></div>");
}]);

'use strict';
var app;
(function (app) {
    var common;
    (function (common) {
        var directives;
        (function (directives) {
            var TemplateItem = (function () {
                function TemplateItem() {
                    this.restrict = 'AE';
                    this.scope = {
                        assessment: '=',
                        item: '=',
                        templateRegistration: '=',
                        getSelectionModel: '&',
                        selectionChange: '&',
                        multiselectChange: '&',
                        hasError: '&',
                        errorMessageGet: '&',
                        required: '=',
                        showLabels: '=',
                        showTemplateItem: '=',
                        addFishgroup: '&',
                        setTabindex: '@'
                    };
                }
                //public templateUrl = '../app.common/directives/templateItem/templateItem.html';
                TemplateItem.prototype.templateUrl = function (element, attributes) {
                    if (attributes.type == "desktop") {
                        if (attributes.itemisreadonly)
                            return "app.common/directives/templateItem/templateItem.desktop.readonly.html";
                        else
                            return "app.common/directives/templateItem/templateItem.desktop.html";
                    }
                    return "app.common/directives/templateItem/templateItem.html";
                };
                TemplateItem.prototype.link = function ($scope, element, attributes) {
                    //$scope.$watch('item', (newValue,oldValue) => {
                    //    (<any>$scope).required = newValue.attribute.required?"Required":"";
                    //});
                    $scope.assessmentDatePickerOptions = {
                        singleDatePicker: true,
                        opens: "left",
                        showWeekNumbers: true
                    };
                    $scope.unformatDecimal = function (value) {
                        return common.utils.unformatDecimal(value);
                    };
                };
                return TemplateItem;
            })();
            directives.TemplateItem = TemplateItem;
        })(directives = common.directives || (common.directives = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerDirective('TemplateItem');

/// <reference path="../../../_typings.ts"/>
var app;
(function (app) {
    var common;
    (function (common) {
        var directives;
        (function (directives) {
            var AvInventoryListDirectiveController = (function () {
                function AvInventoryListDirectiveController($scope) {
                    this.$scope = $scope;
                    this.SiteTypeMappingProductionStage = [
                        {
                            siteTypeValue: "Broodstock",
                            productionStageKey: "ProductionStage_Broodstock"
                        },
                        {
                            siteTypeValue: "Smolt",
                            productionStageKey: "ProductionStage_Smolt"
                        },
                        {
                            siteTypeValue: "Seafarm",
                            productionStageKey: "ProductionStage_Seafarm"
                        },
                        {
                            siteTypeValue: "Hatchery",
                            productionStageKey: "ProductionStage_Hatchery"
                        },
                        {
                            siteTypeValue: "Juvenile",
                            productionStageKey: "ProductionStage_Juvenile"
                        },
                        {
                            siteTypeValue: "Shell fish etc.",
                            productionStageKey: "ProductionStage_ShellFish"
                        },
                    ];
                    this.initialize($scope);
                }
                AvInventoryListDirectiveController.prototype.initialize = function ($scope) {
                    var _this = this;
                    $scope.$watch("inventoryListHeightInPixel", function () {
                        if (!$scope.inventoryListHeightInPixel)
                            $scope.inventoryHeightExpression = { height: 400 + "px" };
                        else
                            $scope.inventoryHeightExpression = {
                                height: $scope.inventoryListHeightInPixel + "px"
                            };
                    });
                    $scope.$watch("prescription", function () { });
                    $scope.$watch("farmerInventory", function () {
                        if ($scope.prescription)
                            $scope.selectAll($scope.prescription.units);
                    });
                    $scope.$watch("selectedFarmerSpeciesName", function () {
                        if (!app.common.utils.isNullOrUndefinedOrEmpty($scope.selectedFarmerSpeciesName)) {
                            _this.$scope.prescription.specieId = _this.mapSpecies($scope.selectedFarmerSpeciesName);
                        }
                    });
                    $scope.$watch("selectedFarmerProductionStage", function () {
                        if (!app.common.utils.isNullOrUndefinedOrEmpty($scope.selectedFarmerProductionStage)) {
                            _this.$scope.prescription.productionStageId = _this.mapProductionStage($scope.selectedFarmerProductionStage);
                        }
                    });
                    $scope.clearAll = function () {
                        _.forEach($scope.farmerInventory, function (unit) {
                            unit.isSelected = false;
                        });
                        _this.$scope.prescription.units = null;
                        _this.calculateFarmerInventoryTotal($scope);
                    };
                    $scope.selectAll = function (units) {
                        _.forEach($scope.farmerInventory, function (unit) {
                            if (!!units) {
                                var unitsArray = units.split(",").map(Number);
                                unit.isSelected = unitsArray.indexOf(unit.unitId) > -1;
                            }
                            else
                                unit.isSelected = true;
                        });
                        if (!units)
                            _this.$scope.prescription.units = null;
                        _this.setPrescriptionAndStage($scope);
                        _this.calculateFarmerInventoryTotal($scope);
                    };
                    $scope.setSelectedUnit = function (unit) {
                        unit.isSelected = !unit.isSelected;
                        _this.setPrescriptionUnits($scope);
                        _this.setPrescriptionAndStage($scope);
                        _this.calculateFarmerInventoryTotal($scope);
                    };
                };
                AvInventoryListDirectiveController.prototype.getSelectedUnits = function ($scope) {
                    return _.filter($scope.farmerInventory, ["isSelected", true]);
                };
                AvInventoryListDirectiveController.prototype.calculateFarmerInventoryTotal = function ($scope) {
                    var data = this.getSelectedUnits($scope);
                    var closeCount = _.sumBy(data, function (item) {
                        return item.closeCount;
                    });
                    var closeBiomass = _.sumBy(data, function (item) {
                        return item.closeBiomass;
                    });
                    $scope.farmerInventoryTotals = {
                        closeCount: closeCount,
                        closeBiomass: closeBiomass,
                        closeWeight: closeBiomass !== 0 ? (closeBiomass / closeCount) * 1000 : 0
                    };
                    // $scope.prescription.weight =
                    //   $scope.farmerInventoryTotals.closeWeight === 0
                    //     ? undefined
                    //     : $scope.farmerInventoryTotals.closeWeight;
                    // $scope.prescription.biomass =
                    //   $scope.farmerInventoryTotals.closeBiomass === 0
                    //     ? undefined
                    //     : $scope.farmerInventoryTotals.closeBiomass;
                };
                AvInventoryListDirectiveController.prototype.setPrescriptionUnits = function ($scope) {
                    //Set prescription.units to null when all units are selected
                    if (_.every($scope.farmerInventory, ["isSelected", true])) {
                        this.$scope.prescription.units = null;
                    }
                    else {
                        var units = this.getSelectedUnits($scope);
                        this.$scope.prescription.units = _.map(units, "unitId").join(", ");
                    }
                };
                AvInventoryListDirectiveController.prototype.setPrescriptionAndStage = function ($scope) {
                    var units = this.getSelectedUnits($scope);
                    if (units.length == 0) {
                        // this.$scope.prescription.specieId = null;
                        this.$scope.prescription.productionStageId = null;
                    }
                    else {
                        this.$scope.prescription.specieId = this.mapSpecies(_.first(units).species);
                        this.$scope.prescription.productionStageId = this.mapProductionStage(_.first(units).siteType);
                    }
                };
                AvInventoryListDirectiveController.prototype.isAnyUnitSelected = function () {
                    return _.some(this.$scope.farmerInventory, ["isSelected", true]);
                };
                AvInventoryListDirectiveController.prototype.mapSpecies = function (farmerSpeciesName) {
                    var specie = _.find(this.$scope.species, function (spec) { return spec.name === farmerSpeciesName; });
                    if (specie != null) {
                        return specie.specieId;
                    }
                    return -1;
                };
                AvInventoryListDirectiveController.prototype.mapProductionStage = function (farmerSiteType) {
                    var productionStage = _.find(this.SiteTypeMappingProductionStage, function (mappingItem) { return mappingItem.siteTypeValue === farmerSiteType; });
                    var stage = _.find(this.$scope.productionStages, function (stage) { return stage.name === (productionStage ? productionStage.productionStageKey : farmerSiteType); });
                    if (stage != null) {
                        return stage.productionStageId;
                    }
                    return -1;
                };
                AvInventoryListDirectiveController.$inject = ["$scope"];
                return AvInventoryListDirectiveController;
            })();
            directives.AvInventoryListDirectiveController = AvInventoryListDirectiveController;
            var AvInventoryList = (function () {
                function AvInventoryList() {
                    this.restrict = "E";
                    this.scope = {
                        disabled: "=",
                        farmerInventory: "=",
                        isFarmerIntegrationOn: "=",
                        prescription: "=",
                        species: "=",
                        productionStages: "=",
                        hideTotalBiomass: "=",
                        hideTotalWeight: "=",
                        inventoryListHeightInPixel: "=",
                        selectedFarmerSpeciesName: '=',
                        selectedFarmerProductionStage: '='
                    };
                    this.controller = AvInventoryListDirectiveController;
                }
                AvInventoryList.prototype.templateUrl = function (element, attributes) {
                    if (attributes.type == "desktop") {
                        return "app.common/directives/inventory_list/inventory.list.directive.desktop.tpl.html";
                    }
                    return "app.common/directives/inventory_list/inventory.list.directive.mobile.tpl.html";
                };
                return AvInventoryList;
            })();
            directives.AvInventoryList = AvInventoryList;
        })(directives = common.directives || (common.directives = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerDirective("AvInventoryList", []);

var app;
(function (app) {
    var common;
    (function (common) {
        var directives;
        (function (directives) {
            var IframeOnload = (function () {
                function IframeOnload() {
                    this.restrict = 'A';
                    this.scope = {
                        callBack: '&iframeOnload'
                    };
                }
                IframeOnload.prototype.link = function ($scope, element, attributes) {
                    element.on('load', function () {
                        return $scope.callBack();
                    });
                };
                return IframeOnload;
            })();
            directives.IframeOnload = IframeOnload;
        })(directives = common.directives || (common.directives = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerDirective('IframeOnload');

/// <reference path="../../../_typings.ts"/>
var app;
(function (app) {
    var common;
    (function (common) {
        var directives;
        (function (directives) {
            var AvRichTextDirectiveController = (function () {
                function AvRichTextDirectiveController($scope, $timeout, $locale, busyIndicator) {
                    var _this = this;
                    this.$timeout = $timeout;
                    this.$locale = $locale;
                    this.busyIndicator = busyIndicator;
                    this.isPaste = null;
                    //Options for rich text editor
                    $scope.froalaOptions = {
                        key: app.common.utils.froalaKey,
                        toolbarInline: false,
                        spellcheck: false,
                        scaytAutoload: false,
                        language: "en-gb",
                        // Set max image size to 5MB.
                        imageMaxSize: 1024 * 1024,
                        placeholderText: "Enter Text Here",
                        height: 100,
                        pluginsEnabled: [
                            "fullscreen",
                            "image",
                            "table",
                            "charCounter",
                            "paragraphStyle",
                            "lists",
                            "wordPaste"
                        ],
                        toolbarButtons: [
                            "fullscreen",
                            "bold",
                            "italic",
                            "underline",
                            "strikeThrough",
                            "|",
                            "fontFamily",
                            "fontSize",
                            "color",
                            "paragraphStyle",
                            "|",
                            "paragraphFormat",
                            "align",
                            "formatOL",
                            "formatUL",
                            "outdent",
                            "indent",
                            "|",
                            "insertLink",
                            "insertImage",
                            "insertTable",
                            "|",
                            "undo",
                            "redo"
                        ],
                        events: {
                            "froalaEditor.initialized": function (e, editor) {
                                var lang = $locale.FROALA;
                                editor.language.translate = function (str) {
                                    if (lang &&
                                        lang.translation[str] &&
                                        lang.translation[str].length) {
                                        return lang.translation[str];
                                    }
                                    else {
                                        return str;
                                    }
                                };
                            },
                            "froalaEditor.image.beforeUpload": function (e, editor, images) {
                                //this.editor = editor;
                                if (_this.isPaste)
                                    return false;
                                if (images.length) {
                                    _this.busyIndicator.show();
                                    new ImageCompressor(images[0], {
                                        quality: 0.2,
                                        success: function (result) {
                                            // Create a File Reader.
                                            var reader = new FileReader();
                                            // Set the reader to insert images when they are loaded.
                                            reader.onloadend = function (e) {
                                                var base64Image = reader.result;
                                                editor.image.insert(base64Image, null, null, editor.image.get());
                                            };
                                            reader.readAsDataURL(result);
                                        },
                                        error: function (e) {
                                            console.log(e.message);
                                        }
                                    });
                                }
                                editor.popups.hideAll();
                                // Stop default upload chain.
                                return false;
                            },
                            "froalaEditor.paste.before": function (e, editor) {
                                _this.busyIndicator.show();
                                _this.isPaste = true;
                            },
                            "froalaEditor.paste.after": function (e, editor) {
                                _this.busyIndicator.hide();
                                _this.isPaste = false;
                            },
                            "froalaEditor.image.loaded": function (e, editor, $img) {
                                _this.busyIndicator.hide();
                            },
                            "froalaEditor.blur": function (e, editor) {
                                var editorContainer = editor.el.parentElement.parentElement;
                                angular.forEach(editorContainer.children, function (htmlElement, key) {
                                    // toolbar is one of editorContainer's children
                                    angular.element(htmlElement).css("z-index", "");
                                });
                            },
                            "froalaEditor.commands.after": function (e, editor, cmd, param1, param2) {
                                if (cmd === "fullscreen") {
                                    if (editor.fullscreen.isActive() === false) {
                                        var editorContainer = editor.el.parentElement.parentElement;
                                        angular.forEach(editorContainer.children, function (htmlElement, key) {
                                            // toolbar is one of editorContainer's children
                                            angular.element(htmlElement).css("z-index", "");
                                        });
                                    }
                                }
                                if (cmd === "formatOL" || cmd === "formatUL") {
                                    var elements = editor.el.children;
                                    angular.forEach(elements, function (elem, key) {
                                        //   console.log(value);
                                        if (elem.tagName === "OL" || elem.tagName === "UL") {
                                            if (elem.tagName === "UL")
                                                angular.element(elem).css("list-style-type", "circle");
                                            else
                                                angular.element(elem).css("list-style-type", "decimal");
                                            angular.element(elem).css("margin-left", "10px");
                                        }
                                    });
                                }
                            },
                            "froalaEditor.focus": function (e, editor) {
                                var pElements = editor.el.children;
                                angular.forEach(pElements, function (element, key) {
                                    // console.log("focus", value);
                                    if (element.tagName === "P")
                                        angular.element(element).css("white-space", "normal");
                                });
                            },
                            "froalaEditor.click": function (e, editor, clickEvent) {
                                var element = clickEvent.target;
                                if (element.tagName === "LI" &&
                                    (element.parentElement.tagName === "OL" ||
                                        element.parentElement.tagName === "UL")) {
                                    setTimeout(function () {
                                        angular.element(element).removeAttr("value");
                                    }, 1);
                                }
                            }
                        }
                    };
                    $timeout(function () {
                        $scope.templatePath =
                            "app.common/directives/rich-text-editor/rich.text.editor.directive.tpl.html";
                    });
                }
                AvRichTextDirectiveController.$inject = [
                    "$scope",
                    "$timeout",
                    "$locale",
                    "busyIndicator"
                ];
                return AvRichTextDirectiveController;
            })();
            directives.AvRichTextDirectiveController = AvRichTextDirectiveController;
            var AvRichText = (function () {
                function AvRichText() {
                    this.template = '<div ng-include="templatePath"></div>';
                    this.restrict = "EA";
                    this.scope = {
                        templateRegistration: "="
                    };
                    this.controller = AvRichTextDirectiveController;
                }
                return AvRichText;
            })();
            directives.AvRichText = AvRichText;
        })(directives = common.directives || (common.directives = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerDirective("AvRichText", [
    "$timeout",
    "$locale",
    "busyIndicator"
]);

/// <reference path="../../_typings.ts"/>
/// <reference path='../app.ts' />
'use strict';
//module app.common.filters {
//    export class DateFormat implements IFilter {
//        constructor() {
//        }
//        public filter = ((input, $filter) => {
//            if (input == null) {
//                return "";
//            }
//            var _date = $filter('date')(input,'shortDate');
//            return _date;
//        });
//    }
//}
//app.common.registerFilter('DateFormat',['$filter']);
//TODO: fix app.common.registerFilter so that it accepts injections
angular.module('app.common.filters', []).filter('dateformat', ["$filter", function ($filter) { return function (input) {
    if (input == null) {
        return "";
    }
    var _date = $filter('date')(input, 'shortDate');
    return _date;
}; }]);
angular.module('app.common.filters').filter('datetimeformat', ["$filter", function ($filter) { return function (input) {
    if (input == null) {
        return "";
    }
    var _date = $filter('date')(input, 'short');
    return _date;
}; }]);
angular.module('app.common.filters').filter('endsWith', ["$filter", function ($filter) { return function (input, ends, csensitive) {
    var sensitive = csensitive || false, position;
    if (!_.isString(input) || _.isUndefined(ends)) {
        return input;
    }
    input = (sensitive) ? input : input.toLowerCase();
    position = input.length - ends.length;
    return input.indexOf((sensitive) ? ends : ends.toLowerCase(), position) !== -1;
}; }]);

/// <reference path="../../_typings.ts"/>
/// <reference path='../app.ts' />
'use strict';
var app;
(function (app) {
    var common;
    (function (common) {
        var filters;
        (function (filters) {
            var GroupBySortOrder = (function () {
                function GroupBySortOrder() {
                    this.filter = _.memoize(function (template) {
                        return _.groupBy(template.templateItems, function (item) {
                            return item.sortOrder;
                        });
                    }, function (template) {
                        return template.templateId;
                    });
                }
                return GroupBySortOrder;
            })();
            filters.GroupBySortOrder = GroupBySortOrder;
        })(filters = common.filters || (common.filters = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerFilter('GroupBySortOrder');

/// <reference path="../../_typings.ts"/>
/// <reference path='../app.ts' />
'use strict';
var app;
(function (app) {
    var common;
    (function (common) {
        var filters;
        (function (filters) {
            var Range = (function () {
                function Range() {
                    this.filter = function (val, range) {
                        range = parseInt(range);
                        for (var i = 1; i < range + 1; i++)
                            val.push(i);
                        return val;
                    };
                }
                return Range;
            })();
            filters.Range = Range;
        })(filters = common.filters || (common.filters = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerFilter('Range');

/// <reference path="../../_typings.ts"/>
/// <reference path='../app.ts' />
'use strict';
var app;
(function (app) {
    var common;
    (function (common) {
        var filters;
        (function (filters) {
            var SummaryTemplateItems = (function () {
                function SummaryTemplateItems() {
                    this.filter = (function (collection) {
                        return _.filter(collection, function (item) {
                            return item.attribute.attributeType.name !== app.constants.attributeType.Comment
                                && item.attribute.attributeType.name !== app.constants.attributeType.File
                                && item.attribute.attributeType.name !== app.constants.attributeType.Enum
                                || (item.attribute.attributeType.name === app.constants.attributeType.Enum && item.attribute.enumDataType !== app.constants.enumDataType.String && item.attribute.aggregations.length);
                        });
                    });
                }
                return SummaryTemplateItems;
            })();
            filters.SummaryTemplateItems = SummaryTemplateItems;
        })(filters = common.filters || (common.filters = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerFilter('SummaryTemplateItems');

/// <reference path="../../_typings.ts"/>
/// <reference path='../app.ts' />
'use strict';
var app;
(function (app) {
    var common;
    (function (common) {
        var filters;
        (function (filters) {
            var FormatNumber = (function () {
                function FormatNumber() {
                    this.filter = function (value) {
                        return app.common.utils.unformatDecimal(value);
                    };
                }
                return FormatNumber;
            })();
            filters.FormatNumber = FormatNumber;
        })(filters = common.filters || (common.filters = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerFilter('FormatNumber');

/// <reference path="../../_typings.ts"/>
/// <reference path='../app.ts' />
'use strict';
var app;
(function (app) {
    var common;
    (function (common) {
        var filters;
        (function (filters) {
            var AssessmentDiscriminator = (function () {
                function AssessmentDiscriminator() {
                    this.filter = function (value) {
                        if (_.isString(value)) {
                            return value.split('|')[0];
                        }
                        return "";
                    };
                }
                return AssessmentDiscriminator;
            })();
            filters.AssessmentDiscriminator = AssessmentDiscriminator;
        })(filters = common.filters || (common.filters = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerFilter('AssessmentDiscriminator');

/// <reference path="../../_typings.ts"/>
/// <reference path='../app.ts' />
'use strict';
//See https://github.com/ST-Software/Scripts/tree/master/Angular%20Modules for more info
angular.module('app.common.filters').filter('stringFormat', function () {
    // function _toFormattedString is based on String.js from http://ajaxcontroltoolkit.codeplex.com/SourceControl/latest#Client/MicrosoftAjax/Extensions/String.js
    // as seen in http://stackoverflow.com/questions/2534803/string-format-in-javascript
    function toFormattedString(useLocale, format, values) {
        var result = '';
        for (var i = 0;;) {
            // Find the next opening or closing brace
            var open = format.indexOf('{', i);
            var close = format.indexOf('}', i);
            if ((open < 0) && (close < 0)) {
                // Not found: copy the end of the string and break
                result += format.slice(i);
                break;
            }
            if ((close > 0) && ((close < open) || (open < 0))) {
                if (format.charAt(close + 1) !== '}') {
                    throw new Error('format stringFormatBraceMismatch');
                }
                result += format.slice(i, close + 1);
                i = close + 2;
                continue;
            }
            // Copy the string before the brace
            result += format.slice(i, open);
            i = open + 1;
            // Check for double braces (which display as one and are not arguments)
            if (format.charAt(i) === '{') {
                result += '{';
                i++;
                continue;
            }
            if (close < 0)
                throw new Error('format stringFormatBraceMismatch');
            // Find the closing brace
            // Get the string between the braces, and split it around the ':' (if any)
            var brace = format.substring(i, close);
            var colonIndex = brace.indexOf(':');
            var argNumber = parseInt((colonIndex < 0) ? brace : brace.substring(0, colonIndex), 10);
            if (isNaN(argNumber))
                throw new Error('format stringFormatInvalid');
            var argFormat = (colonIndex < 0) ? '' : brace.substring(colonIndex + 1);
            var arg = values[argNumber];
            if (typeof (arg) === "undefined" || arg === null) {
                arg = '';
            }
            // If it has a toFormattedString method, call it.  Otherwise, call toString()
            if (arg.toFormattedString) {
                result += arg.toFormattedString(argFormat);
            }
            else if (useLocale && arg.localeFormat) {
                result += arg.localeFormat(argFormat);
            }
            else if (arg.format) {
                result += arg.format(argFormat);
            }
            else
                result += arg.toString();
            i = close + 1;
        }
        return result;
    }
    ;
    return function (/*string*/ template, /*array*/ values) {
        if (!values || !values.length || !template) {
            return template;
        }
        return toFormattedString(false, template, values);
    };
});

(function () {
    'use strict';
    // Define the common module 
    // Contains services:
    //  - common
    //  - logger
    //  - spinner
    var commonModule = angular.module('common', []);
    // Must configure the common service and set its 
    // events via the commonConfigProvider
    commonModule.provider('commonConfig', function () {
        this.config = {};
        this.$get = function () {
            return {
                config: this.config
            };
        };
    });
    commonModule.factory('common', ['$q', '$rootScope', '$timeout', 'commonConfig', 'logger', common]);
    function common($q, $rootScope, $timeout, commonConfig, logger) {
        var throttles = {};
        var service = {
            // common angular dependencies
            $broadcast: $broadcast,
            $q: $q,
            $timeout: $timeout,
            // generic
            activateController: activateController,
            createSearchThrottle: createSearchThrottle,
            debouncedThrottle: debouncedThrottle,
            isNumber: isNumber,
            logger: logger,
            textContains: textContains
        };
        return service;
        function activateController(promises, controllerId) {
            return $q.all(promises).then(function (eventArgs) {
                var data = { controllerId: controllerId };
                $broadcast(commonConfig.config.controllerActivateSuccessEvent, data);
            });
        }
        function $broadcast() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            return $rootScope.$broadcast.apply($rootScope, arguments);
        }
        function createSearchThrottle(viewmodel, list, filteredList, filter, delay) {
            // After a delay, search a viewmodel's list using 
            // a filter function, and return a filteredList.
            // custom delay or use default
            delay = +delay || 300;
            // if only vm and list parameters were passed, set others by naming convention 
            if (!filteredList) {
                // assuming list is named sessions, filteredList is filteredSessions
                filteredList = 'filtered' + list[0].toUpperCase() + list.substr(1).toLowerCase(); // string
                // filter function is named sessionFilter
                filter = list + 'Filter'; // function in string form
            }
            // create the filtering function we will call from here
            var filterFn = function () {
                // translates to ...
                // vm.filteredSessions 
                //      = vm.sessions.filter(function(item( { returns vm.sessionFilter (item) } );
                viewmodel[filteredList] = viewmodel[list].filter(function (item) {
                    return viewmodel[filter](item);
                });
            };
            return (function () {
                // Wrapped in outer IFFE so we can use closure 
                // over filterInputTimeout which references the timeout
                var filterInputTimeout;
                // return what becomes the 'applyFilter' function in the controller
                return function (searchNow) {
                    if (filterInputTimeout) {
                        $timeout.cancel(filterInputTimeout);
                        filterInputTimeout = null;
                    }
                    if (searchNow || !delay) {
                        filterFn();
                    }
                    else {
                        filterInputTimeout = $timeout(filterFn, delay);
                    }
                };
            })();
        }
        function debouncedThrottle(key, callback, delay, immediate) {
            // Perform some action (callback) after a delay. 
            // Track the callback by key, so if the same callback 
            // is issued again, restart the delay.
            var defaultDelay = 1000;
            delay = delay || defaultDelay;
            if (throttles[key]) {
                $timeout.cancel(throttles[key]);
                throttles[key] = undefined;
            }
            if (immediate) {
                callback();
            }
            else {
                throttles[key] = $timeout(callback, delay);
            }
        }
        function isNumber(val) {
            // negative or positive
            return /^[-]?\d+$/.test(val);
        }
        function textContains(text, searchText) {
            return text && -1 !== text.toLowerCase().indexOf(searchText.toLowerCase());
        }
    }
})();

/// <reference path="../_typings.web.ts" />
(function () {
    'use strict';
    angular.module('common').factory('logger', ['$log', logger]);
    function logger($log) {
        var service = {
            getLogFn: getLogFn,
            log: log,
            logError: logError,
            logSuccess: logSuccess,
            logWarning: logWarning
        };
        return service;
        function getLogFn(moduleId, fnName) {
            fnName = fnName || 'log';
            switch (fnName.toLowerCase()) {
                case 'success':
                    fnName = 'logSuccess';
                    break;
                case 'error':
                    fnName = 'logError';
                    break;
                case 'warn':
                    fnName = 'logWarning';
                    break;
                case 'warning':
                    fnName = 'logWarning';
                    break;
            }
            var logFn = service[fnName] || service.log;
            return function (msg, data, showToast) {
                logFn(msg, data, moduleId, (showToast === undefined) ? true : showToast);
            };
        }
        function log(message, data, source, showToast) {
            logIt(message, data, source, showToast, 'info');
        }
        function logWarning(message, data, source, showToast) {
            logIt(message, data, source, showToast, 'warning');
        }
        function logSuccess(message, data, source, showToast) {
            logIt(message, data, source, showToast, 'success');
        }
        function logError(message, data, source, showToast) {
            logIt(message, data, source, showToast, 'error');
        }
        function logIt(message, data, source, showToast, toastType) {
            //var write = (toastType === 'error') ? $log.error : $log.log;
            //source = source ? '[' + source + '] ' : '';
            //write(source, message, data);
            //if (showToast) {
            //    //if (toastType === 'error') {
            //    //    toastr.error(message);
            //    //} else if (toastType === 'warning') {
            //    //    toastr.warning(message);
            //    //} else if (toastType === 'success') {
            //    //    toastr.success(message);
            //    //} else {
            //    //    toastr.info(message);
            //    //}
            //}
        }
    }
})();

/// <reference path="../_typings.web.ts" />
// ReSharper disable once InternalModule
// ReSharper disable once InternalModule
(function () {
    "use strict";
    var app = angular.module("app.web");
    app.directive("avStatusList", function () {
        //Usage:
        //<div data-cc-widget-header title="vm.map.title"></div>
        var directive = {
            link: link,
            templateUrl: "status_list/status_list.html",
            restrict: "E",
        };
        return directive;
        function link(scope, element, attrs) {
            // attrs.$set('class', 'widget-head');
        }
    });
    app.directive("avToggleWindowSize", ['$timeout', function ($timeout) {
            //Usage:
            //<div data-cc-widget-header title="vm.map.title"></div>
            var directive = {
                link: link,
                template: "&nbsp;<a class=\"close close-large\"><i class=\"glyphicon glyphicon-inverse glyphicon-resize-full\" ></i></a>",
                scope: {
                    'windows': "@",
                    'initalMaximized': "@maximized",
                    'level': "@"
                },
                restrict: "E",
                controller: ToggleWindowSizeDirectiveController
            };
            return directive;
            function link(scope, element, attrs) {
                var windows = attrs["windows"].split(" ");
                var mainWindow = windows[0];
                var secondaryWindow = windows[1];
                var main = $("#" + mainWindow);
                var secondary = $("#" + secondaryWindow);
                element.on("click", function () {
                    if (main.hasClass("window-full-screen")) {
                        main.removeClass("window-full-screen");
                        secondary.show();
                        scope.maximized = false;
                        $(element).find("i").removeClass("glyphicon-resize-small");
                        $(element).find("i").addClass("glyphicon-resize-full");
                    }
                    else {
                        $(element).find("i").addClass("glyphicon-resize-small");
                        $(element).find("i").removeClass("glyphicon-resize-full");
                        main.addClass("window-full-screen");
                        secondary.hide();
                        //secondary.slideUp("1000", function () {
                        //});
                        scope.maximized = true;
                    }
                    $timeout(function () {
                        $(window).resize();
                    });
                });
            }
        }]);
    app.directive("avAutofocus", [
        "$timeout", "$interval", function ($timeout, $interval) {
            return {
                restrict: "A",
                link: function ($scope, $element) {
                    var interval;
                    var counter = 0;
                    var setFocus = function () {
                        if ($element.is(":visible")) {
                            $element[0].focus();
                            $interval.cancel(interval);
                        }
                    };
                    $timeout(function () {
                        if (!$element.is(":visible")) {
                            interval = $interval(function () {
                                counter++;
                                if (counter > 20)
                                    $interval.cancel(interval);
                                setFocus();
                            }, 50);
                        }
                        else {
                            setFocus();
                        }
                    }, 50);
                }
            };
        }
    ]);
    app.directive("avTabindexLoop", ["$timeout", function ($timeout) {
            return {
                restrict: "A",
                link: function ($scope, $element, attrs) {
                    attrs.avTabindexLoop = attrs.avTabindexLoop || "true";
                    $scope.$watch(function () { return $scope.viewModel.refreshTabIndexLoop; }, function () {
                        if (attrs.avTabindexLoop === "true") {
                            $timeout(function () {
                                var list = _.filter($element.find("*[tabindex]"), function (a) { return a.tabIndex; }).sort(function (a, b) { return a.tabIndex < b.tabIndex ? -1 : 1; }), first = angular.element(_.first(list)), last = angular.element(_.last(list));
                                _.forEach(list, function (element) {
                                    $(element).unbind('keydown');
                                });
                                last.on("keydown", function (e) {
                                    if (!e.shiftKey && e.keyCode === 9) {
                                        $timeout(function () {
                                            first.focus();
                                        });
                                        return false;
                                    }
                                });
                                first.on("keydown", function (e) {
                                    if (e.shiftKey && e.keyCode === 9) {
                                        $timeout(function () {
                                            last.focus();
                                        });
                                        return false;
                                    }
                                });
                                first.focus();
                            });
                        }
                    });
                }
            };
        }]);
    app.directive("flowImageResize", ["$q", function ($q) {
        return {
            'require': "flowInit",
            'link': function (scope, element, attrs) {
                scope.$flow.opts.preprocess = function (chunk) {
                    chunk.fileObj.promise.then(function (success) {
                        if (!chunk.fileObj.resized && success) {
                            chunk.fileObj.resized = true;
                            chunk.fileObj.retry();
                        }
                        else if (!success) {
                            element.find(".imageUploadMessage").text(chunk.fileObj.fileToBigMessage);
                            chunk.fileObj.cancel();
                        }
                    });
                    if (chunk.fileObj.resized) {
                        chunk.preprocessFinished();
                    }
                };
                scope.$flow.on("filesSubmitted", function (files) {
                    angular.forEach(files, function (file) {
                        var deferred = $q.defer();
                        file.promise = deferred.promise;
                        var tempImg = new Image();
                        var url = URL.createObjectURL(file.file);
                        tempImg.onload = function () {
                            file.file = null; // do not display it
                            var MAX_WIDTH = 1920;
                            var MAX_HEIGHT = 1440;
                            var tempW = tempImg.width;
                            var tempH = tempImg.height;
                            element.find(".imageUploadMessage").text("");
                            if (tempW > tempH) {
                                if (tempW > MAX_WIDTH) {
                                    tempH *= MAX_WIDTH / tempW;
                                    tempW = MAX_WIDTH;
                                    element.find(".imageUploadMessage").text(file.message.replace("{0}", Math.round(tempW) + "x" + Math.round(tempH)));
                                }
                            }
                            else {
                                if (tempH > MAX_HEIGHT) {
                                    tempW *= MAX_HEIGHT / tempH;
                                    tempH = MAX_HEIGHT;
                                    element.find(".imageUploadMessage").text(file.message.replace("{0}", Math.round(tempW) + "x" + Math.round(tempH)));
                                }
                            }
                            var resizedCanvas = document.createElement("canvas");
                            resizedCanvas.width = tempW;
                            resizedCanvas.height = tempH;
                            var ctx = resizedCanvas.getContext("2d");
                            ctx.drawImage(tempImg, 0, 0, tempW, tempH);
                            var dataURL = resizedCanvas.toDataURL("image/jpeg");
                            var tempFile = dataURLtoBlob(dataURL);
                            file.file = tempFile;
                            file.size = tempFile.size;
                            file.file.name = file.name;
                            deferred.resolve(file.size < 5000000);
                            function dataURLtoBlob(dataURL) {
                                // Decode dataURL
                                var binary = atob(dataURL.split(",")[1]);
                                // Se transfiere a un array de 8-bit unsigned
                                var array = [];
                                var length = binary.length;
                                for (var i = 0; i < length; i++) {
                                    array.push(binary.charCodeAt(i));
                                }
                                return new Blob([(new Uint8Array(array))], { type: "image/jpeg" });
                            }
                        };
                        tempImg.src = url;
                    });
                });
            }
        };
    }]);
})();
var ToggleWindowSizeDirectiveController = (function () {
    function ToggleWindowSizeDirectiveController($scope) {
        $scope.initalMaximized = ($scope.initalMaximized == "true");
        $scope.maximized = $scope.initalMaximized;
        $scope.toggleWindowSize = function () {
            $scope.maximized = !$scope.maximized;
        };
    }
    ToggleWindowSizeDirectiveController.$inject = ["$scope"];
    return ToggleWindowSizeDirectiveController;
})();
var Notifications = (function () {
    function Notifications(notificationMessage) {
        this.notificationMessage = notificationMessage;
    }
    return Notifications;
})();
var NotificationDetail = (function () {
    function NotificationDetail() {
    }
    return NotificationDetail;
})();

angular.module('app.web').service('loginModal', ["$state", "$rootScope", function ($state, $rootScope) {
    function assignCurrentUser(user) {
        $rootScope.currentUser = user;
        return user;
    }
    return function () {
        //var instance = $modal.open({
        //    templateUrl: 'views/loginModalTemplate.html',
        //    controller: 'LoginModalCtrl',
        //    controllerAs: 'LoginModalCtrl'
        //})
        //return instance.result.then(assignCurrentUser);
        return $state.go('app.shell');
    };
}]);

/// <reference path="../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var NetworkConnection = (function () {
                function NetworkConnection() {
                }
                NetworkConnection.prototype.isOnline = function () {
                    return true;
                };
                return NetworkConnection;
            })();
            services.NetworkConnection = NetworkConnection;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('NetworkConnection');

/// <reference path="../_typings.web.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var AppLocalStorage = (function (_super) {
                __extends(AppLocalStorage, _super);
                function AppLocalStorage($window, $location, env, apiEndpoint) {
                    _super.call(this, $window, env, apiEndpoint);
                    this.$location = $location;
                    var appStatus = this.applicationStatusGet();
                    if (appStatus.useConfigApiEndpoint) {
                        if (env.name.indexOf('development') === 0) {
                            appStatus.apiEndpoint = this.env.apiEndpoint;
                        }
                        else {
                            var searchFor = /^.*?(?=app\.web|www)/;
                            var url = $location.absUrl();
                            if (searchFor.test(url)) {
                                appStatus.apiEndpoint = searchFor.exec(url)[0];
                            }
                            else {
                                appStatus.apiEndpoint = url;
                            }
                        }
                        this.applicationStatusSet(appStatus);
                    }
                }
                AppLocalStorage.prototype.applicationStatusSet = function (value) {
                    this.apiEndpoint.setBaseEndpoint(value.apiEndpoint, app.constants.deviceType.WebApp);
                    this.$window.localStorage.setItem(this.storageKeys.applicationStatus, JSON.stringify(value));
                };
                AppLocalStorage.prototype.pythonScriptsGet = function () {
                    return this.$window.localStorage.getItem(this.storageKeys.pythonScripts);
                };
                AppLocalStorage.prototype.pythonScriptsSet = function (value) {
                    this.$window.localStorage.setItem(this.storageKeys.pythonScripts, value);
                };
                AppLocalStorage.$inject = ['$window', '$location', 'ENV'];
                return AppLocalStorage;
            })(app.common.services.AppLocalStorage);
            services.AppLocalStorage = AppLocalStorage;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('AppLocalStorage', ['$window', '$location', 'ENV', 'apiEndpointService']);

/// <reference path="../_typings.web.ts" />
"use strict";
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var ReportData = (function () {
                function ReportData(key, type, title, generateReport, fullName, auditId, currentUserId) {
                    if (fullName === void 0) { fullName = ""; }
                    if (auditId === void 0) { auditId = 0; }
                    if (currentUserId === void 0) { currentUserId = ""; }
                    this.key = key;
                    this.type = type;
                    this.title = title;
                    this.generateReport = generateReport;
                    this.fullName = fullName;
                    this.auditId = auditId;
                    this.currentUserId = currentUserId;
                }
                return ReportData;
            })();
            services.ReportData = ReportData;
            var MedicationReportData = (function () {
                function MedicationReportData(type, title, parameter) {
                    if (parameter === void 0) { parameter = null; }
                    this.type = type;
                    this.title = title;
                    this.parameter = parameter;
                }
                return MedicationReportData;
            })();
            services.MedicationReportData = MedicationReportData;
            var PrepareReportData = (function () {
                function PrepareReportData(type, dateRange, sites, treatmentProducts) {
                    if (dateRange === void 0) { dateRange = null; }
                    if (sites === void 0) { sites = null; }
                    if (treatmentProducts === void 0) { treatmentProducts = null; }
                    this.type = type;
                    this.dateRange = dateRange;
                    this.sites = sites;
                    this.treatmentProducts = treatmentProducts;
                }
                return PrepareReportData;
            })();
            services.PrepareReportData = PrepareReportData;
            var HostData = (function () {
                function HostData(name) {
                    this.name = name;
                }
                return HostData;
            })();
            services.HostData = HostData;
            var AssessmentData = (function () {
                function AssessmentData(assessment) {
                    this.assessment = assessment;
                }
                return AssessmentData;
            })();
            services.AssessmentData = AssessmentData;
            var MailListData = (function () {
                function MailListData(type) {
                    this.type = type;
                }
                MailListData.prototype.getTypeAsString = function () {
                    return app.enums.entityType[this.type];
                };
                return MailListData;
            })();
            services.MailListData = MailListData;
            var LockingData = (function () {
                function LockingData(type, isLocked) {
                    this.type = type;
                    this.isLocked = isLocked;
                }
                LockingData.prototype.getTypeAsString = function () {
                    return app.enums.entityType[this.type];
                };
                return LockingData;
            })();
            services.LockingData = LockingData;
            var LockingHistoryData = (function () {
                function LockingHistoryData(type, key, reportTitle) {
                    this.type = type;
                    this.key = key;
                    this.reportTitle = reportTitle;
                }
                LockingHistoryData.prototype.getTypeAsString = function () {
                    return app.enums.entityType[this.type];
                };
                return LockingHistoryData;
            })();
            services.LockingHistoryData = LockingHistoryData;
            var EventData = (function () {
                function EventData(event) {
                    this.event = event;
                }
                return EventData;
            })();
            services.EventData = EventData;
            var BaseSetupData = (function () {
                function BaseSetupData(entity) {
                    this.entity = entity;
                }
                return BaseSetupData;
            })();
            services.BaseSetupData = BaseSetupData;
            var PrescriptionData = (function () {
                function PrescriptionData(prescription, siteId) {
                    if (siteId === void 0) { siteId = 0; }
                    this.prescription = prescription;
                    this.siteId = siteId;
                }
                return PrescriptionData;
            })();
            services.PrescriptionData = PrescriptionData;
            var TreatmentProductData = (function () {
                function TreatmentProductData(treatmentProduct) {
                    this.treatmentProduct = treatmentProduct;
                }
                return TreatmentProductData;
            })();
            services.TreatmentProductData = TreatmentProductData;
            var SupplierData = (function () {
                function SupplierData(supplier) {
                    this.supplier = supplier;
                }
                return SupplierData;
            })();
            services.SupplierData = SupplierData;
            var AttributeEnumData = (function () {
                function AttributeEnumData(attributeMetadataEnumId, maxSortOrder) {
                    this.attributeMetadataEnumId = attributeMetadataEnumId;
                    this.maxSortOrder = maxSortOrder;
                }
                return AttributeEnumData;
            })();
            services.AttributeEnumData = AttributeEnumData;
            var TreatmentProductProducerData = (function () {
                function TreatmentProductProducerData(treatmentProductProducer) {
                    this.treatmentProductProducer = treatmentProductProducer;
                }
                return TreatmentProductProducerData;
            })();
            services.TreatmentProductProducerData = TreatmentProductProducerData;
            var BenchMarkingData = (function () {
                function BenchMarkingData(data) {
                    this.data = data;
                }
                return BenchMarkingData;
            })();
            services.BenchMarkingData = BenchMarkingData;
            var FishgroupData = (function () {
                function FishgroupData(siteId) {
                    this.siteId = siteId;
                }
                return FishgroupData;
            })();
            services.FishgroupData = FishgroupData;
            var UserBusinessObjectPermissionData = (function () {
                function UserBusinessObjectPermissionData(level, objectId, role, customerId, permission, userBusinessObject) {
                    this.level = level;
                    this.objectId = objectId;
                    this.role = role;
                    this.customerId = customerId;
                    this.permission = permission;
                    this.userBusinessObject = userBusinessObject;
                }
                return UserBusinessObjectPermissionData;
            })();
            services.UserBusinessObjectPermissionData = UserBusinessObjectPermissionData;
            var ConfirmationData = (function () {
                function ConfirmationData(parameter, headerText, messageText, onlyAccept, hasComment, requireComment) {
                    if (hasComment === void 0) { hasComment = false; }
                    if (requireComment === void 0) { requireComment = false; }
                    this.parameter = parameter;
                    this.headerText = headerText;
                    this.messageText = messageText;
                    this.onlyAccept = onlyAccept;
                    this.hasComment = hasComment;
                    this.requireComment = requireComment;
                }
                return ConfirmationData;
            })();
            services.ConfirmationData = ConfirmationData;
            var MailData = (function () {
                function MailData(siteId, key, type, assessmentTypeId, mailId, visitType) {
                    if (mailId === void 0) { mailId = -1; }
                    if (visitType === void 0) { visitType = null; }
                    this.siteId = siteId;
                    this.key = key;
                    this.type = type;
                    this.assessmentTypeId = assessmentTypeId;
                    this.mailId = mailId;
                    this.visitType = visitType;
                }
                return MailData;
            })();
            services.MailData = MailData;
            var UserData = (function () {
                function UserData(user, isCustomerMode) {
                    this.user = user;
                    this.isCustomerMode = isCustomerMode;
                }
                return UserData;
            })();
            services.UserData = UserData;
            var EntityData = (function () {
                function EntityData(headerText, entityDeclaration, saveFunc, visibleProperties) {
                    if (visibleProperties === void 0) { visibleProperties = []; }
                    this.headerText = headerText;
                    this.entityDeclaration = entityDeclaration;
                    this.saveFunc = saveFunc;
                    this.visibleProperties = visibleProperties;
                }
                return EntityData;
            })();
            services.EntityData = EntityData;
            var ModalService = (function () {
                function ModalService(ngDialog) {
                    this.ngDialog = ngDialog;
                }
                ModalService.prototype.show = function (templateAsHtml, size, controller, scope, preCloseCallback, data, closeByDocument) {
                    if (closeByDocument === void 0) { closeByDocument = false; }
                    return this.ngDialog.open({
                        template: templateAsHtml,
                        scope: scope,
                        className: "ngdialog-theme-modal" + (_.isEmpty(size) ? "" : " " + size),
                        data: data,
                        controller: controller,
                        controllerAs: controller ? "viewModel" : null,
                        preCloseCallback: preCloseCallback,
                        closeByDocument: closeByDocument,
                        showClose: false,
                        closeByEscape: false
                    });
                };
                ModalService.prototype.showConfirm = function (templateAsHtml, size, controller, scope, preCloseCallback, data) {
                    return this.ngDialog.openConfirm({
                        template: templateAsHtml,
                        scope: scope,
                        className: "ngdialog-theme-modal" + (_.isEmpty(size) ? "" : " " + size),
                        data: data,
                        preCloseCallback: preCloseCallback,
                        showClose: false,
                        closeByEscape: false
                    });
                };
                ModalService.prototype.confirm = function () {
                    this.ngDialog.confirm();
                };
                ModalService.prototype.close = function () {
                    this.ngDialog.close();
                };
                ModalService.$inject = ["ngDialog"];
                return ModalService;
            })();
            services.ModalService = ModalService;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService("ModalService", ["ngDialog"]);

/// <reference path="../../_typings.ts"/>
'use strict';
var app;
(function (app) {
    var common;
    (function (common) {
        var services;
        (function (services) {
            var AuthenticationService = (function () {
                function AuthenticationService($rootScope, $http, $httpBackend, $state, $translate, $q, $timeout, md5, env, authService, networkConnection, appLocalStorage, sharedDatacontext, apiEndpoint, jwtHelper, deviceDetector) {
                    var _this = this;
                    this.$rootScope = $rootScope;
                    this.$http = $http;
                    this.$httpBackend = $httpBackend;
                    this.$state = $state;
                    this.$translate = $translate;
                    this.$q = $q;
                    this.$timeout = $timeout;
                    this.md5 = md5;
                    this.env = env;
                    this.authService = authService;
                    this.networkConnection = networkConnection;
                    this.appLocalStorage = appLocalStorage;
                    this.sharedDatacontext = sharedDatacontext;
                    this.apiEndpoint = apiEndpoint;
                    this.jwtHelper = jwtHelper;
                    this.deviceDetector = deviceDetector;
                    this.crmAssessmentId = 0;
                    $rootScope.$on(app.constants.broadcastEventNames.authLoginRequired, function () { return _this.loginRequired(); });
                    $rootScope.$on(app.constants.broadcastEventNames.authLoginConfirmed, function () { return _this.loginConfirmed(); });
                    $rootScope.$on(app.constants.broadcastEventNames.authLogoutCompleted, function () { return _this.logoutCompleted(); });
                }
                AuthenticationService.prototype.initialize = function () {
                    var _this = this;
                    var credentials = this.credentialsGet();
                    if (credentials != null && credentials.IsLoggedIn && credentials.IsAuthenticated) {
                        if (this.env.client_id === app.constants.applicationType.mobileApp) {
                            this.$timeout(function () {
                                _this.$state.go('app.assessments');
                            });
                        }
                        return true;
                    }
                    else {
                        return false;
                    }
                };
                AuthenticationService.prototype.getAuthLoginErrorMessage = function (user) {
                    if (angular.isDefined(user.IsLoggedIn)) {
                        return user.Message;
                    }
                    else {
                        return "Message_UnauthenticateableToLogIn";
                    }
                };
                AuthenticationService.prototype.getAuthenticatedUserFromToken = function (token, refreshToken) {
                    var payload = this.jwtHelper.decodeToken(token);
                    var user = new common.model.AutheticatedUser();
                    user.UserName = payload.unique_name;
                    user.UserId = payload.nameid;
                    user.Email = payload.Email;
                    //user.IsLoggedIn = true;
                    user.IsAuthenticated = payload.IsAuthenticated;
                    // user.HashedPassword = payload.nameid;
                    user.Token = token;
                    user.RefreshToken = refreshToken;
                    //    user.Message = payload.nameid;
                    user.FullName = payload.FullName;
                    user.FirstName = payload.FirstName;
                    user.LastName = payload.LastName;
                    user.PhoneNumber = payload.PhoneNumber;
                    user.Role = payload.role;
                    user.Culture = payload.Culture;
                    user.EmailConfirmed = payload.EmailConfirmed === "true";
                    return user;
                };
                AuthenticationService.prototype.login = function (userName, password, clearStorage, rememberUser) {
                    var _this = this;
                    userName = userName.toLowerCase();
                    var deffered = this.$q.defer();
                    if (this.networkConnection.isOnline()) {
                        var client_device;
                        var uuid = null;
                        if (this.env.client_id === app.constants.applicationType.webApp) {
                            client_device = this.deviceDetector.browser;
                        }
                        else {
                            client_device = this.deviceDetector.device;
                            if (!_.isUndefined(window.device)) {
                                uuid = device.uuid;
                            }
                        }
                        var data = "grant_type=password&username=" + userName + "&password=" + password + "&client_id=" + this.env.client_id + "&device=" + client_device + "&uuid=" + uuid + (this.crmAssessmentId === 0 ? "" : ("&crmAssessmentId=" + this.crmAssessmentId));
                        //if (loginData.useRefreshTokens) {
                        //    data = data + "&client_id=" + ngAuthSettings.clientId;
                        //}
                        this.$http.post(this.apiEndpoint.getloginEndpoint(), data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
                            .success(function (data, status, headers) {
                            var user = _this.getAuthenticatedUserFromToken(data.access_token, data.refresh_token);
                            if (clearStorage) {
                                _this.sharedDatacontext.clearAll().then(function () {
                                    _this.appLocalStorage.clearUserSpecificSettings();
                                    deffered.resolve(_this.authenticate(user, password, rememberUser));
                                });
                            }
                            else {
                                _this.authenticate(user, password, rememberUser);
                                deffered.resolve(user);
                            }
                            var dbVersion = headers("DbVersion");
                            _this.setDbVersion(dbVersion);
                        })
                            .error(function (err) {
                            deffered.reject(err.error_description);
                        });
                    }
                    else {
                        var credentials = this.credentialsGet();
                        if (credentials != null && (credentials.UserName.toLowerCase() === userName.toLowerCase() || credentials.Email.toLowerCase() === userName.toLowerCase())) {
                            if (credentials.HashedPassword === this.md5.createHash(password)) {
                                deffered.resolve(this.authenticateUser(credentials, credentials.UserName, rememberUser));
                            }
                            else {
                                deffered.reject("ErrorUserNameOrPassword");
                            }
                        }
                        else {
                            deffered.reject("Message_UserNotLoggedIn");
                        }
                    }
                    return deffered.promise;
                };
                AuthenticationService.prototype.authenticateCustomerPortalUser = function (data, client_id) {
                    var user = this.getAuthenticatedUserFromToken(data.access_token, data.refresh_token);
                    user.ClientId = client_id;
                    this.authenticate(user, '', true);
                };
                AuthenticationService.prototype.authenticate = function (data, password, rememberUser) {
                    data.HashedPassword = this.md5.createHash(password);
                    var appStatus = this.appLocalStorage.applicationStatusGet();
                    appStatus.translationsCulture = data.Culture.toLowerCase();
                    this.appLocalStorage.applicationStatusSet(appStatus);
                    app.common.utils.refreshCachedData = true;
                    this.changeLanguage();
                    this.authenticateUser(data, data.UserName, rememberUser);
                };
                AuthenticationService.prototype.changeLanguage = function () {
                    var _this = this;
                    return this.$translate.refresh(this.appLocalStorage.applicationStatusGet().translationsCulture).catch(function () {
                        return _this.$translate.use(_this.appLocalStorage.applicationStatusGet().translationsCulture);
                    });
                };
                AuthenticationService.prototype.getCurrentUserCulture = function () {
                    var _this = this;
                    return this.$http.get(this.apiEndpoint.getUserLanguageEndpoint(), { params: { userName: this.credentialsCurrentUserGet().Email } }).then(function (result) {
                        var language = result.data;
                        if (_.isNull(language))
                            language = "en-gb";
                        var appStatus = _this.appLocalStorage.applicationStatusGet();
                        app.common.utils.refreshCachedData = appStatus.translationsCulture !== language.toLowerCase();
                        appStatus.translationsCulture = language.toLowerCase();
                        _this.appLocalStorage.applicationStatusSet(appStatus);
                    });
                };
                AuthenticationService.prototype.isRemeberMeActive = function () {
                    return this.$http.get(this.apiEndpoint.getAllowRememberMeEndpoint(), {});
                };
                AuthenticationService.prototype.logoutMobile = function () {
                    this.$http.defaults.headers.common.Authorization = null;
                    this.$state.go('login');
                };
                AuthenticationService.prototype.logoutDesktop = function () {
                    var draftPrescriptions = this.appLocalStorage.draftPrescriptionsGet();
                    this.$http.defaults.headers.common.Authorization = null;
                    this.credentialsClear();
                    if (!app.common.utils.isNullOrUndefined(draftPrescriptions))
                        this.appLocalStorage.draftPrescriptionsSet(draftPrescriptions);
                };
                AuthenticationService.prototype.loginCancelled = function () {
                    this.authService.loginCancelled();
                };
                AuthenticationService.prototype.loginRequired = function () {
                    if (this.apiEndpoint.deviceTypeId == app.constants.deviceType.WebApp) {
                        this.logoutDesktop();
                    }
                    else {
                        this.$state.go('login');
                    }
                };
                AuthenticationService.prototype.loginConfirmed = function () {
                };
                AuthenticationService.prototype.logoutCompleted = function () {
                    this.$state.go('login');
                };
                AuthenticationService.prototype.isAutheticated = function () {
                    var credentials = this.credentialsGet();
                    return !(credentials == null || !credentials.IsLoggedIn);
                };
                AuthenticationService.prototype.credentialsUpdate = function (credentials) {
                    this.appLocalStorage.loggedInUserUpdate(credentials == null ? null : JSON.stringify(credentials));
                };
                AuthenticationService.prototype.credentialsSet = function (credentials, rememberUser) {
                    this.appLocalStorage.loggedInUserSet(credentials == null ? null : JSON.stringify(credentials), rememberUser);
                };
                AuthenticationService.prototype.credentialsClear = function () {
                    this.appLocalStorage.loggedInUserClear();
                };
                AuthenticationService.prototype.credentialsCurrentUserGet = function () {
                    if (angular.isDefined(this.appLocalStorage.loggedInUserGet())) {
                        return JSON.parse(this.appLocalStorage.loggedInUserGet());
                    }
                    else {
                        return null;
                    }
                };
                AuthenticationService.prototype.credentialsGet = function () {
                    if (angular.isDefined(this.appLocalStorage.loggedInUserGet())) {
                        return JSON.parse(this.appLocalStorage.loggedInUserGet());
                    }
                    else {
                        return null;
                    }
                };
                AuthenticationService.prototype.isCustomerUser = function () {
                    var user = this.credentialsGet();
                    if (user) {
                        return user.Role == app.constants.accessControlRoles.Customer;
                    }
                    return false;
                };
                AuthenticationService.prototype.authenticateUser = function (credentials, userName, rememberUser) {
                    credentials.IsLoggedIn = true;
                    if (this.credentialsGet() != null && this.credentialsGet().UserName != userName) {
                        this.appLocalStorage.userSettingsSet(null);
                    }
                    this.credentialsSet(credentials, rememberUser);
                    this.$http.defaults.headers.common.TimeZone = common.utils.getTimeZone();
                };
                AuthenticationService.prototype.setDbVersion = function (dbVersion) {
                    var appStatus = this.appLocalStorage.applicationStatusGet();
                    appStatus.dbVersion = dbVersion;
                    this.appLocalStorage.applicationStatusSet(appStatus);
                    this.appLocalStorage.dbVersionSet(dbVersion);
                };
                AuthenticationService.prototype.getValidToken = function () {
                    var token = this.credentialsCurrentUserGet().Token;
                    if (this.jwtHelper.isTokenExpired(token))
                        return this.refreshToken().then(function (response) {
                            return response.access_token;
                        });
                    else
                        return this.$q.when(token);
                };
                AuthenticationService.prototype.refreshToken = function () {
                    var deferred = this.$q.defer();
                    // var authData = localStorageService.get('authorizationData');
                    if (this.credentialsGet() != null) {
                        var clientId = common.utils.isNullOrUndefinedOrEmpty(this.credentialsGet().ClientId) ? this.env.client_id : this.credentialsGet().ClientId;
                        var data = "grant_type=refresh_token&refresh_token=" + encodeURIComponent(String(this.credentialsGet().RefreshToken)) + "&client_id=" + clientId;
                        var parent = this;
                        //  localStorageService.remove('authorizationData');
                        // Prevent duplicate server calls
                        if (!this.authPromise || (this.authPromise && this.authPromise.$$state.status > 0))
                            this.authPromise = this.$http.post(this.apiEndpoint.getloginEndpoint(), data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, ignoreLoadingBar: false });
                        this.authPromise.success(function (response) {
                            //localStorageService.set('authorizationData', { token: response.access_token, userName: response.userName, refreshToken: response.refresh_token, useRefreshTokens: true });
                            var credentials = parent.credentialsGet();
                            credentials.RefreshToken = response.refresh_token;
                            credentials.Token = response.access_token;
                            //parent.setTokenOnHttp(credentials);
                            parent.credentialsUpdate(credentials);
                            //parent.credentialsGet().RefreshToken = response.refresh_token;
                            //parent.credentialsGet().Token = response.access_token;
                            deferred.resolve(response);
                        }).error(function (err, status) {
                            var rejection;
                            if (err && typeof err !== 'string') {
                                rejection = err;
                                rejection['config'] = { ignoreLoadingBar: false };
                            }
                            else {
                                rejection = { status: status, data: err, config: { ignoreLoadingBar: false }, statusText: "Service Unavailable" };
                            }
                            deferred.reject(rejection);
                        });
                    }
                    else {
                        deferred.reject();
                    }
                    return deferred.promise;
                };
                AuthenticationService.$inject = ['$rootScope', '$http', '$httpBackend', '$state', '$translate', '$q', '$timeout', 'md5', 'ENV', 'authService', 'networkConnection', 'appLocalStorage', 'sharedDatacontext', 'apiEndpointService', 'jwtHelper', 'deviceDetector'];
                return AuthenticationService;
            })();
            services.AuthenticationService = AuthenticationService;
        })(services = common.services || (common.services = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerService('AuthenticationService', ['$rootScope', '$http', '$httpBackend', '$state', '$translate', '$q', '$timeout', 'md5', 'ENV', 'authService', 'networkConnection', 'appLocalStorage', 'sharedDatacontext', 'apiEndpointService', 'jwtHelper', 'deviceDetector']);

/// <reference path="../../_typings.ts"/>
"use strict";
var app;
(function (app) {
    var common;
    (function (common) {
        var services;
        (function (services) {
            var FileSystemService = (function () {
                function FileSystemService($q, $timeout, ENV) {
                    var _this = this;
                    this.$q = $q;
                    this.$timeout = $timeout;
                    this.ENV = ENV;
                    this.DEFAULT_QUOTA_MB_CHROME = 1024 * 1024 * 100;
                    window.resolveLocalFileSystemURL =
                        window.resolveLocalFileSystemURL ||
                            window.webkitResolveLocalFileSystemURL;
                    window.requestFileSystem =
                        window.webkitRequestFileSystem || window.requestFileSystem;
                    if (!_.isUndefined(window.requestFileSystem)) {
                        if (window.webkitStorageInfo !== undefined &&
                            window.webkitStorageInfo.requestQuota !== undefined) {
                            if (_.isUndefined(window.jasmine) &&
                                ENV.client_id === app.constants.applicationType.mobileApp) {
                                window.webkitStorageInfo.requestQuota(window.PERSISTENT, this.DEFAULT_QUOTA_MB_CHROME, function (grantedBytes) {
                                    window.requestFileSystem(window.PERSISTENT, grantedBytes, function (fs) {
                                        _this.openedFileSystem = fs;
                                    }, _this.errorHandler);
                                }, this.errorHandler);
                            }
                            else {
                                window.requestFileSystem(window.TEMPORARY, 0, function (fs) {
                                    _this.openedFileSystem = fs;
                                }, this.errorHandler);
                            }
                        }
                        else {
                            window.requestFileSystem(window.PERSISTENT, 0, function (fs) {
                                _this.openedFileSystem = fs;
                            }, this.errorHandler);
                        }
                    }
                }
                FileSystemService.prototype.safeResolve = function (deferral, message) {
                    this.$timeout(function () {
                        deferral.resolve(message);
                    });
                };
                FileSystemService.prototype.safeReject = function (deferral, error) {
                    this.$timeout(function () {
                        deferral.reject(error);
                    });
                };
                FileSystemService.prototype.fixPath = function (path) {
                    path = path || "";
                    path = path.replace(/^\//, "");
                    path = path.replace(/\/$/, "");
                    return path.length === 0 ? "" : path + "/";
                };
                FileSystemService.prototype.isInitialized = function () {
                    return !_.isUndefined(this.openedFileSystem);
                };
                FileSystemService.prototype.fileSystemExists = function () {
                    return this.isInitialized();
                };
                FileSystemService.prototype.rootUrlGet = function () {
                    return this.openedFileSystem.root.toURL();
                };
                FileSystemService.prototype.getFreeDiskSpace = function () {
                    var _this = this;
                    var def = this.$q.defer();
                    if (_.isUndefined(window.cordova)) {
                        return this.$q.when({
                            text: "Getting free disk space success.",
                            obj: this.DEFAULT_QUOTA_MB_CHROME / 1024
                        });
                    }
                    else {
                        cordova.exec(function (freeSpace) {
                            _this.safeResolve(def, {
                                text: "Getting free disk space success.",
                                obj: freeSpace / 1024 / 1024
                            });
                        }, function (e) {
                            _this.safeReject(def, {
                                text: "Error getting free disk space file.",
                                obj: e
                            });
                        }, "File", "getFreeDiskSpace", []);
                    }
                    return def.promise;
                };
                FileSystemService.prototype.fileCreate = function (fileName, path) {
                    var _this = this;
                    var def = this.$q.defer();
                    path = this.fixPath(path);
                    this.openedFileSystem.root.getFile(path + fileName, { create: true, exclusive: false }, function (fileEntry) {
                        _this.safeResolve(def, {
                            text: "File created: " + path + fileName,
                            obj: fileEntry
                        });
                    }, function (e) {
                        _this.safeReject(def, {
                            text: "Error creating file: " + path + fileName,
                            obj: _this.errorHandler(e)
                        });
                    });
                    return def.promise;
                };
                FileSystemService.prototype.getFileExtension = function (fileName) {
                    return fileName.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2);
                };
                FileSystemService.prototype.getFileNameWithoutExtension = function (fileName) {
                    return fileName.substr(0, fileName.lastIndexOf(".")) || fileName;
                };
                FileSystemService.prototype.fileGet = function (fileName, path) {
                    var _this = this;
                    var def = this.$q.defer();
                    path = this.fixPath(path);
                    this.openedFileSystem.root.getFile(path + fileName, { create: false }, function (fileEntry) {
                        fileEntry.file(function (file) {
                            _this.safeResolve(def, {
                                text: "File get: " + path + fileName,
                                obj: file
                            });
                        }, function (e) {
                            _this.safeReject(def, {
                                text: "Error getting file: " + path + fileName,
                                obj: _this.errorHandler(e)
                            });
                        });
                    }, function (e) {
                        _this.safeReject(def, {
                            text: "Error getting file entry: " + path + fileName,
                            obj: _this.errorHandler(e)
                        });
                    });
                    return def.promise;
                };
                FileSystemService.prototype.fileExists = function (fileName, path) {
                    var _this = this;
                    var def = this.$q.defer();
                    path = this.fixPath(path);
                    this.openedFileSystem.root.getFile(path + fileName, { create: false }, function (fileEntry) {
                        _this.safeResolve(def, {
                            text: "File get: " + path + fileName,
                            obj: true
                        });
                    }, function (e) {
                        if (e.code === window.FileError.NOT_FOUND_ERR ||
                            _.isEmpty(fileName)) {
                            // if (e.code === 8 || _.isEmpty(fileName)) {
                            _this.safeResolve(def, {
                                text: "File does not exist: " + path + fileName,
                                obj: false
                            });
                        }
                        else {
                            _this.safeReject(def, {
                                text: "Error finding file: " + path + fileName,
                                obj: _this.errorHandler(e)
                            });
                        }
                    });
                    return def.promise;
                };
                //public directoryCreate(path: string) {
                //    var def = this.$q.defer();
                //    path = this.fixPath(path);
                //    this.openedFileSystem.root.getDirectory(path, { create: true, exclusive: false }, (directoryEntry) => {
                //        this.safeResolve(def, { text: "Directory created: " + path, obj: directoryEntry });
                //    }, (e) => {
                //        this.safeReject(def, { text: "Error creating directory: " + path, obj: this.errorHandler(e) });
                //    });
                //    return def.promise;
                //}
                FileSystemService.prototype.directoryCreate = function (root, sub) {
                    var _this = this;
                    var def = this.$q.defer();
                    root = this.fixPath(root);
                    this.openedFileSystem.root.getDirectory(root, { create: true, exclusive: false }, function (directoryEntry) {
                        if (sub) {
                            root = _this.fixPath(root);
                            directoryEntry.getDirectory(sub, { create: true, exclusive: false }, function (directoryEntry) {
                                _this.safeResolve(def, {
                                    text: "Directory created: " + sub,
                                    obj: directoryEntry
                                });
                            }, function (e) {
                                _this.safeReject(def, {
                                    text: "Error creating directory: " + sub,
                                    obj: _this.errorHandler(e)
                                });
                            });
                        }
                        else {
                            _this.safeResolve(def, {
                                text: "Directory created: " + root,
                                obj: directoryEntry
                            });
                        }
                    }, function (e) {
                        _this.safeReject(def, {
                            text: "Error creating directory: " + root,
                            obj: _this.errorHandler(e)
                        });
                    });
                    return def.promise;
                };
                FileSystemService.prototype.directoryDelete = function (path) {
                    var _this = this;
                    var def = this.$q.defer();
                    path = this.fixPath(path);
                    this.openedFileSystem.root.getDirectory(path, {}, function (dirEntry) {
                        dirEntry.removeRecursively(function () {
                            _this.safeResolve(def, {
                                text: "Directory deleted: " + path,
                                obj: {}
                            });
                        }, function (e) {
                            _this.safeReject(def, {
                                text: "Error deleting directory: " + path,
                                obj: _this.errorHandler(e)
                            });
                        });
                    }, function (e) {
                        if (e.code === window.FileError.NOT_FOUND_ERR) {
                            // if (e.code === 8) {
                            _this.safeResolve(def, {
                                text: "Directory does not exist: " + path,
                                obj: {}
                            });
                        }
                        else {
                            _this.safeReject(def, {
                                text: "Error deleting directory: " + path,
                                obj: _this.errorHandler(e)
                            });
                        }
                    });
                    return def.promise;
                };
                FileSystemService.prototype.fileDelete = function (fileName, path) {
                    var _this = this;
                    var def = this.$q.defer();
                    path = this.fixPath(path);
                    this.openedFileSystem.root.getFile(path + fileName, {}, function (fileEntry) {
                        fileEntry.remove(function () {
                            _this.safeResolve(def, {
                                text: "File removed: " + path + fileName,
                                obj: fileEntry
                            });
                        }, function (e) {
                            _this.safeReject(def, {
                                text: "Error removing file: " + path + fileName,
                                obj: _this.errorHandler(e)
                            });
                        });
                    }, function (e) {
                        if (e.code === window.FileError.NOT_FOUND_ERR) {
                            // if (e.code === 8) {
                            _this.safeResolve(def, {
                                text: "File does not exist: " + path + fileName,
                                obj: _this.errorHandler(e)
                            });
                        }
                        else {
                            _this.safeReject(def, {
                                text: "Error deleting file: " + path + fileName,
                                obj: _this.errorHandler(e)
                            });
                        }
                    });
                    return def.promise;
                };
                FileSystemService.prototype.fileSizeGet = function (fileName, path) {
                    var _this = this;
                    var def = this.$q.defer();
                    path = this.fixPath(path);
                    this.openedFileSystem.root.getFile(path + fileName, { create: false }, function (fileEntry) {
                        fileEntry.getMetadata(function (metadata) {
                            _this.safeResolve(def, {
                                text: "Metadata for file: " + path + fileName,
                                obj: metadata
                            });
                        }, function (e) {
                            _this.safeReject(def, {
                                text: "Error getting metadata: " + path + fileName,
                                obj: _this.errorHandler(e)
                            });
                        });
                    }, function (e) {
                        _this.safeReject(def, {
                            text: "Error finding file: " + path + fileName,
                            obj: _this.errorHandler(e)
                        });
                    });
                    return def.promise;
                };
                FileSystemService.prototype.fileReadAsUrl = function (fileName, path) {
                    path = this.fixPath(path);
                    return this.fileReadHelper(fileName, "url", path);
                };
                FileSystemService.prototype.fileReadAsText = function (fileName, path) {
                    path = this.fixPath(path);
                    return this.fileReadHelper(fileName, "text", path);
                };
                FileSystemService.prototype.fileReadAsArrayBuffer = function (fileName, path) {
                    path = this.fixPath(path);
                    return this.fileReadHelper(fileName, "arrayBuffer", path);
                };
                FileSystemService.prototype.fileReadHelper = function (fileName, readAs, path) {
                    var _this = this;
                    var def = this.$q.defer();
                    path = this.fixPath(path);
                    this.openedFileSystem.root.getFile(path + fileName, { create: false }, function (fileEntry) {
                        if (readAs === "url") {
                            _this.safeResolve(def, {
                                text: "File url: " + path + fileName,
                                obj: fileEntry.toURL()
                            });
                        }
                        else {
                            fileEntry.file(function (file) {
                                var reader = new FileReader();
                                reader.onloadend = function (e) {
                                    _this.safeResolve(def, {
                                        text: "File content as array buffer: " + path + fileName,
                                        obj: reader.result
                                    });
                                };
                                reader.onerror = function (e) {
                                    _this.safeReject(def, {
                                        text: "Error reading file: " + path + fileName,
                                        obj: _this.errorHandler(e)
                                    });
                                };
                                if (readAs === "text") {
                                    reader.readAsText(file);
                                }
                                else if (readAs === "arrayBuffer") {
                                    reader.readAsArrayBuffer(file);
                                }
                                else {
                                    _this.safeReject(def, {
                                        text: "Uknown file type: " + path + fileName,
                                        obj: {}
                                    });
                                }
                            }, function (e) {
                                _this.safeReject(def, {
                                    text: "Error opening file: " + path + fileName,
                                    obj: _this.errorHandler(e)
                                });
                            });
                        }
                    }, function (e) {
                        _this.safeReject(def, {
                            text: "Error finding file: " + path + fileName,
                            obj: _this.errorHandler(e)
                        });
                    });
                    return def.promise;
                };
                FileSystemService.prototype.fileWrite = function (fileName, content, path, create) {
                    var _this = this;
                    if (create === void 0) { create = false; }
                    var def = this.$q.defer();
                    path = this.fixPath(path);
                    this.openedFileSystem.root.getFile(path + fileName, { create: create, exclusive: false }, function (fileEntry) {
                        fileEntry.createWriter(function (fileWriter) {
                            if (!create)
                                fileWriter.seek(fileWriter.length);
                            fileWriter.write(content);
                            _this.safeResolve(def, {
                                text: "File write success: " + path + fileName,
                                obj: { fileName: fileEntry.name }
                            });
                        }, function (e) {
                            _this.safeReject(def, {
                                text: "Error writing to file: " + path + fileName,
                                obj: _this.errorHandler(e)
                            });
                        });
                    }, function (e) {
                        _this.safeReject(def, {
                            text: "Error finding file: " + path + fileName,
                            obj: _this.errorHandler(e)
                        });
                    });
                    return def.promise;
                };
                FileSystemService.prototype.fileWriteUnique = function (fileName, content, path, create) {
                    var _this = this;
                    if (create === void 0) { create = false; }
                    var def = this.$q.defer();
                    path = this.fixPath(path);
                    this.fileExists(fileName, path).then(function (result) {
                        if (result.obj) {
                            fileName =
                                _this.getFileNameWithoutExtension(fileName) +
                                    "_" +
                                    moment.utc().format("YYYYMMDD_HHmmss_SSS") +
                                    "." +
                                    _this.getFileExtension(fileName);
                        }
                        _this.fileWrite(fileName, content, path, create).then(function (result) {
                            _this.safeResolve(def, {
                                text: "File created: " + path + fileName,
                                obj: result.obj
                            });
                        }, function (e) {
                            _this.safeReject(def, {
                                text: "Error creating file: " + path + fileName,
                                obj: _this.errorHandler(e)
                            });
                        });
                    });
                    return def.promise;
                };
                FileSystemService.prototype.directorySizeGet = function (path) {
                    var _this = this;
                    var def = this.$q.defer();
                    path = this.fixPath(path);
                    this.openedFileSystem.root.getDirectory(path, { create: false }, function (directoryEntry) {
                        var directoryReader = directoryEntry.createReader();
                        _this.browseDirectory(directoryReader).then(function (totalSize) {
                            _this.safeResolve(def, {
                                text: "Size of directory: " + path,
                                obj: { size: totalSize }
                            });
                        }, function (e) {
                            _this.safeReject(def, {
                                text: "Error finding directory: " + path,
                                obj: _this.errorHandler(e)
                            });
                        });
                    }, function (e) {
                        _this.safeReject(def, {
                            text: "Error finding directory: " + path,
                            obj: _this.errorHandler(e)
                        });
                    });
                    return def.promise;
                };
                FileSystemService.prototype.browseDirectory = function (reader) {
                    var _this = this;
                    var def = this.$q.defer();
                    reader.readEntries(function (entries) {
                        var filesIndex = 0;
                        var totalSize = 0;
                        if (entries.length === 0)
                            def.resolve(0);
                        _.each(entries, function (entry) {
                            if (entry.isFile) {
                                entry.getMetadata(function (metadata) {
                                    filesIndex++;
                                    totalSize += metadata.size;
                                    if (entries.length === filesIndex)
                                        def.resolve(totalSize);
                                }, function (e) {
                                    def.reject(e);
                                });
                            }
                            else if (entry.isDirectory) {
                                _this.browseDirectory(entry.createReader()).then(function (result) {
                                    filesIndex++;
                                    totalSize = totalSize + result;
                                    if (entries.length === filesIndex)
                                        def.resolve(totalSize);
                                });
                            }
                        });
                    }, function (e) {
                        def.reject(e);
                    });
                    return def.promise;
                };
                FileSystemService.prototype.filesUrlGet = function (fileName, folder) {
                    return this.fileUrlGet(fileName, folder, "url");
                };
                FileSystemService.prototype.filesNameGet = function (fileName, folder) {
                    return this.fileUrlGet(fileName, folder, "path");
                };
                FileSystemService.prototype.fileUrlGet = function (fileName, folder, type) {
                    var _this = this;
                    var def = this.$q.defer();
                    if (folder !== "") {
                        this.openedFileSystem.root.getDirectory(folder, {}, function (directory) {
                            _this.fileUrlGetHelper(def, fileName, folder, type, directory.createReader());
                        }, function (e) {
                            _this.safeReject(def, {
                                text: "Error opening dicrectory: " + folder,
                                obj: _this.errorHandler(e)
                            });
                        });
                    }
                    else {
                        this.fileUrlGetHelper(def, fileName, folder, type, this.openedFileSystem.root.createReader());
                    }
                    return def.promise;
                };
                FileSystemService.prototype.fileUrlGetHelper = function (deferred, fileName, folder, type, reader) {
                    var _this = this;
                    reader.readEntries(function (entries) {
                        var filesIndex = 0;
                        var directoryIndex = 0;
                        var fileNames = [];
                        if (entries.length === 0)
                            deferred.resolve(fileNames);
                        _.each(entries, function (entry) {
                            if (entry.isFile) {
                                if (entry.name === fileName) {
                                    deferred.resolve([
                                        type === "path" ? entry.fullPath : entry.toURL()
                                    ]);
                                }
                                else if (fileName === "") {
                                    fileNames.push(type === "path" ? entry.fullPath : entry.toURL());
                                    filesIndex++;
                                    if (entries.length === filesIndex)
                                        deferred.resolve(fileNames);
                                }
                            }
                            else if (entry.isDirectory) {
                                _this.fileUrlGet("", folder + "/" + entry.name, type).then(function (result) {
                                    fileNames = fileNames.concat(result);
                                    directoryIndex++;
                                    if (entries.length === directoryIndex)
                                        deferred.resolve(fileNames);
                                });
                            }
                        });
                    }, function (e) {
                        deferred.reject({
                            text: "Error reading directory entries: " + folder,
                            obj: e
                        });
                    });
                };
                FileSystemService.prototype.directoryMove = function (src, dest, newName) {
                    var _this = this;
                    var def = this.$q.defer();
                    src = this.fixPath(src);
                    dest = this.fixPath(dest);
                    this.openedFileSystem.root.getDirectory(src, {}, function (srcDir) {
                        _this.openedFileSystem.root.getDirectory(dest, {}, function (toDir) {
                            srcDir.moveTo(toDir, newName, function () {
                                _this.safeResolve(def, {
                                    text: "Directory move success.",
                                    obj: {}
                                });
                            }, function (e) {
                                _this.safeReject(def, {
                                    text: "Error moving directory: " + src + " " + dest,
                                    obj: _this.errorHandler(e)
                                });
                            });
                        }, function (e) {
                            _this.safeReject(def, {
                                text: "Error getting dest directory: " + dest,
                                obj: _this.errorHandler(e)
                            });
                        });
                    }, function (e) {
                        _this.safeReject(def, {
                            text: "Error getting src directory: " + src,
                            obj: _this.errorHandler(e)
                        });
                    });
                    return def.promise;
                };
                FileSystemService.prototype.errorHandler = function (e) {
                    return ("Name: " + e.name + ", Message: " + e.message + ", Code: " + e.code);
                };
                return FileSystemService;
            })();
            services.FileSystemService = FileSystemService;
        })(services = common.services || (common.services = {}));
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
app.common.registerService("FileSystemService", ["$q", "$timeout", "ENV"]);

/// <reference path="../../_typings.ts" />
/// <reference path="../app.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var ApiEndpointService = (function (_super) {
                __extends(ApiEndpointService, _super);
                function ApiEndpointService() {
                    _super.apply(this, arguments);
                }
                return ApiEndpointService;
            })(app.common.services.ApiEndpointService);
            services.ApiEndpointService = ApiEndpointService;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('ApiEndpointService');

/// <reference path="../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var SharedDatacontext = (function () {
                function SharedDatacontext($q, env, apiEndpoint, _breezeservice) {
                    if (_breezeservice === void 0) { _breezeservice = '/api/application'; }
                    this.$q = $q;
                    this.env = env;
                    this.apiEndpoint = apiEndpoint;
                    this._breezeservice = _breezeservice;
                    this.breezeservice = _breezeservice;
                    this.provider = new app.common.data.EntityManagerProvider(apiEndpoint.baseEndpoint + this.breezeservice, true);
                    this.manager = this.provider.create();
                }
                SharedDatacontext.prototype.init = function () {
                    var _this = this;
                    return this.provider.prepare().then(function () {
                        var queryLookups = breeze.EntityQuery
                            .from('Lookups');
                        var queryGetAssessmentIdentifiers = breeze.EntityQuery
                            .from('AssessmentIdentifiers');
                        return _this.$q.all([
                            _this.manager.executeQuery(queryLookups),
                            _this.manager.executeQuery(queryGetAssessmentIdentifiers)
                        ]).then(function (data) {
                            _this.addEntityLevelValidations();
                            app.common.data.mapDtosToEntities(_this.manager, data[1].results, app.constants.entityNames.assessmentIdentifier, "assessmentId", undefined);
                            _this.assessmentUnitOfWork = new app.common.data.AssessmentUnitOfWork(_this.provider);
                            _this.mailUnitOfWork = new app.common.data.MailUnitOfWork(_this.provider);
                            _this.eventUnitOfWork = new app.common.data.EventUnitOfWork(_this.provider);
                            _this.navigatoinUnitOfWork = new app.common.data.NavigatoinUnitOfWork(_this.provider);
                            _this.customerPortalUnitOfWork = new app.common.data.CustomerPortalUnitOfWork(_this.provider);
                            _this.userManagementUnitOfWork = new app.common.data.UserManagementUnitOfWork(_this.provider);
                            _this.prescriptionUnitOfWork = new app.common.data.PrescriptionUnitOfWork(_this.provider);
                            _this.attributeUnitOfWork = new app.common.data.AttributeUnitOfWork(_this.provider);
                            return;
                        });
                    });
                };
                SharedDatacontext.prototype.requestNonBlockingUi = function () {
                    var ajaxAdapter = breeze.config.getAdapterInstance('ajax');
                    ajaxAdapter.requestInterceptor = function (requestInfo) {
                        requestInfo.config.ignoreLoadingBar = true;
                    };
                    ajaxAdapter.requestInterceptor.oneTime = true;
                };
                SharedDatacontext.prototype.addEntityLevelValidations = function () {
                    this.provider.addEntityLevelValidations();
                };
                SharedDatacontext.$inject = ['$q', 'ENV', 'apiEndpointService'];
                return SharedDatacontext;
            })();
            services.SharedDatacontext = SharedDatacontext;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('SharedDatacontext', ['$q', 'ENV', 'apiEndpointService']);

/// <reference path="../_typings.web.ts"/>
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var AssessmentDatacontext = (function (_super) {
                __extends(AssessmentDatacontext, _super);
                function AssessmentDatacontext($rootScope, $http, $translate, _$q, _sharedDatacontext, env, apiEndpoint) {
                    _super.call(this, _$q, _sharedDatacontext);
                    this.$rootScope = $rootScope;
                    this.$http = $http;
                    this.$translate = $translate;
                    this.env = env;
                    this.apiEndpoint = apiEndpoint;
                    this.isCustomerView = false;
                    this.assessmentFaD = {
                        filterList: [],
                        dateRange: {}
                    };
                }
                AssessmentDatacontext.prototype.initializeAssessmentDatacontext = function (assessmentUnitOfWork) {
                    return this.$q.when((this.assessmentUnitOfWork = assessmentUnitOfWork));
                };
                AssessmentDatacontext.prototype.createAssessment = function (initParams) {
                    var assessment = _super.prototype.createAssessment.call(this, initParams);
                    return assessment;
                };
                AssessmentDatacontext.prototype.deleteAssessment = function (assessment) {
                    var query = new breeze.EntityQuery("DeleteAssessmentById?assessmentId=" + assessment.assessmentId);
                    return this.assessmentUnitOfWork.assessmentRepository
                        .executeQuery(query)
                        .then(function (data) {
                        console.log("delete [Assessment] from remote data source");
                    })
                        .catch(function (error) {
                        console.log("error: " + error);
                        return error;
                    });
                };
                AssessmentDatacontext.prototype.save = function (assessment) {
                    var _this = this;
                    if (assessment === void 0) { assessment = null; }
                    //TODO: Proper error handling (wasn't able to implement error handling and still get the save result in the calling method)
                    return this.assessmentUnitOfWork
                        .saveChanges()
                        .then(function (result) {
                        if (assessment) {
                            var data = "?assessmentId=" + assessment.assessmentId;
                            return _this.$http
                                .get(_this.apiEndpoint.getUpdateAssessmentImagesFolderEndpoint() +
                                data, {
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                }
                            })
                                .success(function () {
                                return result;
                            })
                                .error(function (error) {
                                throw error;
                            });
                        }
                        else
                            return result;
                    })
                        .catch(function (error) {
                        console.log("error: " + error);
                        return error;
                    });
                    //return this.assessmentUnitOfWork.saveChanges()
                    //    .then((saveResult) => {
                    //    this.log('Saved data successfully', saveResult, true);
                    //}).catch((error) => {
                    //    this.saveFailed(error);
                    //});
                };
                AssessmentDatacontext.prototype.getImageOnDemand = function (assessmentId, filename) {
                    var data = "?assessmentId=" + assessmentId + "&filename=" + filename;
                    return this.$http.get(this.apiEndpoint.getImageOnDemandEndpoint() + data, { headers: { "Content-Type": "application/x-www-form-urlencoded" } });
                };
                AssessmentDatacontext.prototype.openAttachedFile = function (assessmentId, filename) {
                    var data = "?assessmentId=" + assessmentId + "&filename=" + filename;
                    return this.$http({
                        url: this.apiEndpoint.getOpenAssessmentFileEndPoint() + data,
                        method: "GET",
                        responseType: "arraybuffer",
                        data: {}
                    });
                };
                AssessmentDatacontext.prototype.rejectChanges = function (assessment) {
                    //TODO delete images from temp folder
                    return this.assessmentUnitOfWork.rejectChanges();
                };
                AssessmentDatacontext.prototype.rejectChangesOnEntity = function (entity) {
                    return this.assessmentUnitOfWork.rejectEntityChanges(entity);
                };
                AssessmentDatacontext.prototype.validateEntity = function (entity) {
                    return this.assessmentUnitOfWork.validateEntity(entity);
                };
                AssessmentDatacontext.prototype.getValidationErrors = function (entity) {
                    return this.assessmentUnitOfWork.getValidationErrors(entity);
                };
                AssessmentDatacontext.prototype.saveEntities = function (entities) {
                    return this.assessmentUnitOfWork.saveChanges(entities);
                };
                AssessmentDatacontext.prototype.createAudit = function (initParams) {
                    var audit = this.assessmentUnitOfWork.auditRepository.createEntity(initParams, breeze.EntityState.Added);
                    return audit;
                };
                AssessmentDatacontext.prototype.createUserAssessment = function (initParams) {
                    var userAssesment = this.assessmentUnitOfWork.userAssessmentRepository.createEntity(initParams, breeze.EntityState.Added);
                    return userAssesment;
                };
                AssessmentDatacontext.prototype.CreateUserAssessmentIfNotExisting = function (assessmentId, userId) {
                    var assessment = this.getAssessment(assessmentId);
                    var userAssessment = assessment.userAssessments[0];
                    if (userAssessment == null) {
                        this.createUserAssessment({
                            userId: userId,
                            assessmentId: assessmentId,
                            hasHidden: false,
                            hasRead: true
                        });
                        this.save();
                    }
                    else if (!userAssessment.hasRead) {
                        userAssessment.hasRead = true;
                        this.save();
                    }
                };
                AssessmentDatacontext.prototype.getGenerations = function () {
                    return this.assessmentUnitOfWork.generationsRepository.allInCache();
                };
                AssessmentDatacontext.prototype.getAssessmentRemote = function (assessmentId) {
                    this.$q.when(this.assessmentUnitOfWork.assessmentRepository.findById(assessmentId));
                };
                AssessmentDatacontext.prototype.createFishgroup = function (initParams) {
                    return this.assessmentUnitOfWork.fishGroupRepository.createEntity(initParams, breeze.EntityState.Added);
                };
                //GetAssessmentDTOs
                //public getAssessments(page: number, pageSize: number, filterData: Array<app.web.directives.Filter>) {   //TODO: typing and unit tests
                AssessmentDatacontext.prototype.getAssessments = function (page, pageSize, filterList, dateRange, viewType, levelId, getAll) {
                    if (getAll === void 0) { getAll = false; }
                    var assessmentFilter = new web.model.AssessmentFilter();
                    assessmentFilter.setFilterValuesFromFilterList(filterList, levelId);
                    var fromDate = dateRange
                        ? moment(dateRange.startDate)
                            .startOf("day")
                            .toDate()
                            .toNewUtcDate()
                        : null;
                    var toDate = dateRange
                        ? moment(dateRange.endDate)
                            .startOf("day")
                            .toDate()
                            .toNewUtcDate()
                        : null;
                    var query = new breeze.EntityQuery("GetAssessmentDTOs").withParameters({
                        page: page,
                        pageSize: pageSize,
                        followUps: assessmentFilter.followUps,
                        assessmentTypeGroups: assessmentFilter.typeGroups,
                        assessmentTypes: assessmentFilter.types,
                        customers: assessmentFilter.customers,
                        sites: assessmentFilter.sites,
                        assessmentGroups: assessmentFilter.groups,
                        identifiers: assessmentFilter.identifiers,
                        representatives: assessmentFilter.representatives,
                        fishgroups: assessmentFilter.fishgroups,
                        fromDate: fromDate,
                        toDate: toDate,
                        visitTypes: assessmentFilter.visitTypes
                    }); //TODO user this.authService.credentialsCurrentUserGet().UserId
                    if (getAll === false)
                        query = query.skip(page * pageSize).take(pageSize).inlineCount(true);
                    else
                        query = query.inlineCount(true);
                    if (AssessmentDatacontext.isStatusListView(viewType)) {
                        query = query.where("isHiddenByUser", "equals", false);
                    }
                    if (AssessmentDatacontext.isStatusListView(viewType)) {
                        query = query.where("followUpStatusId", breeze.FilterQueryOp.NotEquals, 1);
                    }
                    if (AssessmentDatacontext.isCustomerPortalView(viewType)) {
                        this.isCustomerView = true;
                    }
                    else {
                        this.isCustomerView = false;
                    }
                    if (AssessmentDatacontext.isStatusListView(viewType) &&
                        AssessmentDatacontext.isCustomerPortalView(viewType)) {
                        var pred = breeze.Predicate.create("followUpStatusId", breeze.FilterQueryOp.NotEquals, 1).or("isReadByUser", "equals", false);
                        query = query.where(pred);
                    }
                    if (AssessmentDatacontext.isCustomerPortalView(viewType)) {
                        query = query.where("isDraft", "equals", false);
                    }
                    //if (forceRemote || !this.sharedDatacontext.storageEnabledAndHasData || !this.assessmentUnitOfWork.assessmentRepository.hasEntitiesInCache()) {
                    //    this.clearCachedEntities(constants.entityNames.assessment);
                    return this.assessmentUnitOfWork.assessmentRepository
                        .executeQueryPartial(query, app.constants.entityNames.assessment, "assessmentId")
                        .then(function (data) {
                        //        return this.getDraftTemplateRegistrations(customerIds, siteIds, assessmentGroups, nahRepresentatives, forceRemote).then(() => {
                        return data;
                        //        });
                    });
                    //} else {
                    //    return this.getAll(false);
                    //}
                };
                AssessmentDatacontext.prototype.getTemplateData = function (page, pageSize, filterList, dateRange, view, type, levelId) {
                    var assessmentFilter = new web.model.AssessmentFilter();
                    assessmentFilter.setFilterValuesFromFilterList(filterList, levelId);
                    var fromDate = dateRange
                        ? moment(dateRange.startDate)
                            .startOf("day")
                            .toDate()
                            .toNewUtcDate()
                        : null;
                    var toDate = dateRange
                        ? moment(dateRange.endDate)
                            .startOf("day")
                            .toDate()
                            .toNewUtcDate()
                        : null;
                    var query = new breeze.EntityQuery("GetTemplateDTOs").withParameters({
                        type: type,
                        page: page,
                        pageSize: pageSize,
                        followUps: assessmentFilter.followUps,
                        assessmentTypeGroups: assessmentFilter.typeGroups,
                        assessmentTypes: assessmentFilter.types,
                        customers: assessmentFilter.customers,
                        sites: assessmentFilter.sites,
                        assessmentGroups: assessmentFilter.groups,
                        representatives: assessmentFilter.representatives,
                        fishgroups: assessmentFilter.fishgroups,
                        fromDate: fromDate,
                        toDate: toDate
                    });
                    query = query
                        .skip(page * pageSize)
                        .take(pageSize)
                        .inlineCount(true);
                    if (AssessmentDatacontext.isCustomerPortalView(view)) {
                        query = query.where("isDraft", "equals", false);
                    }
                    return this.assessmentUnitOfWork.assessmentRepository
                        .executeQueryPartial(query, app.constants.entityNames.templateRegistration, "templateRegistrationId")
                        .then(function (data) { return data; });
                };
                AssessmentDatacontext.isCustomerPortalView = function (viewType) {
                    return (viewType === app.constants.assessmentListViews.customerPortalStatus ||
                        viewType === app.constants.assessmentListViews.customerPortalAssessment);
                };
                AssessmentDatacontext.isAssessmentListView = function (viewType) {
                    return (viewType === app.constants.assessmentListViews.assessment ||
                        viewType === app.constants.assessmentListViews.customerPortalAssessment ||
                        viewType === app.constants.assessmentListViews.timeline);
                };
                AssessmentDatacontext.isStatusListView = function (viewType) {
                    return !this.isAssessmentListView(viewType);
                };
                AssessmentDatacontext.prototype.getSiteIdsWithAssessments = function (filterList, levelId) {
                    var assessmentFilter = new web.model.AssessmentFilter();
                    assessmentFilter.setFilterValuesFromFilterList(filterList, levelId);
                    var query = new breeze.EntityQuery("GetSiteIdsWithAssessments").withParameters({
                        followUps: assessmentFilter.followUps,
                        assessmentTypes: assessmentFilter.types,
                        customers: assessmentFilter.customers,
                        sites: assessmentFilter.sites,
                        representatives: assessmentFilter.representatives
                    }); //TODO user this.authService.credentialsCurrentUserGet().UserId
                    return this.assessmentUnitOfWork.assessmentRepository
                        .executeQuery(query)
                        .then(function (results) {
                        return results;
                    });
                };
                AssessmentDatacontext.prototype.getAssessmentsForMapView = function (siteId, followUps) {
                    var query = new breeze.EntityQuery("GetAssessmentsForMapView").withParameters({
                        siteId: siteId,
                        followUps: followUps
                    }); //TODO user this.authService.credentialsCurrentUserGet().UserId
                    return this.assessmentUnitOfWork.assessmentRepository
                        .executeQueryPartial(query, app.constants.entityNames.assessment, "assessmentId")
                        .then(function (results) {
                        return results.results;
                    });
                };
                AssessmentDatacontext.prototype.getAuditTypes = function () {
                    var query = new breeze.EntityQuery()
                        .from(app.constants.resourceNames.auditTypes)
                        .where("auditingTypeId", "!=", 3);
                    return this.assessmentUnitOfWork.assessmentRepository.executeCacheQuery(query);
                };
                AssessmentDatacontext.prototype.getAuditDtos = function (type, assessmentId, auditTypeIds) {
                    var query = new breeze.EntityQuery("AssessmentAuditDTOs").withParameters({
                        type: type,
                        assessmentId: assessmentId,
                        auditTypeIds: auditTypeIds
                    });
                    return this.assessmentUnitOfWork.auditRepository.executeQuery(query);
                };
                AssessmentDatacontext.prototype.saveLockedAssessmentPdf = function (assessmentId, languageId, assessmentTitle, auditId) {
                    var query = breeze.EntityQuery.from("GetAssessmentReportFileNameAndSaveAsPdf").withParameters({
                        assessmentId: assessmentId,
                        languageId: languageId,
                        assessmentTitle: assessmentTitle,
                        isLocking: true,
                        auditId: auditId
                    });
                    return this.assessmentUnitOfWork.assessmentRepository.executeQuery(query);
                };
                AssessmentDatacontext.prototype.saveMailAttachmentAssessmentPdf = function (assessmentId, languageId, assessmentTitle) {
                    var query = breeze.EntityQuery.from("GetAssessmentReportFileNameAndSaveAsPdf").withParameters({
                        assessmentId: assessmentId,
                        languageId: languageId,
                        assessmentTitle: assessmentTitle
                    });
                    return this.assessmentUnitOfWork.assessmentRepository.executeQuery(query);
                };
                AssessmentDatacontext.prototype.getLanguageId = function (culture) {
                    var _this = this;
                    var query = new breeze.EntityQuery().from(app.constants.resourceNames.languages);
                    var languages = (this.assessmentUnitOfWork.languageRepository.executeCacheQuery(query));
                    var language = _.find(languages, function (lang) {
                        return lang.languageCode.toLowerCase() ==
                            _this.fromCultureToLanguage(culture).toLowerCase();
                    });
                    return language.languageId;
                };
                AssessmentDatacontext.prototype.fromCultureToLanguage = function (culture) {
                    var language = "en-gb"; //default
                    var mainCulture = culture.substring(0, 2);
                    switch (mainCulture) {
                        case "nb":
                            language = "nb-no";
                            break;
                        case "nn":
                            language = "nb-no";
                            break;
                        case "es":
                            language = "es-cl";
                    }
                    return language;
                };
                AssessmentDatacontext.prototype.getAssessmentTypeName = function (assessmentTypeId) {
                    var assessmentTypes = this.getAssessmentTypes();
                    var assessmentType = _.find(assessmentTypes, {
                        assessmentTypeId: assessmentTypeId
                    });
                    return app.localizer.resource[assessmentType.dictionary.name];
                };
                AssessmentDatacontext.prototype.openLockedAssessmentReport = function (assessmentId, fullName, auditId) {
                    var reportUrl = this.getLockedReportUrl(assessmentId, fullName, auditId);
                    (window.location.href = reportUrl), "_blank", "fullscreen=no";
                };
                AssessmentDatacontext.prototype.getLockedReportUrl = function (assessmentId, fullName, auditId, currentUserId) {
                    if (currentUserId === void 0) { currentUserId = ""; }
                    if (this.isCustomerView) {
                        this.CreateUserAssessmentIfNotExisting(assessmentId, currentUserId);
                    }
                    var apiUrl = this.apiEndpoint.getApplicationEndpoint();
                    return (apiUrl +
                        "/OpenAttachedFile?key=" +
                        assessmentId +
                        "&fullName=" +
                        fullName +
                        "&useTempFolder=False&useLockFolder=True&auditId=" +
                        auditId +
                        "&type=Assessment");
                };
                AssessmentDatacontext.prototype.getGenerateReportUrl = function (assessmentId, languageId, assessmentName) {
                    var apiUrl = this.apiEndpoint.getApplicationEndpoint();
                    return (apiUrl +
                        "/GenerateReportAndReturnAsMemoryStream?assessmentId=" +
                        assessmentId +
                        "&languageId=" +
                        languageId +
                        "&assessmentName=" +
                        assessmentName);
                };
                AssessmentDatacontext.prototype.getPrescriptionReportUrl = function (prescriptionId, languageId, prescriptionName) {
                    var apiUrl = this.apiEndpoint.getApplicationEndpoint();
                    return (apiUrl +
                        "/GeneratePrescriptionReportAndReturnAsMemoryStream?prescriptionId=" +
                        prescriptionId +
                        "&languageId=" +
                        languageId +
                        "&prescriptionName=" +
                        prescriptionName);
                };
                AssessmentDatacontext.prototype.getGenerateMedicationPerUserReportUrl = function (param) {
                    var apiUrl = this.apiEndpoint.getApplicationEndpoint();
                    return (apiUrl +
                        "/GenerateMedicationPerUserReportAndReturnAsMemoryStream?" +
                        param);
                };
                AssessmentDatacontext.prototype.getGenerateMedicationPerCustomerReportUrl = function (param) {
                    var apiUrl = this.apiEndpoint.getApplicationEndpoint();
                    return (apiUrl +
                        "/GenerateMedicationPerCustomerReportAndReturnAsMemoryStream?" +
                        param);
                };
                AssessmentDatacontext.prototype.hasChanges = function () {
                    return this.assessmentUnitOfWork.hasChanges();
                };
                AssessmentDatacontext.prototype.reject = function () {
                    return this.assessmentUnitOfWork.rejectChanges();
                };
                AssessmentDatacontext.prototype.getAssessmentFaD = function () {
                    return this.assessmentFaD;
                };
                AssessmentDatacontext.prototype.setAssessmentFaDFiltersList = function (newAssessmentFiltersList) {
                    this.assessmentFaD.filterList = newAssessmentFiltersList;
                };
                AssessmentDatacontext.prototype.setAssessmentFaDDateRange = function (newAssessmentDateRange) {
                    this.assessmentFaD.dateRange = newAssessmentDateRange;
                };
                AssessmentDatacontext.prototype.changeVisitTypeValue = function (dataResults) {
                    if (app.common.utils.isNullOrUndefined(dataResults) || dataResults.length < 1)
                        return [];
                    // both dataResults and results are pointing to a place. Using results instead of dataResults makes more clear.
                    var results = dataResults;
                    results.forEach(function (r) {
                        var visitType = r["visitType"] || null;
                        switch (visitType) {
                            case "VisitType_Delicing":
                                r["visitType"] = "ENUM_VisitType_Delicing";
                                break;
                            case "VisitType_Emergency":
                                r["visitType"] = "ENUM_VisitType_Emergency";
                                break;
                            case "VisitType_Extra":
                                r["visitType"] = "ENUM_VisitType_Extra";
                                break;
                            case "VisitType_Followup":
                                r["visitType"] = "ENUM_VisitType_Followup";
                                break;
                            case "VisitType_Routine":
                                r["visitType"] = "ENUM_VisitType_Routine";
                                break;
                            case "VisitType_SideEffect":
                                r["visitType"] = "ENUM_VisitType_SideEffect";
                                break;
                            case "VisitType_Vaccine":
                                r["visitType"] = "ENUM_VisitType_Vaccine";
                                break;
                            default:
                                // code...
                                break;
                        }
                    });
                    return results;
                };
                AssessmentDatacontext.$inject = [
                    "$rootScope",
                    "$http",
                    "$translate",
                    "$q",
                    "sharedDatacontext",
                    "ENV",
                    "apiEndpointService"
                ];
                return AssessmentDatacontext;
            })(app.common.data
                .BaseAssessmentDatacontext);
            services.AssessmentDatacontext = AssessmentDatacontext;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService("AssessmentDatacontext", [
    "$rootScope",
    "$http",
    "$translate",
    "$q",
    "sharedDatacontext",
    "ENV",
    "apiEndpointService"
]);

/// <reference path="../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var MailDatacontext = (function () {
                function MailDatacontext($rootScope, $http, $translate, $q, env, apiEndpoint, fileSystemService) {
                    this.$rootScope = $rootScope;
                    this.$http = $http;
                    this.$translate = $translate;
                    this.$q = $q;
                    this.env = env;
                    this.apiEndpoint = apiEndpoint;
                    this.fileSystemService = fileSystemService;
                    this.entityQuery = breeze.EntityQuery;
                    this.breeze = breeze;
                    this.activePredicate = new breeze.Predicate("active", breeze.FilterQueryOp.Equals, true);
                    //super();                 
                    this._$q = this.$q;
                }
                MailDatacontext.prototype.init = function (mailUnitOfWork) {
                    return this.$q.when(this.mailUnitOfWork = mailUnitOfWork);
                };
                MailDatacontext.prototype.saveMailAttachmentAssessmentPdf = function (assessmentId, languageId, assessmentTitle) {
                    var query = breeze.EntityQuery
                        .from("GetAssessmentReportFileNameAndSaveAsPdf")
                        .withParameters({
                        assessmentId: assessmentId,
                        languageId: languageId,
                        assessmentTitle: assessmentTitle
                    });
                    return this.mailUnitOfWork.mailRepository.executeQuery(query);
                };
                MailDatacontext.prototype.saveMailAttachmentPrescriptionPdf = function (prescriptionId, languageId, title) {
                    var query = breeze.EntityQuery
                        .from("GetPrescriptionReportFileNameAndSaveAsPdf")
                        .withParameters({
                        prescriptionId: prescriptionId,
                        languageId: languageId,
                        title: title
                    });
                    return this.mailUnitOfWork.mailRepository.executeQuery(query);
                };
                MailDatacontext.prototype.getEmails = function (page, pageSize, filterList, dateRange, userId, deviceType, type) {
                    var assessmentFilter = new web.model.AssessmentFilter();
                    assessmentFilter.setFilterValuesFromFilterList(filterList);
                    var fromDate = dateRange ? moment(dateRange.startDate).startOf('day').toDate().toNewUtcDate() : null;
                    var toDate = dateRange ? moment(dateRange.endDate).startOf('day').toDate().toNewUtcDate() : null;
                    var query = breeze.EntityQuery.from("GetMailDtos").withParameters({
                        page: page,
                        pageSize: pageSize,
                        assessmentTypes: assessmentFilter.types,
                        sites: assessmentFilter.sites,
                        representatives: assessmentFilter.representatives,
                        fromDate: fromDate.toISOString(),
                        toDate: toDate.toISOString(),
                        userId: userId,
                        deviceType: deviceType,
                        type: type
                    });
                    // }).orderByDesc("SentDate");
                    query = query.skip(page * pageSize).take(pageSize).inlineCount(true);
                    return this.mailUnitOfWork.mailRepository.executeQueryWithInlineCount(query);
                };
                //private getMockEmails() {
                //    return [
                //        {
                //            mailId: 1, sentDate: moment().toISOString(), customerName: "Salmones Mainstream S.A.", siteName: "Phillipi", assessmentTypeName: "Pre-transfer", representativeFullName: "Alexandre Carvalho", status: "Sent OK"
                //        }];
                //}
                MailDatacontext.prototype.sendMail = function (mailFromAddress, replyTo, mailToAddresses, mailSubject, mailBody, mailCcAddresses, userName, key, type, sentMailId, siteId, userId) {
                    var mailMessage = {
                        from: mailFromAddress,
                        replyTo: replyTo,
                        to: mailToAddresses,
                        subject: mailSubject,
                        body: mailBody,
                        userName: userName,
                        key: key,
                        type: type,
                        sentMailId: sentMailId,
                        siteId: siteId,
                        Cc: mailCcAddresses,
                        userId: userId
                    };
                    var endPoint = this.apiEndpoint.getMailEndpoint() + 'SendMail';
                    //if(1)throw Error('Something wrong client side!');
                    return this.postRequest(endPoint, mailMessage);
                };
                MailDatacontext.prototype.postRequest = function (endPoint, endPointParameter) {
                    var _this = this;
                    return this.$http({
                        url: endPoint,
                        method: "POST",
                        data: JSON.stringify(endPointParameter)
                    }).error(function (data, status, headers, config) {
                        //TODO: Non-blocking error?
                        _this.$rootScope.$broadcast(app.constants.broadcastEventNames.serverErrorOccured, data);
                    });
                };
                MailDatacontext.prototype.getMailTemplate = function (sentMailId, key, type, mail, userId) {
                    var query = breeze.EntityQuery
                        .from("GetMailBody")
                        .withParameters({
                        sentMailId: sentMailId,
                        key: key,
                        type: type,
                        userId: userId
                    });
                    return this.mailUnitOfWork.mailRepository.executeQuery(query);
                };
                MailDatacontext.prototype.attachmentUploadEndPoint = function () {
                    return this.apiEndpoint.getUploadAttachmentEndPoint();
                };
                MailDatacontext.prototype.getHeaders = function () {
                    return this.$http.defaults.headers.common;
                };
                MailDatacontext.prototype.removeFile = function (filename, assessmentId) {
                    var query = breeze.EntityQuery.from("RemoveMailAttachment").withParameters({
                        assessmentId: assessmentId,
                        fullName: filename,
                    });
                    return this.mailUnitOfWork.mailRepository.executeQuery(query);
                };
                MailDatacontext.prototype.openAttachedFile = function (key, type, fullName) {
                    return this.$http({
                        url: this.apiEndpoint.getOpenAttachmentEndPoint() + '?key=' + key + '&type=' + type + '&fullName=' + encodeURIComponent(fullName),
                        method: 'GET',
                        responseType: 'arraybuffer',
                        data: {},
                        headers: {
                            'Content-type': 'application/json',
                            'Accept': 'application/pdf'
                        }
                    });
                };
                MailDatacontext.prototype.getSentFiles = function (key, type) {
                    var query = breeze.EntityQuery.from('GetAttachedFilesToEdit').withParameters({ key: key, type: type });
                    return this.mailUnitOfWork.mailRepository.executeQuery(query);
                };
                MailDatacontext.$inject = ['$rootScope', '$http', '$translate', '$q', 'ENV', 'apiEndpointService', 'fileSystemService'];
                return MailDatacontext;
            })();
            services.MailDatacontext = MailDatacontext;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('MailDatacontext', ['$rootScope', '$http', '$translate', '$q', 'ENV', 'apiEndpointService', 'fileSystemService']);

/// <reference path="../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var UpcomingEventDatacontext = (function () {
                function UpcomingEventDatacontext($rootScope, $http, $translate, $q, env, apiEndpoint) {
                    this.$rootScope = $rootScope;
                    this.$http = $http;
                    this.$translate = $translate;
                    this.$q = $q;
                    this.env = env;
                    this.apiEndpoint = apiEndpoint;
                }
                UpcomingEventDatacontext.prototype.init = function (eventUnitOfWork) {
                    return this.$q.when(this.eventUnitOfWork = eventUnitOfWork);
                };
                UpcomingEventDatacontext.prototype.getEvents = function (page, pageSize, treeViewObject, focusdate, userId, deviceType) {
                    var query = new breeze.EntityQuery('GetEventsDTO').withParameters({
                        page: page,
                        pageSize: pageSize,
                        businessObject: treeViewObject,
                        focusdate: focusdate.toNewUtcDate().toISOString(),
                        userId: userId,
                        deviceType: deviceType
                    });
                    return this.eventUnitOfWork.eventRepository.executeQueryPartial(query, app.constants.entityNames.event, 'eventId').then(function (data) {
                        return data.results; //TODO:only return data
                    });
                };
                UpcomingEventDatacontext.prototype.getSiteIdsWithEvents = function (filterList, levelId) {
                    var assessmentFilter = new web.model.AssessmentFilter();
                    assessmentFilter.setFilterValuesFromFilterList(filterList, levelId);
                    var query = new breeze.EntityQuery('GetSiteIdsWithEvents').withParameters({
                        assessmentTypes: assessmentFilter.types,
                        customers: assessmentFilter.customers,
                        sites: assessmentFilter.sites,
                        representatives: assessmentFilter.representatives
                    });
                    return this.eventUnitOfWork.eventRepository.executeQuery(query).then(function (results) {
                        return results;
                    });
                };
                UpcomingEventDatacontext.prototype.getEventsForMapView = function (siteId, before30Days, before90Days, after90Days) {
                    var query = new breeze.EntityQuery('GetEventsForMapView').withParameters({
                        siteId: siteId,
                        before30Days: before30Days,
                        before90Days: before90Days,
                        after90Days: after90Days
                    }); //TODO user this.authService.credentialsCurrentUserGet().UserId
                    return this.eventUnitOfWork.eventRepository.executeQuery(query).then(function (results) {
                        return results;
                    });
                };
                UpcomingEventDatacontext.prototype.createEvent = function (event) {
                    return this.eventUnitOfWork.eventRepository.createEntity(event, breeze.EntityState.Added);
                };
                UpcomingEventDatacontext.prototype.getAssessmentTypes = function () {
                    var query = new breeze.EntityQuery()
                        .from('AssessmentTypes')
                        .where('active', '==', true)
                        .orderBy('sortOrder');
                    var assessmentTypes = this.eventUnitOfWork.eventRepository.executeCacheQuery(query);
                    if (assessmentTypes.length > 0) {
                        return assessmentTypes;
                    }
                };
                UpcomingEventDatacontext.prototype.save = function () {
                    return this.eventUnitOfWork.saveChanges();
                };
                UpcomingEventDatacontext.prototype.reject = function () {
                    return this.eventUnitOfWork.rejectChanges();
                };
                UpcomingEventDatacontext.prototype.hasChanges = function () {
                    return this.eventUnitOfWork.hasChanges();
                };
                UpcomingEventDatacontext.$inject = ['$rootScope', '$http', '$translate', '$q', 'ENV', 'apiEndpointService'];
                return UpcomingEventDatacontext;
            })();
            services.UpcomingEventDatacontext = UpcomingEventDatacontext;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('UpcomingEventDatacontext', ['$rootScope', '$http', '$translate', '$q', 'ENV', 'apiEndpointService']);

/// <reference path="../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var NavigationDatacontext = (function () {
                function NavigationDatacontext($rootScope, $http, $translate, $q, env, apiEndpoint) {
                    this.$rootScope = $rootScope;
                    this.$http = $http;
                    this.$translate = $translate;
                    this.$q = $q;
                    this.env = env;
                    this.apiEndpoint = apiEndpoint;
                }
                NavigationDatacontext.prototype.init = function (navigatoinUnitOfWork) {
                    return this.$q.when(this.navigatoinUnitOfWork = navigatoinUnitOfWork);
                };
                NavigationDatacontext.prototype.createSecurityLevel = function (roleName) {
                    this.navigatoinUnitOfWork.securityLevelRepository.createEntity({
                        name: 'Read' + roleName
                    }, breeze.EntityState.Added);
                    this.navigatoinUnitOfWork.securityLevelRepository.createEntity({
                        name: 'Full' + roleName
                    }, breeze.EntityState.Added);
                };
                NavigationDatacontext.prototype.getSecurityLevels = function () {
                    return this.navigatoinUnitOfWork.securityLevelRepository.all();
                };
                NavigationDatacontext.prototype.getOperationUnitTypes = function () {
                    var queryOperationUnitTypes = new breeze.EntityQuery().from(app.constants.resourceNames.operationUnitTypesResource);
                    var queryRoleOperationUnitType = new breeze.EntityQuery().from(app.constants.resourceNames.roleOperationUnitTypeResource);
                    var queryRole = new breeze.EntityQuery().from(app.constants.resourceNames.roleResource);
                    return this.$q.all([
                        this.navigatoinUnitOfWork.navigationOptionRepository.executeQuery(queryOperationUnitTypes),
                        this.navigatoinUnitOfWork.navigationOptionRepository.executeQuery(queryRoleOperationUnitType),
                        this.navigatoinUnitOfWork.navigationOptionRepository.executeQuery(queryRole)
                    ]).then(function (data) {
                        return data;
                    });
                };
                NavigationDatacontext.prototype.getNavigationOptions = function () {
                    var queryNavigationMenu = new breeze.EntityQuery().from(app.constants.resourceNames.navigationMenuResource);
                    var queryNavigationOption = new breeze.EntityQuery().from(app.constants.resourceNames.navigationOptionResource);
                    var queryNavigationURL = new breeze.EntityQuery().from(app.constants.resourceNames.navigationURLResource);
                    var queryNavigationSubOption = new breeze.EntityQuery().from(app.constants.resourceNames.navigationSubOptionResource);
                    return this.$q.all([
                        this.navigatoinUnitOfWork.navigationOptionRepository.executeQuery(queryNavigationMenu),
                        this.navigatoinUnitOfWork.navigationOptionRepository.executeQuery(queryNavigationOption),
                        this.navigatoinUnitOfWork.navigationOptionRepository.executeQuery(queryNavigationURL),
                        this.navigatoinUnitOfWork.navigationOptionRepository.executeQuery(queryNavigationSubOption)
                    ]).then(function (data) {
                        return data;
                    });
                };
                NavigationDatacontext.prototype.save = function () {
                    return this.navigatoinUnitOfWork.saveChanges();
                };
                NavigationDatacontext.prototype.reject = function () {
                    return this.navigatoinUnitOfWork.rejectChanges();
                };
                NavigationDatacontext.prototype.hasChanges = function () {
                    return this.navigatoinUnitOfWork.hasChanges();
                };
                NavigationDatacontext.$inject = ['$rootScope', '$http', '$translate', '$q', 'ENV', 'apiEndpointService'];
                return NavigationDatacontext;
            })();
            services.NavigationDatacontext = NavigationDatacontext;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('NavigationDatacontext', app.web.services.NavigationDatacontext.$inject);

/// <reference path="../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var CustomerPortalDatacontext = (function () {
                function CustomerPortalDatacontext($rootScope, $http, $translate, $q, env, apiEndpoint) {
                    this.$rootScope = $rootScope;
                    this.$http = $http;
                    this.$translate = $translate;
                    this.$q = $q;
                    this.env = env;
                    this.apiEndpoint = apiEndpoint;
                }
                CustomerPortalDatacontext.prototype.init = function (customerPortalUnitOfWork) {
                    return this.$q.when(this.customerPortalUnitOfWork = customerPortalUnitOfWork);
                };
                CustomerPortalDatacontext.prototype.getMainContactPerson = function (siteId) {
                    var query = breeze.EntityQuery.from('MainContactPerson').withParameters({ SiteId: siteId });
                    return this.customerPortalUnitOfWork.contactPersonRepository.executeQuery(query)
                        .then(function (data) {
                        if (data.length > 0) {
                            return data[0].contactPerson;
                        }
                        return null;
                    });
                };
                CustomerPortalDatacontext.prototype.getContactPictureByName = function (siteId, filename) {
                    var query = breeze.EntityQuery.from('GetPictureForContactByName').withParameters({
                        siteId: siteId,
                        filename: filename
                    });
                    return this.customerPortalUnitOfWork.contactPersonRepository.executeQuery(query)
                        .then(function (data) {
                        return data[0].data;
                    });
                };
                CustomerPortalDatacontext.prototype.getSideEffectVaccinesBySite = function (siteId) {
                    var query = new breeze.EntityQuery().from('GetSideEffectVaccines').withParameters({ siteId: siteId });
                    return this.customerPortalUnitOfWork.contactPersonRepository.executeQuery(query);
                };
                CustomerPortalDatacontext.prototype.getPrecisionScorVaccinesBySite = function (siteId) {
                    var query = new breeze.EntityQuery().from('GetPrecisionScoreVaccines').withParameters({ siteId: siteId });
                    return this.customerPortalUnitOfWork.contactPersonRepository.executeQuery(query);
                };
                CustomerPortalDatacontext.prototype.getAssessmentGroups = function (siteId) {
                    var query = new breeze.EntityQuery().from('GetAssessmentGroups').withParameters({ siteId: siteId });
                    return this.customerPortalUnitOfWork.contactPersonRepository.executeQuery(query);
                };
                CustomerPortalDatacontext.prototype.getPrecisionScoreChartItems = function (siteId, chartOptionId, selectedVaccines, fromYearMonth, toYearMonth) {
                    var query = new breeze.EntityQuery().from('GetPrecisionScoreChartItems').withParameters({
                        siteId: siteId, chartOptionId: chartOptionId, vaccines: selectedVaccines, fromYearMonth: fromYearMonth, toYearMonth: toYearMonth
                    });
                    return this.customerPortalUnitOfWork.contactPersonRepository.executeQuery(query);
                };
                CustomerPortalDatacontext.prototype.getSideEffectsItems = function (siteId, chartOptionId, selectedVaccines, selectedAssessmentGroups) {
                    var query = new breeze.EntityQuery().from('GetSideEffectsItems').withParameters({ siteId: siteId, chartOptionId: chartOptionId, selectedVaccines: selectedVaccines, selectedAssessmentGroups: selectedAssessmentGroups });
                    return this.customerPortalUnitOfWork.contactPersonRepository.executeQuery(query);
                };
                CustomerPortalDatacontext.prototype.getPercentileSideEffectsItems = function (siteId, chartOptionId, stageId, selectedVaccines, selectedAssessmentGroups) {
                    var query = new breeze.EntityQuery().from('GeSideEffectsPercentilItems').withParameters({ siteId: siteId, chartOptionId: chartOptionId, stageId: stageId, selectedVaccines: selectedVaccines, selectedAssessmentGroups: selectedAssessmentGroups });
                    return this.customerPortalUnitOfWork.contactPersonRepository.executeQuery(query);
                };
                CustomerPortalDatacontext.prototype.getBenchMarkingPrecisionScoreDetail = function (comparisonTypeId, yearMonth, siteId, comparisonItemValue, selectedVaccines) {
                    var query = new breeze.EntityQuery().from('GetBenchmarkPrecisionScoreDetail').withParameters({
                        comparisonTypeId: comparisonTypeId,
                        yearMonth: yearMonth,
                        siteId: siteId,
                        comparisonItemValue: comparisonItemValue,
                        vaccines: selectedVaccines
                    });
                    return this.customerPortalUnitOfWork.contactPersonRepository.executeQuery(query);
                };
                CustomerPortalDatacontext.prototype.getSideEffectsDetail = function (siteId, chartOptionId, serieName, assessmentTypeKeyId, selectedGroups) {
                    var query = new breeze.EntityQuery().from('GetSideEffectsDetail').withParameters({
                        siteId: siteId,
                        chartOptionId: chartOptionId,
                        serieName: serieName,
                        assessmentTypeKeyId: assessmentTypeKeyId,
                        selectedAssessmentGroups: selectedGroups
                    });
                    return this.customerPortalUnitOfWork.contactPersonRepository.executeQuery(query);
                };
                CustomerPortalDatacontext.prototype.save = function () {
                    return this.customerPortalUnitOfWork.saveChanges();
                };
                CustomerPortalDatacontext.prototype.reject = function () {
                    return this.customerPortalUnitOfWork.rejectChanges();
                };
                CustomerPortalDatacontext.prototype.hasChanges = function () {
                    return this.customerPortalUnitOfWork.hasChanges();
                };
                CustomerPortalDatacontext.$inject = ['$rootScope', '$http', '$translate', '$q', 'ENV', 'apiEndpointService'];
                return CustomerPortalDatacontext;
            })();
            services.CustomerPortalDatacontext = CustomerPortalDatacontext;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('CustomerPortalDatacontext', ['$rootScope', '$http', '$translate', '$q', 'ENV', 'apiEndpointService']);

/// <reference path="../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var UserManagementDatacontext = (function () {
                function UserManagementDatacontext($rootScope, $http, $q, apiEndpoint) {
                    this.$rootScope = $rootScope;
                    this.$http = $http;
                    this.$q = $q;
                    this.apiEndpoint = apiEndpoint;
                }
                UserManagementDatacontext.prototype.init = function (userManagementUnitOfWork) {
                    return this.$q.when(this.userManagementUnitOfWork = userManagementUnitOfWork);
                };
                UserManagementDatacontext.prototype.getUserSignatureUploadEndpoint = function () {
                    return this.apiEndpoint.getUserManagementEndpoint() + 'UploadSignature';
                };
                UserManagementDatacontext.prototype.deleteUserSignature = function () {
                    return this.$http.post(this.apiEndpoint.getUserManagementEndpoint() + 'DeleteSignature', null).then(function (response) {
                        return response;
                    });
                };
                UserManagementDatacontext.prototype.getUserById = function (userId) {
                    var deferred = this.$q.defer();
                    this.$http.get(this.apiEndpoint.getUserManagementEndpoint() + 'GetUser', { params: { id: userId } }).success(function (data) {
                        deferred.resolve(data);
                    }).error(function (err) {
                        deferred.reject(err);
                    });
                    return deferred.promise;
                };
                UserManagementDatacontext.prototype.updateUser = function (userToUpdate) {
                    return this.$http.post(this.apiEndpoint.getUserManagementEndpoint() + 'UpdateUser', userToUpdate).then(function (response) {
                        return response;
                    });
                };
                UserManagementDatacontext.prototype.createRole = function (roleName) {
                    return this.$http.post(this.apiEndpoint.getUserManagementEndpoint() + 'CreateRole', { roleName: roleName }).then(function (response) {
                        return response;
                    });
                };
                UserManagementDatacontext.prototype.changePassword = function (userToUpdate) {
                    return this.$http.post(this.apiEndpoint.getUserManagementEndpoint() + 'ChangePassword', userToUpdate).then(function (response) {
                        return response;
                    });
                };
                UserManagementDatacontext.prototype.forgotPassword = function (user) {
                    return this.$http.post(this.apiEndpoint.getUserManagementEndpoint() + 'ForgotPassword', user).then(function (response) {
                        return response;
                    });
                };
                UserManagementDatacontext.prototype.resetPassword = function (data) {
                    return this.$http.post(this.apiEndpoint.getUserManagementEndpoint() + 'ResetPassword', data).then(function (response) {
                        return response;
                    });
                };
                UserManagementDatacontext.prototype.getUsers = function () {
                    var deferred = this.$q.defer();
                    this.$http.get(this.apiEndpoint.getUserManagementEndpoint() + 'GetUsers').success(function (data) {
                        deferred.resolve(data);
                    }).error(function (err) {
                        deferred.reject(err);
                    });
                    return deferred.promise;
                };
                UserManagementDatacontext.prototype.getCultures = function () {
                    var _this = this;
                    var deferred = this.$q.defer();
                    if (this.localCachedCultures != null && this.localCachedCultures.length > 0) {
                        deferred.resolve(this.localCachedCultures);
                    }
                    else {
                        this.$http.get(this.apiEndpoint.getUserManagementEndpoint() + 'GetCultures').success(function (data) {
                            _this.localCachedCultures = data;
                            deferred.resolve(data);
                        }).error(function (err) {
                            deferred.reject(err);
                        });
                    }
                    return deferred.promise;
                };
                UserManagementDatacontext.prototype.getValidRoles = function (isCustomerMode) {
                    var _this = this;
                    var deferred = this.$q.defer();
                    if (this.localCachedRoles != null && this.localCachedRoles.length > 0) {
                        deferred.resolve(this.localCachedRoles);
                    }
                    else {
                        this.$http.get(this.apiEndpoint.getUserManagementEndpoint() + 'GetValidRoles', { params: { isCustomerMode: isCustomerMode } }).success(function (data) {
                            _this.localCachedRoles = data;
                            deferred.resolve(data);
                        }).error(function (err) {
                            deferred.reject(err);
                        });
                    }
                    return deferred.promise;
                };
                UserManagementDatacontext.prototype.getUsersWithRefreshTokens = function () {
                    var deferred = this.$q.defer();
                    this.$http.get(this.apiEndpoint.getRefreshTokensEndpoint() + 'GetRefreshTokens').success(function (data) {
                        deferred.resolve(data);
                    }).error(function (err) {
                        deferred.reject(err);
                    });
                    return deferred.promise;
                };
                UserManagementDatacontext.prototype.getClients = function () {
                    var deferred = this.$q.defer();
                    this.$http.get(this.apiEndpoint.getRefreshTokensEndpoint() + 'GetClients').success(function (data) {
                        deferred.resolve(data);
                    }).error(function (err) {
                        deferred.reject(err);
                    });
                    return deferred.promise;
                };
                UserManagementDatacontext.prototype.addClient = function (client) {
                    var deferred = this.$q.defer();
                    this.$http.post(this.apiEndpoint.getRefreshTokensEndpoint() + 'AddClient', client).success(function (data) {
                        deferred.resolve(data);
                    }).error(function (err) {
                        deferred.reject(err);
                    });
                    return deferred.promise;
                };
                UserManagementDatacontext.prototype.toggleActive = function (client) {
                    return this.$http.post(this.apiEndpoint.getRefreshTokensEndpoint() + 'ToggleActive', client).then(function (response) {
                        return response;
                    });
                };
                UserManagementDatacontext.prototype.logOffDevice = function (refreshtoken) {
                    return this.$http.post(this.apiEndpoint.getRefreshTokensEndpoint() + 'DeleteRefreshToken', refreshtoken).then(function (response) {
                        return response;
                    });
                };
                UserManagementDatacontext.prototype.deleteUser = function (userToDelete) {
                    return this.$http.post(this.apiEndpoint.getUserManagementEndpoint() + 'DeleteUser', userToDelete).then(function (response) {
                        return response;
                    });
                };
                UserManagementDatacontext.prototype.unDeleteUser = function (userToUndelete) {
                    return this.$http.post(this.apiEndpoint.getUserManagementEndpoint() + 'UnDeleteUser', userToUndelete).then(function (response) {
                        return response;
                    });
                };
                UserManagementDatacontext.prototype.createUserBusinessObject = function (userBusinessObject) {
                    return this.userManagementUnitOfWork.userBusinessObjectRepository.createEntity(userBusinessObject, breeze.EntityState.Added);
                };
                UserManagementDatacontext.prototype.getUserBusinessObjects = function (userId) {
                    var _this = this;
                    var query = new breeze.EntityQuery(app.constants.resourceNames.userBusinessObjectResource).where("userId", "==", userId);
                    var securityLevels = this.getSecurityLevels();
                    return this.userManagementUnitOfWork.userBusinessObjectRepository.executeQuery(query)
                        .then(function (userBusinessObjects) {
                        _.forEach(userBusinessObjects, function (userBusinessObject) {
                            userBusinessObject.permission = web.utils.permission.getPermission(securityLevels, userBusinessObject.securityLevelBitMask);
                            var businessObject;
                            var customerId = 0;
                            switch (userBusinessObject.operationUnitTypeLevelId.toString()) {
                                case app.constants.operationUnitLevels.company:
                                    businessObject = _this.userManagementUnitOfWork.companyRepository.findByIdInCache(userBusinessObject.businessObjectId);
                                    break;
                                case app.constants.operationUnitLevels.companyBU:
                                    businessObject = _this.userManagementUnitOfWork.companyBURepository.findByIdInCache(userBusinessObject.businessObjectId);
                                    break;
                                case app.constants.operationUnitLevels.customer:
                                    businessObject = _this.userManagementUnitOfWork.customerRepository.findByIdInCache(userBusinessObject.businessObjectId);
                                    customerId = userBusinessObject.businessObjectId;
                                    break;
                                case app.constants.operationUnitLevels.customerBU:
                                    businessObject = _this.userManagementUnitOfWork.customerBURepository.findByIdInCache(userBusinessObject.businessObjectId);
                                    customerId = userBusinessObject.customerId;
                                    break;
                                case app.constants.operationUnitLevels.operation:
                                    businessObject = _this.userManagementUnitOfWork.operationRepository.findByIdInCache(userBusinessObject.businessObjectId);
                                    customerId = businessObject.customerBU.customer.customerId;
                                    break;
                                case app.constants.operationUnitLevels.region:
                                    businessObject = _this.userManagementUnitOfWork.regionRepository.findByIdInCache(userBusinessObject.businessObjectId);
                                    customerId = businessObject.operation.customerBU.customer.customerId;
                                    break;
                                case app.constants.operationUnitLevels.area:
                                    businessObject = _this.userManagementUnitOfWork.areaRepository.findByIdInCache(userBusinessObject.businessObjectId);
                                    customerId = businessObject.region.operation.customerBU.customer.customerId;
                                    break;
                                case app.constants.operationUnitLevels.site:
                                    businessObject = _this.userManagementUnitOfWork.siteRepository.findByIdInCache(userBusinessObject.businessObjectId);
                                    customerId = businessObject.area.region.operation.customerBU.customer.customerId;
                                    break;
                                default:
                                    businessObject = { name: "Not defined" };
                            }
                            userBusinessObject.description = _this.getCurrentObjectBreadcrumbDescription(userBusinessObject.operationUnitTypeLevelId, businessObject);
                            userBusinessObject.businessObjectName = businessObject.name;
                            userBusinessObject.customerId = customerId;
                        });
                        return userBusinessObjects;
                    });
                };
                UserManagementDatacontext.prototype.getCurrentObjectBreadcrumbDescription = function (levelId, businessObject) {
                    var description;
                    switch (levelId.toString()) {
                        case app.constants.operationUnitLevels.site:
                            description = "(" + businessObject.area.name + " < " + businessObject.area.region.name + " < " + businessObject.area.region.operation.name + " < " + businessObject.area.region.operation.customerBU.name + " < " + businessObject.area.region.operation.customerBU.customer.name + ")";
                            break;
                        case app.constants.operationUnitLevels.area:
                            description = "(" + businessObject.region.name + " < " + businessObject.region.operation.name + " < " + businessObject.region.operation.customerBU.name + " < " + businessObject.region.operation.customerBU.customer.name + ")";
                            break;
                        case app.constants.operationUnitLevels.region:
                            description = "(" + businessObject.operation.name + " < " + businessObject.operation.customerBU.name + " < " + businessObject.operation.customerBU.customer.name + ")";
                            break;
                        case app.constants.operationUnitLevels.operation:
                            description = "(" + businessObject.customerBU.name + " < " + businessObject.customerBU.customer.name + ")";
                            break;
                        case app.constants.operationUnitLevels.customerBU:
                            description = "(" + businessObject.name + " < " + businessObject.customer.name + ")";
                            break;
                        case app.constants.operationUnitLevels.customer:
                            description = "(" + businessObject.name + ")";
                            break;
                        case app.constants.operationUnitLevels.companyBU:
                            description = "(" + businessObject.name + " < " + businessObject.company.name + ")";
                            break;
                        case app.constants.operationUnitLevels.company:
                            description = "(" + businessObject.name + ")";
                            break;
                        default:
                            description = '';
                            break;
                    }
                    return description;
                };
                UserManagementDatacontext.prototype.getBusinessObject = function (levelId, objectId) {
                    var _this = this;
                    var objects;
                    switch (levelId.toString()) {
                        case app.constants.operationUnitLevels.site:
                            objects = _.map(_.filter(this.getSites(), { 'siteId': objectId }), function (site) {
                                return { object: site, levelId: app.constants.operationUnitLevels.site, title: site.name, id: site.siteId, description: _this.getCurrentObjectBreadcrumbDescription(levelId, site) };
                            });
                            break;
                        case app.constants.operationUnitLevels.area:
                            objects = _.map(_.filter(this.getAreas(), { 'areaId': objectId }), function (area) {
                                return { object: area, levelId: app.constants.operationUnitLevels.area, title: area.name, id: area.areaId, description: _this.getCurrentObjectBreadcrumbDescription(levelId, area) };
                            });
                            break;
                        case app.constants.operationUnitLevels.region:
                            objects = _.map(_.filter(this.getRegions(), { 'regionId': objectId }), function (region) {
                                return { object: region, levelId: app.constants.operationUnitLevels.region, title: region.name, id: region.regionId, description: _this.getCurrentObjectBreadcrumbDescription(levelId, region) };
                            });
                            break;
                        case app.constants.operationUnitLevels.operation:
                            objects = _.map(_.filter(this.getOperations(), { 'operationId': objectId }), function (operation) {
                                return { object: operation, levelId: app.constants.operationUnitLevels.operation, title: operation.name, id: operation.operationId, description: _this.getCurrentObjectBreadcrumbDescription(levelId, operation) };
                            });
                            break;
                        case app.constants.operationUnitLevels.customerBU:
                            objects = _.map(_.filter(this.getCustomerBUs(), { 'customerBUId': objectId }), function (customerBu) {
                                return { object: customerBu, levelId: app.constants.operationUnitLevels.customerBU, title: customerBu.name, id: customerBu.customerBUId, description: _this.getCurrentObjectBreadcrumbDescription(levelId, customerBu) };
                            });
                            break;
                        case app.constants.operationUnitLevels.customer:
                            objects = _.map(_.filter(this.getCustomers(), { 'customerId': objectId }), function (customer) {
                                return { object: customer, levelId: app.constants.operationUnitLevels.customer, title: customer.name, id: customer.customerId, description: _this.getCurrentObjectBreadcrumbDescription(levelId, customer) };
                            });
                            break;
                        case app.constants.operationUnitLevels.companyBU:
                            objects = _.map(_.filter(this.getCompanyBUs(), { 'companyBUId': objectId }), function (companyBu) {
                                return { object: companyBu, levelId: app.constants.operationUnitLevels.companyBU, title: companyBu.name, id: companyBu.companyBUId, description: _this.getCurrentObjectBreadcrumbDescription(levelId, companyBu) };
                            });
                            break;
                        case app.constants.operationUnitLevels.company:
                            objects = _.map(_.filter(this.getCompanies(), { 'companyId': objectId }), function (company) {
                                return { object: company, levelId: app.constants.operationUnitLevels.company, title: company.name, id: company.companyId, description: _this.getCurrentObjectBreadcrumbDescription(levelId, company) };
                            });
                            break;
                    }
                    return objects[0];
                };
                UserManagementDatacontext.prototype.getCustomerId = function (levelId, businessObject) {
                    var customerId;
                    switch (levelId.toString()) {
                        case app.constants.operationUnitLevels.site:
                            customerId = businessObject.area.region.operation.customerBU.customer.customerId;
                            break;
                        case app.constants.operationUnitLevels.area:
                            customerId = businessObject.region.operation.customerBU.customer.customerId;
                            break;
                        case app.constants.operationUnitLevels.region:
                            customerId = businessObject.operation.customerBU.customer.customerId;
                            break;
                        case app.constants.operationUnitLevels.operation:
                            customerId = businessObject.customerBU.customer.customerId;
                            break;
                        case app.constants.operationUnitLevels.customerBU:
                            customerId = businessObject.customer.customerId;
                            break;
                        case app.constants.operationUnitLevels.customer:
                            customerId = businessObject.customerId;
                            break;
                        default:
                            customerId = 0;
                            break;
                    }
                    return customerId;
                };
                UserManagementDatacontext.prototype.getOperationUnitLookupsForUserManagement = function () {
                    var query = new breeze.EntityQuery().from('OperationUnitLookupsForUserManagement');
                    return this.userManagementUnitOfWork.userBusinessObjectRepository.executeQuery(query);
                };
                UserManagementDatacontext.prototype.getOperationUnitTypes = function () {
                    var query = new breeze.EntityQuery().from(app.constants.resourceNames.operationUnitTypesResource);
                    return this.userManagementUnitOfWork.userBusinessObjectRepository.executeCacheQuery(query);
                };
                UserManagementDatacontext.prototype.getSites = function (customerId) {
                    var query = new breeze.EntityQuery().from(app.constants.resourceNames.siteResource);
                    if (customerId) {
                        query = query.where('area.region.operation.customerBU.customerId', '==', customerId);
                    }
                    return this.userManagementUnitOfWork.userBusinessObjectRepository.executeCacheQuery(query);
                };
                UserManagementDatacontext.prototype.getAreas = function () {
                    var query = new breeze.EntityQuery().from(app.constants.resourceNames.areaResource);
                    return this.userManagementUnitOfWork.userBusinessObjectRepository.executeCacheQuery(query);
                };
                UserManagementDatacontext.prototype.getRegions = function () {
                    var query = new breeze.EntityQuery().from(app.constants.resourceNames.regionResource);
                    return this.userManagementUnitOfWork.userBusinessObjectRepository.executeCacheQuery(query);
                };
                UserManagementDatacontext.prototype.getOperations = function () {
                    var query = new breeze.EntityQuery().from(app.constants.resourceNames.operationResource);
                    return this.userManagementUnitOfWork.userBusinessObjectRepository.executeCacheQuery(query);
                };
                UserManagementDatacontext.prototype.getCustomerBUs = function () {
                    var activePredicate = new breeze.Predicate("active", breeze.FilterQueryOp.Equals, true);
                    return this.userManagementUnitOfWork.customerBURepository.findInCache(activePredicate, 'name');
                };
                UserManagementDatacontext.prototype.getCustomers = function () {
                    var activePredicate = new breeze.Predicate("active", breeze.FilterQueryOp.Equals, true);
                    return this.userManagementUnitOfWork.customerRepository.findInCache(activePredicate, 'name');
                };
                UserManagementDatacontext.prototype.getCompanyBUs = function () {
                    var activePredicate = new breeze.Predicate("active", breeze.FilterQueryOp.Equals, true);
                    return this.userManagementUnitOfWork.companyBURepository.findInCache(activePredicate, 'name');
                };
                UserManagementDatacontext.prototype.getCompanies = function () {
                    var activePredicate = new breeze.Predicate("active", breeze.FilterQueryOp.Equals, true);
                    return this.userManagementUnitOfWork.companyRepository.findInCache(activePredicate, 'name');
                };
                UserManagementDatacontext.prototype.getSecurityLevels = function () {
                    return this.userManagementUnitOfWork.securityLevelRepository.allInCache();
                };
                UserManagementDatacontext.prototype.save = function () {
                    return this.userManagementUnitOfWork.saveChanges();
                };
                UserManagementDatacontext.prototype.reject = function () {
                    return this.userManagementUnitOfWork.rejectChanges();
                };
                UserManagementDatacontext.prototype.hasChanges = function () {
                    return this.userManagementUnitOfWork.hasChanges();
                };
                UserManagementDatacontext.$inject = ['$rootScope', '$http', '$q', 'apiEndpointService'];
                return UserManagementDatacontext;
            })();
            services.UserManagementDatacontext = UserManagementDatacontext;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('UserManagementDatacontext', ['$rootScope', '$http', '$q', 'apiEndpointService']);

/// <reference path="../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var PrescriptionDatacontext = (function (_super) {
                __extends(PrescriptionDatacontext, _super);
                function PrescriptionDatacontext(_$q, $http, _sharedDatacontext, apiEndpoint) {
                    _super.call(this, _$q, _sharedDatacontext);
                    this.$http = $http;
                    this.apiEndpoint = apiEndpoint;
                    //public rejectChanges(assessment) {
                    //    return this.sharedDatacontext.loadOfflineStorage().then((provider) => {
                    //        this.prescriptionUnitOfWork.provider = provider;
                    //    });
                    //}
                    this.prescriptionFaD = {
                        filterList: [],
                        dateRange: {}
                    };
                }
                PrescriptionDatacontext.prototype.getPrescriptions = function (page, pageSize, filterList, dateRange, userId, deviceType, getAll) {
                    if (getAll === void 0) { getAll = false; }
                    var filter = new web.model.AssessmentFilter();
                    filter.setFilterValuesFromFilterList(filterList);
                    var fromDate = dateRange ? moment(dateRange.startDate).startOf('day').toDate().toNewUtcDate() : null;
                    var toDate = dateRange ? moment(dateRange.endDate).startOf('day').toDate().toNewUtcDate() : null;
                    var query = breeze.EntityQuery.from("PrescriptionDtos").withParameters({
                        page: page,
                        pageSize: pageSize,
                        representatives: filter.representatives,
                        treatmentProducts: filter.treatmentProducts,
                        sites: filter.sites,
                        fromDate: fromDate.toISOString(),
                        toDate: toDate.toISOString(),
                        userId: userId,
                        deviceType: deviceType
                    });
                    if (getAll === false)
                        query = query.skip(page * pageSize).take(pageSize).inlineCount(true);
                    else
                        query = query.inlineCount(true);
                    return this.assessmentUnitOfWork.prescriptionsRepository.executeQueryWithInlineCount(query);
                };
                PrescriptionDatacontext.prototype.getTreatmentProductsFiltered = function (page, pageSize, filterList) {
                    var filter = new web.model.AssessmentFilter();
                    filter.setFilterValuesFromFilterList(filterList);
                    var query = breeze.EntityQuery.from(app.constants.resourceNames.treatmentProductResource);
                    var producers = filter.treatmentProductProducers.map(function (producerId) { return breeze.Predicate.create("producerId", "==", producerId); });
                    var activeSubstances = filter.activeSubstances.map(function (activeSubstanceId) { return breeze.Predicate.create("activeSubstanceId", "==", activeSubstanceId); });
                    var companyBUs = filter.companyBUs.map(function (companyBUId) { return breeze.Predicate.create("companyBUId", "==", companyBUId); });
                    var producersQuery = breeze.Predicate.or(producers);
                    var activeSubstancesQuery = breeze.Predicate.or(activeSubstances);
                    var companyBUQuery = breeze.Predicate.or(companyBUs);
                    if (producersQuery)
                        query = query.where(producersQuery);
                    if (activeSubstancesQuery)
                        query = query.where(activeSubstancesQuery);
                    if (companyBUQuery)
                        query = query.where(companyBUQuery);
                    query = query.orderBy('name');
                    var filteredItems = this.assessmentUnitOfWork.treatmentProductRepository.executeCacheQuery(query);
                    var items = app.common.utils.getPaginatedItems(filteredItems, page, pageSize);
                    var deffered = this.$q.defer();
                    deffered.resolve(items);
                    return deffered.promise;
                };
                PrescriptionDatacontext.prototype.getPrescriptionFaD = function () {
                    return this.prescriptionFaD;
                };
                PrescriptionDatacontext.prototype.setPrescriptionFaDFiltersList = function (newPrescriptionFiltersList) {
                    this.prescriptionFaD.filterList = newPrescriptionFiltersList;
                };
                PrescriptionDatacontext.prototype.setPrescriptionFaDDateRange = function (newPrescriptionDateRange) {
                    this.prescriptionFaD.dateRange = newPrescriptionDateRange;
                };
                PrescriptionDatacontext.prototype.openAttachedFile = function (prescriptionId, filename) {
                    var data = "?prescriptionId=" + prescriptionId + "&filename=" + filename;
                    return this.$http({
                        url: this.apiEndpoint.getOpenPrescriptionFileEndPoint() + data,
                        method: "GET",
                        responseType: "arraybuffer",
                        data: {}
                    });
                };
                PrescriptionDatacontext.prototype.save = function (prescription) {
                    var _this = this;
                    if (prescription === void 0) { prescription = null; }
                    return this.assessmentUnitOfWork.saveChanges()
                        .then(function (result) {
                        if (prescription) {
                            var data = "?prescriptionId=" + prescription.prescriptionId;
                            return _this.$http
                                .get(_this.apiEndpoint.getUpdatePrescriptionFilesFolderEndpoint() +
                                data, {
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                }
                            })
                                .success(function (success) {
                                return result;
                            })
                                .error(function (error) {
                                throw error;
                            });
                        }
                        else
                            return result;
                    })
                        .catch(function (error) {
                        console.log("error: " + error);
                        return error;
                    });
                };
                PrescriptionDatacontext.prototype.addPropertiesForListPrescriptions = function (results) {
                    var notAllowUnit = ["none", "unknown"];
                    if (!(results && results.length > 0))
                        return [];
                    results.forEach(function (element, index, array) {
                        if (app.common.utils.isNullOrUndefinedOrEmpty(element["amountMeasureUnitName"])
                            || notAllowUnit.indexOf(element["amountMeasureUnitName"].toString().toLowerCase()) > -1)
                            element["amountMeasureUnitName"] = "";
                        var inclusionMeasureUnitName = element["inclusionMeasureUnitName"];
                        var amountMeasureUnitNameStandardName = element["amountMeasureUnitNameStandardName"];
                        var concentrationMeasureUnitName = "";
                        if (app.common.utils.isNullOrUndefinedOrEmpty(inclusionMeasureUnitName)
                            || notAllowUnit.indexOf(inclusionMeasureUnitName.toLowerCase()) > -1) {
                            element["inclusionMeasureUnitName"] = "";
                        }
                        else {
                            if (!app.common.utils.isNullOrUndefinedOrEmpty(amountMeasureUnitNameStandardName)
                                && notAllowUnit.indexOf(amountMeasureUnitNameStandardName.toLowerCase()) === -1) {
                                if (!app.common.utils.isNullOrUndefinedOrEmpty(inclusionMeasureUnitName)
                                    && !app.common.utils.isNullOrUndefinedOrEmpty(amountMeasureUnitNameStandardName))
                                    concentrationMeasureUnitName = amountMeasureUnitNameStandardName + "/" + inclusionMeasureUnitName;
                            }
                        }
                        element["concentrationMeasureUnitName"] = concentrationMeasureUnitName;
                        element["amountString"] = app.common.utils.appendNumberAndUnit(element.amount, element.amountMeasureUnitName);
                        element["concentrationString"] = app.common.utils.appendNumberAndUnit(app.common.utils.precise_round(element.inclusion, 2), element["concentrationMeasureUnitName"]);
                        element["inclusionTotal"] = app.common.utils.precise_round(element.inclusion, 2);
                    });
                    return results;
                };
                PrescriptionDatacontext.$inject = ["$q", "$http", "sharedDatacontext", "apiEndpointService"];
                return PrescriptionDatacontext;
            })(app.common.data.BasePrescriptionDatacontext);
            services.PrescriptionDatacontext = PrescriptionDatacontext;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('PrescriptionDatacontext', ['$q', '$http', 'sharedDatacontext', 'apiEndpointService']);

/// <reference path="../_typings.web.ts"/>
"use strict";
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var SupplierDatacontext = (function () {
                function SupplierDatacontext($q) {
                    this.$q = $q;
                    this.entityQuery = breeze.EntityQuery;
                    this.breeze = breeze;
                    this.activePredicate = new breeze.Predicate("active", breeze.FilterQueryOp.Equals, true);
                }
                SupplierDatacontext.prototype.init = function (prescriptionUnitOfWork) {
                    return this.$q.when((this.prescriptionUnitOfWork = prescriptionUnitOfWork));
                };
                SupplierDatacontext.prototype.createSupplier = function (supplier) {
                    return this.prescriptionUnitOfWork.suppliersRepository.createEntity(supplier, breeze.EntityState.Added);
                };
                SupplierDatacontext.prototype.getSuppliers = function (page, pageSize, filterList) {
                    //return this.getSuppliersFromDto(page, pageSize, filterList);
                    return this.getSuppliersFromCache(page, pageSize, filterList);
                };
                SupplierDatacontext.prototype.getSuppliersFromDto = function (page, pageSize, filterList) {
                    var filter = new web.model.AssessmentFilter();
                    filter.setFilterValuesFromFilterList(filterList);
                    var query = breeze.EntityQuery.from("SupplierDtos").withParameters({
                        page: page,
                        pageSize: pageSize,
                        representatives: filter.representatives,
                        treatmentProducts: filter.treatmentProducts
                    });
                    query = query
                        .skip(page * pageSize)
                        .take(pageSize)
                        .inlineCount(true);
                    return this.prescriptionUnitOfWork.suppliersRepository.executeQueryWithInlineCount(query);
                };
                SupplierDatacontext.prototype.getSuppliersFromCache = function (page, pageSize, filterList) {
                    var filter = new web.model.AssessmentFilter();
                    filter.setFilterValuesFromFilterList(filterList);
                    var query = breeze.EntityQuery.from(app.constants.resourceNames.supplierResource).orderBy("name");
                    var filteredItems = this.prescriptionUnitOfWork.suppliersRepository.executeCacheQuery(query);
                    var items = app.common.utils.getPaginatedItems(filteredItems, page, pageSize);
                    return this.$q.when(items);
                };
                SupplierDatacontext.prototype.getAllSuppliersInOnce = function () {
                    return this.prescriptionUnitOfWork.suppliersRepository.findInCache(this.activePredicate, "name");
                };
                SupplierDatacontext.prototype.getSupplierTypes = function () {
                    return (this.prescriptionUnitOfWork.supplierTypeRepository.findInCache(this.activePredicate, "name"));
                };
                SupplierDatacontext.prototype.save = function () {
                    return this.prescriptionUnitOfWork
                        .saveChanges()
                        .then(function (result) {
                        return result;
                    })
                        .catch(function (error) {
                        console.log("error: " + error);
                        return error;
                    });
                };
                SupplierDatacontext.prototype.getSupplierById = function (supplierId) {
                    return this.prescriptionUnitOfWork.suppliersRepository.findById(supplierId);
                };
                SupplierDatacontext.prototype.deleteSupplier = function (supplierId) {
                    var supplier = this.prescriptionUnitOfWork.suppliersRepository.findByIdInCache(supplierId);
                    var query = new breeze.EntityQuery("DeleteSupplierById?SupplierId=" + supplierId);
                    return this.prescriptionUnitOfWork.suppliersRepository
                        .executeQuery(query)
                        .then(function (data) {
                        supplier.entityAspect.setDeleted();
                        console.log("delete [Supplier] from remote data source");
                    });
                };
                SupplierDatacontext.prototype.getCompanyBUs = function () {
                    return this.prescriptionUnitOfWork.companyBUsRepository.findInCache(this.activePredicate, "name");
                };
                SupplierDatacontext.prototype.hasChanges = function () {
                    return this.prescriptionUnitOfWork.hasChanges();
                };
                SupplierDatacontext.prototype.validateEntity = function (entity) {
                    return this.prescriptionUnitOfWork.validateEntity(entity);
                };
                SupplierDatacontext.prototype.getValidationErrors = function (Supplier) {
                    return Supplier.entityAspect.getValidationErrors();
                };
                SupplierDatacontext.prototype.rejectChangesOnEntity = function (entity) {
                    return this.prescriptionUnitOfWork.rejectEntityChanges(entity);
                };
                SupplierDatacontext.$inject = ["$q"];
                return SupplierDatacontext;
            })();
            services.SupplierDatacontext = SupplierDatacontext;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService("SupplierDatacontext", ["$q"]);

/// <reference path="../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var AttributeDatacontext = (function () {
                function AttributeDatacontext($q) {
                    this.$q = $q;
                    this.entityQuery = breeze.EntityQuery;
                    this.breeze = breeze;
                    this.activePredicate = new breeze.Predicate("active", breeze.FilterQueryOp.Equals, true);
                }
                AttributeDatacontext.prototype.init = function (attributeUnitOfWork) {
                    return this.$q.when(this.attributeUnitOfWork = attributeUnitOfWork);
                };
                AttributeDatacontext.prototype.createAttributeMetadataEnum = function (attributeMetadataEnum) {
                    return this.attributeUnitOfWork.attributeMetadataEnumRepository.createEntity(attributeMetadataEnum, breeze.EntityState.Added);
                };
                AttributeDatacontext.prototype.getAttributeMetadataEnumById = function (attributeMetaDataEnumId) {
                    return this.attributeUnitOfWork.attributeMetadataEnumRepository.findById(attributeMetaDataEnumId);
                };
                AttributeDatacontext.prototype.getAttribute = function (attributeId) {
                    return this.attributeUnitOfWork.attributeRepository.findByIdInCache(attributeId);
                };
                AttributeDatacontext.prototype.getAttributes = function (attributeTypeId) {
                    var query = new breeze.EntityQuery(app.constants.resourceNames.attributes).where(new breeze.Predicate("attributeTypeId", breeze.FilterQueryOp.Equals, attributeTypeId));
                    return this.attributeUnitOfWork.attributeRepository.executeCacheQuery(query);
                };
                AttributeDatacontext.prototype.GetAttributeTemplateRegistrationUsage = function (attributeId) {
                    var query = new breeze.EntityQuery('GetAttributeTemplateRegistrationUsage').withParameters({ attributeId: attributeId });
                    return this.attributeUnitOfWork.attributeRepository.executeQuery(query);
                };
                AttributeDatacontext.prototype.deleteAttributeMetadataEnum = function (attributeMetaDataEnumId) {
                    var predicate = new breeze.Predicate('attributeMetaDataEnumId', breeze.FilterQueryOp.Equals, 'attributeMetaDataEnumId');
                    var attributeMetaDataEnum = this.attributeUnitOfWork.attributeMetadataEnumRepository.findInCache(predicate);
                    if (!app.common.utils.entityIsDetachedOrDeleted(attributeMetaDataEnum[0])) {
                        if (attributeMetaDataEnum[0].attributeMetadataEnumId > 0)
                            attributeMetaDataEnum[0].entityAspect.setDeleted();
                        else
                            this.attributeUnitOfWork.detachEntity(attributeMetaDataEnum[0]);
                    }
                };
                AttributeDatacontext.prototype.getAttributeMetadataEnums = function (attributeId) {
                    var query = new breeze.EntityQuery(app.constants.resourceNames.attributeMetadataEnums).where(new breeze.Predicate("attributeId", breeze.FilterQueryOp.Equals, attributeId));
                    return this.$q.when(this.attributeUnitOfWork.attributeRepository.executeCacheQuery(query));
                };
                AttributeDatacontext.prototype.save = function () {
                    return this.attributeUnitOfWork.saveChanges()
                        .then(function (result) {
                        return result;
                    })
                        .catch(function (error) {
                        console.log('error: ' + error);
                        return error;
                    });
                };
                AttributeDatacontext.prototype.hasChanges = function () {
                    return this.attributeUnitOfWork.hasChanges();
                };
                AttributeDatacontext.prototype.validateEntity = function (entity) {
                    return this.attributeUnitOfWork.validateEntity(entity);
                };
                AttributeDatacontext.prototype.getValidationErrors = function (Supplier) {
                    return Supplier.entityAspect.getValidationErrors();
                };
                AttributeDatacontext.prototype.rejectChangesOnEntity = function (entity) {
                    return this.attributeUnitOfWork.rejectEntityChanges(entity);
                };
                AttributeDatacontext.$inject = ['$q'];
                return AttributeDatacontext;
            })();
            services.AttributeDatacontext = AttributeDatacontext;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('AttributeDatacontext', ['$q']);

/// <reference path="../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var TreatmentProductProducerDatacontext = (function () {
                function TreatmentProductProducerDatacontext($q) {
                    this.$q = $q;
                    this.entityQuery = breeze.EntityQuery;
                    this.breeze = breeze;
                    this.activePredicate = new breeze.Predicate("active", breeze.FilterQueryOp.Equals, true);
                    this._$q = this.$q;
                }
                TreatmentProductProducerDatacontext.prototype.init = function (prescriptionUnitOfWork) {
                    return this.$q.when(this.prescriptionUnitOfWork = prescriptionUnitOfWork);
                };
                TreatmentProductProducerDatacontext.prototype.createTreatmentProductProducer = function (treatmentProductProducer) {
                    return this.prescriptionUnitOfWork.treatmentProductProducersRepository.createEntity(treatmentProductProducer, breeze.EntityState.Added);
                };
                TreatmentProductProducerDatacontext.prototype.getTreatmentProductProducers = function (page, pageSize, filterList) {
                    return this.getTreatmentProductProducerFromCache(page, pageSize, filterList);
                };
                TreatmentProductProducerDatacontext.prototype.getCountries = function () {
                    return this.prescriptionUnitOfWork.countryRepository.allInCache(true, "name");
                };
                TreatmentProductProducerDatacontext.prototype.getTreatmentProductProducerFromCache = function (page, pageSize, filterList) {
                    var filter = new web.model.AssessmentFilter();
                    filter.setFilterValuesFromFilterList(filterList);
                    var query = breeze.EntityQuery.from(app.constants.resourceNames.treatmentProductProducerResource);
                    var filteredItems = this.prescriptionUnitOfWork.treatmentProductProducersRepository.executeCacheQuery(query);
                    var items = app.common.utils.getPaginatedItems(filteredItems, page, pageSize);
                    var deffered = this.$q.defer();
                    deffered.resolve(items);
                    return deffered.promise;
                };
                TreatmentProductProducerDatacontext.prototype.save = function () {
                    return this.prescriptionUnitOfWork.saveChanges()
                        .then(function (result) {
                        return result;
                    })
                        .catch(function (error) {
                        console.log('error: ' + error);
                        return error;
                    });
                };
                TreatmentProductProducerDatacontext.prototype.getTreatmentProductProducerById = function (treatmentProductProducerId) {
                    return this.prescriptionUnitOfWork.treatmentProductProducersRepository.findById(treatmentProductProducerId);
                };
                TreatmentProductProducerDatacontext.prototype.deleteTreatmentProductProducer = function (treatmentProductProducerId) {
                    var query = new breeze.EntityQuery('DeleteTreatmentProductProducerById?treatmentProductProducerId=' + treatmentProductProducerId);
                    return this.prescriptionUnitOfWork.treatmentProductProducersRepository.executeQuery(query)
                        .then(function (data) {
                        // console.log('delete [TreatmentProductProducer] from remote data source');
                    });
                };
                TreatmentProductProducerDatacontext.prototype.hasChanges = function () {
                    return this.prescriptionUnitOfWork.hasChanges();
                };
                TreatmentProductProducerDatacontext.prototype.validateEntity = function (entity) {
                    return this.prescriptionUnitOfWork.validateEntity(entity);
                };
                TreatmentProductProducerDatacontext.prototype.getValidationErrors = function (treatmentProductProducer) {
                    return treatmentProductProducer.entityAspect.getValidationErrors();
                };
                TreatmentProductProducerDatacontext.prototype.rejectChangesOnEntity = function (entity) {
                    return this.prescriptionUnitOfWork.rejectEntityChanges(entity);
                };
                TreatmentProductProducerDatacontext.$inject = ['$q'];
                return TreatmentProductProducerDatacontext;
            })();
            services.TreatmentProductProducerDatacontext = TreatmentProductProducerDatacontext;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('TreatmentProductProducerDatacontext', ['$q']);

/// <reference path="../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var PythonHandler = (function (_super) {
                __extends(PythonHandler, _super);
                function PythonHandler(_$http, _$translate, $q, _appLocalStorage, _datacontext, _env, _apiEndpoint) {
                    _super.call(this, _$http, _$translate, $q, _appLocalStorage, _datacontext, _env, _apiEndpoint);
                }
                PythonHandler.$inject = ['$http', '$translate', '$q', 'appLocalStorage', 'assessmentDatacontext', 'ENV', 'apiEndpointService'];
                return PythonHandler;
            })(app.common.base.services.PythonHandler);
            services.PythonHandler = PythonHandler;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('PythonHandler', ['$http', '$translate', '$q', 'appLocalStorage', 'assessmentDatacontext', 'ENV', 'apiEndpointService']);

/// <reference path="../../_typings.ts"/> 
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var CustomExceptionHandler = (function () {
                function CustomExceptionHandler($rootScope, $translate, $http, env, modalService, apiEndpoint, authenticationService) {
                    var _this = this;
                    this.$rootScope = $rootScope;
                    this.$translate = $translate;
                    this.$http = $http;
                    this.env = env;
                    this.modalService = modalService;
                    this.apiEndpoint = apiEndpoint;
                    this.authenticationService = authenticationService;
                    this.showingModal = false;
                    this.$rootScope.$on(app.constants.broadcastEventNames.clientErrorOccured, function (event, args) {
                        _this.handleError(_this.$rootScope, args);
                    });
                    this.$rootScope.$on(app.constants.broadcastEventNames.serverErrorOccured, function (event, args) {
                        _this.handleError(_this.$rootScope, args);
                    });
                    this.$rootScope.$on(app.constants.broadcastEventNames.nonBlockingErrorOccured, function (event, args) {
                        _this.handleError(_this.$rootScope, args, true);
                    });
                }
                CustomExceptionHandler.prototype.handleError = function ($rootScope, errorContent, skipErrorReporting) {
                    var _this = this;
                    if (skipErrorReporting === void 0) { skipErrorReporting = false; }
                    try {
                        var technicalErrorMessage = errorContent.stack || JSON.stringify(errorContent);
                        this.saveError(technicalErrorMessage).then(function () {
                            if (!_this.env.debug && !_this.showingModal && !skipErrorReporting) {
                                _this.showingModal = true;
                                _this.modalService.show('modules/bug/bug.html', app.constants.dialogSize.defaultSize, '', _this.$rootScope, function () { _this.showingModal = false; }, {});
                            }
                        });
                    }
                    catch (error) {
                        console.log("Error handling failed: " + (error.message || error));
                    }
                };
                CustomExceptionHandler.prototype.saveError = function (technicalErrorMessage) {
                    var errorReports = new app.model.scopeModel.ApplicationErrorReportCollection();
                    var user = this.authenticationService.credentialsCurrentUserGet();
                    var userName = user ? user.UserName : 'User not logged inn';
                    var errorReport = new app.model.scopeModel.ApplicationErrorReport(userName, technicalErrorMessage, "", 1, moment(), this.env.appVersion);
                    errorReports.errorReports.push(errorReport);
                    return this.$http({
                        'method': 'POST',
                        'url': this.apiEndpoint.getErrorEndpoint(),
                        'data': errorReports.errorReports
                    }).then(function () {
                        //success
                    }, function (response) {
                        //error
                        console.log(response);
                    });
                };
                CustomExceptionHandler.$inject = ['$rootScope', '$translate', '$http', 'ENV', 'modalService', 'apiEndpointService', 'authenticationService'];
                return CustomExceptionHandler;
            })();
            services.CustomExceptionHandler = CustomExceptionHandler;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService('CustomExceptionHandler', app.web.services.CustomExceptionHandler.$inject);

/// <reference path="../../_typings.ts" />
/// <reference path="../app.ts" />
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var ExcelService = (function () {
                function ExcelService($rootScope, $http, appLocalStorage, apiEndpointService, authenticationService, fileSaver, $window, $translate) {
                    this.$rootScope = $rootScope;
                    this.$http = $http;
                    this.appLocalStorage = appLocalStorage;
                    this.apiEndpointService = apiEndpointService;
                    this.authenticationService = authenticationService;
                    this.fileSaver = fileSaver;
                    this.$window = $window;
                    this.$translate = $translate;
                }
                ExcelService.prototype.getExcelFile = function (assessment) {
                    var _this = this;
                    this.$http({
                        url: this.apiEndpointService.getAssessmentDataDumpEndpoint() +
                            "?assessmentId=" +
                            assessment.assessmentId +
                            "&assessmentName=" +
                            assessment.assessmentTypeName +
                            "&languageId=" +
                            app.common.utils.languageId,
                        method: "GET",
                        responseType: "arraybuffer",
                        data: {},
                        headers: {
                            "Content-type": "application/json",
                            Accept: "application/octet-stream"
                        }
                    }).then(function (result) {
                        _this.fileSaver.saveAs(new Blob([result.data], {
                            type: "application/octet-binary"
                        }), decodeURIComponent(result
                            .headers("Content-Disposition")
                            .replace("attachment; filename=", "")));
                    });
                };
                ExcelService.prototype.generateAssessmentsExcelFile = function (assessment, headers, type) {
                    var _this = this;
                    var window = this.$window;
                    var XLSX = window.XLSX;
                    var localeString = this.appLocalStorage.ngTranslateLangKeyGet();
                    if (app.common.utils.isNullOrUndefinedOrEmpty(type))
                        type = "_";
                    var arrayOfHeaders = headers.map(function (h) {
                        return _this.$translate.instant(h.text);
                    });
                    var data2Export = this.trimProperties2Export(assessment, headers, localeString);
                    var ws = XLSX.utils.json_to_sheet(data2Export);
                    var wb = XLSX.utils.book_new();
                    // set width of column, https://stackoverflow.com/questions/24395693/how-to-set-cell-width-when-export-xlsx-files-with-js-xlsx
                    var widthOfColumns = headers.map(function (h) {
                        var tempValue;
                        tempValue = !!h.columnWidth ? h.columnWidth : 4;
                        return { wch: tempValue };
                    });
                    ws["!cols"] = widthOfColumns;
                    // https://github.com/SheetJS/js-xlsx/issues/659
                    // Change headers
                    var range = XLSX.utils.decode_range(ws["!ref"]);
                    for (var C = range.s.r; C <= range.e.c; ++C) {
                        var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
                        if (!ws[address])
                            continue;
                        ws[address].v = arrayOfHeaders[C];
                    }
                    XLSX.utils.book_append_sheet(wb, ws, type.toUpperCase());
                    /* write workbook and force a download */
                    XLSX.writeFile(wb, type.toLowerCase() + "_" + app.common.utils.currentTime() + ".xlsx");
                };
                ExcelService.prototype.trimProperties2Export = function (arrayOfObject, headers, localeString) {
                    var _this = this;
                    var result = [];
                    arrayOfObject.forEach(function (object) {
                        var tempObject = {};
                        headers.forEach(function (property) {
                            var tempValue = null;
                            if (!!app.common.utils.isNullOrUndefinedOrEmpty(property.stringSeparator))
                                tempValue = object[property.propertyName];
                            else
                                tempValue = _.split(object[property.propertyName], property.stringSeparator, 1);
                            if (!app.common.utils.isNullOrUndefined(tempValue)
                                && !app.common.utils.isNullOrUndefinedOrEmpty(property["needTranslate"])
                                && property["needTranslate"] === true) {
                                tempValue = _this.$translate.instant(tempValue);
                            }
                            if (!app.common.utils.isNullOrUndefined(tempValue)
                                && !app.common.utils.isNullOrUndefined(property.dataType)) {
                                tempValue = _this.convertValue(tempValue, property.dataType, localeString);
                                tempValue = _this.replaceValue(tempValue, property.propertyName);
                            }
                            if (!app.common.utils.isNullOrUndefined(tempValue) && tempValue.constructor === Array) {
                                tempObject[property.propertyName] = tempValue.join(", ");
                            }
                            else {
                                tempObject[property.propertyName] = tempValue;
                            }
                        });
                        result.push(tempObject);
                    });
                    return result;
                };
                ExcelService.prototype.convertValue = function (value, type, localString) {
                    var options;
                    if (app.common.utils.isNullOrUndefinedOrEmpty(localString))
                        localString = "en-GB";
                    switch (type.toLowerCase()) {
                        case "date":
                            options = {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit"
                            };
                            if (value.constructor === Date) {
                                return value;
                            }
                            else {
                                return new Date(value.toString()).toLocaleDateString(localString, options);
                            }
                        case "datetime":
                            options = {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit"
                            };
                            return new Date(value.toString()).toLocaleString(localString, options);
                        default:
                            return value;
                    }
                };
                ExcelService.prototype.replaceValue = function (value, propertyName) {
                    switch (propertyName.toLowerCase()) {
                        case "followupstatusid":
                            if (value === 1)
                                return this.$translate.instant("NoFollowUpShort");
                            else if (value === 2)
                                return this.$translate.instant("FollowUpRecommendedShort");
                            else if (value === 3)
                                return this.$translate.instant("FollowUpNeededShort");
                            else
                                return value;
                        case "islocked":
                            if (value)
                                return "🔒";
                            else
                                return "";
                        default:
                            return value;
                    }
                };
                ExcelService.$inject = [
                    "$rootScope",
                    "$http",
                    "appLocalStorage",
                    "apiEndpointService",
                    "authenticationService",
                    "FileSaver",
                    "$window",
                    "$translate"
                ];
                return ExcelService;
            })();
            services.ExcelService = ExcelService;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService("ExcelService", app.web.services.ExcelService.$inject);

/// <reference path="../../_typings.ts" />
/// <reference path="../app.ts" />
var app;
(function (app) {
    var web;
    (function (web) {
        var services;
        (function (services) {
            var CubeService = (function () {
                function CubeService($rootScope, $http, apiEndpointService, authenticationService) {
                    this.$rootScope = $rootScope;
                    this.$http = $http;
                    this.apiEndpointService = apiEndpointService;
                    this.authenticationService = authenticationService;
                    this.cubeIsProcessing = false;
                    this.errorMessage = '';
                }
                CubeService.prototype.processCube = function () {
                    return this.$http({
                        url: this.apiEndpointService.getProcessCubeEndpoint(),
                        method: "GET"
                    });
                };
                CubeService.$inject = ['$rootScope', '$http', 'apiEndpointService', 'authenticationService'];
                return CubeService;
            })();
            services.CubeService = CubeService;
        })(services = web.services || (web.services = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerService("CubeService", app.web.services.CubeService.$inject);

/// <reference path="../_typings.web.ts" />
var app;
(function (app) {
    var web;
    (function (web) {
        var model;
        (function (model) {
            var DropdownOption = (function () {
                function DropdownOption(name, id, foreignKey, filterName, selected, foreginObject) {
                    this.name = name;
                    this.id = id;
                    this.foreignKey = foreignKey;
                    this.filterName = filterName;
                    this.selected = selected;
                    this.foreginObject = foreginObject;
                    this.name = name;
                    this.id = id;
                    this.foreignKey = foreignKey;
                    this.filterName = filterName;
                    this.selected = selected;
                    this.foreginObject = foreginObject;
                }
                return DropdownOption;
            })();
            model.DropdownOption = DropdownOption;
            var CascadingRule = (function () {
                function CascadingRule(parent, child) {
                    this.parent = parent;
                    this.child = child;
                    this.parent = parent;
                    this.child = child;
                }
                return CascadingRule;
            })();
            model.CascadingRule = CascadingRule;
            var AssessmentFilter = (function () {
                function AssessmentFilter() {
                }
                AssessmentFilter.prototype.setFilterValuesFromFilterList = function (filterList, levelId) {
                    var _this = this;
                    angular.forEach(filterList, function (filter) {
                        if (filter.name == app.constants.assessmentTypeProperties.assessmentTypeGroup) {
                            _this.typeGroups = filter.selectedIds;
                        }
                        if (filter.name == app.constants.assessmentProperties.assessmentType) {
                            _this.types = filter.selectedIds;
                        }
                        if (filter.name == app.constants.assessmentProperties.followUp) {
                            _this.followUps = filter.selectedIds;
                        }
                        if (filter.name == app.constants.assessmentProperties.customer) {
                            _this.customers = filter.selectedIds;
                        }
                        if (filter.name == app.constants.assessmentProperties.companyBU) {
                            _this.companyBUs = filter.selectedIds;
                        }
                        if (filter.name == app.constants.assessmentProperties.site) {
                            _this.sites = filter.selectedIds.length === 0 && levelId > 1 ? _.map(filter.list, "id") : filter.selectedIds;
                        }
                        if (filter.name == app.constants.assessmentProperties.assessmentGroup) {
                            _this.groups = filter.selectedIds;
                        }
                        if (filter.name == app.constants.assessmentProperties.assessmentIdentifier) {
                            _this.identifiers = filter.selectedIds;
                        }
                        if (filter.name == app.constants.assessmentProperties.representative) {
                            _this.representatives = filter.selectedIds;
                        }
                        if (filter.name == app.constants.assessmentProperties.siteFishgroup) {
                            _this.fishgroups = filter.selectedIds;
                        }
                        if (filter.name == app.constants.prescriptionProperties.treatmentProduct) {
                            _this.treatmentProducts = filter.selectedIds;
                        }
                        if (filter.name == app.constants.treatmentProductProperties.treatmentProductProducer) {
                            _this.treatmentProductProducers = filter.selectedIds;
                        }
                        if (filter.name == app.constants.treatmentProductProperties.activeSubstance) {
                            _this.activeSubstances = filter.selectedIds;
                        }
                        if (filter.name === app.constants.assessmentProperties.visitType) {
                            _this.visitTypes = filter.selectedIds;
                        }
                    });
                };
                return AssessmentFilter;
            })();
            model.AssessmentFilter = AssessmentFilter;
        })(model = web.model || (web.model = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

var app;
(function (app) {
    var web;
    (function (web) {
        var model;
        (function (model) {
            var assessmentGroup = (function () {
                function assessmentGroup(assessmentDiscriminator) {
                    this.assessmentDiscriminator = assessmentDiscriminator;
                    this.assessmentDiscriminator_main = this.assessmentDiscriminator != null ? assessmentDiscriminator.split("|")[0] : null;
                }
                return assessmentGroup;
            })();
            model.assessmentGroup = assessmentGroup;
        })(model = web.model || (web.model = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

var app;
(function (app) {
    var web;
    (function (web) {
        var model;
        (function (model) {
            var baseChart = (function () {
                function baseChart() {
                    this.showLegend = true;
                    this.defaultSerieColors = ['#90ed7d', '#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#7cb5ec', '#91e8e1', '#797641', '#efeeb6', '#f67b94', '#7ce7ca', '#64739a', '#dd9270'];
                }
                baseChart.prototype.getColorByIndex = function (index) {
                    return this.defaultSerieColors[index];
                };
                baseChart.prototype.getLabels = function () {
                    var yAxisTitle = "";
                    var chartTitle = "";
                    switch (this.seletedChartTypeOptionId) {
                        case app.constants.chartTypes.visceralMelanin:
                            {
                                yAxisTitle = app.localizer.resource.VisceralMelaninValues;
                                chartTitle = app.localizer.resource.VisceralMelaninChart;
                                break;
                            }
                        case app.constants.chartTypes.parietalMelanin:
                            {
                                yAxisTitle = app.localizer.resource.ParietalMelaninnValues;
                                chartTitle = app.localizer.resource.ParietalMelaninChart;
                                break;
                            }
                        case app.constants.chartTypes.speilbergScore:
                            {
                                yAxisTitle = app.localizer.resource.SpeilbergScoreValues;
                                chartTitle = app.localizer.resource.SpeilbergScoreChat;
                                break;
                            }
                        case app.constants.chartTypes.precisionScore:
                            {
                                yAxisTitle = app.localizer.resource.PrecisionScoreValues;
                                chartTitle = app.localizer.resource.PrecisionScoreChart;
                                break;
                            }
                        case app.constants.chartTypes.percentileVisceralMelanin:
                            {
                                yAxisTitle = app.localizer.resource.VisceralMelaninValues;
                                chartTitle = app.localizer.resource.PercentileVisceralMelaninChart;
                                break;
                            }
                        case app.constants.chartTypes.percentileParietalMelanin:
                            {
                                yAxisTitle = app.localizer.resource.ParietalMelaninnValues;
                                chartTitle = app.localizer.resource.PercentileParietalMelaninChart;
                                break;
                            }
                        case app.constants.chartTypes.percentileSpeilbergScore:
                            {
                                yAxisTitle = app.localizer.resource.SpeilbergScoreValues;
                                chartTitle = app.localizer.resource.PercentileSpeilbergScoreChat;
                                break;
                            }
                    }
                    return { yAxisTitle: yAxisTitle, chartTitle: chartTitle };
                };
                baseChart.prototype.findLocalizationKeyName = function (translationValue) {
                    for (var property in this.seriesDictionary) {
                        if (this.seriesDictionary.hasOwnProperty(property) && translationValue === this.seriesDictionary[property]) {
                            return property;
                        }
                    }
                };
                //KeyNumber Creation Table:Default behaivor
                baseChart.prototype.getKeyNumbers = function (showAvgSeries) {
                    this.keyNumbers = {};
                    var filteredSeries = this.getFilteredSeriesforKeyNumbers(showAvgSeries);
                    var categories = this.getFiteredCategoriesForKeyNumbers();
                    var keyNumbersData = this.createKeyNumbersByCategory(filteredSeries, categories);
                    this.keyNumbers["rows"] = keyNumbersData;
                    this.keyNumbers["headers"] = this.createKeyNumberHeaders(filteredSeries);
                    return this.keyNumbers;
                };
                baseChart.prototype.createKeyNumbersByCategory = function (series, categories) {
                    var keyNumbersBySerie = this.createKeyNumbersBySerieName(series, categories);
                    var seriesForExport = [];
                    _.forEach(categories, function (categoryName) {
                        var serieExport = {};
                        for (var index = 0; index < series.length; index++) {
                            var serieName = series[index].name;
                            var selectedSerie = _.find(keyNumbersBySerie, { name: serieName });
                            serieExport[serieName] = selectedSerie[categoryName];
                        }
                        ;
                        serieExport["name"] = categoryName;
                        seriesForExport.push(serieExport);
                    });
                    return seriesForExport;
                };
                baseChart.prototype.createKeyNumbersBySerieName = function (series, categories) {
                    var seriesForExport = [];
                    _.forEach(series, function (serie) {
                        var serieExport = {};
                        for (var index = 0; index < categories.length; index++) {
                            var categoryName = categories[index];
                            var point = serie.data[index] === null ? "" : serie.data[index];
                            var pointValue = (point.y !== undefined && point.y != null) ? point.y : point;
                            var sampleCount = serie.dataSampleNumbers[index] === null ? "" : serie.dataSampleNumbers[index];
                            serieExport[categoryName] = pointValue === "" ? "" : pointValue.toString() + " (" + sampleCount.toString() + ")";
                        }
                        serieExport["name"] = serie.name;
                        seriesForExport.push(serieExport);
                    });
                    return seriesForExport;
                };
                baseChart.prototype.createKeyNumberHeaders = function (filteredSeries) {
                    var columnNames = this.getKeyNumberColumns();
                    var headers = [];
                    for (var key in columnNames) {
                        var columnName = columnNames[key];
                        var translatedColumnName = columnName === 'name' ? this.getTranslatedColumnName() : columnName + "(" + app.localizer.resource.NumberOfSamples + ")";
                        var header = {};
                        header["text"] = translatedColumnName;
                        header["propertyName"] = columnName;
                        if (columnName === 'name') {
                            header["colorStyle"] = "{'background-color':'#4488d1','text-shadow':'none'}";
                        }
                        else {
                            var serie = _.filter(filteredSeries, function (serie) { return serie.name === columnName; })[0];
                            header["colorStyle"] = "{'background-color':'" + serie.color + "','color':'white','text-shadow':'none'}";
                        }
                        headers.push(header);
                    }
                    return headers;
                };
                baseChart.prototype.getKeyNumberColumns = function () {
                    if (this.keyNumbers != null && this.keyNumbers.rows.length <= 0)
                        return;
                    var keyNumber = this.keyNumbers.rows[0];
                    var properties = Object.keys(keyNumber);
                    var columns = [];
                    for (var key in properties) {
                        columns.push(properties[key]);
                    }
                    ;
                    var columnName = _.filter(columns, function (prop) { return prop == "name"; });
                    var columnExcludingColumnName = _.filter(columns, function (prop) { return prop != "name"; });
                    columns = columnName.concat(columnExcludingColumnName);
                    return columns;
                };
                baseChart.prototype.getTranslatedColumnName = function () {
                    var columnName = "";
                    switch (this.chartSelectionType) {
                        case app.constants.benchmarkingChartGroups.precisionScore:
                            {
                                columnName = app.localizer.resource.YearMonth;
                                break;
                            }
                        case app.constants.benchmarkingChartGroups.sideEffects:
                            {
                                columnName = app.localizer.resource.Stage;
                                break;
                            }
                        case app.constants.benchmarkingChartGroups.percentilesSideEffects:
                            {
                                columnName = app.localizer.resource.Score;
                                break;
                            }
                        case app.constants.benchmarkingChartGroups.averagesSideEffects:
                            {
                                columnName = app.localizer.resource.Name;
                                break;
                            }
                    }
                    return columnName;
                };
                baseChart.prototype.getFiteredCategoriesForKeyNumbers = function () {
                    return this.highchartsSettings.categories;
                };
                baseChart.prototype.getFilteredSeriesforKeyNumbers = function (showAvgSeries) {
                    var _this = this;
                    if (this.highchartsSettings == null)
                        return;
                    var filteredSeries = null;
                    if (showAvgSeries === true)
                        filteredSeries = _.filter(this.highchartsSettings.series, function (serie) { return (serie.type === _this.dbSerieType || serie.type === app.constants.chartSerieTypes.column); });
                    else
                        filteredSeries = _.filter(this.highchartsSettings.series, function (serie) { return (serie.type === app.constants.chartSerieTypes.column); });
                    return filteredSeries;
                };
                baseChart.prototype.getKeyNumberByPeriod = function (key) {
                    var selectedKeyNumber = _.filter(this.keyNumbersDictionary, { keyNumberId: key });
                    if (selectedKeyNumber != null && selectedKeyNumber.length > 0)
                        return selectedKeyNumber[0].value;
                    else
                        return null;
                };
                baseChart.prototype.setKeyNumbersByPeriod = function (key, keyNumbers) {
                    var keyNumberToSave = { keyNumberId: key, value: keyNumbers };
                    this.keyNumbersDictionary.push(keyNumberToSave);
                };
                baseChart.prototype.getColumnSeries = function (series) {
                    var columns = _.filter(series, function (serie) { return serie.type === app.constants.chartSerieTypes.column; });
                    return columns;
                };
                baseChart.prototype.getSerieByTypeAndName = function (series, serieName, serieType) {
                    var items = _.filter(series, function (serie) { return serie.name === serieName && serie.type === serieType; });
                    if (items != null && items.length > 0)
                        return items[0];
                    else
                        return null;
                };
                baseChart.prototype.getDefaultTooltip = function () {
                    return { pointFormat: '<span style="font-weight: bold; color: {series.color}">{series.name}</span>: <b>{point.y} </b><br/>' };
                };
                baseChart.prototype.getColorBySerieName = function (serieName, index) {
                    if (baseChart.colorsMap[serieName] === undefined) {
                        var color = this.getColorByIndex(index);
                        baseChart.colorsMap[serieName] = color;
                    }
                    return baseChart.colorsMap[serieName];
                };
                baseChart.prototype.clearColorMap = function () {
                    baseChart.colorsMap = {};
                };
                baseChart.prototype.ColorLuminance = function (hex, lum) {
                    // validate hex string
                    hex = String(hex).replace(/[^0-9a-f]/gi, '');
                    if (hex.length < 6) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    lum = lum || 0;
                    // convert to decimal and change luminosity
                    var rgb = "#", c, i;
                    for (i = 0; i < 3; i++) {
                        c = parseInt(hex.substr(i * 2, 2), 16);
                        c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
                        rgb += ("00" + c).substr(c.length);
                    }
                    return rgb;
                };
                baseChart.prototype.getMaxYAxis = function (series) {
                    var result = 0;
                    var data = [];
                    var stdData = [];
                    if (series.length === 0)
                        return 0;
                    var seriesData = this.getSeriesData(series);
                    data = seriesData.data;
                    stdData = seriesData.stdData;
                    var maxData = _.max(data) === undefined ? 0 : _.max(data);
                    var maxstdData = _.max(stdData) === undefined ? 0 : _.max(stdData);
                    if (stdData.length > 0)
                        result = maxData >= maxstdData ? maxData : maxstdData;
                    else
                        result = maxData;
                    return result;
                };
                baseChart.prototype.getSeriesData = function (series) {
                    var data = [];
                    var stdData = [];
                    _.forEach(series, function (serie) {
                        if (serie.type === app.constants.chartSerieTypes.errorbar) {
                            _.forEach(serie.data, function (dataItem) {
                                if (dataItem != null) {
                                    stdData.push(dataItem[0]);
                                    stdData.push(dataItem[1]);
                                }
                            });
                        }
                        else {
                            _.forEach(serie.data, function (dataItem) { data.push(dataItem); });
                        }
                    });
                    return { data: data, stdData: stdData };
                };
                baseChart.prototype.cloneErrorBarSerie = function (sourceSerie) {
                    if (sourceSerie.type != app.constants.chartSerieTypes.errorbar)
                        return;
                    var clonedSerie = {};
                    clonedSerie.name = sourceSerie.name;
                    clonedSerie.type = sourceSerie.type;
                    clonedSerie.data = sourceSerie.data;
                    clonedSerie.linkedTo = sourceSerie.linkedTo;
                    clonedSerie.color = 'rgba(0,0,0,0)';
                    clonedSerie.tooltip = sourceSerie.tooltip;
                    clonedSerie.tooltip.borderRadius = 3;
                    clonedSerie.tooltip.borderWidth = 1;
                    clonedSerie.tooltip.backgroundColor = 'rgba(249, 249, 249, .85)';
                    clonedSerie.tooltip.pointFormat = clonedSerie.tooltip.pointFormat.replace("{series.color}", sourceSerie.color);
                    clonedSerie.lineWidth = 10;
                    return clonedSerie;
                };
                baseChart.prototype.amplifyRangeForStdSeries = function () {
                    var _this = this;
                    var erroBarSeries = _.filter(this.highchartsSettings.series, function (serie) { return (serie.type === app.constants.chartSerieTypes.errorbar); });
                    var clonedSeries = [];
                    _.forEach(erroBarSeries, function (erroBarSerie) {
                        var cloneSerie = _this.cloneErrorBarSerie(erroBarSerie);
                        clonedSeries.push(cloneSerie);
                    });
                    _.forEach(clonedSeries, function (clonedSerie) { _this.highchartsSettings.series.push(clonedSerie); });
                };
                baseChart.colorsMap = {};
                return baseChart;
            })();
            model.baseChart = baseChart;
        })(model = web.model || (web.model = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var model;
        (function (model) {
            var sideEffectColumns = (function () {
                function sideEffectColumns() {
                }
                sideEffectColumns.comparisonItem = "comparisonItem";
                sideEffectColumns.harvest = "harvest";
                sideEffectColumns.preTransfer = "preTransfer";
                sideEffectColumns.seaWater = "seaWater";
                return sideEffectColumns;
            })();
            model.sideEffectColumns = sideEffectColumns;
            var sideEffectsChart = (function (_super) {
                __extends(sideEffectsChart, _super);
                function sideEffectsChart(items, chartType) {
                    _super.call(this);
                    this.categories = [];
                    this.dbAvgPerSeriePrefix = "DbAvg_";
                    this.standardDesviationPrefix = "StdDesv_";
                    this.standardDesviationDbPrefix = "StdDesvDb_";
                    this.standardDesvSufix = " " + app.localizer.resource.StdDesvRange;
                    this.standardDesvDBSufix = " " + app.localizer.resource.DbStdDesvRange;
                    this.sideEffectsItems = this.getsideEffectItems(items);
                    this.numberOfSamples = this.getNumberOfSamples(items);
                    this.seletedChartTypeOptionId = chartType;
                    this.fillSeriesDictionary();
                    this.dbSerieType = app.constants.chartSerieTypes.spline;
                    this.chartSelectionType = app.constants.benchmarkingChartGroups.sideEffects;
                    if (items.length > 0) {
                        this.fromYearMonth = items[0].fromYearMonth;
                        this.toYearMonth = items[0].toYearMonth;
                    }
                }
                sideEffectsChart.prototype.hasDataToShow = function () {
                    return this.sideEffectsItems.length > 0;
                };
                sideEffectsChart.prototype.fillSeriesDictionary = function () {
                    this.seriesDictionary = { preTransfer: app.localizer.resource.PreTransfer, seaWater: app.localizer.resource.Seawater, harvest: app.localizer.resource.Harvest };
                };
                sideEffectsChart.prototype.getsideEffectItems = function (items) {
                    var _this = this;
                    var filtered = _.filter(items, { hasSampleNumbers: false });
                    var entities = _.map(filtered, function (item) {
                        return _this.mapDataSourceItem(item);
                    });
                    return entities;
                };
                sideEffectsChart.prototype.mapDataSourceItem = function (item) {
                    var mapentity = {};
                    mapentity[sideEffectColumns.comparisonItem] = item.comparisonItem;
                    mapentity[sideEffectColumns.harvest] = item.harvest;
                    mapentity[sideEffectColumns.preTransfer] = item.preTransfer;
                    mapentity[sideEffectColumns.seaWater] = item.seaWater;
                    return mapentity;
                };
                sideEffectsChart.prototype.getNumberOfSamples = function (items) {
                    var _this = this;
                    var filtered = _.filter(items, { hasSampleNumbers: true });
                    var entities = _.map(filtered, function (item) {
                        return _this.mapDataSourceItem(item);
                    });
                    return entities;
                };
                sideEffectsChart.prototype.buildCategories = function () {
                    if (this.sideEffectsItems.length > 0) {
                        var sideEffectItem = this.sideEffectsItems[0];
                        for (var property in sideEffectItem) {
                            if (sideEffectItem.hasOwnProperty(property) && property !== sideEffectColumns.comparisonItem) {
                                this.categories.push(property);
                            }
                        }
                    }
                    this.sortByCategory();
                };
                sideEffectsChart.prototype.sortByCategory = function () {
                    var sortedCategories = [];
                    var pretransferCat = _.filter(this.categories, function (category) { return category === sideEffectColumns.preTransfer; })[0];
                    sortedCategories.push(pretransferCat);
                    var seawaterCat = _.filter(this.categories, function (category) { return category === sideEffectColumns.seaWater; })[0];
                    sortedCategories.push(seawaterCat);
                    var harvestCat = _.filter(this.categories, function (category) { return category === sideEffectColumns.harvest; })[0];
                    sortedCategories.push(harvestCat);
                    this.categories = [];
                    this.categories = sortedCategories;
                };
                sideEffectsChart.prototype.buildHighchartsSettings = function () {
                    this.keyNumbersDictionary = [];
                    this.highchartsSettings = {};
                    this.buildCategories();
                    var chartSeries = [];
                    for (var index = 0; index < this.sideEffectsItems.length; index++) {
                        var sideEffectItem = this.sideEffectsItems[index];
                        var highchartsSerie = this.createHighchartsSerie(sideEffectItem);
                        chartSeries.push(highchartsSerie);
                    }
                    var labels = _super.prototype.getLabels.call(this);
                    this.getCategoriesTranslations();
                    var highchartsSeries = this.sort(chartSeries);
                    this.highchartsSettings = { series: highchartsSeries, categories: this.categories, yAxisTitle: labels.yAxisTitle, chartTitle: labels.chartTitle, hasData: true, maxYAxis: this.getMaxYAxis(highchartsSeries), showLegend: this.showLegend, minYaxis: 0 };
                    this.amplifyRangeForStdSeries();
                    return this.highchartsSettings;
                };
                sideEffectsChart.prototype.getHighchartsSettings = function () {
                    if (this.hasDataToShow())
                        return this.buildHighchartsSettings();
                    else
                        return { hasData: false };
                };
                sideEffectsChart.prototype.createHighchartsSerie = function (dataSourceItem) {
                    var newSerie = {};
                    var dataSourceItemName = dataSourceItem.comparisonItem;
                    var dataNumberOfSampleItem = _.filter(this.numberOfSamples, { comparisonItem: dataSourceItemName });
                    newSerie["type"] = this.getSerieType(dataSourceItemName);
                    newSerie["name"] = this.getSerieName(dataSourceItemName);
                    newSerie["data"] = [];
                    newSerie["dataSampleNumbers"] = [];
                    for (var j = 0; j < this.categories.length; j++) {
                        var categoryName = this.categories[j];
                        var dataValue = this.getSerieData(dataSourceItem, dataSourceItemName, categoryName);
                        var numberOfSampleValue = dataNumberOfSampleItem.length > 0 ? dataNumberOfSampleItem[0][categoryName] : null;
                        newSerie["dataSampleNumbers"].push(numberOfSampleValue);
                        newSerie["data"].push(dataValue);
                    }
                    return newSerie;
                };
                sideEffectsChart.prototype.getSerieData = function (currentSideEffectItem, serieName, categoryName) {
                    var isStandardDesviation = ((this.isStandardDeviationSerie(serieName) === true) || (this.isStandardDeviationPerDbSerie(serieName) === true));
                    if (isStandardDesviation)
                        return this.getDatafromStandardDesviationSerieType(currentSideEffectItem, serieName, categoryName);
                    else
                        return this.getDatafromDefaultSerieType(currentSideEffectItem, categoryName);
                };
                sideEffectsChart.prototype.getDatafromStandardDesviationSerieType = function (currentSideEffectItem, serieName, categoryName) {
                    var minValue = 0;
                    var maxValue = 0;
                    var returnValue = null;
                    var currentDataValue = currentSideEffectItem[categoryName];
                    var standardDesviation = currentDataValue;
                    var parentSerieName = serieName.split('_')[1];
                    var isDbStandardDesviationSerie = this.isStandardDeviationPerDbSerie(serieName);
                    var sideEffectItems = this.getComparisonItemData(parentSerieName, isDbStandardDesviationSerie);
                    if (sideEffectItems != null && sideEffectItems.length > 0 && standardDesviation !== null && standardDesviation > 0) {
                        var parentSerieNameDataValue = sideEffectItems[0][categoryName];
                        minValue = (parentSerieNameDataValue - standardDesviation < 0) ? 0 : parentSerieNameDataValue - standardDesviation;
                        maxValue = parentSerieNameDataValue + standardDesviation;
                        returnValue = [parseFloat(app.common.utils.precise_round(minValue, 2)), parseFloat(app.common.utils.precise_round(maxValue, 2))];
                    }
                    else if (sideEffectItems != null && sideEffectItems.length > 0) {
                        var parentSerieNameDefaultValue = sideEffectItems[0][categoryName];
                        returnValue = [parentSerieNameDefaultValue, parentSerieNameDefaultValue];
                    }
                    else
                        returnValue = [null, null];
                    return returnValue;
                };
                sideEffectsChart.prototype.getDatafromDefaultSerieType = function (currentSideEffectItem, categoryName) {
                    var dataValue = currentSideEffectItem[categoryName];
                    return dataValue;
                };
                sideEffectsChart.prototype.getComparisonItemData = function (comparisonItemName, isDbStandardDesviationSerie) {
                    var items = [];
                    if (isDbStandardDesviationSerie) {
                        items = _.filter(this.sideEffectsItems, { comparisonItem: this.dbAvgPerSeriePrefix + comparisonItemName });
                    }
                    else
                        items = _.filter(this.sideEffectsItems, { comparisonItem: comparisonItemName });
                    return items;
                };
                sideEffectsChart.prototype.sort = function (series) {
                    var sortedSeries = [];
                    var columnSeries = this.getColumnSeries(series);
                    for (var index = 0; index < columnSeries.length; index++) {
                        var serieIndex = 0;
                        var columnnSerie = columnSeries[index];
                        var serieName = columnnSerie.name;
                        var columnSerieId = serieName + "Id";
                        var colorBySerie = this.getColorBySerieName(columnnSerie.name, index);
                        columnnSerie["index"] = serieIndex;
                        columnnSerie["id"] = columnSerieId;
                        columnnSerie["tooltip"] = this.getDefaultTooltip();
                        columnnSerie["color"] = colorBySerie;
                        var dbserie = this.getDbSerieByName(series, serieName, this.ColorLuminance(colorBySerie, -0.1));
                        var dbSerieId = dbserie.name + "Id";
                        dbserie["id"] = dbSerieId;
                        var stdSerie = this.getStandardDesviationSerieByName(series, serieName, this.ColorLuminance(colorBySerie, -0.3), columnSerieId);
                        var stdDbSerie = this.getStandardDesviationPerDbSerieByName(series, serieName, this.ColorLuminance(colorBySerie, -0.4), dbSerieId);
                        sortedSeries.push(columnnSerie);
                        if (stdSerie != null) {
                            stdSerie["index"] = serieIndex++;
                            sortedSeries.push(stdSerie);
                        }
                        if (dbserie != null) {
                            dbserie["index"] = serieIndex++;
                            sortedSeries.push(dbserie);
                        }
                        if (stdDbSerie != null) {
                            stdDbSerie["index"] = serieIndex++;
                            sortedSeries.push(stdDbSerie);
                        }
                    }
                    return sortedSeries;
                };
                sideEffectsChart.prototype.getDbSerieByName = function (series, columnserieName, color) {
                    var dbSerieName = app.localizer.resource.DbAvg + " " + columnserieName;
                    var dbSerie = this.getSerieByTypeAndName(series, dbSerieName, this.dbSerieType);
                    if (dbSerie != null) {
                        dbSerie["tooltip"] = this.getDefaultTooltip();
                        dbSerie["color"] = color;
                    }
                    return dbSerie;
                };
                sideEffectsChart.prototype.getStandardDesviationSerieByName = function (series, columnserieName, color, parentSerieId) {
                    var standardDesviationPerSerieName = columnserieName + this.standardDesvSufix;
                    var standardDesviationPerSerie = this.getSerieByTypeAndName(series, standardDesviationPerSerieName, app.constants.chartSerieTypes.errorbar);
                    if (standardDesviationPerSerie != null) {
                        standardDesviationPerSerie["tooltip"] = this.getErrorBarTooltip(standardDesviationPerSerieName);
                        standardDesviationPerSerie["color"] = color;
                        standardDesviationPerSerie["linkedTo"] = parentSerieId;
                    }
                    return standardDesviationPerSerie;
                };
                sideEffectsChart.prototype.getStandardDesviationPerDbSerieByName = function (series, columnserieName, color, parentSerieId) {
                    var standardDesviationPerSerieName = columnserieName + this.standardDesvDBSufix;
                    var standardDesviationPerSerie = this.getSerieByTypeAndName(series, standardDesviationPerSerieName, app.constants.chartSerieTypes.errorbar);
                    if (standardDesviationPerSerie != null) {
                        standardDesviationPerSerie["tooltip"] = this.getErrorBarTooltip(standardDesviationPerSerieName);
                        standardDesviationPerSerie["color"] = color;
                        standardDesviationPerSerie["linkedTo"] = parentSerieId;
                    }
                    return standardDesviationPerSerie;
                };
                sideEffectsChart.prototype.getErrorBarTooltip = function (parentSerieName) {
                    return { pointFormat: '<span style="font-weight: bold; color: {series.color}">' + parentSerieName + '</span>: <b>{point.low}-{point.high} </b><br/>' };
                };
                sideEffectsChart.prototype.getSerieName = function (dataSourceRowName) {
                    var serieName = "";
                    if (this.isAveragePerSerie(dataSourceRowName)) {
                        serieName = app.localizer.resource.DbAvg + " " + dataSourceRowName.replace(this.dbAvgPerSeriePrefix, "");
                    }
                    else if (this.isStandardDeviationPerDbSerie(dataSourceRowName)) {
                        serieName = dataSourceRowName.replace(this.standardDesviationDbPrefix, "") + this.standardDesvDBSufix;
                    }
                    else if (this.isStandardDeviationSerie(dataSourceRowName)) {
                        serieName = dataSourceRowName.replace(this.standardDesviationPrefix, "") + this.standardDesvSufix;
                    }
                    else
                        serieName = dataSourceRowName;
                    return serieName;
                };
                sideEffectsChart.prototype.getSerieType = function (dataSourceRowName) {
                    if (this.isAvgSerie(dataSourceRowName))
                        return this.dbSerieType;
                    else if (this.isStandardDeviationSerie(dataSourceRowName) || this.isStandardDeviationPerDbSerie(dataSourceRowName))
                        return app.constants.chartSerieTypes.errorbar;
                    else
                        return app.constants.chartSerieTypes.column;
                };
                sideEffectsChart.prototype.isAvgSerie = function (dataSourceRowName) {
                    return (this.isAveragePerSerie(dataSourceRowName));
                };
                sideEffectsChart.prototype.isAveragePerSerie = function (serieName) {
                    return serieName.startsWith(this.dbAvgPerSeriePrefix);
                };
                sideEffectsChart.prototype.isStandardDeviationSerie = function (dataSourceRowName) {
                    return (dataSourceRowName.startsWith(this.standardDesviationPrefix));
                };
                sideEffectsChart.prototype.isStandardDeviationPerDbSerie = function (dataSourceRowName) {
                    return (dataSourceRowName.startsWith(this.standardDesviationDbPrefix));
                };
                sideEffectsChart.prototype.getDataBaseAverageByVaccineAndStage = function (vaccine, assessmentType) {
                    var dbAvgByvaccine = 0;
                    var vaccineAvgName = this.dbAvgPerSeriePrefix + vaccine;
                    var dbAverageContainerRow = _.filter(this.sideEffectsItems, { comparisonItem: vaccineAvgName });
                    if (dbAverageContainerRow.length > 0) {
                        var selectedSideEffectItem = dbAverageContainerRow[0];
                        dbAvgByvaccine = this.getAvgfromSideEffectsItem(selectedSideEffectItem, assessmentType);
                    }
                    return dbAvgByvaccine;
                };
                sideEffectsChart.prototype.getDatabaseNumberOfSampleByVaccineAndStage = function (vaccine, assessmentType) {
                    var numberOfSamples = 0;
                    var vaccineAvgName = this.dbAvgPerSeriePrefix + vaccine;
                    var dbAverageContainerRow = _.filter(this.numberOfSamples, { comparisonItem: vaccineAvgName });
                    if (dbAverageContainerRow.length > 0) {
                        var selectedSideEffectItem = dbAverageContainerRow[0];
                        numberOfSamples = this.getAvgfromSideEffectsItem(selectedSideEffectItem, assessmentType);
                    }
                    return numberOfSamples;
                };
                sideEffectsChart.prototype.getAvgfromSideEffectsItem = function (item, assessmentType) {
                    return item[assessmentType];
                };
                sideEffectsChart.prototype.getCategoriesTranslations = function () {
                    for (var index = 0; index < this.categories.length; index++) {
                        var key = this.categories[index];
                        this.categories[index] = this.seriesDictionary[key] !== undefined ? this.seriesDictionary[key] : key;
                    }
                };
                sideEffectsChart.prototype.isAverageSerie = function (serieName) {
                    return (serieName === app.localizer.resource.DbAverage) || serieName.startsWith(app.localizer.resource.DbAvg);
                };
                sideEffectsChart.prototype.isStandardDesviationSerie = function (serieName) {
                    return serieName.endsWith(this.standardDesvSufix) || serieName.endsWith(this.standardDesvDBSufix);
                };
                sideEffectsChart.prototype.getKeyNumbersTable = function () {
                    var defaultKeyNumbers = this.getKeyNumbers(true);
                    return defaultKeyNumbers;
                };
                sideEffectsChart.prototype.getKeyNumbersBySerieAndType = function (serieName, assessmentType) {
                    var key = serieName + assessmentType;
                    return this.getKeyNumberByPeriod(key);
                };
                sideEffectsChart.prototype.setKeyNumbersBySerieAndType = function (serieName, assessmentType, keyNumbers) {
                    var key = serieName + assessmentType;
                    this.setKeyNumbersByPeriod(key, keyNumbers);
                };
                return sideEffectsChart;
            })(app.web.model.baseChart);
            model.sideEffectsChart = sideEffectsChart;
        })(model = web.model || (web.model = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var model;
        (function (model) {
            var precisionScoreChart = (function (_super) {
                __extends(precisionScoreChart, _super);
                function precisionScoreChart(items, chartType, comparisonTypeId) {
                    _super.call(this);
                    this.categories = [];
                    this.precisionsChartItems = items;
                    this.seletedChartTypeOptionId = chartType;
                    this.comparisonTypeId = comparisonTypeId;
                    this.setCategories();
                    this.dbSerieType = app.constants.chartSerieTypes.line;
                    this.chartSelectionType = app.constants.benchmarkingChartGroups.precisionScore;
                }
                precisionScoreChart.prototype.setCategories = function () {
                    this.categories = _.uniqBy(this.precisionsChartItems, function (chartItem) { return chartItem.xaxis; });
                    var avgChartItems = _.filter(this.precisionsChartItems, { isAverage: true });
                    var chartItems = _.filter(this.precisionsChartItems, { isAverage: false });
                    this.series = _.uniqBy(chartItems, function (chartItem) { return chartItem.legend; });
                    this.avgSeries = _.uniqBy(avgChartItems, function (chartItem) { return chartItem.legend; });
                    _.forEach(avgChartItems, function (avgItem) {
                        var hasNoValues = _.filter(chartItems, { xaxis: avgItem.xaxis, legend: avgItem.legend, average: null, sampleCount: null });
                        if (hasNoValues !== null && hasNoValues.length > 0) {
                            avgItem.average = null;
                            avgItem.sampleCount = null;
                        }
                    });
                };
                precisionScoreChart.prototype.buildHighchartsSetting = function () {
                    this.keyNumbersDictionary = [];
                    this.highchartsSettings = {};
                    var highchartSeries = null;
                    var seriesNames = _.map(this.series, function (serie) { return serie.legend; });
                    var stringCategories = _.map(this.categories, function (category) { return category.xaxis; });
                    this.categoriesNames = this.sortCategories(stringCategories);
                    var columnSeries = this.buildSeries(seriesNames, this.categoriesNames, false);
                    if (this.comparisonTypeId != app.constants.precisionScoreComparisonTypes.VaccinationCrew) {
                        var avgSeries = this.buildDbAverageSeries(seriesNames, this.categoriesNames);
                        highchartSeries = columnSeries.concat(avgSeries);
                    }
                    else {
                        highchartSeries = columnSeries;
                        highchartSeries.push(this.buildTotalDbAverageSerie(this.categoriesNames));
                    }
                    this.setColors(highchartSeries);
                    this.setToolips(highchartSeries);
                    var labels = _super.prototype.getLabels.call(this);
                    this.highchartsSettings = { series: highchartSeries, categories: this.categoriesNames, yAxisTitle: labels.yAxisTitle, chartTitle: labels.chartTitle, hasData: true, maxYAxis: this.getMaxYAxis(highchartSeries), showLegend: this.showLegend, minYaxis: 0 };
                    return this.highchartsSettings;
                };
                precisionScoreChart.prototype.getHighchartsSettings = function () {
                    if (this.hasDataToShow())
                        return this.buildHighchartsSetting();
                    else
                        return { hasData: false };
                };
                precisionScoreChart.prototype.hasDataToShow = function () {
                    return this.precisionsChartItems.length > 0;
                };
                precisionScoreChart.prototype.getKeyNumbersTable = function () {
                    var defaultKeyNumbers = this.getPrecisionScoreKeyNumbers();
                    this.removeEmptyKeyNumberRows(defaultKeyNumbers);
                    this.getKeyNumberAvgData(defaultKeyNumbers);
                    return defaultKeyNumbers;
                };
                precisionScoreChart.prototype.getPrecisionScoreKeyNumbers = function () {
                    this.keyNumbers = {};
                    var filteredSeries = null;
                    if (this.comparisonTypeId != app.constants.precisionScoreComparisonTypes.VaccinationCrew) {
                        filteredSeries = this.getFilteredSeriesforKeyNumbers(false);
                    }
                    else {
                        filteredSeries = _.filter(this.highchartsSettings.series, function (serie) { return (serie.type === app.constants.chartSerieTypes.spline || serie.type === app.constants.chartSerieTypes.column); });
                    }
                    var categories = this.getFiteredCategoriesForKeyNumbers();
                    var keyNumbersData = this.createKeyNumbersByCategory(filteredSeries, categories);
                    this.keyNumbers["rows"] = keyNumbersData;
                    this.keyNumbers["headers"] = this.createKeyNumberHeaders(filteredSeries);
                    return this.keyNumbers;
                };
                precisionScoreChart.prototype.getAvgSeries = function (series) {
                    var dbSerieType = this.dbSerieType;
                    return _.filter(series, function (serie) { return serie.type === dbSerieType; });
                };
                precisionScoreChart.prototype.getTotalAvgSerie = function (series) {
                    return _.filter(series, function (serie) { return serie.type === app.constants.chartSerieTypes.spline; });
                };
                precisionScoreChart.prototype.getKeyNumberAvgData = function (defaultKeyNumbers) {
                    var _this = this;
                    var totalAvgSeries = this.getTotalAvgSerie(this.highchartsSettings.series);
                    if ((totalAvgSeries == null || totalAvgSeries.length === 0))
                        return;
                    _.forEach(defaultKeyNumbers.rows, function (row) {
                        if ((totalAvgSeries != null && totalAvgSeries.length > 0)) {
                            row["totalAvgRows"] = totalAvgSeries;
                            row["getTotalAvgValue"] = function (propertyName) {
                                if (propertyName === "name") {
                                    return app.localizer.resource.DbAverage;
                                }
                                else {
                                    if (_this.comparisonTypeId != app.constants.precisionScoreComparisonTypes.VaccinationCrew) {
                                        var key = _this.avgTranslations() + propertyName;
                                        var avgSerie = _.filter(row.totalAvgRows, function (avgDataRow) { return avgDataRow.name == key; })[0];
                                        var avgValue = avgSerie.data[0] == null ? "" : avgSerie.data[0];
                                        var sampleCountValue = avgSerie.dataSampleNumbers[0] === null ? "" : avgSerie.dataSampleNumbers[0];
                                        return avgValue === "" ? "" : avgValue + "(" + sampleCountValue + ")";
                                    }
                                    else {
                                        var avgValue = row.totalAvgRows[0].data[0] == null ? "" : row.totalAvgRows[0].data[0];
                                        var sampleCountValue = row.totalAvgRows[0].dataSampleNumbers[0] === null ? "" : row.totalAvgRows[0].dataSampleNumbers[0];
                                        return avgValue === "" ? "" : avgValue + "(" + sampleCountValue + ")";
                                    }
                                }
                            };
                        }
                    });
                };
                precisionScoreChart.prototype.removeEmptyKeyNumberRows = function (defaultKeyNumbers) {
                    var noEmptyRows = [];
                    var columns = _.filter(defaultKeyNumbers.headers, function (header) { return (header.propertyName != "name"); });
                    _.forEach(defaultKeyNumbers.rows, function (row) {
                        var blankPropertiesCount = 0;
                        for (var i = 0; i < columns.length; i++) {
                            var column = columns[i];
                            if (row[column.propertyName] === "") {
                                blankPropertiesCount++;
                            }
                        }
                        if (columns.length !== blankPropertiesCount) {
                            noEmptyRows.push(row);
                        }
                    });
                    defaultKeyNumbers["rows"] = noEmptyRows;
                };
                precisionScoreChart.prototype.sortCategories = function (categoriesNames) {
                    var categoriesAsNumbers = _.map(categoriesNames, function (category) { return parseInt(category); });
                    var sortedCategories = categoriesAsNumbers.sort(this.sortNumbers);
                    return sortedCategories;
                };
                precisionScoreChart.prototype.sortNumbers = function (numbA, NumbB) {
                    return numbA - NumbB;
                };
                precisionScoreChart.prototype.buildDbAverageSeries = function (seriesNames, categories) {
                    var _this = this;
                    var dbAvgSeries = [];
                    _.forEach(seriesNames, function (serie) {
                        var highchartsSerie = {};
                        var serieName = _this.avgTranslations() + _this.getTranslationSerie(serie);
                        var serieType = app.constants.chartSerieTypes.spline;
                        var data = [];
                        var dataSampleNumbers = [];
                        for (var j = 0; j < categories.length; j++) {
                            var categoryName = categories[j];
                            var totalPoint = _this.getPrecisionScoreChartItem(categoryName, serie, true);
                            if (totalPoint.totalDbAverage != null) {
                                dataSampleNumbers.push(totalPoint.totalSamplecount);
                                data.push(parseFloat(app.common.utils.precise_round(totalPoint.totalDbAverage, 2)));
                            }
                            else {
                                dataSampleNumbers.push(null);
                                data.push(null);
                            }
                        }
                        highchartsSerie["name"] = serieName;
                        highchartsSerie["type"] = serieType;
                        highchartsSerie["data"] = data;
                        highchartsSerie["dataSampleNumbers"] = dataSampleNumbers;
                        dbAvgSeries.push(highchartsSerie);
                    });
                    return dbAvgSeries;
                };
                precisionScoreChart.prototype.buildTotalDbAverageSerie = function (categories) {
                    var highchartsSerie = {};
                    var serieName = app.localizer.resource.DbAvgAllCrews;
                    var serieType = app.constants.chartSerieTypes.spline;
                    var data = [];
                    var dataSampleNumbers = [];
                    for (var j = 0; j < categories.length; j++) {
                        var totalDbAverage = this.precisionsChartItems[0].totalDbAverage;
                        var totalSamplecount = this.precisionsChartItems[0].totalSamplecount;
                        if (totalDbAverage != null) {
                            data.push(parseFloat(app.common.utils.precise_round(totalDbAverage, 2)));
                            dataSampleNumbers.push(totalSamplecount);
                        }
                        else {
                            data.push(null);
                            dataSampleNumbers.push(null);
                        }
                    }
                    highchartsSerie["name"] = serieName;
                    highchartsSerie["type"] = serieType;
                    highchartsSerie["data"] = data;
                    highchartsSerie["dataSampleNumbers"] = dataSampleNumbers;
                    return highchartsSerie;
                };
                precisionScoreChart.prototype.buildSeries = function (series, categories, isAvgPerCategory) {
                    var highchartsSeries = [];
                    for (var i = 0; i < series.length; i++) {
                        var highchartsSerie = {};
                        var serieName = series[i];
                        var newSerieName = isAvgPerCategory ? this.avgTranslations() + this.getTranslationSerie(series[i]) : this.getTranslationSerie(series[i]);
                        var serieType = null;
                        if (isAvgPerCategory) {
                            serieType = this.dbSerieType;
                        }
                        else {
                            serieType = app.constants.chartSerieTypes.column;
                        }
                        var data = [];
                        var dataSampleNumbers = [];
                        for (var j = 0; j < categories.length; j++) {
                            var categoryName = categories[j];
                            var point = this.getPrecisionScoreChartItem(categoryName, serieName, isAvgPerCategory);
                            if (point == null) {
                                data.push(null);
                                dataSampleNumbers.push(null);
                            }
                            else if (point.average != null) {
                                data.push(parseFloat(app.common.utils.precise_round(point.average, 2)));
                                dataSampleNumbers.push(point.sampleCount);
                            }
                            else {
                                data.push(point.average);
                                dataSampleNumbers.push(point.sampleCount);
                            }
                        }
                        highchartsSerie["name"] = newSerieName;
                        highchartsSerie["type"] = serieType;
                        highchartsSerie["data"] = data;
                        highchartsSerie["dataSampleNumbers"] = dataSampleNumbers;
                        highchartsSeries.push(highchartsSerie);
                    }
                    return highchartsSeries;
                };
                precisionScoreChart.prototype.setColors = function (series) {
                    var sortedSeries = [];
                    var columnSeries = this.getColumnSeries(series);
                    for (var index = 0; index < columnSeries.length; index++) {
                        var columnnSerie = columnSeries[index];
                        var colorBySerie = this.getColorByIndex(index);
                        columnnSerie["color"] = colorBySerie;
                        var serieName = columnnSerie.name;
                        this.getDbSerieByName(series, serieName, colorBySerie);
                    }
                    return sortedSeries;
                };
                precisionScoreChart.prototype.setToolips = function (series) {
                    for (var i = 0; i < series.length; i++) {
                        var serie = series[i];
                        serie["tooltip"] = this.getDefaultTooltip();
                    }
                };
                precisionScoreChart.prototype.getPrecisionScoreChartItem = function (categoryName, serieName, isAvg) {
                    var point = _.filter(this.precisionsChartItems, { xaxis: categoryName, legend: serieName, isAverage: isAvg });
                    return (point != null && point.length > 0) ? point[0] : null;
                };
                precisionScoreChart.prototype.getTranslationSerie = function (serieName) {
                    var translatedSerieName = '';
                    if (this.comparisonTypeId === app.constants.precisionScoreComparisonTypes.MachineType || this.comparisonTypeId === app.constants.precisionScoreComparisonTypes.VaccinationCrew) {
                        translatedSerieName = serieName;
                    }
                    else if (this.comparisonTypeId === app.constants.precisionScoreComparisonTypes.vaccinationMethod) {
                        switch (serieName) {
                            case "ENUM_Hand":
                                translatedSerieName = app.localizer.resource.ManualHandScoreSerieName;
                                break;
                            case "ENUM_Machine":
                                translatedSerieName = app.localizer.resource.MachineScoreSerieName;
                                break;
                        }
                    }
                    return translatedSerieName;
                };
                precisionScoreChart.prototype.getSerieKeyName = function (translatedSerieName) {
                    var keySerieName = '';
                    if (this.comparisonTypeId === app.constants.precisionScoreComparisonTypes.MachineType ||
                        this.comparisonTypeId === app.constants.precisionScoreComparisonTypes.VaccinationCrew) {
                        keySerieName = translatedSerieName;
                    }
                    else if (this.comparisonTypeId === app.constants.precisionScoreComparisonTypes.vaccinationMethod) {
                        switch (translatedSerieName) {
                            case app.localizer.resource.ManualHandScoreSerieName:
                                keySerieName = "ENUM_Hand";
                                break;
                            case app.localizer.resource.MachineScoreSerieName:
                                keySerieName = "ENUM_Machine";
                                break;
                        }
                    }
                    return keySerieName;
                };
                precisionScoreChart.prototype.avgTranslations = function () {
                    return app.localizer.resource.DbAvg + " ";
                };
                precisionScoreChart.prototype.getDbSerieByName = function (series, columnserieName, color) {
                    var dbSerieName = this.avgTranslations() + columnserieName;
                    var dbSerie = this.getSerieByTypeAndName(series, dbSerieName, app.constants.chartSerieTypes.spline);
                    if (dbSerie != null) {
                        dbSerie["color"] = color;
                    }
                    return dbSerie;
                };
                precisionScoreChart.prototype.isAverageSerie = function (serieName) {
                    var avgPrefix = this.avgTranslations();
                    return serieName.startsWith(avgPrefix) === true;
                };
                precisionScoreChart.prototype.getDbNumberOfSamples = function (yearMonth, comparisonType) {
                    var dbRow = this.getPrecisionScoreChartItem(yearMonth, comparisonType, true);
                    return dbRow == null ? 0 : dbRow.sampleCount;
                };
                precisionScoreChart.prototype.getNumberOfSamples = function (yearMonth, comparisonType) {
                    var row = this.getPrecisionScoreChartItem(yearMonth, comparisonType, false);
                    return row == null ? 0 : row.sampleCount;
                };
                precisionScoreChart.prototype.getKeyNumbersByYearMonthAndComparisonType = function (yearMonth, comparisonType) {
                    var key = yearMonth + comparisonType;
                    return this.getKeyNumberByPeriod(key);
                };
                precisionScoreChart.prototype.setKeyNumbersByYearMonthAndComparisonType = function (yearMonth, comparisonType, keyNumbers) {
                    var key = yearMonth + comparisonType;
                    this.setKeyNumbersByPeriod(key, keyNumbers);
                };
                return precisionScoreChart;
            })(app.web.model.baseChart);
            model.precisionScoreChart = precisionScoreChart;
        })(model = web.model || (web.model = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var model;
        (function (model) {
            var percentileSideEffectsChart = (function (_super) {
                __extends(percentileSideEffectsChart, _super);
                function percentileSideEffectsChart(dataSource, chartType, stageId) {
                    _super.call(this);
                    this.categories = [];
                    this.dbAverageSerieColor = "#7cb5ec";
                    this.siteSerieColor = "#434348";
                    this.hasSiteData = dataSource[0].summary.hasSiteData;
                    this.hasDbData = dataSource[0].summary.hasDbData;
                    this.sideEffectDatasource = dataSource[0].perecentileChartItems;
                    this.seletedChartTypeOptionId = chartType;
                    this.stageId = stageId;
                    this.setCategories();
                    this.dbSerieType = app.constants.chartSerieTypes.column;
                    this.chartSelectionType = app.constants.benchmarkingChartGroups.percentilesSideEffects;
                    if (this.sideEffectDatasource.length > 0) {
                        this.fromYearMonth = this.sideEffectDatasource[0].fromYearMonth;
                        this.toYearMonth = this.sideEffectDatasource[0].toYearMonth;
                    }
                }
                percentileSideEffectsChart.prototype.hasDataToShow = function () {
                    return (this.hasSiteData === true || this.hasDbData === true);
                };
                percentileSideEffectsChart.prototype.setCategories = function () {
                    this.categories = _.uniqBy(this.sideEffectDatasource, function (chartItem) { return chartItem.xaxis; });
                    var avgChartItems = _.filter(this.sideEffectDatasource, { isAverage: true });
                    var chartItems = _.filter(this.sideEffectDatasource, { isAverage: false });
                    this.series = _.uniqBy(chartItems, function (chartItem) { return chartItem.legend; });
                    this.avgSeries = _.uniqBy(avgChartItems, function (chartItem) { return chartItem.legend; });
                    _.forEach(avgChartItems, function (avgItem) {
                        var hasNoValues = _.filter(chartItems, { xaxis: avgItem.xaxis, legend: avgItem.legend, average: null, sampleCount: null });
                        if (hasNoValues !== null && hasNoValues.length > 0) {
                            avgItem.average = null;
                            avgItem.sampleCount = null;
                        }
                    });
                };
                percentileSideEffectsChart.prototype.buildHighchartsSettings = function () {
                    this.keyNumbersDictionary = [];
                    this.highchartsSettings = {};
                    var seriesNames = _.map(this.series, function (serie) { return serie.legend; });
                    var avgSeriesNames = _.map(this.avgSeries, function (serie) { return serie.legend; });
                    var stringCategories = _.map(this.categories, function (category) { return category.xaxis; });
                    this.categoriesNames = this.sortCategories(stringCategories);
                    var columnSeries = this.buildSeries(seriesNames, this.categoriesNames, false);
                    var avgSeries = this.buildSeries(avgSeriesNames, this.categoriesNames, true);
                    var highchartSeries = columnSeries.concat(avgSeries);
                    var labels = _super.prototype.getLabels.call(this);
                    this.highchartsSettings = { series: highchartSeries, categories: this.categoriesNames, yAxisTitle: labels.yAxisTitle, chartTitle: labels.chartTitle, hasData: true, yAxisFormat: "{value} %", maxYAxis: 100, showLegend: this.showLegend, minYaxis: 0 };
                    this.setColors();
                    return this.highchartsSettings;
                };
                percentileSideEffectsChart.prototype.setColors = function () {
                    var _this = this;
                    var avgSeries = _.filter(this.highchartsSettings.series, function (serie) { return (serie.isDbAverage === true); });
                    var siteSeries = _.filter(this.highchartsSettings.series, function (serie) { return (serie.isDbAverage === false); });
                    _.forEach(avgSeries, function (serie) { serie.color = _this.dbAverageSerieColor; });
                    _.forEach(siteSeries, function (serie) { serie.color = _this.siteSerieColor; });
                };
                percentileSideEffectsChart.prototype.getHighchartsSettings = function () {
                    if (this.hasDataToShow())
                        return this.buildHighchartsSettings();
                    else
                        return { hasData: false };
                };
                percentileSideEffectsChart.prototype.sortCategories = function (categoriesNames) {
                    var categoriesAsNumbers = _.map(categoriesNames, function (category) { return parseInt(category); });
                    var sortedCategories = categoriesAsNumbers.sort(this.sortNumbers);
                    return sortedCategories;
                };
                percentileSideEffectsChart.prototype.sortNumbers = function (numbA, NumbB) {
                    return numbA - NumbB;
                };
                percentileSideEffectsChart.prototype.buildSeries = function (series, categories, isAvg) {
                    var highchartsSeries = [];
                    for (var i = 0; i < series.length; i++) {
                        var highchartsSerie = {};
                        var serieName = series[i];
                        var newSerieName = isAvg ? app.localizer.resource.DbAvg : series[i];
                        var serieType = app.constants.chartSerieTypes.column;
                        var data = [];
                        var dataSampleNumbers = [];
                        for (var j = 0; j < categories.length; j++) {
                            var categoryName = categories[j];
                            var point = this.getPrecisionScoreChartItem(categoryName, serieName, isAvg);
                            if (point == null) {
                                data.push(null);
                                dataSampleNumbers.push(null);
                            }
                            else if (point.average != null) {
                                data.push(parseFloat(app.common.utils.precise_round(point.average, 2)));
                                dataSampleNumbers.push(point.sampleCount);
                            }
                            else {
                                data.push(point.average);
                                dataSampleNumbers.push(point.sampleCount);
                            }
                        }
                        highchartsSerie["name"] = newSerieName;
                        highchartsSerie["type"] = serieType;
                        highchartsSerie["data"] = data;
                        highchartsSerie["dataSampleNumbers"] = dataSampleNumbers;
                        highchartsSerie["isDbAverage"] = isAvg;
                        highchartsSeries.push(highchartsSerie);
                    }
                    return highchartsSeries;
                };
                percentileSideEffectsChart.prototype.getPrecisionScoreChartItem = function (categoryName, serieName, isAvg) {
                    var point = _.filter(this.sideEffectDatasource, { xaxis: categoryName, legend: serieName, isAverage: isAvg });
                    return (point != null && point.length > 0) ? point[0] : null;
                };
                percentileSideEffectsChart.prototype.getKeyNumbersTable = function () {
                    var defaultKeyNumbers = this.getKeyNumbers(true);
                    var headers = defaultKeyNumbers.headers;
                    _.forEach(defaultKeyNumbers.rows, function (row) {
                        for (var i = 0; i < headers.length; i++) {
                            var propertyName = headers[i].propertyName;
                            var value = row[propertyName];
                            if (propertyName != 'name' && value !== "") {
                                row[propertyName] = row[propertyName].toString().replace(" ", "% ");
                            }
                        }
                    });
                    return defaultKeyNumbers;
                };
                return percentileSideEffectsChart;
            })(app.web.model.baseChart);
            model.percentileSideEffectsChart = percentileSideEffectsChart;
        })(model = web.model || (web.model = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var model;
        (function (model) {
            var averageSideEffectsScoreChart = (function (_super) {
                __extends(averageSideEffectsScoreChart, _super);
                function averageSideEffectsScoreChart(dataSource, chartType, stageId) {
                    _super.call(this);
                    this.categories = [];
                    this.dbAverageSerieColor = "#7cb5ec";
                    this.siteSerieColor = "#434348";
                    this.hasSiteData = dataSource[0].summary.hasSiteData;
                    this.hasDbData = dataSource[0].summary.hasDbData;
                    this.sideEffectDatasource = dataSource[0].averageScoreChartItems;
                    _.forEach(this.sideEffectDatasource, function (item) {
                        if (item.xaxis === "DbAverage") {
                            item.xaxis = app.localizer.resource.DbAvg;
                        }
                        if (item.legend === "DbAverage") {
                            item.legend = app.localizer.resource.AverageScoreChart;
                        }
                    });
                    this.seletedChartTypeOptionId = chartType;
                    this.stageId = stageId;
                    this.setCategories();
                    this.dbSerieType = app.constants.chartSerieTypes.column;
                    this.chartSelectionType = app.constants.benchmarkingChartGroups.averagesSideEffects;
                }
                averageSideEffectsScoreChart.prototype.hasDataToShow = function () { return (this.hasSiteData === true || this.hasDbData === true); };
                averageSideEffectsScoreChart.prototype.setCategories = function () {
                    this.categories = _.uniqBy(this.sideEffectDatasource, function (chartItem) { return chartItem.xaxis; });
                    this.series = _.uniqBy(this.sideEffectDatasource, function (chartItem) { return chartItem.legend; });
                };
                averageSideEffectsScoreChart.prototype.buildHighchartsSettings = function () {
                    this.keyNumbersDictionary = [];
                    this.highchartsSettings = {};
                    var seriesNames = _.map(this.series, function (serie) { return serie.legend; });
                    var stringCategories = _.map(this.categories, function (category) { return category.xaxis; });
                    this.categoriesNames = stringCategories;
                    var columnSeries = this.buildSeries(seriesNames, this.categoriesNames);
                    columnSeries.push(this.getStandardDesviationSerie(seriesNames[0], this.categoriesNames));
                    var highchartSeries = columnSeries;
                    var labels = { yAxisTitle: "", chartTitle: app.localizer.resource.AverageScoreChart };
                    this.highchartsSettings = { series: highchartSeries, categories: this.categoriesNames, yAxisTitle: labels.yAxisTitle, chartTitle: labels.chartTitle, hasData: true, maxYAxis: this.getMaxYAxis(highchartSeries), showLegend: false, minYaxis: 0 };
                    this.amplifyRangeForStdSeries();
                    return this.highchartsSettings;
                };
                averageSideEffectsScoreChart.prototype.getHighchartsSettings = function () {
                    if (this.hasDataToShow())
                        return this.buildHighchartsSettings();
                    else
                        return { hasData: false };
                };
                averageSideEffectsScoreChart.prototype.getErrorBarTooltip = function (parentSerieName) {
                    return { pointFormat: '<span style="font-weight: bold; color: {series.color}">' + parentSerieName + '</span>: <b>{point.low}-{point.high} </b><br/>' };
                };
                averageSideEffectsScoreChart.prototype.getStandardDesviationSerie = function (serieName, categories) {
                    var minValue = 0;
                    var maxValue = 0;
                    var highchartsSerie = {};
                    var serieType = app.constants.chartSerieTypes.errorbar;
                    var data = [];
                    for (var j = 0; j < categories.length; j++) {
                        var categoryName = categories[j];
                        var point = this.getChartItem(categoryName, serieName);
                        if (point == null || point.stdDesviation == null)
                            data.push(null);
                        else if (point.stdDesviation != null) {
                            minValue = (point.average - point.stdDesviation < 0) ? 0 : point.average - point.stdDesviation;
                            maxValue = point.average + point.stdDesviation;
                            var returnValue = [parseFloat(app.common.utils.precise_round(minValue, 2)), parseFloat(app.common.utils.precise_round(maxValue, 2))];
                            data.push(returnValue);
                        }
                    }
                    var serieName = serieName + " " + app.localizer.resource.StdDesvRange;
                    highchartsSerie["name"] = serieName;
                    highchartsSerie["type"] = serieType;
                    highchartsSerie["data"] = data;
                    highchartsSerie["tooltip"] = this.getErrorBarTooltip(serieName);
                    return highchartsSerie;
                };
                averageSideEffectsScoreChart.prototype.buildSeries = function (series, categories) {
                    var highchartsSeries = [];
                    for (var i = 0; i < series.length; i++) {
                        var highchartsSerie = {};
                        var serieName = series[i];
                        var newSerieName = serieName;
                        var serieType = app.constants.chartSerieTypes.column;
                        var data = [];
                        var dataSampleNumbers = [];
                        for (var j = 0; j < categories.length; j++) {
                            var categoryName = categories[j];
                            var point = this.getChartItem(categoryName, serieName);
                            var categoryColor = categoryName === app.localizer.resource.DbAvg ? this.dbAverageSerieColor : this.siteSerieColor;
                            if (point == null) {
                                data.push(null);
                                dataSampleNumbers.push(null);
                            }
                            else if (point.average != null) {
                                //data.push(parseFloat(app.common.utils.precise_round(point.average, 2)));
                                data.push({ y: parseFloat(app.common.utils.precise_round(point.average, 2)), color: categoryColor });
                                dataSampleNumbers.push(point.sampleCount);
                            }
                            else {
                                data.push(point.average);
                                dataSampleNumbers.push(point.sampleCount);
                            }
                        }
                        highchartsSerie["name"] = newSerieName;
                        highchartsSerie["type"] = serieType;
                        highchartsSerie["color"] = this.dbAverageSerieColor;
                        highchartsSerie["data"] = data;
                        highchartsSerie["dataSampleNumbers"] = dataSampleNumbers;
                        highchartsSeries.push(highchartsSerie);
                    }
                    return highchartsSeries;
                };
                averageSideEffectsScoreChart.prototype.getChartItem = function (categoryName, serieName) {
                    var point = _.filter(this.sideEffectDatasource, { xaxis: categoryName, legend: serieName });
                    return (point != null && point.length > 0) ? point[0] : null;
                };
                averageSideEffectsScoreChart.prototype.getKeyNumbersTable = function () {
                    var _this = this;
                    var defaultKeyNumbers = this.getKeyNumbers(true);
                    var rows = this.keyNumbers["rows"];
                    _.forEach(rows, function (row) {
                        if (row.name !== app.localizer.resource.DbAvg) {
                            row.rowStyle = function (column) {
                                if (column.text === app.localizer.resource.Name)
                                    return "{'background-color':'" + _this.siteSerieColor + "','color':'white'}";
                                else
                                    return "";
                            };
                        }
                        else
                            row.rowStyle = function (column) { return ""; };
                    });
                    return defaultKeyNumbers;
                };
                return averageSideEffectsScoreChart;
            })(app.web.model.baseChart);
            model.averageSideEffectsScoreChart = averageSideEffectsScoreChart;
        })(model = web.model || (web.model = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

var app;
(function (app) {
    var web;
    (function (web) {
        var model;
        (function (model) {
            var TimelineGroup = (function () {
                function TimelineGroup(showPast, showFuture, text, markers) {
                    this.showPast = showPast;
                    this.showFuture = showFuture;
                    this.text = text;
                    this.markers = markers;
                }
                return TimelineGroup;
            })();
            model.TimelineGroup = TimelineGroup;
            var TimelineMarker = (function () {
                function TimelineMarker() {
                }
                return TimelineMarker;
            })();
            model.TimelineMarker = TimelineMarker;
            var TimelineActivity = (function () {
                function TimelineActivity() {
                }
                return TimelineActivity;
            })();
            model.TimelineActivity = TimelineActivity;
        })(model = web.model || (web.model = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

/// <reference path="../_typings.web.ts"/>
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var ShellController = (function () {
                function ShellController($rootScope, $scope, $state, $translate, config, notificationService, authenticationService, env, $timeout, datacontext, navigationService, modalService, appLocalStorage) {
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.$state = $state;
                    this.$translate = $translate;
                    this.config = config;
                    this.notificationService = notificationService;
                    this.authenticationService = authenticationService;
                    this.env = env;
                    this.$timeout = $timeout;
                    this.datacontext = datacontext;
                    this.navigationService = navigationService;
                    this.modalService = modalService;
                    this.appLocalStorage = appLocalStorage;
                    this.isLoginState = true;
                    this.applicationName = '';
                    this.copyright = '';
                    this.applicationVersion = '';
                    this.spinnerOptions = {
                        radius: 40,
                        lines: 7,
                        length: 0,
                        width: 30,
                        speed: 1.7,
                        corners: 1.0,
                        trail: 100,
                        color: '#F58A00'
                    };
                    this.userName = '';
                    $scope.viewModel = this;
                    this.busyMessage = this.$translate.instant('PleaseWait');
                    this.isBusy = false;
                    this.slideMenuOpen = false;
                    this.init();
                    //this.developerShortcut();
                    if (this.navigationService.customerPortalAssessmentId > 0)
                        $state.go('shell.assessments', { type: 'assessmentList', view: undefined });
                    else if (this.authenticationService.isCustomerUser())
                        $state.go('shell.assessments', { type: 'status', view: app.constants.assessmentListViews.customerPortalStatus });
                    else
                        $state.go('shell.assessments', { type: 'status', view: undefined });
                }
                ShellController.prototype.selectAssessmentTypeGroup = function (assessmentTypeGroup) {
                    if (assessmentTypeGroup != null && this.navigationService.selectedAssessmentTypeGroup != null && assessmentTypeGroup.assessmentTypeGroupId == this.navigationService.selectedAssessmentTypeGroup.assessmentTypeGroupId) {
                        this.navigationService.selectedAssessmentTypeGroup = null;
                        this.selectedAssessmentTypeGroupId = null;
                    }
                    else {
                        this.navigationService.selectedAssessmentTypeGroup = assessmentTypeGroup;
                        this.selectedAssessmentTypeGroupId = this.navigationService.selectedAssessmentTypeGroup.assessmentTypeGroupId;
                    }
                    this.$rootScope.$broadcast(app.constants.broadcastEventNames.assessmentTypeGroup);
                };
                ShellController.prototype.showReport = function (reportId) {
                    console.log("Reports not implemented");
                };
                ShellController.prototype.init = function () {
                    var _this = this;
                    this.$rootScope.$on('$stateChangeStart', function (event, next, current) { _this.toggleSpinner(true); });
                    this.$rootScope.$on(this.config.events.controllerActivateSuccess, function (data) { _this.toggleSpinner(false); });
                    this.$rootScope.$on(this.config.events.spinnerToggle, function (data) { _this.toggleSpinner(data.show); });
                    this.assessmentTypeGroups = this.datacontext.getAssessmentTypeGroups();
                    this.userName = this.authenticationService.credentialsCurrentUserGet().FullName;
                    this.applicationVersion = this.$translate.instant("ApplicationVersion") + ' ' + this.env.appVersion + ' ' + this.$translate.instant('DatabaseVersion') + ' ' + this.appLocalStorage.dbVersionGet();
                    var dt = new Date();
                    this.copyright = '© ' + dt.getFullYear() + ' - ' + this.env.companyName;
                    var environment = this.env.name == "production" ? "" : "    ** " + this.$translate.instant(this.env.name) + " **";
                    this.applicationName = this.env.appName + environment;
                    this.aside = { title: 'Title' };
                    if (this.navigationService.selectedAssessmentTypeGroup != null)
                        this.selectedAssessmentTypeGroupId = this.navigationService.selectedAssessmentTypeGroup.AssesmentTypeGroupId;
                    this.customerPortalTitle = this.navigationService.customerPortalTitle;
                    this.datacontext.getIsFarmerIntegrationEnabled().then(function (result) {
                        _this.appLocalStorage.farmerIntegerationEnabledSet(result);
                    });
                    this.datacontext.GetNoOfDaysFromFarmer().then(function (result) {
                        _this.appLocalStorage.noOfdaysFromFarmerSet(result);
                    });
                };
                ShellController.prototype.developerShortcut = function () {
                    // this.modalService.show('modules/user_settings/user.settings.html', constants.dialogSize.defaultSize, '', null, () => { }, {});   
                    //  this.modalService.show('modules/setup/active_substance/active.substance.html', constants.dialogSize.small, '', null, () => { }, {});            
                    // this.modalService.show('modules/setup/supplier/supplier.list.html', constants.dialogSize.defaultSize, '', null, () => { }, {}); 
                    //  this.modalService.show('modules/setup/supplier/supplier.edit.html', constants.dialogSize.small, '', null, () => { }, new services.SupplierData(null)); 
                    // this.modalService.show('modules/setup/supplier/supplier.edit.html', constants.dialogSize.medium, '', null, () => { }, new services.SupplierData({ supplierId: 71})); 
                    // this.modalService.show('modules/prescription/prescription.edit.html', constants.dialogSize.medium, '', null, () => { }, new services.PrescriptionData(222));
                    this.modalService.show('modules/setup/attribute_enum/attribute_enum.list.html', app.constants.dialogSize.defaultSize, '', null, function () { }, {});
                    //  this.modalService.show('modules/setup/treatment_product/treatment.product.edit.html', constants.dialogSize.medium, '', null, () => { }, new services.TreatmentProductData(null)); 
                    //  this.modalService.show('modules/setup/treatment_product/treatment.product.edit.html', constants.dialogSize.medium, '', null, () => { }, new services.TreatmentProductData(null));
                    //   this.modalService.show('modules/setup/treatment_product/treatment.product.edit.html', constants.dialogSize.medium, '', null, () => { }, new services.TreatmentProductData({ treatmentProductId: 43 }));
                    //this.modalService.show('modules/setup/treatment_product/treatment.product.list.html', constants.dialogSize.defaultSize, '', this.$scope, () => { },
                    //    {});
                };
                ShellController.prototype.toggleSpinner = function (on) { this.isBusy = on; };
                ShellController.$inject = ['$rootScope', '$scope', '$state', '$translate', 'config', 'notificationService', 'authenticationService', 'ENV', '$timeout', 'assessmentDatacontext', 'navigationService', 'modalService', 'appLocalStorage'];
                return ShellController;
            })();
            controllers.ShellController = ShellController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController('ShellController', ['$rootScope', '$scope', '$state', '$translate', 'config', 'notificationService', 'authenticationService', 'ENV', '$timeout', 'assessmentDatacontext', 'navigationService', 'modalService', 'appLocalStorage']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var LoginController = (function () {
                function LoginController($scope, $window, $state, $rootScope, $translate, $interval, $q, env, authenticationService, appLocalStorage, networkConnection, modalService, apiEndpointService) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$window = $window;
                    this.$state = $state;
                    this.$rootScope = $rootScope;
                    this.$translate = $translate;
                    this.$interval = $interval;
                    this.$q = $q;
                    this.env = env;
                    this.authenticationService = authenticationService;
                    this.appLocalStorage = appLocalStorage;
                    this.networkConnection = networkConnection;
                    this.modalService = modalService;
                    this.apiEndpointService = apiEndpointService;
                    this.userName = '';
                    this.password = '';
                    this.footerText = '';
                    this.rememberMe = false;
                    this.showForm = false;
                    this.isInitialized = false;
                    this.loggingIn = false;
                    this.loginFailedMessage = '';
                    this.allowRememberMe = false;
                    this.isOnline = false;
                    $scope.viewModel = this;
                    $scope.viewModel.userName = '';
                    $scope.viewModel.password = '';
                    this.footerText = '© ' + moment().year() + ' ' + env.companyName;
                    this.authenticationService.isRemeberMeActive().then(function (result) {
                        _this.allowRememberMe = result.data;
                        _this.isOnline = _this.networkConnection.isOnline();
                        _this.authenticationService.initialize();
                        _this.isInitialized = true;
                        _this.isInitializedInterval = _this.$interval(function () {
                            if (_this.appLocalStorage.applicationStatusGet().applicationInitialized) {
                                _this.showForm = true;
                                _this.$interval.cancel(_this.isInitializedInterval);
                            }
                        }, 100, 0);
                    });
                }
                LoginController.prototype.login = function () {
                    var _this = this;
                    this.loginFailedMessage = '';
                    this.authenticationService.login(this.$scope.viewModel.userName, this.$scope.viewModel.password, false, this.rememberMe)
                        .then(function (userData) {
                        if (_this.authenticationService.crmAssessmentId !== 0) {
                            _this.authenticationService.crmAssessmentId = 0;
                            _this.$window.location.href = _this.apiEndpointService.getApplicationEndpoint() +
                                "/AssessmentReport?&userId=" +
                                _this.authenticationService.credentialsGet().UserId;
                        }
                        else {
                            if (userData.EmailConfirmed)
                                return _this.$state.go('shell');
                            else
                                return _this.$state.go('confirmDetails');
                        }
                    })
                        .catch(function (result) {
                        _this.loginFailedMessage = result;
                    });
                };
                LoginController.prototype.resetPassword = function () {
                    this.modalService.show('modules/user_settings/user.forgotpassword.html', app.constants.dialogSize.small, '', this.$scope, function () { }, null);
                };
                LoginController.prototype.isSupportedBrowser = function () {
                    var userAgent = this.$window.navigator.userAgent;
                    var browsers = { chrome: /chrome/i, ios: /CriOS/i };
                    for (var key in browsers) {
                        if (browsers[key].test(userAgent)) {
                            return true;
                        }
                    }
                    ;
                    return false;
                };
                LoginController.$inject = ['$scope', '$window', '$state', '$rootScope', '$translate', '$interval', '$q', 'ENV', 'authenticationService', 'appLocalStorage', 'networkConnection', 'modalService', 'apiEndpointService'];
                return LoginController;
            })();
            controllers.LoginController = LoginController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("LoginController", ['$scope', '$window', '$state', '$rootScope', '$translate', '$interval', '$q', 'ENV', 'authenticationService', 'appLocalStorage', 'networkConnection', 'modalService', 'apiEndpointService']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var LoginCustomerPortalController = (function () {
                function LoginCustomerPortalController($scope, $location, $state, $rootScope, $interval, $q, env, authenticationService, appLocalStorage) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$location = $location;
                    this.$state = $state;
                    this.$rootScope = $rootScope;
                    this.$interval = $interval;
                    this.$q = $q;
                    this.env = env;
                    this.authenticationService = authenticationService;
                    this.appLocalStorage = appLocalStorage;
                    this.loginFailedMessage = '';
                    $scope.viewModel = this;
                    this.authenticationService.initialize();
                    this.isInitializedInterval = this.$interval(function () {
                        if (_this.appLocalStorage.applicationStatusGet().applicationInitialized) {
                            _this.$interval.cancel(_this.isInitializedInterval);
                            _this.login();
                        }
                    }, 100, 0);
                }
                LoginCustomerPortalController.prototype.login = function () {
                    this.authenticationService.authenticateCustomerPortalUser(JSON.parse(this.$location.search().token), this.$location.search().client_id);
                    if (this.authenticationService.isAutheticated) {
                        this.$state.go('shell', { isCustomerPortalInAFa: true });
                    }
                    else {
                        this.loginFailedMessage = "Login failed";
                    }
                };
                LoginCustomerPortalController.$inject = ['$scope', '$location', '$state', '$rootScope', '$interval', '$q', 'ENV', 'authenticationService', 'appLocalStorage'];
                return LoginCustomerPortalController;
            })();
            controllers.LoginCustomerPortalController = LoginCustomerPortalController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("LoginCustomerPortalController", ['$scope', '$location', '$state', '$rootScope', '$interval', '$q', 'ENV', 'authenticationService', 'appLocalStorage']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var NoAccessController = (function () {
                function NoAccessController($scope) {
                    this.$scope = $scope;
                    this.message = "You do not have access to this site.";
                }
                NoAccessController.$inject = ['$scope'];
                return NoAccessController;
            })();
            controllers.NoAccessController = NoAccessController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("NoAccessController", ['$scope']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var UserBaseController = (function () {
                function UserBaseController() {
                    this.errors = [];
                }
                UserBaseController.prototype.hasError = function (property) {
                    return _.some(this.errors, { 'property': property });
                };
                UserBaseController.prototype.clearError = function (property) {
                    if (this.hasError(property)) {
                        this.removeError(property);
                    }
                };
                UserBaseController.prototype.removeError = function (property) {
                    _.remove(this.errors, function (error) {
                        return error.property === property;
                    });
                };
                UserBaseController.prototype.getErrorsFromModelstate = function (modelstate, form) {
                    if (form === void 0) { form = null; }
                    this.errors = [];
                    for (var key in modelstate) {
                        for (var i = 0; i < modelstate[key].length; i++) {
                            var error = { errorMessage: modelstate[key][i], property: key.split(".").pop().toCamelCase() };
                            if (!_.some(this.errors, { 'errorMessage': error.errorMessage })) {
                                this.errors.push(error);
                                if (form && key.split(".").pop().toCamelCase() > "") {
                                    form[key.split(".").pop().toCamelCase()].$setValidity("text", false);
                                    form[key.split(".").pop().toCamelCase()].errorMessage = error.errorMessage;
                                }
                            }
                        }
                    }
                };
                UserBaseController.prototype.errorMessageGet = function (property) {
                    var errorMessage = "Undefined error";
                    var error = _.find(this.errors, { 'property': property });
                    if (!_.isUndefined(error)) {
                        errorMessage = error.errorMessage;
                    }
                    return errorMessage;
                };
                return UserBaseController;
            })();
            controllers.UserBaseController = UserBaseController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

/// <reference path="../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var ConfirmDetailsController = (function (_super) {
                __extends(ConfirmDetailsController, _super);
                function ConfirmDetailsController($scope, $state, $interval, env, authenticationService, userManagementDatacontext, appLocalStorage) {
                    var _this = this;
                    _super.call(this);
                    this.$scope = $scope;
                    this.$state = $state;
                    this.$interval = $interval;
                    this.env = env;
                    this.authenticationService = authenticationService;
                    this.userManagementDatacontext = userManagementDatacontext;
                    this.appLocalStorage = appLocalStorage;
                    this.isInitialized = false;
                    this.showForm = false;
                    this.userDetailsCofirmed = false;
                    $scope.viewModel = this;
                    this.isInitialized = true;
                    this.copyright = '© 2015 - ' + this.env.companyName;
                    var credentials = authenticationService.credentialsGet();
                    userManagementDatacontext.getUserById(credentials.UserId).then(function (user) {
                        _this.user = user;
                    });
                    this.isInitializedInterval = this.$interval(function () {
                        if (_this.appLocalStorage.applicationStatusGet().applicationInitialized) {
                            _this.showForm = true;
                            _this.$interval.cancel(_this.isInitializedInterval);
                        }
                    }, 100, 0);
                }
                ConfirmDetailsController.prototype.updateAndConfirm = function () {
                    var _this = this;
                    this.user.emailConfirmed = true;
                    return this.userManagementDatacontext.updateUser(this.user).then(function () {
                        var credentials = _this.authenticationService.credentialsGet();
                        credentials.EmailConfirmed = _this.user.emailConfirmed;
                        credentials.FirstName = _this.user.firstName;
                        credentials.LastName = _this.user.lastName;
                        credentials.Email = _this.user.email;
                        credentials.PhoneNumber = _this.user.phoneNumber;
                        credentials.Culture = _this.user.culture;
                        _this.authenticationService.credentialsUpdate(credentials);
                        _this.$state.go('shell');
                    }).catch(function (response) {
                        _super.prototype.getErrorsFromModelstate.call(_this, response.data.modelState);
                    });
                    ;
                };
                ConfirmDetailsController.$inject = ['$scope', '$state', '$interval', 'ENV', 'authenticationService', 'userManagementDatacontext', 'appLocalStorage'];
                return ConfirmDetailsController;
            })(controllers.UserBaseController);
            controllers.ConfirmDetailsController = ConfirmDetailsController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("ConfirmDetailsController", ['$scope', '$state', '$interval', 'ENV', 'authenticationService', 'userManagementDatacontext', 'appLocalStorage']);

/// <reference path="../_typings.web.ts"/>
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var MainController = (function () {
                //public names: AngularDemo.Model.NameModel;
                function MainController($rootScope, $scope, $state, $location, authenticationService, customExceptionHandler, appLocalStorage, env, idle) {
                    var _this = this;
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.$state = $state;
                    this.$location = $location;
                    this.authenticationService = authenticationService;
                    this.customExceptionHandler = customExceptionHandler;
                    this.appLocalStorage = appLocalStorage;
                    this.env = env;
                    this.idle = idle;
                    this.isLoginState = true;
                    $scope.viewModel = this;
                    this.busyMessage = 'Please wait ...';
                    this.isBusy = false;
                    if (!_.isUndefined(this.$location.search().crmAssessmentId)) {
                        authenticationService.crmAssessmentId = parseInt(this.$location.search().crmAssessmentId);
                        this.$state.go('login');
                    }
                    else if (this.$location.url().indexOf("resetpassword") === -1 && this.$location.url().indexOf("loginCustomerPortal") === -1) {
                        var user = this.authenticationService.credentialsGet();
                        if (user && !user.EmailConfirmed)
                            this.$state.go('confirmDetails');
                        else
                            this.$state.go('shell');
                    }
                    this.$rootScope.$on('routesLoaded', function () {
                        _this.$state.go('assessments');
                    });
                    $scope.$on('IdleStart', function () {
                        if (_this.appLocalStorage.loggedInUserWithRememberMe()) {
                            idle.unwatch();
                        }
                        else if (_this.isLoginState)
                            idle.interrupt();
                        else {
                            _this.warning = true;
                            _this.countdown = env.idleCountdown;
                            _this.$rootScope.$broadcast(app.constants.broadcastEventNames.idleTimeStart);
                        }
                    });
                    $scope.$on('IdleEnd', function () {
                        _this.warning = false;
                    });
                    $scope.$on('IdleTimeout', function () {
                        _this.warning = false;
                        authenticationService.logoutDesktop();
                        location.reload();
                    });
                    $scope.$on('$stateChangeStart', function (event, toState) {
                        event.currentScope.viewModel.isLoginState = (toState.name == "login");
                    });
                }
                MainController.prototype.dismissAlert = function () {
                    this.warning = false;
                    this.idle.interrupt();
                };
                MainController.$inject = ['$rootScope', '$scope', '$state', '$location', 'authenticationService', 'customExceptionHandler', 'appLocalStorage', 'ENV', 'Idle'];
                return MainController;
            })();
            controllers.MainController = MainController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController('MainController', ['$rootScope', '$scope', '$state', '$location', 'authenticationService', 'customExceptionHandler', 'appLocalStorage', 'ENV', 'Idle']);

/// <reference path="../../_typings.web.ts" />
"use strict";
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var DateRange = (function () {
                function DateRange(startDate, endDate) {
                    this.startDate = startDate;
                    this.endDate = endDate;
                    this.startDate = startDate;
                    this.endDate = endDate;
                }
                return DateRange;
            })();
            controllers.DateRange = DateRange;
            var AssessmentListController = (function () {
                function AssessmentListController($rootScope, $scope, $stateParams, $q, $interval, $timeout, $window, $translate, fileSaver, appLocalStorage, modalService, datacontext, upcomingEventDatacontext, navigationService, apiEndpointService, authenticationService, excelService, $locale) {
                    var _this = this;
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.$stateParams = $stateParams;
                    this.$q = $q;
                    this.$interval = $interval;
                    this.$timeout = $timeout;
                    this.$window = $window;
                    this.$translate = $translate;
                    this.fileSaver = fileSaver;
                    this.appLocalStorage = appLocalStorage;
                    this.modalService = modalService;
                    this.datacontext = datacontext;
                    this.upcomingEventDatacontext = upcomingEventDatacontext;
                    this.navigationService = navigationService;
                    this.apiEndpointService = apiEndpointService;
                    this.authenticationService = authenticationService;
                    this.excelService = excelService;
                    this.$locale = $locale;
                    this.pagedassessments = [];
                    this.pagedTemplatedata = [];
                    this.timelineGroups = [];
                    this.currentPage = -1;
                    this.itemsPerPage = 30;
                    this.totalRows = 0;
                    this.filterPanelHeight = 36;
                    this.showAllDate = false;
                    this.selectedDateRangeString = "";
                    this.isCustomerPortalView = this.authenticationService.isCustomerUser();
                    app.common.utils.languageId = this.datacontext.getLanguageId(this.appLocalStorage.applicationStatusGet().translationsCulture);
                    if (this.navigationService.objectKey === null) {
                        navigationService.setObjectKey("0-1", null);
                    }
                    this.initView($scope);
                    this.$scope.$on(app.constants.broadcastEventNames.navigationObjectIdChanged, function (event, data) {
                        _this.setSelectedNavigationObjects();
                    });
                    this.$scope.$on(app.constants.broadcastEventNames.assessmentViewType, function (event, data) {
                        _this.isMapView = data;
                        _this.currentPage = _this.isMapView ? 0 : -1;
                        _this.filterList[_this.filterList.length - 1].isVisible = !_this
                            .isMapView;
                    });
                    this.$scope.$on(app.constants.broadcastEventNames.mapViewDataLoaded, function (event, data) {
                        _this.currentPage = 0;
                        _this.filterList[_this.filterList.length - 1].isVisible = !_this
                            .isMapView;
                    });
                    this.$scope.$on(app.constants.broadcastEventNames.assessmentTypeGroup, function (event, data) {
                        _this.setAssessmentTypeGroupFilter();
                    });
                    $scope.$on(app.constants.broadcastEventNames.registrationCompleted, function (value) {
                        _this.toggleFilterChanged();
                    });
                    $scope.$on(app.constants.broadcastEventNames.collapseAllOpenAssessments, function (value) {
                        _this.collapseAllAssessments();
                    });
                    $scope.$watch(function () { return _this.assessmentDateRange; }, function (dateRange, oldVal, scope) {
                        if (dateRange !== oldVal)
                            if (dateRange.startDate.toString() !== oldVal.startDate.toString() ||
                                dateRange.endDate.toString() !== oldVal.endDate.toString())
                                _this.datacontext.setAssessmentFaDDateRange(dateRange);
                        _this.toggleFilterChanged();
                    }, true); //NB! Deep watch
                    $scope.$watch(function () { return _this.selectedTimelineGroupByArg; }, function (newVal, oldVal) {
                        if (newVal != oldVal)
                            _this.loadTimelineData(_this.selectedTimelineGroupByArg);
                    });
                    $scope.$watch(function () { return _this.showAllDate; }, function (newVal, oldVal) {
                        if (newVal === true) {
                            var format = $locale.DATETIME_FORMATS["shortDate"].toUpperCase();
                            format = app.common.utils.getDateFormat(format);
                            _this.assessmentDateRange = new DateRange(moment("1900-01-01"), moment().add(1, 'y'));
                            _this.selectedDateRangeString = _this.assessmentDateRange.startDate.format(format).toString()
                                + " - "
                                + _this.assessmentDateRange.endDate.format(format).toString();
                        }
                        if (newVal === false) {
                            if (app.common.utils.isNullOrUndefinedOrEmpty(_this.navigationService.customerPortalAssessmentId) || _this.navigationService.customerPortalAssessmentId <= 0) {
                                _this.assessmentDateRange = new DateRange(moment().startOf('month'), moment().endOf("month"));
                            }
                        }
                    });
                    this.initilizeBinding();
                }
                AssessmentListController.prototype.initilizeBinding = function () {
                    var _this = this;
                    this.$interval(function () {
                        _this.setFilterPanelHeight();
                        angular.element(_this.$window).bind("resize", function () {
                            _this.setFilterPanelHeight();
                        });
                    }, 1000, 1);
                };
                AssessmentListController.prototype.setFilterPanelHeight = function () {
                    var _this = this;
                    this.$timeout(function () {
                        _this.filterPanelHeight = angular
                            .element(_this.$window.document)
                            .find("av-filter-panel")
                            .height();
                    }, 100);
                };
                AssessmentListController.prototype.getHeaders = function () {
                    var _this = this;
                    //todo: model
                    return controllers.getAssessmentListHeader(this).filter(function (header) {
                        return !_this.isCustomerPortalView || (_this.isCustomerPortalView && header.name != 'Files');
                    });
                };
                AssessmentListController.prototype.openAttachedFile = function (assessmentId, filename) {
                    var _this = this;
                    this.datacontext.openAttachedFile(assessmentId, filename)
                        .then(function (result) {
                        _this.fileSaver.saveAs(new Blob([result.data]), filename);
                    });
                    ;
                };
                AssessmentListController.prototype.getLabTestHeaders = function () {
                    return controllers.getLabTestListHeader(this);
                };
                AssessmentListController.prototype.delete = function (assessment) {
                    var _this = this;
                    //event.entityAspect.setDeleted();
                    _.remove(this.pagedassessments, function (currentObject) {
                        return currentObject.assessmentId === assessment.assessmentId;
                    });
                    this.datacontext.deleteAssessment(assessment).then(function () {
                        _this.toggleFilterChanged();
                    });
                };
                AssessmentListController.prototype.isCustomerPortalStatusView = function () {
                    return (this.viewType === app.constants.assessmentListViews.customerPortalStatus);
                };
                AssessmentListController.prototype.hide = function (assessment) {
                    _.remove(this.pagedassessments, function (currentObject) {
                        return currentObject.assessmentId === assessment.assessmentId;
                    });
                    var userAssessment = assessment.userAssessments[0];
                    if (userAssessment == null) {
                        this.datacontext.createUserAssessment({
                            userId: this.authenticationService.credentialsCurrentUserGet().UserId,
                            assessmentId: assessment.assessmentId,
                            hasHidden: true,
                            hasRead: false
                        });
                    }
                    else {
                        userAssessment.hasHidden = true;
                    }
                    this.datacontext.save();
                };
                AssessmentListController.prototype.initView = function (scope) {
                    this.viewType = this.$stateParams["view"]
                        ? this.$stateParams["view"]
                        : this.isCustomerPortalView
                            ? this.navigationService.customerPortalAssessmentId !== 0
                                ? app.constants.assessmentListViews.customerPortalAssessment
                                : app.constants.assessmentListViews.customerPortalStatus
                            : app.constants.assessmentListViews.status;
                    this.isMapView = this.navigationService.isMapViewSelected;
                    this.viewSubType = this.$stateParams["type"];
                    this.role = this.authenticationService.credentialsCurrentUserGet().Role;
                    if (this.navigationService.customerPortalAssessmentId > 0 &&
                        !app.common.utils.isNullOrUndefinedOrEmpty(this.navigationService.customerPortalAssessmentDate)) {
                        this.assessmentDateRange = new DateRange(moment(this.navigationService.customerPortalAssessmentDate).startOf("month"), moment(this.navigationService.customerPortalAssessmentDate).endOf("month"));
                    }
                    else {
                        this.assessmentDateRange =
                            this.isCustomerPortalView || this.isTimelineView()
                                ? new DateRange(moment().subtract(1, "year"), moment())
                                : new DateRange(moment().startOf("month"), moment().endOf("month"));
                    }
                    this.headers = this.getHeaders();
                    this.labTestHeaders = this.getLabTestHeaders();
                    this.timelineGroupByArgs = ["Site", "AssessmentGroup", "AssessmentLink"];
                    this.selectedTimelineGroupByArg = "Site";
                    this.cascadingRules = [
                        new web.model.CascadingRule(app.constants.assessmentProperties.customer, app.constants.assessmentProperties.site),
                        new web.model.CascadingRule(app.constants.assessmentProperties.site, app.constants.assessmentProperties.assessmentGroup),
                        new web.model.CascadingRule(app.constants.assessmentProperties.site, app.constants.assessmentProperties.siteFishgroup),
                        new web.model.CascadingRule(app.constants.assessmentTypeProperties.assessmentTypeGroup, app.constants.assessmentProperties.assessmentType)
                    ];
                    this.getFilterList();
                    scope.filterList = null;
                    scope.filterList = this.filterList;
                    // console.log('this.filterList;', this.filterList);
                    // console.log('this.filterList;', this.filterList);
                    // console.log('this.filterList;', this.filterList);
                    scope.assessmentDateRange = this.assessmentDateRange;
                    this.setSelectedNavigationObjects();
                    this.datacontext.setAssessmentFaDDateRange(this.assessmentDateRange);
                    if (this.isAssessmentView()) {
                        this.isCustomerPortalStatusView()
                            ? this.datacontext.setAssessmentFaDFiltersList(this.getSiteFilter()) :
                            this.datacontext.setAssessmentFaDFiltersList(this.filterList);
                    }
                };
                AssessmentListController.prototype.selectSite = function (customerId, siteId) {
                    this.$rootScope.$broadcast(app.constants.broadcastEventNames.siteSelected, app.constants.operationUnitLevels.site + "-" + siteId);
                };
                AssessmentListController.prototype.isStatusView = function () {
                    return (this.viewType === app.constants.assessmentListViews.status ||
                        this.viewType === app.constants.assessmentListViews.customerPortalStatus);
                };
                AssessmentListController.prototype.isAssessmentView = function () {
                    return (this.viewType === app.constants.assessmentListViews.assessment ||
                        this.viewType === app.constants.assessmentListViews.customerPortalAssessment);
                };
                AssessmentListController.prototype.isTemplateView = function () {
                    return (this.viewType === app.constants.assessmentListViews.template ||
                        this.viewType === app.constants.assessmentListViews.customerPortalTemplate);
                };
                AssessmentListController.prototype.isTimelineView = function () {
                    return this.viewType === app.constants.assessmentListViews.timeline;
                };
                AssessmentListController.prototype.showDefaultDropdown = function () {
                    return this.isAssessmentView() || this.isStatusView() || this.isTemplateView() || this.isTimelineView();
                };
                AssessmentListController.prototype.toggleFilterChanged = function () {
                    if (this.currentPage < 0 && !this.isTimelineView())
                        return; //skip those redundant filterchange calls
                    this.currentPage = -1;
                    this.filterChanged = !this.filterChanged;
                    this.$scope.$broadcast(app.constants.broadcastEventNames.assessmentsFilter, {
                        levelId: this.navigationService.selectedLevelId,
                        objectId: this.navigationService.selectedObjectId
                    });
                    if (this.isAssessmentView()) {
                        this.isCustomerPortalStatusView()
                            ? this.datacontext.setAssessmentFaDFiltersList(this.getSiteFilter()) :
                            this.datacontext.setAssessmentFaDFiltersList(this.filterList);
                    }
                    if (this.isMapView && !this.isAssessmentView())
                        this.$rootScope.$broadcast(app.constants.broadcastEventNames.refreshMapView);
                    else if (this.isTimelineView())
                        this.loadTimelineData(this.selectedTimelineGroupByArg);
                };
                AssessmentListController.prototype.loadTemplateData = function () {
                    var _this = this;
                    return this.datacontext
                        .getTemplateData(this.currentPage + 1, 300, this.isCustomerPortalStatusView()
                        ? this.getSiteFilter()
                        : this.filterList, this.isTemplateView() ? this.assessmentDateRange : null, this.viewType, this.viewSubType, this.navigationService.selectedLevelId)
                        .then(function (data) {
                        var rowHeader = 0;
                        var preGroup = _.map(data.results, function (tr) {
                            return {
                                groupKey: tr.assessmentId + 'row' + tr.rowIndex,
                                data: tr
                            };
                        });
                        var dataGroupedByAssessment = _.chain(preGroup)
                            .groupBy('groupKey')
                            .toPairs()
                            .map(function (gr) {
                            return _.map(gr[1], function (val) { return val.data; });
                        }).value();
                        var templatedata = _.map(dataGroupedByAssessment, function (row) {
                            var keys = _.concat(_.map(row, function (tr) {
                                return tr.attribute.dictionary.name;
                            }));
                            var values = _.concat(_.map(row, function (tr) {
                                if (tr.attribute.dictionary.name == 'LabTest_Diagnosis' && !app.common.utils.isNullOrUndefinedOrEmpty(tr.focusValue)) {
                                    return tr.focusValue.split(',').map(function (diagnisisId) {
                                        return _this.datacontext.getDiagnosisById(diagnisisId).name;
                                    }).join(',');
                                }
                                return tr.focusValue;
                            }));
                            var assessment = _.first(row).assessmentDto;
                            assessment.jumpToStep = _.first(row).jumbToStep; // set the sortorder to be the default step
                            assessment.jumpToRow = _.first(row).rowIndex;
                            assessment.samples = _.first(row).samples; // set the sortorder to be the default step
                            rowHeader++;
                            return _.assignIn(assessment, _.zipObject(keys, values));
                        });
                        if (_this.currentPage > -1)
                            _this.pagedTemplatedata = _this.pagedTemplatedata.concat(templatedata);
                        else
                            _this.pagedTemplatedata = templatedata;
                        _this.totalRows = templatedata.length;
                        _this.currentPage++;
                        //if (this.navigationService.customerPortalAssessmentId > 0) {
                        //    var assessment = _.find(this.pagedassessments, (item: any) => {
                        //        return (
                        //            item.assessmentId ==
                        //            this.navigationService.customerPortalAssessmentId
                        //        );
                        //    });
                        //    if (!_.isUndefined(assessment)) assessment.showDetail = true;
                        //    this.navigationService.customerPortalAssessmentId = 0;
                        //}
                        return _this.pagedTemplatedata;
                    });
                };
                AssessmentListController.prototype.loadAssessments = function () {
                    var _this = this;
                    return this.datacontext
                        .getAssessments(this.currentPage + 1, this.itemsPerPage, this.isCustomerPortalStatusView()
                        ? this.getSiteFilter()
                        : this.filterList, this.isAssessmentView() ? this.assessmentDateRange : null, this.viewType, this.navigationService.selectedLevelId)
                        .then(function (data) {
                        if (_this.isCustomerPortalView) {
                            var results = data.results;
                            data.results = results.filter(function (item) {
                                return item["isLocked"] === true && item["visitType"] !== "VisitType_Risk_Assessment" && item.showInCustomerPortal;
                            });
                        }
                        data.results = _this.datacontext.changeVisitTypeValue(data.results);
                        if (_this.currentPage > -1)
                            _this.pagedassessments = _this.pagedassessments.concat(data.results);
                        else
                            _this.pagedassessments = data.results;
                        // console.log(
                        //   "loadAssessments pagedassessments",
                        //   this.pagedassessments
                        // );
                        _this.totalRows = data.inlineCount;
                        _this.currentPage++;
                        if (_this.navigationService.customerPortalAssessmentId > 0) {
                            var assessment = _.find(_this.pagedassessments, function (item) {
                                return (item.assessmentId ==
                                    _this.navigationService.customerPortalAssessmentId);
                            });
                            if (!_.isUndefined(assessment)) {
                                assessment.showDetail = true;
                                if (_this.isCustomerPortalView) {
                                    if (_this.navigationService.customerPortalAssessmentId > 0) {
                                        var userAssessment = assessment.userAssessments[0];
                                        if (userAssessment == null) {
                                            _this.datacontext.createUserAssessment({
                                                userId: _this.authenticationService.credentialsCurrentUserGet()
                                                    .UserId,
                                                assessmentId: assessment.assessmentId,
                                                hasHidden: false,
                                                hasRead: true
                                            });
                                        }
                                        _this.datacontext.save();
                                    }
                                }
                            }
                            _this.navigationService.customerPortalAssessmentId = 0;
                            _this.navigationService.customerPortalAssessmentDate = null;
                        }
                        return _this.pagedassessments;
                    });
                };
                AssessmentListController.prototype.loadTimelineData = function (groupByArg) {
                    var _this = this;
                    if (!this.isTimelineView())
                        return;
                    //if (groupByArg !== 'AssessmentGroup') promiseArray.push();
                    return this.$q
                        .all([
                        this.datacontext.getAssessments(0, 1000, this.isCustomerPortalStatusView()
                            ? this.getSiteFilter()
                            : this.filterList, this.assessmentDateRange, this.viewType, this.navigationService.selectedLevelId),
                        groupByArg !== "AssessmentGroup"
                            ? this.upcomingEventDatacontext.getEvents(0, 1000, this.navigationService.objectKey, new Date(), this.authenticationService.credentialsGet().UserId, "Web App")
                            : this.$q.resolve([])
                    ])
                        .then(function (data) {
                        _this.timelineFromYear = new Date().getFullYear();
                        var assessments = _.filter(data[0].results, function (item) {
                            return item["isLocked"] === true && item["visitType"] !== "VisitType_Risk_Assessment";
                        }).map(function (assessment) {
                            _this.timelineFromYear =
                                _this.timelineFromYear >
                                    new Date(assessment.assessmentDate).getFullYear()
                                    ? new Date(assessment.assessmentDate).getFullYear()
                                    : _this.timelineFromYear;
                            return {
                                markType: app.constants.timelineMarkType.Assessment,
                                date: assessment.assessmentDate,
                                siteName: assessment.siteName,
                                assessmentDiscriminator: assessment.assessmentDiscriminator,
                                assessmentLink: assessment.assessmentType.dictionary.name === "Vaccination"
                                    ? assessment.assessmentDiscriminator
                                    : assessment.assessmentLink,
                                assessmentType: assessment.assessmentType.dictionary.name,
                                details: {
                                    date: assessment.assessmentDate,
                                    id: assessment.assessmentId,
                                    assessmentDiscriminator: assessment.assessmentDiscriminator,
                                    assessmentType: app.localizer.resource[assessment.assessmentType.dictionary.name],
                                    customer: assessment.customerName,
                                    site: assessment.siteName,
                                    fishgroup: assessment.fishgroupName,
                                    contactPerson: assessment.contactPersonNames.join(),
                                    isLocked: assessment.isLocked
                                }
                            };
                        });
                        var events = _.map(data[1], function (event) {
                            return {
                                markType: app.constants.timelineMarkType.Event,
                                date: event.eventDate,
                                siteName: event.siteName,
                                assessmentDiscriminator: null,
                                assessmentLink: null,
                                assessmentType: event.assessmentTypeName,
                                details: {
                                    date: event.eventDate,
                                    id: event.eventId,
                                    assessmentDiscriminator: app.localizer.resource["Title_UpcomingEvents"],
                                    assessmentType: event.assessmentTypeName,
                                    customer: event.customerName,
                                    site: event.siteName,
                                    fishgroup: event.fishgroupName,
                                    contactPerson: event.contactName,
                                    isLocked: event.isLocked
                                }
                            };
                        });
                        var timelineObjs;
                        if (groupByArg === "AssessmentLink")
                            timelineObjs = _.remove(assessments, function (assessment) {
                                return assessment.assessmentLink !== null;
                            });
                        else
                            timelineObjs = assessments.concat(events);
                        _this.timelineGroups = _
                            .chain(timelineObjs)
                            .groupBy(function (obj) {
                            switch (groupByArg) {
                                case "AssessmentLink":
                                    return obj.assessmentLink !== null ? obj.assessmentLink : "";
                                case "AssessmentGroup":
                                    return obj.assessmentDiscriminator !== null
                                        ? obj.assessmentDiscriminator.split("|")[0]
                                        : "";
                                default:
                                    return obj.siteName;
                            }
                        })
                            .toPairs()
                            .map(function (primaryGroup) {
                            return {
                                showPast: false,
                                showFuture: false,
                                text: primaryGroup[0],
                                //minDate: _.minBy(primaryGroup[1],'date'),
                                markers: _
                                    .chain(primaryGroup[1])
                                    .groupBy("date")
                                    .toPairs()
                                    .map(function (secondaryGroup) {
                                    return {
                                        date: new Date(secondaryGroup[0]),
                                        activities: _.map(secondaryGroup[1], function (obj) {
                                            return {
                                                markType: obj.markType,
                                                iconPath: obj.markType ===
                                                    app.constants.timelineMarkType.Assessment
                                                    ? "images/AssessmentType" +
                                                        obj.assessmentType.replace("-", "") +
                                                        ".png"
                                                    : "images/events-calendar-icon.png",
                                                header: obj.assessmentType,
                                                details: obj.details
                                            };
                                        })
                                    };
                                })
                                    .reverse()
                                    .value()
                            };
                        })
                            .value();
                    });
                };
                AssessmentListController.prototype.collapseAllAssessments = function () {
                    _.forEach(this.pagedassessments, function (assessment) {
                        assessment.showDetail = false;
                    });
                };
                AssessmentListController.prototype.getSiteFilter = function () {
                    var tempFilterList = new Array();
                    tempFilterList.push(_.find(this.filterList, function (filter) { return filter.name === app.constants.assessmentProperties.site; }));
                    return tempFilterList;
                };
                AssessmentListController.prototype.setSelectedNavigationObjects = function () {
                    this.setSelectedCustomerFilter();
                    this.setSelectedSiteFilter();
                    if (this.navigationService.isOnSiteLevel()) {
                        var site = this.datacontext.getSite(this.navigationService.selectedObjectId);
                        this.navigationService.isSiteActive = site.active;
                    }
                    this.toggleFilterChanged();
                };
                AssessmentListController.prototype.setSelectedCustomerFilter = function () {
                    var _this = this;
                    var customerFilter = _.find(this.filterList, function (filter) { return filter.name === app.constants.assessmentProperties.customer; });
                    if (customerFilter) {
                        customerFilter.selectedIds.length = 0;
                        if (!this.navigationService.isAboveCustomerLevel()) {
                            customerFilter.isLocked = true;
                            angular.forEach(customerFilter.masterCollection, function (item) {
                                item.selected =
                                    item.id === _this.navigationService.selectedCustomerId;
                                if (item.selected)
                                    customerFilter.selectedIds.push(item.id);
                            });
                        }
                        else {
                            customerFilter.isLocked = false;
                            angular.forEach(customerFilter.masterCollection, function (item) {
                                item.selected = false;
                            });
                        }
                    }
                };
                AssessmentListController.prototype.setSelectedSiteFilter = function () {
                    var _this = this;
                    var siteFilter = _.find(this.filterList, function (filter) { return filter.name === app.constants.assessmentProperties.site; });
                    if (siteFilter) {
                        siteFilter.selectedIds.length = 0;
                        if (this.navigationService.isOnSiteLevel()) {
                            siteFilter.isLocked = true;
                            angular.forEach(siteFilter.masterCollection, function (item) {
                                item.selected =
                                    item.id === _this.navigationService.selectedObjectId;
                                if (item.selected)
                                    siteFilter.selectedIds.push(item.id);
                            });
                        }
                        else {
                            siteFilter.isLocked = false;
                            angular.forEach(siteFilter.masterCollection, function (item) {
                                item.selected = false;
                            });
                        }
                    }
                };
                AssessmentListController.prototype.setAssessmentTypeGroupFilter = function () {
                    var _this = this;
                    var assessmentTypeGroupFilter = _.find(this.filterList, function (filter) {
                        return filter.name === app.constants.assessmentTypeProperties.assessmentTypeGroup;
                    });
                    if (assessmentTypeGroupFilter) {
                        assessmentTypeGroupFilter.selectedIds.length = 0;
                        angular.forEach(assessmentTypeGroupFilter.masterCollection, function (item) {
                            if (_this.navigationService.selectedAssessmentTypeGroup != null) {
                                item.selected =
                                    item.id ===
                                        _this.navigationService.selectedAssessmentTypeGroup
                                            .assessmentTypeGroupId;
                                if (item.selected)
                                    assessmentTypeGroupFilter.selectedIds.push(item.id);
                            }
                            else {
                                item.selected = false;
                            }
                        });
                    }
                };
                AssessmentListController.prototype.getFilterList = function () {
                    var _this = this;
                    this.filterList = new Array();
                    var optionList;
                    var filter;
                    if (!this.isCustomerPortalView) {
                        var customers = this.datacontext.getAllFromCache(app.constants.resourceNames.customerResource, false, "name");
                        optionList = new Array();
                        var customerIds = this.navigationService.getCustomerIds();
                        angular.forEach(customers, function (customer) {
                            if (customerIds.indexOf(customer.customerId) > -1) {
                                optionList.push(new web.model.DropdownOption(customer.name, customer.customerId, 0, app.constants.assessmentProperties.customer, false));
                            }
                        });
                        filter = new web.directives.Filter(app.constants.assessmentProperties.customer, "Filter_Customer", optionList, [], false, false);
                        this.filterList.push(filter);
                    }
                    var sites = this.datacontext.getAllFromCache(app.constants.resourceNames.siteResource, false, "name");
                    optionList = new Array();
                    var siteIds = this.navigationService.getSiteIds();
                    angular.forEach(sites, function (site) {
                        if (siteIds.indexOf(site.siteId) > -1) {
                            optionList.push(new web.model.DropdownOption(site.name, site.siteId, site.area.region.operation.customerBU.customer.customerId, app.constants.assessmentProperties.site, false, [
                                0,
                                0,
                                site.area.region.operation.customerBU.customer.customerId,
                                site.area.region.operation.customerBU.customerBUId,
                                site.area.region.operation.operationId,
                                site.area.region.regionId,
                                site.area.areaId
                            ]));
                        }
                    });
                    filter = new web.directives.Filter(app.constants.assessmentProperties.site, "Filter_Site", optionList, [], false, false, !this.isCustomerPortalView);
                    this.filterList.push(filter);
                    var selectedAssessmentTypeId = null;
                    if (this.$stateParams["assessmentTypeId"])
                        selectedAssessmentTypeId = parseInt(this.$stateParams["assessmentTypeId"]);
                    else
                        selectedAssessmentTypeId = this.role == 'Welfare' ? 0 : null;
                    var identifiers = selectedAssessmentTypeId ? _.filter(this.datacontext.getAssessmentIdentifier(), function (identifier) { return identifier.assessmentTypeId == selectedAssessmentTypeId; }) : this.datacontext.getAssessmentIdentifier();
                    optionList = new Array();
                    angular.forEach(identifiers, function (identifier) {
                        optionList.push(new web.model.DropdownOption(identifier.uniqueId, identifier.uniqueId, identifier.siteId, app.constants.assessmentProperties.assessmentIdentifier, false));
                    });
                    filter = new web.directives.Filter(app.constants.assessmentProperties.assessmentIdentifier, "Filter_Identifier", optionList, [], false, false);
                    this.filterList.push(filter);
                    var visitTypes = selectedAssessmentTypeId ? null : this.datacontext.getAttributeMetadataEnum("VisitType");
                    optionList = new Array();
                    angular.forEach(visitTypes, function (vt) {
                        if (!(_this.isCustomerPortalView && vt["text"] === 'VisitType_Risk_Assessment'))
                            optionList.push(new web.model.DropdownOption(app.common.utils.localizeEnumText(vt, _this.$translate.use().toLowerCase()), vt.value, 0, app.constants.assessmentProperties.visitType, false));
                    });
                    filter = new web.directives.Filter(app.constants.assessmentProperties.visitType, "Filter_VisitType", optionList, [], false, false);
                    this.filterList.push(filter);
                    if (!this.isCustomerPortalView) {
                        var representatives = this.datacontext.getNahRepresentatives(0, true);
                        optionList = new Array();
                        angular.forEach(representatives, function (representative) {
                            optionList.push(new web.model.DropdownOption(representative.fullName, representative.vetUserId, 0, app.constants.assessmentProperties.representative, false));
                        });
                        filter = new web.directives.Filter(app.constants.assessmentProperties.representative, "Filter_Representative", optionList, [], false, false);
                        this.filterList.push(filter);
                    }
                    var assessmentTypesGroups = this.datacontext.getAssessmentTypeGroups();
                    if (assessmentTypesGroups != null && assessmentTypesGroups.length > 0) {
                        optionList = new Array();
                        var selectedAGTId = null;
                        if (!!this.$stateParams["assessmentGroupTypeId"])
                            selectedAGTId = this.$stateParams["assessmentGroupTypeId"];
                        // console.log(
                        //   "selectedAssessmentGroupTypeId",
                        //   selectedAssessmentGroupTypeId
                        // );
                        angular.forEach(assessmentTypesGroups, function (assessmentTypesGroup) {
                            // console.log("assessmentTypesGroup", assessmentTypesGroup);
                            optionList.push(new web.model.DropdownOption(app.localizer.resource[assessmentTypesGroup.dictionary.name], assessmentTypesGroup.assessmentTypeGroupId, 0, app.constants.assessmentTypeProperties.assessmentTypeGroup, assessmentTypesGroup.assessmentTypeGroupId === selectedAGTId));
                        });
                        filter = new web.directives.Filter(app.constants.assessmentTypeProperties.assessmentTypeGroup, "Assessment", optionList, [], false, false, true);
                    }
                    var assessmentTypes = selectedAssessmentTypeId ? _.filter(this.datacontext.getAssessmentTypes(), function (assessmentType) { return assessmentType.assessmentTypeId == selectedAssessmentTypeId; }) : this.datacontext.getAssessmentTypes();
                    optionList = new Array();
                    angular.forEach(assessmentTypes, function (assessmentType) {
                        if (!_this.isCustomerPortalView || (_this.isCustomerPortalView && assessmentType.showInCustomerPortal)) {
                            optionList.push(new web.model.DropdownOption(app.localizer.resource[assessmentType.dictionary.name], assessmentType.assessmentTypeId, assessmentType.assessmentTypeGroupId, app.constants.assessmentProperties.assessmentType, false));
                        }
                    });
                    var selectedAssessmentTypeArrays = [];
                    if (!app.common.utils.isNullOrUndefined(selectedAssessmentTypeId)) {
                        selectedAssessmentTypeArrays.push(selectedAssessmentTypeId);
                    }
                    filter = new web.directives.Filter(app.constants.assessmentProperties.assessmentType, "Filter_Type", optionList, selectedAssessmentTypeArrays, false, false);
                    this.filterList.push(filter);
                    var followUps = this.datacontext.getAssessmentFollowUps();
                    optionList = new Array();
                    angular.forEach(followUps, function (followUp) {
                        optionList.push(new web.model.DropdownOption(app.localizer.resource[followUp.dictionary.name], followUp.followUpStatusId, 0, app.constants.assessmentProperties.followUp, false));
                    });
                    filter = new web.directives.Filter(app.constants.assessmentProperties.followUp, "Filter_FollowUp", optionList, [], false, false);
                    this.filterList.push(filter);
                    if (this.isCustomerPortalView) {
                        var siteFishGroups = this.datacontext.getFishgroups();
                        optionList = new Array();
                        angular.forEach(siteFishGroups, function (siteFishGroup) {
                            optionList.push(new web.model.DropdownOption(siteFishGroup.fishgroupName, siteFishGroup.fishgroupId, siteFishGroup.siteId, app.constants.assessmentProperties.siteFishgroup, false));
                        });
                        filter = new web.directives.Filter(app.constants.assessmentProperties.siteFishgroup, "Filter_Fishgroup", optionList, [], false, false);
                        this.filterList.push(filter);
                    }
                };
                AssessmentListController.prototype.showAlert = function (ev) {
                    this.modalService.show("modules/assessment/assessment.html", app.constants.dialogSize.defaultSize, "", this.$scope, function () { }, {});
                };
                AssessmentListController.prototype.saveToggleLock = function (assessment, comment) {
                    var _this = this;
                    var auditType = app.constants.auditTypes.Lock;
                    var isLocking = !assessment.isLocked;
                    if (assessment.isLocked) {
                        auditType = app.constants.auditTypes.Unlock;
                    }
                    this.datacontext.createAudit({
                        auditDate: moment(),
                        tableName: app.constants.entityNames.assessment,
                        userId: this.authenticationService.credentialsCurrentUserGet().UserId,
                        auditingTypeId: auditType,
                        key: assessment.assessmentId,
                        comment: comment
                    });
                    return this.datacontext.save().then(function (result) {
                        assessment.isLocked = !assessment.isLocked;
                        _this.$rootScope.$broadcast(app.constants.broadcastEventNames.refreshMenus);
                        if (isLocking) {
                            _this.generateAndStorePdf(result, assessment.assessmentId, assessment.assessmentTypeId);
                        }
                    });
                };
                AssessmentListController.prototype.saveToggleFollowUp = function (assessment, val) {
                    assessment.followUpStatusId = val;
                    return this.datacontext.save();
                };
                AssessmentListController.prototype.generateAndStorePdf = function (result, assessmentId, assessmentTypeId) {
                    //Get new auditId
                    var audit = _.find(result.entities, (function (e) { return e.auditId > 0; }));
                    var auditId = audit.auditId;
                    //Get language id from culture
                    var languageId = this.datacontext.getLanguageId(this.appLocalStorage.applicationStatusGet().translationsCulture);
                    //Get title from assessment type
                    var title = this.datacontext.getAssessmentTypeName(assessmentTypeId);
                    this.datacontext.saveLockedAssessmentPdf(assessmentId, languageId, title, auditId);
                };
                AssessmentListController.prototype.openAuditPdf = function (assessment, auditId) {
                    var title = this.datacontext.getAssessmentTypeName(assessment.assessmentTypeId);
                    this.modalService.show("modules/report/report.html", app.constants.dialogSize.large, "", this.$scope, function () { }, new app.web.services.ReportData(assessment.assessmentId, app.enums.entityType.Assessment, title, false, title + ".pdf", auditId));
                };
                AssessmentListController.$inject = [
                    "$rootScope",
                    "$scope",
                    "$stateParams",
                    "$q",
                    "$interval",
                    "$timeout",
                    "$window",
                    "$translate",
                    "FileSaver",
                    "appLocalStorage",
                    "modalService",
                    "assessmentDatacontext",
                    "upcomingEventDatacontext",
                    "navigationService",
                    "apiEndpointService",
                    "authenticationService",
                    "excelService",
                    "$locale"
                ];
                return AssessmentListController;
            })();
            controllers.AssessmentListController = AssessmentListController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("AssessmentListController", [
    "$rootScope",
    "$scope",
    "$stateParams",
    "$q",
    "$interval",
    "$timeout",
    "$window",
    "$translate",
    "FileSaver",
    "appLocalStorage",
    "modalService",
    "assessmentDatacontext",
    "upcomingEventDatacontext",
    "navigationService",
    "apiEndpointService",
    "authenticationService",
    "excelService",
    "$locale"
]);

var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            function getLabTestListHeader(injectInstance) {
                return [{
                        name: "",
                        text: "",
                        class: "fixed-width-4",
                        html: false,
                        propertyName: "",
                        sort: app.constants.sortTypes.notSortable
                    },
                    {
                        name: "Date",
                        text: app.localizer.resource.Date,
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: false,
                        propertyName: "assessmentDate",
                        sort: app.constants.sortTypes.descending
                    },
                    {
                        name: "Customer",
                        text: app.localizer.resource.Customer,
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: false,
                        propertyName: "customerName",
                        textOverflow: true,
                        sort: app.constants.sortTypes.none
                    },
                    {
                        name: "Site",
                        text: app.localizer.resource.Site,
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: true,
                        propertyName: "siteName",
                        selectSite: function (customerId, siteId) {
                            return injectInstance.selectSite(customerId, siteId);
                        },
                        textOverflow: true,
                        sort: app.constants.sortTypes.none
                    },
                    {
                        name: "LabTest_Unit",
                        text: app.localizer.resource.LabTest_Unit,
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: false,
                        propertyName: "LabTest_Unit",
                        sort: app.constants.sortTypes.descending
                    },
                    {
                        name: "LabTest_Count",
                        text: app.localizer.resource.LabTest_Count,
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: false,
                        propertyName: "LabTest_Count",
                        sort: app.constants.sortTypes.descending
                    },
                    {
                        name: "LabTest_Weight",
                        text: app.localizer.resource.LabTest_Weight,
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: false,
                        propertyName: "LabTest_Weight",
                        sort: app.constants.sortTypes.descending
                    },
                    {
                        name: "LabTest_ExternalLaboratory",
                        text: app.localizer.resource.LabTest_ExternalLaboratory,
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: false,
                        propertyName: "LabTest_ExternalLaboratory",
                        sort: app.constants.sortTypes.descending
                    },
                    {
                        name: "LabTest_Diagnosis",
                        text: app.localizer.resource.LabTest_Diagnosis,
                        smColSpan: 2,
                        mdColSpan: 2,
                        html: false,
                        propertyName: "LabTest_Diagnosis",
                        sort: app.constants.sortTypes.descending
                    },
                    {
                        name: "Samples",
                        text: app.localizer.resource.NumberOfSamples,
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: false,
                        propertyName: "samples",
                        sort: app.constants.sortTypes.descending
                    },
                    {
                        name: "Options",
                        text: "",
                        class: "pull-right text-center",
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: false,
                        propertyName: "",
                        confirm: function (assessment) {
                            injectInstance.delete(assessment);
                        },
                        hide: function (assessment) {
                            injectInstance.hide(assessment);
                        },
                        toggleLocking: function (assessment, comment) {
                            injectInstance.saveToggleLock(assessment, comment);
                        },
                        toggleFollowUp: function (assessment, val) {
                            injectInstance.saveToggleFollowUp(assessment, val);
                        },
                        sort: app.constants.sortTypes.notSortable
                    }
                ];
            }
            controllers.getLabTestListHeader = getLabTestListHeader;
            function getAssessmentListHeader(injectInstance) {
                return [{
                        name: "",
                        text: "",
                        class: "fixed-width-4",
                        html: false,
                        propertyName: "",
                        sort: app.constants.sortTypes.notSortable
                    },
                    {
                        name: "Date",
                        text: app.localizer.resource.Date,
                        class: "fixed-width-8",
                        html: false,
                        propertyName: "assessmentDate",
                        sort: app.constants.sortTypes.descending
                    },
                    {
                        name: "Type",
                        text: app.localizer.resource.Type,
                        class: "fixed-width-6",
                        html: false,
                        propertyName: "assessmentTypeName",
                        textOverflow: true,
                        sort: app.constants.sortTypes.none
                    },
                    {
                        name: "VisitType",
                        text: app.localizer.resource.VisitType,
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: false,
                        propertyName: "visitType",
                        textOverflow: true,
                        sort: app.constants.sortTypes.none
                    },
                    {
                        name: "Customer",
                        text: app.localizer.resource.Customer,
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: false,
                        propertyName: "customerName",
                        textOverflow: true,
                        sort: app.constants.sortTypes.none
                    },
                    {
                        name: "Site",
                        text: app.localizer.resource.Site,
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: true,
                        propertyName: "siteName",
                        selectSite: function (customerId, siteId) {
                            return injectInstance.selectSite(customerId, siteId);
                        },
                        textOverflow: true,
                        sort: app.constants.sortTypes.none
                    },
                    {
                        name: "Identifier",
                        text: app.localizer.resource.Identifier,
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: false,
                        propertyName: "uniqueId",
                        textOverflow: true,
                        sort: app.constants.sortTypes.none
                    },
                    {
                        name: "Site Fishgr.",
                        text: app.localizer.resource.Filter_Fishgroup,
                        smColSpan: 1,
                        mdColSpan: 1,
                        html: false,
                        propertyName: "fishgroupName",
                        textOverflow: true,
                        sort: app.constants.sortTypes.none
                    },
                    {
                        name: "Elanco Repr",
                        text: app.localizer.resource.NAHContact,
                        class: "fixed-width-14",
                        html: false,
                        propertyName: "contactPersonNames",
                        textOverflow: true,
                        sort: app.constants.sortTypes.none
                    },
                    {
                        name: "Follow up",
                        text: app.localizer.resource.Filter_FollowUp,
                        class: "fixed-width-12 text-center",
                        html: true,
                        propertyName: "followUpStatusId",
                        sort: app.constants.sortTypes.none
                    },
                    {
                        name: "Files",
                        text: app.localizer.resource.Files,
                        class: "assessment-list-file-column",
                        html: false,
                        propertyName: "files",
                        textOverflow: true,
                        sort: app.constants.sortTypes.notSortable,
                        openAttachedFile: function (assessmentId, file) {
                            injectInstance.openAttachedFile(assessmentId, file);
                        }
                    },
                    {
                        name: "Options",
                        text: "",
                        class: "pull-right text-center fixed-width-4",
                        html: false,
                        propertyName: "",
                        confirm: function (assessment) {
                            injectInstance.delete(assessment);
                        },
                        hide: function (assessment) {
                            injectInstance.hide(assessment);
                        },
                        toggleLocking: function (assessment, comment) {
                            injectInstance.saveToggleLock(assessment, comment);
                        },
                        toggleFollowUp: function (assessment, val) {
                            injectInstance.saveToggleFollowUp(assessment, val);
                        },
                        sort: app.constants.sortTypes.notSortable
                    }
                ];
            }
            controllers.getAssessmentListHeader = getAssessmentListHeader;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

/// <reference path="../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var AssessmentController = (function (_super) {
                __extends(AssessmentController, _super);
                function AssessmentController($rootScope, _$scope, $filter, _$translate, _$q, _$timeout, fileSaver, _env, _datacontext, 
                    //private sharedContext: app.web.services.ISharedDatacontext,
                    _wizardHandler, _pythonHandler, modalService, _appLocalStorage, apiEndpointService, authenticationService, busyIndicator, navigationService, $window) {
                    var _this = this;
                    _super.call(this, _$scope, _$translate, _$q, _$timeout, _wizardHandler, _pythonHandler, _appLocalStorage, _datacontext, _env, busyIndicator);
                    this.$rootScope = $rootScope;
                    this.$filter = $filter;
                    this.fileSaver = fileSaver;
                    this.modalService = modalService;
                    this.apiEndpointService = apiEndpointService;
                    this.authenticationService = authenticationService;
                    this.navigationService = navigationService;
                    this.isSaving = false;
                    this.isLocked = false;
                    this.expand = false;
                    this.$rootScope.$on(app.constants.broadcastEventNames.idleTimeStart, function () {
                        _this.save(app.constants.assessmentStatus.DRAFT);
                    });
                    this.deviceType = app.constants.deviceType.WebApp;
                    this.assessmentParamaters = _$scope.assessmentWizardData ? _$scope.assessmentWizardData : _$scope.ngDialogData;
                    if (!this.assessmentParamaters)
                        return;
                    this.customerKey = this.navigationService.customerKey;
                    this.readonly = this.assessmentParamaters.readonly;
                    this.editMode = this.assessmentParamaters.assessmentOperation === app.constants.operation.EDIT;
                    this.eventDateRange = {
                        startDate: moment(),
                        endDate: moment()
                    };
                    this.confirm = { title: app.localizer.resource.ConfirmCancelTitle, message: app.localizer.resource.ConfirmCancelMessage };
                    this.$timeout(function () {
                        if (!_this.isInitialized) {
                            _this.isInitialized = true;
                            _this.$scope.$on(app.constants.broadcastEventNames.goToStep, function (event, data) {
                                _this.changeLabelAndGo(data.direction, data.toStepIndex);
                            });
                            _this.loadAssessment();
                            _this.isCanceling = false;
                        }
                    });
                    angular.element($window).bind('resize', function () {
                        _this.changeMultiRowHeight();
                    });
                }
                AssessmentController.prototype.isCustomerPortalView = function () {
                    return this.authenticationService.isCustomerUser();
                };
                AssessmentController.prototype.loadAssessment = function () {
                    var _this = this;
                    if (!this.assessmentParamaters)
                        return;
                    if (this.assessmentParamaters.assessmentOperation === app.constants.operation.NEW) {
                        this.assessment = this.datacontext.createAssessment({
                            assessmentDate: moment().startOf('day').toDate(),
                            assessmentTypeId: this.assessmentParamaters.assessmentTypeId,
                            siteId: this.assessmentParamaters.siteId,
                            customerId: this.assessmentParamaters.customerId,
                            assessmentStatus: app.constants.assessmentStatus.DRAFT,
                            isDraft: true,
                            visibility: true,
                            followUpStatusId: this.getDefaultFollowupStatus(this.assessmentParamaters.assessmentTypeId),
                            deviceTypeId: app.constants.deviceType.WebApp,
                            contactPersonId: this.assessmentParamaters.elancoRepId,
                            fishgroupId: this.assessmentParamaters.fishgroupId
                        });
                        this.loadFarmerData(this.assessmentParamaters.assessmentOperation);
                        this.assessment.assessmentSaveStatus = this.$translate.instant('AssessmentNotSaved');
                        this.assessment.excludeFarmerData = this.assessment.site ? app.common.utils.isNullOrUndefined(this.assessment.site.excludeFarmerDataDefault) ? 0 : this.assessment.site.excludeFarmerDataDefault : 0;
                        this.assessment.isFarmerIntegrationOn = this.isFarmerIntegrationOn;
                        this.title = this.$translate.instant('New') + " " + this.$translate.instant('Assessment').toLowerCase() + " - " + this.$translate.instant(this.assessment.assessmentType.dictionary.name);
                        //Set assessmentSite on discriminator
                        if (!_.isEmpty(this.assessmentParamaters.elancoRepId)) {
                            var nahRepr = _.find(this.assessment.templateRegistrations, function (item) {
                                return item.attribute.dictionary.name === "NAHRepresentitive";
                            });
                            if (nahRepr) {
                                nahRepr.textValue = this.assessmentParamaters.elancoRepId;
                                nahRepr.focusValue = this.assessmentParamaters.elancoRepId;
                            }
                        }
                        this.assessment.initVariables();
                        this.assessment.vaccinationSiteId = this.assessmentParamaters.siteId;
                        this.prepareSubscribtionsAndInits();
                    }
                    else {
                        return this.datacontext.getTemplateRegistrations(this.assessmentParamaters.assessmentId, true).then(function () {
                            _this.assessment = _this.datacontext.getAssessment(_this.assessmentParamaters.assessmentId);
                            _this.assessment.isFarmerIntegrationOn = _this.isFarmerIntegrationOn;
                            _this.assessment.initVariables();
                            _this.loadFarmerData(_this.assessmentParamaters.assessmentOperation);
                            _this.title = _this.$translate.instant('Edit') + " " + _this.$translate.instant('Assessment').toLowerCase() + " - " + _this.$translate.instant(_this.assessment.assessmentType.dictionary.name);
                            if (_this.assessmentParamaters.jumbToStep > 0 || _this.assessment.draftStepIndex != null) {
                                _this.$timeout(function () {
                                    _this.changeLabelAndGo('jump', _this.assessmentParamaters.jumbToStep > 0 ? _this.assessmentParamaters.jumbToStep : _this.assessment.draftStepIndex, false, true, _this.assessmentParamaters.jumpToRow);
                                }, 1000);
                            }
                            else {
                                _this.$timeout(function () {
                                    _this.refreshTabIndexLoop = !_this.refreshTabIndexLoop;
                                }, 500);
                            }
                            _this.prepareSubscribtionsAndInits();
                            _this.markAssessmentAsRead();
                        });
                    }
                    this.lastButtonText = this.assessment.assessmentType.sendEmail
                        ? app.localizer.resource.Action_Save_And_Preview_Email
                        : app.localizer.resource.Action_Save_And_Exit;
                };
                AssessmentController.prototype.markAssessmentAsRead = function () {
                    if (!this.authenticationService.isCustomerUser()) {
                        return;
                    }
                    var userAssessment = this.assessment.userAssessments[0];
                    if (userAssessment == null || !userAssessment.hasRead) {
                        this.datacontext.createUserAssessment({
                            userId: this.authenticationService.credentialsCurrentUserGet().UserId,
                            assessmentId: this.assessmentParamaters.assessmentId,
                            hasHidden: false,
                            hasRead: true
                        });
                        this.datacontext.save();
                    }
                };
                AssessmentController.prototype.prepareSubscribtionsAndInits = function () {
                    var _this = this;
                    if (this.assessment.templateGroups)
                        this.assessment.templateGroups.forEach(function (tg) {
                            tg["revisit"] = false;
                        });
                    this.UpdateSelectionChanges([
                        { key: 'Customer', val: this.assessment.customerId },
                        { key: 'Site', val: this.assessment.siteId },
                        { key: 'ProcessingPlant', val: this.assessment.siteId },
                        { key: 'ExcludeFarmerData', val: this.assessment.excludeFarmerData }
                    ]);
                    this.businessRuleExpressions = this.assessment.assessmentType.businessRuleExpressions;
                    this.subscribeExpressionCalculations(this.assessment.templateRegistrations);
                    this.initOffsetsOnRowIndexes(this.assessment.templateGroups);
                    this.$timeout(function () {
                        _.each(_.filter(_this.assessment.templateGroups, { hasTotals: true }), function (templateGroup) {
                            _this.updateTotalsAll(templateGroup.template);
                        });
                        _this.busyIndicator.hide();
                    });
                };
                AssessmentController.prototype.UpdateSelectionChanges = function (attributeKeyVal) {
                    var _this = this;
                    _.forEach(attributeKeyVal, function (keyVal) {
                        var templateItem;
                        _.forEach(_this.assessment.templateGroups, function (tg) {
                            if (!templateItem) {
                                templateItem = _.find(tg.template.templateItems, function (ti) {
                                    return ti.attributeDictionary.name === keyVal.key;
                                });
                                if (templateItem)
                                    _this.onSelectionChange(templateItem, keyVal.val);
                            }
                        });
                    });
                };
                AssessmentController.prototype.getImageUploadHeaders = function () {
                    return this.authenticationService.getValidToken().then(function (token) {
                        return { "Authorization": 'Bearer ' + token };
                    });
                };
                AssessmentController.prototype.getImageUploadTarget = function () {
                    return this.apiEndpointService.getUploadImageEndPoint();
                };
                AssessmentController.prototype.getAttachementUploadTarget = function () {
                    return this.apiEndpointService.getUploadAssessmentFileEndPoint();
                };
                AssessmentController.prototype.getImageOnDemand = function (assessmentId, filename) {
                    return this.datacontext.getImageOnDemand(assessmentId, filename);
                };
                AssessmentController.prototype.openAttachedFile = function (assessmentId, filename) {
                    var _this = this;
                    this.datacontext.openAttachedFile(assessmentId, filename)
                        .then(function (result) {
                        _this.fileSaver.saveAs(new Blob([result.data]), filename);
                    });
                    ;
                };
                AssessmentController.prototype.toggleRows = function (templateGroup) {
                    var _this = this;
                    this.expand = !this.expand;
                    this.$timeout(function () {
                        _.forEach(templateGroup.rows, function (row) {
                            row.open = _this.expand;
                        });
                    });
                };
                ;
                AssessmentController.prototype.fullScreenMode = function (state) {
                    this.fullScreen = state;
                };
                ;
                AssessmentController.prototype.deleteRow = function (rowIndex, templateGroup) {
                    _super.prototype.deleteRow.call(this, parseInt(rowIndex), templateGroup);
                };
                AssessmentController.prototype.addRow = function (templateGroup) {
                    _super.prototype.addRow.call(this, templateGroup);
                };
                AssessmentController.prototype.addFishGroup = function (attributeName, optionSelection, templateRegistration) {
                    var _this = this;
                    this.modalService.showConfirm('modules/fishgroup/fishgroup.html', app.constants.dialogSize.small, '', null, function () { }, new web.services.FishgroupData(attributeName === 'Fishgroup' ? this.assessment.siteId : this.assessment.freshwaterSiteId)).then(function (fishgroup) {
                        var fishgroupId = attributeName === 'Fishgroup' ? fishgroup.fishgroupId : fishgroup.fishgroupId.toString();
                        var selectedfg = new app.model.scopeModel.OptionItem(fishgroup.fishgroupName, fishgroupId);
                        optionSelection.collection.push(selectedfg);
                        optionSelection.selectedOption = selectedfg;
                        if (templateRegistration)
                            templateRegistration.focusValue = fishgroup.fishgroupId.toString();
                        _this.assessment[_this.getSelectionProperty(attributeName)] = fishgroupId;
                    });
                };
                AssessmentController.prototype.showFlagInformation = function () {
                    this.modalService.showConfirm('modules/assessment/flagInformation.html', app.constants.dialogSize.defaultSize, '', this.$scope, function () { }, null);
                };
                AssessmentController.prototype.getManipulatedRowIndex = function (rowIndex) {
                    var _this = this;
                    var offset = _.find(this.offsetsOnRowIndexes, function (offsetRow) {
                        return offsetRow.templateId === _this.getCurrentTemplateId() && offsetRow.rowIndex === parseInt(rowIndex);
                    });
                    return offset ? offset.rowIndex + offset.offset : rowIndex;
                };
                AssessmentController.prototype.multiRowHasError = function (templateItem, rowIndex) {
                    if (rowIndex === void 0) { rowIndex = null; }
                    if (templateItem.template.multiRows && rowIndex) {
                        return _.some(this.hasValidationErrors, function (templateRegistation) {
                            return templateRegistation.templateId === templateItem.templateId && templateRegistation.attributeId === templateItem.attributeId && templateRegistation.rowIndex === parseInt(rowIndex);
                        });
                    }
                    else
                        return _.some(this.hasValidationErrors, function (templateRegistation) {
                            return templateRegistation.templateId === templateItem.templateId && templateRegistation.attributeId === templateItem.attributeId;
                        });
                };
                AssessmentController.prototype.isOnline = function () {
                    return true;
                };
                AssessmentController.prototype.previewReport = function () {
                    var _this = this;
                    if (this.assessment.isLocked) {
                        this.datacontext
                            .getAuditDtos("Assessment", this.assessment.assessmentId, [4])
                            .then(function (lockedAudits) {
                            var auditId = null;
                            if (_this.assessment.isLocked && lockedAudits.length > 0) {
                                auditId = lockedAudits[0].auditId;
                            }
                            _this.openReport(auditId);
                        });
                    }
                    else {
                        this.openReport(null);
                    }
                };
                AssessmentController.prototype.openReport = function (auditId) {
                    this.modalService.show("modules/report/report.html", app.constants.dialogSize.large, "", null, function () { }, new web.services.ReportData(this.assessment.assessmentId, app.enums.entityType.Assessment, app.localizer.resource[this.assessment.assessmentType.dictionary.name], auditId == null, this.assessment.uniqueId, auditId, this.authenticationService.credentialsCurrentUserGet().UserId));
                };
                AssessmentController.prototype.save = function (mode, isSendingMail) {
                    var _this = this;
                    if (isSendingMail === void 0) { isSendingMail = true; }
                    this.$timeout(function () {
                        _this.applyRowIndexOffsets(); //fix row index before save
                        _this.assessment.assessmentSaveStatus = _this.$translate.instant('AssessmentLastSaved');
                        _this.isSaving = true;
                        switch (mode) {
                            case app.constants.assessmentStatus.DRAFT:
                                if (_this.hasChanges()) {
                                    _this.assessment.lastSaved = app.localizer.resource.PleaseWait;
                                    _this.assessment.allowValidation = false;
                                    _this.assessment.draftStepIndex = _this.wizardHandler.wizard().getCurrentStepIndex();
                                    if (_this.validStep(_this.getTemplateRegistrationsForTemplate(_this.getCurrentTemplateId())))
                                        _this.datacontext.save(_this.assessment).then(function () {
                                            _this.assessment.allowValidation = true;
                                            //this.$rootScope.$broadcast(constants.broadcastEventNames.assessmentRegistrationCompleted);
                                            _this.assessment.lastSaved = moment(new Date()).toDate();
                                            _this.isSaving = false;
                                            _this.$timeout(function () {
                                                _this.refreshTabIndexLoop = !_this.refreshTabIndexLoop;
                                            });
                                        });
                                    else {
                                        _this.assessment.lastSaved = app.localizer.resource.PleaseWait;
                                        _this.isSaving = true;
                                    }
                                }
                                else {
                                    //this.assessment.lastSaved = localizer.resource.NoChanges;
                                    _this.isSaving = false;
                                }
                                _this.setLockStatus();
                                break;
                            case app.constants.assessmentStatus.COMPLETED:
                                _this.assessment.lastSaved = app.localizer.resource.PleaseWait;
                                if (!_this.validateAssessment())
                                    return;
                                _this.busyIndicator.show();
                                _this.assessment.isDraft = false;
                                _this.assessment.allowValidation = true;
                                _this.assessment.draftStepIndex = null;
                                _this.assessment.assessmentStatus = app.constants.assessmentStatus.COMPLETED;
                                _this.datacontext.save(_this.assessment).then(function () {
                                    _this.busyIndicator.hide();
                                    _this.assessment.lastSaved = moment(new Date()).toDate();
                                    _this.isSaving = false;
                                    _this.setLockStatus().then(function (result) {
                                        if (_this.assessment.assessmentType.sendEmail && isSendingMail) {
                                            _this.modalService.show('modules/mail/mail.html', app.constants.dialogSize.defaultSize, '', _this.$scope, function () {
                                                //postponed to next digest cycle
                                                _this.$timeout(function () {
                                                    var parent = _this.$scope.$parent;
                                                    parent.closeThisDialog();
                                                    _this.informMainAndDestroy();
                                                });
                                            }, new web.services.MailData(_this.assessment.siteId, _this.assessment.assessmentId, "Assessment", _this.assessment.assessmentTypeId, -1, _this.$translate.instant(_this.assessment["visitType"])));
                                        }
                                        else {
                                            if (_this.isLocked) {
                                                var title = _this.datacontext.getAssessmentTypeName(_this.assessment.assessmentTypeId);
                                                var languageId = _this.datacontext.getLanguageId(_this.appLocalStorage.applicationStatusGet().translationsCulture);
                                                _this.datacontext.saveLockedAssessmentPdf(_this.assessment.assessmentId, languageId, title, _this.lockAuditId);
                                            }
                                            _this.informMainAndDestroy();
                                            _this.modalService.close();
                                        }
                                    });
                                });
                                break;
                        }
                    });
                };
                AssessmentController.prototype.setLockStatus = function (regenReport) {
                    var _this = this;
                    if (regenReport === void 0) { regenReport = false; }
                    if (this.assessment.isLocked == this.isLocked)
                        return this.$q.resolve();
                    var auditType = this.isLocked ? app.constants.auditTypes.Lock : app.constants.auditTypes.Unlock;
                    this.datacontext.createAudit({
                        auditDate: moment(),
                        tableName: app.constants.entityNames.assessment,
                        userId: this.authenticationService.credentialsCurrentUserGet().UserId,
                        auditingTypeId: auditType,
                        key: this.assessment.assessmentId,
                        comment: null
                    });
                    return this.datacontext.save().then(function (result) {
                        _this.assessment.isLocked = _this.isLocked;
                        var audit = _.find(result.entities, (function (e) { return e.auditId > 0; }));
                        _this.lockAuditId = audit.auditId;
                        if (regenReport) {
                            var title = _this.datacontext.getAssessmentTypeName(_this.assessment.assessmentTypeId);
                            var languageId = _this.datacontext.getLanguageId(_this.appLocalStorage.applicationStatusGet().translationsCulture);
                            _this.datacontext.saveLockedAssessmentPdf(_this.assessment.assessmentId, languageId, title, _this.lockAuditId);
                        }
                        return result;
                    });
                };
                AssessmentController.prototype.validateAssessment = function () {
                    var _this = this;
                    _.forEach(this.assessment.templateGroups, function (tg) {
                        var templateRegistrations = _this.getTemplateRegistrationsForTemplate(tg.templateId);
                        tg.hasErrors = _this.validateTemplateRegistations(tg, templateRegistrations).length > 0;
                    });
                    return !_.some(this.assessment.templateGroups, { hasErrors: true });
                };
                AssessmentController.prototype.hasChanges = function () {
                    return this.datacontext.hasChanges();
                };
                AssessmentController.prototype.prepareCloseThisDialog = function () {
                    this.datacontext.rejectChanges(this.assessment);
                    //_.forEach(this.watchCollection, (watch) => {
                    //    watch();
                    //});
                    this.informMainAndDestroy();
                    return true;
                };
                AssessmentController.prototype.informMainAndDestroy = function () {
                    this.$rootScope.$broadcast(app.constants.broadcastEventNames.registrationCompleted);
                    this.$scope.$destroy();
                };
                AssessmentController.prototype.changeMultiRowHeight = function () {
                    var _this = this;
                    var currentTemplateId = this.getCurrentTemplateId();
                    this.multiRowHeight = "auto";
                    if (this.assessment["assessmentType"]
                        && this.assessment["assessmentType"]["templateGroups"]) {
                        var templateGroups = this.assessment["assessmentType"]["templateGroups"];
                        var currentTemplates = templateGroups.filter(function (tp) {
                            return tp["templateId"] === currentTemplateId;
                        });
                        if (app.common.utils.isNullOrUndefined(currentTemplates) || currentTemplates.length < 1)
                            return;
                        var needChangeHeightTemplate = ["Visit_Inventory", "Visit_Mortality", "Visit_LiceCounting", "Visit_Treatments", "Visit_Vaccination", "Visit_Environmental", "Visit_Files", "Visit_Pictures"];
                        var currentTemplate = currentTemplates[0];
                        if (currentTemplate["template"]
                            && currentTemplate["template"]["dictionary"]
                            && currentTemplate["template"]["dictionary"]["name"]
                            && needChangeHeightTemplate.indexOf(currentTemplate["template"]["dictionary"]["name"]) > -1) {
                            var stepElementsContainer = angular.element(document).find(".steps")[0];
                            var stepElements = stepElementsContainer.children;
                            setTimeout(function () {
                                var currentWizardStep = _this.wizardHandler.wizard().getCurrentStepIndex();
                                currentWizardStep = currentWizardStep < 0 ? 0 : currentWizardStep;
                                var currentTemplateElement = stepElements[currentWizardStep];
                                var sectionElement = angular.element(currentTemplateElement).find("section");
                                if (currentTemplateElement && sectionElement) {
                                    var sectionElementHeight = angular.element(sectionElement).height();
                                    var sectionChildren = angular.element(sectionElement).children();
                                    if (sectionChildren && sectionChildren.length > 0) {
                                        var sectionChildrenHeight = [];
                                        angular.forEach(sectionChildren, function (sc) {
                                            sectionChildrenHeight.push(angular.element(sc).height());
                                        });
                                        var sum = 0;
                                        sectionChildrenHeight.forEach(function (sch) {
                                            sum = sum + sch;
                                        });
                                        var temp = sectionElementHeight - sum;
                                        if (temp > 0)
                                            _this.multiRowHeight = "500px";
                                    }
                                }
                            }, 10);
                        }
                    }
                };
                AssessmentController.prototype.onChangeLabelAndGo = function (direction, toStepIndex, skipThis) {
                    this.expand = false;
                    this.changeMultiRowHeight();
                };
                AssessmentController.$inject = [
                    '$rootScope',
                    '$scope',
                    '$filter',
                    '$translate',
                    '$q',
                    '$timeout',
                    'FileSaver',
                    'ENV',
                    'assessmentDatacontext',
                    'WizardHandler',
                    'pythonHandler',
                    'modalService',
                    'appLocalStorage',
                    'apiEndpointService',
                    'authenticationService',
                    'busyIndicator',
                    'navigationService',
                    '$window'];
                return AssessmentController;
            })(app.common.base.controllers.AssessmentController);
            controllers.AssessmentController = AssessmentController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("AssessmentController", [
    '$rootScope',
    '$scope',
    '$filter',
    '$translate',
    '$q',
    '$timeout',
    'FileSaver',
    'ENV',
    'assessmentDatacontext',
    'WizardHandler',
    'pythonHandler',
    'modalService',
    'appLocalStorage',
    'apiEndpointService',
    'authenticationService',
    'busyIndicator',
    'navigationService',
    '$window'
]);

var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var AccessControlController = (function () {
                function AccessControlController($rootScope, $scope, $q, datacontext, modalService) {
                    var _this = this;
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.$q = $q;
                    this.datacontext = datacontext;
                    this.modalService = modalService;
                    this.headerText = 'Access Control';
                    this.headers = [
                        {
                            name: 'Category', text: app.localizer.resource.Category, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'category'
                        },
                        {
                            name: 'Name', text: app.localizer.resource.Name, smColSpan: 3, mdColSpan: 3, html: false, propertyName: 'name'
                        },
                        {
                            name: 'None', text: app.localizer.resource.None, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'none'
                        },
                        /*{
                            name: 'Read', text: localizer.resource.Read, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'read'
                        },*/
                        {
                            name: 'Full', text: app.localizer.resource.Full, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'assessmentTypeName'
                        }];
                    this.utils = new app.web.controllers.AccessControlUtils();
                    this.newRole = null;
                    this.injectedScope = {
                        permissionChanged: function (navigationUrlId, subOption) {
                            if (subOption === void 0) { subOption = null; }
                            return _this.permissionChanged(navigationUrlId, subOption);
                        }
                    };
                    this.initialize();
                }
                AccessControlController.prototype.initialize = function (setDefault) {
                    var _this = this;
                    if (setDefault === void 0) { setDefault = false; }
                    this.tabs = [];
                    this.datacontext.getSecurityLevels().then(function (data) {
                        _this.securityLevels = data;
                        _this.tabs = _this.utils.declareTabs(data);
                    }).then(function () {
                        return _this.datacontext.getNavigationOptions().then(function (data) {
                            _this.navigationOptions = data[1];
                            var distinctList = _.uniqBy(_this.navigationOptions, 'navigationURLId');
                            _.forEach(_this.tabs, function (tab) {
                                _.forEach(distinctList, function (navigationOption) {
                                    if (navigationOption.navigationMenu.dictionary.name != 'None') {
                                        tab.content.push({
                                            category: navigationOption.navigationMenu.dictionary.name,
                                            name: navigationOption.navigationURL.dictionary.name,
                                            navigationURLId: navigationOption.navigationURLId,
                                            checked: _this.getSecurityAccessPermission(navigationOption.securityLevelBitMask, tab.id),
                                            role: tab.id,
                                            showDetail: false,
                                            navOptionId: navigationOption.
                                                navigationOptionId,
                                            hasDetails: navigationOption.navigationSubOptions.length > 0,
                                            navigationSubOptions: _.map(navigationOption.navigationSubOptions, function (navigationSubOption) {
                                                return {
                                                    name: navigationSubOption.dictionary.name,
                                                    checked: _this.getSecurityAccessPermission(navigationSubOption.securityLevelBitMask, tab.id)
                                                };
                                            })
                                        });
                                    }
                                });
                            });
                            if (setDefault) {
                                var defaultNavOptionList = ['Status', 'LogOff', 'Settings', 'Change Password'];
                                _.forEach(_this.tabs, function (tabitem) {
                                    if (tabitem.id == _this.newRole) {
                                        _.forEach(_.filter(tabitem.content, function (navigationOption) { return _.includes(defaultNavOptionList, navigationOption.name); }), function (navigationOption) {
                                            navigationOption.checked = 2;
                                            _this.permissionChanged(navigationOption.navigationURLId);
                                        });
                                    }
                                });
                            }
                        });
                    });
                };
                AccessControlController.prototype.getSecurityAccessPermission = function (navigationSecurityLevelBitMask, role) {
                    return this.utils.getSecurityAccessPermission(navigationSecurityLevelBitMask, role, this.securityLevels);
                };
                AccessControlController.prototype.loadData = function (tab) {
                    return this.$q.when(tab.content);
                };
                AccessControlController.prototype.addRole = function () {
                    var _this = this;
                    this.modalService.show('modules/access_control/role.new.tpl.html', app.constants.dialogSize.medium, '', this.$scope, function () {
                        _this.initialize(true);
                    }, null);
                };
                AccessControlController.prototype.cancel = function () {
                    this.datacontext.reject();
                    this.modalService.close();
                };
                AccessControlController.prototype.save = function () {
                    var _this = this;
                    this.datacontext.save()
                        .then(function () {
                        _this.modalService.close();
                    })
                        .catch(function (error) {
                        _this.errors = error.entityErrors;
                        return false;
                    });
                };
                AccessControlController.prototype.permissionChanged = function (navigationUrlId, subOption) {
                    if (subOption === void 0) { subOption = null; }
                    return this.utils.permissionChanged(this.tabs, this.navigationOptions, this.securityLevels, navigationUrlId, subOption);
                };
                AccessControlController.$inject = ['$rootScope', '$scope', '$q', 'navigationDatacontext', 'modalService'];
                return AccessControlController;
            })();
            controllers.AccessControlController = AccessControlController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("AccessControlController", ['$rootScope', '$scope', '$q', 'navigationDatacontext', 'modalService']);

var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var RoleNewController = (function () {
                function RoleNewController($rootScope, $scope, $q, datacontext, userManagementDatacontext, modalService) {
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.$q = $q;
                    this.datacontext = datacontext;
                    this.userManagementDatacontext = userManagementDatacontext;
                    this.modalService = modalService;
                    this.headerText = 'AddNewRole';
                    this.initialize();
                }
                RoleNewController.prototype.initialize = function () {
                    var _this = this;
                    this.userManagementDatacontext.getValidRoles(false).then(function (result) {
                        _this.roles = result;
                    });
                };
                RoleNewController.prototype.loadData = function (tab) {
                    //   return this.$q.when(tab.content);
                };
                RoleNewController.prototype.cancel = function () {
                    //this.datacontext.reject();
                    this.userManagementDatacontext.reject();
                    var parent = this.$scope.$parent;
                    parent.closeThisDialog();
                };
                RoleNewController.prototype.validate = function () {
                    var _this = this;
                    if (app.common.utils.isNullOrUndefinedOrEmpty(this.roleName)) {
                        this.errorMessage = app.localizer.resource.RoleNameRequired;
                        return false;
                    }
                    if (!this.roleName.match(/^[0-9a-zA-Z_]+$/)) {
                        this.errorMessage = app.localizer.resource.RoleNameNotValid;
                        return false;
                    }
                    var duplicate = _.some(this.roles, function (role) {
                        return role.name == _this.roleName;
                    });
                    if (duplicate) {
                        this.errorMessage = app.localizer.resource.RoleNameAlreadyUsed;
                        return false;
                    }
                    return true;
                };
                RoleNewController.prototype.hasErrors = function () {
                    if (!this.validate()) {
                        this.hasValidationProblem = true;
                    }
                };
                RoleNewController.prototype.save = function () {
                    var _this = this;
                    if (!this.validate()) {
                        this.hasValidationProblem = true;
                        return;
                    }
                    else {
                        this.datacontext.createSecurityLevel(this.roleName);
                        this.userManagementDatacontext.save().then(function () {
                            var parent = _this.$scope.$parent;
                            parent.$parent.viewModel.newRole = _this.roleName;
                            _this.userManagementDatacontext.createRole(_this.roleName).then(function (updatedRole) {
                                parent.closeThisDialog();
                            });
                        }).catch(function (response) {
                            if (response.data.message === "ValidationErrors") {
                            }
                        });
                    }
                };
                RoleNewController.$inject = ['$rootScope', '$scope', '$q', 'navigationDatacontext', 'userManagementDatacontext', 'modalService'];
                return RoleNewController;
            })();
            controllers.RoleNewController = RoleNewController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("RoleNewController", ['$rootScope', '$scope', '$q', 'navigationDatacontext', 'userManagementDatacontext', 'modalService']);

var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var RolePermissionController = (function () {
                function RolePermissionController($rootScope, $scope, $q, datacontext, modalService) {
                    var _this = this;
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.$q = $q;
                    this.datacontext = datacontext;
                    this.modalService = modalService;
                    this.headerText = 'RolePermission';
                    this.headers = [
                        {
                            name: 'Level', text: app.localizer.resource.Level, smColSpan: 3, mdColSpan: 3, html: false, propertyName: 'level'
                        },
                        {
                            name: 'None', text: app.localizer.resource.None, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'none'
                        },
                        {
                            name: 'Read', text: app.localizer.resource.Read, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'read'
                        },
                        {
                            name: 'Full', text: app.localizer.resource.Full, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'assessmentTypeName'
                        }];
                    this.utils = new app.web.controllers.AccessControlUtils();
                    this.injectedScope = {
                        permissionChanged: function (roleBusinessLevelId) { return _this.permissionChanged(roleBusinessLevelId); }
                    };
                    this.initialize();
                }
                RolePermissionController.prototype.initialize = function () {
                    var _this = this;
                    this.tabs = [];
                    this.datacontext.getSecurityLevels().then(function (data) {
                        _this.securityLevels = data;
                        _this.tabs = _this.utils.declareTabs(data);
                    }).then(function () {
                        return _this.datacontext.getOperationUnitTypes().then(function (data) {
                            _this.roleOperationUnitTypes = data[1];
                            //var distinctList = _.uniq(this.roleOperationUnitTypes, 'roleId');
                            _.forEach(_this.tabs, function (tab) {
                                _.forEach(_this.roleOperationUnitTypes, function (roleOperationUnitType) {
                                    if (roleOperationUnitType.role.roleName === tab.id)
                                        tab.content.push({
                                            level: roleOperationUnitType.operationUnitType.title,
                                            operationUnitTypeLevelId: roleOperationUnitType.operationUnitTypeLevelId,
                                            roleBusinessLevelId: roleOperationUnitType.roleBusinessLevelId,
                                            checked: _this.getSecurityAccessPermission(roleOperationUnitType.securityLevelBitMask, tab.heading),
                                            role: tab.id,
                                        });
                                });
                            });
                        });
                    });
                };
                RolePermissionController.prototype.loadData = function (tab) {
                    return this.$q.when(tab.content);
                };
                RolePermissionController.prototype.getSecurityAccessPermission = function (securityLevelBitMask, role) {
                    return this.utils.getSecurityAccessPermission(securityLevelBitMask, role, this.securityLevels);
                };
                RolePermissionController.prototype.cancel = function () {
                    this.datacontext.reject();
                    this.modalService.close();
                };
                RolePermissionController.prototype.save = function () {
                    var _this = this;
                    this.datacontext.save()
                        .then(function () {
                        _this.modalService.close();
                    })
                        .catch(function (error) {
                        _this.errors = error.entityErrors;
                        return false;
                    });
                };
                RolePermissionController.prototype.permissionChanged = function (roleBusinessLevelId) {
                    var _this = this;
                    var securityLevelBitMask = Math.pow(2, web.utils.permission.getSecurityLevelId('ReadDeveloper', this.securityLevels)) + Math.pow(2, web.utils.permission.getSecurityLevelId('FullDeveloper', this.securityLevels)); //Developer gets full control, 7-ReadDeveloper, 8-FullDeveloper
                    var exponent = 0;
                    _.forEach(this.tabs, function (tabitem) {
                        _.forEach(_.filter(tabitem.content, function (roleOperationUnitType) { return roleOperationUnitType.roleBusinessLevelId == roleBusinessLevelId; }), function (roleOpt) {
                            exponent = web.utils.permission.getExponent(tabitem.heading, roleOpt.checked, _this.securityLevels);
                            if (roleOpt.checked != app.constants.accessControlPermissions.none)
                                securityLevelBitMask += Math.pow(2, exponent);
                        });
                    });
                    var roleOpt = _.find(this.roleOperationUnitTypes, function (roleOperationUnitType) { return roleOperationUnitType.roleBusinessLevelId == roleBusinessLevelId; });
                    roleOpt.securityLevelBitMask = securityLevelBitMask;
                    return true;
                };
                RolePermissionController.$inject = ['$rootScope', '$scope', '$q', 'navigationDatacontext', 'modalService'];
                return RolePermissionController;
            })();
            controllers.RolePermissionController = RolePermissionController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("RolePermissionController", ['$rootScope', '$scope', '$q', 'navigationDatacontext', 'modalService']);

var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var AccessControlUtils = (function () {
                function AccessControlUtils() {
                }
                AccessControlUtils.prototype.getSecurityAccessPermission = function (navigationSecurityLevelBitMask, role, securityLevels) {
                    var permission = 0;
                    _.forEach(securityLevels, function (securityLevel) {
                        if (securityLevel.name.indexOf(role) > 0 && navigationSecurityLevelBitMask & Math.pow(2, securityLevel.securityLevelId)) {
                            permission = securityLevel.name.indexOf("Read") == 0 ? app.constants.accessControlPermissions.read : app.constants.accessControlPermissions.full;
                            return permission;
                        }
                    });
                    return permission;
                };
                AccessControlUtils.prototype.declareTabs = function (securityLevels) {
                    var tabs = [];
                    _.forEach(securityLevels, function (securityLevel) {
                        if (securityLevel.name.indexOf("Read") == 0 && securityLevel.name.indexOf("Developer") < 0) {
                            var name = _.replace(securityLevel.name, 'Read', '');
                            tabs.push({
                                heading: name == 'Customer' ? 'AC_' + name : name,
                                id: name,
                                active: name == 'Veterinary',
                                content: []
                            });
                        }
                    });
                    return tabs;
                };
                AccessControlUtils.prototype.permissionChanged = function (tabs, navigationOptions, securityLevels, navigationUrlId, subOption) {
                    if (subOption === void 0) { subOption = null; }
                    var securityLevelBitMask = Math.pow(2, web.utils.permission.getSecurityLevelId('ReadDeveloper', securityLevels)) + Math.pow(2, web.utils.permission.getSecurityLevelId('FullDeveloper', securityLevels)); //Developer gets full control, 7-ReadDeveloper, 8-FullDeveloper
                    var subSecurityLevelBitMask = securityLevelBitMask;
                    var exponent = 0;
                    var subExponent = 0;
                    _.forEach(tabs, function (tabitem) {
                        _.forEach(_.filter(tabitem.content, function (navigationOption) { return navigationOption.navigationURLId == navigationUrlId; }), function (navigationOption) {
                            exponent = web.utils.permission.getExponent(tabitem.id, parseInt(navigationOption.checked), securityLevels);
                            _.forEach(navigationOption.navigationSubOptions, function (navigationSubOption) {
                                if (navigationSubOption.checked > navigationOption.checked) {
                                    navigationSubOption.checked = navigationOption.checked;
                                }
                                subExponent = web.utils.permission.getExponent(tabitem.id, parseInt(navigationSubOption.checked), securityLevels);
                                if (subOption != null && navigationSubOption.name === subOption.name)
                                    if (navigationSubOption.checked != app.constants.accessControlPermissions.none)
                                        subSecurityLevelBitMask += Math.pow(2, subExponent);
                            });
                            if (navigationOption.checked != app.constants.accessControlPermissions.none)
                                securityLevelBitMask += Math.pow(2, exponent);
                        });
                    });
                    if (subOption == null)
                        _.forEach(_.filter(navigationOptions, function (navigationOption) { return navigationOption.navigationURLId == navigationUrlId; }), function (navigationOption) {
                            navigationOption.securityLevelBitMask = securityLevelBitMask;
                            _.forEach(navigationOption.navigationSubOptions, function (navigationSubOption) {
                                if (navigationSubOption.securityLevelBitMask > securityLevelBitMask)
                                    navigationSubOption.securityLevelBitMask = securityLevelBitMask;
                            });
                        });
                    else {
                        _.forEach(_.filter(navigationOptions, function (navigationOption) { return navigationOption.navigationURLId == navigationUrlId; }), function (navigationOption) {
                            _.forEach(navigationOption.navigationSubOptions, function (navigationSubOption) {
                                if (navigationSubOption.dictionary.name === subOption.name)
                                    navigationSubOption.securityLevelBitMask = subSecurityLevelBitMask;
                            });
                        });
                    }
                    return true;
                };
                return AccessControlUtils;
            })();
            controllers.AccessControlUtils = AccessControlUtils;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var UpcomingEventsController = (function () {
                function UpcomingEventsController($rootScope, $scope, $translate, authenticationService, datacontext, navigationService, appLocalStorage) {
                    var _this = this;
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.$translate = $translate;
                    this.authenticationService = authenticationService;
                    this.datacontext = datacontext;
                    this.navigationService = navigationService;
                    this.appLocalStorage = appLocalStorage;
                    this.events = [];
                    this.currentPage = 1;
                    this.itemsPerPage = 30;
                    this.toggleReload = false;
                    $scope.viewModel = this;
                    this.isCustomerPortalView = this.authenticationService.isCustomerUser();
                    var dateHeader = {
                        name: "Date",
                        text: app.localizer.resource.Date,
                        smColSpan: 1, mdColSpan: 1,
                        html: false,
                        propertyName: 'eventDate',
                        sort: app.constants.sortTypes.descending
                    };
                    var typeHeader = {
                        name: "Type",
                        text: app.localizer.resource.Type,
                        smColSpan: 2, mdColSpan: 2,
                        html: false,
                        propertyName: 'assessmentTypeName',
                        sort: app.constants.sortTypes.none
                    };
                    var customerHeader = {
                        name: "Customer",
                        text: app.localizer.resource.Customer,
                        smColSpan: 2, mdColSpan: 2,
                        html: false,
                        propertyName: 'customerName',
                        textOverflow: true,
                        sort: app.constants.sortTypes.none
                    };
                    var siteHeader = {
                        name: "Site",
                        text: app.localizer.resource.Site,
                        smColSpan: 2, mdColSpan: 2,
                        html: false,
                        propertyName: 'siteName',
                        selectSite: function (siteId) { return _this.selectSite(siteId); },
                        textOverflow: true,
                        sort: app.constants.sortTypes.none
                    };
                    var fishgroupHeader = {
                        name: "Fishgroup",
                        text: app.localizer.resource.Filter_Fishgroup,
                        smColSpan: 2, mdColSpan: 2,
                        html: false,
                        propertyName: 'fishgroupName',
                        textOverflow: true,
                        sort: app.constants.sortTypes.none
                    };
                    var contactHeader = {
                        name: "NAHContact",
                        text: app.localizer.resource.NAHContact,
                        smColSpan: 2, mdColSpan: 2,
                        html: false,
                        propertyName: 'contactName',
                        textOverflow: true,
                        sort: app.constants.sortTypes.none
                    };
                    var optionsHeader = {
                        name: "Options",
                        text: '',
                        "class": 'pull-right',
                        smColSpan: 1, mdColSpan: 1,
                        html: false,
                        propertyName: '',
                        confirm: function (event) { _this.delete(event); },
                        sort: app.constants.sortTypes.notSortable
                    };
                    if (this.isCustomerPortalView) {
                        this.headers = [dateHeader, typeHeader, fishgroupHeader, contactHeader];
                    }
                    else {
                        this.headers = [dateHeader, typeHeader, customerHeader, siteHeader, fishgroupHeader, contactHeader, optionsHeader];
                        this.popover = { 'placement': 'bottom', 'title': '', 'content': 'true', 'trigger': 'hover', 'template': 'modules/upcoming_events/event.tpl.html', 'delay': 250 };
                    }
                    this.$scope.$on(app.constants.broadcastEventNames.eventRegistrationCompleted, function () {
                        _this.toggleReload = !_this.toggleReload;
                    });
                    this.$scope.$on(app.constants.broadcastEventNames.navigationObjectIdChanged, function (event, data) {
                        _this.toggleReload = !_this.toggleReload;
                    });
                    this.$scope.$watch('viewModel.eventDate', function (newValue, oldValue) {
                        if (!_.isEqual(newValue, oldValue)) {
                            _this.pagedevents = [];
                            _this.toggleReload = !_this.toggleReload;
                        }
                    });
                    this.eventDate = moment().startOf('day').toDate();
                }
                UpcomingEventsController.prototype.delete = function (event) {
                    var _this = this;
                    event.entityAspect.setDeleted();
                    _.remove(this.pagedevents, function (currentObject) {
                        return currentObject.eventId === event.eventId;
                    });
                    this.datacontext.save().then(function () {
                        _this.toggleReload = !_this.toggleReload;
                    });
                };
                UpcomingEventsController.prototype.selectSite = function (siteId) {
                    this.$rootScope.$broadcast(app.constants.broadcastEventNames.siteSelected, app.constants.operationUnitLevels.site + '-' + siteId);
                };
                UpcomingEventsController.prototype.addAllEventsToCalendar = function () {
                    web.utils.events.addToCalendar(this.pagedevents, this.$translate);
                };
                UpcomingEventsController.prototype.loadData = function () {
                    var _this = this;
                    return this.datacontext.getEvents(this.currentPage, this.itemsPerPage, _.isEmpty(this.navigationService.objectKey) ? JSON.parse(this.appLocalStorage.treeViewDataGet()).ch[0].id : this.navigationService.objectKey, this.eventDate, this.authenticationService.credentialsGet().UserId, "Web App").then(function (results) {
                        _this.pagedevents = _this.events.concat(results);
                        return _this.pagedevents;
                    });
                };
                UpcomingEventsController.$inject = ['$rootScope', '$scope', '$translate', 'authenticationService', 'upcomingEventDatacontext', 'navigationService', 'appLocalStorage'];
                return UpcomingEventsController;
            })();
            controllers.UpcomingEventsController = UpcomingEventsController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("UpcomingEventsController", ['$rootScope', '$scope', '$translate', 'authenticationService', 'upcomingEventDatacontext', 'navigationService', 'appLocalStorage']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var EventController = (function () {
                function EventController($rootScope, $scope, authenticationService, datacontext, assessmentDataContext, modalService) {
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.authenticationService = authenticationService;
                    this.datacontext = datacontext;
                    this.assessmentDataContext = assessmentDataContext;
                    this.modalService = modalService;
                    this.validate = false;
                    this.errorMessage = app.localizer.resource.Error_ValidationErrors;
                    $scope.viewModel = this;
                    if (_.isNumber(this.$scope.ngDialogData.event)) {
                        this.siteId = this.$scope.ngDialogData.event;
                        this.eventData = this.datacontext.createEvent({
                            eventDate: moment(),
                            assessmentTypeId: null,
                            siteId: this.siteId,
                            fishgroupId: null,
                            userId: null,
                            comments: null
                        });
                    }
                    else {
                        this.siteId = this.$scope.ngDialogData.event.siteId;
                        this.eventData = this.$scope.ngDialogData.event;
                    }
                    this.initialize();
                }
                EventController.prototype.initialize = function () {
                    this.assessmentTypes = this.datacontext.getAssessmentTypes();
                    var contactPersons = this.assessmentDataContext.getNahRepresentatives(this.siteId);
                    if (contactPersons.length > 0 && !_.isUndefined(contactPersons[0].main)) {
                        if (this.isNew()) {
                            var repr = _.filter(contactPersons, { 'main': true })[0];
                            if (repr) {
                                var mainContactPersonId = repr.contactPerson.vetUserId;
                                this.eventData.userId = mainContactPersonId;
                            }
                        }
                        contactPersons = _.map(contactPersons, 'contactPerson');
                    }
                    this.contactPersons = contactPersons;
                    this.fishgroups = this.assessmentDataContext.getFishgroups(this.siteId);
                    this.siteName = this.assessmentDataContext.getSite(this.siteId).name;
                    this.headerText = this.isNew() ? app.localizer.resource.NewUpcommingEventRegistration : app.localizer.resource.EditUpcomingEvent;
                };
                EventController.prototype.isNew = function () {
                    return this.eventData.eventId < 0;
                };
                EventController.prototype.isNotHarvest = function () {
                    return this.eventData.assessmentTypeId !== app.constants.assessmentTypes.harvest;
                };
                EventController.prototype.saveEvent = function () {
                    var _this = this;
                    if (!this.eventData.entityAspect.validateEntity()) {
                        this.hasValidationProblem = true;
                        return;
                    }
                    this.hasValidationProblem = false;
                    // this.setNotificationDetails();
                    this.datacontext.save().then(function () {
                        // app.trigger(constants.eventNames.createNotificationIsRequired, { notificationType: constants.notificationType.eventReg, notificationInfo: this.notificationInfo });
                        _this.$rootScope.$broadcast(app.constants.broadcastEventNames.eventRegistrationCompleted);
                        _this.closeWindow();
                    });
                };
                EventController.prototype.hasError = function (propertyName) {
                    return !this.eventData.entityAspect.validateProperty(propertyName) && this.hasValidationProblem;
                };
                EventController.prototype.closeWindow = function () {
                    this.modalService.close();
                };
                EventController.prototype.cancel = function () {
                    this.datacontext.reject();
                    this.modalService.close();
                };
                EventController.prototype.createFishgroup = function () {
                    var _this = this;
                    this.modalService.showConfirm('modules/fishgroup/fishgroup.html', app.constants.dialogSize.small, '', null, function () { }, new web.services.FishgroupData(this.siteId)).then(function (fishgroup) {
                        _this.fishgroups.push(fishgroup);
                        _this.eventData.fishgroupId = fishgroup.fishgroupId;
                    });
                };
                EventController.prototype.hasErrors = function () {
                    return this.eventData.entityAspect.hasValidationErrors;
                };
                EventController.prototype.isDirty = function () {
                    return !this.datacontext.hasChanges();
                };
                EventController.$inject = ['$rootScope', '$scope', 'authenticationService', 'upcomingEventDatacontext', 'assessmentDatacontext', 'modalService'];
                return EventController;
            })();
            controllers.EventController = EventController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("EventController", ['$rootScope', '$scope', 'authenticationService', 'upcomingEventDatacontext', 'assessmentDatacontext', 'modalService']);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var MyContactController = (function () {
                function MyContactController($scope, customerPortalDatacontext, navigationService, apiEndpointService) {
                    var _this = this;
                    this.$scope = $scope;
                    this.customerPortalDatacontext = customerPortalDatacontext;
                    this.navigationService = navigationService;
                    this.apiEndpointService = apiEndpointService;
                    $scope.viewModel = this;
                    $scope.$on(app.constants.broadcastEventNames.navigationObjectIdChanged, function () {
                        _this.contactPersonDataGet();
                    });
                    this.defaultProfileImgUrl = this.apiEndpointService.getBaseEndpoint() + "/Content/images/DefaultProfile.png";
                    this.contactPersonDataGet();
                }
                MyContactController.prototype.contactPersonDataGet = function () {
                    var _this = this;
                    this.hasContact = true;
                    this.hasImage = false;
                    //this.companyName = this.navigationService.companyName;
                    this.companyName = "Elanco"; //This will always be the same value and should probably be fetched from some environment or system setting
                    this.siteId = this.navigationService.selectedObjectId;
                    this.customerPortalDatacontext.getMainContactPerson(this.siteId).then(function (mainContact) {
                        if (mainContact !== null) {
                            _this.mainContact = mainContact;
                            if (_this.mainContact.pictureName !== null) {
                                _this.customerPortalDatacontext.getContactPictureByName(_this.siteId, _this.mainContact.pictureName).then(function (picture) {
                                    _this.imageValue = picture;
                                    _this.hasImage = true;
                                });
                            }
                        }
                        else {
                            _this.hasContact = false;
                        }
                    });
                };
                MyContactController.$inject = ['$scope', 'customerPortalDatacontext', 'navigationService', 'apiEndpointService'];
                return MyContactController;
            })();
            controllers.MyContactController = MyContactController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("MyContactController", ['$scope', 'customerPortalDatacontext', 'navigationService', 'apiEndpointService']);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var BenchmarkingController = (function () {
                function BenchmarkingController($scope, $compile, $q, customerPortalDatacontext, navigationService) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$compile = $compile;
                    this.$q = $q;
                    this.customerPortalDatacontext = customerPortalDatacontext;
                    this.navigationService = navigationService;
                    this.sideEffectData = new web.model.sideEffectsChart([], app.constants.chartTypes.visceralMelanin);
                    this.lookUpContainer = new controllers.benchmarking.lookupContainer();
                    this.toggleReload = false;
                    this.keyNumbers = null;
                    this.avgKeyNumbers = null;
                    this.toggleFilterChanged = false;
                    this.fromYearMonth = 0;
                    this.toYearMonth = 0;
                    this.mainChartContainerSelector = "#mainChartContainer";
                    this.auxChartContainerSelector = "#auxChartContainer";
                    this.siteName = this.getCurrentSite();
                    $scope.viewModel = this;
                    this.$scope.$on(app.constants.broadcastEventNames.navigationObjectIdChanged, function () { var currentSelectedChartTypeId = _this.chartTypeId; return _this.loadInitData().then(function () { _this.loadDataByChartType(currentSelectedChartTypeId); }); });
                    this.loadInitData();
                    this.intililizeGridHeaders();
                }
                BenchmarkingController.prototype.setAssessmentGroupsDataSource = function (assessmentGroupData) {
                    this.assesmentGroupContainer = new controllers.benchmarking.asessmentGroupContainer(assessmentGroupData);
                };
                BenchmarkingController.prototype.loadVaccines = function (data) {
                    this.vaccineContainer = new controllers.benchmarking.vaccineContainer(data[0], data[2]);
                };
                BenchmarkingController.prototype.intililizeGridHeaders = function () {
                    this.precisionScoreHeaders = [
                        { text: app.localizer.resource.Date, mdColSpan: 3, smColSpan: 3, html: false, propertyName: 'assessmentDate' },
                        { text: app.localizer.resource.AssessmentGroup, mdColSpan: 4, smColSpan: 4, html: false, propertyName: 'assessmentDiscriminatorMain' },
                        { text: app.localizer.resource.PrecisionScoreShort, mdColSpan: 2, smColSpan: 2, html: false, propertyName: 'precisionScore' },
                        { text: app.localizer.resource.AverageWeightShort, mdColSpan: 3, smColSpan: 3, html: false, propertyName: 'avgWeight' }];
                    this.sideEffectsHeaders = [
                        { text: app.localizer.resource.Date, mdColSpan: 3, smColSpan: 3, html: false, propertyName: 'assessmentDate' },
                        { text: app.localizer.resource.AssessmenType, mdColSpan: 3, smColSpan: 3, html: false, propertyName: 'assessmentTypeName' },
                        { text: app.localizer.resource.AssessmentGroup, mdColSpan: 2, smColSpan: 2, html: false, propertyName: 'assessmentDiscriminatorMain' },
                        { text: this.headerTextHelper(), mdColSpan: 2, smColSpan: 2, html: false, propertyName: 'value' }];
                };
                BenchmarkingController.prototype.getDefaultfromYearMonth = function () {
                    var yearAsString = moment().subtract(2, "year").year().toString();
                    var month = moment().subtract(2, "year").month() + 1;
                    var monthAsString = month < 10 ? "0" + month.toString() : month.toString();
                    return parseInt(yearAsString + monthAsString);
                };
                BenchmarkingController.prototype.getDefaultftoYearMonth = function () {
                    var yearAsString = moment().year().toString();
                    var month = moment().month() + 1;
                    var monthAsString = month < 10 ? "0" + month.toString() : month.toString();
                    return parseInt(yearAsString + monthAsString);
                };
                BenchmarkingController.prototype.loadInitData = function () {
                    var _this = this;
                    this.warningMessage = "";
                    this.sideEffectData.clearColorMap();
                    this.precisionDateRange = new controllers.DateRange(moment().subtract(2, "year").startOf('month'), moment().endOf('month'));
                    this.siteId = this.navigationService.selectedObjectId;
                    this.fromYearMonth = this.getDefaultfromYearMonth();
                    this.toYearMonth = this.getDefaultftoYearMonth();
                    this.chartTypeItem = null;
                    this.chartTypeId = null;
                    return this.$q.all([
                        this.customerPortalDatacontext.getSideEffectVaccinesBySite(this.siteId),
                        this.customerPortalDatacontext.getAssessmentGroups(this.siteId),
                        this.customerPortalDatacontext.getPrecisionScorVaccinesBySite(this.siteId)
                    ]).then(function (data) {
                        _this.setAssessmentGroupsDataSource(data[1]);
                        _this.loadVaccines(data);
                        _this.$scope.$watch('viewModel.chartTypeId', function () {
                            _this.removePopovers();
                            _this.destroyChart();
                            _this.precisionScoreComparisonTypeId = null;
                            _this.precisionScoreComparisonTypeItem = null;
                            _this.selectedStageItem = null;
                            _this.selectedStageId = null;
                            _this.comparisonTypeItem = null;
                            _this.highchartsData = null;
                            _this.keyNumbers = null;
                            _this.avgKeyNumbers = null;
                        });
                        _this.$scope.$watchCollection('viewModel.vaccineContainer.selectedVaccines', function () {
                            _this.removePopovers();
                        });
                        _this.$scope.$watchCollection('viewModel.assesmentGroupContainer.selectedAssessmentGroups', function () {
                            _this.removePopovers();
                        });
                        _this.$scope.$watchCollection('viewModel.precisionScoreComparisonTypeId', function () {
                            _this.removePopovers();
                        });
                        _this.$scope.$watch('viewModel.precisionDateRange', function (dateRange, oldVal, scope) {
                            _this.removePopovers();
                            if (dateRange !== oldVal)
                                if ((oldVal === undefined) ||
                                    dateRange.startDate.startOf('month').toString() !== oldVal.startDate.startOf('month').toString() ||
                                    dateRange.endDate.endOf('month').toString() !== oldVal.endDate.endOf('month').toString()) {
                                    _this.precisionDateRange.startDate = moment(_this.precisionDateRange.startDate).startOf('month');
                                    _this.precisionDateRange.endDate = moment(_this.precisionDateRange.endDate).endOf('month');
                                    _this.loadVaccineBySite();
                                    _this.loadPrecisionScoreChartByDateRange();
                                }
                        }, true); //NB! Deep watch
                    });
                };
                BenchmarkingController.prototype.removePopovers = function () {
                    //remove all active popover
                    $('.popover').each(function () {
                        $(this).remove();
                    });
                };
                BenchmarkingController.prototype.closeActivePopover = function () {
                    this.removePopovers();
                    this.setPopOverForColumnSeries();
                };
                BenchmarkingController.prototype.headerTextHelper = function () {
                    if (this.visceralMelaninChartIsSelected()) {
                        return app.localizer.resource.AverageVisceralMelaninGroupShort;
                    }
                    else if (this.parietalMelaninChartChartIsSelected()) {
                        return app.localizer.resource.AverageParietalMelaninGroupShort;
                    }
                    else if (this.speilbergScoreChatIsSelected()) {
                        return app.localizer.resource.AverageSpeilbergScoreGroupShort;
                    }
                    return "";
                };
                BenchmarkingController.prototype.loadData = function () {
                    var _this = this;
                    return this.$q.when("").then(function () { return _this.assessments; });
                };
                BenchmarkingController.prototype.precisionScoreChartIsSelected = function () {
                    return this.chartTypeId === app.constants.chartTypes.precisionScore;
                };
                BenchmarkingController.prototype.visceralMelaninChartIsSelected = function () {
                    return (this.chartTypeId === app.constants.chartTypes.visceralMelanin);
                };
                BenchmarkingController.prototype.speilbergScoreChatIsSelected = function () {
                    return (this.chartTypeId === app.constants.chartTypes.speilbergScore);
                };
                BenchmarkingController.prototype.parietalMelaninChartChartIsSelected = function () {
                    return (this.chartTypeId === app.constants.chartTypes.parietalMelanin);
                };
                BenchmarkingController.prototype.sideEffectsChartIsSelected = function () {
                    return this.chartTypeId === app.constants.chartTypes.parietalMelanin || this.chartTypeId === app.constants.chartTypes.visceralMelanin || this.chartTypeId === app.constants.chartTypes.speilbergScore;
                };
                BenchmarkingController.prototype.percentileParietalMelaninIsSelected = function () {
                    return this.chartTypeId === app.constants.chartTypes.percentileParietalMelanin;
                };
                BenchmarkingController.prototype.percentileSpeilbergScoreIsSelected = function () {
                    return this.chartTypeId === app.constants.chartTypes.percentileSpeilbergScore;
                };
                BenchmarkingController.prototype.percentileVisceralMelaninIsSelected = function () {
                    return this.chartTypeId === app.constants.chartTypes.percentileVisceralMelanin;
                };
                BenchmarkingController.prototype.percentileSideEffectIsSelected = function () {
                    return this.percentileParietalMelaninIsSelected() || this.percentileSpeilbergScoreIsSelected() || this.percentileVisceralMelaninIsSelected();
                };
                BenchmarkingController.prototype.destroyKeyNumbersTable = function () {
                    this.keyNumbers = null;
                    this.avgKeyNumbers = null;
                };
                BenchmarkingController.prototype.loadChartData = function () {
                    this.checkEmptyFiltersWarnings();
                    if (this.sideEffectsChartIsSelected() && this.chartHasAssessmengGroupsToSelect() && this.chartHasVaccinesToSelect())
                        this.loadSideEffectsItems();
                    else if (this.precisionScoreChartIsSelected() && this.chartHasVaccinesToSelect() && !this.isLoadingPrecisionScoreChartItems)
                        this.loadPrecisionScoreChartItems();
                    else if (this.percentileSideEffectIsSelected() && this.chartHasAssessmengGroupsToSelect() && this.chartHasVaccinesToSelect())
                        this.loadPercentileSideEffectsItems();
                };
                BenchmarkingController.prototype.loadDataByChartType = function (chartTypeId) {
                    this.chartTypeId = chartTypeId;
                    this.assesmentGroupContainer.loadAssessmentGroups();
                    this.loadVaccineBySite();
                    this.loadChartDataIfSideEffectsIsSelected();
                    this.checkEmptyFiltersWarnings();
                };
                BenchmarkingController.prototype.checkEmptyFiltersWarnings = function () {
                    this.warningMessage = "";
                    if (this.sideEffectsChartIsSelected() || this.percentileSideEffectIsSelected()) {
                        if (!this.chartHasAssessmengGroupsToSelect() || !this.chartHasVaccinesToSelect()) {
                            this.warningMessage = app.localizer.resource.MissingDataInFilters;
                            var assessmentGroupMessage = this.runAssessmentGroupValidation();
                            var vaccineGroupMessage = this.runVaccineValidation();
                            if (assessmentGroupMessage.length > 0)
                                this.warningMessage += assessmentGroupMessage;
                            if (vaccineGroupMessage.length > 0)
                                this.warningMessage += vaccineGroupMessage;
                        }
                    }
                    else if (this.precisionScoreChartIsSelected()) {
                        var vaccineGroupMessage = this.runVaccineValidation();
                        if (vaccineGroupMessage.length > 0) {
                            this.warningMessage = app.localizer.resource.MissingDataInFilters;
                            this.warningMessage += vaccineGroupMessage;
                        }
                    }
                };
                BenchmarkingController.prototype.showWarningMessage = function () {
                    return this.warningMessage != null && this.warningMessage.length > 0;
                };
                BenchmarkingController.prototype.runAssessmentGroupValidation = function () {
                    return !this.chartHasAssessmengGroupsToSelect() ? app.localizer.resource.ThereIsNoAssessmentGroupsToSelect : "";
                };
                BenchmarkingController.prototype.runVaccineValidation = function () {
                    return !this.chartHasVaccinesToSelect() ? app.localizer.resource.ThereIsNoVaccinesToSelect : "";
                };
                BenchmarkingController.prototype.loadVaccineBySite = function () {
                    var fromDate = this.precisionDateRange.startDate.toDate();
                    var toDate = this.precisionDateRange.endDate.toDate();
                    if (this.sideEffectsChartIsSelected() || this.percentileSideEffectIsSelected()) {
                        this.vaccineContainer.loadSideEffectVaccines();
                    }
                    else {
                        this.vaccineContainer.loadPrecisionVaccines(fromDate, toDate);
                    }
                };
                BenchmarkingController.prototype.chartHasAssessmengGroupsToSelect = function () {
                    return this.assesmentGroupContainer.hasAssessmentGroups();
                };
                BenchmarkingController.prototype.chartHasVaccinesToSelect = function () {
                    return this.vaccineContainer.hasVaccines();
                };
                BenchmarkingController.prototype.loadChartDataIfSideEffectsIsSelected = function () {
                    if (this.sideEffectsChartIsSelected() && this.chartHasAssessmengGroupsToSelect() && this.chartHasVaccinesToSelect())
                        this.loadSideEffectsItems();
                };
                BenchmarkingController.prototype.loadPrecisionScoreChart = function (selectedOption) {
                    this.checkEmptyFiltersWarnings();
                    this.precisionScoreComparisonTypeId = selectedOption;
                    if (this.precisionScoreChartIsSelected() && this.chartHasVaccinesToSelect())
                        this.loadPrecisionScoreChartItems();
                };
                BenchmarkingController.prototype.loadPercentilSideEffectsChart = function (stageId) {
                    this.checkEmptyFiltersWarnings();
                    this.selectedStageId = stageId;
                    if (this.percentileSideEffectIsSelected() && this.chartHasVaccinesToSelect() && this.chartHasAssessmengGroupsToSelect()) {
                        this.loadPercentileSideEffectsItems();
                    }
                };
                BenchmarkingController.prototype.loadPrecisionScoreChartByDateRange = function () {
                    this.fromYearMonth = this.convertDateToYearMonthFormat(this.precisionDateRange.startDate);
                    this.toYearMonth = this.convertDateToYearMonthFormat(this.precisionDateRange.endDate);
                    if (this.precisionScoreChartIsSelected())
                        this.loadPrecisionScoreChartItems();
                };
                BenchmarkingController.prototype.convertDateToYearMonthFormat = function (dateValue) {
                    var year = dateValue.year().toString();
                    var numberOfMonth = dateValue.month() + 1;
                    var month = numberOfMonth < 10 ? '0' + numberOfMonth.toString() : numberOfMonth.toString();
                    return parseInt(year + month);
                };
                BenchmarkingController.prototype.getChartVisibility = function () {
                    return (this.canShowSideEffectChart() || this.canShowPrecisionScoreChart() || this.canShowPercentileSideEffectCharts());
                };
                BenchmarkingController.prototype.getAvgChartVisibility = function () {
                    return this.canShowPercentileSideEffectCharts();
                };
                BenchmarkingController.prototype.canShowPercentileSideEffectCharts = function () {
                    return this.percentileSideEffectIsSelected() && this.stageIsSelected();
                };
                BenchmarkingController.prototype.canShowSideEffectChart = function () {
                    return (this.canShowVisceralMelaninChart() || this.canShowParietalMelaninChart() || this.canShowSpeilbergScoreChat());
                };
                BenchmarkingController.prototype.canShowPrecisionScoreChart = function () {
                    return (this.precisionScoreChartIsSelected() && this.precisionScoreComparisonTypeIsSelected());
                };
                BenchmarkingController.prototype.canShowVisceralMelaninChart = function () {
                    return ((this.visceralMelaninChartIsSelected()));
                };
                BenchmarkingController.prototype.canShowSpeilbergScoreChat = function () {
                    return ((this.speilbergScoreChatIsSelected()));
                };
                BenchmarkingController.prototype.canShowParietalMelaninChart = function () {
                    return ((this.parietalMelaninChartChartIsSelected()));
                };
                BenchmarkingController.prototype.destroyChart = function () {
                    this.destroyKeyNumbersTable();
                    this.removeChart(this.mainChartContainerSelector);
                    this.removeChart(this.auxChartContainerSelector);
                };
                BenchmarkingController.prototype.removeChart = function (chartId) {
                    var chartContainer = $(chartId);
                    if (chartContainer.highcharts() !== undefined && chartContainer.highcharts() !== undefined && chartContainer.highcharts() !== null) {
                        chartContainer.highcharts().destroy();
                    }
                };
                BenchmarkingController.prototype.loadPrecisionScoreChartItems = function () {
                    var _this = this;
                    this.destroyChart();
                    if (this.precisionScoreComparisionTypeIsNotSelected())
                        return;
                    var vaccines = this.vaccineContainer.getVaccineSelection();
                    this.isLoadingPrecisionScoreChartItems = true;
                    return this.customerPortalDatacontext.getPrecisionScoreChartItems(this.siteId, this.precisionScoreComparisonTypeId, vaccines, this.fromYearMonth, this.toYearMonth).then(function (data) {
                        _this.vaccinePrecisionsItems = data;
                        _this.getPrecisionScoreChart();
                        _this.isLoadingPrecisionScoreChartItems = false;
                    });
                };
                BenchmarkingController.prototype.loadPercentileSideEffectsItems = function () {
                    var _this = this;
                    this.destroyChart();
                    var vaccineSelection = this.vaccineContainer.getVaccineSelection();
                    var assessmentGroupSelection = this.assesmentGroupContainer.getAssessmentGroupSelection();
                    return this.customerPortalDatacontext.getPercentileSideEffectsItems(this.siteId, this.chartTypeId, this.selectedStageId, vaccineSelection, assessmentGroupSelection).then(function (data) {
                        _this.percentileSideEffectDataSource = data;
                        _this.getPercentileSideEffectScoreChart();
                    });
                };
                BenchmarkingController.prototype.stageIsSelected = function () {
                    return !this.stageIsNotSelected();
                };
                BenchmarkingController.prototype.stageIsNotSelected = function () {
                    return this.selectedStageId === undefined || this.selectedStageId === null || this.selectedStageId === 0;
                };
                BenchmarkingController.prototype.precisionScoreComparisionTypeIsNotSelected = function () {
                    return this.precisionScoreComparisonTypeId === undefined || this.precisionScoreComparisonTypeId === null || this.precisionScoreComparisonTypeId === 0;
                };
                BenchmarkingController.prototype.precisionScoreComparisonTypeIsSelected = function () {
                    return this.precisionScoreComparisionTypeIsNotSelected() === false;
                };
                BenchmarkingController.prototype.loadSideEffectsItems = function () {
                    var _this = this;
                    this.destroyChart();
                    var vaccineSelection = this.vaccineContainer.getVaccineSelection();
                    var assessmentGroupSelection = this.assesmentGroupContainer.getAssessmentGroupSelection();
                    return this.customerPortalDatacontext.getSideEffectsItems(this.siteId, this.chartTypeId, vaccineSelection, assessmentGroupSelection).then(function (data) {
                        _this.sideEffectsItems = data;
                        _this.getSideEffectsItemsChart();
                    });
                };
                BenchmarkingController.prototype.getSideEffectsItemsChart = function () {
                    this.sideEffectData = new web.model.sideEffectsChart(this.sideEffectsItems, this.chartTypeId);
                    this.highchartsData = this.sideEffectData.getHighchartsSettings();
                    if (this.highchartsData.hasData === true)
                        this.showMainChart();
                    else
                        this.warningMessage = app.localizer.resource.NoDataForCurrentSelection;
                };
                BenchmarkingController.prototype.getPrecisionScoreChart = function () {
                    this.precisionScoreChart = new web.model.precisionScoreChart(this.vaccinePrecisionsItems, this.chartTypeId, this.precisionScoreComparisonTypeId);
                    this.highchartsData = this.precisionScoreChart.getHighchartsSettings();
                    if (this.highchartsData.hasData === true)
                        this.showMainChart();
                    else
                        this.warningMessage = app.localizer.resource.NoDataForCurrentSelection;
                };
                BenchmarkingController.prototype.getPercentileSideEffectScoreChart = function () {
                    this.percentilSideEffectData = new app.web.model.percentileSideEffectsChart(this.percentileSideEffectDataSource, this.chartTypeId, this.selectedStageId);
                    this.averageSideEffectsScoreChart = new app.web.model.averageSideEffectsScoreChart(this.percentileSideEffectDataSource, this.chartTypeId, this.selectedStageId);
                    this.highchartsData = this.percentilSideEffectData.getHighchartsSettings();
                    this.avgDataChart = this.averageSideEffectsScoreChart.getHighchartsSettings();
                    if ((this.highchartsData.hasData === false) && (this.avgDataChart.hasData === false)) {
                        this.warningMessage = app.localizer.resource.NoDataForCurrentSelection;
                        return;
                    }
                    if ((this.highchartsData.hasData === true) && (this.avgDataChart.hasData === true)) {
                        this.showMainChart();
                        this.showAvgChart();
                    }
                    if ((this.highchartsData.hasData === true) && (this.avgDataChart.hasData === false)) {
                        this.showMainChart();
                        this.warningMessage = app.localizer.resource.NoAverageDataForThisSelection;
                    }
                    else if ((this.highchartsData.hasData === false) && (this.avgDataChart.hasData === true)) {
                        this.showAvgChart();
                        this.warningMessage = app.localizer.resource.NoPercentilDataForThisSelection;
                    }
                };
                BenchmarkingController.prototype.canShowPopOver = function (serieName) {
                    var canShowPopOver = false;
                    if (this.sideEffectsChartIsSelected()) {
                        canShowPopOver = !this.sideEffectData.isAverageSerie(serieName) && !this.sideEffectData.isStandardDesviationSerie(serieName);
                    }
                    else if (this.precisionScoreChartIsSelected()) {
                        canShowPopOver = !this.precisionScoreChart.isAverageSerie(serieName);
                    }
                    else if (this.percentileSideEffectIsSelected()) {
                        canShowPopOver = true;
                    }
                    return canShowPopOver;
                };
                BenchmarkingController.prototype.getToolTipTemplate = function () {
                    var toolTipTemplate = "";
                    if (this.precisionScoreChartIsSelected()) {
                        toolTipTemplate = "modules/benchmarking/precisionScorePopover.tpl.html";
                    }
                    else if (this.sideEffectsChartIsSelected()) {
                        toolTipTemplate = "modules/benchmarking/sideEffectsPopover.tpl.html";
                    }
                    else if (this.percentileSideEffectIsSelected()) {
                        toolTipTemplate = "modules/benchmarking/persentilSideEffectsPopover.tpl.html";
                    }
                    return toolTipTemplate;
                };
                BenchmarkingController.prototype.loadTooltip = function (chartTitle) {
                    this.showKeyNumbers();
                    if (this.sideEffectsChartIsSelected())
                        this.loadSideEffectScoreKeyNumber();
                    else if (this.precisionScoreChartIsSelected())
                        this.loadBenchMarkingPrecisionScoreKeyNumber();
                    else if (this.percentileSideEffectIsSelected())
                        this.getPercentileSideEffectScoreDetails(chartTitle);
                };
                BenchmarkingController.prototype.loadSideEffectScoreKeyNumber = function () {
                    var serieName = this.selectedSerie;
                    var assessmentTypeKey = this.sideEffectData.findLocalizationKeyName(this.selectedCategory);
                    var cachedKeyNumbers = this.sideEffectData.getKeyNumbersBySerieAndType(serieName, assessmentTypeKey);
                    if (cachedKeyNumbers === null) {
                        this.getSideEffectsDetailFromService(serieName, assessmentTypeKey);
                    }
                    else {
                        this.keyNumbersObject = cachedKeyNumbers;
                        this.assessments = cachedKeyNumbers.assessments;
                    }
                };
                BenchmarkingController.prototype.getSideEffectsDetailFromService = function (serieName, assessmentTypeKey) {
                    var _this = this;
                    var assessmentGroupSelection = this.assesmentGroupContainer.getAssessmentGroupSelection();
                    return this.customerPortalDatacontext.getSideEffectsDetail(this.siteId, this.chartTypeId, serieName, assessmentTypeKey, assessmentGroupSelection).then(function (data) {
                        _this.mapSideEffectScoreKeyNumbers(serieName, assessmentTypeKey, data);
                    });
                };
                BenchmarkingController.prototype.mapSideEffectScoreKeyNumbers = function (serieName, assessmentTypeKey, data) {
                    var _this = this;
                    this.keyNumbersObject = data[0].keyNumbers;
                    this.keyNumbersObject.averageDatabaseScore = this.sideEffectData.getDataBaseAverageByVaccineAndStage(serieName, assessmentTypeKey);
                    this.keyNumbersObject.databaseNumberOfSamples = this.sideEffectData.getDatabaseNumberOfSampleByVaccineAndStage(serieName, assessmentTypeKey);
                    this.keyNumbersObject.assessmentTypeName = this.selectedCategory;
                    this.assessments = data[0].assessments;
                    _.forEach(this.assessments, function (assessment) { assessment.assessmentTypeName = _this.selectedCategory; });
                    this.keyNumbersObject.assessments = this.assessments;
                    this.sideEffectData.setKeyNumbersBySerieAndType(serieName, assessmentTypeKey, this.keyNumbersObject);
                };
                BenchmarkingController.prototype.loadBenchMarkingPrecisionScoreKeyNumber = function () {
                    var comparisonItemValue = this.selectedSerie;
                    var yearMonth = this.selectedCategory;
                    var comparisonItemValueKeyName = this.precisionScoreChart.getSerieKeyName(comparisonItemValue);
                    var cachedKeyNumbers = this.precisionScoreChart.getKeyNumbersByYearMonthAndComparisonType(yearMonth, comparisonItemValueKeyName);
                    if (cachedKeyNumbers === null) {
                        this.getPrecisionScoreKeyNumberFromService(yearMonth, comparisonItemValueKeyName);
                    }
                    else {
                        this.keyNumbersObject = cachedKeyNumbers;
                        this.assessments = cachedKeyNumbers.assessments;
                    }
                };
                BenchmarkingController.prototype.getCurrentSite = function () {
                    var foundSite = _.find(this.navigationService.getSites(), { siteId: this.navigationService.selectedObjectId });
                    return foundSite != undefined ? foundSite.name : "";
                };
                BenchmarkingController.prototype.getPercentilKeyNumberObjectType = function (chartTitle) {
                    var averageSerieSelected = false;
                    var isPercentileChart = this.isChartPercentilChart(chartTitle);
                    if (isPercentileChart) {
                        averageSerieSelected = this.selectedSerie === app.localizer.resource.DbAvg;
                        this.keyNumbersObject.type = averageSerieSelected ? 'PercentilChart_DbAverageSelectedSerie' : 'PercentilChart_SiteSelectedSerie';
                    }
                    else {
                        averageSerieSelected = this.selectedCategory === 'DbAverage';
                        this.keyNumbersObject.type = averageSerieSelected ? 'AverageScore_DbAverageSelectedSerie' : 'AverageScore_SiteSelectedSerie';
                    }
                };
                BenchmarkingController.prototype.getPercentileSideEffectScoreDetails = function (chartTitle) {
                    this.keyNumbersObject = {};
                    this.getPercentilKeyNumberObjectType(chartTitle);
                    switch (this.keyNumbersObject.type) {
                        case "PercentilChart_SiteSelectedSerie":
                            {
                                this.fillKeyNumbersForPercentilChartWhenSiteSerieIsSelected();
                                break;
                            }
                        case "PercentilChart_DbAverageSelectedSerie":
                            {
                                this.fillKeyNumbersForPercentilChartWhenDbAverageSerieIsSelected();
                                break;
                            }
                        case "AverageScore_DbAverageSelectedSerie":
                        case "AverageScore_SiteSelectedSerie":
                            {
                                this.fillKeyNumbersForAverageScoreChart();
                                break;
                            }
                    }
                };
                BenchmarkingController.prototype.fillKeyNumbersForAverageScoreChart = function () {
                    var selectedSiteRow = _.find(this.percentileSideEffectDataSource[0].averageScoreChartItems, { xaxis: this.siteName });
                    var selectedDbAverageRow = _.find(this.percentileSideEffectDataSource[0].averageScoreChartItems, { xaxis: app.localizer.resource.DbAvg });
                    if (selectedSiteRow != null) {
                        this.keyNumbersObject.siteScore = app.common.utils.precise_round(selectedSiteRow.average, 2);
                        this.keyNumbersObject.groups = selectedSiteRow.groups;
                        this.keyNumbersObject.vaccines = selectedSiteRow.vaccines;
                        this.keyNumbersObject.siteSamples = selectedSiteRow.sampleCount;
                    }
                    if (selectedDbAverageRow != null) {
                        this.keyNumbersObject.averageDbScore = app.common.utils.precise_round(selectedDbAverageRow.average, 2);
                        ;
                        this.keyNumbersObject.dbSamples = selectedDbAverageRow.sampleCount;
                    }
                    this.keyNumbersObject.typeName = this.selectedStageItem != null ? this.selectedStageItem.name : "";
                };
                BenchmarkingController.prototype.fillKeyNumbersForPercentilChartWhenDbAverageSerieIsSelected = function () {
                    this.keyNumbersObject.typeName = this.selectedStageItem.name;
                    var selectedDbPercentilRow = _.find(this.percentileSideEffectDataSource[0].perecentileChartItems, { xaxis: this.selectedCategory, legend: 'DbAverage' });
                    var selectedSitePercentilRow = _.find(this.percentileSideEffectDataSource[0].perecentileChartItems, { xaxis: this.selectedCategory, legend: this.siteName });
                    var siteItemsCollection = _.filter(this.percentileSideEffectDataSource[0].perecentileChartItems, { legend: this.siteName });
                    var dbAverageItemsCollection = _.filter(this.percentileSideEffectDataSource[0].perecentileChartItems, { legend: 'DbAverage' });
                    var totalDbSamples = _.sum(_.map(dbAverageItemsCollection, function (item) { return item.sampleCount; }));
                    var totalSiteSamples = _.sum(_.map(siteItemsCollection, function (item) { return item.sampleCount; }));
                    this.keyNumbersObject.attributeValue = this.selectedCategory;
                    if (selectedSitePercentilRow != undefined) {
                        this.keyNumbersObject.siteSamples = selectedSitePercentilRow.sampleCount.toString() + "/" + totalSiteSamples.toString();
                        this.keyNumbersObject.sitePercentage = app.common.utils.precise_round(selectedSitePercentilRow.average, 2);
                    }
                    if (selectedDbPercentilRow != undefined) {
                        this.keyNumbersObject.dbPercentage = app.common.utils.precise_round(selectedDbPercentilRow.average, 2);
                        ;
                        this.keyNumbersObject.dbSamples = selectedDbPercentilRow.sampleCount.toString() + "/" + totalDbSamples.toString();
                    }
                };
                BenchmarkingController.prototype.fillKeyNumbersForPercentilChartWhenSiteSerieIsSelected = function () {
                    this.keyNumbersObject.typeName = this.selectedStageItem != null ? this.selectedStageItem.name : "";
                    var selectedDbPercentilRow = _.find(this.percentileSideEffectDataSource[0].perecentileChartItems, { xaxis: this.selectedCategory, legend: 'DbAverage' });
                    var selectedSitePercentilRow = _.find(this.percentileSideEffectDataSource[0].perecentileChartItems, { xaxis: this.selectedCategory, legend: this.siteName });
                    var siteItemsCollection = _.filter(this.percentileSideEffectDataSource[0].perecentileChartItems, { legend: this.siteName });
                    var dbAverageItemsCollection = _.filter(this.percentileSideEffectDataSource[0].perecentileChartItems, { legend: 'DbAverage' });
                    var totalDbSamples = _.sum(_.map(dbAverageItemsCollection, function (item) { return item.sampleCount; }));
                    var totalSiteSamples = _.sum(_.map(siteItemsCollection, function (item) { return item.sampleCount; }));
                    this.keyNumbersObject.attributeValue = this.selectedCategory;
                    if (selectedSitePercentilRow != undefined) {
                        this.keyNumbersObject.siteSamples = selectedSitePercentilRow.sampleCount.toString() + "/" + totalSiteSamples.toString();
                        this.keyNumbersObject.sitePercentage = app.common.utils.precise_round(selectedSitePercentilRow.average, 2);
                        this.keyNumbersObject.groups = selectedSitePercentilRow.groups;
                        this.keyNumbersObject.vaccines = selectedSitePercentilRow.vaccines;
                    }
                    if (selectedDbPercentilRow != undefined) {
                        this.keyNumbersObject.dbPercentage = app.common.utils.precise_round(selectedDbPercentilRow.average, 2);
                        ;
                        this.keyNumbersObject.dbSamples = selectedDbPercentilRow.sampleCount.toString() + "/" + totalDbSamples.toString();
                    }
                };
                BenchmarkingController.prototype.isChartPercentilChart = function (chartTitle) {
                    return chartTitle === app.localizer.resource.PercentileVisceralMelaninChart || chartTitle === app.localizer.resource.PercentileParietalMelaninChart || chartTitle === app.localizer.resource.PercentileSpeilbergScoreChat;
                };
                BenchmarkingController.prototype.getPrecisionScoreKeyNumberFromService = function (yearMonth, comparisonItemValueKeyName) {
                    var _this = this;
                    var vaccines = this.vaccineContainer.getVaccineSelection();
                    return this.customerPortalDatacontext.getBenchMarkingPrecisionScoreDetail(this.precisionScoreComparisonTypeId, yearMonth, this.siteId, comparisonItemValueKeyName, vaccines).then(function (data) {
                        _this.mapPrecisionScoreKeyNumbers(yearMonth, comparisonItemValueKeyName, data);
                    });
                };
                BenchmarkingController.prototype.mapPrecisionScoreKeyNumbers = function (yearMonth, comparisonItemValueKeyName, data) {
                    this.keyNumbersObject = data[0].keyNumbers;
                    this.keyNumbersObject.numberOfSamples = this.precisionScoreChart.getNumberOfSamples(yearMonth, comparisonItemValueKeyName);
                    this.keyNumbersObject.databaseNumberOfSamples = this.precisionScoreChart.getDbNumberOfSamples(yearMonth, comparisonItemValueKeyName);
                    this.keyNumbersObject.assessments = data[0].assessments;
                    this.assessments = data[0].assessments;
                    this.precisionScoreChart.setKeyNumbersByYearMonthAndComparisonType(yearMonth, comparisonItemValueKeyName, this.keyNumbersObject);
                };
                BenchmarkingController.prototype.showKeyNumbers = function () {
                    this.selectedTooltipTAb = "KeyNumbers";
                };
                BenchmarkingController.prototype.showAssessments = function () {
                    this.selectedTooltipTAb = "Assessments";
                };
                BenchmarkingController.prototype.showMainChart = function () {
                    this.getNewChart(this.mainChartContainerSelector, this.highchartsData);
                };
                BenchmarkingController.prototype.showAvgChart = function () {
                    this.getNewChart(this.auxChartContainerSelector, this.avgDataChart);
                };
                BenchmarkingController.prototype.getNewChart = function (containerSelector, mainHighchartsData) {
                    var series = mainHighchartsData.series;
                    var chartTitle = mainHighchartsData.chartTitle;
                    var categories = mainHighchartsData.categories;
                    var yAxisTitle = mainHighchartsData.yAxisTitle;
                    var yAxisFormat = (mainHighchartsData.yAxisFormat != undefined && mainHighchartsData.yAxisFormat != null) ? mainHighchartsData.yAxisFormat : "{value} ";
                    var showLegend = (mainHighchartsData.showLegend != undefined && mainHighchartsData.showLegend != null) ? mainHighchartsData.showLegend : true;
                    var maxY = mainHighchartsData.maxYAxis === 0 ? 1 : mainHighchartsData.maxYAxis;
                    var self = this;
                    var isColumnSerie = function (serieName) {
                        var selectedSerie = _.filter(series, function (serie) { return (serie.name === serieName); })[0];
                        return (selectedSerie.type === app.constants.chartSerieTypes.column);
                    };
                    if (categories.length === 0)
                        return;
                    if ($(containerSelector).length <= 0)
                        return;
                    $(function () {
                        $(containerSelector).highcharts({
                            title: {
                                text: chartTitle
                            },
                            chart: {
                                events: {
                                    load: function (e) {
                                        self.selectedChart = e.target;
                                        self.setPopOverForColumnSeries();
                                        var tooltipOptions = self.selectedChart.options.tooltip;
                                        self.selectedChart.myTooltip = new Highcharts.Tooltip(self.selectedChart, tooltipOptions);
                                    }
                                }
                            },
                            tooltip: {
                                positioner: function (boxWidth, boxHeight, point) {
                                    var tooltip = this;
                                    var containerWidth = $(tooltip.chart.container).width();
                                    var plotX = (boxWidth + point.plotX < containerWidth) ? point.plotX : point.plotX - boxWidth;
                                    return { x: plotX, y: point.plotY };
                                },
                                borderColor: 'black',
                                enabled: false
                            },
                            xAxis: {
                                categories: categories
                            },
                            yAxis: {
                                min: mainHighchartsData.minYaxis,
                                max: maxY,
                                title: {
                                    text: yAxisTitle
                                },
                                labels: {
                                    format: yAxisFormat
                                }
                            },
                            exporting: {
                                buttons: {
                                    contextButton: {
                                        menuItems: [{
                                                text: app.localizer.resource.Print,
                                                onclick: function () { self.print(); }
                                            }]
                                    }
                                }
                            },
                            legend: { enabled: showLegend },
                            plotOptions: {
                                series: {
                                    stickyTracking: false,
                                    minPointLength: 3,
                                    events: {
                                        click: function (event) {
                                            var isColumSerie = (event.target.id.search("benchmarking") !== -1);
                                            if (!isColumSerie) {
                                                self.selectedChart.myTooltip.refresh(event.point, event);
                                            }
                                        },
                                        mouseOut: function () {
                                            self.selectedChart.myTooltip.hide();
                                        }
                                    },
                                    point: {
                                        events: {
                                            click: function (event) {
                                                if (isColumnSerie(this.series.name)) {
                                                    if (!self.blockPopoverClick) {
                                                        var idnumber = $(event.target).attr('id').split('_')[1];
                                                        _.forEach($("[id^='benchmarkingPopoverId']"), function (item) {
                                                            if ($(item).attr('id').split('_')[1] !== idnumber) {
                                                                self.blockPopoverClick = true;
                                                                $('#benchmarkingPopoverTriggerId_' + $(item).attr('id').split('_')[1]).trigger('click');
                                                            }
                                                        });
                                                        self.intililizeGridHeaders();
                                                        self.selectedSerie = this.series.name;
                                                        self.selectedCategory = this.category;
                                                        if (self.canShowPopOver(this.series.name)) {
                                                            self.loadTooltip(chartTitle);
                                                        }
                                                    }
                                                    else {
                                                        self.blockPopoverClick = false;
                                                    }
                                                }
                                            },
                                            mouseOut: function () {
                                                this.series.chart.pointer.prevKDPoint = null;
                                            }
                                        }
                                    }
                                },
                                column: {
                                    threshold: null
                                }
                            },
                            series: series,
                            credits: { enabled: false }
                        }, function (chart) { });
                    });
                    this.getKeyNumbers();
                };
                BenchmarkingController.prototype.setPopOverForColumnSeries = function () {
                    var _this = this;
                    var toolTipTemplate = this.getToolTipTemplate();
                    var columns = $('.highcharts-tracker > rect');
                    $.each(columns, function (i, c) {
                        var columnSerie = $(c);
                        if (columnSerie.attr('bs-popover') === undefined) {
                            columnSerie.attr('data-content', i);
                            columnSerie.attr('id', 'benchmarkingPopoverTriggerId_' + i);
                            columnSerie.attr('data-placement', 'bottom');
                            columnSerie.attr('data-container', 'body');
                            columnSerie.attr('bs-popover', '');
                            columnSerie.attr('data-trigger', 'click');
                            columnSerie.attr('data-autoClose', 'false');
                            columnSerie.attr('data-template', toolTipTemplate);
                            _this.$compile(columnSerie)(_this.$scope);
                        }
                    });
                };
                BenchmarkingController.prototype.print = function () {
                    if (this.percentileSideEffectIsSelected() === true)
                        this.printPercentileCharts();
                    else
                        this.printSingleChart();
                };
                BenchmarkingController.prototype.printPercentileCharts = function () {
                    var mainChart = $(this.mainChartContainerSelector).highcharts();
                    var auxChart = $(this.auxChartContainerSelector).highcharts();
                    var currentWidthMainchart = mainChart.chartWidth;
                    var currentHeightMainChart = mainChart.chartHeight;
                    var currentWidthAuxChart = auxChart.chartWidth;
                    var currentHeightAuxChart = auxChart.chartHeight;
                    var that = this;
                    var popUpAndPrint = function () {
                        var width = 1000;
                        var height = 500;
                        mainChart.setSize(width, height, false);
                        auxChart.setSize(width, height, false);
                        var mainChartContainer = $(that.mainChartContainerSelector).clone();
                        mainChartContainer.css('height', '50%');
                        var auxChartContainer = $(that.auxChartContainerSelector).clone();
                        var mainKeyNumbersPrint = $('#mainKeyNumbersPrint').clone();
                        mainKeyNumbersPrint.css('height', '50%');
                        mainKeyNumbersPrint.attr("display", "inline");
                        var auxKeyNumbersPrint = $('#auxNumbersPrint').clone();
                        auxKeyNumbersPrint.css('height', '50%');
                        auxKeyNumbersPrint.attr("display", "inline");
                        mainChart.setSize(currentWidthMainchart, currentHeightMainChart, false);
                        auxChart.setSize(currentWidthAuxChart, currentHeightAuxChart, false);
                        var printWindow = window.open('', 'PrintMap', 'width=' + width + ',height=' + height);
                        printWindow.document.write('<html><head><title></title></head><body>');
                        printWindow.document.writeln(mainChartContainer.html());
                        printWindow.document.writeln(mainKeyNumbersPrint.html());
                        printWindow.document.writeln(auxChartContainer.html());
                        printWindow.document.writeln(auxKeyNumbersPrint.html());
                        printWindow.document.write('</body></html>');
                        printWindow.document.close();
                        setTimeout(function () { printWindow.print(); printWindow.close(); }, 500);
                    };
                    setTimeout(popUpAndPrint, 500);
                };
                BenchmarkingController.prototype.printSingleChart = function () {
                    var mainChart = $(this.mainChartContainerSelector).highcharts();
                    var currentWidthMainchart = mainChart.chartWidth;
                    var currentHeightMainChart = mainChart.chartHeight;
                    var that = this;
                    var popUpAndPrint = function () {
                        var width = 1000;
                        var height = 500;
                        mainChart.setSize(width, height, false);
                        var mainChartContainer = $(that.mainChartContainerSelector).clone();
                        mainChartContainer.css('height', '50%');
                        var mainKeyNumbersPrint = $('#mainKeyNumbersPrint').clone();
                        mainKeyNumbersPrint.css('height', '50%');
                        mainKeyNumbersPrint.attr("display", "inline");
                        mainChart.setSize(currentWidthMainchart, currentHeightMainChart, false);
                        var printWindow = window.open('', 'PrintMap', 'width=' + width + ',height=' + height);
                        printWindow.document.write('<html><head><title></title></head><body>');
                        printWindow.document.writeln(mainChartContainer.html());
                        printWindow.document.writeln(mainKeyNumbersPrint.html());
                        printWindow.document.write('</body></html>');
                        printWindow.document.close();
                        setTimeout(function () { printWindow.print(); printWindow.close(); }, 500);
                    };
                    setTimeout(popUpAndPrint, 500);
                };
                BenchmarkingController.prototype.keyNumberLoaded = function () {
                    return this.keyNumbers != null;
                };
                BenchmarkingController.prototype.avgKeyNumberLoaded = function () {
                    return this.avgKeyNumbers != null;
                };
                BenchmarkingController.prototype.getKeyNumbersRows = function () {
                    return this.keyNumberLoaded() ? this.keyNumbers.rows : [];
                };
                BenchmarkingController.prototype.getAvgKeyNumbersRows = function () {
                    return this.avgKeyNumberLoaded() ? this.avgKeyNumbers.rows : [];
                };
                BenchmarkingController.prototype.getKeyNumbersRowsFirstOrDefault = function () {
                    var rows = this.getKeyNumbersRows();
                    var defaultRow = rows.length > 0 ? rows[0] : null;
                    return defaultRow;
                };
                BenchmarkingController.prototype.getAverageValue = function (propertyName) {
                    return this.getKeyNumbersRowsFirstOrDefault().getTotalAvgValue(propertyName);
                };
                BenchmarkingController.prototype.showAvgRowSummary = function () {
                    return (this.precisionScoreChartIsSelected() && this.precisionScoreComparisonTypeId != app.constants.precisionScoreComparisonTypes.VaccinationCrew && this.getKeyNumbersRowsFirstOrDefault() != null);
                };
                BenchmarkingController.prototype.getKeyNumberHeaders = function () {
                    return this.keyNumberLoaded() ? this.keyNumbers.headers : [];
                };
                BenchmarkingController.prototype.getAvgKeyNumberHeaders = function () {
                    return this.avgKeyNumberLoaded() ? this.avgKeyNumbers.headers : [];
                };
                BenchmarkingController.prototype.getKeyNumbers = function () {
                    if (this.precisionScoreChartIsSelected()) {
                        this.keyNumbers = this.precisionScoreChart.getKeyNumbersTable();
                    }
                    else if (this.sideEffectsChartIsSelected()) {
                        this.keyNumbers = this.sideEffectData.getKeyNumbersTable();
                    }
                    else if (this.percentileSideEffectIsSelected()) {
                        this.keyNumbers = this.percentilSideEffectData.getKeyNumbersTable();
                        this.avgKeyNumbers = this.averageSideEffectsScoreChart.getKeyNumbersTable();
                    }
                };
                BenchmarkingController.$inject = ['$scope', '$compile', '$q', 'customerPortalDatacontext', 'navigationService'];
                return BenchmarkingController;
            })();
            controllers.BenchmarkingController = BenchmarkingController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("BenchmarkingController", ['$scope', '$compile', '$q', 'customerPortalDatacontext', 'navigationService']);

/// <reference path="../../_typings.web.ts" />
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var benchmarking;
            (function (benchmarking) {
                var lookupContainer = (function () {
                    function lookupContainer() {
                        this.precisionDatePresetRanges = [];
                        this.loadLookups();
                    }
                    lookupContainer.prototype.loadLookups = function () {
                        this.loadChartTypes();
                        this.loadStages();
                        this.loadPrecisionScoreComparisonTypes();
                    };
                    lookupContainer.prototype.loadChartTypes = function () {
                        this.chartTypes = [
                            { value: app.constants.chartTypes.precisionScore, name: app.localizer.resource.PrecisionScoreChart },
                            { value: app.constants.chartTypes.visceralMelanin, name: app.localizer.resource.VisceralMelaninChart },
                            { value: app.constants.chartTypes.percentileVisceralMelanin, name: app.localizer.resource.PercentileVisceralMelaninChart },
                            { value: app.constants.chartTypes.parietalMelanin, name: app.localizer.resource.ParietalMelaninChart },
                            { value: app.constants.chartTypes.percentileParietalMelanin, name: app.localizer.resource.PercentileParietalMelaninChart },
                            { value: app.constants.chartTypes.speilbergScore, name: app.localizer.resource.SpeilbergScoreChat },
                            { value: app.constants.chartTypes.percentileSpeilbergScore, name: app.localizer.resource.PercentileSpeilbergScoreChat }
                        ];
                    };
                    lookupContainer.prototype.loadStages = function () {
                        this.stages = [
                            { value: app.constants.chartStageTypes.harvest, name: app.localizer.resource.HarvestStage },
                            { value: app.constants.chartStageTypes.preTransfer, name: app.localizer.resource.PreTransferStage },
                            { value: app.constants.chartStageTypes.seaWater, name: app.localizer.resource.SeaWaterStage }
                        ];
                    };
                    lookupContainer.prototype.loadPrecisionScoreComparisonTypes = function () {
                        this.precisionScoreComparisonTypes = [
                            { value: app.constants.precisionScoreComparisonTypes.vaccinationMethod, name: app.localizer.resource.VaccinationMethod },
                            { value: app.constants.precisionScoreComparisonTypes.MachineType, name: app.localizer.resource.TypeOfMachine },
                            { value: app.constants.precisionScoreComparisonTypes.VaccinationCrew, name: app.localizer.resource.VaccinationCrew }
                        ];
                    };
                    lookupContainer.prototype.setPrecisionDatePresetRanges = function () {
                        this.precisionDatePresetRanges[app.localizer.resource.ThisMonth] = [moment().startOf('month'), moment().endOf('month')];
                        this.precisionDatePresetRanges[app.localizer.resource.ThisYear] = [moment().startOf('year'), moment().endOf('month')];
                        this.precisionDatePresetRanges[app.localizer.resource.ThisYearAndLast] = [moment().subtract(1, 'year').startOf('year'), moment().endOf('month')];
                        this.precisionDatePresetRanges[app.localizer.resource.ThisYearAndTwoLast] = [moment().subtract(2, 'year').startOf('year'), moment().endOf('month')];
                        this.precisionDatePresetRanges[app.localizer.resource.ThisYearAndThreeLast] = [moment().subtract(3, 'year').startOf('year'), moment().endOf('month')];
                    };
                    lookupContainer.prototype.getStages = function () { return this.stages; };
                    lookupContainer.prototype.getChartTypes = function () { return this.chartTypes; };
                    lookupContainer.prototype.getPrecisionScoreComparisonTypes = function () { return this.precisionScoreComparisonTypes; };
                    lookupContainer.prototype.getPrecisionDatePresetRanges = function () { return this.precisionDatePresetRanges; };
                    return lookupContainer;
                })();
                benchmarking.lookupContainer = lookupContainer;
            })(benchmarking = controllers.benchmarking || (controllers.benchmarking = {}));
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

/// <reference path="../../_typings.web.ts" />
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var benchmarking;
            (function (benchmarking) {
                var asessmentGroupContainer = (function () {
                    function asessmentGroupContainer(asessmentGroupsBySite) {
                        this.assessmentGroupsDataSource = [];
                        this.selectedAssessmentGroups = [];
                        this.assessmentGroupsDataSource = asessmentGroupsBySite;
                    }
                    asessmentGroupContainer.prototype.loadAssessmentGroups = function () {
                        var _this = this;
                        var tempList = [];
                        this.allAssessmentGroups = this.assessmentGroupsDataSource;
                        var discriminators = _.map(this.allAssessmentGroups, function (grp) { return new web.model.assessmentGroup(grp); });
                        var distinct = [];
                        _.forEach(discriminators, function (dis) { var found = _.some(distinct, function (item) { return item === dis.assessmentDiscriminator_main; }); if (found)
                            return;
                        else
                            distinct.push(dis.assessmentDiscriminator_main); });
                        this.allAssessmentGroups = [];
                        this.allAssessmentGroups = discriminators;
                        this.assessmentGroups = distinct;
                        tempList = [];
                        _.forEach(this.assessmentGroups, function (assessmentDiscriminator) { tempList.push(new web.model.DropdownOption(assessmentDiscriminator, assessmentDiscriminator, null, "benchmark", false)); });
                        this.selectedAssessmentGroups.length = 0;
                        if (!this.assessmentGroupFilter) {
                            this.assessmentGroupFilter = new web.directives.Filter("Assessment Group", app.localizer.resource.Filter_Group.toLowerCase(), tempList, this.selectedAssessmentGroups, false, false, true, false);
                        }
                        else {
                            this.assessmentGroupFilter.list.length = 0;
                            angular.forEach(tempList, function (item) { _this.assessmentGroupFilter.list.push(item); });
                        }
                    };
                    asessmentGroupContainer.prototype.assessmentGroupsAreNotSelected = function () {
                        return (this.selectedAssessmentGroups === undefined || this.selectedAssessmentGroups === null || this.selectedAssessmentGroups.length === 0);
                    };
                    asessmentGroupContainer.prototype.getAssessmentGroupSelection = function () {
                        return this.assessmentGroupsAreNotSelected() ? this.setAssessmentGroupSelection(this.assessmentGroups) : this.setAssessmentGroupSelection(this.selectedAssessmentGroups);
                    };
                    asessmentGroupContainer.prototype.setAssessmentGroupSelection = function (assessmentGroups) {
                        var _this = this;
                        if (this.assessmentGroups == null || this.assessmentGroups.length === 0)
                            return;
                        var newselection = [];
                        _.forEach(assessmentGroups, function (dis) {
                            _.forEach(_this.allAssessmentGroups, function (grp) { if (dis === grp.assessmentDiscriminator_main) {
                                newselection.push(grp.assessmentDiscriminator);
                            } });
                        });
                        return newselection.join(",");
                    };
                    asessmentGroupContainer.prototype.hasAssessmentGroups = function () {
                        return this.assessmentGroupFilter.list.length > 0;
                    };
                    return asessmentGroupContainer;
                })();
                benchmarking.asessmentGroupContainer = asessmentGroupContainer;
            })(benchmarking = controllers.benchmarking || (controllers.benchmarking = {}));
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var benchmarking;
            (function (benchmarking) {
                var vaccineContainer = (function () {
                    function vaccineContainer(sideEffectVaccines, precisionVaccines) {
                        this.sideEffectVaccines = [];
                        this.precisionVaccines = [];
                        this.vaccines = [];
                        this.selectedVaccines = [];
                        this.sideEffectVaccines = sideEffectVaccines;
                        this.precisionVaccines = precisionVaccines;
                    }
                    vaccineContainer.prototype.loadSideEffectVaccines = function () {
                        var _this = this;
                        var tempList = [];
                        this.vaccines = this.sideEffectVaccines;
                        _.forEach(this.vaccines, function (item) { tempList.push(new web.model.DropdownOption(item.vaccine, item.vaccine, null, "benchmark", false)); });
                        this.selectedVaccines.length = 0;
                        if (!this.vaccineFilter) {
                            this.vaccineFilter = new web.directives.Filter("Vaccines", app.localizer.resource.Vaccines.toLowerCase(), tempList, this.selectedVaccines, false, false, true, false);
                        }
                        else {
                            this.vaccineFilter.list.length = 0;
                            angular.forEach(tempList, function (item) { _this.vaccineFilter.list.push(item); });
                        }
                    };
                    vaccineContainer.prototype.loadPrecisionVaccines = function (fromDate, toDate) {
                        var _this = this;
                        var vaccineDataSource = this.precisionVaccines;
                        var tempList = [];
                        this.vaccines = vaccineDataSource.filter(function (v) {
                            var dates = v.assessmentDates.split(",");
                            dates = dates.map(function (d) { return moment(d); });
                            var datesInRange = dates.filter(function (d) { return d >= fromDate && d <= toDate; });
                            return datesInRange.length > 0;
                        });
                        _.forEach(this.vaccines, function (item) { tempList.push(new web.model.DropdownOption(item.vaccine, item.vaccine, null, "benchmark", false)); });
                        this.selectedVaccines.length = 0;
                        if (!this.vaccineFilter) {
                            this.vaccineFilter = new web.directives.Filter("Vaccines", app.localizer.resource.Vaccines.toLowerCase(), tempList, this.selectedVaccines, false, false, true, false);
                        }
                        else {
                            this.vaccineFilter.list.length = 0;
                            angular.forEach(tempList, function (item) {
                                _this.vaccineFilter.list.push(item);
                            });
                        }
                    };
                    vaccineContainer.prototype.hasVaccines = function () {
                        return this.vaccineFilter.list.length > 0;
                    };
                    vaccineContainer.prototype.vaccinesAreNotSelected = function () {
                        return (this.selectedVaccines === undefined || this.selectedVaccines === null || this.selectedVaccines.length === 0);
                    };
                    vaccineContainer.prototype.getVaccineSelection = function () {
                        return this.vaccinesAreNotSelected() ? this.vaccines.map(function (v) { return v.vaccine; }).toString() : this.selectedVaccines.toString();
                    };
                    return vaccineContainer;
                })();
                benchmarking.vaccineContainer = vaccineContainer;
            })(benchmarking = controllers.benchmarking || (controllers.benchmarking = {}));
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var LockingController = (function () {
                function LockingController($scope, $translate, authenticationService, datacontext, appLocalStorage) {
                    this.$scope = $scope;
                    this.$translate = $translate;
                    this.authenticationService = authenticationService;
                    this.datacontext = datacontext;
                    this.appLocalStorage = appLocalStorage;
                    this.comment = '';
                    this.auditType = app.constants.auditTypes.Lock;
                    this.setMessages();
                }
                LockingController.prototype.setMessages = function () {
                    var auditType = this.$translate.instant(this.$scope.ngDialogData.getTypeAsString()).toLowerCase();
                    if (this.$scope.ngDialogData.isLocked) {
                        this.auditType = app.constants.auditTypes.Unlock;
                        this.headerText = app.localizer.resource.Locking_Unlock_Title.format(auditType);
                        this.message = app.localizer.resource.Locking_Unlock_Message.format(auditType);
                    }
                    else {
                        this.headerText = app.localizer.resource.Locking_Lock_Title.format(auditType);
                        this.message = app.localizer.resource.Locking_Lock_Message.format(auditType);
                    }
                };
                LockingController.prototype.submit = function () {
                    this.$scope.confirm(this.comment);
                };
                LockingController.prototype.isLocking = function () {
                    return this.auditType === app.constants.auditTypes.Lock;
                };
                LockingController.$inject = ['$scope', '$translate', 'authenticationService', 'assessmentDatacontext', 'appLocalStorage'];
                return LockingController;
            })();
            controllers.LockingController = LockingController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("LockingController", ['$scope', '$translate', 'authenticationService', 'assessmentDatacontext', 'appLocalStorage']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var AssessmentHistoryController = (function () {
                function AssessmentHistoryController($scope, authenticationService, assessmentDatacontext, modalService) {
                    var _this = this;
                    this.$scope = $scope;
                    this.authenticationService = authenticationService;
                    this.assessmentDatacontext = assessmentDatacontext;
                    this.modalService = modalService;
                    this.headerText = 'Title_AssessmentHistory';
                    this.lockingHistoryData = this.$scope.ngDialogData;
                    this.headers = [
                        {
                            name: 'Status', text: app.localizer.resource.Status, colSpan: 1, html: false, propertyName: 'auditTypeName'
                        },
                        {
                            name: 'Date', text: app.localizer.resource.Date, colSpan: 1, html: false, propertyName: 'auditDate'
                        },
                        {
                            name: 'User', text: app.localizer.resource.User, colSpan: 1, html: false, propertyName: 'userFullName'
                        },
                        {
                            name: 'Comment', text: app.localizer.resource.Comment, colSpan: 1, html: false, propertyName: 'comment'
                        },
                        {
                            name: 'Report', text: app.localizer.resource.Report, colSpan: 1, html: true, openPdf: function (auditId) { _this.openPdf(auditId); }
                        }];
                    this.initFilterList();
                }
                AssessmentHistoryController.prototype.openPdf = function (auditId) {
                    this.modalService.show('modules/report/report.html', app.constants.dialogSize.large, '', this.$scope, function () { }, new app.web.services.ReportData(this.lockingHistoryData.key, this.lockingHistoryData.type, this.lockingHistoryData.reportTitle, false, this.lockingHistoryData.reportTitle + ".pdf", auditId));
                };
                AssessmentHistoryController.prototype.initFilterList = function () {
                    this.filterList = new Array();
                    var auditTypes = this.assessmentDatacontext.getAuditTypes();
                    var optionList = new Array();
                    angular.forEach(auditTypes, function (auditType) {
                        optionList.push(new web.model.DropdownOption(app.localizer.resource["AuditType_" + auditType.name.trim()], auditType.auditingTypeId, 0, app.constants.auditProperties.auditingType, false));
                    });
                    var filter = new web.directives.Filter(app.constants.auditProperties.auditingType, 'Filter_AuditType', optionList, [], false, false);
                    this.filterList.push(filter);
                };
                AssessmentHistoryController.prototype.loadMore = function () {
                    return this.assessmentDatacontext.getAuditDtos(this.lockingHistoryData.type == app.enums.entityType.Assessment ? 'Assessment' : 'Prescription', this.lockingHistoryData.key, this.filterList[0].selectedIds);
                };
                AssessmentHistoryController.$inject = ['$scope', 'authenticationService', 'assessmentDatacontext', 'modalService'];
                return AssessmentHistoryController;
            })();
            controllers.AssessmentHistoryController = AssessmentHistoryController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("AssessmentHistoryController", ['$scope', 'authenticationService', 'assessmentDatacontext', 'modalService']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var ReportController = (function () {
                function ReportController($scope, $q, $http, $timeout, $window, $element, datacontext, appLocalStorage, fileSaver) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$q = $q;
                    this.$http = $http;
                    this.$timeout = $timeout;
                    this.$window = $window;
                    this.$element = $element;
                    this.datacontext = datacontext;
                    this.appLocalStorage = appLocalStorage;
                    this.fileSaver = fileSaver;
                    this.headerText = app.localizer.resource.Title_AssessmentReport;
                    this.previousState = "portrait";
                    this.landscape = "landscape";
                    this.portrait = "portrait";
                    this.landscapeZoom = 1.15;
                    this.portraitZoom = 1.25;
                    this.landscapeHeight = 700;
                    this.portraitHeight = 1080;
                    this.landscapeWidth = 1040;
                    this.portraitWidth = 840;
                    this.isReportNotFound = false;
                    this.dialogData = this.$scope.ngDialogData;
                    this.generateReport = this.dialogData.generateReport;
                    if (this.$scope.ngDialogData.title != null)
                        this.headerText = this.$scope.ngDialogData.title;
                    if (this.dialogData.type === app.enums.entityType.Assessment) {
                        if (this.dialogData.generateReport) {
                            var languageId = this.datacontext
                                .getLanguageId(this.appLocalStorage.applicationStatusGet().translationsCulture);
                            this.reportUrl = datacontext
                                .getGenerateReportUrl(this.dialogData.key, languageId, this.dialogData.title);
                            this.dialogData.generateReport = false;
                        }
                        else {
                            this.reportUrl = datacontext
                                .getLockedReportUrl(this.dialogData.key, this.dialogData.fullName, this.dialogData.auditId, this.dialogData.currentUserId);
                        }
                    }
                    else {
                        var languageId1 = this.datacontext
                            .getLanguageId(this.appLocalStorage.applicationStatusGet().translationsCulture);
                        this.reportUrl = datacontext
                            .getPrescriptionReportUrl(this.dialogData.key, languageId1, this.dialogData.title);
                    }
                    angular.element($window).bind('resize', function () {
                        _this.resizePdfViewer();
                    });
                    this.loadReport();
                }
                ReportController.prototype.resizePdfViewer = function () {
                    var _this = this;
                    this.$timeout(function () {
                        _this.$element.find('#my-pdf-viewer').css('height', parseInt(_this.$element.find('#my-pdf-viewer').parent().css('height')) - 60);
                    }, 1);
                };
                ReportController.prototype.changeView = function (view) {
                    var _this = this;
                    if (this.previousState !== view) {
                        this.previousState = view;
                        return this.$scope.myPdfViewer.setWidth(view === this.portrait ? this.portraitWidth : this.landscapeWidth).then(function () {
                            return _this.$scope.myPdfViewer.setHeight(view === _this.portrait ? _this.portraitHeight : _this.landscapeHeight).then(function () {
                                return _this.$scope.myPdfViewer.zoomTo(view === _this.portrait ? _this.portraitZoom : _this.landscapeZoom).then(function () {
                                    _this.$element.parent().animate({ width: (view === _this.portrait ? '-=300px' : '+=300px') });
                                });
                            });
                        });
                    }
                    return this.$q.when();
                };
                ReportController.prototype.selectPage = function (pageNumber) {
                    var _this = this;
                    this.isRendering = true;
                    return this.$scope.myPdfViewer.goToPage(pageNumber).then(function () {
                        return _this.$scope.myPdfViewer.getDocument().getPage(_this.$scope.myPdfViewer.page).then(function (page) {
                            if (page.view[2] > page.view[3]) {
                                return _this.changeView(_this.landscape);
                            }
                            else {
                                return _this.changeView(_this.portrait);
                            }
                        });
                    }).then(function () {
                        _this.isRendering = false;
                    });
                };
                ReportController.prototype.saveReport = function () {
                    this.fileSaver.saveAs(this.report, this.fileName);
                };
                ReportController.prototype.loadReport = function () {
                    var _this = this;
                    return this.$http({
                        url: this.reportUrl,
                        method: 'GET',
                        responseType: 'arraybuffer',
                        data: {},
                        headers: {
                            'Content-type': 'application/json',
                            'Accept': 'application/pdf'
                        }
                    }).then(function (result) {
                        _this.isReportNotFound = false;
                        _this.report = new Blob([result.data], { type: 'application/pdf' });
                        _this.fileName = decodeURIComponent(result.headers("Content-Disposition").replace("inline; filename=", ""));
                        _this.isRendering = true;
                        return _this.$scope.myPdfViewer.loadDocument(URL.createObjectURL(_this.report)).then(function () {
                            var tempPages = [];
                            for (var i = 1; i <= _this.$scope.myPdfViewer.total; i++) {
                                tempPages.push(i);
                            }
                            _this.pages = tempPages;
                            return _this.$scope.myPdfViewer.zoomTo(_this.portraitZoom).then(function () {
                                return _this.$scope.myPdfViewer.setWidth(_this.portraitWidth).then(function () {
                                    return _this.$scope.myPdfViewer.setHeight(_this.portraitHeight).then(function () {
                                        _this.isRendering = false;
                                        _this.$element.find('#my-pdf-viewer').children('div').css('overflow-y', 'auto !important'); /*set here after report is created because of safari issue*/
                                        _this.resizePdfViewer();
                                    });
                                });
                            });
                        });
                    }).catch(function (error) {
                        var status = error.status;
                        if (status && status == "404") {
                            _this.isReportNotFound = true;
                        }
                        else {
                            throw error;
                        }
                    });
                };
                ReportController.$inject = ['$scope', '$q', '$http', '$timeout', '$window', '$element', 'assessmentDatacontext', 'appLocalStorage', 'FileSaver'];
                return ReportController;
            })();
            controllers.ReportController = ReportController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("ReportController", ['$scope', '$q', '$http', '$timeout', '$window', '$element', 'assessmentDatacontext', 'appLocalStorage', 'FileSaver']);

/// <reference path="../../_typings.web.ts"/>
"use strict";
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var PrepareReportController = (function () {
                function PrepareReportController($scope, authenticationService, prescriptionDatacontext, assessmentDatacontext, navigationService, supplierDatacontext, userManagementDatacontext, $filter, $q, busyIndicator, $http, $timeout, $element, fileSaver, appLocalStorage) {
                    var _this = this;
                    this.$scope = $scope;
                    this.authenticationService = authenticationService;
                    this.prescriptionDatacontext = prescriptionDatacontext;
                    this.assessmentDatacontext = assessmentDatacontext;
                    this.navigationService = navigationService;
                    this.supplierDatacontext = supplierDatacontext;
                    this.userManagementDatacontext = userManagementDatacontext;
                    this.$filter = $filter;
                    this.$q = $q;
                    this.busyIndicator = busyIndicator;
                    this.$http = $http;
                    this.$timeout = $timeout;
                    this.$element = $element;
                    this.fileSaver = fileSaver;
                    this.appLocalStorage = appLocalStorage;
                    this.isMedicationPerUser = false;
                    this.isMedicationPerCustomer = false;
                    this.showFilters = false;
                    this.previousState = "portrait";
                    this.landscape = "landscape";
                    this.portrait = "portrait";
                    this.landscapeZoom = 1;
                    this.portraitZoom = 1;
                    this.landscapeHeight = 630;
                    this.portraitHeight = 891;
                    this.landscapeWidth = 891;
                    this.portraitWidth = 630;
                    this.modalInitWidth = -1;
                    this.MAX_WIDTH_PX = 1782;
                    // private MAX_HEIGHT_PX = 1260;
                    this.FILTER_WIDTH_PX = 217;
                    this.OFFSET_PX = 10;
                    this.A4_LANDSCAPE_WIDTH = 891;
                    this.A4_LANDSCAPE_HEIGHT = 630;
                    // 15*2 is 2 padding of modal, 200 + 10 is left margin's filter and filters, 20 is pdviewer's left margin.
                    this.notPdfViewerWidth = 15 * 2 + (200 + 10) + 20;
                    this.showUsersFilter = false;
                    this.isMedicationPerUser =
                        this.$scope.ngDialogData.type.toLowerCase() === "user";
                    this.isMedicationPerCustomer =
                        this.$scope.ngDialogData.type.toLowerCase() === "customer";
                    this.dateRange =
                        this.$scope.ngDialogData.dateRange ||
                            new controllers.DateRange(moment().months(-4).startOf("month"), moment().endOf("month"));
                    this.sites = this.$scope.ngDialogData.sites;
                    this.treatmentProducts = this.$scope.ngDialogData.treatmentProducts;
                    var user = JSON.parse(this.appLocalStorage.loggedInUserGet());
                    if (!app.common.utils.isNullOrUndefinedOrEmpty(user["Role"]))
                        this.showUsersFilter = ["Developer", "Host", "Administrator"].indexOf(user["Role"]) > -1;
                    if (this.isMedicationPerUser === true) {
                        this.filterList = this.initFilterList("User");
                    }
                    else if (this.isMedicationPerCustomer === true) {
                        this.filterList = this.initFilterList("Customer");
                    }
                    this.pages = [];
                    // wait until modal is showing
                    setTimeout(function () {
                        var initPdfViewerWith = _this.$element.width() - _this.notPdfViewerWidth;
                        _this.$element.find("#pdf-view-zone").css("width", initPdfViewerWith);
                    }, 200);
                }
                PrepareReportController.prototype.showReport = function () {
                    var _this = this;
                    this.isRendering = true;
                    var uri = "";
                    var parameters2Export;
                    var apiParams = {
                        User: ["listUsers", "listTreatmentProducts", "listSuppliers"],
                        Customer: ["listCustomers", "listSites", "listActiveSubstances"]
                    };
                    if (this.isMedicationPerUser) {
                        parameters2Export = this.retrieveUrlParams(this.dateRange, this.filterList, apiParams.User);
                        uri = this.assessmentDatacontext.getGenerateMedicationPerUserReportUrl(parameters2Export);
                    }
                    else if (this.isMedicationPerCustomer) {
                        parameters2Export = this.retrieveUrlParams(this.dateRange, this.filterList, apiParams.Customer);
                        uri = this.assessmentDatacontext.getGenerateMedicationPerCustomerReportUrl(parameters2Export);
                    }
                    if (!app.common.utils.isNullOrUndefinedOrEmpty(uri)) {
                        this.loadReport(uri).then(function (d) {
                            _this.selectPage(1);
                        });
                    }
                };
                PrepareReportController.prototype.retrieveUrlParams = function (dateRange, listFilter, apiParams) {
                    if (apiParams === void 0) { apiParams = []; }
                    var param = [];
                    var selectedFilter, chosenIdsArray;
                    param.push("startDate=" + dateRange.startDate.format("YYYY-MM-DD"));
                    param.push("endDate=" + dateRange.endDate.format("YYYY-MM-DD"));
                    apiParams.forEach(function (apiParam, index) {
                        if (!app.common.utils.isNullOrUndefined(listFilter)) {
                            // console.log("run here 1");
                            selectedFilter = listFilter.filter(function (f) {
                                // console.log("run here 2");
                                return f.order === index;
                            });
                        }
                        else
                            selectedFilter = [];
                        if (selectedFilter !== [] && selectedFilter.length === 1) {
                            // console.log("run here 3");
                            chosenIdsArray = selectedFilter[0].filter.selectedIds;
                            // console.log("run here 4");
                            chosenIdsArray.forEach(function (id) {
                                // console.log("run here 5");
                                param.push(apiParam + "=" + id);
                            });
                        }
                    });
                    var appStatus = this.appLocalStorage.applicationStatusGet();
                    var appLanguage = _.isEmpty(appStatus.translationsCulture)
                        ? "en-gb"
                        : appStatus.translationsCulture;
                    param.push("languageCode=" + appLanguage);
                    return param.join("&");
                };
                //#region  Report
                PrepareReportController.prototype.loadReport = function (reportUrl) {
                    var _this = this;
                    return this.$http({
                        url: reportUrl,
                        method: "GET",
                        responseType: "arraybuffer",
                        data: {},
                        headers: {
                            "Content-type": "application/json",
                            Accept: "application/pdf"
                        }
                    })
                        .then(function (result) {
                        _this.report = new Blob([result.data], { type: "application/pdf" });
                        _this.fileName = decodeURIComponent(result.headers("Content-Disposition").replace("inline; filename=", ""));
                        return _this.$scope.medicationPdfViewer.loadDocument(URL.createObjectURL(_this.report)).then(function () {
                            var pages = [];
                            for (var i = 1; i <= _this.$scope.medicationPdfViewer.total; i++) {
                                pages.push(i);
                            }
                            _this.pages = pages;
                            if (_this.modalInitWidth === -1)
                                _this.modalInitWidth = _this.$element.width();
                            _this.$element.parent().animate({ width: _this.modalInitWidth });
                            _this.previousState = _this.portrait;
                        });
                    })
                        .catch(function (error) {
                        throw error;
                    });
                };
                PrepareReportController.prototype.selectPage = function (pageNumber) {
                    var _this = this;
                    this.isRendering = true;
                    try {
                        return this.$scope.medicationPdfViewer
                            .goToPage(pageNumber)
                            .then(function () {
                            var document = _this.$scope.medicationPdfViewer.getDocument();
                            if (!app.common.utils.isNullOrUndefined(document)) {
                                return document.getPage(_this.$scope.medicationPdfViewer.page)
                                    .then(function (page) {
                                    if (page.view[2] > page.view[3]) {
                                        //landscape
                                        return _this.changeView('landscape');
                                    }
                                    else {
                                        return _this.changeView('portrait');
                                    }
                                });
                            }
                        });
                    }
                    catch (error) {
                        throw error;
                    }
                    finally {
                        this.isRendering = false;
                    }
                };
                PrepareReportController.prototype.changeView = function (view) {
                    if (this.previousState !== view) {
                        this.previousState = view;
                        var calculatedSize = this.calculatePdfViewerSize(view);
                        calculatedSize.zoomRatio = calculatedSize.zoomRatio < 1 ? 1 : calculatedSize.zoomRatio;
                        return this.applySizeToPdfViewer(calculatedSize.width, calculatedSize.height, calculatedSize.zoomRatio);
                    }
                    else {
                        return this.$q.when();
                    }
                };
                PrepareReportController.prototype.calculatePdfViewerSize = function (mode) {
                    if (mode === void 0) { mode = 'landscape'; }
                    if (mode !== 'landscape')
                        mode = 'portrait';
                    else
                        mode = 'landscape';
                    if (this.MAX_WIDTH_PX > document.body.clientWidth * 0.8)
                        this.MAX_WIDTH_PX = document.body.clientWidth * 0.8;
                    var scrollYWidth = 20;
                    var modalWidth = this.$element.width();
                    var clientWidth = document.body.clientWidth;
                    var availablePdfViewerWidth, availablePdfViewerHeight;
                    if (clientWidth - modalWidth > 0) {
                        availablePdfViewerWidth = this.MAX_WIDTH_PX - this.notPdfViewerWidth;
                    }
                    else {
                        availablePdfViewerWidth = clientWidth - this.notPdfViewerWidth;
                    }
                    var pdfWidth = availablePdfViewerWidth - scrollYWidth;
                    if (mode === 'landscape') {
                        availablePdfViewerHeight = Math.round(availablePdfViewerWidth * 210 / 297 * 100) / 100;
                    }
                    else {
                        availablePdfViewerHeight = Math.round(availablePdfViewerWidth * 297 / 210 * 100) / 100;
                    }
                    var zoomRatio = Math.floor(pdfWidth / this.A4_LANDSCAPE_WIDTH * 100) / 100;
                    // zoomRatio = zoomRatio*0.9;
                    return {
                        width: availablePdfViewerWidth,
                        height: availablePdfViewerHeight,
                        zoomRatio: zoomRatio
                    };
                };
                PrepareReportController.prototype.applySizeToPdfViewer = function (width, height, zoomRatio) {
                    var _this = this;
                    var offsetFromPDFViewerToModal = 40; // px
                    if (app.common.utils.isNullOrUndefined(width)
                        || app.common.utils.isNullOrUndefined(height)
                        || app.common.utils.isNullOrUndefined(zoomRatio)
                        || width < 1
                        || height < 1
                        || zoomRatio < 0)
                        return;
                    // adjust height not to be hidden by screen
                    // modal padding is 15
                    // modal header is 23
                    var newHeight = height + offsetFromPDFViewerToModal;
                    if (newHeight > document.body.clientHeight * 0.9 - 15 * 2 - 23)
                        newHeight = document.body.clientHeight * 0.9 - 15 * 2 - 23;
                    zoomRatio = zoomRatio * newHeight / (height + offsetFromPDFViewerToModal);
                    this.$element.find("#medication-pdf-viewer").parent().css("width", width + offsetFromPDFViewerToModal);
                    this.$element.find("#medication-pdf-viewer").parent().css("height", newHeight);
                    this.$element.find("#medication-pdf-viewer").css("width", width + offsetFromPDFViewerToModal);
                    this.$element.find("#medication-pdf-viewer").css("height", newHeight);
                    var currentWidth = this.$scope.medicationPdfViewer.width;
                    var currentHeight = this.$scope.medicationPdfViewer.height;
                    var animationString = this.getCSSChangeString(currentWidth, width);
                    this.$element.parent().animate({
                        width: animationString
                    });
                    return this.$scope.medicationPdfViewer
                        .zoomTo(zoomRatio)
                        .then(function () {
                        return _this.$scope.medicationPdfViewer
                            .setWidth(width)
                            .then(function () {
                            return _this.$scope.medicationPdfViewer
                                .setHeight(height + 300)
                                .then(function () {
                                _this.$element.find("#medication-pdf-viewer").children("div").css("overflow-y", "auto !important"); /*set here after report is created because of safari issue*/
                                // this.resizePdfViewer();
                            });
                        });
                    });
                };
                PrepareReportController.prototype.getCSSChangeString = function (currentValue, newValue) {
                    if (app.common.utils.isNullOrUndefined(currentValue)
                        || app.common.utils.isNullOrUndefined(newValue))
                        return "";
                    var changeValue = newValue - currentValue;
                    var animationString = "";
                    if (changeValue > 0) {
                        animationString = "+=" + changeValue.toString() + "px";
                    }
                    else {
                        animationString = "-=" + (changeValue * -1).toString() + "px";
                    }
                    return animationString;
                };
                PrepareReportController.prototype.saveReport = function () {
                    this.fileSaver.saveAs(this.report, this.fileName);
                };
                //#endregion
                //#region Filter
                PrepareReportController.prototype.initFilterList = function (mode) {
                    var _this = this;
                    var filter = {
                        first: null,
                        second: null,
                        third: null
                    };
                    var optionList = {
                        first: null,
                        second: null,
                        third: null
                    };
                    mode = mode ? mode.toLowerCase() : null;
                    var filterList4Export = [];
                    //* USER MODE
                    if (mode === "user") {
                        this.showFilters = false;
                        //region fetch supplier
                        var suppliers = this.supplierDatacontext.getAllSuppliersInOnce();
                        optionList.third = new Array();
                        if (!app.common.utils.isNullOrUndefined(suppliers) && suppliers.length > 0) {
                            angular.forEach(suppliers, function (supplier) {
                                if (!app.common.utils.isNullOrUndefined(supplier.name))
                                    optionList.third.push(new web.model.DropdownOption(supplier.name, supplier["supplierId"], 0, app.constants.entityNames.supplier, false));
                            });
                        }
                        filter.third = new app.web.directives.Filter(app.constants.entityNames.supplier, "Supplier", optionList.third, [], false, false, true, false);
                        filterList4Export.push({
                            filter: filter.third,
                            order: 2,
                            filterName: "Supplier"
                        });
                        //endregion
                        //region fetch medicine
                        this.busyIndicator.show();
                        this.prescriptionDatacontext.getTreatmentProducts(this.navigationService.selectedCustomerId).then(function (listOfTreatmentProduct) {
                            _this.busyIndicator.hide();
                            optionList.second = new Array();
                            if (!app.common.utils.isNullOrUndefined(listOfTreatmentProduct) && listOfTreatmentProduct.length > 0) {
                                listOfTreatmentProduct.forEach(function (tp) {
                                    optionList.second.push(new web.model.DropdownOption(tp.name, tp["treatmentProductId"], 0, app.constants.prescriptionProperties.treatmentProduct, false));
                                });
                            }
                            filter.second = new app.web.directives.Filter(app.constants.prescriptionProperties.treatmentProduct, "Filter_TreatmentProduct", optionList.second, [], false, false, true, false);
                            filterList4Export.push({
                                filter: filter.second,
                                order: 1,
                                filterName: "Filter_TreatmentProduct"
                            });
                        }, function (error) {
                            _this.busyIndicator.hide();
                            throw error;
                            filter.second = new app.web.directives.Filter(app.constants.prescriptionProperties.treatmentProduct, "Filter_TreatmentProduct", optionList.second, [], false, false, true, false);
                            filterList4Export.push({
                                filter: filter.second,
                                order: 1,
                                filterName: "Filter_TreatmentProduct"
                            });
                        });
                        //endregion
                        //region fetch users
                        if (this.showUsersFilter
                            && this.showUsersFilter === true) {
                            this.busyIndicator.show();
                            optionList.first = new Array();
                            this.userManagementDatacontext.getUsers().then(function (userData) {
                                _this.busyIndicator.hide();
                                _this.users = userData;
                                _this.getFilteredUsers().then(function (result) {
                                    var filteredUsers = result;
                                    angular.forEach(filteredUsers, function (user) {
                                        if (!app.common.utils.isNullOrUndefined(user.fullName))
                                            optionList.first.push(new web.model.DropdownOption(user.fullName, user["id"], 0, app.constants.entityNames.user, false));
                                    });
                                    filter.first = new app.web.directives.Filter(app.constants.entityNames.user, "User", optionList.first, [], false, false, true, false);
                                    // this.userFilter = filter;
                                    filterList4Export.push({ filter: filter.first, order: 0, filterName: "User" });
                                    _this.showFilters = true;
                                });
                            }, function (error) {
                                _this.busyIndicator.hide();
                                _this.showFilters = true;
                                // console.log('errr', error);
                            });
                        }
                        setTimeout(function () {
                            _this.busyIndicator.hide();
                        }, 3000);
                        this.showFilters = true;
                    }
                    //* CUSTOMER MODE
                    if (mode === "customer") {
                        this.showFilters = false;
                        //region fetch customer
                        var customers = this.assessmentDatacontext.getAllFromCache(app.constants.resourceNames.customerResource, false, "name");
                        optionList.first = new Array();
                        var customerIds = this.navigationService.getCustomerIds();
                        // console.log("customers", customers);
                        angular.forEach(customers, function (customer) {
                            if (customerIds.indexOf(customer.customerId) > -1) {
                                if (!app.common.utils.isNullOrUndefinedOrEmpty(customer.name))
                                    optionList.first.push(new web.model.DropdownOption(customer.name, customer["customerId"], 0, app.constants.assessmentProperties.customer, false));
                            }
                        });
                        filter.first = new web.directives.Filter(app.constants.assessmentProperties.customer, "Filter_Customer", optionList.first, [], false, false, true, false);
                        // this.customersFilter = filter;
                        filterList4Export.push({ filter: filter.first, order: 0, filterName: "Filter_Customer" });
                        //endregion
                        //region fetch sites
                        var sites = this.assessmentDatacontext.getAllFromCache(app.constants.resourceNames.siteResource, false, "name");
                        optionList.second = new Array();
                        var siteIds = this.navigationService.getSiteIds();
                        angular.forEach(sites, function (site) {
                            if (siteIds.indexOf(site.siteId) > -1) {
                                if (!app.common.utils.isNullOrUndefinedOrEmpty(site.name))
                                    optionList.second.push(new web.model.DropdownOption(site.name, site["siteId"], site["area"]["region"]["operation"]["customerBU"]["customer"]["customerId"], app.constants.assessmentProperties.site, false, [
                                        0,
                                        0,
                                        site["area"]["region"]["operation"]["customerBU"]["customer"]["customerId"],
                                        site["area"]["region"]["operation"]["customerBU"]["customerBUId"],
                                        site["area"]["region"]["operation"]["operationId"],
                                        site["area"]["region"]["regionId"],
                                        site["area"]["areaId"]
                                    ]));
                            }
                        });
                        filter.second = new web.directives.Filter(app.constants.assessmentProperties.site, "Filter_Site", optionList.second, [], false, false, true, false);
                        filterList4Export.push({ filter: filter.second, order: 1, filterName: "Filter_Site" });
                        //endregion
                        //region fetch active substance
                        var activeSubstances = this.prescriptionDatacontext.getActiveSubstances();
                        optionList.third = new Array();
                        angular.forEach(activeSubstances, function (activeSubstance) {
                            if (!app.common.utils.isNullOrUndefinedOrEmpty(activeSubstance.name))
                                optionList.third.push(new web.model.DropdownOption(activeSubstance.name, activeSubstance["activeSubstanceId"], 0, app.constants.treatmentProductProperties.activeSubstance, false));
                        });
                        filter.third = new app.web.directives.Filter(app.constants.prescriptionProperties.treatmentProduct, "ActiveSubstance", optionList.third, [], false, false, true, false);
                        filterList4Export.push({ filter: filter.third, order: 2, filterName: "ActiveSubstance" });
                        this.showFilters = true;
                    }
                    return filterList4Export;
                };
                PrepareReportController.prototype.getFilteredUsers = function () {
                    var deferred = this.$q.defer();
                    var isActiveFilter;
                    isActiveFilter = true;
                    var role = this.authenticationService.credentialsGet().Role;
                    var filtered = this.$filter("filter")(this.users, {
                        isActive: isActiveFilter
                    });
                    filtered = this.$filter("filter")(filtered, {
                        role: "!customer"
                    });
                    if (role.toLowerCase() === app.constants.accessControlRoles.Host.toLowerCase()) {
                        filtered = this.$filter("filter")(filtered, { role: "!developer" });
                    }
                    if (role.toLowerCase() ===
                        app.constants.accessControlRoles.Administrator.toLowerCase()) {
                        filtered = this.$filter("filter")(filtered, { role: "!developer" });
                        filtered = this.$filter("filter")(filtered, { role: "!host" });
                        filtered = this.$filter("filter")(filtered, { role: "!api" });
                    }
                    return this.$q.when(filtered);
                };
                PrepareReportController.prototype.isShowFilters = function () {
                    return this.showFilters;
                };
                // private assessmentData: services.AssessmentData;
                PrepareReportController.$inject = [
                    "$scope",
                    "authenticationService",
                    "prescriptionDatacontext",
                    "assessmentDatacontext",
                    "navigationService",
                    "supplierDatacontext",
                    "userManagementDatacontext",
                    "$filter",
                    "$q",
                    "busyIndicator",
                    "$http",
                    "$timeout",
                    "$element",
                    "FileSaver",
                    "appLocalStorage"
                ];
                return PrepareReportController;
            })();
            controllers.PrepareReportController = PrepareReportController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("PrepareReportController", [
    "$scope",
    "authenticationService",
    "prescriptionDatacontext",
    "assessmentDatacontext",
    "navigationService",
    "supplierDatacontext",
    "userManagementDatacontext",
    "$filter",
    "$q",
    "busyIndicator",
    "$http",
    "$timeout",
    "$element",
    "FileSaver",
    "appLocalStorage"
]);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var Mail = (function () {
                function Mail() {
                }
                return Mail;
            })();
            controllers.Mail = Mail;
            var MailController = (function () {
                function MailController($rootScope, $scope, authenticationService, mailDatacontext, assessmentDatacontext, appLocalStorage, fileSaver, $locale, busyIndicator) {
                    var _this = this;
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.authenticationService = authenticationService;
                    this.mailDatacontext = mailDatacontext;
                    this.assessmentDatacontext = assessmentDatacontext;
                    this.appLocalStorage = appLocalStorage;
                    this.fileSaver = fileSaver;
                    this.$locale = $locale;
                    this.busyIndicator = busyIndicator;
                    this.attachments = new Array();
                    this.assessmentFiles = new Array();
                    this.validEmail_To = true;
                    this.validEmail_CC = true;
                    $scope.viewModel = this;
                    this.mailData = this.$scope.ngDialogData;
                    this.headerText = this.mailData.type === "Assessment" ? app.localizer.resource.EmailAssessmentReport : app.localizer.resource.EmailPrescriptionReport;
                    this.key = this.mailData.key;
                    this.assessmentTypeId = this.mailData.assessmentTypeId;
                    this.mailId = this.mailData.mailId;
                    this.mail = new Mail();
                    this.mail.siteId = this.mailData.siteId;
                    this.initializeMailFromAssessmentOrSentMail();
                    $scope.$watch(function () { return _this.mail.to; }, function (newVal, oldVal) {
                        if (app.common.utils.isNullOrUndefinedOrEmpty(newVal))
                            _this.validEmail_To = false;
                        else {
                            _this.validEmail_To = _this.validateEmails(newVal);
                        }
                    });
                    $scope.$watch(function () { return _this.mail.cc; }, function (newVal, oldVal) {
                        if (app.common.utils.isNullOrUndefinedOrEmpty(_this.validEmail_CC))
                            _this.validEmail_CC = true;
                        else {
                            _this.validEmail_CC = _this.validateEmails(newVal, true);
                        }
                    });
                    //$scope.$on('flow::fileAdded', function(event, $flow, flowFile) {
                    //    event.preventDefault();//prevent file from uploading
                    //});
                    this.froalaOptions = {
                        key: app.common.utils.froalaKey,
                        toolbarInline: false,
                        spellcheck: false,
                        scaytAutoload: false,
                        // Set max image size to 5MB.
                        // imageMaxSize: 1024 * 1024,
                        placeholderText: "",
                        // height: 100,
                        pluginsEnabled: [
                            "fullscreen",
                            // "image",
                            // "table",
                            "charCounter",
                            // "paragraphStyle",
                            "lists",
                            "wordPaste"
                        ],
                        toolbarButtons: [
                            "fullscreen",
                            "bold",
                            "italic",
                            "underline",
                            "strikeThrough",
                            "|",
                            // "fontFamily",
                            // "fontSize",
                            // "color",
                            // "paragraphStyle",
                            // "|",
                            // "paragraphFormat",
                            // "align",
                            "formatOL",
                            "formatUL",
                            "outdent",
                            "indent",
                            "|",
                            // "insertLink",
                            // "insertImage",
                            // "insertTable",
                            // "|",
                            "undo",
                            "redo"
                        ],
                        events: {
                            "froalaEditor.initialized": function (e, editor) {
                                var lang = $locale.FROALA;
                                editor.language.translate = function (str) {
                                    var firstBracketIndex = str.indexOf("(");
                                    var shortcutString = "";
                                    if (firstBracketIndex >= 0) {
                                        shortcutString = " " + str.substring(firstBracketIndex);
                                        str = str.substring(0, firstBracketIndex - 1);
                                    }
                                    if (lang &&
                                        lang.translation[str] &&
                                        lang.translation[str].length) {
                                        return lang.translation[str] + shortcutString;
                                    }
                                    else {
                                        return str;
                                    }
                                };
                            },
                            "froalaEditor.paste.before": function (e, editor) {
                                _this.busyIndicator.show();
                                _this.isPaste = true;
                            },
                            "froalaEditor.paste.after": function (e, editor) {
                                _this.busyIndicator.hide();
                                _this.isPaste = false;
                            },
                            "froalaEditor.blur": function (e, editor) {
                                var editorContainer = editor.el.parentElement.parentElement;
                                angular.forEach(editorContainer.children, function (htmlElement, key) {
                                    // toolbar is one of editorContainer's children
                                    angular.element(htmlElement).css("z-index", "");
                                });
                            },
                            "froalaEditor.commands.after": function (e, editor, cmd, param1, param2) {
                                if (cmd === "fullscreen") {
                                    if (editor.fullscreen.isActive() === false) {
                                        var editorContainer = editor.el.parentElement.parentElement;
                                        angular.forEach(editorContainer.children, function (htmlElement, key) {
                                            // toolbar is one of editorContainer's children
                                            angular.element(htmlElement).css("z-index", "");
                                        });
                                    }
                                }
                                if (cmd === "formatOL" || cmd === "formatUL") {
                                    var elements = editor.el.children;
                                    angular.forEach(elements, function (elem, key) {
                                        if (elem.tagName === "OL" || elem.tagName === "UL") {
                                            if (elem.tagName === "UL")
                                                angular.element(elem).css("list-style-type", "circle");
                                            else
                                                angular.element(elem).css("list-style-type", "decimal");
                                            angular.element(elem).css("margin-left", "10px");
                                        }
                                    });
                                }
                            },
                            "froalaEditor.focus": function (e, editor) {
                                var pElements = editor.el.children;
                                angular.forEach(pElements, function (element, key) {
                                    if (element.tagName === "P")
                                        angular.element(element).css("white-space", "normal");
                                });
                            },
                            "froalaEditor.click": function (e, editor, clickEvent) {
                                var element = clickEvent.target;
                                if (element.tagName === "LI" &&
                                    (element.parentElement.tagName === "OL" ||
                                        element.parentElement.tagName === "UL")) {
                                    setTimeout(function () {
                                        angular.element(element).removeAttr("value");
                                    }, 1);
                                }
                            }
                        }
                    };
                }
                MailController.prototype.validateEmails = function (emailsString, acceptNull) {
                    if (acceptNull === void 0) { acceptNull = false; }
                    if (app.common.utils.isNullOrUndefinedOrEmpty(emailsString))
                        if (acceptNull === true)
                            return true;
                        else
                            return false;
                    else {
                        // allow using comma and semicolon as separators
                        var replacingSemiColon = emailsString.split(";").join(",");
                        var emails = replacingSemiColon.split(",");
                        var result = app.common.utils.validateArrayEmails(emails);
                        return result;
                    }
                };
                MailController.prototype.initializeMailFromAssessmentOrSentMail = function () {
                    var _this = this;
                    return this.getAssessmentReportFiles().then(function (reportFiles) {
                        angular.forEach(reportFiles, function (filename) { _this.attachments.push(filename); });
                        _this.getMailTemplate();
                    });
                };
                MailController.prototype.getMailTemplate = function () {
                    var _this = this;
                    return this.mailDatacontext.getMailTemplate(this.mailId, this.key, this.$scope.ngDialogData.type, this.mail, this.authenticationService.credentialsCurrentUserGet().UserId)
                        .then(function (result) {
                        var mailMessage = result[0];
                        var first = true;
                        if (mailMessage.to && mailMessage.to.length > 0) {
                            angular.forEach(mailMessage.to, (function (to) {
                                if (first) {
                                    _this.mail.to = to.address;
                                    first = false;
                                }
                                else {
                                    _this.mail.to = _this.mail.to + '; ' + to.address;
                                }
                            }));
                        }
                        first = true;
                        if (mailMessage.cC && mailMessage.cC.length > 0) {
                            angular.forEach(mailMessage.cC, (function (cc) {
                                if (first) {
                                    _this.mail.cc = cc.address;
                                    first = false;
                                }
                                else {
                                    _this.mail.cc = _this.mail.cc + '; ' + cc.address;
                                }
                            }));
                        }
                        _this.mail.from = mailMessage.from;
                        _this.mail.replyTo = mailMessage.replyToList[0].address;
                        _this.mail.subject = _this.getMailSubject(_this.$scope.ngDialogData["visitType"], mailMessage.subject);
                        _this.mail.body = mailMessage.body;
                    });
                };
                MailController.prototype.getMailSubject = function (visitType, predefinedSubject) {
                    if (app.common.utils.isNullOrUndefinedOrEmpty(visitType))
                        return predefinedSubject;
                    var result = "";
                    var predefinedSubjectParts = predefinedSubject.split(" - ");
                    if (predefinedSubjectParts.length < 1)
                        return predefinedSubject;
                    var assessemntTypeVisitLocalization = app.localizer.resource["AssessmentTypeGroup_Visit"];
                    if (predefinedSubjectParts[0] === assessemntTypeVisitLocalization) {
                        predefinedSubjectParts[0] = visitType;
                    }
                    result = predefinedSubjectParts.join(" - ");
                    return result;
                };
                MailController.prototype.getAssessmentReportFiles = function () {
                    if (this.mailId > 0) {
                        return this.mailDatacontext.getSentFiles(this.key, this.$scope.ngDialogData.type);
                    }
                    else {
                        var languageId = this.assessmentDatacontext.getLanguageId(this.appLocalStorage.applicationStatusGet().translationsCulture);
                        if (this.$scope.ngDialogData.type === "Assessment") {
                            var title = this.assessmentDatacontext.getAssessmentTypeName(this.assessmentTypeId);
                            this.getAssessmentFiles(this.key);
                            return this.mailDatacontext.saveMailAttachmentAssessmentPdf(this.key, languageId, title);
                        }
                        else {
                            return this.mailDatacontext.saveMailAttachmentPrescriptionPdf(this.key, languageId, app.localizer.resource["Prescription"]);
                        }
                    }
                };
                MailController.prototype.getAssessmentFiles = function (assessmentId) {
                    var _this = this;
                    if (!!assessmentId) {
                        this.assessmentDatacontext.getTemplateRegistrations(assessmentId).then(function (templateRegistrations) {
                            if (templateRegistrations.length > 0) {
                                angular.forEach(templateRegistrations, function (template) {
                                    if (template.attribute.dictionary.name === 'File') {
                                        if (!!template.textValue)
                                            _this.assessmentFiles.push(template.textValue);
                                    }
                                });
                            }
                        });
                    }
                };
                MailController.prototype.submit = function () {
                    var _this = this;
                    var validEmail_To = this.validateEmails(this.mail.to);
                    var validEmail_CC = this.validateEmails(this.mail.cc, true);
                    if (!(validEmail_To && validEmail_CC))
                        return;
                    this.mailDatacontext.sendMail(this.mail.from, this.mail.replyTo, this.mail.to, this.mail.subject, this.mail.body, this.mail.cc, this.authenticationService.credentialsCurrentUserGet().UserName, this.key, this.$scope.ngDialogData.type, this.mailId, this.mail.siteId, this.authenticationService.credentialsCurrentUserGet().UserId)
                        .then(function (data) {
                        _this.onSuccess(data.data);
                    });
                    //.error((param1, param2, param3, param4, param5) => {
                    //var x = param1;
                    //});
                };
                MailController.prototype.onSuccess = function (data) {
                    //if (!data.Failed) {
                    this.$rootScope.$broadcast(app.constants.broadcastEventNames.mailSent);
                    var parent = this.$scope.$parent;
                    parent.closeThisDialog();
                    //} else {
                    //    alert(data.Expetion.Message);                
                    //}
                };
                MailController.prototype.attachmentUploadTarget = function () {
                    return this.mailDatacontext.attachmentUploadEndPoint();
                };
                MailController.prototype.getHeaders = function () {
                    return this.mailDatacontext.getHeaders();
                };
                MailController.prototype.getImageUploadHeaders = function () {
                    return this.authenticationService.getValidToken().then(function (token) {
                        return { "Authorization": 'Bearer ' + token };
                    });
                };
                MailController.prototype.upload = function ($flow) {
                    this.getImageUploadHeaders().then(function (headers) {
                        $flow.opts.headers = headers;
                        $flow.upload();
                    });
                };
                ;
                MailController.prototype.attachmentAdded = function ($file, $event) {
                    //console.log($file);
                };
                MailController.prototype.deleteAttachedFile = function (filename) {
                    var _this = this;
                    return this.mailDatacontext.removeFile(filename, this.key).then(function () { _this.attachments.splice(_this.attachments.indexOf(filename), 1); });
                };
                MailController.prototype.setAttachmentData = function (files) {
                    this.attachments.push(files[0].name);
                };
                MailController.prototype.openAttachedFile = function (filename) {
                    var _this = this;
                    return this.mailDatacontext.openAttachedFile(this.key, this.$scope.ngDialogData.type, filename).then(function (result) {
                        _this.fileSaver.saveAs(new Blob([result.data], { type: 'application/pdf' }), filename);
                    });
                };
                MailController.prototype.deleteAssessmentFile = function (filename) {
                    this.assessmentFiles.splice(this.assessmentFiles.indexOf(filename), 1);
                };
                MailController.prototype.openAssessmentFile = function (filename) {
                    var _this = this;
                    this.assessmentDatacontext.openAttachedFile(this.key, filename).then(function (result) {
                        _this.fileSaver.saveAs(new Blob([result.data]), filename);
                    });
                    ;
                };
                MailController.$inject = [
                    '$rootScope',
                    '$scope',
                    'authenticationService',
                    'mailDatacontext',
                    'assessmentDatacontext',
                    'appLocalStorage',
                    'FileSaver',
                    '$locale',
                    'busyIndicator'];
                return MailController;
            })();
            controllers.MailController = MailController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("MailController", ['$rootScope',
    '$scope',
    'authenticationService',
    'mailDatacontext',
    'assessmentDatacontext',
    'appLocalStorage',
    'FileSaver',
    '$locale',
    'busyIndicator']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var MailListController = (function () {
                function MailListController($scope, authenticationService, datacontext, assessmentDatacontext, navigationService, modalService) {
                    var _this = this;
                    this.$scope = $scope;
                    this.authenticationService = authenticationService;
                    this.datacontext = datacontext;
                    this.assessmentDatacontext = assessmentDatacontext;
                    this.navigationService = navigationService;
                    this.modalService = modalService;
                    this.headerText = '';
                    this.pagedmails = [];
                    this.currentPage = -1;
                    this.itemsPerPage = 10;
                    this.totalRows = 0;
                    this.mailListData = this.$scope.ngDialogData;
                    this.headerText = this.mailListData.type === app.enums.entityType.Assessment ? app.localizer.resource.EmailDistributionList : app.localizer.resource.EmailDistributionPrescriptionList;
                    this.intiliazeHeaders();
                    this.initFilterList();
                    $scope.$on(app.constants.broadcastEventNames.mailSent, function () {
                        _this.toggleFilterChangedProperty();
                    });
                    $scope.$watch('viewModel.dateRange', function (dateRange, oldVal, scope) {
                        _this.toggleFilterChangedProperty();
                    }, true); //NB! Deep watch
                }
                MailListController.prototype.intiliazeHeaders = function () {
                    var _this = this;
                    switch (this.mailListData.type) {
                        case app.enums.entityType.Assessment:
                            this.headers = [
                                { name: "Date", text: app.localizer.resource.Date, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'sentDate', sort: app.constants.sortTypes.descending },
                                { name: "Customer", text: app.localizer.resource.Customer, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'customerName', textOverflow: true, sort: app.constants.sortTypes.none },
                                { name: "Site", text: app.localizer.resource.Site, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'siteName', textOverflow: true, sort: app.constants.sortTypes.none },
                                { name: "Type", text: app.localizer.resource.Type, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'assessmentTypeName', textOverflow: true, sort: app.constants.sortTypes.none },
                                { name: "NAHContactAssessment", text: app.localizer.resource.NAHContact, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'nahRepresentativeNames', textOverflow: true, sort: app.constants.sortTypes.none },
                                { name: "Status", text: app.localizer.resource.Status, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'status', sort: app.constants.sortTypes.none },
                                { name: "Options", mailType: this.mailListData.getTypeAsString(), text: '', smColSpan: 2, mdColSpan: 2, html: true, editAndResend: function (mailId, assessmentId, assessmentTypeId, siteId) { _this.editAndResend(mailId, assessmentId, assessmentTypeId, siteId); }, sort: app.constants.sortTypes.notSortable }
                            ];
                            break;
                        case app.enums.entityType.Prescription:
                            this.headers = [
                                { name: "Date", text: app.localizer.resource.Date, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'sentDate', sort: app.constants.sortTypes.descending },
                                { name: "Customer", text: app.localizer.resource.Customer, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'customerName', textOverflow: true, sort: app.constants.sortTypes.none },
                                { name: "Site", text: app.localizer.resource.Site, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'siteName', textOverflow: true, sort: app.constants.sortTypes.none },
                                { name: "NAHContactPrescription", text: app.localizer.resource.NAHContact, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'nahRepresentativeName', textOverflow: true, sort: app.constants.sortTypes.none },
                                { name: "Status", text: app.localizer.resource.Status, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'status', sort: app.constants.sortTypes.none },
                                { name: "Options", mailType: this.mailListData.getTypeAsString(), text: '', smColSpan: 2, mdColSpan: 2, html: true, editAndResend: function (mailId, prescriptionId, siteId) { _this.editAndResend(mailId, prescriptionId, 0, siteId); }, sort: app.constants.sortTypes.notSortable }
                            ];
                            break;
                    }
                };
                MailListController.prototype.editAndResend = function (mailId, key, assessmentTypeId, siteId) {
                    switch (this.mailListData.type) {
                        case app.enums.entityType.Assessment:
                            this.modalService.show('modules/mail/mail.html', app.constants.dialogSize.defaultSize, '', this.$scope, function () { }, new web.services.MailData(siteId, key, "Assessment", assessmentTypeId, mailId));
                            break;
                        case app.enums.entityType.Prescription:
                            this.modalService.show('modules/mail/mail.html', app.constants.dialogSize.defaultSize, '', this.$scope, function () { }, new web.services.MailData(siteId, key, "Prescription", 0, mailId));
                            break;
                    }
                };
                MailListController.prototype.initFilterList = function () {
                    this.dateRange = new controllers.DateRange(moment().subtract(12, "months"), moment());
                    this.filterList = new Array();
                    var sites = _.sortBy(this.navigationService.getSites(), 'name');
                    var optionList = new Array();
                    angular.forEach(sites, function (site) {
                        optionList.push(new web.model.DropdownOption(site.name, site.siteId, -1, app.constants.assessmentProperties.site, false));
                    });
                    var filter = new app.web.directives.Filter(app.constants.assessmentProperties.site, 'Filter_Site', optionList, [], false, false);
                    this.filterList.push(filter);
                    if (this.mailListData.type === app.enums.entityType.Assessment) {
                        var assessmentTypes = this.assessmentDatacontext.getAssessmentTypes();
                        optionList = new Array();
                        angular.forEach(assessmentTypes, function (assessmentType) {
                            optionList.push(new web.model.DropdownOption(assessmentType.dictionary.name, assessmentType.assessmentTypeId, 0, app.constants.assessmentProperties.assessmentType, false)); //TODO: Get the translation
                        });
                        filter = new app.web.directives.Filter(app.constants.assessmentProperties.assessmentType, 'Filter_Type', optionList, [], false, false);
                        this.filterList.push(filter);
                    }
                    var representatives = this.assessmentDatacontext.getNahRepresentatives(0, true);
                    optionList = new Array();
                    angular.forEach(representatives, function (representative) {
                        optionList.push(new web.model.DropdownOption(representative.fullName, representative.vetUserId, 0, app.constants.assessmentProperties.representative, false));
                    });
                    filter = new app.web.directives.Filter(app.constants.assessmentProperties.representative, 'Filter_Representative', optionList, [], false, false);
                    this.filterList.push(filter);
                };
                MailListController.prototype.loadMore = function () {
                    var _this = this;
                    this.currentPage++;
                    return this.datacontext.getEmails(this.currentPage, this.itemsPerPage, this.filterList, this.dateRange, this.authenticationService.credentialsCurrentUserGet().UserId, "Web App", this.mailListData.getTypeAsString()).then(function (data) {
                        if (_this.currentPage > 0)
                            _this.pagedmails = _this.pagedmails.concat(data.results);
                        else
                            _this.pagedmails = data.results;
                        _this.totalRows = data.inlineCount;
                        return _this.pagedmails;
                    });
                };
                MailListController.prototype.toggleFilterChangedProperty = function () {
                    if (this.currentPage < 0)
                        return; //skip those redundant filterchange calls
                    this.currentPage = -1;
                    this.toggleFilterChanged = !this.toggleFilterChanged;
                };
                MailListController.$inject = ['$scope', 'authenticationService', 'mailDatacontext', 'assessmentDatacontext', 'navigationService', 'modalService'];
                return MailListController;
            })();
            controllers.MailListController = MailListController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("MailListController", ['$scope', 'authenticationService', 'mailDatacontext', 'assessmentDatacontext', 'navigationService', 'modalService']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var ConfirmController = (function () {
                function ConfirmController($scope, modalService) {
                    this.$scope = $scope;
                    this.modalService = modalService;
                    this.headerText = "test";
                    this.messageText = "message";
                    this.onlyAccept = false;
                    this.hasComment = false;
                    this.requireComment = false;
                    this.comment = "";
                    $scope.viewModel = this;
                    this.headerText = this.$scope.ngDialogData.headerText;
                    this.messageText = this.$scope.ngDialogData.messageText;
                    this.onlyAccept = this.$scope.ngDialogData.onlyAccept;
                    this.hasComment = this.$scope.ngDialogData.hasComment;
                    this.requireComment = this.$scope.ngDialogData.requireComment;
                }
                ConfirmController.prototype.accept = function () {
                    this.$scope.confirm(true);
                };
                ConfirmController.prototype.submit = function () {
                    this.$scope.confirm(this.comment);
                };
                ConfirmController.$inject = ['$scope', 'modalService'];
                return ConfirmController;
            })();
            controllers.ConfirmController = ConfirmController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("ConfirmController", ['$scope', 'modalService']);

var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var FishGroupController = (function () {
                function FishGroupController($rootScope, $scope, datacontext, modalService) {
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.datacontext = datacontext;
                    this.modalService = modalService;
                    this.errorMessage = app.localizer.resource.Error_ValidationErrors;
                    this.fishgroupParamaters = $scope.ngDialogData;
                    this.headerText = app.localizer.resource.NewFishgroup;
                    this.initialize();
                }
                FishGroupController.prototype.initialize = function () {
                    this.fishgroup = this.datacontext.createFishgroup({
                        siteId: this.fishgroupParamaters.siteId,
                        fishgroupName: null,
                        active: true,
                        generationId: null
                    });
                    this.generations = this.datacontext.getGenerations();
                };
                FishGroupController.prototype.validate = function () {
                    return this.datacontext.validateEntity(this.fishgroup);
                };
                FishGroupController.prototype.cancel = function () {
                    this.datacontext.rejectChangesOnEntity(this.fishgroup);
                    this.$scope.closeThisDialog();
                };
                FishGroupController.prototype.save = function () {
                    var _this = this;
                    if (!this.validate()) {
                        this.hasValidationProblem = true;
                        return;
                    }
                    else {
                        this.hasValidationProblem = false;
                        this.datacontext.saveEntities([this.fishgroup]).then(function () {
                            _this.datacontext.saveEntities([_this.fishgroup]);
                            _this.$scope.confirm(_this.fishgroup);
                            return true;
                        });
                    }
                };
                FishGroupController.prototype.hasError = function (propertyName) {
                    return !this.fishgroup.entityAspect.validateProperty(propertyName) && this.hasValidationProblem;
                };
                FishGroupController.prototype.hasErrors = function () {
                    return this.fishgroup.entityAspect.hasValidationErrors;
                };
                FishGroupController.$inject = ['$rootScope', '$scope', 'assessmentDatacontext', 'modalService'];
                return FishGroupController;
            })();
            controllers.FishGroupController = FishGroupController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("FishGroupController", ['$rootScope', '$scope', 'assessmentDatacontext', 'modalService']);

var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var HostController = (function () {
                function HostController($scope, $interval, $timeout, $sce, authenticationService, apiEndpointService, modalService, appLocalStorage) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$interval = $interval;
                    this.$timeout = $timeout;
                    this.$sce = $sce;
                    this.authenticationService = authenticationService;
                    this.apiEndpointService = apiEndpointService;
                    this.modalService = modalService;
                    this.appLocalStorage = appLocalStorage;
                    this.iframeLoadCount = 0;
                    this.iframeLoaded = false;
                    this.isModalBlockedOut = false;
                    $scope.viewModel = this;
                    this.hostParamaters = $scope.ngDialogData;
                    var queryString = "/HotTowel/LegacyApplication?token=" + this.authenticationService.credentialsGet().Token + "&userId=" + this.authenticationService.credentialsGet().UserId + "&culture=" + this.appLocalStorage.applicationStatusGet().translationsCulture;
                    switch (this.hostParamaters.name) {
                        case "operation unit setup":
                            this.headerText = 'Operation unit setup';
                            this.givenUrl = $sce.trustAsResourceUrl(this.apiEndpointService.getBaseEndpoint() + queryString + "&goTo=OperationUnitSetup/operationUnitSetup");
                            break;
                        case "integration log":
                            this.headerText = 'Integration log';
                            this.givenUrl = $sce.trustAsResourceUrl(this.apiEndpointService.getBaseEndpoint() + queryString + "&goTo=IntegrationLog/integrationLog");
                            break;
                        case "crmimportstatus":
                            this.headerText = 'CRM import status';
                            this.givenUrl = $sce.trustAsResourceUrl(this.apiEndpointService.getBaseEndpoint() + queryString + "&goTo=CrmImport/crmImportStatus");
                            break;
                    }
                    $interval(function () {
                        if ($('#iFrameHost').attr("isModalBlockedOut") === "true") {
                            _this.isModalBlockedOut = true;
                        }
                        else {
                            _this.isModalBlockedOut = false;
                        }
                    }, 100);
                }
                HostController.prototype.iframeLoadedCallBack = function () {
                    this.iframeLoaded = true;
                    this.$scope.$digest();
                };
                HostController.prototype.close = function () {
                    var _this = this;
                    if ($('#iFrameHost').attr("hasChanges") === "true") {
                        this.modalService.showConfirm('modules/confirm/confirm.html', app.constants.dialogSize.extraSmall, '', this.$scope, function () { }, new web.services.ConfirmationData(null, app.localizer.resource.Close, app.localizer.resource.Message_ApplicationRefresh, true)).then(function () {
                            _this.modalService.close();
                            _this.$timeout(function () {
                                location.reload();
                            }, 100);
                        });
                    }
                    else {
                        this.modalService.close();
                    }
                };
                HostController.$inject = ['$scope', '$interval', '$timeout', '$sce', 'authenticationService', 'apiEndpointService', 'modalService', 'appLocalStorage'];
                return HostController;
            })();
            controllers.HostController = HostController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("HostController", ['$scope', '$interval', '$timeout', '$sce', 'authenticationService', 'apiEndpointService', 'modalService', 'appLocalStorage']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var BugController = (function () {
                function BugController($scope, $sce, apiEndpoint, authenticationService, datacontext) {
                    this.$scope = $scope;
                    this.apiEndpoint = apiEndpoint;
                    this.authenticationService = authenticationService;
                    this.datacontext = datacontext;
                    this.headerText = 'Error Report';
                    $scope.viewModel = this;
                    this.url = $sce.trustAsResourceUrl(this.apiEndpoint.getErrorReportEndpoint());
                }
                BugController.$inject = ['$scope', '$sce', 'apiEndpointService'];
                return BugController;
            })();
            controllers.BugController = BugController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("BugController", ['$scope', '$sce', 'apiEndpointService']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var UserSettingsController = (function (_super) {
                __extends(UserSettingsController, _super);
                function UserSettingsController($scope, $timeout, $q, appLocalStorage, modalService, authenticationService, userManagementDatacontext, $locale, busyIndicator) {
                    var _this = this;
                    _super.call(this);
                    this.$scope = $scope;
                    this.$timeout = $timeout;
                    this.$q = $q;
                    this.appLocalStorage = appLocalStorage;
                    this.modalService = modalService;
                    this.authenticationService = authenticationService;
                    this.userManagementDatacontext = userManagementDatacontext;
                    this.$locale = $locale;
                    this.busyIndicator = busyIndicator;
                    this.headerText = 'Settings';
                    $scope.viewModel = this;
                    this.data = this.$scope.ngDialogData;
                    this.user = { Culture: null };
                    var credentials = authenticationService.credentialsGet();
                    var userId = credentials.UserId;
                    this.$timeout(function () {
                        return _this.$q.all([userManagementDatacontext.getUserById(userId),
                            userManagementDatacontext.getCultures()]).then(function (result) {
                            _this.user = result[0];
                            _this.cultures = result[1];
                            _this.signatureFile = _this.user.signatureFile;
                        });
                    });
                    this.froalaOptions = {
                        key: app.common.utils.froalaKey,
                        toolbarInline: false,
                        spellcheck: false,
                        scaytAutoload: false,
                        // Set max image size to 5MB.
                        // imageMaxSize: 1024 * 1024,
                        placeholderText: "",
                        height: 200,
                        pluginsEnabled: [
                            "fullscreen",
                            // "image",
                            // "table",
                            "charCounter",
                            // "paragraphStyle",
                            "lists",
                            "wordPaste"
                        ],
                        toolbarButtons: [
                            "fullscreen",
                            "bold",
                            "italic",
                            "underline",
                            "strikeThrough",
                            "|",
                            // "fontFamily",
                            // "fontSize",
                            // "color",
                            // "paragraphStyle",
                            // "|",
                            // "paragraphFormat",
                            // "align",
                            "formatOL",
                            "formatUL",
                            "outdent",
                            "indent",
                            "|",
                            // "insertLink",
                            // "insertImage",
                            // "insertTable",
                            // "|",
                            "undo",
                            "redo"
                        ],
                        events: {
                            "froalaEditor.initialized": function (e, editor) {
                                var lang = $locale.FROALA;
                                editor.language.translate = function (str) {
                                    var firstBracketIndex = str.indexOf("(");
                                    var shortcutString = "";
                                    if (firstBracketIndex >= 0) {
                                        shortcutString = " " + str.substring(firstBracketIndex);
                                        str = str.substring(0, firstBracketIndex - 1);
                                    }
                                    if (lang &&
                                        lang.translation[str] &&
                                        lang.translation[str].length) {
                                        return lang.translation[str] + shortcutString;
                                    }
                                    else {
                                        return str;
                                    }
                                };
                            },
                            "froalaEditor.paste.before": function (e, editor) {
                                _this.busyIndicator.show();
                                _this.isPaste = true;
                            },
                            "froalaEditor.paste.after": function (e, editor) {
                                _this.busyIndicator.hide();
                                _this.isPaste = false;
                            },
                            "froalaEditor.blur": function (e, editor) {
                                var editorContainer = editor.el.parentElement.parentElement;
                                angular.forEach(editorContainer.children, function (htmlElement, key) {
                                    // toolbar is one of editorContainer's children
                                    angular.element(htmlElement).css("z-index", "");
                                });
                            },
                            "froalaEditor.commands.after": function (e, editor, cmd, param1, param2) {
                                if (cmd === "fullscreen") {
                                    if (editor.fullscreen.isActive() === false) {
                                        var editorContainer = editor.el.parentElement.parentElement;
                                        angular.forEach(editorContainer.children, function (htmlElement, key) {
                                            // toolbar is one of editorContainer's children
                                            angular.element(htmlElement).css("z-index", "");
                                        });
                                    }
                                }
                                if (cmd === "formatOL" || cmd === "formatUL") {
                                    var elements = editor.el.children;
                                    angular.forEach(elements, function (elem, key) {
                                        if (elem.tagName === "OL" || elem.tagName === "UL") {
                                            if (elem.tagName === "UL")
                                                angular.element(elem).css("list-style-type", "circle");
                                            else
                                                angular.element(elem).css("list-style-type", "decimal");
                                            angular.element(elem).css("margin-left", "10px");
                                        }
                                    });
                                }
                            },
                            "froalaEditor.focus": function (e, editor) {
                                var pElements = editor.el.children;
                                angular.forEach(pElements, function (element, key) {
                                    if (element.tagName === "P")
                                        angular.element(element).css("white-space", "normal");
                                });
                            },
                            "froalaEditor.click": function (e, editor, clickEvent) {
                                var element = clickEvent.target;
                                if (element.tagName === "LI" &&
                                    (element.parentElement.tagName === "OL" ||
                                        element.parentElement.tagName === "UL")) {
                                    setTimeout(function () {
                                        angular.element(element).removeAttr("value");
                                    }, 1);
                                }
                            }
                        }
                    };
                }
                UserSettingsController.prototype.save = function () {
                    var _this = this;
                    this.userManagementDatacontext.updateUser(this.user).then(function () {
                        var currentUserCredential = _this.authenticationService.credentialsCurrentUserGet();
                        currentUserCredential.Email = _this.user.email;
                        currentUserCredential.FirstName = _this.user.firstName;
                        currentUserCredential.LastName = _this.user.lastName;
                        currentUserCredential.FullName = _this.user.fullName;
                        _this.authenticationService.credentialsSet(currentUserCredential, false);
                        _this.appLocalStorage.clearLocalStorage();
                        location.reload();
                    }).catch(function (response) {
                        if (response.data)
                            _super.prototype.getErrorsFromModelstate.call(_this, response.data.modelState);
                    });
                };
                UserSettingsController.prototype.hasChanges = function () {
                    return (!_.isUndefined(this.$scope.userSettingsForm) && this.$scope.userSettingsForm.$dirty) || this.appLocalStorage.applicationStatusGet().translationsCulture !== this.user.culture;
                };
                UserSettingsController.prototype.signatureUploadTarget = function () {
                    return this.userManagementDatacontext.getUserSignatureUploadEndpoint();
                };
                UserSettingsController.prototype.getImageUploadHeaders = function () {
                    return this.authenticationService.getValidToken().then(function (token) {
                        return { "Authorization": 'Bearer ' + token };
                    });
                };
                UserSettingsController.prototype.upload = function ($flow) {
                    var _this = this;
                    this.getImageUploadHeaders().then(function (headers) {
                        $flow.opts.headers = headers;
                        _this.signatureFile = $flow.files[0];
                        $flow.upload();
                    });
                };
                ;
                UserSettingsController.prototype.deleteSignature = function () {
                    var _this = this;
                    return this.userManagementDatacontext.deleteUserSignature().then(function () {
                        _this.signatureFile = null;
                    });
                };
                UserSettingsController.$inject = [
                    '$scope',
                    '$timeout',
                    '$q',
                    'appLocalStorage',
                    'modalService',
                    'authenticationService',
                    'userManagementDatacontext',
                    '$locale',
                    'busyIndicator'
                ];
                return UserSettingsController;
            })(controllers.UserBaseController);
            controllers.UserSettingsController = UserSettingsController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("UserSettingsController", [
    '$scope',
    '$timeout',
    '$q',
    'appLocalStorage',
    'modalService',
    'authenticationService',
    'userManagementDatacontext',
    '$locale',
    'busyIndicator']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var UserChangePasswordController = (function (_super) {
                __extends(UserChangePasswordController, _super);
                function UserChangePasswordController($scope, modalService, authenticationService, userManagementDatacontext) {
                    _super.call(this);
                    this.$scope = $scope;
                    this.modalService = modalService;
                    this.authenticationService = authenticationService;
                    this.userManagementDatacontext = userManagementDatacontext;
                    this.headerText = 'ChangePassword';
                    $scope.viewModel = this;
                    this.data = this.$scope.ngDialogData;
                    this.user = { oldPassword: '', newPassword: '', confirmPassword: '' };
                }
                UserChangePasswordController.prototype.save = function () {
                    var _this = this;
                    this.userManagementDatacontext.changePassword(this.user).then(function () {
                        var parent = _this.$scope.$parent;
                        parent.closeThisDialog();
                    }).catch(function (response) {
                        _super.prototype.getErrorsFromModelstate.call(_this, response.data.modelState);
                    });
                };
                UserChangePasswordController.$inject = ['$scope', 'modalService', 'authenticationService', 'userManagementDatacontext'];
                return UserChangePasswordController;
            })(controllers.UserBaseController);
            controllers.UserChangePasswordController = UserChangePasswordController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("UserChangePasswordController", ['$scope', 'modalService', 'authenticationService', 'userManagementDatacontext']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var MapViewController = (function () {
                function MapViewController($rootScope, $scope, $timeout, uiGmapIsReady, assessmentDatacontext, upcomingEventDatacontext, navigationService, apiEndpointService, authenticationService) {
                    var _this = this;
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.$timeout = $timeout;
                    this.uiGmapIsReady = uiGmapIsReady;
                    this.assessmentDatacontext = assessmentDatacontext;
                    this.upcomingEventDatacontext = upcomingEventDatacontext;
                    this.navigationService = navigationService;
                    this.apiEndpointService = apiEndpointService;
                    this.authenticationService = authenticationService;
                    this.mapMarkers = [];
                    this.refreshMarkers = true;
                    this.fitToMarkers = false;
                    this.isMapEventView = false;
                    this.mapFollowUpNeeded = true;
                    this.mapFollowUpRecommended = true;
                    this.mapNoEvent90Days = true;
                    this.mapEvent90Days = true;
                    this.mapEvent30Days = true;
                    this.redMarkersCount = 0;
                    this.orangeMarkersCount = 0;
                    this.greenMarkersCount = 0;
                    this.undefinedCoordinates = [];
                    this.popoverTemplate = "modules/map_view/noaddress.tpl.html";
                    this.mapAssessmentPopoverHeader = [
                        {
                            name: 'Date', text: app.localizer.resource.Date, mdColSpan: 1, smColSpan: 1, "class": 'fixed-width-10', html: false, propertyName: 'assessmentDate', sort: app.constants.sortTypes.descending
                        },
                        {
                            name: 'Assessment type', text: app.localizer.resource.Type, mdColSpan: 1, smColSpan: 1, "class": 'fixed-width-16', html: false, propertyName: 'assessmentTypeName', sort: app.constants.sortTypes.none
                        },
                        {
                            name: 'Assessment gr', text: app.localizer.resource.AssessmentGroup, mdColSpan: 2, smColSpan: 2, "class": 'fixed-width-20', html: false, propertyName: 'assessmentDiscriminator', sort: app.constants.sortTypes.none
                        },
                        {
                            name: 'Site Fishgr.', text: app.localizer.resource.Filter_Fishgroup, mdColSpan: 1, smColSpan: 1, "class": 'fixed-width-12', html: false, propertyName: 'fishgroupName', sort: app.constants.sortTypes.none
                        },
                        {
                            name: 'Elanco Repr', text: app.localizer.resource.NAHContact, mdColSpan: 2, smColSpan: 2, "class": 'fixed-width-20', html: false, propertyName: 'contactPersonNames', sort: app.constants.sortTypes.none
                        },
                        {
                            name: 'Follow up', text: app.localizer.resource.Filter_FollowUp, "class": 'fixed-width-8 text-center', mdColSpan: 1, smColSpan: 1, html: true, propertyName: 'followUpStatusId', sort: app.constants.sortTypes.none
                        }];
                    this.mapEventPopoverHeader = [
                        {
                            name: 'Date', text: app.localizer.resource.Date, mdColSpan: 1, smColSpan: 1, "class": 'fixed-width-10', html: false, propertyName: 'eventDate', sort: app.constants.sortTypes.descending
                        },
                        {
                            name: 'Assessment type', text: app.localizer.resource.Type, mdColSpan: 1, smColSpan: 1, "class": 'fixed-width-16', html: false, propertyName: 'assessmentTypeName', sort: app.constants.sortTypes.none
                        },
                        {
                            name: 'Site Fishgr.', text: app.localizer.resource.Filter_Fishgroup, mdColSpan: 1, smColSpan: 1, "class": 'fixed-width-16', html: false, propertyName: 'fishgroupName', sort: app.constants.sortTypes.none
                        },
                        {
                            name: 'Elanco Repr', text: app.localizer.resource.NAHContact, mdColSpan: 1, smColSpan: 1, "class": 'fixed-width-20', html: false, propertyName: 'contactName', sort: app.constants.sortTypes.none
                        }];
                    $(window).resize(function () {
                        _this.adjustHeight();
                    });
                    this.$scope.$on(app.constants.broadcastEventNames.switchMapView, function (event, data) {
                        if (data === app.constants.mapViewType.events) {
                            _this.showMapEvents();
                        }
                        else {
                            _this.showMapAssessments();
                        }
                    });
                    this.$scope.$on(app.constants.broadcastEventNames.refreshMapView, function (event, data) {
                        if (_this.isMapEventView) {
                            _this.showMapEvents();
                        }
                        else {
                            _this.showMapAssessments();
                        }
                    });
                    this.$scope.$on(app.constants.broadcastEventNames.assessmentViewType, function (event, data) {
                        if (data)
                            _this.showMapAssessments();
                    });
                    this.map = { center: { latitude: 45, longitude: -73 }, zoom: 1, options: {}, control: {} };
                    uiGmapIsReady.promise().then(function () {
                        _this.windowsOptions = {
                            disableAutoPan: false,
                            maxWidth: 1200
                        };
                        if (_this.navigationService.mapViewType === app.constants.mapViewType.events) {
                            _this.showMapEvents();
                        }
                        else {
                            _this.showMapAssessments();
                        }
                        _this.adjustHeight();
                    });
                }
                MapViewController.prototype.adjustHeight = function () {
                    var _this = this;
                    this.uiGmapIsReady.promise().then(function () {
                        _this.$timeout(function () {
                            window.google.maps.event.trigger(_this.map.control.getGMap(), "resize");
                        }, 100);
                    });
                };
                MapViewController.prototype.showMapAssessments = function () {
                    var _this = this;
                    this.isMapEventView = false;
                    this.assessmentDatacontext.getSiteIdsWithAssessments(this.$scope.$parent.filterList, this.navigationService.selectedLevelId).then(function (result) {
                        _this.mapViewData = result[0];
                        _this.mapCheckboxSelectionChanged();
                        _this.$rootScope.$broadcast(app.constants.broadcastEventNames.mapViewDataLoaded);
                    });
                };
                MapViewController.prototype.showMapEvents = function () {
                    var _this = this;
                    this.isMapEventView = true;
                    return this.upcomingEventDatacontext.getSiteIdsWithEvents(this.$scope.$parent.filterList, this.navigationService.selectedLevelId).then(function (result) {
                        _this.mapViewData = result[0];
                        _this.mapCheckboxSelectionChanged();
                        _this.$rootScope.$broadcast(app.constants.broadcastEventNames.mapViewDataLoaded);
                    });
                };
                MapViewController.prototype.createMarkers = function (data) {
                    var _this = this;
                    var markers = [];
                    this.undefinedCoordinates = [];
                    _.forEach(Object.keys(data), function (siteId) {
                        var marker = _this.createMarker(parseInt(siteId), data[siteId]);
                        if (marker !== null) {
                            markers.push(marker);
                        }
                    });
                    this.undefinedCoordinates = _.sortBy(this.undefinedCoordinates, 'siteName');
                    this.uiGmapIsReady.promise().then(function () {
                        _this.mapMarkers = markers;
                        if (markers.length === 1) {
                            _this.fitToMarkers = false;
                            var map = _this.map.control.getGMap();
                            var bounds = new window.google.maps.LatLngBounds();
                            bounds.extend(new window.google.maps.LatLng({ lat: markers[0].latitude, lng: markers[0].longitude }));
                            map.setCenter(bounds.getCenter());
                            map.fitBounds(bounds);
                            map.setZoom(10);
                        }
                        else {
                            _this.fitToMarkers = true;
                        }
                    });
                };
                MapViewController.prototype.getSiteAddress = function (site) {
                    var siteAddress = _.find(site.siteAddresses, function (siteAddress) {
                        return siteAddress.addressTypeId === app.constants.addressType.visit;
                    });
                    if (!_.isUndefined(siteAddress))
                        return siteAddress.address;
                    return null;
                };
                MapViewController.prototype.createMarker = function (siteId, parameter) {
                    var _this = this;
                    var site = this.assessmentDatacontext.getSite(siteId);
                    var address = this.getSiteAddress(site);
                    var marker = null;
                    if (address == null || (address.latitude == null || address.longitude == null)) {
                        if (address == null) {
                            this.undefinedCoordinates.push({ siteName: site.name });
                        }
                        else {
                            this.undefinedCoordinates.push({ siteName: site.name });
                        }
                    }
                    else {
                        this.generateStatistics(parameter);
                        marker = {
                            id: site.siteId,
                            latitude: address.latitude,
                            longitude: address.longitude,
                            show: false,
                            icon: this.getMarkerIcon(this.isMapEventView, parameter),
                            mapPopoverDataLoaded: false,
                            mapPopoverTemplate: "modules/map_view/map.tpl.html",
                            mapPopoverData: {
                                SiteName: site.name,
                                CompanyName: _.isUndefined(site.area) ? "" : site.area.region.operation.customerBU.customer.name,
                                toggleReload: false,
                                mapPopoverHeader: this.isMapEventView ? this.mapEventPopoverHeader : this.mapAssessmentPopoverHeader,
                                isMapEventView: this.isMapEventView,
                                gridData: []
                            },
                            markerClick: function (item) {
                                if (!item.model.mapPopoverDataLoaded) {
                                    var contactPersons = _this.assessmentDatacontext.getSiteContactPersons(item.model.id);
                                    if (contactPersons.length > 0) {
                                        item.model.mapPopoverData.ContactPerson = contactPersons[0].fullName;
                                    }
                                    contactPersons = _this.assessmentDatacontext.getNahRepresentatives(item.model.id, true);
                                    if (contactPersons.length > 0 && !_.isUndefined(contactPersons[0].main)) {
                                        var mainContactPerson = _.filter(contactPersons, { 'main': true })[0].contactPerson;
                                        item.model.mapPopoverData.VetContactPerson = mainContactPerson.fullName;
                                    }
                                    if (_this.isMapEventView) {
                                        _this.upcomingEventDatacontext.getEventsForMapView(item.model.id, _this.mapEvent30Days, _this.mapEvent90Days, _this.mapNoEvent90Days).then(function (events) {
                                            item.model.mapPopoverData.gridData = _.map(events, function (item) {
                                                return {
                                                    eventDate: item.eventDate,
                                                    assessmentTypeName: item.assessmentTypeName,
                                                    fishgroupName: item.fishgroupName,
                                                    contactName: item.contactName
                                                };
                                            });
                                            _this.showPopover(item);
                                        });
                                    }
                                    else {
                                        var followUps = [];
                                        if (_this.mapFollowUpNeeded)
                                            followUps.push(3);
                                        if (_this.mapFollowUpRecommended)
                                            followUps.push(2);
                                        _this.assessmentDatacontext.getAssessmentsForMapView(item.model.id, followUps).then(function (assessments) {
                                            item.model.mapPopoverData.gridData = _.map(assessments, function (item) {
                                                return {
                                                    assessmentDate: item.assessmentDate,
                                                    assessmentTypeName: item.assessmentTypeName,
                                                    assessmentDiscriminator: item.assessmentDiscriminator,
                                                    fishgroupName: item.fishgroupName,
                                                    contactPersonNames: item.contactPersonNames,
                                                    followUpStatusId: item.followUpStatusId
                                                };
                                            });
                                            _this.showPopover(item);
                                        });
                                    }
                                }
                                else {
                                    if (_this.selected != null) {
                                        _this.selected.show = false;
                                    }
                                    _this.$timeout(function () {
                                        _this.selected = item.model;
                                        _this.selected.show = true;
                                    }, 250);
                                }
                                _this.$timeout(function () {
                                    var iwOuter = $('.gm-style-iw');
                                    var className = _this.isMapEventView ? "map-marker-popup-event-size" : "map-marker-popup-assessment-size";
                                    _this.removePopoverSizeClass(iwOuter, "map-marker-popup-event-size");
                                    _this.removePopoverSizeClass(iwOuter, "map-marker-popup-assessment-size");
                                    iwOuter.addClass(className);
                                    iwOuter.children().first().addClass(className);
                                    iwOuter.parent().addClass(className);
                                    iwOuter.parent().children().first().children(':not(:eq(0))').addClass(className);
                                }, 500);
                                _this.fitToMarkers = false;
                            }
                        };
                    }
                    return marker;
                };
                MapViewController.prototype.showPopover = function (item) {
                    if (this.selected != null)
                        this.selected.show = false;
                    this.selected = item.model;
                    this.selected.show = true;
                    item.model.mapPopoverDataLoaded = true;
                };
                MapViewController.prototype.removePopoverSizeClass = function (iwOuter, className) {
                    iwOuter.removeClass(className);
                    iwOuter.children().first().removeClass(className);
                    iwOuter.parent().removeClass(className);
                    iwOuter.parent().children().first().children(':not(:eq(0))').removeClass(className);
                };
                MapViewController.prototype.mapCheckboxSelectionChanged = function () {
                    var _this = this;
                    var mapViewData = [];
                    this.greenMarkersCount = 0;
                    this.orangeMarkersCount = 0;
                    this.redMarkersCount = 0;
                    if (this.selected != null)
                        this.selected.show = false;
                    if (this.isMapEventView) {
                        _.forIn(this.mapViewData, function (eventDate, siteId) {
                            if (_this.mapEvent30Days && moment(eventDate) <= moment().add(30, 'days')) {
                                mapViewData[siteId] = eventDate;
                            }
                            else if (_this.mapEvent90Days && moment(eventDate) <= moment().add(90, 'days') && moment(eventDate) > moment().add(30, 'days')) {
                                mapViewData[siteId] = eventDate;
                            }
                            else if (_this.mapNoEvent90Days && moment(eventDate) > moment().add(90, 'days')) {
                                mapViewData[siteId] = eventDate;
                            }
                        });
                    }
                    else {
                        _.forIn(this.mapViewData, function (followUpId, siteId) {
                            if (followUpId === 2 && _this.mapFollowUpRecommended) {
                                mapViewData[siteId] = followUpId;
                            }
                            else if (followUpId === 3 && _this.mapFollowUpNeeded) {
                                mapViewData[siteId] = followUpId;
                            }
                        });
                    }
                    this.createMarkers(mapViewData);
                };
                MapViewController.prototype.generateStatistics = function (parameter) {
                    if (this.isMapEventView) {
                        if (this.mapEvent30Days && moment(parameter) <= moment().add(30, 'days')) {
                            this.redMarkersCount += 1;
                        }
                        else if (this.mapEvent90Days && moment(parameter) <= moment().add(90, 'days') && moment(parameter) > moment().add(30, 'days')) {
                            this.orangeMarkersCount += 1;
                        }
                        else if (this.mapNoEvent90Days && moment(parameter) > moment().add(90, 'days')) {
                            this.greenMarkersCount += 1;
                        }
                    }
                    else {
                        if (parameter === 2 && this.mapFollowUpRecommended) {
                            this.orangeMarkersCount += 1;
                        }
                        else if (parameter === 3 && this.mapFollowUpNeeded) {
                            this.redMarkersCount += 1;
                        }
                    }
                };
                MapViewController.prototype.getMarkerIcon = function (isEvent, parameter) {
                    if (isEvent) {
                        if (moment(parameter) <= moment().add(30, 'days')) {
                            return this.apiEndpointService.baseEndpoint + "/Content/images/map-pointer-red.png";
                        }
                        else if (moment(parameter) <= moment().add(90, 'days')) {
                            return this.apiEndpointService.baseEndpoint + "/Content/images/map-pointer-orange.png";
                        }
                        else {
                            return this.apiEndpointService.baseEndpoint + "/Content/images/map-pointer-green.png";
                        }
                    }
                    else {
                        if (parameter === 1) {
                            return this.apiEndpointService.baseEndpoint + "/Content/images/map-pointer-green.png";
                        }
                        else if (parameter === 2) {
                            return this.apiEndpointService.baseEndpoint + "/Content/images/map-pointer-orange.png";
                        }
                        return this.apiEndpointService.baseEndpoint + "/Content/images/map-pointer-red.png";
                    }
                };
                MapViewController.prototype.closeClick = function () {
                    this.selected.show = false;
                    this.selected = null;
                };
                MapViewController.$inject = ['$rootScope', '$scope', '$timeout', 'uiGmapIsReady', 'assessmentDatacontext', 'upcomingEventDatacontext', 'navigationService', 'apiEndpointService', 'authenticationService'];
                return MapViewController;
            })();
            controllers.MapViewController = MapViewController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("MapViewController", ['$rootScope', '$scope', '$timeout', 'uiGmapIsReady', 'assessmentDatacontext', 'upcomingEventDatacontext', 'navigationService', 'apiEndpointService', 'authenticationService']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var UserEditController = (function (_super) {
                __extends(UserEditController, _super);
                function UserEditController($scope, $element, $timeout, $filter, $q, //ng.IQService,
                    $translate, modalService, userManagementDatacontext) {
                    var _this = this;
                    _super.call(this);
                    this.$scope = $scope;
                    this.$element = $element;
                    this.$timeout = $timeout;
                    this.$filter = $filter;
                    this.$q = $q;
                    this.$translate = $translate;
                    this.modalService = modalService;
                    this.userManagementDatacontext = userManagementDatacontext;
                    this.headerText = 'User';
                    this.showDeletedUsers = false;
                    this.treePermissionControl = {};
                    this.showPermissionTree = false;
                    this.isLoaded = false;
                    this.isLoaded = false;
                    this.isCustomerMode = this.$scope.ngDialogData.isCustomerMode;
                    $q.all([userManagementDatacontext.getValidRoles(this.isCustomerMode),
                        userManagementDatacontext.getCultures(),
                        userManagementDatacontext.getCustomers(),
                        userManagementDatacontext.getOperationUnitTypes(),
                        userManagementDatacontext.getUserBusinessObjects(this.$scope.ngDialogData.user.id)]).then(function (result) {
                        _this.roles = result[0];
                        _this.cultures = result[1];
                        _this.customers = result[2];
                        _this.operationUnitTypes = result[3];
                        _this.userBusinessObjects = result[4];
                        _this.user = _this.$scope.ngDialogData.user;
                        if (_this.$scope.ngDialogData.isCustomerMode) {
                            _this.user.role = app.constants.accessControlRoles.Customer;
                        }
                        _this.isLoaded = true;
                    });
                }
                UserEditController.prototype.save = function () {
                    var _this = this;
                    var form = this.$scope.userEditForm;
                    this.clearErrors(form);
                    this.user.hasError = !(this.hasBusinessObjects(form) && this.hasDefaultBusinessObjects(form) && !this.isMixingSites(form));
                    this.userManagementDatacontext.updateUser(this.user).then(function (updatedUser) {
                        var parent = _this.$scope.$parent;
                        if (parent.ngDialogData.user.id == '') {
                            _this.setUserIdOnBusinessObjects(updatedUser.data.id);
                        }
                        _this.userManagementDatacontext.save().then(function () {
                            parent.closeThisDialog();
                        });
                    }).catch(function (response) {
                        _this.clearErrors(form);
                        _super.prototype.getErrorsFromModelstate.call(_this, response.data.modelState, form);
                        if (response.data.message === "ValidationErrors") {
                            _this.hasBusinessObjects(form);
                            _this.hasDefaultBusinessObjects(form);
                            _this.isMixingSites(form);
                        }
                    });
                };
                UserEditController.prototype.clearErrors = function (form) {
                    if (form != null && form.$error != null && form.$error.text)
                        for (var index in form.$error.text) {
                            var error = form.$error.text[index];
                            form[error.$name].$setValidity("text", true);
                            form[error.$name].$valid = true;
                        }
                };
                UserEditController.prototype.roleChanged = function (role) {
                    var securityLevels = this.userManagementDatacontext.getSecurityLevels();
                    this.isFullAccessRoleSet(role);
                    if (this.isFullAccessRole) {
                        _.forEach(this.userBusinessObjects, function (userBusinessObject) {
                            userBusinessObject.entityAspect.setDeleted();
                        });
                        this.userBusinessObjects = [];
                        var company = this.userManagementDatacontext.getCompanies()[0];
                        if (company && role) {
                            this.addUserBusinessAccess({ levelId: 0, businessObjectId: company.companyId, name: company["name"], permission: "Full", roleName: role["name"] });
                            this.treePermissionControl.openTree();
                        }
                    }
                    _.forEach(this.userBusinessObjects, function (userBusinessObject) {
                        var securityLevelBitMask = 0;
                        var permission = app.constants.accessControlPermissionIdGet(userBusinessObject._permission);
                        if (!app.common.utils.isNullOrUndefined(role)) {
                            var exponent = app.web.utils.permission.getExponent(role.name, permission, securityLevels);
                            if (permission !== app.constants.accessControlPermissions.none) {
                                if (permission === app.constants.accessControlPermissions.full)
                                    securityLevelBitMask = Math.pow(2, exponent) + Math.pow(2, exponent - 1); //read + full
                                else
                                    securityLevelBitMask = Math.pow(2, exponent);
                            }
                            userBusinessObject.securityLevelBitMask = securityLevelBitMask;
                        }
                    });
                };
                UserEditController.prototype.isFullAccessRoleSet = function (role) {
                    this.isFullAccessRole = role.name == app.constants.accessControlRoles.Administrator ||
                        role.name == app.constants.accessControlRoles.Developer ||
                        role.name == app.constants.accessControlRoles.Host;
                };
                UserEditController.prototype.customerChanged = function (customer) {
                    this.treePermissionControl.openCustomer(customer.customerId);
                };
                UserEditController.prototype.cancel = function () {
                    this.userManagementDatacontext.reject();
                    var parent = this.$scope.$parent;
                    parent.closeThisDialog();
                };
                UserEditController.prototype.objectDeleted = function () {
                    this.treePermissionControl.openTree();
                };
                UserEditController.prototype.openPermissionTree = function () {
                    var _this = this;
                    if (this.showPermissionTree) {
                        this.showPermissionTree = false;
                        this.$element.parent().animate({ width: '-=500px' });
                    }
                    else {
                        this.$element.parent().animate({ width: '+=500px' });
                        this.$timeout(function () { _this.showPermissionTree = true; }, 500);
                    }
                    this.treePermissionControl.openTree();
                };
                UserEditController.prototype.addUserBusinessAccess = function (accessDetails) {
                    var securityLevels = this.userManagementDatacontext.getSecurityLevels();
                    var securityLevelBitMask = 0;
                    var permissionId = app.constants.accessControlPermissionIdGet(accessDetails.permission);
                    var exponent = web.utils.permission.getExponent(_.isUndefined(accessDetails.roleName) ? this.roleItem.name : accessDetails.roleName, permissionId, securityLevels);
                    if (permissionId !== app.constants.accessControlPermissions.none) {
                        if (permissionId === app.constants.accessControlPermissions.full)
                            securityLevelBitMask = Math.pow(2, exponent) + Math.pow(2, exponent - 1); //read + full
                        else
                            securityLevelBitMask = Math.pow(2, exponent);
                    }
                    var businessObject = this.userManagementDatacontext.getBusinessObject(accessDetails.levelId, accessDetails.businessObjectId);
                    var customerId = this.userManagementDatacontext.getCustomerId(businessObject.levelId, businessObject.object);
                    this.addUserBusinessObjects(accessDetails.levelId, accessDetails.businessObjectId, { name: accessDetails.name }, securityLevelBitMask, accessDetails.permission, customerId, businessObject.description);
                };
                UserEditController.prototype.addUserBusinessObjects = function (levelId, objectId, object, bitMask, permission, customerId, description) {
                    var userBusinessObject = this.userManagementDatacontext.createUserBusinessObject({
                        userId: this.user.id,
                        operationUnitTypeLevelId: levelId,
                        businessObjectId: objectId,
                        deviceTypeBitMask: 15,
                        securityLevelBitMask: bitMask,
                        isDefault: false,
                        _businessObjectName: object.name,
                        _permission: permission,
                        _customerId: customerId,
                        _description: description
                    });
                    this.userBusinessObjects.push(userBusinessObject);
                };
                UserEditController.prototype.setUserIdOnBusinessObjects = function (userId) {
                    _.forEach(this.userBusinessObjects, function (businessObject) {
                        businessObject.userId = userId;
                    });
                };
                UserEditController.prototype.hasBusinessObjects = function (form) {
                    var userBusinessObjectsPropertyName = "userBusinessObjects";
                    _super.prototype.clearError.call(this, userBusinessObjectsPropertyName);
                    if (this.userBusinessObjects != null && this.userBusinessObjects.length === 0) {
                        if (!_super.prototype.hasError.call(this, userBusinessObjectsPropertyName)) {
                            this.errors.push({ errorMessage: this.$translate.instant("Error_User_SelectPermissionBusinessObject"), property: userBusinessObjectsPropertyName });
                        }
                        return false;
                    }
                    return true;
                };
                UserEditController.prototype.hasDefaultBusinessObjects = function (form) {
                    var userBusinessObjectsPropertyName = "userBusinessObjectsDefaults";
                    _super.prototype.clearError.call(this, userBusinessObjectsPropertyName);
                    var hasDefault = _.some(this.userBusinessObjects, function (businessObject) {
                        return businessObject.isDefault == true && businessObject.permission != 'None';
                    });
                    if (!hasDefault) {
                        if (!_super.prototype.hasError.call(this, userBusinessObjectsPropertyName)) {
                            this.errors.push({ errorMessage: this.$translate.instant("Error_User_SelectDefaultBusinessObject"), property: userBusinessObjectsPropertyName });
                        }
                        return false;
                    }
                    return true;
                };
                UserEditController.prototype.isMixingSites = function (form) {
                    var _this = this;
                    if (!this.isCustomerMode) {
                        return false;
                    }
                    var isMixing = _.some(this.userBusinessObjects, function (businessObject) {
                        return businessObject.customerId != _this.user.customerId;
                    });
                    if (isMixing) {
                        var userBusinessObjectsPropertyName = "customer";
                        if (!_super.prototype.hasError.call(this, userBusinessObjectsPropertyName)) {
                            this.errors.push({ errorMessage: this.$translate.instant("ValidationPermissionMixingSitesForCustomerNotAllowed"), property: userBusinessObjectsPropertyName });
                            form[userBusinessObjectsPropertyName].$setValidity("text", false);
                        }
                    }
                    return isMixing;
                };
                UserEditController.prototype.hasChanges = function () {
                    return (!_.isUndefined(this.$scope.userEditForm) && this.$scope.userEditForm.$dirty) || this.userManagementDatacontext.hasChanges();
                };
                UserEditController.$inject = ['$scope', '$element', '$timeout', '$filter', '$q', '$translate', 'modalService', 'userManagementDatacontext'];
                return UserEditController;
            })(controllers.UserBaseController);
            controllers.UserEditController = UserEditController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("UserEditController", ['$scope', '$element', '$timeout', '$filter', '$q', '$translate', 'modalService', 'userManagementDatacontext']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var UsersController = (function () {
                function UsersController($scope, $timeout, $filter, $q, modalService, authenticationService, userManagementDatacontext) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$timeout = $timeout;
                    this.$filter = $filter;
                    this.$q = $q;
                    this.modalService = modalService;
                    this.authenticationService = authenticationService;
                    this.userManagementDatacontext = userManagementDatacontext;
                    this.headerText = 'Users';
                    this.showDeletedUsers = false;
                    $scope.viewModel = this;
                    this.data = this.$scope.ngDialogData;
                    this.isCustomerMode = this.$scope.ngDialogData.name == 'customeradmin';
                    this.userId = authenticationService.credentialsGet().UserId;
                    this.injectedScope = {
                        userId: this.userId
                    };
                    this.headers = [
                        { text: app.localizer.resource.UserName, colSpan: 1, html: false, propertyName: 'userName' },
                        { text: app.localizer.resource.fullName, colSpan: 1, html: false, propertyName: 'fullName' },
                        //    { text: localizer.resource.role, colSpan: 1, html: false, propertyName: 'role' },
                        { text: app.localizer.resource.email, colSpan: 1, html: false, propertyName: 'email' },
                        { text: app.localizer.resource.LastLoggedInDate, colSpan: 1, html: false, propertyName: 'lastLoggedIn' },
                        { text: "", colSpan: 1, html: true, action: function (actiontype, userId) { _this.action(actiontype, userId); } }
                    ];
                    if (!this.isCustomerMode) {
                        this.headers.splice(2, 0, { text: app.localizer.resource.role, colSpan: 1, html: false, propertyName: 'role' });
                    }
                    this.customer = userManagementDatacontext.getCustomers();
                    userManagementDatacontext.getOperationUnitLookupsForUserManagement();
                }
                UsersController.prototype.loadMore = function () {
                    var _this = this;
                    return this.userManagementDatacontext.getUsers().then(function (userData) {
                        _this.users = userData;
                        return _this.getFilteredUsers().then(function (result) {
                            return result;
                        });
                    });
                };
                UsersController.prototype.getFilteredUsers = function () {
                    var deferred = this.$q.defer();
                    var isActiveFilter;
                    if (this.showDeletedUsers) {
                        isActiveFilter = '!!';
                    }
                    else {
                        isActiveFilter = true;
                    }
                    var role = this.authenticationService.credentialsGet().Role;
                    var filtered = this.$filter('filter')(this.users, { isActive: isActiveFilter });
                    filtered = this.$filter('filter')(filtered, { role: this.isCustomerMode ? 'customer' : '!customer' });
                    if (role.toLowerCase() === app.constants.accessControlRoles.Host.toLowerCase()) {
                        filtered = this.$filter('filter')(filtered, { role: '!developer' });
                    }
                    if (role.toLowerCase() === app.constants.accessControlRoles.Administrator.toLowerCase()) {
                        filtered = this.$filter('filter')(filtered, { role: '!developer' });
                        filtered = this.$filter('filter')(filtered, { role: '!host' });
                        filtered = this.$filter('filter')(filtered, { role: '!api' });
                    }
                    return this.$q.when(_.sortBy(filtered, 'fullName'));
                };
                UsersController.prototype.toggleDeletedUsers = function () {
                    this.showDeletedUsers = !this.showDeletedUsers;
                    this.toggleReload = !this.toggleReload;
                };
                UsersController.prototype.toggleRefresh = function () {
                    this.toggleReload = !this.toggleReload;
                };
                UsersController.prototype.action = function (actiontype, user) {
                    switch (actiontype) {
                        case 'edit':
                            this.editUser(user);
                            break;
                        case 'delete':
                            this.deleteUser(user);
                            break;
                        case 'undelete':
                            this.undeleteUser(user);
                            break;
                        case 'reset':
                            this.resetPassword(user);
                            break;
                        default:
                    }
                };
                UsersController.prototype.addNewUser = function () {
                    var user = {
                        culture: "",
                        email: "",
                        emailSignature: "",
                        firstName: "",
                        fullName: "",
                        id: "",
                        isActive: false,
                        isSystem: false,
                        lastLoggedIn: null,
                        lastName: "",
                        phoneNumber: "",
                        role: this.isCustomerMode ? "Customer" : "",
                        userName: "",
                        hasError: false
                    };
                    this.editUser(user);
                };
                UsersController.prototype.editUser = function (user) {
                    var _this = this;
                    this.modalService.show('modules/user_management/user.edit.html', app.constants.dialogSize.medium, '', this.$scope, function () { _this.loadMore(), _this.toggleRefresh(); }, new web.services.UserData(user, this.isCustomerMode), null);
                };
                UsersController.prototype.deleteUser = function (user) {
                    user.isActive = false;
                    this.userManagementDatacontext.deleteUser(user);
                    this.toggleReload = true;
                };
                UsersController.prototype.undeleteUser = function (user) {
                    user.isActive = true;
                    this.userManagementDatacontext.unDeleteUser(user);
                    this.toggleReload = true;
                };
                UsersController.prototype.resetPassword = function (user) {
                    var _this = this;
                    this.modalService.show('modules/user_management/user.resetpassword.html', app.constants.dialogSize.small, '', this.$scope, function () { _this.loadMore(); }, new web.services.UserData(user, this.isCustomerMode), null);
                };
                UsersController.$inject = ['$scope', '$timeout', '$filter', '$q', 'modalService', 'authenticationService', 'userManagementDatacontext'];
                return UsersController;
            })();
            controllers.UsersController = UsersController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("UsersController", ['$scope', '$timeout', '$filter', '$q', 'modalService', 'authenticationService', 'userManagementDatacontext']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var UserForgotPasswordController = (function (_super) {
                __extends(UserForgotPasswordController, _super);
                function UserForgotPasswordController($scope, modalService, authenticationService, userManagementDatacontext) {
                    _super.call(this);
                    this.$scope = $scope;
                    this.modalService = modalService;
                    this.authenticationService = authenticationService;
                    this.userManagementDatacontext = userManagementDatacontext;
                    $scope.viewModel = this;
                    this.data = this.$scope.ngDialogData;
                    this.user = { email: '' };
                    this.completed = false;
                }
                UserForgotPasswordController.prototype.reset = function () {
                    var _this = this;
                    this.userManagementDatacontext.forgotPassword(this.user).then(function () {
                        _this.completed = true;
                    }).catch(function (response) {
                        _super.prototype.getErrorsFromModelstate.call(_this, response.data.modelState);
                    });
                };
                UserForgotPasswordController.$inject = ['$scope', 'modalService', 'authenticationService', 'userManagementDatacontext'];
                return UserForgotPasswordController;
            })(controllers.UserBaseController);
            controllers.UserForgotPasswordController = UserForgotPasswordController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("UserForgotPasswordController", ['$scope', 'modalService', 'authenticationService', 'userManagementDatacontext']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var UserResetPasswordController = (function (_super) {
                __extends(UserResetPasswordController, _super);
                function UserResetPasswordController($scope, modalService, authenticationService, userManagementDatacontext) {
                    _super.call(this);
                    this.$scope = $scope;
                    this.modalService = modalService;
                    this.authenticationService = authenticationService;
                    this.userManagementDatacontext = userManagementDatacontext;
                    $scope.viewModel = this;
                    this.user = this.$scope.ngDialogData.user;
                    this.completed = false;
                }
                UserResetPasswordController.prototype.reset = function () {
                    var _this = this;
                    this.userManagementDatacontext.forgotPassword({ email: this.user.email }).then(function () {
                        _this.completed = true;
                    }).catch(function (response) {
                        _super.prototype.getErrorsFromModelstate.call(_this, response.data.modelState);
                    });
                };
                UserResetPasswordController.$inject = ['$scope', 'modalService', 'authenticationService', 'userManagementDatacontext'];
                return UserResetPasswordController;
            })(controllers.UserBaseController);
            controllers.UserResetPasswordController = UserResetPasswordController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("UserResetPasswordController", ['$scope', 'modalService', 'authenticationService', 'userManagementDatacontext']);

var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var RefreshTokenController = (function () {
                function RefreshTokenController($rootScope, $scope, userManagementDatacontext, modalService) {
                    var _this = this;
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.userManagementDatacontext = userManagementDatacontext;
                    this.modalService = modalService;
                    this.headerText = app.localizer.resource.RefreshToken;
                    this.headers = [
                        { name: 'ClientId', text: app.localizer.resource.Device, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'ClientId' },
                        { name: 'Subject', text: app.localizer.resource.UserName, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'Subject' },
                        //{ text: localizer.resource.fullName, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'FullName' },
                        { name: 'IssuedUtc', text: app.localizer.resource.LastLoggedInDate, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'IssuedUtc', sort: 'desc' },
                        { name: 'ExpiresUtc', text: app.localizer.resource.Expires, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'ExpiresUtc' },
                        { name: '', text: "", smColSpan: 2, mdColSpan: 2, html: true, action: function (actiontype, refreshtoken) { _this.action(actiontype, refreshtoken); } }
                    ];
                    this.initialize();
                }
                RefreshTokenController.prototype.initialize = function () {
                };
                RefreshTokenController.prototype.action = function (actiontype, refreshtoken) {
                    var _this = this;
                    this.userManagementDatacontext.logOffDevice(refreshtoken).then(function () {
                        return _this.toggleReload = !_this.toggleReload;
                    });
                };
                RefreshTokenController.prototype.loadMore = function () {
                    return this.userManagementDatacontext.getUsersWithRefreshTokens().then(function (userData) {
                        return userData;
                    });
                };
                RefreshTokenController.prototype.validate = function () {
                };
                RefreshTokenController.prototype.cancel = function () {
                    //this.datacontext.rejectChangesOnEntity(this.fishgroup);
                    this.$scope.closeThisDialog();
                };
                RefreshTokenController.prototype.save = function () {
                    //if (!this.validate()) {
                    //    this.hasValidationProblem = true;
                    //    return;
                    //} else {
                    //    this.hasValidationProblem = false;
                    //    this.datacontext.saveEntities([this.fishgroup]).then(() => {
                    //        this.datacontext.saveEntities([this.fishgroup]);
                    //        this.$scope.confirm(this.fishgroup);
                    //        return true;
                    //    });
                    //}
                };
                RefreshTokenController.$inject = ['$rootScope', '$scope', 'userManagementDatacontext', 'modalService'];
                return RefreshTokenController;
            })();
            controllers.RefreshTokenController = RefreshTokenController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("RefreshTokenController", ['$rootScope', '$scope', 'userManagementDatacontext', 'modalService']);

var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var ClientsController = (function () {
                function ClientsController($rootScope, $scope, userManagementDatacontext, modalService) {
                    var _this = this;
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.userManagementDatacontext = userManagementDatacontext;
                    this.modalService = modalService;
                    this.headerText = app.localizer.resource.RefreshToken;
                    this.headers = [
                        { text: app.localizer.resource.Client, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'Id' },
                        { text: app.localizer.resource.Name, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'Name' },
                        { text: app.localizer.resource.RefreshTokenLifeTime, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'RefreshTokenLifeTime' },
                        { text: app.localizer.resource.AllowedOrigin, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'AllowedOrigin' },
                        { text: app.localizer.resource.Secret, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'Secret' },
                        { text: app.localizer.resource.Active, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'Active', action: function (actiontype, client) { _this.action(actiontype, client); } }
                    ];
                    this.initialize();
                }
                ClientsController.prototype.initialize = function () {
                };
                ClientsController.prototype.action = function (actiontype, client) {
                    var _this = this;
                    switch (actiontype) {
                        case "toggleActive":
                            return this.userManagementDatacontext.toggleActive(client).then(function () {
                                return _this.toggleReload = !_this.toggleReload;
                            });
                    }
                };
                ClientsController.prototype.loadMore = function () {
                    return this.userManagementDatacontext.getClients().then(function (clients) {
                        return clients;
                    });
                };
                ClientsController.prototype.addClient = function () {
                    var _this = this;
                    var entityDeclaration = {
                        "id": { name: "ClienId", propertyName: "id", required: true, type: "string" },
                        "name": { name: "Name", propertyName: "name", required: true, type: "string" },
                        "refreshTokenLifeTime": { name: "RefreshTokenLifeTime", propertyName: "refreshTokenLifeTime", required: true, type: "number" },
                        "allowedOrigin": { name: "AllowedOrigin", propertyName: "allowedOrigin", required: true, type: "string" },
                        "active": { name: "Active", propertyName: "active", required: false, type: "boolean" }
                    };
                    this.modalService.show('modules/base_entity/base.entity.html', app.constants.dialogSize.small, '', this.$scope, function () { }, new app.web.services.EntityData(app.localizer.resource.RefreshToken, entityDeclaration, function (client) { return _this.saveClient(client); }));
                };
                ClientsController.prototype.saveClient = function (client) {
                    var _this = this;
                    return this.userManagementDatacontext.addClient(client).then(function () {
                        return _this.toggleReload = !_this.toggleReload;
                    });
                };
                ClientsController.prototype.cancel = function () {
                    //this.datacontext.rejectChangesOnEntity(this.fishgroup);
                    this.$scope.closeThisDialog();
                };
                ClientsController.prototype.save = function () {
                    //if (!this.validate()) {
                    //    this.hasValidationProblem = true;
                    //    return;
                    //} else {
                    //    this.hasValidationProblem = false;
                    //    this.datacontext.saveEntities([this.fishgroup]).then(() => {
                    //        this.datacontext.saveEntities([this.fishgroup]);
                    //        this.$scope.confirm(this.fishgroup);
                    //        return true;
                    //    });
                    //}
                };
                ClientsController.$inject = ['$rootScope', '$scope', 'userManagementDatacontext', 'modalService'];
                return ClientsController;
            })();
            controllers.ClientsController = ClientsController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("ClientsController", ['$rootScope', '$scope', 'userManagementDatacontext', 'modalService']);

/// <reference path="../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var ResetPasswordController = (function (_super) {
                __extends(ResetPasswordController, _super);
                function ResetPasswordController($scope, $state, $rootScope, $location, $interval, appLocalStorage, env, userManagementDatacontext, modalService) {
                    var _this = this;
                    _super.call(this);
                    this.$scope = $scope;
                    this.$state = $state;
                    this.$rootScope = $rootScope;
                    this.$location = $location;
                    this.$interval = $interval;
                    this.appLocalStorage = appLocalStorage;
                    this.env = env;
                    this.userManagementDatacontext = userManagementDatacontext;
                    this.modalService = modalService;
                    this.showForm = false;
                    this.isInitialized = false;
                    this.footerText = '';
                    this.footerText = '© ' + moment().year() + ' ' + env.companyName;
                    this.isInitialized = true;
                    this.completed = false;
                    this.invalidToken = false;
                    this.model = { email: '', password: '', confirmPassword: '', code: this.$location.search().code, isNewUser: this.$location.search().isNewUser };
                    this.isInitializedInterval = this.$interval(function () {
                        if (_this.appLocalStorage.applicationStatusGet().applicationInitialized) {
                            _this.showForm = true;
                            _this.$interval.cancel(_this.isInitializedInterval);
                        }
                    }, 100, 0);
                }
                ResetPasswordController.prototype.setPassword = function () {
                    var _this = this;
                    this.userManagementDatacontext.resetPassword(this.model).then(function () {
                        _this.completed = true;
                    }).catch(function (response) {
                        if (response.data.message === "Invalid token") {
                            _this.invalidToken = true;
                        }
                        else {
                            _super.prototype.getErrorsFromModelstate.call(_this, response.data.modelState);
                        }
                    });
                };
                ResetPasswordController.prototype.resetPassword = function () {
                    this.modalService.show('modules/user_settings/user.forgotpassword.html', app.constants.dialogSize.small, '', this.$scope, function () { }, null);
                };
                ResetPasswordController.prototype.goToLogin = function () {
                    this.$state.go('login');
                };
                ResetPasswordController.$inject = ['$scope', '$state', '$rootScope', '$location', '$interval', 'appLocalStorage', 'ENV', 'userManagementDatacontext', 'modalService'];
                return ResetPasswordController;
            })(controllers.UserBaseController);
            controllers.ResetPasswordController = ResetPasswordController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("ResetPasswordController", ['$scope', '$state', '$rootScope', '$location', '$interval', 'appLocalStorage', 'ENV', 'userManagementDatacontext', 'modalService']);

var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var BaseEntityController = (function () {
                function BaseEntityController($rootScope, $scope, userManagementDatacontext, modalService) {
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.userManagementDatacontext = userManagementDatacontext;
                    this.modalService = modalService;
                    this.headerText = $scope.ngDialogData.headerText;
                    ;
                    this.saveFunc = $scope.ngDialogData.saveFunc;
                    this.entityDeclaration = $scope.ngDialogData.entityDeclaration;
                    this.initialize();
                }
                BaseEntityController.prototype.initialize = function () {
                    this.hasValidationIssues = false;
                    if (!this.entityDeclaration)
                        throw new Error('No entityDeclaration defined.');
                    if (this.entityDeclaration.entityAspect != undefined) {
                        this.createEntityDeclarationFromBreeze();
                    }
                    else {
                        this.createEntity();
                    }
                };
                BaseEntityController.prototype.createEntity = function () {
                    var _this = this;
                    var visibleProperties = this.$scope.ngDialogData.visibleProperties;
                    if (visibleProperties != null && visibleProperties.length > 0) {
                        this.properties = {};
                        _.forEach(visibleProperties, function (visiblePropertyName) {
                            var property = _.find(_this.entityDeclaration, function (prop) { return prop.name === visiblePropertyName; });
                            _this.properties[visiblePropertyName] = property;
                        });
                    }
                    else {
                        this.properties = this.entityDeclaration;
                    }
                    //Add properties to entity
                    for (var key in this.entityDeclaration) {
                        this.entity = $.extend({}, this.entity);
                        this.entity[key] = null;
                    }
                };
                BaseEntityController.prototype.createEntityDeclarationFromBreeze = function () {
                    var _this = this;
                    this.entity = this.entityDeclaration;
                    var visibleProperties = this.$scope.ngDialogData.visibleProperties;
                    if (visibleProperties == null || visibleProperties.length == 0)
                        throw new Error('VisibleProperties must be set for breeze objects');
                    var breezeProperties = this.entityDeclaration.entityAspect.entityManager.metadataStore.getEntityType(this.entityDeclaration.entityAspect.entity.entityType.shortName).getProperties();
                    this.properties = {};
                    _.forEach(visibleProperties, function (visiblePropertyName) {
                        var property = _.find(breezeProperties, function (prop) { return prop.name === visiblePropertyName; });
                        if (property != null) {
                            _this.properties[visiblePropertyName] = {
                                name: visiblePropertyName,
                                propertyName: visiblePropertyName,
                                required: !property.isNullable,
                                type: property.dataType.getName().toLowerCase()
                            };
                        }
                    });
                };
                BaseEntityController.prototype.hasError = function (propertyName) {
                    if (!this.entity)
                        return false;
                    return this.properties[propertyName].required ? app.common.utils.isNullOrUndefinedOrEmpty(this.entity[propertyName]) : false;
                };
                BaseEntityController.prototype.cancel = function () {
                    this.$scope.closeThisDialog();
                };
                BaseEntityController.prototype.save = function () {
                    var _this = this;
                    this.hasValidationIssues = false;
                    return this.saveFunc(this.entity).then(function () {
                        _this.cancel();
                    }, function (error) {
                        _this.hasValidationIssues = true;
                        _this.errorMessage = error.Message;
                    });
                };
                BaseEntityController.$inject = ['$rootScope', '$scope', 'modalService'];
                return BaseEntityController;
            })();
            controllers.BaseEntityController = BaseEntityController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("BaseEntityController", ['$rootScope', '$scope', 'modalService']);

/// <reference path="../../_typings.web.ts"/>
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var PrescriptionListController = (function (_super) {
                __extends(PrescriptionListController, _super);
                function PrescriptionListController($rootScope, $scope, fileSaver, authenticationService, prescriptionDatacontext, assessmentDatacontext, navigationService, appLocalStorage, modalService, excelService, $locale, $window) {
                    var _this = this;
                    _super.call(this);
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.fileSaver = fileSaver;
                    this.authenticationService = authenticationService;
                    this.prescriptionDatacontext = prescriptionDatacontext;
                    this.assessmentDatacontext = assessmentDatacontext;
                    this.navigationService = navigationService;
                    this.appLocalStorage = appLocalStorage;
                    this.modalService = modalService;
                    this.excelService = excelService;
                    this.$locale = $locale;
                    this.$window = $window;
                    this.pagedPrescriptions = [];
                    this.currentPage = -1;
                    this.itemsPerPage = 30;
                    this.totalRows = 0;
                    this.selectedDateRangeString = "";
                    this.SCREEN_WIDTH_BREAKPOINT_IN_PIXEL = 810;
                    this.originalHeaders = [
                        {
                            name: "",
                            text: "",
                            class: "fixed-width-2",
                            html: false,
                            propertyName: "",
                            sort: app.constants.sortTypes.notSortable
                        },
                        {
                            name: "Date",
                            text: app.localizer.resource.Date,
                            class: "fixed-width-7",
                            html: false,
                            propertyName: "prescriptionDate",
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: "prescriptionNumber",
                            text: app.localizer.resource["PrescriptionNumber"],
                            class: "fixed-width-8",
                            html: false,
                            propertyName: "prescriptionNumber",
                            textOverflow: true,
                            sort: app.constants.sortTypes.none
                        },
                        {
                            name: "Customer",
                            text: app.localizer.resource["Customer"],
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: "customer",
                            textOverflow: true,
                            sort: app.constants.sortTypes.none
                        },
                        {
                            name: "Site",
                            text: app.localizer.resource.Site,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: "siteName",
                            textOverflow: true,
                            sort: app.constants.sortTypes.none,
                            selectSite: function (siteId) { return _this.selectSite(siteId); }
                        },
                        {
                            text: app.localizer.resource["Filter_TreatmentProduct"],
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: "treatmentProductName",
                            textOverflow: true,
                            sort: app.constants.sortTypes.none
                        },
                        {
                            text: app.localizer.resource["Amount"],
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: "amountString",
                            textOverflow: true,
                            sort: app.constants.sortTypes.none
                        },
                        {
                            text: app.localizer.resource["ActiveSubstance"],
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: "activeSubstance",
                            textOverflow: true,
                            sort: app.constants.sortTypes.none
                        },
                        {
                            name: "Inclusion",
                            text: app.localizer.resource["TreatmentProduct_Inclusion"],
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: "concentrationString",
                            textOverflow: true,
                            sort: app.constants.sortTypes.none
                        },
                        {
                            text: app.localizer.resource["Veterinary"],
                            class: "fixed-width-8",
                            html: false,
                            propertyName: "vetFullName",
                            textOverflow: true,
                            sort: app.constants.sortTypes.none
                        },
                        {
                            name: "CreatedTime",
                            text: app.localizer.resource.AuditType_Create,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: "createdTime",
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: "Activating",
                            text: app.localizer.resource["Prescription_Activating"],
                            class: "fixed-width-7",
                            html: false,
                            propertyName: "",
                            sort: app.constants.sortTypes.none
                        },
                        {
                            name: "Files",
                            text: app.localizer.resource.Files,
                            class: "prescription-list-file-column",
                            html: false,
                            propertyName: "prescriptionFiles",
                            sort: app.constants.sortTypes.notSortable,
                            openAttachedFile: function (prescriptionId, file) {
                                _this.openAttachment(prescriptionId, file);
                            }
                        },
                        {
                            name: "Options",
                            text: "",
                            class: "pull-right fixed-width-2",
                            html: false,
                            propertyName: "",
                            confirm: function (prescription) {
                                _this.delete(prescription);
                            },
                            toggleLocking: function (prescription, comment) {
                                _this.saveToggleLock(prescription, comment);
                            },
                            toggleActivating: function (prescription, comment) {
                                _this.saveToggleActive(prescription, comment);
                            },
                            sort: app.constants.sortTypes.notSortable
                        }
                    ];
                    this.smallScreenHeaders = [
                        {
                            name: "",
                            text: "",
                            class: "fixed-width-2 no-padding-right",
                            html: false,
                            propertyName: "",
                            sort: app.constants.sortTypes.notSortable
                        },
                        {
                            name: "Date",
                            text: app.localizer.resource.Date,
                            class: "no-padding-right fixed-width-7",
                            html: false,
                            propertyName: "prescriptionDate",
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: "prescriptionNumber",
                            text: app.localizer.resource["PrescriptionNumber"],
                            class: "no-padding-right fixed-width-8",
                            html: false,
                            propertyName: "prescriptionNumber",
                            textOverflow: true,
                            sort: app.constants.sortTypes.none
                        },
                        {
                            name: "Site",
                            text: app.localizer.resource.Site,
                            class: "no-padding-right fixed-width-6",
                            html: false,
                            propertyName: "siteName",
                            textOverflow: true,
                            sort: app.constants.sortTypes.none,
                            selectSite: function (siteId) { return _this.selectSite(siteId); }
                        },
                        {
                            text: app.localizer.resource["Filter_TreatmentProduct"],
                            class: "no-padding-right fixed-width-10",
                            html: false,
                            propertyName: "treatmentProductName",
                            textOverflow: true,
                            sort: app.constants.sortTypes.none
                        },
                        {
                            text: app.localizer.resource["Amount"],
                            class: "fixed-width-6 no-padding-right",
                            html: false,
                            propertyName: "amountString",
                            textOverflow: true,
                            sort: app.constants.sortTypes.none
                        },
                        {
                            text: app.localizer.resource["Veterinary"],
                            class: "fixed-width-6 no-padding-right",
                            html: false,
                            propertyName: "vetFullName",
                            textOverflow: true,
                            sort: app.constants.sortTypes.none
                        },
                        {
                            name: "Activating",
                            text: app.localizer.resource["Prescription_Activating"],
                            class: "fixed-width-4 no-padding-right",
                            html: false,
                            propertyName: "",
                            sort: app.constants.sortTypes.none
                        },
                        {
                            name: "Options",
                            text: "",
                            class: "pull-right fixed-width-2 no-padding-right",
                            html: false,
                            propertyName: "",
                            confirm: function (prescription) {
                                _this.delete(prescription);
                            },
                            toggleLocking: function (prescription, comment) {
                                _this.saveToggleLock(prescription, comment);
                            },
                            toggleActivating: function (prescription, comment) {
                                _this.saveToggleActive(prescription, comment);
                            },
                            sort: app.constants.sortTypes.notSortable
                        }
                    ];
                    this.headers = this.$window.innerWidth >= this.SCREEN_WIDTH_BREAKPOINT_IN_PIXEL ? this.originalHeaders : this.smallScreenHeaders;
                    this.initFilterList();
                    this.$scope.$on(app.constants.broadcastEventNames.navigationObjectIdChanged, function (event, data) {
                        _this.setSelectedSiteFilter();
                        _this.prescriptionDatacontext.setPrescriptionFaDFiltersList(_this.filterList);
                    });
                    this.$scope.$on(app.constants.broadcastEventNames.registrationCompleted, function () {
                        _this.toggleFilterChangedProperty();
                        _this.prescriptionDatacontext.setPrescriptionFaDFiltersList(_this.filterList);
                    });
                    this.$scope.$on(app.constants.broadcastEventNames.refreshTable, function () {
                        _this.toggleFilterChangedProperty();
                    });
                    this.$scope.$watch(function () { return _this.$window.innerWidth; }, function (newval, oldval) {
                        // console.log('innerWidth', newval);
                        var innerWidth = newval;
                        var oldInnerWidth = oldval;
                        if (innerWidth < _this.SCREEN_WIDTH_BREAKPOINT_IN_PIXEL && oldInnerWidth >= _this.SCREEN_WIDTH_BREAKPOINT_IN_PIXEL) {
                            _this.headers = _this.smallScreenHeaders;
                            _this.toggleFilterChangedProperty();
                        }
                        if (innerWidth >= _this.SCREEN_WIDTH_BREAKPOINT_IN_PIXEL && oldInnerWidth < _this.SCREEN_WIDTH_BREAKPOINT_IN_PIXEL) {
                            _this.headers = _this.originalHeaders;
                            _this.toggleFilterChangedProperty();
                        }
                    });
                    this.setSelectedSiteFilter();
                    this.prescriptionDatacontext.setPrescriptionFaDDateRange(this.dateRange);
                    this.prescriptionDatacontext.setPrescriptionFaDFiltersList(this.filterList);
                }
                PrescriptionListController.prototype.selectSite = function (siteId) {
                    this.$rootScope.$broadcast(app.constants.broadcastEventNames.siteSelected, app.constants.operationUnitLevels.site + "-" + siteId);
                };
                PrescriptionListController.prototype.openAttachment = function (prescriptionId, filename) {
                    var _this = this;
                    this.prescriptionDatacontext.openAttachedFile(prescriptionId, filename)
                        .then(function (result) {
                        _this.fileSaver.saveAs(new Blob([result.data]), filename);
                    });
                    ;
                };
                PrescriptionListController.prototype.setSelectedSiteFilter = function () {
                    var _this = this;
                    var siteFilter = _.find(this.filterList, function (filter) { return filter.name === app.constants.assessmentProperties.site; });
                    if (siteFilter) {
                        siteFilter.selectedIds.length = 0;
                        if (this.navigationService.isOnSiteLevel()) {
                            siteFilter.isLocked = true;
                            angular.forEach(siteFilter.masterCollection, function (item) {
                                item.selected =
                                    item.id === _this.navigationService.selectedObjectId;
                                if (item.selected)
                                    siteFilter.selectedIds.push(item.id);
                            });
                        }
                        else {
                            siteFilter.isLocked = false;
                            angular.forEach(siteFilter.masterCollection, function (item) {
                                item.selected = false;
                            });
                        }
                    }
                };
                PrescriptionListController.prototype.changeDateRange = function () {
                    this.toggleFilterChangedProperty();
                    this.prescriptionDatacontext.setPrescriptionFaDDateRange(this.dateRange);
                };
                PrescriptionListController.prototype.toggleShowAllDate = function () {
                    if (this.showAllDate === true) {
                        this.dateRange = new controllers.DateRange(moment("1900-01-01"), moment().add(1, 'y'));
                        var format = this.$locale.DATETIME_FORMATS["shortDate"].toUpperCase();
                        format = app.common.utils.getDateFormat(format);
                        this.selectedDateRangeString = this.dateRange.startDate.format(format).toString()
                            + " - " + this.dateRange.endDate.format(format).toString();
                    }
                    if (this.showAllDate === false)
                        this.dateRange = new controllers.DateRange(moment().startOf('month').subtract(1, 'y'), moment().endOf("month"));
                    this.changeDateRange();
                };
                PrescriptionListController.prototype.initFilterList = function () {
                    var _this = this;
                    this.dateRange = new controllers.DateRange(moment().startOf('month').subtract(1, 'y'), moment().endOf("month"));
                    this.filterList = new Array();
                    var sites = _.sortBy(this.navigationService.getSites(), "name");
                    var optionList = new Array();
                    angular.forEach(sites, function (site) {
                        optionList.push(new web.model.DropdownOption(site.name, site.siteId, -1, app.constants.assessmentProperties.site, false));
                    });
                    var filterOfSite = new app.web.directives.Filter(app.constants.assessmentProperties.site, "Filter_Site", optionList, [], false, false);
                    var treatmentProducts = this.prescriptionDatacontext.getTreatmentProductsFromCache(this.navigationService.selectedCustomerId);
                    optionList = new Array();
                    angular.forEach(treatmentProducts, function (treatmentProduct) {
                        optionList.push(new web.model.DropdownOption(treatmentProduct.name, treatmentProduct.treatmentProductId, 0, app.constants.prescriptionProperties.treatmentProduct, false)); //TODO: Get the translation
                    });
                    var representatives = this.assessmentDatacontext.getNahRepresentatives();
                    optionList = new Array();
                    angular.forEach(representatives, function (representative) {
                        optionList.push(new web.model.DropdownOption(representative.fullName, representative.vetUserId, 0, app.constants.assessmentProperties.representative, false));
                    });
                    var filterOfRepresentative = new web.directives.Filter(app.constants.assessmentProperties.representative, "Filter_Representative", optionList, [], false, false);
                    this.filterList = [filterOfSite, filterOfRepresentative];
                    this.prescriptionDatacontext.getTreatmentProducts(this.navigationService.selectedCustomerId, false).then(function (treatmentProducts) {
                        optionList = new Array();
                        angular.forEach(treatmentProducts, function (treatmentProduct) {
                            optionList.push(new web.model.DropdownOption(treatmentProduct.name, treatmentProduct.treatmentProductId, 0, app.constants.prescriptionProperties.treatmentProduct, false)); //TODO: Get the translation
                        });
                        var filterOfTreatmentProducts = new app.web.directives.Filter(app.constants.prescriptionProperties.treatmentProduct, "Filter_TreatmentProduct", optionList, [], false, false);
                        _this.filterList = [filterOfSite, filterOfTreatmentProducts, filterOfRepresentative];
                    });
                };
                PrescriptionListController.prototype.loadMore = function () {
                    var _this = this;
                    this.currentPage++;
                    return this.prescriptionDatacontext
                        .getPrescriptions(this.currentPage, this.itemsPerPage, this.filterList, this.dateRange, this.authenticationService.credentialsCurrentUserGet().UserId, "Web App")
                        .then(function (data) {
                        // allow locked prescription only - VET-295
                        // if current user is customer user, this is customer portal
                        if (_this.authenticationService.isCustomerUser()) {
                            var results = data.results;
                            data.results = results.filter(function (item) {
                                return item["isLocked"] === true;
                            });
                        }
                        data.results = _this.prescriptionDatacontext.addPropertiesForListPrescriptions(data.results);
                        // console.log("data", data.results);
                        // remove this.Prescriptions because it do not allow the this.pagedPrescriptions to be grown
                        if (_this.currentPage > 0) {
                            _this.pagedPrescriptions = _this.pagedPrescriptions.concat(data.results);
                            _this.Prescriptions.concat(data.results);
                        }
                        else {
                            _this.pagedPrescriptions = data.results;
                            _this.Prescriptions = data.results;
                        }
                        _this.totalRows = data.inlineCount;
                        // append draft prescription
                        var draftPrescriptions = _this.getDraftPrescriptions(_this.filterList, _this.dateRange, _this.appLocalStorage);
                        if (draftPrescriptions && draftPrescriptions.length > 0) {
                            _this.pagedPrescriptions = draftPrescriptions.concat(_this.pagedPrescriptions);
                            _this.totalRows += draftPrescriptions.length;
                        }
                        _this.$rootScope.$broadcast(app.constants.broadcastEventNames.refreshMenus);
                        return _this.pagedPrescriptions;
                    });
                };
                PrescriptionListController.prototype.getDraftPrescriptions = function (filterList, dateRange, appLocalStorage) {
                    var temp = appLocalStorage.draftPrescriptionsGet();
                    var result = null;
                    if (!app.common.utils.isNullOrUndefinedOrEmpty(temp)) {
                        result = JSON.parse(temp);
                        if (result.length > 0) {
                            var filter = new web.model.AssessmentFilter();
                            filter.setFilterValuesFromFilterList(filterList);
                            if (dateRange.startDate) {
                                result = result.filter(function (r) {
                                    return (moment(dateRange.startDate).isBefore(r["prescriptionDate"])
                                        || moment(dateRange.startDate).isSame(r["prescriptionDate"]));
                                });
                            }
                            if (dateRange.endDate) {
                                result = result.filter(function (r) {
                                    return (moment(dateRange.endDate).isAfter(r["prescriptionDate"])
                                        || moment(dateRange.endDate).isSame(r["prescriptionDate"]));
                                });
                            }
                            var treatmentProductsFilter = _.find(filterList, function (filter) { return filter["name"] === app.constants.prescriptionProperties.treatmentProduct; });
                            if (treatmentProductsFilter) {
                                var seletedIds = treatmentProductsFilter["selectedIds"];
                                if (seletedIds && seletedIds.length > 0) {
                                    result = result.filter(function (r) {
                                        return seletedIds.indexOf(r["treatmentProductId"]) > -1;
                                    });
                                }
                            }
                            var representativeFilter = _.find(filterList, function (filter) { return filter["name"] === app.constants.assessmentProperties.representative; });
                            if (representativeFilter) {
                                var representativeSeletedIds = representativeFilter["selectedIds"];
                                if (representativeSeletedIds && representativeSeletedIds.length > 0) {
                                    result = result.filter(function (r) {
                                        return representativeSeletedIds.indexOf(r["regionalAuthorityId"]) > -1;
                                    });
                                }
                            }
                            var siteFilter = _.find(filterList, function (filter) { return filter["name"] === app.constants.assessmentProperties.site; });
                            if (siteFilter) {
                                var siteSeletedIds = siteFilter["selectedIds"];
                                if (siteSeletedIds && siteSeletedIds.length > 0) {
                                    result = result.filter(function (r) {
                                        return siteSeletedIds.indexOf(r["siteId"]) > -1;
                                    });
                                }
                            }
                            return result;
                        }
                        else
                            return [];
                    }
                    else
                        return [];
                };
                PrescriptionListController.prototype.toggleFilterChangedProperty = function () {
                    if (this.currentPage < 0)
                        return; //skip those redundant filterchange calls
                    this.currentPage = -1;
                    this.toggleFilterChanged = !this.toggleFilterChanged;
                };
                PrescriptionListController.prototype.delete = function (prescription) {
                    var _this = this;
                    // check draft or not
                    if (prescription["isDraft"] && prescription["isDraft"] === true) {
                        var draftPrescriptions = null;
                        // delete prescription in table
                        _.remove(this.pagedPrescriptions, function (currentObject) {
                            return (currentObject.prescriptionId === -1
                                && currentObject.createdTime === prescription.createdTime);
                        });
                        this.toggleFilterChangedProperty();
                        // delete prescription in local Storage;
                        this.appLocalStorage.draftPrescriptionsDeleteItem(prescription["createdTime"]);
                    }
                    else {
                        //event.entityAspect.setDeleted();
                        _.remove(this.pagedPrescriptions, function (currentObject) {
                            return (currentObject.prescriptionId === prescription.prescriptionId);
                        });
                        this.prescriptionDatacontext
                            .deletePrescription(prescription.prescriptionId)
                            .then(function () {
                            _this.toggleFilterChangedProperty();
                        });
                    }
                };
                PrescriptionListController.prototype.saveToggleLock = function (prescription, comment) {
                    var _this = this;
                    var auditType = app.constants.auditTypes.Lock;
                    var isLocking = !prescription.isLocked;
                    if (prescription.isLocked) {
                        auditType = app.constants.auditTypes.Unlock;
                    }
                    this.assessmentDatacontext.createAudit({
                        auditDate: moment(),
                        tableName: app.constants.entityNames.prescription,
                        userId: this.authenticationService.credentialsCurrentUserGet().UserId,
                        auditingTypeId: auditType,
                        key: prescription.prescriptionId,
                        comment: comment
                    });
                    return this.assessmentDatacontext.save().then(function (result) {
                        prescription.isLocked = !prescription.isLocked;
                        _this.$rootScope.$broadcast(app.constants.broadcastEventNames.refreshMenus);
                        if (isLocking) {
                            _this.generateAndStorePdf(result, prescription.prescriptionId);
                        }
                    });
                };
                PrescriptionListController.prototype.generateAndStorePdf = function (result, prescriptionId) {
                    //Get new auditId
                    var entities = (result.entities);
                    if (entities && entities.length > 0) {
                        var auditId = entities[0].auditId;
                        //Get language id from culture
                        var languageId = this.assessmentDatacontext.getLanguageId(this.appLocalStorage.applicationStatusGet().translationsCulture);
                        this.prescriptionDatacontext.saveLockePrescriptionPdf(prescriptionId, languageId, app.localizer.resource["Prescription"], auditId);
                    }
                };
                PrescriptionListController.prototype.openAuditPdf = function (assessment, auditId) {
                    this.modalService.show("modules/report/report.html", app.constants.dialogSize.large, "", this.$scope, function () { }, new app.web.services.ReportData(assessment.assessmentId, app.enums.entityType.Prescription, app.localizer.resource["Prescription"], false, app.localizer.resource["Prescription"] + ".pdf", auditId));
                };
                PrescriptionListController.prototype.saveToggleActive = function (prescription, comment) {
                    var _this = this;
                    var newAuditType;
                    if (!prescription.isActivate) {
                        newAuditType = app.constants.auditTypes.Activate;
                    }
                    else {
                        newAuditType = app.constants.auditTypes.Deactivate;
                    }
                    this.prescriptionDatacontext.createAudit({
                        auditDate: moment(),
                        tableName: app.constants.entityNames.prescription,
                        userId: this.authenticationService.credentialsCurrentUserGet().UserId,
                        auditingTypeId: newAuditType,
                        key: prescription.prescriptionId,
                        comment: comment
                    });
                    return this.prescriptionDatacontext.save().then(function (result) {
                        prescription.isActivate = !prescription.isActivate;
                        _this.$rootScope.$broadcast(app.constants.broadcastEventNames.refreshMenus);
                    });
                };
                PrescriptionListController.$inject = [
                    "$rootScope",
                    "$scope",
                    "FileSaver",
                    "authenticationService",
                    "prescriptionDatacontext",
                    "assessmentDatacontext",
                    "navigationService",
                    "appLocalStorage",
                    "modalService",
                    "excelService",
                    "$locale",
                    "$window"
                ];
                return PrescriptionListController;
            })(controllers.BaseListController);
            controllers.PrescriptionListController = PrescriptionListController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("PrescriptionListController", [
    "$rootScope",
    "$scope",
    "FileSaver",
    "authenticationService",
    "prescriptionDatacontext",
    "assessmentDatacontext",
    "navigationService",
    "appLocalStorage",
    "modalService",
    "excelService",
    "$locale",
    "$window"
]);

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/// <reference path="../../_typings.web.ts"/>
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var PrescriptionEditController = (function (_super) {
                __extends(PrescriptionEditController, _super);
                function PrescriptionEditController($rootScope, $scope, $timeout, $q, prescriptionDatacontext, assessmentDataContext, appLocalStorage, modalService, wizardHandler, authenticationService, paletteService, navigationService, $window, $translate, apiEndpointService, fileSaver) {
                    var _this = this;
                    _super.call(this, $scope, modalService);
                    this.$rootScope = $rootScope;
                    this.$scope = $scope;
                    this.$timeout = $timeout;
                    this.$q = $q;
                    this.prescriptionDatacontext = prescriptionDatacontext;
                    this.assessmentDataContext = assessmentDataContext;
                    this.appLocalStorage = appLocalStorage;
                    this.modalService = modalService;
                    this.wizardHandler = wizardHandler;
                    this.authenticationService = authenticationService;
                    this.paletteService = paletteService;
                    this.navigationService = navigationService;
                    this.$window = $window;
                    this.$translate = $translate;
                    this.apiEndpointService = apiEndpointService;
                    this.fileSaver = fileSaver;
                    this.feedCompanySupplierBitMask = 0;
                    this.pharmacySupplierBitMask = 0;
                    // Wizard navigation
                    this.nextButtonText = "next";
                    this.backButtonText = "previous";
                    this.lastButtonText = "";
                    this.showBackButton = false;
                    this.isLastStep = false;
                    this.isLocked = false;
                    this.hasValidationError = false;
                    this.errorMessage = "Error_ValidationErrors";
                    this.editMode = true;
                    this.readonly = false;
                    this.isFarmerIntegrationOn = false;
                    this.selectedFarmerSpeciesName = null;
                    this.selectedFarmerProductionStage = null;
                    this.showErrorAlert = false;
                    this.cellTemplate = 'modules/prescription/file.cell.tpl.html';
                    this.rowHeaderTemplate = 'modules/prescription/rowHeader.tpl.html';
                    this.GridHeaderHeightInPixel = 30;
                    this.GridOffsetInPixel = 30;
                    this.steps = [
                        ["prescriptionDate", "prescriptionNumber", "fieldAssistant"],
                        ["specie", "site", "productionStage", "weight", "biomass"],
                        [
                            "treatmentProduct",
                            "amount",
                            "amountMeasure",
                            "dSSN",
                            "userGuide",
                            "treatmentStart",
                            "treatmentEnd",
                            "regionalAuthority",
                            "pelletSize",
                            "packaging",
                            "withdrawal"
                        ],
                        ["comments"]
                    ];
                    this.PrescriptionManualCheckProperties = {
                        fieldAssistant: {
                            maxLength: 100,
                            translateKey: 'Prescription_FieldAssistant'
                        },
                        packaging: {
                            maxLength: 500,
                            translateKey: 'Packing'
                        },
                        withdrawal: {
                            maxLength: 100,
                            translateKey: 'Prescription_Withdrawal'
                        }
                    };
                    this.errorMessageOnProperty = {};
                    this.treatmentPeriodDateRange = {
                        startDate: null,
                        endDate: null
                    };
                    var now = new Date();
                    this.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                    this.isFarmerIntegrationOn = appLocalStorage.farmerIntegerationEnabledGet();
                    this.$q.when(this.getPrescription()).then(function (data) {
                        _this.prescriptionData = data;
                        var now = new Date();
                        _this.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                        if (_this.prescriptionData) {
                            _this.siteId = _this.prescriptionData.siteId;
                            if (_this.prescriptionData.treatmentStart != null &&
                                _this.prescriptionData.treatmentEnd != null) {
                                _this.treatmentPeriodDateRange = {
                                    startDate: moment(_this.prescriptionData.treatmentStart),
                                    endDate: moment(_this.prescriptionData.treatmentEnd)
                                };
                            }
                            var getSupplierBitMaskResult = _this.getSupplierType(_this.prescriptionData.supplierTypeBitMask);
                            _this.feedCompanySupplierBitMask = getSupplierBitMaskResult.feedCompanySupplierValue;
                            _this.pharmacySupplierBitMask = getSupplierBitMaskResult.pharmacySupplierValue;
                        }
                        _this.draftPrescription = _this.generateDraftPrescription();
                        if (_this.isFarmerIntegrationOn) {
                            _this.$q
                                .when(_this.getFarmerInventory())
                                .then(function (data) {
                                _this.farmerInventory = data;
                                _this.setFarmerFishgroupColours(_this.farmerInventory);
                                _this.setDefaultSpeciesAndStage();
                            });
                        }
                        _this.initialize();
                    });
                }
                PrescriptionEditController.prototype.generateDraftPrescription = function () {
                    var draftPrescription = new app.common.utils.DraftPrescription();
                    var savedDraftPrescription = this.$scope.ngDialogData.prescription ? this.appLocalStorage.draftPrescriptionsGetByPrescription(this.$scope.ngDialogData.prescription) : null;
                    if (savedDraftPrescription !== null) {
                        draftPrescription.copy(savedDraftPrescription);
                        draftPrescription.createdTime = savedDraftPrescription["createdTime"];
                    }
                    return draftPrescription;
                };
                PrescriptionEditController.prototype.setFarmerFishgroupColours = function (data) {
                    var _this = this;
                    var grouped = _.groupBy(data, function (b) { return b.fishGroupName; });
                    var distinctFishGroups = _.uniqBy(data, "fishGroupName").length;
                    var index = 0;
                    _.forEach(grouped, function (groupValue) {
                        var colours = _this.paletteService.gen(distinctFishGroups);
                        _.forEach(groupValue, function (value) {
                            value.backgroundColor = colours[index];
                        });
                        index++;
                    });
                };
                PrescriptionEditController.prototype.getPrescription = function () {
                    if (_.isNull(this.$scope.ngDialogData.prescription) && this.$scope.ngDialogData.siteId > 0) {
                        this.siteId = this.$scope.ngDialogData.siteId;
                        return this.$q.resolve(this.prescriptionDatacontext.createPrescriptionWithSiteId(this.siteId));
                    }
                    else {
                        if (this.$scope.ngDialogData.prescription.prescriptionId && this.$scope.ngDialogData.prescription.prescriptionId < 0) {
                            // copy draftPrescription to newPrescription
                            var initialPrescriptionParams = this.getInitialPrescriptionParams(this.$scope.ngDialogData.prescription);
                            return this.$q.resolve(this.prescriptionDatacontext.createPrescription(initialPrescriptionParams));
                        }
                        else {
                            return this.prescriptionDatacontext.getPrescriptionById(this.$scope.ngDialogData.prescription.prescriptionId);
                        }
                    }
                };
                PrescriptionEditController.prototype.getInitialPrescriptionParams = function (draftPrescription) {
                    return app.common.utils.getInitialPrescriptionParams(draftPrescription);
                };
                PrescriptionEditController.prototype.getFarmerInventory = function () {
                    var isFarmerIntegrationEnabeld = true;
                    // when user has not chosen the site, there is no customer key, so customerId of prescription is used instead.
                    var customerKey;
                    if (app.common.utils.isNullOrUndefined(this.navigationService.customerKey))
                        customerKey = '2-' + this.prescriptionData.site.customer.customerId;
                    else
                        customerKey = this.navigationService.customerKey;
                    var date = this.isNew()
                        ? new Date()
                        : this.prescriptionData.prescriptionDate;
                    if (isFarmerIntegrationEnabeld) {
                        return this.assessmentDataContext.getFarmerInventory(customerKey, this.siteId, date);
                    }
                };
                PrescriptionEditController.prototype.getProductionStages = function () {
                    var _this = this;
                    var productionStages = this.prescriptionDatacontext.getProductionStages();
                    if (productionStages && productionStages.length > 0) {
                        productionStages.forEach(function (stage) {
                            stage["translatedName"] = _this.$translate.instant(stage.name);
                        });
                    }
                    else
                        return [];
                    return productionStages;
                };
                PrescriptionEditController.prototype.initialize = function () {
                    var _this = this;
                    var runTreatmentProductFirstWatch = false;
                    this.headerText = this.isNew()
                        ? app.localizer.resource.PrescriptionNewRegistration
                        : app.localizer.resource.PrescriptionEditRegistration;
                    this.editMode = !this.isNew();
                    this.site = this.assessmentDataContext.getSite(this.siteId);
                    this.userName = this.authenticationService.credentialsCurrentUserGet().FullName;
                    this.vetRepresenatives = new app.model.scopeModel.OptionSelection();
                    this.vetRepresenatives.collection = _.map((this.assessmentDataContext.getNahRepresentatives(this.siteId)), function (siteVetContact) {
                        if (_.isUndefined(siteVetContact.contactPerson)) {
                            return new app.model.scopeModel.OptionItem(siteVetContact.fullName, siteVetContact.vetUserId, siteVetContact.main);
                        }
                        else {
                            return new app.model.scopeModel.OptionItem(siteVetContact.contactPerson.fullName, siteVetContact.contactPerson.vetUserId, siteVetContact.main);
                        }
                    });
                    this.measureUnits = this.prescriptionDatacontext.getMeasureUnits()
                        .filter(function (measureUnit) { return measureUnit.name == 'kg' || measureUnit.name == 'l'; });
                    this.species = this.prescriptionDatacontext.getSpecies();
                    this.productionStages = this.getProductionStages();
                    this.suppliers = this.prescriptionDatacontext.getSuppliers(this.prescriptionData.site ? this.prescriptionData.site.customer.companyBUId : 0);
                    this.prescriptionDatacontext.getTreatmentProducts(this.prescriptionData.site ? this.prescriptionData.site.customer.companyBUId : 0).then(function (data) {
                        _this.treatmentProducts = data;
                    });
                    this.regionalAuthorities = this.prescriptionDatacontext.getRegionalAuthorities(this.prescriptionData.site ? this.prescriptionData.site.customer.companyBUId : 0);
                    this.$scope.$on(app.constants.broadcastEventNames.goToStep, function (event, data) {
                        _this.changeLabelAndGo(data.direction, data.toStepIndex);
                    });
                    this.$scope.$watch(function () { return _this.$window.innerHeight; }, function (newval, oldval) {
                        // when window is 860px, 400px is perfect.
                        // there are inputs for weight and biomass, so the height is decreased, to 330px
                        if (newval > 859)
                            _this.inventoryListHeightInPixel = 330;
                        else
                            _this.inventoryListHeightInPixel = 330 - (860 - newval);
                    });
                    this.$scope.$watch(function () { return _this.hasValidationError; }, function (newval, oldval) {
                        if (newval)
                            _this.showErrorAlert = true;
                    });
                    this.$scope.$watch(function () { return _this.gridOptions.data.length; }, function () {
                        if (!_this.gridOptions.data.length)
                            _this.gridHeight = 'auto';
                        else {
                            _this.gridHeight = _this.GridHeaderHeightInPixel
                                + _this.gridOptions.rowHeight * _this.gridOptions.data.length
                                + _this.GridOffsetInPixel;
                        }
                    });
                    this.$rootScope.$on(app.constants.broadcastEventNames.idleTimeStart, function () {
                        _this.save(app.constants.assessmentStatus.DRAFT);
                    });
                    this.gridOptions = {
                        showColumnFooter: false,
                        enableSorting: false,
                        enableColumnMenus: false,
                        columnFooterHeight: 55,
                        rowHeight: 36,
                        virtualizationThreshold: 50,
                        minRowsToShow: 50,
                        columnDefs: [
                            { name: 'rowHeaderCol', displayName: '#', field: '', maxWidth: 40, minWidth: 31, cellTemplate: this.rowHeaderTemplate },
                            { name: 'Description', field: 'description', cellTemplate: this.cellTemplate },
                            { name: 'File', field: 'name', cellTemplate: this.cellTemplate },
                            { name: 'delete', displayName: '', field: '', maxWidth: 40, minWidth: undefined, cellTemplate: this.cellTemplate }
                        ],
                        data: this.prescriptionData.prescriptionFiles,
                        appScopeProvider: this
                    };
                };
                PrescriptionEditController.prototype.addRow = function () {
                    var file = this.prescriptionDatacontext.createFile(this.prescriptionData.prescriptionId);
                    this.prescriptionData.prescriptionFiles.push(file);
                };
                PrescriptionEditController.prototype.deleteRow = function (rowIndex) {
                    var deletedfile = this.prescriptionData.prescriptionFiles.splice(rowIndex, 1);
                    if (deletedfile[0].fileId > 0)
                        deletedfile[0].entityAspect.setDeleted();
                    else
                        this.prescriptionDatacontext.assessmentUnitOfWork.detachEntity(deletedfile[0]);
                };
                PrescriptionEditController.prototype.attachementUploadTarget = function () {
                    return this.apiEndpointService.getUploadPrescriptionFileEndPoint();
                };
                PrescriptionEditController.prototype.getImageUploadHeaders = function () {
                    return this.authenticationService.getValidToken().then(function (token) {
                        return { "Authorization": 'Bearer ' + token };
                    });
                };
                PrescriptionEditController.prototype.setImageData = function (files, message, file) {
                    file.fileName = message.substring(1, message.length - 1);
                    file.error = {
                        haserror: false,
                        errorType: app.constants.errorType.None,
                        value: ''
                    };
                };
                PrescriptionEditController.prototype.removeImageData = function ($flow, file) {
                    $flow.files = [];
                    file.fileName = null;
                };
                PrescriptionEditController.prototype.upload = function ($flow) {
                    this.getImageUploadHeaders().then(function (headers) {
                        $flow.opts.headers = headers;
                        $flow.upload();
                    });
                };
                PrescriptionEditController.prototype.openAttachment = function (filename) {
                    var _this = this;
                    this.prescriptionDatacontext.openAttachedFile(this.prescriptionData.prescriptionId, filename)
                        .then(function (result) {
                        _this.fileSaver.saveAs(new Blob([result.data]), filename);
                    });
                    ;
                };
                PrescriptionEditController.prototype.getSupplierType = function (supplierTypeBitMask) {
                    if (app.common.utils.isNullOrUndefined(supplierTypeBitMask))
                        supplierTypeBitMask = 0;
                    var feedCompanySupplierValue, pharmacySupplierValue;
                    var binaryStringOfSupplierTypeBitMask = supplierTypeBitMask.toString(2);
                    var binaryCharArrayOfSupplierTypeBitMask = binaryStringOfSupplierTypeBitMask.split("");
                    binaryCharArrayOfSupplierTypeBitMask.reverse();
                    feedCompanySupplierValue = binaryCharArrayOfSupplierTypeBitMask[app.constants.SupplierTypeFeedCompanyIndex] === '1' ? 1 : 0;
                    pharmacySupplierValue = binaryCharArrayOfSupplierTypeBitMask[app.constants.SupplierTypePharmacyIndex] === '1' ? 1 : 0;
                    return {
                        feedCompanySupplierValue: feedCompanySupplierValue,
                        pharmacySupplierValue: pharmacySupplierValue
                    };
                };
                PrescriptionEditController.prototype.onChangeTreatmentProduct = function (option) {
                    var treatmentProduct = option;
                    var withdrawalMeasureUnit = null;
                    if (treatmentProduct
                        && treatmentProduct["quarantineType"])
                        withdrawalMeasureUnit = treatmentProduct["quarantineType"]["name"];
                    this.prescriptionData.withdrawal =
                        app.common.utils.appendNumberAndUnit(treatmentProduct["quarantineValue"], withdrawalMeasureUnit);
                    this.prescriptionData.dSSN = treatmentProduct.dSSN;
                    this.prescriptionData.userGuide = treatmentProduct.userGuide;
                    this.prescriptionData.supplier = treatmentProduct.supplier;
                    this.onChangeSupplier(treatmentProduct.supplier);
                };
                PrescriptionEditController.prototype.onChangeSupplier = function (option) {
                    var supplier = option;
                    var supplierTypeName;
                    if (supplier
                        && supplier.supplierType
                        && supplier.supplierType.name) {
                        supplierTypeName = supplier.supplierType.name.toString();
                        this.feedCompanySupplierBitMask = supplierTypeName.toLowerCase().indexOf("fòr") > -1 ? 1 : 0;
                        this.pharmacySupplierBitMask = supplierTypeName.toLowerCase().indexOf("apotek") > -1 ? 1 : 0;
                        this.onChangeSupplierType();
                    }
                };
                PrescriptionEditController.prototype.onChangeSupplierType = function () {
                    var bitMaskArray = ["0", "0"];
                    bitMaskArray[app.constants.SupplierTypePharmacyIndex] = this.pharmacySupplierBitMask.toString();
                    bitMaskArray[app.constants.SupplierTypeFeedCompanyIndex] = this.feedCompanySupplierBitMask.toString();
                    bitMaskArray.reverse();
                    var binaryString = bitMaskArray.join("");
                    var parseBitMaskIntResult = parseInt(binaryString, 2);
                    this.prescriptionData.supplierTypeBitMask = isNaN(parseBitMaskIntResult) ? 0 : parseBitMaskIntResult;
                };
                PrescriptionEditController.prototype.setDefaultSpeciesAndStage = function () {
                    var _this = this;
                    var specie = this.species.filter(function (spe) {
                        return spe.specieId === _this.prescriptionData["specieId"];
                    });
                    if (!app.common.utils.isNullOrUndefined(specie) && specie.length > 0)
                        this.selectedFarmerSpeciesName = specie[0]["name"];
                    var stage = this.productionStages.filter(function (spe) {
                        return spe.productionStageId === _this.prescriptionData["productionStageId"];
                    });
                    if (!app.common.utils.isNullOrUndefined(stage) && stage.length > 0)
                        this.selectedFarmerProductionStage = stage[0]["name"];
                };
                PrescriptionEditController.prototype.isNew = function () {
                    if (this.prescriptionData && this.prescriptionData.prescriptionId < 0)
                        return true;
                    else
                        return false;
                };
                PrescriptionEditController.prototype.onTreatmentPeriodDateRangeChange = function () {
                    // if range is from today to today, treatmentDateRange will not change!
                    // https://github.com/dangrossman/daterangepicker/issues/637#issuecomment-115250249
                    var _this = this;
                    setTimeout(function () {
                        if (_this.treatmentPeriodDateRange) {
                            if (!_this.treatmentPeriodDateRange.startDate)
                                _this.prescriptionData["treatmentStart"] = moment().startOf('day').toDate();
                            else
                                _this.prescriptionData["treatmentStart"] = _this.treatmentPeriodDateRange.startDate.toDate();
                            if (!_this.treatmentPeriodDateRange.endDate)
                                _this.prescriptionData["treatmentEnd"] = moment().startOf('day').toDate();
                            else
                                _this.prescriptionData["treatmentEnd"] = _this.treatmentPeriodDateRange.endDate
                                    .startOf("day")
                                    .toDate();
                        }
                    }, 1);
                };
                PrescriptionEditController.prototype.isValid = function () {
                    this.hasValidationError = !this.prescriptionDatacontext.validateEntity(this.prescriptionData);
                    return !this.hasValidationError;
                };
                PrescriptionEditController.prototype.setErrorOnProperty = function (propertyName, errorMessage, errorMessageObject) {
                    if (!propertyName)
                        return;
                    if (!errorMessage) {
                        errorMessageObject[propertyName] = {
                            errorMessage: "",
                            hasError: false
                        };
                    }
                    else {
                        errorMessageObject[propertyName] = {
                            errorMessage: errorMessage,
                            hasError: true
                        };
                    }
                };
                PrescriptionEditController.prototype.validateStep = function (currentStep) {
                    var _this = this;
                    var stepProperties = this.steps[currentStep];
                    this.errorMessageOnProperty = {};
                    var errorsInStep = [];
                    errorsInStep = _
                        .chain(this.prescriptionDatacontext.getValidationErrors(this.prescriptionData))
                        .map(function (prop) { return prop.propertyName; })
                        .intersection(stepProperties)
                        .value();
                    stepProperties.forEach(function (property) {
                        if (errorsInStep.indexOf(property) === -1
                            && !app.common.utils.isNullOrUndefined(_this.PrescriptionManualCheckProperties[property])
                            && !_this.validPropertyLength(property))
                            errorsInStep.push(property);
                    });
                    if (currentStep === 1) {
                        if (_.indexOf(errorsInStep, "weight") > -1 &&
                            _.indexOf(errorsInStep, "biomass") > -1 &&
                            _.indexOf(errorsInStep, "specie") === -1) {
                            errorsInStep.push("specie");
                        }
                        if (this.prescriptionData
                            && this.prescriptionData.weight <= 0)
                            errorsInStep.push("weight");
                        if (this.prescriptionData
                            && this.prescriptionData.biomass <= 0)
                            errorsInStep.push("biomass");
                        if (!this.prescriptionData.specie) {
                            errorsInStep.push("specie");
                        }
                    }
                    if (currentStep === 2) {
                        if ((app.common.utils.isNullOrUndefined(this.prescriptionData.amount)
                            || this.prescriptionData.amount < 0)
                            && _.indexOf(errorsInStep, "amount") === -1) {
                            errorsInStep.push("amount");
                        }
                        if (!this.prescriptionData.amountMeasureUnit) {
                            errorsInStep.push("amountMeasureUnit");
                        }
                    }
                    errorsInStep.forEach(function (property) {
                        var translateKey;
                        if (_this.PrescriptionManualCheckProperties[property]
                            && _this.PrescriptionManualCheckProperties[property]["translateKey"])
                            translateKey = _this.PrescriptionManualCheckProperties[property]["translateKey"];
                        else
                            translateKey = property;
                        var receivedErrorMessage;
                        var errorMessageGetResult;
                        if (_this.prescriptionData
                            && typeof _this.prescriptionData.errorMessageGet === 'function')
                            errorMessageGetResult = _this.prescriptionData.errorMessageGet(property);
                        if (!errorMessageGetResult)
                            receivedErrorMessage = "has error";
                        else
                            receivedErrorMessage = errorMessageGetResult;
                        var errorMessage = _this.getTranslatedErrorMessage(property, translateKey, receivedErrorMessage);
                        _this.setErrorOnProperty(property, errorMessage, _this.errorMessageOnProperty);
                    });
                    // console.log('e', errorsInStep);
                    // console.log('this pres', this.prescriptionData);
                    // console.log('e m', this.prescriptionDatacontext.getValidationErrors(
                    //       this.prescriptionData
                    //     ));
                    this.hasValidationError = errorsInStep.length > 0;
                    if (errorsInStep.length === 0) {
                        stepProperties.forEach(function (property) {
                            _this.setErrorOnProperty(property, null, _this.errorMessageOnProperty);
                        });
                    }
                    return errorsInStep.length === 0;
                };
                PrescriptionEditController.prototype.validPropertyLength = function (propertyName) {
                    if (!this.PrescriptionManualCheckProperties[propertyName])
                        return true;
                    var result = true;
                    var propertyValue;
                    if (this.prescriptionData)
                        propertyValue = this.prescriptionData[propertyName];
                    if (!app.common.utils.isNullOrUndefined(this.PrescriptionManualCheckProperties[propertyName]
                        && !app.common.utils.isNullOrUndefined(this.PrescriptionManualCheckProperties[propertyName]["maxLength"]))
                        && !app.common.utils.isNullOrUndefined(propertyValue)) {
                        result = propertyValue.length <= this.PrescriptionManualCheckProperties[propertyName]["maxLength"] ? true : false;
                    }
                    return result;
                };
                PrescriptionEditController.prototype.getTranslatedErrorMessage = function (propertyName, propertyTranslatingKey, errorMessage) {
                    if (!propertyName)
                        return "";
                    if (!errorMessage)
                        errorMessage = "";
                    if (!propertyTranslatingKey)
                        propertyTranslatingKey = propertyName;
                    if (errorMessage !== ""
                        && errorMessage.indexOf("must be a string with") > -1
                        && errorMessage.indexOf("characters or less") > -1) {
                        var translatedProperyName = this.$translate.instant(propertyTranslatingKey);
                        var requiredLengthStringContainer = errorMessage.split(" with ")[1];
                        var requiredLengthString = requiredLengthStringContainer.substring(0, requiredLengthStringContainer.indexOf(" "));
                        var errorMessageTemplate = this.$translate.instant("PrescriptionMaxLengthErrorTemplate");
                        var result = errorMessageTemplate.format(translatedProperyName, requiredLengthString.trim());
                        return result;
                    }
                    else {
                        return this.$translate.instant(errorMessage);
                    }
                };
                PrescriptionEditController.prototype.removeErrorAlert = function () {
                    this.showErrorAlert = false;
                };
                PrescriptionEditController.prototype.cancel = function () {
                    this.rejectChanges();
                    this.$scope.closeThisDialog();
                    this.$rootScope.$broadcast(app.constants.broadcastEventNames.refreshTable);
                    this.$scope.$destroy();
                };
                PrescriptionEditController.prototype.save = function (mode) {
                    var _this = this;
                    if (mode === void 0) { mode = app.constants.assessmentStatus.COMPLETED; }
                    if (mode === app.constants.assessmentStatus.COMPLETED) {
                        if (!this.validateStep(3))
                            return;
                        if (!this.isValid()) {
                            return;
                        }
                        this.prescriptionDatacontext.save(this.prescriptionData).then(function (result) {
                            if (_this.draftPrescription)
                                _this.appLocalStorage.draftPrescriptionsDeleteItem(_this.draftPrescription["createdTime"]);
                            if (_this.prescriptionData && _this.prescriptionData.isDraft)
                                _this.appLocalStorage.draftPrescriptionsDeleteItem(_this.prescriptionData.createdTime);
                            _this.setLockStatus();
                            _this.$rootScope.$broadcast(app.constants.broadcastEventNames.registrationCompleted);
                            _this.$scope.closeThisDialog();
                        });
                    }
                    else if (mode === app.constants.assessmentStatus.DRAFT && this.draftPrescription && this.isNew()) {
                        this.draftPrescription.copy(this.prescriptionData);
                        this.draftPrescription.representativeId = this.authenticationService.credentialsCurrentUserGet().UserId;
                        this.draftPrescription.vetFullName = this.authenticationService.credentialsCurrentUserGet().FullName;
                        this.appLocalStorage.draftPrescriptionSetOneItem(this.draftPrescription);
                    }
                };
                PrescriptionEditController.prototype.setLockStatus = function () {
                    var _this = this;
                    if (this.prescriptionData.isLocked == this.isLocked)
                        return this.$q.resolve();
                    var auditType = this.isLocked ? app.constants.auditTypes.Lock : app.constants.auditTypes.Unlock;
                    this.prescriptionDatacontext.createAudit({
                        auditDate: moment(),
                        tableName: app.constants.entityNames.prescription,
                        userId: this.authenticationService.credentialsCurrentUserGet().UserId,
                        auditingTypeId: auditType,
                        key: this.prescriptionData.prescriptionId,
                        comment: null
                    });
                    return this.prescriptionDatacontext.save().then(function () {
                        _this.prescriptionData.isLocked = _this.isLocked;
                    });
                };
                PrescriptionEditController.prototype.rejectChanges = function () {
                    this.prescriptionDatacontext.rejectChangesOnEntity(this.prescriptionData);
                };
                PrescriptionEditController.prototype.saveAndEmail = function () {
                    var _this = this;
                    if (!this.validateStep(3))
                        return;
                    if (!this.isValid()) {
                        return;
                    }
                    var siteId, prescriptionId;
                    if (this.prescriptionData) {
                        siteId = this.prescriptionData.siteId;
                        prescriptionId = this.prescriptionData.prescriptionId;
                    }
                    this.prescriptionDatacontext.save(this.prescriptionData).then(function (result) {
                        if (_this.draftPrescription)
                            _this.appLocalStorage.draftPrescriptionsDeleteItem(_this.draftPrescription["createdTime"]);
                        if (_this.prescriptionData && _this.prescriptionData.isDraft)
                            _this.appLocalStorage.draftPrescriptionsDeleteItem(_this.prescriptionData.createdTime);
                        _this.setLockStatus();
                        //let prescriptionEntity = {};
                        //if (result["entities"] && result["entities"][0])
                        //  prescriptionEntity = result["entities"][0];
                        _this.modalService.show("modules/mail/mail.html", app.constants.dialogSize.defaultSize, "", _this.$scope, function () {
                            //postponed to next digest cycle
                            _this.$timeout(function () {
                                var parent = _this.$scope.$parent;
                                parent.closeThisDialog();
                                _this.$rootScope.$broadcast(app.constants.broadcastEventNames.registrationCompleted);
                                _this.$scope.$destroy();
                            });
                        }, new web.services.MailData(siteId, _this.prescriptionData.prescriptionId, "Prescription", 0, -1));
                    });
                };
                PrescriptionEditController.prototype.hasChanges = function () {
                    return !this.prescriptionDatacontext.hasChanges();
                };
                PrescriptionEditController.prototype.hasError = function (propertyName, validationStep) {
                    switch (propertyName) {
                        case "prescriptionDate":
                            return this.hasValidationError
                                && (!this.prescriptionData.prescriptionDate);
                        case "amount":
                            return this.hasValidationError
                                && (app.common.utils.isNullOrUndefined(this.prescriptionData.amount)
                                    || this.prescriptionData.amount <= 0);
                        case "amountMeasureUnit":
                            return this.hasValidationError
                                && app.common.utils.isNullOrUndefined(this.prescriptionData.amountMeasureUnit);
                        case "specie":
                            return this.hasValidationError
                                && app.common.utils.isNullOrUndefined(this.prescriptionData.specie);
                        case "treatmentProduct":
                            return this.hasValidationError
                                && app.common.utils.isNullOrUndefined(this.prescriptionData.treatmentProduct);
                        case "regionalAuthority":
                            return this.hasValidationError
                                && app.common.utils.isNullOrUndefined(this.prescriptionData.regionalAuthority);
                        default:
                            var isValidLength = true;
                            if (!app.common.utils.isNullOrUndefined(this.PrescriptionManualCheckProperties[propertyName]))
                                isValidLength = this.validPropertyLength(propertyName);
                            return this.hasValidationError
                                && !this.prescriptionData.entityAspect.validateProperty(propertyName)
                                && !isValidLength;
                    }
                };
                PrescriptionEditController.prototype.changeLabelAndGo = function (direction, toStepIndex) {
                    var _this = this;
                    this.showErrorAlert = true;
                    this.save(app.constants.assessmentStatus.DRAFT);
                    this.$timeout(function () {
                        _this.hasValidationError = false;
                        switch (direction) {
                            case "jump":
                                if (!_this.appLocalStorage.applicationStatusGet().validationsEnabled)
                                    toStepIndex == -1
                                        ? _this.wizardHandler.wizard().next()
                                        : _this.wizardHandler.wizard().jumpTo(toStepIndex, true);
                                else if (_this.readonly ||
                                    _this.validateStep(_this.wizardHandler.wizard().getCurrentStepIndex())) {
                                    toStepIndex == -1
                                        ? _this.wizardHandler.wizard().next()
                                        : _this.wizardHandler.wizard().jumpTo(toStepIndex, true);
                                }
                                break;
                            case "next":
                                if (!_this.appLocalStorage.applicationStatusGet().validationsEnabled)
                                    toStepIndex == -1
                                        ? _this.wizardHandler.wizard().next()
                                        : _this.wizardHandler.wizard().goTo(toStepIndex, true);
                                else if (_this.readonly ||
                                    _this.validateStep(_this.wizardHandler.wizard().getCurrentStepIndex())) {
                                    toStepIndex == -1
                                        ? _this.wizardHandler.wizard().next()
                                        : _this.wizardHandler.wizard().goTo(toStepIndex, true);
                                }
                                break;
                            case "back":
                                toStepIndex == -1
                                    ? _this.wizardHandler.wizard().previous()
                                    : _this.wizardHandler.wizard().goTo(toStepIndex, true);
                                break;
                        }
                        _this.isLastStep = _this.wizardHandler.wizard().isLastStep();
                        if (_this.isLastStep) {
                            _this.nextButtonText = "Done";
                        }
                        _this.showBackButton = !_this.wizardHandler.wizard().isFirstStep();
                    }, 10);
                };
                PrescriptionEditController.$inject = [
                    "$rootScope",
                    "$scope",
                    "$timeout",
                    "$q",
                    "prescriptionDatacontext",
                    "assessmentDatacontext",
                    "appLocalStorage",
                    "modalService",
                    "WizardHandler",
                    "authenticationService",
                    "paletteService",
                    "navigationService",
                    "$window",
                    "$translate",
                    "apiEndpointService",
                    "FileSaver",
                ];
                return PrescriptionEditController;
            })(controllers.BaseEditController);
            controllers.PrescriptionEditController = PrescriptionEditController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("PrescriptionEditController", [
    "$rootScope",
    "$scope",
    "$timeout",
    "$q",
    "prescriptionDatacontext",
    "assessmentDatacontext",
    "appLocalStorage",
    "modalService",
    "WizardHandler",
    "authenticationService",
    "paletteService",
    "navigationService",
    "$window",
    "$translate",
    'apiEndpointService',
    "FileSaver",
]);

/// <reference path="../../../_typings.web.ts"/>
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var BaseSetupController = (function () {
                function BaseSetupController($scope, datacontext) {
                    var _this = this;
                    this.$scope = $scope;
                    this.datacontext = datacontext;
                    $scope.viewModel = this;
                    this.entityName = $scope.ngDialogData.entity;
                    this.resourceName = app.constants.resourceNames[this.entityName.toCamelCase() + 'Resource'];
                    this.headerText = app.localizer.resource[this.entityName];
                    this.headers = [
                        { text: app.localizer.resource.Name, smColSpan: 5, mdColSpan: 5, html: false, propertyName: 'name' },
                        { text: app.localizer.resource.Active, smColSpan: 4, mdColSpan: 4, html: false, propertyName: 'active', action: function (actiontype, item) { _this.action(actiontype, item); } },
                        { text: "", smColSpan: 3, mdColSpan: 3, html: false, propertyName: '', confirm: { title: app.localizer.resource.Alert_Delete_ConfirmTitle, message: app.localizer.resource.Alert_Delete_ConfirmMessage.format(this.headerText.toLowerCase()) }, action: function (actiontype, item) { _this.action(actiontype, item); } }
                    ];
                }
                BaseSetupController.prototype.action = function (actiontype, item) {
                    var _this = this;
                    switch (actiontype) {
                        case app.constants.actionType.toggleActive:
                            item.active = !item.active;
                            return this.saveItem(item);
                        case app.constants.actionType.edit:
                            return this.modalService.show('modules/base_entity/base.entity.html', app.constants.dialogSize.small, '', this.$scope, function () { }, new app.web.services.EntityData(app.localizer.resource.EditRegistration_Title.format(this.headerText), item, function (item) { return _this.saveItem(item); }, ['name', 'active']));
                        case app.constants.actionType.delete:
                            return this.deleteItem(item);
                    }
                };
                BaseSetupController.prototype.loadMore = function () {
                    var funcName = 'getAll' + this.resourceName;
                    if (typeof this.datacontext[funcName] === 'function')
                        return this.$q.when(this.datacontext[funcName]());
                    else
                        throw new Error("No " + funcName + " function implemented in datacontext");
                };
                BaseSetupController.prototype.addNew = function () {
                    var _this = this;
                    var funcName = 'create' + this.entityName;
                    if (typeof this.datacontext[funcName] === 'function') {
                        var entityDeclaration = this.datacontext.createActiveSubstance();
                        this.modalService.show('modules/base_entity/base.entity.html', app.constants.dialogSize.small, '', this.$scope, function () { }, new app.web.services.EntityData(app.localizer.resource.NewRegistration_Title.format(this.headerText), entityDeclaration, function (item) { return _this.saveItem(item); }, ['name', 'active']));
                    }
                    else
                        throw new Error("No " + funcName + " function implemented in datacontext");
                };
                BaseSetupController.prototype.saveItem = function (item) {
                    var _this = this;
                    if (typeof this.datacontext.save === 'function')
                        return this.datacontext.save().then(function () {
                            return _this.toggleReload = !_this.toggleReload;
                        });
                    else
                        throw new Error("No save function implemented in datacontext");
                };
                BaseSetupController.prototype.deleteItem = function (item) {
                    var _this = this;
                    item.entityAspect.setDeleted();
                    return this.saveItem(item)
                        .then(function () {
                        return _this.toggleReload = !_this.toggleReload;
                    })
                        .catch(function (error) {
                        console.log(error);
                        if (app.common.utils.isReferenceConstraintError(error.message)) {
                            _this.errorMessage = "ActiveSubstance_Error_InUse";
                        }
                        else if (error.entityErrors) {
                            _this.errorMessage = "ActiveSubstance_Error_InUse";
                        }
                        _this.datacontext.rejectChangesOnEntity(item);
                    });
                };
                BaseSetupController.prototype.cancel = function () {
                    //  this.prescriptionDatacontext.rejectChangesOnEntity(this.fishgroup);
                    this.$scope.closeThisDialog();
                };
                return BaseSetupController;
            })();
            controllers.BaseSetupController = BaseSetupController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

/// <reference path="../../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var TreatmentProductListController = (function (_super) {
                __extends(TreatmentProductListController, _super);
                function TreatmentProductListController($scope, modalService, prescriptionDatacontext) {
                    var _this = this;
                    _super.call(this, $scope, modalService);
                    this.$scope = $scope;
                    this.prescriptionDatacontext = prescriptionDatacontext;
                    this.pagedItems = [];
                    this.currentPage = 0;
                    this.itemsPerPage = 50;
                    this.totalRows = 0;
                    this.errorMessage = '';
                    this.data = this.$scope.ngDialogData;
                    this.headers = [
                        {
                            name: '', text: '', "class": 'fixed-width-4', html: false, propertyName: '', sort: app.constants.sortTypes.notSortable
                        },
                        {
                            name: "Name", text: app.localizer.resource.TreatmentProduct, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'name', sort: app.constants.sortTypes.ascending
                        },
                        {
                            name: "Supplier", text: app.localizer.resource.TreatmentProduct_Producer, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'producerName', textOverflow: true, sort: app.constants.sortTypes.none
                        },
                        {
                            name: "ActiveSubstance", text: app.localizer.resource.ActiveSubstance, smColSpan: 2, mdColSpan: 2, html: false, propertyName: 'activeSubstanceName', textOverflow: true,
                            sort: app.constants.sortTypes.none
                        },
                        {
                            name: "Concentration", text: app.localizer.resource.TreatmentProduct_Inclusion, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'concentration', textOverflow: true, sort: app.constants.sortTypes.none
                        },
                        {
                            name: "QuarantineType", text: app.localizer.resource.TreatmentProduct_QuarantineValue, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'quarantine', sort: app.constants.sortTypes.none
                        },
                        {
                            name: "Active", text: app.localizer.resource.Active, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'active', sort: app.constants.sortTypes.none
                        },
                        {
                            name: "IsFromFarmer", text: app.localizer.resource.IsFromFarmer, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'isFromFarmer', sort: app.constants.sortTypes.none
                        },
                        {
                            name: "Company", text: app.localizer.resource.Company, smColSpan: 1, mdColSpan: 1, html: false, propertyName: 'companyBUName', sort: app.constants.sortTypes.descending
                        },
                        {
                            name: 'Options', text: '', "class": 'pull-right text-center', smColSpan: 1, mdColSpan: 1, html: false, propertyName: '',
                            confirm: function (prescription) { _this.delete(prescription); }, edit: function (prescription) { _this.edit(prescription); }, sort: app.constants.sortTypes.notSortable
                        }
                    ];
                    this.initFilterList();
                    this.$scope.$on(app.constants.broadcastEventNames.treatmentProductRegistrationCompleted, function () {
                        _this.toggleFilterChangedProperty();
                    });
                }
                TreatmentProductListController.prototype.initFilterList = function () {
                    this.filterList = new Array();
                    var producers = this.prescriptionDatacontext.getProducers();
                    var optionList = new Array();
                    angular.forEach(producers, function (producer) {
                        optionList.push(new web.model.DropdownOption(producer.name, producer.treatmentProductProducerId, 0, app.constants.treatmentProductProperties.treatmentProductProducer, false));
                    });
                    var filter = new web.directives.Filter(app.constants.treatmentProductProperties.treatmentProductProducer, 'TreatmentProduct_Producer', optionList, [], false, false);
                    this.filterList.push(filter);
                    var activesubstances = this.prescriptionDatacontext.getActiveSubstances();
                    optionList = new Array();
                    angular.forEach(activesubstances, function (activeSubstance) {
                        optionList.push(new web.model.DropdownOption(activeSubstance.name, activeSubstance.activeSubstanceId, 0, app.constants.treatmentProductProperties.activeSubstance, false));
                    });
                    filter = new web.directives.Filter(app.constants.treatmentProductProperties.activeSubstance, 'ActiveSubstance', optionList, [], false, false);
                    this.filterList.push(filter);
                    var companyBUs = this.prescriptionDatacontext.getCompanyBUs();
                    optionList = new Array();
                    angular.forEach(companyBUs, function (companyBU) {
                        optionList.push(new web.model.DropdownOption(companyBU.name, companyBU.companyBUId, 0, app.constants.treatmentProductProperties.companyBU, false));
                    });
                    filter = new web.directives.Filter(app.constants.treatmentProductProperties.companyBU, 'Company', optionList, [], false, false);
                    this.filterList.push(filter);
                };
                TreatmentProductListController.prototype.loadMore = function () {
                    var _this = this;
                    this.currentPage++;
                    return this.prescriptionDatacontext.getTreatmentProductsFiltered(this.currentPage, this.itemsPerPage, this.filterList).then(function (data) {
                        var results = _.map(data.results, function (item) { return _.pick(item, ["treatmentProductId", "name", "producerName", "activeSubstanceName", "concentration", "quarantine", "quarantineType", "quarantineValue", "active", "isFromFarmer", "isLocked", "companyBUName"]); });
                        if (_this.currentPage > 1) {
                            _this.pagedItems = _this.pagedItems.concat(results);
                            _this.items = _this.items.concat(results);
                        }
                        else {
                            _this.pagedItems = results;
                            _this.items = results;
                        }
                        _this.totalRows = data.inlineCount;
                        return _this.pagedItems;
                    });
                };
                TreatmentProductListController.prototype.toggleFilterChangedProperty = function () {
                    if (this.currentPage < 0)
                        return; //skip those redundant filterchange calls
                    this.currentPage = -1;
                    this.toggleFilterChanged = !this.toggleFilterChanged;
                };
                TreatmentProductListController.prototype.delete = function (item) {
                    var _this = this;
                    this.prescriptionDatacontext.deleteTreatmentProduct(item.treatmentProductId).then(function () {
                        _.remove(_this.pagedItems, function (currentObject) {
                            return currentObject.treatmentProductId === item.treatmentProductId;
                        });
                        _this.toggleFilterChangedProperty();
                    }).catch(function (error) {
                        if (app.common.utils.isReferenceConstraintError(error.message)) {
                            _this.errorMessage = "TreatmentProduct_Error_InUse";
                        }
                    });
                };
                TreatmentProductListController.prototype.edit = function (item) {
                };
                TreatmentProductListController.prototype.addTreatmentProduct = function () {
                    this.modalService.show('modules/setup/treatment_product/treatment.product.edit.html', app.constants.dialogSize.medium, '', null, function () { }, new web.services.TreatmentProductData(null));
                };
                TreatmentProductListController.$inject = ['$scope', 'modalService', 'prescriptionDatacontext'];
                return TreatmentProductListController;
            })(controllers.BaseModalListController);
            controllers.TreatmentProductListController = TreatmentProductListController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("TreatmentProductListController", ['$scope', 'modalService', 'prescriptionDatacontext']);

/// <reference path="../../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var TreatmentProductEditController = (function (_super) {
                __extends(TreatmentProductEditController, _super);
                function TreatmentProductEditController($rootscope, $scope, $q, modalService, prescriptionDatacontext) {
                    var _this = this;
                    _super.call(this, $scope, modalService);
                    this.$rootscope = $rootscope;
                    this.$q = $q;
                    this.prescriptionDatacontext = prescriptionDatacontext;
                    this.hasValidationError = false;
                    this.usages = [{ id: 0, name: 'Bath', selected: false }, { id: 1, name: 'Feeding', selected: false }, { id: 2, name: 'Vaccination', selected: false }];
                    this.errorMessage = 'Error_ValidationErrors';
                    this.$q.
                        when(this.getEditItem()).
                        then(function (data) {
                        _this.treatmentProduct = data;
                        _this.initialise();
                    });
                }
                TreatmentProductEditController.prototype.getEditItem = function () {
                    if (_.isNull(this.$scope.ngDialogData.treatmentProduct)) {
                        var deffered = this.$q.defer();
                        deffered.resolve(this.prescriptionDatacontext.createTreatmentProduct());
                        return deffered.promise;
                    }
                    else {
                        return this.prescriptionDatacontext.getTreatmentProductById(this.$scope.ngDialogData.treatmentProduct);
                    }
                };
                TreatmentProductEditController.prototype.isNew = function () {
                    return this.treatmentProduct.treatmentProductId < 0;
                };
                TreatmentProductEditController.prototype.initialise = function () {
                    var _this = this;
                    this.headerText = this.isNew() ? app.localizer.resource.TreatmentProduct_NewRegistration : app.localizer.resource.TreatmentProduct_EditRegistration + " " + this.treatmentProduct.name;
                    this.suppliers = this.prescriptionDatacontext.getSuppliers(0); //get all
                    this.producers = this.prescriptionDatacontext.getProducers();
                    this.measureUnits = this.prescriptionDatacontext.getMeasureUnits();
                    this.activeSubstances = this.prescriptionDatacontext.getActiveSubstances();
                    this.quarantineTypes = this.prescriptionDatacontext.getQuarantineTypes();
                    this.indications = this.prescriptionDatacontext.getIndications();
                    this.companyBUs = this.prescriptionDatacontext.getCompanyBUs();
                    if (this.treatmentProduct.indicationMask != null) {
                        this.setSelectedIndication();
                    }
                    if (this.treatmentProduct.usageMask != null) {
                        this.setSelectedUsage();
                    }
                    this.$scope.$watch(function () { return _this.selectedIndications; }, function (newval, oldval) {
                        var indicationMask = 0;
                        _.forEach(newval, function (indication) {
                            indicationMask += Math.pow(2, indication.treatmentProductIndicationId);
                        });
                        _this.treatmentProduct.indicationMask = indicationMask;
                    });
                    this.$scope.$watch(function () { return _this.selectedUsages; }, function (newval, oldval) {
                        var mask = null;
                        _.forEach(newval, function (usage) {
                            mask += Math.pow(2, usage.id);
                        });
                        _this.treatmentProduct.usageMask = mask;
                    });
                    this.$scope.$watch(function () { return _this.treatmentProduct.name; }, function (newval, oldval) {
                        _this.treatmentProduct.officialName = app.common.utils.isNullOrUndefinedOrEmpty(_this.treatmentProduct.officialName) || (!app.common.utils.isNullOrUndefinedOrEmpty(_this.treatmentProduct.officialName) && _this.treatmentProduct.officialName == oldval)
                            ? _this.treatmentProduct.name : _this.treatmentProduct.officialName;
                    });
                };
                TreatmentProductEditController.prototype.setSelectedIndication = function () {
                    var _this = this;
                    this.selectedIndications = new Array();
                    _.forEach(this.indications, function (indication) {
                        if (_this.treatmentProduct != null) {
                            if (_this.treatmentProduct.indicationMask & Math.pow(2, indication.treatmentProductIndicationId)) {
                                indication.selected = true;
                                _this.selectedIndications.push(indication);
                            }
                        }
                    });
                };
                TreatmentProductEditController.prototype.setSelectedUsage = function () {
                    var _this = this;
                    this.selectedUsages = new Array();
                    _.forEach(this.usages, function (usage) {
                        if (_this.treatmentProduct != null) {
                            if (_this.treatmentProduct.usageMask & Math.pow(2, usage.id)) {
                                usage.selected = true;
                                _this.selectedUsages.push(usage);
                            }
                        }
                    });
                };
                TreatmentProductEditController.prototype.qurantineTypeChanged = function (quarantineTypeId) {
                    if (quarantineTypeId == 1) {
                        this.treatmentProduct.quarantineValue = null;
                    }
                };
                TreatmentProductEditController.prototype.hasError = function (propertyName) {
                    return this.hasValidationError && !this.treatmentProduct.entityAspect.validateProperty(propertyName);
                };
                TreatmentProductEditController.prototype.hasChanges = function () {
                    return !this.prescriptionDatacontext.hasChanges();
                    ;
                };
                TreatmentProductEditController.prototype.isValid = function () {
                    this.hasValidationError = !this.prescriptionDatacontext.validateEntity(this.treatmentProduct);
                    return !this.hasValidationError;
                };
                TreatmentProductEditController.prototype.save = function () {
                    var _this = this;
                    if (!this.isValid()) {
                        return;
                    }
                    this.prescriptionDatacontext.save().then(function (result) {
                        _this.$rootscope.$broadcast(app.constants.broadcastEventNames.treatmentProductRegistrationCompleted);
                        _this.closeThisDialog();
                    });
                };
                TreatmentProductEditController.prototype.rejectChanges = function () {
                    this.prescriptionDatacontext.rejectChangesOnEntity(this.treatmentProduct);
                };
                TreatmentProductEditController.$inject = ['$rootScope', '$scope', '$q', 'modalService', 'prescriptionDatacontext'];
                return TreatmentProductEditController;
            })(controllers.BaseEditController);
            controllers.TreatmentProductEditController = TreatmentProductEditController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("TreatmentProductEditController", ['$rootScope', '$scope', '$q', 'modalService', 'prescriptionDatacontext']);

/// <reference path="../../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var SupplierEditController = (function (_super) {
                __extends(SupplierEditController, _super);
                function SupplierEditController($rootscope, $scope, $q, modalService, supplierDataContext) {
                    var _this = this;
                    _super.call(this, $scope, modalService);
                    this.$rootscope = $rootscope;
                    this.$scope = $scope;
                    this.$q = $q;
                    this.supplierDataContext = supplierDataContext;
                    this.data = this.$scope.ngDialogData;
                    this.$q.when(this.getEditItem())
                        .then(function (data) {
                        _this.supplier = data;
                        _this.initialise();
                    });
                }
                SupplierEditController.prototype.getEditItem = function () {
                    if (_.isNull(this.$scope.ngDialogData.supplier)) {
                        var deffered = this.$q.defer();
                        deffered.resolve(this.supplierDataContext.createSupplier(this.supplier));
                        return deffered.promise;
                    }
                    else {
                        return this.supplierDataContext.getSupplierById(this.$scope.ngDialogData.supplier);
                    }
                };
                SupplierEditController.prototype.initialise = function () {
                    this.hasValidationError = false;
                    this.headerText = this.isNew()
                        ? app.localizer.resource.Supplier_NewRegistration
                        : app.localizer.resource.Supplier_EditRegistration + " " + this.supplier.name;
                    this.supplierTypes = this.supplierDataContext.getSupplierTypes();
                    this.companyBUs = this.supplierDataContext.getCompanyBUs();
                };
                SupplierEditController.prototype.isNew = function () {
                    return this.supplier.supplierId < 0;
                };
                SupplierEditController.prototype.hasError = function (propertyName) {
                    return this.hasValidationError && !this.supplier.entityAspect.validateProperty(propertyName);
                };
                SupplierEditController.prototype.hasChanges = function () {
                    return this.supplierDataContext.hasChanges();
                };
                SupplierEditController.prototype.isValid = function () {
                    this.hasValidationError = !this.supplierDataContext.validateEntity(this.supplier);
                    return !this.hasValidationError;
                };
                SupplierEditController.prototype.save = function () {
                    var _this = this;
                    if (!this.isValid()) {
                        return;
                    }
                    this.supplierDataContext.save().then(function (result) {
                        _this.$rootscope.$broadcast(app.constants.broadcastEventNames.supplierRegistrationCompleted);
                        _this.closeThisDialog();
                    });
                };
                SupplierEditController.prototype.rejectChanges = function () {
                    this.supplierDataContext.rejectChangesOnEntity(this.supplier);
                };
                SupplierEditController.$inject = ['$rootScope', '$scope', '$q', 'modalService', 'supplierDatacontext'];
                return SupplierEditController;
            })(controllers.BaseEditController);
            controllers.SupplierEditController = SupplierEditController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("SupplierEditController", ['$rootScope', '$scope', '$q', 'modalService', 'supplierDatacontext']);

/// <reference path="../../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var SupplierListController = (function (_super) {
                __extends(SupplierListController, _super);
                function SupplierListController($scope, modalService, supplierDatacontext) {
                    var _this = this;
                    _super.call(this, $scope, modalService);
                    this.$scope = $scope;
                    this.supplierDatacontext = supplierDatacontext;
                    this.pagedItems = [];
                    this.currentPage = 0;
                    this.itemsPerPage = 10;
                    this.totalRows = 0;
                    this.errorMessage = '';
                    this.data = this.$scope.ngDialogData;
                    this.headers = [
                        {
                            name: '',
                            text: '',
                            "class": 'fixed-width-4',
                            html: false,
                            propertyName: '',
                            sort: app.constants.sortTypes.notSortable
                        },
                        {
                            name: "Name",
                            text: app.localizer.resource.Supplier_Name,
                            smColSpan: 2,
                            mdColSpan: 2,
                            html: false,
                            propertyName: 'name',
                            sort: app.constants.sortTypes.ascending
                        },
                        {
                            name: "Address",
                            text: app.localizer.resource.Supplier_Address,
                            smColSpan: 2,
                            mdColSpan: 2,
                            html: false,
                            propertyName: 'adress',
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: "Postnumber",
                            text: app.localizer.resource.Supplier_Zip,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: 'zip',
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: "Postalcode",
                            text: app.localizer.resource.Supplier_Place,
                            smColSpan: 2,
                            mdColSpan: 2,
                            html: false,
                            propertyName: 'place',
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: "SupplierTypeName",
                            text: app.localizer.resource.Supplier_Type,
                            smColSpan: 2,
                            mdColSpan: 2,
                            html: false,
                            propertyName: 'supplierTypeName',
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: "Active",
                            text: app.localizer.resource.Active,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: 'active',
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: "Company",
                            text: app.localizer.resource.Company,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: 'companyBUName',
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: 'Options',
                            text: '',
                            "class": 'pull-right text-center',
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: '',
                            confirm: function (item) { _this.delete(item); },
                            edit: function (item) { _this.edit(item); },
                            sort: app.constants.sortTypes.notSortable
                        }
                    ];
                    this.$scope.$on(app.constants.broadcastEventNames.supplierRegistrationCompleted, function () {
                        _this.toggleFilterChangedProperty();
                    });
                }
                SupplierListController.prototype.loadMore = function () {
                    var _this = this;
                    this.currentPage++;
                    return this.supplierDatacontext.getSuppliers(this.currentPage, this.itemsPerPage, this.filterList).then(function (data) {
                        var results = _.map(data.results, function (item) { return _.pick(item, ["supplierId", "name", "adress", "zip", "place", "supplierTypeName",
                            "phone", "fax", "active", "companyBUName"]); });
                        if (_this.currentPage > 1)
                            _this.pagedItems = _this.items.concat(results);
                        else
                            _this.pagedItems = _this.items = results;
                        _this.totalRows = data.inlineCount;
                        return _this.pagedItems;
                    });
                };
                SupplierListController.prototype.toggleFilterChangedProperty = function () {
                    if (this.currentPage < 0)
                        return; //skip those redundant filterchange calls
                    this.currentPage = -1;
                    this.toggleFilterChanged = !this.toggleFilterChanged;
                };
                SupplierListController.prototype.delete = function (item) {
                    var _this = this;
                    return this.supplierDatacontext.deleteSupplier(item.supplierId)
                        .then(function () {
                        _this.toggleFilterChangedProperty();
                    })
                        .catch(function (error) {
                        if (app.common.utils.isReferenceConstraintError(error.message)) {
                            _this.errorMessage = "Supplier_Error_InUse";
                        }
                    });
                };
                SupplierListController.prototype.edit = function (item) {
                };
                SupplierListController.prototype.addSupplier = function () {
                    this.modalService.show('modules/setup/supplier/supplier.edit.html', app.constants.dialogSize.medium, '', null, function () { }, new web.services.SupplierData(null));
                };
                SupplierListController.$inject = ['$scope', 'modalService', 'supplierDatacontext'];
                return SupplierListController;
            })(controllers.BaseModalListController);
            controllers.SupplierListController = SupplierListController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("SupplierListController", ['$scope', 'modalService', 'supplierDatacontext']);

/// <reference path="../../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var ActiveSubstanceController = (function (_super) {
                __extends(ActiveSubstanceController, _super);
                function ActiveSubstanceController($scope, $q, prescriptionDatacontext, modalService) {
                    _super.call(this, $scope, prescriptionDatacontext);
                    this.$q = $q;
                    this.modalService = modalService;
                }
                ActiveSubstanceController.$inject = ['$scope', '$q', 'prescriptionDatacontext', 'modalService'];
                return ActiveSubstanceController;
            })(controllers.BaseSetupController);
            controllers.ActiveSubstanceController = ActiveSubstanceController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("ActiveSubstanceController", ['$scope', '$q', 'prescriptionDatacontext', 'modalService']);

/// <reference path="../../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var AttributeEnumListController = (function (_super) {
                __extends(AttributeEnumListController, _super);
                function AttributeEnumListController($scope, $translate, $q, modalService, attributeDatacontext) {
                    var _this = this;
                    _super.call(this, $scope, modalService);
                    this.$scope = $scope;
                    this.$translate = $translate;
                    this.$q = $q;
                    this.attributeDatacontext = attributeDatacontext;
                    this.errorMessage = '';
                    this.attributeId = -1;
                    this.exclude = ['Company name', 'Method', 'Methology', 'NAHRepresentitive', 'Production site', 'Terpauline type',
                        'Fishgroup', 'Generation', 'SiteManager', 'Cage', 'FreshwaterCustomer', 'FreshwaterSite', 'FreshwaterFishgroup',
                        'SeaSite', 'SeaSiteFishgroup', 'SeaSiteManager', 'AssessmentLink', 'FishSampleEvaluator', 'SeaCustomer', 'VaccinationCustomer', 'VaccinationSite'];
                    this.data = this.$scope.ngDialogData;
                    this.loadData();
                    this.headers = this.createHeaders();
                    this.$scope.$on(app.constants.broadcastEventNames.attributeEnumRegistrationCompleted, function () {
                        _this.toggleReloadProperty();
                    });
                }
                AttributeEnumListController.prototype.loadData = function () {
                    var _this = this;
                    var filtered = _.filter(this.attributeDatacontext.getAttributes(4), function (item) {
                        return !_.includes(_this.exclude, item.dictionary.name);
                    });
                    this.attributes = _.map(filtered, function (item) {
                        return { attributeName: _this.$translate.instant(item.dictionary.name), attributeId: item.attributeId };
                    });
                };
                AttributeEnumListController.prototype.attributeSelectionChange = function (attributeId) {
                    this.attributeUsedInTemplates = this.getAttributeUsage(attributeId);
                    this.attributeId = attributeId;
                    this.toggleReloadProperty();
                };
                AttributeEnumListController.prototype.toggleReloadProperty = function () {
                    this.toggleReload = !this.toggleReload;
                };
                AttributeEnumListController.prototype.getAttributeUsage = function (attributeId) {
                    var _this = this;
                    var attribute = this.attributeDatacontext.getAttribute(attributeId);
                    var templates = _.map(attribute.templateItems, 'template');
                    var templateGroups = _.map(_.filter(templates, function (template) { return template.templateGroups[0]; }), 'templateGroups');
                    return _.map(templateGroups, function (templateGroup) {
                        return _this.$translate.instant(templateGroup[0].assessmentType.dictionary.name) + '(' + _this.$translate.instant(templateGroup[0].template.dictionary.name) + ')';
                    }).join(', ');
                };
                AttributeEnumListController.prototype.loadMore = function () {
                    var _this = this;
                    return this.attributeDatacontext.getAttributeMetadataEnums(this.attributeId).then(function (results) {
                        return _this.attributeDatacontext.GetAttributeTemplateRegistrationUsage(_this.attributeId).then(function (attributeValuesUsed) {
                            _this.attributeEnums = _.map(results, function (item) {
                                return _.assign(_.pick(item, ["attributeMetadataEnumId", "value", "text", "sortOrder", "english", "norwegian", "spanish",
                                    "active"]), { "used": !app.common.utils.isNullOrUndefined(_.find(attributeValuesUsed, function (value) { return value == item.value; })) });
                            });
                            return _this.attributeEnums;
                        });
                    });
                    //var deferred = this.$q.defer();
                    //deferred.resolve();
                    //return deferred.promise;
                };
                AttributeEnumListController.prototype.delete = function (item) {
                    var _this = this;
                    return this.attributeDatacontext.deleteAttributeMetadataEnum(item.attributeId)
                        .then(function () {
                        _this.toggleReload();
                    })
                        .catch(function (error) {
                        if (app.common.utils.isReferenceConstraintError(error.message)) {
                            _this.errorMessage = "AttributeMetadataEnum_Error_InUse";
                        }
                    });
                };
                AttributeEnumListController.prototype.sort = function (item, sortDirection) {
                    if (sortDirection == 'up') {
                        var previousItem = _.find(this.attributeEnums, ['sortOrder', item.sortOrder - 1]);
                        if (previousItem != null) {
                            item.sortOrder = previousItem.sortOrder;
                            previousItem.sortOrder += 1;
                        }
                    }
                    else {
                        var nextItem = _.find(this.attributeEnums, ['sortOrder', item.sortOrder + 1]);
                        if (nextItem != null) {
                            nextItem.sortOrder = item.sortOrder;
                        }
                        item.sortOrder += 1;
                    }
                    this.toggleSortReset = !this.toggleSortReset;
                    console.log('do sort ' + sortDirection + ' for :' + item.text);
                };
                AttributeEnumListController.prototype.addAttributeEnum = function () {
                    var maxSortOrder = _.maxBy(this.attributeEnums, 'sortOrder');
                    this.modalService.show('modules/setup/attribute_enum/attribute_enum.edit.html', app.constants.dialogSize.medium, '', null, function () { }, new web.services.AttributeEnumData(null, maxSortOrder.sortOrder + 1));
                };
                AttributeEnumListController.prototype.createHeaders = function () {
                    var _this = this;
                    return [
                        {
                            name: '',
                            text: '',
                            "class": 'fixed-width-4',
                            html: false,
                            propertyName: '',
                            sort: app.constants.sortTypes.notSortable
                        },
                        {
                            name: "Active",
                            text: app.localizer.resource.Active,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: 'active',
                            sort: app.constants.sortTypes.notSortable
                        },
                        {
                            name: "SortOrder",
                            text: app.localizer.resource.AttributeEnum_SortOrder,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: 'sortOrder',
                            sort: app.constants.sortTypes.ascending,
                            changeSort: function (item, direction) { _this.sort(item, direction); }
                        },
                        {
                            name: "Value",
                            text: app.localizer.resource.AttributeEnum_Value,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: 'value',
                            sort: app.constants.sortTypes.notSortable
                        },
                        {
                            name: "Text",
                            text: app.localizer.resource.AttributeEnum_Text,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: 'text',
                            sort: app.constants.sortTypes.notSortable
                        },
                        {
                            name: "English",
                            text: app.localizer.resource.AttributeEnum_English,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: 'english',
                            sort: app.constants.sortTypes.notSortable
                        },
                        {
                            name: "Norwegian",
                            text: app.localizer.resource.AttributeEnum_Norwegian,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: 'norwegian',
                            sort: app.constants.sortTypes.notSortable
                        },
                        {
                            name: "Spanish",
                            text: app.localizer.resource.AttributeEnum_Spanish,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: 'spanish',
                            sort: app.constants.sortTypes.notSortable
                        },
                        {
                            name: "UsedInRegistrations",
                            text: app.localizer.resource.AttributeEnum_UsedInRegistrations,
                            smColSpan: 2,
                            mdColSpan: 1,
                            html: false,
                            propertyName: 'used',
                            sort: app.constants.sortTypes.notSortable
                        },
                        {
                            name: 'Options',
                            text: '',
                            "class": 'pull-right text-center',
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: '',
                            //confirm: (item) => { this.delete(item); },
                            //edit: (item) => { this.edit(item); },
                            sort: app.constants.sortTypes.notSortable
                        }
                    ];
                };
                AttributeEnumListController.$inject = ['$scope', '$translate', '$q', 'modalService', 'attributeDatacontext'];
                return AttributeEnumListController;
            })(controllers.BaseModalListController);
            controllers.AttributeEnumListController = AttributeEnumListController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("AttributeEnumListController", ['$scope', '$translate', '$q', 'modalService', 'attributeDatacontext']);

/// <reference path="../../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var AttributeEnumEditController = (function (_super) {
                __extends(AttributeEnumEditController, _super);
                function AttributeEnumEditController($rootscope, $scope, $q, modalService, attributeDatacontext) {
                    var _this = this;
                    _super.call(this, $scope, modalService);
                    this.$rootscope = $rootscope;
                    this.$scope = $scope;
                    this.$q = $q;
                    this.attributeDatacontext = attributeDatacontext;
                    this.data = this.$scope.ngDialogData;
                    this.$q.when(this.getEditItem())
                        .then(function (data) {
                        _this.attributeMetadataEnum = data;
                        _this.initialise();
                    });
                }
                AttributeEnumEditController.prototype.getEditItem = function () {
                    if (_.isNull(this.$scope.ngDialogData.attributeMetadataEnumId)) {
                        var deffered = this.$q.defer();
                        deffered.resolve(this.attributeDatacontext.createAttributeMetadataEnum(this.attributeMetadataEnum));
                        return deffered.promise;
                    }
                    else {
                        return this.attributeDatacontext.getAttributeMetadataEnumById(this.$scope.ngDialogData.attributeMetadataEnumId);
                    }
                };
                AttributeEnumEditController.prototype.initialise = function () {
                    this.hasValidationError = false;
                    if (this.isNew()) {
                        this.attributeMetadataEnum.sortOrder = this.data.maxSortOrder;
                    }
                };
                AttributeEnumEditController.prototype.isNew = function () {
                    return this.attributeMetadataEnum.attributeMetadataEnumId < 0;
                };
                AttributeEnumEditController.prototype.hasError = function (propertyName) {
                    return this.hasValidationError && !this.attributeMetadataEnum.entityAspect.validateProperty(propertyName);
                };
                AttributeEnumEditController.prototype.hasChanges = function () {
                    return this.attributeDatacontext.hasChanges();
                };
                AttributeEnumEditController.prototype.isValid = function () {
                    this.hasValidationError = !this.attributeDatacontext.validateEntity(this.attributeMetadataEnum);
                    return !this.hasValidationError;
                };
                AttributeEnumEditController.prototype.save = function () {
                    var _this = this;
                    if (!this.isValid()) {
                        return;
                    }
                    this.attributeDatacontext.save().then(function (result) {
                        _this.$rootscope.$broadcast(app.constants.broadcastEventNames.attributeEnumRegistrationCompleted);
                        _this.closeThisDialog();
                    });
                };
                AttributeEnumEditController.prototype.rejectChanges = function () {
                    this.attributeDatacontext.rejectChangesOnEntity(this.attributeMetadataEnum);
                };
                AttributeEnumEditController.$inject = ['$rootScope', '$scope', '$q', 'modalService', 'attributeDatacontext'];
                return AttributeEnumEditController;
            })(controllers.BaseEditController);
            controllers.AttributeEnumEditController = AttributeEnumEditController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("AttributeEnumEditController", ['$rootScope', '$scope', '$q', 'modalService', 'attributeDatacontext']);

/// <reference path="../../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var TreatmentProductProducerEditController = (function (_super) {
                __extends(TreatmentProductProducerEditController, _super);
                function TreatmentProductProducerEditController($rootscope, $scope, $q, modalService, treatmentProductProducerDataContext) {
                    var _this = this;
                    _super.call(this, $scope, modalService);
                    this.$rootscope = $rootscope;
                    this.$scope = $scope;
                    this.$q = $q;
                    this.treatmentProductProducerDataContext = treatmentProductProducerDataContext;
                    this.data = this.$scope.ngDialogData;
                    this.$q.when(this.getEditItem())
                        .then(function (data) {
                        _this.treatmentProductProducer = data;
                        _this.initialise();
                    });
                }
                TreatmentProductProducerEditController.prototype.getEditItem = function () {
                    if (_.isNull(this.$scope.ngDialogData.treatmentProductProducer)) {
                        var deffered = this.$q.defer();
                        deffered.resolve(this.treatmentProductProducerDataContext.createTreatmentProductProducer(this.treatmentProductProducer));
                        return deffered.promise;
                    }
                    else {
                        return this.treatmentProductProducerDataContext.getTreatmentProductProducerById(this.$scope.ngDialogData.treatmentProductProducer);
                    }
                };
                TreatmentProductProducerEditController.prototype.initialise = function () {
                    var _this = this;
                    this.hasValidationError = false;
                    this.headerText = this.isNew()
                        ? app.localizer.resource.TreatmentProductProducer_NewRegistration
                        : app.localizer.resource.TreatmentProductProducer_EditRegistration + " " + this.treatmentProductProducer.name;
                    this.countries = this.treatmentProductProducerDataContext.getCountries();
                    this.$scope.$watch(function () { return _this.treatmentProductProducer.homePage; }, function (newval, oldval) {
                        if (newval != undefined && newval != '') {
                        }
                    });
                };
                TreatmentProductProducerEditController.prototype.isNew = function () {
                    return this.treatmentProductProducer.treatmentProductProducerId < 0;
                };
                TreatmentProductProducerEditController.prototype.hasError = function (propertyName) {
                    return this.hasValidationError && !this.treatmentProductProducer.entityAspect.validateProperty(propertyName);
                };
                TreatmentProductProducerEditController.prototype.hasChanges = function () {
                    return this.treatmentProductProducerDataContext.hasChanges();
                };
                TreatmentProductProducerEditController.prototype.isValid = function () {
                    this.hasValidationError = !this.treatmentProductProducerDataContext.validateEntity(this.treatmentProductProducer);
                    return !this.hasValidationError;
                };
                TreatmentProductProducerEditController.prototype.save = function () {
                    var _this = this;
                    if (!this.isValid()) {
                        return;
                    }
                    this.treatmentProductProducerDataContext.save().then(function (result) {
                        _this.$rootscope.$broadcast(app.constants.broadcastEventNames.treatmentProductProducerRegistrationCompleted);
                        _this.closeThisDialog();
                    });
                };
                TreatmentProductProducerEditController.prototype.rejectChanges = function () {
                    this.treatmentProductProducerDataContext.rejectChangesOnEntity(this.treatmentProductProducer);
                };
                TreatmentProductProducerEditController.$inject = ['$rootScope', '$scope', '$q', 'modalService', 'treatmentProductProducerDatacontext'];
                return TreatmentProductProducerEditController;
            })(controllers.BaseEditController);
            controllers.TreatmentProductProducerEditController = TreatmentProductProducerEditController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("TreatmentProductProducerEditController", ['$rootScope', '$scope', '$q', 'modalService', 'treatmentProductProducerDatacontext']);

/// <reference path="../../../_typings.web.ts"/>
'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var TreatmentProductProducerListController = (function (_super) {
                __extends(TreatmentProductProducerListController, _super);
                function TreatmentProductProducerListController($scope, $translate, modalService, treatmentProductProducerDatacontext) {
                    var _this = this;
                    _super.call(this, $scope, modalService);
                    this.$scope = $scope;
                    this.$translate = $translate;
                    this.treatmentProductProducerDatacontext = treatmentProductProducerDatacontext;
                    this.pagedItems = [];
                    this.currentPage = -1;
                    this.itemsPerPage = 10;
                    this.totalRows = 0;
                    this.errorMessage = '';
                    this.data = this.$scope.ngDialogData;
                    this.headerText = app.localizer.resource.TreatmentProduct_Producer;
                    this.headers = [
                        {
                            name: '',
                            text: '',
                            "class": 'fixed-width-4',
                            html: false,
                            propertyName: '',
                            sort: app.constants.sortTypes.notSortable
                        },
                        {
                            name: "Name",
                            text: app.localizer.resource.TreatmentProductProducer_Name,
                            smColSpan: 2,
                            mdColSpan: 2,
                            html: false,
                            propertyName: 'name',
                            sort: app.constants.sortTypes.ascending
                        },
                        {
                            name: "Address",
                            text: app.localizer.resource.TreatmentProductProducer_Address,
                            smColSpan: 2,
                            mdColSpan: 2,
                            html: false,
                            propertyName: 'address',
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: "PostalCode",
                            text: app.localizer.resource.TreatmentProductProducer_PostalCode,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: 'postalCode',
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: "City",
                            text: app.localizer.resource.TreatmentProductProducer_City,
                            smColSpan: 2,
                            mdColSpan: 2,
                            html: false,
                            propertyName: 'city',
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: "Phone",
                            text: app.localizer.resource.TreatmentProductProducer_Phone,
                            smColSpan: 2,
                            mdColSpan: 2,
                            html: false,
                            propertyName: 'phone',
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: "Active",
                            text: app.localizer.resource.Active,
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: 'active',
                            sort: app.constants.sortTypes.descending
                        },
                        {
                            name: 'Options',
                            text: '',
                            "class": 'pull-right text-center',
                            smColSpan: 1,
                            mdColSpan: 1,
                            html: false,
                            propertyName: '',
                            confirm: function (item) { _this.delete(item); },
                            edit: function (item) { _this.edit(item); },
                            sort: app.constants.sortTypes.notSortable
                        }
                    ];
                    this.$scope.$on(app.constants.broadcastEventNames.treatmentProductProducerRegistrationCompleted, function () {
                        _this.toggleFilterChangedProperty();
                    });
                }
                TreatmentProductProducerListController.prototype.loadMore = function () {
                    var _this = this;
                    this.currentPage++;
                    return this.treatmentProductProducerDatacontext.getTreatmentProductProducers(this.currentPage, this.itemsPerPage, this.filterList).then(function (data) {
                        var results = _.map(data.results, function (item) { return _.pick(item, ["treatmentProductProducerId", "name", "address", "postalCode", "city", "phone",
                            "email", "active"]); });
                        if (_this.currentPage > 1)
                            _this.pagedItems = _this.items.concat(results);
                        else
                            _this.pagedItems = _this.items = results;
                        _this.totalRows = data.inlineCount;
                        return _this.pagedItems;
                    });
                };
                TreatmentProductProducerListController.prototype.toggleFilterChangedProperty = function () {
                    if (this.currentPage < 0)
                        return; //skip those redundant filterchange calls
                    this.currentPage = -1;
                    this.toggleFilterChanged = !this.toggleFilterChanged;
                };
                TreatmentProductProducerListController.prototype.delete = function (item) {
                    var _this = this;
                    return this.treatmentProductProducerDatacontext.deleteTreatmentProductProducer(item.treatmentProductProducerId)
                        .then(function () {
                        _.remove(_this.pagedItems, function (currentObject) {
                            return currentObject.treatmentProductProducerId === item.treatmentProductProducerId;
                        });
                        _this.toggleFilterChangedProperty();
                    })
                        .catch(function (error) {
                        if (app.common.utils.isReferenceConstraintError(error.message)) {
                            _this.errorMessage = _this.$translate.instant("TreatmentProductProducer_Error_InUse").format(item.name);
                        }
                    });
                };
                TreatmentProductProducerListController.prototype.edit = function (item) {
                };
                TreatmentProductProducerListController.prototype.addTreatmentProductProducer = function () {
                    this.modalService.show('modules/setup/treatment_product_producer/treatment.product.producer.edit.html', app.constants.dialogSize.medium, '', null, function () { }, new web.services.TreatmentProductProducerData(null));
                };
                TreatmentProductProducerListController.$inject = ['$scope', '$translate', 'modalService', 'treatmentProductProducerDatacontext'];
                return TreatmentProductProducerListController;
            })(controllers.BaseModalListController);
            controllers.TreatmentProductProducerListController = TreatmentProductProducerListController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("TreatmentProductProducerListController", ['$scope', '$translate', 'modalService', 'treatmentProductProducerDatacontext']);

var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var IpaUploadController = (function () {
                function IpaUploadController($scope, $q, $http, $window, modalService, authenticationService, apiEndpointService, env) {
                    this.$scope = $scope;
                    this.$q = $q;
                    this.$http = $http;
                    this.$window = $window;
                    this.modalService = modalService;
                    this.authenticationService = authenticationService;
                    this.apiEndpointService = apiEndpointService;
                    this.env = env;
                    this.uploadSuccess = false;
                    this.uploadFailed = false;
                    this.initialize();
                }
                IpaUploadController.prototype.initialize = function () {
                    this.headerText = 'Upload IOS app';
                    if (this.$window.location.href.indexOf("apps.mercatus.no") > -1) {
                        if (this.$window.location.href.indexOf("/RC/") > -1) {
                            this.setBundleId('RC');
                        }
                        else if (this.$window.location.href.indexOf("/Training/") > -1) {
                            this.setBundleId('Training');
                        }
                        else {
                            this.setBundleId('Production');
                        }
                    }
                    else {
                        this.bundleId = '';
                    }
                    this.ipaDownloadLink = '';
                    this.applicationVersion = this.env.appVersion;
                };
                IpaUploadController.prototype.setBundleId = function (target) {
                    switch (target) {
                        case 'Production':
                            this.bundleId = 'com.novartis.aquacare';
                            break;
                        case 'RC':
                            this.bundleId = 'com.novartis.aquacare.rc';
                            break;
                        case 'Training':
                            this.bundleId = 'com.novartis.aquacare.training';
                            break;
                        default:
                            this.$window.alert(target + " not implemented");
                    }
                };
                IpaUploadController.prototype.uploadTarget = function () {
                    return this.apiEndpointService.getApplicationEndpoint() + "UploadIosAppZip";
                };
                IpaUploadController.prototype.getUploadHeaders = function () {
                    return this.authenticationService.getValidToken().then(function (token) {
                        return { "Authorization": 'Bearer ' + token };
                    });
                };
                IpaUploadController.prototype.upload = function ($flow) {
                    var _this = this;
                    this.getUploadHeaders().then(function (headers) {
                        $flow.opts.headers = headers;
                        $flow.opts.query = { 'bundleId': _this.bundleId };
                        $flow.upload();
                    });
                };
                ;
                IpaUploadController.prototype.fileAdded = function ($file, $event) {
                    console.log($file);
                };
                IpaUploadController.prototype.onSuccess = function (data) {
                    this.uploadSuccess = true;
                };
                IpaUploadController.prototype.onError = function ($file, $message, $flow) {
                    this.uploadFailed = true;
                    this.errorMessage = $message;
                };
                IpaUploadController.prototype.cancel = function () {
                    this.modalService.close();
                };
                IpaUploadController.prototype.getDownloadLink = function () {
                    var _this = this;
                    var expiryAfterDays = 2;
                    this.expiryTime = moment().add(expiryAfterDays, 'days').format();
                    return this.getExpiryToken(expiryAfterDays).then(function (result) {
                        _this.ipaDownloadLink = _this.apiEndpointService.getBaseEndpoint() + "/MobileDistribution?token=" + result.data;
                    });
                };
                IpaUploadController.prototype.getExpiryToken = function (expiryInDays) {
                    return this.$http.get(this.apiEndpointService.getUserManagementEndpoint() + 'GetExpiryToken', { params: { expiryInDays: expiryInDays } });
                };
                IpaUploadController.$inject = ['$scope', '$q', '$http', '$window', 'modalService', 'authenticationService', 'apiEndpointService', 'ENV'];
                return IpaUploadController;
            })();
            controllers.IpaUploadController = IpaUploadController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("IpaUploadController", ['$scope', '$q', '$http', '$window', 'modalService', 'authenticationService', 'apiEndpointService', 'ENV']);

var app;
(function (app) {
    var web;
    (function (web) {
        var controllers;
        (function (controllers) {
            var ErrorTestController = (function () {
                //public headers: any;
                //public errors: any;
                //public tabs: any;
                //private securityLevels: any
                //private navigationOptions: any;
                //public injectedScope: any;
                function ErrorTestController($scope, $q, $http, $window, modalService, authenticationService, apiEndpointService, env) {
                    this.$scope = $scope;
                    this.$q = $q;
                    this.$http = $http;
                    this.$window = $window;
                    this.modalService = modalService;
                    this.authenticationService = authenticationService;
                    this.apiEndpointService = apiEndpointService;
                    this.env = env;
                    this.initialize();
                }
                ErrorTestController.prototype.initialize = function () {
                    this.headerText = 'Test error handling';
                };
                ErrorTestController.prototype.cancel = function () {
                    this.modalService.close();
                };
                ErrorTestController.prototype.throwError = function () {
                    throw new Error("test error");
                };
                ErrorTestController.$inject = ['$scope', '$q', '$http', '$window', 'modalService', 'authenticationService', 'apiEndpointService', 'ENV'];
                return ErrorTestController;
            })();
            controllers.ErrorTestController = ErrorTestController;
        })(controllers = web.controllers || (web.controllers = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerController("ErrorTestController", ['$scope', '$q', '$http', '$window', 'modalService', 'authenticationService', 'apiEndpointService', 'ENV']);

//https://github.com/JustMaier/angular-signalr-hub
angular.module('SignalR').factory('signalRHubProxy', ['$rootScope', 'Hub', 'appLocalStorage', 'apiEndpointService',
    function ($rootScope, Hub, appLocalStorage, apiEndpointService) {
        //Hub setup
        var hub = new Hub('treeViewHub', {
            listeners: {
                'refreshTreeView': function () {
                    appLocalStorage.treeViewDataSet(null);
                }
            },
            methods: [],
            rootPath: apiEndpointService.baseEndpoint + "/signalr",
            errorHandler: function (error) {
                console.error(error);
            }
        });
        return {};
    }]);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var NotificationDirectiveController = (function () {
                function NotificationDirectiveController($scope, notificationService) {
                    $scope.notificationsCount = 0;
                    function getNotifications() {
                        notificationService.getNotifications().then(function (result) {
                            $scope.notifications = result;
                            $scope.notificationsCount = result.length;
                        });
                    }
                    getNotifications();
                }
                NotificationDirectiveController.$inject = ['$scope', 'notificationService'];
                return NotificationDirectiveController;
            })();
            var AvNotification = (function () {
                function AvNotification() {
                    this.restrict = 'E';
                    this.templateUrl = 'app.web/directives/notification/notification.directive.tpl.html';
                    this.controller = NotificationDirectiveController;
                }
                AvNotification.$inject = ['notificationService'];
                return AvNotification;
            })();
            directives.AvNotification = AvNotification;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvNotification', app.web.directives.AvNotification.$inject);

/// <reference path="../../_typings.web.ts" />
"use strict";
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var MenuDirectiveController = (function () {
                function MenuDirectiveController($rootScope, $scope, $state, $stateParams, $translate, navigationService, assessmentDatacontext, prescriptionDatacontext, authenticationService, modalService, cubeService, excelService, env, apiEndpointService, appLocalStorage) {
                    var type = $stateParams["type"];
                    var view = $stateParams["view"];
                    $scope.aside = null;
                    $scope.assessmentTypes = null;
                    $scope.isAquaVet = env.application === app.constants.applications.aquavet;
                    if (!!$scope.display && $scope.display === "sideMenu") {
                        $scope.aside = { title: "Title" };
                        $scope.assessmentTypes = assessmentDatacontext.getAssessmentTypes();
                    }
                    var getMenuItems = function (loadAssessmentOptions) {
                        if (loadAssessmentOptions === void 0) { loadAssessmentOptions = false; }
                        if (($scope.menuType !== app.constants.menuNames.assessment &&
                            $scope.menuType !== app.constants.menuNames.event &&
                            $scope.menuType !== app.constants.menuNames.gridRow) ||
                            loadAssessmentOptions) {
                            navigationService.getMenuItems($scope.menuType).then(function (result) {
                                if (type === "assessmentList" || type === "status") {
                                    if ($scope.assessment
                                        && $scope.assessment.assessmentType.dictionary.name
                                        && $scope.assessment.assessmentType.dictionary.name != "Visit") {
                                        result = result.filter(function (r) {
                                            return r.value !== "followup";
                                        });
                                    }
                                    if ($scope.assessment
                                        && $scope.assessment.isLocked
                                        && $scope.assessment.isLocked === true) {
                                        result = result.filter(function (r) {
                                            return r.value !== "delete";
                                        });
                                    }
                                    $scope.menuItems = _.filter(result, function (r) {
                                        if (!!$scope.assessment && !$scope.assessment.site.active)
                                            return (r.value !== "hide"
                                                && r.value !== "edit"
                                                && !(($scope.assessment.assessmentTypeId == app.constants.assessmentTypes.preVaccination
                                                    || app.common.utils.IsiPad())
                                                    && r.value === "exporttoexcel"));
                                        return (r.value !== "hide"
                                            && !(((!!$scope.assessment
                                                && $scope.assessment.assessmentTypeId == app.constants.assessmentTypes.preVaccination)
                                                || app.common.utils.IsiPad())
                                                && r.value === "exporttoexcel"));
                                    });
                                }
                                else if (view === 'template') {
                                    $scope.menuItems = _.filter(result, function (r) {
                                        return r.moduleId === "template";
                                    });
                                }
                                else if ($scope.assessment) {
                                    $scope.menuItems = _.filter(result, function (r) {
                                        if (!$scope.assessment.site.active)
                                            return (r.value !== "edit"
                                                && !(($scope.assessment.assessmentTypeId == app.constants.assessmentTypes.preVaccination
                                                    || app.common.utils.IsiPad())
                                                    && r.value === "exporttoexcel"));
                                        return !(($scope.assessment.assessmentTypeId == app.constants.assessmentTypes.preVaccination
                                            || app.common.utils.IsiPad())
                                            && r.value === "exporttoexcel");
                                    });
                                }
                                else if ($scope.event && !$scope.event.site.active) {
                                    $scope.menuItems = _.filter(result, function (r) {
                                        return r.value !== "edit" && r.value !== "createassessment";
                                    });
                                }
                                else if ($scope.ngModel && $scope.menuType === 'Prescription') {
                                    if ($scope.ngModel["isLocked"] && $scope.ngModel["isLocked"] === true) {
                                        result = result.filter(function (item) {
                                            return item.value !== "delete";
                                        });
                                    }
                                    if (!$scope.ngModel["isActivate"]) {
                                        $scope.menuItems = result.filter(function (item) {
                                            return item.value !== 'deactivate';
                                        });
                                    }
                                    else {
                                        $scope.menuItems = result.filter(function (item) {
                                            return item.value !== 'activate';
                                        });
                                    }
                                }
                                else {
                                    $scope.menuItems = _.sortBy(result, ["sortOrder"]);
                                }
                                if ($scope.menuType === app.constants.menuNames.importExport
                                    || $scope.menuType === app.constants.menuNames.registration) {
                                    $scope.menuItemsGrouped = _.groupBy($scope.menuItems, "moduleId");
                                }
                                // console.log("menuItems", $scope.menuItems);
                            });
                        }
                    };
                    getMenuItems();
                    var unregisterFn = $rootScope.$on(app.constants.broadcastEventNames.refreshMenus, function (event, data) {
                        getMenuItems();
                    });
                    $scope.loadOnClick = function () {
                        if (!$scope.menuItems) {
                            getMenuItems(true);
                        }
                    };
                    //$scope.$on('$destroy', unregisterFn());
                    // re-get menu when change view
                    $rootScope.$on(app.constants.broadcastEventNames.routingEvent, function (event, data) {
                        getMenuItems();
                    });
                    $rootScope.$on(app.constants.broadcastEventNames.refreshMenus, function (event, data) {
                        getMenuItems(true);
                    });
                    function UserMenu(item) {
                        switch (item.value) {
                            case "settings":
                                modalService.show("modules/user_settings/user.settings.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, new web.services.AssessmentData($scope.assessment));
                                break;
                            case "change password":
                                modalService.show("modules/user_settings/user.changepassword.html", app.constants.dialogSize.small, "", $scope, function () { }, new web.services.AssessmentData($scope.assessment));
                                break;
                            case "logoff":
                                authenticationService.logoutDesktop();
                                location.reload();
                                break;
                            case "applicationsettings":
                                document.location.href =
                                    apiEndpointService.getBaseEndpoint() +
                                        "/" +
                                        "Install/ApplicationSettings";
                                break;
                            case "userManualReportError":
                                var exceptionString = "User report an error manulaly";
                                $rootScope.$broadcast('clientErrorOccured', exceptionString);
                                break;
                            case "cachemanager":
                                document.location.href =
                                    apiEndpointService.getBaseEndpoint() + "/" + "CacheManager";
                                break;
                            case "glimpse":
                                document.location.href =
                                    apiEndpointService.getBaseEndpoint() + "/" + "glimpse.axd";
                                break;
                            case "install":
                                document.location.href =
                                    apiEndpointService.getBaseEndpoint() + "/" + "install";
                                break;
                            case "errorlog":
                                document.location.href =
                                    apiEndpointService.getBaseEndpoint() + "/" + "yZGh35SdwtgJlfk4f";
                                break;
                            case "log off":
                                alert(item.value);
                                break;
                        }
                    }
                    function openReport(auditId) {
                        modalService.show("modules/report/report.html", app.constants.dialogSize.large, "", $scope, function () { }, new web.services.ReportData($scope.assessment.assessmentId, app.enums.entityType.Assessment, app.localizer.resource[$scope.assessment.assessmentType.dictionary.name], auditId == null, $scope.assessment.uniqueId, auditId, authenticationService.credentialsCurrentUserGet().UserId));
                    }
                    function AssessmentMenu(item, val) {
                        if (val === void 0) { val = null; }
                        switch (item.value) {
                            case "sendmail":
                                modalService.show("modules/mail/mail.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, new web.services.MailData($scope.assessment.siteId, $scope.assessment.assessmentId, "Assessment", $scope.assessment.assessmentTypeId, -1, $translate.instant($scope.assessment["visitType"])));
                                break;
                            case "lock":
                                modalService
                                    .showConfirm("modules/locking/locking.html", app.constants.dialogSize.small, "", $scope, function () { }, new web.services.LockingData(app.enums.entityType.Assessment, $scope.assessment.isLocked))
                                    .then(function (comment) {
                                    $scope.toggleLocking()($scope.assessment, comment);
                                });
                                break;
                            case "unlock":
                                modalService
                                    .showConfirm("modules/locking/locking.html", app.constants.dialogSize.small, "", $scope, function () { }, new web.services.LockingData(app.enums.entityType.Assessment, $scope.assessment.isLocked))
                                    .then(function (comment) {
                                    $scope.toggleLocking()($scope.assessment, comment);
                                });
                                break;
                            case "followup":
                                $scope.toggleFollowUp()($scope.assessment, val);
                                break;
                            case "history":
                                modalService.show("modules/locking/assessment.history.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, new web.services.LockingHistoryData(app.enums.entityType.Assessment, $scope.assessment.assessmentId, app.localizer.resource[$scope.assessment.assessmentType.dictionary.name]));
                                break;
                            case "showreport":
                                if ($scope.assessment.isLocked) {
                                    assessmentDatacontext
                                        .getAuditDtos("Assessment", $scope.assessment.assessmentId, [4])
                                        .then(function (lockedAudits) {
                                        var auditId = null;
                                        if ($scope.assessment.isLocked && lockedAudits.length > 0) {
                                            auditId = lockedAudits[0].auditId;
                                        }
                                        openReport(auditId);
                                    });
                                }
                                else {
                                    openReport(null);
                                }
                                break;
                            case "edit":
                                $rootScope.$broadcast(app.constants.broadcastEventNames.collapseAllOpenAssessments);
                                modalService.show("modules/assessment/assessment.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, new app.common.model.AssessmentWizardData($scope.assessment.assessmentTypeId, app.constants.operation.EDIT, $scope.assessment.siteId, $scope.assessment.customerId, $scope.assessment.assessmentId, false, $scope.assessment.jumpToStep, $scope.assessment.jumpToRow)); //TODO get html url from item
                                break;
                            case "exporttoexcel":
                                excelService.getExcelFile($scope.assessment);
                                break;
                            case "delete":
                                $scope.confirm();
                                break;
                            case "hide":
                                $scope.hide();
                                break;
                            default:
                                alert("Not implemented");
                        }
                    }
                    function EventMenu(item) {
                        switch (item.value) {
                            case "edit":
                                modalService.show("modules/upcoming_events/event.html", app.constants.dialogSize.small, "", $scope, function () { }, new web.services.EventData($scope.event));
                                break;
                            case "createassessment":
                                //navigationService.setObjectKey(constants.operationUnitLevels.site + '-' + $scope.event.siteId, '');
                                $rootScope.$broadcast(app.constants.broadcastEventNames.collapseAllOpenAssessments);
                                modalService.show("modules/assessment/assessment.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, new app.common.model.AssessmentWizardData($scope.event.assessmentTypeId, app.constants.operation.NEW, $scope.event.siteId, $scope.event.customerId, -1, false, 0, 0, $scope.event.userId, $scope.event.fishgroupId)); //TODO get html url from item
                                break;
                            case "delete":
                                $scope.confirm();
                                break;
                            case "addtocalendar":
                                web.utils.events.addToCalendar([$scope.event], $translate);
                                break;
                            default:
                                alert("Not implemented");
                        }
                    }
                    function PrescriptionMenu(item) {
                        var siteId, prescriptionId;
                        var prescriptionModel = ($scope.ngModel);
                        if (prescriptionModel) {
                            siteId = prescriptionModel["siteId"];
                            prescriptionId = prescriptionModel["prescriptionId"];
                        }
                        switch (item.value) {
                            case "lock":
                                modalService
                                    .showConfirm("modules/locking/locking.html", app.constants.dialogSize.small, "", $scope, function () { }, new web.services.LockingData(app.enums.entityType.Prescription, ($scope.ngModel).isLocked))
                                    .then(function (comment) {
                                    $scope.toggleLocking()($scope.ngModel, comment);
                                });
                                break;
                            case "unlock":
                                modalService
                                    .showConfirm("modules/locking/locking.html", app.constants.dialogSize.small, "", $scope, function () { }, new web.services.LockingData(app.enums.entityType.Prescription, ($scope.ngModel).isLocked))
                                    .then(function (comment) {
                                    $scope.toggleLocking()($scope.ngModel, comment);
                                });
                                break;
                            case "history":
                                modalService.show("modules/locking/assessment.history.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, new web.services.LockingHistoryData(app.enums.entityType.Prescription, ($scope.ngModel).prescriptionId, app.localizer.resource["Prescription"]));
                                break;
                            case "edit":
                                modalService.show("modules/prescription/prescription.edit.html", app.constants.dialogSize.medium, "", $scope, function () { }, new web.services.PrescriptionData($scope.ngModel));
                                break;
                            case "showreport":
                                if (prescriptionModel) {
                                    siteId = prescriptionModel["siteId"];
                                    prescriptionId = prescriptionModel["prescriptionId"];
                                }
                                modalService.show("modules/report/report.html", app.constants.dialogSize.large, "", $scope, function () { }, new web.services.ReportData(prescriptionId, app.enums.entityType.Prescription, app.localizer.resource["Prescription"], true));
                                break;
                            case "sendmail":
                                if (siteId && prescriptionId)
                                    modalService.show("modules/mail/mail.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, new web.services.MailData(siteId, prescriptionId, "Prescription", 0, -1));
                                break;
                            case "delete":
                                $scope.confirm();
                                break;
                            case "deactivate":
                                var activatingDeactiveMessage, activatingDeactiveTitle;
                                activatingDeactiveMessage = $translate.instant("Activating_Deactivate_Message");
                                activatingDeactiveTitle = $translate.instant("Activating_Deactivate_Title");
                                activatingDeactiveTitle = activatingDeactiveTitle.format(app.localizer.resource.Prescription);
                                modalService.showConfirm("modules/confirm/confirm.html", app.constants.dialogSize.small, "", $scope, function () { }, new web.services.ConfirmationData(null, activatingDeactiveTitle, activatingDeactiveMessage, false, true, false)).then(function (comment) {
                                    $scope.toggleActivating()($scope.ngModel, comment);
                                });
                                break;
                            case "activate":
                                var activatingActiveMessage, activatingActiveTitle;
                                activatingActiveMessage = $translate.instant("Activating_Activate_Message");
                                activatingActiveTitle = $translate.instant("Activating_Activate_Title");
                                activatingActiveTitle = activatingActiveTitle.format(app.localizer.resource.Prescription);
                                modalService.showConfirm("modules/confirm/confirm.html", app.constants.dialogSize.small, "", $scope, function () { }, new web.services.ConfirmationData(null, activatingActiveTitle, activatingActiveMessage, false, true, false)).then(function (comment) {
                                    $scope.toggleActivating()($scope.ngModel, comment);
                                });
                                break;
                            default:
                                alert("Not implemented");
                        }
                    }
                    function DraftPrescriptionMenu(item) {
                        // console.log('DraftPrescriptionMenu');
                        switch (item.value) {
                            case "edit":
                                modalService.show("modules/prescription/prescription.edit.html", app.constants.dialogSize.medium, "", $scope, function () { }, new web.services.PrescriptionData($scope.ngModel));
                                break;
                            case "delete":
                                $scope.confirm();
                                break;
                            default:
                                alert("Not implemented");
                        }
                    }
                    function SetupOptions(item) {
                        if ($scope.ngModel.hasOwnProperty("supplierId")) {
                            switch (item.value) {
                                case "edit":
                                    modalService.show("modules/setup/supplier/supplier.edit.html", app.constants.dialogSize.medium, "", $scope, function () { }, new web.services.SupplierData(($scope.ngModel).supplierId));
                                    break;
                                case "delete":
                                    $scope.confirm();
                                    break;
                                default:
                                    alert("Not implemented");
                            }
                        }
                        else if ($scope.ngModel.hasOwnProperty("treatmentProductId")) {
                            switch (item.value) {
                                case "edit":
                                case 'details':
                                    modalService.show("modules/setup/treatment_product/treatment.product.edit.html", app.constants.dialogSize.medium, "", $scope, function () { }, new web.services.TreatmentProductData(($scope.ngModel).treatmentProductId));
                                    break;
                                case "delete":
                                    $scope.confirm();
                                    break;
                                default:
                                    alert("Not implemented");
                            }
                        }
                        else if ($scope.ngModel.hasOwnProperty("treatmentProductProducerId")) {
                            switch (item.value) {
                                case "edit":
                                    modalService.show("modules/setup/treatment_product_producer/treatment.product.producer.edit.html", app.constants.dialogSize.medium, "", $scope, function () { }, new web.services.TreatmentProductProducerData(($scope.ngModel).treatmentProductProducerId));
                                    break;
                                case "delete":
                                    $scope.confirm();
                                    break;
                                default:
                                    alert("Not implemented");
                            }
                        }
                        else if ("attributeMetadataEnumId" in $scope.ngModel) {
                            switch (item.value) {
                                case "edit":
                                    modalService.show("modules/setup/attribute_enum/attribute_enum.edit.html", app.constants.dialogSize.medium, "", $scope, function () { }, new web.services.AttributeEnumData(($scope.ngModel).attributeMetadataEnumId));
                                    break;
                                case "delete":
                                    $scope.confirm();
                                    break;
                                default:
                                    alert("Not implemented");
                            }
                        }
                    }
                    function SetupMenu(item) {
                        switch (item.value) {
                            case "treatmentproducts":
                                modalService.show("modules/setup/treatment_product/treatment.product.list.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, {});
                                break;
                            case "supplier":
                                modalService.show("modules/setup/supplier/supplier.list.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, {});
                                break;
                            case "activesubstance":
                                modalService.show("modules/setup/base_setup/base.setup.html", app.constants.dialogSize.small, "app.web.controllers.ActiveSubstanceController", $scope, function () { }, new web.services.BaseSetupData(app.constants.entityNames.activeSubstance));
                                break;
                            case "treatmentproductproducer":
                                modalService.show("modules/setup/treatment_product_producer/treatment.product.producer.list.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, {});
                                break;
                            case "attributemetadataenumadmin":
                                modalService.show("modules/setup/attribute_enum/attribute_enum.list.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, {});
                                break;
                            default:
                                alert(item.menuName + " not implemented");
                        }
                    }
                    function RegistrationMenu(item) {
                        switch (item.value.toLowerCase()) {
                            case "plan new event":
                                modalService.show("modules/upcoming_events/event.html", app.constants.dialogSize.small, "", $scope, function () { }, new web.services.EventData(navigationService.selectedObjectId));
                                break;
                            case "prescription":
                                modalService.show("modules/prescription/prescription.edit.html", app.constants.dialogSize.medium, "", $scope, function () { }, new web.services.PrescriptionData(null, navigationService.selectedObjectId));
                                break;
                            default:
                                if (item.data) {
                                    item.data.siteId = navigationService.selectedObjectId;
                                    item.data.customerId = navigationService.selectedCustomerId;
                                }
                                //Collapse all open assessments
                                $rootScope.$broadcast(app.constants.broadcastEventNames.collapseAllOpenAssessments);
                                modalService.show("modules/assessment/assessment.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, item.data); //TODO get html url from item
                        }
                    }
                    function ImportExportMenu(item) {
                        switch (item.value) {
                            case "e-mail distribution":
                                modalService.show("modules/mail/mail.list.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, new web.services.MailListData(app.enums.entityType.Assessment));
                                break;
                            case "emailprescriptiondistribution":
                                modalService.show("modules/mail/mail.list.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, new web.services.MailListData(app.enums.entityType.Prescription));
                                break;
                            case "export assessments as Excel":
                                exportExcelFile('Assessments');
                                break;
                            case "export prescriptions as Excel":
                                exportExcelFile('Prescriptions');
                                break;
                            default:
                                alert("Not implemented");
                        }
                    }
                    var TabMenu = function (item, val) {
                        if (!item.isSelected) {
                            $scope.isMapView = false;
                            $rootScope.$broadcast(app.constants.broadcastEventNames.assessmentViewType, false);
                            switch (item.value) {
                                case "status":
                                    $state.go("shell.assessments", {
                                        assessmentTypeId: null,
                                        type: "status",
                                        view: app.constants.assessmentListViews.status,
                                        role: authenticationService.credentialsCurrentUserGet().Role
                                    });
                                    break;
                                case "customerportalstatus":
                                    $state.go("shell.assessments", {
                                        type: "status",
                                        view: app.constants.assessmentListViews.customerPortalStatus
                                    });
                                    break;
                                case "assessments list":
                                    if (!val)
                                        $state.go("shell.assessments", {
                                            type: "assessmentList",
                                            view: app.constants.assessmentListViews.assessment,
                                            role: authenticationService.credentialsCurrentUserGet().Role
                                        });
                                    else
                                        $state.go("shell.assessments", {
                                            assessmentTypeId: val,
                                            type: "assessmentList",
                                            view: app.constants.assessmentListViews.assessment,
                                            role: authenticationService.credentialsCurrentUserGet().Role
                                        });
                                    break;
                                case "timeline":
                                case "customerportaltimeline":
                                    $state.go("shell.assessments", {
                                        type: "timeline",
                                        view: app.constants.assessmentListViews.timeline,
                                        role: authenticationService.credentialsCurrentUserGet().Role
                                    });
                                    break;
                                case "customerportalassessmentslist":
                                    $state.go("shell.assessments", {
                                        type: "assessmentList",
                                        view: app.constants.assessmentListViews.customerPortalAssessment,
                                        role: authenticationService.credentialsCurrentUserGet().Role
                                    });
                                    break;
                                case "mycontact":
                                    $state.go("shell.mycontact");
                                    break;
                                case "benchmarking":
                                    $state.go("shell.benchmarking");
                                    break;
                                case "upcomingevents":
                                case "customerportalupcomingevents":
                                    $state.go("shell.upcomingevents");
                                    break;
                                case "labtests":
                                case "customerportallabtests":
                                    $state.go("shell.labtests");
                                    break;
                                case "prescriptions":
                                    $state.go("shell.prescriptions");
                                    break;
                                default:
                                    var assessmentType = _.find(assessmentDatacontext.getAssessmentTypes(), function (assessmentType) { return assessmentType.dictionary.name == val; });
                                    $state.go("shell.assessments", {
                                        assessmentTypeId: assessmentType ? assessmentType.assessmentTypeId : null,
                                        type: "assessmentList",
                                        view: app.constants.assessmentListViews.assessment,
                                        role: authenticationService.credentialsCurrentUserGet().Role
                                    });
                            }
                            $rootScope.$broadcast(app.constants.broadcastEventNames.routingEvent, item.value);
                        }
                        else if (item.isSelected &&
                            $scope.display === "sideMenu" &&
                            item.value === "assessments list") {
                            $scope.isMapView = false;
                            $rootScope.$broadcast(app.constants.broadcastEventNames.assessmentViewType, false);
                            if (!val)
                                $state.go("shell.assessments", {
                                    assessmentTypeId: null,
                                    type: "assessmentList",
                                    view: app.constants.assessmentListViews.assessment
                                });
                            else
                                $state.go("shell.assessments", {
                                    assessmentTypeId: val,
                                    type: "assessmentList",
                                    view: app.constants.assessmentListViews.assessment
                                });
                            $rootScope.$broadcast(app.constants.broadcastEventNames.routingEvent, item.value);
                        }
                    };
                    function AdminMenu(item) {
                        switch (item.value) {
                            case "operation unit setup":
                                modalService.show("modules/host/host.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, new web.services.HostData(item.value));
                                break;
                            case "integration log":
                                modalService.show("modules/host/host.html", app.constants.dialogSize.small, "", $scope, function () { }, new web.services.HostData(item.value));
                                break;
                            case "crmimportstatus":
                                modalService.show("modules/host/host.html", app.constants.dialogSize.extraLarge, "", $scope, function () { }, new web.services.HostData(item.value));
                                break;
                            case "user admin":
                                modalService.show("modules/user_management/users.html", app.constants.dialogSize.large, "", $scope, function () { }, new web.services.HostData(item.value));
                                break;
                            case "customeradmin":
                                modalService.show("modules/user_management/users.html", app.constants.dialogSize.large, "", $scope, function () { }, new web.services.HostData(item.value));
                                break;
                            case "access control":
                                modalService.show("modules/access_control/access.control.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, null);
                                break;
                            case "rolepermission":
                                modalService.show("modules/access_control/role.permission.html", app.constants.dialogSize.defaultSize, "", $scope, function () { }, null);
                                break;
                            case "refreshtoken":
                                modalService.show("modules/refreshtoken/refreshtoken.html", app.constants.dialogSize.large, "", $scope, function () { }, null);
                                break;
                            case "clients":
                                modalService.show("modules/clients/clients.html", app.constants.dialogSize.large, "", $scope, function () { }, null);
                                break;
                            case "iosipaupload":
                                modalService.show("modules/ios/ipa.upload.html", app.constants.dialogSize.small, "", null, function () { }, {});
                                break;
                            case "errorhandlingtestpage":
                                modalService.show("modules/error_test/error.test.html", app.constants.dialogSize.small, "", null, function () { }, {});
                                break;
                            default:
                                alert("Not implemented");
                        }
                    }
                    function ProcessCubeMenu(item) {
                        switch (item.value) {
                            case "processcube":
                                $scope.cubeIsProcessing = true;
                                $scope.cubeProcessingErrorMessage = "";
                                cubeService
                                    .processCube()
                                    .then(function () {
                                    $scope.cubeIsProcessing = false;
                                })
                                    .catch(function (e) {
                                    $scope.cubeIsProcessing = false;
                                    $scope.cubeProcessingErrorMessage = "CubeProcessFailed";
                                    $rootScope.$broadcast(app.constants.broadcastEventNames.nonBlockingErrorOccured, e);
                                });
                                break;
                            default:
                                alert("Not implemented");
                        }
                    }
                    function MapTypeMenu(item) {
                        switch (item.value) {
                            case "Assessments":
                                $rootScope.$broadcast(app.constants.broadcastEventNames.switchMapView, app.constants.mapViewType.assessments);
                                break;
                            case "Events":
                                $rootScope.$broadcast(app.constants.broadcastEventNames.switchMapView, app.constants.mapViewType.events);
                                break;
                            default:
                                alert("Not implemented");
                        }
                    }
                    $scope.selectItem = function (menuItems, item, val) {
                        if (val === void 0) { val = null; }
                        switch (item.menuName) {
                            case app.constants.menuNames.user:
                                UserMenu(item);
                                break;
                            case app.constants.menuNames.assessment:
                            case app.constants.menuNames.template:
                                AssessmentMenu(item, val);
                                break;
                            case app.constants.menuNames.event:
                                EventMenu(item);
                                break;
                            case app.constants.menuNames.registration:
                                RegistrationMenu(item);
                                break;
                            case app.constants.menuNames.importExport:
                                ImportExportMenu(item);
                                break;
                            case app.constants.menuNames.admin:
                                AdminMenu(item);
                                break;
                            case app.constants.menuNames.tab:
                                TabMenu(item, val);
                                break;
                            case app.constants.menuNames.processCube:
                                ProcessCubeMenu(item);
                                break;
                            case app.constants.menuNames.mapType:
                                MapTypeMenu(item);
                                break;
                            case app.constants.menuNames.gridRow:
                                switch (item.moduleId) {
                                    case app.constants.gridRowMenus.prescription:
                                        PrescriptionMenu(item);
                                        break;
                                    case app.constants.gridRowMenus.draftPrescription:
                                        DraftPrescriptionMenu(item);
                                        break;
                                    case app.constants.gridRowMenus.setupOptions:
                                        SetupOptions(item);
                                        break;
                                    default:
                                        alert("Not implemented");
                                }
                                break;
                            case app.constants.menuNames.setup:
                                SetupMenu(item);
                                break;
                            default:
                                alert("Not implemented");
                        }
                        angular.forEach(menuItems, function (item) {
                            item.isSelected = false;
                        });
                        item.isSelected = true;
                    };
                    $scope.showAssessmentView = function () {
                        $scope.isMapView = false;
                        $rootScope.$broadcast(app.constants.broadcastEventNames.assessmentViewType, false);
                    };
                    $scope.showMapView = function () {
                        $scope.showAssessmentView();
                        // $scope.isMapView = true;
                        // $rootScope.$broadcast(
                        //   app.constants.broadcastEventNames.assessmentViewType,
                        //   true
                        // );
                    };
                    $scope.isIpad = function () {
                        return app.common.utils.IsiPad();
                    };
                    function exportExcelFile(type) {
                        if (type === 'Assessments') {
                            var assessmentsFaD = assessmentDatacontext.getAssessmentFaD();
                            var headers = [
                                {
                                    text: "Locked",
                                    propertyName: "isLocked",
                                    dataType: "Boolean",
                                    columnWidth: 6
                                },
                                {
                                    text: "Date",
                                    propertyName: "assessmentDate",
                                    dataType: "Date",
                                    columnWidth: 20
                                },
                                {
                                    text: "Type",
                                    propertyName: "assessmentTypeName",
                                    dataType: "String",
                                    columnWidth: 15,
                                    needTranslate: true
                                },
                                {
                                    text: "VisitType",
                                    propertyName: "visitType",
                                    columnWidth: 20,
                                    needTranslate: true
                                },
                                {
                                    text: "Customer",
                                    propertyName: "customerName",
                                    dataType: "String",
                                    columnWidth: 30
                                },
                                {
                                    text: "Site",
                                    propertyName: "siteName",
                                    dataType: "String",
                                    columnWidth: 15
                                },
                                {
                                    text: "Identifier",
                                    propertyName: "uniqueId",
                                    columnWidth: 20
                                },
                                {
                                    text: "Filter_Fishgroup",
                                    propertyName: "fishgroupName",
                                    dataType: "String",
                                    columnWidth: 15
                                },
                                {
                                    text: "NAHContact",
                                    propertyName: "contactPersonNames",
                                    dataType: "String",
                                    columnWidth: 15
                                },
                                {
                                    text: "Filter_FollowUp",
                                    propertyName: "followUpStatusId",
                                    dataType: "String",
                                    columnWidth: 4
                                }
                            ];
                            assessmentDatacontext.getAssessments(0, 30, assessmentsFaD.filterList, assessmentsFaD.dateRange, "assessment list", navigationService.selectedLevelId, true).then(function (data) {
                                data.results = assessmentDatacontext.changeVisitTypeValue(data.results);
                                excelService.generateAssessmentsExcelFile(data.results, headers, app.localizer.resource.Assessments);
                            });
                        }
                        if (type === 'Prescriptions') {
                            var prescriptionsFaD = prescriptionDatacontext.getPrescriptionFaD();
                            var headers = [
                                {
                                    text: $translate.instant("Locked"),
                                    propertyName: "isLocked",
                                    dataType: "Boolean",
                                    columnWidth: 6
                                },
                                {
                                    text: "Date",
                                    propertyName: "prescriptionDate",
                                    dataType: "Date",
                                    columnWidth: 20
                                },
                                {
                                    text: "PrescriptionNumber",
                                    propertyName: "prescriptionNumber",
                                    columnWidth: 15
                                },
                                {
                                    text: "Customer",
                                    propertyName: "customer",
                                    columnWidth: 30
                                },
                                {
                                    text: "Site",
                                    propertyName: "siteName",
                                    columnWidth: 15
                                },
                                {
                                    text: "Filter_TreatmentProduct",
                                    propertyName: "treatmentProductName",
                                    columnWidth: 30
                                },
                                {
                                    text: "Amount",
                                    propertyName: "amount",
                                    columnWidth: 15
                                },
                                {
                                    text: "FarmerUnit",
                                    propertyName: "amountMeasureUnitName",
                                    columnWidth: 5
                                },
                                {
                                    text: "ActiveSubstance",
                                    propertyName: "activeSubstance",
                                    columnWidth: 15
                                },
                                {
                                    text: "TreatmentProduct_Inclusion",
                                    propertyName: "inclusionTotal",
                                    columnWidth: 15
                                },
                                {
                                    text: "FarmerUnit",
                                    propertyName: "inclusionMeasureUnitName",
                                    columnWidth: 5
                                },
                                {
                                    text: "Veterinary",
                                    propertyName: "vetFullName",
                                    columnWidth: 20
                                },
                                {
                                    text: "AuditType_Create",
                                    propertyName: "createdTime",
                                    columnWidth: 15,
                                    dataType: "DateTime"
                                }
                            ];
                            prescriptionDatacontext.getPrescriptions(0, 30, prescriptionsFaD.filterList, prescriptionsFaD.dateRange, authenticationService.credentialsCurrentUserGet().UserId, "Web App", true)
                                .then(function (data) {
                                data.results = prescriptionDatacontext.addPropertiesForListPrescriptions(data.results);
                                excelService.generateAssessmentsExcelFile(data.results, headers, app.localizer.resource.Prescription);
                            });
                        }
                    }
                    ;
                    $scope.prepareMedicationReport = function (mode) {
                        if (!!mode && (mode === "user" || mode === "customer")) {
                            modalService.show("modules/prepare_report/prepare.report.tpl.html", app.constants.dialogSize.extraLarge, "", "", function () { }, new web.services.PrepareReportData(mode));
                        }
                    };
                }
                MenuDirectiveController.$inject = [
                    "$rootScope",
                    "$scope",
                    "$state",
                    "$stateParams",
                    "$translate",
                    "navigationService",
                    "assessmentDatacontext",
                    "prescriptionDatacontext",
                    "authenticationService",
                    "modalService",
                    "cubeService",
                    "excelService",
                    "ENV",
                    "apiEndpointService",
                    "appLocalStorage"
                ];
                return MenuDirectiveController;
            })();
            directives.MenuDirectiveController = MenuDirectiveController;
            var AvMenu = (function () {
                function AvMenu() {
                    this.restrict = "E";
                    this.templateUrl = function (element, attributes) {
                        if (attributes.type === "Assessment" ||
                            attributes.type === "Prescription" ||
                            attributes.type === "DraftPrescription" ||
                            attributes.type === "TreatmentProduct" ||
                            attributes.type === "SetupOptions" ||
                            attributes.type === "Template")
                            return "app.web/directives/menu/menu.options.tpl.html";
                        else
                            return "app.web/directives/menu/menu.directive.tpl.html";
                    };
                    this.scope = {
                        menuType: "@type",
                        objectLevel: "@level",
                        title: "@",
                        assessment: "=",
                        event: "=",
                        ngModel: "=",
                        confirm: "&",
                        hide: "&",
                        toggleLocking: "&",
                        toggleFollowUp: "&",
                        toggleActivating: "&",
                        display: "@display"
                    };
                    this.controller = MenuDirectiveController;
                }
                AvMenu.$inject = [
                    "$rootScope",
                    "$translate",
                    "navigationService",
                    "authenticationService",
                    "modalService"
                ];
                return AvMenu;
            })();
            directives.AvMenu = AvMenu;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective("AvMenu", app.web.directives.AvMenu.$inject);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var MultirowsDirectiveController = (function () {
                function MultirowsDirectiveController($scope, $q, $compile, $timeout, $http, $translate, busyIndicator) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$timeout = $timeout;
                    this.$translate = $translate;
                    this.busyIndicator = busyIndicator;
                    this.cellTemplate = 'app.web/directives/multirows/cell.tpl.html';
                    this.rowHeaderTemplate = 'app.web/directives/multirows/rowHeader.tpl.html';
                    this.footerCellTemplate = 'app.web/directives/multirows/footer.tpl.html';
                    this.GridHeaderHeightInPixel = 30;
                    this.GridOffsetInPixel = 30;
                    $scope.itemTemplate = 'directives/multirows/row.template.html';
                    $scope.page = 0;
                    $scope.loadingCount = 0;
                    $scope.allowLoadOnScroll = true;
                    $scope.dynamicPopover = '<div><img src=""></div>';
                    $scope.dynamicPopoverTitle = 'Upload Image';
                    $scope.hasPrefilled = true;
                    $scope.popover = {
                        "title": "Title",
                        "content": "Hello Popover<br />This is a multiline message!"
                    };
                    $scope.gridOptions = {
                        showColumnFooter: $scope.templateGroup.hasTotals,
                        enableSorting: false,
                        enableColumnMenus: false,
                        columnFooterHeight: 55,
                        rowHeight: 36,
                        virtualizationThreshold: 50,
                        minRowsToShow: 50,
                        onRegisterApi: function (gridApi) {
                            $scope.gridApi = gridApi;
                            //$scope.gridApi.core.addRowHeaderColumn({ name: 'rowHeaderCol', displayName: '#', width: 50, cellTemplate: this.rowHeaderTemplate, footerCellTemplate: this.footerCellTemplate });
                            //$scope.gridApi.grid.registerRowBuilder((row, gridOptions) => {
                            //     row.isNew = true;
                            //});
                            $scope.gridApi.core.on.rowsRendered($scope, function () {
                                $scope.loadingCount--;
                                if ($scope.loadingCount <= 0)
                                    busyIndicator.hide();
                            });
                        }
                    };
                    $scope.gridOptions.columnDefs = this.getColumnDefs($scope);
                    $scope.totalRows = function (row, col) {
                        if (col.name === 'rowHeaderCol') {
                            return ['Totals', 'TotalsStandardDeviation'];
                        }
                        var arr = _.filter($scope.templateRegistrationsForTotalRows, function (templateRegistration) {
                            return templateRegistration.attribute && templateRegistration.attribute.dictionary.name === col.name;
                        });
                        return _.sortByProperties(arr, ["rowIndex desc"]);
                    };
                    $scope.getFormattedValue = function (templateRegistration) {
                        return app.common.utils.unformatDecimal(templateRegistration.focusValue ? templateRegistration.focusValue : templateRegistration.integerValue);
                    };
                    $scope.$watch('currentTemplateId', function () { return _this.updateData(); });
                    $scope.$watch('templateGroup.rows.length', function () { return _this.updateData(); });
                    $scope.loadMoreRows = function () {
                        $scope.page++;
                        $scope.allowLoadOnScroll = $scope.rows.length > $scope.page * $scope.pageSize;
                        if ($scope.allowLoadOnScroll)
                            return $q.when($scope.rows.slice(0, $scope.page * $scope.pageSize));
                        else
                            return $q.when($scope.rows);
                    };
                    $scope.$on('flow::fileAdded', function (event, $flow, flowFile) {
                        event.preventDefault(); //prevent file from uploading
                    });
                    $scope.$on(app.constants.broadcastEventNames.refreshMultiRow, function () {
                        _this.updateData();
                    });
                    $scope.removeImageData = function ($flow, templateRegistration) {
                        $flow.files = [];
                        templateRegistration.textValue = null;
                        templateRegistration.imageData = null;
                    };
                    $scope.setImageData = function (files, message, templateRegistration) {
                        templateRegistration.textValue = message.substring(1, message.length - 1);
                        templateRegistration.imageData = files[0];
                        templateRegistration["error"] = {
                            haserror: false,
                            errorType: app.constants.errorType.None,
                            value: ''
                        };
                    };
                    $scope.fileErrorHandle = function (files, message, $flow, templateRegistration) {
                        $flow.files = [];
                        templateRegistration["error"] = {
                            haserror: true,
                            errorType: app.constants.errorType.None,
                            value: _.get(JSON.parse(message), 'ModelState').file[0]
                        };
                        templateRegistration.textValue = null;
                        templateRegistration.imageData = null;
                    };
                    $scope.errorMessageGet = function (templateRegistration) {
                        if (templateRegistration && templateRegistration.error)
                            return templateRegistration.error.value;
                        return _this.$translate.instant("Required");
                    };
                    $scope.imageAdded = function ($file, $event) {
                        $file.message = app.localizer.resource.ImageResolutionReduced;
                        $file.fileToBigMessage = app.localizer.resource.FileToBigMessage;
                        return true;
                    };
                    $scope.isFlowFile = function (imageData) {
                        return imageData && imageData.name;
                    };
                    $scope.upload = function ($flow) {
                        $scope.imageUploadHeaders().then(function (headers) {
                            $flow.opts.headers = headers;
                            $flow.upload();
                        });
                    };
                    $scope.getImage = function (templateRegistration, filename) {
                        if (!templateRegistration.imageData)
                            if ($scope.assessment.assessmentId > 0 && filename)
                                $timeout(function () {
                                    $scope.getImageOnDemand({ assessmentId: $scope.assessment.assessmentId, filename: filename })
                                        .success(function (data) {
                                        $timeout(function () { templateRegistration.imageData = data.Data; });
                                    })
                                        .error(function (error) {
                                    });
                                }, 500);
                    };
                    $scope.openAttachment = function (templateRegistration) {
                        $scope.openAttachedFile({
                            assessmentId: $scope.assessment.assessmentId,
                            filename: templateRegistration.textValue
                        });
                    };
                    $scope.getHeaders = function () {
                        return $http.defaults.headers.common;
                    };
                    $scope.formatNumber = function (value) {
                        return app.common.utils.unformatDecimal(value);
                    };
                }
                MultirowsDirectiveController.prototype.updateData = function () {
                    var _this = this;
                    if (!this.$scope.templateGroup.hasMultiRows || this.$scope.currentTemplateId !== this.$scope.templateGroup.templateId)
                        return;
                    this.$scope.loadingCount++;
                    if (!this.$scope.templateGroup.template.hasTabsView)
                        this.busyIndicator.show();
                    this.$timeout(function () {
                        var templateRegs = _this.$scope.getTemplateRegistrations({ template: _this.$scope.templateGroup.template });
                        // VET-261, update format of "FarmerVaccineLastDate" to timestamp [15].attribute.dictionary.name 
                        //angular.forEach(templateRegs, temReg => {
                        //    if (temReg["attribute"]["dictionary"]["name"] === "FarmerVaccineLastDate") {
                        //        let temp = temReg["dateValue"].toLocaleString();
                        //        temReg["focusValue"] = temp;
                        //    }
                        //});
                        var dataGroupedByRowIndex = _.chain(templateRegs)
                            .groupBy('rowIndex')
                            .toPairs()
                            .map(function (tr) {
                            return tr;
                        }).value();
                        _this.$scope.templateRegistrationsForTotalRows = _this.$scope.getTemplateRegistrationsForTotalRows({ template: _this.$scope.templateGroup.template });
                        var rowHeader = 0;
                        _this.$scope.hasPrefilled = _.some(templateRegs, function (tr) {
                            return tr.hasPreFilled;
                        });
                        _this.$scope.gridOptions.data = _.map(dataGroupedByRowIndex, function (row) {
                            var keys = ['rowIndex'].concat(_.map(row[1], function (tr) {
                                return tr.attribute.dictionary.name;
                            })).concat('delete');
                            rowHeader++;
                            return _.zipObject(keys, [rowHeader.toString()].concat(row[1]).concat(['delete']));
                        });
                        if (!_this.$scope.gridOptions.data.length) {
                            _this.$scope.loadingCount--;
                            _this.busyIndicator.hide();
                        }
                        ;
                        if (!_this.$scope.gridOptions.data.length)
                            _this.$scope.gridHeight = 'auto';
                        else {
                            _this.$scope.gridHeight = _this.GridHeaderHeightInPixel
                                + _this.$scope.gridOptions.rowHeight * _this.$scope.gridOptions.data.length
                                + _this.GridOffsetInPixel;
                        }
                        _this.$timeout(function () { _this.busyIndicator.hide(); });
                    });
                };
                MultirowsDirectiveController.prototype.getColumnDefs = function (scope) {
                    var _this = this;
                    //var rowIndexCol = [{ name: 'rowHeaderCol', displayName: '#', field: '', maxWidth: 40, minWidth:31, cellTemplate: this.rowHeaderTemplate, footerCellTemplate: this.footerCellTemplate, headerCellFilter: 'translate', headerTooltip: false, visible: true, templateItem: null }];
                    var rowIndexCol = [{ name: 'rowHeaderCol', displayName: '#', field: '', maxWidth: 40, minWidth: 31, cellTemplate: this.rowHeaderTemplate, footerCellTemplate: this.footerCellTemplate, headerCellFilter: 'translate', headerTooltip: false, visible: true, templateItem: null }];
                    var deleteCol = [{ name: 'delete', displayName: '', field: '', maxWidth: 40, minWidth: undefined, cellTemplate: this.cellTemplate, footerCellTemplate: '', headerCellFilter: 'translate', headerTooltip: false, visible: true, templateItem: null }];
                    //var noOfColumns = scope.templateGroup.template.templateItems.length;
                    var cells = _.map(_.filter(scope.templateGroup.template.templateItems, function (templateItem) {
                        return templateItem.attribute.dictionary.name !== 'ValidExpiryDate';
                    }), function (templateItem) {
                        var minWidth;
                        var maxWidth;
                        switch (templateItem.attribute.attributeType.name) {
                            case app.constants.attributeType.Enum:
                                if (templateItem.attribute.enumDataType === 'String')
                                    minWidth = 200;
                                else
                                    minWidth = 85;
                                maxWidth = 300;
                                break;
                            case app.constants.attributeType.Multiselect:
                                minWidth = 100;
                                maxWidth = 300;
                                break;
                            case app.constants.attributeType.Boolean:
                                maxWidth = 60;
                                break;
                            case app.constants.attributeType.Comment:
                                minWidth = 100;
                                break;
                            case app.constants.attributeType.File:
                                maxWidth = 400;
                                break;
                            case app.constants.attributeType.Integer:
                                minWidth = 80;
                                maxWidth = 100;
                                break;
                            case app.constants.attributeType.Double:
                                if (templateItem.attribute.attributeId === 119) {
                                    minWidth = 85;
                                }
                                else {
                                    maxWidth = 120;
                                    minWidth = 80;
                                }
                                break;
                            default:
                                minWidth = undefined; //auto
                        }
                        return {
                            name: templateItem.attribute.dictionary.name,
                            displayName: templateItem.attribute.dictionary.name,
                            field: 'focusValue',
                            minWidth: minWidth,
                            maxWidth: maxWidth,
                            cellTemplate: _this.cellTemplate,
                            footerCellTemplate: _this.footerCellTemplate,
                            headerCellFilter: 'translate',
                            visible: true,
                            headerTooltip: true,
                            templateItem: templateItem
                        };
                    });
                    return scope.isreadonly ? rowIndexCol.concat(cells) : rowIndexCol.concat(cells).concat(deleteCol);
                };
                MultirowsDirectiveController.$inject = ['$scope', '$q', '$compile', '$timeout', '$http', '$translate', 'busyIndicator'];
                return MultirowsDirectiveController;
            })();
            var AvMultirows = (function () {
                function AvMultirows() {
                    this.templateUrl = 'app.web/directives/multirows/multirows.directive.tpl.html';
                    this.restrict = 'E';
                    this.transclude = true;
                    this.scope = {
                        assessment: '=',
                        templateGroup: '=',
                        currentTemplateId: '=',
                        getTemplateRegistrations: '&',
                        getTemplateRegistration: '&',
                        getTemplateRegistrationsForTotalRows: '&',
                        getTemplateRegistrationsByRowIndex: '&',
                        getSelectionModel: '&',
                        selectItem: '&',
                        selectionChange: '&',
                        takePicture: '&',
                        removePicture: '&',
                        hasError: '&',
                        errorMessageGet: '&',
                        addRow: '&',
                        deleteRow: '&',
                        getManipulatedRowIndex: '&',
                        imageUploadTarget: '&',
                        imageUploadHeaders: '&',
                        attachementUploadTarget: '&',
                        getImageOnDemand: '&',
                        openAttachedFile: '&',
                        pageSize: '=',
                        isreadonly: '=',
                        toggleSize: '=',
                        isCustomerPortal: '=',
                        showTemplateItem: '&',
                    };
                    this.controller = MultirowsDirectiveController;
                }
                AvMultirows.$inject = ['$q', '$compile', '$timeout'];
                return AvMultirows;
            })();
            directives.AvMultirows = AvMultirows;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvMultirows', app.web.directives.AvMultirows.$inject);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var UiGridRow = (function () {
                //public link = this.linkFunction;
                //static $inject: string[] = ['$timeout','$animate'];
                function UiGridRow($timeout, $animate) {
                    var _this = this;
                    this.$timeout = $timeout;
                    this.$animate = $animate;
                    this.priority = -1;
                    this.link = function (scope, elm, attrs) {
                        scope.$watch('row.entity', function (n, o) {
                            if (scope.row.isNew) {
                                elm.addClass('new-row');
                                _this.$timeout(function () {
                                    _this.$animate.removeClass(elm, 'new-row');
                                });
                                scope.row.isNew = false;
                            }
                        });
                        scope.$on('delete-row', function (evt, row) {
                            _this.$animate.addClass(elm, 'delete-row')
                                .then(function () {
                                elm.removeClass('delete-row');
                                // Not in $digest
                                //this.$timeout(() => {
                                //var data = scope.grid.options.data;
                                // data.splice(data.indexOf(row.entity), 1);
                                //});
                            });
                        });
                    };
                }
                UiGridRow.factory = function () {
                    var directive = function ($timeout, $animate) { return new UiGridRow($timeout, $animate); };
                    directive.$inject = ["$timeout", "$animate"];
                    return directive;
                };
                return UiGridRow;
            })();
            directives.UiGridRow = UiGridRow;
            var UiGridCell = (function () {
                //public link = this.linkFunction;
                //static $inject: string[] = ['$timeout','$animate'];
                function UiGridCell() {
                    this.priority = -1;
                    this.link = function (scope, elm, attrs) {
                        scope.deleteRow = function (row) {
                            scope.$emit('delete-row', row);
                        };
                    };
                }
                UiGridCell.factory = function () {
                    var directive = function () { return new UiGridCell(); };
                    //directive.$inject = ["$timeout", "$animate"];
                    return directive;
                };
                return UiGridCell;
            })();
            directives.UiGridCell = UiGridCell;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirectiveViaFactory('UiGridRow');
app.web.registerDirectiveViaFactory('UiGridCell');

var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var AvAssessment = (function () {
                function AvAssessment() {
                    this.templateUrl = 'app.web/directives/assessment/assessment.directive.tpl.html';
                    this.restrict = 'E';
                }
                return AvAssessment;
            })();
            directives.AvAssessment = AvAssessment;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvAssessment', []);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var AssessmentListDirectiveController = (function () {
                function AssessmentListDirectiveController($scope) {
                    $scope.itemTemplate = $scope.customerMode ? 'app.web/directives/assessment_list/assessment.customer.portal.row.tpl.html' : 'app.web/directives/assessment_list/assessment.row.tpl.html';
                    $scope.injectedScope = {
                        getwizardData: function (assessment) {
                            return new app.common.model.AssessmentWizardData(assessment.assessmentTypeId, app.constants.operation.EDIT, assessment.siteId, assessment.customerId, assessment.assessmentId, true);
                        }
                    };
                }
                AssessmentListDirectiveController.$inject = ['$scope'];
                return AssessmentListDirectiveController;
            })();
            directives.AssessmentListDirectiveController = AssessmentListDirectiveController;
            var AvAssessmentList = (function () {
                function AvAssessmentList() {
                    this.templateUrl = 'app.web/directives/assessment_list/assessment.list.directive.tpl.html';
                    this.restrict = 'E';
                    this.scope = {
                        range: '=',
                        assessments: '=',
                        headers: '=',
                        loadMore: '&',
                        toggleReload: '=',
                        customerMode: '=',
                        totalRows: '='
                    };
                    this.controller = AssessmentListDirectiveController;
                }
                return AvAssessmentList;
            })();
            directives.AvAssessmentList = AvAssessmentList;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvAssessmentList', []);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var TemplateListDirectiveController = (function () {
                function TemplateListDirectiveController($scope) {
                    $scope.itemTemplate = $scope.customerMode ? 'app.web/directives/template_list/template.customer.portal.row.tpl.html' : 'app.web/directives/template_list/template.row.tpl.html';
                    $scope.injectedScope = {
                        getwizardData: function (template) {
                            return new app.common.model.AssessmentWizardData(template.assessmentTypeId, app.constants.operation.EDIT, template.siteId, template.customerId, template.assessmentId, true);
                        }
                    };
                }
                TemplateListDirectiveController.$inject = ['$scope'];
                return TemplateListDirectiveController;
            })();
            directives.TemplateListDirectiveController = TemplateListDirectiveController;
            var AvTemplateList = (function () {
                function AvTemplateList() {
                    this.templateUrl = 'app.web/directives/template_list/template.list.directive.tpl.html';
                    this.restrict = 'E';
                    this.scope = {
                        range: '=',
                        assessments: '=',
                        headers: '=',
                        loadMore: '&',
                        toggleReload: '=',
                        customerMode: '=',
                        totalRows: '='
                    };
                    this.controller = TemplateListDirectiveController;
                }
                return AvTemplateList;
            })();
            directives.AvTemplateList = AvTemplateList;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvTemplateList', []);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var OptionsMenu = (function () {
                function OptionsMenu() {
                    this.restrict = 'EA';
                    this.template = "<div class='btn-group' dropdown  >" +
                        "<button type='button' class='btn btn-link  btn-xs dropdown-toggle pull pull-right' dropdown-toggle ng-disabled='disabled'>" +
                        "<i class='glyphicon glyphicon-cog'></i>" +
                        "</button>" +
                        "<ul class='dropdown-menu options-menu pull pull-left' role='menu'>" +
                        "<li><a href='#'>Edit</a></li>" +
                        "<li><a href='#'>Send</a></li>" +
                        "<li><a href='#'>Show Report</a></li>" +
                        "<li class='divider'></li>" +
                        "<li><a href='#'>Hide</a></li>" +
                        "<li><a href='#'>Delete</a></li>" +
                        "</ul>" +
                        "</div>";
                }
                return OptionsMenu;
            })();
            directives.OptionsMenu = OptionsMenu;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('OptionsMenu', []);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var TreeDirectiveController = (function () {
                function TreeDirectiveController($scope, $uibModal, navigationService, appLocalStorage, env) {
                    this.$scope = $scope;
                    this.$uibModal = $uibModal;
                    this.appLocalStorage = appLocalStorage;
                    $scope.selectedNode = null;
                    $scope.grayout = false;
                    $scope.nodeList = [];
                    var tempBreadCrumbs;
                    var treeViewWithRoot;
                    var modalInstance;
                    $scope.openTree = function () {
                        modalInstance = $uibModal.open({
                            animation: true,
                            templateUrl: 'app.web/directives/tree/tree.view.tpl.html',
                            scope: $scope,
                            size: '',
                            windowClass: 'treeView'
                        });
                    };
                    $scope.focusin = function () {
                        $scope.grayout = true;
                    };
                    $scope.focusout = function () {
                        $scope.grayout = false;
                    };
                    $scope.searchNode = function (node) {
                        if (node !== null) {
                            $scope.selectNode(node.originalObject);
                            for (var i = 0; i < $scope.breadcrumbs.length - 1; i++) {
                                $scope.breadcrumbs[i].exp = 1;
                            }
                            $scope.grayout = false;
                        }
                    };
                    $scope.expand = function (node) {
                        node.exp = node.exp === 0 ? 1 : 0;
                    };
                    $scope.setNode = function (node) {
                        if (node.sel === 0 && node.arm) {
                            $scope.selectNode(node);
                        }
                    };
                    $scope.selectNode = function (node) {
                        if ($scope.selectedNode !== null) {
                            if (node.sel === 1) {
                                return;
                            }
                            $scope.selectedNode.sel = 0;
                        }
                        node.sel = 1;
                        $scope.selectedNode = node;
                        tempBreadCrumbs = [];
                        app.web.utils.tree.findSelectedNode(treeViewWithRoot, tempBreadCrumbs);
                        tempBreadCrumbs.pop();
                        $scope.breadcrumbs = (tempBreadCrumbs).reverse();
                        if (!_.isUndefined(modalInstance))
                            modalInstance.close();
                        var customerId = null;
                        var customerNode = _.find($scope.breadcrumbs, function (bc) {
                            return bc.id.indexOf("2-") == 0;
                        });
                        if (!_.isUndefined(customerNode)) {
                            customerId = customerNode.id;
                        }
                        navigationService.setObjectKey(node.id, customerId);
                        navigationService.setAccessRightMask(node.arm);
                    };
                    $scope.$on(app.constants.broadcastEventNames.siteSelected, function (event, selectedObjectId) {
                        var nodeToSelect = app.web.utils.tree.findNodeById(treeViewWithRoot, selectedObjectId);
                        if (nodeToSelect !== null) {
                            $scope.selectNode(nodeToSelect);
                        }
                    });
                    function getTreeViewData() {
                        var result = JSON.parse(appLocalStorage.treeViewDataGet());
                        app.web.utils.tree.removeEmptyNodes(result, 0, null);
                        if (env.shrinkTree === 'farmer') {
                            app.web.utils.tree.shrinkTreeFarmer(result, navigationService.objectKey);
                        }
                        else if (env.shrinkTree === 'all') {
                            app.web.utils.tree.shrinkTree(result, navigationService.objectKey);
                        }
                        treeViewWithRoot = result;
                        result.ch[0].exp = 1;
                        $scope.treeViewData = result.ch;
                        var defaultNode = app.web.utils.tree.findNodeById(treeViewWithRoot, navigationService.objectKey);
                        defaultNode.sel = 1;
                        $scope.selectedNode = defaultNode;
                        tempBreadCrumbs = [];
                        app.web.utils.tree.findSelectedNode(treeViewWithRoot, tempBreadCrumbs);
                        tempBreadCrumbs.pop();
                        $scope.breadcrumbs = (tempBreadCrumbs).reverse();
                        app.web.utils.tree.treeToArray(result, $scope.nodeList);
                    }
                    getTreeViewData();
                }
                TreeDirectiveController.$inject = ['$scope', '$uibModal', 'navigationService', 'appLocalStorage', "ENV"];
                return TreeDirectiveController;
            })();
            directives.TreeDirectiveController = TreeDirectiveController;
            var AvTree = (function () {
                function AvTree() {
                    this.restrict = 'E';
                    this.templateUrl = 'app.web/directives/tree/tree.directive.tpl.html';
                    this.scope = {};
                    this.controller = TreeDirectiveController;
                }
                AvTree.$inject = ['navigationService'];
                return AvTree;
            })();
            directives.AvTree = AvTree;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvTree', app.web.directives.AvTree.$inject);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var TreePermissionDirectiveController = (function () {
                function TreePermissionDirectiveController($scope, $uibModal, navigationService, appLocalStorage, env) {
                    this.$scope = $scope;
                    this.$uibModal = $uibModal;
                    this.appLocalStorage = appLocalStorage;
                    $scope.selectedNode = null;
                    $scope.grayout = false;
                    $scope.nodeList = [];
                    var treeViewWithRoot;
                    $scope.control.openTree = function () {
                        refreshTreeView();
                        if (!app.common.utils.isNullOrUndefinedOrEmpty($scope.customerId))
                            $scope.control.openCustomer($scope.customerId);
                    };
                    $scope.control.openCustomer = function (customerId) {
                        var customerNode = app.web.utils.tree.findNodeById(treeViewWithRoot, "2-" + customerId);
                        customerNode.exp = 1;
                        var levelId = 0;
                        var objectId = 0;
                        _.forEach($scope.nodeList, function (item) {
                            levelId = item.id.split('-')[0];
                            if (levelId == 2) {
                                objectId = item.id.split("-")[1];
                                item.show = objectId == customerId ? 1 : 0;
                            }
                        });
                        if (treeViewWithRoot.ch[0].ch != null && treeViewWithRoot.ch[0].ch.length > 0 && treeViewWithRoot.ch[0].ch[0].id.split('-')[0] == app.constants.operationUnitLevels.companyBU) {
                            _.forEach(treeViewWithRoot.ch[0].ch, function (companyBu) {
                                var hasSelectedCustomer = false;
                                _.find(companyBu.ch, function (customer) {
                                    objectId = customer.id.split("-")[1];
                                    if (!hasSelectedCustomer && objectId == customerId) {
                                        hasSelectedCustomer = true;
                                        companyBu.exp = 1;
                                    }
                                });
                                if (!hasSelectedCustomer)
                                    companyBu.show = 0;
                            });
                        }
                    };
                    function setAccessToNodes(node, levelId, businessObjectId, access) {
                        if (node.ch !== null) {
                            for (var i = 0; i < node.ch.length; i++) {
                                var item = node.ch[i];
                                if ((levelId < parseInt(item.id.split('-')[0])) || (levelId === parseInt(item.id.split('-')[0]) && businessObjectId === parseInt(item.id.split('-')[1]))) {
                                    item.access = app.constants.accessControlPermissionIdGet(access);
                                    item.parentAccess = node.access;
                                }
                                else if (_.isUndefined(item.access)) {
                                    item.access = -1;
                                    item.parentAccess = node.access;
                                }
                                item.sb = 0;
                                setAccessToNodes(item, levelId, businessObjectId, access);
                            }
                        }
                    }
                    $scope.setToEditMode = function (node) {
                        if (!app.common.utils.isNullOrUndefinedOrEmpty($scope.customerId)) {
                            if (node.id.split('-')[0] == 7)
                                node.sb = 1;
                        }
                        else
                            node.sb = 1;
                    };
                    $scope.setPermission = function (node, permission) {
                        var levelId = parseInt(node.id.split('-')[0]);
                        var businessObjectId = parseInt(node.id.split('-')[1]);
                        if (app.constants.accessControlPermissionIdGet(permission) === app.constants.accessControlPermissions.none) {
                            _.forEach(_.filter($scope.userBusinessObjects, function (item) {
                                return (item.operationUnitTypeLevelId > levelId || (item.operationUnitTypeLevelId == levelId && item.businessObjectId == businessObjectId));
                            }), function (item) { item.entityAspect.setDeleted(); });
                            _.remove($scope.userBusinessObjects, function (item) {
                                return (item.operationUnitTypeLevelId > levelId || (item.operationUnitTypeLevelId == levelId && item.businessObjectId == businessObjectId));
                            });
                        }
                        else {
                            _.forEach(_.filter($scope.userBusinessObjects, function (item) {
                                return (item.operationUnitTypeLevelId == levelId && item.businessObjectId == businessObjectId);
                            }), function (item) { item.entityAspect.setDeleted(); });
                            _.remove($scope.userBusinessObjects, function (item) {
                                return (item.operationUnitTypeLevelId == levelId && item.businessObjectId == businessObjectId);
                            });
                        }
                        if (!(node.parentAccess == app.constants.accessControlPermissionIdGet(permission) ||
                            (node.parentAccess == -1 && app.constants.accessControlPermissionIdGet(permission) == app.constants.accessControlPermissions.none))) {
                            $scope.addUserBusinessAccess({ accessDetails: { levelId: levelId, businessObjectId: businessObjectId, name: node.n, permission: permission } });
                        }
                        refreshTreeView();
                        $scope.setToEditMode(node);
                    };
                    $scope.setDefaultObject = function (node) {
                        var levelId = parseInt(node.id.split('-')[0]);
                        var businessObjectId = parseInt(node.id.split('-')[1]);
                        var businessObject = _.find($scope.userBusinessObjects, function (item) {
                            return (item.operationUnitTypeLevelId == levelId && item.businessObjectId == businessObjectId);
                        });
                        if (_.isUndefined(businessObject)) {
                            $scope.addUserBusinessAccess({ accessDetails: { levelId: levelId, businessObjectId: businessObjectId, name: node.n, permission: 'Full' } });
                            businessObject = _.find($scope.userBusinessObjects, function (item) {
                                return (item.operationUnitTypeLevelId == levelId && item.businessObjectId == businessObjectId);
                            });
                        }
                        _.forEach($scope.userBusinessObjects, function (userBusinessObject) {
                            userBusinessObject.isDefault = false;
                        });
                        businessObject.isDefault = true;
                        refreshTreeView();
                        $scope.setToEditMode(node);
                    };
                    function refreshTreeView() {
                        setAccessToNodes(treeViewWithRoot, 0, 1, "Undefined");
                        $scope.userBusinessObjects = _.sortBy($scope.userBusinessObjects, 'operationUnitTypeLevelId');
                        _.forEach($scope.userBusinessObjects, function (item) {
                            var permissionNode = app.web.utils.tree.findNodeById(treeViewWithRoot, item.operationUnitTypeLevelId + "-" + item.businessObjectId);
                            permissionNode.access = app.constants.accessControlPermissionIdGet(item._permission);
                            permissionNode.isDefault = item.isDefault;
                            setAccessToNodes(permissionNode, item.operationUnitTypeLevelId, item.businessObjectId, item._permission);
                        });
                    }
                    $scope.expand = function (node) {
                        node.exp = node.exp === 0 ? 1 : 0;
                    };
                    function getTreeViewData() {
                        var result = JSON.parse(appLocalStorage.treeViewDataGet());
                        app.web.utils.tree.removeEmptyNodes(result, 0, null);
                        if (env.shrinkTree === 'farmer') {
                            app.web.utils.tree.shrinkTreeFarmer(result);
                        }
                        else if (env.shrinkTree === 'all') {
                            app.web.utils.tree.shrinkTree(result);
                        }
                        treeViewWithRoot = result;
                        result.ch[0].exp = 1;
                        $scope.treeViewData = result.ch;
                        var defaultNode = app.web.utils.tree.findNodeById(treeViewWithRoot, navigationService.objectKey);
                        defaultNode.sel = 1;
                        $scope.selectedNode = defaultNode;
                        setAccessToNodes(treeViewWithRoot, 0, 1, "Undefined");
                        app.web.utils.tree.treeToArray(result, $scope.nodeList);
                    }
                    getTreeViewData();
                }
                TreePermissionDirectiveController.$inject = ['$scope', '$uibModal', 'navigationService', 'appLocalStorage', "ENV"];
                return TreePermissionDirectiveController;
            })();
            directives.TreePermissionDirectiveController = TreePermissionDirectiveController;
            var AvTreePermission = (function () {
                function AvTreePermission() {
                    this.restrict = 'E';
                    this.templateUrl = 'app.web/directives/tree/tree.permission.directive.tpl.html';
                    this.scope = {
                        userBusinessObjects: '=',
                        addUserBusinessAccess: '&',
                        control: '=',
                        customerId: '=',
                        isFullAccessRole: '='
                    };
                    this.controller = TreePermissionDirectiveController;
                }
                AvTreePermission.$inject = ['navigationService'];
                return AvTreePermission;
            })();
            directives.AvTreePermission = AvTreePermission;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvTreePermission', app.web.directives.AvTreePermission.$inject);

/// <reference path="../../_typings.web.ts" />
"use strict";
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var SelectorController = (function () {
                function SelectorController($scope, $element, $translate) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$element = $element;
                    this.$translate = $translate;
                    this.filter = $scope.filter;
                    this.toggleFilterChanged = $scope.toggleFilterChanged;
                    this.label = this.filter.label;
                    this.name = this.filter.name;
                    this.list = this.filter.list;
                    this.mode = (this.filter.isSingleSelect) ? "single" : "multiple";
                    this.translation = {
                        selectAll: $translate.instant("SelectAll"),
                        selectNone: $translate.instant("SelectNone"),
                        reset: $translate.instant("Reset"),
                        search: $translate.instant("Search..."),
                        nothingSelected: $translate.instant("All")
                    };
                    this.selectNone = function () {
                        _this.filter.selectedIds.length = 0;
                    };
                    //Watch for changes in filter drop downs and save to filter list
                    $scope.$watch("output", function (output, oldVal, scope) {
                        if (output) {
                            _this.setSelectedFilterData(_this.name, output);
                            if (scope.toggleFilterChanged && (JSON.stringify(_this.filter.selectedIds.sort()) !== JSON.stringify(_.map(oldVal, "id").sort()))) {
                                scope.toggleFilterChanged();
                            }
                        }
                    });
                }
                SelectorController.prototype.fixPosition = function () {
                    var content = this.$element.find('.checkboxLayer');
                    var offset = content.offset();
                    if (offset.left + content.width() > window.innerWidth) {
                        offset.left = window.innerWidth - content.width() - 10;
                        content.offset(offset);
                    }
                };
                SelectorController.prototype.setSelectedFilterData = function (filterName, output) {
                    var _this = this;
                    //clear selected    
                    this.filter.selectedIds.length = 0;
                    //set selected
                    if (output) {
                        angular.forEach(output, function (selectedFilterItem) {
                            _this.filter.selectedIds.push(selectedFilterItem.id);
                        });
                    }
                };
                SelectorController.$inject = ["$scope", "$element", "$translate"];
                return SelectorController;
            })();
            directives.SelectorController = SelectorController;
            var AvSelector = (function () {
                function AvSelector() {
                    this.restrict = "E";
                    this.templateUrl = "app.web/directives/selector/selector.tpl.html";
                    this.scope = {
                        filter: "=",
                        toggleFilterChanged: "&"
                    };
                    this.controller = SelectorController;
                    this.controllerAs = "selector";
                    // detect if new operator was used:
                    if (!(this instanceof AvSelector)) {
                        //create new instance of directive class:
                        return new (AvSelector.bind.apply(AvSelector, Array.prototype.concat.apply([null], arguments)));
                    }
                    return this;
                }
                AvSelector.$inject = ["$translate", "$rootScope"];
                return AvSelector;
            })();
            directives.AvSelector = AvSelector;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective("AvSelector", app.web.directives.AvSelector.$inject);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            // Class
            var Filter = (function () {
                function Filter(name, label, list, selectedIds, isLocked, isSingleSelect, isVisible, showLabel) {
                    if (isVisible === void 0) { isVisible = true; }
                    if (showLabel === void 0) { showLabel = true; }
                    this.name = name;
                    this.label = label;
                    this.list = list;
                    this.selectedIds = selectedIds;
                    this.isLocked = isLocked;
                    this.isSingleSelect = isSingleSelect;
                    this.isVisible = isVisible;
                    this.showLabel = showLabel;
                    this.blockCall = false;
                    this.name = name;
                    this.label = label;
                    this.list = list.slice(0);
                    this.masterCollection = list.slice(0);
                    this.selectedIds = selectedIds;
                    this.isLocked = isLocked;
                    this.isSingleSelect = isSingleSelect;
                    this.isVisible = isVisible;
                    this.showLabel = showLabel;
                    if (!app.common.utils.isNullOrUndefined(selectedIds) && selectedIds.length > 0) {
                        this.list.forEach(function (listItem) {
                            if (listItem["id"] && selectedIds.indexOf(listItem["id"]) > -1)
                                listItem["selected"] = true;
                        });
                    }
                }
                return Filter;
            })();
            directives.Filter = Filter;
            var FilterPanelController = (function () {
                function FilterPanelController($scope, $timeout, $element) {
                    var _this = this;
                    this.$timeout = $timeout;
                    this.$element = $element;
                    $scope.cascadingRules = $scope.cascadingRules || undefined;
                    $scope.toggleFilterChanged = $scope.toggleFilterChanged || undefined;
                    $scope.filterList = $scope.filterList || [];
                    $scope.useBreadcrumbs = true;
                    if ($scope.cascadingRules) {
                        $scope.$on(app.constants.broadcastEventNames.assessmentsFilter, function (value, parameter) {
                            $scope.levelId = parameter.levelId;
                            $scope.objectId = parameter.objectId;
                            _this.applyCascadingRules($scope);
                        });
                        this.applyCascadingRules($scope);
                    }
                    this.adjustFilter();
                    if ($scope.filterList.length > 0) {
                        var filterListLength = $scope.filterList.length;
                        $scope.quantityOfFiltersPerRow = Math.floor(filterListLength / 2);
                    }
                    else
                        $scope.quantityOfFiltersPerRow = 1;
                    $(window).resize(function () {
                        _this.adjustFilter();
                    });
                }
                FilterPanelController.prototype.adjustFilter = function () {
                    var _this = this;
                    this.$element.find("#splitFilter").css("float", "right");
                    this.$element.find(".selector-label").css('width', 'auto');
                    this.$timeout(function () {
                        if (_this.$element.width() > window.innerWidth - 350) {
                            _this.$element.find("#splitFilter").css("float", "none");
                            _this.$element.find(".selector-label").css('width', '');
                        }
                        else {
                            _this.$element.find("#splitFilter").css("float", "right");
                            _this.$element.find(".selector-label").css('width', 'auto');
                        }
                    }, 1);
                };
                FilterPanelController.prototype.applyCascadingRules = function ($scope) {
                    angular.forEach($scope.cascadingRules, function (rule) {
                        var parent = _.find($scope.filterList, function (filter) { return filter.name === rule.parent; });
                        var child = _.find($scope.filterList, function (filter) { return filter.name === rule.child; });
                        if (parent == null || child == null)
                            return;
                        if ($scope.useBreadcrumbs && $scope.levelId > 2 && parent.name == app.constants.assessmentProperties.customer) {
                            var clearedList2 = $scope.levelId === 7 ? _.filter(child.masterCollection, { id: $scope.objectId }) :
                                _.reject(child.masterCollection, function (childListItem) { return !_.includes([$scope.objectId], childListItem.foreginObject[$scope.levelId]); });
                            child.list.length = 0;
                            angular.forEach(clearedList2, function (item) {
                                child.list.push(item);
                            });
                        }
                        else if (parent.selectedIds.length > 0) {
                            var clearedList = _.reject(child.masterCollection, function (childListItem) { return !_.includes(parent.selectedIds, childListItem.foreignKey); });
                            child.list.length = 0;
                            angular.forEach(clearedList, function (item) {
                                child.list.push(item);
                            });
                        }
                        else if (parent.masterCollection.length != parent.list.length) {
                            var clearedList1 = _.reject(child.masterCollection, function (childListItem) { return !_.includes(_.map(parent.list, "id"), childListItem.foreignKey); });
                            child.list.length = 0;
                            angular.forEach(clearedList1, function (item) {
                                child.list.push(item);
                            });
                        }
                        else if (child.masterCollection.length != child.list.length) {
                            child.list.length = 0;
                            angular.forEach(child.masterCollection, function (item) {
                                child.list.push(item);
                            });
                        }
                    });
                };
                FilterPanelController.$inject = ['$scope', '$timeout', '$element'];
                return FilterPanelController;
            })();
            var AvFilterPanel = (function () {
                function AvFilterPanel() {
                    this.templateUrl = 'app.web/directives/filter_panel/filter.panel.directive.tpl.html';
                    this.restrict = 'E';
                    this.scope = {
                        filterList: '=',
                        cascadingRules: '=cascade',
                        toggleFilterChanged: '&'
                    };
                    this.controller = FilterPanelController;
                    // detect if new operator was used:
                    if (!(this instanceof AvFilterPanel)) {
                        //create new instance of directive class:
                        return new (AvFilterPanel.bind.apply(AvFilterPanel, Array.prototype.concat.apply([null], arguments)));
                    }
                    return this;
                }
                AvFilterPanel.$inject = [];
                return AvFilterPanel;
            })();
            directives.AvFilterPanel = AvFilterPanel;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvFilterPanel', app.web.directives.AvFilterPanel.$inject);

var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            angular.module('app.web.directives').directive('avFallBack', ['$window', function ($window) {
                    return {
                        restrict: 'EA',
                        scope: {
                            fallbackSrc: '@'
                        },
                        link: function (scope, element, attrs) {
                            element.bind('error', function () {
                                angular.element(this).attr("href", scope.fallbackSrc);
                            });
                        }
                    };
                }]);
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var DatepickerSingleController = (function () {
                function DatepickerSingleController($rootScope, $scope, $locale, $element, $timeout) {
                    $scope.allowFutureDates = $scope.allowFutureDates == undefined ? false : $scope.allowFutureDates;
                    $scope.allowPastDates = $scope.allowPastDates == undefined ? true : $scope.allowPastDates;
                    $scope.appendToBody = $scope.appendToBody == undefined ? true : $scope.appendToBody;
                    $scope.opened = false;
                    $scope.format = $locale.DATETIME_FORMATS["shortDate"];
                    if (!$scope.allowFutureDates) {
                        $scope.maxDate = new Date();
                    }
                    if (!$scope.allowPastDates) {
                        $scope.minDate = new Date();
                    }
                    $scope.dateOptions = {
                        showWeeks: true,
                        startingDay: 1
                    };
                    var selectedDate = $scope.selectedDate == undefined ? null : moment($scope.selectedDate).toDate();
                    $scope.selectedDate = selectedDate;
                    $scope.open = function ($event) {
                        if ($scope.ngDisabled)
                            return;
                        $scope.opened = true;
                    };
                    $scope.openOnEnter = function ($event) {
                        if ($event.keyCode === 13 && !$scope.ngDisabled)
                            $scope.opened = true;
                    };
                    $scope.element = $element;
                    $scope.$watch('opened', function (newValue, oldValue, scope) {
                        if (!newValue && newValue !== oldValue) {
                            scope.element.focus();
                        }
                    });
                    $element.on('keydown', function ($event) {
                        if ($event.keyCode === 13 && !$scope.ngDisabled) {
                            $element.find('input').focus();
                            $timeout(function () {
                                $scope.opened = true;
                            }, 10);
                        }
                    });
                }
                DatepickerSingleController.$inject = ['$rootScope', '$scope', '$locale', '$element', '$timeout'];
                return DatepickerSingleController;
            })();
            directives.DatepickerSingleController = DatepickerSingleController;
            var AvDatepickerSingle = (function () {
                function AvDatepickerSingle() {
                    this.restrict = 'E';
                    this.templateUrl = 'app.web/directives/datepicker-single/datepicker-single.directive.tpl.html';
                    this.link = this.linkFunction;
                    this.scope = {
                        selectedDate: '=',
                        required: '=?',
                        allowFutureDates: '=?',
                        allowPastDates: '=?',
                        inputClass: '=?',
                        selectionChange: '&',
                        appendToBody: '=?',
                        ngDisabled: '=?'
                    };
                    this.controller = DatepickerSingleController;
                }
                AvDatepickerSingle.prototype.linkFunction = function (scope, element, attrs) {
                };
                AvDatepickerSingle.$inject = ['$rootScope'];
                return AvDatepickerSingle;
            })();
            directives.AvDatepickerSingle = AvDatepickerSingle;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvDatepickerSingle', app.web.directives.AvDatepickerSingle.$inject);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var DatepickerRangeDirectiveController = (function () {
                function DatepickerRangeDirectiveController($rootScope, $scope, $locale) {
                    $scope.allowFutureDates = $scope.allowFutureDates == undefined ? false : $scope.allowFutureDates;
                    $scope.allowPastDates = $scope.allowPastDates == undefined ? true : $scope.allowPastDates;
                    $scope.opens = $scope.opens == undefined ? 'left' : $scope.opens;
                    var maxDate = undefined;
                    if (!$scope.allowFutureDates) {
                        maxDate = new Date();
                    }
                    if (!$scope.allowPastDates && $scope.minDate == null) {
                        $scope.minDate = new Date().toString();
                    }
                    if ($scope.minDate != null) {
                        $scope.minDate = new Date($scope.minDate).toString();
                    }
                    var format = $locale.DATETIME_FORMATS["shortDate"].toUpperCase();
                    if ((format.match(/Y/g) || []).length === 3)
                        format = format.replace("YYY", "YYYY");
                    else if ((format.match(/Y/g) || []).length === 2)
                        format = format.replace("YY", "YYYY");
                    else if ((format.match(/Y/g) || []).length === 1)
                        format = format.replace("Y", "YYYY");
                    var ranges = $scope.presetRanges ? $scope.presetRanges : [];
                    if (!$scope.presetRanges) {
                        var minDate;
                        if ($scope.minDate != undefined) {
                            minDate = moment($scope.minDate, "yyyy-MM-dd");
                        }
                        if ($scope.minDate == undefined || minDate <= moment().startOf('month')) {
                            ranges[app.localizer.resource.ThisMonth] = [moment().startOf('month'), moment().endOf('month')];
                        }
                        if ($scope.minDate == undefined || minDate <= moment().subtract(29, 'days')) {
                            ranges[app.localizer.resource.Last30Days] = [moment().subtract(29, 'days'), moment()];
                        }
                        if ($scope.minDate == undefined || minDate <= moment().subtract(1, 'year')) {
                            ranges[app.localizer.resource.LastYear] = [moment().subtract(1, 'year'), moment()];
                        }
                    }
                    $scope.dateOptions = {
                        showWeekNumbers: true,
                        format: format,
                        locale: {
                            applyLabel: app.localizer.resource.Apply,
                            cancelLabel: app.localizer.resource.Cancel,
                            fromLabel: app.localizer.resource.From,
                            toLabel: app.localizer.resource.To,
                            customRangeLabel: app.localizer.resource.CustomRange,
                            weekLabel: '',
                            firstDay: 1,
                            daysOfWeek: $locale.DATETIME_FORMATS["SHORTDAY"],
                            monthNames: $locale.DATETIME_FORMATS["MONTH"]
                        },
                        maxDate: maxDate,
                        opens: $scope.opens,
                        eventHandlers: {
                            'apply.daterangepicker': $scope.onApplyDaterangepicker
                        }
                    };
                    if (ranges != null && Object.keys(ranges).length > 0)
                        $scope.dateOptions.ranges = ranges;
                }
                DatepickerRangeDirectiveController.$inject = ['$rootScope', '$scope', '$locale'];
                return DatepickerRangeDirectiveController;
            })();
            var AvDatepickerRange = (function () {
                function AvDatepickerRange() {
                    this.restrict = 'E';
                    this.templateUrl = 'app.web/directives/datepicker-range/datepicker-range.directive.tpl.html';
                    this.link = this.linkFunction;
                    this.scope = {
                        selectedDateRange: '=',
                        required: '=?',
                        minDate: '=?',
                        allowFutureDates: '=?',
                        allowPastDates: '=?',
                        inputClass: '=?',
                        selectionChange: '&',
                        presetRanges: '=?',
                        opens: '=?',
                        onApplyDaterangepicker: '&'
                    };
                    this.controller = DatepickerRangeDirectiveController;
                    // detect if new operator was used:
                    if (!(this instanceof AvDatepickerRange)) {
                        //create new instance of directive class:
                        return new (AvDatepickerRange.bind.apply(AvDatepickerRange, Array.prototype.concat.apply([null], arguments)));
                    }
                    return this;
                }
                AvDatepickerRange.prototype.linkFunction = function (scope, element, attrs) {
                    element.children("span").on("click", function () {
                        element.children('input').focus();
                    });
                    element.children("div").on("click", function () {
                        element.children('input').focus();
                    });
                };
                AvDatepickerRange.$inject = ['$rootScope'];
                return AvDatepickerRange;
            })();
            directives.AvDatepickerRange = AvDatepickerRange;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvDatepickerRange', app.web.directives.AvDatepickerRange.$inject);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var ConfirmDirectiveController = (function () {
                function ConfirmDirectiveController($scope, modalService) {
                    this.$scope = $scope;
                    this.modalService = modalService;
                }
                ConfirmDirectiveController.prototype.showModal = function () {
                    return this.modalService.showConfirm('modules/confirm/confirm.html', app.constants.dialogSize.extraSmall, '', this.$scope, function () { }, new web.services.ConfirmationData(this.$scope.confirmParameter, this.$scope.confirmTitle, this.$scope.confirmMessage, false));
                };
                ConfirmDirectiveController.$inject = ['$scope', 'modalService'];
                return ConfirmDirectiveController;
            })();
            directives.ConfirmDirectiveController = ConfirmDirectiveController;
            var AvConfirm = (function () {
                function AvConfirm() {
                    this.link = this.linkFunction;
                    this.priority = 1;
                    this.restrict = 'A';
                    this.scope = {
                        confirmIf: "=",
                        avConfirm: '&',
                        ngClick: '&',
                        confirmTitle: '@',
                        confirmMessage: '@',
                        confirmParameter: "="
                    };
                    this.controller = ConfirmDirectiveController;
                    //detect if new operator was used:
                    if (!(this instanceof AvConfirm)) {
                        //create new instance of directive class:
                        return new (AvConfirm.bind.apply(AvConfirm, Array.prototype.concat.apply([null], arguments)));
                    }
                    this.link = this.linkFunction;
                    return this;
                }
                AvConfirm.prototype.linkFunction = function (scope, element, attrs, controller) {
                    function reBind(func) {
                        element.unbind("click").bind("click", function () {
                            func();
                        });
                    }
                    function bindConfirm() {
                        controller.showModal().then(function (result) {
                            if (result)
                                scope.ngClick();
                        });
                    }
                    if ('confirmIf' in attrs) {
                        scope.$watch('confirmIf', function (newVal) {
                            if (newVal) {
                                reBind(bindConfirm);
                            }
                            else {
                                reBind(function () {
                                    scope.$apply(scope.ngClick);
                                });
                            }
                        });
                    }
                    else {
                        reBind(bindConfirm);
                    }
                };
                AvConfirm.$inject = ['modalService'];
                return AvConfirm;
            })();
            directives.AvConfirm = AvConfirm;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvConfirm', app.web.directives.AvConfirm.$inject);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            angular.module('app.web.directives').directive('avSelectorSingle', ['$compile', function ($compile) {
                    return {
                        restrict: 'E',
                        scope: {
                            ngModel: '=',
                            options: '=',
                            callback: '&',
                            valueField: '=',
                            textField: '=',
                            selectedValue: '=',
                            defaultText: '=?',
                            emptyListText: '=?',
                            ngDisabled: '=?',
                            setTabindex: '@',
                            confirmIf: '=?',
                            confirmTitle: '@',
                            confirmMessage: '@',
                            ngStyleObject: '='
                        },
                        link: function (scope, element, attrs) {
                            scope.defaultText = scope.defaultText || 'Select';
                            scope.emptyListText = scope.emptyListText || 'Message_No_Data';
                            scope.setTabindex = scope.setTabindex || -1;
                            var buttonTextPlaceholder = element.find("placeholder");
                            buttonTextPlaceholder.replaceWith($compile('<span ng-attr-title="{{ ' + 'ngModel.' + scope.textField + '|| defaultText | translate}}" ng-if="options != undefined && options.length > 0">{{ ' + 'ngModel.' + scope.textField + '|| defaultText | translate}}</span>')(scope));
                            var setNgModel = function () {
                                if (scope.valueField !== undefined && scope.selectedValue !== undefined && scope.options !== undefined) {
                                    for (var i = 0; i < scope.options.length; i++) {
                                        //console.log(scope.options[i][scope.valueField]);
                                        if (scope.options[i][scope.valueField] == scope.selectedValue) {
                                            scope.ngModel = scope.options[i];
                                        }
                                    }
                                }
                            };
                            scope.readonly = scope.ngDisabled;
                            scope.$watchCollection("options", function (collection) {
                                if (!scope.readonly) {
                                    if (collection !== undefined && collection.length > 0) {
                                        scope.ngDisabled = false;
                                    }
                                    else {
                                        scope.ngDisabled = true;
                                    }
                                }
                                setNgModel();
                            });
                            //find item from selectedValue
                            if (scope.valueField !== undefined && scope.selectedValue !== undefined && scope.options !== undefined) {
                                scope.$watch('selectedValue', function () {
                                    setNgModel();
                                }, true);
                            }
                            //selection changed handler
                            scope.select = function (option) {
                                scope.ngModel = option;
                                if (scope.valueField !== undefined) {
                                    scope.selectedValue = option[scope.valueField];
                                }
                                if (scope.callback) {
                                    scope.callback({ option: option });
                                }
                                element.find('button').focus();
                            };
                        },
                        templateUrl: 'app.web/directives/selector-single/selector.single.tpl.html'
                    };
                }]);
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            angular.module('app.web.directives').directive('avScreenResize', ['$window', function ($window) {
                    return function (scope, element) {
                        var w = angular.element($window);
                        scope.getWindowDimensions = function () {
                            return { 'h': w.height(), 'w': w.width() };
                        };
                        scope.$watch(scope.getWindowDimensions, function (newValue, oldValue) {
                            scope.windowHeight = newValue.h;
                            scope.windowWidth = newValue.w;
                            scope.style = function (customMargin) {
                                var margin = customMargin ? customMargin : 200;
                                return {
                                    'height': (newValue.h - margin) + 'px',
                                };
                            };
                        }, true);
                        w.bind('resize', function () {
                            scope.$apply();
                        });
                    };
                }]);
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            angular.module('app.web.directives').directive('avElementResize', ['$window', function ($window) {
                    return function (scope, element, attrs) {
                        var autoresize = attrs.avElementResize !== "true";
                        if (autoresize) {
                            var w = angular.element($window);
                            scope.getWindowDimensions = function () {
                                return { 'h': w.height(), 'w': w.width(), 'error': scope.showWarning };
                            };
                            scope.$watch(scope.getWindowDimensions, function (newValue, oldValue) {
                                scope.windowHeight = newValue.error ? newValue.h : newValue.h - 100;
                                scope.windowWidth = newValue.w;
                                scope.style = function (bottomMargin, selected, hasError) {
                                    if (selected === void 0) { selected = false; }
                                    if (hasError === void 0) { hasError = false; }
                                    var margin = hasError ? 260 : 200;
                                    return {
                                        'height': selected ? (newValue.h - margin - bottomMargin) + 'px' : '0px'
                                    };
                                };
                            }, true);
                            w.bind('resize', function () {
                                scope.$apply();
                            });
                        }
                    };
                }]);
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var Followup = (function () {
                function Followup() {
                    this.link = this.linkFunction;
                    this.restrict = 'EA';
                    this.scope = {
                        followUpStatus: "="
                    };
                    this.template = "<span class='label label-followup-needed' ng-if='followUpStatus==3'>{{'FollowUpNeededShort' | translate}}</span>" +
                        "<span ng-if='followUpStatus==2' class='label label-followup-recommended '>{{'FollowUpRecommendedShort' | translate}}</span>" +
                        "<span ng-if='followUpStatus==1' class='label label-followup-notneeded '>{{'NoFollowUpShort' | translate}}</span>";
                    if (!(this instanceof Followup)) {
                        return new (Followup.bind.apply(directives.AvConfirm, Array.prototype.concat.apply([null], arguments)));
                    }
                    this.link = this.linkFunction;
                    return this;
                }
                Followup.prototype.linkFunction = function (scope, element, attrs) {
                };
                return Followup;
            })();
            directives.Followup = Followup;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('Followup', []);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var AvAccessControlDirectiveController = (function () {
                function AvAccessControlDirectiveController($scope) {
                }
                AvAccessControlDirectiveController.$inject = ['$scope'];
                return AvAccessControlDirectiveController;
            })();
            directives.AvAccessControlDirectiveController = AvAccessControlDirectiveController;
            var AvAccessControl = (function () {
                function AvAccessControl() {
                    //public templateUrl = 'directives/assessment_list/assessment.list.directive.html';
                    this.restrict = 'A';
                    //public scope = {                               
                    //};
                    this.controller = directives.AssessmentListDirectiveController;
                }
                AvAccessControl.prototype.link = function (scope, element, attrs) {
                    // The Idea is to remove or disable controls depending on the user permisson. 
                    // right now we do all of it in the server side. 
                    //element.remove();
                };
                return AvAccessControl;
            })();
            directives.AvAccessControl = AvAccessControl;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvAccessControl', []);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var AvSaveOrCancel = (function () {
                function AvSaveOrCancel() {
                    this.restrict = 'E';
                    this.templateUrl = 'app.web/directives/save-or-cancel/save.or.cancel.directive.tpl.html';
                    this.scope = {
                        save: '&',
                        saveText: '@?',
                        close: '&',
                        closeText: '=?',
                        confirmOnClose: '=?'
                    };
                }
                AvSaveOrCancel.$inject = ['$rootScope'];
                return AvSaveOrCancel;
            })();
            directives.AvSaveOrCancel = AvSaveOrCancel;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvSaveOrCancel', app.web.directives.AvSaveOrCancel.$inject);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var AvUserPermissionDirectiveController = (function () {
                function AvUserPermissionDirectiveController($rootScope, $scope, modalService) {
                    var _this = this;
                    this.$scope = $scope;
                    this.modalService = modalService;
                    $scope.addPermission = function (level) {
                        _this.modalService.showConfirm('app.web/directives/user-permission/user.add.permission.tpl.html', app.constants.dialogSize.small, '', _this.$scope, function () { }, new web.services.UserBusinessObjectPermissionData(level, null, $scope.role, $scope.customerId, null, $scope.userBusinessObjects)).then(function (permissionObject) {
                            $scope.addUserBusinessObjects({
                                levelId: permissionObject.levelId,
                                objectId: permissionObject.objectId,
                                object: permissionObject.object,
                                bitMask: permissionObject.bitmask,
                                permission: permissionObject.permission,
                                customerId: $scope.customerId,
                                description: permissionObject.description
                            });
                        });
                    };
                    $scope.setDefault = function (currentUserBusinessObject) {
                        _.forEach($scope.userBusinessObjects, function (userBusinessObject) {
                            userBusinessObject.isDefault = false;
                        });
                        currentUserBusinessObject.isDefault = true;
                    };
                    $scope.delete = function (currentUserBusinessObject) {
                        currentUserBusinessObject.entityAspect.setDeleted();
                        _.remove($scope.userBusinessObjects, function (userBusinessObject) {
                            return userBusinessObject.userBusinessObjectId === currentUserBusinessObject.userBusinessObjectId;
                        });
                        $scope.objectDeleted();
                    };
                }
                AvUserPermissionDirectiveController.$inject = ['$rootScope', '$scope', 'modalService'];
                return AvUserPermissionDirectiveController;
            })();
            var AvUserPermission = (function () {
                function AvUserPermission() {
                    this.templateUrl = 'app.web/directives/user-permission/user.permission.directive.tpl.html';
                    this.restrict = 'E';
                    this.scope = {
                        userBusinessObjects: '=',
                        addUserBusinessObjects: '&',
                        addUserBusinessAccess: '&',
                        openPermissionTree: '&',
                        objectDeleted: '&',
                        role: '=',
                        customerId: '=',
                        isCustomerMode: '=',
                        isFullAccessRole: '='
                    };
                    this.controller = AvUserPermissionDirectiveController;
                }
                AvUserPermission.prototype.link = function (scope, element, attrs) {
                    // The Idea is to remove or disable controls depending on the user permisson. 
                    // right now we do all of it in the server side. 
                    //element.remove();
                };
                AvUserPermission.$inject = ['$rootScope', 'modalService'];
                return AvUserPermission;
            })();
            directives.AvUserPermission = AvUserPermission;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvUserPermission', app.web.directives.AvUserPermission.$inject);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var ValidationTooltipDirectiveController = (function () {
                function ValidationTooltipDirectiveController($scope, $compile, $uibTooltip) {
                    this.$scope = $scope;
                    this.$compile = $compile;
                    this.$uibTooltip = $uibTooltip;
                }
                ValidationTooltipDirectiveController.prototype.addTooltip = function (element, message, enabled, placement) {
                    if (placement === void 0) { placement = "right"; }
                    $(element)
                        .attr('uib-tooltip', "{{" + message + "}}")
                        .attr('tooltip-placement', placement)
                        .attr('tooltip-trigger', "mouseenter")
                        .attr('tooltip-enable', "{{" + enabled + "}}");
                    this.$compile(element)(this.$scope);
                };
                ValidationTooltipDirectiveController.$inject = ['$scope', '$compile', '$uibTooltip'];
                return ValidationTooltipDirectiveController;
            })();
            directives.ValidationTooltipDirectiveController = ValidationTooltipDirectiveController;
            var AvValidationTooltip = (function () {
                function AvValidationTooltip() {
                    this.link = this.linkFunction;
                    this.priority = 10001;
                    this.restrict = 'A';
                    this.scope = false;
                    this.controller = ValidationTooltipDirectiveController;
                    //detect if new operator was used:
                    if (!(this instanceof AvValidationTooltip)) {
                        //create new instance of directive class:
                        return new (AvValidationTooltip.bind.apply(AvValidationTooltip, Array.prototype.concat.apply([null], arguments)));
                    }
                    this.link = this.linkFunction;
                    return this;
                }
                AvValidationTooltip.prototype.linkFunction = function (scope, element, attrs, controller) {
                    if (element.attr("uib-tooltip")) {
                        return;
                    }
                    controller.addTooltip(element, attrs.avValidationTooltip, attrs.avValidationTooltipEnabled, attrs.avValidationTooltipPlacement);
                };
                AvValidationTooltip.$inject = ['$uibTooltip'];
                return AvValidationTooltip;
            })();
            directives.AvValidationTooltip = AvValidationTooltip;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvValidationTooltip', app.web.directives.AvValidationTooltip.$inject);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var AvTimelineDirectiveController = (function () {
                function AvTimelineDirectiveController($scope, $locale) {
                    this.monthNames = [];
                    this.displayYears = [];
                    this.todayIndicatorPosition = 0;
                    this.monthlyWidth = 400;
                    var datetime = $locale.DATETIME_FORMATS;
                    this.monthNames = datetime.MONTH;
                    this.initialize($scope);
                }
                AvTimelineDirectiveController.prototype.initialize = function ($scope) {
                    var _this = this;
                    $scope.$watch('groups', function () {
                        //remove all previous tooltips
                        var tooltipHolder = document.getElementById("tooltipHolder");
                        tooltipHolder.innerHTML = '';
                        var currentYear = new Date().getFullYear();
                        var currentMonth = new Date().getMonth();
                        $scope.todayIndicatorPosition = new Date().getMonth() * _this.monthlyWidth + new Date().getDate() * (_this.monthlyWidth / 30);
                        $scope.timelineSpliterPosition = (new Date().getMonth() + 1) * _this.monthlyWidth;
                        var past = [];
                        _.forEach(_.range($scope.fromYear ? $scope.fromYear : currentYear - 1, currentYear), function (year) {
                            var monthNo = 0;
                            //add all past months in last year
                            _.forEach(_this.monthNames, function (month, index) {
                                {
                                    $scope.todayIndicatorPosition += _this.monthlyWidth;
                                    $scope.timelineSpliterPosition += _this.monthlyWidth;
                                    past.push({ year: year, month: index, text: month + ' ' + year, currentMonth: false, width: _this.monthlyWidth });
                                }
                            });
                        });
                        var future = [];
                        _.forEach(_.range(currentYear, currentYear + 2), function (year) {
                            var monthNo = 0;
                            _.forEach(_this.monthNames, function (month, index) {
                                //add all past months in current year
                                if (currentYear === year && currentMonth == index) {
                                    past.push({ year: currentYear, month: (index), text: month + ' ' + currentYear, currentMonth: true, width: new Date().getDate() * (_this.monthlyWidth / 30) });
                                    future.push({ year: year, month: (index), text: month + ' ' + year, currentMonth: true, width: _this.monthlyWidth - new Date().getDate() * (_this.monthlyWidth / 30) });
                                }
                                else if (currentYear === year && currentMonth > index) {
                                    past.push({ year: currentYear, month: (index), text: month + ' ' + currentYear, currentMonth: false, width: _this.monthlyWidth });
                                }
                                else if (currentYear === year && currentMonth < index) {
                                    future.push({ year: year, month: (index), text: month + ' ' + year, currentMonth: false, width: _this.monthlyWidth });
                                }
                                else if (currentYear < year && currentMonth >= index) {
                                    future.push({ year: year, month: (index), text: month + ' ' + year, currentMonth: false, width: _this.monthlyWidth });
                                }
                            });
                        });
                        $scope.svgHeight = ($scope.groups.length + 2) * 300;
                        $scope.displayYears = [past, future];
                        $scope.monthlyWidth = 400;
                        $scope.spaceBetweenGroups = 300;
                    });
                };
                AvTimelineDirectiveController.$inject = ['$scope', '$locale'];
                return AvTimelineDirectiveController;
            })();
            directives.AvTimelineDirectiveController = AvTimelineDirectiveController;
            var AvTimeline = (function () {
                function AvTimeline() {
                    this.templateUrl = 'app.web/directives/timeline/timeline.directive.tpl.html';
                    this.restrict = 'EA';
                    this.scope = {
                        fromYear: '=',
                        groups: '='
                    };
                    this.controller = AvTimelineDirectiveController;
                }
                AvTimeline.prototype.link = function (scope, element, attrs) {
                    //angular.element(document.querySelector('#content')).on('scroll', function () {
                    //    angular.element(document.querySelector('#header')).scrollLeft($(this).scrollLeft());
                    //});
                    scope.$watch('groups', function () {
                        element.parents().each(function (parent) {
                            $(this).animate({ 'scrollLeft': scope.todayIndicatorPosition - (element[0].parentElement.clientWidth / 2) }, 10);
                        });
                    });
                };
                return AvTimeline;
            })();
            directives.AvTimeline = AvTimeline;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvTimeline', ['$translate']);

'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var AvTimelineTodayDirectiveController = (function () {
                function AvTimelineTodayDirectiveController($scope) {
                    $scope.width = 100;
                    $scope.height = 15;
                    $scope.y = 15;
                    $scope.radius = 10;
                    $scope.content = new Date();
                }
                AvTimelineTodayDirectiveController.$inject = ['$scope'];
                return AvTimelineTodayDirectiveController;
            })();
            directives.AvTimelineTodayDirectiveController = AvTimelineTodayDirectiveController;
            var AvTimelineToday = (function () {
                function AvTimelineToday() {
                    this.templateUrl = 'app.web/directives/timeline/timeline.today.directive.tpl.html';
                    this.restrict = 'EA';
                    this.scope = {
                        x: '='
                    };
                    this.controller = AvTimelineTodayDirectiveController;
                }
                AvTimelineToday.prototype.link = function (scope, element, attrs) {
                    //scope.x = element.width() / 2;
                };
                return AvTimelineToday;
            })();
            directives.AvTimelineToday = AvTimelineToday;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvTimelineToday', []);

'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var AvTimelineGroupDirectiveController = (function () {
                function AvTimelineGroupDirectiveController($scope, $timeout) {
                    this.$timeout = $timeout;
                    $scope.height = 15;
                    $scope.y = 15;
                    $scope.togglePast = function (group) {
                        group.tooltipPastVisibility = !group.showPast;
                        $timeout(function () {
                            group.showPast = !group.showPast;
                        });
                    };
                    $scope.toggleFuture = function (group) {
                        group.tooltipFutureVisibility = !group.showFuture;
                        $timeout(function () {
                            group.showFuture = !group.showFuture;
                        });
                    };
                    $scope.dateMargin = function () {
                        return new Date().getDate() * (400 / 30);
                    };
                }
                AvTimelineGroupDirectiveController.$inject = ['$scope', '$timeout'];
                return AvTimelineGroupDirectiveController;
            })();
            directives.AvTimelineGroupDirectiveController = AvTimelineGroupDirectiveController;
            var AvTimelineGroup = (function () {
                function AvTimelineGroup() {
                    this.templateUrl = 'app.web/directives/timeline/timeline.group.directive.tpl.html';
                    this.templateNamespace = 'svg';
                    this.restrict = 'EA';
                    this.scope = {
                        timelineSpliterPosition: '=',
                        todayIndicatorPosition: '=',
                        groups: '=',
                        displayYears: '=',
                        svgHeight: '=',
                        spaceBetweenGroups: '='
                    };
                    this.controller = AvTimelineGroupDirectiveController;
                }
                AvTimelineGroup.prototype.link = function (scope, element, attrs) {
                    element.width(400 * 24);
                };
                return AvTimelineGroup;
            })();
            directives.AvTimelineGroup = AvTimelineGroup;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvTimelineGroup', []);

'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var AvTimelineMarkerDirectiveController = (function () {
                function AvTimelineMarkerDirectiveController($scope) {
                    var _this = this;
                    this.markerYOffset = 20;
                    $scope.getX = this.getX;
                    $scope.getY = this.getY;
                    $scope.getMarkerYOffset = function (parentIndex, index, markers) { return _this.getMarkerYOffset(parentIndex, index, markers); };
                    $scope.showMarker = function (year, month, date) { return _this.showMarker($scope, year, month, date); };
                    $scope.tooltipX = 0;
                    $scope.tooltipY = 0;
                    $scope.tooltipData;
                    $scope.tooltipType;
                    $scope.showTooltip = function (activity, x, y) {
                        $scope.tooltipX = x;
                        $scope.tooltipY = y;
                        $scope.tooltipData = activity.details;
                        $scope.tooltipType = activity.markType;
                        var tooltip = document.getElementById($scope.tooltipId);
                        var tooltipHolder = document.getElementById("tooltipHolder");
                        tooltipHolder.appendChild(tooltip);
                        //console.log(result);
                    };
                    $scope.moveToFront = function (elem) {
                        return this.parentNode.appendChild(this);
                    };
                    //hide tooltip
                    $scope.$watch('tooltipPastVisibility', function () {
                        if (!$scope.tooltipPastVisibility)
                            $scope.tooltipX = 0;
                    });
                    $scope.$watch('tooltipFutureVisibility', function () {
                        if (!$scope.tooltipFutureVisibility)
                            $scope.tooltipX = 0;
                    });
                }
                AvTimelineMarkerDirectiveController.prototype.getX = function (refX, date, offset) {
                    return parseInt(refX) + new Date(date).getDate() * (400 / 30) + offset;
                };
                AvTimelineMarkerDirectiveController.prototype.getY = function (refY, offset) {
                    return parseInt(refY) + offset;
                };
                AvTimelineMarkerDirectiveController.prototype.showMarker = function ($scope, year, month, date) {
                    return year == new Date(date).getFullYear() && month == new Date(date).getMonth() && ((!$scope.future && new Date(date) <= new Date()) || ($scope.future && new Date(date) > new Date()));
                };
                AvTimelineMarkerDirectiveController.prototype.getMarkerYOffset = function (parentIndex, index, markers) {
                    var _this = this;
                    //this.markerYOffset = this.markerYOffset + (parentIndex*10);
                    var offset = 0;
                    _.forEach(markers, function (marker) {
                        if (marker.date < markers[parentIndex].date && _this.isSameMonth(marker.date, markers[parentIndex].date)) {
                            offset = offset + marker.activities.length * 15;
                        }
                    });
                    return this.markerYOffset + offset;
                };
                AvTimelineMarkerDirectiveController.prototype.isSameMonth = function (date1, date2) {
                    return new Date(date1).getMonth() == new Date(date2).getMonth();
                };
                AvTimelineMarkerDirectiveController.prototype.getDate = function (date) {
                    return new Date(date).getDate();
                };
                AvTimelineMarkerDirectiveController.$inject = ['$scope'];
                return AvTimelineMarkerDirectiveController;
            })();
            directives.AvTimelineMarkerDirectiveController = AvTimelineMarkerDirectiveController;
            var AvTimelineMarker = (function () {
                function AvTimelineMarker() {
                    this.templateUrl = 'app.web/directives/timeline/timeline.marker.directive.tpl.html';
                    this.templateNamespace = 'svg';
                    this.replace = true;
                    this.restrict = 'A';
                    this.scope = {
                        refX: '@',
                        refY: '@',
                        year: '=',
                        month: '=',
                        markers: '=',
                        future: '=',
                        tooltipId: '@',
                        tooltipPastVisibility: '=',
                        tooltipFutureVisibility: '='
                    };
                    this.controller = AvTimelineMarkerDirectiveController;
                }
                AvTimelineMarker.prototype.link = function (scope, element, attrs) {
                    //scope.x = element.width() / 2;
                };
                return AvTimelineMarker;
            })();
            directives.AvTimelineMarker = AvTimelineMarker;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvTimelineMarker', []);

"use strict";
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var AvTimelineTooltipDirectiveController = (function () {
                function AvTimelineTooltipDirectiveController($scope, modalService, assessmentDatacontext) {
                    var _this = this;
                    this.$scope = $scope;
                    this.modalService = modalService;
                    this.assessmentDatacontext = assessmentDatacontext;
                    $scope.width = 400;
                    $scope.height = 145;
                    $scope.headerHeight = 20;
                    $scope.showReport = function (id) {
                        return _this.showReport(id);
                    };
                }
                AvTimelineTooltipDirectiveController.prototype.showReport = function (assessment) {
                    var _this = this;
                    var generateNewReport = assessment.isLocked ? false : true;
                    if (assessment.isLocked) {
                        this.assessmentDatacontext
                            .getAuditDtos("Assessment", assessment.id, [4])
                            .then(function (lockedAudits) {
                            var auditId = null;
                            if (assessment.isLocked && lockedAudits.length > 0) {
                                auditId = lockedAudits[0].auditId;
                            }
                            _this.modalService.show("modules/report/report.html", app.constants.dialogSize.large, "", _this.$scope, function () { }, new web.services.ReportData(assessment.id, app.enums.entityType.Assessment, "", generateNewReport, auditId.toString(), auditId));
                        });
                    }
                    else
                        this.modalService.show("modules/report/report.html", app.constants.dialogSize.large, "", this.$scope, function () { }, new web.services.ReportData(assessment.id, app.enums.entityType.Assessment, "", generateNewReport));
                };
                AvTimelineTooltipDirectiveController.$inject = [
                    "$scope",
                    "modalService",
                    "assessmentDatacontext"
                ];
                return AvTimelineTooltipDirectiveController;
            })();
            directives.AvTimelineTooltipDirectiveController = AvTimelineTooltipDirectiveController;
            var AvTimelineTooltip = (function () {
                function AvTimelineTooltip() {
                    this.templateUrl = "app.web/directives/timeline/timeline.tooltip.directive.tpl.html";
                    this.templateNamespace = "svg";
                    this.restrict = "A";
                    this.replace = true;
                    this.scope = {
                        tooltipData: "=",
                        tooltipType: "=",
                        tooltipX: "=",
                        tooltipY: "="
                    };
                    this.controller = AvTimelineTooltipDirectiveController;
                }
                AvTimelineTooltip.prototype.link = function (scope, element, attrs) {
                    //scope.x = element.width() / 2;
                };
                return AvTimelineTooltip;
            })();
            directives.AvTimelineTooltip = AvTimelineTooltip;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective("AvTimelineTooltip", []);

/// <reference path="../../_typings.web.ts" />
'use strict';
var app;
(function (app) {
    var web;
    (function (web) {
        var directives;
        (function (directives) {
            var InputControlTextController = (function () {
                function InputControlTextController($rootScope, $scope, $locale, $element, $timeout) {
                    $scope.feedbackPosition = $scope.feedbackPosition || 'after';
                    if (!$scope.labelTranslationKey) {
                        var entityName = $element[0].attributes['ng-model'].value.match(/[^.]+$/)[0];
                        $scope.labelTranslationKey = entityName.replace('Data', '').capitalize() + "_" + $scope.ngModelProperty.capitalize();
                    }
                    $scope.$watch('ngModel', function () {
                        if ($scope.ngModel != undefined) {
                            if (typeof $scope.ngModel.isRequired === "function")
                                $scope.isRequired = $scope.ngModel.isRequired($scope.ngModelProperty);
                        }
                    });
                    $scope.$watch('showValidation', function () {
                        checkValidation();
                    });
                    $scope.textChanged = function () {
                        checkValidation();
                    };
                    function checkValidation() {
                        $scope.hasError = false;
                        if ($scope.showValidation) {
                            var property = $scope.validateProperty != undefined ? $scope.validateProperty : $scope.ngModelProperty;
                            if ($scope.ngModel != null && !$scope.ngModel.isValid(property)) {
                                var validationErrors = $scope.ngModel.getValidationErrors();
                                var message = _.find(validationErrors, function (filter) { return filter.propertyName === property; });
                                if (message != null) {
                                    $scope.errorMessage = message.errorMessage;
                                    $scope.hasError = true;
                                }
                            }
                        }
                    }
                }
                InputControlTextController.$inject = ['$rootScope', '$scope', '$locale', '$element', '$timeout'];
                return InputControlTextController;
            })();
            directives.InputControlTextController = InputControlTextController;
            var AvInputControlText = (function () {
                function AvInputControlText() {
                    this.restrict = 'E';
                    this.templateUrl = 'app.web/directives/input-controls/input.control.text.tpl.html';
                    this.link = this.linkFunction;
                    this.scope = {
                        hasError: '=?',
                        isRequired: '=?',
                        labelTranslationKey: '@?',
                        ngModel: '=',
                        ngModelProperty: '@',
                        validateProperty: '@',
                        errorMessage: '=?',
                        feedbackText: '@',
                        feedbackPosition: '@',
                        ngDisabled: '=?',
                        showValidation: '=?'
                    };
                    this.controller = InputControlTextController;
                }
                AvInputControlText.prototype.linkFunction = function (scope, element, attrs, ngModelController) {
                    var parentId = element[0].id;
                    if (parentId === '') {
                        //parentId = attrs["ngModel"].match(/[^.]+$/)[0];
                        parentId = scope.ngModelProperty;
                    }
                    var input = element.find('input');
                    var inputId = 'input' + '_' + parentId;
                    input.attr("id", inputId);
                    var label = element.find('label');
                    label.attr("for", inputId);
                };
                AvInputControlText.$inject = ['$rootScope'];
                return AvInputControlText;
            })();
            directives.AvInputControlText = AvInputControlText;
        })(directives = web.directives || (web.directives = {}));
    })(web = app.web || (app.web = {}));
})(app || (app = {}));
app.web.registerDirective('AvInputControlText', app.web.directives.AvInputControlText.$inject);

/// <reference path="_typings.web.ts" />
function setCookie(cookieName, cookieValue, nDays) {
    var today = new Date();
    var expire = new Date();
    if (nDays == null || nDays == 0)
        nDays = 1;
    expire.setTime(today.getTime() + 3600000 * 24 * nDays);
    document.cookie = cookieName + "=" + escape(cookieValue)
        + ";expires=" + expire.toGMTString() + "; path=/";
}
setCookie("TimeZone", jstz.determine().name(), 365);
